import { openBlock as n, createElementBlock as o, createElementVNode as t, defineComponent as r1, createStaticVNode as a, ref as S, toRef as i0, watch as k1, toDisplayString as I, withDirectives as l1, Fragment as K, renderList as t1, vModelSelect as l0, normalizeClass as z, withModifiers as H1, createVNode as W, unref as U, createCommentVNode as D, computed as n1, onMounted as M1, vModelCheckbox as A1, createTextVNode as Y, createBlock as Q, renderSlot as s1, normalizeProps as s0, guardReactiveProps as h0, resolveDynamicComponent as a0, withCtx as a1, normalizeStyle as E1, vShow as b1, withKeys as J1, watchEffect as s2, toRefs as t2, mergeProps as d0, useCssVars as D2, pushScopeId as e2, popScopeId as r2, vModelText as h2, vModelDynamic as c0, useSlots as P2, Transition as _0, onBeforeUnmount as c2, reactive as C0, nextTick as f0, isRef as v0 } from "vue";
const i = (r, e) => {
  const l = r.__vccOpts || r;
  for (const [s, h] of e)
    l[s] = h;
  return l;
};
var u0 = {}, w0 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p0 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), g0 = /* @__PURE__ */ t("path", {
  d: "M15.5 11.5H14.5L13 14.5L11 8.5L9.5 11.5H8.5M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.75009 14.4724 8.97129 18.311 10.948 20.0749C11.3114 20.3991 11.4931 20.5613 11.7058 20.6251C11.8905 20.6805 12.0958 20.6805 12.2805 20.6251C12.4932 20.5613 12.6749 20.3991 13.0383 20.0749C15.015 18.311 19.2362 14.4724 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $0 = [
  p0,
  g0
];
function M0(r, e) {
  return n(), o("svg", w0, $0);
}
const ak2 = /* @__PURE__ */ i(u0, [["render", M0]]);
var L0 = {}, k0 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, m0 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), x0 = /* @__PURE__ */ t("path", {
  d: "M22 12H18L15 21L9 3L6 12H2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), H0 = [
  m0,
  x0
];
function V0(r, e) {
  return n(), o("svg", k0, H0);
}
const dk2 = /* @__PURE__ */ i(L0, [["render", V0]]);
var Z0 = {}, B0 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, F0 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), j0 = /* @__PURE__ */ t("path", {
  d: "M5 18C3.34315 18 2 16.6569 2 15V7.8C2 6.11984 2 5.27976 2.32698 4.63803C2.6146 4.07354 3.07354 3.6146 3.63803 3.32698C4.27976 3 5.11984 3 6.8 3H17.2C18.8802 3 19.7202 3 20.362 3.32698C20.9265 3.6146 21.3854 4.07354 21.673 4.63803C22 5.27976 22 6.11984 22 7.8V15C22 16.6569 20.6569 18 19 18M8.70803 21H15.292C15.8368 21 16.1093 21 16.2467 20.8889C16.3663 20.7923 16.4347 20.6461 16.4324 20.4925C16.4298 20.3157 16.2554 20.1064 15.9065 19.6879L12.6146 15.7375C12.4035 15.4842 12.298 15.3576 12.1716 15.3114C12.0608 15.2709 11.9392 15.2709 11.8284 15.3114C11.702 15.3576 11.5965 15.4842 11.3854 15.7375L8.09346 19.6879C7.74465 20.1064 7.57024 20.3157 7.56758 20.4925C7.56526 20.6461 7.63373 20.7923 7.75326 20.8889C7.89075 21 8.16318 21 8.70803 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), I0 = [
  F0,
  j0
];
function b0(r, e) {
  return n(), o("svg", B0, I0);
}
const ck2 = /* @__PURE__ */ i(Z0, [["render", b0]]);
var y0 = {}, D0 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P0 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), A0 = /* @__PURE__ */ t("path", {
  d: "M2 7.625C2 9.90317 3.84683 11.75 6.125 11.75C6.43089 11.75 6.58383 11.75 6.66308 11.7773C6.82888 11.8345 6.91545 11.9211 6.97266 12.0869C7 12.1662 7 12.2903 7 12.5386V18.875C7 19.7725 7.72754 20.5 8.625 20.5C9.52246 20.5 10.25 19.7725 10.25 18.875V7.625C10.25 5.34683 8.40317 3.5 6.125 3.5C3.84683 3.5 2 5.34683 2 7.625Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), S0 = /* @__PURE__ */ t("path", {
  d: "M22 7.625C22 9.90317 20.1532 11.75 17.875 11.75C17.5691 11.75 17.4162 11.75 17.3369 11.7773C17.1711 11.8345 17.0845 11.9211 17.0273 12.0869C17 12.1662 17 12.2903 17 12.5386V18.875C17 19.7725 16.2725 20.5 15.375 20.5C14.4775 20.5 13.75 19.7725 13.75 18.875V7.625C13.75 5.34683 15.5968 3.5 17.875 3.5C20.1532 3.5 22 5.34683 22 7.625Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), T0 = [
  P0,
  A0,
  S0
];
function O0(r, e) {
  return n(), o("svg", D0, T0);
}
const _k2 = /* @__PURE__ */ i(y0, [["render", O0]]);
var E0 = {}, R0 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, U0 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), N0 = /* @__PURE__ */ t("path", {
  d: "M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M9 13.5L11 15.5L15.5 11M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), q0 = [
  U0,
  N0
];
function z0(r, e) {
  return n(), o("svg", R0, q0);
}
const Ck2 = /* @__PURE__ */ i(E0, [["render", z0]]);
var K0 = {}, G0 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, W0 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), Y0 = /* @__PURE__ */ t("path", {
  d: "M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M9 13H15M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), X0 = [
  W0,
  Y0
];
function Q0(r, e) {
  return n(), o("svg", G0, X0);
}
const fk2 = /* @__PURE__ */ i(K0, [["render", Q0]]);
var J0 = {}, t4 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, e4 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), r4 = /* @__PURE__ */ t("path", {
  d: "M10.5 5.14185C10.991 5.04813 11.493 5 12 5C14.1217 5 16.1566 5.84285 17.6569 7.34315C19.1571 8.84344 20 10.8783 20 13C20 13.507 19.9519 14.009 19.8582 14.5M18.1356 18.1337C17.9844 18.3144 17.8247 18.489 17.6569 18.6569C16.1566 20.1571 14.1217 21 12 21C9.87827 21 7.84344 20.1571 6.34315 18.6569C4.84285 17.1566 4 15.1217 4 13C4 10.8783 4.84285 8.84344 6.34315 7.34315C6.50948 7.17682 6.68238 7.01857 6.86123 6.86865M4 4L2 6M22 6L19 3M6 19L4 21M21 21L3 3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), n4 = [
  e4,
  r4
];
function o4(r, e) {
  return n(), o("svg", t4, n4);
}
const vk2 = /* @__PURE__ */ i(J0, [["render", o4]]);
var i4 = {}, l4 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, s4 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), h4 = /* @__PURE__ */ t("path", {
  d: "M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M12 16V10M9 13H15M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), a4 = [
  s4,
  h4
];
function d4(r, e) {
  return n(), o("svg", l4, a4);
}
const uk2 = /* @__PURE__ */ i(i4, [["render", d4]]);
var c4 = {}, _4 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C4 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), f4 = /* @__PURE__ */ t("path", {
  d: "M5 3L2 6M22 6L19 3M6 19L4 21M18 19L20 21M12 9V13L14 15M12 21C14.1217 21 16.1566 20.1571 17.6569 18.6569C19.1571 17.1566 20 15.1217 20 13C20 10.8783 19.1571 8.84344 17.6569 7.34315C16.1566 5.84285 14.1217 5 12 5C9.87827 5 7.84344 5.84285 6.34315 7.34315C4.84285 8.84344 4 10.8783 4 13C4 15.1217 4.84285 17.1566 6.34315 18.6569C7.84344 20.1571 9.87827 21 12 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), v4 = [
  C4,
  f4
];
function u4(r, e) {
  return n(), o("svg", _4, v4);
}
const wk2 = /* @__PURE__ */ i(c4, [["render", u4]]);
var w4 = {}, p4 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g4 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), $4 = /* @__PURE__ */ t("path", {
  d: "M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), M4 = [
  g4,
  $4
];
function L4(r, e) {
  return n(), o("svg", p4, M4);
}
const pk2 = /* @__PURE__ */ i(w4, [["render", L4]]);
var k4 = {}, m4 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x4 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), H4 = /* @__PURE__ */ t("path", {
  d: "M12 8.00008V12.0001M12 16.0001H12.01M3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7985 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586V7.94153C21 7.59889 21 7.42756 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7985 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42756 3 7.59889 3 7.94153Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), V4 = [
  x4,
  H4
];
function Z4(r, e) {
  return n(), o("svg", m4, V4);
}
const gk2 = /* @__PURE__ */ i(k4, [["render", Z4]]);
var B4 = {}, F4 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j4 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), I4 = /* @__PURE__ */ t("path", {
  d: "M12 8V12M12 16H12.01M2 8.52274V15.4773C2 15.7218 2 15.8441 2.02763 15.9592C2.05213 16.0613 2.09253 16.1588 2.14736 16.2483C2.2092 16.3492 2.29568 16.4357 2.46863 16.6086L7.39137 21.5314C7.56432 21.7043 7.6508 21.7908 7.75172 21.8526C7.84119 21.9075 7.93873 21.9479 8.04077 21.9724C8.15586 22 8.27815 22 8.52274 22H15.4773C15.7218 22 15.8441 22 15.9592 21.9724C16.0613 21.9479 16.1588 21.9075 16.2483 21.8526C16.3492 21.7908 16.4357 21.7043 16.6086 21.5314L21.5314 16.6086C21.7043 16.4357 21.7908 16.3492 21.8526 16.2483C21.9075 16.1588 21.9479 16.0613 21.9724 15.9592C22 15.8441 22 15.7218 22 15.4773V8.52274C22 8.27815 22 8.15586 21.9724 8.04077C21.9479 7.93873 21.9075 7.84119 21.8526 7.75172C21.7908 7.6508 21.7043 7.56432 21.5314 7.39137L16.6086 2.46863C16.4357 2.29568 16.3492 2.2092 16.2483 2.14736C16.1588 2.09253 16.0613 2.05213 15.9592 2.02763C15.8441 2 15.7218 2 15.4773 2H8.52274C8.27815 2 8.15586 2 8.04077 2.02763C7.93873 2.05213 7.84119 2.09253 7.75172 2.14736C7.6508 2.2092 7.56432 2.29568 7.39137 2.46863L2.46863 7.39137C2.29568 7.56432 2.2092 7.6508 2.14736 7.75172C2.09253 7.84119 2.05213 7.93873 2.02763 8.04077C2 8.15586 2 8.27815 2 8.52274Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), b4 = [
  j4,
  I4
];
function y4(r, e) {
  return n(), o("svg", F4, b4);
}
const $k2 = /* @__PURE__ */ i(B4, [["render", y4]]);
var D4 = {}, P4 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, A4 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), S4 = /* @__PURE__ */ t("path", {
  d: "M12 8V12M12 16H12.01M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), T4 = [
  A4,
  S4
];
function O4(r, e) {
  return n(), o("svg", P4, T4);
}
const Mk2 = /* @__PURE__ */ i(D4, [["render", O4]]);
var E4 = {}, R4 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, U4 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), N4 = /* @__PURE__ */ t("path", {
  d: "M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), q4 = [
  U4,
  N4
];
function z4(r, e) {
  return n(), o("svg", R4, q4);
}
const K4 = /* @__PURE__ */ i(E4, [["render", z4]]);
var G4 = {}, W4 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y4 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), X4 = /* @__PURE__ */ t("path", {
  d: "M3 21H21M12 3V17M12 17L19 10M12 17L5 10",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Q4 = [
  Y4,
  X4
];
function J4(r, e) {
  return n(), o("svg", W4, Q4);
}
const Lk2 = /* @__PURE__ */ i(G4, [["render", J4]]);
var t3 = {}, e3 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r3 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), n3 = /* @__PURE__ */ t("path", {
  d: "M10 18V6C10 5.06812 10 4.60218 9.84776 4.23463C9.64477 3.74458 9.25542 3.35523 8.76537 3.15224C8.39782 3 7.93188 3 7 3C6.06812 3 5.60218 3 5.23463 3.15224C4.74458 3.35523 4.35523 3.74458 4.15224 4.23463C4 4.60218 4 5.06812 4 6V18C4 18.9319 4 19.3978 4.15224 19.7654C4.35523 20.2554 4.74458 20.6448 5.23463 20.8478C5.60218 21 6.06812 21 7 21C7.93188 21 8.39782 21 8.76537 20.8478C9.25542 20.6448 9.64477 20.2554 9.84776 19.7654C10 19.3978 10 18.9319 10 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), o3 = /* @__PURE__ */ t("path", {
  d: "M20 18V10C20 9.06812 20 8.60218 19.8478 8.23463C19.6448 7.74458 19.2554 7.35523 18.7654 7.15224C18.3978 7 17.9319 7 17 7C16.0681 7 15.6022 7 15.2346 7.15224C14.7446 7.35523 14.3552 7.74458 14.1522 8.23463C14 8.60218 14 9.06812 14 10V18C14 18.9319 14 19.3978 14.1522 19.7654C14.3552 20.2554 14.7446 20.6448 15.2346 20.8478C15.6022 21 16.0681 21 17 21C17.9319 21 18.3978 21 18.7654 20.8478C19.2554 20.6448 19.6448 20.2554 19.8478 19.7654C20 19.3978 20 18.9319 20 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), i3 = [
  r3,
  n3,
  o3
];
function l3(r, e) {
  return n(), o("svg", e3, i3);
}
const kk2 = /* @__PURE__ */ i(t3, [["render", l3]]);
var s3 = {}, h3 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, a3 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), d3 = /* @__PURE__ */ t("path", {
  d: "M18 10H6M21 6H3M21 14H3M18 18H6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), c3 = [
  a3,
  d3
];
function _3(r, e) {
  return n(), o("svg", h3, c3);
}
const mk2 = /* @__PURE__ */ i(s3, [["render", _3]]);
var C3 = {}, f3 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, v3 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), u3 = /* @__PURE__ */ t("path", {
  d: "M12 3V21M22 12H15.5M15.5 12L19.5 16M15.5 12L19.5 8M2 12H8.5M8.5 12L4.5 16M8.5 12L4.5 8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), w3 = [
  v3,
  u3
];
function p3(r, e) {
  return n(), o("svg", f3, w3);
}
const xk2 = /* @__PURE__ */ i(C3, [["render", p3]]);
var g3 = {}, $3 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M3 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), L3 = /* @__PURE__ */ t("path", {
  d: "M16 10C16.9319 10 17.3978 10 17.7654 9.84776C18.2554 9.64477 18.6448 9.25542 18.8478 8.76537C19 8.39782 19 7.93188 19 7C19 6.06812 19 5.60218 18.8478 5.23463C18.6448 4.74458 18.2554 4.35523 17.7654 4.15224C17.3978 4 16.9319 4 16 4L8 4C7.06812 4 6.60218 4 6.23463 4.15224C5.74458 4.35523 5.35523 4.74458 5.15224 5.23463C5 5.60218 5 6.06812 5 7C5 7.93188 5 8.39782 5.15224 8.76537C5.35523 9.25542 5.74458 9.64477 6.23463 9.84776C6.60218 10 7.06812 10 8 10L16 10Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), k3 = /* @__PURE__ */ t("path", {
  d: "M18 20C18.9319 20 19.3978 20 19.7654 19.8478C20.2554 19.6448 20.6448 19.2554 20.8478 18.7654C21 18.3978 21 17.9319 21 17C21 16.0681 21 15.6022 20.8478 15.2346C20.6448 14.7446 20.2554 14.3552 19.7654 14.1522C19.3978 14 18.9319 14 18 14H6C5.06812 14 4.60218 14 4.23463 14.1522C3.74458 14.3552 3.35523 14.7446 3.15224 15.2346C3 15.6022 3 16.0681 3 17C3 17.9319 3 18.3978 3.15224 18.7654C3.35523 19.2554 3.74458 19.6448 4.23463 19.8478C4.60218 20 5.06812 20 6 20L18 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), m3 = [
  M3,
  L3,
  k3
];
function x3(r, e) {
  return n(), o("svg", $3, m3);
}
const Hk2 = /* @__PURE__ */ i(g3, [["render", x3]]);
var H3 = {}, V3 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Z3 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), B3 = /* @__PURE__ */ t("path", {
  d: "M21 10H3M21 18H3M21 6H3M21 14H3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), F3 = [
  Z3,
  B3
];
function j3(r, e) {
  return n(), o("svg", V3, F3);
}
const Vk2 = /* @__PURE__ */ i(H3, [["render", j3]]);
var I3 = {}, b3 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y3 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), D3 = /* @__PURE__ */ t("path", {
  d: "M3 3V21M21 12H7M7 12L14 19M7 12L14 5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), P3 = [
  y3,
  D3
];
function A3(r, e) {
  return n(), o("svg", b3, P3);
}
const Zk2 = /* @__PURE__ */ i(I3, [["render", A3]]);
var S3 = {}, T3 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O3 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), E3 = /* @__PURE__ */ t("path", {
  d: "M14 10C14.9319 10 15.3978 10 15.7654 9.84776C16.2554 9.64477 16.6448 9.25542 16.8478 8.76537C17 8.39782 17 7.93188 17 7C17 6.06812 17 5.60218 16.8478 5.23463C16.6448 4.74458 16.2554 4.35523 15.7654 4.15224C15.3978 4 14.9319 4 14 4L6 4C5.06812 4 4.60218 4 4.23463 4.15224C3.74458 4.35523 3.35523 4.74458 3.15224 5.23463C3 5.60218 3 6.06812 3 7C3 7.93188 3 8.39782 3.15224 8.76537C3.35523 9.25542 3.74458 9.64477 4.23463 9.84776C4.60218 10 5.06812 10 6 10L14 10Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), R3 = /* @__PURE__ */ t("path", {
  d: "M18 20C18.9319 20 19.3978 20 19.7654 19.8478C20.2554 19.6448 20.6448 19.2554 20.8478 18.7654C21 18.3978 21 17.9319 21 17C21 16.0681 21 15.6022 20.8478 15.2346C20.6448 14.7446 20.2554 14.3552 19.7654 14.1522C19.3978 14 18.9319 14 18 14H6C5.06812 14 4.60218 14 4.23463 14.1522C3.74458 14.3552 3.35523 14.7446 3.15224 15.2346C3 15.6022 3 16.0681 3 17C3 17.9319 3 18.3978 3.15224 18.7654C3.35523 19.2554 3.74458 19.6448 4.23463 19.8478C4.60218 20 5.06812 20 6 20L18 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), U3 = [
  O3,
  E3,
  R3
];
function N3(r, e) {
  return n(), o("svg", T3, U3);
}
const Bk2 = /* @__PURE__ */ i(S3, [["render", N3]]);
var q3 = {}, z3 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, K3 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), G3 = /* @__PURE__ */ t("path", {
  d: "M16 10H3M20 6H3M20 14H3M16 18H3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), W3 = [
  K3,
  G3
];
function Y3(r, e) {
  return n(), o("svg", z3, W3);
}
const Fk2 = /* @__PURE__ */ i(q3, [["render", Y3]]);
var X3 = {}, Q3 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, J3 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), t9 = /* @__PURE__ */ t("path", {
  d: "M21 21V3M3 12H17M17 12L10 5M17 12L10 19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), e9 = [
  J3,
  t9
];
function r9(r, e) {
  return n(), o("svg", Q3, e9);
}
const jk2 = /* @__PURE__ */ i(X3, [["render", r9]]);
var n9 = {}, o9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, i9 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), l9 = /* @__PURE__ */ t("path", {
  d: "M18 10C18.9319 10 19.3978 10 19.7654 9.84776C20.2554 9.64477 20.6448 9.25542 20.8478 8.76537C21 8.39782 21 7.93188 21 7C21 6.06812 21 5.60218 20.8478 5.23463C20.6448 4.74458 20.2554 4.35523 19.7654 4.15224C19.3978 4 18.9319 4 18 4L10 4C9.06812 4 8.60218 4 8.23463 4.15224C7.74458 4.35523 7.35523 4.74458 7.15224 5.23463C7 5.60218 7 6.06812 7 7C7 7.93188 7 8.39782 7.15224 8.76537C7.35523 9.25542 7.74458 9.64477 8.23463 9.84776C8.60218 10 9.06812 10 10 10L18 10Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), s9 = /* @__PURE__ */ t("path", {
  d: "M18 20C18.9319 20 19.3978 20 19.7654 19.8478C20.2554 19.6448 20.6448 19.2554 20.8478 18.7654C21 18.3978 21 17.9319 21 17C21 16.0681 21 15.6022 20.8478 15.2346C20.6448 14.7446 20.2554 14.3552 19.7654 14.1522C19.3978 14 18.9319 14 18 14H6C5.06812 14 4.60218 14 4.23463 14.1522C3.74458 14.3552 3.35523 14.7446 3.15224 15.2346C3 15.6022 3 16.0681 3 17C3 17.9319 3 18.3978 3.15224 18.7654C3.35523 19.2554 3.74458 19.6448 4.23463 19.8478C4.60218 20 5.06812 20 6 20L18 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), h9 = [
  i9,
  l9,
  s9
];
function a9(r, e) {
  return n(), o("svg", o9, h9);
}
const Ik2 = /* @__PURE__ */ i(n9, [["render", a9]]);
var d9 = {}, c9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _9 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), C9 = /* @__PURE__ */ t("path", {
  d: "M21 10H8M21 6H4M21 14H4M21 18H8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), f9 = [
  _9,
  C9
];
function v9(r, e) {
  return n(), o("svg", c9, f9);
}
const bk2 = /* @__PURE__ */ i(d9, [["render", v9]]);
var u9 = {}, w9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p9 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), g9 = /* @__PURE__ */ t("path", {
  d: "M21 3H3M12 21V7M12 7L5 14M12 7L19 14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $9 = [
  p9,
  g9
];
function M9(r, e) {
  return n(), o("svg", w9, $9);
}
const yk2 = /* @__PURE__ */ i(u9, [["render", M9]]);
var L9 = {}, k9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, m9 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), x9 = /* @__PURE__ */ t("path", {
  d: "M10 18V6C10 5.06812 10 4.60218 9.84776 4.23463C9.64477 3.74458 9.25542 3.35523 8.76537 3.15224C8.39782 3 7.93188 3 7 3C6.06812 3 5.60218 3 5.23463 3.15224C4.74458 3.35523 4.35523 3.74458 4.15224 4.23463C4 4.60218 4 5.06812 4 6V18C4 18.9319 4 19.3978 4.15224 19.7654C4.35523 20.2554 4.74458 20.6448 5.23463 20.8478C5.60218 21 6.06812 21 7 21C7.93188 21 8.39782 21 8.76537 20.8478C9.25542 20.6448 9.64477 20.2554 9.84776 19.7654C10 19.3978 10 18.9319 10 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), H9 = /* @__PURE__ */ t("path", {
  d: "M20 14V6C20 5.06812 20 4.60218 19.8478 4.23463C19.6448 3.74458 19.2554 3.35523 18.7654 3.15224C18.3978 3 17.9319 3 17 3C16.0681 3 15.6022 3 15.2346 3.15224C14.7446 3.35523 14.3552 3.74458 14.1522 4.23463C14 4.60218 14 5.06812 14 6V14C14 14.9319 14 15.3978 14.1522 15.7654C14.3552 16.2554 14.7446 16.6448 15.2346 16.8478C15.6022 17 16.0681 17 17 17C17.9319 17 18.3978 17 18.7654 16.8478C19.2554 16.6448 19.6448 16.2554 19.8478 15.7654C20 15.3978 20 14.9319 20 14Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), V9 = [
  m9,
  x9,
  H9
];
function Z9(r, e) {
  return n(), o("svg", k9, V9);
}
const Dk2 = /* @__PURE__ */ i(L9, [["render", Z9]]);
var B9 = {}, F9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j9 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), I9 = /* @__PURE__ */ t("path", {
  d: "M3 12H21M12 2V8.5M12 8.5L16 4.5M12 8.5L8 4.5M12 22V15.5M12 15.5L16 19.5M12 15.5L8 19.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), b9 = [
  j9,
  I9
];
function y9(r, e) {
  return n(), o("svg", F9, b9);
}
const Pk2 = /* @__PURE__ */ i(B9, [["render", y9]]);
var D9 = {}, P9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, A9 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -596)",
  fill: "none"
}, null, -1), S9 = /* @__PURE__ */ t("path", {
  d: "M10 18V6C10 5.06812 10 4.60218 9.84776 4.23463C9.64477 3.74458 9.25542 3.35523 8.76537 3.15224C8.39782 3 7.93188 3 7 3C6.06812 3 5.60218 3 5.23463 3.15224C4.74458 3.35523 4.35523 3.74458 4.15224 4.23463C4 4.60218 4 5.06812 4 6V18C4 18.9319 4 19.3978 4.15224 19.7654C4.35523 20.2554 4.74458 20.6448 5.23463 20.8478C5.60218 21 6.06812 21 7 21C7.93188 21 8.39782 21 8.76537 20.8478C9.25542 20.6448 9.64477 20.2554 9.84776 19.7654C10 19.3978 10 18.9319 10 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), T9 = /* @__PURE__ */ t("path", {
  d: "M20 16V8C20 7.06812 20 6.60218 19.8478 6.23463C19.6448 5.74458 19.2554 5.35523 18.7654 5.15224C18.3978 5 17.9319 5 17 5C16.0681 5 15.6022 5 15.2346 5.15224C14.7446 5.35523 14.3552 5.74458 14.1522 6.23463C14 6.60218 14 7.06812 14 8V16C14 16.9319 14 17.3978 14.1522 17.7654C14.3552 18.2554 14.7446 18.6448 15.2346 18.8478C15.6022 19 16.0681 19 17 19C17.9319 19 18.3978 19 18.7654 18.8478C19.2554 18.6448 19.6448 18.2554 19.8478 17.7654C20 17.3978 20 16.9319 20 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), O9 = [
  A9,
  S9,
  T9
];
function E9(r, e) {
  return n(), o("svg", P9, O9);
}
const Ak2 = /* @__PURE__ */ i(D9, [["render", E9]]);
var R9 = {}, U9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, N9 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), q9 = /* @__PURE__ */ t("path", {
  d: "M12 8C13.6569 8 15 6.65685 15 5C15 3.34315 13.6569 2 12 2C10.3431 2 9 3.34315 9 5C9 6.65685 10.3431 8 12 8ZM12 8V22M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12H5M12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12H19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), z9 = [
  N9,
  q9
];
function K9(r, e) {
  return n(), o("svg", U9, z9);
}
const Sk2 = /* @__PURE__ */ i(R9, [["render", K9]]);
var G9 = {}, W9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y9 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -196)",
  fill: "none"
}, null, -1), X9 = /* @__PURE__ */ t("path", {
  d: "M12 10.5V7M12 14H12.01M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Q9 = [
  Y9,
  X9
];
function J9(r, e) {
  return n(), o("svg", W9, Q9);
}
const Tk2 = /* @__PURE__ */ i(G9, [["render", J9]]);
var t6 = {}, e6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r6 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -236)",
  fill: "none"
}, null, -1), n6 = /* @__PURE__ */ t("path", {
  d: "M9 11L11 13L15.5 8.5M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), o6 = [
  r6,
  n6
];
function i6(r, e) {
  return n(), o("svg", e6, o6);
}
const Ok2 = /* @__PURE__ */ i(t6, [["render", i6]]);
var l6 = {}, s6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h6 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -276)",
  fill: "none"
}, null, -1), a6 = /* @__PURE__ */ t("path", {
  d: "M7.5 10.5H7.51M12 10.5H12.01M16.5 10.5H16.51M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2ZM8 10.5C8 10.7761 7.77614 11 7.5 11C7.22386 11 7 10.7761 7 10.5C7 10.2239 7.22386 10 7.5 10C7.77614 10 8 10.2239 8 10.5ZM12.5 10.5C12.5 10.7761 12.2761 11 12 11C11.7239 11 11.5 10.7761 11.5 10.5C11.5 10.2239 11.7239 10 12 10C12.2761 10 12.5 10.2239 12.5 10.5ZM17 10.5C17 10.7761 16.7761 11 16.5 11C16.2239 11 16 10.7761 16 10.5C16 10.2239 16.2239 10 16.5 10C16.7761 10 17 10.2239 17 10.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), d6 = [
  h6,
  a6
];
function c6(r, e) {
  return n(), o("svg", s6, d6);
}
const Ek2 = /* @__PURE__ */ i(l6, [["render", c6]]);
var _6 = {}, C6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, f6 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -316)",
  fill: "none"
}, null, -1), v6 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.5C21 14.8978 21 15.5967 20.7716 16.1481C20.4672 16.8831 19.8831 17.4672 19.1481 17.7716C18.5967 18 17.8978 18 16.5 18C16.0114 18 15.7671 18 15.5405 18.0535C15.2383 18.1248 14.9569 18.2656 14.7185 18.4645C14.5397 18.6137 14.3931 18.8091 14.1 19.2L12.64 21.1467C12.4229 21.4362 12.3143 21.5809 12.1812 21.6327C12.0647 21.678 11.9353 21.678 11.8188 21.6327C11.6857 21.5809 11.5771 21.4362 11.36 21.1467L9.9 19.2C9.60685 18.8091 9.46028 18.6137 9.2815 18.4645C9.04312 18.2656 8.76169 18.1248 8.45951 18.0535C8.23287 18 7.98858 18 7.5 18C6.10218 18 5.40326 18 4.85195 17.7716C4.11687 17.4672 3.53284 16.8831 3.22836 16.1481C3 15.5967 3 14.8978 3 13.5V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), u6 = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9973 8.33059C11.1975 7.4216 9.8639 7.17708 8.86188 8.00945C7.85986 8.84182 7.71879 10.2335 8.50568 11.2179C8.97361 11.8033 10.1197 12.8531 10.9719 13.6079C11.3237 13.9195 11.4996 14.0753 11.7114 14.1385C11.8925 14.1926 12.102 14.1926 12.2832 14.1385C12.4949 14.0753 12.6708 13.9195 13.0226 13.6079C13.8748 12.8531 15.0209 11.8033 15.4888 11.2179C16.2757 10.2335 16.1519 8.83306 15.1326 8.00945C14.1134 7.18584 12.797 7.4216 11.9973 8.33059Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), w6 = [
  f6,
  v6,
  u6
];
function p6(r, e) {
  return n(), o("svg", C6, w6);
}
const Rk2 = /* @__PURE__ */ i(_6, [["render", p6]]);
var g6 = {}, $6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M6 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -356)",
  fill: "none"
}, null, -1), L6 = /* @__PURE__ */ t("path", {
  d: "M12 14V10.5M12 7H12.01M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), k6 = [
  M6,
  L6
];
function m6(r, e) {
  return n(), o("svg", $6, k6);
}
const Uk2 = /* @__PURE__ */ i(g6, [["render", m6]]);
var x6 = {}, H6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V6 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -396)",
  fill: "none"
}, null, -1), Z6 = /* @__PURE__ */ t("path", {
  d: "M12 13.5V7.5M9 10.5H15M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), B6 = [
  V6,
  Z6
];
function F6(r, e) {
  return n(), o("svg", H6, B6);
}
const Nk2 = /* @__PURE__ */ i(x6, [["render", F6]]);
var j6 = {}, I6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, b6 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -436)",
  fill: "none"
}, null, -1), y6 = /* @__PURE__ */ t("path", {
  d: "M10 8.50224C10.1762 8.00136 10.524 7.579 10.9817 7.30998C11.4395 7.04095 11.9777 6.9426 12.501 7.03237C13.0243 7.12213 13.499 7.39421 13.8409 7.80041C14.1829 8.20661 14.37 8.72072 14.3692 9.25168C14.3692 10.7506 12.1209 11.5 12.1209 11.5M12.1499 14.5H12.1599M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), D6 = [
  b6,
  y6
];
function P6(r, e) {
  return n(), o("svg", I6, D6);
}
const A6 = /* @__PURE__ */ i(j6, [["render", P6]]);
var S6 = {}, T6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O6 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -476)",
  fill: "none"
}, null, -1), E6 = /* @__PURE__ */ t("path", {
  d: "M9.5 8L14.5 13M14.5 8L9.5 13M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), R6 = [
  O6,
  E6
];
function U6(r, e) {
  return n(), o("svg", T6, R6);
}
const qk2 = /* @__PURE__ */ i(S6, [["render", U6]]);
var N6 = {}, q6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z6 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -156)",
  fill: "none"
}, null, -1), K6 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.5C21 14.8978 21 15.5967 20.7716 16.1481C20.4672 16.8831 19.8831 17.4672 19.1481 17.7716C18.5967 18 17.8978 18 16.5 18C16.0114 18 15.7671 18 15.5405 18.0535C15.2383 18.1248 14.9569 18.2656 14.7185 18.4645C14.5397 18.6137 14.3931 18.8091 14.1 19.2L12.64 21.1467C12.4229 21.4362 12.3143 21.5809 12.1812 21.6327C12.0647 21.678 11.9353 21.678 11.8188 21.6327C11.6857 21.5809 11.5771 21.4362 11.36 21.1467L9.9 19.2C9.60685 18.8091 9.46028 18.6137 9.2815 18.4645C9.04312 18.2656 8.76169 18.1248 8.45951 18.0535C8.23287 18 7.98858 18 7.5 18C6.10218 18 5.40326 18 4.85195 17.7716C4.11687 17.4672 3.53284 16.8831 3.22836 16.1481C3 15.5967 3 14.8978 3 13.5V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), G6 = [
  z6,
  K6
];
function W6(r, e) {
  return n(), o("svg", q6, G6);
}
const zk2 = /* @__PURE__ */ i(N6, [["render", W6]]);
var Y6 = {}, X6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Q6 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), J6 = /* @__PURE__ */ t("path", {
  d: "M22 7.99992V11.9999M10.25 5.49991H6.8C5.11984 5.49991 4.27976 5.49991 3.63803 5.82689C3.07354 6.11451 2.6146 6.57345 2.32698 7.13794C2 7.77968 2 8.61976 2 10.2999L2 11.4999C2 12.4318 2 12.8977 2.15224 13.2653C2.35523 13.7553 2.74458 14.1447 3.23463 14.3477C3.60218 14.4999 4.06812 14.4999 5 14.4999V18.7499C5 18.9821 5 19.0982 5.00963 19.1959C5.10316 20.1455 5.85441 20.8968 6.80397 20.9903C6.90175 20.9999 7.01783 20.9999 7.25 20.9999C7.48217 20.9999 7.59826 20.9999 7.69604 20.9903C8.64559 20.8968 9.39685 20.1455 9.49037 19.1959C9.5 19.0982 9.5 18.9821 9.5 18.7499V14.4999H10.25C12.0164 14.4999 14.1772 15.4468 15.8443 16.3556C16.8168 16.8857 17.3031 17.1508 17.6216 17.1118C17.9169 17.0756 18.1402 16.943 18.3133 16.701C18.5 16.4401 18.5 15.9179 18.5 14.8736V5.1262C18.5 4.08191 18.5 3.55976 18.3133 3.2988C18.1402 3.05681 17.9169 2.92421 17.6216 2.88804C17.3031 2.84903 16.8168 3.11411 15.8443 3.64427C14.1772 4.55302 12.0164 5.49991 10.25 5.49991Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), t5 = [
  Q6,
  J6
];
function e5(r, e) {
  return n(), o("svg", X6, t5);
}
const Kk2 = /* @__PURE__ */ i(Y6, [["render", e5]]);
var r5 = {}, n5 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o5 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), i5 = /* @__PURE__ */ t("path", {
  d: "M4 13.9999L5.57465 20.2985C5.61893 20.4756 5.64107 20.5642 5.66727 20.6415C5.92317 21.397 6.60352 21.9282 7.39852 21.9933C7.4799 21.9999 7.5712 21.9999 7.75379 21.9999C7.98244 21.9999 8.09677 21.9999 8.19308 21.9906C9.145 21.8982 9.89834 21.1449 9.99066 20.193C10 20.0967 10 19.9823 10 19.7537V5.49991M18.5 13.4999C20.433 13.4999 22 11.9329 22 9.99991C22 8.06691 20.433 6.49991 18.5 6.49991M10.25 5.49991H6.5C4.01472 5.49991 2 7.51463 2 9.99991C2 12.4852 4.01472 14.4999 6.5 14.4999H10.25C12.0164 14.4999 14.1772 15.4468 15.8443 16.3556C16.8168 16.8857 17.3031 17.1508 17.6216 17.1118C17.9169 17.0756 18.1402 16.943 18.3133 16.701C18.5 16.4401 18.5 15.9179 18.5 14.8736V5.1262C18.5 4.08191 18.5 3.55976 18.3133 3.2988C18.1402 3.05681 17.9169 2.92421 17.6216 2.88804C17.3031 2.84903 16.8168 3.11411 15.8443 3.64427C14.1772 4.55302 12.0164 5.49991 10.25 5.49991Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), l5 = [
  o5,
  i5
];
function s5(r, e) {
  return n(), o("svg", n5, l5);
}
const Gk2 = /* @__PURE__ */ i(r5, [["render", s5]]);
var h5 = {}, a5 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, d5 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), c5 = /* @__PURE__ */ t("path", {
  d: "M18.5 16C20.433 16 22 13.0899 22 9.5C22 5.91015 20.433 3 18.5 3M18.5 16C16.567 16 15 13.0899 15 9.5C15 5.91015 16.567 3 18.5 3M18.5 16L5.44354 13.6261C4.51605 13.4575 4.05231 13.3731 3.67733 13.189C2.91447 12.8142 2.34636 12.1335 2.11414 11.3159C2 10.914 2 10.4427 2 9.5C2 8.5573 2 8.08595 2.11414 7.68407C2.34636 6.86649 2.91447 6.18577 3.67733 5.81105C4.05231 5.62685 4.51605 5.54254 5.44354 5.3739L18.5 3M5 14L5.39386 19.514C5.43126 20.0376 5.44996 20.2995 5.56387 20.4979C5.66417 20.6726 5.81489 20.8129 5.99629 20.9005C6.20232 21 6.46481 21 6.98979 21H8.7722C9.37234 21 9.67242 21 9.89451 20.8803C10.0897 20.7751 10.2443 20.6081 10.3342 20.4055C10.4365 20.1749 10.4135 19.8757 10.3675 19.2773L10 14.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _5 = [
  d5,
  c5
];
function C5(r, e) {
  return n(), o("svg", a5, _5);
}
const Wk2 = /* @__PURE__ */ i(h5, [["render", C5]]);
var f5 = {}, v5 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, u5 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), w5 = /* @__PURE__ */ t("path", {
  d: "M4 7.9966C3.83599 7.99236 3.7169 7.98287 3.60982 7.96157C2.81644 7.80376 2.19624 7.18356 2.03843 6.39018C2 6.19698 2 5.96466 2 5.5C2 5.03534 2 4.80302 2.03843 4.60982C2.19624 3.81644 2.81644 3.19624 3.60982 3.03843C3.80302 3 4.03534 3 4.5 3H19.5C19.9647 3 20.197 3 20.3902 3.03843C21.1836 3.19624 21.8038 3.81644 21.9616 4.60982C22 4.80302 22 5.03534 22 5.5C22 5.96466 22 6.19698 21.9616 6.39018C21.8038 7.18356 21.1836 7.80376 20.3902 7.96157C20.2831 7.98287 20.164 7.99236 20 7.9966M10 13H14M4 8H20V16.2C20 17.8802 20 18.7202 19.673 19.362C19.3854 19.9265 18.9265 20.3854 18.362 20.673C17.7202 21 16.8802 21 15.2 21H8.8C7.11984 21 6.27976 21 5.63803 20.673C5.07354 20.3854 4.6146 19.9265 4.32698 19.362C4 18.7202 4 17.8802 4 16.2V8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), p5 = [
  u5,
  w5
];
function g5(r, e) {
  return n(), o("svg", v5, p5);
}
const Yk2 = /* @__PURE__ */ i(f5, [["render", g5]]);
var $5 = {}, M5 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, L5 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), k5 = /* @__PURE__ */ t("path", {
  d: "M9 3.8C9 3.51997 9 3.37996 9.0545 3.273C9.10243 3.17892 9.17892 3.10243 9.273 3.0545C9.37996 3 9.51997 3 9.8 3H14.2C14.48 3 14.62 3 14.727 3.0545C14.8211 3.10243 14.8976 3.17892 14.9455 3.273C15 3.37996 15 3.51997 15 3.8V14H19L12 21L5 14H9V3.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), m5 = [
  L5,
  k5
];
function x5(r, e) {
  return n(), o("svg", M5, m5);
}
const Xk2 = /* @__PURE__ */ i($5, [["render", x5]]);
var H5 = {}, V5 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Z5 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), B5 = /* @__PURE__ */ t("path", {
  d: "M3 12L10 5V9H20.2C20.48 9 20.62 9 20.727 9.0545C20.8211 9.10243 20.8976 9.17892 20.9455 9.273C21 9.37996 21 9.51997 21 9.8V14.2C21 14.48 21 14.62 20.9455 14.727C20.8976 14.8211 20.8211 14.8976 20.727 14.9455C20.62 15 20.48 15 20.2 15H10V19L3 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), F5 = [
  Z5,
  B5
];
function j5(r, e) {
  return n(), o("svg", V5, F5);
}
const Qk2 = /* @__PURE__ */ i(H5, [["render", j5]]);
var I5 = {}, b5 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y5 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), D5 = /* @__PURE__ */ t("path", {
  d: "M21 12L14 5V9H3.8C3.51997 9 3.37996 9 3.273 9.0545C3.17892 9.10243 3.10243 9.17892 3.0545 9.273C3 9.37996 3 9.51997 3 9.8V14.2C3 14.48 3 14.62 3.0545 14.727C3.10243 14.8211 3.17892 14.8976 3.273 14.9455C3.37996 15 3.51997 15 3.8 15H14V19L21 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), P5 = [
  y5,
  D5
];
function A5(r, e) {
  return n(), o("svg", b5, P5);
}
const Jk2 = /* @__PURE__ */ i(I5, [["render", A5]]);
var S5 = {}, T5 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O5 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), E5 = /* @__PURE__ */ t("path", {
  d: "M9.8 21C9.51997 21 9.37996 21 9.273 20.9455C9.17892 20.8976 9.10243 20.8211 9.0545 20.727C9 20.62 9 20.48 9 20.2V10H5L12 3L19 10H15V20.2C15 20.48 15 20.62 14.9455 20.727C14.8976 20.8211 14.8211 20.8976 14.727 20.9455C14.62 21 14.48 21 14.2 21H9.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), R5 = [
  O5,
  E5
];
function U5(r, e) {
  return n(), o("svg", T5, R5);
}
const tm2 = /* @__PURE__ */ i(S5, [["render", U5]]);
var N5 = {}, q5 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z5 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), K5 = /* @__PURE__ */ t("path", {
  d: "M9.00023 9.00007V15.0001M9.00023 15.0001H15.0002M9.00023 15.0001L19 5.00001M21.6606 9.41051C22.5515 12.7467 21.6884 16.4538 19.0711 19.0711C15.1658 22.9764 8.83418 22.9764 4.92893 19.0711C1.02369 15.1659 1.02369 8.83424 4.92893 4.92899C7.54623 2.3117 11.2534 1.44852 14.5896 2.33944",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), G5 = [
  z5,
  K5
];
function W5(r, e) {
  return n(), o("svg", q5, G5);
}
const em2 = /* @__PURE__ */ i(N5, [["render", W5]]);
var Y5 = {}, X5 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Q5 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), J5 = /* @__PURE__ */ t("path", {
  d: "M9.41045 2.33944C12.7466 1.44852 16.4538 2.3117 19.0711 4.92899C22.9763 8.83424 22.9763 15.1659 19.0711 19.0711C15.1658 22.9764 8.83418 22.9764 4.92893 19.0711C2.31164 16.4538 1.44846 12.7467 2.33938 9.41051M15.0001 9.00007V15.0001M15.0001 15.0001H9.00014M15.0001 15.0001L4.99995 5.00001",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), t8 = [
  Q5,
  J5
];
function e8(r, e) {
  return n(), o("svg", X5, t8);
}
const rm2 = /* @__PURE__ */ i(Y5, [["render", e8]]);
var r8 = {}, n8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o8 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), i8 = /* @__PURE__ */ t("path", {
  d: "M17 3.33782C19.989 5.06687 22 8.29859 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 8.29859 4.01099 5.06687 7 3.33782M8 12L12 16M12 16L16 12M12 16V2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), l8 = [
  o8,
  i8
];
function s8(r, e) {
  return n(), o("svg", n8, l8);
}
const nm2 = /* @__PURE__ */ i(r8, [["render", s8]]);
var h8 = {}, a8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, d8 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), c8 = /* @__PURE__ */ t("path", {
  d: "M20.6621 17C18.933 19.989 15.7013 22 11.9999 22C6.47703 22 1.99988 17.5228 1.99988 12C1.99988 6.47715 6.47703 2 11.9999 2C15.7013 2 18.933 4.01099 20.6621 7M11.9999 8L7.99995 12M7.99995 12L11.9999 16M7.99995 12H21.9999",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _8 = [
  d8,
  c8
];
function C8(r, e) {
  return n(), o("svg", a8, _8);
}
const om2 = /* @__PURE__ */ i(h8, [["render", C8]]);
var f8 = {}, v8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, u8 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), w8 = /* @__PURE__ */ t("path", {
  d: "M3.33789 7C5.06694 4.01099 8.29866 2 12.0001 2C17.5229 2 22.0001 6.47715 22.0001 12C22.0001 17.5228 17.5229 22 12.0001 22C8.29866 22 5.06694 19.989 3.33789 17M12 16L16 12M16 12L12 8M16 12H2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), p8 = [
  u8,
  w8
];
function g8(r, e) {
  return n(), o("svg", v8, p8);
}
const im2 = /* @__PURE__ */ i(f8, [["render", g8]]);
var $8 = {}, M8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, L8 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), k8 = /* @__PURE__ */ t("path", {
  d: "M14.5896 21.6606C11.2534 22.5515 7.54623 21.6884 4.92893 19.0711C1.02369 15.1658 1.02369 8.83418 4.92893 4.92893C8.83418 1.02369 15.1658 1.02369 19.0711 4.92893C21.6884 7.54623 22.5515 11.2534 21.6606 14.5896M9.00023 15.0001V9.0001M9.00023 9.0001H15.0002M9.00023 9.0001L19 19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), m8 = [
  L8,
  k8
];
function x8(r, e) {
  return n(), o("svg", M8, m8);
}
const lm2 = /* @__PURE__ */ i($8, [["render", x8]]);
var H8 = {}, V8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Z8 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -596)",
  fill: "none"
}, null, -1), B8 = /* @__PURE__ */ t("path", {
  d: "M2.33938 14.5896C1.44846 11.2534 2.31164 7.54623 4.92893 4.92893C8.83418 1.02369 15.1658 1.02369 19.0711 4.92893C22.9763 8.83418 22.9763 15.1658 19.0711 19.0711C16.4538 21.6884 12.7466 22.5515 9.41045 21.6606M15.0001 15.0001V9.0001M15.0001 9.0001H9.00014M15.0001 9.0001L4.99995 19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), F8 = [
  Z8,
  B8
];
function j8(r, e) {
  return n(), o("svg", V8, F8);
}
const sm2 = /* @__PURE__ */ i(H8, [["render", j8]]);
var I8 = {}, b8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y8 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), D8 = /* @__PURE__ */ t("path", {
  d: "M7 20.6621C4.01099 18.933 2 15.7013 2 11.9999C2 6.47703 6.47715 1.99988 12 1.99988C17.5228 1.99988 22 6.47703 22 11.9999C22 15.7013 19.989 18.933 17 20.6621M16 11.9999L12 7.99995M12 7.99995L8 11.9999M12 7.99995V21.9999",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), P8 = [
  y8,
  D8
];
function A8(r, e) {
  return n(), o("svg", b8, P8);
}
const hm2 = /* @__PURE__ */ i(I8, [["render", A8]]);
var S8 = {}, T8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O8 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -676)",
  fill: "none"
}, null, -1), E8 = /* @__PURE__ */ t("path", {
  d: "M9.00019 9.00005V15.0001M9.00019 15.0001H15.0002M9.00019 15.0001L15.0002 8.99994M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), R8 = [
  O8,
  E8
];
function U8(r, e) {
  return n(), o("svg", T8, R8);
}
const am2 = /* @__PURE__ */ i(S8, [["render", U8]]);
var N8 = {}, q8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z8 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -716)",
  fill: "none"
}, null, -1), K8 = /* @__PURE__ */ t("path", {
  d: "M15.0002 9.00005V15.0001M15.0002 15.0001H9.00019M15.0002 15.0001L9.00019 8.99994M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), G8 = [
  z8,
  K8
];
function W8(r, e) {
  return n(), o("svg", q8, G8);
}
const dm2 = /* @__PURE__ */ i(N8, [["render", W8]]);
var Y8 = {}, X8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Q8 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -636)",
  fill: "none"
}, null, -1), J8 = /* @__PURE__ */ t("path", {
  d: "M8 12L12 16M12 16L16 12M12 16V8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), t7 = [
  Q8,
  J8
];
function e7(r, e) {
  return n(), o("svg", X8, t7);
}
const cm2 = /* @__PURE__ */ i(Y8, [["render", e7]]);
var r7 = {}, n7 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o7 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -756)",
  fill: "none"
}, null, -1), i7 = /* @__PURE__ */ t("path", {
  d: "M12 8L8 12M8 12L12 16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), l7 = [
  o7,
  i7
];
function s7(r, e) {
  return n(), o("svg", n7, l7);
}
const _m2 = /* @__PURE__ */ i(r7, [["render", s7]]);
var h7 = {}, a7 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, d7 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -796)",
  fill: "none"
}, null, -1), c7 = /* @__PURE__ */ t("path", {
  d: "M12 16L16 12M16 12L12 8M16 12H8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _7 = [
  d7,
  c7
];
function C7(r, e) {
  return n(), o("svg", a7, _7);
}
const Cm2 = /* @__PURE__ */ i(h7, [["render", C7]]);
var f7 = {}, v7 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, u7 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -876)",
  fill: "none"
}, null, -1), w7 = /* @__PURE__ */ t("path", {
  d: "M9.00019 15.0001V9.00005M9.00019 9.00005H15.0002M9.00019 9.00005L15.0002 14.9999M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), p7 = [
  u7,
  w7
];
function g7(r, e) {
  return n(), o("svg", v7, p7);
}
const fm2 = /* @__PURE__ */ i(f7, [["render", g7]]);
var $7 = {}, M7 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, L7 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -916)",
  fill: "none"
}, null, -1), k7 = /* @__PURE__ */ t("path", {
  d: "M15.0002 15.0001V9.00005M15.0002 9.00005H9.00019M15.0002 9.00005L9.00019 14.9999M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), m7 = [
  L7,
  k7
];
function x7(r, e) {
  return n(), o("svg", M7, m7);
}
const vm2 = /* @__PURE__ */ i($7, [["render", x7]]);
var H7 = {}, V7 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Z7 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -836)",
  fill: "none"
}, null, -1), B7 = /* @__PURE__ */ t("path", {
  d: "M16 12L12 8M12 8L8 12M12 8V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), F7 = [
  Z7,
  B7
];
function j7(r, e) {
  return n(), o("svg", V7, F7);
}
const um2 = /* @__PURE__ */ i(H7, [["render", j7]]);
var I7 = {}, b7 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y7 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -996)",
  fill: "none"
}, null, -1), D7 = /* @__PURE__ */ t("path", {
  d: "M17 7L7 17M7 17H17M7 17V7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), P7 = [
  y7,
  D7
];
function A7(r, e) {
  return n(), o("svg", b7, P7);
}
const wm2 = /* @__PURE__ */ i(I7, [["render", A7]]);
var S7 = {}, T7 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O7 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -1036)",
  fill: "none"
}, null, -1), E7 = /* @__PURE__ */ t("path", {
  d: "M7 7L17 17M17 17V7M17 17H7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), R7 = [
  O7,
  E7
];
function U7(r, e) {
  return n(), o("svg", T7, R7);
}
const pm2 = /* @__PURE__ */ i(S7, [["render", U7]]);
var N7 = {}, q7 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z7 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-64 -956)",
  fill: "none"
}, null, -1), K7 = /* @__PURE__ */ t("path", {
  d: "M12 5V19M12 19L19 12M12 19L5 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), G7 = [
  z7,
  K7
];
function W7(r, e) {
  return n(), o("svg", q7, G7);
}
const Y7 = /* @__PURE__ */ i(N7, [["render", W7]]);
var X7 = {}, Q7 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, J7 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), tt = /* @__PURE__ */ t("path", {
  d: "M19 12H5M5 12L12 19M5 12L12 5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), et = [
  J7,
  tt
];
function rt(r, e) {
  return n(), o("svg", Q7, et);
}
const gm2 = /* @__PURE__ */ i(X7, [["render", rt]]);
var nt = {}, ot = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, it = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), lt = /* @__PURE__ */ t("path", {
  d: "M18 6L6 18M6 18H14M6 18V10",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), st = [
  it,
  lt
];
function ht(r, e) {
  return n(), o("svg", ot, st);
}
const $m2 = /* @__PURE__ */ i(nt, [["render", ht]]);
var at = {}, dt = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ct = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), _t = /* @__PURE__ */ t("path", {
  d: "M6 6L18 18M18 18V10M18 18H10",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ct = [
  ct,
  _t
];
function ft(r, e) {
  return n(), o("svg", dt, Ct);
}
const Mm2 = /* @__PURE__ */ i(at, [["render", ft]]);
var vt = {}, ut = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wt = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), pt = /* @__PURE__ */ t("path", {
  d: "M12 4V20M12 20L18 14M12 20L6 14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), gt = [
  wt,
  pt
];
function $t(r, e) {
  return n(), o("svg", ut, gt);
}
const Lm2 = /* @__PURE__ */ i(vt, [["render", $t]]);
var Mt = {}, Lt = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kt = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), mt = /* @__PURE__ */ t("path", {
  d: "M20 12H4M4 12L10 18M4 12L10 6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), xt = [
  kt,
  mt
];
function Ht(r, e) {
  return n(), o("svg", Lt, xt);
}
const km2 = /* @__PURE__ */ i(Mt, [["render", Ht]]);
var Vt = {}, Zt = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bt = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), Ft = /* @__PURE__ */ t("path", {
  d: "M4 12H20M20 12L14 6M20 12L14 18",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), jt = [
  Bt,
  Ft
];
function It(r, e) {
  return n(), o("svg", Zt, jt);
}
const mm2 = /* @__PURE__ */ i(Vt, [["render", It]]);
var bt = {}, yt = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Dt = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), Pt = /* @__PURE__ */ t("path", {
  d: "M18 18L6 6M6 6V14M6 6H14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), At = [
  Dt,
  Pt
];
function St(r, e) {
  return n(), o("svg", yt, At);
}
const xm2 = /* @__PURE__ */ i(bt, [["render", St]]);
var Tt = {}, Ot = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Et = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), Rt = /* @__PURE__ */ t("path", {
  d: "M6 18L18 6M18 6H10M18 6V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ut = [
  Et,
  Rt
];
function Nt(r, e) {
  return n(), o("svg", Ot, Ut);
}
const Hm2 = /* @__PURE__ */ i(Tt, [["render", Nt]]);
var qt = {}, zt = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Kt = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), Gt = /* @__PURE__ */ t("path", {
  d: "M12 20V4M12 4L6 10M12 4L18 10",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Wt = [
  Kt,
  Gt
];
function Yt(r, e) {
  return n(), o("svg", zt, Wt);
}
const Vm2 = /* @__PURE__ */ i(qt, [["render", Yt]]);
var Xt = {}, Qt = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jt = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), te = /* @__PURE__ */ t("path", {
  d: "M5 12H19M19 12L12 5M19 12L12 19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ee = [
  Jt,
  te
];
function re(r, e) {
  return n(), o("svg", Qt, ee);
}
const Zm2 = /* @__PURE__ */ i(Xt, [["render", re]]);
var ne = {}, oe = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ie = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), le = /* @__PURE__ */ t("path", {
  d: "M9.00019 9.00005V15.0001M9.00019 15.0001H15.0002M9.00019 15.0001L15.0002 8.99994M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), se = [
  ie,
  le
];
function he(r, e) {
  return n(), o("svg", oe, se);
}
const Bm2 = /* @__PURE__ */ i(ne, [["render", he]]);
var ae = {}, de = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ce = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -636)",
  fill: "none"
}, null, -1), _e = /* @__PURE__ */ t("path", {
  d: "M15.0002 9.00005V15.0001M15.0002 15.0001H9.00019M15.0002 15.0001L9.00019 8.99994M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ce = [
  ce,
  _e
];
function fe(r, e) {
  return n(), o("svg", de, Ce);
}
const Fm2 = /* @__PURE__ */ i(ae, [["render", fe]]);
var ve = {}, ue = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, we = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), pe = /* @__PURE__ */ t("path", {
  d: "M8 12L12 16M12 16L16 12M12 16V8M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ge = [
  we,
  pe
];
function $e(r, e) {
  return n(), o("svg", ue, ge);
}
const jm2 = /* @__PURE__ */ i(ve, [["render", $e]]);
var Me = {}, Le = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ke = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -676)",
  fill: "none"
}, null, -1), me = /* @__PURE__ */ t("path", {
  d: "M12 8L8 12M8 12L12 16M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), xe = [
  ke,
  me
];
function He(r, e) {
  return n(), o("svg", Le, xe);
}
const Im2 = /* @__PURE__ */ i(Me, [["render", He]]);
var Ve = {}, Ze = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Be = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -716)",
  fill: "none"
}, null, -1), Fe = /* @__PURE__ */ t("path", {
  d: "M12 16L16 12M16 12L12 8M16 12H8M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), je = [
  Be,
  Fe
];
function Ie(r, e) {
  return n(), o("svg", Ze, je);
}
const bm2 = /* @__PURE__ */ i(Ve, [["render", Ie]]);
var be = {}, ye = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, De = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -796)",
  fill: "none"
}, null, -1), Pe = /* @__PURE__ */ t("path", {
  d: "M9.00019 15.0001V9.00005M9.00019 9.00005H15.0002M9.00019 9.00005L15.0002 14.9999M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ae = [
  De,
  Pe
];
function Se(r, e) {
  return n(), o("svg", ye, Ae);
}
const ym2 = /* @__PURE__ */ i(be, [["render", Se]]);
var Te = {}, Oe = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ee = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -836)",
  fill: "none"
}, null, -1), Re = /* @__PURE__ */ t("path", {
  d: "M15.0002 15.0001V9.00005M15.0002 9.00005H9.00019M15.0002 9.00005L9.00019 14.9999M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ue = [
  Ee,
  Re
];
function Ne(r, e) {
  return n(), o("svg", Oe, Ue);
}
const Dm2 = /* @__PURE__ */ i(Te, [["render", Ne]]);
var qe = {}, ze = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ke = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -756)",
  fill: "none"
}, null, -1), Ge = /* @__PURE__ */ t("path", {
  d: "M16 12L12 8M12 8L8 12M12 8V16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), We = [
  Ke,
  Ge
];
function Ye(r, e) {
  return n(), o("svg", ze, We);
}
const Pm2 = /* @__PURE__ */ i(qe, [["render", Ye]]);
var Xe = {}, Qe = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Je = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -916)",
  fill: "none"
}, null, -1), tr = /* @__PURE__ */ t("path", {
  d: "M17 17L7 7M7 7V17M7 7H17",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), er = [
  Je,
  tr
];
function rr(r, e) {
  return n(), o("svg", Qe, er);
}
const Am2 = /* @__PURE__ */ i(Xe, [["render", rr]]);
var nr = {}, or = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ir = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -956)",
  fill: "none"
}, null, -1), lr = /* @__PURE__ */ t("path", {
  d: "M7 17L17 7M17 7H7M17 7V17",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), sr = [
  ir,
  lr
];
function hr(r, e) {
  return n(), o("svg", or, sr);
}
const Sm2 = /* @__PURE__ */ i(nr, [["render", hr]]);
var ar = {}, dr = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cr = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -876)",
  fill: "none"
}, null, -1), _r = /* @__PURE__ */ t("path", {
  d: "M12 19V5M12 5L5 12M12 5L19 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Cr = [
  cr,
  _r
];
function fr(r, e) {
  return n(), o("svg", dr, Cr);
}
const vr = /* @__PURE__ */ i(ar, [["render", fr]]);
var ur = {}, wr = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pr = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -996)",
  fill: "none"
}, null, -1), gr = /* @__PURE__ */ t("path", {
  d: "M17 4V15M17 15L13 11M17 15L21 11M7 4V20M7 20L3 16M7 20L11 16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $r = [
  pr,
  gr
];
function Mr(r, e) {
  return n(), o("svg", wr, $r);
}
const Tm2 = /* @__PURE__ */ i(ur, [["render", Mr]]);
var Lr = {}, kr = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mr = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-336 -1036)",
  fill: "none"
}, null, -1), xr = /* @__PURE__ */ t("path", {
  d: "M20 17H4M4 17L8 21M4 17L8 13M20 7H9M9 7L13 11M9 7L13 3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Hr = [
  mr,
  xr
];
function Vr(r, e) {
  return n(), o("svg", kr, Hr);
}
const Om2 = /* @__PURE__ */ i(Lr, [["render", Vr]]);
var Zr = {}, Br = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fr = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), jr = /* @__PURE__ */ t("path", {
  d: "M4 7H15M15 7L11 11M15 7L11 3M4 17H20M20 17L16 21M20 17L16 13",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ir = [
  Fr,
  jr
];
function br(r, e) {
  return n(), o("svg", Br, Ir);
}
const Em2 = /* @__PURE__ */ i(Zr, [["render", br]]);
var yr = {}, Dr = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pr = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), Ar = /* @__PURE__ */ t("path", {
  d: "M13 19H17.2942C19.1594 19 20.092 19 20.6215 18.6092C21.0832 18.2685 21.3763 17.7459 21.4263 17.1743C21.4836 16.5187 20.9973 15.7229 20.0247 14.1313L19.0278 12.5M6.13014 10.6052L3.97528 14.1314C3.00267 15.7229 2.51637 16.5187 2.57372 17.1743C2.62372 17.7459 2.91681 18.2685 3.37846 18.6092C3.90799 19 4.84059 19 6.70578 19H8.5M16.8889 8.99999L14.7305 5.46808C13.8277 3.99079 13.3763 3.25214 12.7952 3.00033C12.2879 2.78049 11.7121 2.78049 11.2048 3.00033C10.6237 3.25214 10.1723 3.99079 9.2695 5.46809L8.24967 7.13689M18 5.00006L16.9019 9.09813L12.8038 8.00006M2 11.5981L6.09808 10.5L7.19615 14.5981M15.5 22L12.5 19L15.5 16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Sr = [
  Pr,
  Ar
];
function Tr(r, e) {
  return n(), o("svg", Dr, Sr);
}
const Rm2 = /* @__PURE__ */ i(yr, [["render", Tr]]);
var Or = {}, Er = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rr = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), Ur = /* @__PURE__ */ t("path", {
  d: "M7 20V4M7 4L3 8M7 4L11 8M17 20V9M17 9L13 13M17 9L21 13",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Nr = [
  Rr,
  Ur
];
function qr(r, e) {
  return n(), o("svg", Er, Nr);
}
const Um2 = /* @__PURE__ */ i(Or, [["render", qr]]);
var zr = {}, Kr = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gr = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), Wr = /* @__PURE__ */ t("path", {
  d: "M12 2V22M19.0711 4.92893L4.92893 19.0711M22 12H2M19.0711 19.0711L4.92893 4.92893",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Yr = [
  Gr,
  Wr
];
function Xr(r, e) {
  return n(), o("svg", Kr, Yr);
}
const Nm2 = /* @__PURE__ */ i(zr, [["render", Xr]]);
var Qr = {}, Jr = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tn = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), en = /* @__PURE__ */ t("path", {
  d: "M12 4V20M18 6L6 18M20 12H4M18 18L6 6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rn = [
  tn,
  en
];
function nn(r, e) {
  return n(), o("svg", Jr, rn);
}
const qm2 = /* @__PURE__ */ i(Qr, [["render", nn]]);
var on = {}, ln = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sn = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), hn = /* @__PURE__ */ t("path", {
  d: "M16 7.99999V13C16 13.7956 16.3161 14.5587 16.8787 15.1213C17.4413 15.6839 18.2043 16 19 16C19.7956 16 20.5587 15.6839 21.1213 15.1213C21.6839 14.5587 22 13.7956 22 13V12C21.9999 9.74302 21.2362 7.55247 19.8333 5.78452C18.4303 4.01658 16.4705 2.77521 14.2726 2.26229C12.0747 1.74936 9.76793 1.99503 7.72734 2.95936C5.68676 3.92368 4.03239 5.54995 3.03325 7.57371C2.03411 9.59748 1.74896 11.8997 2.22416 14.1061C2.69936 16.3125 3.90697 18.2932 5.65062 19.7263C7.39428 21.1593 9.57143 21.9603 11.8281 21.9991C14.0847 22.0379 16.2881 21.3122 18.08 19.94M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79085 9.79086 7.99999 12 7.99999C14.2091 7.99999 16 9.79085 16 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), an = [
  sn,
  hn
];
function dn(r, e) {
  return n(), o("svg", ln, an);
}
const zm2 = /* @__PURE__ */ i(on, [["render", dn]]);
var cn = {}, _n = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cn = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), fn = /* @__PURE__ */ t("path", {
  d: "M11.9995 12.0001H12.0095M15.535 15.5357C10.8488 20.222 5.46685 22.438 3.51423 20.4854C1.56161 18.5328 3.77769 13.1509 8.46398 8.46461C13.1503 3.77832 18.5322 1.56224 20.4848 3.51486C22.4374 5.46748 20.2213 10.8494 15.535 15.5357ZM15.535 8.46443C20.2213 13.1507 22.4374 18.5326 20.4848 20.4852C18.5321 22.4379 13.1502 20.2218 8.46394 15.5355C3.77765 10.8492 1.56157 5.4673 3.51419 3.51468C5.46681 1.56206 10.8487 3.77814 15.535 8.46443ZM12.4995 12.0001C12.4995 12.2763 12.2757 12.5001 11.9995 12.5001C11.7234 12.5001 11.4995 12.2763 11.4995 12.0001C11.4995 11.724 11.7234 11.5001 11.9995 11.5001C12.2757 11.5001 12.4995 11.724 12.4995 12.0001Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vn = [
  Cn,
  fn
];
function un(r, e) {
  return n(), o("svg", _n, vn);
}
const Km2 = /* @__PURE__ */ i(cn, [["render", un]]);
var wn = {}, pn = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gn = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), $n = /* @__PURE__ */ t("path", {
  d: "M17.1153 15.3582C16.8446 15.6642 16.5606 15.9665 16.2635 16.2635C11.9678 20.5593 6.58585 22.1422 4.2427 19.7991C2.6363 18.1926 2.8752 15.158 4.56847 12.0242M6.88967 8.72526C7.17138 8.40495 7.46772 8.08875 7.77824 7.77824C12.074 3.48247 17.4559 1.89956 19.7991 4.2427C21.4066 5.85021 21.1662 8.88795 19.4698 12.024M16.2635 7.77824C20.5593 12.074 22.1422 17.4559 19.7991 19.7991C17.4559 22.1422 12.074 20.5593 7.77824 16.2635C3.48247 11.9678 1.89956 6.58585 4.2427 4.2427C6.58585 1.89956 11.9678 3.48247 16.2635 7.77824ZM13.0001 12C13.0001 12.5523 12.5523 13 12.0001 13C11.4478 13 11.0001 12.5523 11.0001 12C11.0001 11.4477 11.4478 11 12.0001 11C12.5523 11 13.0001 11.4477 13.0001 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Mn = [
  gn,
  $n
];
function Ln(r, e) {
  return n(), o("svg", pn, Mn);
}
const Gm2 = /* @__PURE__ */ i(wn, [["render", Ln]]);
var kn = {}, mn = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xn = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), Hn = /* @__PURE__ */ t("path", {
  d: "M21.1525 10.8995L12.1369 19.9151C10.0866 21.9653 6.7625 21.9653 4.71225 19.9151C2.662 17.8648 2.662 14.5407 4.71225 12.4904L13.7279 3.47483C15.0947 2.108 17.3108 2.108 18.6776 3.47483C20.0444 4.84167 20.0444 7.05775 18.6776 8.42458L10.0156 17.0866C9.33213 17.7701 8.22409 17.7701 7.54068 17.0866C6.85726 16.4032 6.85726 15.2952 7.54068 14.6118L15.1421 7.01037",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Vn = [
  xn,
  Hn
];
function Zn(r, e) {
  return n(), o("svg", mn, Vn);
}
const Wm2 = /* @__PURE__ */ i(kn, [["render", Zn]]);
var Bn = {}, Fn = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jn = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), In = /* @__PURE__ */ t("path", {
  d: "M17.5 5.25581V16.5C17.5 19.5376 15.0376 22 12 22C8.96243 22 6.5 19.5376 6.5 16.5V5.66667C6.5 3.64162 8.14162 2 10.1667 2C12.1917 2 13.8333 3.64162 13.8333 5.66667V16.4457C13.8333 17.4583 13.0125 18.2791 12 18.2791C10.9875 18.2791 10.1667 17.4583 10.1667 16.4457V6.65116",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bn = [
  jn,
  In
];
function yn(r, e) {
  return n(), o("svg", Fn, bn);
}
const Ym2 = /* @__PURE__ */ i(Bn, [["render", yn]]);
var Dn = {}, Pn = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, An = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), Sn = /* @__PURE__ */ t("path", {
  d: "M7.96668 14.7219L7 22L11.5884 19.247C11.7381 19.1572 11.8129 19.1123 11.8928 19.0947C11.9634 19.0792 12.0366 19.0792 12.1072 19.0947C12.1871 19.1123 12.2619 19.1572 12.4116 19.247L17 22L16.0343 14.7212M19 9C19 12.866 15.866 16 12 16C8.13401 16 5 12.866 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Tn = [
  An,
  Sn
];
function On(r, e) {
  return n(), o("svg", Pn, Tn);
}
const Xm2 = /* @__PURE__ */ i(Dn, [["render", On]]);
var En = {}, Rn = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Un = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), Nn = /* @__PURE__ */ t("path", {
  d: "M7 15.0903V22L11.7029 20.1188C11.8126 20.0749 11.8675 20.053 11.9242 20.0443C11.9744 20.0366 12.0256 20.0366 12.0758 20.0443C12.1325 20.053 12.1874 20.0749 12.2971 20.1188L17 22V15.0903M19.5 9.5C19.5 13.6421 16.1421 17 12 17C7.85786 17 4.5 13.6421 4.5 9.5C4.5 5.35786 7.85786 2 12 2C16.1421 2 19.5 5.35786 19.5 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qn = [
  Un,
  Nn
];
function zn(r, e) {
  return n(), o("svg", Rn, qn);
}
const Qm2 = /* @__PURE__ */ i(En, [["render", zn]]);
var Kn = {}, Gn = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wn = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), Yn = /* @__PURE__ */ t("path", {
  d: "M7.86866 15.4599L7 22L11.5884 19.247C11.7381 19.1572 11.8129 19.1123 11.8928 19.0947C11.9634 19.0792 12.0366 19.0792 12.1072 19.0947C12.1871 19.1123 12.2619 19.1572 12.4116 19.247L17 22L16.1319 15.4571M16.4259 4.24888C16.5803 4.6224 16.8768 4.9193 17.25 5.0743L18.5589 5.61648C18.9325 5.77121 19.2292 6.06799 19.384 6.44154C19.5387 6.81509 19.5387 7.23481 19.384 7.60836L18.8422 8.91635C18.6874 9.29007 18.6872 9.71021 18.8427 10.0837L19.3835 11.3913C19.4602 11.5764 19.4997 11.7747 19.4997 11.975C19.4998 12.1752 19.4603 12.3736 19.3837 12.5586C19.3071 12.7436 19.1947 12.9118 19.0531 13.0534C18.9114 13.195 18.7433 13.3073 18.5582 13.3839L17.2503 13.9256C16.8768 14.0801 16.5799 14.3765 16.4249 14.7498L15.8827 16.0588C15.728 16.4323 15.4312 16.7291 15.0577 16.8838C14.6841 17.0386 14.2644 17.0386 13.8909 16.8838L12.583 16.342C12.2094 16.1877 11.7899 16.188 11.4166 16.3429L10.1077 16.8843C9.73434 17.0387 9.31501 17.0386 8.94178 16.884C8.56854 16.7293 8.27194 16.4329 8.11711 16.0598L7.57479 14.7504C7.42035 14.3769 7.12391 14.08 6.75064 13.925L5.44175 13.3828C5.06838 13.2282 4.77169 12.9316 4.61691 12.5582C4.46213 12.1849 4.46192 11.7654 4.61633 11.3919L5.1581 10.0839C5.31244 9.71035 5.31213 9.29079 5.15722 8.91746L4.61623 7.60759C4.53953 7.42257 4.50003 7.22426 4.5 7.02397C4.49997 6.82369 4.5394 6.62536 4.61604 6.44032C4.69268 6.25529 4.80504 6.08716 4.94668 5.94556C5.08832 5.80396 5.25647 5.69166 5.44152 5.61508L6.74947 5.07329C7.12265 4.91898 7.41936 4.6229 7.57448 4.25004L8.11664 2.94111C8.27136 2.56756 8.56813 2.27078 8.94167 2.11605C9.3152 1.96132 9.7349 1.96132 10.1084 2.11605L11.4164 2.65784C11.7899 2.81218 12.2095 2.81187 12.5828 2.65696L13.8922 2.11689C14.2657 1.96224 14.6853 1.96228 15.0588 2.11697C15.4322 2.27167 15.729 2.56837 15.8837 2.94182L16.426 4.25115L16.4259 4.24888Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Xn = [
  Wn,
  Yn
];
function Qn(r, e) {
  return n(), o("svg", Gn, Xn);
}
const Jm2 = /* @__PURE__ */ i(Kn, [["render", Qn]]);
var Jn = {}, to = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eo = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), ro = /* @__PURE__ */ t("path", {
  d: "M8.87625 13.0953L4.70122 7.87653C4.44132 7.55166 4.31138 7.38922 4.21897 7.20834C4.13698 7.04787 4.07706 6.87705 4.04084 6.70052C4 6.50155 4 6.29354 4 5.8775V5.2C4 4.0799 4 3.51984 4.21799 3.09202C4.40973 2.71569 4.71569 2.40973 5.09202 2.21799C5.51984 2 6.0799 2 7.2 2H16.8C17.9201 2 18.4802 2 18.908 2.21799C19.2843 2.40973 19.5903 2.71569 19.782 3.09202C20 3.51984 20 4.0799 20 5.2V5.8775C20 6.29354 20 6.50155 19.9592 6.70052C19.9229 6.87705 19.863 7.04787 19.781 7.20834C19.6886 7.38922 19.5587 7.55166 19.2988 7.87652L15.1238 13.0953M5.00005 3L12.0001 12L19 3M15.5355 13.4645C17.4882 15.4171 17.4882 18.5829 15.5355 20.5355C13.5829 22.4882 10.4171 22.4882 8.46446 20.5355C6.51185 18.5829 6.51185 15.4171 8.46446 13.4645C10.4171 11.5118 13.5829 11.5118 15.5355 13.4645Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), no = [
  eo,
  ro
];
function oo(r, e) {
  return n(), o("svg", to, no);
}
const tx2 = /* @__PURE__ */ i(Jn, [["render", oo]]);
var io = {}, lo = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, so = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), ho = /* @__PURE__ */ t("path", {
  d: "M7.13515 11.189L3.3304 4.38052C2.89291 3.59765 2.67417 3.20621 2.71103 2.88573C2.7432 2.60611 2.8917 2.353 3.1201 2.18852C3.38188 2 3.83029 2 4.72711 2H6.96193C7.29523 2 7.46187 2 7.61135 2.04813C7.74362 2.09073 7.86556 2.16042 7.96939 2.25276C8.08674 2.35712 8.17132 2.5007 8.3405 2.78788L12.0001 9L15.6597 2.78788C15.8289 2.5007 15.9135 2.35712 16.0308 2.25276C16.1347 2.16042 16.2566 2.09073 16.3889 2.04813C16.5383 2 16.705 2 17.0383 2H19.2731C20.1699 2 20.6183 2 20.8801 2.18852C21.1085 2.353 21.257 2.60611 21.2892 2.88573C21.326 3.20621 21.1073 3.59765 20.6698 4.38052L16.8651 11.189M10.5001 14L12.0001 13V18M10.7501 18H13.2501M16.5963 10.9038C19.1347 13.4422 19.1347 17.5578 16.5963 20.0962C14.0579 22.6346 9.94232 22.6346 7.40391 20.0962C4.8655 17.5578 4.8655 13.4422 7.40391 10.9038C9.94231 8.3654 14.0579 8.3654 16.5963 10.9038Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ao = [
  so,
  ho
];
function co(r, e) {
  return n(), o("svg", lo, ao);
}
const ex2 = /* @__PURE__ */ i(io, [["render", co]]);
var _o = {}, Co = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fo = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), vo = /* @__PURE__ */ t("path", {
  d: "M20 13V17.8C20 18.9201 20 19.4802 19.782 19.908C19.5903 20.2843 19.2843 20.5903 18.908 20.782C18.4802 21 17.9201 21 16.8 21H7.2C6.0799 21 5.51984 21 5.09202 20.782C4.71569 20.5903 4.40973 20.2843 4.21799 19.908C4 19.4802 4 18.9201 4 17.8V13M9 10H15M9.28571 14H14.7143C16.8467 14 17.913 14 18.7355 13.6039C19.552 13.2107 20.2107 12.552 20.6039 11.7355C21 10.913 21 9.84674 21 7.71429C21 6.11494 21 5.31527 20.7029 4.69835C20.408 4.08603 19.914 3.59197 19.3017 3.29709C18.6847 3 17.8851 3 16.2857 3H7.71429C6.11494 3 5.31527 3 4.69835 3.29709C4.08603 3.59197 3.59197 4.08603 3.29709 4.69835C3 5.31527 3 6.11494 3 7.71429C3 9.84674 3 10.913 3.39612 11.7355C3.7893 12.552 4.44803 13.2107 5.26447 13.6039C6.08703 14 7.15326 14 9.28571 14Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uo = [
  fo,
  vo
];
function wo(r, e) {
  return n(), o("svg", Co, uo);
}
const rx2 = /* @__PURE__ */ i(_o, [["render", wo]]);
var po = {}, go = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $o = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), Mo = /* @__PURE__ */ t("path", {
  d: "M6 11V15M18 9V13M17 4C19.4487 4 20.7731 4.37476 21.4321 4.66544C21.5199 4.70415 21.5638 4.72351 21.6904 4.84437C21.7663 4.91682 21.9049 5.12939 21.9405 5.22809C22 5.39274 22 5.48274 22 5.66274V16.4111C22 17.3199 22 17.7743 21.8637 18.0079C21.7251 18.2454 21.5914 18.3559 21.3319 18.4472C21.0769 18.5369 20.562 18.438 19.5322 18.2401C18.8114 18.1017 17.9565 18 17 18C14 18 11 20 7 20C4.55129 20 3.22687 19.6252 2.56788 19.3346C2.48012 19.2958 2.43624 19.2765 2.3096 19.1556C2.23369 19.0832 2.09512 18.8706 2.05947 18.7719C2 18.6073 2 18.5173 2 18.3373L2 7.58885C2 6.68009 2 6.2257 2.13628 5.99214C2.2749 5.75456 2.40859 5.64412 2.66806 5.55281C2.92314 5.46305 3.43803 5.56198 4.46783 5.75985C5.18862 5.89834 6.04348 6 7 6C10 6 13 4 17 4ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Lo = [
  $o,
  Mo
];
function ko(r, e) {
  return n(), o("svg", go, Lo);
}
const nx2 = /* @__PURE__ */ i(po, [["render", ko]]);
var mo = {}, xo = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ho = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), Vo = /* @__PURE__ */ t("path", {
  d: "M6 10V14M18 10V14M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zo = [
  Ho,
  Vo
];
function Bo(r, e) {
  return n(), o("svg", xo, Zo);
}
const ox2 = /* @__PURE__ */ i(mo, [["render", Bo]]);
var Fo = {}, jo = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Io = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), bo = /* @__PURE__ */ t("path", {
  d: "M14 9H11.5C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.5C13.3284 12 14 12.6716 14 13.5C14 14.3284 13.3284 15 12.5 15H10M12 8V9M12 15V16M18 12H18.01M6 12H6.01M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2ZM18.5 12C18.5 12.2761 18.2761 12.5 18 12.5C17.7239 12.5 17.5 12.2761 17.5 12C17.5 11.7239 17.7239 11.5 18 11.5C18.2761 11.5 18.5 11.7239 18.5 12ZM6.5 12C6.5 12.2761 6.27614 12.5 6 12.5C5.72386 12.5 5.5 12.2761 5.5 12C5.5 11.7239 5.72386 11.5 6 11.5C6.27614 11.5 6.5 11.7239 6.5 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yo = [
  Io,
  bo
];
function Do(r, e) {
  return n(), o("svg", jo, yo);
}
const ix2 = /* @__PURE__ */ i(Fo, [["render", Do]]);
var Po = {}, Ao = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, So = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), To = /* @__PURE__ */ t("path", {
  d: "M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Oo = [
  So,
  To
];
function Eo(r, e) {
  return n(), o("svg", Ao, Oo);
}
const lx2 = /* @__PURE__ */ i(Po, [["render", Eo]]);
var Ro = {}, Uo = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, No = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -156)",
  fill: "none"
}, null, -1), qo = /* @__PURE__ */ t("path", {
  d: "M18 20V10M12 20V4M6 20V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zo = [
  No,
  qo
];
function Ko(r, e) {
  return n(), o("svg", Uo, zo);
}
const sx2 = /* @__PURE__ */ i(Ro, [["render", Ko]]);
var Go = {}, Wo = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yo = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -196)",
  fill: "none"
}, null, -1), Xo = /* @__PURE__ */ t("path", {
  d: "M18 20V4M6 20V16M12 20V10",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qo = [
  Yo,
  Xo
];
function Jo(r, e) {
  return n(), o("svg", Wo, Qo);
}
const hx2 = /* @__PURE__ */ i(Go, [["render", Jo]]);
var ti = {}, ei = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ri = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -236)",
  fill: "none"
}, null, -1), ni = /* @__PURE__ */ t("path", {
  d: "M6 20V4M18 20V16M12 20V10",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oi = [
  ri,
  ni
];
function ii(r, e) {
  return n(), o("svg", ei, oi);
}
const ax2 = /* @__PURE__ */ i(ti, [["render", ii]]);
var li = {}, si = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hi = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -276)",
  fill: "none"
}, null, -1), ai = /* @__PURE__ */ t("path", {
  d: "M3 11L3 21M15 11L15 21M9 3L9 21M21 3V21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), di = [
  hi,
  ai
];
function ci(r, e) {
  return n(), o("svg", si, di);
}
const dx2 = /* @__PURE__ */ i(li, [["render", ci]]);
var _i = {}, Ci = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fi = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -316)",
  fill: "none"
}, null, -1), vi = /* @__PURE__ */ t("path", {
  d: "M3 17V21M15 8V21M9 13V21M21 3V21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ui = [
  fi,
  vi
];
function wi(r, e) {
  return n(), o("svg", Ci, ui);
}
const cx2 = /* @__PURE__ */ i(_i, [["render", wi]]);
var pi = {}, gi = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $i = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -356)",
  fill: "none"
}, null, -1), Mi = /* @__PURE__ */ t("path", {
  d: "M9 8V21M21 17V21M3 3V21M15 13V21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Li = [
  $i,
  Mi
];
function ki(r, e) {
  return n(), o("svg", gi, Li);
}
const _x2 = /* @__PURE__ */ i(pi, [["render", ki]]);
var mi = {}, xi = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hi = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -396)",
  fill: "none"
}, null, -1), Vi = /* @__PURE__ */ t("path", {
  d: "M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 10.5V17.5M11.5 5.5V17.5M16 10.5V17.5M20.5 5.5V17.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zi = [
  Hi,
  Vi
];
function Bi(r, e) {
  return n(), o("svg", xi, Zi);
}
const Cx2 = /* @__PURE__ */ i(mi, [["render", Bi]]);
var Fi = {}, ji = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ii = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -436)",
  fill: "none"
}, null, -1), bi = /* @__PURE__ */ t("path", {
  d: "M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 14.5V17.5M11.5 11.5V17.5M16 8.5V17.5M20.5 5.5V17.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yi = [
  Ii,
  bi
];
function Di(r, e) {
  return n(), o("svg", ji, yi);
}
const fx2 = /* @__PURE__ */ i(Fi, [["render", Di]]);
var Pi = {}, Ai = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Si = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -476)",
  fill: "none"
}, null, -1), Ti = /* @__PURE__ */ t("path", {
  d: "M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 5.5V17.5M11.5 8.5V17.5M16 11.5V17.5M20.5 14.5V17.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Oi = [
  Si,
  Ti
];
function Ei(r, e) {
  return n(), o("svg", Ai, Oi);
}
const vx2 = /* @__PURE__ */ i(Pi, [["render", Ei]]);
var Ri = {}, Ui = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ni = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -516)",
  fill: "none"
}, null, -1), qi = /* @__PURE__ */ t("path", {
  d: "M9 7H4.6C4.03995 7 3.75992 7 3.54601 7.10899C3.35785 7.20487 3.20487 7.35785 3.10899 7.54601C3 7.75992 3 8.03995 3 8.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H9M9 21H15M9 21L9 4.6C9 4.03995 9 3.75992 9.10899 3.54601C9.20487 3.35785 9.35785 3.20487 9.54601 3.10899C9.75992 3 10.0399 3 10.6 3L13.4 3C13.9601 3 14.2401 3 14.454 3.10899C14.6422 3.20487 14.7951 3.35785 14.891 3.54601C15 3.75992 15 4.03995 15 4.6V21M15 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V19.4C21 19.9601 21 20.2401 20.891 20.454C20.7951 20.6422 20.6422 20.7951 20.454 20.891C20.2401 21 19.9601 21 19.4 21H15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zi = [
  Ni,
  qi
];
function Ki(r, e) {
  return n(), o("svg", Ui, zi);
}
const ux2 = /* @__PURE__ */ i(Ri, [["render", Ki]]);
var Gi = {}, Wi = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yi = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -556)",
  fill: "none"
}, null, -1), Xi = /* @__PURE__ */ t("path", {
  d: "M9 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V4.6C3 4.03995 3 3.75992 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.75992 3 4.03995 3 4.6 3H7.4C7.96005 3 8.24008 3 8.45399 3.10899C8.64215 3.20487 8.79513 3.35785 8.89101 3.54601C9 3.75992 9 4.03995 9 4.6V7M9 21H15M9 21L9 7M9 7H13.4C13.9601 7 14.2401 7 14.454 7.10899C14.6422 7.20487 14.7951 7.35785 14.891 7.54601C15 7.75992 15 8.03995 15 8.6V21M15 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V19.4C21 19.9601 21 20.2401 20.891 20.454C20.7951 20.6422 20.6422 20.7951 20.454 20.891C20.2401 21 19.9601 21 19.4 21H15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qi = [
  Yi,
  Xi
];
function Ji(r, e) {
  return n(), o("svg", Wi, Qi);
}
const wx2 = /* @__PURE__ */ i(Gi, [["render", Ji]]);
var tl = {}, el = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rl = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -596)",
  fill: "none"
}, null, -1), nl = /* @__PURE__ */ t("path", {
  d: "M9 12H4.6C4.03995 12 3.75992 12 3.54601 12.109C3.35785 12.2049 3.20487 12.3578 3.10899 12.546C3 12.7599 3 13.0399 3 13.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H9M9 21H15M9 21L9 8.6C9 8.03995 9 7.75992 9.10899 7.54601C9.20487 7.35785 9.35785 7.20487 9.54601 7.10899C9.75992 7 10.0399 7 10.6 7H13.4C13.9601 7 14.2401 7 14.454 7.10899C14.6422 7.20487 14.7951 7.35785 14.891 7.54601C15 7.75992 15 8.03995 15 8.6V21M15 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H16.6C16.0399 3 15.7599 3 15.546 3.10899C15.3578 3.20487 15.2049 3.35785 15.109 3.54601C15 3.75992 15 4.03995 15 4.6V8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ol = [
  rl,
  nl
];
function il(r, e) {
  return n(), o("svg", el, ol);
}
const px2 = /* @__PURE__ */ i(tl, [["render", il]]);
var ll = {}, sl = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hl = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-75 -636)",
  fill: "none"
}, null, -1), al = /* @__PURE__ */ t("path", {
  d: "M8 13V17M16 11V17M12 7V17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dl = [
  hl,
  al
];
function cl(r, e) {
  return n(), o("svg", sl, dl);
}
const gx2 = /* @__PURE__ */ i(ll, [["render", cl]]);
var _l = {}, Cl = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fl = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -156)",
  fill: "none"
}, null, -1), vl = /* @__PURE__ */ t("path", {
  d: "M8 15V17M12 11V17M16 7V17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ul = [
  fl,
  vl
];
function wl(r, e) {
  return n(), o("svg", Cl, ul);
}
const $x2 = /* @__PURE__ */ i(_l, [["render", wl]]);
var pl = {}, gl = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $l = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -196)",
  fill: "none"
}, null, -1), Ml = /* @__PURE__ */ t("path", {
  d: "M8 7V17M12 11V17M16 15V17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ll = [
  $l,
  Ml
];
function kl(r, e) {
  return n(), o("svg", gl, Ll);
}
const Mx2 = /* @__PURE__ */ i(pl, [["render", kl]]);
var ml = {}, xl = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hl = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -236)",
  fill: "none"
}, null, -1), Vl = /* @__PURE__ */ t("path", {
  d: "M8 13V17M16 11V17M12 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zl = [
  Hl,
  Vl
];
function Bl(r, e) {
  return n(), o("svg", xl, Zl);
}
const Lx2 = /* @__PURE__ */ i(ml, [["render", Bl]]);
var Fl = {}, jl = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Il = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -276)",
  fill: "none"
}, null, -1), bl = /* @__PURE__ */ t("path", {
  d: "M8 15V17M12 11V17M16 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yl = [
  Il,
  bl
];
function Dl(r, e) {
  return n(), o("svg", jl, yl);
}
const kx2 = /* @__PURE__ */ i(Fl, [["render", Dl]]);
var Pl = {}, Al = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sl = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -316)",
  fill: "none"
}, null, -1), Tl = /* @__PURE__ */ t("path", {
  d: "M8 7V17M12 11V17M16 15V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ol = [
  Sl,
  Tl
];
function El(r, e) {
  return n(), o("svg", Al, Ol);
}
const mx2 = /* @__PURE__ */ i(Pl, [["render", El]]);
var Rl = {}, Ul = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nl = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -356)",
  fill: "none"
}, null, -1), ql = /* @__PURE__ */ t("path", {
  d: "M12 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M8 13V17M16 11V17M12 7V17M2 5L5 8M5 8L8 5M5 8L5 2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zl = [
  Nl,
  ql
];
function Kl(r, e) {
  return n(), o("svg", Ul, zl);
}
const xx2 = /* @__PURE__ */ i(Rl, [["render", Kl]]);
var Gl = {}, Wl = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yl = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -396)",
  fill: "none"
}, null, -1), Xl = /* @__PURE__ */ t("path", {
  d: "M12 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M8 13V17M16 11V17M12 7V17M2 5H8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ql = [
  Yl,
  Xl
];
function Jl(r, e) {
  return n(), o("svg", Wl, Ql);
}
const Hx2 = /* @__PURE__ */ i(Gl, [["render", Jl]]);
var ts = {}, es = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rs = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -436)",
  fill: "none"
}, null, -1), ns = /* @__PURE__ */ t("path", {
  d: "M12 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M8 13V17M16 11V17M12 7V17M5 8V2M2 5H8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), os = [
  rs,
  ns
];
function is(r, e) {
  return n(), o("svg", es, os);
}
const Vx2 = /* @__PURE__ */ i(ts, [["render", is]]);
var ls = {}, ss = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hs = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -476)",
  fill: "none"
}, null, -1), as = /* @__PURE__ */ t("path", {
  d: "M12 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M8 13V17M16 11V17M12 7V17M2 5L5 2M5 2L8 5M5 2L5 8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ds = [
  hs,
  as
];
function cs(r, e) {
  return n(), o("svg", ss, ds);
}
const Zx2 = /* @__PURE__ */ i(ls, [["render", cs]]);
var _s = {}, Cs = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fs = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -516)",
  fill: "none"
}, null, -1), vs = /* @__PURE__ */ t("path", {
  d: "M20 20V13M12 20V10M4 20L4 16M13.4067 5.0275L18.5751 6.96567M10.7988 5.40092L5.20023 9.59983M21.0607 6.43934C21.6464 7.02513 21.6464 7.97487 21.0607 8.56066C20.4749 9.14645 19.5251 9.14645 18.9393 8.56066C18.3536 7.97487 18.3536 7.02513 18.9393 6.43934C19.5251 5.85355 20.4749 5.85355 21.0607 6.43934ZM5.06066 9.43934C5.64645 10.0251 5.64645 10.9749 5.06066 11.5607C4.47487 12.1464 3.52513 12.1464 2.93934 11.5607C2.35355 10.9749 2.35355 10.0251 2.93934 9.43934C3.52513 8.85355 4.47487 8.85355 5.06066 9.43934ZM13.0607 3.43934C13.6464 4.02513 13.6464 4.97487 13.0607 5.56066C12.4749 6.14645 11.5251 6.14645 10.9393 5.56066C10.3536 4.97487 10.3536 4.02513 10.9393 3.43934C11.5251 2.85355 12.4749 2.85355 13.0607 3.43934Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), us = [
  fs,
  vs
];
function ws(r, e) {
  return n(), o("svg", Cs, us);
}
const Bx2 = /* @__PURE__ */ i(_s, [["render", ws]]);
var ps = {}, gs = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $s = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), Ms = /* @__PURE__ */ t("path", {
  d: "M10.8333 15L12.5 12H8.5L10.1667 9M22 13V11M6.8 18H14.2C15.8802 18 16.7202 18 17.362 17.673C17.9265 17.3854 18.3854 16.9265 18.673 16.362C19 15.7202 19 14.8802 19 13.2V10.8C19 9.11984 19 8.27976 18.673 7.63803C18.3854 7.07354 17.9265 6.6146 17.362 6.32698C16.7202 6 15.8802 6 14.2 6H6.8C5.11984 6 4.27976 6 3.63803 6.32698C3.07354 6.6146 2.6146 7.07354 2.32698 7.63803C2 8.27976 2 9.11984 2 10.8V13.2C2 14.8802 2 15.7202 2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673C4.27976 18 5.11984 18 6.8 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ls = [
  $s,
  Ms
];
function ks(r, e) {
  return n(), o("svg", gs, Ls);
}
const Fx2 = /* @__PURE__ */ i(ps, [["render", ks]]);
var ms = {}, xs = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hs = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), Vs = /* @__PURE__ */ t("path", {
  d: "M9.5 18L13.5 12H7.5L11.5 6M22 13V11M14 18H14.2C15.8802 18 16.7202 18 17.362 17.673C17.9265 17.3854 18.3854 16.9265 18.673 16.362C19 15.7202 19 14.8802 19 13.2V10C19 9.07003 19 8.60504 18.8978 8.22354C18.6204 7.18827 17.8117 6.37962 16.7765 6.10222C16.395 6 15.93 6 15 6M7 6H6.8C5.11984 6 4.27976 6 3.63803 6.32698C3.07354 6.6146 2.6146 7.07354 2.32698 7.63803C2 8.27976 2 9.11984 2 10.8V14C2 14.93 2 15.395 2.10222 15.7765C2.37962 16.8117 3.18827 17.6204 4.22354 17.8978C4.60504 18 5.07003 18 6 18",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zs = [
  Hs,
  Vs
];
function Bs(r, e) {
  return n(), o("svg", xs, Zs);
}
const jx2 = /* @__PURE__ */ i(ms, [["render", Bs]]);
var Fs = {}, js = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Is = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), bs = /* @__PURE__ */ t("path", {
  d: "M22 13V11M6.8 18H14.2C15.8802 18 16.7202 18 17.362 17.673C17.9265 17.3854 18.3854 16.9265 18.673 16.362C19 15.7202 19 14.8802 19 13.2V10.8C19 9.11984 19 8.27976 18.673 7.63803C18.3854 7.07354 17.9265 6.6146 17.362 6.32698C16.7202 6 15.8802 6 14.2 6H6.8C5.11984 6 4.27976 6 3.63803 6.32698C3.07354 6.6146 2.6146 7.07354 2.32698 7.63803C2 8.27976 2 9.11984 2 10.8V13.2C2 14.8802 2 15.7202 2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673C4.27976 18 5.11984 18 6.8 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ys = [
  Is,
  bs
];
function Ds(r, e) {
  return n(), o("svg", js, ys);
}
const Ix2 = /* @__PURE__ */ i(Fs, [["render", Ds]]);
var Ps = {}, As = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ss = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), Ts = /* @__PURE__ */ t("path", {
  d: "M6.5 10V14M10.5 10V14M14.5 10V14M22 13V11M6.8 18H14.2C15.8802 18 16.7202 18 17.362 17.673C17.9265 17.3854 18.3854 16.9265 18.673 16.362C19 15.7202 19 14.8802 19 13.2V10.8C19 9.11984 19 8.27976 18.673 7.63803C18.3854 7.07354 17.9265 6.6146 17.362 6.32698C16.7202 6 15.8802 6 14.2 6H6.8C5.11984 6 4.27976 6 3.63803 6.32698C3.07354 6.6146 2.6146 7.07354 2.32698 7.63803C2 8.27976 2 9.11984 2 10.8V13.2C2 14.8802 2 15.7202 2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673C4.27976 18 5.11984 18 6.8 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Os = [
  Ss,
  Ts
];
function Es(r, e) {
  return n(), o("svg", As, Os);
}
const bx2 = /* @__PURE__ */ i(Ps, [["render", Es]]);
var Rs = {}, Us = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ns = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), qs = /* @__PURE__ */ t("path", {
  d: "M6.5 10V14M22 13V11M6.8 18H14.2C15.8802 18 16.7202 18 17.362 17.673C17.9265 17.3854 18.3854 16.9265 18.673 16.362C19 15.7202 19 14.8802 19 13.2V10.8C19 9.11984 19 8.27976 18.673 7.63803C18.3854 7.07354 17.9265 6.6146 17.362 6.32698C16.7202 6 15.8802 6 14.2 6H6.8C5.11984 6 4.27976 6 3.63803 6.32698C3.07354 6.6146 2.6146 7.07354 2.32698 7.63803C2 8.27976 2 9.11984 2 10.8V13.2C2 14.8802 2 15.7202 2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673C4.27976 18 5.11984 18 6.8 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zs = [
  Ns,
  qs
];
function Ks(r, e) {
  return n(), o("svg", Us, zs);
}
const yx2 = /* @__PURE__ */ i(Rs, [["render", Ks]]);
var Gs = {}, Ws = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ys = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), Xs = /* @__PURE__ */ t("path", {
  d: "M6.5 10V14M10.5 10V14M22 13V11M6.8 18H14.2C15.8802 18 16.7202 18 17.362 17.673C17.9265 17.3854 18.3854 16.9265 18.673 16.362C19 15.7202 19 14.8802 19 13.2V10.8C19 9.11984 19 8.27976 18.673 7.63803C18.3854 7.07354 17.9265 6.6146 17.362 6.32698C16.7202 6 15.8802 6 14.2 6H6.8C5.11984 6 4.27976 6 3.63803 6.32698C3.07354 6.6146 2.6146 7.07354 2.32698 7.63803C2 8.27976 2 9.11984 2 10.8V13.2C2 14.8802 2 15.7202 2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673C4.27976 18 5.11984 18 6.8 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qs = [
  Ys,
  Xs
];
function Js(r, e) {
  return n(), o("svg", Ws, Qs);
}
const Dx2 = /* @__PURE__ */ i(Gs, [["render", Js]]);
var th = {}, eh = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rh = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), nh = /* @__PURE__ */ t("path", {
  d: "M10 2.00008V6.6605C10 6.87768 10 6.98626 9.9669 7.07264C9.93568 7.15413 9.89435 7.21328 9.82858 7.27063C9.75885 7.33142 9.64593 7.37279 9.42008 7.45553C6.54892 8.50734 4.5 11.2644 4.5 14.5C4.5 18.6421 7.85786 22 12 22C16.1421 22 19.5 18.6421 19.5 14.5C19.5 11.2644 17.4511 8.50734 14.5799 7.45553C14.3541 7.37279 14.2411 7.33142 14.1714 7.27063C14.1056 7.21328 14.0643 7.15413 14.0331 7.07264C14 6.98626 14 6.87768 14 6.6605V2.00008M8.5 2H15.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oh = [
  rh,
  nh
];
function ih(r, e) {
  return n(), o("svg", eh, oh);
}
const Px2 = /* @__PURE__ */ i(th, [["render", ih]]);
var lh = {}, sh = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hh = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), ah = /* @__PURE__ */ t("path", {
  d: "M9 6V10.5012C9 11.0521 9 11.3276 8.93132 11.5829C8.87047 11.809 8.77037 12.0228 8.63557 12.2143C8.48344 12.4305 8.27182 12.6068 7.84859 12.9595L4.15141 16.0405C3.72818 16.3932 3.51656 16.5695 3.36443 16.7857C3.22963 16.9772 3.12953 17.191 3.06868 17.4171C3 17.6724 3 17.9479 3 18.4988V18.8C3 19.9201 3 20.4802 3.21799 20.908C3.40973 21.2843 3.71569 21.5903 4.09202 21.782C4.51984 22 5.0799 22 6.2 22H17.8C18.9201 22 19.4802 22 19.908 21.782C20.2843 21.5903 20.5903 21.2843 20.782 20.908C21 20.4802 21 19.9201 21 18.8V18.4988C21 17.9479 21 17.6724 20.9313 17.4171C20.8705 17.191 20.7704 16.9772 20.6356 16.7857C20.4834 16.5695 20.2718 16.3932 19.8486 16.0405L16.1514 12.9595C15.7282 12.6068 15.5166 12.4305 15.3644 12.2143C15.2296 12.0228 15.1295 11.809 15.0687 11.5829C15 11.3276 15 11.0521 15 10.5012V6M8.3 6H15.7C15.98 6 16.12 6 16.227 5.9455C16.3211 5.89757 16.3976 5.82108 16.4455 5.727C16.5 5.62004 16.5 5.48003 16.5 5.2V2.8C16.5 2.51997 16.5 2.37996 16.4455 2.273C16.3976 2.17892 16.3211 2.10243 16.227 2.0545C16.12 2 15.98 2 15.7 2H8.3C8.01997 2 7.87996 2 7.773 2.0545C7.67892 2.10243 7.60243 2.17892 7.5545 2.273C7.5 2.37996 7.5 2.51997 7.5 2.8V5.2C7.5 5.48003 7.5 5.62004 7.5545 5.727C7.60243 5.82108 7.67892 5.89757 7.773 5.9455C7.87996 6 8.01997 6 8.3 6ZM5.5 17H18.5C18.9647 17 19.197 17 19.3902 17.0384C20.1836 17.1962 20.8038 17.8164 20.9616 18.6098C21 18.803 21 19.0353 21 19.5C21 19.9647 21 20.197 20.9616 20.3902C20.8038 21.1836 20.1836 21.8038 19.3902 21.9616C19.197 22 18.9647 22 18.5 22H5.5C5.03534 22 4.80302 22 4.60982 21.9616C3.81644 21.8038 3.19624 21.1836 3.03843 20.3902C3 20.197 3 19.9647 3 19.5C3 19.0353 3 18.803 3.03843 18.6098C3.19624 17.8164 3.81644 17.1962 4.60982 17.0384C4.80302 17 5.03534 17 5.5 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dh = [
  hh,
  ah
];
function ch(r, e) {
  return n(), o("svg", sh, dh);
}
const Ax2 = /* @__PURE__ */ i(lh, [["render", ch]]);
var _h = {}, Ch = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fh = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), vh = /* @__PURE__ */ t("path", {
  d: "M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uh = [
  fh,
  vh
];
function wh(r, e) {
  return n(), o("svg", Ch, uh);
}
const Sx2 = /* @__PURE__ */ i(_h, [["render", wh]]);
var ph = {}, gh = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $h = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), Mh = /* @__PURE__ */ t("path", {
  d: "M14 21H10M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Lh = [
  $h,
  Mh
];
function kh(r, e) {
  return n(), o("svg", gh, Lh);
}
const Tx2 = /* @__PURE__ */ i(ph, [["render", kh]]);
var mh = {}, xh = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hh = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), Vh = /* @__PURE__ */ t("path", {
  d: "M14.9997 19C14.9997 20.6569 13.6566 22 11.9997 22C10.3429 22 8.99972 20.6569 8.99972 19M13.7962 6.23856C14.2317 5.78864 14.4997 5.17562 14.4997 4.5C14.4997 3.11929 13.3804 2 11.9997 2C10.619 2 9.49972 3.11929 9.49972 4.5C9.49972 5.17562 9.76772 5.78864 10.2032 6.23856M17.9997 11.2C17.9997 9.82087 17.3676 8.49823 16.2424 7.52304C15.1171 6.54786 13.591 6 11.9997 6C10.4084 6 8.8823 6.54786 7.75708 7.52304C6.63186 8.49823 5.99972 9.82087 5.99972 11.2C5.99972 13.4818 5.43385 15.1506 4.72778 16.3447C3.92306 17.7056 3.5207 18.3861 3.53659 18.5486C3.55476 18.7346 3.58824 18.7933 3.73906 18.9036C3.87089 19 4.53323 19 5.85791 19H18.1415C19.4662 19 20.1286 19 20.2604 18.9036C20.4112 18.7933 20.4447 18.7346 20.4629 18.5486C20.4787 18.3861 20.0764 17.7056 19.2717 16.3447C18.5656 15.1506 17.9997 13.4818 17.9997 11.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zh = [
  Hh,
  Vh
];
function Bh(r, e) {
  return n(), o("svg", xh, Zh);
}
const Ox2 = /* @__PURE__ */ i(mh, [["render", Bh]]);
var Fh = {}, jh = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ih = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), bh = /* @__PURE__ */ t("path", {
  d: "M14.391 18.015C14.8198 19.6154 13.8701 21.2604 12.2697 21.6893C10.6693 22.1181 9.02426 21.1683 8.59543 19.5679M10.8915 5.74109C11.1957 5.19379 11.2959 4.53229 11.1211 3.8797C10.7637 2.54603 9.39288 1.75457 8.05921 2.11193C6.72555 2.46928 5.93409 3.84013 6.29144 5.17379C6.46631 5.82639 6.88384 6.34916 7.42094 6.67103M16.2359 9.44553C15.879 8.1134 14.926 6.99944 13.5868 6.3487C12.2475 5.69797 10.6316 5.56377 9.09449 5.97563C7.55741 6.38749 6.22508 7.31167 5.3906 8.54486C4.55612 9.77805 4.28785 11.2192 4.64479 12.5514C5.23537 14.7554 5.12069 16.5138 4.74774 17.8499C4.32267 19.3728 4.11014 20.1342 4.16756 20.2871C4.23325 20.462 4.28076 20.5101 4.455 20.5776C4.60729 20.6366 5.24706 20.4651 6.5266 20.1223L18.3917 16.9431C19.6712 16.6002 20.311 16.4288 20.4134 16.3015C20.5305 16.1559 20.5476 16.0906 20.5171 15.9063C20.4904 15.7451 19.9256 15.192 18.796 14.0857C17.805 13.115 16.8265 11.6496 16.2359 9.44553Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yh = [
  Ih,
  bh
];
function Dh(r, e) {
  return n(), o("svg", jh, yh);
}
const Ex2 = /* @__PURE__ */ i(Fh, [["render", Dh]]);
var Ph = {}, Ah = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sh = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), Th = /* @__PURE__ */ t("path", {
  d: "M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M15 5H21M13 2.08389C12.6717 2.02841 12.3373 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8075 17 20.4056 17 20.5383 16.9016C20.6852 16.7926 20.7239 16.7231 20.7388 16.5407C20.7522 16.3761 20.385 15.786 19.6505 14.6057C18.877 13.3626 18.1754 11.5544 18.0283 9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Oh = [
  Sh,
  Th
];
function Eh(r, e) {
  return n(), o("svg", Ah, Oh);
}
const Rx2 = /* @__PURE__ */ i(Ph, [["render", Eh]]);
var Rh = {}, Uh = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nh = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), qh = /* @__PURE__ */ t("path", {
  d: "M8.63306 3.03371C9.61959 2.3649 10.791 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8C18 10.1008 18.2702 11.7512 18.6484 13.0324M6.25867 6.25724C6.08866 6.81726 6 7.40406 6 8C6 11.0902 5.22047 13.206 4.34966 14.6054C3.61513 15.7859 3.24786 16.3761 3.26132 16.5408C3.27624 16.7231 3.31486 16.7926 3.46178 16.9016C3.59446 17 4.19259 17 5.38885 17H17M9.35418 21C10.0593 21.6224 10.9856 22 12 22C13.0144 22 13.9407 21.6224 14.6458 21M21 21L3 3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zh = [
  Nh,
  qh
];
function Kh(r, e) {
  return n(), o("svg", Uh, zh);
}
const Ux2 = /* @__PURE__ */ i(Rh, [["render", Kh]]);
var Gh = {}, Wh = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yh = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), Xh = /* @__PURE__ */ t("path", {
  d: "M14 21H10M8.63306 3.03371C9.61959 2.3649 10.791 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8C18 10.1008 18.2702 11.7512 18.6484 13.0324M6.25867 6.25723C6.08866 6.81726 6 7.40406 6 8C6 11.0902 5.22047 13.206 4.34966 14.6054C3.61513 15.7859 3.24786 16.3761 3.26132 16.5408C3.27624 16.7231 3.31486 16.7926 3.46178 16.9016C3.59446 17 4.19259 17 5.38885 17H17M21 21L3 3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qh = [
  Yh,
  Xh
];
function Jh(r, e) {
  return n(), o("svg", Wh, Qh);
}
const Nx2 = /* @__PURE__ */ i(Gh, [["render", Jh]]);
var ta = {}, ea = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ra = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), na = /* @__PURE__ */ t("path", {
  d: "M15 19C15 20.6569 13.6569 22 12 22C10.3431 22 9 20.6569 9 19M7.37748 7.88479C6.49088 8.81326 6 9.9847 6 11.2C6 13.4818 5.43413 15.1506 4.72806 16.3447C3.92334 17.7056 3.52098 18.3861 3.53686 18.5486C3.55504 18.7346 3.58852 18.7933 3.73934 18.9036C3.87117 19 4.53351 19 5.85819 19H19.88M12 6C11.7071 6 11.4164 6.01856 11.13 6.05493C10.7485 6.10339 10.5577 6.12762 10.3662 6.07557C10.2284 6.0381 10.0206 5.91728 9.91979 5.81604C9.77982 5.67541 9.74922 5.60123 9.68801 5.45287C9.56684 5.15921 9.5 4.83741 9.5 4.5C9.5 3.11929 10.6193 2 12 2C13.3807 2 14.5 3.11929 14.5 4.5C14.5 5.17562 14.232 5.78864 13.7965 6.23856C13.2203 6.08184 12.615 6 12 6ZM12 6C13.5913 6 15.1174 6.54786 16.2426 7.52304C17.3679 8.49823 18 9.82087 18 11.2C18 11.5348 18.0091 11.8563 18.0264 12.1652M21 20L3 4",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oa = [
  ra,
  na
];
function ia(r, e) {
  return n(), o("svg", ea, oa);
}
const qx2 = /* @__PURE__ */ i(ta, [["render", ia]]);
var la = {}, sa = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ha = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), aa = /* @__PURE__ */ t("path", {
  d: "M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8V2M15 5H21M13 2.08389C12.6717 2.02841 12.3373 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4055 17 20.5382 16.9016C20.6851 16.7926 20.7237 16.7231 20.7386 16.5408C20.7521 16.3761 20.3848 15.7858 19.6502 14.6052C19.1582 13.8144 18.6953 12.7948 18.3857 11.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), da = [
  ha,
  aa
];
function ca(r, e) {
  return n(), o("svg", sa, da);
}
const zx2 = /* @__PURE__ */ i(la, [["render", ca]]);
var _a = {}, Ca = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fa = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), va = /* @__PURE__ */ t("path", {
  d: "M9.35442 21C10.0596 21.6224 10.9858 22 12.0002 22C13.0147 22 13.9409 21.6224 14.6461 21M2.29414 5.81989C2.27979 4.36854 3.06227 3.01325 4.32635 2.3M21.7024 5.8199C21.7167 4.36855 20.9342 3.01325 19.6702 2.3M18.0002 8C18.0002 6.4087 17.3681 4.88258 16.2429 3.75736C15.1177 2.63214 13.5915 2 12.0002 2C10.4089 2 8.88283 2.63214 7.75761 3.75736C6.63239 4.88258 6.00025 6.4087 6.00025 8C6.00025 11.0902 5.22072 13.206 4.34991 14.6054C3.61538 15.7859 3.24811 16.3761 3.26157 16.5408C3.27649 16.7231 3.31511 16.7926 3.46203 16.9016C3.59471 17 4.19284 17 5.3891 17H18.6114C19.8077 17 20.4058 17 20.5385 16.9016C20.6854 16.7926 20.724 16.7231 20.7389 16.5408C20.7524 16.3761 20.3851 15.7859 19.6506 14.6054C18.7798 13.206 18.0002 11.0902 18.0002 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ua = [
  fa,
  va
];
function wa(r, e) {
  return n(), o("svg", Ca, ua);
}
const Kx2 = /* @__PURE__ */ i(_a, [["render", wa]]);
var pa = {}, ga = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $a = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), Ma = /* @__PURE__ */ t("path", {
  d: "M14.0003 21H10.0003M2.29414 5.81989C2.27979 4.36854 3.06227 3.01325 4.32635 2.3M21.7025 5.8199C21.7169 4.36855 20.9344 3.01325 19.6703 2.3M18.0003 8C18.0003 6.4087 17.3682 4.88258 16.2429 3.75736C15.1177 2.63214 13.5916 2 12.0003 2C10.409 2 8.88288 2.63214 7.75766 3.75736C6.63244 4.88258 6.0003 6.4087 6.0003 8C6.0003 11.0902 5.22077 13.206 4.34996 14.6054C3.61542 15.7859 3.24816 16.3761 3.26162 16.5408C3.27653 16.7231 3.31516 16.7926 3.46207 16.9016C3.59476 17 4.19289 17 5.38915 17H18.6114C19.8077 17 20.4058 17 20.5385 16.9016C20.6854 16.7926 20.7241 16.7231 20.739 16.5408C20.7524 16.3761 20.3852 15.7859 19.6506 14.6054C18.7798 13.206 18.0003 11.0902 18.0003 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), La = [
  $a,
  Ma
];
function ka(r, e) {
  return n(), o("svg", ga, La);
}
const Gx2 = /* @__PURE__ */ i(pa, [["render", ka]]);
var ma = {}, xa = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ha = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), Va = /* @__PURE__ */ t("path", {
  d: "M15.0002 19C15.0002 20.6569 13.6571 22 12.0002 22C10.3434 22 9.00025 20.6569 9.00025 19M13.7968 6.23856C14.2322 5.78864 14.5002 5.17562 14.5002 4.5C14.5002 3.11929 13.381 2 12.0002 2C10.6195 2 9.50025 3.11929 9.50025 4.5C9.50025 5.17562 9.76825 5.78864 10.2037 6.23856M2.54707 8.32296C2.53272 6.87161 3.3152 5.51631 4.57928 4.80306M21.4534 8.32296C21.4678 6.87161 20.6853 5.51631 19.4212 4.80306M18.0002 11.2C18.0002 9.82087 17.3681 8.49823 16.2429 7.52304C15.1177 6.54786 13.5915 6 12.0002 6C10.4089 6 8.88283 6.54786 7.75761 7.52304C6.63239 8.49823 6.00025 9.82087 6.00025 11.2C6.00025 13.4818 5.43438 15.1506 4.72831 16.3447C3.92359 17.7056 3.52122 18.3861 3.53711 18.5486C3.55529 18.7346 3.58876 18.7933 3.73959 18.9036C3.87142 19 4.53376 19 5.85844 19H18.1421C19.4667 19 20.1291 19 20.2609 18.9036C20.4117 18.7933 20.4452 18.7346 20.4634 18.5486C20.4793 18.3861 20.0769 17.7056 19.2722 16.3447C18.5661 15.1506 18.0002 13.4818 18.0002 11.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Za = [
  Ha,
  Va
];
function Ba(r, e) {
  return n(), o("svg", xa, Za);
}
const Wx2 = /* @__PURE__ */ i(ma, [["render", Ba]]);
var Fa = {}, ja = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ia = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), ba = /* @__PURE__ */ t("path", {
  d: "M15.6459 18.0148C16.0747 19.6152 15.125 21.2602 13.5246 21.689C11.9242 22.1178 10.2792 21.1681 9.85036 19.5677M2.05683 11.6133C1.66734 10.2151 2.07238 8.70349 3.10878 7.68738M12.1463 5.74085C12.4505 5.19355 12.5507 4.53205 12.3759 3.87945C12.0185 2.54579 10.6477 1.75433 9.314 2.11168C7.98034 2.46904 7.18888 3.83988 7.54624 5.17355C7.7211 5.82614 8.13863 6.34891 8.67573 6.67079M20.319 6.72C19.9572 5.31439 18.8506 4.20779 17.445 3.84602M17.4906 9.44528C17.1337 8.11315 16.1808 6.99919 14.8415 6.34845C13.5022 5.69772 11.8863 5.56352 10.3492 5.97538C8.81214 6.38724 7.47981 7.31142 6.64533 8.54461C5.81085 9.77779 5.54258 11.219 5.89952 12.5511C6.4901 14.7552 6.37542 16.5135 6.00247 17.8497C5.5774 19.3725 5.36487 20.134 5.42228 20.2869C5.48798 20.4618 5.53549 20.5098 5.70973 20.5773C5.86202 20.6363 6.50179 20.4649 7.78133 20.122L19.6464 16.9428C20.9259 16.5999 21.5657 16.4285 21.6681 16.3013C21.7852 16.1557 21.8024 16.0904 21.7718 15.906C21.7451 15.7449 21.1803 15.1918 20.0508 14.0855C19.0597 13.1148 18.0812 11.6493 17.4906 9.44528Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ya = [
  Ia,
  ba
];
function Da(r, e) {
  return n(), o("svg", ja, ya);
}
const Yx2 = /* @__PURE__ */ i(Fa, [["render", Da]]);
var Pa = {}, Aa = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sa = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), Ta = /* @__PURE__ */ t("path", {
  d: "M10 7L3 7M21 7L14 7M14 7.25195C17.4505 8.14004 20 11.2722 20 14.9999M4 14.9999C4 11.2722 6.54955 8.14004 10 7.25195M3.6 19H4.4C4.96005 19 5.24008 19 5.45399 18.891C5.64215 18.7951 5.79513 18.6422 5.89101 18.454C6 18.2401 6 17.9601 6 17.4V16.6C6 16.0399 6 15.7599 5.89101 15.546C5.79513 15.3578 5.64215 15.2049 5.45399 15.109C5.24008 15 4.96005 15 4.4 15H3.6C3.03995 15 2.75992 15 2.54601 15.109C2.35785 15.2049 2.20487 15.3578 2.10899 15.546C2 15.7599 2 16.0399 2 16.6V17.4C2 17.9601 2 18.2401 2.10899 18.454C2.20487 18.6422 2.35785 18.7951 2.54601 18.891C2.75992 19 3.03995 19 3.6 19ZM11.6 9H12.4C12.9601 9 13.2401 9 13.454 8.89101C13.6422 8.79513 13.7951 8.64215 13.891 8.45399C14 8.24008 14 7.96005 14 7.4V6.6C14 6.03995 14 5.75992 13.891 5.54601C13.7951 5.35785 13.6422 5.20487 13.454 5.10899C13.2401 5 12.9601 5 12.4 5H11.6C11.0399 5 10.7599 5 10.546 5.10899C10.3578 5.20487 10.2049 5.35785 10.109 5.54601C10 5.75992 10 6.03995 10 6.6V7.4C10 7.96005 10 8.24008 10.109 8.45399C10.2049 8.64215 10.3578 8.79513 10.546 8.89101C10.7599 9 11.0399 9 11.6 9ZM19.6 19H20.4C20.9601 19 21.2401 19 21.454 18.891C21.6422 18.7951 21.7951 18.6422 21.891 18.454C22 18.2401 22 17.9601 22 17.4V16.6C22 16.0399 22 15.7599 21.891 15.546C21.7951 15.3578 21.6422 15.2049 21.454 15.109C21.2401 15 20.9601 15 20.4 15H19.6C19.0399 15 18.7599 15 18.546 15.109C18.3578 15.2049 18.2049 15.3578 18.109 15.546C18 15.7599 18 16.0399 18 16.6V17.4C18 17.9601 18 18.2401 18.109 18.454C18.2049 18.6422 18.3578 18.7951 18.546 18.891C18.7599 19 19.0399 19 19.6 19ZM22 7C22 7.55228 21.5523 8 21 8C20.4477 8 20 7.55228 20 7C20 6.44772 20.4477 6 21 6C21.5523 6 22 6.44772 22 7ZM4 7C4 7.55228 3.55228 8 3 8C2.44772 8 2 7.55228 2 7C2 6.44772 2.44772 6 3 6C3.55228 6 4 6.44772 4 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Oa = [
  Sa,
  Ta
];
function Ea(r, e) {
  return n(), o("svg", Aa, Oa);
}
const Xx2 = /* @__PURE__ */ i(Pa, [["render", Ea]]);
var Ra = {}, Ua = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Na = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), qa = /* @__PURE__ */ t("path", {
  d: "M9.9998 20.2633C6.91189 19.5185 4.48131 17.0879 3.73662 13.9999M20.2636 14C19.5188 17.0879 17.0883 19.5185 14.0004 20.2633M14.0002 3.73657C17.0882 4.48129 19.5188 6.91193 20.2636 9.99989M3.73682 10C4.48152 6.91199 6.9122 4.4813 10.0002 3.73657M3.6 14H4.4C4.96005 14 5.24008 14 5.45399 13.891C5.64215 13.7951 5.79513 13.6422 5.89101 13.454C6 13.2401 6 12.9601 6 12.4V11.6C6 11.0399 6 10.7599 5.89101 10.546C5.79513 10.3578 5.64215 10.2049 5.45399 10.109C5.24008 10 4.96005 10 4.4 10H3.6C3.03995 10 2.75992 10 2.54601 10.109C2.35785 10.2049 2.20487 10.3578 2.10899 10.546C2 10.7599 2 11.0399 2 11.6V12.4C2 12.9601 2 13.2401 2.10899 13.454C2.20487 13.6422 2.35785 13.7951 2.54601 13.891C2.75992 14 3.03995 14 3.6 14ZM19.6 14H20.4C20.9601 14 21.2401 14 21.454 13.891C21.6422 13.7951 21.7951 13.6422 21.891 13.454C22 13.2401 22 12.9601 22 12.4V11.6C22 11.0399 22 10.7599 21.891 10.546C21.7951 10.3578 21.6422 10.2049 21.454 10.109C21.2401 10 20.9601 10 20.4 10H19.6C19.0399 10 18.7599 10 18.546 10.109C18.3578 10.2049 18.2049 10.3578 18.109 10.546C18 10.7599 18 11.0399 18 11.6V12.4C18 12.9601 18 13.2401 18.109 13.454C18.2049 13.6422 18.3578 13.7951 18.546 13.891C18.7599 14 19.0399 14 19.6 14ZM11.6 6H12.4C12.9601 6 13.2401 6 13.454 5.89101C13.6422 5.79513 13.7951 5.64215 13.891 5.45399C14 5.24008 14 4.96005 14 4.4V3.6C14 3.03995 14 2.75992 13.891 2.54601C13.7951 2.35785 13.6422 2.20487 13.454 2.10899C13.2401 2 12.9601 2 12.4 2H11.6C11.0399 2 10.7599 2 10.546 2.10899C10.3578 2.20487 10.2049 2.35785 10.109 2.54601C10 2.75992 10 3.03995 10 3.6V4.4C10 4.96005 10 5.24008 10.109 5.45399C10.2049 5.64215 10.3578 5.79513 10.546 5.89101C10.7599 6 11.0399 6 11.6 6ZM11.6 22H12.4C12.9601 22 13.2401 22 13.454 21.891C13.6422 21.7951 13.7951 21.6422 13.891 21.454C14 21.2401 14 20.9601 14 20.4V19.6C14 19.0399 14 18.7599 13.891 18.546C13.7951 18.3578 13.6422 18.2049 13.454 18.109C13.2401 18 12.9601 18 12.4 18H11.6C11.0399 18 10.7599 18 10.546 18.109C10.3578 18.2049 10.2049 18.3578 10.109 18.546C10 18.7599 10 19.0399 10 19.6V20.4C10 20.9601 10 21.2401 10.109 21.454C10.2049 21.6422 10.3578 21.7951 10.546 21.891C10.7599 22 11.0399 22 11.6 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), za = [
  Na,
  qa
];
function Ka(r, e) {
  return n(), o("svg", Ua, za);
}
const Qx2 = /* @__PURE__ */ i(Ra, [["render", Ka]]);
var Ga = {}, Wa = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ya = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), Xa = /* @__PURE__ */ t("path", {
  d: "M10.8571 7L5.14286 17M6 19H17.9998M18.8571 17L13.1429 7M3.6 21H4.4C4.96005 21 5.24008 21 5.45399 20.891C5.64215 20.7951 5.79513 20.6422 5.89101 20.454C6 20.2401 6 19.9601 6 19.4V18.6C6 18.0399 6 17.7599 5.89101 17.546C5.79513 17.3578 5.64215 17.2049 5.45399 17.109C5.24008 17 4.96005 17 4.4 17H3.6C3.03995 17 2.75992 17 2.54601 17.109C2.35785 17.2049 2.20487 17.3578 2.10899 17.546C2 17.7599 2 18.0399 2 18.6V19.4C2 19.9601 2 20.2401 2.10899 20.454C2.20487 20.6422 2.35785 20.7951 2.54601 20.891C2.75992 21 3.03995 21 3.6 21ZM19.6 21H20.4C20.9601 21 21.2401 21 21.454 20.891C21.6422 20.7951 21.7951 20.6422 21.891 20.454C22 20.2401 22 19.9601 22 19.4V18.6C22 18.0399 22 17.7599 21.891 17.546C21.7951 17.3578 21.6422 17.2049 21.454 17.109C21.2401 17 20.9601 17 20.4 17H19.6C19.0399 17 18.7599 17 18.546 17.109C18.3578 17.2049 18.2049 17.3578 18.109 17.546C18 17.7599 18 18.0399 18 18.6V19.4C18 19.9601 18 20.2401 18.109 20.454C18.2049 20.6422 18.3578 20.7951 18.546 20.891C18.7599 21 19.0399 21 19.6 21ZM11.6 7H12.4C12.9601 7 13.2401 7 13.454 6.89101C13.6422 6.79513 13.7951 6.64215 13.891 6.45399C14 6.24008 14 5.96005 14 5.4V4.6C14 4.03995 14 3.75992 13.891 3.54601C13.7951 3.35785 13.6422 3.20487 13.454 3.10899C13.2401 3 12.9601 3 12.4 3H11.6C11.0399 3 10.7599 3 10.546 3.10899C10.3578 3.20487 10.2049 3.35785 10.109 3.54601C10 3.75992 10 4.03995 10 4.6V5.4C10 5.96005 10 6.24008 10.109 6.45399C10.2049 6.64215 10.3578 6.79513 10.546 6.89101C10.7599 7 11.0399 7 11.6 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qa = [
  Ya,
  Xa
];
function Ja(r, e) {
  return n(), o("svg", Wa, Qa);
}
const Jx2 = /* @__PURE__ */ i(Ga, [["render", Ja]]);
var td = {}, ed = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rd = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), nd = /* @__PURE__ */ t("path", {
  d: "M3 7L15 17L9 22V2L15 7L3 17M18 12H18.01M15 12H15.01M21 12H21.01",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), od = [
  rd,
  nd
];
function id(r, e) {
  return n(), o("svg", ed, od);
}
const tH2 = /* @__PURE__ */ i(td, [["render", id]]);
var ld = {}, sd = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hd = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), ad = /* @__PURE__ */ t("path", {
  d: "M6 17L12 12V22L17.4398 17.4668M12 7V2L18 7L15.0817 9.43194M21 21L3 3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dd = [
  hd,
  ad
];
function cd(r, e) {
  return n(), o("svg", sd, dd);
}
const eH2 = /* @__PURE__ */ i(ld, [["render", cd]]);
var _d = {}, Cd = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fd = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), vd = /* @__PURE__ */ t("path", {
  d: "M6 7L18 17L12 22V2L18 7L6 17",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ud = [
  fd,
  vd
];
function wd(r, e) {
  return n(), o("svg", Cd, ud);
}
const rH2 = /* @__PURE__ */ i(_d, [["render", wd]]);
var pd = {}, gd = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $d = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -596)",
  fill: "none"
}, null, -1), Md = /* @__PURE__ */ t("path", {
  d: "M2 7L14 17L8 22V2L14 7L2 17M20.1445 6.5C21.2581 8.04804 21.914 9.94743 21.914 12C21.914 14.0526 21.2581 15.952 20.1445 17.5M17 8.85724C17.6214 9.74811 17.9858 10.8315 17.9858 12.0001C17.9858 13.1686 17.6214 14.2521 17 15.143",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ld = [
  $d,
  Md
];
function kd(r, e) {
  return n(), o("svg", gd, Ld);
}
const nH2 = /* @__PURE__ */ i(pd, [["render", kd]]);
var md = {}, xd = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hd = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), Vd = /* @__PURE__ */ t("path", {
  d: "M6 12H14C16.2091 12 18 10.2091 18 8C18 5.79086 16.2091 4 14 4H6V12ZM6 12H15C17.2091 12 19 13.7909 19 16C19 18.2091 17.2091 20 15 20H6V12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zd = [
  Hd,
  Vd
];
function Bd(r, e) {
  return n(), o("svg", xd, Zd);
}
const oH2 = /* @__PURE__ */ i(md, [["render", Bd]]);
var Fd = {}, jd = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Id = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), bd = /* @__PURE__ */ t("path", {
  d: "M6 4V20M9.5 4H15.5C17.7091 4 19.5 5.79086 19.5 8C19.5 10.2091 17.7091 12 15.5 12H9.5H16.5C18.7091 12 20.5 13.7909 20.5 16C20.5 18.2091 18.7091 20 16.5 20H9.5M9.5 4V20M9.5 4H4M9.5 20H4",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yd = [
  Id,
  bd
];
function Dd(r, e) {
  return n(), o("svg", jd, yd);
}
const iH2 = /* @__PURE__ */ i(Fd, [["render", Dd]]);
var Pd = {}, Ad = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sd = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -596)",
  fill: "none"
}, null, -1), Td = /* @__PURE__ */ t("path", {
  d: "M8.5 12H13C14.3807 12 15.5 10.8807 15.5 9.5C15.5 8.11929 14.3807 7 13 7H8.5V12ZM8.5 12H14C15.3807 12 16.5 13.1193 16.5 14.5C16.5 15.8807 15.3807 17 14 17H8.5V12ZM7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Od = [
  Sd,
  Td
];
function Ed(r, e) {
  return n(), o("svg", Ad, Od);
}
const lH2 = /* @__PURE__ */ i(Pd, [["render", Ed]]);
var Rd = {}, Ud = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nd = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), qd = /* @__PURE__ */ t("path", {
  d: "M20 19V16H7C5.34315 16 4 17.3431 4 19M8.8 22H16.8C17.9201 22 18.4802 22 18.908 21.782C19.2843 21.5903 19.5903 21.2843 19.782 20.908C20 20.4802 20 19.9201 20 18.8V5.2C20 4.07989 20 3.51984 19.782 3.09202C19.5903 2.71569 19.2843 2.40973 18.908 2.21799C18.4802 2 17.9201 2 16.8 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zd = [
  Nd,
  qd
];
function Kd(r, e) {
  return n(), o("svg", Ud, zd);
}
const sH2 = /* @__PURE__ */ i(Rd, [["render", Kd]]);
var Gd = {}, Wd = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yd = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), Xd = /* @__PURE__ */ t("path", {
  d: "M12 21L11.8999 20.8499C11.2053 19.808 10.858 19.287 10.3991 18.9098C9.99286 18.5759 9.52476 18.3254 9.02161 18.1726C8.45325 18 7.82711 18 6.57482 18H5.2C4.07989 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V6.2C2 5.07989 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.07989 3 5.2 3H5.6C7.84021 3 8.96031 3 9.81596 3.43597C10.5686 3.81947 11.1805 4.43139 11.564 5.18404C12 6.03968 12 7.15979 12 9.4M12 21V9.4M12 21L12.1001 20.8499C12.7947 19.808 13.142 19.287 13.6009 18.9098C14.0071 18.5759 14.4752 18.3254 14.9784 18.1726C15.5467 18 16.1729 18 17.4252 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V6.2C22 5.07989 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H18.4C16.1598 3 15.0397 3 14.184 3.43597C13.4314 3.81947 12.8195 4.43139 12.436 5.18404C12 6.03968 12 7.15979 12 9.4",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qd = [
  Yd,
  Xd
];
function Jd(r, e) {
  return n(), o("svg", Wd, Qd);
}
const hH2 = /* @__PURE__ */ i(Gd, [["render", Jd]]);
var tc = {}, ec = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rc = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), nc = /* @__PURE__ */ t("path", {
  d: "M12 20H5.2C4.07989 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V7.2C2 6.07989 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.07989 4 5.2 4H5.6C7.84021 4 8.96031 4 9.81596 4.43597C10.5686 4.81947 11.1805 5.43139 11.564 6.18404C12 7.03968 12 8.15979 12 10.4M12 20V10.4M12 20H18.8C19.9201 20 20.4802 20 20.908 19.782C21.2843 19.5903 21.5903 19.2843 21.782 18.908C22 18.4802 22 17.9201 22 16.8V7.2C22 6.07989 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H18.4C16.1598 4 15.0397 4 14.184 4.43597C13.4314 4.81947 12.8195 5.43139 12.436 6.18404C12 7.03968 12 8.15979 12 10.4",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oc = [
  rc,
  nc
];
function ic(r, e) {
  return n(), o("svg", ec, oc);
}
const aH2 = /* @__PURE__ */ i(tc, [["render", ic]]);
var lc = {}, sc = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hc = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), ac = /* @__PURE__ */ t("path", {
  d: "M12 13V7M9 10H15M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L12 17L19 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dc = [
  hc,
  ac
];
function cc(r, e) {
  return n(), o("svg", sc, dc);
}
const dH2 = /* @__PURE__ */ i(lc, [["render", cc]]);
var _c = {}, Cc = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fc = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), vc = /* @__PURE__ */ t("path", {
  d: "M9 10.5L11 12.5L15.5 8M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L12 17L19 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uc = [
  fc,
  vc
];
function wc(r, e) {
  return n(), o("svg", Cc, uc);
}
const cH2 = /* @__PURE__ */ i(_c, [["render", wc]]);
var pc = {}, gc = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $c = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), Mc = /* @__PURE__ */ t("path", {
  d: "M9 10H15M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L12 17L19 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Lc = [
  $c,
  Mc
];
function kc(r, e) {
  return n(), o("svg", gc, Lc);
}
const _H2 = /* @__PURE__ */ i(pc, [["render", kc]]);
var mc = {}, xc = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hc = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -596)",
  fill: "none"
}, null, -1), Vc = /* @__PURE__ */ t("path", {
  d: "M9.5 7.5L14.5 12.5M14.5 7.5L9.5 12.5M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L12 17L19 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zc = [
  Hc,
  Vc
];
function Bc(r, e) {
  return n(), o("svg", xc, Zc);
}
const CH2 = /* @__PURE__ */ i(mc, [["render", Bc]]);
var Fc = {}, jc = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ic = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), bc = /* @__PURE__ */ t("path", {
  d: "M5 7.8C5 6.11984 5 5.27976 5.32698 4.63803C5.6146 4.07354 6.07354 3.6146 6.63803 3.32698C7.27976 3 8.11984 3 9.8 3H14.2C15.8802 3 16.7202 3 17.362 3.32698C17.9265 3.6146 18.3854 4.07354 18.673 4.63803C19 5.27976 19 6.11984 19 7.8V21L12 17L5 21V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yc = [
  Ic,
  bc
];
function Dc(r, e) {
  return n(), o("svg", jc, yc);
}
const fH2 = /* @__PURE__ */ i(Fc, [["render", Dc]]);
var Pc = {}, Ac = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sc = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -596)",
  fill: "none"
}, null, -1), Tc = /* @__PURE__ */ t("path", {
  d: "M20.5 8V16.2C20.5 17.8802 20.5 18.7202 20.173 19.362C19.8854 19.9265 19.4265 20.3854 18.862 20.673C18.2202 21 17.3802 21 15.7 21H8.3C6.61984 21 5.77976 21 5.13803 20.673C4.57354 20.3854 4.1146 19.9265 3.82698 19.362C3.5 18.7202 3.5 17.8802 3.5 16.2V8M3.6 3H20.4C20.9601 3 21.2401 3 21.454 3.10899C21.6422 3.20487 21.7951 3.35785 21.891 3.54601C22 3.75992 22 4.03995 22 4.6V6.4C22 6.96005 22 7.24008 21.891 7.45399C21.7951 7.64215 21.6422 7.79513 21.454 7.89101C21.2401 8 20.9601 8 20.4 8H3.6C3.03995 8 2.75992 8 2.54601 7.89101C2.35785 7.79513 2.20487 7.64215 2.10899 7.45399C2 7.24008 2 6.96005 2 6.4V4.6C2 4.03995 2 3.75992 2.10899 3.54601C2.20487 3.35785 2.35785 3.20487 2.54601 3.10899C2.75992 3 3.03995 3 3.6 3ZM9.6 11.5H14.4C14.9601 11.5 15.2401 11.5 15.454 11.609C15.6422 11.7049 15.7951 11.8578 15.891 12.046C16 12.2599 16 12.5399 16 13.1V13.9C16 14.4601 16 14.7401 15.891 14.954C15.7951 15.1422 15.6422 15.2951 15.454 15.391C15.2401 15.5 14.9601 15.5 14.4 15.5H9.6C9.03995 15.5 8.75992 15.5 8.54601 15.391C8.35785 15.2951 8.20487 15.1422 8.10899 14.954C8 14.7401 8 14.4601 8 13.9V13.1C8 12.5399 8 12.2599 8.10899 12.046C8.20487 11.8578 8.35785 11.7049 8.54601 11.609C8.75992 11.5 9.03995 11.5 9.6 11.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Oc = [
  Sc,
  Tc
];
function Ec(r, e) {
  return n(), o("svg", Ac, Oc);
}
const vH2 = /* @__PURE__ */ i(Pc, [["render", Ec]]);
var Rc = {}, Uc = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nc = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), qc = /* @__PURE__ */ t("path", {
  d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M7.5 12L9.93431 14.4343C10.1323 14.6323 10.2313 14.7313 10.3455 14.7684C10.4459 14.8011 10.5541 14.8011 10.6545 14.7684C10.7687 14.7313 10.8677 14.6323 11.0657 14.4343L16.5 9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zc = [
  Nc,
  qc
];
function Kc(r, e) {
  return n(), o("svg", Uc, zc);
}
const uH2 = /* @__PURE__ */ i(Rc, [["render", Kc]]);
var Gc = {}, Wc = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yc = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), Xc = /* @__PURE__ */ t("path", {
  d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M7.5 12H7.51M12 12H12.01M16.5 12H16.51M8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qc = [
  Yc,
  Xc
];
function Jc(r, e) {
  return n(), o("svg", Wc, Qc);
}
const wH2 = /* @__PURE__ */ i(Gc, [["render", Jc]]);
var t_ = {}, e_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r_ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), n_ = /* @__PURE__ */ t("path", {
  d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M8 12H16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), o_ = [
  r_,
  n_
];
function i_(r, e) {
  return n(), o("svg", e_, o_);
}
const pH2 = /* @__PURE__ */ i(t_, [["render", i_]]);
var l_ = {}, s_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h_ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), a_ = /* @__PURE__ */ t("path", {
  d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M12 8V16M8 12H16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), d_ = [
  h_,
  a_
];
function c_(r, e) {
  return n(), o("svg", s_, d_);
}
const gH2 = /* @__PURE__ */ i(l_, [["render", c_]]);
var __ = {}, C_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, f_ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), v_ = /* @__PURE__ */ t("path", {
  d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M9 17L15 7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), u_ = [
  f_,
  v_
];
function w_(r, e) {
  return n(), o("svg", C_, u_);
}
const $H2 = /* @__PURE__ */ i(__, [["render", w_]]);
var p_ = {}, g_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $_ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), M_ = /* @__PURE__ */ t("path", {
  d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M15 9L9 15M9 9L15 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), L_ = [
  $_,
  M_
];
function k_(r, e) {
  return n(), o("svg", g_, L_);
}
const MH2 = /* @__PURE__ */ i(p_, [["render", k_]]);
var m_ = {}, x_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H_ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), V_ = /* @__PURE__ */ t("path", {
  d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Z_ = [
  H_,
  V_
];
function B_(r, e) {
  return n(), o("svg", x_, Z_);
}
const LH2 = /* @__PURE__ */ i(m_, [["render", B_]]);
var F_ = {}, j_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, I_ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), b_ = /* @__PURE__ */ t("path", {
  d: "M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), y_ = [
  I_,
  b_
];
function D_(r, e) {
  return n(), o("svg", j_, y_);
}
const kH2 = /* @__PURE__ */ i(F_, [["render", D_]]);
var P_ = {}, A_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S_ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), T_ = /* @__PURE__ */ t("path", {
  d: "M8 21V7C8 6.07003 8 5.60504 8.10222 5.22354C8.37962 4.18827 9.18827 3.37962 10.2235 3.10222C10.605 3 11.07 3 12 3C12.93 3 13.395 3 13.7765 3.10222C14.8117 3.37962 15.6204 4.18827 15.8978 5.22354C16 5.60504 16 6.07003 16 7V21M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), O_ = [
  S_,
  T_
];
function E_(r, e) {
  return n(), o("svg", A_, O_);
}
const mH2 = /* @__PURE__ */ i(P_, [["render", E_]]);
var R_ = {}, U_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, N_ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), q_ = /* @__PURE__ */ t("path", {
  d: "M22 9H2M2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27977 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), z_ = [
  N_,
  q_
];
function K_(r, e) {
  return n(), o("svg", U_, z_);
}
const xH2 = /* @__PURE__ */ i(R_, [["render", K_]]);
var G_ = {}, W_ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y_ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -636)",
  fill: "none"
}, null, -1), X_ = /* @__PURE__ */ t("path", {
  d: "M8.99997 11.2224L12.7778 15.0002M7.97485 20.975C6.60801 22.3419 4 22.0002 2 22.0002C3.0251 20.0002 1.65827 17.3921 3.0251 16.0253C4.39194 14.6585 6.60801 14.6585 7.97485 16.0253C9.34168 17.3921 9.34168 19.6082 7.97485 20.975ZM11.9216 15.9248L21.0587 6.05671C21.8635 5.18755 21.8375 3.83776 20.9999 3.00017C20.1624 2.16258 18.8126 2.13663 17.9434 2.94141L8.07534 12.0785C7.5654 12.5507 7.31043 12.7868 7.16173 13.0385C6.80514 13.6423 6.79079 14.3887 7.12391 15.0057C7.26283 15.2631 7.50853 15.5088 7.99995 16.0002C8.49136 16.4916 8.73707 16.7373 8.99438 16.8762C9.6114 17.2093 10.3578 17.195 10.9616 16.8384C11.2134 16.6897 11.4494 16.4347 11.9216 15.9248Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Q_ = [
  Y_,
  X_
];
function J_(r, e) {
  return n(), o("svg", W_, Q_);
}
const HH2 = /* @__PURE__ */ i(G_, [["render", J_]]);
var tC = {}, eC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rC = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -676)",
  fill: "none"
}, null, -1), nC = /* @__PURE__ */ t("path", {
  d: "M18 10V3.6C18 3.03995 18 2.75992 17.891 2.54601C17.7951 2.35785 17.6422 2.20487 17.454 2.10899C17.2401 2 16.9601 2 16.4 2H7.6C7.03995 2 6.75992 2 6.54601 2.10899C6.35785 2.20487 6.20487 2.35785 6.10899 2.54601C6 2.75992 6 3.03995 6 3.6V10M18 10H6M18 10V10.2C18 11.8802 18 12.7202 17.673 13.362C17.3854 13.9265 16.9265 14.3854 16.362 14.673C15.7202 15 14.8802 15 13.2 15H10.8C9.11984 15 8.27976 15 7.63803 14.673C7.07354 14.3854 6.6146 13.9265 6.32698 13.362C6 12.7202 6 11.8802 6 10.2V10M14.5 15V19.5C14.5 20.8807 13.3807 22 12 22C10.6193 22 9.5 20.8807 9.5 19.5V15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oC = [
  rC,
  nC
];
function iC(r, e) {
  return n(), o("svg", eC, oC);
}
const VH2 = /* @__PURE__ */ i(tC, [["render", iC]]);
var lC = {}, sC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hC = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -716)",
  fill: "none"
}, null, -1), aC = /* @__PURE__ */ t("path", {
  d: "M20 10V3.6C20 3.03995 20 2.75992 19.891 2.54601C19.7951 2.35785 19.6422 2.20487 19.454 2.10899C19.2401 2 18.9601 2 18.4 2H5.6C5.03995 2 4.75992 2 4.54601 2.10899C4.35785 2.20487 4.20487 2.35785 4.10899 2.54601C4 2.75992 4 3.03995 4 3.6V10M20 10H4M20 10V10.2C20 11.8802 20 12.7202 19.673 13.362C19.3854 13.9265 18.9265 14.3854 18.362 14.673C17.7202 15 16.8802 15 15.2 15H8.8C7.11984 15 6.27976 15 5.63803 14.673C5.07354 14.3854 4.6146 13.9265 4.32698 13.362C4 12.7202 4 11.8802 4 10.2V10M14.5 15V19.5C14.5 20.8807 13.3807 22 12 22C10.6193 22 9.5 20.8807 9.5 19.5V15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dC = [
  hC,
  aC
];
function cC(r, e) {
  return n(), o("svg", sC, dC);
}
const ZH2 = /* @__PURE__ */ i(lC, [["render", cC]]);
var _C = {}, CC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fC = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -636)",
  fill: "none"
}, null, -1), vC = /* @__PURE__ */ t("path", {
  d: "M15 21V15.6C15 15.0399 15 14.7599 14.891 14.546C14.7951 14.3578 14.6422 14.2049 14.454 14.109C14.2401 14 13.9601 14 13.4 14H10.6C10.0399 14 9.75992 14 9.54601 14.109C9.35785 14.2049 9.20487 14.3578 9.10899 14.546C9 14.7599 9 15.0399 9 15.6V21M19 21V6.2C19 5.0799 19 4.51984 18.782 4.09202C18.5903 3.71569 18.2843 3.40973 17.908 3.21799C17.4802 3 16.9201 3 15.8 3H8.2C7.07989 3 6.51984 3 6.09202 3.21799C5.71569 3.40973 5.40973 3.71569 5.21799 4.09202C5 4.51984 5 5.0799 5 6.2V21M21 21H3M9.5 8H9.51M14.5 8H14.51M10 8C10 8.27614 9.77614 8.5 9.5 8.5C9.22386 8.5 9 8.27614 9 8C9 7.72386 9.22386 7.5 9.5 7.5C9.77614 7.5 10 7.72386 10 8ZM15 8C15 8.27614 14.7761 8.5 14.5 8.5C14.2239 8.5 14 8.27614 14 8C14 7.72386 14.2239 7.5 14.5 7.5C14.7761 7.5 15 7.72386 15 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uC = [
  fC,
  vC
];
function wC(r, e) {
  return n(), o("svg", CC, uC);
}
const BH2 = /* @__PURE__ */ i(_C, [["render", wC]]);
var pC = {}, gC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $C = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -676)",
  fill: "none"
}, null, -1), MC = /* @__PURE__ */ t("path", {
  d: "M15 21V15.6C15 15.0399 15 14.7599 14.891 14.546C14.7951 14.3578 14.6422 14.2049 14.454 14.109C14.2401 14 13.9601 14 13.4 14H10.6C10.0399 14 9.75992 14 9.54601 14.109C9.35785 14.2049 9.20487 14.3578 9.10899 14.546C9 14.7599 9 15.0399 9 15.6V21M3 7C3 8.65685 4.34315 10 6 10C7.65685 10 9 8.65685 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 8.65685 16.3431 10 18 10C19.6569 10 21 8.65685 21 7M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), LC = [
  $C,
  MC
];
function kC(r, e) {
  return n(), o("svg", gC, LC);
}
const FH2 = /* @__PURE__ */ i(pC, [["render", kC]]);
var mC = {}, xC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HC = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -716)",
  fill: "none"
}, null, -1), VC = /* @__PURE__ */ t("path", {
  d: "M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.07989 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.0799 4 6.2V21M22 21H2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ZC = [
  HC,
  VC
];
function BC(r, e) {
  return n(), o("svg", xC, ZC);
}
const jH2 = /* @__PURE__ */ i(mC, [["render", BC]]);
var FC = {}, jC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, IC = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -756)",
  fill: "none"
}, null, -1), bC = /* @__PURE__ */ t("path", {
  d: "M9.5 7H14.5M9.5 11H14.5M9.5 15H14.5M18 21V6.2C18 5.0799 18 4.51984 17.782 4.09202C17.5903 3.71569 17.2843 3.40973 16.908 3.21799C16.4802 3 15.9201 3 14.8 3H9.2C8.0799 3 7.51984 3 7.09202 3.21799C6.71569 3.40973 6.40973 3.71569 6.21799 4.09202C6 4.51984 6 5.0799 6 6.2V21M20 21H4",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yC = [
  IC,
  bC
];
function DC(r, e) {
  return n(), o("svg", jC, yC);
}
const IH2 = /* @__PURE__ */ i(FC, [["render", DC]]);
var PC = {}, AC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, SC = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -796)",
  fill: "none"
}, null, -1), TC = /* @__PURE__ */ t("path", {
  d: "M13 11H17.8C18.9201 11 19.4802 11 19.908 11.218C20.2843 11.4097 20.5903 11.7157 20.782 12.092C21 12.5198 21 13.0799 21 14.2V21M13 21V6.2C13 5.0799 13 4.51984 12.782 4.09202C12.5903 3.71569 12.2843 3.40973 11.908 3.21799C11.4802 3 10.9201 3 9.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.0799 3 6.2V21M22 21H2M6.5 7H9.5M6.5 11H9.5M6.5 15H9.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), OC = [
  SC,
  TC
];
function EC(r, e) {
  return n(), o("svg", AC, OC);
}
const bH2 = /* @__PURE__ */ i(PC, [["render", EC]]);
var RC = {}, UC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NC = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -836)",
  fill: "none"
}, null, -1), qC = /* @__PURE__ */ t("path", {
  d: "M11 11H6.2C5.07989 11 4.51984 11 4.09202 11.218C3.71569 11.4097 3.40973 11.7157 3.21799 12.092C3 12.5198 3 13.0799 3 14.2V21M21 21V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H14.2C13.0799 3 12.5198 3 12.092 3.21799C11.7157 3.40973 11.4097 3.71569 11.218 4.09202C11 4.51984 11 5.0799 11 6.2V21M22 21H2M14.5 7H17.5M14.5 11H17.5M14.5 15H17.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zC = [
  NC,
  qC
];
function KC(r, e) {
  return n(), o("svg", UC, zC);
}
const yH2 = /* @__PURE__ */ i(RC, [["render", KC]]);
var GC = {}, WC = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YC = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -876)",
  fill: "none"
}, null, -1), XC = /* @__PURE__ */ t("path", {
  d: "M7.5 11H4.6C4.03995 11 3.75992 11 3.54601 11.109C3.35785 11.2049 3.20487 11.3578 3.10899 11.546C3 11.7599 3 12.0399 3 12.6V21M16.5 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V21M16.5 21V6.2C16.5 5.0799 16.5 4.51984 16.282 4.09202C16.0903 3.71569 15.7843 3.40973 15.408 3.21799C14.9802 3 14.4201 3 13.3 3H10.7C9.57989 3 9.01984 3 8.59202 3.21799C8.21569 3.40973 7.90973 3.71569 7.71799 4.09202C7.5 4.51984 7.5 5.0799 7.5 6.2V21M22 21H2M11 7H13M11 11H13M11 15H13",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), QC = [
  YC,
  XC
];
function JC(r, e) {
  return n(), o("svg", WC, QC);
}
const DH2 = /* @__PURE__ */ i(GC, [["render", JC]]);
var tf = {}, ef = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rf = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -916)",
  fill: "none"
}, null, -1), nf = /* @__PURE__ */ t("path", {
  d: "M3 21H21M6 18V9.99998M10 18V9.99998M14 18V9.99998M18 18V9.99998M20 6.99998L12.424 2.26498C12.2702 2.16884 12.1933 2.12077 12.1108 2.10203C12.0379 2.08546 11.9621 2.08546 11.8892 2.10203C11.8067 2.12077 11.7298 2.16884 11.576 2.26498L4 6.99998H20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), of = [
  rf,
  nf
];
function lf(r, e) {
  return n(), o("svg", ef, of);
}
const PH2 = /* @__PURE__ */ i(tf, [["render", lf]]);
var sf = {}, hf = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, af = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), df = /* @__PURE__ */ t("path", {
  d: "M8.5 19V21.2C8.5 21.48 8.5 21.62 8.4455 21.727C8.39757 21.8211 8.32108 21.8976 8.227 21.9455C8.12004 22 7.98003 22 7.7 22H5.8C5.51997 22 5.37996 22 5.273 21.9455C5.17892 21.8976 5.10243 21.8211 5.0545 21.727C5 21.62 5 21.48 5 21.2V19M19 19V21.2C19 21.48 19 21.62 18.9455 21.727C18.8976 21.8211 18.8211 21.8976 18.727 21.9455C18.62 22 18.48 22 18.2 22H16.3C16.02 22 15.88 22 15.773 21.9455C15.6789 21.8976 15.6024 21.8211 15.5545 21.727C15.5 21.62 15.5 21.48 15.5 21.2V19M3 12H21M3 5.5H21M6.5 15.5H8M16 15.5H17.5M7.8 19H16.2C17.8802 19 18.7202 19 19.362 18.673C19.9265 18.3854 20.3854 17.9265 20.673 17.362C21 16.7202 21 15.8802 21 14.2V6.8C21 5.11984 21 4.27976 20.673 3.63803C20.3854 3.07354 19.9265 2.6146 19.362 2.32698C18.7202 2 17.8802 2 16.2 2H7.8C6.11984 2 5.27976 2 4.63803 2.32698C4.07354 2.6146 3.6146 3.07354 3.32698 3.63803C3 4.27976 3 5.11984 3 6.8V14.2C3 15.8802 3 16.7202 3.32698 17.362C3.6146 17.9265 4.07354 18.3854 4.63803 18.673C5.27976 19 6.11984 19 7.8 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cf = [
  af,
  df
];
function _f(r, e) {
  return n(), o("svg", hf, cf);
}
const AH2 = /* @__PURE__ */ i(sf, [["render", _f]]);
var Cf = {}, ff = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vf = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), uf = /* @__PURE__ */ t("path", {
  d: "M17.5 6.5L6.5 17.5M8.5 10.5V6.5M6.5 8.5H10.5M13.5 15.5H17.5M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wf = [
  vf,
  uf
];
function pf(r, e) {
  return n(), o("svg", ff, wf);
}
const SH2 = /* @__PURE__ */ i(Cf, [["render", pf]]);
var gf = {}, $f = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mf = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), Lf = /* @__PURE__ */ t("path", {
  d: "M21 10H3M16 2V6M8 2V6M9 16L11 18L15.5 13.5M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kf = [
  Mf,
  Lf
];
function mf(r, e) {
  return n(), o("svg", $f, kf);
}
const TH2 = /* @__PURE__ */ i(gf, [["render", mf]]);
var xf = {}, Hf = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vf = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), Zf = /* @__PURE__ */ t("path", {
  d: "M21 10H3M21 12.5V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22H12M16 2V6M8 2V6M14.5 19L16.5 21L21 16.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Bf = [
  Vf,
  Zf
];
function Ff(r, e) {
  return n(), o("svg", Hf, Bf);
}
const OH2 = /* @__PURE__ */ i(xf, [["render", Ff]]);
var jf = {}, If = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bf = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), yf = /* @__PURE__ */ t("path", {
  d: "M21 10H3M16 2V6M8 2V6M10.5 14L12 13V18M10.75 18H13.25M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Df = [
  bf,
  yf
];
function Pf(r, e) {
  return n(), o("svg", If, Df);
}
const EH2 = /* @__PURE__ */ i(jf, [["render", Pf]]);
var Af = {}, Sf = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tf = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), Of = /* @__PURE__ */ t("path", {
  d: "M21 8H3M16 2V5M8 2V5M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22ZM11.9973 12.3306C11.1975 11.4216 9.8639 11.1771 8.86188 12.0094C7.85986 12.8418 7.71879 14.2335 8.50568 15.2179C9.077 15.9327 10.6593 17.3397 11.4833 18.0569C11.662 18.2124 11.7513 18.2902 11.856 18.321C11.9466 18.3477 12.0479 18.3477 12.1386 18.321C12.2432 18.2902 12.3325 18.2124 12.5112 18.0569C13.3353 17.3397 14.9175 15.9327 15.4888 15.2179C16.2757 14.2335 16.1519 12.8331 15.1326 12.0094C14.1134 11.1858 12.797 11.4216 11.9973 12.3306Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ef = [
  Tf,
  Of
];
function Rf(r, e) {
  return n(), o("svg", Sf, Ef);
}
const RH2 = /* @__PURE__ */ i(Af, [["render", Rf]]);
var Uf = {}, Nf = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qf = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), zf = /* @__PURE__ */ t("path", {
  d: "M21 10H3M21 11.5V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22H12.5M16 2V6M8 2V6M17.4976 15.7119C16.7978 14.9328 15.6309 14.7232 14.7541 15.4367C13.8774 16.1501 13.7539 17.343 14.4425 18.1868C15.131 19.0306 17.4976 21 17.4976 21C17.4976 21 19.8642 19.0306 20.5527 18.1868C21.2413 17.343 21.1329 16.1426 20.2411 15.4367C19.3492 14.7307 18.1974 14.9328 17.4976 15.7119Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Kf = [
  qf,
  zf
];
function Gf(r, e) {
  return n(), o("svg", Nf, Kf);
}
const UH2 = /* @__PURE__ */ i(Uf, [["render", Gf]]);
var Wf = {}, Yf = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xf = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), Qf = /* @__PURE__ */ t("path", {
  d: "M9 15H15M21 8H3M16 2V5M8 2V5M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Jf = [
  Xf,
  Qf
];
function tv(r, e) {
  return n(), o("svg", Yf, Jf);
}
const NH2 = /* @__PURE__ */ i(Wf, [["render", tv]]);
var ev = {}, rv = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nv = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), ov = /* @__PURE__ */ t("path", {
  d: "M15 18H21M21 11.5V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22H12.5M21 10H3M16 2V6M8 2V6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iv = [
  nv,
  ov
];
function lv(r, e) {
  return n(), o("svg", rv, iv);
}
const qH2 = /* @__PURE__ */ i(ev, [["render", lv]]);
var sv = {}, hv = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, av = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), dv = /* @__PURE__ */ t("path", {
  d: "M21 8H3M16 2V5M8 2V5M12 18V12M9 15H15M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cv = [
  av,
  dv
];
function _v(r, e) {
  return n(), o("svg", hv, cv);
}
const zH2 = /* @__PURE__ */ i(sv, [["render", _v]]);
var Cv = {}, fv = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vv = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), uv = /* @__PURE__ */ t("path", {
  d: "M21 11.5V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22H12.5M21 10H3M16 2V6M8 2V6M18 21V15M15 18H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wv = [
  vv,
  uv
];
function pv(r, e) {
  return n(), o("svg", fv, wv);
}
const KH2 = /* @__PURE__ */ i(Cv, [["render", pv]]);
var gv = {}, $v = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mv = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), Lv = /* @__PURE__ */ t("path", {
  d: "M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kv = [
  Mv,
  Lv
];
function mv(r, e) {
  return n(), o("svg", $v, kv);
}
const GH2 = /* @__PURE__ */ i(gv, [["render", mv]]);
var xv = {}, Hv = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vv = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), Zv = /* @__PURE__ */ t("path", {
  d: "M2 8.37722C2 8.0269 2 7.85174 2.01462 7.70421C2.1556 6.28127 3.28127 5.1556 4.70421 5.01462C4.85174 5 5.03636 5 5.40558 5C5.54785 5 5.61899 5 5.67939 4.99634C6.45061 4.94963 7.12595 4.46288 7.41414 3.746C7.43671 3.68986 7.45781 3.62657 7.5 3.5C7.54219 3.37343 7.56329 3.31014 7.58586 3.254C7.87405 2.53712 8.54939 2.05037 9.32061 2.00366C9.38101 2 9.44772 2 9.58114 2H14.4189C14.5523 2 14.619 2 14.6794 2.00366C15.4506 2.05037 16.126 2.53712 16.4141 3.254C16.4367 3.31014 16.4578 3.37343 16.5 3.5C16.5422 3.62657 16.5633 3.68986 16.5859 3.746C16.874 4.46288 17.5494 4.94963 18.3206 4.99634C18.381 5 18.4521 5 18.5944 5C18.9636 5 19.1483 5 19.2958 5.01462C20.7187 5.1556 21.8444 6.28127 21.9854 7.70421C22 7.85174 22 8.0269 22 8.37722V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V8.37722Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Bv = /* @__PURE__ */ t("path", {
  d: "M12 16.5C14.2091 16.5 16 14.7091 16 12.5C16 10.2909 14.2091 8.5 12 8.5C9.79086 8.5 8 10.2909 8 12.5C8 14.7091 9.79086 16.5 12 16.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Fv = [
  Vv,
  Zv,
  Bv
];
function jv(r, e) {
  return n(), o("svg", Hv, Fv);
}
const WH2 = /* @__PURE__ */ i(xv, [["render", jv]]);
var Iv = {}, bv = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yv = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), Dv = /* @__PURE__ */ t("path", {
  d: "M2 7.70178C2 6.20963 3.20963 5 4.70178 5C5.47706 5 6.16537 4.5039 6.41053 3.7684L6.5 3.5C6.54219 3.37343 6.56329 3.31014 6.58586 3.254C6.87405 2.53712 7.54939 2.05037 8.32061 2.00366C8.38101 2 8.44772 2 8.58114 2H15.4189C15.5523 2 15.619 2 15.6794 2.00366C16.4506 2.05037 17.126 2.53712 17.4141 3.254C17.4367 3.31014 17.4578 3.37343 17.5 3.5L17.5895 3.7684C17.8346 4.5039 18.5229 5 19.2982 5C20.7904 5 22 6.20963 22 7.70178V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7.70178Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Pv = /* @__PURE__ */ t("path", {
  d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Av = [
  yv,
  Dv,
  Pv
];
function Sv(r, e) {
  return n(), o("svg", bv, Av);
}
const YH2 = /* @__PURE__ */ i(Iv, [["render", Sv]]);
var Tv = {}, Ov = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ev = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), Rv = /* @__PURE__ */ t("path", {
  d: "M2 7.8C2 6.11984 2 5.27976 2.32698 4.63803C2.6146 4.07354 3.07354 3.6146 3.63803 3.32698C4.27976 3 5.11984 3 6.8 3H17.2C18.8802 3 19.7202 3 20.362 3.32698C20.9265 3.6146 21.3854 4.07354 21.673 4.63803C22 5.27976 22 6.11984 22 7.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Uv = /* @__PURE__ */ t("path", {
  d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Nv = [
  Ev,
  Rv,
  Uv
];
function qv(r, e) {
  return n(), o("svg", Ov, Nv);
}
const XH2 = /* @__PURE__ */ i(Tv, [["render", qv]]);
var zv = {}, Kv = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gv = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), Wv = /* @__PURE__ */ t("path", {
  d: "M21.4155 15.3411C18.5924 17.3495 14.8895 17.5726 11.877 16M2.58445 8.65889C5.41439 6.64566 9.12844 6.42638 12.1448 8.01149M15.3737 14.1243C18.2604 12.305 19.9319 8.97413 19.601 5.51222M8.58184 9.90371C5.72231 11.7291 4.06959 15.0436 4.39878 18.4878M15.5269 10.137C15.3939 6.72851 13.345 3.61684 10.1821 2.17222M8.47562 13.9256C8.63112 17.3096 10.6743 20.392 13.8177 21.8278M19.071 4.92893C22.9763 8.83418 22.9763 15.1658 19.071 19.071C15.1658 22.9763 8.83416 22.9763 4.92893 19.071C1.02369 15.1658 1.02369 8.83416 4.92893 4.92893C8.83418 1.02369 15.1658 1.02369 19.071 4.92893ZM14.8284 9.17157C16.3905 10.7337 16.3905 13.2663 14.8284 14.8284C13.2663 16.3905 10.7337 16.3905 9.17157 14.8284C7.60948 13.2663 7.60948 10.7337 9.17157 9.17157C10.7337 7.60948 13.2663 7.60948 14.8284 9.17157Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Yv = [
  Gv,
  Wv
];
function Xv(r, e) {
  return n(), o("svg", Kv, Yv);
}
const QH2 = /* @__PURE__ */ i(zv, [["render", Xv]]);
var Qv = {}, Jv = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tu = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), eu = /* @__PURE__ */ t("path", {
  d: "M5 5H5.41886C5.55228 5 5.61899 5 5.67939 4.99634C6.45061 4.94963 7.12595 4.46288 7.41414 3.746C7.43671 3.68986 7.45781 3.62657 7.5 3.5C7.54219 3.37343 7.56329 3.31014 7.58586 3.254C7.87405 2.53712 8.54939 2.05037 9.32061 2.00366C9.38101 2 9.44772 2 9.58114 2H14.4189C14.5523 2 14.619 2 14.6794 2.00366C15.4506 2.05037 16.126 2.53712 16.4141 3.254C16.4367 3.31014 16.4578 3.37343 16.5 3.5C16.5422 3.62657 16.5633 3.68986 16.5859 3.746C16.874 4.46288 17.5494 4.94963 18.3206 4.99634C18.381 5 18.4521 5 18.5944 5C18.9636 5 19.1483 5 19.2958 5.01462C20.7187 5.1556 21.8444 6.28127 21.9854 7.70421C22 7.85174 22 8.0269 22 8.37722V18C22 19.0849 21.4241 20.0353 20.5613 20.5622M15.0641 15.0714C15.6482 14.3761 16 13.4791 16 12.5C16 10.2909 14.2091 8.5 12 8.5C11.0216 8.5 10.1252 8.8513 9.43012 9.43464M22 22L2 2M2 7.5V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H15.5M12 16.5C9.79086 16.5 8 14.7091 8 12.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ru = [
  tu,
  eu
];
function nu(r, e) {
  return n(), o("svg", Jv, ru);
}
const JH2 = /* @__PURE__ */ i(Qv, [["render", nu]]);
var ou = {}, iu = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lu = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), su = /* @__PURE__ */ t("path", {
  d: "M22 11.5V14.6C22 16.8402 22 17.9603 21.564 18.816C21.1805 19.5686 20.5686 20.1805 19.816 20.564C18.9603 21 17.8402 21 15.6 21H8.4C6.15979 21 5.03969 21 4.18404 20.564C3.43139 20.1805 2.81947 19.5686 2.43597 18.816C2 17.9603 2 16.8402 2 14.6V9.4C2 7.15979 2 6.03969 2.43597 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43597C5.03969 3 6.15979 3 8.4 3H12.5M19 8V2M16 5H22M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hu = [
  lu,
  su
];
function au(r, e) {
  return n(), o("svg", iu, hu);
}
const tV2 = /* @__PURE__ */ i(ou, [["render", au]]);
var du = {}, cu = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _u = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), Cu = /* @__PURE__ */ t("path", {
  d: "M5 13H8M2 9L4 10L5.27064 6.18807C5.53292 5.40125 5.66405 5.00784 5.90729 4.71698C6.12208 4.46013 6.39792 4.26132 6.70951 4.13878C7.06236 4 7.47705 4 8.30643 4H15.6936C16.523 4 16.9376 4 17.2905 4.13878C17.6021 4.26132 17.8779 4.46013 18.0927 4.71698C18.3359 5.00784 18.4671 5.40125 18.7294 6.18807L20 10L22 9M16 13H19M6.8 10H17.2C18.8802 10 19.7202 10 20.362 10.327C20.9265 10.6146 21.3854 11.0735 21.673 11.638C22 12.2798 22 13.1198 22 14.8V17.5C22 17.9647 22 18.197 21.9616 18.3902C21.8038 19.1836 21.1836 19.8038 20.3902 19.9616C20.197 20 19.9647 20 19.5 20H19C17.8954 20 17 19.1046 17 18C17 17.7239 16.7761 17.5 16.5 17.5H7.5C7.22386 17.5 7 17.7239 7 18C7 19.1046 6.10457 20 5 20H4.5C4.03534 20 3.80302 20 3.60982 19.9616C2.81644 19.8038 2.19624 19.1836 2.03843 18.3902C2 18.197 2 17.9647 2 17.5V14.8C2 13.1198 2 12.2798 2.32698 11.638C2.6146 11.0735 3.07354 10.6146 3.63803 10.327C4.27976 10 5.11984 10 6.8 10Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fu = [
  _u,
  Cu
];
function vu(r, e) {
  return n(), o("svg", cu, fu);
}
const eV2 = /* @__PURE__ */ i(du, [["render", vu]]);
var uu = {}, wu = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pu = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), gu = /* @__PURE__ */ t("path", {
  d: "M19 10V6.2C19 5.0799 19 4.51984 18.782 4.09202C18.5903 3.71569 18.2843 3.40973 17.908 3.21799C17.4802 3 16.9201 3 15.8 3H8.2C7.07989 3 6.51984 3 6.09202 3.21799C5.71569 3.40973 5.40973 3.71569 5.21799 4.09202C5 4.51984 5 5.0799 5 6.2V10M5 9H2V8M19 9H22V8M6 13.5H6.01M18 13.5H18.01M6.8 10H17.2C18.8802 10 19.7202 10 20.362 10.327C20.9265 10.6146 21.3854 11.0735 21.673 11.638C22 12.2798 22 13.1198 22 14.8V18C22 18.9319 22 19.3978 21.8478 19.7654C21.6448 20.2554 21.2554 20.6448 20.7654 20.8478C20.3978 21 19.9319 21 19 21H18.4C18.0284 21 17.8426 21 17.6871 20.9754C16.8313 20.8398 16.1602 20.1687 16.0246 19.3129C16 19.1574 16 18.9716 16 18.6C16 18.5071 16 18.4606 15.9938 18.4218C15.96 18.2078 15.7922 18.04 15.5782 18.0062C15.5394 18 15.4929 18 15.4 18H8.6C8.5071 18 8.46065 18 8.42178 18.0062C8.20784 18.04 8.04004 18.2078 8.00616 18.4218C8 18.4606 8 18.5071 8 18.6C8 18.9716 8 19.1574 7.97538 19.3129C7.83983 20.1687 7.16865 20.8398 6.31287 20.9754C6.1574 21 5.9716 21 5.6 21H5C4.06812 21 3.60218 21 3.23463 20.8478C2.74458 20.6448 2.35523 20.2554 2.15224 19.7654C2 19.3978 2 18.9319 2 18V14.8C2 13.1198 2 12.2798 2.32698 11.638C2.6146 11.0735 3.07354 10.6146 3.63803 10.327C4.27976 10 5.11984 10 6.8 10ZM6.5 13.5C6.5 13.7761 6.27614 14 6 14C5.72386 14 5.5 13.7761 5.5 13.5C5.5 13.2239 5.72386 13 6 13C6.27614 13 6.5 13.2239 6.5 13.5ZM18.5 13.5C18.5 13.7761 18.2761 14 18 14C17.7239 14 17.5 13.7761 17.5 13.5C17.5 13.2239 17.7239 13 18 13C18.2761 13 18.5 13.2239 18.5 13.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $u = [
  pu,
  gu
];
function Mu(r, e) {
  return n(), o("svg", wu, $u);
}
const rV2 = /* @__PURE__ */ i(uu, [["render", Mu]]);
var Lu = {}, ku = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mu = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), xu = /* @__PURE__ */ t("path", {
  d: "M6.5 20H5C3.89543 20 3 19.1046 3 18V4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V18C21 19.1046 20.1046 20 19 20H17.5M12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19ZM12 19L12.0214 18.9998L8.82867 22.1926L6.00024 19.3641L9.01965 16.3447M12 19L15.1928 22.1926L18.0212 19.3641L15.0018 16.3447M9 6H15M7 9.5H17",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Hu = [
  mu,
  xu
];
function Vu(r, e) {
  return n(), o("svg", ku, Hu);
}
const nV2 = /* @__PURE__ */ i(Lu, [["render", Vu]]);
var Zu = {}, Bu = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fu = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), ju = /* @__PURE__ */ t("path", {
  d: "M9 18.5H15M7 15H17M5 2H19C20.1046 2 21 2.99492 21 4.22222V19.7778C21 21.0051 20.1046 22 19 22H5C3.89543 22 3 21.0051 3 19.7778V4.22222C3 2.99492 3.89543 2 5 2ZM11.9976 6.21194C11.2978 5.4328 10.1309 5.22321 9.25414 5.93667C8.37738 6.65013 8.25394 7.84299 8.94247 8.6868C9.631 9.53061 11.9976 11.5 11.9976 11.5C11.9976 11.5 14.3642 9.53061 15.0527 8.6868C15.7413 7.84299 15.6329 6.64262 14.7411 5.93667C13.8492 5.23072 12.6974 5.4328 11.9976 6.21194Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Iu = [
  Fu,
  ju
];
function bu(r, e) {
  return n(), o("svg", Bu, Iu);
}
const oV2 = /* @__PURE__ */ i(Zu, [["render", bu]]);
var yu = {}, Du = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pu = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -556)",
  fill: "none"
}, null, -1), Au = /* @__PURE__ */ t("path", {
  d: "M15.5 3.5V2M19.4393 4.56066L20.5 3.5M20.5103 8.5H22.0103M21.9506 13C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81465 5.94668 2.5511 11 2.04938M12 8H16V12M15.6197 8C13.2653 11.3276 9.38636 13.5 5 13.5C3.9971 13.5 3.02072 13.3864 2.08302 13.1715",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Su = [
  Pu,
  Au
];
function Tu(r, e) {
  return n(), o("svg", Du, Su);
}
const iV2 = /* @__PURE__ */ i(yu, [["render", Tu]]);
var Ou = {}, Eu = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ru = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -596)",
  fill: "none"
}, null, -1), Uu = /* @__PURE__ */ t("path", {
  d: "M11 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V13M12 8H16V12M15.5 3.5V2M19.4393 4.56066L20.5 3.5M20.5103 8.5H22.0103M3 13.3471C3.65194 13.4478 4.31987 13.5 5 13.5C9.38636 13.5 13.2653 11.3276 15.6197 8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Nu = [
  Ru,
  Uu
];
function qu(r, e) {
  return n(), o("svg", Eu, Nu);
}
const lV2 = /* @__PURE__ */ i(Ou, [["render", qu]]);
var zu = {}, Ku = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gu = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1036)",
  fill: "none"
}, null, -1), Wu = /* @__PURE__ */ t("path", {
  d: "M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Yu = [
  Gu,
  Wu
];
function Xu(r, e) {
  return n(), o("svg", Ku, Yu);
}
const sV2 = /* @__PURE__ */ i(zu, [["render", Xu]]);
var Qu = {}, Ju = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tw = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -996)",
  fill: "none"
}, null, -1), ew = /* @__PURE__ */ t("path", {
  d: "M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rw = [
  tw,
  ew
];
function nw(r, e) {
  return n(), o("svg", Ju, rw);
}
const ow = /* @__PURE__ */ i(Qu, [["render", nw]]);
var iw = {}, lw = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sw = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1076)",
  fill: "none"
}, null, -1), hw = /* @__PURE__ */ t("path", {
  d: "M6 15L8 17L12.5 12.5M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aw = [
  sw,
  hw
];
function dw(r, e) {
  return n(), o("svg", lw, aw);
}
const hV2 = /* @__PURE__ */ i(iw, [["render", dw]]);
var cw = {}, _w = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cw = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1116)",
  fill: "none"
}, null, -1), fw = /* @__PURE__ */ t("path", {
  d: "M16 8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.0799 16 5.2 16H8M12 15L14 17L18.5 12.5M11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vw = [
  Cw,
  fw
];
function uw(r, e) {
  return n(), o("svg", _w, vw);
}
const aV2 = /* @__PURE__ */ i(cw, [["render", uw]]);
var ww = {}, pw = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gw = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1156)",
  fill: "none"
}, null, -1), $w = /* @__PURE__ */ t("path", {
  d: "M9 11L11 13L15.5 8.5M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.75009 14.4724 8.97129 18.311 10.948 20.0749C11.3114 20.3991 11.4931 20.5613 11.7058 20.6251C11.8905 20.6805 12.0958 20.6805 12.2805 20.6251C12.4932 20.5613 12.6749 20.3991 13.0383 20.0749C15.015 18.311 19.2362 14.4724 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Mw = [
  gw,
  $w
];
function Lw(r, e) {
  return n(), o("svg", pw, Mw);
}
const dV2 = /* @__PURE__ */ i(ww, [["render", Lw]]);
var kw = {}, mw = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xw = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1236)",
  fill: "none"
}, null, -1), Hw = /* @__PURE__ */ t("path", {
  d: "M9 11L12 14L22 4M16 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Vw = [
  xw,
  Hw
];
function Zw(r, e) {
  return n(), o("svg", mw, Vw);
}
const cV2 = /* @__PURE__ */ i(kw, [["render", Zw]]);
var Bw = {}, Fw = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jw = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1196)",
  fill: "none"
}, null, -1), Iw = /* @__PURE__ */ t("path", {
  d: "M7.5 12L10.5 15L16.5 9M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bw = [
  jw,
  Iw
];
function yw(r, e) {
  return n(), o("svg", Fw, bw);
}
const _V2 = /* @__PURE__ */ i(Bw, [["render", yw]]);
var Dw = {}, Pw = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Aw = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1276)",
  fill: "none"
}, null, -1), Sw = /* @__PURE__ */ t("path", {
  d: "M9 12L11 14L15.5 9.5M7.33377 3.8187C8.1376 3.75455 8.90071 3.43846 9.51447 2.91542C10.9467 1.69486 13.0533 1.69486 14.4855 2.91542C15.0993 3.43846 15.8624 3.75455 16.6662 3.8187C18.5421 3.96839 20.0316 5.45794 20.1813 7.33377C20.2455 8.1376 20.5615 8.90071 21.0846 9.51447C22.3051 10.9467 22.3051 13.0533 21.0846 14.4855C20.5615 15.0993 20.2455 15.8624 20.1813 16.6662C20.0316 18.5421 18.5421 20.0316 16.6662 20.1813C15.8624 20.2455 15.0993 20.5615 14.4855 21.0846C13.0533 22.3051 10.9467 22.3051 9.51447 21.0846C8.90071 20.5615 8.1376 20.2455 7.33377 20.1813C5.45794 20.0316 3.96839 18.5421 3.8187 16.6662C3.75455 15.8624 3.43846 15.0993 2.91542 14.4855C1.69486 13.0533 1.69486 10.9467 2.91542 9.51447C3.43846 8.90071 3.75455 8.1376 3.8187 7.33377C3.96839 5.45794 5.45794 3.96839 7.33377 3.8187Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Tw = [
  Aw,
  Sw
];
function Ow(r, e) {
  return n(), o("svg", Pw, Tw);
}
const CV2 = /* @__PURE__ */ i(Dw, [["render", Ow]]);
var Ew = {}, Rw = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uw = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1316)",
  fill: "none"
}, null, -1), Nw = /* @__PURE__ */ t("path", {
  d: "M9 12L11 14L15.5 9.5M17.9012 4.99851C18.1071 5.49653 18.5024 5.8924 19.0001 6.09907L20.7452 6.82198C21.2433 7.02828 21.639 7.42399 21.8453 7.92206C22.0516 8.42012 22.0516 8.97974 21.8453 9.47781L21.1229 11.2218C20.9165 11.7201 20.9162 12.2803 21.1236 12.7783L21.8447 14.5218C21.9469 14.7685 21.9996 15.0329 21.9996 15.2999C21.9997 15.567 21.9471 15.8314 21.8449 16.0781C21.7427 16.3249 21.5929 16.549 21.4041 16.7378C21.2152 16.9266 20.991 17.0764 20.7443 17.1785L19.0004 17.9009C18.5023 18.1068 18.1065 18.5021 17.8998 18.9998L17.1769 20.745C16.9706 21.2431 16.575 21.6388 16.0769 21.8451C15.5789 22.0514 15.0193 22.0514 14.5212 21.8451L12.7773 21.1227C12.2792 20.9169 11.7198 20.9173 11.2221 21.1239L9.47689 21.8458C8.97912 22.0516 8.42001 22.0514 7.92237 21.8453C7.42473 21.6391 7.02925 21.2439 6.82281 20.7464L6.09972 19.0006C5.8938 18.5026 5.49854 18.1067 5.00085 17.9L3.25566 17.1771C2.75783 16.9709 2.36226 16.5754 2.15588 16.0777C1.94951 15.5799 1.94923 15.0205 2.1551 14.5225L2.87746 12.7786C3.08325 12.2805 3.08283 11.7211 2.8763 11.2233L2.15497 9.47678C2.0527 9.2301 2.00004 8.96568 2 8.69863C1.99996 8.43159 2.05253 8.16715 2.15472 7.92043C2.25691 7.67372 2.40671 7.44955 2.59557 7.26075C2.78442 7.07195 3.00862 6.92222 3.25537 6.8201L4.9993 6.09772C5.49687 5.89197 5.89248 5.4972 6.0993 5.00006L6.82218 3.25481C7.02848 2.75674 7.42418 2.36103 7.92222 2.15473C8.42027 1.94842 8.97987 1.94842 9.47792 2.15473L11.2218 2.87712C11.7199 3.08291 12.2793 3.08249 12.7771 2.87595L14.523 2.15585C15.021 1.94966 15.5804 1.9497 16.0784 2.15597C16.5763 2.36223 16.972 2.75783 17.1783 3.25576L17.9014 5.00153L17.9012 4.99851Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qw = [
  Uw,
  Nw
];
function zw(r, e) {
  return n(), o("svg", Rw, qw);
}
const fV2 = /* @__PURE__ */ i(Ew, [["render", zw]]);
var Kw = {}, Gw = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ww = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1356)",
  fill: "none"
}, null, -1), Yw = /* @__PURE__ */ t("path", {
  d: "M9 12L11 14L15.5 9.5M9.2019 20.6009C9.52965 20.5575 9.86073 20.6464 10.1218 20.8475L11.3251 21.7708C11.7228 22.0764 12.2761 22.0764 12.6727 21.7708L13.9215 20.812C14.1548 20.6331 14.4492 20.5542 14.7403 20.5931L16.3024 20.7986C16.799 20.8642 17.2779 20.5875 17.4701 20.1242L18.0712 18.6709C18.1834 18.3987 18.3989 18.1832 18.6711 18.0709L20.1243 17.4698C20.5876 17.2787 20.8643 16.7988 20.7987 16.3021L20.601 14.7966C20.5576 14.4688 20.6465 14.1377 20.8476 13.8766L21.7709 12.6733C22.0764 12.2755 22.0764 11.7222 21.7709 11.3256L20.812 10.0767C20.6332 9.84339 20.5543 9.54896 20.5932 9.25785L20.7987 7.69568C20.8643 7.19902 20.5876 6.72015 20.1243 6.52793L18.6711 5.92684C18.3989 5.81462 18.1834 5.59907 18.0712 5.32685L17.4701 3.87356C17.279 3.41024 16.799 3.13358 16.3024 3.19913L14.7403 3.40468C14.4492 3.44468 14.1548 3.36579 13.9226 3.18802L12.6738 2.22916C12.2761 1.92361 11.7228 1.92361 11.3262 2.22916L10.0774 3.18802C9.84407 3.36579 9.54965 3.44468 9.25856 3.40691L7.69647 3.20136C7.19984 3.1358 6.721 3.41246 6.52879 3.87578L5.92884 5.32907C5.81552 5.60018 5.59998 5.81573 5.32889 5.92906L3.87568 6.52904C3.41238 6.72126 3.13574 7.20013 3.20129 7.69679L3.40683 9.25897C3.4446 9.55007 3.36572 9.8445 3.18796 10.0767L2.22915 11.3256C1.92362 11.7233 1.92362 12.2767 2.22915 12.6733L3.18796 13.9222C3.36683 14.1555 3.44571 14.4499 3.40683 14.741L3.20129 16.3032C3.13574 16.7999 3.41238 17.2787 3.87568 17.471L5.32889 18.0721C5.60109 18.1843 5.81663 18.3998 5.92884 18.672L6.5299 20.1253C6.721 20.5887 7.20096 20.8653 7.69758 20.7998L9.2019 20.6009Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Xw = [
  Ww,
  Yw
];
function Qw(r, e) {
  return n(), o("svg", Gw, Xw);
}
const vV2 = /* @__PURE__ */ i(Kw, [["render", Qw]]);
var Jw = {}, tp = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ep = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -956)",
  fill: "none"
}, null, -1), rp = /* @__PURE__ */ t("path", {
  d: "M20 6L9 17L4 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), np = [
  ep,
  rp
];
function op(r, e) {
  return n(), o("svg", tp, np);
}
const uV2 = /* @__PURE__ */ i(Jw, [["render", op]]);
var ip = {}, lp = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sp = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), hp = /* @__PURE__ */ t("path", {
  d: "M7 13L12 18L17 13M7 6L12 11L17 6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ap = [
  sp,
  hp
];
function dp(r, e) {
  return n(), o("svg", lp, ap);
}
const wV2 = /* @__PURE__ */ i(ip, [["render", dp]]), cp = ["id", "data-id"], _p = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), Cp = /* @__PURE__ */ t("path", {
  d: "M6 9L12 15L18 9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fp = [
  _p,
  Cp
], A2 = /* @__PURE__ */ r1({
  __name: "ChevronDownIcon",
  props: {
    id: { default: "" },
    dataId: { default: "" }
  },
  setup(r) {
    return (e, l) => (n(), o("svg", {
      id: e.id,
      "data-id": e.dataId,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, fp, 8, cp));
  }
});
var vp = {}, up = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wp = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), pp = /* @__PURE__ */ t("path", {
  d: "M18 17L13 12L18 7M11 17L6 12L11 7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), gp = [
  wp,
  pp
];
function $p(r, e) {
  return n(), o("svg", up, gp);
}
const Mp = /* @__PURE__ */ i(vp, [["render", $p]]);
var Lp = {}, kp = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mp = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), xp = /* @__PURE__ */ t("path", {
  d: "M15 18L9 12L15 6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Hp = [
  mp,
  xp
];
function Vp(r, e) {
  return n(), o("svg", kp, Hp);
}
const Zp = /* @__PURE__ */ i(Lp, [["render", Vp]]);
var Bp = {}, Fp = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jp = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), Ip = /* @__PURE__ */ t("path", {
  d: "M6 17L11 12L6 7M13 17L18 12L13 7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bp = [
  jp,
  Ip
];
function yp(r, e) {
  return n(), o("svg", Fp, bp);
}
const Dp = /* @__PURE__ */ i(Bp, [["render", yp]]);
var Pp = {}, Ap = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sp = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), Tp = /* @__PURE__ */ t("path", {
  d: "M9 18L15 12L9 6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Op = [
  Sp,
  Tp
];
function Ep(r, e) {
  return n(), o("svg", Ap, Op);
}
const Rp = /* @__PURE__ */ i(Pp, [["render", Ep]]);
var Up = {}, Np = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qp = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), zp = /* @__PURE__ */ t("path", {
  d: "M9 7L4 12L9 17M15 7L20 12L15 17",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Kp = [
  qp,
  zp
];
function Gp(r, e) {
  return n(), o("svg", Np, Kp);
}
const pV2 = /* @__PURE__ */ i(Up, [["render", Gp]]);
var Wp = {}, Yp = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xp = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), Qp = /* @__PURE__ */ t("path", {
  d: "M7 15L12 20L17 15M7 9L12 4L17 9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Jp = [
  Xp,
  Qp
];
function tg(r, e) {
  return n(), o("svg", Yp, Jp);
}
const gV2 = /* @__PURE__ */ i(Wp, [["render", tg]]);
var eg = {}, rg = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ng = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -636)",
  fill: "none"
}, null, -1), og = /* @__PURE__ */ t("path", {
  d: "M17 18L12 13L7 18M17 11L12 6L7 11",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ig = [
  ng,
  og
];
function lg(r, e) {
  return n(), o("svg", rg, ig);
}
const $V2 = /* @__PURE__ */ i(eg, [["render", lg]]);
var sg = {}, hg = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ag = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), dg = /* @__PURE__ */ t("path", {
  d: "M18 15L12 9L6 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cg = [
  ag,
  dg
];
function _g(r, e) {
  return n(), o("svg", hg, cg);
}
const MV2 = /* @__PURE__ */ i(sg, [["render", _g]]);
var Cg = {}, fg = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vg = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -636)",
  fill: "none"
}, null, -1), ug = /* @__PURE__ */ t("path", {
  d: "M2 12.05C4.03079 12.2759 5.92428 13.186 7.36911 14.6309C8.81395 16.0757 9.72414 17.9692 9.95 20M2 16.1C2.96089 16.296 3.84294 16.7702 4.53638 17.4636C5.22982 18.157 5.70403 19.0391 5.9 20M2 20H2.01M14 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wg = [
  vg,
  ug
];
function pg(r, e) {
  return n(), o("svg", fg, wg);
}
const LV2 = /* @__PURE__ */ i(Cg, [["render", pg]]);
var gg = {}, $g = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mg = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -756)",
  fill: "none"
}, null, -1), Lg = /* @__PURE__ */ t("path", {
  d: "M7 20.6622C9.98901 18.9331 12 15.7014 12 12C12 8.29859 9.98901 5.06687 7 3.33782M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kg = [
  Mg,
  Lg
];
function mg(r, e) {
  return n(), o("svg", $g, kg);
}
const kV2 = /* @__PURE__ */ i(gg, [["render", mg]]);
var xg = {}, Hg = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vg = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), Zg = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Bg = [
  Vg,
  Zg
];
function Fg(r, e) {
  return n(), o("svg", Hg, Bg);
}
const mV2 = /* @__PURE__ */ i(xg, [["render", Fg]]);
var jg = {}, Ig = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bg = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -676)",
  fill: "none"
}, null, -1), yg = /* @__PURE__ */ t("path", {
  d: "M9 3L8 8M16 3L15 8M22 8H2M6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Dg = [
  bg,
  yg
];
function Pg(r, e) {
  return n(), o("svg", Ig, Dg);
}
const xV2 = /* @__PURE__ */ i(jg, [["render", Pg]]);
var Ag = {}, Sg = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tg = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), Og = /* @__PURE__ */ t("path", {
  d: "M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M12 15.5V11C12 10.1716 12.6716 9.5 13.5 9.5C14.3284 9.5 15 10.1716 15 11V15.5C15 17.1569 13.6569 18.5 12 18.5C10.3431 18.5 9 17.1569 9 15.5V11.5M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Eg = [
  Tg,
  Og
];
function Rg(r, e) {
  return n(), o("svg", Sg, Eg);
}
const HV2 = /* @__PURE__ */ i(Ag, [["render", Rg]]);
var Ug = {}, Ng = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qg = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), zg = /* @__PURE__ */ t("path", {
  d: "M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9 15L11 17L15.5 12.5M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Kg = [
  qg,
  zg
];
function Gg(r, e) {
  return n(), o("svg", Ng, Kg);
}
const VV2 = /* @__PURE__ */ i(Ug, [["render", Gg]]);
var Wg = {}, Yg = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xg = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), Qg = /* @__PURE__ */ t("path", {
  d: "M12 11V17M12 17L9 14M12 17L15 14M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Jg = [
  Xg,
  Qg
];
function t$(r, e) {
  return n(), o("svg", Yg, Jg);
}
const ZV2 = /* @__PURE__ */ i(Wg, [["render", t$]]);
var e$ = {}, r$ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, n$ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), o$ = /* @__PURE__ */ t("path", {
  d: "M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9 14H15M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), i$ = [
  n$,
  o$
];
function l$(r, e) {
  return n(), o("svg", r$, i$);
}
const BV2 = /* @__PURE__ */ i(e$, [["render", l$]]);
var s$ = {}, h$ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, a$ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), d$ = /* @__PURE__ */ t("path", {
  d: "M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M12 17V11M9 14H15M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), c$ = [
  a$,
  d$
];
function _$(r, e) {
  return n(), o("svg", h$, c$);
}
const FV2 = /* @__PURE__ */ i(s$, [["render", _$]]);
var C$ = {}, f$ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, v$ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), u$ = /* @__PURE__ */ t("path", {
  d: "M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9.5 12L14.5 17M14.5 12L9.5 17M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), w$ = [
  v$,
  u$
];
function p$(r, e) {
  return n(), o("svg", f$, w$);
}
const jV2 = /* @__PURE__ */ i(C$, [["render", p$]]);
var g$ = {}, $$ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M$ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), L$ = /* @__PURE__ */ t("path", {
  d: "M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), k$ = [
  M$,
  L$
];
function m$(r, e) {
  return n(), o("svg", $$, k$);
}
const IV2 = /* @__PURE__ */ i(g$, [["render", m$]]);
var x$ = {}, H$ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V$ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), Z$ = /* @__PURE__ */ t("path", {
  d: "M14.5 19L16.5 21L21 16.5M21.9851 12.5499C21.995 12.3678 22 12.1845 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.4354 6.33651 21.858 11.7385 21.9966M12 6V12L15.7384 13.8692",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), B$ = [
  V$,
  Z$
];
function F$(r, e) {
  return n(), o("svg", H$, B$);
}
const bV2 = /* @__PURE__ */ i(x$, [["render", F$]]);
var j$ = {}, I$ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, b$ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), y$ = /* @__PURE__ */ t("path", {
  d: "M22.7 11.5L20.7005 13.5L18.7 11.5M20.9451 13C20.9814 12.6717 21 12.338 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C14.8273 21 17.35 19.6963 19 17.6573M12 7V12L15 14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), D$ = [
  b$,
  y$
];
function P$(r, e) {
  return n(), o("svg", I$, D$);
}
const yV2 = /* @__PURE__ */ i(j$, [["render", P$]]);
var A$ = {}, S$ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, T$ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), O$ = /* @__PURE__ */ t("path", {
  d: "M21.9208 13.265C21.9731 12.8507 22 12.4285 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.4354 22 12.8643 21.9722 13.285 21.9182M12 6V12L15.7384 13.8692M19 22V16M16 19H22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), E$ = [
  T$,
  O$
];
function R$(r, e) {
  return n(), o("svg", S$, E$);
}
const DV2 = /* @__PURE__ */ i(A$, [["render", R$]]);
var U$ = {}, N$ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, q$ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), z$ = /* @__PURE__ */ t("path", {
  d: "M20.4532 12.8928C20.1754 15.5027 18.6967 17.9484 16.2497 19.3612C12.1842 21.7084 6.98566 20.3155 4.63845 16.25L4.38845 15.817M3.54617 11.1071C3.82397 8.49723 5.30276 6.05151 7.74974 4.63874C11.8152 2.29153 17.0138 3.68447 19.361 7.74995L19.611 8.18297M3.49316 18.0659L4.22522 15.3339L6.95727 16.0659M17.0422 7.93398L19.7743 8.66603L20.5063 5.93398M11.9997 7.49995V12L14.4997 13.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), K$ = [
  q$,
  z$
];
function G$(r, e) {
  return n(), o("svg", N$, K$);
}
const PV2 = /* @__PURE__ */ i(U$, [["render", G$]]);
var W$ = {}, Y$ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, X$ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), Q$ = /* @__PURE__ */ t("path", {
  d: "M22.7 13.5L20.7005 11.5L18.7 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C15.3019 3 18.1885 4.77814 19.7545 7.42909M12 7V12L15 14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), J$ = [
  X$,
  Q$
];
function tM(r, e) {
  return n(), o("svg", Y$, J$);
}
const AV2 = /* @__PURE__ */ i(W$, [["render", tM]]);
var eM = {}, rM = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nM = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), oM = /* @__PURE__ */ t("path", {
  d: "M16.5 17H21.5L16.5 22H21.5M21.9506 13C21.9833 12.6711 22 12.3375 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.1677 22 12.3344 21.9959 12.5 21.9877C12.6678 21.9795 12.8345 21.9671 13 21.9506M12 6V12L15.7384 13.8692",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iM = [
  nM,
  oM
];
function lM(r, e) {
  return n(), o("svg", rM, iM);
}
const SV2 = /* @__PURE__ */ i(eM, [["render", lM]]);
var sM = {}, hM = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aM = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), dM = /* @__PURE__ */ t("path", {
  d: "M12 9.5V13.5L14.5 15M12 5C7.30558 5 3.5 8.80558 3.5 13.5C3.5 18.1944 7.30558 22 12 22C16.6944 22 20.5 18.1944 20.5 13.5C20.5 8.80558 16.6944 5 12 5ZM12 5V2M10 2H14M20.329 5.59204L18.829 4.09204L19.579 4.84204M3.67102 5.59204L5.17102 4.09204L4.42102 4.84204",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cM = [
  aM,
  dM
];
function _M(r, e) {
  return n(), o("svg", hM, cM);
}
const TV2 = /* @__PURE__ */ i(sM, [["render", _M]]);
var CM = {}, fM = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vM = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), uM = /* @__PURE__ */ t("path", {
  d: "M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wM = [
  vM,
  uM
];
function pM(r, e) {
  return n(), o("svg", fM, wM);
}
const OV2 = /* @__PURE__ */ i(CM, [["render", pM]]);
var gM = {}, $M = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MM = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), LM = /* @__PURE__ */ t("path", {
  d: "M6.5 19C4.01472 19 2 16.9853 2 14.5C2 12.1564 3.79151 10.2313 6.07974 10.0194C6.54781 7.17213 9.02024 5 12 5C14.9798 5 17.4522 7.17213 17.9203 10.0194C20.2085 10.2313 22 12.1564 22 14.5C22 16.9853 19.9853 19 17.5 19C13.1102 19 10.3433 19 6.5 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kM = [
  MM,
  LM
];
function mM(r, e) {
  return n(), o("svg", $M, kM);
}
const EV2 = /* @__PURE__ */ i(gM, [["render", mM]]);
var xM = {}, HM = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VM = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), ZM = /* @__PURE__ */ t("path", {
  d: "M6 19C3.79086 19 2 17.2091 2 15C2 13.1358 3.27532 11.5694 5.00111 11.1257C5.00037 11.0839 5 11.042 5 11C5 7.13401 8.13401 4 12 4C15.6099 4 18.5815 6.73249 18.9594 10.2419C20.7284 10.8481 22 12.5255 22 14.5C22 16.9853 19.9853 19 17.5 19C13.7609 19 10.1876 19 6 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BM = [
  VM,
  ZM
];
function FM(r, e) {
  return n(), o("svg", HM, BM);
}
const RV2 = /* @__PURE__ */ i(xM, [["render", FM]]);
var jM = {}, IM = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bM = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), yM = /* @__PURE__ */ t("path", {
  d: "M9.5 19C5.35786 19 2 15.6421 2 11.5C2 7.35786 5.35786 4 9.5 4C12.3827 4 14.8855 5.62634 16.141 8.01153C16.2597 8.00388 16.3794 8 16.5 8C19.5376 8 22 10.4624 22 13.5C22 16.5376 19.5376 19 16.5 19C13.9485 19 12.1224 19 9.5 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DM = [
  bM,
  yM
];
function PM(r, e) {
  return n(), o("svg", IM, DM);
}
const UV2 = /* @__PURE__ */ i(jM, [["render", PM]]);
var AM = {}, SM = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TM = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1396)",
  fill: "none"
}, null, -1), OM = /* @__PURE__ */ t("path", {
  d: "M6.5 19C4.01472 19 2 16.9853 2 14.5C2 12.1564 3.79151 10.2313 6.07974 10.0194C6.54781 7.17213 9.02024 5 12 5C14.9798 5 17.4522 7.17213 17.9203 10.0194C20.2085 10.2313 22 12.1564 22 14.5C22 16.9853 19.9853 19 17.5 19C13.1102 19 10.3433 19 6.5 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EM = [
  TM,
  OM
];
function RM(r, e) {
  return n(), o("svg", SM, EM);
}
const NV2 = /* @__PURE__ */ i(AM, [["render", RM]]);
var UM = {}, NM = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qM = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1436)",
  fill: "none"
}, null, -1), zM = /* @__PURE__ */ t("path", {
  d: "M9.5 19C5.35786 19 2 15.6421 2 11.5C2 7.35786 5.35786 4 9.5 4C12.3827 4 14.8855 5.62634 16.141 8.01153C16.2597 8.00388 16.3794 8 16.5 8C19.5376 8 22 10.4624 22 13.5C22 16.5376 19.5376 19 16.5 19C13.9485 19 12.1224 19 9.5 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KM = [
  qM,
  zM
];
function GM(r, e) {
  return n(), o("svg", NM, KM);
}
const qV2 = /* @__PURE__ */ i(UM, [["render", GM]]);
var WM = {}, YM = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XM = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), QM = /* @__PURE__ */ t("path", {
  d: "M19 15.7439C20.7478 15.1262 22 13.4593 22 11.5C22 9.15643 20.2085 7.23129 17.9203 7.01937C17.4522 4.17213 14.9798 2 12 2C9.02024 2 6.54781 4.17213 6.07974 7.01937C3.79151 7.23129 2 9.15643 2 11.5C2 13.4593 3.25221 15.1262 5 15.7439M13 10L9 16H15L11 22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JM = [
  XM,
  QM
];
function tL(r, e) {
  return n(), o("svg", YM, JM);
}
const zV2 = /* @__PURE__ */ i(WM, [["render", tL]]);
var eL = {}, rL = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nL = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), oL = /* @__PURE__ */ t("path", {
  d: "M16.5 13C19.0768 13 21.2397 11.228 21.8366 8.83604C21.4087 8.94287 20.961 8.99958 20.5 8.99958C17.4624 8.99958 15 6.53715 15 3.49958C15 3.03881 15.0567 2.59128 15.1634 2.16357C12.7717 2.76068 11 4.92345 11 7.50003C11 8.41275 11.2223 9.27355 11.6158 10.0312M5 7V3M3 5H7M6 22C3.79086 22 2 20.2091 2 18C2 16.0221 3.43551 14.3796 5.32148 14.0573C6.12876 11.697 8.3662 10 11 10C13.2882 10 15.2772 11.2809 16.2892 13.1648C16.6744 13.0574 17.0805 13 17.5 13C19.9853 13 22 15.0147 22 17.5C22 19.9853 19.9853 22 17.5 22C13.6667 22 9.83333 22 6 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iL = [
  nL,
  oL
];
function lL(r, e) {
  return n(), o("svg", rL, iL);
}
const KV2 = /* @__PURE__ */ i(eL, [["render", lL]]);
var sL = {}, hL = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aL = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), dL = /* @__PURE__ */ t("path", {
  d: "M21.7003 16.1181C21.8939 15.616 22 15.0704 22 14.5C22 12.1564 20.2085 10.2313 17.9203 10.0194C17.4522 7.17213 14.9798 5 12 5C11.5534 5 11.1183 5.04879 10.6995 5.14132M7.28746 7.28585C6.67317 8.06419 6.24759 8.99838 6.07974 10.0194C3.79151 10.2313 2 12.1564 2 14.5C2 16.9853 4.01472 19 6.5 19H17.5C17.9561 19 18.3963 18.9322 18.8112 18.806M3 3L21 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cL = [
  aL,
  dL
];
function _L(r, e) {
  return n(), o("svg", hL, cL);
}
const GV2 = /* @__PURE__ */ i(sL, [["render", _L]]);
var CL = {}, fL = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vL = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), uL = /* @__PURE__ */ t("path", {
  d: "M20 15.2422C21.206 14.435 22 13.0602 22 11.5C22 9.15643 20.2085 7.23129 17.9203 7.01937C17.4522 4.17213 14.9798 2 12 2C9.02024 2 6.54781 4.17213 6.07974 7.01937C3.79151 7.23129 2 9.15643 2 11.5C2 13.0602 2.79401 14.435 4 15.2422M8 18V20M8 12V14M16 18V20M16 12V14M12 20V22M12 14V16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wL = [
  vL,
  uL
];
function pL(r, e) {
  return n(), o("svg", fL, wL);
}
const WV2 = /* @__PURE__ */ i(CL, [["render", pL]]);
var gL = {}, $L = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ML = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), LL = /* @__PURE__ */ t("path", {
  d: "M16 12V20M8 12V20M12 14V22M20 15.2422C21.206 14.435 22 13.0602 22 11.5C22 9.15643 20.2085 7.23129 17.9203 7.01937C17.4522 4.17213 14.9798 2 12 2C9.02024 2 6.54781 4.17213 6.07974 7.01937C3.79151 7.23129 2 9.15643 2 11.5C2 13.0602 2.79401 14.435 4 15.2422",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kL = [
  ML,
  LL
];
function mL(r, e) {
  return n(), o("svg", $L, kL);
}
const YV2 = /* @__PURE__ */ i(gL, [["render", mL]]);
var xL = {}, HL = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VL = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), ZL = /* @__PURE__ */ t("path", {
  d: "M20 15.2422C21.206 14.435 22 13.0602 22 11.5C22 9.15643 20.2085 7.23129 17.9203 7.01937C17.4522 4.17213 14.9798 2 12 2C9.02024 2 6.54781 4.17213 6.07974 7.01937C3.79151 7.23129 2 9.15643 2 11.5C2 13.0602 2.79401 14.435 4 15.2422M12.25 15L9.44995 22M17.05 13L14.25 20M9.05 13L6.25 20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BL = [
  VL,
  ZL
];
function FL(r, e) {
  return n(), o("svg", HL, BL);
}
const XV2 = /* @__PURE__ */ i(xL, [["render", FL]]);
var jL = {}, IL = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bL = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), yL = /* @__PURE__ */ t("path", {
  d: "M16 18.5V21M8 18.5V21M12 19.5V22M7 15C4.23858 15 2 12.7614 2 10C2 7.23858 4.23858 5 7 5C7.03315 5 7.06622 5.00032 7.09922 5.00097C8.0094 3.2196 9.86227 2 12 2C14.5192 2 16.6429 3.69375 17.2943 6.00462C17.3625 6.00155 17.4311 6 17.5 6C19.9853 6 22 8.01472 22 10.5C22 12.9853 19.9853 15 17.5 15C13.7434 15 11.2352 15 7 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DL = [
  bL,
  yL
];
function PL(r, e) {
  return n(), o("svg", IL, DL);
}
const QV2 = /* @__PURE__ */ i(jL, [["render", PL]]);
var AL = {}, SL = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TL = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), OL = /* @__PURE__ */ t("path", {
  d: "M16 18.5L15 21M8 18.5L7 21M12 18.5L11 21M7 15C4.23858 15 2 12.7614 2 10C2 7.23858 4.23858 5 7 5C7.03315 5 7.06622 5.00032 7.09922 5.00097C8.0094 3.2196 9.86227 2 12 2C14.5192 2 16.6429 3.69375 17.2943 6.00462C17.3625 6.00155 17.4311 6 17.5 6C19.9853 6 22 8.01472 22 10.5C22 12.9853 19.9853 15 17.5 15C13.7434 15 11.2352 15 7 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EL = [
  TL,
  OL
];
function RL(r, e) {
  return n(), o("svg", SL, EL);
}
const JV2 = /* @__PURE__ */ i(AL, [["render", RL]]);
var UL = {}, NL = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qL = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -596)",
  fill: "none"
}, null, -1), zL = /* @__PURE__ */ t("path", {
  d: "M13 21H6M19 18H10M7 18H5M18 21H16M7 15C4.23858 15 2 12.7614 2 10C2 7.23858 4.23858 5 7 5C7.03315 5 7.06622 5.00032 7.09922 5.00097C8.0094 3.2196 9.86227 2 12 2C14.5192 2 16.6429 3.69375 17.2943 6.00462C17.3625 6.00155 17.4311 6 17.5 6C19.9853 6 22 8.01472 22 10.5C22 12.9853 19.9853 15 17.5 15C13.7434 15 11.2352 15 7 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KL = [
  qL,
  zL
];
function GL(r, e) {
  return n(), o("svg", NL, KL);
}
const tZ2 = /* @__PURE__ */ i(UL, [["render", GL]]);
var WL = {}, YL = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XL = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-64 -636)",
  fill: "none"
}, null, -1), QL = /* @__PURE__ */ t("path", {
  d: "M20 15.2422C21.206 14.435 22 13.0602 22 11.5C22 9.15643 20.2085 7.23129 17.9203 7.01937C17.4522 4.17213 14.9798 2 12 2C9.02024 2 6.54781 4.17213 6.07974 7.01937C3.79151 7.23129 2 9.15643 2 11.5C2 13.0602 2.79401 14.435 4 15.2422M8 15H8.01M8 19H8.01M12 17H12.01M12 21H12.01M16 15H16.01M16 19H16.01",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JL = [
  XL,
  QL
];
function tk(r, e) {
  return n(), o("svg", YL, JL);
}
const eZ2 = /* @__PURE__ */ i(WL, [["render", tk]]);
var ek = {}, rk = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nk = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), ok = /* @__PURE__ */ t("path", {
  d: "M8 18H8.01M8 21H8.01M12 18.5H12.01M12 21.5H12.01M16 18H16.01M16 21H16.01M7 15C4.23858 15 2 12.7614 2 10C2 7.23858 4.23858 5 7 5C7.03315 5 7.06622 5.00032 7.09922 5.00097C8.0094 3.2196 9.86227 2 12 2C14.5192 2 16.6429 3.69375 17.2943 6.00462C17.3625 6.00155 17.4311 6 17.5 6C19.9853 6 22 8.01472 22 10.5C22 12.9853 19.9853 15 17.5 15C13.7434 15 11.2352 15 7 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ik = [
  nk,
  ok
];
function lk(r, e) {
  return n(), o("svg", rk, ik);
}
const rZ2 = /* @__PURE__ */ i(ek, [["render", lk]]);
var sk = {}, hk = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ak = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), dk = /* @__PURE__ */ t("path", {
  d: "M19.368 12.4048C20.935 11.5606 22 9.9047 22 8C22 5.23858 19.7614 3 17 3C14.2386 3 12 5.23858 12 8M12 8C9.86227 8 8.0094 9.2196 7.09922 11.001C7.06622 11.0003 7.03315 11 7 11C4.23858 11 2 13.2386 2 16C2 18.7614 4.23858 21 7 21C11.2352 21 13.7434 21 17.5 21C19.9853 21 22 18.9853 22 16.5C22 14.0147 19.9853 12 17.5 12C17.4311 12 17.3625 12.0016 17.2943 12.0046C16.6429 9.69375 14.5192 8 12 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ck = [
  ak,
  dk
];
function _k(r, e) {
  return n(), o("svg", hk, ck);
}
const nZ2 = /* @__PURE__ */ i(sk, [["render", _k]]);
var Ck = {}, fk = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vk = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), uk = /* @__PURE__ */ t("path", {
  d: "M10.5 1.5V3.1M3.6 10H2M5.4512 4.95137L4.31982 3.82M15.5498 4.95137L16.6812 3.82M19 10H17.4M6.50007 10.0001C6.50007 7.79093 8.29093 6.00007 10.5001 6.00007C12.0061 6.00007 13.3177 6.83235 14.0001 8.06206M6 22C3.79086 22 2 20.2091 2 18C2 15.7909 3.79086 14 6 14C6.46419 14 6.90991 14.0791 7.32442 14.2245C8.04061 12.3396 9.86387 11 12 11C14.1361 11 15.9594 12.3396 16.6756 14.2245C17.0901 14.0791 17.5358 14 18 14C20.2091 14 22 15.7909 22 18C22 20.2091 20.2091 22 18 22C13.3597 22 9.87921 22 6 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wk = [
  vk,
  uk
];
function pk(r, e) {
  return n(), o("svg", fk, wk);
}
const oZ2 = /* @__PURE__ */ i(Ck, [["render", pk]]);
var gk = {}, $k = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mk = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), Lk = /* @__PURE__ */ t("path", {
  d: "M3.15003 11C3.05165 10.5153 3 10.0137 3 9.5C3 5.35786 6.35786 2 10.5 2C14.3031 2 17.445 4.83064 17.9339 8.5M6 22C3.79086 22 2 20.2091 2 18C2 15.7909 3.79086 14 6 14C6.11333 14 6.22556 14.0047 6.3365 14.014C7.15622 11.6763 9.38235 10 12 10C14.2248 10 16.1668 11.2109 17.2029 13.0097C17.3011 13.0033 17.4002 13 17.5 13C19.9853 13 22 15.0147 22 17.5C22 19.9853 19.9853 22 17.5 22C13.7633 22 10.0546 22 6 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kk = [
  Mk,
  Lk
];
function mk(r, e) {
  return n(), o("svg", $k, kk);
}
const iZ2 = /* @__PURE__ */ i(gk, [["render", mk]]);
var xk = {}, Hk = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vk = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), Zk = /* @__PURE__ */ t("path", {
  d: "M16 18L22 12L16 6M8 6L2 12L8 18",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Bk = [
  Vk,
  Zk
];
function Fk(r, e) {
  return n(), o("svg", Hk, Bk);
}
const lZ2 = /* @__PURE__ */ i(xk, [["render", Fk]]);
var jk = {}, Ik = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bk = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), yk = /* @__PURE__ */ t("path", {
  d: "M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Dk = [
  bk,
  yk
];
function Pk(r, e) {
  return n(), o("svg", Ik, Dk);
}
const sZ2 = /* @__PURE__ */ i(jk, [["render", Pk]]);
var Ak = {}, Sk = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tk = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), Ok = /* @__PURE__ */ t("path", {
  d: "M22 9H2M14 17.5L16.5 15L14 12.5M10 12.5L7.5 15L10 17.5M2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27977 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ek = [
  Tk,
  Ok
];
function Rk(r, e) {
  return n(), o("svg", Sk, Ek);
}
const hZ2 = /* @__PURE__ */ i(Ak, [["render", Rk]]);
var Uk = {}, Nk = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qk = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -596)",
  fill: "none"
}, null, -1), zk = /* @__PURE__ */ t("path", {
  d: "M14.5 15L17.5 12L14.5 9M9.5 9L6.5 12L9.5 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Kk = [
  qk,
  zk
];
function Gk(r, e) {
  return n(), o("svg", Nk, Kk);
}
const aZ2 = /* @__PURE__ */ i(Uk, [["render", Gk]]);
var Wk = {}, Yk = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xk = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -636)",
  fill: "none"
}, null, -1), Qk = /* @__PURE__ */ t("path", {
  d: "M14 17L17 14L14 11M10 7L7 10L10 13M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Jk = [
  Xk,
  Qk
];
function tm(r, e) {
  return n(), o("svg", Yk, Jk);
}
const dZ2 = /* @__PURE__ */ i(Wk, [["render", tm]]);
var em = {}, rm = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nm = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -676)",
  fill: "none"
}, null, -1), om = /* @__PURE__ */ t("path", {
  d: "M15.5 15L18.5 12L15.5 9M8.5 9L5.5 12L8.5 15M13 7L11 17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), im = [
  nm,
  om
];
function lm(r, e) {
  return n(), o("svg", rm, im);
}
const cZ2 = /* @__PURE__ */ i(em, [["render", lm]]);
var sm = {}, hm = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, am = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -796)",
  fill: "none"
}, null, -1), dm = /* @__PURE__ */ t("path", {
  d: "M16 18L22 12L16 6M8 6L2 12L8 18",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cm = [
  am,
  dm
];
function _m(r, e) {
  return n(), o("svg", hm, cm);
}
const _Z2 = /* @__PURE__ */ i(sm, [["render", _m]]);
var Cm = {}, fm = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vm = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -836)",
  fill: "none"
}, null, -1), um = /* @__PURE__ */ t("path", {
  d: "M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wm = [
  vm,
  um
];
function pm(r, e) {
  return n(), o("svg", fm, wm);
}
const CZ2 = /* @__PURE__ */ i(Cm, [["render", pm]]);
var gm = {}, $m = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mm = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -716)",
  fill: "none"
}, null, -1), Lm = /* @__PURE__ */ t("path", {
  d: "M14.5 15L17.5 12L14.5 9M9.5 9L6.5 12L9.5 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), km = [
  Mm,
  Lm
];
function mm(r, e) {
  return n(), o("svg", $m, km);
}
const fZ2 = /* @__PURE__ */ i(gm, [["render", mm]]);
var xm = {}, Hm = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vm = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), Zm = /* @__PURE__ */ t("path", {
  d: "M14 17L17 14L14 11M10 7L7 10L10 13M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Bm = [
  Vm,
  Zm
];
function Fm(r, e) {
  return n(), o("svg", Hm, Bm);
}
const vZ2 = /* @__PURE__ */ i(xm, [["render", Fm]]);
var jm = {}, Im = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bm = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), ym = /* @__PURE__ */ t("path", {
  d: "M12 8.99994L4.06386 14.1584C3.37601 14.6055 3.03209 14.8291 2.91297 15.1126C2.80888 15.3603 2.80888 15.6396 2.91297 15.8873M12 8.99994L19.9361 14.1584C20.624 14.6055 20.9679 14.8291 21.087 15.1126C21.1911 15.3603 21.1911 15.6396 21.087 15.8873M12 8.99994V2.49994M12 14.9999L4.06386 9.84145C3.37601 9.39435 3.03209 9.1708 2.91297 8.8873C2.80888 8.63955 2.80888 8.36033 2.91297 8.11258M12 14.9999L19.9361 9.84145C20.624 9.39435 20.9679 9.1708 21.087 8.8873C21.1911 8.63955 21.1911 8.36033 21.087 8.11258M12 14.9999V21.4999M21.272 15.9732L12.872 21.4332C12.5564 21.6383 12.3985 21.7409 12.2285 21.7808C12.0782 21.8161 11.9218 21.8161 11.7715 21.7808C11.6015 21.7409 11.4436 21.6383 11.128 21.4332L2.72802 15.9732C2.46201 15.8002 2.32901 15.7138 2.23265 15.5985C2.14735 15.4964 2.08327 15.3783 2.04417 15.2512C2 15.1075 2 14.9489 2 14.6316V9.36824C2 9.05098 2 8.89235 2.04417 8.74871C2.08327 8.62155 2.14735 8.50348 2.23265 8.4014C2.32901 8.28608 2.46201 8.19963 2.72802 8.02673L11.128 2.56673C11.4436 2.36157 11.6015 2.259 11.7715 2.21909C11.9218 2.18381 12.0782 2.18381 12.2285 2.21909C12.3985 2.259 12.5564 2.36157 12.872 2.56673L21.272 8.02673C21.538 8.19963 21.671 8.28608 21.7674 8.4014C21.8527 8.50348 21.9167 8.62155 21.9558 8.74871C22 8.89235 22 9.05098 22 9.36824V14.6316C22 14.9489 22 15.1075 21.9558 15.2512C21.9167 15.3783 21.8527 15.4964 21.7674 15.5985C21.671 15.7138 21.538 15.8002 21.272 15.9732Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Dm = [
  bm,
  ym
];
function Pm(r, e) {
  return n(), o("svg", Im, Dm);
}
const uZ2 = /* @__PURE__ */ i(jm, [["render", Pm]]);
var Am = {}, Sm = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tm = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), Om = /* @__PURE__ */ t("path", {
  d: "M15.9377 15.9377C19.3603 15.4795 22 12.548 22 9C22 5.13401 18.866 2 15 2C11.452 2 8.52049 4.63967 8.06227 8.06227M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Em = [
  Tm,
  Om
];
function Rm(r, e) {
  return n(), o("svg", Sm, Em);
}
const wZ2 = /* @__PURE__ */ i(Am, [["render", Rm]]);
var Um = {}, Nm = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qm = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), zm = /* @__PURE__ */ t("path", {
  d: "M15.9377 15.9377C19.3603 15.4795 22 12.548 22 9C22 5.13401 18.866 2 15 2C11.452 2 8.52049 4.63967 8.06227 8.06227M7.5 13L9 12V17.5M7.5 17.5H10.5M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Km = [
  qm,
  zm
];
function Gm(r, e) {
  return n(), o("svg", Nm, Km);
}
const pZ2 = /* @__PURE__ */ i(Um, [["render", Gm]]);
var Wm = {}, Ym = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xm = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), Qm = /* @__PURE__ */ t("path", {
  d: "M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Jm = [
  Xm,
  Qm
];
function tx(r, e) {
  return n(), o("svg", Ym, Jm);
}
const gZ2 = /* @__PURE__ */ i(Wm, [["render", tx]]);
var ex = {}, rx = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nx = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), ox = /* @__PURE__ */ t("path", {
  d: "M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M7.5 13L9 12V17.5M7.5 17.5H10.5M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ix = [
  nx,
  ox
];
function lx(r, e) {
  return n(), o("svg", rx, ix);
}
const $Z2 = /* @__PURE__ */ i(ex, [["render", lx]]);
var sx = {}, hx = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ax = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), dx = /* @__PURE__ */ t("path", {
  d: "M13.5295 8.35186C12.9571 8.75995 12.2566 9 11.5 9C9.567 9 8 7.433 8 5.5C8 3.567 9.567 2 11.5 2C12.753 2 13.8522 2.65842 14.4705 3.64814M6 20.0872H8.61029C8.95063 20.0872 9.28888 20.1277 9.61881 20.2086L12.3769 20.8789C12.9753 21.0247 13.5988 21.0388 14.2035 20.9214L17.253 20.3281C18.0585 20.1712 18.7996 19.7854 19.3803 19.2205L21.5379 17.1217C22.154 16.5234 22.154 15.5524 21.5379 14.9531C20.9832 14.4134 20.1047 14.3527 19.4771 14.8103L16.9626 16.6449C16.6025 16.9081 16.1643 17.0498 15.7137 17.0498H13.2855L14.8311 17.0498C15.7022 17.0498 16.4079 16.3633 16.4079 15.5159V15.2091C16.4079 14.5055 15.9156 13.892 15.2141 13.7219L12.8286 13.1417C12.4404 13.0476 12.0428 13 11.6431 13C10.6783 13 8.93189 13.7988 8.93189 13.7988L6 15.0249M20 6.5C20 8.433 18.433 10 16.5 10C14.567 10 13 8.433 13 6.5C13 4.567 14.567 3 16.5 3C18.433 3 20 4.567 20 6.5ZM2 14.6L2 20.4C2 20.9601 2 21.2401 2.10899 21.454C2.20487 21.6422 2.35785 21.7951 2.54601 21.891C2.75992 22 3.03995 22 3.6 22H4.4C4.96005 22 5.24008 22 5.45399 21.891C5.64215 21.7951 5.79513 21.6422 5.89101 21.454C6 21.2401 6 20.9601 6 20.4V14.6C6 14.0399 6 13.7599 5.89101 13.546C5.79513 13.3578 5.64215 13.2049 5.45399 13.109C5.24008 13 4.96005 13 4.4 13L3.6 13C3.03995 13 2.75992 13 2.54601 13.109C2.35785 13.2049 2.20487 13.3578 2.10899 13.546C2 13.7599 2 14.0399 2 14.6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cx = [
  ax,
  dx
];
function _x(r, e) {
  return n(), o("svg", hx, cx);
}
const MZ2 = /* @__PURE__ */ i(sx, [["render", _x]]);
var Cx = {}, fx = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vx = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), ux = /* @__PURE__ */ t("path", {
  d: "M12 17C12 19.7614 14.2386 22 17 22C19.7614 22 22 19.7614 22 17C22 14.2386 19.7614 12 17 12C14.2386 12 12 14.2386 12 17ZM12 17C12 15.8742 12.3721 14.8353 13 13.9995V5M12 17C12 17.8254 12.2 18.604 12.5541 19.2901C11.7117 20.0018 9.76584 20.5 7.5 20.5C4.46243 20.5 2 19.6046 2 18.5V5M13 5C13 6.10457 10.5376 7 7.5 7C4.46243 7 2 6.10457 2 5M13 5C13 3.89543 10.5376 3 7.5 3C4.46243 3 2 3.89543 2 5M2 14C2 15.1046 4.46243 16 7.5 16C9.689 16 11.5793 15.535 12.4646 14.8618M13 9.5C13 10.6046 10.5376 11.5 7.5 11.5C4.46243 11.5 2 10.6046 2 9.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wx = [
  vx,
  ux
];
function px(r, e) {
  return n(), o("svg", fx, wx);
}
const LZ2 = /* @__PURE__ */ i(Cx, [["render", px]]);
var gx = {}, $x = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mx = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), Lx = /* @__PURE__ */ t("path", {
  d: "M13 5C13 6.10457 10.5376 7 7.5 7C4.46243 7 2 6.10457 2 5M13 5C13 3.89543 10.5376 3 7.5 3C4.46243 3 2 3.89543 2 5M13 5V9.45715C11.7785 9.82398 11 10.3789 11 11M2 5V17C2 18.1046 4.46243 19 7.5 19C8.82963 19 10.0491 18.8284 11 18.5429V11M2 9C2 10.1046 4.46243 11 7.5 11C8.82963 11 10.0491 10.8284 11 10.5429M2 13C2 14.1046 4.46243 15 7.5 15C8.82963 15 10.0491 14.8284 11 14.5429M22 11C22 12.1046 19.5376 13 16.5 13C13.4624 13 11 12.1046 11 11M22 11C22 9.89543 19.5376 9 16.5 9C13.4624 9 11 9.89543 11 11M22 11V19C22 20.1046 19.5376 21 16.5 21C13.4624 21 11 20.1046 11 19V11M22 15C22 16.1046 19.5376 17 16.5 17C13.4624 17 11 16.1046 11 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kx = [
  Mx,
  Lx
];
function mx(r, e) {
  return n(), o("svg", $x, kx);
}
const kZ2 = /* @__PURE__ */ i(gx, [["render", mx]]);
var xx = {}, Hx = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vx = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -596)",
  fill: "none"
}, null, -1), Zx = /* @__PURE__ */ t("path", {
  d: "M13 5C13 6.10457 10.5376 7 7.5 7C4.46243 7 2 6.10457 2 5M13 5C13 3.89543 10.5376 3 7.5 3C4.46243 3 2 3.89543 2 5M13 5V6.5M2 5V17C2 18.1046 4.46243 19 7.5 19M7.5 11C7.33145 11 7.16468 10.9972 7 10.9918C4.19675 10.9 2 10.0433 2 9M7.5 15C4.46243 15 2 14.1046 2 13M22 11.5C22 12.6046 19.5376 13.5 16.5 13.5C13.4624 13.5 11 12.6046 11 11.5M22 11.5C22 10.3954 19.5376 9.5 16.5 9.5C13.4624 9.5 11 10.3954 11 11.5M22 11.5V19C22 20.1046 19.5376 21 16.5 21C13.4624 21 11 20.1046 11 19V11.5M22 15.25C22 16.3546 19.5376 17.25 16.5 17.25C13.4624 17.25 11 16.3546 11 15.25",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Bx = [
  Vx,
  Zx
];
function Fx(r, e) {
  return n(), o("svg", Hx, Bx);
}
const mZ2 = /* @__PURE__ */ i(xx, [["render", Fx]]);
var jx = {}, Ix = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bx = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -636)",
  fill: "none"
}, null, -1), yx = /* @__PURE__ */ t("path", {
  d: "M20 5C20 6.65685 16.4183 8 12 8C7.58172 8 4 6.65685 4 5M20 5C20 3.34315 16.4183 2 12 2C7.58172 2 4 3.34315 4 5M20 5V19C20 20.6569 16.4183 22 12 22C7.58172 22 4 20.6569 4 19V5M20 9.6666C20 11.3235 16.4183 12.6666 12 12.6666C7.58172 12.6666 4 11.3235 4 9.6666M20 14.33C20 15.9869 16.4183 17.33 12 17.33C7.58172 17.33 4 15.9869 4 14.33",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Dx = [
  bx,
  yx
];
function Px(r, e) {
  return n(), o("svg", Ix, Dx);
}
const xZ2 = /* @__PURE__ */ i(jx, [["render", Px]]);
var Ax = {}, Sx = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tx = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -676)",
  fill: "none"
}, null, -1), Ox = /* @__PURE__ */ t("path", {
  d: "M6 6L8 4M8 4L6 2M8 4H6C3.79086 4 2 5.79086 2 8M18 18L16 20M16 20L18 22M16 20H18C20.2091 20 22 18.2091 22 16M13.4172 13.4172C14.1994 13.7908 15.0753 14 16 14C19.3137 14 22 11.3137 22 8C22 4.68629 19.3137 2 16 2C12.6863 2 10 4.68629 10 8C10 8.92472 10.2092 9.80057 10.5828 10.5828M14 16C14 19.3137 11.3137 22 8 22C4.68629 22 2 19.3137 2 16C2 12.6863 4.68629 10 8 10C11.3137 10 14 12.6863 14 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ex = [
  Tx,
  Ox
];
function Rx(r, e) {
  return n(), o("svg", Sx, Ex);
}
const HZ2 = /* @__PURE__ */ i(Ax, [["render", Rx]]);
var Ux = {}, Nx = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qx = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -716)",
  fill: "none"
}, null, -1), zx = /* @__PURE__ */ t("path", {
  d: "M6 6L8 4M8 4L6 2M8 4H6C3.79086 4 2 5.79086 2 8M18 18L16 20M16 20L18 22M16 20H18C20.2091 20 22 18.2091 22 16M10.189 6.5C10.8551 3.91216 13.2042 2 16 2C19.3137 2 22 4.68629 22 8C22 10.7957 20.0879 13.1449 17.5001 13.811M14 16C14 19.3137 11.3137 22 8 22C4.68629 22 2 19.3137 2 16C2 12.6863 4.68629 10 8 10C11.3137 10 14 12.6863 14 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Kx = [
  qx,
  zx
];
function Gx(r, e) {
  return n(), o("svg", Nx, Kx);
}
const VZ2 = /* @__PURE__ */ i(Ux, [["render", Gx]]);
var Wx = {}, Yx = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xx = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), Qx = /* @__PURE__ */ t("path", {
  d: "M12 20.4722C13.0615 21.4223 14.4633 22 16 22C19.3137 22 22 19.3137 22 16C22 13.2331 20.1271 10.9036 17.5798 10.2102M6.42018 10.2102C3.87293 10.9036 2 13.2331 2 16C2 19.3137 4.68629 22 8 22C11.3137 22 14 19.3137 14 16C14 15.2195 13.851 14.4738 13.5798 13.7898M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Jx = [
  Xx,
  Qx
];
function tH(r, e) {
  return n(), o("svg", Yx, Jx);
}
const ZZ2 = /* @__PURE__ */ i(Wx, [["render", tH]]);
var eH = {}, rH = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nH = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -636)",
  fill: "none"
}, null, -1), oH = /* @__PURE__ */ t("path", {
  d: "M6.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21H6.8C7.9201 21 8.48016 21 8.90798 20.782C9.28431 20.5903 9.59027 20.2843 9.78201 19.908C10 19.4802 10 18.9201 10 17.8V6.2C10 5.0799 10 4.51984 9.78201 4.09202C9.59027 3.71569 9.28431 3.40973 8.90798 3.21799C8.48016 3 7.9201 3 6.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iH = /* @__PURE__ */ t("path", {
  d: "M17.8 3H17.2C16.0799 3 15.5198 3 15.092 3.21799C14.7157 3.40973 14.4097 3.71569 14.218 4.09202C14 4.51984 14 5.0799 14 6.2V17.8C14 18.9201 14 19.4802 14.218 19.908C14.4097 20.2843 14.7157 20.5903 15.092 20.782C15.5198 21 16.0799 21 17.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lH = [
  nH,
  oH,
  iH
];
function sH(r, e) {
  return n(), o("svg", rH, lH);
}
const BZ2 = /* @__PURE__ */ i(eH, [["render", sH]]);
var hH = {}, aH = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dH = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -676)",
  fill: "none"
}, null, -1), cH = /* @__PURE__ */ t("path", {
  d: "M12 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _H = [
  dH,
  cH
];
function CH(r, e) {
  return n(), o("svg", aH, _H);
}
const FZ2 = /* @__PURE__ */ i(hH, [["render", CH]]);
var fH = {}, vH = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uH = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -716)",
  fill: "none"
}, null, -1), wH = /* @__PURE__ */ t("path", {
  d: "M9 3V21M15 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pH = [
  uH,
  wH
];
function gH(r, e) {
  return n(), o("svg", vH, pH);
}
const jZ2 = /* @__PURE__ */ i(fH, [["render", gH]]);
var $H = {}, MH = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LH = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -916)",
  fill: "none"
}, null, -1), kH = /* @__PURE__ */ t("path", {
  d: "M9 9V6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9H9ZM9 9V15M9 9H15M9 15V18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15H9ZM9 15H15M15 15H18C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V15ZM15 15V9M15 9V6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.65685 19.6569 9 18 9H15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mH = [
  LH,
  kH
];
function xH(r, e) {
  return n(), o("svg", MH, mH);
}
const IZ2 = /* @__PURE__ */ i($H, [["render", xH]]);
var HH = {}, VH = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZH = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), BH = /* @__PURE__ */ t("path", {
  d: "M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12H20M12 22C6.47715 22 2 17.5228 2 12M12 22V20M2 12C2 6.47715 6.47715 2 12 2M2 12H4M12 2V4M19.0711 19.0711L17.6569 17.6569M6.34315 6.34315L4.92893 4.92893M17.6569 6.34315L19.0711 4.92893M4.92893 19.0711L6.34315 17.6569M8 12L10.5 10.5L12 8L13.5 10.5L16 12L13.5 13.5L12 16L10.5 13.5L8 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FH = [
  ZH,
  BH
];
function jH(r, e) {
  return n(), o("svg", VH, FH);
}
const bZ2 = /* @__PURE__ */ i(HH, [["render", jH]]);
var IH = {}, bH = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yH = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), DH = /* @__PURE__ */ t("path", {
  d: "M22 12H20M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M19.0711 19.0711L17.6569 17.6569M4 12H2M2 12C2 17.5228 6.47715 22 12 22M2 12C2 6.47715 6.47715 2 12 2M6.34315 6.34315L4.92893 4.92893M12 4V2M17.6569 6.34315L19.0711 4.92893M12 22V20M4.92893 19.0711L6.34315 17.6569M12 8L16 12L12 16L8 12L12 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PH = [
  yH,
  DH
];
function AH(r, e) {
  return n(), o("svg", bH, PH);
}
const yZ2 = /* @__PURE__ */ i(IH, [["render", AH]]);
var SH = {}, TH = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OH = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), EH = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), RH = /* @__PURE__ */ t("path", {
  d: "M14.7221 8.26596C15.2107 8.10312 15.4549 8.02169 15.6174 8.07962C15.7587 8.13003 15.87 8.24127 15.9204 8.38263C15.9783 8.54507 15.8969 8.78935 15.734 9.27789L14.2465 13.7405C14.2001 13.8797 14.1769 13.9492 14.1374 14.007C14.1024 14.0582 14.0582 14.1024 14.007 14.1374C13.9492 14.1769 13.8797 14.2001 13.7405 14.2465L9.27789 15.734C8.78935 15.8969 8.54507 15.9783 8.38263 15.9204C8.24127 15.87 8.13003 15.7587 8.07962 15.6174C8.02169 15.4549 8.10312 15.2107 8.26596 14.7221L9.75351 10.2595C9.79989 10.1203 9.82308 10.0508 9.8626 9.99299C9.8976 9.94182 9.94182 9.8976 9.99299 9.8626C10.0508 9.82308 10.1203 9.79989 10.2595 9.75351L14.7221 8.26596Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), UH = [
  OH,
  EH,
  RH
];
function NH(r, e) {
  return n(), o("svg", TH, UH);
}
const DZ2 = /* @__PURE__ */ i(SH, [["render", NH]]);
var qH = {}, zH = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, KH = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), GH = /* @__PURE__ */ t("path", {
  d: "M12 4C10.6193 4 9.5 5.11929 9.5 6.5C9.5 7.88071 10.6193 9 12 9C13.3807 9 14.5 7.88071 14.5 6.5C14.5 5.11929 13.3807 4 12 4ZM12 4V2M21 14.9375C18.8012 17.4287 15.5841 19 12 19C8.41592 19 5.19883 17.4287 3 14.9375M10.7448 8.66169L3 22M13.2552 8.66169L21 22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), WH = [
  KH,
  GH
];
function YH(r, e) {
  return n(), o("svg", zH, WH);
}
const PZ2 = /* @__PURE__ */ i(qH, [["render", YH]]);
var XH = {}, QH = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, JH = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), tV = /* @__PURE__ */ t("path", {
  d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 16.0586V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), eV = [
  JH,
  tV
];
function rV(r, e) {
  return n(), o("svg", QH, eV);
}
const AZ2 = /* @__PURE__ */ i(XH, [["render", rV]]);
var nV = {}, oV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iV = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -956)",
  fill: "none"
}, null, -1), lV = /* @__PURE__ */ t("path", {
  d: "M12 2C12.5917 2 13.1713 2.05139 13.7348 2.14994M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22M12 2V22M17.738 3.809C18.6922 4.47869 19.5241 5.31089 20.1934 6.26541M21.8501 10.2656C21.9486 10.8289 22 11.4085 22 12C22 12.5915 21.9486 13.1711 21.8501 13.7344M20.1892 17.7406C19.5203 18.693 18.6896 19.5233 17.7369 20.1917M13.7328 21.8504C13.17 21.9487 12.591 22 12 22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), sV = [
  iV,
  lV
];
function hV(r, e) {
  return n(), o("svg", oV, sV);
}
const SZ2 = /* @__PURE__ */ i(nV, [["render", hV]]);
var aV = {}, dV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cV = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -996)",
  fill: "none"
}, null, -1), _V = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), CV = /* @__PURE__ */ t("path", {
  d: "M12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5V18.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fV = [
  cV,
  _V,
  CV
];
function vV(r, e) {
  return n(), o("svg", dV, fV);
}
const TZ2 = /* @__PURE__ */ i(aV, [["render", vV]]);
var uV = {}, wV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pV = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -1036)",
  fill: "none"
}, null, -1), gV = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $V = /* @__PURE__ */ t("path", {
  d: "M16 8.5C16 12.6421 12.6421 16 8.5 16C7.88534 16 7.28795 15.9261 6.71623 15.7866C7.89585 17.4297 9.82294 18.5 12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 9.82294 17.4297 7.89585 15.7866 6.71623C15.9261 7.28795 16 7.88534 16 8.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), MV = [
  pV,
  gV,
  $V
];
function LV(r, e) {
  return n(), o("svg", wV, MV);
}
const OZ2 = /* @__PURE__ */ i(uV, [["render", LV]]);
var kV = {}, mV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xV = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1476)",
  fill: "none"
}, null, -1), HV = /* @__PURE__ */ t("path", {
  d: "M5 15C4.06812 15 3.60218 15 3.23463 14.8478C2.74458 14.6448 2.35523 14.2554 2.15224 13.7654C2 13.3978 2 12.9319 2 12V5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H12C12.9319 2 13.3978 2 13.7654 2.15224C14.2554 2.35523 14.6448 2.74458 14.8478 3.23463C15 3.60218 15 4.06812 15 5M12.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V12.2C22 11.0799 22 10.5198 21.782 10.092C21.5903 9.71569 21.2843 9.40973 20.908 9.21799C20.4802 9 19.9201 9 18.8 9H12.2C11.0799 9 10.5198 9 10.092 9.21799C9.71569 9.40973 9.40973 9.71569 9.21799 10.092C9 10.5198 9 11.0799 9 12.2V18.8C9 19.9201 9 20.4802 9.21799 20.908C9.40973 21.2843 9.71569 21.5903 10.092 21.782C10.5198 22 11.0799 22 12.2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VV = [
  xV,
  HV
];
function ZV(r, e) {
  return n(), o("svg", mV, VV);
}
const EZ2 = /* @__PURE__ */ i(kV, [["render", ZV]]);
var BV = {}, FV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jV = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1516)",
  fill: "none"
}, null, -1), IV = /* @__PURE__ */ t("path", {
  d: "M16 8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.0799 16 5.2 16H8M11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bV = [
  jV,
  IV
];
function yV(r, e) {
  return n(), o("svg", FV, bV);
}
const RZ2 = /* @__PURE__ */ i(BV, [["render", yV]]);
var DV = {}, PV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AV = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1556)",
  fill: "none"
}, null, -1), SV = /* @__PURE__ */ t("path", {
  d: "M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TV = [
  AV,
  SV
];
function OV(r, e) {
  return n(), o("svg", PV, TV);
}
const UZ2 = /* @__PURE__ */ i(DV, [["render", OV]]);
var EV = {}, RV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UV = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1596)",
  fill: "none"
}, null, -1), NV = /* @__PURE__ */ t("path", {
  d: "M16 16V18.8C16 19.9201 16 20.4802 15.782 20.908C15.5903 21.2843 15.2843 21.5903 14.908 21.782C14.4802 22 13.9201 22 12.8 22H5.2C4.0799 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V11.2C2 10.0799 2 9.51984 2.21799 9.09202C2.40973 8.71569 2.71569 8.40973 3.09202 8.21799C3.51984 8 4.0799 8 5.2 8H8M11.2 16H18.8C19.9201 16 20.4802 16 20.908 15.782C21.2843 15.5903 21.5903 15.2843 21.782 14.908C22 14.4802 22 13.9201 22 12.8V5.2C22 4.0799 22 3.51984 21.782 3.09202C21.5903 2.71569 21.2843 2.40973 20.908 2.21799C20.4802 2 19.9201 2 18.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.07989 8 5.2V12.8C8 13.9201 8 14.4802 8.21799 14.908C8.40973 15.2843 8.71569 15.5903 9.09202 15.782C9.51984 16 10.0799 16 11.2 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qV = [
  UV,
  NV
];
function zV(r, e) {
  return n(), o("svg", RV, qV);
}
const NZ2 = /* @__PURE__ */ i(EV, [["render", zV]]);
var KV = {}, GV = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WV = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1636)",
  fill: "none"
}, null, -1), YV = /* @__PURE__ */ t("path", {
  d: "M8 16V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H16M5.2 16H12.8C13.9201 16 14.4802 16 14.908 15.782C15.2843 15.5903 15.5903 15.2843 15.782 14.908C16 14.4802 16 13.9201 16 12.8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.07989 16 5.2 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XV = [
  WV,
  YV
];
function QV(r, e) {
  return n(), o("svg", GV, XV);
}
const qZ2 = /* @__PURE__ */ i(KV, [["render", QV]]);
var JV = {}, tZ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eZ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1676)",
  fill: "none"
}, null, -1), rZ = /* @__PURE__ */ t("path", {
  d: "M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nZ = [
  eZ,
  rZ
];
function oZ(r, e) {
  return n(), o("svg", tZ, nZ);
}
const zZ2 = /* @__PURE__ */ i(JV, [["render", oZ]]);
var iZ = {}, lZ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sZ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1716)",
  fill: "none"
}, null, -1), hZ = /* @__PURE__ */ t("path", {
  d: "M10.5 2.0028C9.82495 2.01194 9.4197 2.05103 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8.05103 3.4197 8.01194 3.82495 8.0028 4.5M19.5 2.0028C20.1751 2.01194 20.5803 2.05103 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C21.949 3.4197 21.9881 3.82494 21.9972 4.49999M21.9972 13.5C21.9881 14.175 21.949 14.5803 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.5803 15.949 20.1751 15.9881 19.5 15.9972M22 7.99999V9.99999M14.0001 2H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aZ = [
  sZ,
  hZ
];
function dZ(r, e) {
  return n(), o("svg", lZ, aZ);
}
const KZ2 = /* @__PURE__ */ i(iZ, [["render", dZ]]);
var cZ = {}, _Z = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CZ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -676)",
  fill: "none"
}, null, -1), fZ = /* @__PURE__ */ t("path", {
  d: "M20 4V5.4C20 8.76031 20 10.4405 19.346 11.7239C18.7708 12.8529 17.8529 13.7708 16.7239 14.346C15.4405 15 13.7603 15 10.4 15H4M4 15L9 10M4 15L9 20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vZ = [
  CZ,
  fZ
];
function uZ(r, e) {
  return n(), o("svg", _Z, vZ);
}
const GZ2 = /* @__PURE__ */ i(cZ, [["render", uZ]]);
var wZ = {}, pZ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gZ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -716)",
  fill: "none"
}, null, -1), $Z = /* @__PURE__ */ t("path", {
  d: "M4 4V5.4C4 8.76031 4 10.4405 4.65396 11.7239C5.2292 12.8529 6.14708 13.7708 7.27606 14.346C8.55953 15 10.2397 15 13.6 15H20M20 15L15 10M20 15L15 20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), MZ = [
  gZ,
  $Z
];
function LZ(r, e) {
  return n(), o("svg", pZ, MZ);
}
const WZ2 = /* @__PURE__ */ i(wZ, [["render", LZ]]);
var kZ = {}, mZ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xZ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -756)",
  fill: "none"
}, null, -1), HZ = /* @__PURE__ */ t("path", {
  d: "M21 4H17.6C14.2397 4 12.5595 4 11.2761 4.65396C10.1471 5.2292 9.2292 6.14708 8.65396 7.27606C8 8.55953 8 10.2397 8 13.6V20M8 20L13 15M8 20L3 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VZ = [
  xZ,
  HZ
];
function ZZ(r, e) {
  return n(), o("svg", mZ, VZ);
}
const YZ2 = /* @__PURE__ */ i(kZ, [["render", ZZ]]);
var BZ = {}, FZ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jZ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -796)",
  fill: "none"
}, null, -1), IZ = /* @__PURE__ */ t("path", {
  d: "M21 20H17.6C14.2397 20 12.5595 20 11.2761 19.346C10.1471 18.7708 9.2292 17.8529 8.65396 16.7239C8 15.4405 8 13.7603 8 10.4V4M8 4L13 9M8 4L3 9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bZ = [
  jZ,
  IZ
];
function yZ(r, e) {
  return n(), o("svg", FZ, bZ);
}
const XZ2 = /* @__PURE__ */ i(BZ, [["render", yZ]]);
var DZ = {}, PZ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AZ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -836)",
  fill: "none"
}, null, -1), SZ = /* @__PURE__ */ t("path", {
  d: "M3 4H6.4C9.76031 4 11.4405 4 12.7239 4.65396C13.8529 5.2292 14.7708 6.14708 15.346 7.27606C16 8.55953 16 10.2397 16 13.6L16 20M16 20L11 15M16 20L21 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TZ = [
  AZ,
  SZ
];
function OZ(r, e) {
  return n(), o("svg", PZ, TZ);
}
const QZ2 = /* @__PURE__ */ i(DZ, [["render", OZ]]);
var EZ = {}, RZ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UZ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -876)",
  fill: "none"
}, null, -1), NZ = /* @__PURE__ */ t("path", {
  d: "M3 20H6.4C9.76031 20 11.4405 20 12.7239 19.346C13.8529 18.7708 14.7708 17.8529 15.346 16.7239C16 15.4405 16 13.7603 16 10.4L16 4M16 4L11 9M16 4L21 9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qZ = [
  UZ,
  NZ
];
function zZ(r, e) {
  return n(), o("svg", RZ, qZ);
}
const JZ2 = /* @__PURE__ */ i(EZ, [["render", zZ]]);
var KZ = {}, GZ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WZ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -916)",
  fill: "none"
}, null, -1), YZ = /* @__PURE__ */ t("path", {
  d: "M9 14L4 9M4 9L9 4M4 9H10.4C13.7603 9 15.4405 9 16.7239 9.65396C17.8529 10.2292 18.7708 11.1471 19.346 12.2761C20 13.5595 20 15.2397 20 18.6V20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XZ = [
  WZ,
  YZ
];
function QZ(r, e) {
  return n(), o("svg", GZ, XZ);
}
const tB2 = /* @__PURE__ */ i(KZ, [["render", QZ]]);
var JZ = {}, tB = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eB = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -956)",
  fill: "none"
}, null, -1), rB = /* @__PURE__ */ t("path", {
  d: "M4 20V18.6C4 15.2397 4 13.5595 4.65396 12.2761C5.2292 11.1471 6.14708 10.2292 7.27606 9.65396C8.55953 9 10.2397 9 13.6 9H20M20 9L15 14M20 9L15 4",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nB = [
  eB,
  rB
];
function oB(r, e) {
  return n(), o("svg", tB, nB);
}
const eB2 = /* @__PURE__ */ i(JZ, [["render", oB]]);
var iB = {}, lB = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sB = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), hB = /* @__PURE__ */ t("path", {
  d: "M9 2V4M15 2V4M9 20V22M15 20V22M20 9H22M20 14H22M2 9H4M2 14H4M8.8 20H15.2C16.8802 20 17.7202 20 18.362 19.673C18.9265 19.3854 19.3854 18.9265 19.673 18.362C20 17.7202 20 16.8802 20 15.2V8.8C20 7.11984 20 6.27976 19.673 5.63803C19.3854 5.07354 18.9265 4.6146 18.362 4.32698C17.7202 4 16.8802 4 15.2 4H8.8C7.11984 4 6.27976 4 5.63803 4.32698C5.07354 4.6146 4.6146 5.07354 4.32698 5.63803C4 6.27976 4 7.11984 4 8.8V15.2C4 16.8802 4 17.7202 4.32698 18.362C4.6146 18.9265 5.07354 19.3854 5.63803 19.673C6.27976 20 7.11984 20 8.8 20ZM10.6 15H13.4C13.9601 15 14.2401 15 14.454 14.891C14.6422 14.7951 14.7951 14.6422 14.891 14.454C15 14.2401 15 13.9601 15 13.4V10.6C15 10.0399 15 9.75992 14.891 9.54601C14.7951 9.35785 14.6422 9.20487 14.454 9.10899C14.2401 9 13.9601 9 13.4 9H10.6C10.0399 9 9.75992 9 9.54601 9.10899C9.35785 9.20487 9.20487 9.35785 9.10899 9.54601C9 9.75992 9 10.0399 9 10.6V13.4C9 13.9601 9 14.2401 9.10899 14.454C9.20487 14.6422 9.35785 14.7951 9.54601 14.891C9.75992 15 10.0399 15 10.6 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aB = [
  sB,
  hB
];
function dB(r, e) {
  return n(), o("svg", lB, aB);
}
const rB2 = /* @__PURE__ */ i(iB, [["render", dB]]);
var cB = {}, _B = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CB = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), fB = /* @__PURE__ */ t("path", {
  d: "M9 2V5M15 2V5M9 19V22M15 19V22M19 9H22M19 14H22M2 9H5M2 14H5M9.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V9.8C19 8.11984 19 7.27976 18.673 6.63803C18.3854 6.07354 17.9265 5.6146 17.362 5.32698C16.7202 5 15.8802 5 14.2 5H9.8C8.11984 5 7.27976 5 6.63803 5.32698C6.07354 5.6146 5.6146 6.07354 5.32698 6.63803C5 7.27976 5 8.11984 5 9.8V14.2C5 15.8802 5 16.7202 5.32698 17.362C5.6146 17.9265 6.07354 18.3854 6.63803 18.673C7.27976 19 8.11984 19 9.8 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vB = [
  CB,
  fB
];
function uB(r, e) {
  return n(), o("svg", _B, vB);
}
const nB2 = /* @__PURE__ */ i(cB, [["render", uB]]);
var wB = {}, pB = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gB = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -756)",
  fill: "none"
}, null, -1), $B = /* @__PURE__ */ t("path", {
  d: "M22 10H2M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), MB = [
  gB,
  $B
];
function LB(r, e) {
  return n(), o("svg", pB, MB);
}
const oB2 = /* @__PURE__ */ i(wB, [["render", LB]]);
var kB = {}, mB = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xB = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -796)",
  fill: "none"
}, null, -1), HB = /* @__PURE__ */ t("path", {
  d: "M22 10H2M11 14H6M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VB = [
  xB,
  HB
];
function ZB(r, e) {
  return n(), o("svg", mB, VB);
}
const iB2 = /* @__PURE__ */ i(kB, [["render", ZB]]);
var BB = {}, FB = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jB = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -836)",
  fill: "none"
}, null, -1), IB = /* @__PURE__ */ t("path", {
  d: "M16 18L18 20L22 16M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bB = [
  jB,
  IB
];
function yB(r, e) {
  return n(), o("svg", FB, bB);
}
const lB2 = /* @__PURE__ */ i(BB, [["render", yB]]);
var DB = {}, PB = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AB = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -876)",
  fill: "none"
}, null, -1), SB = /* @__PURE__ */ t("path", {
  d: "M16 18L19 21M19 21L22 18M19 21V15M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TB = [
  AB,
  SB
];
function OB(r, e) {
  return n(), o("svg", PB, TB);
}
const sB2 = /* @__PURE__ */ i(DB, [["render", OB]]);
var EB = {}, RB = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UB = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-64 -916)",
  fill: "none"
}, null, -1), NB = /* @__PURE__ */ t("path", {
  d: "M9 17L12 20M12 20L15 17M12 20V13M22 9H2M5.5 18H5.2C4.0799 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.7157 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40974 21.5903 4.7157 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V14.8C22 15.9201 22 16.4802 21.782 16.908C21.5903 17.2843 21.2843 17.5903 20.908 17.782C20.4802 18 19.9201 18 18.8 18H18.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qB = [
  UB,
  NB
];
function zB(r, e) {
  return n(), o("svg", RB, qB);
}
const hB2 = /* @__PURE__ */ i(EB, [["render", zB]]);
var KB = {}, GB = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WB = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), YB = /* @__PURE__ */ t("path", {
  d: "M2 10H22V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H11M14.5 21L16.525 20.595C16.7015 20.5597 16.7898 20.542 16.8721 20.5097C16.9452 20.4811 17.0147 20.4439 17.079 20.399C17.1516 20.3484 17.2152 20.2848 17.3426 20.1574L21.5 16C22.0523 15.4477 22.0523 14.5523 21.5 14C20.9477 13.4477 20.0523 13.4477 19.5 14L15.3426 18.1574C15.2152 18.2848 15.1516 18.3484 15.101 18.421C15.0561 18.4853 15.0189 18.5548 14.9903 18.6279C14.958 18.7102 14.9403 18.7985 14.905 18.975L14.5 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XB = [
  WB,
  YB
];
function QB(r, e) {
  return n(), o("svg", GB, XB);
}
const aB2 = /* @__PURE__ */ i(KB, [["render", QB]]);
var JB = {}, tF = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eF = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), rF = /* @__PURE__ */ t("path", {
  d: "M20.25 17.5V15.75C20.25 14.7835 19.4665 14 18.5 14C17.5335 14 16.75 14.7835 16.75 15.75V17.5M22 10H2M22 11V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H11M16.6 21.5H20.4C20.9601 21.5 21.2401 21.5 21.454 21.391C21.6422 21.2951 21.7951 21.1422 21.891 20.954C22 20.7401 22 20.4601 22 19.9V19.1C22 18.5399 22 18.2599 21.891 18.046C21.7951 17.8578 21.6422 17.7049 21.454 17.609C21.2401 17.5 20.9601 17.5 20.4 17.5H16.6C16.0399 17.5 15.7599 17.5 15.546 17.609C15.3578 17.7049 15.2049 17.8578 15.109 18.046C15 18.2599 15 18.5399 15 19.1V19.9C15 20.4601 15 20.7401 15.109 20.954C15.2049 21.1422 15.3578 21.2951 15.546 21.391C15.7599 21.5 16.0399 21.5 16.6 21.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nF = [
  eF,
  rF
];
function oF(r, e) {
  return n(), o("svg", tF, nF);
}
const dB2 = /* @__PURE__ */ i(JB, [["render", oF]]);
var iF = {}, lF = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sF = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), hF = /* @__PURE__ */ t("path", {
  d: "M16 18H22M22 10H2M22 13.5V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aF = [
  sF,
  hF
];
function dF(r, e) {
  return n(), o("svg", lF, aF);
}
const cB2 = /* @__PURE__ */ i(iF, [["render", dF]]);
var cF = {}, _F = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CF = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), fF = /* @__PURE__ */ t("path", {
  d: "M19 21V15M16 18H22M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vF = [
  CF,
  fF
];
function uF(r, e) {
  return n(), o("svg", _F, vF);
}
const _B2 = /* @__PURE__ */ i(cF, [["render", uF]]);
var wF = {}, pF = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gF = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), $F = /* @__PURE__ */ t("path", {
  d: "M22 10H2M11 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H17M11 19L13 21M11 19L13 17M7 19H5.2C4.07989 19 3.51984 19 3.09202 18.782C2.71569 18.5903 2.40973 18.2843 2.21799 17.908C2 17.4802 2 16.9201 2 15.8V8.2C2 7.0799 2 6.51984 2.21799 6.09202C2.40973 5.71569 2.7157 5.40973 3.09202 5.21799C3.51984 5 4.0799 5 5.2 5H13M13 5L11 7M13 5L11 3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), MF = [
  gF,
  $F
];
function LF(r, e) {
  return n(), o("svg", pF, MF);
}
const CB2 = /* @__PURE__ */ i(wF, [["render", LF]]);
var kF = {}, mF = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xF = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), HF = /* @__PURE__ */ t("path", {
  d: "M22 22L20.5 20.5M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H10.5M21.5 18C21.5 19.933 19.933 21.5 18 21.5C16.067 21.5 14.5 19.933 14.5 18C14.5 16.067 16.067 14.5 18 14.5C19.933 14.5 21.5 16.067 21.5 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VF = [
  xF,
  HF
];
function ZF(r, e) {
  return n(), o("svg", mF, VF);
}
const fB2 = /* @__PURE__ */ i(kF, [["render", ZF]]);
var BF = {}, FF = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jF = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), IF = /* @__PURE__ */ t("path", {
  d: "M22 10H2M22 11V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19H11.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bF = [
  jF,
  IF
];
function yF(r, e) {
  return n(), o("svg", FF, bF);
}
const vB2 = /* @__PURE__ */ i(BF, [["render", yF]]);
var DF = {}, PF = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AF = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), SF = /* @__PURE__ */ t("path", {
  d: "M16 18L19 15M19 15L22 18M19 15V21M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TF = [
  AF,
  SF
];
function OF(r, e) {
  return n(), o("svg", PF, TF);
}
const uB2 = /* @__PURE__ */ i(DF, [["render", OF]]);
var EF = {}, RF = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UF = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), NF = /* @__PURE__ */ t("path", {
  d: "M9 16L12 13M12 13L15 16M12 13V20M22 9H2M5.5 18H5.2C4.0799 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.7157 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40974 21.5903 4.7157 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V14.8C22 15.9201 22 16.4802 21.782 16.908C21.5903 17.2843 21.2843 17.5903 20.908 17.782C20.4802 18 19.9201 18 18.8 18H18.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qF = [
  UF,
  NF
];
function zF(r, e) {
  return n(), o("svg", RF, qF);
}
const wB2 = /* @__PURE__ */ i(EF, [["render", zF]]);
var KF = {}, GF = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WF = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), YF = /* @__PURE__ */ t("path", {
  d: "M16.5 16L21.5 21M21.5 16L16.5 21M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XF = [
  WF,
  YF
];
function QF(r, e) {
  return n(), o("svg", GF, XF);
}
const pB2 = /* @__PURE__ */ i(KF, [["render", QF]]);
var JF = {}, tj = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ej = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -1076)",
  fill: "none"
}, null, -1), rj = /* @__PURE__ */ t("path", {
  d: "M2 6H14.8C15.9201 6 16.4802 6 16.908 6.21799C17.2843 6.40973 17.5903 6.71569 17.782 7.09202C18 7.51984 18 8.07989 18 9.2V22M22 18L9.2 18C8.07989 18 7.51984 18 7.09202 17.782C6.71569 17.5903 6.40973 17.2843 6.21799 16.908C6 16.4802 6 15.9201 6 14.8V2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nj = [
  ej,
  rj
];
function oj(r, e) {
  return n(), o("svg", tj, nj);
}
const gB2 = /* @__PURE__ */ i(JF, [["render", oj]]);
var ij = {}, lj = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sj = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -1116)",
  fill: "none"
}, null, -1), hj = /* @__PURE__ */ t("path", {
  d: "M10 6H14.8C15.9201 6 16.4802 6 16.908 6.21799C17.2843 6.40973 17.5903 6.71569 17.782 7.09202C18 7.51984 18 8.07989 18 9.2V14M2 6H6M18 18V22M22 18L9.2 18C8.07989 18 7.51984 18 7.09202 17.782C6.71569 17.5903 6.40973 17.2843 6.21799 16.908C6 16.4802 6 15.9201 6 14.8V2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aj = [
  sj,
  hj
];
function dj(r, e) {
  return n(), o("svg", lj, aj);
}
const $B2 = /* @__PURE__ */ i(ij, [["render", dj]]);
var cj = {}, _j = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cj = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), fj = /* @__PURE__ */ t("path", {
  d: "M17.8779 20.0899C16.1694 21.3312 14.1118 21.9998 12 21.9998C9.88821 21.9998 7.83063 21.3312 6.12215 20.0899M16.3837 3.01182C18.2818 3.93756 19.8381 5.44044 20.8295 7.30504C21.8209 9.16964 22.1966 11.3002 21.9027 13.3915M2.09742 13.3914C1.80352 11.3002 2.1792 9.16955 3.17063 7.30494C4.16205 5.44034 5.71832 3.93747 7.61639 3.01172M17.5 11.9998C17.5 15.0373 15.0376 17.4998 12 17.4998C8.96244 17.4998 6.50001 15.0373 6.50001 11.9998C6.50001 8.96219 8.96244 6.49976 12 6.49976C15.0376 6.49976 17.5 8.96219 17.5 11.9998Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vj = [
  Cj,
  fj
];
function uj(r, e) {
  return n(), o("svg", _j, vj);
}
const MB2 = /* @__PURE__ */ i(cj, [["render", uj]]);
var wj = {}, pj = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gj = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), $j = /* @__PURE__ */ t("path", {
  d: "M17.8779 20.0899C16.1694 21.3312 14.1118 21.9998 12 21.9998C9.88821 21.9998 7.83063 21.3312 6.12215 20.0899M16.3837 3.01182C18.2818 3.93756 19.8381 5.44044 20.8295 7.30504C21.8209 9.16964 22.1966 11.3002 21.9027 13.3915M2.09742 13.3914C1.80352 11.3002 2.1792 9.16955 3.17063 7.30494C4.16205 5.44034 5.71832 3.93747 7.61639 3.01172M11.4343 6.56544L6.56569 11.4341C6.36768 11.6321 6.26868 11.7311 6.23158 11.8452C6.19895 11.9457 6.19895 12.0538 6.23158 12.1543C6.26868 12.2684 6.36768 12.3674 6.56569 12.5654L11.4343 17.4341C11.6323 17.6321 11.7313 17.7311 11.8455 17.7682C11.9459 17.8008 12.0541 17.8008 12.1545 17.7682C12.2687 17.7311 12.3677 17.6321 12.5657 17.4341L17.4343 12.5654C17.6323 12.3674 17.7313 12.2684 17.7684 12.1543C17.8011 12.0538 17.8011 11.9457 17.7684 11.8452C17.7313 11.7311 17.6323 11.6321 17.4343 11.4341L12.5657 6.56544C12.3677 6.36743 12.2687 6.26843 12.1545 6.23134C12.0541 6.19871 11.9459 6.19871 11.8455 6.23134C11.7313 6.26843 11.6323 6.36743 11.4343 6.56544Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Mj = [
  gj,
  $j
];
function Lj(r, e) {
  return n(), o("svg", pj, Mj);
}
const LB2 = /* @__PURE__ */ i(wj, [["render", Lj]]);
var kj = {}, mj = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xj = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -636)",
  fill: "none"
}, null, -1), Hj = /* @__PURE__ */ t("path", {
  d: "M2 2L4 4M22 2L20 4M22 22L20 20M2 22L4 20M2 16H3.5M8 2V3.5M22 8H20.5M16 22V20.5M18 16H21.5M16 2V6M2 8H6M8 22V18M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Vj = [
  xj,
  Hj
];
function Zj(r, e) {
  return n(), o("svg", mj, Vj);
}
const kB2 = /* @__PURE__ */ i(kj, [["render", Zj]]);
var Bj = {}, Fj = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jj = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -676)",
  fill: "none"
}, null, -1), Ij = /* @__PURE__ */ t("path", {
  d: "M2 2L4 4M22 2L20 4M22 22L20 20M2 22L4 20M2 16H3.5M8 2V3.5M22 8H20.5M16 22V20.5M18 16H21.5M16 2V6M2 8H6M8 22V18M11.4343 7.56569L7.56569 11.4343C7.36768 11.6323 7.26867 11.7313 7.23158 11.8455C7.19895 11.9459 7.19895 12.0541 7.23158 12.1545C7.26867 12.2687 7.36768 12.3677 7.56569 12.5657L11.4343 16.4343C11.6323 16.6323 11.7313 16.7313 11.8455 16.7684C11.9459 16.8011 12.0541 16.8011 12.1545 16.7684C12.2687 16.7313 12.3677 16.6323 12.5657 16.4343L16.4343 12.5657C16.6323 12.3677 16.7313 12.2687 16.7684 12.1545C16.8011 12.0541 16.8011 11.9459 16.7684 11.8455C16.7313 11.7313 16.6323 11.6323 16.4343 11.4343L12.5657 7.56569C12.3677 7.36768 12.2687 7.26867 12.1545 7.23158C12.0541 7.19895 11.9459 7.19895 11.8455 7.23158C11.7313 7.26867 11.6323 7.36768 11.4343 7.56569Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bj = [
  jj,
  Ij
];
function yj(r, e) {
  return n(), o("svg", Fj, bj);
}
const mB2 = /* @__PURE__ */ i(Bj, [["render", yj]]);
var Dj = {}, Pj = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Aj = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), Sj = /* @__PURE__ */ t("path", {
  d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 16.0586V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Tj = [
  Aj,
  Sj
];
function Oj(r, e) {
  return n(), o("svg", Pj, Tj);
}
const xB2 = /* @__PURE__ */ i(Dj, [["render", Oj]]);
var Ej = {}, Rj = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uj = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), Nj = /* @__PURE__ */ t("path", {
  d: "M12 2.50008V12.0001M12 12.0001L20.5 7.27779M12 12.0001L3.5 7.27779M12 12.0001V21.5001M20.5 16.7223L12.777 12.4318C12.4934 12.2742 12.3516 12.1954 12.2015 12.1645C12.0685 12.1372 11.9315 12.1372 11.7986 12.1645C11.6484 12.1954 11.5066 12.2742 11.223 12.4318L3.5 16.7223M21 16.0586V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qj = [
  Uj,
  Nj
];
function zj(r, e) {
  return n(), o("svg", Rj, qj);
}
const HB2 = /* @__PURE__ */ i(Ej, [["render", zj]]);
var Kj = {}, Gj = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wj = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), Yj = /* @__PURE__ */ t("path", {
  d: "M3.5 8H16M16 8V20.5M16 8L20.5 3.5M21 15.3373V3.8C21 3.51997 21 3.37996 20.9455 3.273C20.8976 3.17892 20.8211 3.10243 20.727 3.0545C20.62 3 20.48 3 20.2 3H8.66274C8.41815 3 8.29586 3 8.18077 3.02763C8.07873 3.05213 7.98119 3.09253 7.89172 3.14736C7.7908 3.2092 7.70432 3.29568 7.53137 3.46863L3.46863 7.53137C3.29568 7.70432 3.2092 7.7908 3.14736 7.89172C3.09253 7.98119 3.05213 8.07873 3.02763 8.18077C3 8.29586 3 8.41815 3 8.66274V20.2C3 20.48 3 20.62 3.0545 20.727C3.10243 20.8211 3.17892 20.8976 3.273 20.9455C3.37996 21 3.51997 21 3.8 21H15.3373C15.5818 21 15.7041 21 15.8192 20.9724C15.9213 20.9479 16.0188 20.9075 16.1083 20.8526C16.2092 20.7908 16.2957 20.7043 16.4686 20.5314L20.5314 16.4686C20.7043 16.2957 20.7908 16.2092 20.8526 16.1083C20.9075 16.0188 20.9479 15.9213 20.9724 15.8192C21 15.7041 21 15.5818 21 15.3373Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Xj = [
  Wj,
  Yj
];
function Qj(r, e) {
  return n(), o("svg", Gj, Xj);
}
const VB2 = /* @__PURE__ */ i(Kj, [["render", Qj]]);
var Jj = {}, tI = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eI = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), rI = /* @__PURE__ */ t("path", {
  d: "M20.5 16H8M8 16V3.5M8 16L3.5 20.5M3.5 8H16M16 8V20.5M16 8L20.5 3.5M21 15.3373V3.8C21 3.51997 21 3.37996 20.9455 3.273C20.8976 3.17892 20.8211 3.10243 20.727 3.0545C20.62 3 20.48 3 20.2 3H8.66274C8.41815 3 8.29586 3 8.18077 3.02763C8.07873 3.05213 7.98119 3.09253 7.89172 3.14736C7.7908 3.2092 7.70432 3.29568 7.53137 3.46863L3.46863 7.53137C3.29568 7.70432 3.2092 7.7908 3.14736 7.89172C3.09253 7.98119 3.05213 8.07873 3.02763 8.18077C3 8.29586 3 8.41815 3 8.66274V20.2C3 20.48 3 20.62 3.0545 20.727C3.10243 20.8211 3.17892 20.8976 3.273 20.9455C3.37996 21 3.51997 21 3.8 21H15.3373C15.5818 21 15.7041 21 15.8192 20.9724C15.9213 20.9479 16.0188 20.9075 16.1083 20.8526C16.2092 20.7908 16.2957 20.7043 16.4686 20.5314L20.5314 16.4686C20.7043 16.2957 20.7908 16.2092 20.8526 16.1083C20.9075 16.0188 20.9479 15.9213 20.9724 15.8192C21 15.7041 21 15.5818 21 15.3373Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nI = [
  eI,
  rI
];
function oI(r, e) {
  return n(), o("svg", tI, nI);
}
const ZB2 = /* @__PURE__ */ i(Jj, [["render", oI]]);
var iI = {}, lI = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sI = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), hI = /* @__PURE__ */ t("path", {
  d: "M9.75 20.7501L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L14.25 20.7501M5.25 18.2501L3.82297 17.4573C3.52346 17.2909 3.37368 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V14.5001M3 9.50009V7.94153C3 7.59889 3 7.42757 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37368 6.79248 3.52345 6.70928 3.82297 6.54288L5.25 5.75009M9.75 3.25008L11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7986 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L14.25 3.25008M18.75 5.75008L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42757 21 7.59889 21 7.94153V9.50008M21 14.5001V16.0586C21 16.4013 21 16.5726 20.9495 16.7254C20.9049 16.8606 20.8318 16.9847 20.7354 17.0893C20.6263 17.2077 20.4766 17.2909 20.177 17.4573L18.75 18.2501M9.75 10.7501L12 12.0001M12 12.0001L14.25 10.7501M12 12.0001V14.5001M3 7.00008L5.25 8.25008M18.75 8.25008L21 7.00008M12 19.5001V22.0001",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aI = [
  sI,
  hI
];
function dI(r, e) {
  return n(), o("svg", lI, aI);
}
const BB2 = /* @__PURE__ */ i(iI, [["render", dI]]);
var cI = {}, _I = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CI = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -756)",
  fill: "none"
}, null, -1), fI = /* @__PURE__ */ t("path", {
  d: "M9.5 7.5H13.75C14.9926 7.5 16 8.50736 16 9.75C16 10.9926 14.9926 12 13.75 12H9.5H14.25C15.4926 12 16.5 13.0074 16.5 14.25C16.5 15.4926 15.4926 16.5 14.25 16.5H9.5M9.5 7.5H8M9.5 7.5V16.5M9.5 16.5H8M10 6V7.5M10 16.5V18M13 6V7.5M13 16.5V18M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vI = [
  CI,
  fI
];
function uI(r, e) {
  return n(), o("svg", _I, vI);
}
const FB2 = /* @__PURE__ */ i(cI, [["render", uI]]);
var wI = {}, pI = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gI = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -716)",
  fill: "none"
}, null, -1), $I = /* @__PURE__ */ t("path", {
  d: "M9.5 2V4M9.5 20V22M13.5 2V4M13.5 20V22M7.5 4H14C16.2091 4 18 5.79086 18 8C18 10.2091 16.2091 12 14 12H7.5H15C17.2091 12 19 13.7909 19 16C19 18.2091 17.2091 20 15 20H7.5M7.5 4H5.5M7.5 4V20M7.5 20H5.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), MI = [
  gI,
  $I
];
function LI(r, e) {
  return n(), o("svg", pI, MI);
}
const jB2 = /* @__PURE__ */ i(wI, [["render", LI]]);
var kI = {}, mI = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xI = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -836)",
  fill: "none"
}, null, -1), HI = /* @__PURE__ */ t("path", {
  d: "M8.5 14.6667C8.5 15.9553 9.54467 17 10.8333 17H13C14.3807 17 15.5 15.8807 15.5 14.5C15.5 13.1193 14.3807 12 13 12H11C9.61929 12 8.5 10.8807 8.5 9.5C8.5 8.11929 9.61929 7 11 7H13.1667C14.4553 7 15.5 8.04467 15.5 9.33333M12 5.5V7M12 17V18.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VI = [
  xI,
  HI
];
function ZI(r, e) {
  return n(), o("svg", mI, VI);
}
const IB2 = /* @__PURE__ */ i(kI, [["render", ZI]]);
var BI = {}, FI = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jI = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -796)",
  fill: "none"
}, null, -1), II = /* @__PURE__ */ t("path", {
  d: "M6 16C6 18.2091 7.79086 20 10 20H14C16.2091 20 18 18.2091 18 16C18 13.7909 16.2091 12 14 12H10C7.79086 12 6 10.2091 6 8C6 5.79086 7.79086 4 10 4H14C16.2091 4 18 5.79086 18 8M12 2V22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bI = [
  jI,
  II
];
function yI(r, e) {
  return n(), o("svg", FI, bI);
}
const bB2 = /* @__PURE__ */ i(BI, [["render", yI]]);
var DI = {}, PI = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AI = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -916)",
  fill: "none"
}, null, -1), SI = /* @__PURE__ */ t("path", {
  d: "M6.5 15.5L12.0002 18L17.5 15.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6.5 11.5L12.0002 14L17.5 11.5L12.0002 5L6.5 11.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TI = [
  AI,
  SI
];
function OI(r, e) {
  return n(), o("svg", PI, TI);
}
const yB2 = /* @__PURE__ */ i(DI, [["render", OI]]);
var EI = {}, RI = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UI = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-336 -876)",
  fill: "none"
}, null, -1), NI = /* @__PURE__ */ t("path", {
  d: "M4 11.0001L12 13L20 11M4 11.0001L12 2M4 11.0001L12 9.00008M20 11L12 2M20 11L12 9.00008M12 2V9.00008M5.5 15L12.0001 22L18.5 15L12 16.5L5.5 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qI = [
  UI,
  NI
];
function zI(r, e) {
  return n(), o("svg", RI, qI);
}
const DB2 = /* @__PURE__ */ i(EI, [["render", zI]]);
var KI = {}, GI = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WI = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), YI = /* @__PURE__ */ t("path", {
  d: "M15.3333 8.27316C14.4487 7.48142 13.2806 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C13.2806 17 14.4487 16.5186 15.3333 15.7268M6 13.5H11M6 10.5H11M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XI = [
  WI,
  YI
];
function QI(r, e) {
  return n(), o("svg", GI, XI);
}
const PB2 = /* @__PURE__ */ i(KI, [["render", QI]]);
var JI = {}, tb = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eb = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), rb = /* @__PURE__ */ t("path", {
  d: "M19 5.51903C17.5176 4.25973 15.5975 3.5 13.5 3.5C8.80558 3.5 5 7.30558 5 12C5 16.6944 8.80558 20.5 13.5 20.5C15.5975 20.5 17.5176 19.7403 19 18.481M3 14H13M3 10H13",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nb = [
  eb,
  rb
];
function ob(r, e) {
  return n(), o("svg", tb, nb);
}
const AB2 = /* @__PURE__ */ i(JI, [["render", ob]]);
var ib = {}, lb = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sb = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), hb = /* @__PURE__ */ t("path", {
  d: "M15 17.5H9C9 17.5 11 15.2444 11 12.5C11 11 9.91479 10.4867 9.89534 8.96204C9.8966 5.94404 13.5297 6.1045 14.7926 7.30402M9 12.5H14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ab = [
  sb,
  hb
];
function db(r, e) {
  return n(), o("svg", lb, ab);
}
const SB2 = /* @__PURE__ */ i(ib, [["render", db]]);
var cb = {}, _b = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cb = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), fb = /* @__PURE__ */ t("path", {
  d: "M17.5 20.5H6.5C6.5 20.5 10 17.7413 10 13.5C10 10.6725 7.91376 9.66123 7.8837 7.30497C7.88566 2.64078 13.5005 2.88877 15.4521 4.74258M6.5 13.5H15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vb = [
  Cb,
  fb
];
function ub(r, e) {
  return n(), o("svg", _b, vb);
}
const TB2 = /* @__PURE__ */ i(cb, [["render", ub]]);
var wb = {}, pb = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gb = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), $b = /* @__PURE__ */ t("path", {
  d: "M9.5 6.5H14C15.3807 6.5 16.5 7.61929 16.5 9C16.5 10.3807 15.3807 11.5 14 11.5H9.5V6.5ZM9.5 6.5V17.5M9.75 11.5H8M13 14.75H8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Mb = [
  gb,
  $b
];
function Lb(r, e) {
  return n(), o("svg", pb, Mb);
}
const OB2 = /* @__PURE__ */ i(wb, [["render", Lb]]);
var kb = {}, mb = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xb = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), Hb = /* @__PURE__ */ t("path", {
  d: "M8.5 11.5H14.5C16.7091 11.5 18.5 9.70914 18.5 7.5C18.5 5.29086 16.7091 3.5 14.5 3.5H8.5V11.5ZM8.5 11.5H6.5M13.5 15.5H6.5M8.5 4V20.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Vb = [
  xb,
  Hb
];
function Zb(r, e) {
  return n(), o("svg", mb, Vb);
}
const EB2 = /* @__PURE__ */ i(kb, [["render", Zb]]);
var Bb = {}, Fb = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jb = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), Ib = /* @__PURE__ */ t("path", {
  d: "M8.5 9.99984H15.5M8.5 6.5H15.5M14 18.0002L8.5 13.5002L10 13.5C14.4447 13.5 14.4447 6.5 10 6.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bb = [
  jb,
  Ib
];
function yb(r, e) {
  return n(), o("svg", Fb, bb);
}
const RB2 = /* @__PURE__ */ i(Bb, [["render", yb]]);
var Db = {}, Pb = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ab = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), Sb = /* @__PURE__ */ t("path", {
  d: "M6 3H18M6 8H18M14.5 21L6 13H9C15.667 13 15.667 3 9 3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Tb = [
  Ab,
  Sb
];
function Ob(r, e) {
  return n(), o("svg", Pb, Tb);
}
const UB2 = /* @__PURE__ */ i(Db, [["render", Ob]]);
var Eb = {}, Rb = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ub = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), Nb = /* @__PURE__ */ t("path", {
  d: "M12 18V12M12 12L16 7M12 12L8 7M16 12H8M15.5 15H8.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qb = [
  Ub,
  Nb
];
function zb(r, e) {
  return n(), o("svg", Rb, qb);
}
const NB2 = /* @__PURE__ */ i(Eb, [["render", zb]]);
var Kb = {}, Gb = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wb = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), Yb = /* @__PURE__ */ t("path", {
  d: "M12 20.5V11.5M12 11.5L18.5001 3.5M12 11.5L5.50012 3.5M18 11.5H5.99998M17 15.5H6.99998",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Xb = [
  Wb,
  Yb
];
function Qb(r, e) {
  return n(), o("svg", Gb, Xb);
}
const qB2 = /* @__PURE__ */ i(Kb, [["render", Qb]]);
var Jb = {}, ty = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ey = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-64 -1156)",
  fill: "none"
}, null, -1), ry = /* @__PURE__ */ t("path", {
  d: "M12.9999 12.9999L18.9999 18.9999M17.964 10.7512L12.9533 12.4531C12.8163 12.4996 12.7478 12.5229 12.6908 12.562C12.6404 12.5967 12.5967 12.6404 12.562 12.6908C12.5229 12.7478 12.4996 12.8163 12.4531 12.9533L10.7512 17.964C10.5402 18.5854 10.4346 18.896 10.2696 18.99C10.1267 19.0713 9.95281 19.0772 9.80468 19.0056C9.63374 18.923 9.50756 18.6201 9.25521 18.0144L3.74699 4.79312C3.51283 4.23109 3.39576 3.95007 3.45272 3.77426C3.50214 3.62172 3.62172 3.50214 3.77426 3.45272C3.95007 3.39576 4.23109 3.51283 4.79312 3.74699L18.0144 9.25521C18.6201 9.50756 18.923 9.63374 19.0056 9.80468C19.0772 9.95281 19.0713 10.1267 18.99 10.2696C18.896 10.4346 18.5854 10.5402 17.964 10.7512Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ny = [
  ey,
  ry
];
function oy(r, e) {
  return n(), o("svg", ty, ny);
}
const zB2 = /* @__PURE__ */ i(Jb, [["render", oy]]);
var iy = {}, ly = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sy = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), hy = /* @__PURE__ */ t("path", {
  d: "M20.5056 10.7754C21.1225 10.5355 21.431 10.4155 21.5176 10.2459C21.5926 10.099 21.5903 9.92446 21.5115 9.77954C21.4205 9.61226 21.109 9.50044 20.486 9.2768L4.59629 3.5728C4.0866 3.38983 3.83175 3.29835 3.66514 3.35605C3.52029 3.40621 3.40645 3.52004 3.35629 3.6649C3.29859 3.8315 3.39008 4.08635 3.57304 4.59605L9.277 20.4858C9.50064 21.1088 9.61246 21.4203 9.77973 21.5113C9.92465 21.5901 10.0991 21.5924 10.2461 21.5174C10.4157 21.4308 10.5356 21.1223 10.7756 20.5054L13.3724 13.8278C13.4194 13.707 13.4429 13.6466 13.4792 13.5957C13.5114 13.5506 13.5508 13.5112 13.5959 13.479C13.6468 13.4427 13.7072 13.4192 13.828 13.3722L20.5056 10.7754Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ay = [
  sy,
  hy
];
function dy(r, e) {
  return n(), o("svg", ly, ay);
}
const KB2 = /* @__PURE__ */ i(iy, [["render", dy]]);
var cy = {}, _y = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cy = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), fy = /* @__PURE__ */ t("path", {
  d: "M4.71152 3.67446C4.17096 3.46151 3.90067 3.35504 3.72846 3.41232C3.57892 3.46207 3.46158 3.5794 3.41184 3.72894C3.35455 3.90116 3.46102 4.17144 3.67397 4.71201L8.97461 18.1675C9.14612 18.6028 9.23188 18.8205 9.37164 18.9079C9.49348 18.9841 9.64219 19.0041 9.77986 18.963C9.93778 18.9158 10.0782 18.7286 10.3589 18.3542L12.4996 15.5001L15.9489 20.2429C16.1385 20.5036 16.2334 20.634 16.3542 20.6885C16.4602 20.7363 16.5796 20.7457 16.6918 20.715C16.8196 20.68 16.9336 20.566 17.1616 20.338L20.3376 17.1621C20.5655 16.9341 20.6795 16.8201 20.7145 16.6923C20.7452 16.5801 20.7359 16.4607 20.688 16.3547C20.6335 16.2338 20.5032 16.139 20.2424 15.9494L15.4996 12.5001L18.3538 10.3594C18.7281 10.0787 18.9153 9.93827 18.9625 9.78035C19.0036 9.64268 18.9836 9.49397 18.9074 9.37213C18.82 9.23237 18.6024 9.14661 18.167 8.97509L4.71152 3.67446Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vy = [
  Cy,
  fy
];
function uy(r, e) {
  return n(), o("svg", _y, vy);
}
const GB2 = /* @__PURE__ */ i(cy, [["render", uy]]);
var wy = {}, py = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gy = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), $y = /* @__PURE__ */ t("path", {
  d: "M4.40701 3.41403C3.94876 3.27925 3.71963 3.21186 3.56363 3.27001C3.42768 3.32069 3.32045 3.42793 3.26977 3.56387C3.21162 3.71988 3.27901 3.949 3.41379 4.40726L7.61969 18.7073C7.74493 19.1332 7.80756 19.3461 7.93395 19.4449C8.04424 19.5312 8.18564 19.5672 8.32377 19.5443C8.48206 19.5181 8.639 19.3611 8.95286 19.0473L11.9999 16.0002L16.4343 20.4345C16.6323 20.6325 16.7313 20.7315 16.8454 20.7686C16.9459 20.8012 17.054 20.8012 17.1545 20.7686C17.2686 20.7315 17.3676 20.6325 17.5656 20.4345L20.4343 17.5659C20.6323 17.3679 20.7313 17.2689 20.7684 17.1547C20.801 17.0543 20.801 16.9461 20.7684 16.8457C20.7313 16.7315 20.6323 16.6325 20.4343 16.4345L15.9999 12.0002L19.047 8.95311C19.3609 8.63924 19.5178 8.48231 19.5441 8.32402C19.567 8.18589 19.5309 8.04448 19.4447 7.93419C19.3458 7.8078 19.1329 7.74518 18.7071 7.61993L4.40701 3.41403Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), My = [
  gy,
  $y
];
function Ly(r, e) {
  return n(), o("svg", py, My);
}
const WB2 = /* @__PURE__ */ i(wy, [["render", Ly]]);
var ky = {}, my = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xy = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), Hy = /* @__PURE__ */ t("path", {
  d: "M21 9.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9.5M17.3862 17.7113L15.6879 20.8653C15.4103 21.3808 15.2715 21.6386 15.1023 21.7059C14.9555 21.7643 14.7896 21.7498 14.6551 21.6668C14.5001 21.5712 14.4081 21.2933 14.2241 20.7375L11.5004 12.5113C11.3392 12.0245 11.2586 11.7812 11.3166 11.6191C11.367 11.478 11.478 11.367 11.6191 11.3166C11.7812 11.2586 12.0245 11.3392 12.5113 11.5004L20.7374 14.2241C21.2933 14.4082 21.5712 14.5002 21.6668 14.6551C21.7498 14.7897 21.7642 14.9555 21.7058 15.1024C21.6386 15.2715 21.3808 15.4103 20.8652 15.6879L17.7113 17.3862C17.6328 17.4285 17.5935 17.4497 17.5591 17.4768C17.5286 17.501 17.501 17.5286 17.4768 17.5591C17.4497 17.5935 17.4285 17.6328 17.3862 17.7113Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Vy = [
  xy,
  Hy
];
function Zy(r, e) {
  return n(), o("svg", my, Vy);
}
const YB2 = /* @__PURE__ */ i(ky, [["render", Zy]]);
var By = {}, Fy = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jy = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), Iy = /* @__PURE__ */ t("path", {
  d: "M9 3.5V2M5.06066 5.06066L4 4M5.06066 13L4 14.0607M13 5.06066L14.0607 4M3.5 9H2M15.8645 16.1896L13.3727 20.817C13.0881 21.3457 12.9457 21.61 12.7745 21.6769C12.6259 21.7349 12.4585 21.7185 12.324 21.6328C12.1689 21.534 12.0806 21.2471 11.9038 20.6733L8.44519 9.44525C8.3008 8.97651 8.2286 8.74213 8.28669 8.58383C8.33729 8.44595 8.44595 8.33729 8.58383 8.2867C8.74213 8.22861 8.9765 8.3008 9.44525 8.44519L20.6732 11.9038C21.247 12.0806 21.5339 12.169 21.6327 12.324C21.7185 12.4586 21.7348 12.6259 21.6768 12.7745C21.61 12.9458 21.3456 13.0881 20.817 13.3728L16.1896 15.8645C16.111 15.9068 16.0717 15.9279 16.0374 15.9551C16.0068 15.9792 15.9792 16.0068 15.9551 16.0374C15.9279 16.0717 15.9068 16.111 15.8645 16.1896Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), by = [
  jy,
  Iy
];
function yy(r, e) {
  return n(), o("svg", Fy, by);
}
const XB2 = /* @__PURE__ */ i(By, [["render", yy]]);
var Dy = {}, Py = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ay = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), Sy = /* @__PURE__ */ t("path", {
  d: "M9 3.5V2M5.06066 5.06066L4 4M5.06066 13L4 14.0607M13 5.06066L14.0607 4M3.5 9H2M8.5 8.5L12.6111 21.2778L15.5 18.3889L19.1111 22L22 19.1111L18.3889 15.5L21.2778 12.6111L8.5 8.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ty = [
  Ay,
  Sy
];
function Oy(r, e) {
  return n(), o("svg", Py, Ty);
}
const QB2 = /* @__PURE__ */ i(Dy, [["render", Oy]]);
var Ey = {}, Ry = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uy = /* @__PURE__ */ a('<rect width="1144" height="820" transform="translate(-336 -356)" fill="none"></rect><path d="M21.2 22C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V10.8C22 10.52 22 10.38 21.9455 10.273C21.8976 10.1789 21.8211 10.1024 21.727 10.0545C21.62 10 21.48 10 21.2 10L18.8 10C18.52 10 18.38 10 18.273 10.0545C18.1789 10.1024 18.1024 10.1789 18.0545 10.273C18 10.38 18 10.52 18 10.8V13.2C18 13.48 18 13.62 17.9455 13.727C17.8976 13.8211 17.8211 13.8976 17.727 13.9455C17.62 14 17.48 14 17.2 14H14.8C14.52 14 14.38 14 14.273 14.0545C14.1789 14.1024 14.1024 14.1789 14.0545 14.273C14 14.38 14 14.52 14 14.8V17.2C14 17.48 14 17.62 13.9455 17.727C13.8976 17.8211 13.8211 17.8976 13.727 17.9455C13.62 18 13.48 18 13.2 18H10.8C10.52 18 10.38 18 10.273 18.0545C10.1789 18.1024 10.1024 18.1789 10.0545 18.273C10 18.38 10 18.52 10 18.8V21.2C10 21.48 10 21.62 10.0545 21.727C10.1024 21.8211 10.1789 21.8976 10.273 21.9455C10.38 22 10.52 22 10.8 22L21.2 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 6.8C10 6.51997 10 6.37996 10.0545 6.273C10.1024 6.17892 10.1789 6.10243 10.273 6.0545C10.38 6 10.52 6 10.8 6H13.2C13.48 6 13.62 6 13.727 6.0545C13.8211 6.10243 13.8976 6.17892 13.9455 6.273C14 6.37996 14 6.51997 14 6.8V9.2C14 9.48003 14 9.62004 13.9455 9.727C13.8976 9.82108 13.8211 9.89757 13.727 9.9455C13.62 10 13.48 10 13.2 10H10.8C10.52 10 10.38 10 10.273 9.9455C10.1789 9.89757 10.1024 9.82108 10.0545 9.727C10 9.62004 10 9.48003 10 9.2V6.8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3 12.8C3 12.52 3 12.38 3.0545 12.273C3.10243 12.1789 3.17892 12.1024 3.273 12.0545C3.37996 12 3.51997 12 3.8 12H6.2C6.48003 12 6.62004 12 6.727 12.0545C6.82108 12.1024 6.89757 12.1789 6.9455 12.273C7 12.38 7 12.52 7 12.8V15.2C7 15.48 7 15.62 6.9455 15.727C6.89757 15.8211 6.82108 15.8976 6.727 15.9455C6.62004 16 6.48003 16 6.2 16H3.8C3.51997 16 3.37996 16 3.273 15.9455C3.17892 15.8976 3.10243 15.8211 3.0545 15.727C3 15.62 3 15.48 3 15.2V12.8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2 2.8C2 2.51997 2 2.37996 2.0545 2.273C2.10243 2.17892 2.17892 2.10243 2.273 2.0545C2.37996 2 2.51997 2 2.8 2H5.2C5.48003 2 5.62004 2 5.727 2.0545C5.82108 2.10243 5.89757 2.17892 5.9455 2.273C6 2.37996 6 2.51997 6 2.8V5.2C6 5.48003 6 5.62004 5.9455 5.727C5.89757 5.82108 5.82108 5.89757 5.727 5.9455C5.62004 6 5.48003 6 5.2 6H2.8C2.51997 6 2.37996 6 2.273 5.9455C2.17892 5.89757 2.10243 5.82108 2.0545 5.727C2 5.62004 2 5.48003 2 5.2V2.8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>', 5), Ny = [
  Uy
];
function qy(r, e) {
  return n(), o("svg", Ry, Ny);
}
const JB2 = /* @__PURE__ */ i(Ey, [["render", qy]]);
var zy = {}, Ky = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gy = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), Wy = /* @__PURE__ */ t("path", {
  d: "M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.66 17 22 12 22C7 22 3 20.66 3 19V5M21 12C21 13.66 17 15 12 15C7 15 3 13.66 3 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Yy = [
  Gy,
  Wy
];
function Xy(r, e) {
  return n(), o("svg", Ky, Yy);
}
const tF2 = /* @__PURE__ */ i(zy, [["render", Xy]]);
var Qy = {}, Jy = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tD = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), eD = /* @__PURE__ */ t("path", {
  d: "M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.66 17 22 12 22C7 22 3 20.66 3 19V5M21 9.72021C21 11.3802 17 12.7202 12 12.7202C7 12.7202 3 11.3802 3 9.72021M21 14.44C21 16.1 17 17.44 12 17.44C7 17.44 3 16.1 3 14.44",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rD = [
  tD,
  eD
];
function nD(r, e) {
  return n(), o("svg", Jy, rD);
}
const eF2 = /* @__PURE__ */ i(Qy, [["render", nD]]);
var oD = {}, iD = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lD = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), sD = /* @__PURE__ */ t("path", {
  d: "M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20M14 20C14 18.8954 13.1046 18 12 18M14 20H21M10 20C10 18.8954 10.8954 18 12 18M10 20H3M12 18V14M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V11C21 12.66 17 14 12 14M3 5V11C3 12.66 7 14 12 14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hD = [
  lD,
  sD
];
function aD(r, e) {
  return n(), o("svg", iD, hD);
}
const rF2 = /* @__PURE__ */ i(oD, [["render", aD]]);
var dD = {}, cD = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _D = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), CD = /* @__PURE__ */ t("path", {
  d: "M17 20H16.8C15.1198 20 14.2798 20 13.638 19.673C13.0735 19.3854 12.6146 18.9265 12.327 18.362C12 17.7202 12 16.8802 12 15.2V8.8C12 7.11984 12 6.27976 12.327 5.63803C12.6146 5.07354 13.0735 4.6146 13.638 4.32698C14.2798 4 15.1198 4 16.8 4H17M17 20C17 21.1046 17.8954 22 19 22C20.1046 22 21 21.1046 21 20C21 18.8954 20.1046 18 19 18C17.8954 18 17 18.8954 17 20ZM17 4C17 5.10457 17.8954 6 19 6C20.1046 6 21 5.10457 21 4C21 2.89543 20.1046 2 19 2C17.8954 2 17 2.89543 17 4ZM7 12L17 12M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12ZM17 12C17 13.1046 17.8954 14 19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fD = [
  _D,
  CD
];
function vD(r, e) {
  return n(), o("svg", cD, fD);
}
const nF2 = /* @__PURE__ */ i(dD, [["render", vD]]);
var uD = {}, wD = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pD = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), gD = /* @__PURE__ */ t("path", {
  d: "M12 4V15.2C12 16.8802 12 17.7202 12.327 18.362C12.6146 18.9265 13.0735 19.3854 13.638 19.673C14.2798 20 15.1198 20 16.8 20H17M17 20C17 21.1046 17.8954 22 19 22C20.1046 22 21 21.1046 21 20C21 18.8954 20.1046 18 19 18C17.8954 18 17 18.8954 17 20ZM7 4L17 4M7 4C7 5.10457 6.10457 6 5 6C3.89543 6 3 5.10457 3 4C3 2.89543 3.89543 2 5 2C6.10457 2 7 2.89543 7 4ZM17 4C17 5.10457 17.8954 6 19 6C20.1046 6 21 5.10457 21 4C21 2.89543 20.1046 2 19 2C17.8954 2 17 2.89543 17 4ZM12 12H17M17 12C17 13.1046 17.8954 14 19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $D = [
  pD,
  gD
];
function MD(r, e) {
  return n(), o("svg", wD, $D);
}
const oF2 = /* @__PURE__ */ i(uD, [["render", MD]]);
var LD = {}, kD = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mD = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), xD = /* @__PURE__ */ t("path", {
  d: "M11 4.5H18.3C19.4201 4.5 19.9802 4.5 20.408 4.71799C20.7843 4.90973 21.0903 5.21569 21.282 5.59202C21.5 6.01984 21.5 6.57989 21.5 7.7V9C21.5 9.93188 21.5 10.3978 21.3478 10.7654C21.1448 11.2554 20.7554 11.6448 20.2654 11.8478C19.8978 12 19.4319 12 18.5 12M13 19.5H5.7C4.5799 19.5 4.01984 19.5 3.59202 19.282C3.21569 19.0903 2.90973 18.7843 2.71799 18.408C2.5 17.9802 2.5 17.4201 2.5 16.3V15C2.5 14.0681 2.5 13.6022 2.65224 13.2346C2.85523 12.7446 3.24458 12.3552 3.73463 12.1522C4.10218 12 4.56812 12 5.5 12M10.3 14.5H13.7C13.98 14.5 14.12 14.5 14.227 14.4455C14.3211 14.3976 14.3976 14.3211 14.4455 14.227C14.5 14.12 14.5 13.98 14.5 13.7V10.3C14.5 10.02 14.5 9.87996 14.4455 9.773C14.3976 9.67892 14.3211 9.60243 14.227 9.5545C14.12 9.5 13.98 9.5 13.7 9.5H10.3C10.02 9.5 9.87996 9.5 9.773 9.5545C9.67892 9.60243 9.60243 9.67892 9.5545 9.773C9.5 9.87996 9.5 10.02 9.5 10.3V13.7C9.5 13.98 9.5 14.12 9.5545 14.227C9.60243 14.3211 9.67892 14.3976 9.773 14.4455C9.87996 14.5 10.02 14.5 10.3 14.5ZM17.8 22H21.2C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V17.8C22 17.52 22 17.38 21.9455 17.273C21.8976 17.1789 21.8211 17.1024 21.727 17.0545C21.62 17 21.48 17 21.2 17H17.8C17.52 17 17.38 17 17.273 17.0545C17.1789 17.1024 17.1024 17.1789 17.0545 17.273C17 17.38 17 17.52 17 17.8V21.2C17 21.48 17 21.62 17.0545 21.727C17.1024 21.8211 17.1789 21.8976 17.273 21.9455C17.38 22 17.52 22 17.8 22ZM2.8 7H6.2C6.48003 7 6.62004 7 6.727 6.9455C6.82108 6.89757 6.89757 6.82108 6.9455 6.727C7 6.62004 7 6.48003 7 6.2V2.8C7 2.51997 7 2.37996 6.9455 2.273C6.89757 2.17892 6.82108 2.10243 6.727 2.0545C6.62004 2 6.48003 2 6.2 2H2.8C2.51997 2 2.37996 2 2.273 2.0545C2.17892 2.10243 2.10243 2.17892 2.0545 2.273C2 2.37996 2 2.51997 2 2.8V6.2C2 6.48003 2 6.62004 2.0545 6.727C2.10243 6.82108 2.17892 6.89757 2.273 6.9455C2.37996 7 2.51997 7 2.8 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), HD = [
  mD,
  xD
];
function VD(r, e) {
  return n(), o("svg", kD, HD);
}
const iF2 = /* @__PURE__ */ i(LD, [["render", VD]]);
var ZD = {}, BD = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FD = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -636)",
  fill: "none"
}, null, -1), jD = /* @__PURE__ */ t("path", {
  d: "M4 18V17.8C4 16.1198 4 15.2798 4.32698 14.638C4.6146 14.0735 5.07354 13.6146 5.63803 13.327C6.27976 13 7.11984 13 8.8 13H15.2C16.8802 13 17.7202 13 18.362 13.327C18.9265 13.6146 19.3854 14.0735 19.673 14.638C20 15.2798 20 16.1198 20 17.8V18M4 18C2.89543 18 2 18.8954 2 20C2 21.1046 2.89543 22 4 22C5.10457 22 6 21.1046 6 20C6 18.8954 5.10457 18 4 18ZM20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18ZM12 18C10.8954 18 10 18.8954 10 20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20C14 18.8954 13.1046 18 12 18ZM12 18V8M6 8H18C18.9319 8 19.3978 8 19.7654 7.84776C20.2554 7.64477 20.6448 7.25542 20.8478 6.76537C21 6.39782 21 5.93188 21 5C21 4.06812 21 3.60218 20.8478 3.23463C20.6448 2.74458 20.2554 2.35523 19.7654 2.15224C19.3978 2 18.9319 2 18 2H6C5.06812 2 4.60218 2 4.23463 2.15224C3.74458 2.35523 3.35523 2.74458 3.15224 3.23463C3 3.60218 3 4.06812 3 5C3 5.93188 3 6.39782 3.15224 6.76537C3.35523 7.25542 3.74458 7.64477 4.23463 7.84776C4.60218 8 5.06812 8 6 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ID = [
  FD,
  jD
];
function bD(r, e) {
  return n(), o("svg", BD, ID);
}
const lF2 = /* @__PURE__ */ i(ZD, [["render", bD]]);
var yD = {}, DD = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PD = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), AD = /* @__PURE__ */ t("path", {
  d: "M17 9L11 15M11 9L17 15M2.72 12.96L7.04 18.72C7.392 19.1893 7.568 19.424 7.79105 19.5932C7.9886 19.7432 8.21232 19.855 8.45077 19.9231C8.72 20 9.01334 20 9.6 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H9.6C9.01334 4 8.72 4 8.45077 4.07689C8.21232 4.14499 7.9886 4.25685 7.79105 4.40675C7.568 4.576 7.392 4.81067 7.04 5.28L2.72 11.04C2.46181 11.3843 2.33271 11.5564 2.28294 11.7454C2.23902 11.9123 2.23902 12.0877 2.28294 12.2546C2.33271 12.4436 2.46181 12.6157 2.72 12.96Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), SD = [
  PD,
  AD
];
function TD(r, e) {
  return n(), o("svg", DD, SD);
}
const sF2 = /* @__PURE__ */ i(yD, [["render", TD]]);
var OD = {}, ED = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, RD = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), UD = /* @__PURE__ */ t("path", {
  d: "M2.49954 9H21.4995M9.99954 3L7.99954 9L11.9995 20.5L15.9995 9L13.9995 3M12.6141 20.2625L21.5727 9.51215C21.7246 9.32995 21.8005 9.23885 21.8295 9.13717C21.8551 9.04751 21.8551 8.95249 21.8295 8.86283C21.8005 8.76114 21.7246 8.67005 21.5727 8.48785L17.2394 3.28785C17.1512 3.18204 17.1072 3.12914 17.0531 3.09111C17.0052 3.05741 16.9518 3.03238 16.8953 3.01717C16.8314 3 16.7626 3 16.6248 3H7.37424C7.2365 3 7.16764 3 7.10382 3.01717C7.04728 3.03238 6.99385 3.05741 6.94596 3.09111C6.89192 3.12914 6.84783 3.18204 6.75966 3.28785L2.42633 8.48785C2.2745 8.67004 2.19858 8.76114 2.16957 8.86283C2.144 8.95249 2.144 9.04751 2.16957 9.13716C2.19858 9.23885 2.2745 9.32995 2.42633 9.51215L11.385 20.2625C11.596 20.5158 11.7015 20.6424 11.8279 20.6886C11.9387 20.7291 12.0603 20.7291 12.1712 20.6886C12.2975 20.6424 12.4031 20.5158 12.6141 20.2625Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ND = [
  RD,
  UD
];
function qD(r, e) {
  return n(), o("svg", ED, ND);
}
const hF2 = /* @__PURE__ */ i(OD, [["render", qD]]);
var zD = {}, KD = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GD = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), WD = /* @__PURE__ */ t("path", {
  d: "M5.00033 22H19.0003M2.50033 8H21.5003M10.0003 2L8.00033 8L12.0003 18.5L16.0003 8L14.0003 2M12.5923 18.3489L21.5319 8.5153C21.6979 8.33264 21.781 8.24131 21.814 8.13732C21.8432 8.04569 21.8453 7.94759 21.8201 7.85478C21.7916 7.74946 21.7125 7.65465 21.5545 7.46501L17.2402 2.28785C17.152 2.18204 17.108 2.12914 17.0539 2.09111C17.006 2.05741 16.9526 2.03238 16.896 2.01717C16.8322 2 16.7634 2 16.6256 2H7.37503C7.2373 2 7.16844 2 7.10462 2.01717C7.04808 2.03238 6.99465 2.05741 6.94676 2.09111C6.89272 2.12914 6.84863 2.18204 6.76046 2.28785L2.44616 7.46501C2.28813 7.65464 2.20911 7.74946 2.18054 7.85478C2.15535 7.94759 2.15747 8.04569 2.18662 8.13732C2.21971 8.24131 2.30273 8.33264 2.46879 8.51529L11.4084 18.3489C11.6136 18.5746 11.7162 18.6875 11.8368 18.7292C11.9427 18.7659 12.0579 18.7659 12.1639 18.7292C12.2845 18.6875 12.3871 18.5746 12.5923 18.3489Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), YD = [
  GD,
  WD
];
function XD(r, e) {
  return n(), o("svg", KD, YD);
}
const aF2 = /* @__PURE__ */ i(zD, [["render", XD]]);
var QD = {}, JD = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tP = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), eP = /* @__PURE__ */ t("path", {
  d: "M12 11.75H12.005M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM12.25 11.75C12.25 11.8881 12.1381 12 12 12C11.8619 12 11.75 11.8881 11.75 11.75C11.75 11.6119 11.8619 11.5 12 11.5C12.1381 11.5 12.25 11.6119 12.25 11.75Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rP = [
  tP,
  eP
];
function nP(r, e) {
  return n(), o("svg", JD, rP);
}
const dF2 = /* @__PURE__ */ i(QD, [["render", nP]]);
var oP = {}, iP = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lP = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), sP = /* @__PURE__ */ t("path", {
  d: "M15.25 8.75H15.255M8.75 15.25H8.755M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM15.5 8.75C15.5 8.88807 15.3881 9 15.25 9C15.1119 9 15 8.88807 15 8.75C15 8.61193 15.1119 8.5 15.25 8.5C15.3881 8.5 15.5 8.61193 15.5 8.75ZM9 15.25C9 15.3881 8.88807 15.5 8.75 15.5C8.61193 15.5 8.5 15.3881 8.5 15.25C8.5 15.1119 8.61193 15 8.75 15C8.88807 15 9 15.1119 9 15.25Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hP = [
  lP,
  sP
];
function aP(r, e) {
  return n(), o("svg", iP, hP);
}
const cF2 = /* @__PURE__ */ i(oP, [["render", aP]]);
var dP = {}, cP = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _P = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), CP = /* @__PURE__ */ t("path", {
  d: "M16.25 7.75H16.255M12 11.75H12.005M7.75 16.25H7.755M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM16.5 7.75C16.5 7.88807 16.3881 8 16.25 8C16.1119 8 16 7.88807 16 7.75C16 7.61193 16.1119 7.5 16.25 7.5C16.3881 7.5 16.5 7.61193 16.5 7.75ZM12.25 11.75C12.25 11.8881 12.1381 12 12 12C11.8619 12 11.75 11.8881 11.75 11.75C11.75 11.6119 11.8619 11.5 12 11.5C12.1381 11.5 12.25 11.6119 12.25 11.75ZM8 16.25C8 16.3881 7.88807 16.5 7.75 16.5C7.61193 16.5 7.5 16.3881 7.5 16.25C7.5 16.1119 7.61193 16 7.75 16C7.88807 16 8 16.1119 8 16.25Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fP = [
  _P,
  CP
];
function vP(r, e) {
  return n(), o("svg", cP, fP);
}
const _F2 = /* @__PURE__ */ i(dP, [["render", vP]]);
var uP = {}, wP = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pP = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), gP = /* @__PURE__ */ t("path", {
  d: "M16.25 7.75H16.255M16.25 16.25H16.255M7.75 7.75H7.755M7.75 16.25H7.755M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM16.5 7.75C16.5 7.88807 16.3881 8 16.25 8C16.1119 8 16 7.88807 16 7.75C16 7.61193 16.1119 7.5 16.25 7.5C16.3881 7.5 16.5 7.61193 16.5 7.75ZM16.5 16.25C16.5 16.3881 16.3881 16.5 16.25 16.5C16.1119 16.5 16 16.3881 16 16.25C16 16.1119 16.1119 16 16.25 16C16.3881 16 16.5 16.1119 16.5 16.25ZM8 7.75C8 7.88807 7.88807 8 7.75 8C7.61193 8 7.5 7.88807 7.5 7.75C7.5 7.61193 7.61193 7.5 7.75 7.5C7.88807 7.5 8 7.61193 8 7.75ZM8 16.25C8 16.3881 7.88807 16.5 7.75 16.5C7.61193 16.5 7.5 16.3881 7.5 16.25C7.5 16.1119 7.61193 16 7.75 16C7.88807 16 8 16.1119 8 16.25Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $P = [
  pP,
  gP
];
function MP(r, e) {
  return n(), o("svg", wP, $P);
}
const CF2 = /* @__PURE__ */ i(uP, [["render", MP]]);
var LP = {}, kP = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mP = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), xP = /* @__PURE__ */ t("path", {
  d: "M16.25 7.75H16.255M16.25 16.25H16.255M7.75 7.75H7.755M12 11.75H12.005M7.75 16.25H7.755M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM16.5 7.75C16.5 7.88807 16.3881 8 16.25 8C16.1119 8 16 7.88807 16 7.75C16 7.61193 16.1119 7.5 16.25 7.5C16.3881 7.5 16.5 7.61193 16.5 7.75ZM16.5 16.25C16.5 16.3881 16.3881 16.5 16.25 16.5C16.1119 16.5 16 16.3881 16 16.25C16 16.1119 16.1119 16 16.25 16C16.3881 16 16.5 16.1119 16.5 16.25ZM8 7.75C8 7.88807 7.88807 8 7.75 8C7.61193 8 7.5 7.88807 7.5 7.75C7.5 7.61193 7.61193 7.5 7.75 7.5C7.88807 7.5 8 7.61193 8 7.75ZM12.25 11.75C12.25 11.8881 12.1381 12 12 12C11.8619 12 11.75 11.8881 11.75 11.75C11.75 11.6119 11.8619 11.5 12 11.5C12.1381 11.5 12.25 11.6119 12.25 11.75ZM8 16.25C8 16.3881 7.88807 16.5 7.75 16.5C7.61193 16.5 7.5 16.3881 7.5 16.25C7.5 16.1119 7.61193 16 7.75 16C7.88807 16 8 16.1119 8 16.25Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), HP = [
  mP,
  xP
];
function VP(r, e) {
  return n(), o("svg", kP, HP);
}
const fF2 = /* @__PURE__ */ i(LP, [["render", VP]]);
var ZP = {}, BP = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FP = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), jP = /* @__PURE__ */ t("path", {
  d: "M16.25 7.75H16.255M16.25 11.75H16.255M16.25 16.25H16.255M7.75 7.75H7.755M7.75 11.75H7.755M7.75 16.25H7.755M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM16.5 7.75C16.5 7.88807 16.3881 8 16.25 8C16.1119 8 16 7.88807 16 7.75C16 7.61193 16.1119 7.5 16.25 7.5C16.3881 7.5 16.5 7.61193 16.5 7.75ZM16.5 11.75C16.5 11.8881 16.3881 12 16.25 12C16.1119 12 16 11.8881 16 11.75C16 11.6119 16.1119 11.5 16.25 11.5C16.3881 11.5 16.5 11.6119 16.5 11.75ZM16.5 16.25C16.5 16.3881 16.3881 16.5 16.25 16.5C16.1119 16.5 16 16.3881 16 16.25C16 16.1119 16.1119 16 16.25 16C16.3881 16 16.5 16.1119 16.5 16.25ZM8 7.75C8 7.88807 7.88807 8 7.75 8C7.61193 8 7.5 7.88807 7.5 7.75C7.5 7.61193 7.61193 7.5 7.75 7.5C7.88807 7.5 8 7.61193 8 7.75ZM8 11.75C8 11.8881 7.88807 12 7.75 12C7.61193 12 7.5 11.8881 7.5 11.75C7.5 11.6119 7.61193 11.5 7.75 11.5C7.88807 11.5 8 11.6119 8 11.75ZM8 16.25C8 16.3881 7.88807 16.5 7.75 16.5C7.61193 16.5 7.5 16.3881 7.5 16.25C7.5 16.1119 7.61193 16 7.75 16C7.88807 16 8 16.1119 8 16.25Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), IP = [
  FP,
  jP
];
function bP(r, e) {
  return n(), o("svg", BP, IP);
}
const vF2 = /* @__PURE__ */ i(ZP, [["render", bP]]);
var yP = {}, DP = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PP = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -716)",
  fill: "none"
}, null, -1), AP = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), SP = /* @__PURE__ */ t("path", {
  d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TP = [
  PP,
  AP,
  SP
];
function OP(r, e) {
  return n(), o("svg", DP, TP);
}
const uF2 = /* @__PURE__ */ i(yP, [["render", OP]]);
var EP = {}, RP = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UP = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -756)",
  fill: "none"
}, null, -1), NP = /* @__PURE__ */ t("path", {
  d: "M15 5.67363C17.3649 6.7971 19 9.2076 19 12M8.39241 18C6.35958 16.7751 5 14.5463 5 12M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qP = [
  UP,
  NP
];
function zP(r, e) {
  return n(), o("svg", RP, qP);
}
const wF2 = /* @__PURE__ */ i(EP, [["render", zP]]);
var KP = {}, GP = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WP = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-64 -756)",
  fill: "none"
}, null, -1), YP = /* @__PURE__ */ t("path", {
  d: "M21 21V3M3 21V3M9 8V16C9 16.9319 9 17.3978 9.15224 17.7654C9.35523 18.2554 9.74458 18.6448 10.2346 18.8478C10.6022 19 11.0681 19 12 19C12.9319 19 13.3978 19 13.7654 18.8478C14.2554 18.6448 14.6448 18.2554 14.8478 17.7654C15 17.3978 15 16.9319 15 16V8C15 7.06812 15 6.60218 14.8478 6.23463C14.6448 5.74458 14.2554 5.35523 13.7654 5.15224C13.3978 5 12.9319 5 12 5C11.0681 5 10.6022 5 10.2346 5.15224C9.74458 5.35523 9.35523 5.74458 9.15224 6.23463C9 6.60218 9 7.06812 9 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XP = [
  WP,
  YP
];
function QP(r, e) {
  return n(), o("svg", GP, XP);
}
const pF2 = /* @__PURE__ */ i(KP, [["render", QP]]);
var JP = {}, tA = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eA = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), rA = /* @__PURE__ */ t("path", {
  d: "M21 3H3M21 21H3M5 12C5 11.0681 5 10.6022 5.15224 10.2346C5.35523 9.74458 5.74458 9.35523 6.23463 9.15224C6.60218 9 7.06812 9 8 9L16 9C16.9319 9 17.3978 9 17.7654 9.15224C18.2554 9.35523 18.6448 9.74458 18.8478 10.2346C19 10.6022 19 11.0681 19 12C19 12.9319 19 13.3978 18.8478 13.7654C18.6448 14.2554 18.2554 14.6448 17.7654 14.8478C17.3978 15 16.9319 15 16 15L8 15C7.06812 15 6.60218 15 6.23463 14.8478C5.74458 14.6448 5.35523 14.2554 5.15224 13.7654C5 13.3978 5 12.9319 5 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nA = [
  eA,
  rA
];
function oA(r, e) {
  return n(), o("svg", tA, nA);
}
const gF2 = /* @__PURE__ */ i(JP, [["render", oA]]);
var iA = {}, lA = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sA = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1756)",
  fill: "none"
}, null, -1), hA = /* @__PURE__ */ t("path", {
  d: "M4 12H20M13 6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aA = [
  sA,
  hA
];
function dA(r, e) {
  return n(), o("svg", lA, aA);
}
const $F2 = /* @__PURE__ */ i(iA, [["render", dA]]);
var cA = {}, _A = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CA = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1796)",
  fill: "none"
}, null, -1), fA = /* @__PURE__ */ t("path", {
  d: "M4 12H20M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6ZM14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vA = [
  CA,
  fA
];
function uA(r, e) {
  return n(), o("svg", _A, vA);
}
const MF2 = /* @__PURE__ */ i(cA, [["render", uA]]);
var wA = {}, pA = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gA = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1836)",
  fill: "none"
}, null, -1), $A = /* @__PURE__ */ t("path", {
  d: "M12 8H12.01M12 16H12.01M7 12H17M12.5 8C12.5 8.27614 12.2761 8.5 12 8.5C11.7239 8.5 11.5 8.27614 11.5 8C11.5 7.72386 11.7239 7.5 12 7.5C12.2761 7.5 12.5 7.72386 12.5 8ZM12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), MA = [
  gA,
  $A
];
function LA(r, e) {
  return n(), o("svg", pA, MA);
}
const LF2 = /* @__PURE__ */ i(wA, [["render", LA]]);
var kA = {}, mA = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xA = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), HA = /* @__PURE__ */ t("path", {
  d: "M3 12H3.01M7.5 12H7.51M16.5 12H16.51M12 12H12.01M21 12H21.01M21 21V20.2C21 19.0799 21 18.5198 20.782 18.092C20.5903 17.7157 20.2843 17.4097 19.908 17.218C19.4802 17 18.9201 17 17.8 17H6.2C5.0799 17 4.51984 17 4.09202 17.218C3.7157 17.4097 3.40973 17.7157 3.21799 18.092C3 18.5198 3 19.0799 3 20.2V21M21 3V3.8C21 4.9201 21 5.48016 20.782 5.90798C20.5903 6.28431 20.2843 6.59027 19.908 6.78201C19.4802 7 18.9201 7 17.8 7H6.2C5.0799 7 4.51984 7 4.09202 6.78201C3.71569 6.59027 3.40973 6.28431 3.21799 5.90798C3 5.48016 3 4.92011 3 3.8V3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VA = [
  xA,
  HA
];
function ZA(r, e) {
  return n(), o("svg", mA, VA);
}
const kF2 = /* @__PURE__ */ i(kA, [["render", ZA]]);
var BA = {}, FA = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jA = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), IA = /* @__PURE__ */ t("path", {
  d: "M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bA = [
  jA,
  IA
];
function yA(r, e) {
  return n(), o("svg", FA, bA);
}
const mF2 = /* @__PURE__ */ i(BA, [["render", yA]]);
var DA = {}, PA = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AA = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), SA = /* @__PURE__ */ t("path", {
  d: "M21 5L10 5M21 19L10 19M21 12L10 12M6 5C6 5.82843 5.32843 6.5 4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5ZM6 19C6 19.8284 5.32843 20.5 4.5 20.5C3.67157 20.5 3 19.8284 3 19C3 18.1716 3.67157 17.5 4.5 17.5C5.32843 17.5 6 18.1716 6 19ZM6 12C6 12.8284 5.32843 13.5 4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TA = [
  AA,
  SA
];
function OA(r, e) {
  return n(), o("svg", PA, TA);
}
const xF2 = /* @__PURE__ */ i(DA, [["render", OA]]);
var EA = {}, RA = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UA = /* @__PURE__ */ a('<rect width="1144" height="2180" transform="translate(-64 -1876)" fill="none"></rect><path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>', 10), NA = [
  UA
];
function qA(r, e) {
  return n(), o("svg", RA, NA);
}
const HF2 = /* @__PURE__ */ i(EA, [["render", qA]]);
var zA = {}, KA = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GA = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1916)",
  fill: "none"
}, null, -1), WA = /* @__PURE__ */ t("path", {
  d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), YA = /* @__PURE__ */ t("path", {
  d: "M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XA = /* @__PURE__ */ t("path", {
  d: "M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), QA = [
  GA,
  WA,
  YA,
  XA
];
function JA(r, e) {
  return n(), o("svg", KA, QA);
}
const VF2 = /* @__PURE__ */ i(zA, [["render", JA]]);
var tS = {}, eS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rS = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1956)",
  fill: "none"
}, null, -1), nS = /* @__PURE__ */ t("path", {
  d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oS = /* @__PURE__ */ t("path", {
  d: "M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iS = /* @__PURE__ */ t("path", {
  d: "M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lS = [
  rS,
  nS,
  oS,
  iS
];
function sS(r, e) {
  return n(), o("svg", eS, lS);
}
const hS = /* @__PURE__ */ i(tS, [["render", sS]]);
var aS = {}, dS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cS = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -1996)",
  fill: "none"
}, null, -1), _S = /* @__PURE__ */ t("path", {
  d: "M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), CS = [
  cS,
  _S
];
function fS(r, e) {
  return n(), o("svg", dS, CS);
}
const ZF2 = /* @__PURE__ */ i(aS, [["render", fS]]);
var vS = {}, uS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wS = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -2036)",
  fill: "none"
}, null, -1), pS = /* @__PURE__ */ t("path", {
  d: "M21 21H3M18 11L12 17M12 17L6 11M12 17V3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), gS = [
  wS,
  pS
];
function $S(r, e) {
  return n(), o("svg", uS, gS);
}
const BF2 = /* @__PURE__ */ i(vS, [["render", $S]]);
var MS = {}, LS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kS = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-64 -2076)",
  fill: "none"
}, null, -1), mS = /* @__PURE__ */ t("path", {
  d: "M8 12L12 16M12 16L16 12M12 16V8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), xS = [
  kS,
  mS
];
function HS(r, e) {
  return n(), o("svg", LS, xS);
}
const FF2 = /* @__PURE__ */ i(MS, [["render", HS]]);
var VS = {}, ZS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, BS = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), FS = /* @__PURE__ */ t("path", {
  d: "M8 12L12 16M12 16L16 12M12 16V6.8C12 5.40929 12 4.71394 11.4495 3.9354C11.0837 3.41812 10.0306 2.77968 9.40278 2.69462C8.45789 2.5666 8.09907 2.75378 7.38143 3.12814C4.18333 4.79643 2 8.14324 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 8.29859 19.989 5.06687 17 3.33782",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), jS = [
  BS,
  FS
];
function IS(r, e) {
  return n(), o("svg", ZS, jS);
}
const jF2 = /* @__PURE__ */ i(VS, [["render", IS]]);
var bS = {}, yS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, DS = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), PS = /* @__PURE__ */ t("path", {
  d: "M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 17L12 21M12 21L16 17M12 21V12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), AS = [
  DS,
  PS
];
function SS(r, e) {
  return n(), o("svg", yS, AS);
}
const IF2 = /* @__PURE__ */ i(bS, [["render", SS]]);
var TS = {}, OS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ES = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), RS = /* @__PURE__ */ t("path", {
  d: "M8 17L12 21M12 21L16 17M12 21V12M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), US = [
  ES,
  RS
];
function NS(r, e) {
  return n(), o("svg", OS, US);
}
const bF2 = /* @__PURE__ */ i(TS, [["render", NS]]);
var qS = {}, zS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, KS = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), GS = /* @__PURE__ */ t("path", {
  d: "M20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 12.9391 4.20651 11.9264 4.58152 11C5.76829 8.06817 12 2 12 2C12 2 18.2317 8.06817 19.4185 11C19.7935 11.9264 20 12.9391 20 14Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), WS = [
  KS,
  GS
];
function YS(r, e) {
  return n(), o("svg", zS, WS);
}
const yF2 = /* @__PURE__ */ i(qS, [["render", YS]]);
var XS = {}, QS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, JS = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), tT = /* @__PURE__ */ t("path", {
  d: "M22 16C22 19.3137 19.3137 22 16 22C12.6863 22 10 19.3137 10 16C10 11.6863 16 2 16 2C16 2 22 11.6863 22 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), eT = /* @__PURE__ */ t("path", {
  d: "M8 9C8 10.6569 6.65685 12 5 12C3.34315 12 2 10.6569 2 9C2 6.84315 5 2 5 2C5 2 8 6.84315 8 9Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rT = [
  JS,
  tT,
  eT
];
function nT(r, e) {
  return n(), o("svg", QS, rT);
}
const DF2 = /* @__PURE__ */ i(XS, [["render", nT]]);
var oT = {}, iT = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lT = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), sT = /* @__PURE__ */ t("path", {
  d: "M12 21.5C13.8565 21.5 15.637 20.7625 16.9497 19.4497C18.2625 18.137 19 16.3565 19 14.5C19 12.5 18 10.6 16 9C14 7.4 12.5 5 12 2.5C11.5 5 10 7.4 8 9C6 10.6 5 12.5 5 14.5C5 16.3565 5.7375 18.137 7.05025 19.4497C8.36301 20.7625 10.1435 21.5 12 21.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hT = [
  lT,
  sT
];
function aT(r, e) {
  return n(), o("svg", iT, hT);
}
const PF2 = /* @__PURE__ */ i(oT, [["render", aT]]);
var dT = {}, cT = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _T = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), CT = /* @__PURE__ */ t("path", {
  d: "M12.56 6.08C13.2478 4.98112 13.7353 3.76904 14 2.5C14.5 5 16 7.4 18 9C20 10.6 21 12.5 21 14.5C21.0057 15.8823 20.6009 17.2352 19.8368 18.3871C19.0727 19.539 17.9838 20.4382 16.7081 20.9705C15.4324 21.5028 14.0274 21.6444 12.6712 21.3773C11.3149 21.1101 10.0685 20.4463 9.09 19.47M7 15.78C9.2 15.78 11 13.95 11 11.73C11 10.57 10.43 9.47 9.29 8.54C8.15 7.61 7.29 6.23 7 4.78C6.71 6.23 5.86 7.62 4.71 8.54C3.56 9.46 3 10.58 3 11.73C3 13.95 4.8 15.78 7 15.78Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fT = [
  _T,
  CT
];
function vT(r, e) {
  return n(), o("svg", cT, fT);
}
const AF2 = /* @__PURE__ */ i(dT, [["render", vT]]);
var uT = {}, wT = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pT = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), gT = /* @__PURE__ */ t("path", {
  d: "M10.5 6.49981L17.5 13.4998M2 21.9998C2 21.9998 6.5 21.4998 9 18.9998L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99982C19.8954 1.89525 18.1046 1.89524 17 2.99981L5 14.9998C2.5 17.4998 2 21.9998 2 21.9998Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $T = [
  pT,
  gT
];
function MT(r, e) {
  return n(), o("svg", wT, $T);
}
const SF2 = /* @__PURE__ */ i(uT, [["render", MT]]);
var LT = {}, kT = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mT = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), xT = /* @__PURE__ */ t("path", {
  d: "M2.87601 18.1156C2.92195 17.7021 2.94493 17.4954 3.00748 17.3022C3.06298 17.1307 3.1414 16.9676 3.24061 16.8171C3.35242 16.6475 3.49952 16.5005 3.7937 16.2063L17 3C18.1046 1.89543 19.8954 1.89543 21 3C22.1046 4.10457 22.1046 5.89543 21 7L7.7937 20.2063C7.49951 20.5005 7.35242 20.6475 7.18286 20.7594C7.03242 20.8586 6.86926 20.937 6.69782 20.9925C6.50457 21.055 6.29783 21.078 5.88434 21.124L2.49997 21.5L2.87601 18.1156Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), HT = [
  mT,
  xT
];
function VT(r, e) {
  return n(), o("svg", kT, HT);
}
const TF2 = /* @__PURE__ */ i(LT, [["render", VT]]);
var ZT = {}, BT = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FT = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), jT = /* @__PURE__ */ t("path", {
  d: "M18 10L14 6M2.49997 21.5L5.88434 21.124C6.29783 21.078 6.50457 21.055 6.69782 20.9925C6.86926 20.937 7.03242 20.8586 7.18286 20.7594C7.35242 20.6475 7.49951 20.5005 7.7937 20.2063L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8954 1.89543 18.1046 1.89543 17 3L3.7937 16.2063C3.49952 16.5005 3.35242 16.6475 3.24061 16.8171C3.1414 16.9676 3.06298 17.1307 3.00748 17.3022C2.94493 17.4954 2.92195 17.7021 2.87601 18.1156L2.49997 21.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), IT = [
  FT,
  jT
];
function bT(r, e) {
  return n(), o("svg", BT, IT);
}
const OF2 = /* @__PURE__ */ i(ZT, [["render", bT]]);
var yT = {}, DT = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PT = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), AT = /* @__PURE__ */ t("path", {
  d: "M12 20H21M3.00003 20H4.67457C5.16376 20 5.40835 20 5.63852 19.9447C5.84259 19.8957 6.03768 19.8149 6.21663 19.7053C6.41846 19.5816 6.59141 19.4086 6.93732 19.0627L19.5001 6.49998C20.3285 5.67156 20.3285 4.32841 19.5001 3.49998C18.6716 2.67156 17.3285 2.67156 16.5001 3.49998L3.93729 16.0627C3.59139 16.4086 3.41843 16.5816 3.29475 16.7834C3.18509 16.9624 3.10428 17.1574 3.05529 17.3615C3.00003 17.5917 3.00003 17.8363 3.00003 18.3255V20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ST = [
  PT,
  AT
];
function TT(r, e) {
  return n(), o("svg", DT, ST);
}
const EF2 = /* @__PURE__ */ i(yT, [["render", TT]]);
var OT = {}, ET = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, RT = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), UT = /* @__PURE__ */ t("path", {
  d: "M21 18L19.9999 19.094C19.4695 19.6741 18.7502 20 18.0002 20C17.2501 20 16.5308 19.6741 16.0004 19.094C15.4693 18.5151 14.75 18.1901 14.0002 18.1901C13.2504 18.1901 12.5312 18.5151 12 19.094M3.00003 20H4.67457C5.16376 20 5.40835 20 5.63852 19.9447C5.84259 19.8957 6.03768 19.8149 6.21663 19.7053C6.41846 19.5816 6.59141 19.4086 6.93732 19.0627L19.5001 6.49998C20.3285 5.67156 20.3285 4.32841 19.5001 3.49998C18.6716 2.67156 17.3285 2.67156 16.5001 3.49998L3.93729 16.0627C3.59139 16.4086 3.41843 16.5816 3.29475 16.7834C3.18509 16.9624 3.10428 17.1574 3.05529 17.3615C3.00003 17.5917 3.00003 17.8363 3.00003 18.3255V20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), NT = [
  RT,
  UT
];
function qT(r, e) {
  return n(), o("svg", ET, NT);
}
const RF2 = /* @__PURE__ */ i(OT, [["render", qT]]);
var zT = {}, KT = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GT = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), WT = /* @__PURE__ */ t("path", {
  d: "M11 3.99998H6.8C5.11984 3.99998 4.27976 3.99998 3.63803 4.32696C3.07354 4.61458 2.6146 5.07353 2.32698 5.63801C2 6.27975 2 7.11983 2 8.79998V17.2C2 18.8801 2 19.7202 2.32698 20.362C2.6146 20.9264 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9264 19.673 20.362C20 19.7202 20 18.8801 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.49998C22.3284 4.67156 22.3284 3.32841 21.5 2.49998C20.6716 1.67156 19.3284 1.67155 18.5 2.49998L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1574 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), YT = [
  GT,
  WT
];
function XT(r, e) {
  return n(), o("svg", KT, YT);
}
const UF2 = /* @__PURE__ */ i(zT, [["render", XT]]);
var QT = {}, JT = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tO = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), eO = /* @__PURE__ */ t("path", {
  d: "M5 9H19M5 15H19M19 5L5 19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rO = [
  tO,
  eO
];
function nO(r, e) {
  return n(), o("svg", JT, rO);
}
const NF2 = /* @__PURE__ */ i(QT, [["render", nO]]);
var oO = {}, iO = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lO = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), sO = /* @__PURE__ */ t("path", {
  d: "M5 9H19M5 15H19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hO = [
  lO,
  sO
];
function aO(r, e) {
  return n(), o("svg", iO, hO);
}
const qF2 = /* @__PURE__ */ i(oO, [["render", aO]]);
var dO = {}, cO = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _O = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), CO = /* @__PURE__ */ t("path", {
  d: "M17.9995 13L10.9995 6.00004M20.9995 21H7.99955M10.9368 20.0628L19.6054 11.3941C20.7935 10.2061 21.3875 9.61207 21.6101 8.92709C21.8058 8.32456 21.8058 7.67551 21.6101 7.07298C21.3875 6.388 20.7935 5.79397 19.6054 4.60592L19.3937 4.39415C18.2056 3.2061 17.6116 2.61207 16.9266 2.38951C16.3241 2.19373 15.675 2.19373 15.0725 2.38951C14.3875 2.61207 13.7935 3.2061 12.6054 4.39415L4.39366 12.6059C3.20561 13.794 2.61158 14.388 2.38902 15.073C2.19324 15.6755 2.19324 16.3246 2.38902 16.9271C2.61158 17.6121 3.20561 18.2061 4.39366 19.3941L5.06229 20.0628C5.40819 20.4087 5.58114 20.5816 5.78298 20.7053C5.96192 20.815 6.15701 20.8958 6.36108 20.9448C6.59126 21 6.83585 21 7.32503 21H8.67406C9.16324 21 9.40784 21 9.63801 20.9448C9.84208 20.8958 10.0372 20.815 10.2161 20.7053C10.418 20.5816 10.5909 20.4087 10.9368 20.0628Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fO = [
  _O,
  CO
];
function vO(r, e) {
  return n(), o("svg", cO, fO);
}
const zF2 = /* @__PURE__ */ i(dO, [["render", vO]]);
var uO = {}, wO = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pO = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -996)",
  fill: "none"
}, null, -1), gO = /* @__PURE__ */ t("path", {
  d: "M14 10L21 3M21 3H15M21 3V9M10 14L3 21M3 21H9M3 21L3 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $O = [
  pO,
  gO
];
function MO(r, e) {
  return n(), o("svg", wO, $O);
}
const KF2 = /* @__PURE__ */ i(uO, [["render", MO]]);
var LO = {}, kO = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mO = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-608 -1036)",
  fill: "none"
}, null, -1), xO = /* @__PURE__ */ t("path", {
  d: "M3 21L21 3M3 21H9M3 21L3 15M21 3H15M21 3V9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), HO = [
  mO,
  xO
];
function VO(r, e) {
  return n(), o("svg", kO, HO);
}
const GF2 = /* @__PURE__ */ i(LO, [["render", VO]]);
var ZO = {}, BO = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FO = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), jO = /* @__PURE__ */ t("path", {
  d: "M21 14V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H14M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V10M15 9L21 3M21 3H15M21 3V9M9 15L3 21M3 21H9M3 21L3 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), IO = [
  FO,
  jO
];
function bO(r, e) {
  return n(), o("svg", BO, IO);
}
const WF2 = /* @__PURE__ */ i(ZO, [["render", bO]]);
var yO = {}, DO = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PO = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), AO = /* @__PURE__ */ t("path", {
  d: "M20 14V16.8C20 17.9201 20 18.4802 19.782 18.908C19.5903 19.2843 19.2843 19.5903 18.908 19.782C18.4802 20 17.9201 20 16.8 20H14M10 4H7.2C6.0799 4 5.51984 4 5.09202 4.21799C4.71569 4.40973 4.40973 4.71569 4.21799 5.09202C4 5.51984 4 6.07989 4 7.2V10M15 9L21 3M21 3H15M21 3V9M9 15L3 21M3 21H9M3 21L3 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), SO = [
  PO,
  AO
];
function TO(r, e) {
  return n(), o("svg", DO, SO);
}
const YF2 = /* @__PURE__ */ i(yO, [["render", TO]]);
var OO = {}, EO = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, RO = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), UO = /* @__PURE__ */ t("path", {
  d: "M15 9L21 3M21 3H15M21 3V9M9 9L3 3M3 3L3 9M3 3L9 3M9 15L3 21M3 21H9M3 21L3 15M15 15L21 21M21 21V15M21 21H15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), NO = [
  RO,
  UO
];
function qO(r, e) {
  return n(), o("svg", EO, NO);
}
const XF2 = /* @__PURE__ */ i(OO, [["render", qO]]);
var zO = {}, KO = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GO = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), WO = /* @__PURE__ */ t("path", {
  d: "M16 8L21 3M21 3H16M21 3V8M8 8L3 3M3 3L3 8M3 3L8 3M8 16L3 21M3 21H8M3 21L3 16M16 16L21 21M21 21V16M21 21H16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), YO = [
  GO,
  WO
];
function XO(r, e) {
  return n(), o("svg", KO, YO);
}
const QF2 = /* @__PURE__ */ i(zO, [["render", XO]]);
var QO = {}, JO = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tE = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), eE = /* @__PURE__ */ t("path", {
  d: "M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rE = [
  tE,
  eE
];
function nE(r, e) {
  return n(), o("svg", JO, rE);
}
const JF2 = /* @__PURE__ */ i(QO, [["render", nE]]);
var oE = {}, iE = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lE = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), sE = /* @__PURE__ */ t("path", {
  d: "M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hE = /* @__PURE__ */ t("path", {
  d: "M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aE = [
  lE,
  sE,
  hE
];
function dE(r, e) {
  return n(), o("svg", iE, aE);
}
const tj2 = /* @__PURE__ */ i(oE, [["render", dE]]);
var cE = {}, _E = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CE = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), fE = /* @__PURE__ */ t("path", {
  d: "M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M17 9.24C16.605 9.725 16.065 10 15.5 10C14.935 10 14.41 9.725 14 9.24M10 9.24C9.605 9.725 9.065 10 8.5 10C7.935 10 7.41 9.725 7 9.24M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vE = [
  CE,
  fE
];
function uE(r, e) {
  return n(), o("svg", _E, vE);
}
const ej2 = /* @__PURE__ */ i(cE, [["render", uE]]);
var wE = {}, pE = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gE = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), $E = /* @__PURE__ */ t("path", {
  d: "M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ME = [
  gE,
  $E
];
function LE(r, e) {
  return n(), o("svg", pE, ME);
}
const rj2 = /* @__PURE__ */ i(wE, [["render", LE]]);
var kE = {}, mE = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xE = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), HE = /* @__PURE__ */ t("path", {
  d: "M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM12 17.5C14.5005 17.5 16.5 15.667 16.5 14H7.5C7.5 15.667 9.4995 17.5 12 17.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VE = [
  xE,
  HE
];
function ZE(r, e) {
  return n(), o("svg", mE, VE);
}
const nj2 = /* @__PURE__ */ i(kE, [["render", ZE]]);
var BE = {}, FE = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jE = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), IE = /* @__PURE__ */ t("path", {
  d: "M7.5 8V9.5M16.5 8V9.5M11 12.6001C11.8 12.6001 12.5 11.9001 12.5 11.1001V8M15.2002 15.2C13.4002 17 10.5002 17 8.7002 15.2M3 7.8L3 16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27977 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3L7.8 3C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bE = [
  jE,
  IE
];
function yE(r, e) {
  return n(), o("svg", FE, bE);
}
const oj2 = /* @__PURE__ */ i(BE, [["render", yE]]);
var DE = {}, PE = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AE = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), SE = /* @__PURE__ */ t("path", {
  d: "M8 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M8 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V16M21 8V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H16M21 16V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H16M7.5 8V9.5M16.5 8V9.5M11 12.6001C11.8 12.6001 12.5 11.9001 12.5 11.1001V8M15.2002 15.2C13.4002 17 10.5002 17 8.7002 15.2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TE = [
  AE,
  SE
];
function OE(r, e) {
  return n(), o("svg", PE, TE);
}
const ij2 = /* @__PURE__ */ i(DE, [["render", OE]]);
var EE = {}, RE = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UE = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), NE = /* @__PURE__ */ t("path", {
  d: "M8 15H16M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qE = [
  UE,
  NE
];
function zE(r, e) {
  return n(), o("svg", RE, qE);
}
const lj2 = /* @__PURE__ */ i(EE, [["render", zE]]);
var KE = {}, GE = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WE = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), YE = /* @__PURE__ */ t("path", {
  d: "M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M17 9.24C16.605 9.725 16.065 10 15.5 10C14.935 10 14.41 9.725 14 9.24M10 9.24C9.605 9.725 9.065 10 8.5 10C7.935 10 7.41 9.725 7 9.24M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XE = [
  WE,
  YE
];
function QE(r, e) {
  return n(), o("svg", GE, XE);
}
const sj2 = /* @__PURE__ */ i(KE, [["render", QE]]);
var JE = {}, tR = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eR = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), rR = /* @__PURE__ */ t("path", {
  d: "M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nR = [
  eR,
  rR
];
function oR(r, e) {
  return n(), o("svg", tR, nR);
}
const hj2 = /* @__PURE__ */ i(JE, [["render", oR]]);
var iR = {}, lR = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sR = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), hR = /* @__PURE__ */ t("path", {
  d: "M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M8 9H10M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aR = [
  sR,
  hR
];
function dR(r, e) {
  return n(), o("svg", lR, aR);
}
const aj2 = /* @__PURE__ */ i(iR, [["render", dR]]);
var cR = {}, _R = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CR = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -796)",
  fill: "none"
}, null, -1), fR = /* @__PURE__ */ t("path", {
  d: "M21.9997 16.437C21.9997 17.567 21.9997 18.1321 21.7714 18.4091C21.5731 18.6497 21.2739 18.7841 20.9623 18.7724C20.6036 18.759 20.1813 18.3836 19.3367 17.6329L14.345 13.1958C13.8797 12.7822 13.6471 12.5754 13.5614 12.3312C13.4861 12.1168 13.4861 11.8831 13.5614 11.6687C13.6471 11.4245 13.8797 11.2177 14.345 10.8041L19.3367 6.36706C20.1813 5.61631 20.6036 5.24093 20.9623 5.22751C21.2739 5.21584 21.5731 5.35021 21.7714 5.59086C21.9997 5.86787 21.9997 6.43288 21.9997 7.56291V16.437Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vR = /* @__PURE__ */ t("path", {
  d: "M10.9997 16.437C10.9997 17.567 10.9997 18.1321 10.7714 18.4091C10.5731 18.6497 10.2739 18.7841 9.96228 18.7724C9.60359 18.759 9.1813 18.3836 8.3367 17.6329L3.34502 13.1958C2.87973 12.7822 2.64709 12.5754 2.56135 12.3312C2.48606 12.1168 2.48606 11.8831 2.56135 11.6687C2.64709 11.4245 2.87973 11.2177 3.34502 10.8041L8.3367 6.36706C9.1813 5.61631 9.60359 5.24093 9.96228 5.22751C10.2739 5.21584 10.5731 5.35021 10.7714 5.59086C10.9997 5.86787 10.9997 6.43288 10.9997 7.56291V16.437Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uR = [
  CR,
  fR,
  vR
];
function wR(r, e) {
  return n(), o("svg", _R, uR);
}
const dj2 = /* @__PURE__ */ i(cR, [["render", wR]]);
var pR = {}, gR = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $R = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -836)",
  fill: "none"
}, null, -1), MR = /* @__PURE__ */ t("path", {
  d: "M13 16.437C13 17.567 13 18.1321 13.2283 18.4091C13.4266 18.6497 13.7258 18.7841 14.0374 18.7724C14.3961 18.759 14.8184 18.3836 15.663 17.6329L20.6547 13.1958C21.12 12.7822 21.3526 12.5754 21.4383 12.3312C21.5136 12.1168 21.5136 11.8831 21.4383 11.6687C21.3526 11.4245 21.12 11.2177 20.6547 10.8041L15.663 6.36706C14.8184 5.61631 14.3961 5.24093 14.0374 5.22751C13.7258 5.21584 13.4266 5.35021 13.2283 5.59086C13 5.86787 13 6.43288 13 7.56291V16.437Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), LR = /* @__PURE__ */ t("path", {
  d: "M2 16.437C2 17.567 2 18.1321 2.22827 18.4091C2.42657 18.6497 2.72579 18.7841 3.0374 18.7724C3.39609 18.759 3.81839 18.3836 4.66298 17.6329L9.65466 13.1958C10.12 12.7822 10.3526 12.5754 10.4383 12.3312C10.5136 12.1168 10.5136 11.8831 10.4383 11.6687C10.3526 11.4245 10.12 11.2177 9.65466 10.8041L4.66298 6.36706C3.81839 5.61631 3.39609 5.24093 3.0374 5.22751C2.72579 5.21584 2.42657 5.35021 2.22827 5.59086C2 5.86787 2 6.43288 2 7.56291V16.437Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kR = [
  $R,
  MR,
  LR
];
function mR(r, e) {
  return n(), o("svg", gR, kR);
}
const cj2 = /* @__PURE__ */ i(pR, [["render", mR]]);
var xR = {}, HR = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VR = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -636)",
  fill: "none"
}, null, -1), ZR = /* @__PURE__ */ t("path", {
  d: "M16 8.00007L2 22.0001M18 15.0001H9M6.6 19.0001H13.3373C13.5818 19.0001 13.7041 19.0001 13.8192 18.9724C13.9213 18.9479 14.0188 18.9075 14.1083 18.8527C14.2092 18.7909 14.2957 18.7044 14.4686 18.5314L19.5 13.5001C19.739 13.2611 19.8584 13.1416 19.9546 13.0358C22.0348 10.7474 22.0348 7.25275 19.9546 4.9643C19.8584 4.85851 19.739 4.73903 19.5 4.50007C19.261 4.26111 19.1416 4.14163 19.0358 4.04547C16.7473 1.96531 13.2527 1.96531 10.9642 4.04547C10.8584 4.14163 10.739 4.26111 10.5 4.50007L5.46863 9.53144C5.29568 9.70439 5.2092 9.79087 5.14736 9.89179C5.09253 9.98126 5.05213 10.0788 5.02763 10.1808C5 10.2959 5 10.4182 5 10.6628V17.4001C5 17.9601 5 18.2401 5.10899 18.4541C5.20487 18.6422 5.35785 18.7952 5.54601 18.8911C5.75992 19.0001 6.03995 19.0001 6.6 19.0001Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BR = [
  VR,
  ZR
];
function FR(r, e) {
  return n(), o("svg", HR, BR);
}
const _j2 = /* @__PURE__ */ i(xR, [["render", FR]]);
var jR = {}, IR = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bR = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -676)",
  fill: "none"
}, null, -1), yR = /* @__PURE__ */ t("path", {
  d: "M12 1.5H8.5C6.567 1.5 5 3.067 5 5C5 6.933 6.567 8.5 8.5 8.5M12 1.5V8.5M12 1.5H15.5C17.433 1.5 19 3.067 19 5C19 6.933 17.433 8.5 15.5 8.5M12 8.5H8.5M12 8.5V15.5M12 8.5H15.5M8.5 8.5C6.567 8.5 5 10.067 5 12C5 13.933 6.567 15.5 8.5 15.5M12 15.5H8.5M12 15.5V19C12 20.933 10.433 22.5 8.5 22.5C6.567 22.5 5 20.933 5 19C5 17.067 6.567 15.5 8.5 15.5M15.5 8.5C17.433 8.5 19 10.067 19 12C19 13.933 17.433 15.5 15.5 15.5C13.567 15.5 12 13.933 12 12C12 10.067 13.567 8.5 15.5 8.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DR = [
  bR,
  yR
];
function PR(r, e) {
  return n(), o("svg", IR, DR);
}
const Cj2 = /* @__PURE__ */ i(jR, [["render", PR]]);
var AR = {}, SR = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TR = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -156)",
  fill: "none"
}, null, -1), OR = /* @__PURE__ */ t("path", {
  d: "M4 6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ER = [
  TR,
  OR
];
function RR(r, e) {
  return n(), o("svg", SR, ER);
}
const fj2 = /* @__PURE__ */ i(AR, [["render", RR]]);
var UR = {}, NR = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qR = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -196)",
  fill: "none"
}, null, -1), zR = /* @__PURE__ */ t("path", {
  d: "M14 11H8M10 15H8M16 7H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KR = [
  qR,
  zR
];
function GR(r, e) {
  return n(), o("svg", NR, KR);
}
const vj2 = /* @__PURE__ */ i(UR, [["render", GR]]);
var WR = {}, YR = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XR = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), QR = /* @__PURE__ */ t("path", {
  d: "M8 14V18M16 12V18M12 8V18M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JR = [
  XR,
  QR
];
function tU(r, e) {
  return n(), o("svg", YR, JR);
}
const uj2 = /* @__PURE__ */ i(WR, [["render", tU]]);
var eU = {}, rU = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nU = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), oU = /* @__PURE__ */ t("path", {
  d: "M14 2.26946V6.4C14 6.96005 14 7.24008 14.109 7.45399C14.2049 7.64215 14.3578 7.79513 14.546 7.89101C14.7599 8 15.0399 8 15.6 8H19.7305M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iU = [
  nU,
  oU
];
function lU(r, e) {
  return n(), o("svg", rU, iU);
}
const wj2 = /* @__PURE__ */ i(eU, [["render", lU]]);
var sU = {}, hU = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aU = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), dU = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M14 17H8M16 13H8M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cU = [
  aU,
  dU
];
function _U(r, e) {
  return n(), o("svg", hU, cU);
}
const pj2 = /* @__PURE__ */ i(sU, [["render", _U]]);
var CU = {}, fU = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vU = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), uU = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M16 13H8M16 17H8M10 9H8M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wU = [
  vU,
  uU
];
function pU(r, e) {
  return n(), o("svg", fU, wU);
}
const gU = /* @__PURE__ */ i(CU, [["render", pU]]);
var $U = {}, MU = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LU = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), kU = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M8 15V18M16 13V18M12 10.5V18M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mU = [
  LU,
  kU
];
function xU(r, e) {
  return n(), o("svg", MU, mU);
}
const gj2 = /* @__PURE__ */ i($U, [["render", xU]]);
var HU = {}, VU = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZU = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), BU = /* @__PURE__ */ t("path", {
  d: "M6 10V4.5C6 3.67157 6.67157 3 7.5 3C8.32843 3 9 3.67157 9 4.5V10C9 11.6569 7.65685 13 6 13C4.34315 13 3 11.6569 3 10V6M12.5 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V16.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FU = [
  ZU,
  BU
];
function jU(r, e) {
  return n(), o("svg", VU, FU);
}
const $j2 = /* @__PURE__ */ i(HU, [["render", jU]]);
var IU = {}, bU = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yU = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), DU = /* @__PURE__ */ t("path", {
  d: "M12.5 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V16.5M16 13H11.5M16 9H12.5M16 17H8M6 10V4.5C6 3.67157 6.67157 3 7.5 3C8.32843 3 9 3.67157 9 4.5V10C9 11.6569 7.65685 13 6 13C4.34315 13 3 11.6569 3 10V6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PU = [
  yU,
  DU
];
function AU(r, e) {
  return n(), o("svg", bU, PU);
}
const Mj2 = /* @__PURE__ */ i(IU, [["render", AU]]);
var SU = {}, TU = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OU = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), EU = /* @__PURE__ */ t("path", {
  d: "M20 7V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 18V12.5C18 11.6716 18.6716 11 19.5 11C20.3284 11 21 11.6716 21 12.5V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), RU = [
  OU,
  EU
];
function UU(r, e) {
  return n(), o("svg", TU, RU);
}
const Lj2 = /* @__PURE__ */ i(SU, [["render", UU]]);
var NU = {}, qU = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zU = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), KU = /* @__PURE__ */ t("path", {
  d: "M20 7V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M12.5 11H8M11.5 15H8M16 7H8M18 18V12.5C18 11.6716 18.6716 11 19.5 11C20.3284 11 21 11.6716 21 12.5V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GU = [
  zU,
  KU
];
function WU(r, e) {
  return n(), o("svg", qU, GU);
}
const kj2 = /* @__PURE__ */ i(NU, [["render", WU]]);
var YU = {}, XU = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QU = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -596)",
  fill: "none"
}, null, -1), JU = /* @__PURE__ */ t("path", {
  d: "M12 14V8.5C12 7.67157 12.6716 7 13.5 7C14.3284 7 15 7.67157 15 8.5V14C15 15.6569 13.6569 17 12 17C10.3431 17 9 15.6569 9 14V10M8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tN = [
  QU,
  JU
];
function eN(r, e) {
  return n(), o("svg", XU, tN);
}
const mj2 = /* @__PURE__ */ i(YU, [["render", eN]]);
var rN = {}, nN = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oN = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -636)",
  fill: "none"
}, null, -1), iN = /* @__PURE__ */ t("path", {
  d: "M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11982 22 8.79993 22H12M14.5 19L16.5 21L21 16.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lN = [
  oN,
  iN
];
function sN(r, e) {
  return n(), o("svg", nN, lN);
}
const xj2 = /* @__PURE__ */ i(rN, [["render", sN]]);
var hN = {}, aN = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dN = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -676)",
  fill: "none"
}, null, -1), cN = /* @__PURE__ */ t("path", {
  d: "M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M14.5 19L16.5 21L21 16.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _N = [
  dN,
  cN
];
function CN(r, e) {
  return n(), o("svg", aN, _N);
}
const Hj2 = /* @__PURE__ */ i(hN, [["render", CN]]);
var fN = {}, vN = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uN = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-64 -716)",
  fill: "none"
}, null, -1), wN = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9 16L11 18L15.5 13.5M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pN = [
  uN,
  wN
];
function gN(r, e) {
  return n(), o("svg", vN, pN);
}
const Vj2 = /* @__PURE__ */ i(fN, [["render", gN]]);
var $N = {}, MN = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LN = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -676)",
  fill: "none"
}, null, -1), kN = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M14 17.5L16.5 15L14 12.5M10 12.5L7.5 15L10 17.5M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mN = [
  LN,
  kN
];
function xN(r, e) {
  return n(), o("svg", MN, mN);
}
const Zj2 = /* @__PURE__ */ i($N, [["render", xN]]);
var HN = {}, VN = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZN = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -716)",
  fill: "none"
}, null, -1), BN = /* @__PURE__ */ t("path", {
  d: "M5 18.5C5 18.9644 5 19.1966 5.02567 19.3916C5.2029 20.7378 6.26222 21.7971 7.60842 21.9743C7.80337 22 8.03558 22 8.5 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V9.98822C21 9.25445 21 8.88757 20.9171 8.5423C20.8436 8.2362 20.7224 7.94356 20.5579 7.67515C20.3724 7.3724 20.113 7.11296 19.5941 6.59411L16.4059 3.40589C15.887 2.88703 15.6276 2.6276 15.3249 2.44208C15.0564 2.27759 14.7638 2.15638 14.4577 2.08289C14.1124 2 13.7455 2 13.0118 2H8.5C8.03558 2 7.80337 2 7.60842 2.02567C6.26222 2.2029 5.2029 3.26222 5.02567 4.60842C5 4.80337 5 5.03558 5 5.5M9 14.5L11.5 12L9 9.5M5 9.5L2.5 12L5 14.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FN = [
  ZN,
  BN
];
function jN(r, e) {
  return n(), o("svg", VN, FN);
}
const Bj2 = /* @__PURE__ */ i(HN, [["render", jN]]);
var IN = {}, bN = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yN = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), DN = /* @__PURE__ */ t("path", {
  d: "M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.1198 22 8.79986 22H12.5M15 19L18 22M18 22L21 19M18 22V16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PN = [
  yN,
  DN
];
function AN(r, e) {
  return n(), o("svg", bN, PN);
}
const Fj2 = /* @__PURE__ */ i(IN, [["render", AN]]);
var SN = {}, TN = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ON = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), EN = /* @__PURE__ */ t("path", {
  d: "M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.1198 22 8.79986 22H12.5M14 11H8M10 15H8M16 7H8M15 19L18 22M18 22L21 19M18 22V16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), RN = [
  ON,
  EN
];
function UN(r, e) {
  return n(), o("svg", TN, RN);
}
const jj2 = /* @__PURE__ */ i(SN, [["render", UN]]);
var NN = {}, qN = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zN = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), KN = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9 15L12 18M12 18L15 15M12 18L12 12M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GN = [
  zN,
  KN
];
function WN(r, e) {
  return n(), o("svg", qN, GN);
}
const Ij2 = /* @__PURE__ */ i(NN, [["render", WN]]);
var YN = {}, XN = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QN = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), JN = /* @__PURE__ */ t("path", {
  d: "M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M16.9973 14.8306C16.1975 13.9216 14.8639 13.6771 13.8619 14.5094C12.8599 15.3418 12.7188 16.7335 13.5057 17.7179C14.2926 18.7024 16.9973 21 16.9973 21C16.9973 21 19.7019 18.7024 20.4888 17.7179C21.2757 16.7335 21.1519 15.3331 20.1326 14.5094C19.1134 13.6858 17.797 13.9216 16.9973 14.8306Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tq = [
  QN,
  JN
];
function eq(r, e) {
  return n(), o("svg", XN, tq);
}
const bj2 = /* @__PURE__ */ i(YN, [["render", eq]]);
var rq = {}, nq = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oq = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), iq = /* @__PURE__ */ t("path", {
  d: "M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M12.5 11H8M9 15H8M16 7H8M16.9973 14.8306C16.1975 13.9216 14.8639 13.6771 13.8619 14.5094C12.8599 15.3418 12.7188 16.7335 13.5057 17.7179C14.2926 18.7024 16.9973 21 16.9973 21C16.9973 21 19.7019 18.7024 20.4888 17.7179C21.2757 16.7335 21.1519 15.3331 20.1326 14.5094C19.1134 13.6858 17.797 13.9216 16.9973 14.8306Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lq = [
  oq,
  iq
];
function sq(r, e) {
  return n(), o("svg", nq, lq);
}
const yj2 = /* @__PURE__ */ i(rq, [["render", sq]]);
var hq = {}, aq = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dq = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), cq = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2ZM11.9973 11.8306C11.1975 10.9216 9.8639 10.6771 8.86188 11.5094C7.85986 12.3418 7.71879 13.7335 8.50568 14.7179C9.29257 15.7024 11.9973 18 11.9973 18C11.9973 18 14.7019 15.7024 15.4888 14.7179C16.2757 13.7335 16.1519 12.3331 15.1326 11.5094C14.1134 10.6858 12.797 10.9216 11.9973 11.8306Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _q = [
  dq,
  cq
];
function Cq(r, e) {
  return n(), o("svg", aq, _q);
}
const Dj2 = /* @__PURE__ */ i(hq, [["render", Cq]]);
var fq = {}, vq = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uq = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-64 -236)",
  fill: "none"
}, null, -1), wq = /* @__PURE__ */ t("path", {
  d: "M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H10.5M19.25 17V15.25C19.25 14.2835 18.4665 13.5 17.5 13.5C16.5335 13.5 15.75 14.2835 15.75 15.25V17M15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.0399 21 17.7599 20.891 17.546C20.7951 17.3578 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H15.6C15.0399 17 14.7599 17 14.546 17.109C14.3578 17.2049 14.2049 17.3578 14.109 17.546C14 17.7599 14 18.0399 14 18.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pq = [
  uq,
  wq
];
function gq(r, e) {
  return n(), o("svg", vq, pq);
}
const Pj2 = /* @__PURE__ */ i(fq, [["render", gq]]);
var $q = {}, Mq = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lq = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-64 -276)",
  fill: "none"
}, null, -1), kq = /* @__PURE__ */ t("path", {
  d: "M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H10.5M13 11H8M11 15H8M16 7H8M19.25 17V15.25C19.25 14.2835 18.4665 13.5 17.5 13.5C16.5335 13.5 15.75 14.2835 15.75 15.25V17M15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.0399 21 17.7599 20.891 17.546C20.7951 17.3578 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H15.6C15.0399 17 14.7599 17 14.546 17.109C14.3578 17.2049 14.2049 17.3578 14.109 17.546C14 17.7599 14 18.0399 14 18.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mq = [
  Lq,
  kq
];
function xq(r, e) {
  return n(), o("svg", Mq, mq);
}
const Aj2 = /* @__PURE__ */ i($q, [["render", xq]]);
var Hq = {}, Vq = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zq = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-64 -316)",
  fill: "none"
}, null, -1), Bq = /* @__PURE__ */ t("path", {
  d: "M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8M14 2L20 8M14 2V8H20M13.75 14V12.25C13.75 11.2835 12.9665 10.5 12 10.5C11.0335 10.5 10.25 11.2835 10.25 12.25V14M10.1 18H13.9C14.4601 18 14.7401 18 14.954 17.891C15.1422 17.7951 15.2951 17.6422 15.391 17.454C15.5 17.2401 15.5 16.9601 15.5 16.4V15.6C15.5 15.0399 15.5 14.7599 15.391 14.546C15.2951 14.3578 15.1422 14.2049 14.954 14.109C14.7401 14 14.4601 14 13.9 14H10.1C9.53995 14 9.25992 14 9.04601 14.109C8.85785 14.2049 8.70487 14.3578 8.60899 14.546C8.5 14.7599 8.5 15.0399 8.5 15.6V16.4C8.5 16.9601 8.5 17.2401 8.60899 17.454C8.70487 17.6422 8.85785 17.7951 9.04601 17.891C9.25992 18 9.53995 18 10.1 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Fq = [
  Zq,
  Bq
];
function jq(r, e) {
  return n(), o("svg", Vq, Fq);
}
const Sj2 = /* @__PURE__ */ i(Hq, [["render", jq]]);
var Iq = {}, bq = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yq = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), Dq = /* @__PURE__ */ t("path", {
  d: "M20 11.9412V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H14M15 17H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Pq = [
  yq,
  Dq
];
function Aq(r, e) {
  return n(), o("svg", bq, Pq);
}
const Tj2 = /* @__PURE__ */ i(Iq, [["render", Aq]]);
var Sq = {}, Tq = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Oq = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), Eq = /* @__PURE__ */ t("path", {
  d: "M20 11.9412V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H14M14 11H8M10 15H8M16 7H8M15 17H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Rq = [
  Oq,
  Eq
];
function Uq(r, e) {
  return n(), o("svg", Tq, Rq);
}
const Oj2 = /* @__PURE__ */ i(Sq, [["render", Uq]]);
var Nq = {}, qq = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zq = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), Kq = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9 15H15M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Gq = [
  zq,
  Kq
];
function Wq(r, e) {
  return n(), o("svg", qq, Gq);
}
const Ej2 = /* @__PURE__ */ i(Nq, [["render", Wq]]);
var Yq = {}, Xq = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qq = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), Jq = /* @__PURE__ */ t("path", {
  d: "M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M18 21V15M15 18H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tz = [
  Qq,
  Jq
];
function ez(r, e) {
  return n(), o("svg", Xq, tz);
}
const Rj2 = /* @__PURE__ */ i(Yq, [["render", ez]]);
var rz = {}, nz = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oz = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), iz = /* @__PURE__ */ t("path", {
  d: "M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M18 21V15M15 18H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lz = [
  oz,
  iz
];
function sz(r, e) {
  return n(), o("svg", nz, lz);
}
const Uj2 = /* @__PURE__ */ i(rz, [["render", sz]]);
var hz = {}, az = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dz = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), cz = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M12 18V12M9 15H15M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _z = [
  dz,
  cz
];
function Cz(r, e) {
  return n(), o("svg", az, _z);
}
const Nj2 = /* @__PURE__ */ i(hz, [["render", Cz]]);
var fz = {}, vz = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uz = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -636)",
  fill: "none"
}, null, -1), wz = /* @__PURE__ */ t("path", {
  d: "M20 9.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H14M16.5 15.0022C16.6762 14.5014 17.024 14.079 17.4817 13.81C17.9395 13.5409 18.4777 13.4426 19.001 13.5324C19.5243 13.6221 19.999 13.8942 20.3409 14.3004C20.6829 14.7066 20.87 15.2207 20.8692 15.7517C20.8692 17.2506 18.6209 18 18.6209 18M18.65 21H18.66",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pz = [
  uz,
  wz
];
function gz(r, e) {
  return n(), o("svg", vz, pz);
}
const qj2 = /* @__PURE__ */ i(fz, [["render", gz]]);
var $z = {}, Mz = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lz = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -676)",
  fill: "none"
}, null, -1), kz = /* @__PURE__ */ t("path", {
  d: "M20 9.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H14M14 11H8M10 15H8M16 7H8M16.5 15.0022C16.6762 14.5014 17.024 14.079 17.4817 13.81C17.9395 13.5409 18.4777 13.4426 19.001 13.5324C19.5243 13.6221 19.999 13.8942 20.3409 14.3004C20.6829 14.7066 20.87 15.2207 20.8692 15.7517C20.8692 17.2506 18.6209 18 18.6209 18M18.6499 21H18.6599",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mz = [
  Lz,
  kz
];
function xz(r, e) {
  return n(), o("svg", Mz, mz);
}
const zj2 = /* @__PURE__ */ i($z, [["render", xz]]);
var Hz = {}, Vz = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zz = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -716)",
  fill: "none"
}, null, -1), Bz = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9.84998 12.0022C10.0262 11.5014 10.3739 11.079 10.8317 10.81C11.2895 10.5409 11.8277 10.4426 12.351 10.5324C12.8743 10.6221 13.349 10.8942 13.6909 11.3004C14.0329 11.7066 14.22 12.2207 14.2192 12.7517C14.2192 14.2506 11.9709 15 11.9709 15M12 18H12.01M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Fz = [
  Zz,
  Bz
];
function jz(r, e) {
  return n(), o("svg", Vz, Fz);
}
const Kj2 = /* @__PURE__ */ i(Hz, [["render", jz]]);
var Iz = {}, bz = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yz = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), Dz = /* @__PURE__ */ t("path", {
  d: "M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H11.5M22 22L20.5 20.5M21.5 18C21.5 19.933 19.933 21.5 18 21.5C16.067 21.5 14.5 19.933 14.5 18C14.5 16.067 16.067 14.5 18 14.5C19.933 14.5 21.5 16.067 21.5 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Pz = [
  yz,
  Dz
];
function Az(r, e) {
  return n(), o("svg", bz, Pz);
}
const Gj2 = /* @__PURE__ */ i(Iz, [["render", Az]]);
var Sz = {}, Tz = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Oz = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), Ez = /* @__PURE__ */ t("path", {
  d: "M14 11H8M10 15H8M16 7H8M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H11.5M22 22L20.5 20.5M21.5 18C21.5 19.933 19.933 21.5 18 21.5C16.067 21.5 14.5 19.933 14.5 18C14.5 16.067 16.067 14.5 18 14.5C19.933 14.5 21.5 16.067 21.5 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Rz = [
  Oz,
  Ez
];
function Uz(r, e) {
  return n(), o("svg", Tz, Rz);
}
const Wj2 = /* @__PURE__ */ i(Sz, [["render", Uz]]);
var Nz = {}, qz = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zz = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), Kz = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M16 18.5L14.5 17M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2ZM15.5 14.5C15.5 16.433 13.933 18 12 18C10.067 18 8.5 16.433 8.5 14.5C8.5 12.567 10.067 11 12 11C13.933 11 15.5 12.567 15.5 14.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Gz = [
  zz,
  Kz
];
function Wz(r, e) {
  return n(), o("svg", qz, Gz);
}
const Yj2 = /* @__PURE__ */ i(Nz, [["render", Wz]]);
var Yz = {}, Xz = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qz = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-64 -356)",
  fill: "none"
}, null, -1), Jz = /* @__PURE__ */ t("path", {
  d: "M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tK = [
  Qz,
  Jz
];
function eK(r, e) {
  return n(), o("svg", Xz, tK);
}
const Xj2 = /* @__PURE__ */ i(Yz, [["render", eK]]);
var rK = {}, nK = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oK = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), iK = /* @__PURE__ */ t("path", {
  d: "M14 11H8M10 15H8M16 7H8M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lK = [
  oK,
  iK
];
function sK(r, e) {
  return n(), o("svg", nK, lK);
}
const Qj2 = /* @__PURE__ */ i(rK, [["render", sK]]);
var hK = {}, aK = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dK = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), cK = /* @__PURE__ */ t("path", {
  d: "M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8M14 2L20 8M14 2V8H20M12 18C12 18 15 16.5701 15 14.4252V11.9229L12.8124 11.1412C12.2868 10.9529 11.712 10.9529 11.1864 11.1412L9 11.9229V14.4252C9 16.5701 12 18 12 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _K = [
  dK,
  cK
];
function CK(r, e) {
  return n(), o("svg", aK, _K);
}
const Jj2 = /* @__PURE__ */ i(hK, [["render", CK]]);
var fK = {}, vK = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uK = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), wK = /* @__PURE__ */ t("path", {
  d: "M20 12V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M16 16L21 21M21 16L16 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pK = [
  uK,
  wK
];
function gK(r, e) {
  return n(), o("svg", vK, pK);
}
const tI2 = /* @__PURE__ */ i(fK, [["render", gK]]);
var $K = {}, MK = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LK = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), kK = /* @__PURE__ */ t("path", {
  d: "M14 11H8M10 15H8M16 7H8M20 12V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M16 16L21 21M21 16L16 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mK = [
  LK,
  kK
];
function xK(r, e) {
  return n(), o("svg", MK, mK);
}
const eI2 = /* @__PURE__ */ i($K, [["render", xK]]);
var HK = {}, VK = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZK = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), BK = /* @__PURE__ */ t("path", {
  d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9.5 12L14.5 17M14.5 12L9.5 17M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FK = [
  ZK,
  BK
];
function jK(r, e) {
  return n(), o("svg", VK, FK);
}
const rI2 = /* @__PURE__ */ i(HK, [["render", jK]]);
var IK = {}, bK = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yK = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -876)",
  fill: "none"
}, null, -1), DK = /* @__PURE__ */ t("path", {
  d: "M2 12H22M2 7H7M17 7H22M2 17H7M17 17H22M7 22V2M17 22V2M6.8 22H17.2C18.8802 22 19.7202 22 20.362 21.673C20.9265 21.3854 21.3854 20.9265 21.673 20.362C22 19.7202 22 18.8802 22 17.2V6.8C22 5.11984 22 4.27976 21.673 3.63803C21.3854 3.07354 20.9265 2.6146 20.362 2.32698C19.7202 2 18.8802 2 17.2 2H6.8C5.11984 2 4.27976 2 3.63803 2.32698C3.07354 2.6146 2.6146 3.07354 2.32698 3.63803C2 4.27976 2 5.11984 2 6.8V17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PK = [
  yK,
  DK
];
function AK(r, e) {
  return n(), o("svg", bK, PK);
}
const nI2 = /* @__PURE__ */ i(IK, [["render", AK]]);
var SK = {}, TK = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OK = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -916)",
  fill: "none"
}, null, -1), EK = /* @__PURE__ */ t("path", {
  d: "M12 22V2M7 22V17M7 7V2M17 22V17M17 7V2M2 7H22M2 17H22M22 17.2V6.8C22 5.11984 22 4.27976 21.673 3.63803C21.3854 3.07354 20.9265 2.6146 20.362 2.32698C19.7202 2 18.8802 2 17.2 2L6.8 2C5.11984 2 4.27976 2 3.63803 2.32698C3.07354 2.6146 2.6146 3.07354 2.32698 3.63803C2 4.27976 2 5.11984 2 6.8L2 17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H17.2C18.8802 22 19.7202 22 20.362 21.673C20.9265 21.3854 21.3854 20.9265 21.673 20.362C22 19.7202 22 18.8802 22 17.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), RK = [
  OK,
  EK
];
function UK(r, e) {
  return n(), o("svg", TK, RK);
}
const oI2 = /* @__PURE__ */ i(SK, [["render", UK]]);
var NK = {}, qK = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zK = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -956)",
  fill: "none"
}, null, -1), KK = /* @__PURE__ */ t("path", {
  d: "M7 2V6M7 16V20M17 4V8M17 18V22M2 6H12M2 16H12M12 8H22M12 18H22M12 20V3.6C12 3.03995 12 2.75992 11.891 2.54601C11.7951 2.35785 11.6422 2.20487 11.454 2.10899C11.2401 2 10.9601 2 10.4 2H6.8C5.11984 2 4.27976 2 3.63803 2.32698C3.07354 2.6146 2.6146 3.07354 2.32698 3.63803C2 4.27976 2 5.11984 2 6.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20H12ZM12 4H17.2C18.8802 4 19.7202 4 20.362 4.32698C20.9265 4.6146 21.3854 5.07354 21.673 5.63803C22 6.27976 22 7.11984 22 8.8V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.7202 22 18.8802 22 17.2 22H13.6C13.0399 22 12.7599 22 12.546 21.891C12.3578 21.7951 12.2049 21.6422 12.109 21.454C12 21.2401 12 20.9601 12 20.4V4Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GK = [
  zK,
  KK
];
function WK(r, e) {
  return n(), o("svg", qK, GK);
}
const iI2 = /* @__PURE__ */ i(NK, [["render", WK]]);
var YK = {}, XK = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QK = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -636)",
  fill: "none"
}, null, -1), JK = /* @__PURE__ */ t("path", {
  d: "M2 4.6C2 4.03995 2 3.75992 2.10899 3.54601C2.20487 3.35785 2.35785 3.20487 2.54601 3.10899C2.75992 3 3.03995 3 3.6 3H20.4C20.9601 3 21.2401 3 21.454 3.10899C21.6422 3.20487 21.7951 3.35785 21.891 3.54601C22 3.75992 22 4.03995 22 4.6V5.26939C22 5.53819 22 5.67259 21.9672 5.79756C21.938 5.90831 21.8901 6.01323 21.8255 6.10776C21.7526 6.21443 21.651 6.30245 21.4479 6.4785L15.0521 12.0215C14.849 12.1975 14.7474 12.2856 14.6745 12.3922C14.6099 12.4868 14.562 12.5917 14.5328 12.7024C14.5 12.8274 14.5 12.9618 14.5 13.2306V18.4584C14.5 18.6539 14.5 18.7517 14.4685 18.8363C14.4406 18.911 14.3953 18.9779 14.3363 19.0315C14.2695 19.0922 14.1787 19.1285 13.9971 19.2012L10.5971 20.5612C10.2296 20.7082 10.0458 20.7817 9.89827 20.751C9.76927 20.7242 9.65605 20.6476 9.58325 20.5377C9.5 20.4122 9.5 20.2142 9.5 19.8184V13.2306C9.5 12.9618 9.5 12.8274 9.46715 12.7024C9.43805 12.5917 9.39014 12.4868 9.32551 12.3922C9.25258 12.2856 9.15102 12.1975 8.94789 12.0215L2.55211 6.4785C2.34898 6.30245 2.24742 6.21443 2.17449 6.10776C2.10986 6.01323 2.06195 5.90831 2.03285 5.79756C2 5.67259 2 5.53819 2 5.26939V4.6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tG = [
  QK,
  JK
];
function eG(r, e) {
  return n(), o("svg", XK, tG);
}
const lI2 = /* @__PURE__ */ i(YK, [["render", eG]]);
var rG = {}, nG = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oG = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -676)",
  fill: "none"
}, null, -1), iG = /* @__PURE__ */ t("path", {
  d: "M3.38589 5.66687C2.62955 4.82155 2.25138 4.39889 2.23712 4.03968C2.22473 3.72764 2.35882 3.42772 2.59963 3.22889C2.87684 3 3.44399 3 4.57828 3H19.4212C20.5555 3 21.1227 3 21.3999 3.22889C21.6407 3.42772 21.7748 3.72764 21.7624 4.03968C21.7481 4.39889 21.3699 4.82155 20.6136 5.66687L14.9074 12.0444C14.7566 12.2129 14.6812 12.2972 14.6275 12.3931C14.5798 12.4781 14.5448 12.5697 14.5236 12.6648C14.4997 12.7721 14.4997 12.8852 14.4997 13.1113V18.4584C14.4997 18.6539 14.4997 18.7517 14.4682 18.8363C14.4403 18.911 14.395 18.9779 14.336 19.0315C14.2692 19.0922 14.1784 19.1285 13.9969 19.2012L10.5969 20.5612C10.2293 20.7082 10.0455 20.7817 9.89802 20.751C9.76901 20.7242 9.6558 20.6476 9.583 20.5377C9.49975 20.4122 9.49975 20.2142 9.49975 19.8184V13.1113C9.49975 12.8852 9.49975 12.7721 9.47587 12.6648C9.45469 12.5697 9.41971 12.4781 9.37204 12.3931C9.31828 12.2972 9.2429 12.2129 9.09213 12.0444L3.38589 5.66687Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lG = [
  oG,
  iG
];
function sG(r, e) {
  return n(), o("svg", nG, lG);
}
const sI2 = /* @__PURE__ */ i(rG, [["render", sG]]);
var hG = {}, aG = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dG = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -716)",
  fill: "none"
}, null, -1), cG = /* @__PURE__ */ t("path", {
  d: "M6 12H18M3 6H21M9 18H15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _G = [
  dG,
  cG
];
function CG(r, e) {
  return n(), o("svg", aG, _G);
}
const hI2 = /* @__PURE__ */ i(hG, [["render", CG]]);
var fG = {}, vG = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uG = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), wG = /* @__PURE__ */ t("path", {
  d: "M6.91822 3.38565C8.40742 2.50524 10.1447 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0331 21.9998 12.0662 21.9995 12.0993M3.38114 6.92585C2.50352 8.41335 2 10.1479 2 12C2 16.6596 5.18693 20.5748 9.5 21.685M20.7076 16.9206C19.3872 19.2522 17.1574 21.001 14.5 21.685M14.0893 6.37378C13.4387 6.13207 12.7348 6 12 6C8.68629 6 6 8.68629 6 12C6 12.7387 6.13351 13.4463 6.37772 14.0999M17.6251 9.90767C17.8675 10.5591 18 11.2641 18 12C18 15.3137 15.3137 18 12 18C11.2701 18 10.5707 17.8697 9.92373 17.631M12 10V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pG = [
  uG,
  wG
];
function gG(r, e) {
  return n(), o("svg", vG, pG);
}
const aI2 = /* @__PURE__ */ i(fG, [["render", gG]]);
var $G = {}, MG = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LG = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), kG = /* @__PURE__ */ t("path", {
  d: "M12 10V14M7.44712 3.42103C8.73941 2.52503 10.3084 2 12 2C16.4183 2 20 5.58172 20 10V11.2367M4.41632 7.44607C4.14633 8.24809 4 9.10696 4 10V14C4 17.6349 6.42416 20.7035 9.74396 21.6775M19.6588 16.3187C18.9294 18.7314 17.0911 20.6626 14.7367 21.5196M14.325 6.14635C13.6464 5.7361 12.8508 5.5 12 5.5C9.51472 5.5 7.5 7.51472 7.5 10V12.95M16.5 11.04V14C16.5 16.4853 14.4853 18.5 12 18.5C11.1514 18.5 10.3576 18.2651 9.68014 17.8567",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mG = [
  LG,
  kG
];
function xG(r, e) {
  return n(), o("svg", MG, mG);
}
const dI2 = /* @__PURE__ */ i($G, [["render", xG]]);
var HG = {}, VG = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZG = /* @__PURE__ */ a('<rect width="1144" height="580" transform="translate(-336 -196)" fill="none"></rect><path d="M8.10008 21.221C6.71021 19.2375 5.89258 16.8243 5.89258 14.2187C5.89258 10.8443 8.6265 8.10938 11.9989 8.10938C15.3712 8.10938 18.1051 10.8443 18.1051 14.2187" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.10008 21.221C6.71021 19.2375 5.89258 16.8243 5.89258 14.2187C5.89258 10.8443 8.6265 8.10938 11.9989 8.10938C15.3712 8.10938 18.1051 10.8443 18.1051 14.2187" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.4359 20.3118C18.3259 20.3179 18.218 20.3281 18.107 20.3281C14.7347 20.3281 12.0007 17.5931 12.0007 14.2188" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.4361 20.3118C18.3262 20.3179 18.2182 20.3281 18.1073 20.3281C14.7349 20.3281 12.001 17.5931 12.001 14.2188" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.2694 21.9999C10.675 20.382 8.94705 17.5024 8.94705 14.2187C8.94705 12.5315 10.3145 11.164 12.0007 11.164C13.6869 11.164 15.0543 12.5315 15.0543 14.2187C15.0543 15.9059 16.4218 17.2733 18.108 17.2733C19.7942 17.2733 21.1616 15.9059 21.1616 14.2187C21.1616 9.1571 17.0602 5.05469 12.0017 5.05469C6.94319 5.05469 2.8418 9.1571 2.8418 14.2187C2.8418 15.3469 2.96806 16.4455 3.20021 17.5045" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.2694 21.9999C10.675 20.382 8.94705 17.5024 8.94705 14.2187C8.94705 12.5315 10.3145 11.164 12.0007 11.164C13.6869 11.164 15.0543 12.5315 15.0543 14.2187C15.0543 15.9059 16.4218 17.2733 18.108 17.2733C19.7942 17.2733 21.1616 15.9059 21.1616 14.2187C21.1616 9.1571 17.0602 5.05469 12.0017 5.05469C6.94319 5.05469 2.8418 9.1571 2.8418 14.2187C2.8418 15.3469 2.96806 16.4455 3.20021 17.5045" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20.5257 5.86313C18.4435 3.4978 15.399 2 12.0002 2C8.60136 2 5.55687 3.4978 3.47461 5.86313" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20.5257 5.86313C18.4435 3.4978 15.399 2 12.0002 2C8.60136 2 5.55687 3.4978 3.47461 5.86313" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>', 9), BG = [
  ZG
];
function FG(r, e) {
  return n(), o("svg", VG, BG);
}
const cI2 = /* @__PURE__ */ i(HG, [["render", FG]]);
var jG = {}, IG = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bG = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), yG = /* @__PURE__ */ t("path", {
  d: "M5.80688 18.5304C5.82459 18.5005 5.84273 18.4709 5.8613 18.4413C7.2158 16.2881 7.99991 13.7418 7.99991 11C7.99991 8.79086 9.79077 7 11.9999 7C14.209 7 15.9999 8.79086 15.9999 11C15.9999 12.017 15.9307 13.0186 15.7966 14M13.6792 20.8436C14.2909 19.6226 14.7924 18.3369 15.1707 17M19.0097 18.132C19.6547 15.8657 20 13.4732 20 11C20 6.58172 16.4183 3 12 3C10.5429 3 9.17669 3.38958 8 4.07026M3 15.3641C3.64066 14.0454 4 12.5646 4 11C4 9.54285 4.38958 8.17669 5.07026 7M11.9999 11C11.9999 14.5172 10.9911 17.7988 9.24707 20.5712",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DG = [
  bG,
  yG
];
function PG(r, e) {
  return n(), o("svg", IG, DG);
}
const _I2 = /* @__PURE__ */ i(jG, [["render", PG]]);
var AG = {}, SG = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TG = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -396)",
  fill: "none"
}, null, -1), OG = /* @__PURE__ */ t("path", {
  d: "M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3L4 22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EG = [
  TG,
  OG
];
function RG(r, e) {
  return n(), o("svg", SG, EG);
}
const CI2 = /* @__PURE__ */ i(AG, [["render", RG]]);
var UG = {}, NG = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qG = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), zG = /* @__PURE__ */ t("path", {
  d: "M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V4C20 4 19 5 16 5C13 5 11 3 8 3C5 3 4 4 4 4M4 22L4 2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KG = [
  qG,
  zG
];
function GG(r, e) {
  return n(), o("svg", NG, KG);
}
const fI2 = /* @__PURE__ */ i(UG, [["render", GG]]);
var WG = {}, YG = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XG = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), QG = /* @__PURE__ */ t("path", {
  d: "M4 13H19.587C20.0495 13 20.2808 13 20.4128 12.903C20.528 12.8185 20.6015 12.6887 20.6147 12.5464C20.63 12.3833 20.511 12.185 20.273 11.7884L18.247 8.4116C18.1572 8.26195 18.1123 8.18712 18.0947 8.10724C18.0792 8.03659 18.0792 7.96341 18.0947 7.89276C18.1123 7.81288 18.1572 7.73805 18.247 7.5884L20.273 4.2116C20.511 3.81503 20.63 3.61674 20.6147 3.45359C20.6015 3.31133 20.528 3.18154 20.4128 3.09698C20.2808 3 20.0495 3 19.587 3H4L4 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JG = [
  XG,
  QG
];
function tW(r, e) {
  return n(), o("svg", YG, JG);
}
const vI2 = /* @__PURE__ */ i(WG, [["render", tW]]);
var eW = {}, rW = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nW = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), oW = /* @__PURE__ */ t("path", {
  d: "M13.5 6.5H19.7056C20.1342 6.5 20.3485 6.5 20.4776 6.59027C20.5903 6.6691 20.6655 6.79086 20.6856 6.92692C20.7086 7.08273 20.6128 7.27442 20.4211 7.65777L19.1688 10.1623C19.1068 10.2864 19.0758 10.3485 19.0626 10.4137C19.051 10.4714 19.0496 10.5308 19.0586 10.5891C19.0688 10.6548 19.097 10.7182 19.1533 10.845L20.5 13.8751C20.6667 14.25 20.75 14.4374 20.7227 14.5888C20.6988 14.721 20.6227 14.8381 20.5116 14.9136C20.3844 15 20.1793 15 19.769 15H12.1C11.5399 15 11.2599 15 11.046 14.891C10.8578 14.7951 10.7049 14.6422 10.609 14.454C10.5 14.2401 10.5 13.9601 10.5 13.4V11M3 21L3 3.5M3 11H11.9C12.4601 11 12.7401 11 12.954 10.891C13.1422 10.7951 13.2951 10.6422 13.391 10.454C13.5 10.2401 13.5 9.96005 13.5 9.4V4.1C13.5 3.53995 13.5 3.25992 13.391 3.04601C13.2951 2.85785 13.1422 2.70487 12.954 2.60899C12.7401 2.5 12.4601 2.5 11.9 2.5L4.6 2.5C4.03995 2.5 3.75992 2.5 3.54601 2.60899C3.35785 2.70487 3.20487 2.85785 3.10899 3.04601C3 3.25992 3 3.53995 3 4.1V11Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iW = [
  nW,
  oW
];
function lW(r, e) {
  return n(), o("svg", rW, iW);
}
const uI2 = /* @__PURE__ */ i(eW, [["render", lW]]);
var sW = {}, hW = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aW = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), dW = /* @__PURE__ */ t("path", {
  d: "M14.1111 6.72217H20.1404C20.5877 6.72217 20.8114 6.72217 20.9422 6.81621C21.0563 6.89826 21.1306 7.02456 21.1469 7.16416C21.1656 7.32417 21.057 7.51967 20.8398 7.91068L19.3702 10.5559C19.2914 10.6977 19.252 10.7686 19.2366 10.8437C19.2229 10.9101 19.2229 10.9787 19.2366 11.0451C19.252 11.1202 19.2914 11.1911 19.3702 11.3329L20.8398 13.9781C21.057 14.3691 21.1656 14.5646 21.1469 14.7246C21.1306 14.8642 21.0563 14.9905 20.9422 15.0726C20.8114 15.1666 20.5877 15.1666 20.1404 15.1666H12.5445C11.9844 15.1666 11.7044 15.1666 11.4905 15.0576C11.3023 14.9617 11.1493 14.8088 11.0535 14.6206C10.9445 14.4067 10.9445 14.1267 10.9445 13.5666V10.9444M7.25004 21.5002L3.02782 4.61133M4.6112 10.9444H12.5112C13.0712 10.9444 13.3512 10.9444 13.5651 10.8355C13.7533 10.7396 13.9063 10.5866 14.0022 10.3984C14.1112 10.1845 14.1112 9.9045 14.1112 9.34445V4.1C14.1112 3.53995 14.1112 3.25992 14.0022 3.04601C13.9063 2.85785 13.7533 2.70487 13.5651 2.60899C13.3512 2.5 13.0712 2.5 12.5112 2.5H4.54927C3.85075 2.5 3.50149 2.5 3.2626 2.64474C3.05323 2.77159 2.89767 2.97084 2.82538 3.20472C2.74291 3.47158 2.82762 3.81041 2.99704 4.48807L4.6112 10.9444Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cW = [
  aW,
  dW
];
function _W(r, e) {
  return n(), o("svg", hW, cW);
}
const wI2 = /* @__PURE__ */ i(sW, [["render", _W]]);
var CW = {}, fW = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vW = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-64 -596)",
  fill: "none"
}, null, -1), uW = /* @__PURE__ */ t("path", {
  d: "M4 21L4 4M4 13H11.4C11.9601 13 12.2401 13 12.454 12.891C12.6422 12.7951 12.7951 12.6422 12.891 12.454C13 12.2401 13 11.9601 13 11.4V4.6C13 4.03995 13 3.75992 12.891 3.54601C12.7951 3.35785 12.6422 3.20487 12.454 3.10899C12.2401 3 11.9601 3 11.4 3H5.6C5.03995 3 4.75992 3 4.54601 3.10899C4.35785 3.20487 4.20487 3.35785 4.10899 3.54601C4 3.75992 4 4.03995 4 4.6V13ZM13 5H19.4C19.9601 5 20.2401 5 20.454 5.10899C20.6422 5.20487 20.7951 5.35785 20.891 5.54601C21 5.75992 21 6.03995 21 6.6V13.4C21 13.9601 21 14.2401 20.891 14.454C20.7951 14.6422 20.6422 14.7951 20.454 14.891C20.2401 15 19.9601 15 19.4 15H14.6C14.0399 15 13.7599 15 13.546 14.891C13.3578 14.7951 13.2049 14.6422 13.109 14.454C13 14.2401 13 13.9601 13 13.4V5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wW = [
  vW,
  uW
];
function pW(r, e) {
  return n(), o("svg", fW, wW);
}
const pI2 = /* @__PURE__ */ i(CW, [["render", pW]]);
var gW = {}, $W = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MW = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), LW = /* @__PURE__ */ t("path", {
  d: "M8 8L4.09346 12.6879C3.74465 13.1064 3.57024 13.3157 3.56758 13.4925C3.56526 13.6461 3.63373 13.7923 3.75326 13.8889C3.89075 14 4.16318 14 4.70803 14H12L11 22L16 16M15.65 10H19.292C19.8368 10 20.1093 10 20.2467 10.1111C20.3663 10.2077 20.4347 10.3539 20.4324 10.5075C20.4298 10.6843 20.2554 10.8936 19.9065 11.3121L18.5502 12.9397M10.5728 4.91265L13 2L12.4002 6.79771M21 21L3 3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kW = [
  MW,
  LW
];
function mW(r, e) {
  return n(), o("svg", $W, kW);
}
const gI2 = /* @__PURE__ */ i(gW, [["render", mW]]);
var xW = {}, HW = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VW = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), ZW = /* @__PURE__ */ t("path", {
  d: "M13 2L4.09344 12.6879C3.74463 13.1064 3.57023 13.3157 3.56756 13.4925C3.56524 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9065 11.3121C20.2553 10.8936 20.4297 10.6843 20.4324 10.5075C20.4347 10.3539 20.3663 10.2077 20.2467 10.1111C20.1092 10 19.8368 10 19.292 10H12L13 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BW = [
  VW,
  ZW
];
function FW(r, e) {
  return n(), o("svg", HW, BW);
}
const $I2 = /* @__PURE__ */ i(xW, [["render", FW]]);
var jW = {}, IW = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bW = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), yW = /* @__PURE__ */ t("path", {
  d: "M17.5 17.6L6.5 17.6M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DW = [
  bW,
  yW
];
function PW(r, e) {
  return n(), o("svg", IW, DW);
}
const MI2 = /* @__PURE__ */ i(jW, [["render", PW]]);
var AW = {}, SW = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TW = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), OW = /* @__PURE__ */ t("path", {
  d: "M6.5 17.5L6.5 6.5M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EW = [
  TW,
  OW
];
function RW(r, e) {
  return n(), o("svg", SW, EW);
}
const LI2 = /* @__PURE__ */ i(AW, [["render", RW]]);
var UW = {}, NW = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qW = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), zW = /* @__PURE__ */ t("path", {
  d: "M17.5 17.5L17.5 6.5M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KW = [
  qW,
  zW
];
function GW(r, e) {
  return n(), o("svg", NW, KW);
}
const kI2 = /* @__PURE__ */ i(UW, [["render", GW]]);
var WW = {}, YW = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XW = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), QW = /* @__PURE__ */ t("path", {
  d: "M17.5 6.5L6.5 6.5M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JW = [
  XW,
  QW
];
function tY(r, e) {
  return n(), o("svg", YW, JW);
}
const mI2 = /* @__PURE__ */ i(WW, [["render", tY]]);
var eY = {}, rY = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nY = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), oY = /* @__PURE__ */ t("path", {
  d: "M3 9H16.5C18.9853 9 21 11.0147 21 13.5C21 15.9853 18.9853 18 16.5 18H12M3 9L7 5M3 9L7 13",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iY = [
  nY,
  oY
];
function lY(r, e) {
  return n(), o("svg", rY, iY);
}
const xI2 = /* @__PURE__ */ i(eY, [["render", lY]]);
var sY = {}, hY = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aY = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), dY = /* @__PURE__ */ t("path", {
  d: "M21 9H7.5C5.01472 9 3 11.0147 3 13.5C3 15.9853 5.01472 18 7.5 18H12M21 9L17 5M21 9L17 13",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cY = [
  aY,
  dY
];
function _Y(r, e) {
  return n(), o("svg", hY, cY);
}
const HI2 = /* @__PURE__ */ i(sY, [["render", _Y]]);
var CY = {}, fY = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vY = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), uY = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM9 14L11 16L15.5 11.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wY = [
  vY,
  uY
];
function pY(r, e) {
  return n(), o("svg", fY, wY);
}
const VI2 = /* @__PURE__ */ i(CY, [["render", pY]]);
var gY = {}, $Y = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MY = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -716)",
  fill: "none"
}, null, -1), LY = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM9.5 11.5L14.5 16.5M16 14C16 16.2091 14.2091 18 12 18C9.79086 18 8 16.2091 8 14C8 11.7909 9.79086 10 12 10C14.2091 10 16 11.7909 16 14Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kY = [
  MY,
  LY
];
function mY(r, e) {
  return n(), o("svg", $Y, kY);
}
const ZI2 = /* @__PURE__ */ i(gY, [["render", mY]]);
var xY = {}, HY = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VY = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), ZY = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM14 16.5L16.5 14L14 11.5M10 11.5L7.5 14L10 16.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BY = [
  VY,
  ZY
];
function FY(r, e) {
  return n(), o("svg", HY, BY);
}
const BI2 = /* @__PURE__ */ i(xY, [["render", FY]]);
var jY = {}, IY = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bY = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), yY = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM9 14L12 17M12 17L15 14M12 17V11",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DY = [
  bY,
  yY
];
function PY(r, e) {
  return n(), o("svg", IY, DY);
}
const FI2 = /* @__PURE__ */ i(jY, [["render", PY]]);
var AY = {}, SY = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TY = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), OY = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM10.1 17.5H13.9C14.4601 17.5 14.7401 17.5 14.954 17.391C15.1422 17.2951 15.2951 17.1422 15.391 16.954C15.5 16.7401 15.5 16.4601 15.5 15.9V15.1C15.5 14.5399 15.5 14.2599 15.391 14.046C15.2951 13.8578 15.1422 13.7049 14.954 13.609C14.7401 13.5 14.4601 13.5 13.9 13.5H10.1C9.53995 13.5 9.25992 13.5 9.04601 13.609C8.85785 13.7049 8.70487 13.8578 8.60899 14.046C8.5 14.2599 8.5 14.5399 8.5 15.1V15.9C8.5 16.4601 8.5 16.7401 8.60899 16.954C8.70487 17.1422 8.85785 17.2951 9.04601 17.391C9.25992 17.5 9.53995 17.5 10.1 17.5ZM13.75 13.5V11.75C13.75 10.7835 12.9665 10 12 10C11.0335 10 10.25 10.7835 10.25 11.75V13.5H13.75Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EY = [
  TY,
  OY
];
function RY(r, e) {
  return n(), o("svg", SY, EY);
}
const jI2 = /* @__PURE__ */ i(AY, [["render", RY]]);
var UY = {}, NY = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qY = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), zY = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM9 14H15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KY = [
  qY,
  zY
];
function GY(r, e) {
  return n(), o("svg", NY, KY);
}
const II2 = /* @__PURE__ */ i(UY, [["render", GY]]);
var WY = {}, YY = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XY = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), QY = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM12 17V11M9 14H15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JY = [
  XY,
  QY
];
function tX(r, e) {
  return n(), o("svg", YY, JY);
}
const bI2 = /* @__PURE__ */ i(WY, [["render", tX]]);
var eX = {}, rX = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nX = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -636)",
  fill: "none"
}, null, -1), oX = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM9.8501 11.7522C10.0263 11.2514 10.3741 10.829 10.8318 10.56C11.2896 10.2909 11.8278 10.1926 12.3511 10.2824C12.8744 10.3721 13.3491 10.6442 13.691 11.0504C14.033 11.4566 14.2201 11.9707 14.2193 12.5017C14.2193 14.0006 11.971 14.75 11.971 14.75M12 17.75H12.01",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iX = [
  nX,
  oX
];
function lX(r, e) {
  return n(), o("svg", rX, iX);
}
const yI2 = /* @__PURE__ */ i(eX, [["render", lX]]);
var sX = {}, hX = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aX = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -676)",
  fill: "none"
}, null, -1), dX = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM15.5 17.5L14 16M15 13.5C15 15.433 13.433 17 11.5 17C9.567 17 8 15.433 8 13.5C8 11.567 9.567 10 11.5 10C13.433 10 15 11.567 15 13.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cX = [
  aX,
  dX
];
function _X(r, e) {
  return n(), o("svg", hX, cX);
}
const DI2 = /* @__PURE__ */ i(sX, [["render", _X]]);
var CX = {}, fX = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vX = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), uX = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM12 17.5C12 17.5 15 16.0701 15 13.9252V11.4229L12.8124 10.6412C12.2868 10.4529 11.712 10.4529 11.1864 10.6412L9 11.4229V13.9252C9 16.0701 12 17.5 12 17.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wX = [
  vX,
  uX
];
function pX(r, e) {
  return n(), o("svg", fX, wX);
}
const PI2 = /* @__PURE__ */ i(CX, [["render", pX]]);
var gX = {}, $X = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MX = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), LX = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM9.5 11.5L14.5 16.5M14.5 11.5L9.5 16.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kX = [
  MX,
  LX
];
function mX(r, e) {
  return n(), o("svg", $X, kX);
}
const AI2 = /* @__PURE__ */ i(gX, [["render", mX]]);
var xX = {}, HX = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VX = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), ZX = /* @__PURE__ */ t("path", {
  d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BX = [
  VX,
  ZX
];
function FX(r, e) {
  return n(), o("svg", HX, BX);
}
const SI2 = /* @__PURE__ */ i(xX, [["render", FX]]);
var jX = {}, IX = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bX = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -716)",
  fill: "none"
}, null, -1), yX = /* @__PURE__ */ t("path", {
  d: "M12 15.5V22.5L5 15.5M5 15.5V8.5H12M5 15.5H19L12 8.5M12 8.5H19V1.5H5L12 8.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DX = [
  bX,
  yX
];
function PX(r, e) {
  return n(), o("svg", IX, DX);
}
const TI2 = /* @__PURE__ */ i(jX, [["render", PX]]);
var AX = {}, SX = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TX = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -996)",
  fill: "none"
}, null, -1), OX = /* @__PURE__ */ t("path", {
  d: "M5.99989 11H9.99989M7.99989 9V13M14.9999 12H15.0099M17.9999 10H18.0099M10.4488 5H13.5509C16.1758 5 17.4883 5 18.5184 5.49743C19.4254 5.9354 20.179 6.63709 20.6805 7.51059C21.2501 8.5027 21.3436 9.81181 21.5306 12.43L21.7766 15.8745C21.8973 17.5634 20.5597 19 18.8664 19C18.0005 19 17.1794 18.6154 16.6251 17.9502L16.2499 17.5C15.9068 17.0882 15.7351 16.8823 15.5398 16.7159C15.1302 16.3672 14.6344 16.1349 14.1043 16.0436C13.8514 16 13.5834 16 13.0473 16H10.9525C10.4164 16 10.1484 16 9.89553 16.0436C9.36539 16.1349 8.86957 16.3672 8.46 16.7159C8.26463 16.8823 8.09305 17.0882 7.74989 17.5L7.37473 17.9502C6.8204 18.6154 5.99924 19 5.13335 19C3.44013 19 2.1025 17.5634 2.22314 15.8745L2.46918 12.43C2.65619 9.81181 2.7497 8.5027 3.31926 7.51059C3.82074 6.63709 4.57433 5.9354 5.48135 5.49743C6.51151 5 7.82396 5 10.4488 5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EX = [
  TX,
  OX
];
function RX(r, e) {
  return n(), o("svg", SX, EX);
}
const OI2 = /* @__PURE__ */ i(AX, [["render", RX]]);
var UX = {}, NX = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qX = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -1036)",
  fill: "none"
}, null, -1), zX = /* @__PURE__ */ t("path", {
  d: "M6 12H10M8 10V14M15 13H15.01M18 11H18.01M5.2 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V9.2C22 8.0799 22 7.51984 21.782 7.09202C21.5903 6.71569 21.2843 6.40973 20.908 6.21799C20.4802 6 19.9201 6 18.8 6H5.2C4.07989 6 3.51984 6 3.09202 6.21799C2.71569 6.40973 2.40973 6.71569 2.21799 7.09202C2 7.51984 2 8.07989 2 9.2V14.8C2 15.9201 2 16.4802 2.21799 16.908C2.40973 17.2843 2.71569 17.5903 3.09202 17.782C3.51984 18 4.0799 18 5.2 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KX = [
  qX,
  zX
];
function GX(r, e) {
  return n(), o("svg", NX, KX);
}
const EI2 = /* @__PURE__ */ i(UX, [["render", GX]]);
var WX = {}, YX = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XX = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -636)",
  fill: "none"
}, null, -1), QX = /* @__PURE__ */ t("path", {
  d: "M12 6V22M12 6H8.46429C7.94332 6 7.4437 5.78929 7.07533 5.41421C6.70695 5.03914 6.5 4.53043 6.5 4C6.5 3.46957 6.70695 2.96086 7.07533 2.58579C7.4437 2.21071 7.94332 2 8.46429 2C11.2143 2 12 6 12 6ZM12 6H15.5357C16.0567 6 16.5563 5.78929 16.9247 5.41421C17.293 5.03914 17.5 4.53043 17.5 4C17.5 3.46957 17.293 2.96086 16.9247 2.58579C16.5563 2.21071 16.0567 2 15.5357 2C12.7857 2 12 6 12 6ZM20 11V18.8C20 19.9201 20 20.4802 19.782 20.908C19.5903 21.2843 19.2843 21.5903 18.908 21.782C18.4802 22 17.9201 22 16.8 22L7.2 22C6.07989 22 5.51984 22 5.09202 21.782C4.71569 21.5903 4.40973 21.2843 4.21799 20.908C4 20.4802 4 19.9201 4 18.8V11M2 7.6L2 9.4C2 9.96005 2 10.2401 2.10899 10.454C2.20487 10.6422 2.35785 10.7951 2.54601 10.891C2.75992 11 3.03995 11 3.6 11L20.4 11C20.9601 11 21.2401 11 21.454 10.891C21.6422 10.7951 21.7951 10.6422 21.891 10.454C22 10.2401 22 9.96005 22 9.4V7.6C22 7.03995 22 6.75992 21.891 6.54601C21.7951 6.35785 21.6422 6.20487 21.454 6.10899C21.2401 6 20.9601 6 20.4 6L3.6 6C3.03995 6 2.75992 6 2.54601 6.10899C2.35785 6.20487 2.20487 6.35785 2.10899 6.54601C2 6.75992 2 7.03995 2 7.6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JX = [
  XX,
  QX
];
function tQ(r, e) {
  return n(), o("svg", YX, JX);
}
const RI2 = /* @__PURE__ */ i(WX, [["render", tQ]]);
var eQ = {}, rQ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nQ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -676)",
  fill: "none"
}, null, -1), oQ = /* @__PURE__ */ t("path", {
  d: "M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7ZM12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7ZM12 7L12 22M2 14H22M2 10.2L2 18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22L18.8 22C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V10.2C22 9.0799 22 8.51984 21.782 8.09202C21.5903 7.7157 21.2843 7.40974 20.908 7.21799C20.4802 7 19.9201 7 18.8 7L5.2 7C4.0799 7 3.51984 7 3.09202 7.21799C2.7157 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iQ = [
  nQ,
  oQ
];
function lQ(r, e) {
  return n(), o("svg", rQ, iQ);
}
const UI2 = /* @__PURE__ */ i(eQ, [["render", lQ]]);
var sQ = {}, hQ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aQ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), dQ = /* @__PURE__ */ t("path", {
  d: "M3 3V13.2C3 14.8802 3 15.7202 3.32698 16.362C3.6146 16.9265 4.07354 17.3854 4.63803 17.673C5.27976 18 6.11984 18 7.8 18H15M15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18ZM3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cQ = [
  aQ,
  dQ
];
function _Q(r, e) {
  return n(), o("svg", hQ, cQ);
}
const NI2 = /* @__PURE__ */ i(sQ, [["render", _Q]]);
var CQ = {}, fQ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vQ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), uQ = /* @__PURE__ */ t("path", {
  d: "M6 3V15M6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21C7.65685 21 9 19.6569 9 18M6 15C7.65685 15 9 16.3431 9 18M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9ZM18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wQ = [
  vQ,
  uQ
];
function pQ(r, e) {
  return n(), o("svg", fQ, wQ);
}
const qI2 = /* @__PURE__ */ i(CQ, [["render", pQ]]);
var gQ = {}, $Q = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MQ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), LQ = /* @__PURE__ */ t("path", {
  d: "M16 12C16 14.2091 14.2091 16 12 16C9.79085 16 7.99999 14.2091 7.99999 12M16 12C16 9.79086 14.2091 8 12 8C9.79085 8 7.99999 9.79086 7.99999 12M16 12H22M7.99999 12H2.00018",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kQ = [
  MQ,
  LQ
];
function mQ(r, e) {
  return n(), o("svg", $Q, kQ);
}
const zI2 = /* @__PURE__ */ i(gQ, [["render", mQ]]);
var xQ = {}, HQ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VQ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), ZQ = /* @__PURE__ */ t("path", {
  d: "M15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18ZM15 18C12.6131 18 10.3239 17.0518 8.63604 15.364C6.94821 13.6761 6 11.3869 6 9M6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM6 9V21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BQ = [
  VQ,
  ZQ
];
function FQ(r, e) {
  return n(), o("svg", HQ, BQ);
}
const KI2 = /* @__PURE__ */ i(xQ, [["render", FQ]]);
var jQ = {}, IQ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bQ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), yQ = /* @__PURE__ */ t("path", {
  d: "M18 15C16.3431 15 15 16.3431 15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15ZM18 15V8C18 7.46957 17.7893 6.96086 17.4142 6.58579C17.0391 6.21071 16.5304 6 16 6H13M6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM6 9V21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DQ = [
  bQ,
  yQ
];
function PQ(r, e) {
  return n(), o("svg", IQ, DQ);
}
const GI2 = /* @__PURE__ */ i(jQ, [["render", PQ]]);
var AQ = {}, SQ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TQ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), OQ = /* @__PURE__ */ t("path", {
  d: "M10 11.5347C11.2335 10.8218 12.7663 10.8218 13.9999 11.5347M8.82843 9.17157C10.3905 10.7337 10.3905 13.2663 8.82843 14.8284C7.26634 16.3905 4.73367 16.3905 3.17157 14.8284C1.60948 13.2663 1.60948 10.7337 3.17157 9.17157C4.73366 7.60948 7.26633 7.60948 8.82843 9.17157ZM20.8284 9.17157C22.3905 10.7337 22.3905 13.2663 20.8284 14.8284C19.2663 16.3905 16.7337 16.3905 15.1716 14.8284C13.6095 13.2663 13.6095 10.7337 15.1716 9.17157C16.7337 7.60948 19.2663 7.60948 20.8284 9.17157Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EQ = [
  TQ,
  OQ
];
function RQ(r, e) {
  return n(), o("svg", SQ, EQ);
}
const WI2 = /* @__PURE__ */ i(AQ, [["render", RQ]]);
var UQ = {}, NQ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qQ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), zQ = /* @__PURE__ */ t("path", {
  d: "M10 14.5347C11.2335 13.8218 12.7663 13.8218 13.9999 14.5347M2 15L2.70149 7.98511C2.72808 7.71915 2.74138 7.58617 2.76178 7.47208C3.00222 6.12702 4.1212 5.11436 5.48352 5.00894C5.59907 5 5.73271 5 6 5M22 15L21.2985 7.98511C21.2719 7.71916 21.2586 7.58617 21.2382 7.47208C20.9978 6.12702 19.8788 5.11436 18.5165 5.00894C18.4009 5 18.2673 5 18 5M8.82843 12.1716C10.3905 13.7337 10.3905 16.2663 8.82843 17.8284C7.26634 19.3905 4.73367 19.3905 3.17157 17.8284C1.60948 16.2663 1.60948 13.7337 3.17157 12.1716C4.73366 10.6095 7.26633 10.6095 8.82843 12.1716ZM20.8284 12.1716C22.3905 13.7337 22.3905 16.2663 20.8284 17.8284C19.2663 19.3905 16.7337 19.3905 15.1716 17.8284C13.6095 16.2663 13.6095 13.7337 15.1716 12.1716C16.7337 10.6095 19.2663 10.6095 20.8284 12.1716Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KQ = [
  qQ,
  zQ
];
function GQ(r, e) {
  return n(), o("svg", NQ, KQ);
}
const YI2 = /* @__PURE__ */ i(UQ, [["render", GQ]]);
var WQ = {}, YQ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XQ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), QQ = /* @__PURE__ */ t("path", {
  d: "M2 12H22M2 12C2 17.5228 6.47715 22 12 22M2 12C2 6.47715 6.47715 2 12 2M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22M12 2C9.49872 4.73835 8.07725 8.29203 8 12C8.07725 15.708 9.49872 19.2616 12 22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JQ = [
  XQ,
  QQ
];
function tJ(r, e) {
  return n(), o("svg", YQ, JQ);
}
const XI2 = /* @__PURE__ */ i(WQ, [["render", tJ]]);
var eJ = {}, rJ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nJ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), oJ = /* @__PURE__ */ t("path", {
  d: "M18.6317 2.36816C23.1227 6.85919 23.1227 14.1406 18.6317 18.6316C14.3308 22.9325 7.47094 23.1146 2.95335 19.178C2.75634 19.0064 2.65783 18.9205 2.61336 18.8032C2.57595 18.7044 2.57176 18.5824 2.60232 18.4813C2.63863 18.3612 2.73705 18.2628 2.93388 18.0659L5.14913 15.8507M17.9999 10.4999C17.9999 14.642 14.6421 17.9999 10.4999 17.9999C6.35779 17.9999 2.99992 14.642 2.99992 10.4999C2.99992 6.35776 6.35779 2.99989 10.4999 2.99989C14.6421 2.99989 17.9999 6.35776 17.9999 10.4999Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iJ = [
  nJ,
  oJ
];
function lJ(r, e) {
  return n(), o("svg", rJ, iJ);
}
const QI2 = /* @__PURE__ */ i(eJ, [["render", lJ]]);
var sJ = {}, hJ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aJ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), dJ = /* @__PURE__ */ t("path", {
  d: "M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22M12 2C9.49872 4.73835 8.07725 8.29203 8 12C8.07725 15.708 9.49872 19.2616 12 22M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22M2.50002 9H21.5M2.5 15H21.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cJ = [
  aJ,
  dJ
];
function _J(r, e) {
  return n(), o("svg", hJ, cJ);
}
const JI2 = /* @__PURE__ */ i(sJ, [["render", _J]]);
var CJ = {}, fJ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vJ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), uJ = /* @__PURE__ */ t("path", {
  d: "M2.66113 18.3391L7.25499 13.7452M18.2175 2.78271C21.9275 6.4927 21.9275 12.5078 18.2175 16.2177C14.5075 19.9277 8.49243 19.9277 4.78245 16.2177M17 22.0002H6.99997M12 22.0002V19.0002M17.5 9.50023C17.5 12.8139 14.8137 15.5002 11.5 15.5002C8.18626 15.5002 5.49997 12.8139 5.49997 9.50023C5.49997 6.18652 8.18626 3.50023 11.5 3.50023C14.8137 3.50023 17.5 6.18652 17.5 9.50023Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wJ = [
  vJ,
  uJ
];
function pJ(r, e) {
  return n(), o("svg", fJ, wJ);
}
const tb2 = /* @__PURE__ */ i(CJ, [["render", pJ]]);
var gJ = {}, $J = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MJ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), LJ = /* @__PURE__ */ t("path", {
  d: "M12 2C15 4 15.9228 8.29203 16 12C15.9228 15.708 15 20 12 22M12 2C9 4 8.07725 8.29203 8 12C8.07725 15.708 9 20 12 22M12 2C6.47715 2 2 6.47715 2 12M12 2C17.5228 2 22 6.47715 22 12M12 22C17.5229 22 22 17.5228 22 12M12 22C6.47716 22 2 17.5228 2 12M22 12C20 15 15.708 15.9228 12 16C8.29203 15.9228 4 15 2 12M22 12C20 9 15.708 8.07725 12 8C8.29203 8.07725 4 9 2 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kJ = [
  MJ,
  LJ
];
function mJ(r, e) {
  return n(), o("svg", $J, kJ);
}
const eb2 = /* @__PURE__ */ i(gJ, [["render", mJ]]);
var xJ = {}, HJ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VJ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), ZJ = /* @__PURE__ */ t("path", {
  d: "M3.07598 7.48282L7.36402 10.5457C7.58715 10.705 7.69872 10.7847 7.81548 10.8031C7.91821 10.8192 8.02343 10.8029 8.11648 10.7565C8.22223 10.7037 8.30449 10.594 8.46901 10.3747L9.37511 9.16652C9.42164 9.10448 9.4449 9.07347 9.47224 9.04671C9.49652 9.02295 9.52315 9.00173 9.55173 8.98338C9.58392 8.9627 9.61935 8.94696 9.6902 8.91546L13.5588 7.19609C13.7192 7.12482 13.7993 7.08918 13.8598 7.03352C13.9133 6.9843 13.9554 6.924 13.9832 6.85684C14.0146 6.78091 14.0204 6.69336 14.0321 6.51826L14.3154 2.2694M13.5 13.5L16.116 14.6211C16.4195 14.7512 16.5713 14.8163 16.6517 14.9243C16.7222 15.0191 16.7569 15.1358 16.7496 15.2537C16.7413 15.3881 16.6497 15.5255 16.4665 15.8002L15.2375 17.6438C15.1507 17.774 15.1072 17.8391 15.0499 17.8863C14.9991 17.928 14.9406 17.9593 14.8777 17.9784C14.8067 18 14.7284 18 14.5719 18H12.5766C12.3693 18 12.2656 18 12.1774 17.9653C12.0995 17.9347 12.0305 17.885 11.9768 17.8208C11.916 17.7481 11.8832 17.6497 11.8177 17.453L11.1048 15.3144C11.0661 15.1983 11.0468 15.1403 11.0417 15.0814C11.0372 15.0291 11.0409 14.9764 11.0528 14.9253C11.0662 14.8677 11.0935 14.813 11.1482 14.7036L11.6897 13.6206C11.7997 13.4005 11.8547 13.2905 11.9395 13.2222C12.0141 13.162 12.1046 13.1246 12.1999 13.1143C12.3081 13.1027 12.4248 13.1416 12.6582 13.2194L13.5 13.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BJ = [
  VJ,
  ZJ
];
function FJ(r, e) {
  return n(), o("svg", HJ, BJ);
}
const rb2 = /* @__PURE__ */ i(xJ, [["render", FJ]]);
var jJ = {}, IJ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bJ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), yJ = /* @__PURE__ */ t("path", {
  d: "M15 2.4578C14.053 2.16035 13.0452 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 10.2847 21.5681 8.67022 20.8071 7.25945M17 5.75H17.005M10.5001 21.8883L10.5002 19.6849C10.5002 19.5656 10.5429 19.4502 10.6205 19.3596L13.1063 16.4594C13.3106 16.2211 13.2473 15.8556 12.9748 15.6999L10.1185 14.0677C10.0409 14.0234 9.97663 13.9591 9.93234 13.8814L8.07046 10.6186C7.97356 10.4488 7.78657 10.3511 7.59183 10.3684L2.06418 10.8607M21 6C21 8.20914 19 10 17 12C15 10 13 8.20914 13 6C13 3.79086 14.7909 2 17 2C19.2091 2 21 3.79086 21 6ZM17.25 5.75C17.25 5.88807 17.1381 6 17 6C16.8619 6 16.75 5.88807 16.75 5.75C16.75 5.61193 16.8619 5.5 17 5.5C17.1381 5.5 17.25 5.61193 17.25 5.75Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DJ = [
  bJ,
  yJ
];
function PJ(r, e) {
  return n(), o("svg", IJ, DJ);
}
const nb2 = /* @__PURE__ */ i(jJ, [["render", PJ]]);
var AJ = {}, SJ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TJ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), OJ = /* @__PURE__ */ t("path", {
  d: "M2.68675 15.6451L4.59494 14.5435C4.6983 14.4839 4.8196 14.4631 4.9369 14.4851L8.6914 15.1878C8.99995 15.2455 9.28478 15.008 9.28338 14.6941L9.26876 11.4045C9.26836 11.3151 9.29193 11.2272 9.33701 11.15L11.2317 7.90621C11.3303 7.73739 11.3215 7.52658 11.2091 7.3666L8.01892 2.82568M19.0002 4.85905C13.5002 7.50004 16.5 11 17.5002 11.5C19.3773 12.4384 21.9876 12.5 21.9876 12.5C21.9958 12.3344 22 12.1677 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.1677 22 12.3344 21.9959 12.5 21.9877M16.7578 21.9398L13.591 13.591L21.9398 16.7578L18.2376 18.2376L16.7578 21.9398Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EJ = [
  TJ,
  OJ
];
function RJ(r, e) {
  return n(), o("svg", SJ, EJ);
}
const ob2 = /* @__PURE__ */ i(AJ, [["render", RJ]]);
var UJ = {}, NJ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qJ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -756)",
  fill: "none"
}, null, -1), zJ = /* @__PURE__ */ t("path", {
  d: "M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM12 8H21.17M3.95 6.06L8.54 14M10.88 21.94L15.46 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KJ = [
  qJ,
  zJ
];
function GJ(r, e) {
  return n(), o("svg", NJ, KJ);
}
const ib2 = /* @__PURE__ */ i(UJ, [["render", GJ]]);
var WJ = {}, YJ = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XJ = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), QJ = /* @__PURE__ */ t("path", {
  d: "M5 10.0001V16.0112C5 16.3702 5 16.5496 5.05465 16.7081C5.10299 16.8482 5.18187 16.9759 5.28558 17.0817C5.40287 17.2015 5.5634 17.2818 5.88446 17.4423L11.2845 20.1423C11.5468 20.2735 11.678 20.3391 11.8156 20.3649C11.9375 20.3877 12.0625 20.3877 12.1844 20.3649C12.322 20.3391 12.4532 20.2735 12.7155 20.1423L18.1155 17.4423C18.4366 17.2818 18.5971 17.2015 18.7144 17.0817C18.8181 16.9759 18.897 16.8482 18.9453 16.7081C19 16.5496 19 16.3702 19 16.0112V10.0001M2 8.50006L11.6422 3.67895C11.7734 3.61336 11.839 3.58056 11.9078 3.56766C11.9687 3.55622 12.0313 3.55622 12.0922 3.56766C12.161 3.58056 12.2266 3.61336 12.3578 3.67895L22 8.50006L12.3578 13.3212C12.2266 13.3868 12.161 13.4196 12.0922 13.4325C12.0313 13.4439 11.9687 13.4439 11.9078 13.4325C11.839 13.4196 11.7734 13.3868 11.6422 13.3212L2 8.50006Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JJ = [
  XJ,
  QJ
];
function t11(r, e) {
  return n(), o("svg", YJ, JJ);
}
const lb2 = /* @__PURE__ */ i(WJ, [["render", t11]]);
var e11 = {}, r11 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, n11 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), o11 = /* @__PURE__ */ t("path", {
  d: "M17 14.5001V11.4945C17 11.315 17 11.2253 16.9727 11.146C16.9485 11.076 16.9091 11.0122 16.8572 10.9592C16.7986 10.8993 16.7183 10.8592 16.5578 10.779L12 8.50006M4 9.50006V16.3067C4 16.6786 4 16.8645 4.05802 17.0274C4.10931 17.1713 4.1929 17.3016 4.30238 17.4082C4.42622 17.5287 4.59527 17.6062 4.93335 17.7612L11.3334 20.6945C11.5786 20.8069 11.7012 20.8631 11.8289 20.8853C11.9421 20.9049 12.0579 20.9049 12.1711 20.8853C12.2988 20.8631 12.4214 20.8069 12.6666 20.6945L19.0666 17.7612C19.4047 17.6062 19.5738 17.5287 19.6976 17.4082C19.8071 17.3016 19.8907 17.1713 19.942 17.0274C20 16.8645 20 16.6786 20 16.3067V9.50006M2 8.50006L11.6422 3.67895C11.7734 3.61336 11.839 3.58056 11.9078 3.56766C11.9687 3.55622 12.0313 3.55622 12.0922 3.56766C12.161 3.58056 12.2266 3.61336 12.3578 3.67895L22 8.50006L12.3578 13.3212C12.2266 13.3868 12.161 13.4196 12.0922 13.4325C12.0313 13.4439 11.9687 13.4439 11.9078 13.4325C11.839 13.4196 11.7734 13.3868 11.6422 13.3212L2 8.50006Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), i11 = [
  n11,
  o11
];
function l11(r, e) {
  return n(), o("svg", r11, i11);
}
const sb2 = /* @__PURE__ */ i(e11, [["render", l11]]);
var s11 = {}, h11 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, a11 = /* @__PURE__ */ a('<rect width="1144" height="860" transform="translate(-336 -396)" fill="none"></rect><path d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>', 5), d11 = [
  a11
];
function c11(r, e) {
  return n(), o("svg", h11, d11);
}
const hb2 = /* @__PURE__ */ i(s11, [["render", c11]]);
var _11 = {}, C11 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, f11 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), v11 = /* @__PURE__ */ t("path", {
  d: "M8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.0799 3 6.2V8M8 21H6.2C5.0799 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V16M21 8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H16M21 16V17.8C21 18.9201 21 19.4802 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H16M12 17L12 7M7 12H17",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), u11 = [
  f11,
  v11
];
function w11(r, e) {
  return n(), o("svg", C11, u11);
}
const ab2 = /* @__PURE__ */ i(_11, [["render", w11]]);
var p11 = {}, g11 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $11 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), M11 = /* @__PURE__ */ t("path", {
  d: "M8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.0799 3 6.2V8M8 21H6.2C5.0799 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V16M21 8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H16M21 16V17.8C21 18.9201 21 19.4802 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H16M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), L11 = [
  $11,
  M11
];
function k11(r, e) {
  return n(), o("svg", g11, L11);
}
const db2 = /* @__PURE__ */ i(p11, [["render", k11]]);
var m11 = {}, x11 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H11 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), V11 = /* @__PURE__ */ t("path", {
  d: "M3 3H3.01M3 12H3.01M3 21H3.01M3 16.5H3.01M3 7.5H3.01M7.5 3H7.51M7.5 12H7.51M7.5 21H7.51M16.5 3H16.51M16.5 12H16.51M16.5 21H16.51M12 3H12.01M12 12H12.01M12 21H12.01M12 16.5H12.01M12 7.5H12.01M21 3H21.01M21 12H21.01M21 21H21.01M21 16.5H21.01M21 7.5H21.01",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Z11 = [
  H11,
  V11
];
function B11(r, e) {
  return n(), o("svg", x11, Z11);
}
const cb2 = /* @__PURE__ */ i(m11, [["render", B11]]);
var F11 = {}, j11 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, I11 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), b11 = /* @__PURE__ */ t("path", {
  d: "M3 3H3.01M3 12H3.01M3 16.5H3.01M3 7.5H3.01M7.5 3H7.51M7.5 12H7.51M16.5 3H16.51M16.5 12H16.51M12 3H12.01M12 12H12.01M12 16.5H12.01M12 7.5H12.01M21 3H21.01M21 12H21.01M21 16.5H21.01M21 7.5H21.01M21 21H3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), y11 = [
  I11,
  b11
];
function D11(r, e) {
  return n(), o("svg", j11, y11);
}
const _b2 = /* @__PURE__ */ i(F11, [["render", D11]]);
var P11 = {}, A11 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S11 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), T11 = /* @__PURE__ */ t("path", {
  d: "M3 3H3.01M3 12H3.01M3 21H3.01M3 16.5H3.01M3 7.5H3.01M7.5 3H7.51M7.5 12H7.51M7.5 21H7.51M16.5 3H16.51M16.5 12H16.51M16.5 21H16.51M21 3H21.01M21 12H21.01M21 21H21.01M21 16.5H21.01M21 7.5H21.01M12 21V3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), O11 = [
  S11,
  T11
];
function E11(r, e) {
  return n(), o("svg", A11, O11);
}
const Cb2 = /* @__PURE__ */ i(P11, [["render", E11]]);
var R11 = {}, U11 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, N11 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -636)",
  fill: "none"
}, null, -1), q11 = /* @__PURE__ */ t("path", {
  d: "M7.5 3H7.51M7.5 12H7.51M7.5 21H7.51M16.5 3H16.51M16.5 12H16.51M16.5 21H16.51M12 3H12.01M12 12H12.01M12 21H12.01M12 16.5H12.01M12 7.5H12.01M21 3H21.01M21 12H21.01M21 21H21.01M21 16.5H21.01M21 7.5H21.01M3 21V3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), z11 = [
  N11,
  q11
];
function K11(r, e) {
  return n(), o("svg", U11, z11);
}
const fb2 = /* @__PURE__ */ i(R11, [["render", K11]]);
var G11 = {}, W11 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y11 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -676)",
  fill: "none"
}, null, -1), X11 = /* @__PURE__ */ t("path", {
  d: "M7.5 12H7.51M16.5 12H16.51M12 12H12.01M12 16.5H12.01M12 7.5H12.01M3 7.8L3 16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27977 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3L7.8 3C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Q11 = [
  Y11,
  X11
];
function J11(r, e) {
  return n(), o("svg", W11, Q11);
}
const vb2 = /* @__PURE__ */ i(G11, [["render", J11]]);
var t21 = {}, e21 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r21 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -716)",
  fill: "none"
}, null, -1), n21 = /* @__PURE__ */ t("path", {
  d: "M7.5 3H7.51M7.5 12H7.51M7.5 21H7.51M16.5 3H16.51M16.5 12H16.51M16.5 21H16.51M12 3H12.01M12 12H12.01M12 21H12.01M12 16.5H12.01M12 7.5H12.01M3 3H3.01M3 12H3.01M3 21H3.01M3 16.5H3.01M3 7.5H3.01M21 21V3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), o21 = [
  r21,
  n21
];
function i21(r, e) {
  return n(), o("svg", e21, o21);
}
const ub2 = /* @__PURE__ */ i(t21, [["render", i21]]);
var l21 = {}, s21 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h21 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-336 -756)",
  fill: "none"
}, null, -1), a21 = /* @__PURE__ */ t("path", {
  d: "M3 21H3.01M3 12H3.01M3 16.5H3.01M3 7.5H3.01M7.5 21H7.51M7.5 12H7.51M16.5 21H16.51M16.5 12H16.51M12 21H12.01M12 12H12.01M12 16.5H12.01M12 7.5H12.01M21 21H21.01M21 12H21.01M21 16.5H21.01M21 7.5H21.01M21 3H3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), d21 = [
  h21,
  a21
];
function c21(r, e) {
  return n(), o("svg", s21, d21);
}
const wb2 = /* @__PURE__ */ i(l21, [["render", c21]]);
var _21 = {}, C21 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, f21 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), v21 = /* @__PURE__ */ t("path", {
  d: "M3 3H3.01M3 21H3.01M3 16.5H3.01M3 7.5H3.01M7.5 3H7.51M7.5 21H7.51M16.5 3H16.51M16.5 21H16.51M12 3H12.01M12 21H12.01M12 16.5H12.01M12 7.5H12.01M21 3H21.01M21 21H21.01M21 16.5H21.01M21 7.5H21.01M21 12H3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), u21 = [
  f21,
  v21
];
function w21(r, e) {
  return n(), o("svg", C21, u21);
}
const pb2 = /* @__PURE__ */ i(_21, [["render", w21]]);
var p21 = {}, g21 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $21 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -756)",
  fill: "none"
}, null, -1), M21 = /* @__PURE__ */ t("path", {
  d: "M6.9 11.4444V14.2222M6.9 11.4444V4.77778C6.9 3.8573 7.66112 3.11111 8.6 3.11111C9.53888 3.11111 10.3 3.8573 10.3 4.77778M6.9 11.4444C6.9 10.524 6.13888 9.77778 5.2 9.77778C4.26112 9.77778 3.5 10.524 3.5 11.4444V13.6667C3.5 18.269 7.30558 22 12 22C16.6944 22 20.5 18.269 20.5 13.6667V8.11111C20.5 7.19064 19.7389 6.44444 18.8 6.44444C17.8611 6.44444 17.1 7.19064 17.1 8.11111M10.3 4.77778V10.8889M10.3 4.77778V3.66667C10.3 2.74619 11.0611 2 12 2C12.9389 2 13.7 2.74619 13.7 3.66667V4.77778M13.7 4.77778V10.8889M13.7 4.77778C13.7 3.8573 14.4611 3.11111 15.4 3.11111C16.3389 3.11111 17.1 3.8573 17.1 4.77778V8.11111M17.1 8.11111V10.8889",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), L21 = [
  $21,
  M21
];
function k21(r, e) {
  return n(), o("svg", g21, L21);
}
const gb2 = /* @__PURE__ */ i(p21, [["render", k21]]);
var m21 = {}, x21 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H21 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -1076)",
  fill: "none"
}, null, -1), V21 = /* @__PURE__ */ t("path", {
  d: "M2.5 12H21.5M6 16H10M8.96656 4H15.0334C16.1103 4 16.6487 4 17.1241 4.16396C17.5445 4.30896 17.9274 4.5456 18.2451 4.85675C18.6043 5.2086 18.8451 5.6902 19.3267 6.65337L21.4932 10.9865C21.6822 11.3645 21.7767 11.5535 21.8434 11.7515C21.9026 11.9275 21.9453 12.1085 21.971 12.2923C22 12.4992 22 12.7105 22 13.1331V15.2C22 16.8802 22 17.7202 21.673 18.362C21.3854 18.9265 20.9265 19.3854 20.362 19.673C19.7202 20 18.8802 20 17.2 20H6.8C5.11984 20 4.27976 20 3.63803 19.673C3.07354 19.3854 2.6146 18.9265 2.32698 18.362C2 17.7202 2 16.8802 2 15.2V13.1331C2 12.7105 2 12.4992 2.02897 12.2923C2.05471 12.1085 2.09744 11.9275 2.15662 11.7515C2.22326 11.5535 2.31776 11.3645 2.50675 10.9865L4.67331 6.65337C5.1549 5.69019 5.3957 5.2086 5.75495 4.85675C6.07263 4.5456 6.45551 4.30896 6.87589 4.16396C7.35125 4 7.88969 4 8.96656 4Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Z21 = [
  H21,
  V21
];
function B21(r, e) {
  return n(), o("svg", x21, Z21);
}
const $b2 = /* @__PURE__ */ i(m21, [["render", B21]]);
var F21 = {}, j21 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, I21 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -796)",
  fill: "none"
}, null, -1), b21 = /* @__PURE__ */ t("path", {
  d: "M4 8H20M4 16H20M8 3V21M16 3V21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), y21 = [
  I21,
  b21
];
function D21(r, e) {
  return n(), o("svg", j21, y21);
}
const Mb2 = /* @__PURE__ */ i(F21, [["render", D21]]);
var P21 = {}, A21 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S21 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -836)",
  fill: "none"
}, null, -1), T21 = /* @__PURE__ */ t("path", {
  d: "M9.49999 3L6.49999 21M17.5 3L14.5 21M20.5 8H3.5M19.5 16H2.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), O21 = [
  S21,
  T21
];
function E21(r, e) {
  return n(), o("svg", A21, O21);
}
const Lb2 = /* @__PURE__ */ i(P21, [["render", E21]]);
var R21 = {}, U21 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, N21 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -796)",
  fill: "none"
}, null, -1), q21 = /* @__PURE__ */ t("path", {
  d: "M6 4V20M18 4V20M8 4H4M18 12L6 12M8 20H4M20 20H16M20 4H16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), z21 = [
  N21,
  q21
];
function K21(r, e) {
  return n(), o("svg", U21, z21);
}
const kb2 = /* @__PURE__ */ i(R21, [["render", K21]]);
var G21 = {}, W21 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y21 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -836)",
  fill: "none"
}, null, -1), X21 = /* @__PURE__ */ t("path", {
  d: "M6 4V20M18 4V20M9.5 4V20M11.5 4H4M18 12H9.5M11.5 20H4M20 20H16M20 4H16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Q21 = [
  Y21,
  X21
];
function J21(r, e) {
  return n(), o("svg", W21, Q21);
}
const mb2 = /* @__PURE__ */ i(G21, [["render", J21]]);
var t01 = {}, e01 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r01 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -876)",
  fill: "none"
}, null, -1), n01 = /* @__PURE__ */ t("path", {
  d: "M8 7V17M16 7V17M16 12L8 12M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), o01 = [
  r01,
  n01
];
function i01(r, e) {
  return n(), o("svg", e01, o01);
}
const xb2 = /* @__PURE__ */ i(t01, [["render", i01]]);
var l01 = {}, s01 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h01 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -1116)",
  fill: "none"
}, null, -1), a01 = /* @__PURE__ */ t("path", {
  d: "M21 18V12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12V18M5.5 21C4.11929 21 3 19.8807 3 18.5V16.5C3 15.1193 4.11929 14 5.5 14C6.88071 14 8 15.1193 8 16.5V18.5C8 19.8807 6.88071 21 5.5 21ZM18.5 21C17.1193 21 16 19.8807 16 18.5V16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5V18.5C21 19.8807 19.8807 21 18.5 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), d01 = [
  h01,
  a01
];
function c01(r, e) {
  return n(), o("svg", s01, d01);
}
const Hb2 = /* @__PURE__ */ i(l01, [["render", c01]]);
var _01 = {}, C01 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, f01 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -1156)",
  fill: "none"
}, null, -1), v01 = /* @__PURE__ */ t("path", {
  d: "M22 17V13C22 7.47715 17.5228 3 12 3C6.47715 3 2 7.47715 2 13V17M7.5 21C6.11929 21 5 19.8807 5 18.5V15.5C5 14.1193 6.11929 13 7.5 13C8.88071 13 10 14.1193 10 15.5V18.5C10 19.8807 8.88071 21 7.5 21ZM16.5 21C15.1193 21 14 19.8807 14 18.5V15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V18.5C19 19.8807 17.8807 21 16.5 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), u01 = [
  f01,
  v01
];
function w01(r, e) {
  return n(), o("svg", C01, u01);
}
const Vb2 = /* @__PURE__ */ i(_01, [["render", w01]]);
var p01 = {}, g01 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $01 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -916)",
  fill: "none"
}, null, -1), M01 = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), L01 = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9966 9.06791C10.9969 7.8992 9.32987 7.58482 8.07735 8.65501C6.82482 9.72519 6.64848 11.5145 7.6321 12.7802C8.26211 13.5909 9.87558 15.0942 10.9542 16.0704C11.3127 16.3947 11.4919 16.5569 11.7066 16.622C11.8911 16.6779 12.102 16.6779 12.2866 16.622C12.5012 16.5569 12.6805 16.3947 13.0389 16.0704C14.1176 15.0942 15.731 13.5909 16.3611 12.7802C17.3447 11.5145 17.1899 9.71393 15.9158 8.65501C14.6417 7.59608 12.9963 7.8992 11.9966 9.06791Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), k01 = [
  $01,
  M01,
  L01
];
function m01(r, e) {
  return n(), o("svg", g01, k01);
}
const Zb2 = /* @__PURE__ */ i(p01, [["render", m01]]);
var x01 = {}, H01 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V01 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -956)",
  fill: "none"
}, null, -1), Z01 = /* @__PURE__ */ t("path", {
  d: "M6 20.0872H8.61029C8.95063 20.0872 9.28888 20.1277 9.61881 20.2087L12.3769 20.8789C12.9753 21.0247 13.5988 21.0389 14.2035 20.9214L17.253 20.3281C18.0585 20.1712 18.7996 19.7855 19.3803 19.2205L21.5379 17.1217C22.154 16.5234 22.154 15.5524 21.5379 14.9531C20.9832 14.4135 20.1047 14.3527 19.4771 14.8103L16.9626 16.6449C16.6025 16.9081 16.1643 17.0498 15.7137 17.0498H13.2855L14.8311 17.0498C15.7022 17.0498 16.4079 16.3633 16.4079 15.5159V15.2092C16.4079 14.5055 15.9156 13.892 15.2141 13.7219L12.8286 13.1418C12.4404 13.0476 12.0428 13 11.6431 13C10.6783 13 8.93189 13.7988 8.93189 13.7988L6 15.0249M2 14.6L2 20.4C2 20.9601 2 21.2401 2.10899 21.454C2.20487 21.6422 2.35785 21.7951 2.54601 21.891C2.75992 22 3.03995 22 3.6 22H4.4C4.96005 22 5.24008 22 5.45399 21.891C5.64215 21.7952 5.79513 21.6422 5.89101 21.454C6 21.2401 6 20.9601 6 20.4V14.6C6 14.04 6 13.7599 5.89101 13.546C5.79513 13.3579 5.64215 13.2049 5.45399 13.109C5.24008 13 4.96005 13 4.4 13H3.6C3.03995 13 2.75992 13 2.54601 13.109C2.35785 13.2049 2.20487 13.3579 2.10899 13.546C2 13.7599 2 14.04 2 14.6ZM17.1914 3.59227C16.5946 2.34341 15.2186 1.6818 13.8804 2.32039C12.5423 2.95898 11.9722 4.4734 12.5325 5.80284C12.8787 6.62448 13.8707 8.22002 14.5781 9.31905C14.8394 9.72513 14.9701 9.92817 15.161 10.0469C15.3247 10.1488 15.5297 10.2037 15.7224 10.1974C15.9471 10.1899 16.1618 10.0794 16.5911 9.85845C17.7532 9.26033 19.4101 8.37457 20.1208 7.83614C21.2707 6.96494 21.5556 5.36359 20.6947 4.14626C19.8337 2.92892 18.3327 2.80914 17.1914 3.59227Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), B01 = [
  V01,
  Z01
];
function F01(r, e) {
  return n(), o("svg", H01, B01);
}
const Bb2 = /* @__PURE__ */ i(x01, [["render", F01]]);
var j01 = {}, I01 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, b01 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -996)",
  fill: "none"
}, null, -1), y01 = /* @__PURE__ */ t("path", {
  d: "M11.223 2.43164C11.5066 2.27409 11.6484 2.19531 11.7985 2.16442C11.9315 2.13709 12.0685 2.13709 12.2015 2.16442C12.3516 2.19531 12.4934 2.27409 12.777 2.43164L20.177 6.54276C20.4766 6.70916 20.6263 6.79236 20.7354 6.9107C20.8318 7.01539 20.9049 7.13947 20.9495 7.27464C21 7.42744 21 7.59876 21 7.94141V16.0585C21 16.4012 21 16.5725 20.9495 16.7253C20.9049 16.8605 20.8318 16.9845 20.7354 17.0892C20.6263 17.2076 20.4766 17.2908 20.177 17.4572L12.777 21.5683C12.4934 21.7258 12.3516 21.8046 12.2015 21.8355C12.0685 21.8628 11.9315 21.8628 11.7985 21.8355C11.6484 21.8046 11.5066 21.7258 11.223 21.5683L3.82297 17.4572C3.52345 17.2908 3.37369 17.2076 3.26463 17.0892C3.16816 16.9845 3.09515 16.8605 3.05048 16.7253C3 16.5725 3 16.4012 3 16.0585V7.94141C3 7.59876 3 7.42744 3.05048 7.27464C3.09515 7.13947 3.16816 7.01539 3.26463 6.9107C3.37369 6.79236 3.52345 6.70916 3.82297 6.54276L11.223 2.43164Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), D01 = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9966 9.06787C10.9969 7.89916 9.32987 7.58478 8.07735 8.65497C6.82482 9.72515 6.64848 11.5145 7.6321 12.7802C8.26211 13.5909 9.87558 15.0942 10.9542 16.0703C11.3127 16.3947 11.4919 16.5569 11.7066 16.6219C11.8911 16.6779 12.102 16.6779 12.2866 16.6219C12.5012 16.5569 12.6805 16.3947 13.0389 16.0703C14.1176 15.0942 15.731 13.5909 16.3611 12.7802C17.3447 11.5145 17.1899 9.7139 15.9158 8.65497C14.6417 7.59604 12.9963 7.89916 11.9966 9.06787Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), P01 = [
  b01,
  y01,
  D01
];
function A01(r, e) {
  return n(), o("svg", I01, P01);
}
const Fb2 = /* @__PURE__ */ i(j01, [["render", A01]]);
var S01 = {}, T01 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O01 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1036)",
  fill: "none"
}, null, -1), E01 = /* @__PURE__ */ t("path", {
  d: "M7.39137 2.46863C7.56432 2.29568 7.6508 2.2092 7.75172 2.14736C7.84119 2.09253 7.93873 2.05213 8.04077 2.02763C8.15586 2 8.27815 2 8.52274 2H15.4773C15.7218 2 15.8441 2 15.9592 2.02763C16.0613 2.05213 16.1588 2.09253 16.2483 2.14736C16.3492 2.2092 16.4357 2.29568 16.6086 2.46863L21.5314 7.39137C21.7043 7.56432 21.7908 7.6508 21.8526 7.75172C21.9075 7.84119 21.9479 7.93873 21.9724 8.04077C22 8.15586 22 8.27815 22 8.52274V15.4773C22 15.7218 22 15.8441 21.9724 15.9592C21.9479 16.0613 21.9075 16.1588 21.8526 16.2483C21.7908 16.3492 21.7043 16.4357 21.5314 16.6086L16.6086 21.5314C16.4357 21.7043 16.3492 21.7908 16.2483 21.8526C16.1588 21.9075 16.0613 21.9479 15.9592 21.9724C15.8441 22 15.7218 22 15.4773 22H8.52274C8.27815 22 8.15586 22 8.04077 21.9724C7.93873 21.9479 7.84119 21.9075 7.75172 21.8526C7.6508 21.7908 7.56432 21.7043 7.39137 21.5314L2.46863 16.6086C2.29568 16.4357 2.2092 16.3492 2.14736 16.2483C2.09253 16.1588 2.05213 16.0613 2.02763 15.9592C2 15.8441 2 15.7218 2 15.4773V8.52274C2 8.27815 2 8.15586 2.02763 8.04077C2.05213 7.93873 2.09253 7.84119 2.14736 7.75172C2.2092 7.6508 2.29568 7.56432 2.46863 7.39137L7.39137 2.46863Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), R01 = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9966 9.06791C10.9969 7.8992 9.32987 7.58482 8.07735 8.65501C6.82482 9.72519 6.64848 11.5145 7.6321 12.7802C8.26211 13.5909 9.87558 15.0942 10.9542 16.0704C11.3127 16.3947 11.4919 16.5569 11.7066 16.622C11.8911 16.6779 12.102 16.6779 12.2866 16.622C12.5012 16.5569 12.6805 16.3947 13.0389 16.0704C14.1176 15.0942 15.731 13.5909 16.3611 12.7802C17.3447 11.5145 17.1899 9.71393 15.9158 8.65501C14.6417 7.59608 12.9963 7.8992 11.9966 9.06791Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), U01 = [
  O01,
  E01,
  R01
];
function N01(r, e) {
  return n(), o("svg", T01, U01);
}
const jb2 = /* @__PURE__ */ i(S01, [["render", N01]]);
var q01 = {}, z01 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, K01 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1076)",
  fill: "none"
}, null, -1), G01 = /* @__PURE__ */ t("path", {
  d: "M16.1111 3C19.6333 3 22 6.3525 22 9.48C22 15.8138 12.1778 21 12 21C11.8222 21 2 15.8138 2 9.48C2 6.3525 4.36667 3 7.88889 3C9.91111 3 11.2333 4.02375 12 4.92375C12.7667 4.02375 14.0889 3 16.1111 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), W01 = [
  K01,
  G01
];
function Y01(r, e) {
  return n(), o("svg", z01, W01);
}
const Ib2 = /* @__PURE__ */ i(q01, [["render", Y01]]);
var X01 = {}, Q01 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, J01 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1116)",
  fill: "none"
}, null, -1), t41 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), e41 = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9966 9.06791C10.9969 7.8992 9.32987 7.58482 8.07735 8.65501C6.82482 9.72519 6.64848 11.5145 7.6321 12.7802C8.26211 13.5909 9.87558 15.0942 10.9542 16.0704C11.3127 16.3947 11.4919 16.5569 11.7066 16.622C11.8911 16.6779 12.102 16.6779 12.2866 16.622C12.5012 16.5569 12.6805 16.3947 13.0389 16.0704C14.1176 15.0942 15.731 13.5909 16.3611 12.7802C17.3447 11.5145 17.1899 9.71393 15.9158 8.65501C14.6417 7.59608 12.9963 7.8992 11.9966 9.06791Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), r41 = [
  J01,
  t41,
  e41
];
function n41(r, e) {
  return n(), o("svg", Q01, r41);
}
const bb2 = /* @__PURE__ */ i(X01, [["render", n41]]);
var o41 = {}, i41 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, l41 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -876)",
  fill: "none"
}, null, -1), s41 = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.89982 14.6651 9.84977 19.1041 11.4721 20.5408C11.6536 20.7016 11.7444 20.7819 11.8502 20.8135C11.9426 20.8411 12.0437 20.8411 12.1361 20.8135C12.2419 20.7819 12.3327 20.7016 12.5142 20.5408C14.1365 19.1041 19.0865 14.6651 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), h41 = [
  l41,
  s41
];
function a41(r, e) {
  return n(), o("svg", i41, h41);
}
const yb2 = /* @__PURE__ */ i(o41, [["render", a41]]);
var d41 = {}, c41 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _41 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1156)",
  fill: "none"
}, null, -1), C41 = /* @__PURE__ */ t("path", {
  d: "M15.5455 9.92543C15.9195 9.26103 16.2313 8.66151 16.4236 8.20521C17.3573 5.98947 16.434 3.44077 14.1769 2.40112C11.9199 1.36148 9.65341 2.4395 8.65871 4.52093C6.75657 3.2157 4.21918 3.40739 2.81989 5.44424C1.42059 7.48108 1.85975 10.142 3.77629 11.594C4.6461 12.253 6.36636 13.2242 7.98596 14.0884M16.2972 11.7499C15.8751 9.482 13.9454 7.82334 11.5156 8.27415C9.08592 8.72497 7.51488 10.9171 7.84335 13.299C8.10725 15.2127 9.56392 19.7027 10.1264 21.394C10.2032 21.6248 10.2415 21.7402 10.3175 21.8206C10.3837 21.8907 10.4717 21.9416 10.5655 21.9638C10.6732 21.9894 10.7923 21.9649 11.0306 21.916C12.7765 21.5575 17.3933 20.574 19.1826 19.8457C21.4096 18.9392 22.5589 16.4841 21.6981 14.153C20.8372 11.8219 18.4723 10.9815 16.2972 11.7499Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), f41 = [
  _41,
  C41
];
function v41(r, e) {
  return n(), o("svg", c41, f41);
}
const Db2 = /* @__PURE__ */ i(d41, [["render", v41]]);
var u41 = {}, w41 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p41 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1196)",
  fill: "none"
}, null, -1), g41 = /* @__PURE__ */ t("path", {
  d: "M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $41 = [
  p41,
  g41
];
function M41(r, e) {
  return n(), o("svg", w41, $41);
}
const L41 = /* @__PURE__ */ i(u41, [["render", M41]]);
var k41 = {}, m41 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x41 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1276)",
  fill: "none"
}, null, -1), H41 = /* @__PURE__ */ t("path", {
  d: "M9.08997 8.99999C9.32507 8.33166 9.78912 7.7681 10.3999 7.40912C11.0107 7.05015 11.7289 6.91893 12.4271 7.0387C13.1254 7.15848 13.7588 7.52151 14.215 8.06352C14.6713 8.60552 14.921 9.29151 14.92 9.99999C14.92 12 11.92 13 11.92 13M12 17H12.01M2 8.52274V15.4773C2 15.7218 2 15.8441 2.02763 15.9592C2.05213 16.0613 2.09253 16.1588 2.14736 16.2483C2.2092 16.3492 2.29568 16.4357 2.46863 16.6086L7.39137 21.5314C7.56432 21.7043 7.6508 21.7908 7.75172 21.8526C7.84119 21.9075 7.93873 21.9479 8.04077 21.9724C8.15586 22 8.27815 22 8.52274 22H15.4773C15.7218 22 15.8441 22 15.9592 21.9724C16.0613 21.9479 16.1588 21.9075 16.2483 21.8526C16.3492 21.7908 16.4357 21.7043 16.6086 21.5314L21.5314 16.6086C21.7043 16.4357 21.7908 16.3492 21.8526 16.2483C21.9075 16.1588 21.9479 16.0613 21.9724 15.9592C22 15.8441 22 15.7218 22 15.4773V8.52274C22 8.27815 22 8.15586 21.9724 8.04077C21.9479 7.93873 21.9075 7.84119 21.8526 7.75172C21.7908 7.6508 21.7043 7.56432 21.5314 7.39137L16.6086 2.46863C16.4357 2.29568 16.3492 2.2092 16.2483 2.14736C16.1588 2.09253 16.0613 2.05213 15.9592 2.02763C15.8441 2 15.7218 2 15.4773 2H8.52274C8.27815 2 8.15586 2 8.04077 2.02763C7.93873 2.05213 7.84119 2.09253 7.75172 2.14736C7.6508 2.2092 7.56432 2.29568 7.39137 2.46863L2.46863 7.39137C2.29568 7.56432 2.2092 7.6508 2.14736 7.75172C2.09253 7.84119 2.05213 7.93873 2.02763 8.04077C2 8.15586 2 8.27815 2 8.52274Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), V41 = [
  x41,
  H41
];
function Z41(r, e) {
  return n(), o("svg", m41, V41);
}
const Pb2 = /* @__PURE__ */ i(k41, [["render", Z41]]);
var B41 = {}, F41 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j41 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1236)",
  fill: "none"
}, null, -1), I41 = /* @__PURE__ */ t("path", {
  d: "M9.08997 8.99995C9.32507 8.33162 9.78912 7.76806 10.3999 7.40908C11.0107 7.05011 11.7289 6.91889 12.4271 7.03866C13.1254 7.15844 13.7588 7.52148 14.215 8.06348C14.6713 8.60548 14.921 9.29147 14.92 9.99995C14.92 12 11.92 13 11.92 13M12 17H12.01M3 7.94141V16.0585C3 16.4012 3 16.5725 3.05048 16.7253C3.09515 16.8605 3.16816 16.9845 3.26463 17.0892C3.37369 17.2076 3.52345 17.2908 3.82297 17.4572L11.223 21.5683C11.5066 21.7258 11.6484 21.8046 11.7985 21.8355C11.9315 21.8628 12.0685 21.8628 12.2015 21.8355C12.3516 21.8046 12.4934 21.7258 12.777 21.5683L20.177 17.4572C20.4766 17.2908 20.6263 17.2076 20.7354 17.0892C20.8318 16.9845 20.9049 16.8605 20.9495 16.7253C21 16.5725 21 16.4012 21 16.0585V7.94141C21 7.59876 21 7.42744 20.9495 7.27464C20.9049 7.13947 20.8318 7.01539 20.7354 6.9107C20.6263 6.79236 20.4766 6.70916 20.177 6.54276L12.777 2.43164C12.4934 2.27409 12.3516 2.19531 12.2015 2.16442C12.0685 2.13709 11.9315 2.13709 11.7985 2.16442C11.6484 2.19531 11.5066 2.27409 11.223 2.43164L3.82297 6.54276C3.52345 6.70916 3.37369 6.79236 3.26463 6.9107C3.16816 7.01539 3.09515 7.13947 3.05048 7.27464C3 7.42744 3 7.59876 3 7.94141Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), b41 = [
  j41,
  I41
];
function y41(r, e) {
  return n(), o("svg", F41, b41);
}
const Ab2 = /* @__PURE__ */ i(B41, [["render", y41]]);
var D41 = {}, P41 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, A41 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1316)",
  fill: "none"
}, null, -1), S41 = /* @__PURE__ */ t("path", {
  d: "M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), T41 = [
  A41,
  S41
];
function O41(r, e) {
  return n(), o("svg", P41, T41);
}
const Sb2 = /* @__PURE__ */ i(D41, [["render", O41]]);
var E41 = {}, R41 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, U41 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), N41 = /* @__PURE__ */ t("path", {
  d: "M11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7985 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42756 21 7.59889 21 7.94153V16.0586C21 16.4013 21 16.5726 20.9495 16.7254C20.9049 16.8606 20.8318 16.9847 20.7354 17.0893C20.6263 17.2077 20.4766 17.2909 20.177 17.4573L12.777 21.5684C12.4934 21.726 12.3516 21.8047 12.2015 21.8356C12.0685 21.863 11.9315 21.863 11.7985 21.8356C11.6484 21.8047 11.5066 21.726 11.223 21.5684L3.82297 17.4573C3.52345 17.2909 3.37369 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V7.94153C3 7.59889 3 7.42756 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37369 6.79248 3.52345 6.70928 3.82297 6.54288L11.223 2.43177Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), q41 = [
  U41,
  N41
];
function z41(r, e) {
  return n(), o("svg", R41, q41);
}
const Tb2 = /* @__PURE__ */ i(E41, [["render", z41]]);
var K41 = {}, G41 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, W41 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), Y41 = /* @__PURE__ */ t("path", {
  d: "M21.5679 11.223C21.7255 11.5066 21.8042 11.6484 21.8351 11.7985C21.8625 11.9315 21.8625 12.0685 21.8351 12.2015C21.8042 12.3516 21.7255 12.4934 21.5679 12.777L17.4568 20.177C17.2904 20.4766 17.2072 20.6263 17.0889 20.7354C16.9842 20.8318 16.8601 20.9049 16.7249 20.9495C16.5721 21 16.4008 21 16.0582 21H7.94104C7.5984 21 7.42708 21 7.27428 20.9495C7.1391 20.9049 7.01502 20.8318 6.91033 20.7354C6.79199 20.6263 6.70879 20.4766 6.54239 20.177L2.43128 12.777C2.27372 12.4934 2.19494 12.3516 2.16406 12.2015C2.13672 12.0685 2.13672 11.9315 2.16406 11.7985C2.19494 11.6484 2.27372 11.5066 2.43128 11.223L6.54239 3.82297C6.70879 3.52345 6.79199 3.37369 6.91033 3.26463C7.01502 3.16816 7.1391 3.09515 7.27428 3.05048C7.42708 3 7.5984 3 7.94104 3L16.0582 3C16.4008 3 16.5721 3 16.7249 3.05049C16.8601 3.09515 16.9842 3.16816 17.0889 3.26463C17.2072 3.37369 17.2904 3.52345 17.4568 3.82297L21.5679 11.223Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), X41 = [
  W41,
  Y41
];
function Q41(r, e) {
  return n(), o("svg", G41, X41);
}
const Ob2 = /* @__PURE__ */ i(K41, [["render", Q41]]);
var J41 = {}, t31 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, e31 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1356)",
  fill: "none"
}, null, -1), r31 = /* @__PURE__ */ t("path", {
  d: "M3 10.5651C3 9.9907 3 9.70352 3.07403 9.43905C3.1396 9.20478 3.24737 8.98444 3.39203 8.78886C3.55534 8.56806 3.78202 8.39175 4.23539 8.03912L11.0177 2.764C11.369 2.49075 11.5447 2.35412 11.7387 2.3016C11.9098 2.25526 12.0902 2.25526 12.2613 2.3016C12.4553 2.35412 12.631 2.49075 12.9823 2.764L19.7646 8.03913C20.218 8.39175 20.4447 8.56806 20.608 8.78886C20.7526 8.98444 20.8604 9.20478 20.926 9.43905C21 9.70352 21 9.9907 21 10.5651V17.8C21 18.9201 21 19.4801 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4801 3 18.9201 3 17.8V10.5651Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), n31 = [
  e31,
  r31
];
function o31(r, e) {
  return n(), o("svg", t31, n31);
}
const Eb2 = /* @__PURE__ */ i(J41, [["render", o31]]);
var i31 = {}, l31 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, s31 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1396)",
  fill: "none"
}, null, -1), h31 = /* @__PURE__ */ t("path", {
  d: "M9 21V13.6C9 13.0399 9 12.7599 9.10899 12.546C9.20487 12.3578 9.35785 12.2049 9.54601 12.109C9.75992 12 10.0399 12 10.6 12H13.4C13.9601 12 14.2401 12 14.454 12.109C14.6422 12.2049 14.7951 12.3578 14.891 12.546C15 12.7599 15 13.0399 15 13.6V21M11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), a31 = [
  s31,
  h31
];
function d31(r, e) {
  return n(), o("svg", l31, a31);
}
const Rb2 = /* @__PURE__ */ i(i31, [["render", d31]]);
var c31 = {}, _31 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C31 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1436)",
  fill: "none"
}, null, -1), f31 = /* @__PURE__ */ t("path", {
  d: "M9 21V13.6C9 13.0399 9 12.7599 9.109 12.546C9.20487 12.3578 9.35785 12.2049 9.54601 12.109C9.75993 12 10.04 12 10.6 12H13.4C13.9601 12 14.2401 12 14.454 12.109C14.6422 12.2049 14.7951 12.3578 14.891 12.546C15 12.7599 15 13.0399 15 13.6V21M2 9.5L11.04 2.72C11.3843 2.46181 11.5564 2.33271 11.7454 2.28294C11.9123 2.23902 12.0877 2.23902 12.2546 2.28295C12.4436 2.33271 12.6157 2.46181 12.96 2.72L22 9.5M4 8V17.8C4 18.9201 4 19.4802 4.21799 19.908C4.40974 20.2843 4.7157 20.5903 5.09202 20.782C5.51985 21 6.0799 21 7.2 21H16.8C17.9201 21 18.4802 21 18.908 20.782C19.2843 20.5903 19.5903 20.2843 19.782 19.908C20 19.4802 20 18.9201 20 17.8V8L13.92 3.44C13.2315 2.92361 12.8872 2.66542 12.5091 2.56589C12.1754 2.47804 11.8246 2.47804 11.4909 2.56589C11.1128 2.66542 10.7685 2.92361 10.08 3.44L4 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), v31 = [
  C31,
  f31
];
function u31(r, e) {
  return n(), o("svg", _31, v31);
}
const Ub2 = /* @__PURE__ */ i(c31, [["render", u31]]);
var w31 = {}, p31 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g31 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1476)",
  fill: "none"
}, null, -1), $31 = /* @__PURE__ */ t("path", {
  d: "M12 16C13.6569 16 15 14.6568 15 13C15 11.3431 13.6569 9.99998 12 9.99998C10.3431 9.99998 9 11.3431 9 13C9 14.6568 10.3431 16 12 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), M31 = /* @__PURE__ */ t("path", {
  d: "M3 10.5651C3 9.9907 3 9.70352 3.07403 9.43905C3.1396 9.20478 3.24737 8.98444 3.39203 8.78886C3.55534 8.56806 3.78202 8.39175 4.23539 8.03912L11.0177 2.764C11.369 2.49075 11.5447 2.35412 11.7387 2.3016C11.9098 2.25526 12.0902 2.25526 12.2613 2.3016C12.4553 2.35412 12.631 2.49075 12.9823 2.764L19.7646 8.03913C20.218 8.39175 20.4447 8.56806 20.608 8.78886C20.7526 8.98444 20.8604 9.20478 20.926 9.43905C21 9.70352 21 9.9907 21 10.5651V17.8C21 18.9201 21 19.4801 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4801 3 18.9201 3 17.8V10.5651Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), L31 = [
  g31,
  $31,
  M31
];
function k31(r, e) {
  return n(), o("svg", p31, L31);
}
const Nb2 = /* @__PURE__ */ i(w31, [["render", k31]]);
var m31 = {}, x31 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H31 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1516)",
  fill: "none"
}, null, -1), V31 = /* @__PURE__ */ t("path", {
  d: "M12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21H8.2C8.48003 21 8.62004 21 8.727 20.9455C8.82108 20.8976 8.89757 20.8211 8.9455 20.727C9 20.62 9 20.48 9 20.2V13.6C9 13.0399 9 12.7599 9.10899 12.546C9.20487 12.3578 9.35785 12.2049 9.54601 12.109C9.75992 12 10.0399 12 10.6 12H13.4C13.9601 12 14.2401 12 14.454 12.109C14.6422 12.2049 14.7951 12.3578 14.891 12.546C15 12.7599 15 13.0399 15 13.6V20.2C15 20.48 15 20.62 15.0545 20.727C15.1024 20.8211 15.1789 20.8976 15.273 20.9455C15.38 21 15.52 21 15.8 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Z31 = [
  H31,
  V31
];
function B31(r, e) {
  return n(), o("svg", x31, Z31);
}
const qb2 = /* @__PURE__ */ i(m31, [["render", B31]]);
var F31 = {}, j31 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, I31 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1556)",
  fill: "none"
}, null, -1), b31 = /* @__PURE__ */ t("path", {
  d: "M8 17H16M11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), y31 = [
  I31,
  b31
];
function D31(r, e) {
  return n(), o("svg", j31, y31);
}
const zb2 = /* @__PURE__ */ i(F31, [["render", D31]]);
var P31 = {}, A31 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S31 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1596)",
  fill: "none"
}, null, -1), T31 = /* @__PURE__ */ t("path", {
  d: "M8.12602 14C8.57006 15.7252 10.1362 17 12 17C13.8638 17 15.4299 15.7252 15.874 14M11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), O31 = [
  S31,
  T31
];
function E31(r, e) {
  return n(), o("svg", A31, O31);
}
const Kb2 = /* @__PURE__ */ i(P31, [["render", E31]]);
var R31 = {}, U31 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, N31 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-347 -636)",
  fill: "none"
}, null, -1), q31 = /* @__PURE__ */ t("path", {
  d: "M17 9.5V6.1C17 5.53995 17 5.25992 16.891 5.04601C16.7951 4.85785 16.6422 4.70487 16.454 4.60899C16.2401 4.5 15.9601 4.5 15.4 4.5H3M13 14.5V17.9C13 18.4601 13 18.7401 12.891 18.954C12.7951 19.1422 12.6422 19.2951 12.454 19.391C12.2401 19.5 11.9601 19.5 11.4 19.5H3M3 2L3 22M3 14.5L19.4 14.5C19.9601 14.5 20.2401 14.5 20.454 14.391C20.6422 14.2951 20.7951 14.1422 20.891 13.954C21 13.7401 21 13.4601 21 12.9V11.1C21 10.5399 21 10.2599 20.891 10.046C20.7951 9.85785 20.6422 9.70487 20.454 9.60899C20.2401 9.5 19.9601 9.5 19.4 9.5L3 9.5L3 14.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), z31 = [
  N31,
  q31
];
function K31(r, e) {
  return n(), o("svg", U31, z31);
}
const Gb2 = /* @__PURE__ */ i(R31, [["render", K31]]);
var G31 = {}, W31 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y31 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -156)",
  fill: "none"
}, null, -1), X31 = /* @__PURE__ */ t("path", {
  d: "M17 9.5V12.9C17 13.4601 17 13.7401 16.891 13.954C16.7951 14.1422 16.6422 14.2951 16.454 14.391C16.2401 14.5 15.9601 14.5 15.4 14.5L3 14.5M13 14.5V17.9C13 18.4601 13 18.7401 12.891 18.954C12.7951 19.1422 12.6422 19.2951 12.454 19.391C12.2401 19.5 11.9601 19.5 11.4 19.5H3M3 2L3 22M3 9.5L19.4 9.5C19.9601 9.5 20.2401 9.5 20.454 9.39101C20.6422 9.29513 20.7951 9.14215 20.891 8.95399C21 8.74008 21 8.46005 21 7.9V6.1C21 5.53995 21 5.25992 20.891 5.04601C20.7951 4.85785 20.6422 4.70487 20.454 4.60899C20.2401 4.5 19.9601 4.5 19.4 4.5L3 4.5L3 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Q31 = [
  Y31,
  X31
];
function J31(r, e) {
  return n(), o("svg", W31, Q31);
}
const Wb2 = /* @__PURE__ */ i(G31, [["render", J31]]);
var t91 = {}, e91 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r91 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -196)",
  fill: "none"
}, null, -1), n91 = /* @__PURE__ */ t("path", {
  d: "M13 9.5V6.1C13 5.53995 13 5.25992 12.891 5.04601C12.7951 4.85785 12.6422 4.70487 12.454 4.60899C12.2401 4.5 11.9601 4.5 11.4 4.5H3M17 14.5V11.1C17 10.5399 17 10.2599 16.891 10.046C16.7951 9.85785 16.6422 9.70487 16.454 9.60899C16.2401 9.5 15.9601 9.5 15.4 9.5H3M3 2L3 22M3 19.5H19.4C19.9601 19.5 20.2401 19.5 20.454 19.391C20.6422 19.2951 20.7951 19.1422 20.891 18.954C21 18.7401 21 18.4601 21 17.9V16.1C21 15.5399 21 15.2599 20.891 15.046C20.7951 14.8578 20.6422 14.7049 20.454 14.609C20.2401 14.5 19.9601 14.5 19.4 14.5L3 14.5L3 19.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), o91 = [
  r91,
  n91
];
function i91(r, e) {
  return n(), o("svg", e91, o91);
}
const Yb2 = /* @__PURE__ */ i(t91, [["render", i91]]);
var l91 = {}, s91 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h91 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), a91 = /* @__PURE__ */ t("path", {
  d: "M12 12L7.72711 8.43926C7.09226 7.91022 6.77484 7.6457 6.54664 7.32144C6.34444 7.03413 6.19429 6.71354 6.10301 6.37428C6 5.99139 6 5.57819 6 4.7518V2M12 12L16.2729 8.43926C16.9077 7.91022 17.2252 7.6457 17.4534 7.32144C17.6556 7.03413 17.8057 6.71354 17.897 6.37428C18 5.99139 18 5.57819 18 4.7518V2M12 12L7.72711 15.5607C7.09226 16.0898 6.77484 16.3543 6.54664 16.6786C6.34444 16.9659 6.19429 17.2865 6.10301 17.6257C6 18.0086 6 18.4218 6 19.2482V22M12 12L16.2729 15.5607C16.9077 16.0898 17.2252 16.3543 17.4534 16.6786C17.6556 16.9659 17.8057 17.2865 17.897 17.6257C18 18.0086 18 18.4218 18 19.2482V22M4 2H20M4 22H20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), d91 = [
  h91,
  a91
];
function c91(r, e) {
  return n(), o("svg", s91, d91);
}
const Xb2 = /* @__PURE__ */ i(l91, [["render", c91]]);
var _91 = {}, C91 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, f91 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), v91 = /* @__PURE__ */ t("path", {
  d: "M18.1626 2H5.83744C5.37494 2 5 2.37494 5 2.83744C5 5.50268 6.05876 8.05876 7.94337 9.94337L9.16256 11.1626C9.28363 11.2836 9.34417 11.3442 9.3875 11.4023C9.65188 11.7569 9.65188 12.2431 9.3875 12.5977C9.34417 12.6558 9.28363 12.7164 9.16256 12.8374L7.94337 14.0566C6.05876 15.9412 5 18.4973 5 21.1626C5 21.6251 5.37494 22 5.83744 22H18.1626C18.6251 22 19 21.6251 19 21.1626C19 18.4973 17.9412 15.9412 16.0566 14.0566L14.8374 12.8374C14.7164 12.7164 14.6558 12.6558 14.6125 12.5977C14.3481 12.2431 14.3481 11.7569 14.6125 11.4023C14.6558 11.3442 14.7164 11.2836 14.8374 11.1626L16.0566 9.94337C17.9412 8.05876 19 5.50268 19 2.83744C19 2.37494 18.6251 2 18.1626 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), u91 = [
  f91,
  v91
];
function w91(r, e) {
  return n(), o("svg", C91, u91);
}
const Qb2 = /* @__PURE__ */ i(_91, [["render", w91]]);
var p91 = {}, g91 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $91 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), M91 = /* @__PURE__ */ t("path", {
  d: "M9 18.5H15M6.6 2H17.4C17.9601 2 18.2401 2 18.454 2.10899C18.6422 2.20487 18.7951 2.35785 18.891 2.54601C19 2.75992 19 3.03995 19 3.6V5.67452C19 6.1637 19 6.40829 18.9447 6.63846C18.8957 6.84254 18.8149 7.03763 18.7053 7.21657C18.5816 7.4184 18.4086 7.59135 18.0627 7.93726L15.1314 10.8686C14.7354 11.2646 14.5373 11.4627 14.4632 11.691C14.3979 11.8918 14.3979 12.1082 14.4632 12.309C14.5373 12.5373 14.7354 12.7354 15.1314 13.1314L18.0627 16.0627C18.4086 16.4086 18.5816 16.5816 18.7053 16.7834C18.8149 16.9624 18.8957 17.1575 18.9447 17.3615C19 17.5917 19 17.8363 19 18.3255V20.4C19 20.9601 19 21.2401 18.891 21.454C18.7951 21.6422 18.6422 21.7951 18.454 21.891C18.2401 22 17.9601 22 17.4 22H6.6C6.03995 22 5.75992 22 5.54601 21.891C5.35785 21.7951 5.20487 21.6422 5.10899 21.454C5 21.2401 5 20.9601 5 20.4V18.3255C5 17.8363 5 17.5917 5.05526 17.3615C5.10425 17.1575 5.18506 16.9624 5.29472 16.7834C5.4184 16.5816 5.59135 16.4086 5.93726 16.0627L8.86863 13.1314C9.26465 12.7354 9.46265 12.5373 9.53684 12.309C9.6021 12.1082 9.6021 11.8918 9.53684 11.691C9.46266 11.4627 9.26464 11.2646 8.86863 10.8686L5.93726 7.93726C5.59136 7.59136 5.4184 7.4184 5.29472 7.21657C5.18506 7.03763 5.10425 6.84254 5.05526 6.63846C5 6.40829 5 6.1637 5 5.67452V3.6C5 3.03995 5 2.75992 5.10899 2.54601C5.20487 2.35785 5.35785 2.20487 5.54601 2.10899C5.75992 2 6.03995 2 6.6 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), L91 = [
  $91,
  M91
];
function k91(r, e) {
  return n(), o("svg", g91, L91);
}
const Jb2 = /* @__PURE__ */ i(p91, [["render", k91]]);
var m91 = {}, x91 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H91 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), V91 = /* @__PURE__ */ t("path", {
  d: "M16.5 20.5002C15.2465 20.814 13.6884 21 12 21C10.3116 21 8.75349 20.814 7.5 20.5002M18 16.4305C16.5341 16.9842 14.3894 17.3333 12 17.3333C9.61061 17.3333 7.46589 16.9842 6 16.4305M4.5 11.6679C5.93143 12.5598 8.75311 13.1667 12 13.1667C15.2469 13.1667 18.0686 12.5598 19.5 11.6679M21 6C21 7.65685 16.9706 9 12 9C7.02944 9 3 7.65685 3 6C3 4.34315 7.02944 3 12 3C16.9706 3 21 4.34315 21 6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Z91 = [
  H91,
  V91
];
function B91(r, e) {
  return n(), o("svg", x91, Z91);
}
const ty2 = /* @__PURE__ */ i(m91, [["render", B91]]);
var F91 = {}, j91 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, I91 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), b91 = /* @__PURE__ */ t("path", {
  d: "M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12M18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12M18 12C18 16.4183 14.4183 20 10 20C5.58172 20 2 16.4183 2 12M6 12C6 7.58172 9.58172 4 14 4C18.4183 4 22 7.58172 22 12M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), y91 = [
  I91,
  b91
];
function D91(r, e) {
  return n(), o("svg", j91, y91);
}
const ey2 = /* @__PURE__ */ i(F91, [["render", D91]]);
var P91 = {}, A91 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S91 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), T91 = /* @__PURE__ */ t("path", {
  d: "M21 4H3M20 8L6 8M18 12L9 12M15 16L8 16M17 20H12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), O91 = [
  S91,
  T91
];
function E91(r, e) {
  return n(), o("svg", A91, O91);
}
const ry2 = /* @__PURE__ */ i(P91, [["render", E91]]);
var R91 = {}, U91 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, N91 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), q91 = /* @__PURE__ */ t("path", {
  d: "M16.2 21H6.93137C6.32555 21 6.02265 21 5.88238 20.8802C5.76068 20.7763 5.69609 20.6203 5.70865 20.4608C5.72312 20.2769 5.93731 20.0627 6.36569 19.6343L14.8686 11.1314C15.2646 10.7354 15.4627 10.5373 15.691 10.4632C15.8918 10.3979 16.1082 10.3979 16.309 10.4632C16.5373 10.5373 16.7354 10.7354 17.1314 11.1314L21 15V16.2M16.2 21C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2M16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), z91 = [
  N91,
  q91
];
function K91(r, e) {
  return n(), o("svg", U91, z91);
}
const ny2 = /* @__PURE__ */ i(R91, [["render", K91]]);
var G91 = {}, W91 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y91 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), X91 = /* @__PURE__ */ t("path", {
  d: "M5.99958 20.0004L14.8686 11.1314C15.2646 10.7354 15.4627 10.5373 15.691 10.4632C15.8918 10.3979 16.1082 10.3979 16.309 10.4632C16.5373 10.5373 16.7354 10.7354 17.1314 11.1314L21.4053 15.4053M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Q91 = [
  Y91,
  X91
];
function J91(r, e) {
  return n(), o("svg", W91, Q91);
}
const oy2 = /* @__PURE__ */ i(G91, [["render", J91]]);
var t61 = {}, e61 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r61 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), n61 = /* @__PURE__ */ t("path", {
  d: "M4.27209 20.7279L10.8686 14.1314C11.2646 13.7354 11.4627 13.5373 11.691 13.4632C11.8918 13.3979 12.1082 13.3979 12.309 13.4632C12.5373 13.5373 12.7354 13.7354 13.1314 14.1314L19.6839 20.6839M14 15L16.8686 12.1314C17.2646 11.7354 17.4627 11.5373 17.691 11.4632C17.8918 11.3979 18.1082 11.3979 18.309 11.4632C18.5373 11.5373 18.7354 11.7354 19.1314 12.1314L22 15M10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9ZM6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), o61 = [
  r61,
  n61
];
function i61(r, e) {
  return n(), o("svg", e61, o61);
}
const iy2 = /* @__PURE__ */ i(t61, [["render", i61]]);
var l61 = {}, s61 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h61 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), a61 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), d61 = /* @__PURE__ */ t("path", {
  d: "M9 9.5L6 15H18L13.5 7.5L11 11L9 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), c61 = [
  h61,
  a61,
  d61
];
function _61(r, e) {
  return n(), o("svg", s61, c61);
}
const ly2 = /* @__PURE__ */ i(l61, [["render", _61]]);
var C61 = {}, f61 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, v61 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), u61 = /* @__PURE__ */ t("path", {
  d: "M19 21H20.0104C20.9816 21 21.4671 21 21.7348 20.7975C21.968 20.6211 22.1123 20.3515 22.1297 20.0596C22.1497 19.7246 21.8804 19.3205 21.3417 18.5125L18.3313 13.9969C17.8862 13.3292 17.6636 12.9954 17.3831 12.8791C17.1378 12.7773 16.8622 12.7773 16.6169 12.8791C16.3364 12.9954 16.1139 13.3292 15.6687 13.9969L14.9245 15.1132M19 21L11.3155 9.90018C10.8736 9.26182 10.6526 8.94264 10.3766 8.83044C10.1351 8.73228 9.8649 8.73228 9.62344 8.83044C9.34742 8.94264 9.12645 9.26182 8.68451 9.90018L2.73822 18.4893C2.17519 19.3025 1.89368 19.7092 1.90971 20.0473C1.92366 20.3419 2.06688 20.6152 2.30109 20.7943C2.57002 21 3.06459 21 4.05373 21H19ZM21 6C21 7.65685 19.6569 9 18 9C16.3432 9 15 7.65685 15 6C15 4.34315 16.3432 3 18 3C19.6569 3 21 4.34315 21 6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), w61 = [
  v61,
  u61
];
function p61(r, e) {
  return n(), o("svg", f61, w61);
}
const sy2 = /* @__PURE__ */ i(C61, [["render", p61]]);
var g61 = {}, $61 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M61 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), L61 = /* @__PURE__ */ t("path", {
  d: "M16 5L18 7L22 3M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), k61 = [
  M61,
  L61
];
function m61(r, e) {
  return n(), o("svg", $61, k61);
}
const hy2 = /* @__PURE__ */ i(g61, [["render", m61]]);
var x61 = {}, H61 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V61 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), Z61 = /* @__PURE__ */ t("path", {
  d: "M16 5L19 8M19 8L22 5M19 8V2M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), B61 = [
  V61,
  Z61
];
function F61(r, e) {
  return n(), o("svg", H61, B61);
}
const ay2 = /* @__PURE__ */ i(x61, [["render", F61]]);
var j61 = {}, I61 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, b61 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -916)",
  fill: "none"
}, null, -1), y61 = /* @__PURE__ */ t("path", {
  d: "M21 9.25H15M21 4H3M21 14.75H15M21 20H3M4.6 16H9.4C9.96005 16 10.2401 16 10.454 15.891C10.6422 15.7951 10.7951 15.6422 10.891 15.454C11 15.2401 11 14.9601 11 14.4V9.6C11 9.03995 11 8.75992 10.891 8.54601C10.7951 8.35785 10.6422 8.20487 10.454 8.10899C10.2401 8 9.96005 8 9.4 8H4.6C4.03995 8 3.75992 8 3.54601 8.10899C3.35785 8.20487 3.20487 8.35785 3.10899 8.54601C3 8.75992 3 9.03995 3 9.6V14.4C3 14.9601 3 15.2401 3.10899 15.454C3.20487 15.6422 3.35785 15.7951 3.54601 15.891C3.75992 16 4.03995 16 4.6 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), D61 = [
  b61,
  y61
];
function P61(r, e) {
  return n(), o("svg", I61, D61);
}
const dy2 = /* @__PURE__ */ i(j61, [["render", P61]]);
var A61 = {}, S61 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, T61 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -956)",
  fill: "none"
}, null, -1), O61 = /* @__PURE__ */ t("path", {
  d: "M21 4H3M21 20H3M9 9.25H3M9 14.75H3M14.6 16H19.4C19.9601 16 20.2401 16 20.454 15.891C20.6422 15.7951 20.7951 15.6422 20.891 15.454C21 15.2401 21 14.9601 21 14.4V9.6C21 9.03995 21 8.75992 20.891 8.54601C20.7951 8.35785 20.6422 8.20487 20.454 8.10899C20.2401 8 19.9601 8 19.4 8H14.6C14.0399 8 13.7599 8 13.546 8.10899C13.3578 8.20487 13.2049 8.35785 13.109 8.54601C13 8.75992 13 9.03995 13 9.6V14.4C13 14.9601 13 15.2401 13.109 15.454C13.2049 15.6422 13.3578 15.7951 13.546 15.891C13.7599 16 14.0399 16 14.6 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), E61 = [
  T61,
  O61
];
function R61(r, e) {
  return n(), o("svg", S61, E61);
}
const cy2 = /* @__PURE__ */ i(A61, [["render", R61]]);
var U61 = {}, N61 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, q61 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), z61 = /* @__PURE__ */ t("path", {
  d: "M19 8L16 5M16 5L19 2M16 5L22 5M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), K61 = [
  q61,
  z61
];
function G61(r, e) {
  return n(), o("svg", N61, K61);
}
const _y2 = /* @__PURE__ */ i(U61, [["render", G61]]);
var W61 = {}, Y61 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, X61 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), Q61 = /* @__PURE__ */ t("path", {
  d: "M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M19 8V2M16 5H22M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), J61 = [
  X61,
  Q61
];
function t51(r, e) {
  return n(), o("svg", Y61, J61);
}
const Cy2 = /* @__PURE__ */ i(W61, [["render", t51]]);
var e51 = {}, r51 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, n51 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), o51 = /* @__PURE__ */ t("path", {
  d: "M19 8L22 5M22 5L19 2M22 5L16 5M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), i51 = [
  n51,
  o51
];
function l51(r, e) {
  return n(), o("svg", r51, i51);
}
const fy2 = /* @__PURE__ */ i(e51, [["render", l51]]);
var s51 = {}, h51 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, a51 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), d51 = /* @__PURE__ */ t("path", {
  d: "M16 5L19 2M19 2L22 5M19 2V8M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), c51 = [
  a51,
  d51
];
function _51(r, e) {
  return n(), o("svg", h51, c51);
}
const vy2 = /* @__PURE__ */ i(s51, [["render", _51]]);
var C51 = {}, f51 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, v51 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), u51 = /* @__PURE__ */ t("path", {
  d: "M16 5L18 7L22 3M22 12V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.7202 22 18.8802 22 17.2 22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H12M2.14551 19.9263C2.61465 18.2386 4.16256 17 5.99977 17H12.9998C13.9291 17 14.3937 17 14.7801 17.0769C16.3669 17.3925 17.6073 18.6329 17.9229 20.2196C17.9998 20.606 17.9998 21.0707 17.9998 22M14 9.5C14 11.7091 12.2091 13.5 10 13.5C7.79086 13.5 6 11.7091 6 9.5C6 7.29086 7.79086 5.5 10 5.5C12.2091 5.5 14 7.29086 14 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), w51 = [
  v51,
  u51
];
function p51(r, e) {
  return n(), o("svg", f51, w51);
}
const uy2 = /* @__PURE__ */ i(C51, [["render", p51]]);
var g51 = {}, $51 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M51 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), L51 = /* @__PURE__ */ t("path", {
  d: "M16 5L19 8M19 8L22 5M19 8V2M22 12V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.7202 22 18.8802 22 17.2 22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H12M2.14574 19.9263C2.61488 18.2386 4.1628 17 6 17H13C13.9293 17 14.394 17 14.7804 17.0769C16.3671 17.3925 17.6075 18.6329 17.9231 20.2196C18 20.606 18 21.0707 18 22M14 9.5C14 11.7091 12.2091 13.5 10 13.5C7.79086 13.5 6 11.7091 6 9.5C6 7.29086 7.79086 5.5 10 5.5C12.2091 5.5 14 7.29086 14 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), k51 = [
  M51,
  L51
];
function m51(r, e) {
  return n(), o("svg", $51, k51);
}
const wy2 = /* @__PURE__ */ i(g51, [["render", m51]]);
var x51 = {}, H51 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V51 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), Z51 = /* @__PURE__ */ t("path", {
  d: "M19 8L16 5M16 5L19 2M16 5L22 5M22 12V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.7202 22 18.8802 22 17.2 22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H12M2.14551 19.9263C2.61465 18.2386 4.16256 17 5.99977 17H12.9998C13.9291 17 14.3937 17 14.7801 17.0769C16.3669 17.3925 17.6073 18.6329 17.9229 20.2196C17.9998 20.606 17.9998 21.0707 17.9998 22M14 9.5C14 11.7091 12.2091 13.5 10 13.5C7.79086 13.5 6 11.7091 6 9.5C6 7.29086 7.79086 5.5 10 5.5C12.2091 5.5 14 7.29086 14 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), B51 = [
  V51,
  Z51
];
function F51(r, e) {
  return n(), o("svg", H51, B51);
}
const py2 = /* @__PURE__ */ i(x51, [["render", F51]]);
var j51 = {}, I51 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, b51 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), y51 = /* @__PURE__ */ t("path", {
  d: "M19 8V2M16 5H22M22 12V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.7202 22 18.8802 22 17.2 22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H12M2.14574 19.9263C2.61488 18.2386 4.1628 17 6 17H13C13.9293 17 14.394 17 14.7804 17.0769C16.3671 17.3925 17.6075 18.6329 17.9231 20.2196C18 20.606 18 21.0707 18 22M14 9.5C14 11.7091 12.2091 13.5 10 13.5C7.79086 13.5 6 11.7091 6 9.5C6 7.29086 7.79086 5.5 10 5.5C12.2091 5.5 14 7.29086 14 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), D51 = [
  b51,
  y51
];
function P51(r, e) {
  return n(), o("svg", I51, D51);
}
const gy2 = /* @__PURE__ */ i(j51, [["render", P51]]);
var A51 = {}, S51 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, T51 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), O51 = /* @__PURE__ */ t("path", {
  d: "M19 8L22 5M22 5L19 2M22 5L16 5M22 12V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.7202 22 18.8802 22 17.2 22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H12M2.14551 19.9263C2.61465 18.2386 4.16256 17 5.99977 17H12.9998C13.9291 17 14.3937 17 14.7801 17.0769C16.3669 17.3925 17.6073 18.6329 17.9229 20.2196C17.9998 20.606 17.9998 21.0707 17.9998 22M14 9.5C14 11.7091 12.2091 13.5 10 13.5C7.79086 13.5 6 11.7091 6 9.5C6 7.29086 7.79086 5.5 10 5.5C12.2091 5.5 14 7.29086 14 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), E51 = [
  T51,
  O51
];
function R51(r, e) {
  return n(), o("svg", S51, E51);
}
const $y2 = /* @__PURE__ */ i(A51, [["render", R51]]);
var U51 = {}, N51 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, q51 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), z51 = /* @__PURE__ */ t("path", {
  d: "M16 5L19 2M19 2L22 5M19 2V8M22 12V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.7202 22 18.8802 22 17.2 22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H12M2.14551 19.9263C2.61465 18.2386 4.16256 17 5.99977 17H12.9998C13.9291 17 14.3937 17 14.7801 17.0769C16.3669 17.3925 17.6073 18.6329 17.9229 20.2196C17.9998 20.606 17.9998 21.0707 17.9998 22M14 9.5C14 11.7091 12.2091 13.5 10 13.5C7.79086 13.5 6 11.7091 6 9.5C6 7.29086 7.79086 5.5 10 5.5C12.2091 5.5 14 7.29086 14 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), K51 = [
  q51,
  z51
];
function G51(r, e) {
  return n(), o("svg", N51, K51);
}
const My2 = /* @__PURE__ */ i(U51, [["render", G51]]);
var W51 = {}, Y51 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, X51 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), Q51 = /* @__PURE__ */ t("path", {
  d: "M16.5 2.5L21.5 7.5M21.5 2.5L16.5 7.5M22 12V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C19.7202 22 18.8802 22 17.2 22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H12M2.14551 19.9263C2.61465 18.2386 4.16256 17 5.99977 17H12.9998C13.9291 17 14.3937 17 14.7801 17.0769C16.3669 17.3925 17.6073 18.6329 17.9229 20.2196C17.9998 20.606 17.9998 21.0707 17.9998 22M14 9.5C14 11.7091 12.2091 13.5 10 13.5C7.79086 13.5 6 11.7091 6 9.5C6 7.29086 7.79086 5.5 10 5.5C12.2091 5.5 14 7.29086 14 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), J51 = [
  X51,
  Q51
];
function t81(r, e) {
  return n(), o("svg", Y51, J51);
}
const Ly2 = /* @__PURE__ */ i(W51, [["render", t81]]);
var e81 = {}, r81 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, n81 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), o81 = /* @__PURE__ */ t("path", {
  d: "M4.00002 21.8174C4.6026 22 5.41649 22 6.8 22H17.2C18.5835 22 19.3974 22 20 21.8174M4.00002 21.8174C3.87082 21.7783 3.75133 21.7308 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H17.2C18.8802 2 19.7202 2 20.362 2.32698C20.9265 2.6146 21.3854 3.07354 21.673 3.63803C22 4.27976 22 5.11984 22 6.8V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C20.2487 21.7308 20.1292 21.7783 20 21.8174M4.00002 21.8174C4.00035 21.0081 4.00521 20.5799 4.07686 20.2196C4.39249 18.6329 5.63288 17.3925 7.21964 17.0769C7.60603 17 8.07069 17 9 17H15C15.9293 17 16.394 17 16.7804 17.0769C18.3671 17.3925 19.6075 18.6329 19.9231 20.2196C19.9948 20.5799 19.9996 21.0081 20 21.8174M16 9.5C16 11.7091 14.2091 13.5 12 13.5C9.79086 13.5 8 11.7091 8 9.5C8 7.29086 9.79086 5.5 12 5.5C14.2091 5.5 16 7.29086 16 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), i81 = [
  n81,
  o81
];
function l81(r, e) {
  return n(), o("svg", r81, i81);
}
const ky2 = /* @__PURE__ */ i(e81, [["render", l81]]);
var s81 = {}, h81 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, a81 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), d81 = /* @__PURE__ */ t("path", {
  d: "M16.5 2.5L21.5 7.5M21.5 2.5L16.5 7.5M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), c81 = [
  a81,
  d81
];
function _81(r, e) {
  return n(), o("svg", h81, c81);
}
const my2 = /* @__PURE__ */ i(s81, [["render", _81]]);
var C81 = {}, f81 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, v81 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -516)",
  fill: "none"
}, null, -1), u81 = /* @__PURE__ */ t("path", {
  d: "M2.5 12H5.88197C6.56717 12 7.19357 12.3871 7.5 13C7.80643 13.6129 8.43283 14 9.11803 14H14.882C15.5672 14 16.1936 13.6129 16.5 13C16.8064 12.3871 17.4328 12 18.118 12H21.5M8.96656 4H15.0334C16.1103 4 16.6487 4 17.1241 4.16396C17.5445 4.30896 17.9274 4.5456 18.2451 4.85675C18.6043 5.2086 18.8451 5.6902 19.3267 6.65337L21.4932 10.9865C21.6822 11.3645 21.7767 11.5535 21.8434 11.7515C21.9026 11.9275 21.9453 12.1085 21.971 12.2923C22 12.4992 22 12.7105 22 13.1331V15.2C22 16.8802 22 17.7202 21.673 18.362C21.3854 18.9265 20.9265 19.3854 20.362 19.673C19.7202 20 18.8802 20 17.2 20H6.8C5.11984 20 4.27976 20 3.63803 19.673C3.07354 19.3854 2.6146 18.9265 2.32698 18.362C2 17.7202 2 16.8802 2 15.2V13.1331C2 12.7105 2 12.4992 2.02897 12.2923C2.05471 12.1085 2.09744 11.9275 2.15662 11.7515C2.22326 11.5535 2.31776 11.3645 2.50675 10.9865L4.67331 6.65337C5.1549 5.69019 5.3957 5.2086 5.75495 4.85675C6.07263 4.5456 6.45551 4.30896 6.87589 4.16396C7.35125 4 7.88969 4 8.96656 4Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), w81 = [
  v81,
  u81
];
function p81(r, e) {
  return n(), o("svg", f81, w81);
}
const xy2 = /* @__PURE__ */ i(C81, [["render", p81]]);
var g81 = {}, $81 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M81 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -556)",
  fill: "none"
}, null, -1), L81 = /* @__PURE__ */ t("path", {
  d: "M2 12H5.88197C6.56717 12 7.19357 12.3871 7.5 13C7.80643 13.6129 8.43283 14 9.11803 14H14.882C15.5672 14 16.1936 13.6129 16.5 13C16.8064 12.3871 17.4328 12 18.118 12H22M2 12V8.8C2 7.11984 2 6.27976 2.32698 5.63803C2.6146 5.07354 3.07354 4.6146 3.63803 4.32698C4.27976 4 5.11984 4 6.8 4H17.2C18.8802 4 19.7202 4 20.362 4.32698C20.9265 4.6146 21.3854 5.07354 21.673 5.63803C22 6.27976 22 7.11984 22 8.8V12M2 12V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), k81 = [
  M81,
  L81
];
function m81(r, e) {
  return n(), o("svg", $81, k81);
}
const Hy2 = /* @__PURE__ */ i(g81, [["render", m81]]);
var x81 = {}, H81 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V81 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), Z81 = /* @__PURE__ */ t("path", {
  d: "M18.1777 8C23.2737 8 23.2737 16 18.1777 16C13.0827 16 11.0447 8 5.43875 8C0.85375 8 0.85375 16 5.43875 16C11.0447 16 13.0828 8 18.1788 8H18.1777Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), B81 = [
  V81,
  Z81
];
function F81(r, e) {
  return n(), o("svg", H81, B81);
}
const Vy2 = /* @__PURE__ */ i(x81, [["render", F81]]);
var j81 = {}, I81 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, b81 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1636)",
  fill: "none"
}, null, -1), y81 = /* @__PURE__ */ t("path", {
  d: "M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), D81 = [
  b81,
  y81
];
function P81(r, e) {
  return n(), o("svg", I81, D81);
}
const A81 = /* @__PURE__ */ i(j81, [["render", P81]]);
var S81 = {}, T81 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O81 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1676)",
  fill: "none"
}, null, -1), E81 = /* @__PURE__ */ t("path", {
  d: "M12 16.0001V12.0001M12 8.00008H12.01M3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7985 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586V7.94153C21 7.59889 21 7.42756 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7985 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42756 3 7.59889 3 7.94153Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), R81 = [
  O81,
  E81
];
function U81(r, e) {
  return n(), o("svg", T81, R81);
}
const Zy2 = /* @__PURE__ */ i(S81, [["render", U81]]);
var N81 = {}, q81 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z81 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1716)",
  fill: "none"
}, null, -1), K81 = /* @__PURE__ */ t("path", {
  d: "M12 16V12M12 8H12.01M2 8.52274V15.4773C2 15.7218 2 15.8441 2.02763 15.9592C2.05213 16.0613 2.09253 16.1588 2.14736 16.2483C2.2092 16.3492 2.29568 16.4357 2.46863 16.6086L7.39137 21.5314C7.56432 21.7043 7.6508 21.7908 7.75172 21.8526C7.84119 21.9075 7.93873 21.9479 8.04077 21.9724C8.15586 22 8.27815 22 8.52274 22H15.4773C15.7218 22 15.8441 22 15.9592 21.9724C16.0613 21.9479 16.1588 21.9075 16.2483 21.8526C16.3492 21.7908 16.4357 21.7043 16.6086 21.5314L21.5314 16.6086C21.7043 16.4357 21.7908 16.3492 21.8526 16.2483C21.9075 16.1588 21.9479 16.0613 21.9724 15.9592C22 15.8441 22 15.7218 22 15.4773V8.52274C22 8.27815 22 8.15586 21.9724 8.04077C21.9479 7.93873 21.9075 7.84119 21.8526 7.75172C21.7908 7.6508 21.7043 7.56432 21.5314 7.39137L16.6086 2.46863C16.4357 2.29568 16.3492 2.2092 16.2483 2.14736C16.1588 2.09253 16.0613 2.05213 15.9592 2.02763C15.8441 2 15.7218 2 15.4773 2H8.52274C8.27815 2 8.15586 2 8.04077 2.02763C7.93873 2.05213 7.84119 2.09253 7.75172 2.14736C7.6508 2.2092 7.56432 2.29568 7.39137 2.46863L2.46863 7.39137C2.29568 7.56432 2.2092 7.6508 2.14736 7.75172C2.09253 7.84119 2.05213 7.93873 2.02763 8.04077C2 8.15586 2 8.27815 2 8.52274Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), G81 = [
  z81,
  K81
];
function W81(r, e) {
  return n(), o("svg", q81, G81);
}
const By2 = /* @__PURE__ */ i(N81, [["render", W81]]);
var Y81 = {}, X81 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Q81 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1756)",
  fill: "none"
}, null, -1), J81 = /* @__PURE__ */ t("path", {
  d: "M12 16V12M12 8H12.01M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), t71 = [
  Q81,
  J81
];
function e71(r, e) {
  return n(), o("svg", X81, t71);
}
const Fy2 = /* @__PURE__ */ i(Y81, [["render", e71]]);
var r71 = {}, n71 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o71 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), i71 = /* @__PURE__ */ t("path", {
  d: "M9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), l71 = /* @__PURE__ */ t("path", {
  d: "M15 22C18.866 22 22 18.866 22 15C22 11.134 18.866 8 15 8C11.134 8 8 11.134 8 15C8 18.866 11.134 22 15 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), s71 = [
  o71,
  i71,
  l71
];
function h71(r, e) {
  return n(), o("svg", n71, s71);
}
const jy2 = /* @__PURE__ */ i(r71, [["render", h71]]);
var a71 = {}, d71 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, c71 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), _71 = /* @__PURE__ */ t("path", {
  d: "M2 5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H12.8C13.9201 2 14.4802 2 14.908 2.21799C15.2843 2.40973 15.5903 2.71569 15.782 3.09202C16 3.51984 16 4.0799 16 5.2V12.8C16 13.9201 16 14.4802 15.782 14.908C15.5903 15.2843 15.2843 15.5903 14.908 15.782C14.4802 16 13.9201 16 12.8 16H5.2C4.07989 16 3.51984 16 3.09202 15.782C2.71569 15.5903 2.40973 15.2843 2.21799 14.908C2 14.4802 2 13.9201 2 12.8V5.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), C71 = /* @__PURE__ */ t("path", {
  d: "M8 11.2C8 10.0799 8 9.51984 8.21799 9.09202C8.40973 8.71569 8.71569 8.40973 9.09202 8.21799C9.51984 8 10.0799 8 11.2 8H18.8C19.9201 8 20.4802 8 20.908 8.21799C21.2843 8.40973 21.5903 8.71569 21.782 9.09202C22 9.51984 22 10.0799 22 11.2V18.8C22 19.9201 22 20.4802 21.782 20.908C21.5903 21.2843 21.2843 21.5903 20.908 21.782C20.4802 22 19.9201 22 18.8 22H11.2C10.0799 22 9.51984 22 9.09202 21.782C8.71569 21.5903 8.40973 21.2843 8.21799 20.908C8 20.4802 8 19.9201 8 18.8V11.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), f71 = [
  c71,
  _71,
  C71
];
function v71(r, e) {
  return n(), o("svg", d71, f71);
}
const Iy2 = /* @__PURE__ */ i(a71, [["render", v71]]);
var u71 = {}, w71 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p71 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -996)",
  fill: "none"
}, null, -1), g71 = /* @__PURE__ */ t("path", {
  d: "M19 4H10M14 20H5M15 4L9 20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $71 = [
  p71,
  g71
];
function M71(r, e) {
  return n(), o("svg", w71, $71);
}
const by2 = /* @__PURE__ */ i(u71, [["render", M71]]);
var L71 = {}, k71 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, m71 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -1036)",
  fill: "none"
}, null, -1), x71 = /* @__PURE__ */ t("path", {
  d: "M13.25 4L7.25 20M16.75 4L10.75 20M19.5 4L9.5 4M14.5 20H4.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), H71 = [
  m71,
  x71
];
function V71(r, e) {
  return n(), o("svg", k71, H71);
}
const yy2 = /* @__PURE__ */ i(L71, [["render", V71]]);
var Z71 = {}, B71 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, F71 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -1076)",
  fill: "none"
}, null, -1), j71 = /* @__PURE__ */ t("path", {
  d: "M14 7L10 17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), I71 = [
  F71,
  j71
];
function b71(r, e) {
  return n(), o("svg", B71, I71);
}
const Dy2 = /* @__PURE__ */ i(Z71, [["render", b71]]);
var y71 = {}, D71 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P71 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), A71 = /* @__PURE__ */ t("path", {
  d: "M17 8.99994C17 8.48812 16.8047 7.9763 16.4142 7.58579C16.0237 7.19526 15.5118 7 15 7M15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.27368 9.01832 9.54308 9.05381 9.80704C9.11218 10.2412 9.14136 10.4583 9.12172 10.5956C9.10125 10.7387 9.0752 10.8157 9.00469 10.9419C8.937 11.063 8.81771 11.1823 8.57913 11.4209L3.46863 16.5314C3.29568 16.7043 3.2092 16.7908 3.14736 16.8917C3.09253 16.9812 3.05213 17.0787 3.02763 17.1808C3 17.2959 3 17.4182 3 17.6627V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H7V19H9V17H11L12.5791 15.4209C12.8177 15.1823 12.937 15.063 13.0581 14.9953C13.1843 14.9248 13.2613 14.8987 13.4044 14.8783C13.5417 14.8586 13.7588 14.8878 14.193 14.9462C14.4569 14.9817 14.7263 15 15 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), S71 = [
  P71,
  A71
];
function T71(r, e) {
  return n(), o("svg", D71, S71);
}
const Py2 = /* @__PURE__ */ i(y71, [["render", T71]]);
var O71 = {}, E71 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, R71 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), U71 = /* @__PURE__ */ t("path", {
  d: "M15 9H15.01M15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.27368 9.01832 9.54308 9.05381 9.80704C9.11218 10.2412 9.14136 10.4583 9.12172 10.5956C9.10125 10.7387 9.0752 10.8157 9.00469 10.9419C8.937 11.063 8.81771 11.1823 8.57913 11.4209L3.46863 16.5314C3.29568 16.7043 3.2092 16.7908 3.14736 16.8917C3.09253 16.9812 3.05213 17.0787 3.02763 17.1808C3 17.2959 3 17.4182 3 17.6627V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H6.33726C6.58185 21 6.70414 21 6.81923 20.9724C6.92127 20.9479 7.01881 20.9075 7.10828 20.8526C7.2092 20.7908 7.29568 20.7043 7.46863 20.5314L12.5791 15.4209C12.8177 15.1823 12.937 15.063 13.0581 14.9953C13.1843 14.9248 13.2613 14.8987 13.4044 14.8783C13.5417 14.8586 13.7588 14.8878 14.193 14.9462C14.4569 14.9817 14.7263 15 15 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), N71 = [
  R71,
  U71
];
function q71(r, e) {
  return n(), o("svg", E71, N71);
}
const Ay2 = /* @__PURE__ */ i(O71, [["render", q71]]);
var z71 = {}, K71 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, G71 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-64 -1196)",
  fill: "none"
}, null, -1), W71 = /* @__PURE__ */ t("path", {
  d: "M6 10H6.01M8 14H8.01M10 10H10.01M12 14H12.01M14 10H14.01M16 14H16.01M18 10H18.01M5.2 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V9.2C22 8.0799 22 7.51984 21.782 7.09202C21.5903 6.71569 21.2843 6.40973 20.908 6.21799C20.4802 6 19.9201 6 18.8 6H5.2C4.07989 6 3.51984 6 3.09202 6.21799C2.71569 6.40973 2.40973 6.71569 2.21799 7.09202C2 7.51984 2 8.07989 2 9.2V14.8C2 15.9201 2 16.4802 2.21799 16.908C2.40973 17.2843 2.71569 17.5903 3.09202 17.782C3.51984 18 4.0799 18 5.2 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Y71 = [
  G71,
  W71
];
function X71(r, e) {
  return n(), o("svg", K71, Y71);
}
const Sy2 = /* @__PURE__ */ i(z71, [["render", X71]]);
var Q71 = {}, J71 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tt1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), et1 = /* @__PURE__ */ t("path", {
  d: "M7 14.5H17M6 10H6.01M10 10H10.01M14 10H14.01M18 10H18.01M5.2 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V9.2C22 8.0799 22 7.51984 21.782 7.09202C21.5903 6.71569 21.2843 6.40973 20.908 6.21799C20.4802 6 19.9201 6 18.8 6H5.2C4.07989 6 3.51984 6 3.09202 6.21799C2.71569 6.40973 2.40973 6.71569 2.21799 7.09202C2 7.51984 2 8.07989 2 9.2V14.8C2 15.9201 2 16.4802 2.21799 16.908C2.40973 17.2843 2.71569 17.5903 3.09202 17.782C3.51984 18 4.0799 18 5.2 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rt1 = [
  tt1,
  et1
];
function nt1(r, e) {
  return n(), o("svg", J71, rt1);
}
const Ty2 = /* @__PURE__ */ i(Q71, [["render", nt1]]);
var ot1 = {}, it1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lt1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), st1 = /* @__PURE__ */ t("path", {
  d: "M3 16V7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V16H15.6627C15.4182 16 15.2959 16 15.1808 16.0276C15.0787 16.0521 14.9812 16.0925 14.8917 16.1474C14.7908 16.2092 14.7043 16.2957 14.5314 16.4686L14.4686 16.5314C14.2957 16.7043 14.2092 16.7908 14.1083 16.8526C14.0188 16.9075 13.9213 16.9479 13.8192 16.9724C13.7041 17 13.5818 17 13.3373 17H10.6627C10.4182 17 10.2959 17 10.1808 16.9724C10.0787 16.9479 9.98119 16.9075 9.89172 16.8526C9.7908 16.7908 9.70432 16.7043 9.53137 16.5314L9.46863 16.4686C9.29568 16.2957 9.2092 16.2092 9.10828 16.1474C9.01881 16.0925 8.92127 16.0521 8.81923 16.0276C8.70414 16 8.58185 16 8.33726 16H3ZM3 16C2.44772 16 2 16.4477 2 17V17.3333C2 17.9533 2 18.2633 2.06815 18.5176C2.25308 19.2078 2.79218 19.7469 3.48236 19.9319C3.7367 20 4.04669 20 4.66667 20H19.3333C19.9533 20 20.2633 20 20.5176 19.9319C21.2078 19.7469 21.7469 19.2078 21.9319 18.5176C22 18.2633 22 17.9533 22 17.3333C22 17.0233 22 16.8683 21.9659 16.7412C21.8735 16.3961 21.6039 16.1265 21.2588 16.0341C21.1317 16 20.9767 16 20.6667 16H20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ht1 = [
  lt1,
  st1
];
function at1(r, e) {
  return n(), o("svg", it1, ht1);
}
const Oy2 = /* @__PURE__ */ i(ot1, [["render", at1]]);
var dt1 = {}, ct1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _t1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), Ct1 = /* @__PURE__ */ t("path", {
  d: "M21 16V7.2C21 6.0799 21 5.51984 20.782 5.09202C20.5903 4.71569 20.2843 4.40973 19.908 4.21799C19.4802 4 18.9201 4 17.8 4H6.2C5.07989 4 4.51984 4 4.09202 4.21799C3.71569 4.40973 3.40973 4.71569 3.21799 5.09202C3 5.51984 3 6.0799 3 7.2V16M4.66667 20H19.3333C19.9533 20 20.2633 20 20.5176 19.9319C21.2078 19.7469 21.7469 19.2078 21.9319 18.5176C22 18.2633 22 17.9533 22 17.3333C22 17.0233 22 16.8683 21.9659 16.7412C21.8735 16.3961 21.6039 16.1265 21.2588 16.0341C21.1317 16 20.9767 16 20.6667 16H3.33333C3.02334 16 2.86835 16 2.74118 16.0341C2.39609 16.1265 2.12654 16.3961 2.03407 16.7412C2 16.8683 2 17.0233 2 17.3333C2 17.9533 2 18.2633 2.06815 18.5176C2.25308 19.2078 2.79218 19.7469 3.48236 19.9319C3.73669 20 4.04669 20 4.66667 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ft1 = [
  _t1,
  Ct1
];
function vt1(r, e) {
  return n(), o("svg", ct1, ft1);
}
const Ey2 = /* @__PURE__ */ i(dt1, [["render", vt1]]);
var ut1 = {}, wt1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pt1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), gt1 = /* @__PURE__ */ t("path", {
  d: "M12.3578 7.17895C12.2266 7.11336 12.161 7.08056 12.0922 7.06766C12.0313 7.05622 11.9687 7.05622 11.9078 7.06766C11.839 7.08056 11.7734 7.11336 11.6422 7.17895L2 12.0001L11.6422 16.8212C11.7734 16.8868 11.839 16.9196 11.9078 16.9325C11.9687 16.9439 12.0313 16.9439 12.0922 16.9325C12.161 16.9196 12.2266 16.8868 12.3578 16.8212L22 12.0001L12.3578 7.17895Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $t1 = [
  pt1,
  gt1
];
function Mt1(r, e) {
  return n(), o("svg", wt1, $t1);
}
const Ry2 = /* @__PURE__ */ i(ut1, [["render", Mt1]]);
var Lt1 = {}, kt1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mt1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), xt1 = /* @__PURE__ */ t("path", {
  d: "M2 12.0001L11.6422 16.8212C11.7734 16.8868 11.839 16.9196 11.9078 16.9325C11.9687 16.9439 12.0313 16.9439 12.0922 16.9325C12.161 16.9196 12.2266 16.8868 12.3578 16.8212L22 12.0001M2 17.0001L11.6422 21.8212C11.7734 21.8868 11.839 21.9196 11.9078 21.9325C11.9687 21.9439 12.0313 21.9439 12.0922 21.9325C12.161 21.9196 12.2266 21.8868 12.3578 21.8212L22 17.0001M2 7.00006L11.6422 2.17895C11.7734 2.11336 11.839 2.08056 11.9078 2.06766C11.9687 2.05622 12.0313 2.05622 12.0922 2.06766C12.161 2.08056 12.2266 2.11336 12.3578 2.17895L22 7.00006L12.3578 11.8212C12.2266 11.8868 12.161 11.9196 12.0922 11.9325C12.0313 11.9439 11.9687 11.9439 11.9078 11.9325C11.839 11.9196 11.7734 11.8868 11.6422 11.8212L2 7.00006Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ht1 = [
  mt1,
  xt1
];
function Vt1(r, e) {
  return n(), o("svg", kt1, Ht1);
}
const Uy2 = /* @__PURE__ */ i(Lt1, [["render", Vt1]]);
var Zt1 = {}, Bt1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ft1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), jt1 = /* @__PURE__ */ t("path", {
  d: "M7 9.50006L2 12.0001L11.6422 16.8212C11.7734 16.8868 11.839 16.9196 11.9078 16.9325C11.9687 16.9439 12.0313 16.9439 12.0922 16.9325C12.161 16.9196 12.2266 16.8868 12.3578 16.8212L22 12.0001L17 9.50006M7 14.5001L2 17.0001L11.6422 21.8212C11.7734 21.8868 11.839 21.9196 11.9078 21.9325C11.9687 21.9439 12.0313 21.9439 12.0922 21.9325C12.161 21.9196 12.2266 21.8868 12.3578 21.8212L22 17.0001L17 14.5001M2 7.00006L11.6422 2.17895C11.7734 2.11336 11.839 2.08056 11.9078 2.06766C11.9687 2.05622 12.0313 2.05622 12.0922 2.06766C12.161 2.08056 12.2266 2.11336 12.3578 2.17895L22 7.00006L12.3578 11.8212C12.2266 11.8868 12.161 11.9196 12.0922 11.9325C12.0313 11.9439 11.9687 11.9439 11.9078 11.9325C11.839 11.9196 11.7734 11.8868 11.6422 11.8212L2 7.00006Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), It1 = [
  Ft1,
  jt1
];
function bt1(r, e) {
  return n(), o("svg", Bt1, It1);
}
const Ny2 = /* @__PURE__ */ i(Zt1, [["render", bt1]]);
var yt1 = {}, Dt1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pt1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), At1 = /* @__PURE__ */ t("path", {
  d: "M2 14.5001L11.6422 19.3212C11.7734 19.3868 11.839 19.4196 11.9078 19.4325C11.9687 19.4439 12.0313 19.4439 12.0922 19.4325C12.161 19.4196 12.2266 19.3868 12.3578 19.3212L22 14.5001M2 9.50006L11.6422 4.67895C11.7734 4.61336 11.839 4.58056 11.9078 4.56766C11.9687 4.55622 12.0313 4.55622 12.0922 4.56766C12.161 4.58056 12.2266 4.61336 12.3578 4.67895L22 9.50006L12.3578 14.3212C12.2266 14.3868 12.161 14.4196 12.0922 14.4325C12.0313 14.4439 11.9687 14.4439 11.9078 14.4325C11.839 14.4196 11.7734 14.3868 11.6422 14.3212L2 9.50006Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), St1 = [
  Pt1,
  At1
];
function Tt1(r, e) {
  return n(), o("svg", Dt1, St1);
}
const qy2 = /* @__PURE__ */ i(yt1, [["render", Tt1]]);
var Ot1 = {}, Et1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rt1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), Ut1 = /* @__PURE__ */ t("path", {
  d: "M7 12.0001L2 14.5001L11.6422 19.3212C11.7734 19.3868 11.839 19.4196 11.9078 19.4325C11.9687 19.4439 12.0313 19.4439 12.0922 19.4325C12.161 19.4196 12.2266 19.3868 12.3578 19.3212L22 14.5001L17 12.0001M2 9.50006L11.6422 4.67895C11.7734 4.61336 11.839 4.58056 11.9078 4.56766C11.9687 4.55622 12.0313 4.55622 12.0922 4.56766C12.161 4.58056 12.2266 4.61336 12.3578 4.67895L22 9.50006L12.3578 14.3212C12.2266 14.3868 12.161 14.4196 12.0922 14.4325C12.0313 14.4439 11.9687 14.4439 11.9078 14.4325C11.839 14.4196 11.7734 14.3868 11.6422 14.3212L2 9.50006Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Nt1 = [
  Rt1,
  Ut1
];
function qt1(r, e) {
  return n(), o("svg", Et1, Nt1);
}
const zy2 = /* @__PURE__ */ i(Ot1, [["render", qt1]]);
var zt1 = {}, Kt1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gt1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), Wt1 = /* @__PURE__ */ t("path", {
  d: "M3 9H21M9 9L9 21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Yt1 = [
  Gt1,
  Wt1
];
function Xt1(r, e) {
  return n(), o("svg", Kt1, Yt1);
}
const Ky2 = /* @__PURE__ */ i(zt1, [["render", Xt1]]);
var Qt1 = {}, Jt1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, te1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), ee1 = /* @__PURE__ */ t("path", {
  d: "M17.5 11H12.5M17.5 15H12.5M17.5 7H12.5M9 3L9 21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), re1 = [
  te1,
  ee1
];
function ne1(r, e) {
  return n(), o("svg", Jt1, re1);
}
const Gy2 = /* @__PURE__ */ i(Qt1, [["render", ne1]]);
var oe1 = {}, ie1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, le1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), se1 = /* @__PURE__ */ t("path", {
  d: "M17.5 17H6.5M17.5 13H6.5M3 9H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), he1 = [
  le1,
  se1
];
function ae1(r, e) {
  return n(), o("svg", ie1, he1);
}
const Wy2 = /* @__PURE__ */ i(oe1, [["render", ae1]]);
var de1 = {}, ce1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _e1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), Ce1 = /* @__PURE__ */ t("path", {
  d: "M12 12L21 12M12 3L12 21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fe1 = [
  _e1,
  Ce1
];
function ve1(r, e) {
  return n(), o("svg", ce1, fe1);
}
const Yy2 = /* @__PURE__ */ i(de1, [["render", ve1]]);
var ue1 = {}, we1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pe1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -636)",
  fill: "none"
}, null, -1), ge1 = /* @__PURE__ */ t("path", {
  d: "M3 15H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $e1 = [
  pe1,
  ge1
];
function Me1(r, e) {
  return n(), o("svg", we1, $e1);
}
const Xy2 = /* @__PURE__ */ i(ue1, [["render", Me1]]);
var Le1 = {}, ke1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, me1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -676)",
  fill: "none"
}, null, -1), xe1 = /* @__PURE__ */ t("path", {
  d: "M3 12H21M12 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), He1 = [
  me1,
  xe1
];
function Ve1(r, e) {
  return n(), o("svg", ke1, He1);
}
const Qy2 = /* @__PURE__ */ i(Le1, [["render", Ve1]]);
var Ze1 = {}, Be1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fe1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -716)",
  fill: "none"
}, null, -1), je1 = /* @__PURE__ */ t("path", {
  d: "M3 9H21M3 15H21M12 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ie1 = [
  Fe1,
  je1
];
function be1(r, e) {
  return n(), o("svg", Be1, Ie1);
}
const Jy2 = /* @__PURE__ */ i(Ze1, [["render", be1]]);
var ye1 = {}, De1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pe1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-608 -756)",
  fill: "none"
}, null, -1), Ae1 = /* @__PURE__ */ t("path", {
  d: "M9 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Se1 = [
  Pe1,
  Ae1
];
function Te1(r, e) {
  return n(), o("svg", De1, Se1);
}
const tD2 = /* @__PURE__ */ i(ye1, [["render", Te1]]);
var Oe1 = {}, Ee1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Re1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), Ue1 = /* @__PURE__ */ t("path", {
  d: "M15 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ne1 = [
  Re1,
  Ue1
];
function qe1(r, e) {
  return n(), o("svg", Ee1, Ne1);
}
const eD2 = /* @__PURE__ */ i(Oe1, [["render", qe1]]);
var ze1 = {}, Ke1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ge1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), We1 = /* @__PURE__ */ t("path", {
  d: "M3 9H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ye1 = [
  Ge1,
  We1
];
function Xe1(r, e) {
  return n(), o("svg", Ke1, Ye1);
}
const rD2 = /* @__PURE__ */ i(ze1, [["render", Xe1]]);
var Qe1 = {}, Je1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tr1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -1116)",
  fill: "none"
}, null, -1), er1 = /* @__PURE__ */ t("path", {
  d: "M21 9.25H12M21 4H3M21 14.75H12M21 20H3M4.28 8.56L8.14667 11.46C8.43616 11.6771 8.5809 11.7857 8.63266 11.9188C8.678 12.0353 8.678 12.1647 8.63266 12.2812C8.5809 12.4143 8.43616 12.5229 8.14667 12.74L4.28 15.64C3.86802 15.949 3.66203 16.1035 3.48961 16.0999C3.33956 16.0968 3.19885 16.0264 3.10632 15.9082C3 15.7725 3 15.515 3 15V9.2C3 8.68503 3 8.42754 3.10632 8.29175C3.19885 8.17358 3.33956 8.10323 3.48961 8.10011C3.66203 8.09652 3.86802 8.25102 4.28 8.56Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rr1 = [
  tr1,
  er1
];
function nr1(r, e) {
  return n(), o("svg", Je1, rr1);
}
const nD2 = /* @__PURE__ */ i(Qe1, [["render", nr1]]);
var or1 = {}, ir1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lr1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-336 -1156)",
  fill: "none"
}, null, -1), sr1 = /* @__PURE__ */ t("path", {
  d: "M21 9.24995H12M21 3.99995L12 3.99995M21 14.75H3M21 20H3M4.28 2.95995L8.14667 5.85995C8.43616 6.07707 8.5809 6.18563 8.63266 6.31872C8.678 6.43529 8.678 6.56462 8.63266 6.68119C8.5809 6.81427 8.43616 6.92283 8.14667 7.13995L4.28 10.04C3.86802 10.3489 3.66203 10.5034 3.48961 10.4998C3.33956 10.4967 3.19885 10.4264 3.10632 10.3082C3 10.1724 3 9.91493 3 9.39995V3.59995C3 3.08498 3 2.82749 3.10632 2.6917C3.19885 2.57354 3.33956 2.50318 3.48961 2.50006C3.66203 2.49648 3.86802 2.65097 4.28 2.95995Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hr1 = [
  lr1,
  sr1
];
function ar1(r, e) {
  return n(), o("svg", ir1, hr1);
}
const oD2 = /* @__PURE__ */ i(or1, [["render", ar1]]);
var dr1 = {}, cr1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _r1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), Cr1 = /* @__PURE__ */ t("path", {
  d: "M9 13L15 13M7 17L11.2717 7.60225C11.5031 7.09323 11.6188 6.83872 11.7791 6.75976C11.9184 6.69115 12.0816 6.69115 12.2209 6.75976C12.3812 6.83872 12.4969 7.09323 12.7283 7.60225L17 17M21 3V21M3 3L3 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fr1 = [
  _r1,
  Cr1
];
function vr1(r, e) {
  return n(), o("svg", cr1, fr1);
}
const iD2 = /* @__PURE__ */ i(dr1, [["render", vr1]]);
var ur1 = {}, wr1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pr1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), gr1 = /* @__PURE__ */ t("path", {
  d: "M2 18H22M2 18L5 15M2 18L5 21M22 18L19 15M22 18L19 21M7 3H17M12 3V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $r1 = [
  pr1,
  gr1
];
function Mr1(r, e) {
  return n(), o("svg", wr1, $r1);
}
const lD2 = /* @__PURE__ */ i(ur1, [["render", Mr1]]);
var Lr1 = {}, kr1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mr1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1796)",
  fill: "none"
}, null, -1), xr1 = /* @__PURE__ */ t("path", {
  d: "M9.13626 9.13628L4.92893 4.92896M4.92893 19.0711L9.16797 14.8321M14.8611 14.8638L19.0684 19.0711M19.0684 4.92896L14.8287 9.16862M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Hr1 = [
  mr1,
  xr1
];
function Vr1(r, e) {
  return n(), o("svg", kr1, Hr1);
}
const sD2 = /* @__PURE__ */ i(Lr1, [["render", Vr1]]);
var Zr1 = {}, Br1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fr1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1836)",
  fill: "none"
}, null, -1), jr1 = /* @__PURE__ */ t("path", {
  d: "M8.46445 8.46448L4.92893 4.92896M4.92893 19.0711L8.46448 15.5355M15.5355 15.5355L19.0711 19.071M19.0711 4.92891L15.5355 8.46445M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ir1 = [
  Fr1,
  jr1
];
function br1(r, e) {
  return n(), o("svg", Br1, Ir1);
}
const hD2 = /* @__PURE__ */ i(Zr1, [["render", br1]]);
var yr1 = {}, Dr1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pr1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), Ar1 = /* @__PURE__ */ t("path", {
  d: "M15 16.5V19C15 19.9319 15 20.3978 14.8478 20.7654C14.6448 21.2554 14.2554 21.6448 13.7654 21.8478C13.3978 22 12.9319 22 12 22C11.0681 22 10.6022 22 10.2346 21.8478C9.74458 21.6448 9.35523 21.2554 9.15224 20.7654C9 20.3978 9 19.9319 9 19V16.5M15 16.5C17.6489 15.3427 19.5 12.5755 19.5 9.5C19.5 5.35786 16.1421 2 12 2C7.85786 2 4.5 5.35786 4.5 9.5C4.5 12.5755 6.35114 15.3427 9 16.5M15 16.5H9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Sr1 = [
  Pr1,
  Ar1
];
function Tr1(r, e) {
  return n(), o("svg", Dr1, Sr1);
}
const aD2 = /* @__PURE__ */ i(yr1, [["render", Tr1]]);
var Or1 = {}, Er1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rr1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), Ur1 = /* @__PURE__ */ t("path", {
  d: "M10 17.6586V20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20V17.6586M12 2V3M3 12H2M5.5 5.5L4.8999 4.8999M18.5 5.5L19.1002 4.8999M22 12H21M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Nr1 = [
  Rr1,
  Ur1
];
function qr1(r, e) {
  return n(), o("svg", Er1, Nr1);
}
const dD2 = /* @__PURE__ */ i(Or1, [["render", qr1]]);
var zr1 = {}, Kr1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gr1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), Wr1 = /* @__PURE__ */ t("path", {
  d: "M9.5 22H14.5M15 15.3264C17.3649 14.2029 19 11.7924 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 11.7924 6.63505 14.2029 9 15.3264V16C9 16.9319 9 17.3978 9.15224 17.7654C9.35523 18.2554 9.74458 18.6448 10.2346 18.8478C10.6022 19 11.0681 19 12 19C12.9319 19 13.3978 19 13.7654 18.8478C14.2554 18.6448 14.6448 18.2554 14.8478 17.7654C15 17.3978 15 16.9319 15 16V15.3264Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Yr1 = [
  Gr1,
  Wr1
];
function Xr1(r, e) {
  return n(), o("svg", Kr1, Yr1);
}
const cD2 = /* @__PURE__ */ i(zr1, [["render", Xr1]]);
var Qr1 = {}, Jr1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tn1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), en1 = /* @__PURE__ */ t("path", {
  d: "M9.5 22H14.5M10 10H14M12 10L12 16M15 15.3264C17.3649 14.2029 19 11.7924 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 11.7924 6.63505 14.2029 9 15.3264V16C9 16.9319 9 17.3978 9.15224 17.7654C9.35523 18.2554 9.74458 18.6448 10.2346 18.8478C10.6022 19 11.0681 19 12 19C12.9319 19 13.3978 19 13.7654 18.8478C14.2554 18.6448 14.6448 18.2554 14.8478 17.7654C15 17.3978 15 16.9319 15 16V15.3264Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rn1 = [
  tn1,
  en1
];
function nn1(r, e) {
  return n(), o("svg", Jr1, rn1);
}
const _D2 = /* @__PURE__ */ i(Qr1, [["render", nn1]]);
var on1 = {}, in1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ln1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), sn1 = /* @__PURE__ */ t("path", {
  d: "M12 2V3M3 12H2M5.5 5.5L4.8999 4.8999M18.5 5.5L19.1002 4.8999M22 12H21M10 13.5H14M12 13.5V18.5M15.5 16.874C17.0141 15.7848 18 14.0075 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 14.0075 6.98593 15.7848 8.5 16.874V18.8C8.5 19.9201 8.5 20.4802 8.71799 20.908C8.90973 21.2843 9.21569 21.5903 9.59202 21.782C10.0198 22 10.5799 22 11.7 22H12.3C13.4201 22 13.9802 22 14.408 21.782C14.7843 21.5903 15.0903 21.2843 15.282 20.908C15.5 20.4802 15.5 19.9201 15.5 18.8V16.874Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hn1 = [
  ln1,
  sn1
];
function an1(r, e) {
  return n(), o("svg", in1, hn1);
}
const CD2 = /* @__PURE__ */ i(on1, [["render", an1]]);
var dn1 = {}, cn1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _n1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), Cn1 = /* @__PURE__ */ t("path", {
  d: "M13 2L4.09344 12.6879C3.74463 13.1064 3.57023 13.3157 3.56756 13.4925C3.56524 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9065 11.3121C20.2553 10.8936 20.4297 10.6843 20.4324 10.5075C20.4347 10.3539 20.3663 10.2077 20.2467 10.1111C20.1092 10 19.8368 10 19.292 10H12L13 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fn1 = [
  _n1,
  Cn1
];
function vn1(r, e) {
  return n(), o("svg", cn1, fn1);
}
const fD2 = /* @__PURE__ */ i(dn1, [["render", vn1]]);
var un1 = {}, wn1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pn1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), gn1 = /* @__PURE__ */ t("path", {
  d: "M14.2495 2H8.49395C8.31447 2 8.22473 2 8.14551 2.02733C8.07544 2.05149 8.01163 2.09093 7.95868 2.14279C7.89881 2.20143 7.85868 2.2817 7.77841 2.44223L3.57841 10.8422C3.38673 11.2256 3.29089 11.4173 3.31391 11.5731C3.33401 11.7091 3.40927 11.8309 3.52197 11.9097C3.65104 12 3.86534 12 4.29395 12H10.4995L7.49953 22L19.6926 9.35531C20.104 8.9287 20.3097 8.7154 20.3217 8.53288C20.3321 8.37446 20.2667 8.22049 20.1454 8.11803C20.0057 8 19.7094 8 19.1167 8H11.9995L14.2495 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $n1 = [
  pn1,
  gn1
];
function Mn1(r, e) {
  return n(), o("svg", wn1, $n1);
}
const vD2 = /* @__PURE__ */ i(un1, [["render", Mn1]]);
var Ln1 = {}, kn1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mn1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -236)",
  fill: "none"
}, null, -1), xn1 = /* @__PURE__ */ t("path", {
  d: "M21 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V3M20 15L16.0811 10.8173C15.9326 10.6588 15.8584 10.5796 15.7688 10.5386C15.6897 10.5024 15.6026 10.4875 15.516 10.4953C15.4179 10.5042 15.3215 10.5542 15.1287 10.6543L11.8713 12.3457C11.6785 12.4458 11.5821 12.4958 11.484 12.5047C11.3974 12.5125 11.3103 12.4976 11.2312 12.4614C11.1416 12.4204 11.0674 12.3412 10.9189 12.1827L7 8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Hn1 = [
  mn1,
  xn1
];
function Vn1(r, e) {
  return n(), o("svg", kn1, Hn1);
}
const uD2 = /* @__PURE__ */ i(Ln1, [["render", Vn1]]);
var Zn1 = {}, Bn1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fn1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -276)",
  fill: "none"
}, null, -1), jn1 = /* @__PURE__ */ t("path", {
  d: "M21 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V3M21 15L15.5657 9.56569C15.3677 9.36768 15.2687 9.26867 15.1545 9.23158C15.0541 9.19895 14.9459 9.19895 14.8455 9.23158C14.7313 9.26867 14.6323 9.36768 14.4343 9.56569L12.5657 11.4343C12.3677 11.6323 12.2687 11.7313 12.1545 11.7684C12.0541 11.8011 11.9459 11.8011 11.8455 11.7684C11.7313 11.7313 11.6323 11.6323 11.4343 11.4343L7 7M21 15H17M21 15V11",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), In1 = [
  Fn1,
  jn1
];
function bn1(r, e) {
  return n(), o("svg", Bn1, In1);
}
const wD2 = /* @__PURE__ */ i(Zn1, [["render", bn1]]);
var yn1 = {}, Dn1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pn1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -316)",
  fill: "none"
}, null, -1), An1 = /* @__PURE__ */ t("path", {
  d: "M17 15L11.5657 9.56569C11.3677 9.36768 11.2687 9.26867 11.1545 9.23158C11.0541 9.19895 10.9459 9.19895 10.8455 9.23158C10.7313 9.26867 10.6323 9.36768 10.4343 9.56569L8.56569 11.4343C8.36768 11.6323 8.26867 11.7313 8.15451 11.7684C8.05409 11.8011 7.94591 11.8011 7.84549 11.7684C7.73133 11.7313 7.63232 11.6323 7.43431 11.4343L3 7M17 15H13M17 15V11M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Sn1 = [
  Pn1,
  An1
];
function Tn1(r, e) {
  return n(), o("svg", Dn1, Sn1);
}
const pD2 = /* @__PURE__ */ i(yn1, [["render", Tn1]]);
var On1 = {}, En1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rn1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -356)",
  fill: "none"
}, null, -1), Un1 = /* @__PURE__ */ t("path", {
  d: "M3 9L9.65533 13.7538C9.85422 13.8959 10.1267 13.8733 10.2995 13.7005L13.7005 10.2995C13.8733 10.1267 14.1458 10.1041 14.3447 10.2462L21 15M6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Nn1 = [
  Rn1,
  Un1
];
function qn1(r, e) {
  return n(), o("svg", En1, Nn1);
}
const gD2 = /* @__PURE__ */ i(On1, [["render", qn1]]);
var zn1 = {}, Kn1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gn1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -396)",
  fill: "none"
}, null, -1), Wn1 = /* @__PURE__ */ t("path", {
  d: "M6 10L9.43431 13.4343C9.63232 13.6323 9.73133 13.7313 9.84549 13.7684C9.94591 13.8011 10.0541 13.8011 10.1545 13.7684C10.2687 13.7313 10.3677 13.6323 10.5657 13.4343L13.4343 10.5657C13.6323 10.3677 13.7313 10.2687 13.8455 10.2316C13.9459 10.1989 14.0541 10.1989 14.1545 10.2316C14.2687 10.2687 14.3677 10.3677 14.5657 10.5657L18 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Yn1 = [
  Gn1,
  Wn1
];
function Xn1(r, e) {
  return n(), o("svg", Kn1, Yn1);
}
const $D2 = /* @__PURE__ */ i(zn1, [["render", Xn1]]);
var Qn1 = {}, Jn1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, to1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -436)",
  fill: "none"
}, null, -1), eo1 = /* @__PURE__ */ t("path", {
  d: "M21 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V3M20 8L16.0811 12.1827C15.9326 12.3412 15.8584 12.4204 15.7688 12.4614C15.6897 12.4976 15.6026 12.5125 15.516 12.5047C15.4179 12.4958 15.3215 12.4458 15.1287 12.3457L11.8713 10.6543C11.6785 10.5542 11.5821 10.5042 11.484 10.4953C11.3974 10.4875 11.3103 10.5024 11.2312 10.5386C11.1416 10.5796 11.0674 10.6588 10.9189 10.8173L7 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ro1 = [
  to1,
  eo1
];
function no1(r, e) {
  return n(), o("svg", Jn1, ro1);
}
const MD2 = /* @__PURE__ */ i(Qn1, [["render", no1]]);
var oo1 = {}, io1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lo1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -476)",
  fill: "none"
}, null, -1), so1 = /* @__PURE__ */ t("path", {
  d: "M21 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V3M21 7L15.5657 12.4343C15.3677 12.6323 15.2687 12.7313 15.1545 12.7684C15.0541 12.8011 14.9459 12.8011 14.8455 12.7684C14.7313 12.7313 14.6323 12.6323 14.4343 12.4343L12.5657 10.5657C12.3677 10.3677 12.2687 10.2687 12.1545 10.2316C12.0541 10.1989 11.9459 10.1989 11.8455 10.2316C11.7313 10.2687 11.6323 10.3677 11.4343 10.5657L7 15M21 7H17M21 7V11",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ho1 = [
  lo1,
  so1
];
function ao1(r, e) {
  return n(), o("svg", io1, ho1);
}
const LD2 = /* @__PURE__ */ i(oo1, [["render", ao1]]);
var do1 = {}, co1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _o1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -516)",
  fill: "none"
}, null, -1), Co1 = /* @__PURE__ */ t("path", {
  d: "M17 9L11.5657 14.4343C11.3677 14.6323 11.2687 14.7313 11.1545 14.7684C11.0541 14.8011 10.9459 14.8011 10.8455 14.7684C10.7313 14.7313 10.6323 14.6323 10.4343 14.4343L8.56569 12.5657C8.36768 12.3677 8.26867 12.2687 8.15451 12.2316C8.05409 12.1989 7.94591 12.1989 7.84549 12.2316C7.73133 12.2687 7.63232 12.3677 7.43431 12.5657L3 17M17 9H13M17 9V13M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fo1 = [
  _o1,
  Co1
];
function vo1(r, e) {
  return n(), o("svg", co1, fo1);
}
const kD2 = /* @__PURE__ */ i(do1, [["render", vo1]]);
var uo1 = {}, wo1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, po1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -556)",
  fill: "none"
}, null, -1), go1 = /* @__PURE__ */ t("path", {
  d: "M21 9L14.5515 13.6061C14.3555 13.746 14.2576 13.816 14.1527 13.8371C14.0602 13.8557 13.9643 13.8478 13.8762 13.8142C13.7762 13.7762 13.691 13.691 13.5208 13.5208L10.4792 10.4792C10.309 10.309 10.2238 10.2238 10.1238 10.1858C10.0357 10.1522 9.9398 10.1443 9.84732 10.1629C9.74241 10.184 9.64445 10.254 9.44853 10.3939L3 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $o1 = [
  po1,
  go1
];
function Mo1(r, e) {
  return n(), o("svg", wo1, $o1);
}
const mD2 = /* @__PURE__ */ i(uo1, [["render", Mo1]]);
var Lo1 = {}, ko1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mo1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -596)",
  fill: "none"
}, null, -1), xo1 = /* @__PURE__ */ t("path", {
  d: "M18 10L14.5657 13.4343C14.3677 13.6323 14.2687 13.7313 14.1545 13.7684C14.0541 13.8011 13.9459 13.8011 13.8455 13.7684C13.7313 13.7313 13.6323 13.6323 13.4343 13.4343L10.5657 10.5657C10.3677 10.3677 10.2687 10.2687 10.1545 10.2316C10.0541 10.1989 9.94591 10.1989 9.84549 10.2316C9.73133 10.2687 9.63232 10.3677 9.43431 10.5657L6 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ho1 = [
  mo1,
  xo1
];
function Vo1(r, e) {
  return n(), o("svg", ko1, Ho1);
}
const xD2 = /* @__PURE__ */ i(Lo1, [["render", Vo1]]);
var Zo1 = {}, Bo1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fo1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), jo1 = /* @__PURE__ */ t("path", {
  d: "M9 13H15M7 17L11.2717 7.60224C11.5031 7.09323 11.6188 6.83872 11.7791 6.75976C11.9184 6.69115 12.0816 6.69115 12.2209 6.75976C12.3812 6.83872 12.4969 7.09323 12.7283 7.60224L17 17M21 21H3M21 3H3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Io1 = [
  Fo1,
  jo1
];
function bo1(r, e) {
  return n(), o("svg", Bo1, Io1);
}
const HD2 = /* @__PURE__ */ i(Zo1, [["render", bo1]]);
var yo1 = {}, Do1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Po1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1876)",
  fill: "none"
}, null, -1), Ao1 = /* @__PURE__ */ t("path", {
  d: "M12.7076 18.3639L11.2933 19.7781C9.34072 21.7308 6.1749 21.7308 4.22228 19.7781C2.26966 17.8255 2.26966 14.6597 4.22228 12.7071L5.63649 11.2929M18.3644 12.7071L19.7786 11.2929C21.7312 9.34024 21.7312 6.17441 19.7786 4.22179C17.826 2.26917 14.6602 2.26917 12.7076 4.22179L11.2933 5.636M8.50045 15.4999L15.5005 8.49994",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), So1 = [
  Po1,
  Ao1
];
function To1(r, e) {
  return n(), o("svg", Do1, So1);
}
const VD2 = /* @__PURE__ */ i(yo1, [["render", To1]]);
var Oo1 = {}, Eo1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ro1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1916)",
  fill: "none"
}, null, -1), Uo1 = /* @__PURE__ */ t("path", {
  d: "M9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H9M15 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15M7 12L17 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), No1 = [
  Ro1,
  Uo1
];
function qo1(r, e) {
  return n(), o("svg", Eo1, No1);
}
const ZD2 = /* @__PURE__ */ i(Oo1, [["render", qo1]]);
var zo1 = {}, Ko1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Go1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1956)",
  fill: "none"
}, null, -1), Wo1 = /* @__PURE__ */ t("path", {
  d: "M9.99999 13C10.4294 13.5741 10.9773 14.0491 11.6065 14.3929C12.2357 14.7367 12.9315 14.9411 13.6466 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59695 21.9547 8.33394 21.9434 7.02296C21.932 5.71198 21.4061 4.45791 20.4791 3.53087C19.552 2.60383 18.298 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.46997L11.75 5.17997M14 11C13.5705 10.4258 13.0226 9.95078 12.3934 9.60703C11.7642 9.26327 11.0685 9.05885 10.3533 9.00763C9.63819 8.95641 8.9204 9.0596 8.24864 9.31018C7.57688 9.56077 6.96687 9.9529 6.45999 10.46L3.45999 13.46C2.5492 14.403 2.04522 15.666 2.05662 16.977C2.06801 18.288 2.59385 19.542 3.52089 20.4691C4.44793 21.3961 5.702 21.9219 7.01298 21.9333C8.32396 21.9447 9.58697 21.4408 10.53 20.53L12.24 18.82",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Yo1 = [
  Go1,
  Wo1
];
function Xo1(r, e) {
  return n(), o("svg", Ko1, Yo1);
}
const BD2 = /* @__PURE__ */ i(zo1, [["render", Xo1]]);
var Qo1 = {}, Jo1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ti1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -1996)",
  fill: "none"
}, null, -1), ei1 = /* @__PURE__ */ t("path", {
  d: "M7.5 7H7C4.23858 7 2 9.23858 2 12C2 14.7614 4.23858 17 7 17H9C11.7614 17 14 14.7614 14 12M16.5 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15C12.2386 7 10 9.23858 10 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ri1 = [
  ti1,
  ei1
];
function ni1(r, e) {
  return n(), o("svg", Jo1, ri1);
}
const FD2 = /* @__PURE__ */ i(Qo1, [["render", ni1]]);
var oi1 = {}, ii1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, li1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -2036)",
  fill: "none"
}, null, -1), si1 = /* @__PURE__ */ t("path", {
  d: "M9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H9M8 12L18 12M15.7778 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15.7778C15.3482 7 15 7.34822 15 7.77778V16.2222C15 16.6518 15.3482 17 15.7778 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hi1 = [
  li1,
  si1
];
function ai1(r, e) {
  return n(), o("svg", ii1, hi1);
}
const jD2 = /* @__PURE__ */ i(oi1, [["render", ai1]]);
var di1 = {}, ci1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _i1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-336 -2076)",
  fill: "none"
}, null, -1), Ci1 = /* @__PURE__ */ t("path", {
  d: "M9 4V2M15 20V22M4 9H2M20 15H22M4.91421 4.91421L3.5 3.5M19.0858 19.0858L20.5 20.5M12 17.6569L9.87868 19.7782C8.31658 21.3403 5.78392 21.3403 4.22183 19.7782C2.65973 18.2161 2.65973 15.6834 4.22183 14.1213L6.34315 12M17.6569 12L19.7782 9.87868C21.3403 8.31658 21.3403 5.78392 19.7782 4.22183C18.2161 2.65973 15.6834 2.65973 14.1213 4.22183L12 6.34315",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fi1 = [
  _i1,
  Ci1
];
function vi1(r, e) {
  return n(), o("svg", ci1, fi1);
}
const ID2 = /* @__PURE__ */ i(di1, [["render", vi1]]);
var ui1 = {}, wi1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pi1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), gi1 = /* @__PURE__ */ t("path", {
  d: "M8.5 15.5L15.5 8.49998M9 4V2M15 20V22M4 9H2M20 15H22M4.91421 4.91421L3.5 3.5M19.0858 19.0857L20.5 20.4999M12 17.6568L9.87871 19.7781C8.31662 21.3402 5.78396 21.3402 4.22186 19.7781C2.65976 18.216 2.65976 15.6833 4.22186 14.1212L6.34318 11.9999M17.6569 11.9999L19.7782 9.87859C21.3403 8.31649 21.3403 5.78383 19.7782 4.22174C18.2161 2.65964 15.6835 2.65964 14.1214 4.22174L12 6.34306",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $i1 = [
  pi1,
  gi1
];
function Mi1(r, e) {
  return n(), o("svg", wi1, $i1);
}
const bD2 = /* @__PURE__ */ i(ui1, [["render", Mi1]]);
var Li1 = {}, ki1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mi1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), xi1 = /* @__PURE__ */ t("path", {
  d: "M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Hi1 = [
  mi1,
  xi1
];
function Vi1(r, e) {
  return n(), o("svg", ki1, Hi1);
}
const yD2 = /* @__PURE__ */ i(Li1, [["render", Vi1]]);
var Zi1 = {}, Bi1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fi1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), ji1 = /* @__PURE__ */ t("path", {
  d: "M21 9.00001L21 3.00001M21 3.00001H15M21 3.00001L12 12M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ii1 = [
  Fi1,
  ji1
];
function bi1(r, e) {
  return n(), o("svg", Bi1, Ii1);
}
const DD2 = /* @__PURE__ */ i(Zi1, [["render", bi1]]);
var yi1 = {}, Di1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pi1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), Ai1 = /* @__PURE__ */ t("path", {
  d: "M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Si1 = [
  Pi1,
  Ai1
];
function Ti1(r, e) {
  return n(), o("svg", Di1, Si1);
}
const PD2 = /* @__PURE__ */ i(yi1, [["render", Ti1]]);
var Oi1 = {}, Ei1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ri1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), Ui1 = /* @__PURE__ */ t("path", {
  d: "M12 2.25V4.75M12 18V22M5.75 12H2.25M21.25 12H19.75M18.4571 18.4571L17.75 17.75M18.6642 5.41579L17.25 6.83M4.92157 19.0784L7.75 16.25M5.12868 5.20868L7.25 7.33",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ni1 = [
  Ri1,
  Ui1
];
function qi1(r, e) {
  return n(), o("svg", Ei1, Ni1);
}
const AD2 = /* @__PURE__ */ i(Oi1, [["render", qi1]]);
var zi1 = {}, Ki1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gi1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), Wi1 = /* @__PURE__ */ t("path", {
  d: "M12 2V6M12 18V22M6 12H2M22 12H18M19.0784 19.0784L16.25 16.25M19.0784 4.99994L16.25 7.82837M4.92157 19.0784L7.75 16.25M4.92157 4.99994L7.75 7.82837",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Yi1 = [
  Gi1,
  Wi1
];
function Xi1(r, e) {
  return n(), o("svg", Ki1, Yi1);
}
const R1 = /* @__PURE__ */ i(zi1, [["render", Xi1]]);
var Qi1 = {}, Ji1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tl1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), el1 = /* @__PURE__ */ t("path", {
  d: "M3.34025 16.9997C2.0881 14.8298 2.72473 12.0644 4.79795 10.6601L4.80018 10.6578C6.46564 9.53235 8.65775 9.57012 10.2843 10.7523L13.7164 13.2477C15.3418 14.4299 17.5339 14.4676 19.2005 13.3421L19.2027 13.3399C21.2771 11.9356 21.9148 9.16792 20.6604 7.00026M17.002 20.6593C14.8321 21.9114 12.0667 21.2748 10.6623 19.2016L10.6601 19.1994C9.53457 17.5339 9.57234 15.3418 10.7545 13.7152L13.2499 10.2832C14.4321 8.6577 14.4699 6.46559 13.3444 4.79901L13.3399 4.79679C11.9356 2.72468 9.16792 2.08582 7.00026 3.3402M19.0705 4.92901C22.9758 8.83436 22.9758 15.1651 19.0705 19.0705C15.1651 22.9758 8.83436 22.9758 4.92901 19.0705C1.02366 15.1651 1.02366 8.83436 4.92901 4.92901C8.83436 1.02366 15.1651 1.02366 19.0705 4.92901Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rl1 = [
  tl1,
  el1
];
function nl1(r, e) {
  return n(), o("svg", Ji1, rl1);
}
const SD2 = /* @__PURE__ */ i(Qi1, [["render", nl1]]);
var ol1 = {}, il1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ll1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), sl1 = /* @__PURE__ */ t("path", {
  d: "M17 10V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V10M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hl1 = [
  ll1,
  sl1
];
function al1(r, e) {
  return n(), o("svg", il1, hl1);
}
const TD2 = /* @__PURE__ */ i(ol1, [["render", al1]]);
var dl1 = {}, cl1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _l1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), Cl1 = /* @__PURE__ */ t("path", {
  d: "M17 11V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V11M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V15.8C21 14.1198 21 13.2798 20.673 12.638C20.3854 12.0735 19.9265 11.6146 19.362 11.327C18.7202 11 17.8802 11 16.2 11H7.8C6.11984 11 5.27976 11 4.63803 11.327C4.07354 11.6146 3.6146 12.0735 3.32698 12.638C3 13.2798 3 14.1198 3 15.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fl1 = [
  _l1,
  Cl1
];
function vl1(r, e) {
  return n(), o("svg", cl1, fl1);
}
const OD2 = /* @__PURE__ */ i(dl1, [["render", vl1]]);
var ul1 = {}, wl1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pl1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), gl1 = /* @__PURE__ */ t("path", {
  d: "M17 11V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V11M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V15.8C20 14.1198 20 13.2798 19.673 12.638C19.3854 12.0735 18.9265 11.6146 18.362 11.327C17.7202 11 16.8802 11 15.2 11H8.8C7.11984 11 6.27976 11 5.63803 11.327C5.07354 11.6146 4.6146 12.0735 4.32698 12.638C4 13.2798 4 14.1198 4 15.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $l1 = [
  pl1,
  gl1
];
function Ml1(r, e) {
  return n(), o("svg", wl1, $l1);
}
const ED2 = /* @__PURE__ */ i(ul1, [["render", Ml1]]);
var Ll1 = {}, kl1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ml1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), xl1 = /* @__PURE__ */ t("path", {
  d: "M7.10102 10H7V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10H16.899M12 14V16M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 11.134 8.13401 8 12 8C15.866 8 19 11.134 19 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Hl1 = [
  ml1,
  xl1
];
function Vl1(r, e) {
  return n(), o("svg", kl1, Hl1);
}
const RD2 = /* @__PURE__ */ i(Ll1, [["render", Vl1]]);
var Zl1 = {}, Bl1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fl1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), jl1 = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Il1 = /* @__PURE__ */ t("path", {
  d: "M13.7316 13.1947C13.661 12.9831 13.6257 12.8772 13.6276 12.7907C13.6295 12.6996 13.6417 12.6519 13.6836 12.5711C13.7235 12.4942 13.83 12.395 14.0432 12.1967C14.6318 11.649 15 10.8675 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 10.8675 9.36818 11.649 9.95681 12.1967C10.17 12.395 10.2765 12.4942 10.3164 12.5711C10.3583 12.6519 10.3705 12.6996 10.3724 12.7907C10.3743 12.8772 10.339 12.9831 10.2684 13.1947L9.35099 15.947C9.23249 16.3025 9.17324 16.4803 9.20877 16.6218C9.23987 16.7456 9.31718 16.8529 9.42484 16.9216C9.54783 17 9.7352 17 10.1099 17H13.8901C14.2648 17 14.4522 17 14.5752 16.9216C14.6828 16.8529 14.7601 16.7456 14.7912 16.6218C14.8268 16.4803 14.7675 16.3025 14.649 15.947L13.7316 13.1947Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bl1 = [
  Fl1,
  jl1,
  Il1
];
function yl1(r, e) {
  return n(), o("svg", Bl1, bl1);
}
const UD2 = /* @__PURE__ */ i(Zl1, [["render", yl1]]);
var Dl1 = {}, Pl1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Al1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), Sl1 = /* @__PURE__ */ t("path", {
  d: "M16.2 21C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27977 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3L7.8 3C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8L3 16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Tl1 = /* @__PURE__ */ t("path", {
  d: "M13.7316 13.1947C13.661 12.9831 13.6257 12.8772 13.6276 12.7907C13.6295 12.6996 13.6417 12.6519 13.6836 12.5711C13.7235 12.4942 13.83 12.395 14.0432 12.1967C14.6318 11.6489 15 10.8675 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 10.8675 9.36818 11.649 9.95681 12.1967C10.17 12.395 10.2765 12.4942 10.3164 12.5711C10.3583 12.6519 10.3705 12.6996 10.3724 12.7907C10.3743 12.8772 10.339 12.9831 10.2684 13.1947L9.35099 15.947C9.23249 16.3025 9.17324 16.4803 9.20877 16.6218C9.23987 16.7456 9.31718 16.8529 9.42484 16.9216C9.54783 17 9.7352 17 10.1099 17H13.8901C14.2648 17 14.4522 17 14.5752 16.9216C14.6828 16.8529 14.7601 16.7456 14.7912 16.6218C14.8268 16.4803 14.7675 16.3025 14.649 15.947L13.7316 13.1947Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ol1 = [
  Al1,
  Sl1,
  Tl1
];
function El1(r, e) {
  return n(), o("svg", Pl1, Ol1);
}
const ND2 = /* @__PURE__ */ i(Dl1, [["render", El1]]);
var Rl1 = {}, Ul1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nl1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), ql1 = /* @__PURE__ */ t("path", {
  d: "M7 10V8C7 5.23858 9.23858 3 12 3C14.0503 3 15.8124 4.2341 16.584 6M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zl1 = [
  Nl1,
  ql1
];
function Kl1(r, e) {
  return n(), o("svg", Ul1, zl1);
}
const qD2 = /* @__PURE__ */ i(Rl1, [["render", Kl1]]);
var Gl1 = {}, Wl1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yl1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), Xl1 = /* @__PURE__ */ t("path", {
  d: "M7 11V8C7 5.23858 9.23858 3 12 3C14.419 3 16.4367 4.71776 16.9 7M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V15.8C21 14.1198 21 13.2798 20.673 12.638C20.3854 12.0735 19.9265 11.6146 19.362 11.327C18.7202 11 17.8802 11 16.2 11H7.8C6.11984 11 5.27976 11 4.63803 11.327C4.07354 11.6146 3.6146 12.0735 3.32698 12.638C3 13.2798 3 14.1198 3 15.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ql1 = [
  Yl1,
  Xl1
];
function Jl1(r, e) {
  return n(), o("svg", Wl1, Ql1);
}
const zD2 = /* @__PURE__ */ i(Gl1, [["render", Jl1]]);
var ts1 = {}, es1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rs1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), ns1 = /* @__PURE__ */ t("path", {
  d: "M7 11V8C7 5.23858 9.23858 3 12 3C14.419 3 16.4367 4.71776 16.9 7M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V15.8C20 14.1198 20 13.2798 19.673 12.638C19.3854 12.0735 18.9265 11.6146 18.362 11.327C17.7202 11 16.8802 11 15.2 11H8.8C7.11984 11 6.27976 11 5.63803 11.327C5.07354 11.6146 4.6146 12.0735 4.32698 12.638C4 13.2798 4 14.1198 4 15.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), os1 = [
  rs1,
  ns1
];
function is1(r, e) {
  return n(), o("svg", es1, os1);
}
const KD2 = /* @__PURE__ */ i(ts1, [["render", is1]]);
var ls1 = {}, ss1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hs1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), as1 = /* @__PURE__ */ t("path", {
  d: "M7 10V8C7 5.23858 9.23858 3 12 3C13.6358 3 15.0882 3.78555 16.0004 5M12 14V16M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 11.134 8.13401 8 12 8C15.866 8 19 11.134 19 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ds1 = [
  hs1,
  as1
];
function cs1(r, e) {
  return n(), o("svg", ss1, ds1);
}
const GD2 = /* @__PURE__ */ i(ls1, [["render", cs1]]);
var _s1 = {}, Cs1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fs1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), vs1 = /* @__PURE__ */ t("path", {
  d: "M15 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11985 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H15M10 7L15 12M15 12L10 17M15 12L3 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), us1 = [
  fs1,
  vs1
];
function ws1(r, e) {
  return n(), o("svg", Cs1, us1);
}
const WD2 = /* @__PURE__ */ i(_s1, [["render", ws1]]);
var ps1 = {}, gs1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $s1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), Ms1 = /* @__PURE__ */ t("path", {
  d: "M6 17C6 17.93 6 18.395 6.10222 18.7765C6.37962 19.8117 7.18827 20.6204 8.22354 20.8978C8.60504 21 9.07003 21 10 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H10C9.07003 3 8.60504 3 8.22354 3.10222C7.18827 3.37962 6.37962 4.18827 6.10222 5.22354C6 5.60504 6 6.07003 6 7M12 8L16 12M16 12L12 16M16 12H3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ls1 = [
  $s1,
  Ms1
];
function ks1(r, e) {
  return n(), o("svg", gs1, Ls1);
}
const YD2 = /* @__PURE__ */ i(ps1, [["render", ks1]]);
var ms1 = {}, xs1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hs1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), Vs1 = /* @__PURE__ */ t("path", {
  d: "M6 17C6 17.3513 6 17.5269 6.01567 17.6796C6.14575 18.9474 7.0626 19.9946 8.30206 20.2911C8.45134 20.3268 8.6255 20.35 8.97368 20.3965L15.5656 21.2754C17.442 21.5256 18.3803 21.6507 19.1084 21.3611C19.7478 21.1069 20.2803 20.6407 20.6168 20.0406C21 19.357 21 18.4105 21 16.5175V7.48244C21 5.5894 21 4.64288 20.6168 3.95935C20.2803 3.35923 19.7478 2.893 19.1084 2.6388C18.3803 2.34926 17.442 2.47435 15.5656 2.72455L8.97368 3.60347C8.62546 3.6499 8.45135 3.67311 8.30206 3.70883C7.0626 4.00532 6.14575 5.05254 6.01567 6.3203C6 6.47301 6 6.64866 6 6.99996M12 7.99996L16 12M16 12L12 16M16 12H3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zs1 = [
  Hs1,
  Vs1
];
function Bs1(r, e) {
  return n(), o("svg", xs1, Zs1);
}
const XD2 = /* @__PURE__ */ i(ms1, [["render", Bs1]]);
var Fs1 = {}, js1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Is1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), bs1 = /* @__PURE__ */ t("path", {
  d: "M12 8L16 12M16 12L12 16M16 12H3M3.33782 7C5.06687 4.01099 8.29859 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C8.29859 22 5.06687 19.989 3.33782 17",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ys1 = [
  Is1,
  bs1
];
function Ds1(r, e) {
  return n(), o("svg", js1, ys1);
}
const QD2 = /* @__PURE__ */ i(Fs1, [["render", Ds1]]);
var Ps1 = {}, As1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ss1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), Ts1 = /* @__PURE__ */ t("path", {
  d: "M16 17L21 12M21 12L16 7M21 12H9M9 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Os1 = [
  Ss1,
  Ts1
];
function Es1(r, e) {
  return n(), o("svg", As1, Os1);
}
const JD2 = /* @__PURE__ */ i(Ps1, [["render", Es1]]);
var Rs1 = {}, Us1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ns1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), qs1 = /* @__PURE__ */ t("path", {
  d: "M16 17L21 12M21 12L16 7M21 12H9M12 17C12 17.93 12 18.395 11.8978 18.7765C11.6204 19.8117 10.8117 20.6204 9.77646 20.8978C9.39496 21 8.92997 21 8 21H7.5C6.10218 21 5.40326 21 4.85195 20.7716C4.11687 20.4672 3.53284 19.8831 3.22836 19.1481C3 18.5967 3 17.8978 3 16.5V7.5C3 6.10217 3 5.40326 3.22836 4.85195C3.53284 4.11687 4.11687 3.53284 4.85195 3.22836C5.40326 3 6.10218 3 7.5 3H8C8.92997 3 9.39496 3 9.77646 3.10222C10.8117 3.37962 11.6204 4.18827 11.8978 5.22354C12 5.60504 12 6.07003 12 7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zs1 = [
  Ns1,
  qs1
];
function Ks1(r, e) {
  return n(), o("svg", Us1, zs1);
}
const tP2 = /* @__PURE__ */ i(Rs1, [["render", Ks1]]);
var Gs1 = {}, Ws1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ys1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -636)",
  fill: "none"
}, null, -1), Xs1 = /* @__PURE__ */ t("path", {
  d: "M16 16.9999L21 11.9999M21 11.9999L16 6.99994M21 11.9999H9M12 16.9999C12 17.2955 12 17.4433 11.989 17.5713C11.8748 18.9019 10.8949 19.9968 9.58503 20.2572C9.45903 20.2823 9.31202 20.2986 9.01835 20.3312L7.99694 20.4447C6.46248 20.6152 5.69521 20.7005 5.08566 20.5054C4.27293 20.2453 3.60942 19.6515 3.26118 18.8724C3 18.2881 3 17.5162 3 15.9722V8.02764C3 6.4837 3 5.71174 3.26118 5.12746C3.60942 4.34842 4.27293 3.75454 5.08566 3.49447C5.69521 3.29941 6.46246 3.38466 7.99694 3.55516L9.01835 3.66865C9.31212 3.70129 9.45901 3.71761 9.58503 3.74267C10.8949 4.0031 11.8748 5.09798 11.989 6.42855C12 6.55657 12 6.70436 12 6.99994",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qs1 = [
  Ys1,
  Xs1
];
function Js1(r, e) {
  return n(), o("svg", Ws1, Qs1);
}
const eP2 = /* @__PURE__ */ i(Gs1, [["render", Js1]]);
var th1 = {}, eh1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rh1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -676)",
  fill: "none"
}, null, -1), nh1 = /* @__PURE__ */ t("path", {
  d: "M18 8L22 12M22 12L18 16M22 12H9M15 4.20404C13.7252 3.43827 12.2452 3 10.6667 3C5.8802 3 2 7.02944 2 12C2 16.9706 5.8802 21 10.6667 21C12.2452 21 13.7252 20.5617 15 19.796",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oh1 = [
  rh1,
  nh1
];
function ih1(r, e) {
  return n(), o("svg", eh1, oh1);
}
const rP2 = /* @__PURE__ */ i(th1, [["render", ih1]]);
var lh1 = {}, sh1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hh1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), ah1 = /* @__PURE__ */ t("path", {
  d: "M8 22V20M9.5 15V7M16 22V20M14.5 15V7M8.8 20H15.2C16.8802 20 17.7202 20 18.362 19.673C18.9265 19.3854 19.3854 18.9265 19.673 18.362C20 17.7202 20 16.8802 20 15.2V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V15.2C4 16.8802 4 17.7202 4.32698 18.362C4.6146 18.9265 5.07354 19.3854 5.63803 19.673C6.27976 20 7.11984 20 8.8 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dh1 = [
  hh1,
  ah1
];
function ch1(r, e) {
  return n(), o("svg", sh1, dh1);
}
const nP2 = /* @__PURE__ */ i(lh1, [["render", ch1]]);
var _h1 = {}, Ch1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fh1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), vh1 = /* @__PURE__ */ t("path", {
  d: "M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M12.8 17.5H17.7C17.98 17.5 18.12 17.5 18.227 17.4455C18.3211 17.3976 18.3976 17.3211 18.4455 17.227C18.5 17.12 18.5 16.98 18.5 16.7V14.3C18.5 14.02 18.5 13.88 18.4455 13.773C18.3976 13.6789 18.3211 13.6024 18.227 13.5545C18.12 13.5 17.98 13.5 17.7 13.5H12.8C12.52 13.5 12.38 13.5 12.273 13.5545C12.1789 13.6024 12.1024 13.6789 12.0545 13.773C12 13.88 12 14.02 12 14.3V16.7C12 16.98 12 17.12 12.0545 17.227C12.1024 17.3211 12.1789 17.3976 12.273 17.4455C12.38 17.5 12.52 17.5 12.8 17.5ZM6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V11.8C22 10.1198 22 9.27976 21.673 8.63803C21.3854 8.07354 20.9265 7.6146 20.362 7.32698C19.7202 7 18.8802 7 17.2 7H6.8C5.11984 7 4.27976 7 3.63803 7.32698C3.07354 7.6146 2.6146 8.07354 2.32698 8.63803C2 9.27976 2 10.1198 2 11.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uh1 = [
  fh1,
  vh1
];
function wh1(r, e) {
  return n(), o("svg", Ch1, uh1);
}
const oP2 = /* @__PURE__ */ i(_h1, [["render", wh1]]);
var ph1 = {}, gh1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $h1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), Mh1 = /* @__PURE__ */ t("path", {
  d: "M8 21V7C8 6.07003 8 5.60504 8.10222 5.22354C8.37962 4.18827 9.18827 3.37962 10.2235 3.10222C10.605 3 11.07 3 12 3C12.93 3 13.395 3 13.7765 3.10222C14.8117 3.37962 15.6204 4.18827 15.8978 5.22354C16 5.60504 16 6.07003 16 7V13.5M16 17.5V21M6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V11.8C22 10.1198 22 9.27976 21.673 8.63803C21.3854 8.07354 20.9265 7.6146 20.362 7.32698C19.7202 7 18.8802 7 17.2 7H6.8C5.11984 7 4.27976 7 3.63803 7.32698C3.07354 7.6146 2.6146 8.07354 2.32698 8.63803C2 9.27976 2 10.1198 2 11.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21ZM12.8 17.5H17.7C17.98 17.5 18.12 17.5 18.227 17.4455C18.3211 17.3976 18.3976 17.3211 18.4455 17.227C18.5 17.12 18.5 16.98 18.5 16.7V14.3C18.5 14.02 18.5 13.88 18.4455 13.773C18.3976 13.6789 18.3211 13.6024 18.227 13.5545C18.12 13.5 17.98 13.5 17.7 13.5H12.8C12.52 13.5 12.38 13.5 12.273 13.5545C12.1789 13.6024 12.1024 13.6789 12.0545 13.773C12 13.88 12 14.02 12 14.3V16.7C12 16.98 12 17.12 12.0545 17.227C12.1024 17.3211 12.1789 17.3976 12.273 17.4455C12.38 17.5 12.52 17.5 12.8 17.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Lh1 = [
  $h1,
  Mh1
];
function kh1(r, e) {
  return n(), o("svg", gh1, Lh1);
}
const iP2 = /* @__PURE__ */ i(ph1, [["render", kh1]]);
var mh1 = {}, xh1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hh1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), Vh1 = /* @__PURE__ */ t("path", {
  d: "M13.0001 14L10.0001 11M15.0104 3.5V2M18.9498 5.06066L20.0104 4M18.9498 13L20.0104 14.0607M11.0104 5.06066L9.94979 4M20.5104 9H22.0104M6.13146 20.8686L15.3687 11.6314C15.7647 11.2354 15.9627 11.0373 16.0369 10.809C16.1022 10.6082 16.1022 10.3918 16.0369 10.191C15.9627 9.96265 15.7647 9.76465 15.3687 9.36863L14.6315 8.63137C14.2354 8.23535 14.0374 8.03735 13.8091 7.96316C13.6083 7.8979 13.3919 7.8979 13.1911 7.96316C12.9627 8.03735 12.7647 8.23535 12.3687 8.63137L3.13146 17.8686C2.73545 18.2646 2.53744 18.4627 2.46325 18.691C2.39799 18.8918 2.39799 19.1082 2.46325 19.309C2.53744 19.5373 2.73545 19.7354 3.13146 20.1314L3.86872 20.8686C4.26474 21.2646 4.46275 21.4627 4.69108 21.5368C4.89192 21.6021 5.10827 21.6021 5.30911 21.5368C5.53744 21.4627 5.73545 21.2646 6.13146 20.8686Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zh1 = [
  Hh1,
  Vh1
];
function Bh1(r, e) {
  return n(), o("svg", xh1, Zh1);
}
const lP2 = /* @__PURE__ */ i(mh1, [["render", Bh1]]);
var Fh1 = {}, jh1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ih1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), bh1 = /* @__PURE__ */ t("path", {
  d: "M15 4V2M15 16V14M8 9H10M20 9H22M17.8 11.8L19 13M17.8 6.2L19 5M3 21L12 12M12.2 6.2L11 5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yh1 = [
  Ih1,
  bh1
];
function Dh1(r, e) {
  return n(), o("svg", jh1, yh1);
}
const sP2 = /* @__PURE__ */ i(Fh1, [["render", Dh1]]);
var Ph1 = {}, Ah1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sh1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -596)",
  fill: "none"
}, null, -1), Th1 = /* @__PURE__ */ t("path", {
  d: "M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Oh1 = [
  Sh1,
  Th1
];
function Eh1(r, e) {
  return n(), o("svg", Ah1, Oh1);
}
const hP2 = /* @__PURE__ */ i(Ph1, [["render", Eh1]]);
var Rh1 = {}, Uh1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nh1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -636)",
  fill: "none"
}, null, -1), qh1 = /* @__PURE__ */ t("path", {
  d: "M21.5 18L14.8571 12M9.14286 12L2.50003 18M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zh1 = [
  Nh1,
  qh1
];
function Kh1(r, e) {
  return n(), o("svg", Uh1, zh1);
}
const aP2 = /* @__PURE__ */ i(Rh1, [["render", Kh1]]);
var Gh1 = {}, Wh1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yh1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -676)",
  fill: "none"
}, null, -1), Xh1 = /* @__PURE__ */ t("path", {
  d: "M2 7L7.19384 10.4626C7.49349 10.6623 7.64331 10.7622 7.8054 10.833C7.94927 10.8958 8.10003 10.9414 8.25458 10.969C8.42869 11 8.60876 11 8.96888 11H15.0311C15.3912 11 15.5713 11 15.7454 10.969C15.9 10.9414 16.0507 10.8958 16.1946 10.833C16.3567 10.7622 16.5065 10.6623 16.8062 10.4626L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qh1 = [
  Yh1,
  Xh1
];
function Jh1(r, e) {
  return n(), o("svg", Wh1, Qh1);
}
const dP2 = /* @__PURE__ */ i(Gh1, [["render", Jh1]]);
var ta1 = {}, ea1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ra1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-75 -716)",
  fill: "none"
}, null, -1), na1 = /* @__PURE__ */ t("path", {
  d: "M13.744 2.63346L21.272 7.52667C21.538 7.69957 21.671 7.78602 21.7674 7.90134C21.8527 8.00342 21.9167 8.12149 21.9558 8.24865C22 8.39229 22 8.55092 22 8.86818V16.1999C22 17.88 22 18.7201 21.673 19.3619C21.3854 19.9263 20.9265 20.3853 20.362 20.6729C19.7202 20.9999 18.8802 20.9999 17.2 20.9999H6.8C5.11984 20.9999 4.27976 20.9999 3.63803 20.6729C3.07354 20.3853 2.6146 19.9263 2.32698 19.3619C2 18.7201 2 17.88 2 16.1999V8.86818C2 8.55092 2 8.39229 2.04417 8.24865C2.08327 8.12149 2.14735 8.00342 2.23265 7.90134C2.32901 7.78602 2.46201 7.69957 2.72802 7.52667L10.256 2.63346M13.744 2.63346C13.1127 2.22315 12.7971 2.01799 12.457 1.93817C12.1564 1.86761 11.8436 1.86761 11.543 1.93817C11.2029 2.01799 10.8873 2.22315 10.256 2.63346M13.744 2.63346L20.9681 7.32913C21.312 7.55268 21.484 7.66445 21.5435 7.8062C21.5956 7.93008 21.5956 8.06969 21.5435 8.19356C21.484 8.33531 21.312 8.44709 20.9681 8.67064L13.744 13.3663C13.1127 13.7766 12.7971 13.9818 12.457 14.0616C12.1564 14.1321 11.8436 14.1321 11.543 14.0616C11.2029 13.9818 10.8873 13.7766 10.256 13.3663L3.03193 8.67064C2.68801 8.44709 2.51604 8.33531 2.45649 8.19356C2.40444 8.06969 2.40444 7.93008 2.45649 7.8062C2.51604 7.66445 2.68801 7.55268 3.03193 7.32913L10.256 2.63346",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oa1 = [
  ra1,
  na1
];
function ia1(r, e) {
  return n(), o("svg", ea1, oa1);
}
const cP2 = /* @__PURE__ */ i(ta1, [["render", ia1]]);
var la1 = {}, sa1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ha1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), aa1 = /* @__PURE__ */ t("path", {
  d: "M13.744 2.63358L21.272 7.52679C21.538 7.69969 21.671 7.78615 21.7674 7.90146C21.8527 8.00354 21.9167 8.12162 21.9558 8.24877C22 8.39241 22 8.55104 22 8.8683V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V8.8683C2 8.55104 2 8.39241 2.04417 8.24877C2.08327 8.12162 2.14735 8.00354 2.23265 7.90146C2.32901 7.78615 2.46201 7.69969 2.72802 7.52679L10.256 2.63358M13.744 2.63358C13.1127 2.22327 12.7971 2.01812 12.457 1.93829C12.1564 1.86774 11.8436 1.86774 11.543 1.93829C11.2029 2.01812 10.8873 2.22327 10.256 2.63358M13.744 2.63358L19.9361 6.65849C20.624 7.10559 20.9679 7.32915 21.087 7.61264C21.1911 7.86039 21.1911 8.13961 21.087 8.38737C20.9679 8.67086 20.624 8.89441 19.9361 9.34152L13.744 13.3664C13.1127 13.7767 12.7971 13.9819 12.457 14.0617C12.1564 14.1323 11.8436 14.1323 11.543 14.0617C11.2029 13.9819 10.8873 13.7767 10.256 13.3664L4.06386 9.34151C3.37601 8.89441 3.03209 8.67086 2.91297 8.38737C2.80888 8.13961 2.80888 7.86039 2.91297 7.61264C3.03209 7.32915 3.37601 7.1056 4.06386 6.65849L10.256 2.63358M21.5 19L14.8572 13M9.14282 13L2.5 19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), da1 = [
  ha1,
  aa1
];
function ca1(r, e) {
  return n(), o("svg", sa1, da1);
}
const _P2 = /* @__PURE__ */ i(la1, [["render", ca1]]);
var _a1 = {}, Ca1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fa1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), va1 = /* @__PURE__ */ t("path", {
  d: "M9 18L2 22V6L9 2M9 18L16 22M9 18V2M16 22L22 18V2L16 6M16 22V6M16 6L9 2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ua1 = [
  fa1,
  va1
];
function wa1(r, e) {
  return n(), o("svg", Ca1, ua1);
}
const CP2 = /* @__PURE__ */ i(_a1, [["render", wa1]]);
var pa1 = {}, ga1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $a1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), Ma1 = /* @__PURE__ */ t("path", {
  d: "M8 3L16 21M3 17L12 12M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), La1 = [
  $a1,
  Ma1
];
function ka1(r, e) {
  return n(), o("svg", ga1, La1);
}
const fP2 = /* @__PURE__ */ i(pa1, [["render", ka1]]);
var ma1 = {}, xa1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ha1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), Va1 = /* @__PURE__ */ t("path", {
  d: "M20 12C20 16.4183 16.4183 20 12 20M20 12C20 7.58172 16.4183 4 12 4M20 12H22M12 20C7.58172 20 4 16.4183 4 12M12 20V22M4 12C4 7.58172 7.58172 4 12 4M4 12H2M12 4V2M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Za1 = [
  Ha1,
  Va1
];
function Ba1(r, e) {
  return n(), o("svg", xa1, Za1);
}
const vP2 = /* @__PURE__ */ i(ma1, [["render", Ba1]]);
var Fa1 = {}, ja1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ia1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), ba1 = /* @__PURE__ */ t("path", {
  d: "M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ya1 = /* @__PURE__ */ t("path", {
  d: "M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Da1 = [
  Ia1,
  ba1,
  ya1
];
function Pa1(r, e) {
  return n(), o("svg", ja1, Da1);
}
const uP2 = /* @__PURE__ */ i(Fa1, [["render", Pa1]]);
var Aa1 = {}, Sa1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ta1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), Oa1 = /* @__PURE__ */ t("path", {
  d: "M12 12.5C13.6569 12.5 15 11.1569 15 9.5C15 7.84315 13.6569 6.5 12 6.5C10.3431 6.5 9 7.84315 9 9.5C9 11.1569 10.3431 12.5 12 12.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ea1 = /* @__PURE__ */ t("path", {
  d: "M12 22C14 18 20 15.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 15.4183 10 18 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ra1 = [
  Ta1,
  Oa1,
  Ea1
];
function Ua1(r, e) {
  return n(), o("svg", Sa1, Ra1);
}
const wP2 = /* @__PURE__ */ i(Aa1, [["render", Ua1]]);
var Na1 = {}, qa1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, za1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), Ka1 = /* @__PURE__ */ t("path", {
  d: "M12 22C13 17 20 16.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 16.4183 11 17 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ga1 = /* @__PURE__ */ t("path", {
  d: "M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Wa1 = [
  za1,
  Ka1,
  Ga1
];
function Ya1(r, e) {
  return n(), o("svg", qa1, Wa1);
}
const pP2 = /* @__PURE__ */ i(Na1, [["render", Ya1]]);
var Xa1 = {}, Qa1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ja1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), td1 = /* @__PURE__ */ t("path", {
  d: "M5 14.2864C3.14864 15.1031 2 16.2412 2 17.5C2 19.9853 6.47715 22 12 22C17.5228 22 22 19.9853 22 17.5C22 16.2412 20.8514 15.1031 19 14.2864M18 8C18 12.0637 13.5 14 12 17C10.5 14 6 12.0637 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ed1 = [
  Ja1,
  td1
];
function rd1(r, e) {
  return n(), o("svg", Qa1, ed1);
}
const gP2 = /* @__PURE__ */ i(Xa1, [["render", rd1]]);
var nd1 = {}, od1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, id1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), ld1 = /* @__PURE__ */ t("path", {
  d: "M16 13.3744C19.5318 14.0688 22 15.6547 22 17.5C22 19.9853 17.5228 22 12 22C6.47715 22 2 19.9853 2 17.5C2 15.6547 4.46819 14.0688 8 13.3744M12 17V3L17.3177 6.27244C17.7056 6.51114 17.8995 6.63049 17.9614 6.78085C18.0154 6.912 18.0111 7.0599 17.9497 7.18771C17.8792 7.33426 17.6787 7.44222 17.2777 7.65815L12 10.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), sd1 = [
  id1,
  ld1
];
function hd1(r, e) {
  return n(), o("svg", od1, sd1);
}
const $P2 = /* @__PURE__ */ i(nd1, [["render", hd1]]);
var ad1 = {}, dd1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cd1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), _d1 = /* @__PURE__ */ t("path", {
  d: "M16 13.3744C19.5318 14.0688 22 15.6547 22 17.5C22 19.9853 17.5228 22 12 22C6.47715 22 2 19.9853 2 17.5C2 15.6547 4.46819 14.0688 8 13.3744M12 17V9M12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Cd1 = [
  cd1,
  _d1
];
function fd1(r, e) {
  return n(), o("svg", dd1, Cd1);
}
const MP2 = /* @__PURE__ */ i(ad1, [["render", fd1]]);
var vd1 = {}, ud1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wd1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), pd1 = /* @__PURE__ */ t("path", {
  d: "M14 10L21 3M21 3H15M21 3V9M10 14L3 21M3 21H9M3 21L3 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), gd1 = [
  wd1,
  pd1
];
function $d1(r, e) {
  return n(), o("svg", ud1, gd1);
}
const LP2 = /* @__PURE__ */ i(vd1, [["render", $d1]]);
var Md1 = {}, Ld1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kd1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), md1 = /* @__PURE__ */ t("path", {
  d: "M8 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M8 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V16M21 8V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H16M21 16V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), xd1 = [
  kd1,
  md1
];
function Hd1(r, e) {
  return n(), o("svg", Ld1, xd1);
}
const kP2 = /* @__PURE__ */ i(Md1, [["render", Hd1]]);
var Vd1 = {}, Zd1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bd1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -716)",
  fill: "none"
}, null, -1), Fd1 = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), jd1 = /* @__PURE__ */ t("path", {
  d: "M13.8333 7.3C13.8333 7.01997 13.8333 6.87996 13.7788 6.773C13.7309 6.67892 13.6544 6.60243 13.5603 6.5545C13.4534 6.5 13.3134 6.5 13.0333 6.5H10.9667C10.6866 6.5 10.5466 6.5 10.4397 6.5545C10.3456 6.60243 10.2691 6.67892 10.2212 6.773C10.1667 6.87996 10.1667 7.01997 10.1667 7.3V9.36667C10.1667 9.64669 10.1667 9.78671 10.1122 9.89366C10.0642 9.98774 9.98774 10.0642 9.89366 10.1122C9.78671 10.1667 9.64669 10.1667 9.36667 10.1667H7.3C7.01997 10.1667 6.87996 10.1667 6.773 10.2212C6.67892 10.2691 6.60243 10.3456 6.5545 10.4397C6.5 10.5466 6.5 10.6866 6.5 10.9667V13.0333C6.5 13.3134 6.5 13.4534 6.5545 13.5603C6.60243 13.6544 6.67892 13.7309 6.773 13.7788C6.87996 13.8333 7.01997 13.8333 7.3 13.8333H9.36667C9.64669 13.8333 9.78671 13.8333 9.89366 13.8878C9.98774 13.9358 10.0642 14.0123 10.1122 14.1063C10.1667 14.2133 10.1667 14.3533 10.1667 14.6333V16.7C10.1667 16.98 10.1667 17.12 10.2212 17.227C10.2691 17.3211 10.3456 17.3976 10.4397 17.4455C10.5466 17.5 10.6866 17.5 10.9667 17.5H13.0333C13.3134 17.5 13.4534 17.5 13.5603 17.4455C13.6544 17.3976 13.7309 17.3211 13.7788 17.227C13.8333 17.12 13.8333 16.98 13.8333 16.7V14.6333C13.8333 14.3533 13.8333 14.2133 13.8878 14.1063C13.9358 14.0123 14.0123 13.9358 14.1063 13.8878C14.2133 13.8333 14.3533 13.8333 14.6333 13.8333H16.7C16.98 13.8333 17.12 13.8333 17.227 13.7788C17.3211 13.7309 17.3976 13.6544 17.4455 13.5603C17.5 13.4534 17.5 13.3134 17.5 13.0333V10.9667C17.5 10.6866 17.5 10.5466 17.4455 10.4397C17.3976 10.3456 17.3211 10.2691 17.227 10.2212C17.12 10.1667 16.98 10.1667 16.7 10.1667H14.6333C14.3533 10.1667 14.2133 10.1667 14.1063 10.1122C14.0123 10.0642 13.9358 9.98774 13.8878 9.89366C13.8333 9.78671 13.8333 9.64669 13.8333 9.36667V7.3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Id1 = [
  Bd1,
  Fd1,
  jd1
];
function bd1(r, e) {
  return n(), o("svg", Zd1, Id1);
}
const mP2 = /* @__PURE__ */ i(Vd1, [["render", bd1]]);
var yd1 = {}, Dd1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pd1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -756)",
  fill: "none"
}, null, -1), Ad1 = /* @__PURE__ */ t("path", {
  d: "M15 4.6C15 4.03995 15 3.75992 14.891 3.54601C14.7951 3.35785 14.6422 3.20487 14.454 3.10899C14.2401 3 13.9601 3 13.4 3H10.6C10.0399 3 9.75992 3 9.54601 3.10899C9.35785 3.20487 9.20487 3.35785 9.10899 3.54601C9 3.75992 9 4.03995 9 4.6V7.4C9 7.96005 9 8.24008 8.89101 8.45399C8.79513 8.64215 8.64215 8.79513 8.45399 8.89101C8.24008 9 7.96005 9 7.4 9H4.6C4.03995 9 3.75992 9 3.54601 9.10899C3.35785 9.20487 3.20487 9.35785 3.10899 9.54601C3 9.75992 3 10.0399 3 10.6V13.4C3 13.9601 3 14.2401 3.10899 14.454C3.20487 14.6422 3.35785 14.7951 3.54601 14.891C3.75992 15 4.03995 15 4.6 15H7.4C7.96005 15 8.24008 15 8.45399 15.109C8.64215 15.2049 8.79513 15.3578 8.89101 15.546C9 15.7599 9 16.0399 9 16.6V19.4C9 19.9601 9 20.2401 9.10899 20.454C9.20487 20.6422 9.35785 20.7951 9.54601 20.891C9.75992 21 10.0399 21 10.6 21H13.4C13.9601 21 14.2401 21 14.454 20.891C14.6422 20.7951 14.7951 20.6422 14.891 20.454C15 20.2401 15 19.9601 15 19.4V16.6C15 16.0399 15 15.7599 15.109 15.546C15.2049 15.3578 15.3578 15.2049 15.546 15.109C15.7599 15 16.0399 15 16.6 15H19.4C19.9601 15 20.2401 15 20.454 14.891C20.6422 14.7951 20.7951 14.6422 20.891 14.454C21 14.2401 21 13.9601 21 13.4V10.6C21 10.0399 21 9.75992 20.891 9.54601C20.7951 9.35785 20.6422 9.20487 20.454 9.10899C20.2401 9 19.9601 9 19.4 9L16.6 9C16.0399 9 15.7599 9 15.546 8.89101C15.3578 8.79513 15.2049 8.64215 15.109 8.45399C15 8.24008 15 7.96005 15 7.4V4.6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Sd1 = [
  Pd1,
  Ad1
];
function Td1(r, e) {
  return n(), o("svg", Dd1, Sd1);
}
const xP2 = /* @__PURE__ */ i(yd1, [["render", Td1]]);
var Od1 = {}, Ed1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rd1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -796)",
  fill: "none"
}, null, -1), Ud1 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Nd1 = /* @__PURE__ */ t("path", {
  d: "M13.8333 7.3C13.8333 7.01997 13.8333 6.87996 13.7788 6.773C13.7309 6.67892 13.6544 6.60243 13.5603 6.5545C13.4534 6.5 13.3134 6.5 13.0333 6.5H10.9667C10.6866 6.5 10.5466 6.5 10.4397 6.5545C10.3456 6.60243 10.2691 6.67892 10.2212 6.773C10.1667 6.87996 10.1667 7.01997 10.1667 7.3V9.36667C10.1667 9.64669 10.1667 9.78671 10.1122 9.89366C10.0642 9.98774 9.98774 10.0642 9.89366 10.1122C9.78671 10.1667 9.64669 10.1667 9.36667 10.1667H7.3C7.01997 10.1667 6.87996 10.1667 6.773 10.2212C6.67892 10.2691 6.60243 10.3456 6.5545 10.4397C6.5 10.5466 6.5 10.6866 6.5 10.9667V13.0333C6.5 13.3134 6.5 13.4534 6.5545 13.5603C6.60243 13.6544 6.67892 13.7309 6.773 13.7788C6.87996 13.8333 7.01997 13.8333 7.3 13.8333H9.36667C9.64669 13.8333 9.78671 13.8333 9.89366 13.8878C9.98774 13.9358 10.0642 14.0123 10.1122 14.1063C10.1667 14.2133 10.1667 14.3533 10.1667 14.6333V16.7C10.1667 16.98 10.1667 17.12 10.2212 17.227C10.2691 17.3211 10.3456 17.3976 10.4397 17.4455C10.5466 17.5 10.6866 17.5 10.9667 17.5H13.0333C13.3134 17.5 13.4534 17.5 13.5603 17.4455C13.6544 17.3976 13.7309 17.3211 13.7788 17.227C13.8333 17.12 13.8333 16.98 13.8333 16.7V14.6333C13.8333 14.3533 13.8333 14.2133 13.8878 14.1063C13.9358 14.0123 14.0123 13.9358 14.1063 13.8878C14.2133 13.8333 14.3533 13.8333 14.6333 13.8333H16.7C16.98 13.8333 17.12 13.8333 17.227 13.7788C17.3211 13.7309 17.3976 13.6544 17.4455 13.5603C17.5 13.4534 17.5 13.3134 17.5 13.0333V10.9667C17.5 10.6866 17.5 10.5466 17.4455 10.4397C17.3976 10.3456 17.3211 10.2691 17.227 10.2212C17.12 10.1667 16.98 10.1667 16.7 10.1667H14.6333C14.3533 10.1667 14.2133 10.1667 14.1063 10.1122C14.0123 10.0642 13.9358 9.98774 13.8878 9.89366C13.8333 9.78671 13.8333 9.64669 13.8333 9.36667V7.3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qd1 = [
  Rd1,
  Ud1,
  Nd1
];
function zd1(r, e) {
  return n(), o("svg", Ed1, qd1);
}
const HP2 = /* @__PURE__ */ i(Od1, [["render", zd1]]);
var Kd1 = {}, Gd1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wd1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -836)",
  fill: "none"
}, null, -1), Yd1 = /* @__PURE__ */ t("path", {
  d: "M3 12H21M3 6H21M3 18H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Xd1 = [
  Wd1,
  Yd1
];
function Qd1(r, e) {
  return n(), o("svg", Gd1, Xd1);
}
const VP2 = /* @__PURE__ */ i(Kd1, [["render", Qd1]]);
var Jd1 = {}, tc1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ec1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -876)",
  fill: "none"
}, null, -1), rc1 = /* @__PURE__ */ t("path", {
  d: "M3 12H15M3 6H21M3 18H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nc1 = [
  ec1,
  rc1
];
function oc1(r, e) {
  return n(), o("svg", tc1, nc1);
}
const ZP2 = /* @__PURE__ */ i(Jd1, [["render", oc1]]);
var ic1 = {}, lc1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sc1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -916)",
  fill: "none"
}, null, -1), hc1 = /* @__PURE__ */ t("path", {
  d: "M3 12H21M3 6H21M3 18H15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ac1 = [
  sc1,
  hc1
];
function dc1(r, e) {
  return n(), o("svg", lc1, ac1);
}
const BP2 = /* @__PURE__ */ i(ic1, [["render", dc1]]);
var cc1 = {}, _c1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cc1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -956)",
  fill: "none"
}, null, -1), fc1 = /* @__PURE__ */ t("path", {
  d: "M3 12H21M3 6H21M9 18H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vc1 = [
  Cc1,
  fc1
];
function uc1(r, e) {
  return n(), o("svg", _c1, vc1);
}
const FP2 = /* @__PURE__ */ i(cc1, [["render", uc1]]);
var wc1 = {}, pc1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gc1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -996)",
  fill: "none"
}, null, -1), $c1 = /* @__PURE__ */ t("path", {
  d: "M3 8.5H21M3 15.5H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Mc1 = [
  gc1,
  $c1
];
function Lc1(r, e) {
  return n(), o("svg", pc1, Mc1);
}
const jP2 = /* @__PURE__ */ i(wc1, [["render", Lc1]]);
var kc1 = {}, mc1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xc1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), Hc1 = /* @__PURE__ */ t("path", {
  d: "M12.4996 11V7.5M12.4996 14.5H12.5096M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Vc1 = [
  xc1,
  Hc1
];
function Zc1(r, e) {
  return n(), o("svg", mc1, Vc1);
}
const IP2 = /* @__PURE__ */ i(kc1, [["render", Zc1]]);
var Bc1 = {}, Fc1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jc1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), Ic1 = /* @__PURE__ */ t("path", {
  d: "M12 10.5V7M12 14H12.01M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bc1 = [
  jc1,
  Ic1
];
function yc1(r, e) {
  return n(), o("svg", Fc1, bc1);
}
const bP2 = /* @__PURE__ */ i(Bc1, [["render", yc1]]);
var Dc1 = {}, Pc1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ac1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), Sc1 = /* @__PURE__ */ t("path", {
  d: "M6.09436 11.2288C6.03221 10.8282 5.99996 10.4179 5.99996 10C5.99996 5.58172 9.60525 2 14.0526 2C18.4999 2 22.1052 5.58172 22.1052 10C22.1052 10.9981 21.9213 11.9535 21.5852 12.8345C21.5154 13.0175 21.4804 13.109 21.4646 13.1804C21.4489 13.2512 21.4428 13.301 21.4411 13.3735C21.4394 13.4466 21.4493 13.5272 21.4692 13.6883L21.8717 16.9585C21.9153 17.3125 21.9371 17.4895 21.8782 17.6182C21.8266 17.731 21.735 17.8205 21.6211 17.8695C21.4911 17.9254 21.3146 17.8995 20.9617 17.8478L17.7765 17.3809C17.6101 17.3565 17.527 17.3443 17.4512 17.3448C17.3763 17.3452 17.3245 17.3507 17.2511 17.3661C17.177 17.3817 17.0823 17.4172 16.893 17.4881C16.0097 17.819 15.0524 18 14.0526 18C13.6344 18 13.2237 17.9683 12.8227 17.9073M7.63158 22C10.5965 22 13 19.5376 13 16.5C13 13.4624 10.5965 11 7.63158 11C4.66668 11 2.26316 13.4624 2.26316 16.5C2.26316 17.1106 2.36028 17.6979 2.53955 18.2467C2.61533 18.4787 2.65322 18.5947 2.66566 18.6739C2.67864 18.7567 2.68091 18.8031 2.67608 18.8867C2.67145 18.9668 2.65141 19.0573 2.61134 19.2383L2 22L4.9948 21.591C5.15827 21.5687 5.24 21.5575 5.31137 21.558C5.38652 21.5585 5.42641 21.5626 5.50011 21.5773C5.5701 21.5912 5.67416 21.6279 5.88227 21.7014C6.43059 21.8949 7.01911 22 7.63158 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Tc1 = [
  Ac1,
  Sc1
];
function Oc1(r, e) {
  return n(), o("svg", Pc1, Tc1);
}
const yP2 = /* @__PURE__ */ i(Dc1, [["render", Oc1]]);
var Ec1 = {}, Rc1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uc1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), Nc1 = /* @__PURE__ */ t("path", {
  d: "M10 15L6.92474 18.1137C6.49579 18.548 6.28131 18.7652 6.09695 18.7805C5.93701 18.7938 5.78042 18.7295 5.67596 18.6076C5.55556 18.4672 5.55556 18.162 5.55556 17.5515V15.9916C5.55556 15.444 5.10707 15.0477 4.5652 14.9683V14.9683C3.25374 14.7762 2.22378 13.7463 2.03168 12.4348C2 12.2186 2 11.9605 2 11.4444V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H14.2C15.8802 2 16.7202 2 17.362 2.32698C17.9265 2.6146 18.3854 3.07354 18.673 3.63803C19 4.27976 19 5.11984 19 6.8V11M19 22L16.8236 20.4869C16.5177 20.2742 16.3647 20.1678 16.1982 20.0924C16.0504 20.0255 15.8951 19.9768 15.7356 19.9474C15.5558 19.9143 15.3695 19.9143 14.9969 19.9143H13.2C12.0799 19.9143 11.5198 19.9143 11.092 19.6963C10.7157 19.5046 10.4097 19.1986 10.218 18.8223C10 18.3944 10 17.8344 10 16.7143V14.2C10 13.0799 10 12.5198 10.218 12.092C10.4097 11.7157 10.7157 11.4097 11.092 11.218C11.5198 11 12.0799 11 13.2 11H18.8C19.9201 11 20.4802 11 20.908 11.218C21.2843 11.4097 21.5903 11.7157 21.782 12.092C22 12.5198 22 13.0799 22 14.2V16.9143C22 17.8462 22 18.3121 21.8478 18.6797C21.6448 19.1697 21.2554 19.5591 20.7654 19.762C20.3978 19.9143 19.9319 19.9143 19 19.9143V22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qc1 = [
  Uc1,
  Nc1
];
function zc1(r, e) {
  return n(), o("svg", Rc1, qc1);
}
const DP2 = /* @__PURE__ */ i(Ec1, [["render", zc1]]);
var Kc1 = {}, Gc1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wc1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), Yc1 = /* @__PURE__ */ t("path", {
  d: "M9.49962 11.5L11.4996 13.5L15.9996 9M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Xc1 = [
  Wc1,
  Yc1
];
function Qc1(r, e) {
  return n(), o("svg", Gc1, Xc1);
}
const PP2 = /* @__PURE__ */ i(Kc1, [["render", Qc1]]);
var Jc1 = {}, t_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, e_1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), r_1 = /* @__PURE__ */ t("path", {
  d: "M9 10.5L11 12.5L15.5 8M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), n_1 = [
  e_1,
  r_1
];
function o_1(r, e) {
  return n(), o("svg", t_1, n_1);
}
const AP2 = /* @__PURE__ */ i(Jc1, [["render", o_1]]);
var i_1 = {}, l_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, s_1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), h_1 = /* @__PURE__ */ t("path", {
  d: "M20.9996 11.5C20.9996 16.1944 17.194 20 12.4996 20C11.4228 20 10.3928 19.7998 9.44478 19.4345C9.27145 19.3678 9.18478 19.3344 9.11586 19.3185C9.04807 19.3029 8.999 19.2963 8.92949 19.2937C8.85881 19.291 8.78127 19.299 8.62619 19.315L3.50517 19.8444C3.01692 19.8948 2.7728 19.9201 2.6288 19.8322C2.50337 19.7557 2.41794 19.6279 2.3952 19.4828C2.36909 19.3161 2.48575 19.1002 2.71906 18.6684L4.35472 15.6408C4.48942 15.3915 4.55677 15.2668 4.58728 15.1469C4.6174 15.0286 4.62469 14.9432 4.61505 14.8214C4.60529 14.6981 4.55119 14.5376 4.443 14.2166C4.15547 13.3636 3.99962 12.45 3.99962 11.5C3.99962 6.80558 7.8052 3 12.4996 3C17.194 3 20.9996 6.80558 20.9996 11.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), a_1 = [
  s_1,
  h_1
];
function d_1(r, e) {
  return n(), o("svg", l_1, a_1);
}
const SP2 = /* @__PURE__ */ i(i_1, [["render", d_1]]);
var c_1 = {}, __1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C_1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), f_1 = /* @__PURE__ */ t("path", {
  d: "M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), v_1 = [
  C_1,
  f_1
];
function u_1(r, e) {
  return n(), o("svg", __1, v_1);
}
const TP2 = /* @__PURE__ */ i(c_1, [["render", u_1]]);
var w_1 = {}, p_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g_1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), $_1 = /* @__PURE__ */ t("path", {
  d: "M7.5 12H7.51M12 12H12.01M16.5 12H16.51M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21ZM8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), M_1 = [
  g_1,
  $_1
];
function L_1(r, e) {
  return n(), o("svg", p_1, M_1);
}
const OP2 = /* @__PURE__ */ i(w_1, [["render", L_1]]);
var k_1 = {}, m_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x_1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), H_1 = /* @__PURE__ */ t("path", {
  d: "M7.5 10.5H7.51M12 10.5H12.01M16.5 10.5H16.51M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18ZM8 10.5C8 10.7761 7.77614 11 7.5 11C7.22386 11 7 10.7761 7 10.5C7 10.2239 7.22386 10 7.5 10C7.77614 10 8 10.2239 8 10.5ZM12.5 10.5C12.5 10.7761 12.2761 11 12 11C11.7239 11 11.5 10.7761 11.5 10.5C11.5 10.2239 11.7239 10 12 10C12.2761 10 12.5 10.2239 12.5 10.5ZM17 10.5C17 10.7761 16.7761 11 16.5 11C16.2239 11 16 10.7761 16 10.5C16 10.2239 16.2239 10 16.5 10C16.7761 10 17 10.2239 17 10.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), V_1 = [
  x_1,
  H_1
];
function Z_1(r, e) {
  return n(), o("svg", m_1, V_1);
}
const EP2 = /* @__PURE__ */ i(k_1, [["render", Z_1]]);
var B_1 = {}, F_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j_1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), I_1 = /* @__PURE__ */ t("path", {
  d: "M20.9996 11.5C20.9996 16.1944 17.194 20 12.4996 20C11.4228 20 10.3928 19.7998 9.44478 19.4345C9.27145 19.3678 9.18478 19.3344 9.11586 19.3185C9.04807 19.3029 8.999 19.2963 8.92949 19.2937C8.85881 19.291 8.78127 19.299 8.62619 19.315L3.50517 19.8444C3.01692 19.8948 2.7728 19.9201 2.6288 19.8322C2.50337 19.7557 2.41794 19.6279 2.3952 19.4828C2.36909 19.3161 2.48575 19.1002 2.71906 18.6684L4.35472 15.6408C4.48942 15.3915 4.55677 15.2668 4.58728 15.1469C4.6174 15.0286 4.62469 14.9432 4.61505 14.8214C4.60529 14.6981 4.55119 14.5376 4.443 14.2166C4.15547 13.3636 3.99962 12.45 3.99962 11.5C3.99962 6.80558 7.8052 3 12.4996 3C17.194 3 20.9996 6.80558 20.9996 11.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), b_1 = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.4965 8.94925C11.5968 7.9104 10.0965 7.63095 8.96924 8.58223C7.84196 9.5335 7.68326 11.124 8.56851 12.2491C9.11696 12.9461 10.4935 14.2191 11.4616 15.087C11.8172 15.4057 11.995 15.5651 12.2084 15.6293C12.3914 15.6844 12.6017 15.6844 12.7847 15.6293C12.9981 15.5651 13.1759 15.4057 13.5315 15.087C14.4996 14.2191 15.8761 12.9461 16.4246 12.2491C17.3098 11.124 17.1705 9.5235 16.0238 8.58223C14.8772 7.64096 13.3963 7.9104 12.4965 8.94925Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), y_1 = [
  j_1,
  I_1,
  b_1
];
function D_1(r, e) {
  return n(), o("svg", F_1, y_1);
}
const RP2 = /* @__PURE__ */ i(B_1, [["render", D_1]]);
var P_1 = {}, A_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S_1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -636)",
  fill: "none"
}, null, -1), T_1 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H13.6837C13.0597 18 12.7477 18 12.4492 18.0613C12.1844 18.1156 11.9282 18.2055 11.6875 18.3285C11.4162 18.4671 11.1725 18.662 10.6852 19.0518L8.29976 20.9602C7.88367 21.2931 7.67563 21.4595 7.50054 21.4597C7.34827 21.4599 7.20422 21.3906 7.10923 21.2716C7 21.1348 7 20.8684 7 20.3355V18C6.07003 18 5.60504 18 5.22354 17.8978C4.18827 17.6204 3.37962 16.8117 3.10222 15.7765C3 15.395 3 14.93 3 14V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), O_1 = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9969 7.69925C11.0972 6.6604 9.59689 6.38095 8.46961 7.33223C7.34234 8.2835 7.18364 9.87399 8.06889 10.9991C8.61733 11.6961 9.99389 12.9691 10.962 13.837C11.3176 14.1557 11.4953 14.3151 11.7087 14.3793C11.8918 14.4344 12.1021 14.4344 12.2851 14.3793C12.4985 14.3151 12.6763 14.1557 13.0319 13.837C13.9999 12.9691 15.3765 11.6961 15.9249 10.9991C16.8102 9.87399 16.6709 8.2735 15.5242 7.33223C14.3776 6.39096 12.8966 6.6604 11.9969 7.69925Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), E_1 = [
  S_1,
  T_1,
  O_1
];
function R_1(r, e) {
  return n(), o("svg", A_1, E_1);
}
const UP2 = /* @__PURE__ */ i(P_1, [["render", R_1]]);
var U_1 = {}, N_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, q_1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -676)",
  fill: "none"
}, null, -1), z_1 = /* @__PURE__ */ t("path", {
  d: "M11.707 3.03647C7.38421 3.43621 3.99962 7.07285 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.44299 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78121 19.299 8.85882 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20C16.9304 20 20.5694 16.6098 20.9641 12.2819M20.1209 3.87868C21.2925 5.05025 21.2925 6.94975 20.1209 8.12132C18.9494 9.29289 17.0499 9.29289 15.8783 8.12132C14.7067 6.94975 14.7067 5.05025 15.8783 3.87868C17.0499 2.70711 18.9494 2.70711 20.1209 3.87868Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), K_1 = [
  q_1,
  z_1
];
function G_1(r, e) {
  return n(), o("svg", N_1, K_1);
}
const NP2 = /* @__PURE__ */ i(U_1, [["render", G_1]]);
var W_1 = {}, Y_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, X_1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-336 -716)",
  fill: "none"
}, null, -1), Q_1 = /* @__PURE__ */ t("path", {
  d: "M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H15.2C16.8802 18 17.7202 18 18.362 17.673C18.9265 17.3854 19.3854 16.9265 19.673 16.362C20 15.7202 20 14.8802 20 13.2V13M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), J_1 = [
  X_1,
  Q_1
];
function tC1(r, e) {
  return n(), o("svg", Y_1, J_1);
}
const qP2 = /* @__PURE__ */ i(W_1, [["render", tC1]]);
var eC1 = {}, rC1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nC1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), oC1 = /* @__PURE__ */ t("path", {
  d: "M12.4996 14.5V8.5M9.49962 11.5H15.4996M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iC1 = [
  nC1,
  oC1
];
function lC1(r, e) {
  return n(), o("svg", rC1, iC1);
}
const zP2 = /* @__PURE__ */ i(eC1, [["render", lC1]]);
var sC1 = {}, hC1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aC1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), dC1 = /* @__PURE__ */ t("path", {
  d: "M12 13.5V7.5M9 10.5H15M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cC1 = [
  aC1,
  dC1
];
function _C1(r, e) {
  return n(), o("svg", hC1, cC1);
}
const KP2 = /* @__PURE__ */ i(sC1, [["render", _C1]]);
var CC1 = {}, fC1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vC1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), uC1 = /* @__PURE__ */ t("path", {
  d: "M10.4996 9.00224C10.6758 8.50136 11.0236 8.079 11.4814 7.80998C11.9391 7.54095 12.4773 7.4426 13.0006 7.53237C13.524 7.62213 13.9986 7.89421 14.3406 8.30041C14.6825 8.70661 14.8697 9.22072 14.8689 9.75168C14.8689 11.2506 12.6205 12 12.6205 12M12.6495 15H12.6595M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wC1 = [
  vC1,
  uC1
];
function pC1(r, e) {
  return n(), o("svg", fC1, wC1);
}
const GP2 = /* @__PURE__ */ i(CC1, [["render", pC1]]);
var gC1 = {}, $C1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MC1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), LC1 = /* @__PURE__ */ t("path", {
  d: "M10 8.00224C10.1762 7.50136 10.524 7.07901 10.9817 6.80998C11.4395 6.54095 11.9777 6.4426 12.501 6.53237C13.0243 6.62213 13.499 6.89421 13.8409 7.30041C14.1829 7.70661 14.37 8.22072 14.3692 8.75168C14.3692 10.2506 12.1209 11 12.1209 11M12.1499 14H12.1599M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kC1 = [
  MC1,
  LC1
];
function mC1(r, e) {
  return n(), o("svg", $C1, kC1);
}
const WP2 = /* @__PURE__ */ i(gC1, [["render", mC1]]);
var xC1 = {}, HC1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VC1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), ZC1 = /* @__PURE__ */ t("path", {
  d: "M8.99962 14C8.99962 14 10.3121 15.5 12.4996 15.5C14.6871 15.5 15.9996 14 15.9996 14M15.2496 9H15.2596M9.74962 9H9.75962M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20ZM15.7496 9C15.7496 9.27614 15.5258 9.5 15.2496 9.5C14.9735 9.5 14.7496 9.27614 14.7496 9C14.7496 8.72386 14.9735 8.5 15.2496 8.5C15.5258 8.5 15.7496 8.72386 15.7496 9ZM10.2496 9C10.2496 9.27614 10.0258 9.5 9.74962 9.5C9.47348 9.5 9.24962 9.27614 9.24962 9C9.24962 8.72386 9.47348 8.5 9.74962 8.5C10.0258 8.5 10.2496 8.72386 10.2496 9Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BC1 = [
  VC1,
  ZC1
];
function FC1(r, e) {
  return n(), o("svg", HC1, BC1);
}
const YP2 = /* @__PURE__ */ i(xC1, [["render", FC1]]);
var jC1 = {}, IC1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bC1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), yC1 = /* @__PURE__ */ t("path", {
  d: "M8.5 12.5C8.5 12.5 9.8125 14 12 14C14.1875 14 15.5 12.5 15.5 12.5M14.75 7.5H14.76M9.25 7.5H9.26M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18ZM15.25 7.5C15.25 7.77614 15.0261 8 14.75 8C14.4739 8 14.25 7.77614 14.25 7.5C14.25 7.22386 14.4739 7 14.75 7C15.0261 7 15.25 7.22386 15.25 7.5ZM9.75 7.5C9.75 7.77614 9.52614 8 9.25 8C8.97386 8 8.75 7.77614 8.75 7.5C8.75 7.22386 8.97386 7 9.25 7C9.52614 7 9.75 7.22386 9.75 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DC1 = [
  bC1,
  yC1
];
function PC1(r, e) {
  return n(), o("svg", IC1, DC1);
}
const XP2 = /* @__PURE__ */ i(jC1, [["render", PC1]]);
var AC1 = {}, SC1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TC1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), OC1 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H9.68375C9.0597 18 8.74767 18 8.44921 18.0613C8.18443 18.1156 7.9282 18.2055 7.68749 18.3285C7.41617 18.4671 7.17252 18.662 6.68521 19.0518L4.29976 20.9602C3.88367 21.2931 3.67563 21.4595 3.50054 21.4597C3.34827 21.4599 3.20422 21.3906 3.10923 21.2716C3 21.1348 3 20.8684 3 20.3355V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EC1 = [
  TC1,
  OC1
];
function RC1(r, e) {
  return n(), o("svg", SC1, EC1);
}
const QP2 = /* @__PURE__ */ i(AC1, [["render", RC1]]);
var UC1 = {}, NC1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qC1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), zC1 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H13.6837C13.0597 18 12.7477 18 12.4492 18.0613C12.1844 18.1156 11.9282 18.2055 11.6875 18.3285C11.4162 18.4671 11.1725 18.662 10.6852 19.0518L8.29976 20.9602C7.88367 21.2931 7.67563 21.4595 7.50054 21.4597C7.34827 21.4599 7.20422 21.3906 7.10923 21.2716C7 21.1348 7 20.8684 7 20.3355V18C6.07003 18 5.60504 18 5.22354 17.8978C4.18827 17.6204 3.37962 16.8117 3.10222 15.7765C3 15.395 3 14.93 3 14V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KC1 = [
  qC1,
  zC1
];
function GC1(r, e) {
  return n(), o("svg", NC1, KC1);
}
const JP2 = /* @__PURE__ */ i(UC1, [["render", GC1]]);
var WC1 = {}, YC1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XC1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), QC1 = /* @__PURE__ */ t("path", {
  d: "M7.99962 9.5H11.9996M7.99962 13H14.9996M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JC1 = [
  XC1,
  QC1
];
function tf1(r, e) {
  return n(), o("svg", YC1, JC1);
}
const tA2 = /* @__PURE__ */ i(WC1, [["render", tf1]]);
var ef1 = {}, rf1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nf1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), of1 = /* @__PURE__ */ t("path", {
  d: "M8 9.5H12M8 13H15M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), if1 = [
  nf1,
  of1
];
function lf1(r, e) {
  return n(), o("svg", rf1, if1);
}
const eA2 = /* @__PURE__ */ i(ef1, [["render", lf1]]);
var sf1 = {}, hf1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, af1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), df1 = /* @__PURE__ */ t("path", {
  d: "M7 8.5H12M7 12H15M9.68375 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V20.3355C3 20.8684 3 21.1348 3.10923 21.2716C3.20422 21.3906 3.34827 21.4599 3.50054 21.4597C3.67563 21.4595 3.88367 21.2931 4.29976 20.9602L6.68521 19.0518C7.17252 18.662 7.41617 18.4671 7.68749 18.3285C7.9282 18.2055 8.18443 18.1156 8.44921 18.0613C8.74767 18 9.0597 18 9.68375 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cf1 = [
  af1,
  df1
];
function _f1(r, e) {
  return n(), o("svg", hf1, cf1);
}
const rA2 = /* @__PURE__ */ i(sf1, [["render", _f1]]);
var Cf1 = {}, ff1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vf1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), uf1 = /* @__PURE__ */ t("path", {
  d: "M7 8.5H12M7 12H15M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wf1 = [
  vf1,
  uf1
];
function pf1(r, e) {
  return n(), o("svg", ff1, wf1);
}
const nA2 = /* @__PURE__ */ i(Cf1, [["render", pf1]]);
var gf1 = {}, $f1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mf1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -636)",
  fill: "none"
}, null, -1), Lf1 = /* @__PURE__ */ t("path", {
  d: "M9.99962 9L14.9996 14M14.9996 9L9.99962 14M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kf1 = [
  Mf1,
  Lf1
];
function mf1(r, e) {
  return n(), o("svg", $f1, kf1);
}
const oA2 = /* @__PURE__ */ i(gf1, [["render", mf1]]);
var xf1 = {}, Hf1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vf1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -676)",
  fill: "none"
}, null, -1), Zf1 = /* @__PURE__ */ t("path", {
  d: "M9.5 8L14.5 13M14.5 8L9.5 13M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Bf1 = [
  Vf1,
  Zf1
];
function Ff1(r, e) {
  return n(), o("svg", Hf1, Bf1);
}
const iA2 = /* @__PURE__ */ i(xf1, [["render", Ff1]]);
var jf1 = {}, If1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bf1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), yf1 = /* @__PURE__ */ t("path", {
  d: "M19 10V12C19 15.866 15.866 19 12 19M5 10V12C5 15.866 8.13401 19 12 19M12 19V22M8 22H16M12 15C10.3431 15 9 13.6569 9 12V5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5V12C15 13.6569 13.6569 15 12 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Df1 = [
  bf1,
  yf1
];
function Pf1(r, e) {
  return n(), o("svg", If1, Df1);
}
const lA2 = /* @__PURE__ */ i(jf1, [["render", Pf1]]);
var Af1 = {}, Sf1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tf1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), Of1 = /* @__PURE__ */ t("path", {
  d: "M20 12V13C20 17.4183 16.4183 21 12 21C7.58172 21 4 17.4183 4 13V12M12 17C9.79086 17 8 15.2091 8 13V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V13C16 15.2091 14.2091 17 12 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ef1 = [
  Tf1,
  Of1
];
function Rf1(r, e) {
  return n(), o("svg", Sf1, Ef1);
}
const sA2 = /* @__PURE__ */ i(Af1, [["render", Rf1]]);
var Uf1 = {}, Nf1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qf1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), zf1 = /* @__PURE__ */ t("path", {
  d: "M15 9.4V5C15 3.34315 13.6569 2 12 2C10.8224 2 9.80325 2.67852 9.3122 3.66593M12 19V22M12 19C8.13401 19 5 15.866 5 12V10M12 19C15.866 19 19 15.866 19 12V10M8 22H16M2 2L22 22M12 15C10.3431 15 9 13.6569 9 12V9L14.1226 14.12C13.5796 14.6637 12.8291 15 12 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Kf1 = [
  qf1,
  zf1
];
function Gf1(r, e) {
  return n(), o("svg", Nf1, Kf1);
}
const hA2 = /* @__PURE__ */ i(Uf1, [["render", Gf1]]);
var Wf1 = {}, Yf1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xf1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -596)",
  fill: "none"
}, null, -1), Qf1 = /* @__PURE__ */ t("path", {
  d: "M4 12V13C4 17.4183 7.58172 21 12 21C14.4653 21 16.6701 19.8849 18.1376 18.1316M2 2L22 22M16 10.4V7C16 4.79086 14.2091 3 12 3C11.0406 3 10.1601 3.33778 9.47086 3.9009M12 17C9.79086 17 8 15.2091 8 13V8L15.2815 15.288C14.5585 16.323 13.3583 17 12 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Jf1 = [
  Xf1,
  Qf1
];
function tv1(r, e) {
  return n(), o("svg", Yf1, Jf1);
}
const aA2 = /* @__PURE__ */ i(Wf1, [["render", tv1]]);
var ev1 = {}, rv1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nv1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), ov1 = /* @__PURE__ */ t("path", {
  d: "M3 22H12M11 6.25204C11.6392 6.08751 12.3094 6 13 6C17.4183 6 21 9.58172 21 14C21 17.3574 18.9318 20.2317 16 21.4185M5.5 13H9.5C9.96466 13 10.197 13 10.3902 13.0384C11.1836 13.1962 11.8038 13.8164 11.9616 14.6098C12 14.803 12 15.0353 12 15.5C12 15.9647 12 16.197 11.9616 16.3902C11.8038 17.1836 11.1836 17.8038 10.3902 17.9616C10.197 18 9.96466 18 9.5 18H5.5C5.03534 18 4.80302 18 4.60982 17.9616C3.81644 17.8038 3.19624 17.1836 3.03843 16.3902C3 16.197 3 15.9647 3 15.5C3 15.0353 3 14.803 3.03843 14.6098C3.19624 13.8164 3.81644 13.1962 4.60982 13.0384C4.80302 13 5.03534 13 5.5 13ZM4 5.5V13H11V5.5C11 3.567 9.433 2 7.5 2C5.567 2 4 3.567 4 5.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iv1 = [
  nv1,
  ov1
];
function lv1(r, e) {
  return n(), o("svg", rv1, iv1);
}
const dA2 = /* @__PURE__ */ i(ev1, [["render", lv1]]);
var sv1 = {}, hv1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, av1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), dv1 = /* @__PURE__ */ t("path", {
  d: "M4 14H10M10 14V20M10 14L3 21M20 10H14M14 10V4M14 10L21 3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cv1 = [
  av1,
  dv1
];
function _v1(r, e) {
  return n(), o("svg", hv1, cv1);
}
const cA2 = /* @__PURE__ */ i(sv1, [["render", _v1]]);
var Cv1 = {}, fv1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vv1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), uv1 = /* @__PURE__ */ t("path", {
  d: "M2.99988 8H3.19988C4.88004 8 5.72011 8 6.36185 7.67302C6.92634 7.3854 7.38528 6.92646 7.6729 6.36197C7.99988 5.72024 7.99988 4.88016 7.99988 3.2V3M2.99988 16H3.19988C4.88004 16 5.72011 16 6.36185 16.327C6.92634 16.6146 7.38528 17.0735 7.6729 17.638C7.99988 18.2798 7.99988 19.1198 7.99988 20.8V21M15.9999 3V3.2C15.9999 4.88016 15.9999 5.72024 16.3269 6.36197C16.6145 6.92646 17.0734 7.3854 17.6379 7.67302C18.2796 8 19.1197 8 20.7999 8H20.9999M15.9999 21V20.8C15.9999 19.1198 15.9999 18.2798 16.3269 17.638C16.6145 17.0735 17.0734 16.6146 17.6379 16.327C18.2796 16 19.1197 16 20.7999 16H20.9999",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wv1 = [
  vv1,
  uv1
];
function pv1(r, e) {
  return n(), o("svg", fv1, wv1);
}
const _A2 = /* @__PURE__ */ i(Cv1, [["render", pv1]]);
var gv1 = {}, $v1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mv1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1076)",
  fill: "none"
}, null, -1), Lv1 = /* @__PURE__ */ t("path", {
  d: "M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kv1 = [
  Mv1,
  Lv1
];
function mv1(r, e) {
  return n(), o("svg", $v1, kv1);
}
const CA2 = /* @__PURE__ */ i(gv1, [["render", mv1]]);
var xv1 = {}, Hv1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vv1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1116)",
  fill: "none"
}, null, -1), Zv1 = /* @__PURE__ */ t("path", {
  d: "M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Bv1 = [
  Vv1,
  Zv1
];
function Fv1(r, e) {
  return n(), o("svg", Hv1, Bv1);
}
const fA2 = /* @__PURE__ */ i(xv1, [["render", Fv1]]);
var jv1 = {}, Iv1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bv1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1036)",
  fill: "none"
}, null, -1), yv1 = /* @__PURE__ */ t("path", {
  d: "M5 12H19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Dv1 = [
  bv1,
  yv1
];
function Pv1(r, e) {
  return n(), o("svg", Iv1, Dv1);
}
const vA2 = /* @__PURE__ */ i(jv1, [["render", Pv1]]);
var Av1 = {}, Sv1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tv1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -636)",
  fill: "none"
}, null, -1), Ov1 = /* @__PURE__ */ t("path", {
  d: "M16.2427 4.75732C18.5858 7.10047 18.5858 10.8995 16.2427 13.2426M7.75734 13.2426C5.41419 10.8995 5.41419 7.10047 7.75734 4.75732M4.85829 16C1.02359 12.0894 1.04705 5.81059 4.92869 1.92896M19.0713 1.92896C22.9529 5.81059 22.9764 12.0894 19.1417 16M12 16V9M4.99998 22H19C19.9319 22 20.3978 22 20.7653 21.8478C21.2554 21.6448 21.6447 21.2554 21.8477 20.7654C22 20.3978 22 19.9319 22 19C22 18.0681 22 17.6022 21.8477 17.2346C21.6447 16.7446 21.2554 16.3552 20.7653 16.1522C20.3978 16 19.9319 16 19 16H4.99998C4.06809 16 3.60215 16 3.23461 16.1522C2.74455 16.3552 2.35521 16.7446 2.15222 17.2346C1.99998 17.6022 1.99998 18.0681 1.99998 19C1.99998 19.9319 1.99998 20.3978 2.15222 20.7654C2.35521 21.2554 2.74455 21.6448 3.23461 21.8478C3.60215 22 4.06809 22 4.99998 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ev1 = [
  Tv1,
  Ov1
];
function Rv1(r, e) {
  return n(), o("svg", Sv1, Ev1);
}
const uA2 = /* @__PURE__ */ i(Av1, [["render", Rv1]]);
var Uv1 = {}, Nv1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qv1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -676)",
  fill: "none"
}, null, -1), zv1 = /* @__PURE__ */ t("path", {
  d: "M6.20472 10.5578C5.72578 8.76952 6.08709 6.80306 7.28865 5.28366M17.7952 10.5577C18.2742 8.76947 17.9129 6.80301 16.7113 5.28361M2.34183 11.5996C1.50387 8.47481 2.20543 5.02318 4.44651 2.4458M21.6547 11.5996C22.4926 8.47485 21.7911 5.02322 19.55 2.44584M12 14.9999V8.99992M5.49998 18.4999H9.49998M5.19998 21.9999H18.8C19.9201 21.9999 20.4801 21.9999 20.908 21.7819C21.2843 21.5902 21.5902 21.2842 21.782 20.9079C22 20.4801 22 19.92 22 18.7999V18.1999C22 17.0798 22 16.5198 21.782 16.0919C21.5902 15.7156 21.2843 15.4097 20.908 15.2179C20.4801 14.9999 19.9201 14.9999 18.8 14.9999H5.19998C4.07987 14.9999 3.51982 14.9999 3.092 15.2179C2.71567 15.4097 2.40971 15.7156 2.21796 16.0919C1.99998 16.5198 1.99998 17.0798 1.99998 18.1999V18.7999C1.99998 19.92 1.99998 20.4801 2.21796 20.9079C2.40971 21.2842 2.71567 21.5902 3.092 21.7819C3.51982 21.9999 4.07987 21.9999 5.19998 21.9999Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Kv1 = [
  qv1,
  zv1
];
function Gv1(r, e) {
  return n(), o("svg", Nv1, Kv1);
}
const wA2 = /* @__PURE__ */ i(Uv1, [["render", Gv1]]);
var Wv1 = {}, Yv1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xv1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -716)",
  fill: "none"
}, null, -1), Qv1 = /* @__PURE__ */ t("path", {
  d: "M8 21H16M12 17V21M6.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Jv1 = [
  Xv1,
  Qv1
];
function tu1(r, e) {
  return n(), o("svg", Yv1, Jv1);
}
const pA2 = /* @__PURE__ */ i(Wv1, [["render", tu1]]);
var eu1 = {}, ru1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nu1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -756)",
  fill: "none"
}, null, -1), ou1 = /* @__PURE__ */ t("path", {
  d: "M7.57181 21C8.90661 20.3598 10.41 20 12 20C13.59 20 15.0934 20.3598 16.4282 21M6.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iu1 = [
  nu1,
  ou1
];
function lu1(r, e) {
  return n(), o("svg", ru1, iu1);
}
const gA2 = /* @__PURE__ */ i(eu1, [["render", lu1]]);
var su1 = {}, hu1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, au1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -796)",
  fill: "none"
}, null, -1), du1 = /* @__PURE__ */ t("path", {
  d: "M2 14L22 14M8 21H16M6.8 18H17.2C18.8802 18 19.7202 18 20.362 17.673C20.9265 17.3854 21.3854 16.9265 21.673 16.362C22 15.7202 22 14.8802 22 13.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V13.2C2 14.8802 2 15.7202 2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673C4.27976 18 5.11984 18 6.8 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cu1 = [
  au1,
  du1
];
function _u1(r, e) {
  return n(), o("svg", hu1, cu1);
}
const $A2 = /* @__PURE__ */ i(su1, [["render", _u1]]);
var Cu1 = {}, fu1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vu1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -836)",
  fill: "none"
}, null, -1), uu1 = /* @__PURE__ */ t("path", {
  d: "M15 17V21H9V17M5.2 17H18.8C19.9201 17 20.4802 17 20.908 16.782C21.2843 16.5903 21.5903 16.2843 21.782 15.908C22 15.4802 22 14.9201 22 13.8V6.2C22 5.0799 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H5.2C4.07989 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.07989 2 6.2V13.8C2 14.9201 2 15.4802 2.21799 15.908C2.40973 16.2843 2.71569 16.5903 3.09202 16.782C3.51984 17 4.0799 17 5.2 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wu1 = [
  vu1,
  uu1
];
function pu1(r, e) {
  return n(), o("svg", fu1, wu1);
}
const MA2 = /* @__PURE__ */ i(Cu1, [["render", pu1]]);
var gu1 = {}, $u1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mu1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -876)",
  fill: "none"
}, null, -1), Lu1 = /* @__PURE__ */ t("path", {
  d: "M5.5 20H8M17 9H17.01M8 6H5.2C4.0799 6 3.51984 6 3.09202 6.21799C2.71569 6.40973 2.40973 6.71569 2.21799 7.09202C2 7.51984 2 8.0799 2 9.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.0799 16 5.2 16H8M15.2 20H18.8C19.9201 20 20.4802 20 20.908 19.782C21.2843 19.5903 21.5903 19.2843 21.782 18.908C22 18.4802 22 17.9201 22 16.8V7.2C22 6.0799 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H15.2C14.0799 4 13.5198 4 13.092 4.21799C12.7157 4.40973 12.4097 4.71569 12.218 5.09202C12 5.51984 12 6.07989 12 7.2V16.8C12 17.9201 12 18.4802 12.218 18.908C12.4097 19.2843 12.7157 19.5903 13.092 19.782C13.5198 20 14.0799 20 15.2 20ZM18 15C18 15.5523 17.5523 16 17 16C16.4477 16 16 15.5523 16 15C16 14.4477 16.4477 14 17 14C17.5523 14 18 14.4477 18 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ku1 = [
  Mu1,
  Lu1
];
function mu1(r, e) {
  return n(), o("svg", $u1, ku1);
}
const LA2 = /* @__PURE__ */ i(gu1, [["render", mu1]]);
var xu1 = {}, Hu1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vu1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-336 -636)",
  fill: "none"
}, null, -1), Zu1 = /* @__PURE__ */ t("path", {
  d: "M22 15.8442C20.6866 16.4382 19.2286 16.7688 17.6935 16.7688C11.9153 16.7688 7.23116 12.0847 7.23116 6.30654C7.23116 4.77135 7.5618 3.3134 8.15577 2C4.52576 3.64163 2 7.2947 2 11.5377C2 17.3159 6.68414 22 12.4623 22C16.7053 22 20.3584 19.4742 22 15.8442Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Bu1 = [
  Vu1,
  Zu1
];
function Fu1(r, e) {
  return n(), o("svg", Hu1, Bu1);
}
const kA2 = /* @__PURE__ */ i(xu1, [["render", Fu1]]);
var ju1 = {}, Iu1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bu1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), yu1 = /* @__PURE__ */ t("path", {
  d: "M21.9548 12.9564C20.5779 15.3717 17.9791 17.0001 15 17.0001C10.5817 17.0001 7 13.4184 7 9.00008C7 6.02072 8.62867 3.42175 11.0443 2.04492C5.96975 2.52607 2 6.79936 2 11.9998C2 17.5227 6.47715 21.9998 12 21.9998C17.2002 21.9998 21.4733 18.0305 21.9548 12.9564Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Du1 = [
  bu1,
  yu1
];
function Pu1(r, e) {
  return n(), o("svg", Iu1, Du1);
}
const mA2 = /* @__PURE__ */ i(ju1, [["render", Pu1]]);
var Au1 = {}, Su1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tu1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), Ou1 = /* @__PURE__ */ t("path", {
  d: "M20.0017 6.00022C22.6667 9.54505 22.6661 14.4578 20 18.0021M12 22C13.5711 22 15.0575 21.6377 16.3803 20.9921C16.2542 20.9974 16.1274 21 16 21C11.0294 21 7 16.9706 7 12C7 7.02944 11.0294 3 16 3C16.1274 3 16.2542 3.00265 16.3803 3.00789C15.0575 2.36229 13.5711 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Eu1 = [
  Tu1,
  Ou1
];
function Ru1(r, e) {
  return n(), o("svg", Su1, Eu1);
}
const xA2 = /* @__PURE__ */ i(Au1, [["render", Ru1]]);
var Uu1 = {}, Nu1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qu1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), zu1 = /* @__PURE__ */ t("path", {
  d: "M18 2L18.6178 3.23558C18.8833 3.76656 19.016 4.03205 19.1934 4.26211C19.3507 4.46626 19.5337 4.64927 19.7379 4.80664C19.9679 4.98397 20.2334 5.11672 20.7644 5.38221L22 6L20.7644 6.61779C20.2334 6.88328 19.9679 7.01603 19.7379 7.19336C19.5337 7.35073 19.3507 7.53374 19.1934 7.73789C19.016 7.96795 18.8833 8.23344 18.6178 8.76442L18 10L17.3822 8.76442C17.1167 8.23344 16.984 7.96795 16.8066 7.73789C16.6493 7.53374 16.4663 7.35073 16.2621 7.19336C16.0321 7.01603 15.7666 6.88328 15.2356 6.61779L14 6L15.2356 5.38221C15.7666 5.11672 16.0321 4.98397 16.2621 4.80664C16.4663 4.64927 16.6493 4.46626 16.8066 4.26211C16.984 4.03205 17.1167 3.76656 17.3822 3.23558L18 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ku1 = /* @__PURE__ */ t("path", {
  d: "M21 13.3893C19.689 15.689 17.2145 17.2395 14.3779 17.2395C10.1711 17.2395 6.76075 13.8292 6.76075 9.62233C6.76075 6.78554 8.31149 4.31094 10.6115 3C5.77979 3.45812 2 7.52692 2 12.4785C2 17.7371 6.26292 22 11.5215 22C16.4729 22 20.5415 18.2206 21 13.3893Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Gu1 = [
  qu1,
  zu1,
  Ku1
];
function Wu1(r, e) {
  return n(), o("svg", Nu1, Gu1);
}
const HA2 = /* @__PURE__ */ i(Uu1, [["render", Wu1]]);
var Yu1 = {}, Xu1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qu1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -916)",
  fill: "none"
}, null, -1), Ju1 = /* @__PURE__ */ t("path", {
  d: "M12 9V6M12 22C8.13401 22 5 18.866 5 15V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V15C19 18.866 15.866 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tw1 = [
  Qu1,
  Ju1
];
function ew1(r, e) {
  return n(), o("svg", Xu1, tw1);
}
const VA2 = /* @__PURE__ */ i(Yu1, [["render", ew1]]);
var rw1 = {}, nw1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ow1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), iw1 = /* @__PURE__ */ t("path", {
  d: "M5 9L2 12M2 12L5 15M2 12H22M9 5L12 2M12 2L15 5M12 2V22M15 19L12 22M12 22L9 19M19 9L22 12M22 12L19 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lw1 = [
  ow1,
  iw1
];
function sw1(r, e) {
  return n(), o("svg", nw1, lw1);
}
const ZA2 = /* @__PURE__ */ i(rw1, [["render", sw1]]);
var hw1 = {}, aw1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dw1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -956)",
  fill: "none"
}, null, -1), cw1 = /* @__PURE__ */ t("path", {
  d: "M9 18V6.35537C9 5.87383 9 5.63306 9.0876 5.43778C9.16482 5.26565 9.28917 5.11887 9.44627 5.0144C9.62449 4.89588 9.86198 4.8563 10.337 4.77714L19.137 3.31047C19.7779 3.20364 20.0984 3.15023 20.3482 3.243C20.5674 3.32441 20.7511 3.48005 20.8674 3.68286C21 3.91398 21 4.23889 21 4.8887V16M9 18C9 19.6568 7.65685 21 6 21C4.34315 21 3 19.6568 3 18C3 16.3431 4.34315 15 6 15C7.65685 15 9 16.3431 9 18ZM21 16C21 17.6568 19.6569 19 18 19C16.3431 19 15 17.6568 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _w1 = [
  dw1,
  cw1
];
function Cw1(r, e) {
  return n(), o("svg", aw1, _w1);
}
const BA2 = /* @__PURE__ */ i(hw1, [["render", Cw1]]);
var fw1 = {}, vw1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uw1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -996)",
  fill: "none"
}, null, -1), ww1 = /* @__PURE__ */ t("path", {
  d: "M12 18V5.58888C12 4.73166 12 4.30306 12.1805 4.04492C12.3382 3.81952 12.5817 3.669 12.8538 3.6288C13.1655 3.58276 13.5488 3.77444 14.3155 4.1578L18 6.00003M12 18C12 19.6569 10.6569 21 9 21C7.34315 21 6 19.6569 6 18C6 16.3432 7.34315 15 9 15C10.6569 15 12 16.3432 12 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pw1 = [
  uw1,
  ww1
];
function gw1(r, e) {
  return n(), o("svg", vw1, pw1);
}
const FA2 = /* @__PURE__ */ i(fw1, [["render", gw1]]);
var $w1 = {}, Mw1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lw1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -1036)",
  fill: "none"
}, null, -1), kw1 = /* @__PURE__ */ t("path", {
  d: "M14.5 18V5.58888C14.5 4.73166 14.5 4.30306 14.6805 4.04492C14.8382 3.81952 15.0817 3.669 15.3538 3.6288C15.6655 3.58276 16.0488 3.77444 16.8155 4.1578L20.5 6.00003M14.5 18C14.5 19.6569 13.1569 21 11.5 21C9.84315 21 8.5 19.6569 8.5 18C8.5 16.3432 9.84315 15 11.5 15C13.1569 15 14.5 16.3432 14.5 18ZM6.5 10V4.00003M3.5 7.00003H9.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mw1 = [
  Lw1,
  kw1
];
function xw1(r, e) {
  return n(), o("svg", Mw1, mw1);
}
const jA2 = /* @__PURE__ */ i($w1, [["render", xw1]]);
var Hw1 = {}, Vw1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zw1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), Bw1 = /* @__PURE__ */ t("path", {
  d: "M3.41345 10.7445C2.81811 10.513 2.52043 10.3972 2.43353 10.2304C2.35819 10.0858 2.35809 9.91354 2.43326 9.76886C2.51997 9.60195 2.8175 9.48584 3.41258 9.25361L20.3003 2.66327C20.8375 2.45364 21.1061 2.34883 21.2777 2.40616C21.4268 2.45596 21.5437 2.57292 21.5935 2.72197C21.6509 2.8936 21.5461 3.16219 21.3364 3.69937L14.7461 20.5871C14.5139 21.1822 14.3977 21.4797 14.2308 21.5664C14.0862 21.6416 13.9139 21.6415 13.7693 21.5662C13.6025 21.4793 13.4867 21.1816 13.2552 20.5862L10.6271 13.8282C10.5801 13.7074 10.5566 13.647 10.5203 13.5961C10.4881 13.551 10.4487 13.5115 10.4036 13.4794C10.3527 13.4431 10.2923 13.4196 10.1715 13.3726L3.41345 10.7445Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Fw1 = [
  Zw1,
  Bw1
];
function jw1(r, e) {
  return n(), o("svg", Vw1, Fw1);
}
const IA2 = /* @__PURE__ */ i(Hw1, [["render", jw1]]);
var Iw1 = {}, bw1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yw1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), Dw1 = /* @__PURE__ */ t("path", {
  d: "M5.03685 21.3253C4.45216 21.5826 4.15982 21.7112 3.98042 21.6547C3.8249 21.6057 3.70303 21.484 3.65387 21.3285C3.59717 21.1492 3.72545 20.8567 3.98203 20.2717L11.2634 3.6702C11.495 3.14212 11.6108 2.87808 11.7727 2.79727C11.9133 2.72708 12.0787 2.72708 12.2193 2.79727C12.3812 2.87808 12.497 3.14212 12.7287 3.6702L20.01 20.2717C20.2666 20.8567 20.3949 21.1492 20.3382 21.3285C20.289 21.484 20.1671 21.6057 20.0116 21.6547C19.8322 21.7112 19.5399 21.5826 18.9552 21.3253L12.3182 18.405C12.1995 18.3528 12.1402 18.3267 12.0785 18.3164C12.0239 18.3072 11.9681 18.3072 11.9135 18.3164C11.8519 18.3267 11.7925 18.3528 11.6738 18.405L5.03685 21.3253Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Pw1 = [
  yw1,
  Dw1
];
function Aw1(r, e) {
  return n(), o("svg", bw1, Pw1);
}
const bA2 = /* @__PURE__ */ i(Iw1, [["render", Aw1]]);
var Sw1 = {}, Tw1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ow1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), Ew1 = /* @__PURE__ */ t("path", {
  d: "M11.337 6.16115L20.3003 2.66327C20.8375 2.45364 21.1061 2.34883 21.2777 2.40616C21.4268 2.45596 21.5437 2.57292 21.5935 2.72197C21.6509 2.8936 21.5461 3.16219 21.3364 3.69937L17.8274 12.6913M16.3857 16.3857L14.7461 20.5871C14.5139 21.1822 14.3977 21.4797 14.2308 21.5664C14.0862 21.6416 13.9139 21.6415 13.7693 21.5662C13.6025 21.4793 13.4867 21.1816 13.2552 20.5862L10.6271 13.8282C10.5801 13.7074 10.5566 13.647 10.5203 13.5961C10.4881 13.551 10.4487 13.5115 10.4036 13.4794C10.3527 13.4431 10.2923 13.4196 10.1715 13.3726L3.41345 10.7445C2.81811 10.513 2.52043 10.3972 2.43353 10.2304C2.35819 10.0858 2.35809 9.91354 2.43326 9.76885C2.51997 9.60195 2.8175 9.48584 3.41258 9.25361L7.61748 7.61268M20.9995 21.0002L2.99952 3.00017",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Rw1 = [
  Ow1,
  Ew1
];
function Uw1(r, e) {
  return n(), o("svg", Tw1, Rw1);
}
const yA2 = /* @__PURE__ */ i(Sw1, [["render", Uw1]]);
var Nw1 = {}, qw1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zw1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), Kw1 = /* @__PURE__ */ t("path", {
  d: "M10.4712 5.47577L11.2631 3.67044C11.4947 3.14236 11.6105 2.87832 11.7724 2.79751C11.913 2.72732 12.0784 2.72732 12.219 2.79751C12.3809 2.87832 12.4967 3.14236 12.7283 3.67044L15.9006 10.9033M8.94668 8.95153L3.98158 20.272C3.725 20.857 3.59672 21.1495 3.65342 21.3288C3.70258 21.4842 3.82445 21.606 3.97997 21.6549C4.15937 21.7114 4.45171 21.5828 5.0364 21.3256L11.6734 18.4053C11.7921 18.3531 11.8514 18.327 11.9131 18.3166C11.9677 18.3075 12.0235 18.3075 12.0781 18.3166C12.1397 18.327 12.1991 18.3531 12.3178 18.4053L18.9547 21.3256C19.5394 21.5828 19.8318 21.7114 20.0112 21.6549C20.1667 21.606 20.2886 21.4842 20.3377 21.3288C20.3944 21.1495 20.2661 20.857 20.0096 20.272L19.8054 19.8066M22 22L2 2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Gw1 = [
  zw1,
  Kw1
];
function Ww1(r, e) {
  return n(), o("svg", qw1, Gw1);
}
const DA2 = /* @__PURE__ */ i(Nw1, [["render", Ww1]]);
var Yw1 = {}, Xw1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qw1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), Jw1 = /* @__PURE__ */ t("path", {
  d: "M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V13M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tp1 = [
  Qw1,
  Jw1
];
function ep1(r, e) {
  return n(), o("svg", Xw1, tp1);
}
const PA2 = /* @__PURE__ */ i(Yw1, [["render", ep1]]);
var rp1 = {}, np1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, op1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), ip1 = /* @__PURE__ */ t("path", {
  d: "M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H15.2C16.8802 18 17.7202 18 18.362 17.673C18.9265 17.3854 19.3854 16.9265 19.673 16.362C20 15.7202 20 14.8802 20 13.2V13M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lp1 = [
  op1,
  ip1
];
function sp1(r, e) {
  return n(), o("svg", np1, lp1);
}
const AA2 = /* @__PURE__ */ i(rp1, [["render", sp1]]);
var hp1 = {}, ap1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dp1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), cp1 = /* @__PURE__ */ t("path", {
  d: "M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V13M13 17H7M15 13H7M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _p1 = [
  dp1,
  cp1
];
function Cp1(r, e) {
  return n(), o("svg", ap1, _p1);
}
const SA2 = /* @__PURE__ */ i(hp1, [["render", Cp1]]);
var fp1 = {}, vp1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, up1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), wp1 = /* @__PURE__ */ t("path", {
  d: "M7.39137 2.46863C7.56432 2.29568 7.6508 2.2092 7.75172 2.14736C7.84119 2.09253 7.93873 2.05213 8.04077 2.02763C8.15586 2 8.27815 2 8.52274 2H15.4773C15.7218 2 15.8441 2 15.9592 2.02763C16.0613 2.05213 16.1588 2.09253 16.2483 2.14736C16.3492 2.2092 16.4357 2.29568 16.6086 2.46863L21.5314 7.39137C21.7043 7.56432 21.7908 7.6508 21.8526 7.75172C21.9075 7.84119 21.9479 7.93873 21.9724 8.04077C22 8.15586 22 8.27815 22 8.52274V15.4773C22 15.7218 22 15.8441 21.9724 15.9592C21.9479 16.0613 21.9075 16.1588 21.8526 16.2483C21.7908 16.3492 21.7043 16.4357 21.5314 16.6086L16.6086 21.5314C16.4357 21.7043 16.3492 21.7908 16.2483 21.8526C16.1588 21.9075 16.0613 21.9479 15.9592 21.9724C15.8441 22 15.7218 22 15.4773 22H8.52274C8.27815 22 8.15586 22 8.04077 21.9724C7.93873 21.9479 7.84119 21.9075 7.75172 21.8526C7.6508 21.7908 7.56432 21.7043 7.39137 21.5314L2.46863 16.6086C2.29568 16.4357 2.2092 16.3492 2.14736 16.2483C2.09253 16.1588 2.05213 16.0613 2.02763 15.9592C2 15.8441 2 15.7218 2 15.4773V8.52274C2 8.27815 2 8.15586 2.02763 8.04077C2.05213 7.93873 2.09253 7.84119 2.14736 7.75172C2.2092 7.6508 2.29568 7.56432 2.46863 7.39137L7.39137 2.46863Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pp1 = [
  up1,
  wp1
];
function gp1(r, e) {
  return n(), o("svg", vp1, pp1);
}
const TA2 = /* @__PURE__ */ i(fp1, [["render", gp1]]);
var $p1 = {}, Mp1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lp1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), kp1 = /* @__PURE__ */ t("path", {
  d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M14 20.889L12.777 21.5684C12.4934 21.726 12.3516 21.8047 12.2015 21.8356C12.0685 21.863 11.9315 21.863 11.7986 21.8356C11.6484 21.8047 11.5066 21.726 11.223 21.5684L3.82297 17.4573C3.52346 17.2909 3.37368 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V7.94153C3 7.59889 3 7.42757 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37368 6.79248 3.52345 6.70928 3.82297 6.54288L11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7986 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42757 21 7.59889 21 7.94153L21 12.5001M7.5 4.50008L16.5 9.50008M16 18.0001L18 20.0001L22 16.0001",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mp1 = [
  Lp1,
  kp1
];
function xp1(r, e) {
  return n(), o("svg", Mp1, mp1);
}
const OA2 = /* @__PURE__ */ i($p1, [["render", xp1]]);
var Hp1 = {}, Vp1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zp1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), Bp1 = /* @__PURE__ */ t("path", {
  d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M14 20.889L12.777 21.5684C12.4934 21.726 12.3516 21.8047 12.2015 21.8356C12.0685 21.863 11.9315 21.863 11.7986 21.8356C11.6484 21.8047 11.5066 21.726 11.223 21.5684L3.82297 17.4573C3.52346 17.2909 3.37368 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V7.94153C3 7.59889 3 7.42757 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37368 6.79248 3.52345 6.70928 3.82297 6.54288L11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7986 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42757 21 7.59889 21 7.94153V13.0001M7.5 4.50008L16.5 9.50008M16 18.0001H22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Fp1 = [
  Zp1,
  Bp1
];
function jp1(r, e) {
  return n(), o("svg", Vp1, Fp1);
}
const EA2 = /* @__PURE__ */ i(Hp1, [["render", jp1]]);
var Ip1 = {}, bp1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yp1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), Dp1 = /* @__PURE__ */ t("path", {
  d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M14 20.889L12.777 21.5684C12.4934 21.726 12.3516 21.8047 12.2015 21.8356C12.0685 21.863 11.9315 21.863 11.7986 21.8356C11.6484 21.8047 11.5066 21.726 11.223 21.5684L3.82297 17.4573C3.52346 17.2909 3.37368 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V7.94153C3 7.59889 3 7.42757 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37368 6.79248 3.52345 6.70928 3.82297 6.54288L11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7986 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42757 21 7.59889 21 7.94153L21 12.5001M7.5 4.50008L16.5 9.50008M19 21.0001V15.0001M16 18.0001H22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Pp1 = [
  yp1,
  Dp1
];
function Ap1(r, e) {
  return n(), o("svg", bp1, Pp1);
}
const RA2 = /* @__PURE__ */ i(Ip1, [["render", Ap1]]);
var Sp1 = {}, Tp1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Op1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), Ep1 = /* @__PURE__ */ t("path", {
  d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 12.0001V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37368 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37368 17.2077 3.52346 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L13 21.4445M7.5 4.50008L16.5 9.50008M22 21.5001L21 20.5001M22 18.0001C22 19.6569 20.6569 21.0001 19 21.0001C17.3431 21.0001 16 19.6569 16 18.0001C16 16.3432 17.3431 15.0001 19 15.0001C20.6569 15.0001 22 16.3432 22 18.0001Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Rp1 = [
  Op1,
  Ep1
];
function Up1(r, e) {
  return n(), o("svg", Tp1, Rp1);
}
const UA2 = /* @__PURE__ */ i(Sp1, [["render", Up1]]);
var Np1 = {}, qp1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zp1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), Kp1 = /* @__PURE__ */ t("path", {
  d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 12.5001L21 7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37368 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37368 17.2077 3.52346 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L13 21.4445M7.5 4.50008L16.5 9.50008M16.5 16.0001L21.5 21.0001M21.5 16.0001L16.5 21.0001",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Gp1 = [
  zp1,
  Kp1
];
function Wp1(r, e) {
  return n(), o("svg", qp1, Gp1);
}
const NA2 = /* @__PURE__ */ i(Np1, [["render", Wp1]]);
var Yp1 = {}, Xp1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qp1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), Jp1 = /* @__PURE__ */ t("path", {
  d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 16.0586V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tg1 = /* @__PURE__ */ t("path", {
  d: "M16.5 9.5L7.5 4.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), eg1 = [
  Qp1,
  Jp1,
  tg1
];
function rg1(r, e) {
  return n(), o("svg", Xp1, eg1);
}
const qA2 = /* @__PURE__ */ i(Yp1, [["render", rg1]]);
var ng1 = {}, og1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ig1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), lg1 = /* @__PURE__ */ t("path", {
  d: "M15.9997 11L1.9997 11M9.9997 4L7.9997 2M13.9997 22L1.9997 22M21.9997 16C21.9997 17.1046 21.1043 18 19.9997 18C18.8951 18 17.9997 17.1046 17.9997 16C17.9997 14.8954 19.9997 13 19.9997 13C19.9997 13 21.9997 14.8954 21.9997 16ZM8.9997 3L15.8683 9.86863C16.2643 10.2646 16.4624 10.4627 16.5365 10.691C16.6018 10.8918 16.6018 11.1082 16.5365 11.309C16.4624 11.5373 16.2643 11.7354 15.8683 12.1314L11.2624 16.7373C10.4704 17.5293 10.0744 17.9253 9.61773 18.0737C9.21605 18.2042 8.78335 18.2042 8.38166 18.0737C7.92501 17.9253 7.52899 17.5293 6.73696 16.7373L3.26244 13.2627C2.4704 12.4707 2.07439 12.0747 1.92601 11.618C1.7955 11.2163 1.7955 10.7837 1.92601 10.382C2.07439 9.92531 2.47041 9.52929 3.26244 8.73726L8.9997 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), sg1 = [
  ig1,
  lg1
];
function hg1(r, e) {
  return n(), o("svg", og1, sg1);
}
const zA2 = /* @__PURE__ */ i(ng1, [["render", hg1]]);
var ag1 = {}, dg1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cg1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), _g1 = /* @__PURE__ */ t("path", {
  d: "M2.99955 13H19.9995M11.9995 3.5L10.4995 2M11.4995 3L20.3682 11.8686C20.7642 12.2646 20.9622 12.4627 21.0364 12.691C21.1016 12.8918 21.1016 13.1082 21.0364 13.309C20.9622 13.5373 20.7642 13.7354 20.3682 14.1314L14.8937 19.6059C13.7056 20.7939 13.1116 21.388 12.4266 21.6105C11.8241 21.8063 11.175 21.8063 10.5725 21.6105C9.88751 21.388 9.29349 20.7939 8.10543 19.6059L4.89366 16.3941C3.70561 15.2061 3.11158 14.612 2.88902 13.9271C2.69324 13.3245 2.69324 12.6755 2.88902 12.0729C3.11158 11.388 3.70561 10.7939 4.89366 9.60589L11.4995 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Cg1 = [
  cg1,
  _g1
];
function fg1(r, e) {
  return n(), o("svg", dg1, Cg1);
}
const KA2 = /* @__PURE__ */ i(ag1, [["render", fg1]]);
var vg1 = {}, ug1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wg1 = /* @__PURE__ */ a('<rect width="1144" height="1260" transform="translate(-608 -476)" fill="none"></rect><path d="M2 12C2 17.5228 6.47715 22 12 22C13.6569 22 15 20.6569 15 19V18.5C15 18.0356 15 17.8034 15.0257 17.6084C15.2029 16.2622 16.2622 15.2029 17.6084 15.0257C17.8034 15 18.0356 15 18.5 15H19C20.6569 15 22 13.6569 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>', 5), pg1 = [
  wg1
];
function gg1(r, e) {
  return n(), o("svg", ug1, pg1);
}
const GA2 = /* @__PURE__ */ i(vg1, [["render", gg1]]);
var $g1 = {}, Mg1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lg1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), kg1 = /* @__PURE__ */ t("path", {
  d: "M21.1525 10.8995L12.1369 19.9151C10.0866 21.9653 6.7625 21.9653 4.71225 19.9151C2.662 17.8648 2.662 14.5407 4.71225 12.4904L13.7279 3.47483C15.0947 2.108 17.3108 2.108 18.6776 3.47483C20.0444 4.84167 20.0444 7.05775 18.6776 8.42458L10.0156 17.0866C9.33213 17.7701 8.22409 17.7701 7.54068 17.0866C6.85726 16.4032 6.85726 15.2952 7.54068 14.6118L15.1421 7.01037",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mg1 = [
  Lg1,
  kg1
];
function xg1(r, e) {
  return n(), o("svg", Mg1, mg1);
}
const WA2 = /* @__PURE__ */ i($g1, [["render", xg1]]);
var Hg1 = {}, Vg1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zg1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), Bg1 = /* @__PURE__ */ t("path", {
  d: "M21 10H13M21 6H13M21 14H13M21 18H13M6 20L6 4M6 20L3 17M6 20L9 17M6 4L3 7M6 4L9 7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Fg1 = [
  Zg1,
  Bg1
];
function jg1(r, e) {
  return n(), o("svg", Vg1, Fg1);
}
const YA2 = /* @__PURE__ */ i(Hg1, [["render", jg1]]);
var Ig1 = {}, bg1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yg1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), Dg1 = /* @__PURE__ */ t("path", {
  d: "M3 6H21M3 12H18C18.7956 12 19.5587 12.3161 20.1213 12.8787C20.6839 13.4413 21 14.2044 21 15C21 15.7956 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7956 18 18 18H14M14 18L16 16M14 18L16 20M3 18H10",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Pg1 = [
  yg1,
  Dg1
];
function Ag1(r, e) {
  return n(), o("svg", bg1, Pg1);
}
const XA2 = /* @__PURE__ */ i(Ig1, [["render", Ag1]]);
var Sg1 = {}, Tg1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Og1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), Eg1 = /* @__PURE__ */ t("path", {
  d: "M22 11V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.71569 21.2843 5.40973 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.71569 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V11.8C2 12.9201 2 13.4802 2.21799 13.908C2.40973 14.2843 2.71569 14.5903 3.09202 14.782C3.51984 15 4.0799 15 5.2 15H11M12 10H12.005M17 10H17.005M7 10H7.005M19.25 17V15.25C19.25 14.2835 18.4665 13.5 17.5 13.5C16.5335 13.5 15.75 14.2835 15.75 15.25V17M12.25 10C12.25 10.1381 12.1381 10.25 12 10.25C11.8619 10.25 11.75 10.1381 11.75 10C11.75 9.86193 11.8619 9.75 12 9.75C12.1381 9.75 12.25 9.86193 12.25 10ZM17.25 10C17.25 10.1381 17.1381 10.25 17 10.25C16.8619 10.25 16.75 10.1381 16.75 10C16.75 9.86193 16.8619 9.75 17 9.75C17.1381 9.75 17.25 9.86193 17.25 10ZM7.25 10C7.25 10.1381 7.13807 10.25 7 10.25C6.86193 10.25 6.75 10.1381 6.75 10C6.75 9.86193 6.86193 9.75 7 9.75C7.13807 9.75 7.25 9.86193 7.25 10ZM15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.0399 21 17.7599 20.891 17.546C20.7951 17.3578 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H15.6C15.0399 17 14.7599 17 14.546 17.109C14.3578 17.2049 14.2049 17.3578 14.109 17.546C14 17.7599 14 18.0399 14 18.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Rg1 = [
  Og1,
  Eg1
];
function Ug1(r, e) {
  return n(), o("svg", Tg1, Rg1);
}
const QA2 = /* @__PURE__ */ i(Sg1, [["render", Ug1]]);
var Ng1 = {}, qg1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zg1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), Kg1 = /* @__PURE__ */ t("path", {
  d: "M12 12H12.005M17 12H17.005M7 12H7.005M5.2 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.0799 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H5.2C4.0799 17 3.51984 17 3.09202 16.782C2.71569 16.5903 2.40973 16.2843 2.21799 15.908C2 15.4802 2 14.9201 2 13.8V10.2C2 9.0799 2 8.51984 2.21799 8.09202C2.40973 7.71569 2.71569 7.40973 3.09202 7.21799C3.51984 7 4.0799 7 5.2 7ZM12.25 12C12.25 12.1381 12.1381 12.25 12 12.25C11.8619 12.25 11.75 12.1381 11.75 12C11.75 11.8619 11.8619 11.75 12 11.75C12.1381 11.75 12.25 11.8619 12.25 12ZM17.25 12C17.25 12.1381 17.1381 12.25 17 12.25C16.8619 12.25 16.75 12.1381 16.75 12C16.75 11.8619 16.8619 11.75 17 11.75C17.1381 11.75 17.25 11.8619 17.25 12ZM7.25 12C7.25 12.1381 7.13807 12.25 7 12.25C6.86193 12.25 6.75 12.1381 6.75 12C6.75 11.8619 6.86193 11.75 7 11.75C7.13807 11.75 7.25 11.8619 7.25 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Gg1 = [
  zg1,
  Kg1
];
function Wg1(r, e) {
  return n(), o("svg", qg1, Gg1);
}
const JA2 = /* @__PURE__ */ i(Ng1, [["render", Wg1]]);
var Yg1 = {}, Xg1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qg1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), Jg1 = /* @__PURE__ */ t("path", {
  d: "M10 16H14M8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), t$1 = [
  Qg1,
  Jg1
];
function e$1(r, e) {
  return n(), o("svg", Xg1, t$1);
}
const tS2 = /* @__PURE__ */ i(Yg1, [["render", e$1]]);
var r$1 = {}, n$1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o$1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -1076)",
  fill: "none"
}, null, -1), i$1 = /* @__PURE__ */ t("path", {
  d: "M9.5 15V9M14.5 15V9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), l$1 = [
  o$1,
  i$1
];
function s$1(r, e) {
  return n(), o("svg", n$1, l$1);
}
const eS2 = /* @__PURE__ */ i(r$1, [["render", s$1]]);
var h$1 = {}, a$1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, d$1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -1116)",
  fill: "none"
}, null, -1), c$1 = /* @__PURE__ */ t("path", {
  d: "M9.5 15V9M14.5 15V9M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _$1 = [
  d$1,
  c$1
];
function C$1(r, e) {
  return n(), o("svg", a$1, _$1);
}
const rS2 = /* @__PURE__ */ i(h$1, [["render", C$1]]);
var f$1 = {}, v$1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, u$1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), w$1 = /* @__PURE__ */ t("path", {
  d: "M18 13L16.7004 6.50182C16.6278 6.13883 16.5915 5.95733 16.5032 5.80953C16.4252 5.67886 16.3183 5.56773 16.1908 5.4846C16.0466 5.39057 15.8667 5.34714 15.5069 5.26028L2 2M2 2L5.26028 15.5069C5.34714 15.8667 5.39057 16.0466 5.4846 16.1908C5.56773 16.3183 5.67886 16.4252 5.80953 16.5032C5.95733 16.5915 6.13883 16.6278 6.50182 16.7004L13 18M2 2L9.586 9.586M16.1314 20.8686L20.8686 16.1314C21.2646 15.7354 21.4627 15.5373 21.5368 15.309C21.6021 15.1082 21.6021 14.8918 21.5368 14.691C21.4627 14.4627 21.2646 14.2646 20.8686 13.8686L20.1314 13.1314C19.7354 12.7354 19.5373 12.5373 19.309 12.4632C19.1082 12.3979 18.8918 12.3979 18.691 12.4632C18.4627 12.5373 18.2646 12.7354 17.8686 13.1314L13.1314 17.8686C12.7354 18.2646 12.5373 18.4627 12.4632 18.691C12.3979 18.8918 12.3979 19.1082 12.4632 19.309C12.5373 19.5373 12.7354 19.7354 13.1314 20.1314L13.8686 20.8686C14.2646 21.2646 14.4627 21.4627 14.691 21.5368C14.8918 21.6021 15.1082 21.6021 15.309 21.5368C15.5373 21.4627 15.7354 21.2646 16.1314 20.8686ZM13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), p$1 = [
  u$1,
  w$1
];
function g$1(r, e) {
  return n(), o("svg", v$1, p$1);
}
const nS2 = /* @__PURE__ */ i(f$1, [["render", g$1]]);
var $$1 = {}, M$1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, L$1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -636)",
  fill: "none"
}, null, -1), k$1 = /* @__PURE__ */ t("path", {
  d: "M13 5.99985L6.50182 7.29948C6.13883 7.37208 5.95733 7.40838 5.80952 7.49665C5.67886 7.57469 5.56772 7.68152 5.4846 7.80901C5.39057 7.95321 5.34714 8.13314 5.26028 8.49299L2 21.9998M2 21.9998L15.5069 18.7396C15.8667 18.6527 16.0466 18.6093 16.1908 18.5153C16.3183 18.4321 16.4252 18.321 16.5032 18.1903C16.5915 18.0425 16.6278 17.861 16.7004 17.498L18 10.9998M2 21.9998L9.586 14.4138M20.8686 7.86848L16.1314 3.13122C15.7354 2.7352 15.5373 2.53719 15.309 2.46301C15.1082 2.39775 14.8918 2.39775 14.691 2.46301C14.4627 2.53719 14.2646 2.7352 13.8686 3.13122L13.1314 3.86848C12.7354 4.2645 12.5373 4.4625 12.4632 4.69083C12.3979 4.89168 12.3979 5.10802 12.4632 5.30887C12.5373 5.53719 12.7354 5.7352 13.1314 6.13122L17.8686 10.8685C18.2646 11.2645 18.4627 11.4625 18.691 11.5367C18.8918 11.6019 19.1082 11.6019 19.309 11.5367C19.5373 11.4625 19.7354 11.2645 20.1314 10.8685L20.8686 10.1312C21.2646 9.7352 21.4627 9.53719 21.5368 9.30887C21.6021 9.10802 21.6021 8.89168 21.5368 8.69083C21.4627 8.4625 21.2646 8.2645 20.8686 7.86848ZM11 10.9998C12.1046 10.9998 13 11.8953 13 12.9998C13 14.1044 12.1046 14.9998 11 14.9998C9.89543 14.9998 9 14.1044 9 12.9998C9 11.8953 9.89543 10.9998 11 10.9998Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), m$1 = [
  L$1,
  k$1
];
function x$1(r, e) {
  return n(), o("svg", M$1, m$1);
}
const oS2 = /* @__PURE__ */ i($$1, [["render", x$1]]);
var H$1 = {}, V$1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Z$1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -676)",
  fill: "none"
}, null, -1), B$1 = /* @__PURE__ */ t("path", {
  d: "M2 4.99985H8M15 6.99985L8.83447 8.76143C8.52956 8.84855 8.37711 8.8921 8.25117 8.97398C8.13969 9.04647 8.04379 9.14045 7.96907 9.25045C7.88466 9.3747 7.83803 9.52625 7.74477 9.82933L4 21.9998M4 21.9998L16.1705 18.2551C16.4736 18.1618 16.6251 18.1152 16.7494 18.0308C16.8594 17.9561 16.9534 17.8602 17.0259 17.7487C17.1077 17.6227 17.1513 17.4703 17.2384 17.1654L19 10.9998M4 21.9998L10.586 15.4138M21.8686 7.86848L18.1314 4.13122C17.7354 3.7352 17.5373 3.53719 17.309 3.46301C17.1082 3.39775 16.8918 3.39775 16.691 3.46301C16.4627 3.53719 16.2646 3.7352 15.8686 4.13122L15.1314 4.86848C14.7354 5.2645 14.5373 5.4625 14.4632 5.69083C14.3979 5.89168 14.3979 6.10802 14.4632 6.30887C14.5373 6.53719 14.7354 6.7352 15.1314 7.13122L18.8686 10.8685C19.2646 11.2645 19.4627 11.4625 19.691 11.5367C19.8918 11.6019 20.1082 11.6019 20.309 11.5367C20.5373 11.4625 20.7354 11.2645 21.1314 10.8685L21.8686 10.1312C22.2646 9.7352 22.4627 9.53719 22.5368 9.30887C22.6021 9.10802 22.6021 8.89168 22.5368 8.69083C22.4627 8.4625 22.2646 8.26449 21.8686 7.86848ZM12 11.9998C13.1046 11.9998 14 12.8953 14 13.9998C14 15.1044 13.1046 15.9998 12 15.9998C10.8954 15.9998 10 15.1044 10 13.9998C10 12.8953 10.8954 11.9998 12 11.9998Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), F$1 = [
  Z$1,
  B$1
];
function j$1(r, e) {
  return n(), o("svg", V$1, F$1);
}
const iS2 = /* @__PURE__ */ i(H$1, [["render", j$1]]);
var I$1 = {}, b$1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y$1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -716)",
  fill: "none"
}, null, -1), D$1 = /* @__PURE__ */ t("path", {
  d: "M15 7L8.83447 8.76158C8.52956 8.8487 8.37711 8.89226 8.25117 8.97414C8.13969 9.04662 8.04379 9.1406 7.96907 9.2506C7.88466 9.37485 7.83803 9.5264 7.74477 9.82948L4 22M4 22L16.1705 18.2552C16.4736 18.162 16.6251 18.1153 16.7494 18.0309C16.8594 17.9562 16.9534 17.8603 17.0259 17.7488C17.1077 17.6229 17.1513 17.4704 17.2384 17.1655L19 11M4 22L10.586 15.4139M5 8V2M2 5H8M21.8686 7.86863L18.1314 4.13137C17.7354 3.73535 17.5373 3.53735 17.309 3.46316C17.1082 3.3979 16.8918 3.3979 16.691 3.46316C16.4627 3.53735 16.2646 3.73535 15.8686 4.13137L15.1314 4.86863C14.7354 5.26465 14.5373 5.46265 14.4632 5.69098C14.3979 5.89183 14.3979 6.10817 14.4632 6.30902C14.5373 6.53735 14.7354 6.73535 15.1314 7.13137L18.8686 10.8686C19.2646 11.2646 19.4627 11.4627 19.691 11.5368C19.8918 11.6021 20.1082 11.6021 20.309 11.5368C20.5373 11.4627 20.7354 11.2646 21.1314 10.8686L21.8686 10.1314C22.2646 9.73535 22.4627 9.53735 22.5368 9.30902C22.6021 9.10817 22.6021 8.89183 22.5368 8.69098C22.4627 8.46265 22.2646 8.26465 21.8686 7.86863ZM12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), P$1 = [
  y$1,
  D$1
];
function A$1(r, e) {
  return n(), o("svg", b$1, P$1);
}
const lS2 = /* @__PURE__ */ i(I$1, [["render", A$1]]);
var S$1 = {}, T$1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O$1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -756)",
  fill: "none"
}, null, -1), E$1 = /* @__PURE__ */ t("path", {
  d: "M2.5 21.4998L8.04927 19.3655C8.40421 19.229 8.58168 19.1607 8.74772 19.0716C8.8952 18.9924 9.0358 18.901 9.16804 18.7984C9.31692 18.6829 9.45137 18.5484 9.72028 18.2795L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99981C19.8955 1.89525 18.1046 1.89524 17 2.99981L5.72028 14.2795C5.45138 14.5484 5.31692 14.6829 5.20139 14.8318C5.09877 14.964 5.0074 15.1046 4.92823 15.2521C4.83911 15.4181 4.77085 15.5956 4.63433 15.9506L2.5 21.4998ZM2.5 21.4998L4.55812 16.1488C4.7054 15.7659 4.77903 15.5744 4.90534 15.4867C5.01572 15.4101 5.1523 15.3811 5.2843 15.4063C5.43533 15.4351 5.58038 15.5802 5.87048 15.8703L8.12957 18.1294C8.41967 18.4195 8.56472 18.5645 8.59356 18.7155C8.61877 18.8475 8.58979 18.9841 8.51314 19.0945C8.42545 19.2208 8.23399 19.2944 7.85107 19.4417L2.5 21.4998Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), R$1 = [
  O$1,
  E$1
];
function U$1(r, e) {
  return n(), o("svg", T$1, R$1);
}
const sS2 = /* @__PURE__ */ i(S$1, [["render", U$1]]);
var N$1 = {}, q$1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z$1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -796)",
  fill: "none"
}, null, -1), K$1 = /* @__PURE__ */ t("path", {
  d: "M18 2L22 6M2 22L3.2764 17.3199C3.35968 17.0145 3.40131 16.8619 3.46523 16.7195C3.52199 16.5931 3.59172 16.4729 3.67332 16.3609C3.76521 16.2348 3.87711 16.1229 4.1009 15.8991L14.4343 5.56569C14.6323 5.36768 14.7313 5.26867 14.8455 5.23158C14.9459 5.19895 15.0541 5.19895 15.1545 5.23158C15.2687 5.26867 15.3677 5.36768 15.5657 5.56569L18.4343 8.43431C18.6323 8.63232 18.7313 8.73133 18.7684 8.84549C18.8011 8.94591 18.8011 9.05409 18.7684 9.15451C18.7313 9.26867 18.6323 9.36768 18.4343 9.56569L8.1009 19.8991C7.87711 20.1229 7.76521 20.2348 7.63908 20.3267C7.52709 20.4083 7.40692 20.478 7.28052 20.5348C7.13815 20.5987 6.98548 20.6403 6.68014 20.7236L2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), G$1 = [
  z$1,
  K$1
];
function W$1(r, e) {
  return n(), o("svg", q$1, G$1);
}
const hS2 = /* @__PURE__ */ i(N$1, [["render", W$1]]);
var Y$1 = {}, X$1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Q$1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -836)",
  fill: "none"
}, null, -1), J$1 = /* @__PURE__ */ t("path", {
  d: "M21 20.9998H13M2.5 21.4998L8.04927 19.3655C8.40421 19.229 8.58168 19.1607 8.74772 19.0716C8.8952 18.9924 9.0358 18.901 9.16804 18.7984C9.31692 18.6829 9.45137 18.5484 9.72028 18.2795L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99981C19.8955 1.89525 18.1046 1.89524 17 2.99981L5.72028 14.2795C5.45138 14.5484 5.31692 14.6829 5.20139 14.8318C5.09877 14.964 5.0074 15.1046 4.92823 15.2521C4.83911 15.4181 4.77085 15.5956 4.63433 15.9506L2.5 21.4998ZM2.5 21.4998L4.55812 16.1488C4.7054 15.7659 4.77903 15.5744 4.90534 15.4867C5.01572 15.4101 5.1523 15.3811 5.2843 15.4063C5.43533 15.4351 5.58038 15.5802 5.87048 15.8703L8.12957 18.1294C8.41967 18.4195 8.56472 18.5645 8.59356 18.7155C8.61877 18.8475 8.58979 18.9841 8.51314 19.0945C8.42545 19.2208 8.23399 19.2944 7.85107 19.4417L2.5 21.4998Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tM1 = [
  Q$1,
  J$1
];
function eM1(r, e) {
  return n(), o("svg", X$1, tM1);
}
const aS2 = /* @__PURE__ */ i(Y$1, [["render", eM1]]);
var rM1 = {}, nM1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oM1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), iM1 = /* @__PURE__ */ t("path", {
  d: "M11.0605 2.93203C11.3983 2.68689 11.5672 2.56432 11.7518 2.51696C11.9148 2.47514 12.0858 2.47514 12.2488 2.51696C12.4334 2.56432 12.6023 2.68689 12.9401 2.93203L21.0586 8.82396C21.397 9.06956 21.5663 9.19235 21.6686 9.3535C21.7589 9.49579 21.8119 9.65862 21.8224 9.82684C21.8344 10.0174 21.7697 10.2162 21.6404 10.6138L18.5401 20.1449C18.4109 20.5421 18.3463 20.7407 18.2247 20.8876C18.1173 21.0173 17.979 21.1178 17.8224 21.1798C17.6451 21.25 17.4362 21.25 17.0186 21.25H6.98203C6.56437 21.25 6.35554 21.25 6.17822 21.1798C6.02164 21.1178 5.88325 21.0173 5.77589 20.8876C5.65429 20.7407 5.58969 20.5421 5.4605 20.1449L2.36021 10.6138C2.23086 10.2162 2.16619 10.0174 2.17817 9.82684C2.18874 9.65862 2.24166 9.49579 2.33202 9.3535C2.43434 9.19235 2.60355 9.06956 2.94196 8.82396L11.0605 2.93203Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lM1 = [
  oM1,
  iM1
];
function sM1(r, e) {
  return n(), o("svg", nM1, lM1);
}
const dS2 = /* @__PURE__ */ i(rM1, [["render", sM1]]);
var hM1 = {}, aM1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dM1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1156)",
  fill: "none"
}, null, -1), cM1 = /* @__PURE__ */ t("path", {
  d: "M19 5L5 19M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM18.5 17.5C18.5 18.0523 18.0523 18.5 17.5 18.5C16.9477 18.5 16.5 18.0523 16.5 17.5C16.5 16.9477 16.9477 16.5 17.5 16.5C18.0523 16.5 18.5 16.9477 18.5 17.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _M1 = [
  dM1,
  cM1
];
function CM1(r, e) {
  return n(), o("svg", aM1, _M1);
}
const cS2 = /* @__PURE__ */ i(hM1, [["render", CM1]]);
var fM1 = {}, vM1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uM1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1196)",
  fill: "none"
}, null, -1), wM1 = /* @__PURE__ */ t("path", {
  d: "M19 5L5 19M9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7C5 5.89543 5.89543 5 7 5C8.10457 5 9 5.89543 9 7ZM19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pM1 = [
  uM1,
  wM1
];
function gM1(r, e) {
  return n(), o("svg", vM1, pM1);
}
const _S2 = /* @__PURE__ */ i(fM1, [["render", gM1]]);
var $M1 = {}, MM1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LM1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1236)",
  fill: "none"
}, null, -1), kM1 = /* @__PURE__ */ t("path", {
  d: "M9 9H9.01M15 15H15.01M16 8L8 16M9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mM1 = [
  LM1,
  kM1
];
function xM1(r, e) {
  return n(), o("svg", MM1, mM1);
}
const CS2 = /* @__PURE__ */ i($M1, [["render", xM1]]);
var HM1 = {}, VM1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZM1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -876)",
  fill: "none"
}, null, -1), BM1 = /* @__PURE__ */ t("path", {
  d: "M19 9V15M5 7V17M17 6.71429L7 5.28571M17 17.2857L7 18.7143M4.6 7H5.4C5.96005 7 6.24008 7 6.45399 6.89101C6.64215 6.79513 6.79513 6.64215 6.89101 6.45399C7 6.24008 7 5.96005 7 5.4V4.6C7 4.03995 7 3.75992 6.89101 3.54601C6.79513 3.35785 6.64215 3.20487 6.45399 3.10899C6.24008 3 5.96005 3 5.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V5.4C3 5.96005 3 6.24008 3.10899 6.45399C3.20487 6.64215 3.35785 6.79513 3.54601 6.89101C3.75992 7 4.03995 7 4.6 7ZM4.6 21H5.4C5.96005 21 6.24008 21 6.45399 20.891C6.64215 20.7951 6.79513 20.6422 6.89101 20.454C7 20.2401 7 19.9601 7 19.4V18.6C7 18.0399 7 17.7599 6.89101 17.546C6.79513 17.3578 6.64215 17.2049 6.45399 17.109C6.24008 17 5.96005 17 5.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3578 3.10899 17.546C3 17.7599 3 18.0399 3 18.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21ZM18.6 9H19.4C19.9601 9 20.2401 9 20.454 8.89101C20.6422 8.79513 20.7951 8.64215 20.891 8.45399C21 8.24008 21 7.96005 21 7.4V6.6C21 6.03995 21 5.75992 20.891 5.54601C20.7951 5.35785 20.6422 5.20487 20.454 5.10899C20.2401 5 19.9601 5 19.4 5H18.6C18.0399 5 17.7599 5 17.546 5.10899C17.3578 5.20487 17.2049 5.35785 17.109 5.54601C17 5.75992 17 6.03995 17 6.6V7.4C17 7.96005 17 8.24008 17.109 8.45399C17.2049 8.64215 17.3578 8.79513 17.546 8.89101C17.7599 9 18.0399 9 18.6 9ZM18.6 19H19.4C19.9601 19 20.2401 19 20.454 18.891C20.6422 18.7951 20.7951 18.6422 20.891 18.454C21 18.2401 21 17.9601 21 17.4V16.6C21 16.0399 21 15.7599 20.891 15.546C20.7951 15.3578 20.6422 15.2049 20.454 15.109C20.2401 15 19.9601 15 19.4 15H18.6C18.0399 15 17.7599 15 17.546 15.109C17.3578 15.2049 17.2049 15.3578 17.109 15.546C17 15.7599 17 16.0399 17 16.6V17.4C17 17.9601 17 18.2401 17.109 18.454C17.2049 18.6422 17.3578 18.7951 17.546 18.891C17.7599 19 18.0399 19 18.6 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FM1 = [
  ZM1,
  BM1
];
function jM1(r, e) {
  return n(), o("svg", VM1, FM1);
}
const fS2 = /* @__PURE__ */ i(HM1, [["render", jM1]]);
var IM1 = {}, bM1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yM1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -916)",
  fill: "none"
}, null, -1), DM1 = /* @__PURE__ */ t("path", {
  d: "M16 5.00007L16 19.0001M10 4.00007L10 20.0001M3 12.0001H21M3 5.98924L3 18.0109C3 19.3749 3 20.0569 3.28134 20.5297C3.52803 20.9442 3.9162 21.2556 4.37434 21.4065C4.89685 21.5785 5.56262 21.4306 6.89418 21.1347L18.4942 18.5569C19.3883 18.3582 19.8354 18.2589 20.1691 18.0185C20.4634 17.8064 20.6945 17.5183 20.8377 17.1849C21 16.807 21 16.3491 21 15.4331V8.56702C21 7.65109 21 7.19312 20.8377 6.8152C20.6945 6.48186 20.4634 6.19373 20.1691 5.98168C19.8354 5.74126 19.3883 5.64191 18.4942 5.44322L6.89418 2.86544C5.56262 2.56954 4.89685 2.42159 4.37434 2.59368C3.9162 2.74457 3.52803 3.05596 3.28134 3.47045C3 3.94318 3 4.6252 3 5.98924Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PM1 = [
  yM1,
  DM1
];
function AM1(r, e) {
  return n(), o("svg", bM1, PM1);
}
const vS2 = /* @__PURE__ */ i(IM1, [["render", AM1]]);
var SM1 = {}, TM1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OM1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -1156)",
  fill: "none"
}, null, -1), EM1 = /* @__PURE__ */ t("path", {
  d: "M12 17.5H12.01M8.2 22H15.8C16.9201 22 17.4802 22 17.908 21.782C18.2843 21.5903 18.5903 21.2843 18.782 20.908C19 20.4802 19 19.9201 19 18.8V5.2C19 4.07989 19 3.51984 18.782 3.09202C18.5903 2.71569 18.2843 2.40973 17.908 2.21799C17.4802 2 16.9201 2 15.8 2H8.2C7.0799 2 6.51984 2 6.09202 2.21799C5.71569 2.40973 5.40973 2.71569 5.21799 3.09202C5 3.51984 5 4.0799 5 5.2V18.8C5 19.9201 5 20.4802 5.21799 20.908C5.40973 21.2843 5.71569 21.5903 6.09202 21.782C6.51984 22 7.07989 22 8.2 22ZM12.5 17.5C12.5 17.7761 12.2761 18 12 18C11.7239 18 11.5 17.7761 11.5 17.5C11.5 17.2239 11.7239 17 12 17C12.2761 17 12.5 17.2239 12.5 17.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), RM1 = [
  OM1,
  EM1
];
function UM1(r, e) {
  return n(), o("svg", TM1, RM1);
}
const uS2 = /* @__PURE__ */ i(SM1, [["render", UM1]]);
var NM1 = {}, qM1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zM1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-336 -1196)",
  fill: "none"
}, null, -1), KM1 = /* @__PURE__ */ t("path", {
  d: "M15 2V3.4C15 3.96005 15 4.24008 14.891 4.45399C14.7951 4.64215 14.6422 4.79513 14.454 4.89101C14.2401 5 13.9601 5 13.4 5H10.6C10.0399 5 9.75992 5 9.54601 4.89101C9.35785 4.79513 9.20487 4.64215 9.10899 4.45399C9 4.24008 9 3.96005 9 3.4V2M8.2 22H15.8C16.9201 22 17.4802 22 17.908 21.782C18.2843 21.5903 18.5903 21.2843 18.782 20.908C19 20.4802 19 19.9201 19 18.8V5.2C19 4.07989 19 3.51984 18.782 3.09202C18.5903 2.71569 18.2843 2.40973 17.908 2.21799C17.4802 2 16.9201 2 15.8 2H8.2C7.0799 2 6.51984 2 6.09202 2.21799C5.71569 2.40973 5.40973 2.71569 5.21799 3.09202C5 3.51984 5 4.0799 5 5.2V18.8C5 19.9201 5 20.4802 5.21799 20.908C5.40973 21.2843 5.71569 21.5903 6.09202 21.782C6.51984 22 7.07989 22 8.2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GM1 = [
  zM1,
  KM1
];
function WM1(r, e) {
  return n(), o("svg", qM1, GM1);
}
const wS2 = /* @__PURE__ */ i(NM1, [["render", WM1]]);
var YM1 = {}, XM1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QM1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), JM1 = /* @__PURE__ */ t("path", {
  d: "M14.0497 6C15.0264 6.19057 15.924 6.66826 16.6277 7.37194C17.3314 8.07561 17.8091 8.97326 17.9997 9.95M14.0497 2C16.0789 2.22544 17.9713 3.13417 19.4159 4.57701C20.8606 6.01984 21.7717 7.91101 21.9997 9.94M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tL1 = [
  QM1,
  JM1
];
function eL1(r, e) {
  return n(), o("svg", XM1, tL1);
}
const pS2 = /* @__PURE__ */ i(YM1, [["render", eL1]]);
var rL1 = {}, nL1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oL1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), iL1 = /* @__PURE__ */ t("path", {
  d: "M4.85864 6C6.67357 4.14864 9.20268 3 12.0001 3C14.7975 3 17.3266 4.14864 19.1415 6M16.4723 9C15.3736 7.7725 13.777 7 12 7C10.223 7 8.62647 7.7725 7.52783 9M12 17C13.5105 17 14.9608 17.2576 16.3094 17.7313C16.3542 17.747 16.3767 17.7549 16.412 17.7705C16.7326 17.9118 16.9788 18.2591 17.0058 18.6084C17.0088 18.647 17.0088 18.6811 17.0088 18.7494C17.0088 18.9821 17.0088 19.0985 17.0185 19.1965C17.1122 20.1457 17.8631 20.8966 18.8123 20.9903C18.9103 21 19.0267 21 19.2594 21H19.5044C19.965 21 20.1952 21 20.3868 20.9622C21.1829 20.8053 21.8053 20.1829 21.9622 19.3868C22 19.1952 22 18.965 22 18.5044V18.3062C22 17.831 22 17.5933 21.9493 17.3209C21.8358 16.7119 21.3933 15.9583 20.9166 15.5624C20.7035 15.3854 20.5589 15.3048 20.2698 15.1435C17.822 13.7781 15.0019 13 12 13C8.99812 13 6.17797 13.7781 3.73021 15.1435C3.4411 15.3048 3.29654 15.3854 3.0834 15.5624C2.60675 15.9583 2.16421 16.7119 2.05074 17.3209C2 17.5933 2 17.831 2 18.3062V18.5044C2 18.965 2 19.1952 2.03776 19.3868C2.19469 20.1829 2.81709 20.8053 3.61321 20.9622C3.80476 21 4.03504 21 4.4956 21H4.74057C4.97332 21 5.0897 21 5.18773 20.9903C6.13689 20.8966 6.8878 20.1457 6.98152 19.1965C6.9912 19.0985 6.9912 18.9821 6.9912 18.7494C6.9912 18.6811 6.9912 18.647 6.99418 18.6084C7.02122 18.2591 7.2674 17.9118 7.58798 17.7705C7.62335 17.7549 7.64577 17.747 7.69061 17.7313C9.03921 17.2576 10.4895 17 12 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lL1 = [
  oL1,
  iL1
];
function sL1(r, e) {
  return n(), o("svg", nL1, lL1);
}
const gS2 = /* @__PURE__ */ i(rL1, [["render", sL1]]);
var hL1 = {}, aL1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dL1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), cL1 = /* @__PURE__ */ t("path", {
  d: "M5.47542 12.8631C4.44449 11.2622 3.67643 9.54121 3.17124 7.76131C3.01103 7.19687 2.93093 6.91464 2.9297 6.5017C2.92833 6.04347 3.08969 5.42298 3.31412 5.02348C3.51636 4.66345 3.78117 4.39863 4.3108 3.86901L4.46843 3.71138C4.99987 3.17993 5.2656 2.91421 5.55098 2.76987C6.11854 2.4828 6.7888 2.4828 7.35636 2.76987C7.64174 2.91421 7.90747 3.17993 8.43891 3.71138L8.63378 3.90625C8.98338 4.25585 9.15819 4.43066 9.27247 4.60643C9.70347 5.26932 9.70347 6.1239 9.27247 6.7868C9.15819 6.96257 8.98338 7.13738 8.63378 7.48698C8.51947 7.60129 8.46231 7.65845 8.41447 7.72526C8.24446 7.96269 8.18576 8.30695 8.26748 8.58731C8.29048 8.6662 8.32041 8.72855 8.38028 8.85324C8.50111 9.10491 8.62956 9.35383 8.76563 9.59967M11.1817 12.8179L11.2266 12.8631C12.4282 14.0646 13.7869 15.0134 15.2365 15.7094C15.3612 15.7693 15.4235 15.7992 15.5024 15.8222C15.7828 15.904 16.127 15.8453 16.3644 15.6752C16.4313 15.6274 16.4884 15.5702 16.6027 15.4559C16.9523 15.1063 17.1271 14.9315 17.3029 14.8172C17.9658 14.3862 18.8204 14.3862 19.4833 14.8172C19.6591 14.9315 19.8339 15.1063 20.1835 15.4559L20.3783 15.6508C20.9098 16.1822 21.1755 16.448 21.3198 16.7333C21.6069 17.3009 21.6069 17.9712 21.3198 18.5387C21.1755 18.8241 20.9098 19.0898 20.3783 19.6213L20.2207 19.7789C19.6911 20.3085 19.4263 20.5733 19.0662 20.7756C18.6667 21 18.0462 21.1614 17.588 21.16C17.1751 21.1588 16.8928 21.0787 16.3284 20.9185C13.295 20.0575 10.4326 18.433 8.04466 16.045L7.99976 16M20.9996 3L2.99961 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _L1 = [
  dL1,
  cL1
];
function CL1(r, e) {
  return n(), o("svg", aL1, _L1);
}
const $S2 = /* @__PURE__ */ i(hL1, [["render", CL1]]);
var fL1 = {}, vL1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uL1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), wL1 = /* @__PURE__ */ t("path", {
  d: "M14.9996 4V9M14.9996 9L19.9996 9M14.9996 9L20.9996 3M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pL1 = [
  uL1,
  wL1
];
function gL1(r, e) {
  return n(), o("svg", vL1, pL1);
}
const MS2 = /* @__PURE__ */ i(fL1, [["render", gL1]]);
var $L1 = {}, ML1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LL1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), kL1 = /* @__PURE__ */ t("path", {
  d: "M16.4996 3L12.9996 6.5M12.9996 6.5L16.4996 10M12.9996 6.5H20.9996M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mL1 = [
  LL1,
  kL1
];
function xL1(r, e) {
  return n(), o("svg", ML1, mL1);
}
const LS2 = /* @__PURE__ */ i($L1, [["render", xL1]]);
var HL1 = {}, VL1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZL1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), BL1 = /* @__PURE__ */ t("path", {
  d: "M20.9996 8V3M20.9996 3H15.9996M20.9996 3L14.9996 9M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FL1 = [
  ZL1,
  BL1
];
function jL1(r, e) {
  return n(), o("svg", VL1, FL1);
}
const kS2 = /* @__PURE__ */ i(HL1, [["render", jL1]]);
var IL1 = {}, bL1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yL1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), DL1 = /* @__PURE__ */ t("path", {
  d: "M17.4996 3L20.9996 6.5M20.9996 6.5L17.4996 10M20.9996 6.5H12.9996M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PL1 = [
  yL1,
  DL1
];
function AL1(r, e) {
  return n(), o("svg", bL1, PL1);
}
const mS2 = /* @__PURE__ */ i(IL1, [["render", AL1]]);
var SL1 = {}, TL1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OL1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), EL1 = /* @__PURE__ */ t("path", {
  d: "M19.9996 10V3M14.9996 10V3M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), RL1 = [
  OL1,
  EL1
];
function UL1(r, e) {
  return n(), o("svg", TL1, RL1);
}
const xS2 = /* @__PURE__ */ i(SL1, [["render", UL1]]);
var NL1 = {}, qL1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zL1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), KL1 = /* @__PURE__ */ t("path", {
  d: "M16.9996 11V3M12.9996 7H20.9996M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GL1 = [
  zL1,
  KL1
];
function WL1(r, e) {
  return n(), o("svg", qL1, GL1);
}
const HS2 = /* @__PURE__ */ i(NL1, [["render", WL1]]);
var YL1 = {}, XL1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QL1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -516)",
  fill: "none"
}, null, -1), JL1 = /* @__PURE__ */ t("path", {
  d: "M20.9996 3L14.9996 9M14.9996 3L20.9996 9M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tk1 = [
  QL1,
  JL1
];
function ek1(r, e) {
  return n(), o("svg", XL1, tk1);
}
const VS2 = /* @__PURE__ */ i(YL1, [["render", ek1]]);
var rk1 = {}, nk1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ok1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -716)",
  fill: "none"
}, null, -1), ik1 = /* @__PURE__ */ t("path", {
  d: "M8.38028 8.85335C9.07627 10.303 10.0251 11.6616 11.2266 12.8632C12.4282 14.0648 13.7869 15.0136 15.2365 15.7096C15.3612 15.7694 15.4235 15.7994 15.5024 15.8224C15.7828 15.9041 16.127 15.8454 16.3644 15.6754C16.4313 15.6275 16.4884 15.5704 16.6027 15.4561C16.9523 15.1064 17.1271 14.9316 17.3029 14.8174C17.9658 14.3864 18.8204 14.3864 19.4833 14.8174C19.6591 14.9316 19.8339 15.1064 20.1835 15.4561L20.3783 15.6509C20.9098 16.1824 21.1755 16.4481 21.3198 16.7335C21.6069 17.301 21.6069 17.9713 21.3198 18.5389C21.1755 18.8242 20.9098 19.09 20.3783 19.6214L20.2207 19.779C19.6911 20.3087 19.4263 20.5735 19.0662 20.7757C18.6667 21.0001 18.0462 21.1615 17.588 21.1601C17.1751 21.1589 16.8928 21.0788 16.3284 20.9186C13.295 20.0576 10.4326 18.4332 8.04466 16.0452C5.65668 13.6572 4.03221 10.7948 3.17124 7.76144C3.01103 7.19699 2.93092 6.91477 2.9297 6.50182C2.92833 6.0436 3.08969 5.42311 3.31411 5.0236C3.51636 4.66357 3.78117 4.39876 4.3108 3.86913L4.46843 3.7115C4.99987 3.18006 5.2656 2.91433 5.55098 2.76999C6.11854 2.48292 6.7888 2.48292 7.35636 2.76999C7.64174 2.91433 7.90747 3.18006 8.43891 3.7115L8.63378 3.90637C8.98338 4.25597 9.15819 4.43078 9.27247 4.60655C9.70347 5.26945 9.70347 6.12403 9.27247 6.78692C9.15819 6.96269 8.98338 7.1375 8.63378 7.4871C8.51947 7.60142 8.46231 7.65857 8.41447 7.72538C8.24446 7.96281 8.18576 8.30707 8.26748 8.58743C8.29048 8.66632 8.32041 8.72866 8.38028 8.85335Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lk1 = [
  ok1,
  ik1
];
function sk1(r, e) {
  return n(), o("svg", nk1, lk1);
}
const ZS2 = /* @__PURE__ */ i(rk1, [["render", sk1]]);
var hk1 = {}, ak1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dk1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-619 -636)",
  fill: "none"
}, null, -1), ck1 = /* @__PURE__ */ t("path", {
  d: "M21.2104 15.8899C20.5742 17.3944 19.5792 18.7202 18.3123 19.7512C17.0454 20.7823 15.5452 21.4874 13.9428 21.8047C12.3405 22.1221 10.6848 22.0421 9.12055 21.5717C7.55627 21.1014 6.13103 20.255 4.96942 19.1066C3.80782 17.9582 2.94522 16.5427 2.45704 14.9839C1.96886 13.4251 1.86996 11.7704 2.169 10.1646C2.46804 8.55873 3.1559 7.05058 4.17245 5.77198C5.189 4.49338 6.50329 3.48327 8.0004 2.82995M21.2392 8.17311C21.6395 9.13958 21.8851 10.1613 21.9684 11.2008C21.989 11.4576 21.9993 11.586 21.9483 11.7017C21.9057 11.7983 21.8213 11.8897 21.7284 11.9399C21.6172 11.9999 21.4783 11.9999 21.2004 11.9999H12.8004C12.5204 11.9999 12.3804 11.9999 12.2734 11.9455C12.1793 11.8975 12.1028 11.821 12.0549 11.7269C12.0004 11.62 12.0004 11.48 12.0004 11.1999V2.79995C12.0004 2.52208 12.0004 2.38315 12.0605 2.27193C12.1107 2.17903 12.2021 2.09464 12.2987 2.05204C12.4144 2.00105 12.5428 2.01134 12.7996 2.03193C13.839 2.11527 14.8608 2.36083 15.8272 2.76115C17.0405 3.2637 18.1429 4.00029 19.0715 4.92888C20.0001 5.85747 20.7367 6.95986 21.2392 8.17311Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _k1 = [
  dk1,
  ck1
];
function Ck1(r, e) {
  return n(), o("svg", ak1, _k1);
}
const BS2 = /* @__PURE__ */ i(hk1, [["render", Ck1]]);
var fk1 = {}, vk1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uk1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-891 -156)",
  fill: "none"
}, null, -1), wk1 = /* @__PURE__ */ t("path", {
  d: "M17.2 14C17.477 14 17.6155 14 17.7278 14.0615C17.8204 14.1122 17.9065 14.2075 17.9478 14.3047C17.9978 14.4225 17.9852 14.5479 17.96 14.7987C17.8296 16.0987 17.3822 17.3514 16.6518 18.4445C15.7727 19.7601 14.5233 20.7855 13.0615 21.391C11.5997 21.9965 9.99113 22.155 8.43928 21.8463C6.88743 21.5376 5.46197 20.7757 4.34315 19.6568C3.22433 18.538 2.4624 17.1126 2.15372 15.5607C1.84504 14.0089 2.00347 12.4003 2.60897 10.9385C3.21447 9.47671 4.23985 8.22728 5.55544 7.34823C6.64856 6.61783 7.90125 6.17039 9.20131 6.03995C9.45207 6.01479 9.57745 6.00221 9.69528 6.0522C9.79249 6.09344 9.88776 6.17964 9.9385 6.27224C10 6.38449 10 6.52299 10 6.79999V13.2C10 13.48 10 13.62 10.0545 13.727C10.1024 13.8211 10.1789 13.8976 10.273 13.9455C10.38 14 10.52 14 10.8 14H17.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pk1 = /* @__PURE__ */ t("path", {
  d: "M14 2.79999C14 2.52298 14 2.38448 14.0615 2.27223C14.1122 2.17963 14.2075 2.09344 14.3047 2.0522C14.4225 2.0022 14.5479 2.01478 14.7987 2.03993C16.6271 2.22333 18.346 3.03229 19.6569 4.34313C20.9677 5.65398 21.7767 7.37289 21.9601 9.20129C21.9852 9.45206 21.9978 9.57744 21.9478 9.69527C21.9066 9.79248 21.8204 9.88774 21.7278 9.93848C21.6155 9.99998 21.477 9.99999 21.2 9.99999L14.8 9.99999C14.52 9.99999 14.38 9.99999 14.273 9.94549C14.1789 9.89755 14.1024 9.82106 14.0545 9.72698C14 9.62003 14 9.48001 14 9.19999V2.79999Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), gk1 = [
  uk1,
  wk1,
  pk1
];
function $k1(r, e) {
  return n(), o("svg", vk1, gk1);
}
const FS2 = /* @__PURE__ */ i(fk1, [["render", $k1]]);
var Mk1 = {}, Lk1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kk1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-891 -196)",
  fill: "none"
}, null, -1), mk1 = /* @__PURE__ */ t("path", {
  d: "M12 2C13.3132 2 14.6136 2.25866 15.8268 2.76121C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7363 6.95991 21.2388 8.17317C21.7413 9.38643 22 10.6868 22 12M12 2V12M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5229 22 12M12 2C17.5228 2 22 6.47716 22 12M22 12L12 12M22 12C22 13.5781 21.6265 15.1338 20.9101 16.5399C20.1936 17.946 19.1546 19.1626 17.8779 20.0902L12 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), xk1 = [
  kk1,
  mk1
];
function Hk1(r, e) {
  return n(), o("svg", Lk1, xk1);
}
const jS2 = /* @__PURE__ */ i(Mk1, [["render", Hk1]]);
var Vk1 = {}, Zk1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bk1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-891 -236)",
  fill: "none"
}, null, -1), Fk1 = /* @__PURE__ */ t("path", {
  d: "M12 12L2.33178 9.44554C1.70974 11.7999 1.96813 14.3002 3.05847 16.4776C4.14881 18.6549 5.99616 20.3596 8.25395 21.2718L12 12ZM12 12L12.1047 2.00055C9.88558 1.97731 7.72174 2.69293 5.95402 4.0347C4.1863 5.37647 2.91514 7.26815 2.34075 9.41181L12 12ZM22 12C22 17.5228 17.5229 22 12 22C6.47716 22 2.00001 17.5228 2.00001 12C2.00001 6.47715 6.47716 2 12 2C17.5229 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), jk1 = [
  Bk1,
  Fk1
];
function Ik1(r, e) {
  return n(), o("svg", Zk1, jk1);
}
const IS2 = /* @__PURE__ */ i(Vk1, [["render", Ik1]]);
var bk1 = {}, yk1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Dk1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -716)",
  fill: "none"
}, null, -1), Pk1 = /* @__PURE__ */ t("path", {
  d: "M4.99993 13C4.99993 14.6484 5.66466 16.1415 6.74067 17.226C6.84445 17.3305 6.89633 17.3828 6.92696 17.4331C6.95619 17.4811 6.9732 17.5224 6.98625 17.5771C6.99993 17.6343 6.99993 17.6995 6.99993 17.8298V20.2C6.99993 20.48 6.99993 20.62 7.05443 20.727C7.10236 20.8211 7.17885 20.8976 7.27293 20.9455C7.37989 21 7.5199 21 7.79993 21H9.69993C9.97996 21 10.12 21 10.2269 20.9455C10.321 20.8976 10.3975 20.8211 10.4454 20.727C10.4999 20.62 10.4999 20.48 10.4999 20.2V19.8C10.4999 19.52 10.4999 19.38 10.5544 19.273C10.6024 19.1789 10.6789 19.1024 10.7729 19.0545C10.8799 19 11.0199 19 11.2999 19H12.6999C12.98 19 13.12 19 13.2269 19.0545C13.321 19.1024 13.3975 19.1789 13.4454 19.273C13.4999 19.38 13.4999 19.52 13.4999 19.8V20.2C13.4999 20.48 13.4999 20.62 13.5544 20.727C13.6024 20.8211 13.6789 20.8976 13.7729 20.9455C13.8799 21 14.0199 21 14.2999 21H16.2C16.48 21 16.62 21 16.727 20.9455C16.8211 20.8976 16.8976 20.8211 16.9455 20.727C17 20.62 17 20.48 17 20.2V19.2243C17 19.0223 17 18.9212 17.0288 18.8401C17.0563 18.7624 17.0911 18.708 17.15 18.6502C17.2114 18.59 17.3155 18.5417 17.5237 18.445C18.5059 17.989 19.344 17.2751 19.9511 16.3902C20.0579 16.2346 20.1112 16.1568 20.1683 16.1108C20.2228 16.0668 20.2717 16.0411 20.3387 16.021C20.4089 16 20.4922 16 20.6587 16H21.2C21.48 16 21.62 16 21.727 15.9455C21.8211 15.8976 21.8976 15.8211 21.9455 15.727C22 15.62 22 15.48 22 15.2V11.7857C22 11.5192 22 11.3859 21.9505 11.283C21.9013 11.181 21.819 11.0987 21.717 11.0495C21.6141 11 21.4808 11 21.2143 11C21.0213 11 20.9248 11 20.8471 10.9738C20.7633 10.9456 20.7045 10.908 20.6437 10.8438C20.5874 10.7842 20.5413 10.6846 20.4493 10.4855C20.1538 9.84622 19.7492 9.26777 19.2593 8.77404C19.1555 8.66945 19.1036 8.61716 19.073 8.56687C19.0437 8.51889 19.0267 8.47759 19.0137 8.42294C19 8.36567 19 8.30051 19 8.17018V7.06058C19 6.70053 19 6.52051 18.925 6.39951C18.8593 6.29351 18.7564 6.21588 18.6365 6.18184C18.4995 6.14299 18.3264 6.19245 17.9802 6.29136L15.6077 6.96922C15.5673 6.98074 15.5472 6.9865 15.5267 6.99054C15.5085 6.99414 15.4901 6.99671 15.4716 6.99826C15.4508 7 15.4298 7 15.3879 7H14.959M4.99993 13C4.99993 10.6959 6.29864 8.6952 8.20397 7.6899M4.99993 13H4C2.89543 13 2 12.1046 2 11C2 10.2597 2.4022 9.61337 3 9.26756M15 6.5C15 8.433 13.433 10 11.5 10C9.567 10 8 8.433 8 6.5C8 4.567 9.567 3 11.5 3C13.433 3 15 4.567 15 6.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ak1 = [
  Dk1,
  Pk1
];
function Sk1(r, e) {
  return n(), o("svg", yk1, Ak1);
}
const bS2 = /* @__PURE__ */ i(bk1, [["render", Sk1]]);
var Tk1 = {}, Ok1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ek1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -756)",
  fill: "none"
}, null, -1), Rk1 = /* @__PURE__ */ t("path", {
  d: "M4.99993 13C4.99993 9.68629 7.68622 7 10.9999 7M4.99993 13C4.99993 14.6484 5.66466 16.1415 6.74067 17.226C6.84445 17.3305 6.89633 17.3828 6.92696 17.4331C6.95619 17.4811 6.9732 17.5224 6.98625 17.5771C6.99993 17.6343 6.99993 17.6995 6.99993 17.8298V20.2C6.99993 20.48 6.99993 20.62 7.05443 20.727C7.10236 20.8211 7.17885 20.8976 7.27293 20.9455C7.37989 21 7.5199 21 7.79993 21H9.69993C9.97996 21 10.12 21 10.2269 20.9455C10.321 20.8976 10.3975 20.8211 10.4454 20.727C10.4999 20.62 10.4999 20.48 10.4999 20.2V19.8C10.4999 19.52 10.4999 19.38 10.5544 19.273C10.6024 19.1789 10.6789 19.1024 10.7729 19.0545C10.8799 19 11.0199 19 11.2999 19H12.6999C12.98 19 13.12 19 13.2269 19.0545C13.321 19.1024 13.3975 19.1789 13.4454 19.273C13.4999 19.38 13.4999 19.52 13.4999 19.8V20.2C13.4999 20.48 13.4999 20.62 13.5544 20.727C13.6024 20.8211 13.6789 20.8976 13.7729 20.9455C13.8799 21 14.0199 21 14.2999 21H16.2C16.48 21 16.62 21 16.727 20.9455C16.8211 20.8976 16.8976 20.8211 16.9455 20.727C17 20.62 17 20.48 17 20.2V19.2243C17 19.0223 17 18.9212 17.0288 18.8401C17.0563 18.7624 17.0911 18.708 17.15 18.6502C17.2114 18.59 17.3155 18.5417 17.5237 18.445C18.5059 17.989 19.344 17.2751 19.9511 16.3902C20.0579 16.2346 20.1112 16.1568 20.1683 16.1108C20.2228 16.0668 20.2717 16.0411 20.3387 16.021C20.4089 16 20.4922 16 20.6587 16H21.2C21.48 16 21.62 16 21.727 15.9455C21.8211 15.8976 21.8976 15.8211 21.9455 15.727C22 15.62 22 15.48 22 15.2V11.7857C22 11.5192 22 11.3859 21.9505 11.283C21.9013 11.181 21.819 11.0987 21.717 11.0495C21.6141 11 21.4808 11 21.2143 11C21.0213 11 20.9248 11 20.8471 10.9738C20.7633 10.9456 20.7045 10.908 20.6437 10.8438C20.5874 10.7842 20.5413 10.6846 20.4493 10.4855C20.1538 9.84622 19.7492 9.26777 19.2593 8.77404C19.1555 8.66945 19.1036 8.61716 19.073 8.56687C19.0437 8.51889 19.0267 8.47759 19.0137 8.42294C19 8.36567 19 8.30051 19 8.17018V7.06058C19 6.70053 19 6.52051 18.925 6.39951C18.8593 6.29351 18.7564 6.21588 18.6365 6.18184C18.4995 6.14299 18.3264 6.19245 17.9802 6.29136L15.6077 6.96922C15.5673 6.98074 15.5472 6.9865 15.5267 6.99054C15.5085 6.99414 15.4901 6.99671 15.4716 6.99826C15.4508 7 15.4297 7 15.3874 7H10.9999M4.99993 13H4C2.89543 13 2 12.1046 2 11C2 10.2597 2.4022 9.61337 3 9.26756M10.9999 7H14.9646C14.9879 6.8367 15 6.66976 15 6.5C15 4.567 13.433 3 11.5 3C9.567 3 8 4.567 8 6.5C8 6.9172 8.073 7.31736 8.20692 7.68839C9.04114 7.24881 9.99144 7 10.9999 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Uk1 = [
  Ek1,
  Rk1
];
function Nk1(r, e) {
  return n(), o("svg", Ok1, Uk1);
}
const yS2 = /* @__PURE__ */ i(Tk1, [["render", Nk1]]);
var qk1 = {}, zk1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Kk1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -956)",
  fill: "none"
}, null, -1), Gk1 = /* @__PURE__ */ t("path", {
  d: "M16 4V20M16 4H18M16 4H10.5C8.01472 4 6 6.01472 6 8.5C6 10.9853 8.01472 13 10.5 13H16V4ZM14 20H18",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Wk1 = [
  Kk1,
  Gk1
];
function Yk1(r, e) {
  return n(), o("svg", zk1, Wk1);
}
const DS2 = /* @__PURE__ */ i(qk1, [["render", Yk1]]);
var Xk1 = {}, Qk1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jk1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -996)",
  fill: "none"
}, null, -1), tm1 = /* @__PURE__ */ t("path", {
  d: "M17.5 4V20M19.5 4H9C6.79086 4 5 5.79086 5 8C5 10.2091 6.79086 12 9 12H14M14 4V20M12 20H19.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), em1 = [
  Jk1,
  tm1
];
function rm1(r, e) {
  return n(), o("svg", Qk1, em1);
}
const PS2 = /* @__PURE__ */ i(Xk1, [["render", rm1]]);
var nm1 = {}, om1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, im1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -1036)",
  fill: "none"
}, null, -1), lm1 = /* @__PURE__ */ t("path", {
  d: "M15 17V7H11C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), sm1 = [
  im1,
  lm1
];
function hm1(r, e) {
  return n(), o("svg", om1, sm1);
}
const AS2 = /* @__PURE__ */ i(nm1, [["render", hm1]]);
var am1 = {}, dm1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cm1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1276)",
  fill: "none"
}, null, -1), _m1 = /* @__PURE__ */ t("path", {
  d: "M12.0004 15L12.0004 22M8.00043 7.30813V9.43875C8.00043 9.64677 8.00043 9.75078 7.98001 9.85026C7.9619 9.93852 7.93194 10.0239 7.89095 10.1042C7.84474 10.1946 7.77977 10.2758 7.64982 10.4383L6.08004 12.4005C5.4143 13.2327 5.08143 13.6487 5.08106 13.9989C5.08073 14.3035 5.21919 14.5916 5.4572 14.7815C5.73088 15 6.26373 15 7.32943 15H16.6714C17.7371 15 18.27 15 18.5437 14.7815C18.7817 14.5916 18.9201 14.3035 18.9198 13.9989C18.9194 13.6487 18.5866 13.2327 17.9208 12.4005L16.351 10.4383C16.2211 10.2758 16.1561 10.1946 16.1099 10.1042C16.0689 10.0239 16.039 9.93852 16.0208 9.85026C16.0004 9.75078 16.0004 9.64677 16.0004 9.43875V7.30813C16.0004 7.19301 16.0004 7.13544 16.0069 7.07868C16.0127 7.02825 16.0223 6.97833 16.0357 6.92937C16.0507 6.87424 16.0721 6.8208 16.1149 6.71391L17.1227 4.19423C17.4168 3.45914 17.5638 3.09159 17.5025 2.79655C17.4489 2.53853 17.2956 2.31211 17.0759 2.1665C16.8247 2 16.4289 2 15.6372 2H8.36368C7.57197 2 7.17611 2 6.92494 2.1665C6.70529 2.31211 6.55199 2.53853 6.49838 2.79655C6.43707 3.09159 6.58408 3.45914 6.87812 4.19423L7.88599 6.71391C7.92875 6.8208 7.95013 6.87424 7.96517 6.92937C7.97853 6.97833 7.98814 7.02825 7.99392 7.07868C8.00043 7.13544 8.00043 7.19301 8.00043 7.30813Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Cm1 = [
  cm1,
  _m1
];
function fm1(r, e) {
  return n(), o("svg", dm1, Cm1);
}
const SS2 = /* @__PURE__ */ i(am1, [["render", fm1]]);
var vm1 = {}, um1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wm1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1316)",
  fill: "none"
}, null, -1), pm1 = /* @__PURE__ */ t("path", {
  d: "M8.3767 15.6163L2.71985 21.2732M11.6944 6.64181L10.1335 8.2027C10.0062 8.33003 9.94252 8.39369 9.86999 8.44427C9.80561 8.48917 9.73616 8.52634 9.66309 8.555C9.58077 8.58729 9.49249 8.60495 9.31592 8.64026L5.65145 9.37315C4.69915 9.56361 4.223 9.65884 4.00024 9.9099C3.80617 10.1286 3.71755 10.4213 3.75771 10.7109C3.8038 11.0434 4.14715 11.3867 4.83387 12.0735L11.9196 19.1592C12.6063 19.8459 12.9497 20.1893 13.2821 20.2354C13.5718 20.2755 13.8645 20.1869 14.0832 19.9928C14.3342 19.7701 14.4294 19.2939 14.6199 18.3416L15.3528 14.6771C15.3881 14.5006 15.4058 14.4123 15.4381 14.33C15.4667 14.2569 15.5039 14.1875 15.5488 14.1231C15.5994 14.0505 15.663 13.9869 15.7904 13.8596L17.3512 12.2987C17.4326 12.2173 17.4734 12.1766 17.5181 12.141C17.5578 12.1095 17.5999 12.081 17.644 12.0558C17.6936 12.0274 17.7465 12.0048 17.8523 11.9594L20.3467 10.8904C21.0744 10.5785 21.4383 10.4226 21.6035 10.1706C21.7481 9.95025 21.7998 9.68175 21.7474 9.42348C21.6875 9.12813 21.4076 8.84822 20.8478 8.28839L15.7047 3.14526C15.1448 2.58543 14.8649 2.30552 14.5696 2.24565C14.3113 2.19329 14.0428 2.245 13.8225 2.38953C13.5705 2.55481 13.4145 2.91866 13.1027 3.64636L12.0337 6.14071C11.9883 6.24653 11.9656 6.29944 11.9373 6.34905C11.9121 6.39313 11.8836 6.43522 11.852 6.47496C11.8165 6.51971 11.7758 6.56041 11.6944 6.64181Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), gm1 = [
  wm1,
  pm1
];
function $m1(r, e) {
  return n(), o("svg", um1, gm1);
}
const TS2 = /* @__PURE__ */ i(vm1, [["render", $m1]]);
var Mm1 = {}, Lm1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, km1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1356)",
  fill: "none"
}, null, -1), mm1 = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), xm1 = [
  km1,
  mm1
];
function Hm1(r, e) {
  return n(), o("svg", Lm1, xm1);
}
const OS2 = /* @__PURE__ */ i(Mm1, [["render", Hm1]]);
var Vm1 = {}, Zm1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bm1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), Fm1 = /* @__PURE__ */ t("path", {
  d: "M17.7448 2.81298C18.7095 1.8165 20.3036 1.80361 21.2843 2.78436C22.2382 3.73823 22.2559 5.27921 21.3243 6.25481L18.5456 9.16457C18.3278 9.39265 18.219 9.50668 18.1518 9.64024C18.0924 9.75847 18.0571 9.88732 18.0478 10.0193C18.0374 10.1684 18.0728 10.3221 18.1438 10.6293L19.8717 18.1169C19.9444 18.4323 19.9808 18.59 19.9691 18.7426C19.9587 18.8776 19.921 19.0091 19.8582 19.1291C19.7873 19.2647 19.6729 19.3792 19.444 19.608L19.0732 19.9788C18.4671 20.585 18.164 20.888 17.8538 20.9429C17.583 20.9908 17.3043 20.925 17.0835 20.761C16.8306 20.5733 16.695 20.1666 16.424 19.3534L14.4142 13.3241L11.0689 16.6695C10.8692 16.8691 10.7694 16.969 10.7026 17.0866C10.6434 17.1907 10.6034 17.3047 10.5846 17.423C10.5633 17.5565 10.5789 17.6968 10.61 17.9775L10.7937 19.6309C10.8249 19.9116 10.8405 20.0519 10.8192 20.1854C10.8004 20.3037 10.7604 20.4177 10.7012 20.5219C10.6344 20.6394 10.5346 20.7393 10.3349 20.939L10.1374 21.1365C9.66434 21.6095 9.42781 21.8461 9.16496 21.9146C8.93442 21.9746 8.68999 21.9504 8.47571 21.8463C8.2314 21.7276 8.04585 21.4493 7.67475 20.8926L6.10643 18.5401C6.04013 18.4407 6.00698 18.391 5.96849 18.3459C5.9343 18.3058 5.89701 18.2685 5.85694 18.2343C5.81184 18.1958 5.76212 18.1627 5.66267 18.0964L3.31018 16.5281C2.75354 16.157 2.47521 15.9714 2.35649 15.7271C2.25236 15.5128 2.22816 15.2684 2.28824 15.0378C2.35674 14.775 2.59327 14.5385 3.06633 14.0654L3.26384 13.8679C3.46352 13.6682 3.56337 13.5684 3.68095 13.5016C3.78511 13.4424 3.89906 13.4024 4.01736 13.3836C4.15089 13.3623 4.29123 13.3779 4.5719 13.4091L6.22529 13.5928C6.50596 13.6239 6.6463 13.6395 6.77983 13.6182C6.89813 13.5994 7.01208 13.5594 7.11624 13.5002C7.23382 13.4334 7.33366 13.3336 7.53335 13.1339L10.8787 9.7886L4.84939 7.77884C4.03616 7.50776 3.62955 7.37222 3.44176 7.11932C3.27777 6.89848 3.212 6.61984 3.2599 6.34898C3.31477 6.03879 3.61784 5.73572 4.22399 5.12957L4.59476 4.7588C4.82365 4.52991 4.9381 4.41546 5.07369 4.34457C5.1937 4.28183 5.3252 4.24411 5.46023 4.23371C5.61278 4.22197 5.77049 4.25836 6.0859 4.33115L13.545 6.05249C13.855 6.12401 14.01 6.15978 14.1596 6.14914C14.3041 6.13886 14.4446 6.09733 14.5714 6.02742C14.7028 5.95501 14.8134 5.84074 15.0347 5.6122L17.7448 2.81298Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), jm1 = [
  Bm1,
  Fm1
];
function Im1(r, e) {
  return n(), o("svg", Zm1, jm1);
}
const ES2 = /* @__PURE__ */ i(Vm1, [["render", Im1]]);
var bm1 = {}, ym1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Dm1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), Pm1 = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Am1 = /* @__PURE__ */ t("path", {
  d: "M9.5 8.96533C9.5 8.48805 9.5 8.24941 9.59974 8.11618C9.68666 8.00007 9.81971 7.92744 9.96438 7.9171C10.1304 7.90525 10.3311 8.03429 10.7326 8.29239L15.4532 11.3271C15.8016 11.551 15.9758 11.663 16.0359 11.8054C16.0885 11.9298 16.0885 12.0702 16.0359 12.1946C15.9758 12.337 15.8016 12.449 15.4532 12.6729L10.7326 15.7076C10.3311 15.9657 10.1304 16.0948 9.96438 16.0829C9.81971 16.0726 9.68666 15.9999 9.59974 15.8838C9.5 15.7506 9.5 15.512 9.5 15.0347V8.96533Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Sm1 = [
  Dm1,
  Pm1,
  Am1
];
function Tm1(r, e) {
  return n(), o("svg", ym1, Sm1);
}
const RS2 = /* @__PURE__ */ i(bm1, [["render", Tm1]]);
var Om1 = {}, Em1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rm1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), Um1 = /* @__PURE__ */ t("path", {
  d: "M9.5 8.96533C9.5 8.48805 9.5 8.24941 9.59974 8.11618C9.68666 8.00007 9.81971 7.92744 9.96438 7.9171C10.1304 7.90525 10.3311 8.03429 10.7326 8.29239L15.4532 11.3271C15.8016 11.551 15.9758 11.663 16.0359 11.8054C16.0885 11.9298 16.0885 12.0702 16.0359 12.1946C15.9758 12.337 15.8016 12.449 15.4532 12.6729L10.7326 15.7076C10.3311 15.9657 10.1304 16.0948 9.96438 16.0829C9.81971 16.0726 9.68666 15.9999 9.59974 15.8838C9.5 15.7506 9.5 15.512 9.5 15.0347V8.96533Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Nm1 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qm1 = [
  Rm1,
  Um1,
  Nm1
];
function zm1(r, e) {
  return n(), o("svg", Em1, qm1);
}
const US2 = /* @__PURE__ */ i(Om1, [["render", zm1]]);
var Km1 = {}, Gm1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wm1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), Ym1 = /* @__PURE__ */ t("path", {
  d: "M5 4.98951C5 4.01835 5 3.53277 5.20249 3.2651C5.37889 3.03191 5.64852 2.88761 5.9404 2.87018C6.27544 2.85017 6.67946 3.11953 7.48752 3.65823L18.0031 10.6686C18.6708 11.1137 19.0046 11.3363 19.1209 11.6168C19.2227 11.8621 19.2227 12.1377 19.1209 12.383C19.0046 12.6635 18.6708 12.886 18.0031 13.3312L7.48752 20.3415C6.67946 20.8802 6.27544 21.1496 5.9404 21.1296C5.64852 21.1122 5.37889 20.9679 5.20249 20.7347C5 20.467 5 19.9814 5 19.0103V4.98951Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Xm1 = [
  Wm1,
  Ym1
];
function Qm1(r, e) {
  return n(), o("svg", Gm1, Xm1);
}
const NS2 = /* @__PURE__ */ i(Km1, [["render", Qm1]]);
var Jm1 = {}, tx1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ex1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1436)",
  fill: "none"
}, null, -1), rx1 = /* @__PURE__ */ t("path", {
  d: "M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nx1 = [
  ex1,
  rx1
];
function ox1(r, e) {
  return n(), o("svg", tx1, nx1);
}
const ix1 = /* @__PURE__ */ i(Jm1, [["render", ox1]]);
var lx1 = {}, sx1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hx1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1476)",
  fill: "none"
}, null, -1), ax1 = /* @__PURE__ */ t("path", {
  d: "M12 8V16M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dx1 = [
  hx1,
  ax1
];
function cx1(r, e) {
  return n(), o("svg", sx1, dx1);
}
const qS2 = /* @__PURE__ */ i(lx1, [["render", cx1]]);
var _x1 = {}, Cx1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fx1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1396)",
  fill: "none"
}, null, -1), vx1 = /* @__PURE__ */ t("path", {
  d: "M12 5V19M5 12H19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ux1 = [
  fx1,
  vx1
];
function wx1(r, e) {
  return n(), o("svg", Cx1, ux1);
}
const zS2 = /* @__PURE__ */ i(_x1, [["render", wx1]]);
var px1 = {}, gx1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $x1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), Mx1 = /* @__PURE__ */ t("path", {
  d: "M17.1189 18C19.4623 16.4151 21 13.7779 21 10.785C21 5.9333 16.9704 2 12 2C7.02958 2 3 5.9333 3 10.785C3 13.7779 4.53771 16.4151 6.88113 18M8.35967 14C7.51875 13.15 7 12.0086 7 10.7505C7 8.12711 9.23881 6 12 6C14.7612 6 17 8.12711 17 10.7505C17 12.0095 16.4813 13.15 15.6403 14M12 22C10.8954 22 10 21.1046 10 20V18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18V20C14 21.1046 13.1046 22 12 22ZM13 11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Lx1 = [
  $x1,
  Mx1
];
function kx1(r, e) {
  return n(), o("svg", gx1, Lx1);
}
const KS2 = /* @__PURE__ */ i(px1, [["render", kx1]]);
var mx1 = {}, xx1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hx1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), Vx1 = /* @__PURE__ */ t("path", {
  d: "M12.0001 2V12M18.3601 6.64C19.6185 7.89879 20.4754 9.50244 20.8224 11.2482C21.1694 12.9939 20.991 14.8034 20.3098 16.4478C19.6285 18.0921 18.4749 19.4976 16.9949 20.4864C15.515 21.4752 13.775 22.0029 11.9951 22.0029C10.2152 22.0029 8.47527 21.4752 6.99529 20.4864C5.51532 19.4976 4.36176 18.0921 3.68049 16.4478C2.99921 14.8034 2.82081 12.9939 3.16784 11.2482C3.51487 9.50244 4.37174 7.89879 5.63012 6.64",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zx1 = [
  Hx1,
  Vx1
];
function Bx1(r, e) {
  return n(), o("svg", xx1, Zx1);
}
const GS2 = /* @__PURE__ */ i(mx1, [["render", Bx1]]);
var Fx1 = {}, jx1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ix1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), bx1 = /* @__PURE__ */ t("path", {
  d: "M12 7V12M8 8.99951C7.37209 9.83526 7 10.8742 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 10.8742 16.6279 9.83526 16 8.99951M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yx1 = [
  Ix1,
  bx1
];
function Dx1(r, e) {
  return n(), o("svg", jx1, yx1);
}
const WS2 = /* @__PURE__ */ i(Fx1, [["render", Dx1]]);
var Px1 = {}, Ax1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sx1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), Tx1 = /* @__PURE__ */ t("path", {
  d: "M12 7V17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ox1 = [
  Sx1,
  Tx1
];
function Ex1(r, e) {
  return n(), o("svg", Ax1, Ox1);
}
const YS2 = /* @__PURE__ */ i(Px1, [["render", Ex1]]);
var Rx1 = {}, Ux1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nx1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-891 -276)",
  fill: "none"
}, null, -1), qx1 = /* @__PURE__ */ t("path", {
  d: "M12 16V21M12 16L18 21M12 16L6 21M21 3V11.2C21 12.8802 21 13.7202 20.673 14.362C20.3854 14.9265 19.9265 15.3854 19.362 15.673C18.7202 16 17.8802 16 16.2 16H7.8C6.11984 16 5.27976 16 4.63803 15.673C4.07354 15.3854 3.6146 14.9265 3.32698 14.362C3 13.7202 3 12.8802 3 11.2V3M8 9V12M12 7V12M16 11V12M22 3H2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zx1 = [
  Nx1,
  qx1
];
function Kx1(r, e) {
  return n(), o("svg", Ux1, zx1);
}
const XS2 = /* @__PURE__ */ i(Rx1, [["render", Kx1]]);
var Gx1 = {}, Wx1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yx1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-891 -316)",
  fill: "none"
}, null, -1), Xx1 = /* @__PURE__ */ t("path", {
  d: "M12 16V21M18 21L14.0486 17.7072C13.3198 17.0998 12.9554 16.7962 12.5487 16.6801C12.19 16.5778 11.81 16.5778 11.4513 16.6801C11.0446 16.7962 10.6802 17.0998 9.95141 17.7072L6 21M8 11V12M12 9V12M16 7V12M22 3H2M3 3H21V11.2C21 12.8802 21 13.7202 20.673 14.362C20.3854 14.9265 19.9265 15.3854 19.362 15.673C18.7202 16 17.8802 16 16.2 16H7.8C6.11984 16 5.27976 16 4.63803 15.673C4.07354 15.3854 3.6146 14.9265 3.32698 14.362C3 13.7202 3 12.8802 3 11.2V3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qx1 = [
  Yx1,
  Xx1
];
function Jx1(r, e) {
  return n(), o("svg", Wx1, Qx1);
}
const QS2 = /* @__PURE__ */ i(Gx1, [["render", Jx1]]);
var tH1 = {}, eH1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rH1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-891 -356)",
  fill: "none"
}, null, -1), nH1 = /* @__PURE__ */ t("path", {
  d: "M12 16V21M12 16L18 21M12 16L6 21M8 7V12M12 9V12M16 11V12M22 3H2M3 3H21V11.2C21 12.8802 21 13.7202 20.673 14.362C20.3854 14.9265 19.9265 15.3854 19.362 15.673C18.7202 16 17.8802 16 16.2 16H7.8C6.11984 16 5.27976 16 4.63803 15.673C4.07354 15.3854 3.6146 14.9265 3.32698 14.362C3 13.7202 3 12.8802 3 11.2V3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oH1 = [
  rH1,
  nH1
];
function iH1(r, e) {
  return n(), o("svg", eH1, oH1);
}
const JS2 = /* @__PURE__ */ i(tH1, [["render", iH1]]);
var lH1 = {}, sH1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hH1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), aH1 = /* @__PURE__ */ t("path", {
  d: "M18 7V5.2C18 4.0799 18 3.51984 17.782 3.09202C17.5903 2.71569 17.2843 2.40973 16.908 2.21799C16.4802 2 15.9201 2 14.8 2H9.2C8.0799 2 7.51984 2 7.09202 2.21799C6.71569 2.40973 6.40973 2.71569 6.21799 3.09202C6 3.51984 6 4.0799 6 5.2V7M6 18C5.07003 18 4.60504 18 4.22354 17.8978C3.18827 17.6204 2.37962 16.8117 2.10222 15.7765C2 15.395 2 14.93 2 14V11.8C2 10.1198 2 9.27976 2.32698 8.63803C2.6146 8.07354 3.07354 7.6146 3.63803 7.32698C4.27976 7 5.11984 7 6.8 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V14C22 14.93 22 15.395 21.8978 15.7765C21.6204 16.8117 20.8117 17.6204 19.7765 17.8978C19.395 18 18.93 18 18 18M15 10.5H18M9.2 22H14.8C15.9201 22 16.4802 22 16.908 21.782C17.2843 21.5903 17.5903 21.2843 17.782 20.908C18 20.4802 18 19.9201 18 18.8V17.2C18 16.0799 18 15.5198 17.782 15.092C17.5903 14.7157 17.2843 14.4097 16.908 14.218C16.4802 14 15.9201 14 14.8 14H9.2C8.0799 14 7.51984 14 7.09202 14.218C6.71569 14.4097 6.40973 14.7157 6.21799 15.092C6 15.5198 6 16.0799 6 17.2V18.8C6 19.9201 6 20.4802 6.21799 20.908C6.40973 21.2843 6.71569 21.5903 7.09202 21.782C7.51984 22 8.07989 22 9.2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dH1 = [
  hH1,
  aH1
];
function cH1(r, e) {
  return n(), o("svg", sH1, dH1);
}
const tT2 = /* @__PURE__ */ i(lH1, [["render", cH1]]);
var _H1 = {}, CH1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fH1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -636)",
  fill: "none"
}, null, -1), vH1 = /* @__PURE__ */ t("path", {
  d: "M7.5 4.5C7.5 3.11929 8.61929 2 10 2C11.3807 2 12.5 3.11929 12.5 4.5V6H13.5C14.8978 6 15.5967 6 16.1481 6.22836C16.8831 6.53284 17.4672 7.11687 17.7716 7.85195C18 8.40326 18 9.10218 18 10.5H19.5C20.8807 10.5 22 11.6193 22 13C22 14.3807 20.8807 15.5 19.5 15.5H18V17.2C18 18.8802 18 19.7202 17.673 20.362C17.3854 20.9265 16.9265 21.3854 16.362 21.673C15.7202 22 14.8802 22 13.2 22H12.5V20.25C12.5 19.0074 11.4926 18 10.25 18C9.00736 18 8 19.0074 8 20.25V22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V15.5H3.5C4.88071 15.5 6 14.3807 6 13C6 11.6193 4.88071 10.5 3.5 10.5H2C2 9.10218 2 8.40326 2.22836 7.85195C2.53284 7.11687 3.11687 6.53284 3.85195 6.22836C4.40326 6 5.10218 6 6.5 6H7.5V4.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uH1 = [
  fH1,
  vH1
];
function wH1(r, e) {
  return n(), o("svg", CH1, uH1);
}
const eT2 = /* @__PURE__ */ i(_H1, [["render", wH1]]);
var pH1 = {}, gH1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $H1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -676)",
  fill: "none"
}, null, -1), MH1 = /* @__PURE__ */ t("path", {
  d: "M12 2L15.6 5.6C18 -0.7 24.7 6 18.4 8.4L22 12L18.4 15.6C16 9.3 9.3 16 15.6 18.4L12 22L8.4 18.4C6 24.7 -0.7 18 5.6 15.6L2 12L5.6 8.4C8 14.7 14.7 8 8.4 5.6L12 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), LH1 = [
  $H1,
  MH1
];
function kH1(r, e) {
  return n(), o("svg", gH1, LH1);
}
const rT2 = /* @__PURE__ */ i(pH1, [["render", kH1]]);
var mH1 = {}, xH1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HH1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-608 -716)",
  fill: "none"
}, null, -1), VH1 = /* @__PURE__ */ t("path", {
  d: "M7 12H12V17M3.01 12H3M8.01 17H8M12.01 21H12M21.01 12H21M3 17H4.5M15.5 12H17.5M3 21H8M12 2V8M17.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V17.6C21 17.0399 21 16.7599 20.891 16.546C20.7951 16.3578 20.6422 16.2049 20.454 16.109C20.2401 16 19.9601 16 19.4 16H17.6C17.0399 16 16.7599 16 16.546 16.109C16.3578 16.2049 16.2049 16.3578 16.109 16.546C16 16.7599 16 17.0399 16 17.6V19.4C16 19.9601 16 20.2401 16.109 20.454C16.2049 20.6422 16.3578 20.7951 16.546 20.891C16.7599 21 17.0399 21 17.6 21ZM17.6 8H19.4C19.9601 8 20.2401 8 20.454 7.89101C20.6422 7.79513 20.7951 7.64215 20.891 7.45399C21 7.24008 21 6.96005 21 6.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H17.6C17.0399 3 16.7599 3 16.546 3.10899C16.3578 3.20487 16.2049 3.35785 16.109 3.54601C16 3.75992 16 4.03995 16 4.6V6.4C16 6.96005 16 7.24008 16.109 7.45399C16.2049 7.64215 16.3578 7.79513 16.546 7.89101C16.7599 8 17.0399 8 17.6 8ZM4.6 8H6.4C6.96005 8 7.24008 8 7.45399 7.89101C7.64215 7.79513 7.79513 7.64215 7.89101 7.45399C8 7.24008 8 6.96005 8 6.4V4.6C8 4.03995 8 3.75992 7.89101 3.54601C7.79513 3.35785 7.64215 3.20487 7.45399 3.10899C7.24008 3 6.96005 3 6.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V6.4C3 6.96005 3 7.24008 3.10899 7.45399C3.20487 7.64215 3.35785 7.79513 3.54601 7.89101C3.75992 8 4.03995 8 4.6 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ZH1 = [
  HH1,
  VH1
];
function BH1(r, e) {
  return n(), o("svg", xH1, ZH1);
}
const nT2 = /* @__PURE__ */ i(mH1, [["render", BH1]]);
var FH1 = {}, jH1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, IH1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), bH1 = /* @__PURE__ */ t("path", {
  d: "M6.5 6.5H6.51M17.5 6.5H17.51M6.5 17.5H6.51M13 13H13.01M17.5 17.5H17.51M17 21H21V17M14 16.5V21M21 14H16.5M15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10ZM4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10ZM4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yH1 = [
  IH1,
  bH1
];
function DH1(r, e) {
  return n(), o("svg", jH1, yH1);
}
const oT2 = /* @__PURE__ */ i(FH1, [["render", DH1]]);
var PH1 = {}, AH1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, SH1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -836)",
  fill: "none"
}, null, -1), TH1 = /* @__PURE__ */ t("path", {
  d: "M9 10.5L11 12.5L15.5 8M20 21V7.8C20 6.11984 20 5.27976 19.673 4.63803C19.3854 4.07354 18.9265 3.6146 18.362 3.32698C17.7202 3 16.8802 3 15.2 3H8.8C7.11984 3 6.27976 3 5.63803 3.32698C5.07354 3.6146 4.6146 4.07354 4.32698 4.63803C4 5.27976 4 6.11984 4 7.8V21L6.75 19L9.25 21L12 19L14.75 21L17.25 19L20 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), OH1 = [
  SH1,
  TH1
];
function EH1(r, e) {
  return n(), o("svg", AH1, OH1);
}
const iT2 = /* @__PURE__ */ i(PH1, [["render", EH1]]);
var RH1 = {}, UH1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NH1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -796)",
  fill: "none"
}, null, -1), qH1 = /* @__PURE__ */ t("path", {
  d: "M4 7.8C4 6.11984 4 5.27976 4.32698 4.63803C4.6146 4.07354 5.07354 3.6146 5.63803 3.32698C6.27976 3 7.11984 3 8.8 3H15.2C16.8802 3 17.7202 3 18.362 3.32698C18.9265 3.6146 19.3854 4.07354 19.673 4.63803C20 5.27976 20 6.11984 20 7.8V21L17.25 19L14.75 21L12 19L9.25 21L6.75 19L4 21V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zH1 = [
  NH1,
  qH1
];
function KH1(r, e) {
  return n(), o("svg", UH1, zH1);
}
const lT2 = /* @__PURE__ */ i(RH1, [["render", KH1]]);
var GH1 = {}, WH1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YH1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), XH1 = /* @__PURE__ */ t("path", {
  d: "M3 10L3 14M7.5 6L7.5 18M12 3V21M16.5 6V18M21 10V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), QH1 = [
  YH1,
  XH1
];
function JH1(r, e) {
  return n(), o("svg", WH1, QH1);
}
const sT2 = /* @__PURE__ */ i(GH1, [["render", JH1]]);
var tV1 = {}, eV1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rV1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), nV1 = /* @__PURE__ */ t("path", {
  d: "M3 10L3 14M7.5 11V13M12 6V18M16.5 3V21M21 10V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oV1 = [
  rV1,
  nV1
];
function iV1(r, e) {
  return n(), o("svg", eV1, oV1);
}
const hT2 = /* @__PURE__ */ i(tV1, [["render", iV1]]);
var lV1 = {}, sV1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hV1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), aV1 = /* @__PURE__ */ t("path", {
  d: "M6 11V13M10 9V15M14 7V17M18 11V13M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dV1 = [
  hV1,
  aV1
];
function cV1(r, e) {
  return n(), o("svg", sV1, dV1);
}
const aT2 = /* @__PURE__ */ i(lV1, [["render", cV1]]);
var _V1 = {}, CV1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fV1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -1076)",
  fill: "none"
}, null, -1), vV1 = /* @__PURE__ */ t("path", {
  d: "M12 3V6M12 10.5V13.5M12 18V21M3.28777 7.99059L7.67567 11.3659C7.95617 11.5817 8.09641 11.6895 8.14681 11.821C8.19098 11.9363 8.19098 12.0637 8.14681 12.179C8.09641 12.3105 7.95617 12.4183 7.67567 12.6341L3.28777 16.0094C2.87415 16.3276 2.66735 16.4867 2.49387 16.4845C2.34295 16.4827 2.20094 16.4128 2.10745 16.2943C2 16.1581 2 15.8971 2 15.3753V8.62469C2 8.10286 2 7.84195 2.10745 7.70574C2.20094 7.58724 2.34295 7.51732 2.49387 7.51547C2.66735 7.51334 2.87415 7.67243 3.28777 7.99059ZM20.7122 7.99059L16.3243 11.3659C16.0438 11.5817 15.9036 11.6895 15.8532 11.821C15.809 11.9363 15.809 12.0637 15.8532 12.179C15.9036 12.3105 16.0438 12.4183 16.3243 12.6341L20.7122 16.0094C21.1258 16.3276 21.3327 16.4867 21.5061 16.4845C21.6571 16.4827 21.7991 16.4128 21.8925 16.2943C22 16.1581 22 15.8971 22 15.3753V8.62469C22 8.10286 22 7.84195 21.8925 7.70574C21.7991 7.58724 21.6571 7.51732 21.5061 7.51547C21.3327 7.51334 21.1258 7.67243 20.7122 7.99059Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uV1 = [
  fV1,
  vV1
];
function wV1(r, e) {
  return n(), o("svg", CV1, uV1);
}
const dT2 = /* @__PURE__ */ i(_V1, [["render", wV1]]);
var pV1 = {}, gV1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $V1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -1116)",
  fill: "none"
}, null, -1), MV1 = /* @__PURE__ */ t("path", {
  d: "M12 3V6M12 10.5V13.5M12 18V21M22 12H15.5M15.5 12L19.5 16M15.5 12L19.5 8M2 12H8.5M8.5 12L4.5 16M8.5 12L4.5 8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), LV1 = [
  $V1,
  MV1
];
function kV1(r, e) {
  return n(), o("svg", gV1, LV1);
}
const cT2 = /* @__PURE__ */ i(pV1, [["render", kV1]]);
var mV1 = {}, xV1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HV1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), VV1 = /* @__PURE__ */ t("path", {
  d: "M2 10C2 10 4.00498 7.26822 5.63384 5.63824C7.26269 4.00827 9.5136 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.89691 21 4.43511 18.2543 3.35177 14.5M2 10V4M2 10H8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ZV1 = [
  HV1,
  VV1
];
function BV1(r, e) {
  return n(), o("svg", xV1, ZV1);
}
const _T2 = /* @__PURE__ */ i(mV1, [["render", BV1]]);
var FV1 = {}, jV1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, IV1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), bV1 = /* @__PURE__ */ t("path", {
  d: "M2 10C2 10 2.12132 9.15076 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.364 5.63604C19.6092 6.88131 20.4133 8.40072 20.7762 10M2 10V4M2 10H8M22 14C22 14 21.8787 14.8492 18.364 18.364C14.8492 21.8787 9.15076 21.8787 5.63604 18.364C4.39076 17.1187 3.58669 15.5993 3.22383 14M22 14V20M22 14H16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yV1 = [
  IV1,
  bV1
];
function DV1(r, e) {
  return n(), o("svg", jV1, yV1);
}
const CT2 = /* @__PURE__ */ i(FV1, [["render", DV1]]);
var PV1 = {}, AV1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, SV1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -516)",
  fill: "none"
}, null, -1), TV1 = /* @__PURE__ */ t("path", {
  d: "M14 2C14 2 14.8492 2.12132 18.364 5.63604C21.8787 9.15076 21.8787 14.8492 18.364 18.364C17.1187 19.6092 15.5993 20.4133 14 20.7762M14 2L20 2M14 2L14 8M10 21.9998C10 21.9998 9.15076 21.8785 5.63604 18.3638C2.12132 14.849 2.12132 9.15056 5.63604 5.63584C6.88131 4.39057 8.40072 3.5865 10 3.22363M10 21.9998L4 22M10 21.9998L10 16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), OV1 = [
  SV1,
  TV1
];
function EV1(r, e) {
  return n(), o("svg", AV1, OV1);
}
const fT2 = /* @__PURE__ */ i(PV1, [["render", EV1]]);
var RV1 = {}, UV1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NV1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -556)",
  fill: "none"
}, null, -1), qV1 = /* @__PURE__ */ t("path", {
  d: "M17 18.8746C19.1213 17.329 20.5 14.8255 20.5 12C20.5 7.30555 16.6944 3.49998 12 3.49998H11.5M12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 9.17444 4.87867 6.67091 7 5.12537M11 22.4L13 20.4L11 18.4M13 5.59998L11 3.59998L13 1.59998",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zV1 = [
  NV1,
  qV1
];
function KV1(r, e) {
  return n(), o("svg", UV1, zV1);
}
const vT2 = /* @__PURE__ */ i(RV1, [["render", KV1]]);
var GV1 = {}, WV1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YV1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -596)",
  fill: "none"
}, null, -1), XV1 = /* @__PURE__ */ t("path", {
  d: "M8.54661 19.7675C10.9457 20.8319 13.8032 20.7741 16.2502 19.3613C20.3157 17.0141 21.7086 11.8156 19.3614 7.75008L19.1114 7.31706M4.63851 16.2502C2.2913 12.1847 3.68424 6.98619 7.74972 4.63898C10.1967 3.22621 13.0542 3.16841 15.4533 4.23277M2.49341 16.3338L5.22546 17.0659L5.95751 14.3338M18.0426 9.6659L18.7747 6.93385L21.5067 7.6659",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), QV1 = [
  YV1,
  XV1
];
function JV1(r, e) {
  return n(), o("svg", WV1, QV1);
}
const uT2 = /* @__PURE__ */ i(GV1, [["render", JV1]]);
var tZ1 = {}, eZ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rZ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -636)",
  fill: "none"
}, null, -1), nZ1 = /* @__PURE__ */ t("path", {
  d: "M21 10C21 10 18.995 7.26822 17.3662 5.63824C15.7373 4.00827 13.4864 3 11 3C6.02944 3 2 7.02944 2 12C2 16.9706 6.02944 21 11 21C15.1031 21 18.5649 18.2543 19.6482 14.5M21 10V4M21 10H15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oZ1 = [
  rZ1,
  nZ1
];
function iZ1(r, e) {
  return n(), o("svg", eZ1, oZ1);
}
const wT2 = /* @__PURE__ */ i(tZ1, [["render", iZ1]]);
var lZ1 = {}, sZ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hZ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -676)",
  fill: "none"
}, null, -1), aZ1 = /* @__PURE__ */ t("path", {
  d: "M2 14C2 14 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C19.6092 17.1187 20.4133 15.5993 20.7762 14M2 14V20M2 14H8M22 10C22 10 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C4.39076 6.88131 3.58669 8.40072 3.22383 10M22 10V4M22 10H16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dZ1 = [
  hZ1,
  aZ1
];
function cZ1(r, e) {
  return n(), o("svg", sZ1, dZ1);
}
const pT2 = /* @__PURE__ */ i(lZ1, [["render", cZ1]]);
var _Z1 = {}, CZ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fZ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -716)",
  fill: "none"
}, null, -1), vZ1 = /* @__PURE__ */ t("path", {
  d: "M14 22C14 22 14.8492 21.8787 18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604C17.1187 4.39077 15.5993 3.58669 14 3.22383M14 22H20M14 22L14 16M10 2.00019C10 2.00019 9.15076 2.12152 5.63604 5.63624C2.12132 9.15095 2.12132 14.8494 5.63604 18.3642C6.88131 19.6094 8.40072 20.4135 10 20.7764M10 2.00019L4 2M10 2.00019L10 8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uZ1 = [
  fZ1,
  vZ1
];
function wZ1(r, e) {
  return n(), o("svg", CZ1, uZ1);
}
const gT2 = /* @__PURE__ */ i(_Z1, [["render", wZ1]]);
var pZ1 = {}, gZ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $Z1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -756)",
  fill: "none"
}, null, -1), MZ1 = /* @__PURE__ */ t("path", {
  d: "M17 5.12537C19.1213 6.67091 20.5 9.17444 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5H11.5M7 18.8746C4.87867 17.329 3.5 14.8255 3.5 12C3.5 7.30555 7.30558 3.49998 12 3.49998H12.5M13 22.4L11 20.4L13 18.4M11 5.59998L13 3.59998L11 1.59998",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), LZ1 = [
  $Z1,
  MZ1
];
function kZ1(r, e) {
  return n(), o("svg", gZ1, LZ1);
}
const $T2 = /* @__PURE__ */ i(pZ1, [["render", kZ1]]);
var mZ1 = {}, xZ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HZ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -796)",
  fill: "none"
}, null, -1), VZ1 = /* @__PURE__ */ t("path", {
  d: "M20.453 12.893C20.1752 15.5029 18.6964 17.9487 16.2494 19.3614C12.1839 21.7086 6.98539 20.3157 4.63818 16.2502L4.38818 15.8172M3.54613 11.107C3.82393 8.49711 5.30272 6.05138 7.74971 4.63862C11.8152 2.29141 17.0137 3.68434 19.3609 7.74983L19.6109 8.18285M3.49316 18.0661L4.22521 15.334L6.95727 16.0661M17.0424 7.93401L19.7744 8.66606L20.5065 5.93401",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ZZ1 = [
  HZ1,
  VZ1
];
function BZ1(r, e) {
  return n(), o("svg", xZ1, ZZ1);
}
const MT2 = /* @__PURE__ */ i(mZ1, [["render", BZ1]]);
var FZ1 = {}, jZ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, IZ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), bZ1 = /* @__PURE__ */ t("path", {
  d: "M17 2L21 6M21 6L17 10M21 6H7.8C6.11984 6 5.27976 6 4.63803 6.32698C4.07354 6.6146 3.6146 7.07354 3.32698 7.63803C3 8.27976 3 9.11984 3 10.8V11M3 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V13M3 18L7 22M3 18L7 14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yZ1 = [
  IZ1,
  bZ1
];
function DZ1(r, e) {
  return n(), o("svg", jZ1, yZ1);
}
const LT2 = /* @__PURE__ */ i(FZ1, [["render", DZ1]]);
var PZ1 = {}, AZ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, SZ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -636)",
  fill: "none"
}, null, -1), TZ1 = /* @__PURE__ */ t("path", {
  d: "M11 2L14 5M14 5L11 8M14 5H6.8C5.11984 5 4.27976 5 3.63803 5.32698C3.07354 5.6146 2.6146 6.07354 2.32698 6.63803C2 7.27976 2 8.11984 2 9.8V15.5C2 15.9644 2 16.1966 2.02567 16.3916C2.2029 17.7378 3.26222 18.7971 4.60842 18.9743C4.80337 19 5.03558 19 5.5 19M10 19H17.2C18.8802 19 19.7202 19 20.362 18.673C20.9265 18.3854 21.3854 17.9265 21.673 17.362C22 16.7202 22 15.8802 22 14.2V8.5C22 8.03558 22 7.80337 21.9743 7.60842C21.7971 6.26222 20.7378 5.2029 19.3916 5.02567C19.1966 5 18.9644 5 18.5 5M10 19L13 22M10 19L13 16",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), OZ1 = [
  SZ1,
  TZ1
];
function EZ1(r, e) {
  return n(), o("svg", AZ1, OZ1);
}
const kT2 = /* @__PURE__ */ i(PZ1, [["render", EZ1]]);
var RZ1 = {}, UZ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NZ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -676)",
  fill: "none"
}, null, -1), qZ1 = /* @__PURE__ */ t("path", {
  d: "M13 22L10 19M10 19L13 16M10 19H15C18.866 19 22 15.866 22 12C22 9.2076 20.3649 6.7971 18 5.67363M6 18.3264C3.63505 17.2029 2 14.7924 2 12C2 8.13401 5.13401 5 9 5H14M14 5L11 2M14 5L11 8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zZ1 = [
  NZ1,
  qZ1
];
function KZ1(r, e) {
  return n(), o("svg", UZ1, zZ1);
}
const mT2 = /* @__PURE__ */ i(RZ1, [["render", KZ1]]);
var GZ1 = {}, WZ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YZ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -716)",
  fill: "none"
}, null, -1), XZ1 = /* @__PURE__ */ t("path", {
  d: "M12 20.5001C16.6944 20.5001 20.5 16.6945 20.5 12.0001C20.5 9.17456 19.1213 6.67103 17 5.1255M13 22.4001L11 20.4001L13 18.4001M12 3.5001C7.30558 3.5001 3.5 7.30568 3.5 12.0001C3.5 14.8256 4.87867 17.3292 7 18.8747M11 5.6001L13 3.6001L11 1.6001",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), QZ1 = [
  YZ1,
  XZ1
];
function JZ1(r, e) {
  return n(), o("svg", WZ1, QZ1);
}
const xT2 = /* @__PURE__ */ i(GZ1, [["render", JZ1]]);
var tB1 = {}, eB1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rB1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -836)",
  fill: "none"
}, null, -1), nB1 = /* @__PURE__ */ t("path", {
  d: "M4 7H14C17.3137 7 20 9.68629 20 13C20 16.3137 17.3137 19 14 19H4M4 7L8 3M4 7L8 11",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oB1 = [
  rB1,
  nB1
];
function iB1(r, e) {
  return n(), o("svg", eB1, oB1);
}
const HT2 = /* @__PURE__ */ i(tB1, [["render", iB1]]);
var lB1 = {}, sB1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hB1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -876)",
  fill: "none"
}, null, -1), aB1 = /* @__PURE__ */ t("path", {
  d: "M20 7H10C6.68629 7 4 9.68629 4 13C4 16.3137 6.68629 19 10 19H20M20 7L16 3M20 7L16 11",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dB1 = [
  hB1,
  aB1
];
function cB1(r, e) {
  return n(), o("svg", sB1, dB1);
}
const VT2 = /* @__PURE__ */ i(lB1, [["render", cB1]]);
var _B1 = {}, CB1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fB1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-608 -1156)",
  fill: "none"
}, null, -1), vB1 = /* @__PURE__ */ t("path", {
  d: "M21 4H3M21 20H3M12 9.25H3M12 14.75H3M19.72 8.46L15.8533 11.36C15.5638 11.5771 15.4191 11.6857 15.3673 11.8188C15.322 11.9353 15.322 12.0647 15.3673 12.1812C15.4191 12.3143 15.5638 12.4229 15.8533 12.64L19.72 15.54C20.132 15.849 20.338 16.0035 20.5104 15.9999C20.6604 15.9968 20.8012 15.9264 20.8937 15.8082C21 15.6725 21 15.415 21 14.9V9.1C21 8.58503 21 8.32754 20.8937 8.19175C20.8012 8.07358 20.6604 8.00323 20.5104 8.00011C20.338 7.99652 20.132 8.15102 19.72 8.46Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uB1 = [
  fB1,
  vB1
];
function wB1(r, e) {
  return n(), o("svg", CB1, uB1);
}
const ZT2 = /* @__PURE__ */ i(_B1, [["render", wB1]]);
var pB1 = {}, gB1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $B1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), MB1 = /* @__PURE__ */ t("path", {
  d: "M12 9.24995H3M12 3.99995L3 3.99995M21 14.75H3M21 20H3M19.72 2.95995L15.8533 5.85995C15.5638 6.07707 15.4191 6.18563 15.3673 6.31872C15.322 6.43529 15.322 6.56462 15.3673 6.68119C15.4191 6.81427 15.5638 6.92283 15.8533 7.13995L19.72 10.04C20.132 10.3489 20.338 10.5034 20.5104 10.4998C20.6604 10.4967 20.8012 10.4264 20.8937 10.3082C21 10.1724 21 9.91493 21 9.39995V3.59995C21 3.08498 21 2.82749 20.8937 2.6917C20.8012 2.57354 20.6604 2.50318 20.5104 2.50006C20.338 2.49648 20.132 2.65097 19.72 2.95995Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), LB1 = [
  $B1,
  MB1
];
function kB1(r, e) {
  return n(), o("svg", gB1, LB1);
}
const BT2 = /* @__PURE__ */ i(pB1, [["render", kB1]]);
var mB1 = {}, xB1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HB1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), VB1 = /* @__PURE__ */ t("path", {
  d: "M12.9996 10.9999L3.49964 20.4999M14.0181 3.53838C15.2361 4.34658 16.4068 5.29941 17.5008 6.3934C18.6042 7.49683 19.564 8.67831 20.3767 9.90766M9.2546 7.89605L6.37973 6.93776C6.04865 6.8274 5.68398 6.89763 5.41756 7.12306L2.56041 9.54065C1.97548 10.0356 2.14166 10.9775 2.86064 11.2424L5.56784 12.2398M11.6807 18.3524L12.6781 21.0596C12.943 21.7786 13.8849 21.9448 14.3798 21.3599L16.7974 18.5027C17.0228 18.2363 17.0931 17.8716 16.9827 17.5405L16.0244 14.6657M19.3482 2.27063L14.4418 3.08838C13.9119 3.17668 13.426 3.43709 13.0591 3.82932L6.446 10.8985C4.73185 12.7308 4.77953 15.5924 6.55378 17.3667C8.32803 19.1409 11.1896 19.1886 13.022 17.4744L20.0911 10.8614C20.4834 10.4944 20.7438 10.0085 20.8321 9.47869L21.6498 4.57222C21.8754 3.21858 20.7019 2.04503 19.3482 2.27063Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ZB1 = [
  HB1,
  VB1
];
function BB1(r, e) {
  return n(), o("svg", xB1, ZB1);
}
const FT2 = /* @__PURE__ */ i(mB1, [["render", BB1]]);
var FB1 = {}, jB1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, IB1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), bB1 = /* @__PURE__ */ t("path", {
  d: "M12 14.9998L9 11.9998M12 14.9998C13.3968 14.4685 14.7369 13.7985 16 12.9998M12 14.9998V19.9998C12 19.9998 15.03 19.4498 16 17.9998C17.08 16.3798 16 12.9998 16 12.9998M9 11.9998C9.53214 10.6192 10.2022 9.29582 11 8.04976C12.1652 6.18675 13.7876 4.65281 15.713 3.59385C17.6384 2.53489 19.8027 1.98613 22 1.99976C22 4.71976 21.22 9.49976 16 12.9998M9 11.9998H4C4 11.9998 4.55 8.96976 6 7.99976C7.62 6.91976 11 7.99976 11 7.99976M4.5 16.4998C3 17.7598 2.5 21.4998 2.5 21.4998C2.5 21.4998 6.24 20.9998 7.5 19.4998C8.21 18.6598 8.2 17.3698 7.41 16.5898C7.02131 16.2188 6.50929 16.0044 5.97223 15.9878C5.43516 15.9712 4.91088 16.1535 4.5 16.4998Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yB1 = [
  IB1,
  bB1
];
function DB1(r, e) {
  return n(), o("svg", jB1, yB1);
}
const jT2 = /* @__PURE__ */ i(FB1, [["render", DB1]]);
var PB1 = {}, AB1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, SB1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), TB1 = /* @__PURE__ */ t("path", {
  d: "M19 4.5C19 4.96466 19 5.19698 18.9616 5.39018C18.8038 6.18356 18.1836 6.80376 17.3902 6.96157C17.197 7 16.9647 7 16.5 7H5.5C5.03534 7 4.80302 7 4.60982 6.96157C3.81644 6.80376 3.19624 6.18356 3.03843 5.39018C3 5.19698 3 4.96466 3 4.5C3 4.03534 3 3.80302 3.03843 3.60982C3.19624 2.81644 3.81644 2.19624 4.60982 2.03843C4.80302 2 5.03534 2 5.5 2H16.5C16.9647 2 17.197 2 17.3902 2.03843C18.1836 2.19624 18.8038 2.81644 18.9616 3.60982C19 3.80302 19 4.03534 19 4.5ZM19 4.5C19.9319 4.5 20.3978 4.5 20.7654 4.65224C21.2554 4.85523 21.6448 5.24458 21.8478 5.73463C22 6.10218 22 6.56812 22 7.5V7.8C22 8.9201 22 9.48016 21.782 9.90798C21.5903 10.2843 21.2843 10.5903 20.908 10.782C20.4802 11 19.9201 11 18.8 11H15.2C14.0799 11 13.5198 11 13.092 11.218C12.7157 11.4097 12.4097 11.7157 12.218 12.092C12 12.5198 12 13.0799 12 14.2V15M11.6 22H12.4C12.9601 22 13.2401 22 13.454 21.891C13.6422 21.7951 13.7951 21.6422 13.891 21.454C14 21.2401 14 20.9601 14 20.4V16.6C14 16.0399 14 15.7599 13.891 15.546C13.7951 15.3578 13.6422 15.2049 13.454 15.109C13.2401 15 12.9601 15 12.4 15H11.6C11.0399 15 10.7599 15 10.546 15.109C10.3578 15.2049 10.2049 15.3578 10.109 15.546C10 15.7599 10 16.0399 10 16.6V20.4C10 20.9601 10 21.2401 10.109 21.454C10.2049 21.6422 10.3578 21.7951 10.546 21.891C10.7599 22 11.0399 22 11.6 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), OB1 = [
  SB1,
  TB1
];
function EB1(r, e) {
  return n(), o("svg", AB1, OB1);
}
const IT2 = /* @__PURE__ */ i(PB1, [["render", EB1]]);
var RB1 = {}, UB1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NB1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), qB1 = /* @__PURE__ */ t("path", {
  d: "M11.5 5H11.9344C14.9816 5 16.5053 5 17.0836 5.54729C17.5836 6.02037 17.8051 6.71728 17.6702 7.39221C17.514 8.17302 16.2701 9.05285 13.7823 10.8125L9.71772 13.6875C7.2299 15.4471 5.98599 16.327 5.82984 17.1078C5.69486 17.7827 5.91642 18.4796 6.41636 18.9527C6.99474 19.5 8.51836 19.5 11.5656 19.5H12.5M8 5C8 6.65685 6.65685 8 5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5ZM22 19C22 20.6569 20.6569 22 19 22C17.3431 22 16 20.6569 16 19C16 17.3431 17.3431 16 19 16C20.6569 16 22 17.3431 22 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zB1 = [
  NB1,
  qB1
];
function KB1(r, e) {
  return n(), o("svg", UB1, zB1);
}
const bT2 = /* @__PURE__ */ i(RB1, [["render", KB1]]);
var GB1 = {}, WB1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YB1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), XB1 = /* @__PURE__ */ t("path", {
  d: "M17.8 10C18.9201 10 19.4802 10 19.908 9.78201C20.2843 9.59027 20.5903 9.28431 20.782 8.90798C21 8.48016 21 7.92011 21 6.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.7157 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3L6.2 3C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2L3 6.8C3 7.9201 3 8.48016 3.21799 8.90798C3.40973 9.28431 3.71569 9.59027 4.09202 9.78201C4.51984 10 5.07989 10 6.2 10L17.8 10Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), QB1 = /* @__PURE__ */ t("path", {
  d: "M17.8 21C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V17.2C21 16.0799 21 15.5198 20.782 15.092C20.5903 14.7157 20.2843 14.4097 19.908 14.218C19.4802 14 18.9201 14 17.8 14L6.2 14C5.0799 14 4.51984 14 4.09202 14.218C3.71569 14.4097 3.40973 14.7157 3.21799 15.092C3 15.5198 3 16.0799 3 17.2L3 17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JB1 = [
  YB1,
  XB1,
  QB1
];
function tF1(r, e) {
  return n(), o("svg", WB1, JB1);
}
const yT2 = /* @__PURE__ */ i(GB1, [["render", tF1]]);
var eF1 = {}, rF1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nF1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), oF1 = /* @__PURE__ */ t("path", {
  d: "M3 12H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iF1 = [
  nF1,
  oF1
];
function lF1(r, e) {
  return n(), o("svg", rF1, iF1);
}
const DT2 = /* @__PURE__ */ i(eF1, [["render", lF1]]);
var sF1 = {}, hF1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aF1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -516)",
  fill: "none"
}, null, -1), dF1 = /* @__PURE__ */ t("path", {
  d: "M3 9H21M3 15H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cF1 = [
  aF1,
  dF1
];
function _F1(r, e) {
  return n(), o("svg", hF1, cF1);
}
const PT2 = /* @__PURE__ */ i(sF1, [["render", _F1]]);
var CF1 = {}, fF1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vF1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -756)",
  fill: "none"
}, null, -1), uF1 = /* @__PURE__ */ t("path", {
  d: "M4 11C6.38695 11 8.67613 11.9482 10.364 13.636C12.0518 15.3239 13 17.6131 13 20M4 4C8.24346 4 12.3131 5.68571 15.3137 8.68629C18.3143 11.6869 20 15.7565 20 20M6 19C6 19.5523 5.55228 20 5 20C4.44772 20 4 19.5523 4 19C4 18.4477 4.44772 18 5 18C5.55228 18 6 18.4477 6 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wF1 = [
  vF1,
  uF1
];
function pF1(r, e) {
  return n(), o("svg", fF1, wF1);
}
const AT2 = /* @__PURE__ */ i(CF1, [["render", pF1]]);
var gF1 = {}, $F1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MF1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -796)",
  fill: "none"
}, null, -1), LF1 = /* @__PURE__ */ t("path", {
  d: "M3.00024 13.0225C8.18522 12.2429 11.7559 15.8146 10.9774 20.9996M3.00024 8.03784C10.938 7.25824 16.7417 13.0619 15.9621 20.9997M3.00024 3.05212C13.6919 2.27364 21.7264 10.3082 20.948 20.9998M5 21C3.89566 21 3 20.1043 3 19C3 17.8957 3.89566 17 5 17C6.10434 17 7 17.8957 7 19C7 20.1043 6.10434 21 5 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kF1 = [
  MF1,
  LF1
];
function mF1(r, e) {
  return n(), o("svg", $F1, kF1);
}
const ST2 = /* @__PURE__ */ i(gF1, [["render", mF1]]);
var xF1 = {}, HF1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VF1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), ZF1 = /* @__PURE__ */ t("path", {
  d: "M14.5 5.49989L16 6.99989M11.5 8.49989L13 9.99989M8.49996 11.4999L9.99996 12.9999M5.49996 14.4999L6.99996 15.9999M2.56561 17.5656L6.43424 21.4342C6.63225 21.6322 6.73125 21.7313 6.84542 21.7683C6.94584 21.801 7.05401 21.801 7.15443 21.7683C7.2686 21.7313 7.3676 21.6322 7.56561 21.4342L21.4342 7.56561C21.6322 7.3676 21.7313 7.2686 21.7683 7.15443C21.801 7.05401 21.801 6.94584 21.7683 6.84542C21.7313 6.73125 21.6322 6.63225 21.4342 6.43424L17.5656 2.56561C17.3676 2.3676 17.2686 2.2686 17.1544 2.2315C17.054 2.19887 16.9458 2.19887 16.8454 2.2315C16.7313 2.2686 16.6322 2.3676 16.4342 2.56561L2.56561 16.4342C2.3676 16.6322 2.2686 16.7313 2.2315 16.8454C2.19887 16.9458 2.19887 17.054 2.2315 17.1544C2.2686 17.2686 2.3676 17.3676 2.56561 17.5656Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BF1 = [
  VF1,
  ZF1
];
function FF1(r, e) {
  return n(), o("svg", HF1, BF1);
}
const TT2 = /* @__PURE__ */ i(xF1, [["render", FF1]]);
var jF1 = {}, IF1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bF1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -876)",
  fill: "none"
}, null, -1), yF1 = /* @__PURE__ */ t("path", {
  d: "M6 21H9M15 21H18M17.5 6.5V14.5M3 6.2L3 14.8C3 15.9201 3 16.4802 3.21799 16.908C3.40973 17.2843 3.71569 17.5903 4.09202 17.782C4.51984 18 5.07989 18 6.2 18L17.8 18C18.9201 18 19.4802 18 19.908 17.782C20.2843 17.5903 20.5903 17.2843 20.782 16.908C21 16.4802 21 15.9201 21 14.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.7157 20.2843 3.40974 19.908 3.21799C19.4802 3 18.9201 3 17.8 3L6.2 3C5.0799 3 4.51984 3 4.09202 3.21799C3.7157 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2ZM11.5 10.5C11.5 11.8807 10.3807 13 9 13C7.61929 13 6.5 11.8807 6.5 10.5C6.5 9.11929 7.61929 8 9 8C10.3807 8 11.5 9.11929 11.5 10.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DF1 = [
  bF1,
  yF1
];
function PF1(r, e) {
  return n(), o("svg", IF1, DF1);
}
const OT2 = /* @__PURE__ */ i(jF1, [["render", PF1]]);
var AF1 = {}, SF1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TF1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-608 -916)",
  fill: "none"
}, null, -1), OF1 = /* @__PURE__ */ t("path", {
  d: "M9 9H9.01M15 15H15.01M16 8L8 16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EF1 = [
  TF1,
  OF1
];
function RF1(r, e) {
  return n(), o("svg", SF1, EF1);
}
const ET2 = /* @__PURE__ */ i(AF1, [["render", RF1]]);
var UF1 = {}, NF1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qF1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), zF1 = /* @__PURE__ */ t("path", {
  d: "M9 9H9.01M15 15H15.01M16 8L8 16M7.33377 3.8187C8.1376 3.75455 8.90071 3.43846 9.51447 2.91542C10.9467 1.69486 13.0533 1.69486 14.4855 2.91542C15.0993 3.43846 15.8624 3.75455 16.6662 3.8187C18.5421 3.96839 20.0316 5.45794 20.1813 7.33377C20.2455 8.1376 20.5615 8.90071 21.0846 9.51447C22.3051 10.9467 22.3051 13.0533 21.0846 14.4855C20.5615 15.0993 20.2455 15.8624 20.1813 16.6662C20.0316 18.5421 18.5421 20.0316 16.6662 20.1813C15.8624 20.2455 15.0993 20.5615 14.4855 21.0846C13.0533 22.3051 10.9467 22.3051 9.51447 21.0846C8.90071 20.5615 8.1376 20.2455 7.33377 20.1813C5.45794 20.0316 3.96839 18.5421 3.8187 16.6662C3.75455 15.8624 3.43846 15.0993 2.91542 14.4855C1.69486 13.0533 1.69486 10.9467 2.91542 9.51447C3.43846 8.90071 3.75455 8.1376 3.8187 7.33377C3.96839 5.45794 5.45794 3.96839 7.33377 3.8187ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KF1 = [
  qF1,
  zF1
];
function GF1(r, e) {
  return n(), o("svg", NF1, KF1);
}
const RT2 = /* @__PURE__ */ i(UF1, [["render", GF1]]);
var WF1 = {}, YF1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XF1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), QF1 = /* @__PURE__ */ t("path", {
  d: "M9 9H9.01M15 15H15.01M16 8L8 16M17.9012 4.99851C18.1071 5.49653 18.5024 5.8924 19.0001 6.09907L20.7452 6.82198C21.2433 7.02828 21.639 7.42399 21.8453 7.92206C22.0516 8.42012 22.0516 8.97974 21.8453 9.47781L21.1229 11.2218C20.9165 11.7201 20.9162 12.2803 21.1236 12.7783L21.8447 14.5218C21.9469 14.7685 21.9996 15.0329 21.9996 15.2999C21.9997 15.567 21.9471 15.8314 21.8449 16.0781C21.7427 16.3249 21.5929 16.549 21.4041 16.7378C21.2152 16.9266 20.991 17.0764 20.7443 17.1785L19.0004 17.9009C18.5023 18.1068 18.1065 18.5021 17.8998 18.9998L17.1769 20.745C16.9706 21.2431 16.575 21.6388 16.0769 21.8451C15.5789 22.0514 15.0193 22.0514 14.5212 21.8451L12.7773 21.1227C12.2792 20.9169 11.7198 20.9173 11.2221 21.1239L9.47689 21.8458C8.97912 22.0516 8.42001 22.0514 7.92237 21.8453C7.42473 21.6391 7.02925 21.2439 6.82281 20.7464L6.09972 19.0006C5.8938 18.5026 5.49854 18.1067 5.00085 17.9L3.25566 17.1771C2.75783 16.9709 2.36226 16.5754 2.15588 16.0777C1.94951 15.5799 1.94923 15.0205 2.1551 14.5225L2.87746 12.7786C3.08325 12.2805 3.08283 11.7211 2.8763 11.2233L2.15497 9.47678C2.0527 9.2301 2.00004 8.96568 2 8.69863C1.99996 8.43159 2.05253 8.16715 2.15472 7.92043C2.25691 7.67372 2.40671 7.44955 2.59557 7.26075C2.78442 7.07195 3.00862 6.92222 3.25537 6.8201L4.9993 6.09772C5.49687 5.89197 5.89248 5.4972 6.0993 5.00006L6.82218 3.25481C7.02848 2.75674 7.42418 2.36103 7.92222 2.15473C8.42027 1.94842 8.97987 1.94842 9.47792 2.15473L11.2218 2.87712C11.7199 3.08291 12.2793 3.08249 12.7771 2.87595L14.523 2.15585C15.021 1.94966 15.5804 1.9497 16.0784 2.15597C16.5763 2.36223 16.972 2.75783 17.1783 3.25576L17.9014 5.00153L17.9012 4.99851ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), JF1 = [
  XF1,
  QF1
];
function tj1(r, e) {
  return n(), o("svg", YF1, JF1);
}
const UT2 = /* @__PURE__ */ i(WF1, [["render", tj1]]);
var ej1 = {}, rj1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nj1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), oj1 = /* @__PURE__ */ t("path", {
  d: "M9 9H9.01M15 15H15.01M16 8L8 16M9.2019 20.6009C9.52965 20.5575 9.86073 20.6464 10.1218 20.8475L11.3251 21.7708C11.7228 22.0764 12.2761 22.0764 12.6727 21.7708L13.9215 20.812C14.1548 20.6331 14.4492 20.5542 14.7403 20.5931L16.3024 20.7986C16.799 20.8642 17.2779 20.5875 17.4701 20.1242L18.0712 18.6709C18.1834 18.3987 18.3989 18.1832 18.6711 18.0709L20.1243 17.4698C20.5876 17.2787 20.8643 16.7988 20.7987 16.3021L20.601 14.7966C20.5576 14.4688 20.6465 14.1377 20.8476 13.8766L21.7709 12.6733C22.0764 12.2755 22.0764 11.7222 21.7709 11.3256L20.812 10.0767C20.6332 9.84339 20.5543 9.54896 20.5932 9.25785L20.7987 7.69568C20.8643 7.19902 20.5876 6.72015 20.1243 6.52793L18.6711 5.92684C18.3989 5.81462 18.1834 5.59907 18.0712 5.32685L17.4701 3.87356C17.279 3.41024 16.799 3.13358 16.3024 3.19913L14.7403 3.40468C14.4492 3.44468 14.1548 3.36579 13.9226 3.18802L12.6738 2.22916C12.2761 1.92361 11.7228 1.92361 11.3262 2.22916L10.0774 3.18802C9.84407 3.36579 9.54965 3.44468 9.25856 3.40691L7.69647 3.20136C7.19984 3.1358 6.721 3.41246 6.52879 3.87578L5.92884 5.32907C5.81552 5.60018 5.59998 5.81573 5.32889 5.92906L3.87568 6.52904C3.41238 6.72126 3.13574 7.20013 3.20129 7.69679L3.40683 9.25897C3.4446 9.55007 3.36572 9.8445 3.18796 10.0767L2.22915 11.3256C1.92362 11.7233 1.92362 12.2767 2.22915 12.6733L3.18796 13.9222C3.36683 14.1555 3.44571 14.4499 3.40683 14.741L3.20129 16.3032C3.13574 16.7999 3.41238 17.2787 3.87568 17.471L5.32889 18.0721C5.60109 18.1843 5.81663 18.3998 5.92884 18.672L6.5299 20.1253C6.721 20.5887 7.20096 20.8653 7.69758 20.7998L9.2019 20.6009ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ij1 = [
  nj1,
  oj1
];
function lj1(r, e) {
  return n(), o("svg", rj1, ij1);
}
const NT2 = /* @__PURE__ */ i(ej1, [["render", lj1]]);
var sj1 = {}, hj1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aj1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1516)",
  fill: "none"
}, null, -1), dj1 = /* @__PURE__ */ t("path", {
  d: "M7 3V6.4C7 6.96005 7 7.24008 7.10899 7.45399C7.20487 7.64215 7.35785 7.79513 7.54601 7.89101C7.75992 8 8.03995 8 8.6 8H15.4C15.9601 8 16.2401 8 16.454 7.89101C16.6422 7.79513 16.7951 7.64215 16.891 7.45399C17 7.24008 17 6.96005 17 6.4V4M17 21V14.6C17 14.0399 17 13.7599 16.891 13.546C16.7951 13.3578 16.6422 13.2049 16.454 13.109C16.2401 13 15.9601 13 15.4 13H8.6C8.03995 13 7.75992 13 7.54601 13.109C7.35785 13.2049 7.20487 13.3578 7.10899 13.546C7 13.7599 7 14.0399 7 14.6V21M21 9.32548V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cj1 = [
  aj1,
  dj1
];
function _j1(r, e) {
  return n(), o("svg", hj1, cj1);
}
const qT2 = /* @__PURE__ */ i(sj1, [["render", _j1]]);
var Cj1 = {}, fj1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vj1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1556)",
  fill: "none"
}, null, -1), uj1 = /* @__PURE__ */ t("path", {
  d: "M15 8H8.6C8.03995 8 7.75992 8 7.54601 7.89101C7.35785 7.79513 7.20487 7.64215 7.10899 7.45399C7 7.24008 7 6.96005 7 6.4V3M17 21V14.6C17 14.0399 17 13.7599 16.891 13.546C16.7951 13.3578 16.6422 13.2049 16.454 13.109C16.2401 13 15.9601 13 15.4 13H8.6C8.03995 13 7.75992 13 7.54601 13.109C7.35785 13.2049 7.20487 13.3578 7.10899 13.546C7 13.7599 7 14.0399 7 14.6V21M21 9.32548V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wj1 = [
  vj1,
  uj1
];
function pj1(r, e) {
  return n(), o("svg", fj1, wj1);
}
const zT2 = /* @__PURE__ */ i(Cj1, [["render", pj1]]);
var gj1 = {}, $j1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mj1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1596)",
  fill: "none"
}, null, -1), Lj1 = /* @__PURE__ */ t("path", {
  d: "M7 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548V17M12.5 10H8.6C8.03995 10 7.75992 10 7.54601 9.89101C7.35785 9.79513 7.20487 9.64215 7.10899 9.45399C7 9.24008 7 8.96005 7 8.4V6.5M13.5 21V16.6C13.5 16.0399 13.5 15.7599 13.391 15.546C13.2951 15.3578 13.1422 15.2049 12.954 15.109C12.7401 15 12.4601 15 11.9 15H8.6C8.03995 15 7.75992 15 7.54601 15.109C7.35785 15.2049 7.20487 15.3578 7.10899 15.546C7 15.7599 7 16.0399 7 16.6V21M17.5 10.1627V17.8C17.5 18.9201 17.5 19.4802 17.282 19.908C17.0903 20.2843 16.7843 20.5903 16.408 20.782C15.9802 21 15.4201 21 14.3 21H6.2C5.0799 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V9.7C3 8.57989 3 8.01984 3.21799 7.59202C3.40973 7.21569 3.71569 6.90973 4.09202 6.71799C4.51984 6.5 5.0799 6.5 6.2 6.5H13.8373C14.0818 6.5 14.2041 6.5 14.3192 6.52763C14.4213 6.55213 14.5188 6.59253 14.6083 6.64736C14.7092 6.7092 14.7957 6.79568 14.9686 6.96863L17.0314 9.03137C17.2043 9.20432 17.2908 9.2908 17.3526 9.39172C17.4075 9.48119 17.4479 9.57873 17.4724 9.68077C17.5 9.79586 17.5 9.91815 17.5 10.1627Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kj1 = [
  Mj1,
  Lj1
];
function mj1(r, e) {
  return n(), o("svg", $j1, kj1);
}
const KT2 = /* @__PURE__ */ i(gj1, [["render", mj1]]);
var xj1 = {}, Hj1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vj1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), Zj1 = /* @__PURE__ */ t("path", {
  d: "M14 22H6.8M6.8 22C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2M6.8 22H7.2C8.88016 22 9.72024 22 10.362 21.673C10.9265 21.3854 11.3854 20.9265 11.673 20.362C12 19.7202 12 18.8802 12 17.2V16.8C12 15.1198 12 14.2798 11.673 13.638C11.3854 13.0735 10.9265 12.6146 10.362 12.327C9.72024 12 8.88016 12 7.2 12H6.8C5.11984 12 4.27976 12 3.63803 12.327C3.07354 12.6146 2.6146 13.0735 2.32698 13.638C2 14.2798 2 15.1198 2 16.8V17.2M2 17.2V10M10 2H14M22 10V14M18 22C18.93 22 19.395 22 19.7765 21.8978C20.8117 21.6204 21.6204 20.8117 21.8978 19.7765C22 19.395 22 18.93 22 18M22 6C22 5.07003 22 4.60504 21.8978 4.22354C21.6204 3.18827 20.8117 2.37962 19.7765 2.10222C19.395 2 18.93 2 18 2M6 2C5.07003 2 4.60504 2 4.22354 2.10222C3.18827 2.37962 2.37962 3.18827 2.10222 4.22354C2 4.60504 2 5.07003 2 6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Bj1 = [
  Vj1,
  Zj1
];
function Fj1(r, e) {
  return n(), o("svg", Hj1, Bj1);
}
const GT2 = /* @__PURE__ */ i(xj1, [["render", Fj1]]);
var jj1 = {}, Ij1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bj1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), yj1 = /* @__PURE__ */ t("path", {
  d: "M16 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M11.5 12.5L17 7M17 7H12M17 7V12M6.2 21H8.8C9.9201 21 10.4802 21 10.908 20.782C11.2843 20.5903 11.5903 20.2843 11.782 19.908C12 19.4802 12 18.9201 12 17.8V15.2C12 14.0799 12 13.5198 11.782 13.092C11.5903 12.7157 11.2843 12.4097 10.908 12.218C10.4802 12 9.92011 12 8.8 12H6.2C5.0799 12 4.51984 12 4.09202 12.218C3.71569 12.4097 3.40973 12.7157 3.21799 13.092C3 13.5198 3 14.0799 3 15.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Dj1 = [
  bj1,
  yj1
];
function Pj1(r, e) {
  return n(), o("svg", Ij1, Dj1);
}
const WT2 = /* @__PURE__ */ i(jj1, [["render", Pj1]]);
var Aj1 = {}, Sj1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tj1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), Oj1 = /* @__PURE__ */ t("path", {
  d: "M16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8M16.2 3C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8M16.2 3H15.2C14.0799 3 13.5198 3 13.092 3.21799C12.7157 3.40973 12.4097 3.71569 12.218 4.09202C12 4.51984 12 5.07989 12 6.2V8.8C12 9.9201 12 10.4802 12.218 10.908C12.4097 11.2843 12.7157 11.5903 13.092 11.782C13.5198 12 14.0799 12 15.2 12H17.8C18.9201 12 19.4802 12 19.908 11.782C20.2843 11.5903 20.5903 11.2843 20.782 10.908C21 10.4802 21 9.92011 21 8.8V7.8M12.5 11.5L7 17M7 17H12M7 17L7 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ej1 = [
  Tj1,
  Oj1
];
function Rj1(r, e) {
  return n(), o("svg", Sj1, Ej1);
}
const YT2 = /* @__PURE__ */ i(Aj1, [["render", Rj1]]);
var Uj1 = {}, Nj1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qj1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), zj1 = /* @__PURE__ */ t("path", {
  d: "M2 17V16.8498C2 16.5333 2 16.3751 2.02421 16.2209C2.0457 16.084 2.08136 15.9497 2.13061 15.8202C2.18609 15.6743 2.2646 15.5369 2.42162 15.2622L6 9M2 17C2 19.2091 3.79086 21 6 21C8.20914 21 10 19.2091 10 17M2 17V16.8C2 16.52 2 16.38 2.0545 16.273C2.10243 16.1789 2.17892 16.1024 2.273 16.0545C2.37996 16 2.51997 16 2.8 16H9.2C9.48003 16 9.62004 16 9.727 16.0545C9.82108 16.1024 9.89757 16.1789 9.9455 16.273C10 16.38 10 16.52 10 16.8V17M6 9L9.57838 15.2622C9.7354 15.5369 9.81391 15.6743 9.86939 15.8202C9.91864 15.9497 9.9543 16.084 9.97579 16.2209C10 16.3751 10 16.5333 10 16.8498V17M6 9L18 7M14 15V14.8498C14 14.5333 14 14.3751 14.0242 14.2209C14.0457 14.084 14.0814 13.9497 14.1306 13.8202C14.1861 13.6743 14.2646 13.5369 14.4216 13.2622L18 7M14 15C14 17.2091 15.7909 19 18 19C20.2091 19 22 17.2091 22 15M14 15V14.8C14 14.52 14 14.38 14.0545 14.273C14.1024 14.1789 14.1789 14.1024 14.273 14.0545C14.38 14 14.52 14 14.8 14H21.2C21.48 14 21.62 14 21.727 14.0545C21.8211 14.1024 21.8976 14.1789 21.9455 14.273C22 14.38 22 14.52 22 14.8V15M18 7L21.5784 13.2622C21.7354 13.5369 21.8139 13.6743 21.8694 13.8202C21.9186 13.9497 21.9543 14.084 21.9758 14.2209C22 14.3751 22 14.5333 22 14.8498V15M12 3V8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Kj1 = [
  qj1,
  zj1
];
function Gj1(r, e) {
  return n(), o("svg", Nj1, Kj1);
}
const XT2 = /* @__PURE__ */ i(Uj1, [["render", Gj1]]);
var Wj1 = {}, Yj1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xj1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), Qj1 = /* @__PURE__ */ t("path", {
  d: "M2.50047 13H8.50047M15.5005 13H21.5005M12.0005 7V21M12.0005 7C13.3812 7 14.5005 5.88071 14.5005 4.5M12.0005 7C10.6198 7 9.50047 5.88071 9.50047 4.5M4.00047 21L20.0005 21M4.00047 4.50001L9.50047 4.5M9.50047 4.5C9.50047 3.11929 10.6198 2 12.0005 2C13.3812 2 14.5005 3.11929 14.5005 4.5M14.5005 4.5L20.0005 4.5M8.88091 14.3364C8.48022 15.8706 7.11858 17 5.50047 17C3.88237 17 2.52073 15.8706 2.12004 14.3364C2.0873 14.211 2.07093 14.1483 2.06935 13.8979C2.06838 13.7443 2.12544 13.3904 2.17459 13.2449C2.25478 13.0076 2.34158 12.8737 2.51519 12.6059L5.50047 8L8.48576 12.6059C8.65937 12.8737 8.74617 13.0076 8.82636 13.2449C8.87551 13.3904 8.93257 13.7443 8.9316 13.8979C8.93002 14.1483 8.91365 14.211 8.88091 14.3364ZM21.8809 14.3364C21.4802 15.8706 20.1186 17 18.5005 17C16.8824 17 15.5207 15.8706 15.12 14.3364C15.0873 14.211 15.0709 14.1483 15.0693 13.8979C15.0684 13.7443 15.1254 13.3904 15.1746 13.2449C15.2548 13.0076 15.3416 12.8737 15.5152 12.6059L18.5005 8L21.4858 12.6059C21.6594 12.8737 21.7462 13.0076 21.8264 13.2449C21.8755 13.3904 21.9326 13.7443 21.9316 13.8979C21.93 14.1483 21.9137 14.211 21.8809 14.3364Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Jj1 = [
  Xj1,
  Qj1
];
function tI1(r, e) {
  return n(), o("svg", Yj1, Jj1);
}
const QT2 = /* @__PURE__ */ i(Wj1, [["render", tI1]]);
var eI1 = {}, rI1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nI1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), oI1 = /* @__PURE__ */ t("path", {
  d: "M8 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M8 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V16M21 8V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H16M21 16V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H16M3 12H3.01M7.5 12H7.51M16.5 12H16.51M12 12H12.01M21 12H21.01",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), iI1 = [
  nI1,
  oI1
];
function lI1(r, e) {
  return n(), o("svg", rI1, iI1);
}
const JT2 = /* @__PURE__ */ i(eI1, [["render", lI1]]);
var sI1 = {}, hI1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aI1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), dI1 = /* @__PURE__ */ t("path", {
  d: "M20 4L8.5 15.5M8.5 8.5L20 20M6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3ZM6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cI1 = [
  aI1,
  dI1
];
function _I1(r, e) {
  return n(), o("svg", hI1, cI1);
}
const tO2 = /* @__PURE__ */ i(sI1, [["render", _I1]]);
var CI1 = {}, fI1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vI1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), uI1 = /* @__PURE__ */ t("path", {
  d: "M4.5 8.6L21 17M21 7L4.5 15.4M6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3ZM6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wI1 = [
  vI1,
  uI1
];
function pI1(r, e) {
  return n(), o("svg", fI1, wI1);
}
const eO2 = /* @__PURE__ */ i(CI1, [["render", pI1]]);
var gI1 = {}, $I1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MI1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), LI1 = /* @__PURE__ */ t("path", {
  d: "M20 4L8.5 15.5M8.5 8.5L20 20M17.5 12H17.51M22 12H22.01M6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3ZM6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), kI1 = [
  MI1,
  LI1
];
function mI1(r, e) {
  return n(), o("svg", $I1, kI1);
}
const rO2 = /* @__PURE__ */ i(gI1, [["render", mI1]]);
var xI1 = {}, HI1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VI1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), ZI1 = /* @__PURE__ */ t("path", {
  d: "M4.5 8.6L21 17M21 7L4.5 15.4M17.5 12H17.51M22 12H22.01M6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3ZM6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), BI1 = [
  VI1,
  ZI1
];
function FI1(r, e) {
  return n(), o("svg", HI1, BI1);
}
const nO2 = /* @__PURE__ */ i(xI1, [["render", FI1]]);
var jI1 = {}, II1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bI1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1636)",
  fill: "none"
}, null, -1), yI1 = /* @__PURE__ */ t("path", {
  d: "M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DI1 = [
  bI1,
  yI1
];
function PI1(r, e) {
  return n(), o("svg", II1, DI1);
}
const oO2 = /* @__PURE__ */ i(jI1, [["render", PI1]]);
var AI1 = {}, SI1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TI1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1676)",
  fill: "none"
}, null, -1), OI1 = /* @__PURE__ */ t("path", {
  d: "M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EI1 = [
  TI1,
  OI1
];
function RI1(r, e) {
  return n(), o("svg", SI1, EI1);
}
const UI1 = /* @__PURE__ */ i(AI1, [["render", RI1]]);
var NI1 = {}, qI1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zI1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1716)",
  fill: "none"
}, null, -1), KI1 = /* @__PURE__ */ t("path", {
  d: "M21 21L16.65 16.65M11 6C13.7614 6 16 8.23858 16 11M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GI1 = [
  zI1,
  KI1
];
function WI1(r, e) {
  return n(), o("svg", qI1, GI1);
}
const iO2 = /* @__PURE__ */ i(NI1, [["render", WI1]]);
var YI1 = {}, XI1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QI1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1756)",
  fill: "none"
}, null, -1), JI1 = /* @__PURE__ */ t("path", {
  d: "M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tb1 = [
  QI1,
  JI1
];
function eb1(r, e) {
  return n(), o("svg", XI1, tb1);
}
const lO2 = /* @__PURE__ */ i(YI1, [["render", eb1]]);
var rb1 = {}, nb1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ob1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -556)",
  fill: "none"
}, null, -1), ib1 = /* @__PURE__ */ t("path", {
  d: "M10.4995 13.5001L20.9995 3.00005M10.6271 13.8281L13.2552 20.5861C13.4867 21.1815 13.6025 21.4791 13.7693 21.566C13.9139 21.6414 14.0862 21.6415 14.2308 21.5663C14.3977 21.4796 14.5139 21.1821 14.7461 20.587L21.3364 3.69925C21.5461 3.16207 21.6509 2.89348 21.5935 2.72185C21.5437 2.5728 21.4268 2.45583 21.2777 2.40604C21.1061 2.34871 20.8375 2.45352 20.3003 2.66315L3.41258 9.25349C2.8175 9.48572 2.51997 9.60183 2.43326 9.76873C2.35809 9.91342 2.35819 10.0857 2.43353 10.2303C2.52043 10.3971 2.81811 10.5128 3.41345 10.7444L10.1715 13.3725C10.2923 13.4195 10.3527 13.443 10.4036 13.4793C10.4487 13.5114 10.4881 13.5509 10.5203 13.596C10.5566 13.6468 10.5801 13.7073 10.6271 13.8281Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lb1 = [
  ob1,
  ib1
];
function sb1(r, e) {
  return n(), o("svg", nb1, lb1);
}
const sO2 = /* @__PURE__ */ i(rb1, [["render", sb1]]);
var hb1 = {}, ab1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, db1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -596)",
  fill: "none"
}, null, -1), cb1 = /* @__PURE__ */ t("path", {
  d: "M12.0005 18.9998V11.9998M12.292 19.0845L19.2704 21.4207C19.8173 21.6038 20.0908 21.6953 20.2594 21.6296C20.4059 21.5726 20.517 21.45 20.5594 21.2987C20.6082 21.1244 20.4903 20.8613 20.2545 20.3349L12.766 3.6222C12.5354 3.1075 12.4201 2.85015 12.2594 2.77041C12.1199 2.70113 11.956 2.70087 11.8162 2.7697C11.6553 2.84892 11.5392 3.1059 11.3069 3.61986L3.75244 20.3359C3.51474 20.8619 3.39589 21.1248 3.44422 21.2993C3.48619 21.4508 3.59697 21.5737 3.74329 21.6312C3.91178 21.6974 4.18567 21.6064 4.73346 21.4246L11.786 19.0838C11.8799 19.0527 11.9268 19.0371 11.9749 19.0309C12.0175 19.0255 12.0606 19.0255 12.1032 19.0311C12.1512 19.0374 12.1981 19.0531 12.292 19.0845Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _b1 = [
  db1,
  cb1
];
function Cb1(r, e) {
  return n(), o("svg", ab1, _b1);
}
const hO2 = /* @__PURE__ */ i(hb1, [["render", Cb1]]);
var fb1 = {}, vb1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ub1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -636)",
  fill: "none"
}, null, -1), wb1 = /* @__PURE__ */ t("path", {
  d: "M10.5004 12H5.00043M4.91577 12.2915L2.58085 19.2662C2.39742 19.8142 2.3057 20.0881 2.37152 20.2569C2.42868 20.4034 2.55144 20.5145 2.70292 20.5567C2.87736 20.6054 3.14083 20.4869 3.66776 20.2497L20.3792 12.7296C20.8936 12.4981 21.1507 12.3824 21.2302 12.2216C21.2993 12.082 21.2993 11.9181 21.2302 11.7784C21.1507 11.6177 20.8936 11.5019 20.3792 11.2705L3.66193 3.74776C3.13659 3.51135 2.87392 3.39315 2.69966 3.44164C2.54832 3.48375 2.42556 3.59454 2.36821 3.74078C2.30216 3.90917 2.3929 4.18255 2.57437 4.72931L4.91642 11.7856C4.94759 11.8795 4.96317 11.9264 4.96933 11.9744C4.97479 12.0171 4.97473 12.0602 4.96916 12.1028C4.96289 12.1508 4.94718 12.1977 4.91577 12.2915Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pb1 = [
  ub1,
  wb1
];
function gb1(r, e) {
  return n(), o("svg", vb1, pb1);
}
const aO2 = /* @__PURE__ */ i(fb1, [["render", gb1]]);
var $b1 = {}, Mb1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lb1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), kb1 = /* @__PURE__ */ t("path", {
  d: "M6 6H6.01M6 18H6.01M5.2 10H18.8C19.9201 10 20.4802 10 20.908 9.78201C21.2843 9.59027 21.5903 9.28431 21.782 8.90798C22 8.48016 22 7.92011 22 6.8V5.2C22 4.0799 22 3.51984 21.782 3.09202C21.5903 2.71569 21.2843 2.40973 20.908 2.21799C20.4802 2 19.9201 2 18.8 2H5.2C4.07989 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V6.8C2 7.92011 2 8.48016 2.21799 8.90798C2.40973 9.28431 2.71569 9.59027 3.09202 9.78201C3.51984 10 4.0799 10 5.2 10ZM5.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V17.2C22 16.0799 22 15.5198 21.782 15.092C21.5903 14.7157 21.2843 14.4097 20.908 14.218C20.4802 14 19.9201 14 18.8 14H5.2C4.07989 14 3.51984 14 3.09202 14.218C2.71569 14.4097 2.40973 14.7157 2.21799 15.092C2 15.5198 2 16.0799 2 17.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.0799 22 5.2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mb1 = [
  Lb1,
  kb1
];
function xb1(r, e) {
  return n(), o("svg", Mb1, mb1);
}
const dO2 = /* @__PURE__ */ i($b1, [["render", xb1]]);
var Hb1 = {}, Vb1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zb1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), Bb1 = /* @__PURE__ */ t("path", {
  d: "M6 8H6.01M6 16H6.01M6 12H18M6 12C3.79086 12 2 10.2091 2 8C2 5.79086 3.79086 4 6 4H18C20.2091 4 22 5.79086 22 8C22 10.2091 20.2091 12 18 12M6 12C3.79086 12 2 13.7909 2 16C2 18.2091 3.79086 20 6 20H18C20.2091 20 22 18.2091 22 16C22 13.7909 20.2091 12 18 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Fb1 = [
  Zb1,
  Bb1
];
function jb1(r, e) {
  return n(), o("svg", Vb1, Fb1);
}
const cO2 = /* @__PURE__ */ i(Hb1, [["render", jb1]]);
var Ib1 = {}, bb1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yb1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), Db1 = /* @__PURE__ */ t("path", {
  d: "M22 17.5L21.3083 7.46975C21.1997 5.89504 21.1454 5.10768 20.8041 4.51082C20.5036 3.98533 20.0512 3.56304 19.5062 3.29942C18.8873 3 18.0981 3 16.5196 3H7.48037C5.90191 3 5.11268 3 4.49376 3.29942C3.94884 3.56304 3.49642 3.98533 3.19594 4.51082C2.85464 5.10768 2.80034 5.89503 2.69174 7.46975L2 17.5M22 17.5C22 19.433 20.433 21 18.5 21H5.5C3.567 21 2 19.433 2 17.5M22 17.5C22 15.567 20.433 14 18.5 14H5.5C3.567 14 2 15.567 2 17.5M6 17.5H6.01M12 17.5H18",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Pb1 = [
  yb1,
  Db1
];
function Ab1(r, e) {
  return n(), o("svg", bb1, Pb1);
}
const _O2 = /* @__PURE__ */ i(Ib1, [["render", Ab1]]);
var Sb1 = {}, Tb1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ob1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), Eb1 = /* @__PURE__ */ t("path", {
  d: "M22 10.5L21.5256 6.70463C21.3395 5.21602 21.2465 4.47169 20.8961 3.9108C20.5875 3.41662 20.1416 3.02301 19.613 2.77804C19.013 2.5 18.2629 2.5 16.7626 2.5H7.23735C5.73714 2.5 4.98704 2.5 4.38702 2.77804C3.85838 3.02301 3.4125 3.41662 3.10386 3.9108C2.75354 4.47169 2.6605 5.21601 2.47442 6.70463L2 10.5M5.5 14.5H18.5M5.5 14.5C3.567 14.5 2 12.933 2 11C2 9.067 3.567 7.5 5.5 7.5H18.5C20.433 7.5 22 9.067 22 11C22 12.933 20.433 14.5 18.5 14.5M5.5 14.5C3.567 14.5 2 16.067 2 18C2 19.933 3.567 21.5 5.5 21.5H18.5C20.433 21.5 22 19.933 22 18C22 16.067 20.433 14.5 18.5 14.5M6 11H6.01M6 18H6.01M12 11H18M12 18H18",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Rb1 = [
  Ob1,
  Eb1
];
function Ub1(r, e) {
  return n(), o("svg", Tb1, Rb1);
}
const CO2 = /* @__PURE__ */ i(Sb1, [["render", Ub1]]);
var Nb1 = {}, qb1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zb1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), Kb1 = /* @__PURE__ */ t("path", {
  d: "M19 9C19 12.866 15.866 16 12 16M19 9C19 5.13401 15.866 2 12 2M19 9H5M12 16C8.13401 16 5 12.866 5 9M12 16C13.7509 14.0832 14.7468 11.5956 14.8009 9C14.7468 6.40442 13.7509 3.91685 12 2M12 16C10.2491 14.0832 9.25498 11.5956 9.20091 9C9.25498 6.40442 10.2491 3.91685 12 2M12 16V18M5 9C5 5.13401 8.13401 2 12 2M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20M14 20C14 18.8954 13.1046 18 12 18M14 20H21M10 20C10 18.8954 10.8954 18 12 18M10 20H3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Gb1 = [
  zb1,
  Kb1
];
function Wb1(r, e) {
  return n(), o("svg", qb1, Gb1);
}
const fO2 = /* @__PURE__ */ i(Nb1, [["render", Wb1]]);
var Yb1 = {}, Xb1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qb1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), Jb1 = /* @__PURE__ */ t("path", {
  d: "M20 12C20 16.4183 16.4183 20 12 20M20 12C20 7.58172 16.4183 4 12 4M20 12H4M12 20C7.58172 20 4 16.4183 4 12M12 20C14.001 17.8093 15.1388 14.9664 15.2006 12C15.1388 9.03363 14.001 6.19068 12 4M12 20C9.99898 17.8093 8.86235 14.9664 8.80055 12C8.86235 9.03363 9.99898 6.19068 12 4M4 12C4 7.58172 7.58172 4 12 4M6 20C6 21.1046 5.10457 22 4 22C2.89543 22 2 21.1046 2 20C2 18.8954 2.89543 18 4 18C5.10457 18 6 18.8954 6 20ZM22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20C18 18.8954 18.8954 18 20 18C21.1046 18 22 18.8954 22 20ZM6 4C6 5.10457 5.10457 6 4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4ZM22 4C22 5.10457 21.1046 6 20 6C18.8954 6 18 5.10457 18 4C18 2.89543 18.8954 2 20 2C21.1046 2 22 2.89543 22 4Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ty1 = [
  Qb1,
  Jb1
];
function ey1(r, e) {
  return n(), o("svg", Xb1, ty1);
}
const vO2 = /* @__PURE__ */ i(Yb1, [["render", ey1]]);
var ry1 = {}, ny1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oy1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1796)",
  fill: "none"
}, null, -1), iy1 = /* @__PURE__ */ t("path", {
  d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ly1 = /* @__PURE__ */ t("path", {
  d: "M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), sy1 = [
  oy1,
  iy1,
  ly1
];
function hy1(r, e) {
  return n(), o("svg", ny1, sy1);
}
const uO2 = /* @__PURE__ */ i(ry1, [["render", hy1]]);
var ay1 = {}, dy1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cy1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1836)",
  fill: "none"
}, null, -1), _y1 = /* @__PURE__ */ t("path", {
  d: "M9.3951 19.3711L9.97955 20.6856C10.1533 21.0768 10.4368 21.4093 10.7958 21.6426C11.1547 21.8759 11.5737 22.0001 12.0018 22C12.4299 22.0001 12.8488 21.8759 13.2078 21.6426C13.5667 21.4093 13.8503 21.0768 14.024 20.6856L14.6084 19.3711C14.8165 18.9047 15.1664 18.5159 15.6084 18.26C16.0532 18.0034 16.5678 17.8941 17.0784 17.9478L18.5084 18.1C18.9341 18.145 19.3637 18.0656 19.7451 17.8713C20.1265 17.6771 20.4434 17.3763 20.6573 17.0056C20.8715 16.635 20.9735 16.2103 20.9511 15.7829C20.9286 15.3555 20.7825 14.9438 20.5307 14.5978L19.684 13.4344C19.3825 13.0171 19.2214 12.5148 19.224 12C19.2239 11.4866 19.3865 10.9864 19.6884 10.5711L20.5351 9.40778C20.787 9.06175 20.933 8.65007 20.9555 8.22267C20.978 7.79528 20.8759 7.37054 20.6618 7C20.4479 6.62923 20.131 6.32849 19.7496 6.13423C19.3681 5.93997 18.9386 5.86053 18.5129 5.90556L17.0829 6.05778C16.5722 6.11141 16.0577 6.00212 15.6129 5.74556C15.17 5.48825 14.82 5.09736 14.6129 4.62889L14.024 3.31444C13.8503 2.92317 13.5667 2.59072 13.2078 2.3574C12.8488 2.12408 12.4299 1.99993 12.0018 2C11.5737 1.99993 11.1547 2.12408 10.7958 2.3574C10.4368 2.59072 10.1533 2.92317 9.97955 3.31444L9.3951 4.62889C9.18803 5.09736 8.83798 5.48825 8.3951 5.74556C7.95032 6.00212 7.43577 6.11141 6.9251 6.05778L5.49066 5.90556C5.06499 5.86053 4.6354 5.93997 4.25397 6.13423C3.87255 6.32849 3.55567 6.62923 3.34177 7C3.12759 7.37054 3.02555 7.79528 3.04804 8.22267C3.07052 8.65007 3.21656 9.06175 3.46844 9.40778L4.3151 10.5711C4.61704 10.9864 4.77964 11.4866 4.77955 12C4.77964 12.5134 4.61704 13.0137 4.3151 13.4289L3.46844 14.5922C3.21656 14.9382 3.07052 15.3499 3.04804 15.7773C3.02555 16.2047 3.12759 16.6295 3.34177 17C3.55589 17.3706 3.8728 17.6712 4.25417 17.8654C4.63554 18.0596 5.06502 18.1392 5.49066 18.0944L6.92066 17.9422C7.43133 17.8886 7.94587 17.9979 8.39066 18.2544C8.83519 18.511 9.18687 18.902 9.3951 19.3711Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Cy1 = /* @__PURE__ */ t("path", {
  d: "M12 15C13.6568 15 15 13.6569 15 12C15 10.3431 13.6568 9 12 9C10.3431 9 8.99998 10.3431 8.99998 12C8.99998 13.6569 10.3431 15 12 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fy1 = [
  cy1,
  _y1,
  Cy1
];
function vy1(r, e) {
  return n(), o("svg", dy1, fy1);
}
const wO2 = /* @__PURE__ */ i(ay1, [["render", vy1]]);
var uy1 = {}, wy1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, py1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1876)",
  fill: "none"
}, null, -1), gy1 = /* @__PURE__ */ t("path", {
  d: "M15.0505 9H5.5C4.11929 9 3 7.88071 3 6.5C3 5.11929 4.11929 4 5.5 4H15.0505M8.94949 20H18.5C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15H8.94949M3 17.5C3 19.433 4.567 21 6.5 21C8.433 21 10 19.433 10 17.5C10 15.567 8.433 14 6.5 14C4.567 14 3 15.567 3 17.5ZM21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $y1 = [
  py1,
  gy1
];
function My1(r, e) {
  return n(), o("svg", wy1, $y1);
}
const pO2 = /* @__PURE__ */ i(uy1, [["render", My1]]);
var Ly1 = {}, ky1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, my1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1916)",
  fill: "none"
}, null, -1), xy1 = /* @__PURE__ */ t("path", {
  d: "M3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8ZM9 16L21 16M9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Hy1 = [
  my1,
  xy1
];
function Vy1(r, e) {
  return n(), o("svg", ky1, Hy1);
}
const gO2 = /* @__PURE__ */ i(Ly1, [["render", Vy1]]);
var Zy1 = {}, By1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fy1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1956)",
  fill: "none"
}, null, -1), jy1 = /* @__PURE__ */ t("path", {
  d: "M21 12V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M16 7L12 3M12 3L8 7M12 3V15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Iy1 = [
  Fy1,
  jy1
];
function by1(r, e) {
  return n(), o("svg", By1, Iy1);
}
const $O2 = /* @__PURE__ */ i(Zy1, [["render", by1]]);
var yy1 = {}, Dy1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Py1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -1996)",
  fill: "none"
}, null, -1), Ay1 = /* @__PURE__ */ t("path", {
  d: "M7 11C6.07003 11 5.60504 11 5.22354 11.1022C4.18827 11.3796 3.37962 12.1883 3.10222 13.2235C3 13.605 3 14.07 3 15V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V15C21 14.07 21 13.605 20.8978 13.2235C20.6204 12.1883 19.8117 11.3796 18.7765 11.1022C18.395 11 17.93 11 17 11M16 7L12 3M12 3L8 7M12 3V15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Sy1 = [
  Py1,
  Ay1
];
function Ty1(r, e) {
  return n(), o("svg", Dy1, Sy1);
}
const MO2 = /* @__PURE__ */ i(yy1, [["render", Ty1]]);
var Oy1 = {}, Ey1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ry1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -2036)",
  fill: "none"
}, null, -1), Uy1 = /* @__PURE__ */ t("path", {
  d: "M21 9.00001L21 3.00001M21 3.00001H15M21 3.00001L12 12M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Ny1 = [
  Ry1,
  Uy1
];
function qy1(r, e) {
  return n(), o("svg", Ey1, Ny1);
}
const LO2 = /* @__PURE__ */ i(Oy1, [["render", qy1]]);
var zy1 = {}, Ky1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gy1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-608 -2076)",
  fill: "none"
}, null, -1), Wy1 = /* @__PURE__ */ t("path", {
  d: "M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Yy1 = [
  Gy1,
  Wy1
];
function Xy1(r, e) {
  return n(), o("svg", Ky1, Yy1);
}
const kO2 = /* @__PURE__ */ i(zy1, [["render", Xy1]]);
var Qy1 = {}, Jy1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tD1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), eD1 = /* @__PURE__ */ t("path", {
  d: "M21 6H17.8C16.1198 6 15.2798 6 14.638 6.32698C14.0735 6.6146 13.6146 7.07354 13.327 7.63803C13 8.27976 13 9.11984 13 10.8V12M21 6L18 3M21 6L18 9M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rD1 = [
  tD1,
  eD1
];
function nD1(r, e) {
  return n(), o("svg", Jy1, rD1);
}
const mO2 = /* @__PURE__ */ i(Qy1, [["render", nD1]]);
var oD1 = {}, iD1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lD1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), sD1 = /* @__PURE__ */ t("path", {
  d: "M20.7914 12.6074C21.0355 12.3981 21.1575 12.2935 21.2023 12.169C21.2415 12.0598 21.2415 11.9402 21.2023 11.831C21.1575 11.7065 21.0355 11.6018 20.7914 11.3926L12.3206 4.13196C11.9004 3.77176 11.6903 3.59166 11.5124 3.58725C11.3578 3.58342 11.2101 3.65134 11.1124 3.77122C11 3.90915 11 4.18589 11 4.73936V9.03462C8.86532 9.40807 6.91159 10.4897 5.45971 12.1139C3.87682 13.8845 3.00123 16.1759 3 18.551V19.1629C4.04934 17.8989 5.35951 16.8765 6.84076 16.1659C8.1467 15.5394 9.55842 15.1683 11 15.0705V19.2606C11 19.8141 11 20.0908 11.1124 20.2288C11.2101 20.3486 11.3578 20.4166 11.5124 20.4127C11.6903 20.4083 11.9004 20.2282 12.3206 19.868L20.7914 12.6074Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hD1 = [
  lD1,
  sD1
];
function aD1(r, e) {
  return n(), o("svg", iD1, hD1);
}
const xO2 = /* @__PURE__ */ i(oD1, [["render", aD1]]);
var dD1 = {}, cD1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _D1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), CD1 = /* @__PURE__ */ t("path", {
  d: "M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fD1 = [
  _D1,
  CD1
];
function vD1(r, e) {
  return n(), o("svg", cD1, fD1);
}
const HO2 = /* @__PURE__ */ i(dD1, [["render", vD1]]);
var uD1 = {}, wD1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pD1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), gD1 = /* @__PURE__ */ t("path", {
  d: "M11.302 21.6147C11.5234 21.7439 11.6341 21.8085 11.7903 21.842C11.9116 21.868 12.0884 21.868 12.2097 21.842C12.3659 21.8085 12.4766 21.7439 12.698 21.6147C14.646 20.4783 20 16.9083 20 11.9999V7.21747C20 6.41796 20 6.0182 19.8692 5.67457C19.7537 5.37101 19.566 5.10015 19.3223 4.8854C19.0465 4.64231 18.6722 4.50195 17.9236 4.22122L12.5618 2.21054C12.3539 2.13258 12.25 2.0936 12.143 2.07815C12.0482 2.06444 11.9518 2.06444 11.857 2.07815C11.75 2.0936 11.6461 2.13258 11.4382 2.21054L6.0764 4.22122C5.3278 4.50195 4.9535 4.64231 4.67766 4.8854C4.43398 5.10015 4.24627 5.37101 4.13076 5.67457C4 6.0182 4 6.41796 4 7.21747V11.9999C4 16.9083 9.35396 20.4783 11.302 21.6147Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $D1 = [
  pD1,
  gD1
];
function MD1(r, e) {
  return n(), o("svg", wD1, $D1);
}
const VO2 = /* @__PURE__ */ i(uD1, [["render", MD1]]);
var LD1 = {}, kD1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mD1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), xD1 = /* @__PURE__ */ t("path", {
  d: "M11.302 21.6149C11.5234 21.7441 11.6341 21.8087 11.7903 21.8422C11.9116 21.8682 12.0884 21.8682 12.2097 21.8422C12.3659 21.8087 12.4766 21.7441 12.698 21.6149C14.646 20.4785 20 16.9085 20 12.0001V8.20007C20 7.12617 20 6.58923 19.8345 6.20807C19.6662 5.82067 19.4986 5.61458 19.1536 5.37097C18.8141 5.13129 18.1486 4.99289 16.8177 4.71609C15.3508 4.41101 14.2243 3.8601 13.1944 3.06339C12.7005 2.68133 12.4536 2.49031 12.2603 2.43821C12.0564 2.38323 11.9436 2.38323 11.7397 2.43821C11.5464 2.49031 11.2995 2.68134 10.8056 3.06339C9.77572 3.8601 8.6492 4.41101 7.1823 4.71609C5.85137 4.99289 5.18591 5.13129 4.84645 5.37097C4.50142 5.61458 4.33379 5.82067 4.16554 6.20807C4 6.58923 4 7.12617 4 8.20007V12.0001C4 16.9085 9.35396 20.4785 11.302 21.6149Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), HD1 = [
  mD1,
  xD1
];
function VD1(r, e) {
  return n(), o("svg", kD1, HD1);
}
const ZO2 = /* @__PURE__ */ i(LD1, [["render", VD1]]);
var ZD1 = {}, BD1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FD1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), jD1 = /* @__PURE__ */ t("path", {
  d: "M12 2.50011V21.5001M20 12.0001C20 16.9086 14.646 20.4785 12.698 21.615C12.4766 21.7442 12.3659 21.8087 12.2097 21.8422C12.0884 21.8682 11.9116 21.8682 11.7903 21.8422C11.6341 21.8087 11.5234 21.7442 11.302 21.615C9.35396 20.4785 4 16.9086 4 12.0001V7.21772C4 6.4182 4 6.01845 4.13076 5.67482C4.24627 5.37126 4.43398 5.10039 4.67766 4.88564C4.9535 4.64255 5.3278 4.50219 6.0764 4.22146L11.4382 2.21079C11.6461 2.13283 11.75 2.09385 11.857 2.07839C11.9518 2.06469 12.0482 2.06469 12.143 2.07839C12.25 2.09385 12.3539 2.13283 12.5618 2.21079L17.9236 4.22146C18.6722 4.50219 19.0465 4.64255 19.3223 4.88564C19.566 5.10039 19.7537 5.37126 19.8692 5.67482C20 6.01845 20 6.4182 20 7.21772V12.0001Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ID1 = [
  FD1,
  jD1
];
function bD1(r, e) {
  return n(), o("svg", BD1, ID1);
}
const BO2 = /* @__PURE__ */ i(ZD1, [["render", bD1]]);
var yD1 = {}, DD1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PD1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), AD1 = /* @__PURE__ */ t("path", {
  d: "M9.21296 14.5001C9.52517 15.0946 10.1486 15.5001 10.8667 15.5001H13C14.1046 15.5001 15 14.6047 15 13.5001C15 12.3955 14.1046 11.5001 13 11.5001H11C9.89543 11.5001 9 10.6047 9 9.50011C9 8.39555 9.89543 7.50011 11 7.50011H13.1333C13.8514 7.50011 14.4748 7.90561 14.787 8.50011M12 6.00011V7.50011M12 15.5001V17.0001M20 12.0001C20 16.9086 14.646 20.4785 12.698 21.615C12.4766 21.7442 12.3659 21.8087 12.2097 21.8422C12.0884 21.8682 11.9116 21.8682 11.7903 21.8422C11.6341 21.8087 11.5234 21.7442 11.302 21.615C9.35396 20.4785 4 16.9086 4 12.0001V7.21772C4 6.4182 4 6.01845 4.13076 5.67482C4.24627 5.37126 4.43398 5.10039 4.67766 4.88564C4.9535 4.64255 5.3278 4.50219 6.0764 4.22146L11.4382 2.21079C11.6461 2.13283 11.75 2.09385 11.857 2.07839C11.9518 2.06469 12.0482 2.06469 12.143 2.07839C12.25 2.09385 12.3539 2.13283 12.5618 2.21079L17.9236 4.22146C18.6722 4.50219 19.0465 4.64255 19.3223 4.88564C19.566 5.10039 19.7537 5.37126 19.8692 5.67482C20 6.01845 20 6.4182 20 7.21772V12.0001Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), SD1 = [
  PD1,
  AD1
];
function TD1(r, e) {
  return n(), o("svg", DD1, SD1);
}
const FO2 = /* @__PURE__ */ i(yD1, [["render", TD1]]);
var OD1 = {}, ED1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, RD1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), UD1 = /* @__PURE__ */ t("path", {
  d: "M8.80868 3.19661L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999C20 12.7202 19.8847 13.4117 19.6818 14.0708M17.6219 17.6255C15.9362 19.5859 13.7879 20.9788 12.6996 21.6138C12.4772 21.7436 12.366 21.8085 12.2098 21.842C12.0885 21.868 11.9116 21.868 11.7904 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V5.77618C4 5.30923 4.28966 4.89125 4.72688 4.72729M3 2.99987L21 20.9999",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ND1 = [
  RD1,
  UD1
];
function qD1(r, e) {
  return n(), o("svg", ED1, ND1);
}
const jO2 = /* @__PURE__ */ i(OD1, [["render", qD1]]);
var zD1 = {}, KD1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GD1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), WD1 = /* @__PURE__ */ t("path", {
  d: "M12 14.4999V8.49987M9 11.4999H15M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), YD1 = [
  GD1,
  WD1
];
function XD1(r, e) {
  return n(), o("svg", KD1, YD1);
}
const IO2 = /* @__PURE__ */ i(zD1, [["render", XD1]]);
var QD1 = {}, JD1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tP1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), eP1 = /* @__PURE__ */ t("path", {
  d: "M9 11.4999L11 13.4999L15.5 8.99987M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rP1 = [
  tP1,
  eP1
];
function nP1(r, e) {
  return n(), o("svg", JD1, rP1);
}
const bO2 = /* @__PURE__ */ i(QD1, [["render", nP1]]);
var oP1 = {}, iP1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lP1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "580",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), sP1 = /* @__PURE__ */ t("path", {
  d: "M13 7.49987L10 10.4999L14 12.4999L11 15.4999M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hP1 = [
  lP1,
  sP1
];
function aP1(r, e) {
  return n(), o("svg", iP1, hP1);
}
const yO2 = /* @__PURE__ */ i(oP1, [["render", aP1]]);
var dP1 = {}, cP1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _P1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), CP1 = /* @__PURE__ */ t("path", {
  d: "M5.52 2.64L3.96 4.72C3.65102 5.13198 3.49652 5.33797 3.50011 5.51039C3.50323 5.66044 3.57358 5.80115 3.69175 5.89368C3.82754 6 4.08503 6 4.6 6H19.4C19.915 6 20.1725 6 20.3083 5.89368C20.4264 5.80115 20.4968 5.66044 20.4999 5.51039C20.5035 5.33797 20.349 5.13198 20.04 4.72L18.48 2.64M5.52 2.64C5.696 2.40533 5.784 2.288 5.89552 2.20338C5.9943 2.12842 6.10616 2.0725 6.22539 2.03845C6.36 2 6.50667 2 6.8 2H17.2C17.4933 2 17.64 2 17.7746 2.03845C17.8938 2.0725 18.0057 2.12842 18.1045 2.20338C18.216 2.288 18.304 2.40533 18.48 2.64M5.52 2.64L3.64 5.14666C3.40254 5.46328 3.28381 5.62159 3.1995 5.79592C3.12469 5.95062 3.07012 6.11431 3.03715 6.28296C3 6.47301 3 6.6709 3 7.06666L3 18.8C3 19.9201 3 20.4802 3.21799 20.908C3.40973 21.2843 3.71569 21.5903 4.09202 21.782C4.51984 22 5.07989 22 6.2 22L17.8 22C18.9201 22 19.4802 22 19.908 21.782C20.2843 21.5903 20.5903 21.2843 20.782 20.908C21 20.4802 21 19.9201 21 18.8V7.06667C21 6.6709 21 6.47301 20.9628 6.28296C20.9299 6.11431 20.8753 5.95062 20.8005 5.79592C20.7162 5.62159 20.5975 5.46328 20.36 5.14667L18.48 2.64M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fP1 = [
  _P1,
  CP1
];
function vP1(r, e) {
  return n(), o("svg", cP1, fP1);
}
const DO2 = /* @__PURE__ */ i(dP1, [["render", vP1]]);
var uP1 = {}, wP1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pP1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), gP1 = /* @__PURE__ */ t("path", {
  d: "M16.0004 9V6C16.0004 3.79086 14.2095 2 12.0004 2C9.79123 2 8.00037 3.79086 8.00037 6V9M3.59237 10.352L2.99237 16.752C2.82178 18.5717 2.73648 19.4815 3.03842 20.1843C3.30367 20.8016 3.76849 21.3121 4.35839 21.6338C5.0299 22 5.94374 22 7.77142 22H16.2293C18.057 22 18.9708 22 19.6423 21.6338C20.2322 21.3121 20.6971 20.8016 20.9623 20.1843C21.2643 19.4815 21.179 18.5717 21.0084 16.752L20.4084 10.352C20.2643 8.81535 20.1923 8.04704 19.8467 7.46616C19.5424 6.95458 19.0927 6.54511 18.555 6.28984C17.9444 6 17.1727 6 15.6293 6L8.37142 6C6.82806 6 6.05638 6 5.44579 6.28984C4.90803 6.54511 4.45838 6.95458 4.15403 7.46616C3.80846 8.04704 3.73643 8.81534 3.59237 10.352Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $P1 = [
  pP1,
  gP1
];
function MP1(r, e) {
  return n(), o("svg", wP1, $P1);
}
const PO2 = /* @__PURE__ */ i(uP1, [["render", MP1]]);
var LP1 = {}, kP1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mP1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), xP1 = /* @__PURE__ */ t("path", {
  d: "M15.9996 8C15.9996 9.06087 15.5782 10.0783 14.828 10.8284C14.0779 11.5786 13.0605 12 11.9996 12C10.9387 12 9.92131 11.5786 9.17116 10.8284C8.42102 10.0783 7.99959 9.06087 7.99959 8M3.63281 7.40138L2.93281 15.8014C2.78243 17.6059 2.70724 18.5082 3.01227 19.2042C3.28027 19.8157 3.74462 20.3204 4.33177 20.6382C5.00006 21 5.90545 21 7.71623 21H16.283C18.0937 21 18.9991 21 19.6674 20.6382C20.2546 20.3204 20.7189 19.8157 20.9869 19.2042C21.2919 18.5082 21.2167 17.6059 21.0664 15.8014L20.3664 7.40138C20.237 5.84875 20.1723 5.07243 19.8285 4.48486C19.5257 3.96744 19.0748 3.5526 18.5341 3.29385C17.92 3 17.141 3 15.583 3L8.41623 3C6.85821 3 6.07921 3 5.4651 3.29384C4.92433 3.5526 4.47349 3.96744 4.17071 4.48486C3.82689 5.07243 3.76219 5.84875 3.63281 7.40138Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), HP1 = [
  mP1,
  xP1
];
function VP1(r, e) {
  return n(), o("svg", kP1, HP1);
}
const AO2 = /* @__PURE__ */ i(LP1, [["render", VP1]]);
var ZP1 = {}, BP1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FP1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), jP1 = /* @__PURE__ */ t("path", {
  d: "M2 2H3.30616C3.55218 2 3.67519 2 3.77418 2.04524C3.86142 2.08511 3.93535 2.14922 3.98715 2.22995C4.04593 2.32154 4.06333 2.44332 4.09812 2.68686L4.57143 6M4.57143 6L5.62332 13.7314C5.75681 14.7125 5.82355 15.2031 6.0581 15.5723C6.26478 15.8977 6.56108 16.1564 6.91135 16.3174C7.30886 16.5 7.80394 16.5 8.79411 16.5H17.352C18.2945 16.5 18.7658 16.5 19.151 16.3304C19.4905 16.1809 19.7818 15.9398 19.9923 15.6342C20.2309 15.2876 20.3191 14.8247 20.4955 13.8988L21.8191 6.94969C21.8812 6.62381 21.9122 6.46087 21.8672 6.3335C21.8278 6.22177 21.7499 6.12768 21.6475 6.06802C21.5308 6 21.365 6 21.0332 6H4.57143ZM10 21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21C8 20.4477 8.44772 20 9 20C9.55228 20 10 20.4477 10 21ZM18 21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21C16 20.4477 16.4477 20 17 20C17.5523 20 18 20.4477 18 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), IP1 = [
  FP1,
  jP1
];
function bP1(r, e) {
  return n(), o("svg", BP1, IP1);
}
const SO2 = /* @__PURE__ */ i(ZP1, [["render", bP1]]);
var yP1 = {}, DP1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PP1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -516)",
  fill: "none"
}, null, -1), AP1 = /* @__PURE__ */ t("path", {
  d: "M6.50014 17H17.3294C18.2793 17 18.7543 17 19.1414 16.8284C19.4827 16.6771 19.7748 16.4333 19.9847 16.1246C20.2228 15.7744 20.3078 15.3071 20.4777 14.3724L21.8285 6.94311C21.8874 6.61918 21.9169 6.45721 21.8714 6.33074C21.8315 6.21979 21.7536 6.12651 21.6516 6.06739C21.5353 6 21.3707 6 21.0414 6H5.00014M2 2H3.3164C3.55909 2 3.68044 2 3.77858 2.04433C3.86507 2.0834 3.93867 2.14628 3.99075 2.22563C4.04984 2.31565 4.06876 2.43551 4.10662 2.67523L6.89338 20.3248C6.93124 20.5645 6.95016 20.6843 7.00925 20.7744C7.06133 20.8537 7.13493 20.9166 7.22142 20.9557C7.31956 21 7.44091 21 7.6836 21H19",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), SP1 = [
  PP1,
  AP1
];
function TP1(r, e) {
  return n(), o("svg", DP1, SP1);
}
const TO2 = /* @__PURE__ */ i(yP1, [["render", TP1]]);
var OP1 = {}, EP1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, RP1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -556)",
  fill: "none"
}, null, -1), UP1 = /* @__PURE__ */ t("path", {
  d: "M5.00014 14H18.1359C19.1487 14 19.6551 14 20.0582 13.8112C20.4134 13.6448 20.7118 13.3777 20.9163 13.0432C21.1485 12.6633 21.2044 12.16 21.3163 11.1534L21.9013 5.88835C21.9355 5.58088 21.9525 5.42715 21.9031 5.30816C21.8597 5.20366 21.7821 5.11697 21.683 5.06228C21.5702 5 21.4155 5 21.1062 5H4.50014M2 2H3.24844C3.51306 2 3.64537 2 3.74889 2.05032C3.84002 2.09463 3.91554 2.16557 3.96544 2.25376C4.02212 2.35394 4.03037 2.48599 4.04688 2.7501L4.95312 17.2499C4.96963 17.514 4.97788 17.6461 5.03456 17.7462C5.08446 17.8344 5.15998 17.9054 5.25111 17.9497C5.35463 18 5.48694 18 5.75156 18H19M7.5 21.5H7.51M16.5 21.5H16.51M8 21.5C8 21.7761 7.77614 22 7.5 22C7.22386 22 7 21.7761 7 21.5C7 21.2239 7.22386 21 7.5 21C7.77614 21 8 21.2239 8 21.5ZM17 21.5C17 21.7761 16.7761 22 16.5 22C16.2239 22 16 21.7761 16 21.5C16 21.2239 16.2239 21 16.5 21C16.7761 21 17 21.2239 17 21.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), NP1 = [
  RP1,
  UP1
];
function qP1(r, e) {
  return n(), o("svg", EP1, NP1);
}
const OO2 = /* @__PURE__ */ i(OP1, [["render", qP1]]);
var zP1 = {}, KP1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GP1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -836)",
  fill: "none"
}, null, -1), WP1 = /* @__PURE__ */ t("path", {
  d: "M18 15L21 18M21 18L18 21M21 18H18.5689C17.6297 18 17.1601 18 16.7338 17.8705C16.3564 17.7559 16.0054 17.5681 15.7007 17.3176C15.3565 17.0348 15.096 16.644 14.575 15.8626L14.3333 15.5M18 3L21 6M21 6L18 9M21 6H18.5689C17.6297 6 17.1601 6 16.7338 6.12945C16.3564 6.24406 16.0054 6.43194 15.7007 6.68236C15.3565 6.96523 15.096 7.35597 14.575 8.13744L9.42496 15.8626C8.90398 16.644 8.64349 17.0348 8.29933 17.3176C7.99464 17.5681 7.64357 17.7559 7.2662 17.8705C6.83994 18 6.37033 18 5.43112 18H3M3 6H5.43112C6.37033 6 6.83994 6 7.2662 6.12945C7.64357 6.24406 7.99464 6.43194 8.29933 6.68236C8.64349 6.96523 8.90398 7.35597 9.42496 8.13744L9.66667 8.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), YP1 = [
  GP1,
  WP1
];
function XP1(r, e) {
  return n(), o("svg", KP1, YP1);
}
const EO2 = /* @__PURE__ */ i(zP1, [["render", XP1]]);
var QP1 = {}, JP1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tA1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -876)",
  fill: "none"
}, null, -1), eA1 = /* @__PURE__ */ t("path", {
  d: "M21 16V21M21 21H16M21 21L15 15M3 3L9 9M16 3H21M21 3V8M21 3L3 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rA1 = [
  tA1,
  eA1
];
function nA1(r, e) {
  return n(), o("svg", JP1, rA1);
}
const RO2 = /* @__PURE__ */ i(QP1, [["render", nA1]]);
var oA1 = {}, iA1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lA1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -916)",
  fill: "none"
}, null, -1), sA1 = /* @__PURE__ */ t("path", {
  d: "M16.2426 7.75738C18.5858 10.1005 18.5858 13.8995 16.2426 16.2427M7.75736 16.2426C5.41421 13.8995 5.41421 10.1005 7.75736 7.75735M4.92893 19.0711C1.02369 15.1658 1.02369 8.8342 4.92893 4.92896M19.0711 4.929C22.9763 8.83424 22.9763 15.1659 19.0711 19.0711M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8955 10.8954 10 12 10C13.1046 10 14 10.8955 14 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hA1 = [
  lA1,
  sA1
];
function aA1(r, e) {
  return n(), o("svg", iA1, hA1);
}
const UO2 = /* @__PURE__ */ i(oA1, [["render", aA1]]);
var dA1 = {}, cA1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _A1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -956)",
  fill: "none"
}, null, -1), CA1 = /* @__PURE__ */ t("path", {
  d: "M16.2427 5.75732C18.5858 8.10047 18.5858 11.8995 16.2427 14.2426M7.75734 14.2426C5.41419 11.8995 5.41419 8.10047 7.75734 5.75732M4.92869 17.0711C1.02345 13.1658 1.02345 6.8342 4.92869 2.92896M19.0713 2.92896C22.9765 6.8342 22.9765 13.1658 19.0713 17.0711M12 12C13.1045 12 14 11.1046 14 10C14 8.89543 13.1045 8 12 8C10.8954 8 9.99998 8.89543 9.99998 10C9.99998 11.1046 10.8954 12 12 12ZM12 12V21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fA1 = [
  _A1,
  CA1
];
function vA1(r, e) {
  return n(), o("svg", cA1, fA1);
}
const NO2 = /* @__PURE__ */ i(dA1, [["render", vA1]]);
var uA1 = {}, wA1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pA1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -996)",
  fill: "none"
}, null, -1), gA1 = /* @__PURE__ */ t("path", {
  d: "M10.5858 13.4142C9.80474 12.6332 9.80474 11.3668 10.5858 10.5858C11.3668 9.80474 12.6332 9.80474 13.4142 10.5858C14.1953 11.3668 14.1953 12.6332 13.4142 13.4142M7.75736 16.2426C5.41421 13.8995 5.41421 10.1005 7.75736 7.75736C10.1005 5.41421 13.8995 5.41421 16.2426 7.75736C18.5858 10.1005 18.5858 13.8995 16.2426 16.2426M4.92893 19.0711C1.02369 15.1658 1.02369 8.83418 4.92893 4.92893C8.83418 1.02369 15.1658 1.02369 19.0711 4.92893C22.9763 8.83418 22.9763 15.1658 19.0711 19.0711",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $A1 = [
  pA1,
  gA1
];
function MA1(r, e) {
  return n(), o("svg", wA1, $A1);
}
const qO2 = /* @__PURE__ */ i(uA1, [["render", MA1]]);
var LA1 = {}, kA1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mA1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -1036)",
  fill: "none"
}, null, -1), xA1 = /* @__PURE__ */ t("path", {
  d: "M4 6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), HA1 = /* @__PURE__ */ t("path", {
  d: "M8 13.8C8 13.52 8 13.38 8.0545 13.273C8.10243 13.1789 8.17892 13.1024 8.273 13.0545C8.37996 13 8.51997 13 8.8 13H15.2C15.48 13 15.62 13 15.727 13.0545C15.8211 13.1024 15.8976 13.1789 15.9455 13.273C16 13.38 16 13.52 16 13.8V17.2C16 17.48 16 17.62 15.9455 17.727C15.8976 17.8211 15.8211 17.8976 15.727 17.9455C15.62 18 15.48 18 15.2 18H8.8C8.51997 18 8.37996 18 8.273 17.9455C8.17892 17.8976 8.10243 17.8211 8.0545 17.727C8 17.62 8 17.48 8 17.2V13.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VA1 = [
  mA1,
  xA1,
  HA1
];
function ZA1(r, e) {
  return n(), o("svg", kA1, VA1);
}
const zO2 = /* @__PURE__ */ i(LA1, [["render", ZA1]]);
var BA1 = {}, FA1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jA1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -516)",
  fill: "none"
}, null, -1), IA1 = /* @__PURE__ */ t("path", {
  d: "M19.7141 6.9999L18.2856 16.9999M6.14286 7L4.35714 17M18 5L8 5M16 19L6 19M5.6 7H6.4C6.96005 7 7.24008 7 7.45399 6.89101C7.64215 6.79513 7.79513 6.64215 7.89101 6.45399C8 6.24008 8 5.96005 8 5.4V4.6C8 4.03995 8 3.75992 7.89101 3.54601C7.79513 3.35785 7.64215 3.20487 7.45399 3.10899C7.24008 3 6.96005 3 6.4 3H5.6C5.03995 3 4.75992 3 4.54601 3.10899C4.35785 3.20487 4.20487 3.35785 4.10899 3.54601C4 3.75992 4 4.03995 4 4.6V5.4C4 5.96005 4 6.24008 4.10899 6.45399C4.20487 6.64215 4.35785 6.79513 4.54601 6.89101C4.75992 7 5.03995 7 5.6 7ZM3.6 21H4.4C4.96005 21 5.24008 21 5.45399 20.891C5.64215 20.7951 5.79513 20.6422 5.89101 20.454C6 20.2401 6 19.9601 6 19.4V18.6C6 18.0399 6 17.7599 5.89101 17.546C5.79513 17.3578 5.64215 17.2049 5.45399 17.109C5.24008 17 4.96005 17 4.4 17H3.6C3.03995 17 2.75992 17 2.54601 17.109C2.35785 17.2049 2.20487 17.3578 2.10899 17.546C2 17.7599 2 18.0399 2 18.6V19.4C2 19.9601 2 20.2401 2.10899 20.454C2.20487 20.6422 2.35785 20.7951 2.54601 20.891C2.75992 21 3.03995 21 3.6 21ZM19.6 7H20.4C20.9601 7 21.2401 7 21.454 6.89101C21.6422 6.79513 21.7951 6.64215 21.891 6.45399C22 6.24008 22 5.96005 22 5.4V4.6C22 4.03995 22 3.75992 21.891 3.54601C21.7951 3.35785 21.6422 3.20487 21.454 3.10899C21.2401 3 20.9601 3 20.4 3H19.6C19.0399 3 18.7599 3 18.546 3.10899C18.3578 3.20487 18.2049 3.35785 18.109 3.54601C18 3.75992 18 4.03995 18 4.6V5.4C18 5.96005 18 6.24008 18.109 6.45399C18.2049 6.64215 18.3578 6.79513 18.546 6.89101C18.7599 7 19.0399 7 19.6 7ZM17.6 21H18.4C18.9601 21 19.2401 21 19.454 20.891C19.6422 20.7951 19.7951 20.6422 19.891 20.454C20 20.2401 20 19.9601 20 19.4V18.6C20 18.0399 20 17.7599 19.891 17.546C19.7951 17.3578 19.6422 17.2049 19.454 17.109C19.2401 17 18.9601 17 18.4 17H17.6C17.0399 17 16.7599 17 16.546 17.109C16.3578 17.2049 16.2049 17.3578 16.109 17.546C16 17.7599 16 18.0399 16 18.6V19.4C16 19.9601 16 20.2401 16.109 20.454C16.2049 20.6422 16.3578 20.7951 16.546 20.891C16.7599 21 17.0399 21 17.6 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bA1 = [
  jA1,
  IA1
];
function yA1(r, e) {
  return n(), o("svg", FA1, bA1);
}
const KO2 = /* @__PURE__ */ i(BA1, [["render", yA1]]);
var DA1 = {}, PA1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AA1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -1076)",
  fill: "none"
}, null, -1), SA1 = /* @__PURE__ */ t("path", {
  d: "M5 19V5M16.4005 6.07961L10.5617 10.7506C10.0279 11.1777 9.76097 11.3912 9.66433 11.6492C9.5796 11.8754 9.5796 12.1246 9.66433 12.3508C9.76097 12.6088 10.0279 12.8223 10.5617 13.2494L16.4005 17.9204C17.2327 18.5861 17.6487 18.919 17.9989 18.9194C18.3035 18.9197 18.5916 18.7812 18.7815 18.5432C19 18.2695 19 17.7367 19 16.671V7.329C19 6.2633 19 5.73045 18.7815 5.45677C18.5916 5.21876 18.3035 5.0803 17.9989 5.08063C17.6487 5.081 17.2327 5.41387 16.4005 6.07961Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TA1 = [
  AA1,
  SA1
];
function OA1(r, e) {
  return n(), o("svg", PA1, TA1);
}
const GO2 = /* @__PURE__ */ i(DA1, [["render", OA1]]);
var EA1 = {}, RA1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UA1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -1116)",
  fill: "none"
}, null, -1), NA1 = /* @__PURE__ */ t("path", {
  d: "M19 5V19M7.59951 17.9204L13.4383 13.2494C13.9721 12.8223 14.239 12.6088 14.3357 12.3508C14.4204 12.1246 14.4204 11.8754 14.3357 11.6492C14.239 11.3912 13.9721 11.1777 13.4383 10.7506L7.59951 6.07961C6.76734 5.41387 6.35125 5.081 6.00108 5.08063C5.69654 5.0803 5.40845 5.21876 5.21846 5.45677C5 5.73045 5 6.2633 5 7.329V16.671C5 17.7367 5 18.2695 5.21846 18.5432C5.40845 18.7812 5.69654 18.9197 6.00108 18.9194C6.35125 18.919 6.76734 18.5861 7.59951 17.9204Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qA1 = [
  UA1,
  NA1
];
function zA1(r, e) {
  return n(), o("svg", RA1, qA1);
}
const WO2 = /* @__PURE__ */ i(EA1, [["render", zA1]]);
var KA1 = {}, GA1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WA1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), YA1 = /* @__PURE__ */ t("path", {
  d: "M4.93 4.93L19.07 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XA1 = [
  WA1,
  YA1
];
function QA1(r, e) {
  return n(), o("svg", GA1, XA1);
}
const YO2 = /* @__PURE__ */ i(KA1, [["render", QA1]]);
var JA1 = {}, tS1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eS1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), rS1 = /* @__PURE__ */ t("path", {
  d: "M4.93 4.93L19.07 19.07M19.0699 4.92999L4.92993 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nS1 = [
  eS1,
  rS1
];
function oS1(r, e) {
  return n(), o("svg", tS1, nS1);
}
const XO2 = /* @__PURE__ */ i(JA1, [["render", oS1]]);
var iS1 = {}, lS1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sS1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), hS1 = /* @__PURE__ */ t("path", {
  d: "M7 22L17 2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aS1 = [
  sS1,
  hS1
];
function dS1(r, e) {
  return n(), o("svg", lS1, aS1);
}
const QO2 = /* @__PURE__ */ i(iS1, [["render", dS1]]);
var cS1 = {}, _S1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CS1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), fS1 = /* @__PURE__ */ t("path", {
  d: "M4.93 4.93L19.07 19.07M2 8.52274V15.4773C2 15.7218 2 15.8441 2.02763 15.9592C2.05213 16.0613 2.09253 16.1588 2.14736 16.2483C2.2092 16.3492 2.29568 16.4357 2.46863 16.6086L7.39137 21.5314C7.56432 21.7043 7.6508 21.7908 7.75172 21.8526C7.84119 21.9075 7.93873 21.9479 8.04077 21.9724C8.15586 22 8.27815 22 8.52274 22H15.4773C15.7218 22 15.8441 22 15.9592 21.9724C16.0613 21.9479 16.1588 21.9075 16.2483 21.8526C16.3492 21.7908 16.4357 21.7043 16.6086 21.5314L21.5314 16.6086C21.7043 16.4357 21.7908 16.3492 21.8526 16.2483C21.9075 16.1588 21.9479 16.0613 21.9724 15.9592C22 15.8441 22 15.7218 22 15.4773V8.52274C22 8.27815 22 8.15586 21.9724 8.04077C21.9479 7.93873 21.9075 7.84119 21.8526 7.75172C21.7908 7.6508 21.7043 7.56432 21.5314 7.39137L16.6086 2.46863C16.4357 2.29568 16.3492 2.2092 16.2483 2.14736C16.1588 2.09253 16.0613 2.05213 15.9592 2.02763C15.8441 2 15.7218 2 15.4773 2H8.52274C8.27815 2 8.15586 2 8.04077 2.02763C7.93873 2.05213 7.84119 2.09253 7.75172 2.14736C7.6508 2.2092 7.56432 2.29568 7.39137 2.46863L2.46863 7.39137C2.29568 7.56432 2.2092 7.6508 2.14736 7.75172C2.09253 7.84119 2.05213 7.93873 2.02763 8.04077C2 8.15586 2 8.27815 2 8.52274Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vS1 = [
  CS1,
  fS1
];
function uS1(r, e) {
  return n(), o("svg", _S1, vS1);
}
const JO2 = /* @__PURE__ */ i(cS1, [["render", uS1]]);
var wS1 = {}, pS1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gS1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -1156)",
  fill: "none"
}, null, -1), $S1 = /* @__PURE__ */ t("path", {
  d: "M5 21V14M5 10V3M12 21V12M12 8V3M19 21V16M19 12V3M2 14H8M9 8H15M16 16H22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), MS1 = [
  gS1,
  $S1
];
function LS1(r, e) {
  return n(), o("svg", pS1, MS1);
}
const tE2 = /* @__PURE__ */ i(wS1, [["render", LS1]]);
var kS1 = {}, mS1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xS1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-608 -1196)",
  fill: "none"
}, null, -1), HS1 = /* @__PURE__ */ t("path", {
  d: "M5 21L5 15M5 15C6.10457 15 7 14.1046 7 13C7 11.8954 6.10457 11 5 11C3.89543 11 3 11.8954 3 13C3 14.1046 3.89543 15 5 15ZM5 7V3M12 21V15M12 7V3M12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7ZM19 21V17M19 17C20.1046 17 21 16.1046 21 15C21 13.8954 20.1046 13 19 13C17.8954 13 17 13.8954 17 15C17 16.1046 17.8954 17 19 17ZM19 9V3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VS1 = [
  xS1,
  HS1
];
function ZS1(r, e) {
  return n(), o("svg", mS1, VS1);
}
const eE2 = /* @__PURE__ */ i(kS1, [["render", ZS1]]);
var BS1 = {}, FS1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jS1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), IS1 = /* @__PURE__ */ t("path", {
  d: "M15.0505 9H5.5C4.11929 9 3 7.88071 3 6.5C3 5.11929 4.11929 4 5.5 4H15.0505M8.94949 20H18.5C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15H8.94949M3 17.5C3 19.433 4.567 21 6.5 21C8.433 21 10 19.433 10 17.5C10 15.567 8.433 14 6.5 14C4.567 14 3 15.567 3 17.5ZM21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bS1 = [
  jS1,
  IS1
];
function yS1(r, e) {
  return n(), o("svg", FS1, bS1);
}
const rE2 = /* @__PURE__ */ i(BS1, [["render", yS1]]);
var DS1 = {}, PS1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AS1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), SS1 = /* @__PURE__ */ t("path", {
  d: "M3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8ZM9 16L21 16M9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TS1 = [
  AS1,
  SS1
];
function OS1(r, e) {
  return n(), o("svg", PS1, TS1);
}
const nE2 = /* @__PURE__ */ i(DS1, [["render", OS1]]);
var ES1 = {}, RS1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, US1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), NS1 = /* @__PURE__ */ t("path", {
  d: "M18.0622 8.5L5.9378 15.5M18.0622 8.5L19.1602 4.40192M18.0622 8.5L22.1602 9.59808M5.9378 15.5L1.83972 14.4019M5.9378 15.5L4.83972 19.5981M18.0621 15.4999L5.93771 8.49986M18.0621 15.4999L22.1602 14.4018M18.0621 15.4999L19.1602 19.598M5.93771 8.49986L4.83986 4.40203M5.93771 8.49986L1.83986 9.59819M12 5L12 19M12 5L8.99998 2M12 5L15 2M12 19L8.99998 22M12 19L15 22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qS1 = [
  US1,
  NS1
];
function zS1(r, e) {
  return n(), o("svg", RS1, qS1);
}
const oE2 = /* @__PURE__ */ i(ES1, [["render", zS1]]);
var KS1 = {}, GS1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WS1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), YS1 = /* @__PURE__ */ t("path", {
  d: "M12 8V16M12 8V2M12 8L7 3M12 8L17 3M12 16V22M12 16L7 21M12 16L17 21M16 12H8M16 12H22M16 12L21 7M16 12L21 17M8 12H2M8 12L3 7M8 12L3 17",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XS1 = [
  WS1,
  YS1
];
function QS1(r, e) {
  return n(), o("svg", GS1, XS1);
}
const iE2 = /* @__PURE__ */ i(KS1, [["render", QS1]]);
var JS1 = {}, tT1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eT1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -556)",
  fill: "none"
}, null, -1), rT1 = /* @__PURE__ */ t("path", {
  d: "M12 18L12 6M12 18L9 16M12 18L15 16M12 6L9 8M12 6L15 8M21 3H3M21 21H3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nT1 = [
  eT1,
  rT1
];
function oT1(r, e) {
  return n(), o("svg", tT1, nT1);
}
const lE2 = /* @__PURE__ */ i(JS1, [["render", oT1]]);
var iT1 = {}, lT1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sT1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -596)",
  fill: "none"
}, null, -1), hT1 = /* @__PURE__ */ t("path", {
  d: "M21 3H3M21 21H3M12 17.5L12 6.50004M15.0001 6.50001L9 6.5M15.0001 17.5L9 17.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aT1 = [
  sT1,
  hT1
];
function dT1(r, e) {
  return n(), o("svg", lT1, aT1);
}
const sE2 = /* @__PURE__ */ i(iT1, [["render", dT1]]);
var cT1 = {}, _T1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CT1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -636)",
  fill: "none"
}, null, -1), fT1 = /* @__PURE__ */ t("path", {
  d: "M6 12H18M6 12L8 9M6 12L8 15M18 12L16 9M18 12L16 15M21 21V3M3 21V3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vT1 = [
  CT1,
  fT1
];
function uT1(r, e) {
  return n(), o("svg", _T1, vT1);
}
const hE2 = /* @__PURE__ */ i(cT1, [["render", uT1]]);
var wT1 = {}, pT1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gT1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -676)",
  fill: "none"
}, null, -1), $T1 = /* @__PURE__ */ t("path", {
  d: "M21 21V3M3 21V3M6.5 12H17.5M17.5 15L17.5 9M6.5 15L6.5 9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), MT1 = [
  gT1,
  $T1
];
function LT1(r, e) {
  return n(), o("svg", pT1, MT1);
}
const aE2 = /* @__PURE__ */ i(wT1, [["render", LT1]]);
var kT1 = {}, mT1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xT1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), HT1 = /* @__PURE__ */ t("path", {
  d: "M12 6H12.01M8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22ZM12.5 6C12.5 6.27614 12.2761 6.5 12 6.5C11.7239 6.5 11.5 6.27614 11.5 6C11.5 5.72386 11.7239 5.5 12 5.5C12.2761 5.5 12.5 5.72386 12.5 6ZM16 14C16 16.2091 14.2091 18 12 18C9.79086 18 8 16.2091 8 14C8 11.7909 9.79086 10 12 10C14.2091 10 16 11.7909 16 14Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VT1 = [
  xT1,
  HT1
];
function ZT1(r, e) {
  return n(), o("svg", mT1, VT1);
}
const dE2 = /* @__PURE__ */ i(kT1, [["render", ZT1]]);
var BT1 = {}, FT1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jT1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), IT1 = /* @__PURE__ */ t("path", {
  d: "M12 12H12.01M18 6H18.01M6 6H6.01M18 18H18.01M6 18H6.01M6.8 22H17.2C18.8802 22 19.7202 22 20.362 21.673C20.9265 21.3854 21.3854 20.9265 21.673 20.362C22 19.7202 22 18.8802 22 17.2V6.8C22 5.11984 22 4.27976 21.673 3.63803C21.3854 3.07354 20.9265 2.6146 20.362 2.32698C19.7202 2 18.8802 2 17.2 2H6.8C5.11984 2 4.27976 2 3.63803 2.32698C3.07354 2.6146 2.6146 3.07354 2.32698 3.63803C2 4.27976 2 5.11984 2 6.8V17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bT1 = [
  jT1,
  IT1
];
function yT1(r, e) {
  return n(), o("svg", FT1, bT1);
}
const cE2 = /* @__PURE__ */ i(BT1, [["render", yT1]]);
var DT1 = {}, PT1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AT1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), ST1 = /* @__PURE__ */ t("path", {
  d: "M18 18V20.4C18 20.9601 18 21.2401 17.891 21.454C17.7951 21.6422 17.6422 21.7951 17.454 21.891C17.2401 22 16.9601 22 16.4 22H7.6C7.03995 22 6.75992 22 6.54601 21.891C6.35785 21.7951 6.20487 21.6422 6.10899 21.454C6 21.2401 6 20.9601 6 20.4V18M12 10H12.01M7.8 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V6.8C21 5.11984 21 4.27976 20.673 3.63803C20.3854 3.07354 19.9265 2.6146 19.362 2.32698C18.7202 2 17.8802 2 16.2 2H7.8C6.11984 2 5.27976 2 4.63803 2.32698C4.07354 2.6146 3.6146 3.07354 3.32698 3.63803C3 4.27976 3 5.11984 3 6.8V13.2C3 14.8802 3 15.7202 3.32698 16.362C3.6146 16.9265 4.07354 17.3854 4.63803 17.673C5.27976 18 6.11984 18 7.8 18ZM17 10C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10C7 7.23858 9.23858 5 12 5C14.7614 5 17 7.23858 17 10ZM12.5 10C12.5 10.2761 12.2761 10.5 12 10.5C11.7239 10.5 11.5 10.2761 11.5 10C11.5 9.72386 11.7239 9.5 12 9.5C12.2761 9.5 12.5 9.72386 12.5 10Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TT1 = [
  AT1,
  ST1
];
function OT1(r, e) {
  return n(), o("svg", PT1, TT1);
}
const _E2 = /* @__PURE__ */ i(DT1, [["render", OT1]]);
var ET1 = {}, RT1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UT1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), NT1 = /* @__PURE__ */ t("path", {
  d: "M12 2V4.5M12 2C6.47715 2 2 6.47715 2 12M12 2C17.5228 2 22 6.47715 22 12M12 19.5V22M12 22C17.5228 22 22 17.5228 22 12M12 22C6.47715 22 2 17.5228 2 12M4.5 12H2M22 12H19.5M19.0784 19.0784L17.3047 17.3047M4.92163 19.0784L6.69715 17.3029M4.92163 5L6.65808 6.73645M19.0784 5L13.4999 10.5M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qT1 = [
  UT1,
  NT1
];
function zT1(r, e) {
  return n(), o("svg", RT1, qT1);
}
const CE2 = /* @__PURE__ */ i(ET1, [["render", zT1]]);
var KT1 = {}, GT1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WT1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), YT1 = /* @__PURE__ */ t("path", {
  d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12M22 12C22 6.47715 17.5228 2 12 2M22 12H19.5M2 12C2 6.47715 6.47715 2 12 2M2 12H4.5M12 2V4.5M19.0784 5L13.4999 10.5M19.0784 19.0784L18.8745 18.8745C18.1827 18.1827 17.8368 17.8368 17.4331 17.5894C17.0753 17.3701 16.6851 17.2085 16.2769 17.1105C15.8166 17 15.3274 17 14.349 17L9.65096 17C8.6726 17 8.18342 17 7.72307 17.1106C7.31493 17.2086 6.92475 17.3702 6.56686 17.5895C6.1632 17.8369 5.8173 18.1828 5.12549 18.8746L4.92163 19.0784M4.92163 5L6.65808 6.73645M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XT1 = [
  WT1,
  YT1
];
function QT1(r, e) {
  return n(), o("svg", GT1, XT1);
}
const fE2 = /* @__PURE__ */ i(KT1, [["render", QT1]]);
var JT1 = {}, tO1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eO1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -516)",
  fill: "none"
}, null, -1), rO1 = /* @__PURE__ */ t("path", {
  d: "M5 12C5 8.13401 8.13401 5 12 5M16.4999 7.5L11.9999 12M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nO1 = [
  eO1,
  rO1
];
function oO1(r, e) {
  return n(), o("svg", tO1, nO1);
}
const vE2 = /* @__PURE__ */ i(JT1, [["render", oO1]]);
var iO1 = {}, lO1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sO1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -556)",
  fill: "none"
}, null, -1), hO1 = /* @__PURE__ */ t("path", {
  d: "M17.7453 16C18.5362 14.8661 19 13.4872 19 12C19 11.4851 18.9444 10.9832 18.8389 10.5M6.25469 16C5.46381 14.8662 5 13.4872 5 12C5 8.13401 8.13401 5 12 5C12.4221 5 12.8355 5.03737 13.2371 5.10897M16.4999 7.5L11.9999 12M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aO1 = [
  sO1,
  hO1
];
function dO1(r, e) {
  return n(), o("svg", lO1, aO1);
}
const uE2 = /* @__PURE__ */ i(iO1, [["render", dO1]]);
var cO1 = {}, _O1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CO1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), fO1 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vO1 = [
  CO1,
  fO1
];
function uO1(r, e) {
  return n(), o("svg", _O1, vO1);
}
const wE2 = /* @__PURE__ */ i(cO1, [["render", uO1]]);
var wO1 = {}, pO1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gO1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), $O1 = /* @__PURE__ */ t("path", {
  d: "M9 17L4 22M15 17L20 22M12 2V4M12 22V17M5.2 17H18.8C19.9201 17 20.4802 17 20.908 16.782C21.2843 16.5903 21.5903 16.2843 21.782 15.908C22 15.4802 22 14.9201 22 13.8V7.2C22 6.07989 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H5.2C4.07989 4 3.51984 4 3.09202 4.21799C2.71569 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.07989 2 7.2V13.8C2 14.9201 2 15.4802 2.21799 15.908C2.40973 16.2843 2.71569 16.5903 3.09202 16.782C3.51984 17 4.0799 17 5.2 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), MO1 = [
  gO1,
  $O1
];
function LO1(r, e) {
  return n(), o("svg", pO1, MO1);
}
const pE2 = /* @__PURE__ */ i(wO1, [["render", LO1]]);
var kO1 = {}, mO1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xO1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), HO1 = /* @__PURE__ */ t("path", {
  d: "M11.2827 3.45332C11.5131 2.98638 11.6284 2.75291 11.7848 2.67831C11.9209 2.61341 12.0791 2.61341 12.2152 2.67831C12.3717 2.75291 12.4869 2.98638 12.7174 3.45332L14.9041 7.88328C14.9721 8.02113 15.0061 8.09006 15.0558 8.14358C15.0999 8.19096 15.1527 8.22935 15.2113 8.25662C15.2776 8.28742 15.3536 8.29854 15.5057 8.32077L20.397 9.03571C20.9121 9.11099 21.1696 9.14863 21.2888 9.27444C21.3925 9.38389 21.4412 9.5343 21.4215 9.68377C21.3988 9.85558 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0076 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8584 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8584 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0076 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85558 2.57853 9.68377C2.55879 9.5343 2.60755 9.38389 2.71125 9.27444C2.83044 9.14863 3.08797 9.11099 3.60304 9.03571L8.49431 8.32077C8.64642 8.29854 8.72248 8.28742 8.78872 8.25662C8.84736 8.22935 8.90016 8.19096 8.94419 8.14358C8.99391 8.09006 9.02793 8.02113 9.09597 7.88328L11.2827 3.45332Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), VO1 = [
  xO1,
  HO1
];
function ZO1(r, e) {
  return n(), o("svg", mO1, VO1);
}
const gE2 = /* @__PURE__ */ i(kO1, [["render", ZO1]]);
var BO1 = {}, FO1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jO1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), IO1 = /* @__PURE__ */ t("path", {
  d: "M11.3063 3.20693C11.5338 2.81107 11.6476 2.61315 11.7962 2.54681C11.9259 2.48895 12.074 2.48895 12.2037 2.54681C12.3524 2.61315 12.4661 2.81107 12.6936 3.20693L14.6487 6.60925C14.733 6.75579 14.7751 6.82906 14.8341 6.88231C14.8863 6.92942 14.9479 6.96498 15.0148 6.98666C15.0905 7.01117 15.175 7.011 15.344 7.01065L19.2681 7.00272C19.7246 7.00179 19.9529 7.00133 20.0847 7.09691C20.1996 7.18028 20.2737 7.30858 20.2884 7.4498C20.3053 7.61171 20.1908 7.80918 19.9617 8.20412L17.9928 11.5985C17.908 11.7447 17.8656 11.8178 17.849 11.8955C17.8343 11.9643 17.8343 12.0355 17.849 12.1043C17.8656 12.182 17.908 12.2551 17.9928 12.4013L19.9617 15.7957C20.1908 16.1906 20.3053 16.3881 20.2884 16.55C20.2737 16.6912 20.1996 16.8195 20.0847 16.9029C19.9529 16.9985 19.7246 16.998 19.2681 16.9971L15.344 16.9891C15.175 16.9888 15.0905 16.9886 15.0148 17.0131C14.9479 17.0348 14.8863 17.0704 14.8341 17.1175C14.7751 17.1707 14.733 17.244 14.6487 17.3905L12.6936 20.7929C12.4661 21.1887 12.3524 21.3867 12.2037 21.453C12.074 21.5108 11.9259 21.5108 11.7962 21.453C11.6476 21.3867 11.5338 21.1887 11.3063 20.7929L9.35116 17.3905C9.26695 17.244 9.22485 17.1707 9.16581 17.1175C9.11357 17.0704 9.05198 17.0348 8.98507 17.0131C8.90943 16.9886 8.82493 16.9888 8.65592 16.9891L4.73183 16.9971C4.27527 16.998 4.04699 16.9985 3.91521 16.9029C3.80027 16.8195 3.7262 16.6912 3.71147 16.55C3.69458 16.3881 3.80913 16.1906 4.03821 15.7957L6.00712 12.4013C6.09193 12.2551 6.13433 12.182 6.15092 12.1043C6.1656 12.0355 6.1656 11.9643 6.15092 11.8955C6.13433 11.8178 6.09192 11.7447 6.00712 11.5985L4.03821 8.20411C3.80913 7.80918 3.69458 7.61171 3.71147 7.4498C3.7262 7.30858 3.80027 7.18028 3.91521 7.09691C4.04699 7.00133 4.27527 7.00179 4.73184 7.00272L8.65592 7.01065C8.82493 7.011 8.90943 7.01117 8.98507 6.98666C9.05198 6.96498 9.11357 6.92942 9.16581 6.88231C9.22485 6.82906 9.26695 6.75579 9.35116 6.60925L11.3063 3.20693Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bO1 = [
  jO1,
  IO1
];
function yO1(r, e) {
  return n(), o("svg", FO1, bO1);
}
const $E2 = /* @__PURE__ */ i(BO1, [["render", yO1]]);
var DO1 = {}, PO1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, AO1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), SO1 = /* @__PURE__ */ t("path", {
  d: "M11.2896 3.36637C11.5193 2.92427 11.6342 2.70323 11.7881 2.63139C11.9221 2.56883 12.077 2.56883 12.211 2.63139C12.3649 2.70323 12.4798 2.92427 12.7095 3.36637L14.2225 6.27865C14.3216 6.46934 14.3711 6.56468 14.4454 6.62803C14.511 6.68394 14.5899 6.72195 14.6745 6.73837C14.7704 6.75697 14.8758 6.73625 15.0867 6.69481L18.3069 6.06197C18.7958 5.9659 19.0402 5.91786 19.1923 5.99342C19.3248 6.05921 19.4214 6.18027 19.456 6.32406C19.4958 6.4892 19.3946 6.71681 19.1922 7.17203L17.8586 10.1707C17.7713 10.3671 17.7276 10.4653 17.7244 10.5628C17.7216 10.649 17.7411 10.7344 17.781 10.8108C17.8262 10.8973 17.9082 10.9668 18.072 11.1058L20.5746 13.229C20.9545 13.5513 21.1445 13.7124 21.1803 13.8785C21.2114 14.0231 21.177 14.174 21.0862 14.2908C20.9819 14.4249 20.7408 14.4876 20.2587 14.6132L17.0827 15.4402C16.8748 15.4944 16.7708 15.5215 16.6925 15.5798C16.6234 15.6313 16.5688 15.6998 16.534 15.7786C16.4945 15.868 16.4912 15.9754 16.4847 16.1901L16.3851 19.4705C16.37 19.9685 16.3624 20.2175 16.2549 20.349C16.1613 20.4635 16.0218 20.5307 15.8739 20.5325C15.704 20.5345 15.5047 20.3852 15.1059 20.0865L12.4791 18.1191C12.3071 17.9903 12.2211 17.9259 12.1267 17.9011C12.0434 17.8791 11.9558 17.8791 11.8724 17.9011C11.778 17.9259 11.692 17.9903 11.52 18.1191L8.8932 20.0865C8.49444 20.3852 8.29506 20.5345 8.12521 20.5325C7.97731 20.5307 7.8378 20.4635 7.74418 20.349C7.63667 20.2175 7.62911 19.9685 7.61399 19.4705L7.51439 16.1901C7.50787 15.9754 7.50461 15.868 7.46514 15.7786C7.43031 15.6998 7.37569 15.6313 7.30658 15.5798C7.22829 15.5215 7.12432 15.4944 6.91636 15.4402L3.74042 14.6132C3.2583 14.4876 3.01724 14.4249 2.91295 14.2908C2.82214 14.174 2.78768 14.0231 2.81884 13.8785C2.85463 13.7124 3.04458 13.5513 3.42448 13.229L5.92706 11.1058C6.09093 10.9668 6.17286 10.8973 6.21808 10.8108C6.258 10.7344 6.27749 10.649 6.27467 10.5628C6.27148 10.4653 6.22782 10.3671 6.1405 10.1707L4.80694 7.17203C4.6045 6.71681 4.50328 6.4892 4.54309 6.32406C4.57775 6.18027 4.6743 6.05921 4.80677 5.99342C4.95891 5.91786 5.20333 5.9659 5.69219 6.06197L8.91245 6.69481C9.1233 6.73625 9.22873 6.75697 9.32458 6.73837C9.4092 6.72195 9.48812 6.68394 9.55371 6.62803C9.62802 6.56468 9.67755 6.46934 9.77662 6.27865L11.2896 3.36637Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), TO1 = [
  AO1,
  SO1
];
function OO1(r, e) {
  return n(), o("svg", PO1, TO1);
}
const ME2 = /* @__PURE__ */ i(DO1, [["render", OO1]]);
var EO1 = {}, RO1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UO1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), NO1 = /* @__PURE__ */ t("path", {
  d: "M12 2L14.012 7.23109C14.294 7.96432 14.435 8.33093 14.6542 8.63931C14.8486 8.91262 15.0874 9.15141 15.3607 9.34575C15.6691 9.56503 16.0357 9.70603 16.7689 9.98804L22 12L16.7689 14.012C16.0357 14.294 15.6691 14.435 15.3607 14.6542C15.0874 14.8486 14.8486 15.0874 14.6542 15.3607C14.435 15.6691 14.294 16.0357 14.012 16.7689L12 22L9.98804 16.7689C9.70603 16.0357 9.56503 15.6691 9.34575 15.3607C9.15141 15.0874 8.91262 14.8486 8.63931 14.6542C8.33093 14.435 7.96432 14.294 7.23109 14.012L2 12L7.23108 9.98804C7.96431 9.70603 8.33093 9.56503 8.63931 9.34575C8.91262 9.15141 9.15141 8.91262 9.34575 8.63931C9.56503 8.33093 9.70603 7.96431 9.98804 7.23108L12 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qO1 = [
  UO1,
  NO1
];
function zO1(r, e) {
  return n(), o("svg", RO1, qO1);
}
const LE2 = /* @__PURE__ */ i(EO1, [["render", zO1]]);
var KO1 = {}, GO1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WO1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), YO1 = /* @__PURE__ */ t("path", {
  d: "M12 2L10.6985 7.20599C10.4445 8.22185 10.3176 8.72978 10.0531 9.14309C9.81915 9.50868 9.50868 9.81915 9.14309 10.0531C8.72978 10.3176 8.22185 10.4445 7.20599 10.6985L2 12L7.20599 13.3015C8.22185 13.5555 8.72978 13.6824 9.14309 13.9469C9.50868 14.1808 9.81915 14.4913 10.0531 14.8569C10.3176 15.2702 10.4445 15.7782 10.6985 16.794L12 22L13.3015 16.794C13.5555 15.7782 13.6824 15.2702 13.9469 14.8569C14.1808 14.4913 14.4913 14.1808 14.8569 13.9469C15.2702 13.6824 15.7782 13.5555 16.794 13.3015L22 12L16.794 10.6985C15.7782 10.4445 15.2702 10.3176 14.8569 10.0531C14.4913 9.81915 14.1808 9.50868 13.9469 9.14309C13.6824 8.72978 13.5555 8.22185 13.3015 7.20599L12 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XO1 = [
  WO1,
  YO1
];
function QO1(r, e) {
  return n(), o("svg", GO1, XO1);
}
const kE2 = /* @__PURE__ */ i(KO1, [["render", QO1]]);
var JO1 = {}, tE1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eE1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), rE1 = /* @__PURE__ */ t("path", {
  d: "M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.84281 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nE1 = [
  eE1,
  rE1
];
function oE1(r, e) {
  return n(), o("svg", tE1, nE1);
}
const mE2 = /* @__PURE__ */ i(JO1, [["render", oE1]]);
var iE1 = {}, lE1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sE1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), hE1 = /* @__PURE__ */ t("path", {
  d: "M22 12H20M19.071 19.0711L17.6567 17.6569M4 12H2M6.34292 6.34317L4.92871 4.92896M12 4V2M17.6567 6.34317L19.071 4.92896M12 22V20M4.92871 19.0711L6.34292 17.6569M12 7L13.545 10.13L17 10.635L14.5 13.07L15.09 16.51L12 14.885L8.91 16.51L9.5 13.07L7 10.635L10.455 10.13L12 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aE1 = [
  sE1,
  hE1
];
function dE1(r, e) {
  return n(), o("svg", lE1, aE1);
}
const xE2 = /* @__PURE__ */ i(iE1, [["render", dE1]]);
var cE1 = {}, _E1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CE1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), fE1 = /* @__PURE__ */ t("path", {
  d: "M6.5 13L7.28446 14.5689C7.54995 15.0999 7.68269 15.3654 7.86003 15.5954C8.01739 15.7996 8.20041 15.9826 8.40455 16.14C8.63462 16.3173 8.9001 16.4501 9.43108 16.7155L11 17.5L9.43108 18.2845C8.9001 18.5499 8.63462 18.6827 8.40455 18.86C8.20041 19.0174 8.01739 19.2004 7.86003 19.4046C7.68269 19.6346 7.54995 19.9001 7.28446 20.4311L6.5 22L5.71554 20.4311C5.45005 19.9001 5.31731 19.6346 5.13997 19.4046C4.98261 19.2004 4.79959 19.0174 4.59545 18.86C4.36538 18.6827 4.0999 18.5499 3.56892 18.2845L2 17.5L3.56892 16.7155C4.0999 16.4501 4.36538 16.3173 4.59545 16.14C4.79959 15.9826 4.98261 15.7996 5.13997 15.5954C5.31731 15.3654 5.45005 15.0999 5.71554 14.5689L6.5 13Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vE1 = /* @__PURE__ */ t("path", {
  d: "M15 2L16.1786 5.06442C16.4606 5.79765 16.6016 6.16426 16.8209 6.47264C17.0153 6.74595 17.254 6.98475 17.5274 7.17909C17.8357 7.39836 18.2024 7.53937 18.9356 7.82138L22 9L18.9356 10.1786C18.2024 10.4606 17.8357 10.6016 17.5274 10.8209C17.254 11.0153 17.0153 11.254 16.8209 11.5274C16.6016 11.8357 16.4606 12.2024 16.1786 12.9356L15 16L13.8214 12.9356C13.5394 12.2024 13.3984 11.8357 13.1791 11.5274C12.9847 11.254 12.746 11.0153 12.4726 10.8209C12.1643 10.6016 11.7976 10.4606 11.0644 10.1786L8 9L11.0644 7.82138C11.7976 7.53937 12.1643 7.39836 12.4726 7.17909C12.746 6.98475 12.9847 6.74595 13.1791 6.47264C13.3984 6.16426 13.5394 5.79765 13.8214 5.06442L15 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uE1 = [
  CE1,
  fE1,
  vE1
];
function wE1(r, e) {
  return n(), o("svg", _E1, uE1);
}
const HE2 = /* @__PURE__ */ i(cE1, [["render", wE1]]);
var pE1 = {}, gE1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $E1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), ME1 = /* @__PURE__ */ t("path", {
  d: "M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), LE1 = [
  $E1,
  ME1
];
function kE1(r, e) {
  return n(), o("svg", gE1, LE1);
}
const VE2 = /* @__PURE__ */ i(pE1, [["render", kE1]]);
var mE1 = {}, xE1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HE1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), VE1 = /* @__PURE__ */ t("path", {
  d: "M18.5 8V3M5.5 21V16M16 5.5H21M3 18.5H8M6.5 2L5.71554 3.56892C5.45005 4.09989 5.31731 4.36538 5.13997 4.59545C4.98261 4.79959 4.79959 4.98261 4.59545 5.13997C4.36538 5.31731 4.0999 5.45005 3.56892 5.71554L2 6.5L3.56892 7.28446C4.0999 7.54995 4.36538 7.68269 4.59545 7.86003C4.79959 8.01739 4.98261 8.20041 5.13997 8.40455C5.31731 8.63462 5.45005 8.9001 5.71554 9.43108L6.5 11L7.28446 9.43108C7.54995 8.9001 7.68269 8.63462 7.86003 8.40455C8.01739 8.20041 8.20041 8.01739 8.40455 7.86003C8.63462 7.68269 8.9001 7.54995 9.43108 7.28446L11 6.5L9.43108 5.71554C8.9001 5.45005 8.63462 5.31731 8.40455 5.13997C8.20041 4.98261 8.01739 4.79959 7.86003 4.59545C7.68269 4.36538 7.54995 4.0999 7.28446 3.56892L6.5 2ZM17 12L16.0489 13.9022C15.7834 14.4332 15.6506 14.6987 15.4733 14.9288C15.3159 15.1329 15.1329 15.3159 14.9288 15.4733C14.6987 15.6506 14.4332 15.7834 13.9023 16.0489L12 17L13.9023 17.9511C14.4332 18.2166 14.6987 18.3494 14.9288 18.5267C15.1329 18.6841 15.3159 18.8671 15.4733 19.0712C15.6506 19.3013 15.7834 19.5668 16.0489 20.0977L17 22L17.9511 20.0978C18.2166 19.5668 18.3494 19.3013 18.5267 19.0712C18.6841 18.8671 18.8671 18.6841 19.0712 18.5267C19.3013 18.3494 19.5668 18.2166 20.0977 17.9511L22 17L20.0977 16.0489C19.5668 15.7834 19.3013 15.6506 19.0712 15.4733C18.8671 15.3159 18.6841 15.1329 18.5267 14.9288C18.3494 14.6987 18.2166 14.4332 17.9511 13.9023L17 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), ZE1 = [
  HE1,
  VE1
];
function BE1(r, e) {
  return n(), o("svg", xE1, ZE1);
}
const ZE2 = /* @__PURE__ */ i(mE1, [["render", BE1]]);
var FE1 = {}, jE1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, IE1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -556)",
  fill: "none"
}, null, -1), bE1 = /* @__PURE__ */ t("path", {
  d: "M22.0006 12.1171C22.0006 6.5296 17.471 2 11.8835 2C7.34846 2 3.51036 4.98385 2.22531 9.0954C2.143 9.35878 2.10184 9.49047 2.10572 9.65514C2.10888 9.78904 2.14958 9.95446 2.20891 10.0745C2.28188 10.2222 2.39454 10.3349 2.61986 10.5602L13.4409 21.3807C13.6662 21.606 13.7788 21.7187 13.9265 21.7916C14.0466 21.8509 14.212 21.8916 14.3459 21.8948C14.5106 21.8987 14.6423 21.8575 14.9057 21.7752C19.017 20.49 22.0006 16.652 22.0006 12.1171Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yE1 = /* @__PURE__ */ t("path", {
  d: "M3.4468 9.7341C3.6873 9.71699 3.93013 9.70829 4.17499 9.70829C9.76253 9.70829 14.2921 14.2379 14.2921 19.8254C14.2921 20.0703 14.2834 20.3131 14.2663 20.5536C14.2364 20.9738 14.2215 21.1839 14.099 21.3137C13.9995 21.4191 13.8298 21.4824 13.6856 21.468C13.508 21.4502 13.3466 21.2887 13.0236 20.9658L3.03464 10.9768C2.71171 10.6539 2.55024 10.4924 2.53246 10.3148C2.51801 10.1706 2.58136 10.0009 2.68675 9.9014C2.81651 9.77892 3.02661 9.76398 3.4468 9.7341Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), DE1 = [
  IE1,
  bE1,
  yE1
];
function PE1(r, e) {
  return n(), o("svg", jE1, DE1);
}
const BE2 = /* @__PURE__ */ i(FE1, [["render", PE1]]);
var AE1 = {}, SE1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, TE1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -516)",
  fill: "none"
}, null, -1), OE1 = /* @__PURE__ */ t("path", {
  d: "M13 3.5V6.2C13 7.88016 13 8.72024 13.327 9.36197C13.6146 9.92646 14.0735 10.3854 14.638 10.673C15.2798 11 16.1198 11 17.8 11H20.5M21 12.9882V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H11.0118C11.7455 3 12.1124 3 12.4577 3.08289C12.7638 3.15638 13.0564 3.27759 13.3249 3.44208C13.6276 3.6276 13.887 3.88703 14.4059 4.40589L19.5941 9.59411C20.113 10.113 20.3724 10.3724 20.5579 10.6751C20.7224 10.9436 20.8436 11.2362 20.9171 11.5423C21 11.8876 21 12.2545 21 12.9882Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), EE1 = [
  TE1,
  OE1
];
function RE1(r, e) {
  return n(), o("svg", SE1, EE1);
}
const FE2 = /* @__PURE__ */ i(AE1, [["render", RE1]]);
var UE1 = {}, NE1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qE1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), zE1 = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), KE1 = /* @__PURE__ */ t("path", {
  d: "M8 9.6C8 9.03995 8 8.75992 8.10899 8.54601C8.20487 8.35785 8.35785 8.20487 8.54601 8.10899C8.75992 8 9.03995 8 9.6 8H14.4C14.9601 8 15.2401 8 15.454 8.10899C15.6422 8.20487 15.7951 8.35785 15.891 8.54601C16 8.75992 16 9.03995 16 9.6V14.4C16 14.9601 16 15.2401 15.891 15.454C15.7951 15.6422 15.6422 15.7951 15.454 15.891C15.2401 16 14.9601 16 14.4 16H9.6C9.03995 16 8.75992 16 8.54601 15.891C8.35785 15.7951 8.20487 15.6422 8.10899 15.454C8 15.2401 8 14.9601 8 14.4V9.6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GE1 = [
  qE1,
  zE1,
  KE1
];
function WE1(r, e) {
  return n(), o("svg", NE1, GE1);
}
const jE2 = /* @__PURE__ */ i(UE1, [["render", WE1]]);
var YE1 = {}, XE1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QE1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), JE1 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tR1 = /* @__PURE__ */ t("path", {
  d: "M8 9.6C8 9.03995 8 8.75992 8.10899 8.54601C8.20487 8.35785 8.35785 8.20487 8.54601 8.10899C8.75992 8 9.03995 8 9.6 8H14.4C14.9601 8 15.2401 8 15.454 8.10899C15.6422 8.20487 15.7951 8.35785 15.891 8.54601C16 8.75992 16 9.03995 16 9.6V14.4C16 14.9601 16 15.2401 15.891 15.454C15.7951 15.6422 15.6422 15.7951 15.454 15.891C15.2401 16 14.9601 16 14.4 16H9.6C9.03995 16 8.75992 16 8.54601 15.891C8.35785 15.7951 8.20487 15.6422 8.10899 15.454C8 15.2401 8 14.9601 8 14.4V9.6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), eR1 = [
  QE1,
  JE1,
  tR1
];
function rR1(r, e) {
  return n(), o("svg", XE1, eR1);
}
const IE2 = /* @__PURE__ */ i(YE1, [["render", rR1]]);
var nR1 = {}, oR1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iR1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), lR1 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), sR1 = [
  iR1,
  lR1
];
function hR1(r, e) {
  return n(), o("svg", oR1, sR1);
}
const bE2 = /* @__PURE__ */ i(nR1, [["render", hR1]]);
var aR1 = {}, dR1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cR1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -556)",
  fill: "none"
}, null, -1), _R1 = /* @__PURE__ */ t("path", {
  d: "M6 16C6 18.2091 7.79086 20 10 20H14C16.2091 20 18 18.2091 18 16C18 13.7909 16.2091 12 14 12M18 8C18 5.79086 16.2091 4 14 4H10C7.79086 4 6 5.79086 6 8M3 12H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), CR1 = [
  cR1,
  _R1
];
function fR1(r, e) {
  return n(), o("svg", dR1, CR1);
}
const yE2 = /* @__PURE__ */ i(aR1, [["render", fR1]]);
var vR1 = {}, uR1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wR1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -596)",
  fill: "none"
}, null, -1), pR1 = /* @__PURE__ */ t("path", {
  d: "M6 16C6 18.2091 7.79086 20 10 20H14C16.2091 20 18 18.2091 18 16C18 13.7909 16.2091 12 14 12M10.5 20C12.7091 20 14.5 18.2091 14.5 16C14.5 13.7909 12.7091 12 10.5 12M18 8C18 5.79086 16.2091 4 14 4H10C7.79086 4 6 5.79086 6 8M13.5 4C11.2909 4 9.5 5.79086 9.5 8M3 12H21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), gR1 = [
  wR1,
  pR1
];
function $R1(r, e) {
  return n(), o("svg", uR1, gR1);
}
const DE2 = /* @__PURE__ */ i(vR1, [["render", $R1]]);
var MR1 = {}, LR1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kR1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -636)",
  fill: "none"
}, null, -1), mR1 = /* @__PURE__ */ t("path", {
  d: "M6 12H18M11 12H13C14.3807 12 15.5 13.1193 15.5 14.5C15.5 15.8807 14.3807 17 13 17H10.8333C9.83827 17 8.98868 16.3771 8.65321 15.5M15.3468 8.5C15.0113 7.62288 14.1617 7 13.1667 7H11C9.97484 7 9.0938 7.61705 8.70802 8.5M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), xR1 = [
  kR1,
  mR1
];
function HR1(r, e) {
  return n(), o("svg", LR1, xR1);
}
const PE2 = /* @__PURE__ */ i(MR1, [["render", HR1]]);
var VR1 = {}, ZR1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, BR1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -676)",
  fill: "none"
}, null, -1), FR1 = /* @__PURE__ */ t("path", {
  d: "M3 5L13 15M13 5L3 15M21 19.0001H17C17 17.5001 17.44 17.0001 18.5 16.5001C19.56 16.0001 21 15.3301 21 14.0001C21 13.5301 20.83 13.0701 20.52 12.7101C20.1999 12.3476 19.7649 12.1061 19.2879 12.026C18.811 11.9459 18.321 12.0321 17.9 12.2701C17.48 12.5101 17.16 12.8901 17 13.3401",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), jR1 = [
  BR1,
  FR1
];
function IR1(r, e) {
  return n(), o("svg", ZR1, jR1);
}
const AE2 = /* @__PURE__ */ i(VR1, [["render", IR1]]);
var bR1 = {}, yR1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, DR1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -516)",
  fill: "none"
}, null, -1), PR1 = /* @__PURE__ */ t("path", {
  d: "M12 3V5M5.31412 7.31412L3.8999 5.8999M18.6858 7.31412L20.1 5.8999M6 15C6 11.6863 8.68629 9 12 9C15.3137 9 18 11.6863 18 15M22 15H2M19 19H5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), AR1 = [
  DR1,
  PR1
];
function SR1(r, e) {
  return n(), o("svg", yR1, AR1);
}
const SE2 = /* @__PURE__ */ i(bR1, [["render", SR1]]);
var TR1 = {}, OR1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ER1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), RR1 = /* @__PURE__ */ t("path", {
  d: "M22 16.5H2M20 20H4M12 3V5M4 13H2M6.31412 7.31412L4.8999 5.8999M17.6855 7.31412L19.0998 5.8999M22 13H20M7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), UR1 = [
  ER1,
  RR1
];
function NR1(r, e) {
  return n(), o("svg", OR1, UR1);
}
const TE2 = /* @__PURE__ */ i(TR1, [["render", NR1]]);
var qR1 = {}, zR1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, KR1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -596)",
  fill: "none"
}, null, -1), GR1 = /* @__PURE__ */ t("path", {
  d: "M6.06006 20.9125C7.27006 21.4625 8.81006 21.4625 10.0201 20.9125C11.2301 20.3625 12.7701 20.3625 13.9801 20.9125C15.1901 21.4625 16.7301 21.4625 17.9401 20.9125M12 3V5M4 13H2M6.31412 7.31412L4.8999 5.8999M17.6855 7.31412L19.0998 5.8999M22 13H20M7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13M2.1001 17.4125C3.3101 16.8625 4.8501 16.8625 6.0601 17.4125C7.2701 17.9625 8.8101 17.9625 10.0201 17.4125C11.2301 16.8625 12.7701 16.8625 13.9801 17.4125C15.1901 17.9625 16.7301 17.9625 17.9401 17.4125C19.1501 16.8625 20.6901 16.8625 21.9001 17.4125",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), WR1 = [
  KR1,
  GR1
];
function YR1(r, e) {
  return n(), o("svg", zR1, WR1);
}
const OE2 = /* @__PURE__ */ i(qR1, [["render", YR1]]);
var XR1 = {}, QR1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, JR1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), tU1 = /* @__PURE__ */ t("path", {
  d: "M12 2V4M12 20V22M4 12H2M6.31412 6.31412L4.8999 4.8999M17.6859 6.31412L19.1001 4.8999M6.31412 17.69L4.8999 19.1042M17.6859 17.69L19.1001 19.1042M22 12H20M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), eU1 = [
  JR1,
  tU1
];
function rU1(r, e) {
  return n(), o("svg", QR1, eU1);
}
const EE2 = /* @__PURE__ */ i(XR1, [["render", rU1]]);
var nU1 = {}, oU1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iU1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-608 -636)",
  fill: "none"
}, null, -1), lU1 = /* @__PURE__ */ t("path", {
  d: "M4 18H2M6.31412 12.3141L4.8999 10.8999M17.6858 12.3141L19.1 10.8999M22 18H20M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18M22 22H2M16 6L12 2M12 2L8 6M12 2V9",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), sU1 = [
  iU1,
  lU1
];
function hU1(r, e) {
  return n(), o("svg", oU1, sU1);
}
const RE2 = /* @__PURE__ */ i(nU1, [["render", hU1]]);
var aU1 = {}, dU1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cU1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), _U1 = /* @__PURE__ */ t("path", {
  d: "M4 18H2M6.31412 12.3141L4.8999 10.8999M17.6858 12.3141L19.1 10.8999M22 18H20M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18M22 22H2M16 5L12 9M12 9L8 5M12 9V2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), CU1 = [
  cU1,
  _U1
];
function fU1(r, e) {
  return n(), o("svg", dU1, CU1);
}
const UE2 = /* @__PURE__ */ i(aU1, [["render", fU1]]);
var vU1 = {}, uU1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wU1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -916)",
  fill: "none"
}, null, -1), pU1 = /* @__PURE__ */ t("path", {
  d: "M20 17H4M4 17L8 13M4 17L8 21M4 7H20M20 7L16 3M20 7L16 11",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), gU1 = [
  wU1,
  pU1
];
function $U1(r, e) {
  return n(), o("svg", uU1, gU1);
}
const NE2 = /* @__PURE__ */ i(vU1, [["render", $U1]]);
var MU1 = {}, LU1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kU1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -956)",
  fill: "none"
}, null, -1), mU1 = /* @__PURE__ */ t("path", {
  d: "M4 17H20M20 17L16 13M20 17L16 21M20 7H4M4 7L8 3M4 7L8 11",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), xU1 = [
  kU1,
  mU1
];
function HU1(r, e) {
  return n(), o("svg", LU1, xU1);
}
const qE2 = /* @__PURE__ */ i(MU1, [["render", HU1]]);
var VU1 = {}, ZU1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, BU1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -996)",
  fill: "none"
}, null, -1), FU1 = /* @__PURE__ */ t("path", {
  d: "M17 4V20M17 20L13 16M17 20L21 16M7 20V4M7 4L3 8M7 4L11 8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), jU1 = [
  BU1,
  FU1
];
function IU1(r, e) {
  return n(), o("svg", ZU1, jU1);
}
const zE2 = /* @__PURE__ */ i(VU1, [["render", IU1]]);
var bU1 = {}, yU1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, DU1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1140",
  transform: "translate(-880 -1036)",
  fill: "none"
}, null, -1), PU1 = /* @__PURE__ */ t("path", {
  d: "M7 4V20M7 20L3 16M7 20L11 16M17 20V4M17 4L13 8M17 4L21 8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), AU1 = [
  DU1,
  PU1
];
function SU1(r, e) {
  return n(), o("svg", yU1, AU1);
}
const KE2 = /* @__PURE__ */ i(bU1, [["render", SU1]]);
var TU1 = {}, OU1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, EU1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "860",
  transform: "translate(-880 -716)",
  fill: "none"
}, null, -1), RU1 = /* @__PURE__ */ t("path", {
  d: "M3 9L21 9M9 3L9 21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), UU1 = [
  EU1,
  RU1
];
function NU1(r, e) {
  return n(), o("svg", OU1, UU1);
}
const GE2 = /* @__PURE__ */ i(TU1, [["render", NU1]]);
var qU1 = {}, zU1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, KU1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), GU1 = /* @__PURE__ */ t("path", {
  d: "M12 17.5H12.01M7.2 22H16.8C17.9201 22 18.4802 22 18.908 21.782C19.2843 21.5903 19.5903 21.2843 19.782 20.908C20 20.4802 20 19.9201 20 18.8V5.2C20 4.07989 20 3.51984 19.782 3.09202C19.5903 2.71569 19.2843 2.40973 18.908 2.21799C18.4802 2 17.9201 2 16.8 2H7.2C6.0799 2 5.51984 2 5.09202 2.21799C4.71569 2.40973 4.40973 2.71569 4.21799 3.09202C4 3.51984 4 4.0799 4 5.2V18.8C4 19.9201 4 20.4802 4.21799 20.908C4.40973 21.2843 4.71569 21.5903 5.09202 21.782C5.51984 22 6.07989 22 7.2 22ZM12.5 17.5C12.5 17.7761 12.2761 18 12 18C11.7239 18 11.5 17.7761 11.5 17.5C11.5 17.2239 11.7239 17 12 17C12.2761 17 12.5 17.2239 12.5 17.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), WU1 = [
  KU1,
  GU1
];
function YU1(r, e) {
  return n(), o("svg", zU1, WU1);
}
const WE2 = /* @__PURE__ */ i(qU1, [["render", YU1]]);
var XU1 = {}, QU1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, JU1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -516)",
  fill: "none"
}, null, -1), tN1 = /* @__PURE__ */ t("path", {
  d: "M15 2V3.4C15 3.96005 15 4.24008 14.891 4.45399C14.7951 4.64215 14.6422 4.79513 14.454 4.89101C14.2401 5 13.9601 5 13.4 5H10.6C10.0399 5 9.75992 5 9.54601 4.89101C9.35785 4.79513 9.20487 4.64215 9.10899 4.45399C9 4.24008 9 3.96005 9 3.4V2M7.2 22H16.8C17.9201 22 18.4802 22 18.908 21.782C19.2843 21.5903 19.5903 21.2843 19.782 20.908C20 20.4802 20 19.9201 20 18.8V5.2C20 4.07989 20 3.51984 19.782 3.09202C19.5903 2.71569 19.2843 2.40973 18.908 2.21799C18.4802 2 17.9201 2 16.8 2H7.2C6.0799 2 5.51984 2 5.09202 2.21799C4.71569 2.40973 4.40973 2.71569 4.21799 3.09202C4 3.51984 4 4.0799 4 5.2V18.8C4 19.9201 4 20.4802 4.21799 20.908C4.40973 21.2843 4.71569 21.5903 5.09202 21.782C5.51984 22 6.07989 22 7.2 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), eN1 = [
  JU1,
  tN1
];
function rN1(r, e) {
  return n(), o("svg", QU1, eN1);
}
const YE2 = /* @__PURE__ */ i(XU1, [["render", rN1]]);
var nN1 = {}, oN1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iN1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -596)",
  fill: "none"
}, null, -1), lN1 = /* @__PURE__ */ t("path", {
  d: "M8 8H8.01M2 5.2L2 9.67451C2 10.1637 2 10.4083 2.05526 10.6385C2.10425 10.8425 2.18506 11.0376 2.29472 11.2166C2.4184 11.4184 2.59135 11.5914 2.93726 11.9373L10.6059 19.6059C11.7939 20.7939 12.388 21.388 13.0729 21.6105C13.6755 21.8063 14.3245 21.8063 14.927 21.6105C15.612 21.388 16.2061 20.7939 17.3941 19.6059L19.6059 17.3941C20.7939 16.2061 21.388 15.612 21.6105 14.927C21.8063 14.3245 21.8063 13.6755 21.6105 13.0729C21.388 12.388 20.7939 11.7939 19.6059 10.6059L11.9373 2.93726C11.5914 2.59135 11.4184 2.4184 11.2166 2.29472C11.0376 2.18506 10.8425 2.10425 10.6385 2.05526C10.4083 2 10.1637 2 9.67452 2L5.2 2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), sN1 = [
  iN1,
  lN1
];
function hN1(r, e) {
  return n(), o("svg", oN1, sN1);
}
const XE2 = /* @__PURE__ */ i(nN1, [["render", hN1]]);
var aN1 = {}, dN1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cN1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -636)",
  fill: "none"
}, null, -1), _N1 = /* @__PURE__ */ t("path", {
  d: "M8 8H8.01M4.56274 2.93726L2.93726 4.56274C2.59136 4.90864 2.4184 5.0816 2.29472 5.28343C2.18506 5.46237 2.10425 5.65746 2.05526 5.86154C2 6.09171 2 6.3363 2 6.82548L2 9.67452C2 10.1637 2 10.4083 2.05526 10.6385C2.10425 10.8425 2.18506 11.0376 2.29472 11.2166C2.4184 11.4184 2.59135 11.5914 2.93726 11.9373L10.6059 19.6059C11.7939 20.7939 12.388 21.388 13.0729 21.6105C13.6755 21.8063 14.3245 21.8063 14.927 21.6105C15.612 21.388 16.2061 20.7939 17.3941 19.6059L19.6059 17.3941C20.7939 16.2061 21.388 15.612 21.6105 14.927C21.8063 14.3245 21.8063 13.6755 21.6105 13.0729C21.388 12.388 20.7939 11.7939 19.6059 10.6059L11.9373 2.93726C11.5914 2.59136 11.4184 2.4184 11.2166 2.29472C11.0376 2.18506 10.8425 2.10425 10.6385 2.05526C10.4083 2 10.1637 2 9.67452 2L6.82548 2C6.3363 2 6.09171 2 5.86154 2.05526C5.65746 2.10425 5.46237 2.18506 5.28343 2.29472C5.0816 2.4184 4.90865 2.59135 4.56274 2.93726ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), CN1 = [
  cN1,
  _N1
];
function fN1(r, e) {
  return n(), o("svg", dN1, CN1);
}
const QE2 = /* @__PURE__ */ i(aN1, [["render", fN1]]);
var vN1 = {}, uN1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wN1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -676)",
  fill: "none"
}, null, -1), pN1 = /* @__PURE__ */ t("path", {
  d: "M21 11L13.4059 3.40589C12.887 2.88703 12.6276 2.6276 12.3249 2.44208C12.0564 2.27759 11.7638 2.15638 11.4577 2.08289C11.1124 2 10.7455 2 10.0118 2L6 2M3 8.7L3 10.6745C3 11.1637 3 11.4083 3.05526 11.6385C3.10425 11.8425 3.18506 12.0376 3.29472 12.2166C3.4184 12.4184 3.59136 12.5914 3.93726 12.9373L11.7373 20.7373C12.5293 21.5293 12.9253 21.9253 13.382 22.0737C13.7837 22.2042 14.2163 22.2042 14.618 22.0737C15.0747 21.9253 15.4707 21.5293 16.2627 20.7373L18.7373 18.2627C19.5293 17.4707 19.9253 17.0747 20.0737 16.618C20.2042 16.2163 20.2042 15.7837 20.0737 15.382C19.9253 14.9253 19.5293 14.5293 18.7373 13.7373L11.4373 6.43726C11.0914 6.09136 10.9184 5.9184 10.7166 5.79472C10.5376 5.68506 10.3425 5.60425 10.1385 5.55526C9.90829 5.5 9.6637 5.5 9.17452 5.5H6.2C5.0799 5.5 4.51984 5.5 4.09202 5.71799C3.7157 5.90973 3.40973 6.21569 3.21799 6.59202C3 7.01984 3 7.57989 3 8.7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), gN1 = [
  wN1,
  pN1
];
function $N1(r, e) {
  return n(), o("svg", uN1, gN1);
}
const JE2 = /* @__PURE__ */ i(vN1, [["render", $N1]]);
var MN1 = {}, LN1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kN1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -596)",
  fill: "none"
}, null, -1), mN1 = /* @__PURE__ */ t("path", {
  d: "M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12H18M12 22C6.47715 22 2 17.5228 2 12M12 22V18M2 12C2 6.47715 6.47715 2 12 2M2 12H6M12 2V6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), xN1 = [
  kN1,
  mN1
];
function HN1(r, e) {
  return n(), o("svg", LN1, xN1);
}
const tR2 = /* @__PURE__ */ i(MN1, [["render", HN1]]);
var VN1 = {}, ZN1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, BN1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -636)",
  fill: "none"
}, null, -1), FN1 = /* @__PURE__ */ t("path", {
  d: "M22 12H18M6 12H2M12 6V2M12 22V18M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), jN1 = [
  BN1,
  FN1
];
function IN1(r, e) {
  return n(), o("svg", ZN1, jN1);
}
const eR2 = /* @__PURE__ */ i(VN1, [["render", IN1]]);
var bN1 = {}, yN1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, DN1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -676)",
  fill: "none"
}, null, -1), PN1 = /* @__PURE__ */ t("path", {
  d: "M22 12H18M6 12H2M12 6V2M12 22V18M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), AN1 = [
  DN1,
  PN1
];
function SN1(r, e) {
  return n(), o("svg", yN1, AN1);
}
const rR2 = /* @__PURE__ */ i(bN1, [["render", SN1]]);
var TN1 = {}, ON1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, EN1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -716)",
  fill: "none"
}, null, -1), RN1 = /* @__PURE__ */ t("path", {
  d: "M16 8V5L19 2L20 4L22 5L19 8H16ZM16 8L12 11.9999M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), UN1 = [
  EN1,
  RN1
];
function NN1(r, e) {
  return n(), o("svg", ON1, UN1);
}
const nR2 = /* @__PURE__ */ i(TN1, [["render", NN1]]);
var qN1 = {}, zN1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, KN1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -756)",
  fill: "none"
}, null, -1), GN1 = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), WN1 = /* @__PURE__ */ t("path", {
  d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), YN1 = /* @__PURE__ */ t("path", {
  d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), XN1 = [
  KN1,
  GN1,
  WN1,
  YN1
];
function QN1(r, e) {
  return n(), o("svg", zN1, XN1);
}
const oR2 = /* @__PURE__ */ i(qN1, [["render", QN1]]);
var JN1 = {}, tq1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eq1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), rq1 = /* @__PURE__ */ t("path", {
  d: "M13.1218 14.8446L18.0004 21.9999M10.879 14.8446L6.00041 21.9999M14.0004 13.2C14.0004 14.3045 13.105 15.2 12.0004 15.2C10.8958 15.2 10.0004 14.3045 10.0004 13.2C10.0004 12.0954 10.8958 11.2 12.0004 11.2C13.105 11.2 14.0004 12.0954 14.0004 13.2ZM17.1489 4.53225L5.36462 7.68984C5.09414 7.76232 4.95889 7.79855 4.86969 7.87888C4.79122 7.94953 4.73713 8.04321 4.71518 8.14649C4.69022 8.26391 4.72646 8.39915 4.79893 8.66964L5.67892 11.9538C5.7514 12.2243 5.78763 12.3595 5.86796 12.4487C5.93861 12.5272 6.03229 12.5813 6.13557 12.6032C6.25299 12.6282 6.38823 12.5919 6.65871 12.5195L18.443 9.36188L17.1489 4.53225ZM21.7928 9.49958C20.7109 9.78949 20.1699 9.93444 19.7002 9.83461C19.2871 9.74679 18.9124 9.53045 18.6298 9.21657C18.3085 8.85975 18.1635 8.31878 17.8736 7.23684L17.7183 6.65728C17.4284 5.57535 17.2835 5.03438 17.3833 4.56471C17.4711 4.15158 17.6875 3.77686 18.0013 3.49425C18.3582 3.17296 18.8991 3.02801 19.9811 2.7381C20.2515 2.66562 20.3868 2.62939 20.5042 2.65434C20.6075 2.6763 20.7012 2.73038 20.7718 2.80885C20.8521 2.89806 20.8884 3.0333 20.9609 3.30379L22.3585 8.51979C22.431 8.79027 22.4672 8.92551 22.4422 9.04293C22.4203 9.14621 22.3662 9.23989 22.2877 9.31055C22.1985 9.39087 22.0633 9.42711 21.7928 9.49958ZM3.50212 12.33L4.85441 11.9677C5.1249 11.8952 5.26014 11.8589 5.34935 11.7786C5.42782 11.708 5.4819 11.6143 5.50386 11.511C5.52881 11.3936 5.49258 11.2583 5.4201 10.9879L5.05775 9.63556C4.98528 9.36508 4.94904 9.22983 4.86872 9.14063C4.79806 9.06216 4.70438 9.00807 4.6011 8.98612C4.48368 8.96116 4.34844 8.9974 4.07796 9.06988L2.72566 9.43222C2.45518 9.5047 2.31993 9.54094 2.23073 9.62126C2.15226 9.69191 2.09817 9.78559 2.07622 9.88888C2.05126 10.0063 2.0875 10.1415 2.15998 10.412L2.52232 11.7643C2.5948 12.0348 2.63104 12.17 2.71136 12.2592C2.78201 12.3377 2.87569 12.3918 2.97898 12.4138C3.09639 12.4387 3.23163 12.4025 3.50212 12.33Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), nq1 = [
  eq1,
  rq1
];
function oq1(r, e) {
  return n(), o("svg", tq1, nq1);
}
const iR2 = /* @__PURE__ */ i(JN1, [["render", oq1]]);
var iq1 = {}, lq1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sq1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), hq1 = /* @__PURE__ */ t("path", {
  d: "M22 9H2M6 17.5L8.5 15L6 12.5M11 17.5L15 17.5M2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27977 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), aq1 = [
  sq1,
  hq1
];
function dq1(r, e) {
  return n(), o("svg", lq1, aq1);
}
const lR2 = /* @__PURE__ */ i(iq1, [["render", dq1]]);
var cq1 = {}, _q1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cq1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -516)",
  fill: "none"
}, null, -1), fq1 = /* @__PURE__ */ t("path", {
  d: "M7 15L10 12L7 9M13 15H17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), vq1 = [
  Cq1,
  fq1
];
function uq1(r, e) {
  return n(), o("svg", _q1, vq1);
}
const sR2 = /* @__PURE__ */ i(cq1, [["render", uq1]]);
var wq1 = {}, pq1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gq1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -556)",
  fill: "none"
}, null, -1), $q1 = /* @__PURE__ */ t("path", {
  d: "M7 15L10 12L7 9M13 15H17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Mq1 = [
  gq1,
  $q1
];
function Lq1(r, e) {
  return n(), o("svg", pq1, Mq1);
}
const hR2 = /* @__PURE__ */ i(wq1, [["render", Lq1]]);
var kq1 = {}, mq1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xq1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), Hq1 = /* @__PURE__ */ t("path", {
  d: "M4 17L10 11L4 5M12 19H20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Vq1 = [
  xq1,
  Hq1
];
function Zq1(r, e) {
  return n(), o("svg", mq1, Vq1);
}
const aR2 = /* @__PURE__ */ i(kq1, [["render", Zq1]]);
var Bq1 = {}, Fq1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jq1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -716)",
  fill: "none"
}, null, -1), Iq1 = /* @__PURE__ */ t("path", {
  d: "M13 7H5.2C4.0799 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.0799 2 10.2V13.8C2 14.9201 2 15.4802 2.21799 15.908C2.40973 16.2843 2.71569 16.5903 3.09202 16.782C3.51984 17 4.07989 17 5.2 17H13M17 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.0799 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H17M17 21L17 3M19.5 3.00001L14.5 3M19.5 21L14.5 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), bq1 = [
  jq1,
  Iq1
];
function yq1(r, e) {
  return n(), o("svg", Fq1, bq1);
}
const dR2 = /* @__PURE__ */ i(Bq1, [["render", yq1]]);
var Dq1 = {}, Pq1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Aq1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), Sq1 = /* @__PURE__ */ t("path", {
  d: "M14.5 4.5C14.5 3.11929 13.3807 2 12 2C10.6193 2 9.5 3.11929 9.5 4.5V13.7578C8.29401 14.565 7.5 15.9398 7.5 17.5C7.5 19.9853 9.51472 22 12 22C14.4853 22 16.5 19.9853 16.5 17.5C16.5 15.9398 15.706 14.565 14.5 13.7578V4.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Tq1 = [
  Aq1,
  Sq1
];
function Oq1(r, e) {
  return n(), o("svg", Pq1, Tq1);
}
const cR2 = /* @__PURE__ */ i(Dq1, [["render", Oq1]]);
var Eq1 = {}, Rq1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uq1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), Nq1 = /* @__PURE__ */ t("path", {
  d: "M14.5 4.5C14.5 3.11929 13.3807 2 12 2C10.6193 2 9.5 3.11929 9.5 4.5V13.7578C8.29401 14.565 7.5 15.9398 7.5 17.5C7.5 19.9853 9.51472 22 12 22C14.4853 22 16.5 19.9853 16.5 17.5C16.5 15.9398 15.706 14.565 14.5 13.7578V4.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), qq1 = /* @__PURE__ */ t("path", {
  d: "M12 18.5C12.5523 18.5 13 18.0523 13 17.5C13 16.9477 12.5523 16.5 12 16.5C11.4477 16.5 11 16.9477 11 17.5C11 18.0523 11.4477 18.5 12 18.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zq1 = [
  Uq1,
  Nq1,
  qq1
];
function Kq1(r, e) {
  return n(), o("svg", Rq1, zq1);
}
const _R2 = /* @__PURE__ */ i(Eq1, [["render", Kq1]]);
var Gq1 = {}, Wq1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yq1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), Xq1 = /* @__PURE__ */ t("path", {
  d: "M21 3L15 3M21 7L15 7M21 11L15 11M5.5 13.7578V4.5C5.5 3.11929 6.61929 2 8 2C9.38071 2 10.5 3.11929 10.5 4.5V13.7578C11.706 14.565 12.5 15.9398 12.5 17.5C12.5 19.9853 10.4853 22 8 22C5.51472 22 3.5 19.9853 3.5 17.5C3.5 15.9398 4.29401 14.565 5.5 13.7578ZM9 17.5C9 18.0523 8.55228 18.5 8 18.5C7.44772 18.5 7 18.0523 7 17.5C7 16.9477 7.44772 16.5 8 16.5C8.55228 16.5 9 16.9477 9 17.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qq1 = [
  Yq1,
  Xq1
];
function Jq1(r, e) {
  return n(), o("svg", Wq1, Qq1);
}
const CR2 = /* @__PURE__ */ i(Gq1, [["render", Jq1]]);
var tz1 = {}, ez1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rz1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), nz1 = /* @__PURE__ */ t("path", {
  d: "M2 12H12M9 4V20M3 9L6 12L3 15M12 6L9 9L6 6M6 18L9 15L10.5 16.5M20 14.5351V4C20 2.89543 19.1046 2 18 2C16.8954 2 16 2.89543 16 4V14.5351C14.8044 15.2267 14 16.5194 14 18C14 20.2091 15.7909 22 18 22C20.2091 22 22 20.2091 22 18C22 16.5194 21.1956 15.2267 20 14.5351Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oz1 = [
  rz1,
  nz1
];
function iz1(r, e) {
  return n(), o("svg", ez1, oz1);
}
const fR2 = /* @__PURE__ */ i(tz1, [["render", iz1]]);
var lz1 = {}, sz1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hz1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), az1 = /* @__PURE__ */ t("path", {
  d: "M12 9C11.1077 8.98562 10.2363 9.27003 9.52424 9.808C8.81222 10.346 8.30055 11.1066 8.07061 11.9688C7.84068 12.8311 7.90568 13.7455 8.25529 14.5665C8.6049 15.3876 9.21904 16.0682 10 16.5M12 3V5M6.6 18.4L5.2 19.8M4 13H2M6.6 7.6L5.2 6.2M20 14.5351V4C20 2.89543 19.1046 2 18 2C16.8954 2 16 2.89543 16 4V14.5351C14.8044 15.2267 14 16.5194 14 18C14 20.2091 15.7909 22 18 22C20.2091 22 22 20.2091 22 18C22 16.5194 21.1956 15.2267 20 14.5351Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dz1 = [
  hz1,
  az1
];
function cz1(r, e) {
  return n(), o("svg", sz1, dz1);
}
const vR2 = /* @__PURE__ */ i(lz1, [["render", cz1]]);
var _z1 = {}, Cz1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fz1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), vz1 = /* @__PURE__ */ t("path", {
  d: "M17.0001 2V13M22.0001 9.8V5.2C22.0001 4.07989 22.0001 3.51984 21.7821 3.09202C21.5903 2.71569 21.2844 2.40973 20.908 2.21799C20.4802 2 19.9202 2 18.8001 2H8.11806C6.65658 2 5.92584 2 5.33563 2.26743C4.81545 2.50314 4.37335 2.88242 4.06129 3.36072C3.70722 3.90339 3.59611 4.62564 3.37388 6.07012L2.8508 9.47012C2.5577 11.3753 2.41114 12.3279 2.69386 13.0691C2.94199 13.7197 3.4087 14.2637 4.01398 14.6079C4.70358 15 5.66739 15 7.59499 15H8.40005C8.96011 15 9.24013 15 9.45404 15.109C9.64221 15.2049 9.79519 15.3578 9.89106 15.546C10.0001 15.7599 10.0001 16.0399 10.0001 16.6V19.5342C10.0001 20.896 11.104 22 12.4659 22C12.7907 22 13.0851 21.8087 13.217 21.5119L16.5778 13.9502C16.7306 13.6062 16.807 13.4343 16.9278 13.3082C17.0346 13.1967 17.1658 13.1115 17.311 13.0592C17.4753 13 17.6635 13 18.0398 13H18.8001C19.9202 13 20.4802 13 20.908 12.782C21.2844 12.5903 21.5903 12.2843 21.7821 11.908C22.0001 11.4802 22.0001 10.9201 22.0001 9.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), uz1 = [
  fz1,
  vz1
];
function wz1(r, e) {
  return n(), o("svg", Cz1, uz1);
}
const uR2 = /* @__PURE__ */ i(_z1, [["render", wz1]]);
var pz1 = {}, gz1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $z1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), Mz1 = /* @__PURE__ */ t("path", {
  d: "M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9197 20.3914 19.4562L21.4683 12.4562C21.7479 10.6389 20.3418 9 18.5032 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.915 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Lz1 = [
  $z1,
  Mz1
];
function kz1(r, e) {
  return n(), o("svg", gz1, Lz1);
}
const wR2 = /* @__PURE__ */ i(pz1, [["render", kz1]]);
var mz1 = {}, xz1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hz1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), Vz1 = /* @__PURE__ */ t("path", {
  d: "M10 8V7M10 12.5V11.5M10 17V16M5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40973 21.5903 4.71569 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V8.5C20.067 8.5 18.5 10.067 18.5 12C18.5 13.933 20.067 15.5 22 15.5V16.8C22 17.9201 22 18.4802 21.782 18.908C21.5903 19.2843 21.2843 19.5903 20.908 19.782C20.4802 20 19.9201 20 18.8 20H5.2C4.0799 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V15.5C3.933 15.5 5.5 13.933 5.5 12C5.5 10.067 3.933 8.5 2 8.5V7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Zz1 = [
  Hz1,
  Vz1
];
function Bz1(r, e) {
  return n(), o("svg", xz1, Zz1);
}
const pR2 = /* @__PURE__ */ i(mz1, [["render", Bz1]]);
var Fz1 = {}, jz1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Iz1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), bz1 = /* @__PURE__ */ t("path", {
  d: "M8 8V7M8 12.5V11.5M8 17V16M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), yz1 = [
  Iz1,
  bz1
];
function Dz1(r, e) {
  return n(), o("svg", jz1, yz1);
}
const gR2 = /* @__PURE__ */ i(Fz1, [["render", Dz1]]);
var Pz1 = {}, Az1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sz1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -796)",
  fill: "none"
}, null, -1), Tz1 = /* @__PURE__ */ t("path", {
  d: "M7 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H7M7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7M7 17C9.76142 17 12 14.7614 12 12C12 9.23858 9.76142 7 7 7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Oz1 = [
  Sz1,
  Tz1
];
function Ez1(r, e) {
  return n(), o("svg", Az1, Oz1);
}
const $R2 = /* @__PURE__ */ i(Pz1, [["render", Ez1]]);
var Rz1 = {}, Uz1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nz1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -836)",
  fill: "none"
}, null, -1), qz1 = /* @__PURE__ */ t("path", {
  d: "M17 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H17M17 17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7M17 17C14.2386 17 12 14.7614 12 12C12 9.23858 14.2386 7 17 7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), zz1 = [
  Nz1,
  qz1
];
function Kz1(r, e) {
  return n(), o("svg", Uz1, zz1);
}
const MR2 = /* @__PURE__ */ i(Rz1, [["render", Kz1]]);
var Gz1 = {}, Wz1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yz1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -876)",
  fill: "none"
}, null, -1), Xz1 = /* @__PURE__ */ t("path", {
  d: "M10.0005 16H18C20.2091 16 22 14.2091 22 12C22 9.79086 20.2091 8 18 8H10.0005M12 12C12 14.7614 9.76142 17 7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7C9.76142 7 12 9.23858 12 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Qz1 = [
  Yz1,
  Xz1
];
function Jz1(r, e) {
  return n(), o("svg", Wz1, Qz1);
}
const LR2 = /* @__PURE__ */ i(Gz1, [["render", Jz1]]);
var tK1 = {}, eK1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rK1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -916)",
  fill: "none"
}, null, -1), nK1 = /* @__PURE__ */ t("path", {
  d: "M13.9995 16H6C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8H13.9995M21.9995 12C21.9995 14.7614 19.7609 17 16.9995 17C14.2381 17 11.9995 14.7614 11.9995 12C11.9995 9.23858 14.2381 7 16.9995 7C19.7609 7 21.9995 9.23858 21.9995 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), oK1 = [
  rK1,
  nK1
];
function iK1(r, e) {
  return n(), o("svg", eK1, oK1);
}
const kR2 = /* @__PURE__ */ i(tK1, [["render", iK1]]);
var lK1 = {}, sK1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hK1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -956)",
  fill: "none"
}, null, -1), aK1 = /* @__PURE__ */ t("path", {
  d: "M2 12C2 8.68629 4.68629 6 8 6H16C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18H8C4.68629 18 2 15.3137 2 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dK1 = /* @__PURE__ */ t("path", {
  d: "M8 14.5C9.38071 14.5 10.5 13.3807 10.5 12C10.5 10.6193 9.38071 9.5 8 9.5C6.61929 9.5 5.5 10.6193 5.5 12C5.5 13.3807 6.61929 14.5 8 14.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), cK1 = [
  hK1,
  aK1,
  dK1
];
function _K1(r, e) {
  return n(), o("svg", sK1, cK1);
}
const mR2 = /* @__PURE__ */ i(lK1, [["render", _K1]]);
var CK1 = {}, fK1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vK1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -996)",
  fill: "none"
}, null, -1), uK1 = /* @__PURE__ */ t("path", {
  d: "M2 12C2 8.68629 4.68629 6 8 6H16C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18H8C4.68629 18 2 15.3137 2 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), wK1 = /* @__PURE__ */ t("path", {
  d: "M16 14.5C17.3807 14.5 18.5 13.3807 18.5 12C18.5 10.6193 17.3807 9.5 16 9.5C14.6193 9.5 13.5 10.6193 13.5 12C13.5 13.3807 14.6193 14.5 16 14.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pK1 = [
  vK1,
  uK1,
  wK1
];
function gK1(r, e) {
  return n(), o("svg", fK1, pK1);
}
const xR2 = /* @__PURE__ */ i(CK1, [["render", gK1]]);
var $K1 = {}, MK1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LK1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1036)",
  fill: "none"
}, null, -1), kK1 = /* @__PURE__ */ t("path", {
  d: "M15.6314 7.63137C15.2353 7.23535 15.0373 7.03735 14.9631 6.80902C14.8979 6.60817 14.8979 6.39183 14.9631 6.19098C15.0373 5.96265 15.2353 5.76465 15.6314 5.36863L18.4697 2.53026C17.7165 2.18962 16.8804 2 16 2C12.6863 2 9.99998 4.68629 9.99998 8C9.99998 8.49104 10.059 8.9683 10.1702 9.42509C10.2894 9.91424 10.349 10.1588 10.3384 10.3133C10.3273 10.4751 10.3032 10.5612 10.2286 10.7051C10.1574 10.8426 10.0208 10.9791 9.7478 11.2522L3.49998 17.5C2.67156 18.3284 2.67156 19.6716 3.49998 20.5C4.32841 21.3284 5.67156 21.3284 6.49998 20.5L12.7478 14.2522C13.0208 13.9791 13.1574 13.8426 13.2949 13.7714C13.4388 13.6968 13.5249 13.6727 13.6867 13.6616C13.8412 13.651 14.0857 13.7106 14.5749 13.8297C15.0317 13.941 15.5089 14 16 14C19.3137 14 22 11.3137 22 8C22 7.11959 21.8104 6.28347 21.4697 5.53026L18.6314 8.36863C18.2353 8.76465 18.0373 8.96265 17.809 9.03684C17.6082 9.1021 17.3918 9.1021 17.191 9.03684C16.9626 8.96265 16.7646 8.76465 16.3686 8.36863L15.6314 7.63137Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mK1 = [
  LK1,
  kK1
];
function xK1(r, e) {
  return n(), o("svg", MK1, mK1);
}
const HR2 = /* @__PURE__ */ i($K1, [["render", xK1]]);
var HK1 = {}, VK1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZK1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1076)",
  fill: "none"
}, null, -1), BK1 = /* @__PURE__ */ t("path", {
  d: "M6 6L10.5 10.5M6 6H3L2 3L3 2L6 3V6ZM19.259 2.74101L16.6314 5.36863C16.2354 5.76465 16.0373 5.96265 15.9632 6.19098C15.8979 6.39183 15.8979 6.60817 15.9632 6.80902C16.0373 7.03735 16.2354 7.23535 16.6314 7.63137L16.8686 7.86863C17.2646 8.26465 17.4627 8.46265 17.691 8.53684C17.8918 8.6021 18.1082 8.6021 18.309 8.53684C18.5373 8.46265 18.7354 8.26465 19.1314 7.86863L21.5893 5.41072C21.854 6.05488 22 6.76039 22 7.5C22 10.5376 19.5376 13 16.5 13C16.1338 13 15.7759 12.9642 15.4298 12.8959C14.9436 12.8001 14.7005 12.7521 14.5532 12.7668C14.3965 12.7824 14.3193 12.8059 14.1805 12.8802C14.0499 12.9501 13.919 13.081 13.657 13.343L6.5 20.5C5.67157 21.3284 4.32843 21.3284 3.5 20.5C2.67157 19.6716 2.67157 18.3284 3.5 17.5L10.657 10.343C10.919 10.081 11.0499 9.95005 11.1198 9.81949C11.1941 9.68068 11.2176 9.60347 11.2332 9.44681C11.2479 9.29945 11.1999 9.05638 11.1041 8.57024C11.0358 8.22406 11 7.86621 11 7.5C11 4.46243 13.4624 2 16.5 2C17.5055 2 18.448 2.26982 19.259 2.74101ZM12.0001 14.9999L17.5 20.4999C18.3284 21.3283 19.6716 21.3283 20.5 20.4999C21.3284 19.6715 21.3284 18.3283 20.5 17.4999L15.9753 12.9753C15.655 12.945 15.3427 12.8872 15.0408 12.8043C14.6517 12.6975 14.2249 12.7751 13.9397 13.0603L12.0001 14.9999Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FK1 = [
  ZK1,
  BK1
];
function jK1(r, e) {
  return n(), o("svg", VK1, FK1);
}
const VR2 = /* @__PURE__ */ i(HK1, [["render", jK1]]);
var IK1 = {}, bK1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yK1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), DK1 = /* @__PURE__ */ t("path", {
  d: "M9.5 22H14.5M8 2H16M12 5V2M4 12H20M17 19L18.5 22M7 19L5.5 22M8.5 15.5H8.51M15.5 15.5H15.51M8.8 19H15.2C16.8802 19 17.7202 19 18.362 18.673C18.9265 18.3854 19.3854 17.9265 19.673 17.362C20 16.7202 20 15.8802 20 14.2V9.8C20 8.11984 20 7.27976 19.673 6.63803C19.3854 6.07354 18.9265 5.6146 18.362 5.32698C17.7202 5 16.8802 5 15.2 5H8.8C7.11984 5 6.27976 5 5.63803 5.32698C5.07354 5.6146 4.6146 6.07354 4.32698 6.63803C4 7.27976 4 8.11984 4 9.8V14.2C4 15.8802 4 16.7202 4.32698 17.362C4.6146 17.9265 5.07354 18.3854 5.63803 18.673C6.27976 19 7.11984 19 8.8 19ZM9 15.5C9 15.7761 8.77614 16 8.5 16C8.22386 16 8 15.7761 8 15.5C8 15.2239 8.22386 15 8.5 15C8.77614 15 9 15.2239 9 15.5ZM16 15.5C16 15.7761 15.7761 16 15.5 16C15.2239 16 15 15.7761 15 15.5C15 15.2239 15.2239 15 15.5 15C15.7761 15 16 15.2239 16 15.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PK1 = [
  yK1,
  DK1
];
function AK1(r, e) {
  return n(), o("svg", bK1, PK1);
}
const ZR2 = /* @__PURE__ */ i(IK1, [["render", AK1]]);
var SK1 = {}, TK1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OK1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), EK1 = /* @__PURE__ */ t("path", {
  d: "M18.5 3L17.5135 2.50675C17.1355 2.31776 16.9465 2.22326 16.7485 2.15662C16.5725 2.09744 16.3915 2.05471 16.2077 2.02897C16.0008 2 15.7895 2 15.3669 2H8.63313C8.21053 2 7.99923 2 7.79227 2.02897C7.60847 2.05471 7.42745 2.09744 7.25155 2.15662C7.05348 2.22326 6.86449 2.31776 6.4865 2.50675L5.5 3M11 6L9 2M13 6L15 2M4 13H20M17 20L18 22M7 20L6.00016 22M8.5 16.5H8.51M15.5 16.5H15.51M8.8 20H15.2C16.8802 20 17.7202 20 18.362 19.673C18.9265 19.3854 19.3854 18.9265 19.673 18.362C20 17.7202 20 16.8802 20 15.2V10.8C20 9.11984 20 8.27976 19.673 7.63803C19.3854 7.07354 18.9265 6.6146 18.362 6.32698C17.7202 6 16.8802 6 15.2 6H8.8C7.11984 6 6.27976 6 5.63803 6.32698C5.07354 6.6146 4.6146 7.07354 4.32698 7.63803C4 8.27976 4 9.11984 4 10.8V15.2C4 16.8802 4 17.7202 4.32698 18.362C4.6146 18.9265 5.07354 19.3854 5.63803 19.673C6.27976 20 7.11984 20 8.8 20ZM9 16.5C9 16.7761 8.77614 17 8.5 17C8.22386 17 8 16.7761 8 16.5C8 16.2239 8.22386 16 8.5 16C8.77614 16 9 16.2239 9 16.5ZM16 16.5C16 16.7761 15.7761 17 15.5 17C15.2239 17 15 16.7761 15 16.5C15 16.2239 15.2239 16 15.5 16C15.7761 16 16 16.2239 16 16.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), RK1 = [
  OK1,
  EK1
];
function UK1(r, e) {
  return n(), o("svg", TK1, RK1);
}
const BR2 = /* @__PURE__ */ i(SK1, [["render", UK1]]);
var NK1 = {}, qK1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zK1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -756)",
  fill: "none"
}, null, -1), KK1 = /* @__PURE__ */ t("path", {
  d: "M19 7V17M5 7V17M17 5L7 5M17 19H7M4.6 7H5.4C5.96005 7 6.24008 7 6.45399 6.89101C6.64215 6.79513 6.79513 6.64215 6.89101 6.45399C7 6.24008 7 5.96005 7 5.4V4.6C7 4.03995 7 3.75992 6.89101 3.54601C6.79513 3.35785 6.64215 3.20487 6.45399 3.10899C6.24008 3 5.96005 3 5.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V5.4C3 5.96005 3 6.24008 3.10899 6.45399C3.20487 6.64215 3.35785 6.79513 3.54601 6.89101C3.75992 7 4.03995 7 4.6 7ZM4.6 21H5.4C5.96005 21 6.24008 21 6.45399 20.891C6.64215 20.7951 6.79513 20.6422 6.89101 20.454C7 20.2401 7 19.9601 7 19.4V18.6C7 18.0399 7 17.7599 6.89101 17.546C6.79513 17.3578 6.64215 17.2049 6.45399 17.109C6.24008 17 5.96005 17 5.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3578 3.10899 17.546C3 17.7599 3 18.0399 3 18.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21ZM18.6 7H19.4C19.9601 7 20.2401 7 20.454 6.89101C20.6422 6.79513 20.7951 6.64215 20.891 6.45399C21 6.24008 21 5.96005 21 5.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H18.6C18.0399 3 17.7599 3 17.546 3.10899C17.3578 3.20487 17.2049 3.35785 17.109 3.54601C17 3.75992 17 4.03995 17 4.6V5.4C17 5.96005 17 6.24008 17.109 6.45399C17.2049 6.64215 17.3578 6.79513 17.546 6.89101C17.7599 7 18.0399 7 18.6 7ZM18.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.0399 21 17.7599 20.891 17.546C20.7951 17.3578 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H18.6C18.0399 17 17.7599 17 17.546 17.109C17.3578 17.2049 17.2049 17.3578 17.109 17.546C17 17.7599 17 18.0399 17 18.6V19.4C17 19.9601 17 20.2401 17.109 20.454C17.2049 20.6422 17.3578 20.7951 17.546 20.891C17.7599 21 18.0399 21 18.6 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GK1 = [
  zK1,
  KK1
];
function WK1(r, e) {
  return n(), o("svg", qK1, GK1);
}
const FR2 = /* @__PURE__ */ i(NK1, [["render", WK1]]);
var YK1 = {}, XK1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QK1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1116)",
  fill: "none"
}, null, -1), JK1 = /* @__PURE__ */ t("path", {
  d: "M12.913 17H20.087M12.913 17L11 21M12.913 17L15.7783 11.009C16.0092 10.5263 16.1246 10.2849 16.2826 10.2086C16.4199 10.1423 16.5801 10.1423 16.7174 10.2086C16.8754 10.2849 16.9908 10.5263 17.2217 11.009L20.087 17M20.087 17L22 21M2 5H8M8 5H11.5M8 5V3M11.5 5H14M11.5 5C11.0039 7.95729 9.85259 10.6362 8.16555 12.8844M10 14C9.38747 13.7248 8.76265 13.3421 8.16555 12.8844M8.16555 12.8844C6.81302 11.8478 5.60276 10.4266 5 9M8.16555 12.8844C6.56086 15.0229 4.47143 16.7718 2 18",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tG1 = [
  QK1,
  JK1
];
function eG1(r, e) {
  return n(), o("svg", XK1, tG1);
}
const jR2 = /* @__PURE__ */ i(YK1, [["render", eG1]]);
var rG1 = {}, nG1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oG1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1156)",
  fill: "none"
}, null, -1), iG1 = /* @__PURE__ */ t("path", {
  d: "M5 8L10 13M4 14L10 8L12 5M2 5H14M7 2H8M12.913 17H20.087M12.913 17L11 21M12.913 17L15.7783 11.009C16.0092 10.5263 16.1246 10.2849 16.2826 10.2086C16.4199 10.1423 16.5801 10.1423 16.7174 10.2086C16.8754 10.2849 16.9908 10.5263 17.2217 11.009L20.087 17M20.087 17L22 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lG1 = [
  oG1,
  iG1
];
function sG1(r, e) {
  return n(), o("svg", nG1, lG1);
}
const IR2 = /* @__PURE__ */ i(rG1, [["render", sG1]]);
var hG1 = {}, aG1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dG1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1196)",
  fill: "none"
}, null, -1), cG1 = /* @__PURE__ */ t("path", {
  d: "M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _G1 = [
  dG1,
  cG1
];
function CG1(r, e) {
  return n(), o("svg", aG1, _G1);
}
const bR2 = /* @__PURE__ */ i(hG1, [["render", CG1]]);
var fG1 = {}, vG1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uG1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1236)",
  fill: "none"
}, null, -1), wG1 = /* @__PURE__ */ t("path", {
  d: "M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pG1 = [
  uG1,
  wG1
];
function gG1(r, e) {
  return n(), o("svg", vG1, pG1);
}
const yR2 = /* @__PURE__ */ i(fG1, [["render", gG1]]);
var $G1 = {}, MG1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LG1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1276)",
  fill: "none"
}, null, -1), kG1 = /* @__PURE__ */ t("path", {
  d: "M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mG1 = [
  LG1,
  kG1
];
function xG1(r, e) {
  return n(), o("svg", MG1, mG1);
}
const DR2 = /* @__PURE__ */ i($G1, [["render", xG1]]);
var HG1 = {}, VG1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZG1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1316)",
  fill: "none"
}, null, -1), BG1 = /* @__PURE__ */ t("path", {
  d: "M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FG1 = [
  ZG1,
  BG1
];
function jG1(r, e) {
  return n(), o("svg", VG1, FG1);
}
const PR2 = /* @__PURE__ */ i(HG1, [["render", jG1]]);
var IG1 = {}, bG1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yG1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-891 -396)",
  fill: "none"
}, null, -1), DG1 = /* @__PURE__ */ t("path", {
  d: "M22 17L14.1314 9.13137C13.7354 8.73535 13.5373 8.53735 13.309 8.46316C13.1082 8.3979 12.8918 8.3979 12.691 8.46316C12.4627 8.53735 12.2646 8.73535 11.8686 9.13137L9.13137 11.8686C8.73535 12.2646 8.53735 12.4627 8.30902 12.5368C8.10817 12.6021 7.89183 12.6021 7.69098 12.5368C7.46265 12.4627 7.26465 12.2646 6.86863 11.8686L2 7M22 17H15M22 17V10",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PG1 = [
  yG1,
  DG1
];
function AG1(r, e) {
  return n(), o("svg", bG1, PG1);
}
const AR2 = /* @__PURE__ */ i(IG1, [["render", AG1]]);
var SG1 = {}, TG1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OG1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-891 -436)",
  fill: "none"
}, null, -1), EG1 = /* @__PURE__ */ t("path", {
  d: "M7 7L17 17M17 17V7M17 17H7",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), RG1 = [
  OG1,
  EG1
];
function UG1(r, e) {
  return n(), o("svg", TG1, RG1);
}
const SR2 = /* @__PURE__ */ i(SG1, [["render", UG1]]);
var NG1 = {}, qG1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zG1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-891 -476)",
  fill: "none"
}, null, -1), KG1 = /* @__PURE__ */ t("path", {
  d: "M22 7L14.1314 14.8686C13.7354 15.2646 13.5373 15.4627 13.309 15.5368C13.1082 15.6021 12.8918 15.6021 12.691 15.5368C12.4627 15.4627 12.2646 15.2646 11.8686 14.8686L9.13137 12.1314C8.73535 11.7354 8.53735 11.5373 8.30902 11.4632C8.10817 11.3979 7.89183 11.3979 7.69098 11.4632C7.46265 11.5373 7.26465 11.7354 6.86863 12.1314L2 17M22 7H15M22 7V14",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GG1 = [
  zG1,
  KG1
];
function WG1(r, e) {
  return n(), o("svg", qG1, GG1);
}
const TR2 = /* @__PURE__ */ i(NG1, [["render", WG1]]);
var YG1 = {}, XG1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QG1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-891 -516)",
  fill: "none"
}, null, -1), JG1 = /* @__PURE__ */ t("path", {
  d: "M7 17L17 7M17 7H7M17 7V17",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tW1 = [
  QG1,
  JG1
];
function eW1(r, e) {
  return n(), o("svg", XG1, tW1);
}
const OR2 = /* @__PURE__ */ i(YG1, [["render", eW1]]);
var rW1 = {}, nW1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oW1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), iW1 = /* @__PURE__ */ t("path", {
  d: "M2.39019 18.0983L10.6151 3.89171C11.0696 3.10655 11.2969 2.71396 11.5935 2.58211C11.8521 2.4671 12.1474 2.4671 12.4061 2.58211C12.7026 2.71396 12.9299 3.10654 13.3844 3.89171L21.6093 18.0983C22.0655 18.8863 22.2936 19.2803 22.2599 19.6037C22.2305 19.8857 22.0827 20.142 21.8534 20.3088C21.5904 20.5 21.1352 20.5 20.2246 20.5H3.77487C2.86435 20.5 2.40908 20.5 2.14613 20.3088C1.91677 20.142 1.769 19.8857 1.73959 19.6037C1.70588 19.2803 1.93398 18.8863 2.39019 18.0983Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lW1 = [
  oW1,
  iW1
];
function sW1(r, e) {
  return n(), o("svg", nW1, lW1);
}
const ER2 = /* @__PURE__ */ i(rW1, [["render", sW1]]);
var hW1 = {}, aW1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dW1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), cW1 = /* @__PURE__ */ t("path", {
  d: "M12 15C8.68629 15 6 12.3137 6 9V3.44444C6 3.0306 6 2.82367 6.06031 2.65798C6.16141 2.38021 6.38021 2.16141 6.65798 2.06031C6.82367 2 7.0306 2 7.44444 2H16.5556C16.9694 2 17.1763 2 17.342 2.06031C17.6198 2.16141 17.8386 2.38021 17.9397 2.65798C18 2.82367 18 3.0306 18 3.44444V9C18 12.3137 15.3137 15 12 15ZM12 15V18M18 4H20.5C20.9659 4 21.1989 4 21.3827 4.07612C21.6277 4.17761 21.8224 4.37229 21.9239 4.61732C22 4.80109 22 5.03406 22 5.5V6C22 6.92997 22 7.39496 21.8978 7.77646C21.6204 8.81173 20.8117 9.62038 19.7765 9.89778C19.395 10 18.93 10 18 10M6 4H3.5C3.03406 4 2.80109 4 2.61732 4.07612C2.37229 4.17761 2.17761 4.37229 2.07612 4.61732C2 4.80109 2 5.03406 2 5.5V6C2 6.92997 2 7.39496 2.10222 7.77646C2.37962 8.81173 3.18827 9.62038 4.22354 9.89778C4.60504 10 5.07003 10 6 10M7.44444 22H16.5556C16.801 22 17 21.801 17 21.5556C17 19.5919 15.4081 18 13.4444 18H10.5556C8.59188 18 7 19.5919 7 21.5556C7 21.801 7.19898 22 7.44444 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _W1 = [
  dW1,
  cW1
];
function CW1(r, e) {
  return n(), o("svg", aW1, _W1);
}
const RR2 = /* @__PURE__ */ i(hW1, [["render", CW1]]);
var fW1 = {}, vW1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uW1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "540",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), wW1 = /* @__PURE__ */ t("path", {
  d: "M12 17C8.41015 17 5.5 14.0899 5.5 10.5V4.55556C5.5 4.03739 5.5 3.77831 5.59369 3.57738C5.69305 3.36431 5.86431 3.19305 6.07738 3.09369C6.27831 3 6.53739 3 7.05556 3H16.9444C17.4626 3 17.7217 3 17.9226 3.09369C18.1357 3.19305 18.3069 3.36431 18.4063 3.57738C18.5 3.77831 18.5 4.03739 18.5 4.55556V10.5C18.5 14.0899 15.5899 17 12 17ZM12 17V21M17 21H7M22 5V10M2 5V10",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pW1 = [
  uW1,
  wW1
];
function gW1(r, e) {
  return n(), o("svg", vW1, pW1);
}
const UR2 = /* @__PURE__ */ i(fW1, [["render", gW1]]);
var $W1 = {}, MW1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LW1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), kW1 = /* @__PURE__ */ t("path", {
  d: "M14 7H16.3373C16.5818 7 16.7041 7 16.8192 7.02763C16.9213 7.05213 17.0188 7.09253 17.1083 7.14736C17.2092 7.2092 17.2957 7.29568 17.4686 7.46863L21.5314 11.5314C21.7043 11.7043 21.7908 11.7908 21.8526 11.8917C21.9075 11.9812 21.9479 12.0787 21.9724 12.1808C22 12.2959 22 12.4182 22 12.6627V15.5C22 15.9659 22 16.1989 21.9239 16.3827C21.8224 16.6277 21.6277 16.8224 21.3827 16.9239C21.1989 17 20.9659 17 20.5 17M15.5 17H14M14 17V7.2C14 6.0799 14 5.51984 13.782 5.09202C13.5903 4.71569 13.2843 4.40973 12.908 4.21799C12.4802 4 11.9201 4 10.8 4H5.2C4.0799 4 3.51984 4 3.09202 4.21799C2.71569 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.0799 2 7.2V15C2 16.1046 2.89543 17 4 17M14 17H10M10 17C10 18.6569 8.65685 20 7 20C5.34315 20 4 18.6569 4 17M10 17C10 15.3431 8.65685 14 7 14C5.34315 14 4 15.3431 4 17M20.5 17.5C20.5 18.8807 19.3807 20 18 20C16.6193 20 15.5 18.8807 15.5 17.5C15.5 16.1193 16.6193 15 18 15C19.3807 15 20.5 16.1193 20.5 17.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mW1 = [
  LW1,
  kW1
];
function xW1(r, e) {
  return n(), o("svg", MW1, mW1);
}
const NR2 = /* @__PURE__ */ i($W1, [["render", xW1]]);
var HW1 = {}, VW1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZW1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "700",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), BW1 = /* @__PURE__ */ t("path", {
  d: "M16 16V6.2C16 5.0799 16 4.51984 15.782 4.09202C15.5903 3.71569 15.2843 3.40973 14.908 3.21799C14.4802 3 13.9201 3 12.8 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.0799 16 5.2 16H16ZM16 16H20.4C20.9601 16 21.2401 16 21.454 15.891C21.6422 15.7951 21.7951 15.6422 21.891 15.454C22 15.2401 22 14.9601 22 14.4V11.6627C22 11.4182 22 11.2959 21.9724 11.1808C21.9479 11.0787 21.9075 10.9812 21.8526 10.8917C21.7908 10.7908 21.7043 10.7043 21.5314 10.5314L19.4686 8.46863C19.2957 8.29568 19.2092 8.2092 19.1083 8.14736C19.0188 8.09253 18.9213 8.05213 18.8192 8.02763C18.7041 8 18.5818 8 18.3373 8H16M9 18.5C9 19.8807 7.88071 21 6.5 21C5.11929 21 4 19.8807 4 18.5C4 17.1193 5.11929 16 6.5 16C7.88071 16 9 17.1193 9 18.5ZM20 18.5C20 19.8807 18.8807 21 17.5 21C16.1193 21 15 19.8807 15 18.5C15 17.1193 16.1193 16 17.5 16C18.8807 16 20 17.1193 20 18.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FW1 = [
  ZW1,
  BW1
];
function jW1(r, e) {
  return n(), o("svg", VW1, FW1);
}
const qR2 = /* @__PURE__ */ i(HW1, [["render", jW1]]);
var IW1 = {}, bW1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yW1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -556)",
  fill: "none"
}, null, -1), DW1 = /* @__PURE__ */ t("path", {
  d: "M18 17V19.4C18 19.9601 18 20.2401 17.891 20.454C17.7951 20.6422 17.6422 20.7951 17.454 20.891C17.2401 21 16.9601 21 16.4 21H7.6C7.03995 21 6.75992 21 6.54601 20.891C6.35785 20.7951 6.20487 20.6422 6.10899 20.454C6 20.2401 6 19.9601 6 19.4V17M6.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PW1 = [
  yW1,
  DW1
];
function AW1(r, e) {
  return n(), o("svg", bW1, PW1);
}
const zR2 = /* @__PURE__ */ i(IW1, [["render", AW1]]);
var SW1 = {}, TW1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OW1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -596)",
  fill: "none"
}, null, -1), EW1 = /* @__PURE__ */ t("path", {
  d: "M17 21L12 17L7 21M6.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), RW1 = [
  OW1,
  EW1
];
function UW1(r, e) {
  return n(), o("svg", TW1, RW1);
}
const KR2 = /* @__PURE__ */ i(SW1, [["render", UW1]]);
var NW1 = {}, qW1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zW1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -636)",
  fill: "none"
}, null, -1), KW1 = /* @__PURE__ */ t("path", {
  d: "M17 3L12 7L7 3M6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V11.8C22 10.1198 22 9.27976 21.673 8.63803C21.3854 8.07354 20.9265 7.6146 20.362 7.32698C19.7202 7 18.8802 7 17.2 7H6.8C5.11984 7 4.27976 7 3.63803 7.32698C3.07354 7.6146 2.6146 8.07354 2.32698 8.63803C2 9.27976 2 10.1198 2 11.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GW1 = [
  zW1,
  KW1
];
function WW1(r, e) {
  return n(), o("svg", qW1, GW1);
}
const GR2 = /* @__PURE__ */ i(NW1, [["render", WW1]]);
var YW1 = {}, XW1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QW1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -796)",
  fill: "none"
}, null, -1), JW1 = /* @__PURE__ */ t("path", {
  d: "M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M9 20H15M12 4V20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tY1 = [
  QW1,
  JW1
];
function eY1(r, e) {
  return n(), o("svg", XW1, tY1);
}
const WR2 = /* @__PURE__ */ i(YW1, [["render", eY1]]);
var rY1 = {}, nY1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oY1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -836)",
  fill: "none"
}, null, -1), iY1 = /* @__PURE__ */ t("path", {
  d: "M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M8 20H16M10.25 4V20M13.75 4V20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lY1 = [
  oY1,
  iY1
];
function sY1(r, e) {
  return n(), o("svg", nY1, lY1);
}
const YR2 = /* @__PURE__ */ i(rY1, [["render", sY1]]);
var hY1 = {}, aY1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dY1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -876)",
  fill: "none"
}, null, -1), cY1 = /* @__PURE__ */ t("path", {
  d: "M8 7H16M12 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _Y1 = [
  dY1,
  cY1
];
function CY1(r, e) {
  return n(), o("svg", aY1, _Y1);
}
const XR2 = /* @__PURE__ */ i(hY1, [["render", CY1]]);
var fY1 = {}, vY1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uY1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -916)",
  fill: "none"
}, null, -1), wY1 = /* @__PURE__ */ t("path", {
  d: "M4 7V6C4 5.45879 4.21497 4.96778 4.56419 4.60772M9 20H15M12 12V20M3 3L21 21M9.5 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M12 4V6.5",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pY1 = [
  uY1,
  wY1
];
function gY1(r, e) {
  return n(), o("svg", vY1, pY1);
}
const QR2 = /* @__PURE__ */ i(fY1, [["render", gY1]]);
var $Y1 = {}, MY1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LY1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -956)",
  fill: "none"
}, null, -1), kY1 = /* @__PURE__ */ t("path", {
  d: "M8 20H16M10.25 10.5V20M13.75 14V20M3 3L21 21M4 6.99995V5.99995C4 5.45873 4.21497 4.96773 4.56419 4.60767M9.5 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M10.25 4V5M13.75 4V8",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mY1 = [
  LY1,
  kY1
];
function xY1(r, e) {
  return n(), o("svg", MY1, mY1);
}
const JR2 = /* @__PURE__ */ i($Y1, [["render", xY1]]);
var HY1 = {}, VY1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZY1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), BY1 = /* @__PURE__ */ t("path", {
  d: "M17 19.4C17 20.8359 15.8807 22 14.5 22C13.1193 22 12 20.8359 12 19.4V12M2.12627 10.4063C2.88948 5.64091 7.01953 2 12 2C16.9804 2 21.1104 5.64091 21.8737 10.4063C21.9482 10.8714 21.9854 11.1039 21.8919 11.3523C21.8175 11.55 21.6353 11.7636 21.4519 11.8684C21.2214 12 20.9476 12 20.4 12H3.59997C3.05232 12 2.7785 12 2.54801 11.8684C2.36463 11.7636 2.18246 11.55 2.10805 11.3523C2.01453 11.1039 2.05178 10.8714 2.12627 10.4063Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FY1 = [
  ZY1,
  BY1
];
function jY1(r, e) {
  return n(), o("svg", VY1, FY1);
}
const tU2 = /* @__PURE__ */ i(HY1, [["render", jY1]]);
var IY1 = {}, bY1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yY1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), DY1 = /* @__PURE__ */ t("path", {
  d: "M7 19.4C7 20.8359 8.11929 22 9.5 22C10.8807 22 12 20.8359 12 19.4V11M12 11C10.3898 11 8 12 8 12C8 12 6.61017 11 5 11C3.38983 11 2 12 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12 20.6102 11 19 11C17.3898 11 16 12 16 12C16 12 13.6102 11 12 11Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PY1 = [
  yY1,
  DY1
];
function AY1(r, e) {
  return n(), o("svg", bY1, PY1);
}
const eU2 = /* @__PURE__ */ i(IY1, [["render", AY1]]);
var SY1 = {}, TY1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OY1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -476)",
  fill: "none"
}, null, -1), EY1 = /* @__PURE__ */ t("path", {
  d: "M6.25 21.9595L12 12.0002M17 3.33995C12.6868 0.849735 7.28964 1.93783 4.246 5.68314C3.94893 6.0487 3.80039 6.23148 3.75718 6.49336C3.7228 6.70172 3.77373 6.97785 3.88018 7.16024C4.01398 7.38947 4.25111 7.52638 4.72539 7.8002L19.2746 16.2002C19.7489 16.474 19.986 16.6109 20.2514 16.6122C20.4626 16.6132 20.7272 16.5192 20.8905 16.3853C21.0957 16.2169 21.1797 15.9969 21.3477 15.5568C23.0695 11.0483 21.3132 5.83017 17 3.33995ZM17 3.33995C15.0868 2.23538 11.2973 5.21728 8.5359 10.0002M17 3.33995C18.9132 4.44452 18.2255 9.21728 15.4641 14.0002M22 22.0002H2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), RY1 = [
  OY1,
  EY1
];
function UY1(r, e) {
  return n(), o("svg", TY1, RY1);
}
const rU2 = /* @__PURE__ */ i(SY1, [["render", UY1]]);
var NY1 = {}, qY1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zY1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -996)",
  fill: "none"
}, null, -1), KY1 = /* @__PURE__ */ t("path", {
  d: "M18 4V11C18 14.3137 15.3137 17 12 17C8.68629 17 6 14.3137 6 11V4M4 21H20",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), GY1 = [
  zY1,
  KY1
];
function WY1(r, e) {
  return n(), o("svg", qY1, GY1);
}
const nU2 = /* @__PURE__ */ i(NY1, [["render", WY1]]);
var YY1 = {}, XY1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QY1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -1036)",
  fill: "none"
}, null, -1), JY1 = /* @__PURE__ */ t("path", {
  d: "M19 4V10C19 13.866 15.866 17 12 17C8.13401 17 5 13.866 5 10V4M8.5 4V10C8.5 13.2218 10.6766 15.9352 13.6395 16.7501M4 21H20M3 4L10.5 4M17 4L21 4",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), tX1 = [
  QY1,
  JY1
];
function eX1(r, e) {
  return n(), o("svg", XY1, tX1);
}
const oU2 = /* @__PURE__ */ i(YY1, [["render", eX1]]);
var rX1 = {}, nX1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oX1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -1076)",
  fill: "none"
}, null, -1), iX1 = /* @__PURE__ */ t("path", {
  d: "M15.5 7V10.5C15.5 12.433 13.933 14 12 14C10.067 14 8.5 12.433 8.5 10.5V7M8 17H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), lX1 = [
  oX1,
  iX1
];
function sX1(r, e) {
  return n(), o("svg", nX1, lX1);
}
const iU2 = /* @__PURE__ */ i(rX1, [["render", sX1]]);
var hX1 = {}, aX1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dX1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1356)",
  fill: "none"
}, null, -1), cX1 = /* @__PURE__ */ t("path", {
  d: "M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _X1 = [
  dX1,
  cX1
];
function CX1(r, e) {
  return n(), o("svg", aX1, _X1);
}
const lU2 = /* @__PURE__ */ i(hX1, [["render", CX1]]);
var fX1 = {}, vX1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uX1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1396)",
  fill: "none"
}, null, -1), wX1 = /* @__PURE__ */ t("path", {
  d: "M21 3H3M18 13L12 7M12 7L6 13M12 7V21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pX1 = [
  uX1,
  wX1
];
function gX1(r, e) {
  return n(), o("svg", vX1, pX1);
}
const sU2 = /* @__PURE__ */ i(fX1, [["render", gX1]]);
var $X1 = {}, MX1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LX1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1436)",
  fill: "none"
}, null, -1), kX1 = /* @__PURE__ */ t("path", {
  d: "M16 12L12 8M12 8L8 12M12 8V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), mX1 = [
  LX1,
  kX1
];
function xX1(r, e) {
  return n(), o("svg", MX1, mX1);
}
const hU2 = /* @__PURE__ */ i($X1, [["render", xX1]]);
var HX1 = {}, VX1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZX1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1476)",
  fill: "none"
}, null, -1), BX1 = /* @__PURE__ */ t("path", {
  d: "M16 12L12 8M12 8L8 12M12 8V17.2C12 18.5907 12 19.2861 12.5505 20.0646C12.9163 20.5819 13.9694 21.2203 14.5972 21.3054C15.5421 21.4334 15.9009 21.2462 16.6186 20.8719C19.8167 19.2036 22 15.8568 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.7014 4.01099 18.9331 7 20.6622",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), FX1 = [
  ZX1,
  BX1
];
function jX1(r, e) {
  return n(), o("svg", VX1, FX1);
}
const aU2 = /* @__PURE__ */ i(HX1, [["render", jX1]]);
var IX1 = {}, bX1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yX1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1516)",
  fill: "none"
}, null, -1), DX1 = /* @__PURE__ */ t("path", {
  d: "M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), PX1 = [
  yX1,
  DX1
];
function AX1(r, e) {
  return n(), o("svg", bX1, PX1);
}
const SX1 = /* @__PURE__ */ i(IX1, [["render", AX1]]);
var TX1 = {}, OX1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, EX1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1556)",
  fill: "none"
}, null, -1), RX1 = /* @__PURE__ */ t("path", {
  d: "M8 16L12 12M12 12L16 16M12 12V21M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), UX1 = [
  EX1,
  RX1
];
function NX1(r, e) {
  return n(), o("svg", OX1, UX1);
}
const dU2 = /* @__PURE__ */ i(TX1, [["render", NX1]]);
var qX1 = {}, zX1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, KX1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -676)",
  fill: "none"
}, null, -1), GX1 = /* @__PURE__ */ t("path", {
  d: "M18 9V3.6C18 3.03995 18 2.75992 17.891 2.54601C17.7951 2.35785 17.6422 2.20487 17.454 2.10899C17.2401 2 16.9601 2 16.4 2H7.6C7.03995 2 6.75992 2 6.54601 2.10899C6.35785 2.20487 6.20487 2.35785 6.10899 2.54601C6 2.75992 6 3.03995 6 3.6V9M10 6V5M14 6V5M8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V12.2C20 11.0799 20 10.5198 19.782 10.092C19.5903 9.71569 19.2843 9.40973 18.908 9.21799C18.4802 9 17.9201 9 16.8 9H7.2C6.0799 9 5.51984 9 5.09202 9.21799C4.71569 9.40973 4.40973 9.71569 4.21799 10.092C4 10.5198 4 11.0799 4 12.2V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), WX1 = [
  KX1,
  GX1
];
function YX1(r, e) {
  return n(), o("svg", zX1, WX1);
}
const cU2 = /* @__PURE__ */ i(qX1, [["render", YX1]]);
var XX1 = {}, QX1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, JX1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -436)",
  fill: "none"
}, null, -1), tQ1 = /* @__PURE__ */ t("path", {
  d: "M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), eQ1 = [
  JX1,
  tQ1
];
function rQ1(r, e) {
  return n(), o("svg", QX1, eQ1);
}
const _U2 = /* @__PURE__ */ i(XX1, [["render", rQ1]]);
var nQ1 = {}, oQ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iQ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -476)",
  fill: "none"
}, null, -1), lQ1 = /* @__PURE__ */ t("path", {
  d: "M12 15C8.8299 15 6.01077 16.5306 4.21597 18.906C3.82968 19.4172 3.63653 19.6728 3.64285 20.0183C3.64773 20.2852 3.81533 20.6219 4.02534 20.7867C4.29716 21 4.67384 21 5.4272 21H18.5727C19.3261 21 19.7028 21 19.9746 20.7867C20.1846 20.6219 20.3522 20.2852 20.3571 20.0183C20.3634 19.6728 20.1703 19.4172 19.784 18.906C17.9892 16.5306 15.17 15 12 15Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), sQ1 = /* @__PURE__ */ t("path", {
  d: "M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51469 3 7.49997 5.01472 7.49997 7.5C7.49997 9.98528 9.51469 12 12 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hQ1 = [
  iQ1,
  lQ1,
  sQ1
];
function aQ1(r, e) {
  return n(), o("svg", oQ1, hQ1);
}
const CU2 = /* @__PURE__ */ i(nQ1, [["render", aQ1]]);
var dQ1 = {}, cQ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _Q1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -516)",
  fill: "none"
}, null, -1), CQ1 = /* @__PURE__ */ t("path", {
  d: "M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fQ1 = [
  _Q1,
  CQ1
];
function vQ1(r, e) {
  return n(), o("svg", cQ1, fQ1);
}
const fU2 = /* @__PURE__ */ i(dQ1, [["render", vQ1]]);
var uQ1 = {}, wQ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pQ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-64 -556)",
  fill: "none"
}, null, -1), gQ1 = /* @__PURE__ */ t("path", {
  d: "M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M16 18L18 20L22 16M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $Q1 = [
  pQ1,
  gQ1
];
function MQ1(r, e) {
  return n(), o("svg", wQ1, $Q1);
}
const vU2 = /* @__PURE__ */ i(uQ1, [["render", MQ1]]);
var LQ1 = {}, kQ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mQ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -156)",
  fill: "none"
}, null, -1), xQ1 = /* @__PURE__ */ t("path", {
  d: "M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M16 6L18 8L22 4M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), HQ1 = [
  mQ1,
  xQ1
];
function VQ1(r, e) {
  return n(), o("svg", kQ1, HQ1);
}
const uU2 = /* @__PURE__ */ i(LQ1, [["render", VQ1]]);
var ZQ1 = {}, BQ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FQ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -196)",
  fill: "none"
}, null, -1), jQ1 = /* @__PURE__ */ t("path", {
  d: "M5.3163 19.4384C5.92462 18.0052 7.34492 17 9 17H15C16.6551 17 18.0754 18.0052 18.6837 19.4384M16 9.5C16 11.7091 14.2091 13.5 12 13.5C9.79086 13.5 8 11.7091 8 9.5C8 7.29086 9.79086 5.5 12 5.5C14.2091 5.5 16 7.29086 16 9.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), IQ1 = [
  FQ1,
  jQ1
];
function bQ1(r, e) {
  return n(), o("svg", BQ1, IQ1);
}
const wU2 = /* @__PURE__ */ i(ZQ1, [["render", bQ1]]);
var yQ1 = {}, DQ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PQ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -236)",
  fill: "none"
}, null, -1), AQ1 = /* @__PURE__ */ t("path", {
  d: "M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M16 18L19 21M19 21L22 18M19 21V15M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), SQ1 = [
  PQ1,
  AQ1
];
function TQ1(r, e) {
  return n(), o("svg", DQ1, SQ1);
}
const pU2 = /* @__PURE__ */ i(yQ1, [["render", TQ1]]);
var OQ1 = {}, EQ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, RQ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -276)",
  fill: "none"
}, null, -1), UQ1 = /* @__PURE__ */ t("path", {
  d: "M16 7L19 10M19 10L22 7M19 10V4M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), NQ1 = [
  RQ1,
  UQ1
];
function qQ1(r, e) {
  return n(), o("svg", EQ1, NQ1);
}
const gU2 = /* @__PURE__ */ i(OQ1, [["render", qQ1]]);
var zQ1 = {}, KQ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GQ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -316)",
  fill: "none"
}, null, -1), WQ1 = /* @__PURE__ */ t("path", {
  d: "M9 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5ZM11 21L14.1014 20.1139C14.2499 20.0715 14.3241 20.0502 14.3934 20.0184C14.4549 19.9902 14.5134 19.9558 14.5679 19.9158C14.6293 19.8707 14.6839 19.8161 14.7932 19.7068L21.25 13.25C21.9404 12.5597 21.9404 11.4403 21.25 10.75C20.5597 10.0596 19.4404 10.0596 18.75 10.75L12.2932 17.2068C12.1839 17.3161 12.1293 17.3707 12.0842 17.4321C12.0442 17.4866 12.0098 17.5451 11.9816 17.6066C11.9497 17.6759 11.9285 17.7501 11.8861 17.8987L11 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), YQ1 = [
  GQ1,
  WQ1
];
function XQ1(r, e) {
  return n(), o("svg", KQ1, YQ1);
}
const $U2 = /* @__PURE__ */ i(zQ1, [["render", XQ1]]);
var QQ1 = {}, JQ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tJ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -356)",
  fill: "none"
}, null, -1), eJ1 = /* @__PURE__ */ t("path", {
  d: "M19 21L16 18M16 18L19 15M16 18H22M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rJ1 = [
  tJ1,
  eJ1
];
function nJ1(r, e) {
  return n(), o("svg", JQ1, rJ1);
}
const MU2 = /* @__PURE__ */ i(QQ1, [["render", nJ1]]);
var oJ1 = {}, iJ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lJ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -396)",
  fill: "none"
}, null, -1), sJ1 = /* @__PURE__ */ t("path", {
  d: "M19 9L16 6M16 6L19 3M16 6L22 6M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hJ1 = [
  lJ1,
  sJ1
];
function aJ1(r, e) {
  return n(), o("svg", iJ1, hJ1);
}
const LU2 = /* @__PURE__ */ i(oJ1, [["render", aJ1]]);
var dJ1 = {}, cJ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _J1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -436)",
  fill: "none"
}, null, -1), CJ1 = /* @__PURE__ */ t("path", {
  d: "M16 18H22M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fJ1 = [
  _J1,
  CJ1
];
function vJ1(r, e) {
  return n(), o("svg", cJ1, fJ1);
}
const kU2 = /* @__PURE__ */ i(dJ1, [["render", vJ1]]);
var uJ1 = {}, wJ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pJ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -476)",
  fill: "none"
}, null, -1), gJ1 = /* @__PURE__ */ t("path", {
  d: "M16 7H22M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $J1 = [
  pJ1,
  gJ1
];
function MJ1(r, e) {
  return n(), o("svg", wJ1, $J1);
}
const mU2 = /* @__PURE__ */ i(uJ1, [["render", MJ1]]);
var LJ1 = {}, kJ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mJ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -516)",
  fill: "none"
}, null, -1), xJ1 = /* @__PURE__ */ t("path", {
  d: "M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), HJ1 = [
  mJ1,
  xJ1
];
function VJ1(r, e) {
  return n(), o("svg", kJ1, HJ1);
}
const xU2 = /* @__PURE__ */ i(LJ1, [["render", VJ1]]);
var ZJ1 = {}, BJ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FJ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-336 -556)",
  fill: "none"
}, null, -1), jJ1 = /* @__PURE__ */ t("path", {
  d: "M19 10V4M16 7H22M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), IJ1 = [
  FJ1,
  jJ1
];
function bJ1(r, e) {
  return n(), o("svg", BJ1, IJ1);
}
const HU2 = /* @__PURE__ */ i(ZJ1, [["render", bJ1]]);
var yJ1 = {}, DJ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PJ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -156)",
  fill: "none"
}, null, -1), AJ1 = /* @__PURE__ */ t("path", {
  d: "M19 21L22 18M22 18L19 15M22 18H16M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), SJ1 = [
  PJ1,
  AJ1
];
function TJ1(r, e) {
  return n(), o("svg", DJ1, SJ1);
}
const VU2 = /* @__PURE__ */ i(yJ1, [["render", TJ1]]);
var OJ1 = {}, EJ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, RJ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -196)",
  fill: "none"
}, null, -1), UJ1 = /* @__PURE__ */ t("path", {
  d: "M19 9L22 6M22 6L19 3M22 6L16 6M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), NJ1 = [
  RJ1,
  UJ1
];
function qJ1(r, e) {
  return n(), o("svg", EJ1, NJ1);
}
const ZU2 = /* @__PURE__ */ i(OJ1, [["render", qJ1]]);
var zJ1 = {}, KJ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GJ1 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -236)",
  fill: "none"
}, null, -1), WJ1 = /* @__PURE__ */ t("path", {
  d: "M4.00002 21.8174C4.6026 22 5.41649 22 6.8 22H17.2C18.5835 22 19.3974 22 20 21.8174M4.00002 21.8174C3.87082 21.7783 3.75133 21.7308 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H17.2C18.8802 2 19.7202 2 20.362 2.32698C20.9265 2.6146 21.3854 3.07354 21.673 3.63803C22 4.27976 22 5.11984 22 6.8V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C20.2487 21.7308 20.1292 21.7783 20 21.8174M4.00002 21.8174C4.00035 21.0081 4.00521 20.5799 4.07686 20.2196C4.39249 18.6329 5.63288 17.3925 7.21964 17.0769C7.60603 17 8.07069 17 9 17H15C15.9293 17 16.394 17 16.7804 17.0769C18.3671 17.3925 19.6075 18.6329 19.9231 20.2196C19.9948 20.5799 19.9996 21.0081 20 21.8174M16 9.5C16 11.7091 14.2091 13.5 12 13.5C9.79086 13.5 8 11.7091 8 9.5C8 7.29086 9.79086 5.5 12 5.5C14.2091 5.5 16 7.29086 16 9.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), YJ1 = [
  GJ1,
  WJ1
];
function XJ1(r, e) {
  return n(), o("svg", KJ1, YJ1);
}
const BU2 = /* @__PURE__ */ i(zJ1, [["render", XJ1]]);
var QJ1 = {}, JJ1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t12 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -276)",
  fill: "none"
}, null, -1), e12 = /* @__PURE__ */ t("path", {
  d: "M16 18L19 15M19 15L22 18M19 15V21M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), r12 = [
  t12,
  e12
];
function n12(r, e) {
  return n(), o("svg", JJ1, r12);
}
const FU2 = /* @__PURE__ */ i(QJ1, [["render", n12]]);
var o12 = {}, i12 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, l12 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -316)",
  fill: "none"
}, null, -1), s12 = /* @__PURE__ */ t("path", {
  d: "M16 6L19 3M19 3L22 6M19 3V9M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), h12 = [
  l12,
  s12
];
function a12(r, e) {
  return n(), o("svg", i12, h12);
}
const jU2 = /* @__PURE__ */ i(o12, [["render", a12]]);
var d12 = {}, c12 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _12 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -356)",
  fill: "none"
}, null, -1), C12 = /* @__PURE__ */ t("path", {
  d: "M16.5 16L21.5 21M21.5 16L16.5 21M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), f12 = [
  _12,
  C12
];
function v12(r, e) {
  return n(), o("svg", c12, f12);
}
const IU2 = /* @__PURE__ */ i(d12, [["render", v12]]);
var u12 = {}, w12 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p12 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -396)",
  fill: "none"
}, null, -1), g12 = /* @__PURE__ */ t("path", {
  d: "M16.5 4L21.5 9M21.5 4L16.5 9M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $12 = [
  p12,
  g12
];
function M12(r, e) {
  return n(), o("svg", w12, $12);
}
const bU2 = /* @__PURE__ */ i(u12, [["render", M12]]);
var L12 = {}, k12 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, m12 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -436)",
  fill: "none"
}, null, -1), x12 = /* @__PURE__ */ t("path", {
  d: "M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), H12 = [
  m12,
  x12
];
function V12(r, e) {
  return n(), o("svg", k12, H12);
}
const yU2 = /* @__PURE__ */ i(L12, [["render", V12]]);
var Z12 = {}, B12 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, F12 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -476)",
  fill: "none"
}, null, -1), j12 = /* @__PURE__ */ t("path", {
  d: "M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), I12 = [
  F12,
  j12
];
function b12(r, e) {
  return n(), o("svg", B12, I12);
}
const DU2 = /* @__PURE__ */ i(Z12, [["render", b12]]);
var y12 = {}, D12 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P12 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -512)",
  fill: "none"
}, null, -1), A12 = /* @__PURE__ */ t("path", {
  d: "M18 15.8369C19.4559 16.5683 20.7041 17.742 21.6152 19.2096C21.7956 19.5003 21.8858 19.6456 21.917 19.8468C21.9804 20.2558 21.7008 20.7585 21.3199 20.9204C21.1325 21 20.9216 21 20.5 21M16 11.5322C17.4817 10.7959 18.5 9.26686 18.5 7.5C18.5 5.73314 17.4817 4.20411 16 3.46776M14 7.5C14 9.98528 11.9852 12 9.49996 12C7.01468 12 4.99996 9.98528 4.99996 7.5C4.99996 5.01472 7.01468 3 9.49996 3C11.9852 3 14 5.01472 14 7.5ZM2.55919 18.9383C4.1535 16.5446 6.66933 15 9.49996 15C12.3306 15 14.8464 16.5446 16.4407 18.9383C16.79 19.4628 16.9646 19.725 16.9445 20.0599C16.9289 20.3207 16.7579 20.64 16.5495 20.7976C16.2819 21 15.9138 21 15.1776 21H3.82232C3.08613 21 2.71804 21 2.4504 20.7976C2.24201 20.64 2.07105 20.3207 2.05539 20.0599C2.03529 19.725 2.20992 19.4628 2.55919 18.9383Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), S12 = [
  P12,
  A12
];
function T12(r, e) {
  return n(), o("svg", D12, S12);
}
const PU2 = /* @__PURE__ */ i(y12, [["render", T12]]);
var O12 = {}, E12 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, R12 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-608 -556)",
  fill: "none"
}, null, -1), U12 = /* @__PURE__ */ t("path", {
  d: "M16 18L18 20L22 16M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), N12 = [
  R12,
  U12
];
function q12(r, e) {
  return n(), o("svg", E12, N12);
}
const AU2 = /* @__PURE__ */ i(O12, [["render", q12]]);
var z12 = {}, K12 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, G12 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-880 -156)",
  fill: "none"
}, null, -1), W12 = /* @__PURE__ */ t("path", {
  d: "M16 18L19 21M19 21L22 18M19 21V15M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Y12 = [
  G12,
  W12
];
function X12(r, e) {
  return n(), o("svg", K12, Y12);
}
const SU2 = /* @__PURE__ */ i(z12, [["render", X12]]);
var Q12 = {}, J12 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t22 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-880 -196)",
  fill: "none"
}, null, -1), e22 = /* @__PURE__ */ t("path", {
  d: "M11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7M11.9999 21.5L14.025 21.095C14.2015 21.0597 14.2898 21.042 14.3721 21.0097C14.4452 20.9811 14.5147 20.9439 14.579 20.899C14.6516 20.8484 14.7152 20.7848 14.8426 20.6574L21.5 14C22.0524 13.4477 22.0523 12.5523 21.5 12C20.9477 11.4477 20.0523 11.4477 19.5 12L12.8425 18.6575C12.7152 18.7848 12.6516 18.8484 12.601 18.921C12.5561 18.9853 12.5189 19.0548 12.4902 19.1278C12.458 19.2102 12.4403 19.2984 12.405 19.475L11.9999 21.5ZM13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), r22 = [
  t22,
  e22
];
function n22(r, e) {
  return n(), o("svg", J12, r22);
}
const TU2 = /* @__PURE__ */ i(Q12, [["render", n22]]);
var o22 = {}, i22 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, l22 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-880 -236)",
  fill: "none"
}, null, -1), s22 = /* @__PURE__ */ t("path", {
  d: "M19 21L16 18M16 18L19 15M16 18H22M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), h22 = [
  l22,
  s22
];
function a22(r, e) {
  return n(), o("svg", i22, h22);
}
const OU2 = /* @__PURE__ */ i(o22, [["render", a22]]);
var d22 = {}, c22 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _22 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-880 -276)",
  fill: "none"
}, null, -1), C22 = /* @__PURE__ */ t("path", {
  d: "M16 18H22M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), f22 = [
  _22,
  C22
];
function v22(r, e) {
  return n(), o("svg", c22, f22);
}
const EU2 = /* @__PURE__ */ i(d22, [["render", v22]]);
var u22 = {}, w22 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p22 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-880 -316)",
  fill: "none"
}, null, -1), g22 = /* @__PURE__ */ t("path", {
  d: "M19 21V15M16 18H22M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), $22 = [
  p22,
  g22
];
function M22(r, e) {
  return n(), o("svg", w22, $22);
}
const RU2 = /* @__PURE__ */ i(u22, [["render", M22]]);
var L22 = {}, k22 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, m22 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), x22 = /* @__PURE__ */ t("path", {
  d: "M19 21L22 18M22 18L19 15M22 18H16M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), H22 = [
  m22,
  x22
];
function V22(r, e) {
  return n(), o("svg", k22, H22);
}
const UU2 = /* @__PURE__ */ i(L22, [["render", V22]]);
var Z22 = {}, B22 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, F22 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), j22 = /* @__PURE__ */ t("path", {
  d: "M16 18L19 15M19 15L22 18M19 15V21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), I22 = [
  F22,
  j22
];
function b22(r, e) {
  return n(), o("svg", B22, I22);
}
const NU2 = /* @__PURE__ */ i(Z22, [["render", b22]]);
var y22 = {}, D22 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P22 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "660",
  transform: "translate(-880 -436)",
  fill: "none"
}, null, -1), A22 = /* @__PURE__ */ t("path", {
  d: "M16.5 16L21.5 21M21.5 16L16.5 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), S22 = [
  P22,
  A22
];
function T22(r, e) {
  return n(), o("svg", D22, S22);
}
const qU2 = /* @__PURE__ */ i(y22, [["render", T22]]);
var O22 = {}, E22 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, R22 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "820",
  transform: "translate(-880 -596)",
  fill: "none"
}, null, -1), U22 = /* @__PURE__ */ t("path", {
  d: "M19.9061 21C21.2464 18.2888 22 15.2329 22 12C22 8.76711 21.2464 5.71116 19.9061 3M4.09393 3C2.75363 5.71116 2 8.76711 2 12C2 15.2329 2.75363 18.2888 4.09393 21M16.5486 8.625H16.459C15.8056 8.625 15.1848 8.91202 14.7596 9.41072L9.38471 15.7143C8.95948 16.213 8.33871 16.5 7.6853 16.5H7.59563M8.71483 8.625H10.1089C10.6086 8.625 11.0477 8.95797 11.185 9.44094L12.9594 15.6841C13.0967 16.167 13.5358 16.5 14.0355 16.5H15.4296",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), N22 = [
  R22,
  U22
];
function q22(r, e) {
  return n(), o("svg", E22, N22);
}
const zU2 = /* @__PURE__ */ i(O22, [["render", q22]]);
var z22 = {}, K22 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, G22 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -756)",
  fill: "none"
}, null, -1), W22 = /* @__PURE__ */ t("path", {
  d: "M5 5C3.34315 5 2 6.34315 2 8V16C2 17.6569 3.34315 19 5 19H14C15.3527 19 16.4962 18.1048 16.8705 16.8745M17 12L20.6343 8.36569C21.0627 7.93731 21.2769 7.72312 21.4608 7.70865C21.6203 7.69609 21.7763 7.76068 21.8802 7.88238C22 8.02265 22 8.32556 22 8.93137V15.0686C22 15.6744 22 15.9774 21.8802 16.1176C21.7763 16.2393 21.6203 16.3039 21.4608 16.2914C21.2769 16.2769 21.0627 16.0627 20.6343 15.6343L17 12ZM17 12V9.8C17 8.11984 17 7.27976 16.673 6.63803C16.3854 6.07354 15.9265 5.6146 15.362 5.32698C14.7202 5 13.8802 5 12.2 5H9.5M2 2L22 22",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Y22 = [
  G22,
  W22
];
function X22(r, e) {
  return n(), o("svg", K22, Y22);
}
const KU2 = /* @__PURE__ */ i(z22, [["render", X22]]);
var Q22 = {}, J22 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t02 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -716)",
  fill: "none"
}, null, -1), e02 = /* @__PURE__ */ t("path", {
  d: "M22 8.93137C22 8.32555 22 8.02265 21.8802 7.88238C21.7763 7.76068 21.6203 7.69609 21.4608 7.70865C21.2769 7.72312 21.0627 7.93731 20.6343 8.36569L17 12L20.6343 15.6343C21.0627 16.0627 21.2769 16.2769 21.4608 16.2914C21.6203 16.3039 21.7763 16.2393 21.8802 16.1176C22 15.9774 22 15.6744 22 15.0686V8.93137Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), r02 = /* @__PURE__ */ t("path", {
  d: "M2 9.8C2 8.11984 2 7.27976 2.32698 6.63803C2.6146 6.07354 3.07354 5.6146 3.63803 5.32698C4.27976 5 5.11984 5 6.8 5H12.2C13.8802 5 14.7202 5 15.362 5.32698C15.9265 5.6146 16.3854 6.07354 16.673 6.63803C17 7.27976 17 8.11984 17 9.8V14.2C17 15.8802 17 16.7202 16.673 17.362C16.3854 17.9265 15.9265 18.3854 15.362 18.673C14.7202 19 13.8802 19 12.2 19H6.8C5.11984 19 4.27976 19 3.63803 18.673C3.07354 18.3854 2.6146 17.9265 2.32698 17.362C2 16.7202 2 15.8802 2 14.2V9.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), n02 = [
  t02,
  e02,
  r02
];
function o02(r, e) {
  return n(), o("svg", J22, n02);
}
const GU2 = /* @__PURE__ */ i(Q22, [["render", o02]]);
var i02 = {}, l02 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, s02 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1596)",
  fill: "none"
}, null, -1), h02 = /* @__PURE__ */ t("path", {
  d: "M12 2V7M12 2C11.2867 2 10.5909 2.07467 9.91991 2.21663M12 2C12.7132 2 13.4091 2.07467 14.08 2.21663M12 7C9.23855 7 7 9.2386 7 12M12 7C14.7614 7 17 9.2386 17 12M12 17V22M12 17C14.7614 17 17 14.7614 17 12M12 17C9.23855 17 7 14.7614 7 12M12 22C12.7122 22 13.407 21.9255 14.077 21.784M12 22C11.2851 22 10.5878 21.925 9.91545 21.7824M4.92891 4.92893L8.46444 8.46447M15.5355 15.5355L19.071 19.0711M2 12H7M2 12C2 12.7133 2.07466 13.4092 2.21664 14.0802M2 12C2 11.2857 2.07488 10.5888 2.21727 9.91683M17 12H22M22 12C22 11.2867 21.9253 10.5908 21.7833 9.91978M22 12C22 12.7131 21.9254 13.4086 21.7835 14.0794M4.92891 19.0711L8.46444 15.5355M15.5355 8.46447L19.071 4.92893M17.4466 3.61208C18.621 4.37619 19.6249 5.38023 20.3888 6.55469M20.386 17.4496C19.622 18.6229 18.6183 19.626 17.4445 20.3893M6.55371 20.3882C5.38104 19.6252 4.37831 18.623 3.61474 17.4508M3.61171 6.55387C4.37545 5.37994 5.37894 4.37633 6.55275 3.61244",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), a02 = [
  s02,
  h02
];
function d02(r, e) {
  return n(), o("svg", l02, a02);
}
const WU2 = /* @__PURE__ */ i(i02, [["render", d02]]);
var c02 = {}, _02 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C02 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -796)",
  fill: "none"
}, null, -1), f02 = /* @__PURE__ */ t("path", {
  d: "M6 16L18 16M6 16C8.20914 16 10 14.2091 10 12C10 9.79086 8.20914 8 6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16ZM18 16C20.2091 16 22 14.2091 22 12C22 9.79086 20.2091 8 18 8C15.7909 8 14 9.79086 14 12C14 14.2091 15.7909 16 18 16Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), v02 = [
  C02,
  f02
];
function u02(r, e) {
  return n(), o("svg", _02, v02);
}
const YU2 = /* @__PURE__ */ i(c02, [["render", u02]]);
var w02 = {}, p02 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g02 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -836)",
  fill: "none"
}, null, -1), $02 = /* @__PURE__ */ t("path", {
  d: "M19.7479 4.99993C21.1652 6.97016 22 9.38756 22 11.9999C22 14.6123 21.1652 17.0297 19.7479 18.9999M15.7453 7.99993C16.5362 9.13376 17 10.5127 17 11.9999C17 13.4872 16.5362 14.8661 15.7453 15.9999M9.63432 5.36561L6.46863 8.5313C6.29568 8.70425 6.2092 8.79073 6.10828 8.85257C6.01881 8.9074 5.92127 8.9478 5.81923 8.9723C5.70414 8.99993 5.58185 8.99993 5.33726 8.99993H3.6C3.03995 8.99993 2.75992 8.99993 2.54601 9.10892C2.35785 9.20479 2.20487 9.35777 2.10899 9.54594C2 9.75985 2 10.0399 2 10.5999V13.3999C2 13.96 2 14.24 2.10899 14.4539C2.20487 14.6421 2.35785 14.7951 2.54601 14.8909C2.75992 14.9999 3.03995 14.9999 3.6 14.9999H5.33726C5.58185 14.9999 5.70414 14.9999 5.81923 15.0276C5.92127 15.0521 6.01881 15.0925 6.10828 15.1473C6.2092 15.2091 6.29568 15.2956 6.46863 15.4686L9.63431 18.6342C10.0627 19.0626 10.2769 19.2768 10.4608 19.2913C10.6203 19.3038 10.7763 19.2392 10.8802 19.1175C11 18.9773 11 18.6744 11 18.0686V5.9313C11 5.32548 11 5.02257 10.8802 4.88231C10.7763 4.76061 10.6203 4.69602 10.4608 4.70858C10.2769 4.72305 10.0627 4.93724 9.63432 5.36561Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), M02 = [
  g02,
  $02
];
function L02(r, e) {
  return n(), o("svg", p02, M02);
}
const XU2 = /* @__PURE__ */ i(w02, [["render", L02]]);
var k02 = {}, m02 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x02 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -876)",
  fill: "none"
}, null, -1), H02 = /* @__PURE__ */ t("path", {
  d: "M18.2451 7.99993C19.036 9.13376 19.4998 10.5127 19.4998 11.9999C19.4998 13.4872 19.036 14.8661 18.2451 15.9999M12.1343 4.36561L8.96863 7.5313C8.79568 7.70425 8.7092 7.79073 8.60828 7.85257C8.51881 7.9074 8.42127 7.9478 8.31923 7.9723C8.20414 7.99993 8.08185 7.99993 7.83726 7.99993H6.1C5.53995 7.99993 5.25992 7.99993 5.04601 8.10892C4.85785 8.20479 4.70487 8.35777 4.60899 8.54594C4.5 8.75985 4.5 9.03987 4.5 9.59993V14.3999C4.5 14.96 4.5 15.24 4.60899 15.4539C4.70487 15.6421 4.85785 15.7951 5.04601 15.8909C5.25992 15.9999 5.53995 15.9999 6.1 15.9999H7.83726C8.08185 15.9999 8.20414 15.9999 8.31923 16.0276C8.42127 16.0521 8.51881 16.0925 8.60828 16.1473C8.7092 16.2091 8.79568 16.2956 8.96863 16.4686L12.1343 19.6342C12.5627 20.0626 12.7769 20.2768 12.9608 20.2913C13.1203 20.3038 13.2763 20.2392 13.3802 20.1175C13.5 19.9773 13.5 19.6744 13.5 19.0686V4.9313C13.5 4.32548 13.5 4.02257 13.3802 3.88231C13.2763 3.76061 13.1203 3.69602 12.9608 3.70858C12.7769 3.72305 12.5627 3.93724 12.1343 4.36561Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), V02 = [
  x02,
  H02
];
function Z02(r, e) {
  return n(), o("svg", m02, V02);
}
const QU2 = /* @__PURE__ */ i(k02, [["render", Z02]]);
var B02 = {}, F02 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j02 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -916)",
  fill: "none"
}, null, -1), I02 = /* @__PURE__ */ t("path", {
  d: "M15 11.9999H22M9.63432 4.36561L6.46863 7.5313C6.29568 7.70425 6.2092 7.79073 6.10828 7.85257C6.01881 7.9074 5.92127 7.9478 5.81923 7.9723C5.70414 7.99993 5.58185 7.99993 5.33726 7.99993H3.6C3.03995 7.99993 2.75992 7.99993 2.54601 8.10892C2.35785 8.20479 2.20487 8.35777 2.10899 8.54594C2 8.75985 2 9.03987 2 9.59993V14.3999C2 14.96 2 15.24 2.10899 15.4539C2.20487 15.6421 2.35785 15.7951 2.54601 15.8909C2.75992 15.9999 3.03995 15.9999 3.6 15.9999H5.33726C5.58185 15.9999 5.70414 15.9999 5.81923 16.0276C5.92127 16.0521 6.01881 16.0925 6.10828 16.1473C6.2092 16.2091 6.29568 16.2956 6.46863 16.4686L9.63431 19.6342C10.0627 20.0626 10.2769 20.2768 10.4608 20.2913C10.6203 20.3038 10.7763 20.2392 10.8802 20.1175C11 19.9773 11 19.6744 11 19.0686V4.9313C11 4.32548 11 4.02257 10.8802 3.88231C10.7763 3.76061 10.6203 3.69602 10.4608 3.70858C10.2769 3.72305 10.0627 3.93724 9.63432 4.36561Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), b02 = [
  j02,
  I02
];
function y02(r, e) {
  return n(), o("svg", F02, b02);
}
const JU2 = /* @__PURE__ */ i(B02, [["render", y02]]);
var D02 = {}, P02 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, A02 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -956)",
  fill: "none"
}, null, -1), S02 = /* @__PURE__ */ t("path", {
  d: "M18.5 15.4999V8.49993M15 11.9999H22M9.63432 4.36561L6.46863 7.5313C6.29568 7.70425 6.2092 7.79073 6.10828 7.85257C6.01881 7.9074 5.92127 7.9478 5.81923 7.9723C5.70414 7.99993 5.58185 7.99993 5.33726 7.99993H3.6C3.03995 7.99993 2.75992 7.99993 2.54601 8.10892C2.35785 8.20479 2.20487 8.35777 2.10899 8.54594C2 8.75985 2 9.03987 2 9.59993V14.3999C2 14.96 2 15.24 2.10899 15.4539C2.20487 15.6421 2.35785 15.7951 2.54601 15.8909C2.75992 15.9999 3.03995 15.9999 3.6 15.9999H5.33726C5.58185 15.9999 5.70414 15.9999 5.81923 16.0276C5.92127 16.0521 6.01881 16.0925 6.10828 16.1473C6.2092 16.2091 6.29568 16.2956 6.46863 16.4686L9.63431 19.6342C10.0627 20.0626 10.2769 20.2768 10.4608 20.2913C10.6203 20.3038 10.7763 20.2392 10.8802 20.1175C11 19.9773 11 19.6744 11 19.0686V4.9313C11 4.32548 11 4.02257 10.8802 3.88231C10.7763 3.76061 10.6203 3.69602 10.4608 3.70858C10.2769 3.72305 10.0627 3.93724 9.63432 4.36561Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), T02 = [
  A02,
  S02
];
function O02(r, e) {
  return n(), o("svg", P02, T02);
}
const tN2 = /* @__PURE__ */ i(D02, [["render", O02]]);
var E02 = {}, R02 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, U02 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -996)",
  fill: "none"
}, null, -1), N02 = /* @__PURE__ */ t("path", {
  d: "M22 8.99993L16 14.9999M16 8.99993L22 14.9999M9.63432 4.36561L6.46863 7.5313C6.29568 7.70425 6.2092 7.79073 6.10828 7.85257C6.01881 7.9074 5.92127 7.9478 5.81923 7.9723C5.70414 7.99993 5.58185 7.99993 5.33726 7.99993H3.6C3.03995 7.99993 2.75992 7.99993 2.54601 8.10892C2.35785 8.20479 2.20487 8.35777 2.10899 8.54594C2 8.75985 2 9.03987 2 9.59993V14.3999C2 14.96 2 15.24 2.10899 15.4539C2.20487 15.6421 2.35785 15.7951 2.54601 15.8909C2.75992 15.9999 3.03995 15.9999 3.6 15.9999H5.33726C5.58185 15.9999 5.70414 15.9999 5.81923 16.0276C5.92127 16.0521 6.01881 16.0925 6.10828 16.1473C6.2092 16.2091 6.29568 16.2956 6.46863 16.4686L9.63431 19.6342C10.0627 20.0626 10.2769 20.2768 10.4608 20.2913C10.6203 20.3038 10.7763 20.2392 10.8802 20.1175C11 19.9773 11 19.6744 11 19.0686V4.9313C11 4.32548 11 4.02257 10.8802 3.88231C10.7763 3.76061 10.6203 3.69602 10.4608 3.70858C10.2769 3.72305 10.0627 3.93724 9.63432 4.36561Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), q02 = [
  U02,
  N02
];
function z02(r, e) {
  return n(), o("svg", R02, q02);
}
const eN2 = /* @__PURE__ */ i(E02, [["render", z02]]);
var K02 = {}, G02 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, W02 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -716)",
  fill: "none"
}, null, -1), Y02 = /* @__PURE__ */ t("path", {
  d: "M22 8.5H2M2 12.5H5.54668C6.08687 12.5 6.35696 12.5 6.61813 12.5466C6.84995 12.5879 7.0761 12.6563 7.29191 12.7506C7.53504 12.8567 7.75977 13.0065 8.20924 13.3062L8.79076 13.6938C9.24023 13.9935 9.46496 14.1433 9.70809 14.2494C9.9239 14.3437 10.15 14.4121 10.3819 14.4534C10.643 14.5 10.9131 14.5 11.4533 14.5H12.5467C13.0869 14.5 13.357 14.5 13.6181 14.4534C13.85 14.4121 14.0761 14.3437 14.2919 14.2494C14.535 14.1433 14.7598 13.9935 15.2092 13.6938L15.7908 13.3062C16.2402 13.0065 16.465 12.8567 16.7081 12.7506C16.9239 12.6563 17.15 12.5879 17.3819 12.5466C17.643 12.5 17.9131 12.5 18.4533 12.5H22M2 7.2L2 16.8C2 17.9201 2 18.4802 2.21799 18.908C2.40973 19.2843 2.71569 19.5903 3.09202 19.782C3.51984 20 4.07989 20 5.2 20L18.8 20C19.9201 20 20.4802 20 20.908 19.782C21.2843 19.5903 21.5903 19.2843 21.782 18.908C22 18.4802 22 17.9201 22 16.8V7.2C22 6.0799 22 5.51984 21.782 5.09202C21.5903 4.7157 21.2843 4.40974 20.908 4.21799C20.4802 4 19.9201 4 18.8 4L5.2 4C4.0799 4 3.51984 4 3.09202 4.21799C2.7157 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.07989 2 7.2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), X02 = [
  W02,
  Y02
];
function Q02(r, e) {
  return n(), o("svg", G02, X02);
}
const rN2 = /* @__PURE__ */ i(K02, [["render", Q02]]);
var J02 = {}, t42 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, e42 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -756)",
  fill: "none"
}, null, -1), r42 = /* @__PURE__ */ t("path", {
  d: "M16 7.99983V4.50048C16 3.66874 16 3.25287 15.8248 2.9973C15.6717 2.77401 15.4346 2.62232 15.1678 2.57691C14.8623 2.52493 14.4847 2.6992 13.7295 3.04775L4.85901 7.14182C4.18551 7.45267 3.84875 7.6081 3.60211 7.84915C3.38406 8.06225 3.21762 8.32238 3.1155 8.60966C3 8.93462 3 9.30551 3 10.0473V14.9998M16.5 14.4998H16.51M3 11.1998L3 17.7998C3 18.9199 3 19.48 3.21799 19.9078C3.40973 20.2841 3.71569 20.5901 4.09202 20.7818C4.51984 20.9998 5.07989 20.9998 6.2 20.9998H17.8C18.9201 20.9998 19.4802 20.9998 19.908 20.7818C20.2843 20.5901 20.5903 20.2841 20.782 19.9078C21 19.48 21 18.9199 21 17.7998V11.1998C21 10.0797 21 9.51967 20.782 9.09185C20.5903 8.71552 20.2843 8.40956 19.908 8.21782C19.4802 7.99983 18.9201 7.99983 17.8 7.99983L6.2 7.99983C5.0799 7.99983 4.51984 7.99983 4.09202 8.21781C3.7157 8.40956 3.40973 8.71552 3.21799 9.09185C3 9.51967 3 10.0797 3 11.1998ZM17 14.4998C17 14.776 16.7761 14.9998 16.5 14.9998C16.2239 14.9998 16 14.776 16 14.4998C16 14.2237 16.2239 13.9998 16.5 13.9998C16.7761 13.9998 17 14.2237 17 14.4998Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), n42 = [
  e42,
  r42
];
function o42(r, e) {
  return n(), o("svg", t42, n42);
}
const nN2 = /* @__PURE__ */ i(J02, [["render", o42]]);
var i42 = {}, l42 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, s42 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -796)",
  fill: "none"
}, null, -1), h42 = /* @__PURE__ */ t("path", {
  d: "M16.5 14H16.51M3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7L5 7C3.89543 7 3 6.10457 3 5ZM3 5C3 3.89543 3.89543 3 5 3H17M17 14C17 14.2761 16.7761 14.5 16.5 14.5C16.2239 14.5 16 14.2761 16 14C16 13.7239 16.2239 13.5 16.5 13.5C16.7761 13.5 17 13.7239 17 14Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), a42 = [
  s42,
  h42
];
function d42(r, e) {
  return n(), o("svg", l42, a42);
}
const oN2 = /* @__PURE__ */ i(i42, [["render", d42]]);
var c42 = {}, _42 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C42 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -836)",
  fill: "none"
}, null, -1), f42 = /* @__PURE__ */ t("path", {
  d: "M20 9.5V7.2C20 6.0799 20 5.51984 19.782 5.09202C19.5903 4.7157 19.2843 4.40974 18.908 4.21799C18.4802 4 17.9201 4 16.8 4H5.2C4.0799 4 3.51984 4 3.09202 4.21799C2.7157 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.0799 2 7.2V16.8C2 17.9201 2 18.4802 2.21799 18.908C2.40973 19.2843 2.71569 19.5903 3.09202 19.782C3.51984 20 4.07989 20 5.2 20L16.8 20C17.9201 20 18.4802 20 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V14.5M15 12C15 11.5353 15 11.303 15.0384 11.1098C15.1962 10.3164 15.8164 9.69624 16.6098 9.53843C16.803 9.5 17.0353 9.5 17.5 9.5H19.5C19.9647 9.5 20.197 9.5 20.3902 9.53843C21.1836 9.69624 21.8038 10.3164 21.9616 11.1098C22 11.303 22 11.5353 22 12C22 12.4647 22 12.697 21.9616 12.8902C21.8038 13.6836 21.1836 14.3038 20.3902 14.4616C20.197 14.5 19.9647 14.5 19.5 14.5H17.5C17.0353 14.5 16.803 14.5 16.6098 14.4616C15.8164 14.3038 15.1962 13.6836 15.0384 12.8902C15 12.697 15 12.4647 15 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), v42 = [
  C42,
  f42
];
function u42(r, e) {
  return n(), o("svg", _42, v42);
}
const iN2 = /* @__PURE__ */ i(c42, [["render", u42]]);
var w42 = {}, p42 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g42 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1020",
  transform: "translate(-880 -876)",
  fill: "none"
}, null, -1), $42 = /* @__PURE__ */ t("path", {
  d: "M19 10L5.00003 10M19 10L20.8642 13.1069C21.282 13.8032 21.4909 14.1514 21.5993 14.5262C21.6955 14.8582 21.7335 15.2045 21.7117 15.5495C21.6871 15.9389 21.5587 16.324 21.3019 17.0944L21.0941 17.7179C20.7007 18.8981 20.5039 19.4882 20.1391 19.9245C19.8169 20.3098 19.4032 20.608 18.9358 20.7918C18.4065 21 17.7845 21 16.5404 21L7.45967 21C6.2156 21 5.59356 21 5.06429 20.7918C4.5969 20.608 4.18315 20.3098 3.86096 19.9245C3.49611 19.4882 3.2994 18.8981 2.90599 17.7179L2.69816 17.0944C2.44137 16.324 2.31298 15.9389 2.28838 15.5495C2.26658 15.2044 2.30458 14.8582 2.40071 14.5261C2.5092 14.1514 2.71809 13.8032 3.13587 13.1069L5.00003 10M19 10L19.4173 8.53955C19.6151 7.84717 19.714 7.50097 19.6363 7.22708C19.5683 6.98715 19.413 6.78132 19.201 6.64996C18.959 6.5 18.599 6.5 17.8789 6.5L6.1212 6.5C5.4011 6.5 5.04105 6.5 4.79904 6.64996C4.58705 6.78132 4.43179 6.98715 4.36372 7.22708C4.28602 7.50097 4.38493 7.84717 4.58276 8.53955L5.00003 10M12 6.5H8.46431C7.94335 6.5 7.44373 6.28929 7.07535 5.91421C6.70698 5.53914 6.50003 5.03043 6.50003 4.5C6.50003 3.96957 6.70698 3.46086 7.07535 3.08579C7.44373 2.71071 7.94335 2.5 8.46431 2.5C11.2143 2.5 12 6.5 12 6.5ZM12 6.5H15.5357C16.0567 6.5 16.5563 6.28929 16.9247 5.91421C17.2931 5.53914 17.5 5.03043 17.5 4.5C17.5 3.96957 17.2931 3.46086 16.9247 3.08579C16.5563 2.71071 16.0567 2.5 15.5357 2.5C12.7857 2.5 12 6.5 12 6.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), M42 = [
  g42,
  $42
];
function L42(r, e) {
  return n(), o("svg", p42, M42);
}
const lN2 = /* @__PURE__ */ i(w42, [["render", L42]]);
var k42 = {}, m42 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x42 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -356)",
  fill: "none"
}, null, -1), H42 = /* @__PURE__ */ t("path", {
  d: "M7 17L7.48551 19.4276C7.66878 20.3439 7.76041 20.8021 7.99964 21.1448C8.2106 21.447 8.50097 21.685 8.83869 21.8326C9.22166 22 9.6889 22 10.6234 22H13.3766C14.3111 22 14.7783 22 15.1613 21.8326C15.499 21.685 15.7894 21.447 16.0004 21.1448C16.2396 20.8021 16.3312 20.3439 16.5145 19.4276L17 17M7 7L7.48551 4.57243C7.66878 3.6561 7.76041 3.19793 7.99964 2.85522C8.2106 2.55301 8.50097 2.31497 8.83869 2.16737C9.22166 2 9.6889 2 10.6234 2H13.3766C14.3111 2 14.7783 2 15.1613 2.16737C15.499 2.31497 15.7894 2.55301 16.0004 2.85522C16.2396 3.19793 16.3312 3.6561 16.5145 4.57243L17 7M12 9V12L13.5 13.5M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), V42 = [
  x42,
  H42
];
function Z42(r, e) {
  return n(), o("svg", m42, V42);
}
const sN2 = /* @__PURE__ */ i(k42, [["render", Z42]]);
var B42 = {}, F42 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j42 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "500",
  transform: "translate(-880 -396)",
  fill: "none"
}, null, -1), I42 = /* @__PURE__ */ t("path", {
  d: "M17 18.5L16.6631 19.6791C16.4254 20.511 16.3066 20.927 16.0639 21.2358C15.8498 21.5083 15.5685 21.7205 15.2476 21.8515C14.8841 22 14.4515 22 13.5862 22H10.4138C9.54854 22 9.11592 22 8.75239 21.8515C8.43152 21.7205 8.15022 21.5083 7.93606 21.2358C7.69343 20.927 7.57458 20.511 7.33689 19.6791L7 18.5M17 5.5L16.6631 4.32089C16.4254 3.48896 16.3066 3.07298 16.0639 2.76423C15.8498 2.49171 15.5685 2.27953 15.2476 2.14847C14.8841 2 14.4515 2 13.5862 2H10.4138C9.54854 2 9.11592 2 8.75239 2.14847C8.43152 2.27953 8.15022 2.49171 7.93606 2.76423C7.69343 3.07299 7.57458 3.48895 7.33689 4.32089L7 5.5M12 9V12L13.5 13.5M8.7 18.5H15.3C16.4201 18.5 16.9802 18.5 17.408 18.282C17.7843 18.0903 18.0903 17.7843 18.282 17.408C18.5 16.9802 18.5 16.4201 18.5 15.3V8.7C18.5 7.57989 18.5 7.01984 18.282 6.59202C18.0903 6.21569 17.7843 5.90973 17.408 5.71799C16.9802 5.5 16.4201 5.5 15.3 5.5H8.7C7.5799 5.5 7.01984 5.5 6.59202 5.71799C6.21569 5.90973 5.90973 6.21569 5.71799 6.59202C5.5 7.01984 5.5 7.57989 5.5 8.7V15.3C5.5 16.4201 5.5 16.9802 5.71799 17.408C5.90973 17.7843 6.21569 18.0903 6.59202 18.282C7.01984 18.5 7.57989 18.5 8.7 18.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), b42 = [
  j42,
  I42
];
function y42(r, e) {
  return n(), o("svg", F42, b42);
}
const hN2 = /* @__PURE__ */ i(B42, [["render", y42]]);
var D42 = {}, P42 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, A42 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -516)",
  fill: "none"
}, null, -1), S42 = /* @__PURE__ */ t("path", {
  d: "M2 6C2.6 6.5 3.2 7 4.5 7C7 7 7 5 9.5 5C10.8 5 11.4 5.5 12 6C12.6 6.5 13.2 7 14.5 7C17 7 17 5 19.5 5C20.8 5 21.4 5.5 22 6M2 18C2.6 18.5 3.2 19 4.5 19C7 19 7 17 9.5 17C10.8 17 11.4 17.5 12 18C12.6 18.5 13.2 19 14.5 19C17 19 17 17 19.5 17C20.8 17 21.4 17.5 22 18M2 12C2.6 12.5 3.2 13 4.5 13C7 13 7 11 9.5 11C10.8 11 11.4 11.5 12 12C12.6 12.5 13.2 13 14.5 13C17 13 17 11 19.5 11C20.8 11 21.4 11.5 22 12",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), T42 = [
  A42,
  S42
];
function O42(r, e) {
  return n(), o("svg", P42, T42);
}
const aN2 = /* @__PURE__ */ i(D42, [["render", O42]]);
var E42 = {}, R42 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, U42 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -1036)",
  fill: "none"
}, null, -1), N42 = /* @__PURE__ */ t("path", {
  d: "M12 18C16.4183 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 7.58172 18 12 18ZM12 18V22M12 22H7M12 22H17M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), q42 = [
  U42,
  N42
];
function z42(r, e) {
  return n(), o("svg", R42, q42);
}
const dN2 = /* @__PURE__ */ i(E42, [["render", z42]]);
var K42 = {}, G42 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, W42 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -1076)",
  fill: "none"
}, null, -1), Y42 = /* @__PURE__ */ t("path", {
  d: "M8 22H16M20.5 10.5C20.5 15.1944 16.6944 19 12 19C7.30558 19 3.5 15.1944 3.5 10.5C3.5 5.80558 7.30558 2 12 2C16.6944 2 20.5 5.80558 20.5 10.5ZM15.1875 10.5C15.1875 12.2604 13.7604 13.6875 12 13.6875C10.2396 13.6875 8.8125 12.2604 8.8125 10.5C8.8125 8.73959 10.2396 7.3125 12 7.3125C13.7604 7.3125 15.1875 8.73959 15.1875 10.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), X42 = [
  W42,
  Y42
];
function Q42(r, e) {
  return n(), o("svg", G42, X42);
}
const cN2 = /* @__PURE__ */ i(K42, [["render", Q42]]);
var J42 = {}, t32 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, e32 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -1156)",
  fill: "none"
}, null, -1), r32 = /* @__PURE__ */ t("path", {
  d: "M15.3119 10C16.6802 10.4263 17.9624 11.1191 19.08 12.05M22.5799 8.49997C19.6575 5.92394 15.8956 4.50262 11.9999 4.50262C11.3949 4.50262 10.7931 4.5369 10.1972 4.60447M8.52979 15.61C9.54499 14.8888 10.7595 14.5013 12.0048 14.5013C13.2501 14.5013 14.4646 14.8888 15.4798 15.61M12 19.5H12.01M1.19336 8.70076C2.52697 7.47869 4.06839 6.47975 5.75851 5.76306M4.73193 12.243C6.12934 11.012 7.84172 10.1302 9.73265 9.73393M15.6983 15.7751C14.6792 14.9763 13.3952 14.5 11.9999 14.5C10.5835 14.5 9.28172 14.9908 8.25537 15.8116M3 3L21 21",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), n32 = [
  e32,
  r32
];
function o32(r, e) {
  return n(), o("svg", t32, n32);
}
const _N2 = /* @__PURE__ */ i(J42, [["render", o32]]);
var i32 = {}, l32 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, s32 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -1116)",
  fill: "none"
}, null, -1), h32 = /* @__PURE__ */ t("path", {
  d: "M12 19.5H12.01M22.8064 8.70076C19.9595 6.09199 16.1656 4.5 11.9999 4.5C7.83414 4.5 4.04023 6.09199 1.19336 8.70076M4.73193 12.243C6.67006 10.5357 9.21407 9.5 12 9.5C14.7859 9.5 17.3299 10.5357 19.268 12.243M15.6983 15.7751C14.6792 14.9763 13.3952 14.5 11.9999 14.5C10.5835 14.5 9.28172 14.9908 8.25537 15.8116",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), a32 = [
  s32,
  h32
];
function d32(r, e) {
  return n(), o("svg", l32, a32);
}
const CN2 = /* @__PURE__ */ i(i32, [["render", d32]]);
var c32 = {}, _32 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C32 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -556)",
  fill: "none"
}, null, -1), f32 = /* @__PURE__ */ t("path", {
  d: "M21 18C21 18 19.8096 17.5305 19 17.3021C13.8797 15.8574 10.1203 20.1426 5 18.6979C4.19041 18.4695 3 18 3 18M21 12C21 12 19.8096 11.5305 19 11.3021C13.8797 9.85739 10.1203 14.1426 5 12.6979C4.19041 12.4695 3 12 3 12M21 6C21 6 19.8096 5.53048 19 5.30206C13.8797 3.85739 10.1203 8.14261 5 6.69794C4.19041 6.46952 3 6 3 6",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), v32 = [
  C32,
  f32
];
function u32(r, e) {
  return n(), o("svg", _32, v32);
}
const fN2 = /* @__PURE__ */ i(c32, [["render", u32]]);
var w32 = {}, p32 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g32 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -596)",
  fill: "none"
}, null, -1), $32 = /* @__PURE__ */ t("path", {
  d: "M9.50929 4.66667C9.8755 4.2575 10.4077 4 11 4C12.1046 4 13 4.89543 13 6C13 7.10457 12.1046 8 11 8H2.00002M12.5093 19.3333C12.8755 19.7425 13.4077 20 14 20C15.1046 20 16 19.1046 16 18C16 16.8954 15.1046 16 14 16H2.00002M16.7639 7C17.3132 6.38625 18.1115 6 19 6C20.6569 6 22 7.34315 22 9C22 10.6569 20.6569 12 19 12H2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), M32 = [
  g32,
  $32
];
function L32(r, e) {
  return n(), o("svg", p32, M32);
}
const vN2 = /* @__PURE__ */ i(w32, [["render", L32]]);
var k32 = {}, m32 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x32 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "740",
  transform: "translate(-880 -636)",
  fill: "none"
}, null, -1), H32 = /* @__PURE__ */ t("path", {
  d: "M16.7639 6.5C17.3132 5.88625 18.1115 5.5 19 5.5C20.6569 5.5 22 6.84315 22 8.5C22 10.1569 20.6569 11.5 19 11.5H13M6.7639 4C7.31322 3.38625 8.1115 3 9 3C10.6569 3 12 4.34315 12 6C12 7.65685 10.6569 9 9 9H2M10.7639 20C11.3132 20.6137 12.1115 21 13 21C14.6569 21 16 19.6569 16 18C16 16.3431 14.6569 15 13 15H2",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), V32 = [
  x32,
  H32
];
function Z32(r, e) {
  return n(), o("svg", m32, V32);
}
const uN2 = /* @__PURE__ */ i(k32, [["render", Z32]]);
var B32 = {}, F32 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j32 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1676)",
  fill: "none"
}, null, -1), I32 = /* @__PURE__ */ t("path", {
  d: "M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), b32 = [
  j32,
  I32
];
function y32(r, e) {
  return n(), o("svg", F32, b32);
}
const S2 = /* @__PURE__ */ i(B32, [["render", y32]]);
var D32 = {}, P32 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, A32 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1716)",
  fill: "none"
}, null, -1), S32 = /* @__PURE__ */ t("path", {
  d: "M18 6L6 18M6 6L18 18",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), T32 = [
  A32,
  S32
];
function O32(r, e) {
  return n(), o("svg", P32, T32);
}
const wN2 = /* @__PURE__ */ i(D32, [["render", O32]]);
var E32 = {}, R32 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, U32 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1756)",
  fill: "none"
}, null, -1), N32 = /* @__PURE__ */ t("path", {
  d: "M9 9L15 15M15 9L9 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), q32 = [
  U32,
  N32
];
function z32(r, e) {
  return n(), o("svg", R32, q32);
}
const pN2 = /* @__PURE__ */ i(E32, [["render", z32]]);
var K32 = {}, G32 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, W32 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1636)",
  fill: "none"
}, null, -1), Y32 = /* @__PURE__ */ t("path", {
  d: "M17 7L7 17M7 7L17 17",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), X32 = [
  W32,
  Y32
];
function Q32(r, e) {
  return n(), o("svg", G32, X32);
}
const m2 = /* @__PURE__ */ i(K32, [["render", Q32]]);
var J32 = {}, t92 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, e92 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1300",
  transform: "translate(-880 -1196)",
  fill: "none"
}, null, -1), r92 = /* @__PURE__ */ t("path", {
  d: "M21.5813 7.19989C21.4733 6.76846 21.2534 6.37318 20.9438 6.05395C20.6341 5.73473 20.2457 5.50287 19.8178 5.3818C18.2542 5 12 5 12 5C12 5 5.74578 5 4.18222 5.41816C3.75429 5.53923 3.36588 5.77109 3.05623 6.09031C2.74659 6.40954 2.52666 6.80482 2.41868 7.23625C2.13253 8.82303 1.99255 10.4327 2.00052 12.0451C1.99032 13.6696 2.1303 15.2916 2.41868 16.8903C2.53773 17.3083 2.76258 17.6886 3.0715 17.9943C3.38043 18.3 3.76299 18.5209 4.18222 18.6357C5.74578 19.0538 12 19.0538 12 19.0538C12 19.0538 18.2542 19.0538 19.8178 18.6357C20.2457 18.5146 20.6341 18.2827 20.9438 17.9635C21.2534 17.6443 21.4733 17.249 21.5813 16.8176C21.8653 15.2427 22.0052 13.6453 21.9995 12.0451C22.0097 10.4206 21.8697 8.79862 21.5813 7.19989Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), n92 = /* @__PURE__ */ t("path", {
  d: "M9.75 9.46533C9.75 8.98805 9.75 8.74941 9.84974 8.61618C9.93666 8.50008 10.0697 8.42744 10.2144 8.4171C10.3804 8.40525 10.5811 8.53429 10.9826 8.79239L14.9254 11.3271C15.2738 11.551 15.448 11.663 15.5082 11.8054C15.5607 11.9298 15.5607 12.0702 15.5082 12.1946C15.448 12.337 15.2738 12.449 14.9254 12.6729L10.9826 15.2076C10.5811 15.4657 10.3804 15.5948 10.2144 15.5829C10.0697 15.5726 9.93666 15.4999 9.84974 15.3838C9.75 15.2506 9.75 15.012 9.75 14.5347V9.46533Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), o92 = [
  e92,
  r92,
  n92
];
function i92(r, e) {
  return n(), o("svg", t92, o92);
}
const gN2 = /* @__PURE__ */ i(J32, [["render", i92]]);
var l92 = {}, s92 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h92 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1836)",
  fill: "none"
}, null, -1), a92 = /* @__PURE__ */ t("path", {
  d: "M12 5.5L7.36159 12.2468C7.08236 12.6529 6.94275 12.856 6.95113 13.0248C6.95843 13.1718 7.03015 13.3082 7.14716 13.3975C7.28151 13.5 7.52794 13.5 8.02082 13.5H12V18.5L16.6384 11.7532C16.9176 11.3471 17.0573 11.144 17.0489 10.9752C17.0416 10.8282 16.9699 10.6918 16.8528 10.6025C16.7185 10.5 16.4721 10.5 15.9792 10.5H12V5.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), d92 = /* @__PURE__ */ t("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), c92 = [
  h92,
  a92,
  d92
];
function _92(r, e) {
  return n(), o("svg", s92, c92);
}
const $N2 = /* @__PURE__ */ i(l92, [["render", _92]]);
var C92 = {}, f92 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, v92 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1876)",
  fill: "none"
}, null, -1), u92 = /* @__PURE__ */ t("path", {
  d: "M9 17.5H3.5M6.5 12H2M9 6.5H4M17 3L10.4036 12.235C10.1116 12.6438 9.96562 12.8481 9.97194 13.0185C9.97744 13.1669 10.0486 13.3051 10.1661 13.3958C10.3011 13.5 10.5522 13.5 11.0546 13.5H16L15 21L21.5964 11.765C21.8884 11.3562 22.0344 11.1519 22.0281 10.9815C22.0226 10.8331 21.9514 10.6949 21.8339 10.6042C21.6989 10.5 21.4478 10.5 20.9454 10.5H16L17 3Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), w92 = [
  v92,
  u92
];
function p92(r, e) {
  return n(), o("svg", f92, w92);
}
const MN2 = /* @__PURE__ */ i(C92, [["render", p92]]);
var g92 = {}, $92 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M92 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1916)",
  fill: "none"
}, null, -1), L92 = /* @__PURE__ */ t("path", {
  d: "M8 8L4.09346 12.6879C3.74465 13.1064 3.57024 13.3157 3.56758 13.4925C3.56526 13.6461 3.63373 13.7923 3.75326 13.8889C3.89075 14 4.16318 14 4.70803 14H12L11 22L16 16M15.65 10H19.292C19.8368 10 20.1093 10 20.2467 10.1111C20.3663 10.2077 20.4347 10.3539 20.4324 10.5075C20.4298 10.6843 20.2554 10.8936 19.9065 11.3121L18.5502 12.9397M10.5728 4.91265L13 2L12.4002 6.79771M21 21L3 3",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), k92 = [
  M92,
  L92
];
function m92(r, e) {
  return n(), o("svg", $92, k92);
}
const LN2 = /* @__PURE__ */ i(g92, [["render", m92]]);
var x92 = {}, H92 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V92 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1956)",
  fill: "none"
}, null, -1), Z92 = /* @__PURE__ */ t("path", {
  d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), B92 = /* @__PURE__ */ t("path", {
  d: "M12 6L7.4336 12.2269C7.13256 12.6374 6.98205 12.8427 6.9869 13.0142C6.99113 13.1634 7.06185 13.303 7.17972 13.3947C7.31514 13.5 7.56967 13.5 8.07872 13.5H12V18L16.5664 11.7731C16.8674 11.3626 17.018 11.1573 17.0131 10.9858C17.0089 10.8366 16.9381 10.697 16.8203 10.6053C16.6849 10.5 16.4303 10.5 15.9213 10.5H12V6Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), F92 = [
  V92,
  Z92,
  B92
];
function j92(r, e) {
  return n(), o("svg", H92, F92);
}
const kN2 = /* @__PURE__ */ i(x92, [["render", j92]]);
var I92 = {}, b92 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y92 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "2180",
  transform: "translate(-880 -1796)",
  fill: "none"
}, null, -1), D92 = /* @__PURE__ */ t("path", {
  d: "M13 2L4.09344 12.6879C3.74463 13.1064 3.57023 13.3157 3.56756 13.4925C3.56524 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9065 11.3121C20.2553 10.8936 20.4297 10.6843 20.4324 10.5075C20.4347 10.3539 20.3663 10.2077 20.2467 10.1111C20.1092 10 19.8368 10 19.292 10H12L13 2Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), P92 = [
  y92,
  D92
];
function A92(r, e) {
  return n(), o("svg", b92, P92);
}
const mN2 = /* @__PURE__ */ i(I92, [["render", A92]]);
var S92 = {}, T92 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O92 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -1116)",
  fill: "none"
}, null, -1), E92 = /* @__PURE__ */ t("path", {
  d: "M21 21L16.65 16.65M11 8V14M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), R92 = [
  O92,
  E92
];
function U92(r, e) {
  return n(), o("svg", T92, R92);
}
const xN2 = /* @__PURE__ */ i(S92, [["render", U92]]);
var N92 = {}, q92 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z92 = /* @__PURE__ */ t("rect", {
  width: "1144",
  height: "1260",
  transform: "translate(-880 -1156)",
  fill: "none"
}, null, -1), K92 = /* @__PURE__ */ t("path", {
  d: "M21 21L16.65 16.65M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), G92 = [
  z92,
  K92
];
function W92(r, e) {
  return n(), o("svg", q92, G92);
}
const HN2 = /* @__PURE__ */ i(N92, [["render", W92]]);
var Y92 = {}, X92 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Q92 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -296)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M6.78274 22.8093C8.36037 23.5721 10.1302 24 12.0001 24C13.87 24 15.6399 23.5721 17.2175 22.8093L18.261 12L17.2175 1.19072C15.6399 0.427875 13.87 0 12.0001 0C10.1302 0 8.36037 0.427875 6.78274 1.19072L5.73926 12L6.78274 22.8093Z" fill="#FFDA44"></path><path d="M17.2168 22.8091C21.2308 20.8682 23.9994 16.7577 23.9994 12.0002C23.9994 7.24272 21.2308 3.13225 17.2168 1.19135V22.8091Z" fill="#D80027"></path><path d="M6.78262 22.8091V1.19135C2.76867 3.13225 0 7.24267 0 12.0002C0 16.7577 2.76867 20.8682 6.78262 22.8091Z" fill="#0052B4"></path><path d="M12 16.1734C12 14.2585 12 11.9995 12 11.9995H15.1304V13.5647C15.1304 13.8366 14.6087 14.833 13.3209 15.6517C12.8332 15.9618 12.3283 16.0616 12 16.1734Z" fill="#D80027"></path><path d="M11.9996 8.86884H8.86914V11.9993H11.9996V8.86884Z" fill="#D80027"></path><path d="M13.5653 7.8262C13.5653 7.24987 13.0981 6.78271 12.5218 6.78271C12.3315 6.78271 12.1536 6.83446 12.0001 6.92343C11.8465 6.83446 11.6687 6.78271 11.4783 6.78271C10.9021 6.78271 10.4349 7.24987 10.4349 7.8262H7.82617V13.0435C7.82617 14.9858 9.36864 16.1091 10.5782 16.6914C10.4877 16.846 10.4349 17.0254 10.4349 17.2175C10.4349 17.7938 10.9021 18.261 11.4783 18.261C11.6687 18.261 11.8465 18.2093 12.0001 18.1203C12.1537 18.2093 12.3315 18.261 12.5218 18.261C13.0981 18.261 13.5653 17.7938 13.5653 17.2175C13.5653 17.0254 13.5124 16.846 13.4218 16.6914C14.6314 16.1091 16.174 14.9859 16.174 13.0435V7.8262H13.5653ZM14.6088 13.0435C14.6088 13.3155 14.6087 14.1428 13.321 14.9616C12.8332 15.2717 12.3284 15.4728 12.0001 15.5846C11.6718 15.4728 11.1669 15.2717 10.6791 14.9616C9.39138 14.1428 9.39138 13.3155 9.39138 13.0435V9.3914H14.6088V13.0435Z" fill="#FF9811"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), J92 = [
  Q92
];
function t62(r, e) {
  return n(), o("svg", X92, J92);
}
const VN2 = /* @__PURE__ */ i(Y92, [["render", t62]]);
var e62 = {}, r62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, n62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -1136)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M6.78223 16.1729L7.82571 23.2527C9.12565 23.7351 10.5318 23.999 11.9996 23.999C17.1591 23.999 21.5577 20.7425 23.2532 16.1729H6.78223Z" fill="black"></path><path d="M6.78223 7.8266L7.82571 0.746785C9.12565 0.264394 10.5318 0.000488281 11.9996 0.000488281C17.1591 0.000488281 21.5577 3.25699 23.2532 7.8266H6.78223Z" fill="#6DA544"></path><path d="M0 11.9999C0 17.1595 3.25655 21.558 7.82611 23.2536V0.746338C3.25655 2.44185 0 6.84037 0 11.9999Z" fill="#A2001D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), o62 = [
  n62
];
function i62(r, e) {
  return n(), o("svg", r62, o62);
}
const ZN2 = /* @__PURE__ */ i(e62, [["render", i62]]);
var l62 = {}, s62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -16)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M17.2175 1.19072C15.6399 0.427875 13.87 0 12.0001 0C10.1303 0 8.36037 0.427875 6.78274 1.19072L5.73926 12L6.78274 22.8093C8.36037 23.5721 10.1303 24 12.0001 24C13.87 24 15.6399 23.5721 17.2175 22.8093L18.261 12L17.2175 1.19072Z" fill="#D80027"></path><path d="M6.78262 1.19135C2.76872 3.1323 0 7.24272 0 12.0002C0 16.7577 2.76872 20.8681 6.78262 22.8091V1.19135Z" fill="black"></path><path d="M17.2178 1.19135V22.8091C21.2317 20.8681 24.0004 16.7577 24.0004 12.0002C24.0004 7.24272 21.2317 3.1323 17.2178 1.19135Z" fill="#496E2D"></path><path d="M12.0001 7.82672C9.69484 7.82672 7.82617 9.69544 7.82617 12.0006C7.82617 14.3058 9.69489 16.1745 12.0001 16.1745C14.3052 16.1745 16.174 14.3058 16.174 12.0006C16.174 9.69544 14.3053 7.82672 12.0001 7.82672ZM12.0001 14.6093C10.5593 14.6093 9.39138 13.4413 9.39138 12.0006C9.39138 10.5599 10.5594 9.39192 12.0001 9.39192C13.4408 9.39192 14.6088 10.5599 14.6088 12.0006C14.6088 13.4413 13.4408 14.6093 12.0001 14.6093Z" fill="#FFDA44"></path><path d="M12.0005 10.4362C11.4242 10.4362 10.957 10.9034 10.957 11.4797V13.0449H13.044V11.4797C13.044 10.9034 12.5768 10.4362 12.0005 10.4362Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), a62 = [
  h62
];
function d62(r, e) {
  return n(), o("svg", s62, a62);
}
const BN2 = /* @__PURE__ */ i(l62, [["render", d62]]);
var c62 = {}, _62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -464)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 11.9992C0 12.8212 0.082875 13.6238 0.240328 14.3992L12 15.1297L23.7597 14.3992C23.9172 13.6238 24 12.8212 24 11.9992C24 11.1773 23.9171 10.3747 23.7597 9.59923L12 8.86877L0.240328 9.59923C0.082875 10.3747 0 11.1773 0 11.9992Z" fill="#0052B4"></path><path d="M23.7596 14.3992H0.240234C1.35206 19.8765 6.19448 23.9992 11.9999 23.9992C17.8053 23.9992 22.6477 19.8765 23.7596 14.3992Z" fill="#F0F0F0"></path><path d="M0.240234 9.6H23.7597C22.6478 4.12266 17.8054 0 11.9999 0C6.19439 0 1.35206 4.12266 0.240234 9.6Z" fill="black"></path><path d="M17.218 9.59937H6.7832L8.91508 8.59653L7.77981 6.53192L10.0947 6.97466L10.3882 4.63611L12.0006 6.35614L13.6131 4.63611L13.9063 6.97466L16.2214 6.53192L15.0862 8.59662L17.218 9.59937Z" fill="#FFDA44"></path><path d="M0 12.0008C0 18.6282 5.37262 24.0008 12 24.0008L2.39981 4.80042C0.893062 6.80615 0 9.2991 0 12.0008Z" fill="#A2001D"></path><path d="M12 23.9999C18.6274 23.9999 24 18.6272 24 11.9999C24 9.29813 23.1069 6.80517 21.6002 4.79944L12 23.9999Z" fill="#A2001D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), f62 = [
  C62
];
function v62(r, e) {
  return n(), o("svg", _62, f62);
}
const FN2 = /* @__PURE__ */ i(c62, [["render", v62]]);
var u62 = {}, w62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -408)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"></path><path d="M11.9678 12.0005H11.9999C11.9999 11.9897 11.9999 11.9792 11.9999 11.9684C11.9892 11.9791 11.9785 11.9898 11.9678 12.0005Z" fill="#F0F0F0"></path><path d="M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z" fill="#F0F0F0"></path><path d="M6.07027 1.56506C4.19344 2.63377 2.63311 4.19405 1.56445 6.07088V11.9999H4.69491V4.69561V4.69552H11.9993C11.9993 3.70819 11.9993 2.7676 11.9993 1.56506H6.07027Z" fill="#D80027"></path><path d="M11.9989 10.5248L7.73539 6.26135H6.25977V6.26145L11.9988 12.0005H11.9989C11.9989 12.0005 11.9989 10.9829 11.9989 10.5248Z" fill="#D80027"></path><path d="M20.2942 13.7574C20.6393 13.2826 20.8698 12.7029 20.8698 12.0008V6.78339C20.4337 7.11095 19.8919 7.30511 19.3046 7.30511C18.4512 7.30511 17.6935 6.89528 17.2176 6.26172C16.7416 6.89528 15.984 7.30511 15.1306 7.30511C14.5433 7.30511 14.0014 7.11091 13.5654 6.78348V12.0008C13.5654 12.7029 13.7959 13.2826 14.141 13.7574H20.2942Z" fill="#F3F3F3"></path><path d="M19.208 11.0321C19.3741 10.6269 19.5033 10.0345 19.5033 9.7397C19.5033 9.26603 18.8858 8.88208 18.8858 8.88208C18.8858 8.88208 18.2682 9.26603 18.2682 9.7397C18.2682 10.0345 18.3975 10.6269 18.5635 11.0321L18.207 11.837C18.4166 11.9222 18.6456 11.9696 18.8858 11.9696C19.1261 11.9696 19.355 11.9222 19.5646 11.837L19.208 11.0321Z" fill="#FF9811"></path><path d="M16.7955 8.42672C16.3617 8.4855 15.784 8.66995 15.5287 8.81733C15.1185 9.05419 15.0947 9.78089 15.0947 9.78089C15.0947 9.78089 15.7361 10.1237 16.1462 9.88687C16.4016 9.73945 16.8499 9.33145 17.1177 8.98495L17.9932 8.8912C17.9622 8.66723 17.8885 8.44519 17.7685 8.2372C17.6483 8.02922 17.4929 7.85447 17.3144 7.71558L16.7955 8.42672Z" fill="#FF9811"></path><path d="M15.7445 11.8206C16.0123 12.1669 16.4608 12.5748 16.7162 12.7223C17.1264 12.9591 17.7677 12.6164 17.7677 12.6164C17.7677 12.6164 17.7438 11.8896 17.3336 11.6528C17.0782 11.5053 16.5007 11.3211 16.0667 11.2624L15.5479 10.5511C15.3694 10.69 15.214 10.8648 15.0938 11.0726C14.9738 11.2807 14.9003 11.5027 14.8691 11.7268L15.7445 11.8206Z" fill="#FF9811"></path><path d="M14.0117 13.5657C14.9862 15.1292 17.2175 15.6525 17.2175 15.6525C17.2175 15.6525 19.4487 15.1292 20.4232 13.5657H14.0117Z" fill="#338AF3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), g62 = [
  p62
];
function $62(r, e) {
  return n(), o("svg", w62, g62);
}
const jN2 = /* @__PURE__ */ i(u62, [["render", $62]]);
var M62 = {}, L62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, k62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -128)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M18.783 8.90742H14.4364C14.7048 8.62646 14.8699 8.24606 14.8699 7.82686C14.8699 6.96244 14.1691 6.26166 13.3047 6.26166C12.7601 6.26166 12.2807 6.53991 12.0004 6.96183C11.72 6.53991 11.2406 6.26166 10.696 6.26166C9.83159 6.26166 9.13081 6.96244 9.13081 7.82686C9.13081 8.24606 9.29595 8.6265 9.56426 8.90742H5.21777C5.21777 10.06 6.2217 10.9943 7.37421 10.9943H7.30465C7.30465 12.147 8.23901 13.0814 9.39166 13.0814C9.39166 13.4547 9.49005 13.8046 9.6618 14.1076L7.93071 15.8388L9.25887 17.1668L11.1429 15.2829C11.2166 15.3099 11.293 15.3316 11.3719 15.3464L10.2334 17.9168L12.0004 19.8269L13.7673 17.9167L12.6289 15.3463C12.7077 15.3316 12.7841 15.3099 12.8578 15.2828L14.7418 17.1668L16.07 15.8386L14.3389 14.1075C14.5106 13.8046 14.609 13.4545 14.609 13.0812C15.7616 13.0812 16.696 12.1469 16.696 10.9942H16.6265C17.779 10.9943 18.783 10.06 18.783 8.90742Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), m62 = [
  k62
];
function x62(r, e) {
  return n(), o("svg", L62, m62);
}
const IN2 = /* @__PURE__ */ i(M62, [["render", x62]]);
var H62 = {}, V62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Z62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -576)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12.0001C24 10.5323 23.736 9.12615 23.2536 7.82621L12 7.30444L0.746391 7.82616C0.264047 9.12614 0 10.5323 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174L12 16.6957L23.2536 16.174C23.736 14.874 24 13.4679 24 12.0001Z" fill="#0052B4"></path><path d="M11.9997 23.9996C17.1593 23.9996 21.5578 20.7431 23.2533 16.1735H0.746094C2.44161 20.7431 6.84012 23.9996 11.9997 23.9996Z" fill="#FF9811"></path><path d="M0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0C6.84012 0 2.44161 3.2565 0.746094 7.82611Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), B62 = [
  Z62
];
function F62(r, e) {
  return n(), o("svg", V62, B62);
}
const bN2 = /* @__PURE__ */ i(H62, [["render", F62]]);
var j62 = {}, I62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, b62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -352)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z" fill="#D80027"></path><path d="M24 12.0004C24 18.6277 18.6274 24.0004 12 24.0004C5.37262 24.0004 0 18.6277 0 12.0004" fill="black"></path><path d="M10.3535 9.54359L11.3708 10.2819L10.9831 11.4776L11.9997 10.7381L13.017 11.4763L12.6279 10.281L13.6443 9.54162L12.3874 9.54237L11.9982 8.34711L11.6105 9.5428L10.3535 9.54359Z" fill="#FFDA44"></path><path d="M14.9994 6.80332C14.0538 6.25736 13.0199 5.99969 11.9994 6.00147V7.56635C12.7537 7.56499 13.5178 7.7553 14.2168 8.1589C16.3345 9.38158 17.0627 12.0992 15.84 14.2169C14.6173 16.3346 11.8998 17.0628 9.78199 15.8402C9.16502 15.484 8.66698 15.0003 8.29985 14.4422L6.99316 15.3048C7.4899 16.06 8.16471 16.7137 8.99941 17.1956C11.8646 18.8498 15.5413 17.8646 17.1955 14.9995C18.8497 12.1343 17.8646 8.45754 14.9994 6.80332Z" fill="#FFDA44"></path><path d="M8.53898 10.956C8.12414 11.7144 8.40267 12.6655 9.16101 13.0804L14.2446 15.8582C13.8989 16.4901 14.0825 17.2593 14.7144 17.605L16.0876 18.3561C16.7195 18.7019 17.5122 18.4698 17.8579 17.8378L18.6091 16.4646L8.53898 10.956Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), y62 = [
  b62
];
function D62(r, e) {
  return n(), o("svg", I62, y62);
}
const yN2 = /* @__PURE__ */ i(j62, [["render", D62]]);
var P62 = {}, A62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -520)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12.0007 -0.000976562C7.24316 -0.000976562 3.13241 2.7677 1.19141 6.78165H22.8099C20.869 2.7677 16.7582 -0.000976562 12.0007 -0.000976562Z" fill="#338AF3"></path><path d="M12.0007 23.9987C16.7582 23.9987 20.869 21.23 22.81 17.2161H1.19141C3.13241 21.23 7.24316 23.9987 12.0007 23.9987Z" fill="#338AF3"></path><path d="M15.5864 12L14.1208 12.6894L14.9012 14.1087L13.3098 13.8043L13.1082 15.4119L11.9997 14.2295L10.8912 15.4119L10.6896 13.8043L9.09821 14.1087L9.87859 12.6894L8.41309 12L9.87863 11.3106L9.09821 9.89135L10.6896 10.1958L10.8913 8.58813L11.9997 9.77051L13.1082 8.58813L13.3098 10.1958L14.9013 9.89135L14.1209 11.3107L15.5864 12Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), T62 = [
  S62
];
function O62(r, e) {
  return n(), o("svg", A62, T62);
}
const DN2 = /* @__PURE__ */ i(P62, [["render", O62]]);
var E62 = {}, R62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, U62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -240)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M17.8217 1.50525C16.0974 0.54675 14.1127 0 12 0C5.37309 0 0.00084375 5.37178 0 11.9986L8.34783 7.82611L17.8217 1.50525Z" fill="#0052B4"></path><path d="M0 12.0019C0.00084375 18.6287 5.37309 24.0005 12 24.0005C14.1127 24.0005 16.0974 23.4538 17.8217 22.4952L8.34783 16.1744L0 12.0019Z" fill="#0052B4"></path><path d="M18.8217 2.12703C18.4994 1.90395 18.1654 1.69648 17.8213 1.50519L0 11.9983C0 11.9988 0 11.9993 0 11.9998C0 12.0002 0 12.0007 0 12.0012L17.8213 22.4943C18.1655 22.3029 18.4994 22.0955 18.8218 21.8724L2.05416 11.9998L18.8217 2.12703Z" fill="#D80027"></path><path d="M20.8692 11.5526H19.4398C19.8115 11.1064 19.7885 10.4425 19.3698 10.0238C19.8133 9.58035 19.8133 8.86124 19.3698 8.41766L19.3431 8.44447C19.7866 8.00099 19.8133 7.25507 19.3698 6.81158L12.9453 13.2361C13.3888 13.6797 14.0953 13.6744 14.5388 13.2308L14.6625 13.1178L17.7388 12.8382V14.1613H18.7823V12.7433L20.3475 12.601L20.8692 11.5526Z" fill="#A2001D"></path><path d="M13.0439 14.6089L12 14.0872L13.0439 13.5654H19.8264V14.6089H13.0439Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), N62 = [
  U62
];
function q62(r, e) {
  return n(), o("svg", R62, N62);
}
const PN2 = /* @__PURE__ */ i(E62, [["render", q62]]);
var z62 = {}, K62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, G62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -744)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M23.2536 16.173C23.736 14.8731 24 13.467 24 11.9991C24 10.5313 23.736 9.12525 23.2536 7.82522L12 6.78174L0.746391 7.82522C0.264047 9.12525 0 10.5313 0 11.9991C0 13.467 0.264047 14.8731 0.746391 16.173L12 17.2165L23.2536 16.173Z" fill="#F0F0F0"></path><path d="M11.9998 23.9996C17.1593 23.9996 21.5578 20.7431 23.2533 16.1735H0.746094C2.44166 20.7431 6.84013 23.9996 11.9998 23.9996Z" fill="#D80027"></path><path d="M11.9997 0C6.84012 0 2.44166 3.2565 0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), W62 = [
  G62
];
function Y62(r, e) {
  return n(), o("svg", K62, W62);
}
const AN2 = /* @__PURE__ */ i(z62, [["render", Y62]]);
var X62 = {}, Q62 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, J62 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -688)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0028 12 0.00135937 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"></path><path d="M11.9678 12.0004H11.9999C11.9999 11.9895 11.9999 11.9791 11.9999 11.9683C11.9892 11.979 11.9785 11.9897 11.9678 12.0004Z" fill="#F0F0F0"></path><path d="M12 6.26171C12 4.15023 12 2.76662 12 0.000854492H11.998C5.3715 0.00193262 0 5.37404 0 12.0008H6.26086V8.47524L9.78642 12.0008H11.9679C11.9787 11.9901 11.9894 11.9794 12 11.9687C12 11.1602 12 10.4389 12 9.78732L8.47443 6.26171H12Z" fill="#F0F0F0"></path><path d="M6.07124 1.56567C4.19441 2.63438 2.63413 4.19466 1.56543 6.07149V12.0005H4.69588V4.69617V4.69613H12.0002C12.0002 3.7088 12.0002 2.76821 12.0002 1.56567H6.07124Z" fill="#D80027"></path><path d="M12.0008 10.5249L7.73739 6.2615H6.26172C6.26172 6.26145 6.26172 6.2615 6.26172 6.2615L12.0008 12.0005H12.0008C12.0008 12.0005 12.0008 10.9831 12.0008 10.5249Z" fill="#D80027"></path><path d="M7.23729 14.0864L7.89588 15.4635L9.38309 15.1198L8.71709 16.4933L9.91305 17.4417L8.42398 17.7774L8.42815 19.3038L7.23729 18.3488L6.04648 19.3038L6.05065 17.7774L4.56152 17.4417L5.75754 16.4933L5.09145 15.1198L6.57874 15.4635L7.23729 14.0864Z" fill="#F0F0F0"></path><path d="M17.9668 16.6954L18.2961 17.384L19.0397 17.2121L18.7066 17.8989L19.3047 18.3731L18.5601 18.5409L18.5622 19.3041L17.9668 18.8266L17.3714 19.3041L17.3734 18.5409L16.6289 18.3731L17.2269 17.8989L16.8939 17.2121L17.6375 17.384L17.9668 16.6954Z" fill="#F0F0F0"></path><path d="M14.9033 9.39148L15.2326 10.0801L15.9762 9.90814L15.6432 10.5949L16.2412 11.0691L15.4967 11.2369L15.4987 12.0002L14.9033 11.5227L14.3079 12.0002L14.3099 11.2369L13.5654 11.0691L14.1634 10.5949L13.8304 9.90814L14.574 10.0801L14.9033 9.39148Z" fill="#F0F0F0"></path><path d="M17.9668 5.21765L18.2961 5.90625L19.0397 5.73436L18.7067 6.42112L19.3046 6.89531L18.5601 7.06317L18.5622 7.82639L17.9668 7.34887L17.3714 7.82639L17.3734 7.06317L16.6289 6.89531L17.2268 6.42112L16.8939 5.73436L17.6375 5.90625L17.9668 5.21765Z" fill="#F0F0F0"></path><path d="M20.6416 8.34778L20.9709 9.03637L21.7145 8.86443L21.3815 9.5512L21.9795 10.0254L21.2349 10.1933L21.237 10.9565L20.6416 10.479L20.0462 10.9565L20.0482 10.1933L19.3037 10.0254L19.9017 9.5512L19.5687 8.86443L20.3123 9.03637L20.6416 8.34778Z" fill="#F0F0F0"></path><path d="M18.729 12.0004L18.988 12.7975H19.8262L19.1481 13.2902L19.4072 14.0873L18.729 13.5947L18.0509 14.0873L18.3099 13.2902L17.6318 12.7975H18.47L18.729 12.0004Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), t52 = [
  J62
];
function e52(r, e) {
  return n(), o("svg", Q62, t52);
}
const SN2 = /* @__PURE__ */ i(X62, [["render", e52]]);
var r52 = {}, n52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o52 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -632)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M11.9999 24.0003C15.637 24.0003 18.8959 22.382 21.0965 19.8264H2.90332C5.10396 22.382 8.36285 24.0003 11.9999 24.0003Z" fill="#338AF3"></path><path d="M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1305H23.5867C23.8556 14.1323 24 13.0831 24 12Z" fill="#338AF3"></path><path d="M0.954102 16.6962C1.18543 17.2397 1.45585 17.7625 1.76152 18.2614H22.239C22.5446 17.7624 22.8151 17.2397 23.0465 16.6962H0.954102Z" fill="#338AF3"></path><path d="M5.4988 7.56904L3.1543 6.53432L5.4988 5.4996L6.53347 3.15515L7.56814 5.4996L9.9126 6.53432L7.56814 7.56904L6.53347 9.9135L5.4988 7.56904Z" fill="#F0F0F0"></path><path d="M6.53326 4.44739L7.17221 5.89531L8.62018 6.53436L7.17221 7.17336L6.53326 8.62128L5.89421 7.17336L4.44629 6.53436L5.89421 5.89531L6.53326 4.44739Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), i52 = [
  o52
];
function l52(r, e) {
  return n(), o("svg", n52, i52);
}
const TN2 = /* @__PURE__ */ i(r52, [["render", l52]]);
var s52 = {}, h52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, a52 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -72)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M23.5866 15.1299C23.8556 14.1317 24 13.0826 24 11.9994C24 10.9163 23.8556 9.86715 23.5866 8.869L10.9565 0.045105C8.61178 0.247136 6.46008 1.12323 4.69566 2.4789L0.413391 8.869C0.144375 9.86715 0 10.9163 0 11.9994C0 13.0763 0.142641 14.1197 0.408656 15.1126L4.69561 21.52C6.46003 22.8757 8.61173 23.7518 10.9565 23.9538L23.5866 15.1299Z" fill="#FFDA44"></path><path d="M0.413086 15.1305C1.1074 17.7067 2.63763 19.9395 4.69535 21.5206V15.1305H0.413086Z" fill="#0052B4"></path><path d="M10.9561 23.9544C11.3 23.984 11.6479 24.0001 11.9995 24.0001C17.5439 24.0001 22.2091 20.2397 23.5861 15.1305H10.9561V23.9544Z" fill="#0052B4"></path><path d="M23.5861 8.86955C22.2091 3.76036 17.5439 0 11.9995 0C11.6479 0 11.3 0.0160312 10.9561 0.0456562V8.86955H23.5861Z" fill="#0052B4"></path><path d="M4.69535 2.4798C2.63763 4.06089 1.1074 6.29369 0.413086 8.86989H4.69535V2.4798Z" fill="#0052B4"></path><path d="M23.8984 10.4343H9.39136H9.39131V0.284729C8.28234 0.530635 7.23098 0.929213 6.26086 1.45857V10.4342H0.101578C0.0347813 10.9466 0 11.469 0 11.9995C0 12.53 0.0347813 13.0524 0.101578 13.5647H6.26081H6.26086V22.5404C7.23098 23.0697 8.28234 23.4684 9.39131 23.7142V13.5648V13.5647H23.8984C23.9651 13.0524 24 12.53 24 11.9995C24 11.469 23.9651 10.9466 23.8984 10.4343Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), d52 = [
  a52
];
function c52(r, e) {
  return n(), o("svg", h52, d52);
}
const ON2 = /* @__PURE__ */ i(s52, [["render", c52]]);
var _52 = {}, C52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, f52 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -800)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12.0001C24 10.5323 23.736 9.12615 23.2536 7.82621L12 7.30444L0.746391 7.82616C0.264047 9.12614 0 10.5323 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174L12 16.6957L23.2536 16.174C23.736 14.874 24 13.4679 24 12.0001Z" fill="#D80027"></path><path d="M12.0007 23.9996C17.1603 23.9996 21.5588 20.7431 23.2543 16.1735H0.74707C2.44259 20.7431 6.8411 23.9996 12.0007 23.9996Z" fill="#6DA544"></path><path d="M0.74707 7.82513H23.2543C21.5588 3.25552 17.1603 -0.000976562 12.0007 -0.000976562C6.8411 -0.000976562 2.44259 3.25552 0.74707 7.82513Z" fill="#338AF3"></path><path d="M12.2605 15.3911C10.3875 15.3911 8.86915 13.8727 8.86915 11.9997C8.86915 10.1268 10.3875 8.60843 12.2605 8.60843C12.8444 8.60843 13.3939 8.75609 13.8737 9.01606C13.121 8.28007 12.0918 7.82581 10.9561 7.82581C8.6509 7.82581 6.78223 9.69452 6.78223 11.9997C6.78223 14.3049 8.65094 16.1736 10.9561 16.1736C12.0919 16.1736 13.1211 15.7193 13.8737 14.9833C13.3939 15.2434 12.8444 15.3911 12.2605 15.3911Z" fill="#F0F0F0"></path><path d="M14.8693 9.65076L15.3185 10.9141L16.5295 10.3384L15.9538 11.5493L17.2171 11.9986L15.9538 12.4478L16.5295 13.6588L15.3185 13.0831L14.8693 14.3464L14.4202 13.0831L13.2091 13.6588L13.7849 12.4478L12.5215 11.9986L13.7849 11.5493L13.2091 10.3384L14.4202 10.9141L14.8693 9.65076Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), v52 = [
  f52
];
function u52(r, e) {
  return n(), o("svg", C52, v52);
}
const EN2 = /* @__PURE__ */ i(_52, [["render", u52]]);
var w52 = {}, p52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g52 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -128)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9999 -0.000732422C7.74505 -0.000732422 4.0077 2.21378 1.87695 5.55297L18.15 22.3047C21.6536 20.2093 23.9999 16.3785 23.9999 11.9993C23.9999 5.37189 18.6273 -0.000732422 11.9999 -0.000732422Z" fill="#FFDA44"></path><path d="M23.9996 11.9991C23.9996 8.8856 22.8137 6.04928 20.8691 3.91656V20.0817C22.8137 17.949 23.9996 15.1127 23.9996 11.9991Z" fill="#0052B4"></path><path d="M14.9901 22.587L16.2471 22.5862L16.6348 21.3904L17.024 22.5857L17.6544 22.5853C18.041 22.3784 18.4149 22.1509 18.7747 21.9043L2.0948 5.22437C1.81992 5.62543 1.56923 6.04421 1.34381 6.47827L1.49203 6.93352L2.74898 6.93272L1.73255 7.67218L2.1217 8.86744L1.10433 8.12926L0.497531 8.57063C0.174047 9.65701 0 10.8077 0 11.9992C0 18.6265 5.37262 23.9992 12 23.9992C13.4012 23.9992 14.7461 23.7586 15.9961 23.317L14.9901 22.587ZM2.67652 11.4774L3.06417 10.2818L2.04689 9.54348L3.30384 9.54268L3.69155 8.34694L4.0807 9.54221L5.33766 9.54141L4.32117 10.2809L4.71033 11.4761L3.69295 10.7379L2.67652 11.4774ZM5.26519 14.0861L5.65284 12.8904L4.63556 12.1522L5.89252 12.1514L6.28022 10.9556L6.66937 12.1509L7.92633 12.1501L6.90989 12.8896L7.29905 14.0848L6.28167 13.3466L5.26519 14.0861ZM7.85381 16.6948L8.24147 15.4991L7.22419 14.7608L8.48114 14.7601L8.86884 13.5643L9.258 14.7596L10.515 14.7588L9.49851 15.4982L9.88767 16.6935L8.8703 15.9552L7.85381 16.6948ZM11.4589 18.5641L10.4424 19.3035L10.8301 18.1078L9.81281 17.3695L11.0698 17.3687L11.4575 16.173L11.8467 17.3683L13.1036 17.3675L12.0872 18.1069L12.4763 19.3022L11.4589 18.5641ZM13.0311 21.9122L13.4188 20.7165L12.4015 19.9782L13.6584 19.9774L14.0461 18.7817L14.4353 19.977L15.6922 19.9762L14.6758 20.7156L15.065 21.9109L14.0476 21.1726L13.0311 21.9122Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), $52 = [
  g52
];
function M52(r, e) {
  return n(), o("svg", p52, $52);
}
const RN2 = /* @__PURE__ */ i(w52, [["render", M52]]);
var L52 = {}, k52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, m52 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -1024)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M17.2175 1.19084C15.6399 0.427997 13.87 0.00012207 12.0001 0.00012207C10.1303 0.00012207 8.36037 0.427997 6.78274 1.19084L5.73926 12.0001L6.78274 22.8094C8.36037 23.5722 10.1303 24.0001 12.0001 24.0001C13.87 24.0001 15.6399 23.5722 17.2175 22.8094L18.261 12.0001L17.2175 1.19084Z" fill="#FFDA44"></path><path d="M6.78262 1.19128C2.76872 3.13219 0 7.24261 0 12.0001C0 16.7577 2.76872 20.8681 6.78262 22.809V1.19128Z" fill="#0052B4"></path><path d="M17.2178 1.19165V22.8094C21.2317 20.8685 24.0004 16.758 24.0004 12.0005C24.0004 7.24303 21.2317 3.13256 17.2178 1.19165Z" fill="#0052B4"></path><path d="M15.6518 7.30337L16.3518 7.65334L15.6518 7.30337L14.9518 6.9534C14.9096 7.03783 13.9956 8.8975 13.8463 11.7382H12.7822V7.30337L11.9996 6.25989L11.217 7.30337V11.7382H10.153C10.0036 8.8975 9.08966 7.03783 9.04743 6.9534L7.64746 7.65339C7.65712 7.67261 8.60835 9.60878 8.60835 12.5208V13.3034H11.217V17.7382H12.7822V13.3034H15.3909V12.5207C15.3909 11.0152 15.6514 9.77378 15.87 8.99744C16.1083 8.15087 16.3503 7.65648 16.3527 7.65156L15.6518 7.30337Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), x52 = [
  m52
];
function H52(r, e) {
  return n(), o("svg", k52, x52);
}
const UN2 = /* @__PURE__ */ i(L52, [["render", H52]]);
var V52 = {}, Z52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, B52 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -968)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D"></path><path d="M9.3912 17.2175C12.2727 17.2175 14.6086 14.8816 14.6086 12.0001C14.6086 9.11861 12.2727 6.78271 9.3912 6.78271C6.50973 6.78271 4.17383 9.11861 4.17383 12.0001C4.17383 14.8816 6.50973 17.2175 9.3912 17.2175Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), F52 = [
  B52
];
function j52(r, e) {
  return n(), o("svg", Z52, F52);
}
const NN2 = /* @__PURE__ */ i(V52, [["render", j52]]);
var I52 = {}, b52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y52 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -1136)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M16.1735 0.746513C14.8735 0.264169 13.4675 0.00012207 11.9996 0.00012207C10.5318 0.00012207 9.1257 0.264169 7.82571 0.746513L6.78223 12.0001L7.82571 23.2537C9.1257 23.7361 10.5318 24.0001 11.9996 24.0001C13.4675 24.0001 14.8735 23.7361 16.1735 23.2537L17.217 12.0001L16.1735 0.746513Z" fill="#FFDA44"></path><path d="M23.9999 11.9993C23.9999 6.83976 20.7434 2.4412 16.1738 0.745728V23.253C20.7434 21.5574 23.9999 17.1589 23.9999 11.9993Z" fill="#D80027"></path><path d="M0 12C0 17.1596 3.2565 21.5581 7.82611 23.2537V0.74646C3.2565 2.44193 0 6.84049 0 12Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), D52 = [
  y52
];
function P52(r, e) {
  return n(), o("svg", b52, D52);
}
const qN2 = /* @__PURE__ */ i(I52, [["render", P52]]);
var A52 = {}, S52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, T52 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -520)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z" fill="#D80027"></path><path d="M24 12.0007C24 18.6281 18.6274 24.0007 12 24.0007C5.37262 24.0007 0 18.6281 0 12.0007" fill="#6DA544"></path><path d="M12.0003 7.82544L12.9067 10.6153H15.8405L13.4671 12.3397L14.3736 15.1298L12.0003 13.4055L9.62697 15.1298L10.5336 12.3397L8.16016 10.6153H11.0938L12.0003 7.82544Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), O52 = [
  T52
];
function E52(r, e) {
  return n(), o("svg", S52, O52);
}
const zN2 = /* @__PURE__ */ i(A52, [["render", E52]]);
var R52 = {}, U52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, N52 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -464)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12.0007C24 10.5329 23.736 9.12676 23.2536 7.82682L12 7.30505L0.746391 7.82677C0.264047 9.12675 0 10.5329 0 12.0007C0 13.4685 0.264047 14.8747 0.746391 16.1746L12 16.6964L23.2536 16.1746C23.736 14.8747 24 13.4685 24 12.0007Z" fill="#496E2D"></path><path d="M11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738H0.746094C2.44161 20.7434 6.84012 23.9999 11.9997 23.9999Z" fill="#D80027"></path><path d="M0.746094 7.82538H23.2534C21.5578 3.25577 17.1593 -0.000732422 11.9997 -0.000732422C6.84012 -0.000732422 2.44161 3.25577 0.746094 7.82538Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), q52 = [
  N52
];
function z52(r, e) {
  return n(), o("svg", U52, q52);
}
const KN2 = /* @__PURE__ */ i(R52, [["render", z52]]);
var K52 = {}, G52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, W52 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -912)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 -0.000976562C9.59141 -0.000976562 7.34928 0.708945 5.46997 1.93018L8.55617 3.99873L4.69531 5.9987L8.55617 7.99866L4.69531 9.99863L8.55617 11.9984L4.69531 13.9983L8.55617 15.9982L4.69531 17.9984L8.55617 19.9983L5.46959 22.0675C7.349 23.289 9.59127 23.999 11.9997 23.999C18.627 23.999 23.9997 18.6264 23.9997 11.999C23.9997 5.37165 18.627 -0.000976562 11.9997 -0.000976562Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Y52 = [
  W52
];
function X52(r, e) {
  return n(), o("svg", G52, Y52);
}
const GN2 = /* @__PURE__ */ i(K52, [["render", X52]]);
var Q52 = {}, J52 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -576)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M19.3067 2.48005C15.0105 -0.82586 8.98955 -0.82586 4.69336 2.48L12 9.78669L19.3067 2.48005Z" fill="#D80027"></path><path d="M12 14.214L4.69336 21.5206C8.98955 24.8265 15.0105 24.8265 19.3067 21.5206L12 14.2139L12 14.214Z" fill="#D80027"></path><path d="M9.78705 12.0003L2.48041 4.6936C-0.8255 8.98979 -0.8255 15.0108 2.48041 19.307L9.78705 12.0003Z" fill="#6DA544"></path><path d="M14.2148 12.0003L21.5214 19.307C24.8273 15.0108 24.8273 8.98979 21.5214 4.6936L14.2148 12.0003Z" fill="#6DA544"></path><path d="M12.0006 17.2178C14.8821 17.2178 17.218 14.8819 17.218 12.0005C17.218 9.11898 14.8821 6.78308 12.0006 6.78308C9.1191 6.78308 6.7832 9.11898 6.7832 12.0005C6.7832 14.8819 9.1191 17.2178 12.0006 17.2178Z" fill="#F0F0F0"></path><path d="M12 8.34827L12.4518 9.13089H13.3555L12.9037 9.91347L13.3555 10.6961H12.4518L12 11.4787L11.5482 10.6961H10.6445L11.0964 9.91347L10.6445 9.13089H11.5482L12 8.34827Z" fill="#D80027"></path><path d="M9.70319 12.001L10.155 12.7836H11.0587L10.6068 13.5662L11.0587 14.3488H10.155L9.70319 15.1314L9.25131 14.3488H8.34766L8.79948 13.5662L8.34766 12.7836H9.25131L9.70319 12.001Z" fill="#D80027"></path><path d="M14.2969 12.001L14.7488 12.7836H15.6524L15.2006 13.5662L15.6524 14.3488H14.7488L14.2969 15.1314L13.8451 14.3488H12.9414L13.3932 13.5662L12.9414 12.7836H13.8451L14.2969 12.001Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), e82 = [
  t82
];
function r82(r, e) {
  return n(), o("svg", J52, e82);
}
const WN2 = /* @__PURE__ */ i(Q52, [["render", r82]]);
var n82 = {}, o82 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, i82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -1248)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M7.82617 10.9569L8.86966 23.587C9.86777 23.856 10.9169 24.0004 12.0001 24.0004C18.6274 24.0004 24.0001 18.6278 24.0001 12.0004L7.82617 10.9569Z" fill="#D80027"></path><path d="M7.82617 12.0001L8.86961 0.413513C9.86777 0.144497 10.9169 0.00012207 12.0001 0.00012207C18.6274 0.00012207 24.0001 5.37275 24.0001 12.0001H7.82617Z" fill="#FFDA44"></path><path d="M0 11.9997C0 17.544 3.76036 22.2093 8.86955 23.5863V0.413086C3.76036 1.79009 0 6.45537 0 11.9997Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), l82 = [
  i82
];
function s82(r, e) {
  return n(), o("svg", o82, l82);
}
const YN2 = /* @__PURE__ */ i(n82, [["render", s82]]);
var h82 = {}, a82 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, d82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -1192)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M21.4265 9.65236H17.4787C17.4787 8.932 16.8947 8.34802 16.1744 8.34802L15.1309 10.435C15.1309 10.435 16.2439 13.5654 16.2091 13.5654H17.5135C18.2339 13.5654 18.8178 12.9815 18.8178 12.2611C19.5382 12.2611 20.1221 11.6771 20.1221 10.9567H20.0787C20.799 10.9567 21.4265 10.3728 21.4265 9.65236Z" fill="#ACABB1"></path><path d="M2.57422 9.65224H6.52204C6.52204 8.93188 7.10601 8.3479 7.82637 8.3479L8.86987 10.4348C8.86987 10.4348 7.7568 13.5653 7.79161 13.5653H6.48727C5.76687 13.5653 5.18294 12.9814 5.18294 12.261C4.46253 12.261 3.8786 11.677 3.8786 10.9566H3.92204C3.20164 10.9566 2.57422 10.3726 2.57422 9.65224Z" fill="#ACABB1"></path><path d="M16.174 16.6957V17.2174H7.82621V16.6957H5.73926V18.7826H7.82621V19.3043H16.174V18.7826H18.261V16.6957H16.174Z" fill="#FFDA44"></path><path d="M7.82617 8.34851V13.5659C7.82617 16.7608 12.0001 17.7398 12.0001 17.7398C12.0001 17.7398 16.174 16.7608 16.174 13.5659V8.34851L12.0001 7.82678L7.82617 8.34851Z" fill="#0052B4"></path><path d="M16.174 10.4342H7.82617V13.5646H16.174V10.4342Z" fill="#D80027"></path><path d="M14.087 5.73881V6.52142L13.5653 6.78231L13.0436 6.26054V4.69531H10.9566V6.26054L10.4349 6.78231L9.91312 6.52142V5.73881H7.82617V8.34748H16.174V5.73881H14.087Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), c82 = [
  d82
];
function _82(r, e) {
  return n(), o("svg", a82, c82);
}
const XN2 = /* @__PURE__ */ i(h82, [["render", _82]]);
var C82 = {}, f82 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, v82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -1304)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#D80027"></path><path d="M12.0001 5.73889V9.78622L7.82617 5.73889H12.0001Z" fill="#0052B4"></path><path d="M6.26098 11.9996H9.78649L6.26098 7.30396L5.73926 10.9561L6.26098 11.9996Z" fill="#0052B4"></path><path d="M11.9688 12.0012H12.0009C12.0009 11.9904 12.0009 11.9798 12.0009 11.969C11.9902 11.9797 11.9795 11.9905 11.9688 12.0012Z" fill="#F0F0F0"></path><path d="M11.999 6.26135C11.999 4.14986 11.999 2.76635 11.999 0.000488281H11.997C5.37048 0.00161328 -0.000976562 5.37372 -0.000976562 12.0005H6.25988V8.47497L9.7854 12.0005H11.967C11.9776 11.9898 11.9883 11.9791 11.9991 11.9684C11.9991 11.1599 11.9991 10.4386 11.9991 9.78696L8.47346 6.26135H11.999Z" fill="#F0F0F0"></path><path d="M6.07027 1.56519C4.19344 2.63389 2.63311 4.19417 1.56445 6.071V12.5217H4.69491V4.69573V4.69564H12.521C12.521 3.70831 12.521 2.76772 12.521 1.56519H6.07027Z" fill="#D80027"></path><path d="M12.476 11.0002L7.73539 6.25977H6.25977V6.25986L12.4758 12.4759H12.4759C12.476 12.476 12.476 11.4584 12.476 11.0002Z" fill="#D80027"></path><path d="M13.5654 6.25989V11.999C13.5654 14.7946 20.8698 14.7946 20.8698 11.999V6.25989H13.5654Z" fill="#F3F3F3"></path><path d="M13.5654 12.0005V12.0005C13.5654 14.7961 17.2176 15.6527 17.2176 15.6527C17.2176 15.6527 20.8698 14.7961 20.8698 12.0005V12.0005H13.5654Z" fill="#6DA544"></path><path d="M17.2171 9.70447L15.5215 10.4349V12.0001L17.2171 13.0436L18.9128 12.0001V10.4349L17.2171 9.70447Z" fill="#A2001D"></path><path d="M18.9128 8.86865H15.5215V10.4339H18.9128V8.86865Z" fill="#338AF3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), u82 = [
  v82
];
function w82(r, e) {
  return n(), o("svg", f82, u82);
}
const QN2 = /* @__PURE__ */ i(C82, [["render", w82]]);
var p82 = {}, g82 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -408)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12.0002 23.9977C18.6266 23.9977 23.9984 18.6259 23.9984 11.9995C23.9984 5.37302 18.6266 0.0012207 12.0002 0.0012207C5.37375 0.0012207 0.00195312 5.37302 0.00195312 11.9995C0.00195312 18.6259 5.37375 23.9977 12.0002 23.9977Z" fill="#F0F0F0"></path><path d="M1.6094 6.00122C1.06784 6.93912 0.668365 7.91967 0.402344 8.91846L20.468 20.5034C21.2 19.7736 21.8495 18.9373 22.3909 17.9995L1.6094 6.00122Z" fill="black"></path><path d="M17.9983 1.6092C13.1974 -1.16253 7.27791 -0.238742 3.53125 3.4969L23.5969 15.0818C24.9588 9.9694 22.799 4.38098 17.9983 1.6092Z" fill="#FFDA44"></path><path d="M6.0003 22.3899C10.8011 25.1617 16.7207 24.2379 20.4673 20.5023L0.401573 8.91724C-0.960222 14.0298 1.19945 19.6182 6.0003 22.3899Z" fill="#FFDA44"></path><path d="M15.3903 10.6964C15.3903 12.569 13.8722 14.0872 11.9995 14.0872C10.1268 14.0872 8.60867 12.5691 8.60867 10.6964C8.60867 10.1125 8.75629 9.56306 9.01626 9.08337C8.28045 9.83587 7.82617 10.8649 7.82617 12.0005C7.82617 14.3054 9.6946 16.1738 11.9995 16.1738C14.3044 16.1738 16.1728 14.3054 16.1728 12.0005C16.1728 10.8649 15.7186 9.83587 14.9827 9.08337C15.2427 9.56315 15.3903 10.1125 15.3903 10.6964Z" fill="#D80027"></path><path d="M12.7828 6.78357H11.2178V14.6085H12.7828V6.78357Z" fill="#D80027"></path><path d="M14.6082 8.34827H9.3916C9.3916 8.70841 9.70534 9.00036 10.0654 9.00036H10.0437C10.0437 9.36051 10.3357 9.65245 10.6958 9.65245C10.6958 10.0126 10.9878 10.3045 11.3479 10.3045H12.652C13.0122 10.3045 13.3041 10.0126 13.3041 9.65245C13.6643 9.65245 13.9562 9.36051 13.9562 9.00036H13.9345C14.2945 9.00031 14.6082 8.70846 14.6082 8.34827Z" fill="#D80027"></path><path d="M15.6519 15.13H8.34863V16.695H15.6519V15.13Z" fill="#D80027"></path><path d="M16.6944 15.651H13.5645V17.216H16.6944V15.651Z" fill="#D80027"></path><path d="M10.4346 15.651H7.30469V17.216H10.4346V15.651Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), M82 = [
  $82
];
function L82(r, e) {
  return n(), o("svg", g82, M82);
}
const JN2 = /* @__PURE__ */ i(p82, [["render", L82]]);
var k82 = {}, m82 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -16)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12.0006C24 10.5328 23.736 9.12669 23.2536 7.82676L12 7.30499L0.746391 7.82671C0.264 9.12669 0 10.5328 0 12.0006C0 13.4685 0.264 14.8746 0.746391 16.1745L12 16.6963L23.2536 16.1746C23.736 14.8746 24 13.4685 24 12.0006Z" fill="#FFDA44"></path><path d="M11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738H0.746094C2.44161 20.7434 6.84013 23.9999 11.9997 23.9999Z" fill="#6DA544"></path><path d="M0.746094 7.82641H23.2534C21.5578 3.25681 17.1593 0.000305176 11.9997 0.000305176C6.84012 0.000305176 2.44161 3.25681 0.746094 7.82641Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), H82 = [
  x82
];
function V82(r, e) {
  return n(), o("svg", m82, H82);
}
const tq2 = /* @__PURE__ */ i(k82, [["render", V82]]);
var Z82 = {}, B82 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, F82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -1304)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12 0.000981008C11.9888 -0.00745649 -0.00318686 11.9978 6.35322e-07 12.001C6.35322e-07 5.37361 5.37262 0.000981008 12 0.000981008Z" fill="#D80027"></path><path d="M12 4.44543e-06C12.0112 -0.00843305 24.0032 11.9968 24 12C24 5.37263 18.6274 4.44543e-06 12 4.44543e-06Z" fill="#D80027"></path><path d="M12 23.9994C11.9888 24.0078 -0.00318686 12.0026 6.35322e-07 11.9994C6.35322e-07 18.6268 5.37262 23.9994 12 23.9994Z" fill="#0052B4"></path><path d="M12 23.9989C12.0112 24.0073 24.0032 12.0021 24 11.9989C24 18.6263 18.6274 23.9989 12 23.9989Z" fill="#0052B4"></path><path d="M11.9995 6.26074L13.2946 10.2465H17.4855L14.0949 12.7098L15.39 16.6956L11.9995 14.2322L8.60908 16.6956L9.90414 12.7098L6.51367 10.2465H10.7045L11.9995 6.26074Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), j82 = [
  F82
];
function I82(r, e) {
  return n(), o("svg", B82, j82);
}
const eq2 = /* @__PURE__ */ i(Z82, [["render", I82]]);
var b82 = {}, y82 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, D82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -576)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M5.2373 21.9127C7.16321 23.2292 9.49182 23.9997 12.0008 23.9997C14.5097 23.9997 16.8384 23.2292 18.7642 21.9127L12.0008 20.8693L5.2373 21.9127Z" fill="#D80027"></path><path d="M18.7642 2.08709C16.8384 0.770606 14.5097 0.00012207 12.0008 0.00012207C9.49182 0.00012207 7.16312 0.770606 5.2373 2.08709L12.0008 3.13057L18.7642 2.08709Z" fill="#D80027"></path><path d="M5.2373 21.9127C7.16321 23.2292 9.49182 23.9997 12.0008 23.9997C14.5097 23.9997 16.8384 23.2292 18.7642 21.9127L12.0008 20.8693L5.2373 21.9127Z" fill="#D80027"></path><path d="M18.7642 2.08709C16.8384 0.770606 14.5097 0.00012207 12.0008 0.00012207C9.49182 0.00012207 7.16312 0.770606 5.2373 2.08709L12.0008 3.13057L18.7642 2.08709Z" fill="#D80027"></path><path d="M23.9706 11.2165C23.6863 7.51292 21.436 3.91217 18.7646 2.08606H5.2377C2.2782 4.10923 0.27068 7.42274 0.0263672 11.2165L12.0012 11.9991L23.9706 11.2165Z" fill="#0052B4"></path><path d="M0.0253906 12.7823C0.269703 16.5761 2.27717 19.8895 5.23667 21.9127H18.7636C21.7232 19.8896 23.7306 16.5761 23.9749 12.7823L12.0002 11.9996L0.0253906 12.7823Z" fill="#0052B4"></path><path d="M23.9694 11.2173H12.7826V1.56519H11.2174V11.2173H0.0252656C0.008625 11.4761 0 11.737 0 12C0 12.2629 0.00857813 12.5238 0.0252187 12.7826H11.2174V22.4348H12.7826V12.7826H23.9748C23.9914 12.5238 24 12.2629 24 12C24 11.7389 23.9895 11.4779 23.9694 11.2173Z" fill="#D80027"></path><path d="M4.69629 11.9992L12.0006 7.4082L19.305 11.9992L12.0006 16.5903L4.69629 11.9992Z" fill="#F0F0F0"></path><path d="M7.82617 14.0872H17.2174L15.1305 10.9568L14.087 12.0003L13.0435 11.4786L12.0001 13.0438H9.91309L8.86961 12.0003L7.82617 14.0872Z" fill="#6DA544"></path><path d="M12.0004 8.8689L12.2595 9.66601H13.0975L12.4195 10.1587L12.6785 10.9559L12.0004 10.4632L11.3223 10.9559L11.5814 10.1587L10.9033 9.66601H11.7414L12.0004 8.8689Z" fill="#FFDA44"></path><path d="M12.0006 6.09656L2.60938 11.9993L12.0006 17.9021L21.392 11.9993L12.0006 6.09656ZM5.55069 11.9993L12.0006 7.94526L18.4507 11.9993L12.0006 16.0534L5.55069 11.9993Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), P82 = [
  D82
];
function A82(r, e) {
  return n(), o("svg", y82, P82);
}
const rq2 = /* @__PURE__ */ i(b82, [["render", A82]]);
var S82 = {}, T82 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -72)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M3.51534 3.51432C0.943538 6.08612 -0.216478 9.5349 0.034444 12.898L12.899 0.0334789C9.53587 -0.21749 6.08713 0.942526 3.51534 3.51432Z" fill="#FFDA44"></path><path d="M4.28516 21.1899C8.99989 25.1565 16.048 24.9219 20.4856 20.4843C24.9233 16.0467 25.1579 8.99856 21.1912 4.28387L4.28516 21.1899Z" fill="#0052B4"></path><path d="M11.957 11.5167L12.9912 10.9566L11.957 10.3964C11.7156 8.82794 10.4763 7.58861 8.90783 7.34721L8.34763 6.31305L7.78747 7.34716C6.21904 7.58857 4.97976 8.82789 4.73826 10.3964L3.7041 10.9566L4.73821 11.5167C4.97966 13.0852 6.21894 14.3246 7.78743 14.566L8.34763 15.6001L8.90778 14.566C10.4763 14.3246 11.7156 13.0852 11.957 11.5167ZM8.34768 13.0436C7.19507 13.0436 6.26071 12.1092 6.26071 10.9566C6.26071 9.80393 7.19502 8.86961 8.34768 8.86961C9.50033 8.86961 10.4346 9.80393 10.4346 10.9566C10.4346 12.1092 9.50029 13.0436 8.34768 13.0436Z" fill="black"></path><path d="M8.34767 9.39093L8.7995 10.1735H9.7032L9.25133 10.9561L9.7032 11.7388H8.7995L8.34767 12.5213L7.89584 11.7388H6.99219L7.44402 10.9561L6.99219 10.1735H7.89584L8.34767 9.39093Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), E82 = [
  O82
];
function R82(r, e) {
  return n(), o("svg", T82, E82);
}
const nq2 = /* @__PURE__ */ i(S82, [["render", R82]]);
var U82 = {}, N82 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, q82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -240)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#6DA544"></path><path d="M11.9999 4.69611L21.913 12.0004L11.9999 19.3048L2.08691 12.0004L11.9999 4.69611Z" fill="#FFDA44"></path><path d="M12.0001 16.1738C14.3052 16.1738 16.174 14.3051 16.174 11.9999C16.174 9.69476 14.3052 7.82605 12.0001 7.82605C9.69489 7.82605 7.82617 9.69476 7.82617 11.9999C7.82617 14.3051 9.69489 16.1738 12.0001 16.1738Z" fill="#F0F0F0"></path><path d="M9.91276 11.7395C9.18694 11.7395 8.48649 11.8499 7.82715 12.0547C7.85635 14.3347 9.71279 16.1743 11.9997 16.1743C13.4138 16.1743 14.6628 15.4704 15.4178 14.3945C14.1261 12.7775 12.1385 11.7395 9.91276 11.7395Z" fill="#0052B4"></path><path d="M16.0962 12.7998C16.1464 12.5409 16.1735 12.2737 16.1735 12.0001C16.1735 9.69491 14.3048 7.82623 11.9997 7.82623C10.2796 7.82623 8.80306 8.86691 8.16406 10.3528C8.72891 10.2357 9.31372 10.1741 9.91273 10.1741C12.337 10.174 14.5301 11.1817 16.0962 12.7998Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), z82 = [
  q82
];
function K82(r, e) {
  return n(), o("svg", N82, z82);
}
const oq2 = /* @__PURE__ */ i(U82, [["render", K82]]);
var G82 = {}, W82 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y82 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -856)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M7.30584 7.82513H23.2551C21.5596 3.25552 17.161 -0.000976562 12.0015 -0.000976562C8.68771 -0.000976562 5.68804 1.34241 3.5166 3.51413L7.30584 7.82513Z" fill="#338AF3"></path><path d="M7.30486 16.1725H23.2541C21.5586 20.7421 17.16 23.9986 12.0005 23.9986C8.68673 23.9986 5.68706 22.6552 3.51562 20.4835L7.30486 16.1725Z" fill="#338AF3"></path><path d="M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31374 16.6859 12 11.9996L3.51471 3.51428Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), X82 = [
  Y82
];
function Q82(r, e) {
  return n(), o("svg", W82, X82);
}
const iq2 = /* @__PURE__ */ i(G82, [["render", Q82]]);
var J82 = {}, t72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, e72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -1360)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M3.51373 20.4854C-1.17255 15.7991 -1.17255 8.20118 3.51373 3.51485C8.20002 -1.17148 15.798 -1.17143 20.4844 3.51485C20.4844 3.51649 23.6704 14.2988 18.984 18.9851C14.2978 23.6715 3.51702 20.4887 3.51373 20.4854Z" fill="#FFDA44"></path><path d="M3.51465 20.4846C8.20093 25.1709 15.7989 25.1709 20.4853 20.4846C25.1716 15.7983 25.1716 8.20036 20.4853 3.51404L3.51465 20.4846Z" fill="#FF9811"></path><path d="M18.7886 6.78192V4.69495H14.7885L14.4829 5.00052C13.3959 6.08751 13.5788 7.35557 13.7123 8.28145C13.8361 9.14034 13.8509 9.46935 13.5315 9.78881C13.2121 10.1082 12.883 10.0934 12.0242 9.96946C11.0983 9.83601 9.83032 9.65315 8.74334 10.7401C7.6564 11.827 7.83935 13.095 7.97294 14.0208C8.09684 14.8796 8.11174 15.2086 7.79243 15.5279C7.47307 15.8472 7.14396 15.8323 6.28535 15.7084C5.95057 15.6601 5.6044 15.6102 5.23484 15.6061L5.21191 17.693C5.4432 17.6955 5.70752 17.7336 5.98737 17.774C6.31868 17.8219 6.69368 17.876 7.08865 17.876C7.49796 17.876 7.92855 17.8176 8.3538 17.634V19.3037H11.4843V17.7385H9.91905V16.695H10.9625V15.1298H10.1285C10.1681 14.6235 10.0985 14.1386 10.0385 13.7229C9.91465 12.8641 9.89974 12.5351 10.2191 12.2159C10.5385 11.8965 10.8674 11.9113 11.7264 12.0351C12.401 12.1324 13.2574 12.2553 14.093 11.8946V13.5646H17.2234V11.9994H15.6582V10.9559H16.7017V9.3907H15.8678C15.9074 8.88431 15.8379 8.39948 15.7779 7.98365C15.6914 7.3836 15.658 7.04217 15.7548 6.78196H18.7886V6.78192Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), r72 = [
  e72
];
function n72(r, e) {
  return n(), o("svg", t72, r72);
}
const lq2 = /* @__PURE__ */ i(J82, [["render", n72]]);
var o72 = {}, i72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, l72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -184)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0.566625 8.34777C0.199031 9.49944 -4.68667e-05 10.7263 8.276e-09 11.9999C-4.68667e-05 13.2735 0.199031 14.5004 0.566672 15.6521L12 16.1739L23.4333 15.6521C23.8008 14.5004 24 13.2734 24 12C24 10.7264 23.8009 9.49944 23.4333 8.34777L12 7.82605L0.566625 8.34777Z" fill="#F0F0F0"></path><path d="M24 12.0005C24 11.2886 23.9377 10.5913 23.8187 9.91351H0.181313C0.0623437 10.5913 0 11.2885 0 12.0005C0 12.7124 0.0623906 13.4096 0.181313 14.0874H23.8187C23.9376 13.4096 24 12.7124 24 12.0005Z" fill="black"></path><path d="M11.9997 23.9997C17.3536 23.9997 21.8878 20.4933 23.433 15.6518H0.566406C2.11164 20.4932 6.64591 23.9996 11.9997 23.9997Z" fill="#338AF3"></path><path d="M11.9998 -0.00061035C6.64595 -0.00061035 2.11173 3.50578 0.566406 8.34712L23.433 8.34717C21.8878 3.50578 17.3536 -0.0007041 11.9998 -0.00061035Z" fill="#338AF3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), s72 = [
  l72
];
function h72(r, e) {
  return n(), o("svg", i72, s72);
}
const sq2 = /* @__PURE__ */ i(o72, [["render", h72]]);
var a72 = {}, d72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, c72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -1080)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FCFCFC"></path><path d="M4.95669 11.1289L3.65234 8.76249L4.95669 6.43323L6.26103 8.76249L4.95669 11.1289Z" fill="#A2001D"></path><path d="M2.34731 11.1289L1.04297 8.76249L2.34731 6.43323L3.65166 8.76249L2.34731 11.1289Z" fill="#A2001D"></path><path d="M4.95669 17.5643L3.65234 15.1979L4.95669 12.8687L6.26103 15.1979L4.95669 17.5643Z" fill="#A2001D"></path><path d="M2.34731 17.5643L1.04297 15.1979L2.34731 12.8687L3.65166 15.1979L2.34731 17.5643Z" fill="#A2001D"></path><path d="M6.26041 2.32875L5.89113 1.66931C5.22878 2.06175 4.60755 2.51611 4.03516 3.02442L4.95606 4.69509L6.26041 2.32875Z" fill="#A2001D"></path><path d="M4.95605 19.3042L4.02539 20.9662C4.59727 21.4752 5.21808 21.9302 5.88014 22.3235L6.26044 21.6335L4.95605 19.3042Z" fill="#A2001D"></path><path d="M7.30371 15.1306V23.0461C8.74601 23.66 10.3329 24.0002 11.9994 24.0002C17.1589 24.0002 21.5575 20.7437 23.253 16.1741L7.30371 15.1306Z" fill="#6DA544"></path><path d="M23.253 16.174C23.7354 14.874 23.9994 13.468 23.9994 12.0001C23.9994 5.37275 18.6268 0.00012207 11.9994 0.00012207C10.333 0.00012207 8.74601 0.340106 7.30371 0.953935V16.1741H23.253V16.174Z" fill="#A2001D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), _72 = [
  c72
];
function C72(r, e) {
  return n(), o("svg", d72, _72);
}
const hq2 = /* @__PURE__ */ i(a72, [["render", C72]]);
var f72 = {}, v72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, u72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -1192)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 7.8815 21.9249 4.24808 18.7635 2.08695L12 1.56519L5.23655 2.0869C2.07516 4.24808 0 7.88155 0 12C0 16.1186 2.07516 19.7519 5.23655 21.913L12 22.4348L18.7635 21.9131C21.9249 19.7519 24 16.1186 24 12Z" fill="#0052B4"></path><path d="M18.7642 2.08709C16.8384 0.77056 14.5097 0.00012207 12.0008 0.00012207C9.49187 0.00012207 7.16316 0.77056 5.2373 2.08709H18.7642Z" fill="#A2001D"></path><path d="M5.23633 21.9133C7.16214 23.2299 9.49089 24.0003 11.9998 24.0003C14.5087 24.0003 16.8374 23.2299 18.7632 21.9133H5.23633Z" fill="#A2001D"></path><path d="M12.0009 17.7382C15.1705 17.7382 17.74 15.1687 17.74 11.999C17.74 8.82939 15.1705 6.25989 12.0009 6.25989C8.83122 6.25989 6.26172 8.82939 6.26172 11.999C6.26172 15.1687 8.83122 17.7382 12.0009 17.7382Z" fill="#F0F0F0"></path><path d="M12.0003 16.6954C14.5937 16.6954 16.696 14.5931 16.696 11.9997C16.696 9.4064 14.5937 7.30408 12.0003 7.30408C9.40701 7.30408 7.30469 9.4064 7.30469 11.9997C7.30469 14.5931 9.40701 16.6954 12.0003 16.6954Z" fill="#6DA544"></path><path d="M11.9996 15.1296C13.7285 15.1296 15.13 13.728 15.13 11.9991C15.13 10.2702 13.7285 8.86865 11.9996 8.86865C10.2707 8.86865 8.86914 10.2702 8.86914 11.9991C8.86914 13.728 10.2707 15.1296 11.9996 15.1296Z" fill="#F0F0F0"></path><path d="M11.9994 11.217L10.3037 11.9997V13.304L11.9994 14.3475L13.695 13.304V11.9997L11.9994 11.217Z" fill="#0052B4"></path><path d="M13.695 10.4358H10.3037V12.001H13.695V10.4358Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), w72 = [
  u72
];
function p72(r, e) {
  return n(), o("svg", v72, w72);
}
const aq2 = /* @__PURE__ */ i(f72, [["render", p72]]);
var g72 = {}, $72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -744)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M24.0004 12.0011C24.0004 7.24352 21.2317 3.13277 17.2178 1.19177V22.8103C21.2317 20.8693 24.0004 16.7586 24.0004 12.0011Z" fill="#D80027"></path><path d="M0 12.0004C0 16.758 2.76867 20.8687 6.78262 22.8097V1.19116C2.76867 3.13216 0 7.24291 0 12.0004Z" fill="#D80027"></path><path d="M14.087 13.5663L16.174 12.5228L15.1305 12.001V10.9576L13.0435 12.001L14.087 9.91408H13.0435L12.0001 8.34888L10.9566 9.91408H9.91309L10.9566 12.001L8.86961 10.9576V12.001L7.82617 12.5228L9.91309 13.5663L9.39138 14.6097H11.4783V16.1749H12.5218V14.6097H14.6088L14.087 13.5663Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), L72 = [
  M72
];
function k72(r, e) {
  return n(), o("svg", $72, L72);
}
const dq2 = /* @__PURE__ */ i(g72, [["render", k72]]);
var m72 = {}, x72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -1136)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#6DA544"></path><path d="M18.4209 17.2178L18.7502 17.9063L19.4938 17.7345L19.1608 18.4212L19.7588 18.8954L19.0142 19.0632L19.0163 19.8265L18.4209 19.349L17.8255 19.8265L17.8275 19.0632L17.083 18.8954L17.681 18.4212L17.348 17.7345L18.0916 17.9063L18.4209 17.2178Z" fill="#FFDA44"></path><path d="M15.3574 9.91223L15.6867 10.6008L16.4304 10.4289L16.0973 11.1157L16.6953 11.5899L15.9508 11.7577L15.9528 12.5209L15.3574 12.0435L14.762 12.5209L14.764 11.7577L14.0195 11.5899L14.6175 11.1157L14.2845 10.4289L15.0281 10.6008L15.3574 9.91223Z" fill="#FFDA44"></path><path d="M18.4208 5.73828L18.7501 6.42683L19.4937 6.25489L19.1608 6.9417L19.7587 7.41594L19.0142 7.5837L19.0162 8.34697L18.4208 7.86945L17.8254 8.34697L17.8275 7.5837L17.083 7.41594L17.6809 6.9417L17.3479 6.25489L18.0915 6.42683L18.4208 5.73828Z" fill="#FFDA44"></path><path d="M21.0976 8.87012L21.4269 9.55866L22.1706 9.38677L21.8376 10.0736L22.4355 10.5478L21.691 10.7156L21.6931 11.4788L21.0976 11.0013L20.5022 11.4788L20.5042 10.7156L19.7598 10.5478L20.3578 10.0736L20.0247 9.38677L20.7683 9.55866L21.0976 8.87012Z" fill="#FFDA44"></path><path d="M19.1841 12.5211L19.4432 13.3183H20.2813L19.6032 13.811L19.8623 14.6081L19.1841 14.1155L18.506 14.6081L18.765 13.811L18.0869 13.3183H18.9251L19.1841 12.5211Z" fill="#FFDA44"></path><path d="M13.3045 15.3913C11.4315 15.3913 9.9131 13.8729 9.9131 12C9.9131 10.127 11.4314 8.60867 13.3045 8.60867C13.8884 8.60867 14.4379 8.75638 14.9177 9.0163C14.1651 8.28027 13.1359 7.82605 12 7.82605C9.69489 7.82605 7.82617 9.69477 7.82617 11.9999C7.82617 14.3051 9.69489 16.1738 12 16.1738C13.1359 16.1738 14.1651 15.7196 14.9176 14.9836C14.4379 15.2436 13.8884 15.3913 13.3045 15.3913Z" fill="#FFDA44"></path><path d="M7.54678 4.69546C7.18584 4.07184 6.51201 3.65198 5.7397 3.65198C4.96738 3.65198 4.29356 4.07184 3.93262 4.69546H7.54678Z" fill="#FFDA44"></path><path d="M7.55328 4.7074L5.73927 6.52141L3.92525 4.7074C3.75186 5.01166 3.65234 5.36355 3.65234 5.73883C3.65234 6.89144 4.5867 7.8258 5.73931 7.8258C6.89192 7.8258 7.82628 6.89149 7.82628 5.73883C7.82623 5.36355 7.72667 5.01166 7.55328 4.7074Z" fill="#FFDA44"></path><path d="M5.21777 6.00049V7.76083C5.38451 7.80372 5.55935 7.82655 5.73949 7.82655C5.91964 7.82655 6.09448 7.80367 6.26121 7.76083V6.00049H5.21777Z" fill="#A2001D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), V72 = [
  H72
];
function Z72(r, e) {
  return n(), o("svg", x72, V72);
}
const cq2 = /* @__PURE__ */ i(m72, [["render", Z72]]);
var B72 = {}, F72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -1080)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M6.50505 22.6698L15.3206 15.3194L22.6709 6.50387C21.5281 4.28913 19.716 2.47605 17.5022 1.33179L8.67967 8.67854L1.33301 17.501C2.47718 19.7149 4.29025 21.527 6.50505 22.6698Z" fill="#FFDA44"></path><path d="M20.485 20.4851C24.2709 16.6992 24.9977 11.0134 22.6669 6.49719L6.49707 22.667C11.0133 24.9978 16.6991 24.271 20.485 20.4851Z" fill="#D80027"></path><path d="M3.51436 3.51375C-0.271537 7.29965 -0.998285 12.9855 1.33248 17.5017L17.5023 1.33191C12.9861 -0.998946 7.30026 -0.272103 3.51436 3.51375Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), I72 = [
  j72
];
function b72(r, e) {
  return n(), o("svg", F72, I72);
}
const _q2 = /* @__PURE__ */ i(B72, [["render", b72]]);
var y72 = {}, D72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -296)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M22.667 6.49842C22.1125 5.42409 21.3857 4.41572 20.4852 3.51516C19.5845 2.61455 18.5761 1.88775 17.5018 1.33331L9.04798 9.04922L1.33203 17.5031C1.88652 18.5774 2.61331 19.5858 3.51387 20.4864C4.41444 21.387 5.42286 22.1138 6.49714 22.6682L14.951 14.9523L22.667 6.49842Z" fill="#FFDA44"></path><path d="M3.51455 20.4854C4.01795 20.9888 4.55509 21.4378 5.11848 21.8331L21.8334 5.11811C21.4381 4.55472 20.9892 4.01758 20.4858 3.51419C19.9824 3.0108 19.4453 2.56188 18.8819 2.16663L2.16699 18.8815C2.5622 19.4448 3.01112 19.982 3.51455 20.4854Z" fill="#D80027"></path><path d="M3.51441 3.51437C-0.271541 7.30032 -0.998338 12.9862 1.33257 17.5023L17.5024 1.33257C12.9862 -0.998286 7.30032 -0.271396 3.51441 3.51437Z" fill="#338AF3"></path><path d="M20.486 20.4851C24.2719 16.6992 24.9986 11.0133 22.6679 6.49713L6.49805 22.6669C11.0142 24.9978 16.7001 24.271 20.486 20.4851Z" fill="#338AF3"></path><path d="M6.39547 3.65118L7.043 5.64417H9.1385L7.44322 6.87586L8.09075 8.86879L6.39547 7.63706L4.70009 8.86879L5.34772 6.87586L3.65234 5.64417H5.74784L6.39547 3.65118Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), A72 = [
  P72
];
function S72(r, e) {
  return n(), o("svg", D72, A72);
}
const Cq2 = /* @__PURE__ */ i(y72, [["render", S72]]);
var T72 = {}, O72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, E72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -856)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M22.5406 6.26036C20.99 3.41837 18.3236 1.27295 15.1301 0.412231L14.6084 6.26036H22.5406Z" fill="#0052B4"></path><path d="M1.45898 6.2606H9.39117L8.86945 0.412476C5.676 1.27319 3.00966 3.41866 1.45898 6.2606Z" fill="#0052B4"></path><path d="M14.6084 12.0017V17.7408H22.5406C23.4708 16.036 23.9997 14.0806 23.9997 12.0017H14.6084Z" fill="#6DA544"></path><path d="M9.39131 12.0007H0C0 14.0796 0.528891 16.035 1.45908 17.7399H9.39127V12.0007H9.39131Z" fill="#6DA544"></path><path d="M1.45898 17.7396C3.00966 20.5816 5.676 22.727 8.86945 23.5878L9.39117 18.4733L1.45898 17.7396Z" fill="#FFDA44"></path><path d="M15.1301 23.5884C18.3236 22.7276 20.99 20.5822 22.5406 17.7402L14.6084 18.4738L15.1301 23.5884Z" fill="#FFDA44"></path><path d="M14.6084 18.4738L22.5406 17.7402H14.6084V18.4738Z" fill="#FFDA44"></path><path d="M9.39122 17.7396H1.45898L9.39122 18.4732V17.7396Z" fill="#FFDA44"></path><path d="M12.0006 0.000366211C10.9174 0.000366211 9.86827 0.144741 8.87012 0.413757V23.587C9.86827 23.856 10.9174 24.0004 12.0006 24.0004C13.0837 24.0004 14.1329 23.856 15.131 23.587V0.413757C14.1329 0.144741 13.0837 0.000366211 12.0006 0.000366211Z" fill="#D80027"></path><path d="M6.45438 2.60913L6.7781 3.60555H7.8259L6.9783 4.2214L7.30207 5.21782L6.45438 4.60202L5.60674 5.21782L5.9306 4.2214L5.08301 3.60555H6.13071L6.45438 2.60913Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), R72 = [
  E72
];
function U72(r, e) {
  return n(), o("svg", O72, R72);
}
const fq2 = /* @__PURE__ */ i(T72, [["render", U72]]);
var N72 = {}, q72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -184)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M18.26 9.91308H14.0861V5.73914H9.91217V9.91308H5.73828V14.087H9.91217V18.2609H14.0861V14.087H18.26V9.91308Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), K72 = [
  z72
];
function G72(r, e) {
  return n(), o("svg", q72, K72);
}
const vq2 = /* @__PURE__ */ i(N72, [["render", G72]]);
var W72 = {}, Y72 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, X72 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -1304)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"></path><path d="M11.9678 12.001H11.9999C11.9999 11.9902 11.9999 11.9797 11.9999 11.9689C11.9892 11.9796 11.9785 11.9903 11.9678 12.001Z" fill="#F0F0F0"></path><path d="M12 6.26184C12 4.15035 12 2.76684 12 0.000976562H11.998C5.37145 0.00210156 0 5.37421 0 12.001H6.26086V8.47546L9.78637 12.001H11.9679C11.9786 11.9903 11.9893 11.9796 12 11.9689C12 11.1604 12 10.4391 12 9.78745L8.47443 6.26184H12Z" fill="#F0F0F0"></path><path d="M6.07124 1.56458C4.19441 2.63328 2.63409 4.19356 1.56543 6.07039V11.9994H4.69588V4.69512V4.69503H12.0002C12.0002 3.7077 12.0002 2.76711 12.0002 1.56458H6.07124Z" fill="#D80027"></path><path d="M11.9999 10.5236L7.73637 6.26013H6.26074V6.26023L11.9998 11.9992H11.9999C11.9999 11.9992 11.9999 10.9817 11.9999 10.5236Z" fill="#D80027"></path><path d="M16.1747 12L16.3968 12.6833H17.1152L16.534 13.1055L16.756 13.7888L16.1747 13.3665L15.5935 13.7888L15.8155 13.1055L15.2344 12.6833H15.9527L16.1747 12Z" fill="#F0F0F0"></path><path d="M13.2229 13.223L13.863 13.5491L14.371 13.0411L14.2586 13.7507L14.8987 14.0769L14.1891 14.1892L14.0768 14.8989L13.7506 14.2587L13.041 14.3711L13.5491 13.8631L13.2229 13.223Z" fill="#F0F0F0"></path><path d="M12 16.1731L12.6833 15.9511L12.6833 15.2328L13.1055 15.8139L13.7888 15.5918L13.3665 16.1731L13.7888 16.7544L13.1055 16.5324L12.6833 17.1135V16.3952L12 16.1731Z" fill="#F0F0F0"></path><path d="M13.2229 19.1254L13.549 18.4853L13.041 17.9774L13.7506 18.0897L14.0768 17.4496L14.1891 18.1592L14.8987 18.2715L14.2586 18.5977L14.371 19.3073L13.863 18.7992L13.2229 19.1254Z" fill="#F0F0F0"></path><path d="M16.1738 20.3481L15.9518 19.6648H15.2334L15.8146 19.2426L15.5926 18.5593L16.1738 18.9816L16.7551 18.5593L16.5331 19.2426L17.1143 19.6648H16.3959L16.1738 20.3481Z" fill="#F0F0F0"></path><path d="M19.125 19.1254L18.4849 18.7994L17.977 19.3073L18.0893 18.5977L17.4492 18.2716L18.1588 18.1592L18.2712 17.4496L18.5973 18.0897L19.3069 17.9774L18.7988 18.4853L19.125 19.1254Z" fill="#F0F0F0"></path><path d="M20.3484 16.1731L19.6651 16.3952V17.1135L19.2428 16.5323L18.5596 16.7544L18.9819 16.1731L18.5596 15.5918L19.2428 15.8139L19.6651 15.2328V15.9511L20.3484 16.1731Z" fill="#F0F0F0"></path><path d="M19.125 13.223L18.799 13.8631L19.3069 14.3711L18.5973 14.2587L18.2712 14.8988L18.1588 14.1892L17.4492 14.0768L18.0893 13.7507L17.977 13.0411L18.485 13.5491L19.125 13.223Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Q72 = [
  X72
];
function J72(r, e) {
  return n(), o("svg", Y72, Q72);
}
const uq2 = /* @__PURE__ */ i(W72, [["render", J72]]);
var tt2 = {}, et2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rt2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -968)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M24 12.0003C24 18.6277 18.6274 24.0003 12 24.0003C5.37262 24.0003 0 18.6277 0 12.0003C0 5.37293 12 12.0003 12 12.0003C12 12.0003 21.0825 12.0003 24 12.0003Z" fill="#D80027"></path><path d="M0 12C0 5.37262 5.37262 0 12 0C12 4.56352 12 12 12 12C12 12 4.17389 12 0 12Z" fill="#0052B4"></path><path d="M7.14312 4.17346L7.92017 6.56493H10.4347L8.40041 8.0429L9.17741 10.4344L7.14312 8.95635L5.10884 10.4344L5.88584 8.0429L3.85156 6.56493H6.36608L7.14312 4.17346Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), nt2 = [
  rt2
];
function ot2(r, e) {
  return n(), o("svg", et2, nt2);
}
const wq2 = /* @__PURE__ */ i(tt2, [["render", ot2]]);
var it2 = {}, lt2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, st2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -688)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M17.2175 1.19108C15.6399 0.428241 13.87 0.000366211 12.0001 0.000366211C10.1303 0.000366211 8.36037 0.428241 6.78274 1.19108L5.73926 12.0004L6.78274 22.8096C8.36037 23.5725 10.1303 24.0004 12.0001 24.0004C13.87 24.0004 15.6399 23.5725 17.2175 22.8096L18.261 12.0004L17.2175 1.19108Z" fill="#D80027"></path><path d="M12 7.82544L13.0359 11.0138H16.3888L13.6764 12.9846L14.7124 16.1732L12 14.2025L9.28753 16.1732L10.3237 12.9846L7.61133 11.0138H10.964L12 7.82544Z" fill="#FFDA44"></path><path d="M6.78262 1.19165C2.76872 3.13256 0 7.24298 0 12.0005C0 16.758 2.76872 20.8685 6.78262 22.8094V1.19165Z" fill="#496E2D"></path><path d="M17.2178 1.19165V22.8094C21.2317 20.8685 24.0004 16.758 24.0004 12.0005C24.0004 7.24303 21.2317 3.13256 17.2178 1.19165Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ht2 = [
  st2
];
function at2(r, e) {
  return n(), o("svg", lt2, ht2);
}
const pq2 = /* @__PURE__ */ i(it2, [["render", at2]]);
var dt2 = {}, ct2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _t2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -1024)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M6.56719 7.30139L7.60313 10.4889H10.9547L8.24531 12.4623L9.28125 15.6498L6.56719 13.6811L3.85313 15.6498L4.89375 12.4623L2.17969 10.4889H5.53125L6.56719 7.30139Z" fill="#FFDA44"></path><path d="M14.226 18.5846L13.4338 17.6096L12.2619 18.0643L12.9416 17.0096L12.1494 16.03L13.3635 16.3534L14.0479 15.2987L14.1135 16.555L15.3322 16.8784L14.1557 17.3284L14.226 18.5846Z" fill="#FFDA44"></path><path d="M15.802 15.7253L16.177 14.5253L15.1504 13.7987L16.4066 13.78L16.777 12.58L17.1848 13.7706L18.441 13.7565L17.4332 14.5065L17.8363 15.6971L16.8098 14.9706L15.802 15.7253Z" fill="#FFDA44"></path><path d="M17.9256 8.80662L17.3725 9.9363L18.2725 10.8129L17.0303 10.6347L16.4771 11.7597L16.2615 10.5222L15.0146 10.3441L16.1303 9.75818L15.9146 8.51599L16.8146 9.39255L17.9256 8.80662Z" fill="#FFDA44"></path><path d="M14.2592 5.38501L14.1654 6.63657L15.3326 7.11001L14.1092 7.41001L14.0201 8.66626L13.3592 7.59751L12.1357 7.89751L12.9467 6.93657L12.2811 5.87251L13.4482 6.34595L14.2592 5.38501Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ct2 = [
  _t2
];
function ft2(r, e) {
  return n(), o("svg", ct2, Ct2);
}
const gq2 = /* @__PURE__ */ i(dt2, [["render", ft2]]);
var vt2 = {}, ut2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wt2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -1192)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z" fill="#FFDA44"></path><path d="M1.60547 18.0005C3.68039 21.5872 7.55808 24.0005 11.9997 24.0005C16.4414 24.0005 20.319 21.5872 22.394 18.0005L11.9997 17.2179L1.60547 18.0005Z" fill="#D80027"></path><path d="M22.3942 17.9998C23.4153 16.2347 24 14.1856 24 11.9998H0C0 14.1856 0.584719 16.2347 1.60575 17.9998H22.3942Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), pt2 = [
  wt2
];
function gt2(r, e) {
  return n(), o("svg", ut2, pt2);
}
const $q2 = /* @__PURE__ */ i(vt2, [["render", gt2]]);
var $t2 = {}, Mt2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lt2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -1360)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.2536 7.82617H0.746391C0.264047 9.12616 0 10.5322 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174H23.2537C23.736 14.874 24 13.4679 24 12.0001C24 10.5322 23.736 9.12616 23.2536 7.82617Z" fill="#D80027"></path><path d="M12.0009 -0.000488281C8.36383 -0.000488281 5.10494 1.61782 2.9043 4.1734H21.0975C18.8969 1.61782 15.638 -0.000488281 12.0009 -0.000488281Z" fill="#0052B4"></path><path d="M21.0965 19.826H2.90332C5.10396 22.3816 8.36285 23.9999 11.9999 23.9999C15.637 23.9999 18.8959 22.3816 21.0965 19.826Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), kt2 = [
  Lt2
];
function mt2(r, e) {
  return n(), o("svg", Mt2, kt2);
}
const Mq2 = /* @__PURE__ */ i($t2, [["render", mt2]]);
var xt2 = {}, Ht2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vt2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -72)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24.0001C18.6273 24.0001 23.9999 18.6275 23.9999 12.0001C23.9999 5.37274 18.6273 0.000183105 12 0.000183105C5.37256 0.000183105 0 5.37274 0 12.0001C0 18.6275 5.37256 24.0001 12 24.0001Z" fill="#F0F0F0"></path><path d="M11.9999 0.000244141C8.07405 0.000244141 4.58871 1.8857 2.39941 4.80024H21.6004C19.4111 1.88565 15.9258 0.000244141 11.9999 0.000244141Z" fill="#0052B4"></path><path d="M11.9999 24.0002C15.9258 24.0002 19.4111 22.1147 21.6004 19.2002H2.39941C4.58866 22.1148 8.07406 24.0002 11.9999 24.0002Z" fill="#0052B4"></path><path d="M0 12.0002C0 12.8222 0.0828749 13.6248 0.240328 14.4002H23.7597C23.9172 13.6248 24 12.8222 24 12.0002C24 11.1783 23.9171 10.3757 23.7597 9.60022H0.240328C0.0828749 10.3757 0 11.1783 0 12.0002Z" fill="#0052B4"></path><path d="M3.51468 3.51459C-1.17156 8.20082 -1.17156 15.7988 3.51468 20.4852C5.45122 18.5486 7.31366 16.6861 11.9999 11.9999L3.51468 3.51459Z" fill="#D80027"></path><path d="M4.85695 8.86957L5.63385 11.2609H8.14851L6.11427 12.739L6.89118 15.1303L4.85695 13.6524L2.82262 15.1303L3.59971 12.739L1.56543 11.2609H4.0799L4.85695 8.86957Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Zt2 = [
  Vt2
];
function Bt2(r, e) {
  return n(), o("svg", Ht2, Zt2);
}
const Lq2 = /* @__PURE__ */ i(xt2, [["render", Bt2]]);
var Ft2 = {}, jt2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, It2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -128)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M12 24.0007C15.9375 24.0007 19.432 22.1042 21.6201 19.1749H2.37988C4.56801 22.1042 8.06249 24.0007 12 24.0007Z" fill="#0052B4"></path><path d="M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.419 0.246984 14.7803 0.699188 16.0439H23.3008C23.753 14.7803 24 13.419 24 12Z" fill="#0052B4"></path><path d="M8.21457 7.69598L8.86205 9.68873H10.9576L9.26232 10.9205L9.9098 12.9134L8.21457 11.6817L6.51934 12.9134L7.16691 10.9205L5.47168 9.68873H7.56708L8.21457 7.69598Z" fill="#F0F0F0"></path><path d="M4.61541 5.6095L5.00391 6.80519H6.26124L5.2441 7.54422L5.6326 8.73995L4.61541 8.00092L3.59827 8.73995L3.98682 7.54422L2.96973 6.80519H4.22701L4.61541 5.6095Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), bt2 = [
  It2
];
function yt2(r, e) {
  return n(), o("svg", jt2, bt2);
}
const kq2 = /* @__PURE__ */ i(Ft2, [["render", yt2]]);
var Dt2 = {}, Pt2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, At2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -1080)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M20.4853 20.4857C15.799 25.172 8.20104 25.172 3.51472 20.4857C-1.1716 15.7995 -1.17155 8.20146 3.51472 3.51514C3.88363 3.884 13.1068 10.8936 13.1068 10.8936L20.4853 20.4857Z" fill="#0052B4"></path><path d="M3.51465 3.51422C8.20092 -1.17206 15.7989 -1.17206 20.4853 3.51422C25.1716 8.20049 25.1715 15.7985 20.4853 20.4848" fill="#6DA544"></path><path d="M12.0006 15.131C13.7295 15.131 15.131 13.7295 15.131 12.0006C15.131 10.2717 13.7295 8.87012 12.0006 8.87012C10.2717 8.87012 8.87012 10.2717 8.87012 12.0006C8.87012 13.7295 10.2717 15.131 12.0006 15.131Z" fill="#FFDA44"></path><path d="M4.46876 17.2175L4.79806 17.9061L5.54164 17.7342L5.20864 18.4209L5.80667 18.8952L5.06211 19.0629L5.06417 19.8262L4.46876 19.3487L3.87336 19.8262L3.87542 19.0629L3.13086 18.8952L3.72889 18.4209L3.39584 17.7342L4.13947 17.9061L4.46876 17.2175Z" fill="#F0F0F0"></path><path d="M2.31442 11.4769L2.64372 12.1655L3.38729 11.9935L3.05434 12.6803L3.65228 13.1546L2.90776 13.3223L2.90982 14.0856L2.31442 13.6081L1.71906 14.0856L1.72108 13.3223L0.976562 13.1546L1.57455 12.6803L1.24155 11.9935L1.98512 12.1655L2.31442 11.4769Z" fill="#F0F0F0"></path><path d="M4.46872 6.78186L4.79801 7.47041L5.54159 7.29847L5.20864 7.98528L5.80662 8.45951L5.06206 8.62728L5.06412 9.39054L4.46872 8.91307L3.87331 9.39054L3.87537 8.62728L3.13086 8.45951L3.7288 7.98528L3.3958 7.29847L4.13942 7.47041L4.46872 6.78186Z" fill="#F0F0F0"></path><path d="M7.1445 10.4346L7.47379 11.1231L8.21742 10.9512L7.88437 11.638L8.48236 12.1122L7.73784 12.28L7.73986 13.0432L7.1445 12.5658L6.54909 13.0432L6.55116 12.28L5.80664 12.1122L6.40458 11.638L6.07162 10.9512L6.8152 11.1231L7.1445 10.4346Z" fill="#F0F0F0"></path><path d="M5.23094 13.5646L5.48998 14.3617H6.3281L5.65001 14.8544L5.90904 15.6515L5.23094 15.1589L4.55285 15.6515L4.81188 14.8544L4.13379 14.3617H4.97191L5.23094 13.5646Z" fill="#F0F0F0"></path><path d="M12 14.0871H13.0434C13.0434 14.0871 13.4956 13.2872 13.0434 12.5219L14.0869 11.4784L13.5652 10.4349H13.0435C13.0435 10.4349 12.7826 11.2176 11.7391 11.2176C10.6957 11.2176 10.4348 10.4349 10.4348 10.4349H9.91309L10.4348 11.4784L9.91309 12.5219L10.4348 13.0436C10.4348 13.0436 10.9565 12.0001 12 12.5219C12 12.5219 12.4434 13.1741 12 14.0871Z" fill="#6DA544"></path><path d="M19.7888 6.57258C19.8134 6.44437 19.8265 6.31214 19.8265 6.17677C19.8265 5.24864 19.2205 4.4625 18.3828 4.19128C18.6387 4.7116 18.783 5.29678 18.783 5.91591C18.783 6.12469 18.7662 6.32953 18.7347 6.52945C18.6086 6.32634 18.4466 6.14077 18.2488 5.98331C17.5034 5.39025 16.4849 5.37455 15.7318 5.874C16.3132 6.00094 16.8754 6.25898 17.3726 6.65456C17.7618 6.96431 18.0763 7.38328 18.3172 7.78772L15.1309 8.78545C18.2613 9.30717 20.87 7.22025 20.87 7.22025C20.5809 6.64219 20.132 6.54469 19.7888 6.57258Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), St2 = [
  At2
];
function Tt2(r, e) {
  return n(), o("svg", Pt2, St2);
}
const mq2 = /* @__PURE__ */ i(Dt2, [["render", Tt2]]);
var Ot2 = {}, Et2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rt2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -184)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FCFCFC"></path><path d="M18.7829 10.4344C18.4177 10.4344 17.9655 10.4344 17.2177 10.4344C17.2177 13.316 14.8818 15.6518 12.0004 15.6518C9.1188 15.6518 6.78298 13.316 6.78298 10.4344C6.2786 10.4344 5.72205 10.4344 5.21777 10.4344C5.21777 13.5383 7.30259 16.1552 10.1484 16.9611C9.83637 17.5538 9.8839 18.3 10.3296 18.8562C10.915 18.387 11.521 17.9013 12.0351 17.4894C12.5493 17.9014 13.1553 18.387 13.7407 18.8562C14.1908 18.2945 14.2351 17.5388 13.9127 16.9432C16.7273 16.1175 18.7829 13.5162 18.7829 10.4344Z" fill="#6DA544"></path><path d="M7.82617 9.91286C7.82617 9.91286 7.82617 12.5215 10.4349 12.5215L10.9566 13.0433H12.0001C12.0001 13.0433 12.5218 11.4781 13.5653 11.4781C13.5653 11.4781 13.5653 10.4346 14.6088 10.4346C15.6522 10.4346 16.174 10.4346 16.174 10.4346C16.174 10.4346 15.6522 8.34761 18.2609 6.7824L17.2174 6.26068C17.2174 6.26068 13.5653 8.86937 10.9566 8.34765V9.39114H9.91309L9.39138 8.86942L7.82617 9.91286Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ut2 = [
  Rt2
];
function Nt2(r, e) {
  return n(), o("svg", Et2, Ut2);
}
const xq2 = /* @__PURE__ */ i(Ot2, [["render", Nt2]]);
var qt2 = {}, zt2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Kt2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -240)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M10.9565 11.9993C10.9565 11.9993 3.52168 20.4863 3.51465 20.4846C5.68618 22.6562 8.68623 23.9993 12 23.9993C18.6273 23.9993 24 18.6267 24 11.9993H10.9565Z" fill="#D80027"></path><path d="M3.51471 3.51459C-1.17157 8.20087 -1.17157 15.7989 3.51471 20.4852C5.45126 18.5487 7.31375 16.6862 12 11.9999L3.51471 3.51459Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Gt2 = [
  Kt2
];
function Wt2(r, e) {
  return n(), o("svg", zt2, Gt2);
}
const Hq2 = /* @__PURE__ */ i(qt2, [["render", Wt2]]);
var Yt2 = {}, Xt2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qt2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -128)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0.746094 16.1749C2.44161 20.7445 6.84012 24.001 11.9997 24.001C17.1593 24.001 21.5578 20.7445 23.2533 16.1749L11.9997 15.1315L0.746094 16.1749Z" fill="#FFDA44"></path><path d="M11.9997 0.000793457C6.84012 0.000793457 2.44161 3.25729 0.746094 7.8269L11.9997 8.87034L23.2533 7.82686C21.5578 3.25729 17.1593 0.000793457 11.9997 0.000793457Z" fill="black"></path><path d="M0.746391 7.82574C0.264047 9.12573 0 10.5318 0 11.9996C0 13.4675 0.264047 14.8735 0.746391 16.1735H23.2537C23.736 14.8735 24 13.4675 24 11.9996C24 10.5318 23.736 9.12573 23.2536 7.82574H0.746391Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Jt2 = [
  Qt2
];
function te2(r, e) {
  return n(), o("svg", Xt2, Jt2);
}
const Vq2 = /* @__PURE__ */ i(Yt2, [["render", te2]]);
var ee2 = {}, re2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ne2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -408)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M10.9565 13.044C10.9565 13.044 3.52168 3.51354 3.51465 3.51522C5.68618 1.34364 8.68623 0.000488281 12 0.000488281C18.6273 0.000488281 24 5.37311 24 12.0005L10.9565 13.044Z" fill="#338AF3"></path><path d="M10.9565 11.9994C10.9565 11.9994 3.52168 20.4863 3.51465 20.4847C5.68618 22.6562 8.68623 23.9994 12 23.9994C18.6273 23.9994 24 18.6268 24 11.9994H10.9565Z" fill="#6DA544"></path><path d="M3.51471 3.51465C-1.17157 8.20093 -1.17157 15.7989 3.51471 20.4853C5.45126 18.5487 7.31374 16.6862 12 12L3.51471 3.51465Z" fill="#F0F0F0"></path><path d="M4.85597 8.86938L5.63292 11.2608H8.14758L6.1133 12.7388L6.8902 15.1303L4.85597 13.6523L2.82164 15.1303L3.59873 12.7388L1.56445 11.2608H4.07892L4.85597 8.86938Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), oe2 = [
  ne2
];
function ie2(r, e) {
  return n(), o("svg", re2, oe2);
}
const Zq2 = /* @__PURE__ */ i(ee2, [["render", ie2]]);
var le2 = {}, se2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, he2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -352)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M9.39165 10.4349H23.8987C23.1317 4.54709 18.0972 0.00012207 12.0003 0.00012207C11.1043 0.00012207 10.2316 0.099169 9.3916 0.285356V10.4349H9.39165Z" fill="#D80027"></path><path d="M6.26085 10.4357V1.46002C2.96586 3.25787 0.607016 6.55557 0.101562 10.4357H6.26085V10.4357Z" fill="#D80027"></path><path d="M6.2608 13.5656H0.101562C0.607016 17.4457 2.96586 20.7434 6.26085 22.5412L6.2608 13.5656Z" fill="#D80027"></path><path d="M9.3916 13.5656V23.7151C10.2316 23.9013 11.1043 24.0003 12.0003 24.0003C18.0972 24.0003 23.1317 19.4534 23.8987 13.5656H9.3916V13.5656Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ae2 = [
  he2
];
function de2(r, e) {
  return n(), o("svg", se2, ae2);
}
const Bq2 = /* @__PURE__ */ i(le2, [["render", de2]]);
var ce2 = {}, _e2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ce2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -464)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M14.3486 23.7693C19.0925 22.8282 22.8294 19.0913 23.7705 14.3474H14.3486V23.7693Z" fill="#496E2D"></path><path d="M0.230469 14.3474C1.17148 19.0913 4.90845 22.8282 9.65234 23.7693V14.3474H0.230469Z" fill="#496E2D"></path><path d="M23.7705 9.65222C22.8294 4.90838 19.0925 1.17141 14.3486 0.230347V9.65222H23.7705Z" fill="#496E2D"></path><path d="M9.65234 0.230469C4.90845 1.17153 1.17148 4.9085 0.230469 9.65234H9.65234V0.230469Z" fill="#496E2D"></path><path d="M11.2175 14.3481H9.65234V23.77C10.1631 23.8713 10.6857 23.9399 11.2175 23.9742V14.3481Z" fill="#FFDA44"></path><path d="M11.2175 9.6528V0.0267334C10.6857 0.0609522 10.1631 0.129624 9.65234 0.230921V9.6528H11.2175Z" fill="#FFDA44"></path><path d="M12.782 0.0265977C12.5232 0.00986328 12.2624 0.000488281 11.9994 0.000488281C11.7364 0.000488281 11.4756 0.00986328 11.2168 0.0265977V9.65271H12.782V0.0265977H12.782Z" fill="black"></path><path d="M11.2168 23.9738C11.4756 23.9906 11.7364 24 11.9994 24C12.2624 24 12.5232 23.9906 12.782 23.9738V14.3478H11.2168V23.9738H11.2168Z" fill="black"></path><path d="M9.65243 11.2178V9.65259H0.230555C0.129211 10.1634 0.0605859 10.6859 0.0263672 11.2178H9.65243Z" fill="#FFDA44"></path><path d="M14.3486 11.2183H23.9747C23.9405 10.6864 23.8719 10.1639 23.7706 9.65308H14.3487V11.2183H14.3486Z" fill="#FFDA44"></path><path d="M14.3477 12.7832H23.9738C23.9904 12.5244 23.9998 12.2635 23.9998 12.0005C23.9998 11.7375 23.9904 11.4767 23.9737 11.2179H14.3477V12.7832Z" fill="black"></path><path d="M0.0261094 11.2179C0.00942187 11.4767 0 11.7375 0 12.0005C0 12.2635 0.00942187 12.5244 0.0261094 12.7832H9.65222V11.2179H0.0261094V11.2179Z" fill="black"></path><path d="M11.9999 17.7389C15.1695 17.7389 17.739 15.1694 17.739 11.9998C17.739 8.83012 15.1695 6.26062 11.9999 6.26062C8.83024 6.26062 6.26074 8.83012 6.26074 11.9998C6.26074 15.1694 8.83024 17.7389 11.9999 17.7389Z" fill="#D80027"></path><path d="M13.3075 12.6408C12.8806 11.7871 12.3258 10.9218 12.3258 10.9218C12.3258 10.9218 12.3395 10.5278 12.3395 10.293C12.3395 9.9394 12.0529 9.65271 11.6992 9.65271C11.3642 9.65271 11.0897 9.9101 11.0617 10.2378C10.7983 10.255 10.5898 10.4735 10.5898 10.7413C10.5898 10.936 10.7001 11.1047 10.8616 11.189C10.9418 11.0013 11.099 10.8548 11.2933 10.788C11.325 10.8139 11.359 10.8371 11.3953 10.8567L11.4774 10.896C11.4774 10.896 11.1732 11.7534 11.1732 12.214C11.1732 13.5088 12.027 13.9082 12.027 13.9082V13.9215L11.6001 14.3484H12.4538V13.4946L12.8807 13.9215C12.8845 13.9135 13.6893 13.4044 13.3075 12.6408Z" fill="#496E2D"></path><path d="M11.9996 7.30444L12.1938 7.90229H12.8224L12.3139 8.2718L12.5082 8.86964L11.9996 8.50018L11.491 8.86964L11.6853 8.2718L11.1768 7.90229H11.8054L11.9996 7.30444Z" fill="#496E2D"></path><path d="M9.24012 8.20183L9.74862 8.57135L10.2572 8.20178L10.063 8.79972L10.5716 9.16914L9.94292 9.16919L9.74867 9.76704L9.55437 9.16919L8.92578 9.16914L9.43433 8.79963L9.24012 8.20183Z" fill="#496E2D"></path><path d="M7.53418 10.5491H8.16273L8.35702 9.95129L8.55127 10.5491L9.17991 10.5491L8.67136 10.9187L8.86566 11.5165L8.35702 11.147L7.84848 11.5165L8.04268 10.9186L7.53418 10.5491Z" fill="#496E2D"></path><path d="M7.53418 13.4513L8.04268 13.0819L7.84843 12.484L8.35702 12.8535L8.86562 12.484L8.67137 13.0819L9.17996 13.4514L8.55127 13.4514L8.35702 14.0492L8.16273 13.4513H7.53418Z" fill="#496E2D"></path><path d="M9.24017 15.7989L9.43437 15.2012L8.92578 14.8317H9.55442L9.74872 14.2338L9.94297 14.8316H10.5716L10.063 15.2012L10.2573 15.799L9.74867 15.4295L9.24017 15.7989Z" fill="#496E2D"></path><path d="M11.9996 16.6963L11.8054 16.0986H11.1768L11.6853 15.729L11.491 15.1312L11.9996 15.5006L12.5081 15.1311L12.3139 15.729L12.8224 16.0985L12.1938 16.0986L11.9996 16.6963Z" fill="#496E2D"></path><path d="M14.7601 15.7989L14.2516 15.4295L13.7431 15.799L13.9373 15.2012L13.4287 14.8317L14.0574 14.8316L14.2516 14.2338L14.4459 14.8317H15.0745L14.5659 15.2012L14.7601 15.7989Z" fill="#496E2D"></path><path d="M16.4661 13.4514H15.8375L15.6433 14.0493L15.449 13.4515H14.8203L15.3289 13.0819L15.1346 12.4841L15.6433 12.8536L16.1518 12.4841L15.9576 13.082L16.4661 13.4514Z" fill="#496E2D"></path><path d="M16.4661 10.5491L15.9576 10.9186L16.1518 11.5164L15.6433 11.1469L15.1347 11.5165L15.3289 10.9186L14.8203 10.5491L15.449 10.549L15.6432 9.95129L15.8375 10.5491H16.4661Z" fill="#496E2D"></path><path d="M14.7601 8.20178L14.5659 8.79958L15.0745 9.1691H14.4459L14.2516 9.76699L14.0574 9.16915L13.4287 9.16919L13.9373 8.79958L13.7431 8.20183L14.2516 8.57125L14.7601 8.20178Z" fill="#496E2D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), fe2 = [
  Ce2
];
function ve2(r, e) {
  return n(), o("svg", _e2, fe2);
}
const Fq2 = /* @__PURE__ */ i(ce2, [["render", ve2]]);
var ue2 = {}, we2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pe2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -520)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M0.414062 15.1311C1.52209 19.2422 4.75914 22.4793 8.87027 23.5873V15.1311H0.414062Z" fill="#D80027"></path><path d="M8.86924 0.41333C4.75816 1.52131 1.52107 4.75841 0.413086 8.86949H8.86929V0.41333H8.86924Z" fill="#0052B4"></path><path d="M23.587 8.86973C22.479 4.75865 19.2419 1.52156 15.1309 0.413574V8.86978H23.587V8.86973Z" fill="#D80027"></path><path d="M15.1309 23.5871C19.2419 22.479 22.479 19.242 23.5871 15.1309H15.1309V23.5871Z" fill="#0052B4"></path><path d="M15.131 11.9998C15.131 13.7288 13.7295 15.1303 12.0006 15.1303C10.2717 15.1303 8.87012 13.7288 8.87012 11.9998C8.87012 10.2709 12.0006 8.86938 12.0006 8.86938C12.0006 8.86938 15.131 10.2709 15.131 11.9998Z" fill="#496E2D"></path><path d="M8.87012 11.9998C8.87012 10.2709 10.2717 8.86938 12.0006 8.86938C13.7295 8.86938 15.131 10.2709 15.131 11.9998" fill="#0052B4"></path><path d="M10.2393 10.4344V12.391C10.2393 13.3635 11.0276 14.1518 12.0001 14.1518C12.9726 14.1518 13.761 13.3635 13.761 12.391V10.4344H10.2393Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ge2 = [
  pe2
];
function $e2(r, e) {
  return n(), o("svg", we2, ge2);
}
const jq2 = /* @__PURE__ */ i(ue2, [["render", $e2]]);
var Me2 = {}, Le2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ke2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -1360)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M1.19072 6.78262C0.427875 8.36025 0 10.1301 0 12C0 13.8699 0.427875 15.6398 1.19072 17.2174L12 18.2609L22.8093 17.2174C23.5721 15.6398 24 13.8699 24 12C24 10.1301 23.5721 8.36025 22.8093 6.78262L12 5.73914L1.19072 6.78262Z" fill="#F0F0F0"></path><path d="M1.19141 17.2167C3.13231 21.2306 7.24273 23.9993 12.0003 23.9993C16.7578 23.9993 20.8682 21.2306 22.8091 17.2167H1.19141Z" fill="black"></path><path d="M1.19141 6.78287H22.8091C20.8682 2.76892 16.7578 0.000244141 12.0003 0.000244141C7.24273 0.000244141 3.13231 2.76892 1.19141 6.78287Z" fill="#D80027"></path><path d="M3.51471 3.51392C-1.17157 8.2002 -1.17157 15.7982 3.51471 20.4845C5.45126 18.548 7.31375 16.6855 12 11.9992L3.51471 3.51392Z" fill="#496E2D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), me2 = [
  ke2
];
function xe2(r, e) {
  return n(), o("svg", Le2, me2);
}
const Iq2 = /* @__PURE__ */ i(Me2, [["render", xe2]]);
var He2 = {}, Ve2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ze2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -184)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12.0008 0C18.6281 0 24.0007 5.37262 24.0007 12C24.0007 18.6274 18.6281 24 12.0008 24C12.0008 23.4783 10.4355 12 10.4355 12L12.0008 0Z" fill="#F0F0F0"></path><path d="M12 24C5.37262 24 0 18.6274 0 12C0 5.37262 5.37262 0 12 0" fill="#496E2D"></path><path d="M14.5781 9.69867L13.5936 11.0555L11.999 10.5383L12.9852 11.894L12.0007 13.2508L13.5946 12.7318L14.5808 14.0874L14.5798 12.4111L16.1738 11.8921L14.5793 11.3751L14.5781 9.69867Z" fill="#D80027"></path><path d="M12.9948 15.392C11.1219 15.392 9.60353 13.8736 9.60353 12.0007C9.60353 10.1277 11.1219 8.60935 12.9948 8.60935C13.5788 8.60935 14.1283 8.757 14.608 9.01697C13.8554 8.28099 12.8262 7.82672 11.6905 7.82672C9.38528 7.82672 7.5166 9.69544 7.5166 12.0006C7.5166 14.3058 9.38532 16.1745 11.6905 16.1745C12.8263 16.1745 13.8555 15.7202 14.608 14.9843C14.1283 15.2443 13.5788 15.392 12.9948 15.392Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Be2 = [
  Ze2
];
function Fe2(r, e) {
  return n(), o("svg", Ve2, Be2);
}
const bq2 = /* @__PURE__ */ i(He2, [["render", Fe2]]);
var je2 = {}, Ie2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, be2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -632)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z" fill="#FFDA44"></path><path d="M1.60547 18.0009C3.68039 21.5876 7.55808 24.0009 11.9997 24.0009C16.4414 24.0009 20.319 21.5876 22.394 18.0009L11.9997 17.2183L1.60547 18.0009Z" fill="#D80027"></path><path d="M22.3942 18.0002C23.4153 16.2352 24 14.1861 24 12.0002H0C0 14.1861 0.584719 16.2352 1.60575 18.0002H22.3942Z" fill="#0052B4"></path><path d="M12.0001 16.1744C14.3052 16.1744 16.174 14.3057 16.174 12.0006C16.174 9.69537 14.3052 7.82666 12.0001 7.82666C9.69489 7.82666 7.82617 9.69537 7.82617 12.0006C7.82617 14.3057 9.69489 16.1744 12.0001 16.1744Z" fill="#FFDA44"></path><path d="M12.0003 14.6092C10.5618 14.6092 9.3916 13.439 9.3916 12.0005V10.4353C9.3916 8.99689 10.5619 7.82666 12.0003 7.82666C13.4387 7.82666 14.609 8.99694 14.609 10.4353V12.0005C14.609 13.439 13.4387 14.6092 12.0003 14.6092Z" fill="#338AF3"></path><path d="M16.1741 5.74002H13.0436C13.0436 5.16374 12.5764 4.69653 12.0001 4.69653C11.4238 4.69653 10.9566 5.16374 10.9566 5.74002H7.82617C7.82617 6.31635 8.32816 6.7835 8.90439 6.7835H8.86966C8.86966 7.35983 9.33681 7.82699 9.91314 7.82699C9.91314 8.40332 10.3803 8.87047 10.9566 8.87047H13.0436C13.6199 8.87047 14.0871 8.40332 14.0871 7.82699C14.6634 7.82699 15.1306 7.35983 15.1306 6.7835H15.0958C15.6721 6.7835 16.1741 6.3163 16.1741 5.74002Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ye2 = [
  be2
];
function De2(r, e) {
  return n(), o("svg", Ie2, ye2);
}
const yq2 = /* @__PURE__ */ i(je2, [["render", De2]]);
var Pe2 = {}, Ae2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Se2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -912)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 11.9995C0 13.4673 0.264047 14.8734 0.746391 16.1734L12 16.6951L23.2536 16.1734C23.736 14.8734 24 13.4673 24 11.9995C24 10.5316 23.736 9.12558 23.2536 7.8256L12 7.30383L0.746391 7.82555C0.264047 9.12558 0 10.5316 0 11.9995Z" fill="black"></path><path d="M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z" fill="#0052B4"></path><path d="M23.2533 16.1742H0.746094C2.44161 20.7438 6.84012 24.0003 11.9997 24.0003C17.1593 24.0003 21.5578 20.7438 23.2533 16.1742Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Te2 = [
  Se2
];
function Oe2(r, e) {
  return n(), o("svg", Ae2, Te2);
}
const Dq2 = /* @__PURE__ */ i(Pe2, [["render", Oe2]]);
var Ee2 = {}, Re2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ue2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -688)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z" fill="#D80027"></path><path d="M11.9997 24.0003C17.1593 24.0003 21.5578 20.7438 23.2533 16.1742H0.746094C2.44161 20.7438 6.84012 24.0003 11.9997 24.0003Z" fill="black"></path><path d="M16.174 10.6956H13.0436C13.0436 10.1193 12.5764 9.6521 12.0001 9.6521C11.4238 9.6521 10.9566 10.1193 10.9566 10.6956H7.82617C7.82617 11.2719 8.32816 11.7391 8.90444 11.7391H8.86966C8.86966 12.3154 9.33681 12.7826 9.91314 12.7826C9.91314 13.3589 10.3803 13.826 10.9566 13.826H13.0436C13.6199 13.826 14.0871 13.3589 14.0871 12.7826C14.6634 12.7826 15.1306 12.3154 15.1306 11.7391H15.0958C15.6721 11.7391 16.174 11.2719 16.174 10.6956Z" fill="#FF9811"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ne2 = [
  Ue2
];
function qe2(r, e) {
  return n(), o("svg", Re2, Ne2);
}
const Pq2 = /* @__PURE__ */ i(Ee2, [["render", qe2]]);
var ze2 = {}, Ke2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ge2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -1416)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M1.19072 6.78189C0.427875 8.35951 0 10.1294 0 11.9993C0 13.8692 0.427875 15.639 1.19072 17.2166L12 18.2601L22.8093 17.2166C23.5721 15.639 24 13.8692 24 11.9993C24 10.1294 23.5721 8.35951 22.8093 6.78189L12 5.7384L1.19072 6.78189Z" fill="#F0F0F0"></path><path d="M1.19141 17.2178C3.13231 21.2317 7.24278 24.0004 12.0003 24.0004C16.7577 24.0004 20.8682 21.2317 22.8091 17.2178H1.19141Z" fill="#496E2D"></path><path d="M1.19141 6.78226H22.8091C20.8682 2.76831 16.7578 -0.000366211 12.0003 -0.000366211C7.24273 -0.000366211 3.13231 2.76831 1.19141 6.78226Z" fill="black"></path><path d="M3.51471 3.51501C-1.17157 8.2013 -1.17157 15.7993 3.51471 20.4856C5.45126 18.5491 7.31375 16.6866 12 12.0003L3.51471 3.51501Z" fill="#D80027"></path><path d="M15.1307 12C15.1307 10.2516 16.3594 8.79103 18.0002 8.43272C17.748 8.37764 17.4864 8.34778 17.2176 8.34778C15.2005 8.34778 13.5654 9.98287 13.5654 12C13.5654 14.017 15.2005 15.6521 17.2176 15.6521C17.4863 15.6521 17.748 15.6223 18.0002 15.5672C16.3594 15.2089 15.1307 13.7483 15.1307 12Z" fill="#D80027"></path><path d="M18.1533 9.6521L18.6714 11.2465H20.3477L18.9915 12.2317L19.5096 13.826L18.1533 12.8407L16.7972 13.826L17.3153 12.2317L15.959 11.2465H17.6353L18.1533 9.6521Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), We2 = [
  Ge2
];
function Ye2(r, e) {
  return n(), o("svg", Ke2, We2);
}
const Aq2 = /* @__PURE__ */ i(ze2, [["render", Ye2]]);
var Xe2 = {}, Qe2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Je2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -856)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M10.9565 10.9565C10.9565 10.9565 3.52168 20.487 3.51465 20.4853C5.68618 22.6569 8.68623 24 12 24C18.6273 24 24 18.6274 24 12L10.9565 10.9565Z" fill="#338AF3"></path><path d="M10.9565 11.9996C10.9565 11.9996 3.52168 3.51268 3.51465 3.51437C5.68618 1.34279 8.68623 -0.000366211 12 -0.000366211C18.6273 -0.000366211 24 5.37226 24 11.9996H10.9565Z" fill="#6DA544"></path><path d="M3.51373 3.5155C-1.17255 8.20178 -1.17255 15.7998 3.51373 20.4861C3.51341 20.4881 23.999 12.0008 23.999 12.0008L3.51373 3.5155Z" fill="#D80027"></path><path d="M6.26081 7.04321C3.95929 7.04321 2.08691 8.91563 2.08691 11.2171V12.7823C2.08691 15.0838 3.95934 16.9562 6.26081 16.9562C8.56227 16.9562 10.4347 15.0838 10.4347 12.7823V11.2171C10.4347 8.91563 8.56232 7.04321 6.26081 7.04321ZM8.86949 12.7824C8.86949 13.9482 8.10065 14.9377 7.04338 15.2709V13.565L8.15076 12.4576L7.04399 11.3508L7.04338 10.9569V10.4346H5.47823V11.9997L4.3716 13.1063L5.47823 14.2129V15.271C4.42096 14.9378 3.65212 13.9483 3.65212 12.7824V11.2172C3.65212 9.77874 4.8224 8.60851 6.26081 8.60851C7.69921 8.60851 8.86949 9.77879 8.86949 11.2172V12.7824Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), tr2 = [
  Je2
];
function er2(r, e) {
  return n(), o("svg", Qe2, tr2);
}
const Sq2 = /* @__PURE__ */ i(Xe2, [["render", er2]]);
var rr2 = {}, nr2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, or2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -1080)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 11.9992C0 13.4671 0.264047 14.8731 0.746391 16.1731L12 17.2166L23.2536 16.1731C23.736 14.8731 24 13.4671 24 11.9992C24 10.5314 23.736 9.12533 23.2536 7.82534L12 6.78186L0.746391 7.82534C0.264047 9.12533 0 10.5314 0 11.9992Z" fill="#FFDA44"></path><path d="M23.2553 7.82574C21.5597 3.25618 17.1612 -0.000366211 12.0017 -0.000366211C6.84208 -0.000366211 2.44356 3.25618 0.748047 7.82574H23.2553Z" fill="#D80027"></path><path d="M0.74707 16.174C2.44259 20.7435 6.8411 24.0001 12.0007 24.0001C17.1603 24.0001 21.5588 20.7435 23.2543 16.174H0.74707Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ir2 = [
  or2
];
function lr2(r, e) {
  return n(), o("svg", nr2, ir2);
}
const Tq2 = /* @__PURE__ */ i(rr2, [["render", lr2]]);
var sr2 = {}, hr2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ar2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -968)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 12C0 13.4679 0.264047 14.874 0.746437 16.174L12 17.2173L23.2536 16.1739C23.736 14.874 24 13.4679 24 12C24 10.5522 23.7435 9.1644 23.2737 7.87942L12 6.78259L0.726281 7.87947C0.256453 9.1644 0 10.5522 0 12Z" fill="#FFDA44"></path><path d="M11.9997 24.0003C17.1593 24.0003 21.5578 20.7438 23.2533 16.1742H0.746094C2.44161 20.7438 6.84012 24.0003 11.9997 24.0003Z" fill="#D80027"></path><path d="M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z" fill="#6DA544"></path><path d="M11.9999 17.7399C15.1695 17.7399 17.739 15.1704 17.739 12.0007C17.739 8.8311 15.1695 6.2616 11.9999 6.2616C8.83024 6.2616 6.26074 8.8311 6.26074 12.0007C6.26074 15.1704 8.83024 17.7399 11.9999 17.7399Z" fill="#0052B4"></path><path d="M11.999 7.5564L13.035 10.7449H16.393L13.6753 12.7156L14.7195 15.9136L11.999 13.9336L9.28269 15.9099L10.3227 12.7156L7.60742 10.7449H10.963L11.999 7.5564Z" fill="#FFDA44"></path><path d="M16.1308 12.7938L12.8441 11.7258L14.8753 8.93018L14.0312 8.31677L11.9999 11.1126L9.96872 8.31682L9.1245 8.93013L11.1557 11.726L7.86914 12.7938L8.19155 13.7862L11.4782 12.7184V16.1741H12.5217V12.7183L15.8082 13.7862L16.1308 12.7938Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), dr2 = [
  ar2
];
function cr2(r, e) {
  return n(), o("svg", hr2, dr2);
}
const Oq2 = /* @__PURE__ */ i(sr2, [["render", cr2]]);
var _r2 = {}, Cr2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fr2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -1192)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.8984 10.4347H9.39136H9.39131V0.285156C8.28234 0.531062 7.23098 0.929641 6.26086 1.459V10.4346V10.4347H0.101578C0.0347813 10.9471 0 11.4694 0 11.9999C0 12.5304 0.0347813 13.0528 0.101578 13.5651H6.26081H6.26086V22.5408C7.23098 23.0701 8.28234 23.4688 9.39131 23.7146V13.5653V13.5652H23.8984C23.9651 13.0528 24 12.5304 24 11.9999C24 11.4694 23.9651 10.9471 23.8984 10.4347Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), vr2 = [
  fr2
];
function ur2(r, e) {
  return n(), o("svg", Cr2, vr2);
}
const Eq2 = /* @__PURE__ */ i(_r2, [["render", ur2]]);
var wr2 = {}, pr2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gr2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -1136)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#338AF3"></path><path d="M12.0001 5.74023V9.78756L7.82617 5.74023H12.0001Z" fill="#0052B4"></path><path d="M6.26098 12.0018H9.78654L6.26098 7.30615L5.73926 10.9583L6.26098 12.0018Z" fill="#0052B4"></path><path d="M11.9678 12.0001H11.9999C11.9999 11.9893 11.9999 11.9787 11.9999 11.9679C11.9892 11.9786 11.9785 11.9894 11.9678 12.0001Z" fill="#F0F0F0"></path><path d="M12 6.26147C12 4.14999 12 2.76647 12 0.000610352H11.998C5.3715 0.00173535 0 5.37384 0 12.0006H6.26086V8.47509L9.78642 12.0006H11.968C11.9787 11.9899 11.9894 11.9792 12.0001 11.9685C12.0001 11.16 12.0001 10.4387 12.0001 9.78708L8.47443 6.26147H12Z" fill="#F0F0F0"></path><path d="M6.07124 1.5658C4.19441 2.6345 2.63413 4.19478 1.56543 6.07161V12.0006H4.69588V4.69635V4.69625H12.0002C12.0002 3.70892 12.0002 2.76833 12.0002 1.5658H6.07124Z" fill="#D80027"></path><path d="M11.9998 10.5249L7.73641 6.26147H6.26074V6.26157L11.9997 12.0006H11.9998C11.9998 12.0006 11.9998 10.983 11.9998 10.5249Z" fill="#D80027"></path><path d="M13.5654 7.82718V12.001C13.5654 14.7966 17.2176 15.6532 17.2176 15.6532C17.2176 15.6532 20.8698 14.7966 20.8698 12.001V7.82718L17.2176 6.78369L13.5654 7.82718Z" fill="#F3F3F3"></path><path d="M20.8698 7.82631V6.26111H13.5654V7.82631H16.6958V10.9568H13.5654V12.0002C13.5654 12.0002 13.5654 12.0003 13.5654 12.0003L16.6958 12.0003V15.4924C17.0107 15.6038 17.2176 15.6524 17.2176 15.6524C17.2176 15.6524 17.4244 15.6039 17.7393 15.4924V12.0003H20.8698V12.0002V10.9568H17.7393V7.82626H20.8698V7.82631Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), $r2 = [
  gr2
];
function Mr2(r, e) {
  return n(), o("svg", pr2, $r2);
}
const Rq2 = /* @__PURE__ */ i(wr2, [["render", Mr2]]);
var Lr2 = {}, kr2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mr2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -1024)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"></path><path d="M11.9678 12.0002H11.9999C11.9999 11.9894 11.9999 11.9789 11.9999 11.968C11.9892 11.9788 11.9785 11.9895 11.9678 12.0002Z" fill="#F0F0F0"></path><path d="M12 6.26074C12 4.14925 12 2.76574 12 -0.00012207H11.998C5.3715 0.00100293 0 5.37311 0 11.9999H6.26086V8.47436L9.78642 11.9999H11.9679C11.9786 11.9892 11.9893 11.9785 12 11.9678C12 11.1593 12 10.438 12 9.78635L8.47443 6.26074H12Z" fill="#F0F0F0"></path><path d="M6.07027 1.56494C4.19344 2.63364 2.63316 4.19393 1.56445 6.07075V11.9997H4.69491V4.69549V4.69539H11.9993C11.9993 3.70807 11.9993 2.76747 11.9993 1.56494H6.07027Z" fill="#D80027"></path><path d="M11.9989 10.5244L7.73544 6.26099H6.25977V6.26108L11.9988 12.0001H11.9989C11.9989 12.0001 11.9989 10.9826 11.9989 10.5244Z" fill="#D80027"></path><path d="M19.3046 14.0863V14.608H15.1307V14.0863H13.5654V16.1732H14.6089V16.695H19.8263V16.1732H20.8698V14.0863H19.3046Z" fill="#FFDA44"></path><path d="M13.5654 6.2616V12.0007C13.5654 14.7963 17.2176 15.6529 17.2176 15.6529C17.2176 15.6529 20.8698 14.7963 20.8698 12.0007V6.2616H13.5654Z" fill="#338AF3"></path><path d="M17.2174 10.5428C16.3044 10.5428 16.3044 11.3776 15.3914 11.3776C14.4784 11.3776 14.4784 10.5428 13.5654 10.5428V12.0037C14.4784 12.0037 14.4784 12.8385 15.3914 12.8385C16.3044 12.8385 16.3044 12.0037 17.2174 12.0037C18.1304 12.0037 18.1304 12.8385 19.0436 12.8385C19.9567 12.8385 19.9566 12.0037 20.8698 12.0037V10.5428C19.9567 10.5428 19.9567 11.3776 19.0436 11.3776C18.1304 11.3776 18.1304 10.5428 17.2174 10.5428Z" fill="#F3F3F3"></path><path d="M17.2174 7.61804C16.3044 7.61804 16.3044 8.45284 15.3914 8.45284C14.4784 8.45284 14.4784 7.61804 13.5654 7.61804V9.0789C14.4784 9.0789 14.4784 9.9137 15.3914 9.9137C16.3044 9.9137 16.3044 9.0789 17.2174 9.0789C18.1304 9.0789 18.1304 9.9137 19.0436 9.9137C19.9567 9.9137 19.9566 9.0789 20.8698 9.0789V7.61804C19.9567 7.61804 19.9567 8.45284 19.0436 8.45284C18.1304 8.45284 18.1304 7.61804 17.2174 7.61804Z" fill="#F3F3F3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), xr2 = [
  mr2
];
function Hr2(r, e) {
  return n(), o("svg", kr2, xr2);
}
const Uq2 = /* @__PURE__ */ i(Lr2, [["render", Hr2]]);
var Vr2 = {}, Zr2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Br2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -408)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"></path><path d="M12.001 5.21741L12.519 6.81172H14.1954L12.8392 7.79708L13.3572 9.39134L12.001 8.40603L10.6448 9.39134L11.1629 7.79708L9.80664 6.81172H11.483L12.001 5.21741Z" fill="#F0F0F0"></path><path d="M5.21777 11.9997L6.81209 11.4816V9.80518L7.79745 11.1615L9.39171 10.6434L8.4064 11.9997L9.39171 13.3558L7.79745 12.8377L6.81209 14.1939V12.5176L5.21777 11.9997Z" fill="#F0F0F0"></path><path d="M12.0011 18.7829L11.4831 17.1886H9.80664L11.1629 16.2033L10.6449 14.609L12.0011 15.5943L13.3572 14.609L12.8392 16.2033L14.1954 17.1886H12.5191L12.0011 18.7829Z" fill="#F0F0F0"></path><path d="M18.7833 11.9995L17.189 12.5176V14.1939L16.2036 12.8377L14.6094 13.3557L15.5947 11.9995L14.6094 10.6434L16.2036 11.1615L17.189 9.80518V11.4816L18.7833 11.9995Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Fr2 = [
  Br2
];
function jr2(r, e) {
  return n(), o("svg", Zr2, Fr2);
}
const Nq2 = /* @__PURE__ */ i(Vr2, [["render", jr2]]);
var Ir2 = {}, br2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, yr2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -1080)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.4781 12L23.898 10.4348C23.8283 9.90131 23.7237 9.37875 23.5865 8.86959H10.9563V0.0456543C10.4238 0.0914981 9.90139 0.172545 9.39111 0.285701L7.30414 1.5652L6.26066 1.45987C5.71151 1.7595 5.18834 2.10075 4.69545 2.47945V8.86954H0.413187C0.275984 9.3787 0.171359 9.90126 0.101609 10.4347L0.521516 12L0.101562 13.5652C0.171312 14.0987 0.275937 14.6213 0.413141 15.1304H4.69541V21.5205C5.1883 21.8993 5.71151 22.2405 6.26061 22.5401L7.82581 22.4347L9.39101 23.7142C9.90134 23.8274 10.4238 23.9084 10.9562 23.9543V15.1305H23.5863C23.7235 14.6213 23.8281 14.0987 23.8979 13.5652L23.4781 12Z" fill="#0052B4"></path><path d="M23.8984 10.4347H9.39136H9.39131V0.285156C8.28234 0.531062 7.23098 0.929641 6.26086 1.459V10.4347H0.101578C0.034875 10.9471 0 11.4694 0 11.9999C0 12.5304 0.034875 13.0528 0.101578 13.5651H6.26081H6.26086V22.5408C7.23098 23.0701 8.28234 23.4688 9.39131 23.7146V13.5653V13.5652H23.8984C23.9651 13.0528 24 12.5304 24 11.9999C24 11.4694 23.9651 10.9471 23.8984 10.4347Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Dr2 = [
  yr2
];
function Pr2(r, e) {
  return n(), o("svg", br2, Dr2);
}
const qq2 = /* @__PURE__ */ i(Ir2, [["render", Pr2]]);
var Ar2 = {}, Sr2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tr2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -1248)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.9999 11.9999C23.9999 6.84037 20.7434 2.44185 16.1738 0.746338V23.2536C20.7434 21.558 23.9999 17.1595 23.9999 11.9999Z" fill="#D80027"></path><path d="M0 12.0008C0 17.1604 3.25655 21.5589 7.82611 23.2544V0.747192C3.25655 2.44271 0 6.84122 0 12.0008Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Or2 = [
  Tr2
];
function Er2(r, e) {
  return n(), o("svg", Sr2, Or2);
}
const zq2 = /* @__PURE__ */ i(Ar2, [["render", Er2]]);
var Rr2 = {}, Ur2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nr2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -1360)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M23.2536 16.175C23.736 14.875 24 13.4689 24 12.0011C24 10.5332 23.736 9.12721 23.2536 7.82718L12 6.78369L0.746391 7.82718C0.264047 9.12721 0 10.5332 0 12.0011C0 13.4689 0.264047 14.875 0.746391 16.175L12 17.2184L23.2536 16.175Z" fill="#FFDA44"></path><path d="M12.0007 23.9997C17.1603 23.9997 21.5588 20.7432 23.2543 16.1736H0.74707C2.44263 20.7432 6.8411 23.9997 12.0007 23.9997Z" fill="#0052B4"></path><path d="M12.0007 0.000732422C6.8411 0.000732422 2.44263 3.25723 0.74707 7.82684H23.2543C21.5588 3.25723 17.1603 0.000732422 12.0007 0.000732422Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), qr2 = [
  Nr2
];
function zr2(r, e) {
  return n(), o("svg", Ur2, qr2);
}
const Kq2 = /* @__PURE__ */ i(Rr2, [["render", zr2]]);
var Kr2 = {}, Gr2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wr2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -744)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4694 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4694 23.9651 10.9471 23.8984 10.4348Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Yr2 = [
  Wr2
];
function Xr2(r, e) {
  return n(), o("svg", Gr2, Yr2);
}
const Gq2 = /* @__PURE__ */ i(Kr2, [["render", Xr2]]);
var Qr2 = {}, Jr2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tn2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -1192)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M2.48032 4.69299C1.53771 5.91938 0.826945 7.3329 0.413086 8.86848H6.6558L2.48032 4.69299Z" fill="#0052B4"></path><path d="M23.5864 8.86855C23.1725 7.33302 22.4617 5.91951 21.5191 4.69312L17.3438 8.86855H23.5864Z" fill="#0052B4"></path><path d="M0.413086 15.1302C0.826992 16.6658 1.53776 18.0793 2.48032 19.3056L6.65567 15.1302H0.413086Z" fill="#0052B4"></path><path d="M19.3053 2.47976C18.0789 1.53715 16.6655 0.826382 15.1299 0.412476V6.65515L19.3053 2.47976Z" fill="#0052B4"></path><path d="M4.69336 21.5176C5.91975 22.4602 7.33327 23.171 8.8688 23.5849V17.3423L4.69336 21.5176Z" fill="#0052B4"></path><path d="M8.86875 0.412476C7.33322 0.826382 5.9197 1.53715 4.69336 2.47971L8.86875 6.6551V0.412476Z" fill="#0052B4"></path><path d="M15.1299 23.5849C16.6654 23.171 18.0789 22.4602 19.3053 21.5177L15.1299 17.3423V23.5849Z" fill="#0052B4"></path><path d="M17.3438 15.1302L21.5191 19.3057C22.4617 18.0793 23.1725 16.6658 23.5864 15.1302H17.3438Z" fill="#0052B4"></path><path d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z" fill="#D80027"></path><path d="M15.1309 15.1313L20.4857 20.4861C20.732 20.2399 20.9669 19.9825 21.191 19.7157L16.6066 15.1312H15.1309V15.1313Z" fill="#D80027"></path><path d="M8.86951 15.1312H8.86941L3.51465 20.486C3.76084 20.7323 4.01823 20.9672 4.28504 21.1914L8.86951 16.6068V15.1312Z" fill="#D80027"></path><path d="M8.86976 8.86911V8.86902L3.51495 3.51416C3.26866 3.76035 3.03373 4.01774 2.80957 4.28455L7.39409 8.86907H8.86976V8.86911Z" fill="#D80027"></path><path d="M15.1309 8.87017L20.4857 3.51526C20.2395 3.26898 19.9821 3.03405 19.7153 2.80994L15.1309 7.39445V8.87017Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), en2 = [
  tn2
];
function rn2(r, e) {
  return n(), o("svg", Jr2, en2);
}
const Wq2 = /* @__PURE__ */ i(Qr2, [["render", rn2]]);
var nn2 = {}, on2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, in2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -408)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M5.23633 2.08691C7.16219 0.770377 9.49084 -6.10352e-05 11.9998 -6.10352e-05C14.5087 -6.10352e-05 16.8374 0.770377 18.7632 2.08691L11.9998 2.60863L5.23633 2.08691Z" fill="#A2001D"></path><path d="M12.0004 11.9995L11.2346 11.2336L11.0312 11.5979L12.0004 11.9995Z" fill="#0052B4"></path><path d="M3.51471 3.51514C-1.17157 8.20142 -1.17157 15.7994 3.51471 20.4858C5.45126 18.5492 7.31375 16.6867 12 12.0004L3.51471 3.51514Z" fill="#496E2D"></path><path d="M20.4853 3.51587C25.1716 8.20215 25.1716 15.8002 20.4853 20.4865C18.5488 18.5499 16.6863 16.6875 12 12.0012L20.4853 3.51587Z" fill="#496E2D"></path><path d="M12.0001 16.1741C14.3052 16.1741 16.174 14.3054 16.174 12.0002C16.174 9.69501 14.3052 7.82629 12.0001 7.82629C9.69489 7.82629 7.82617 9.69501 7.82617 12.0002C7.82617 14.3054 9.69489 16.1741 12.0001 16.1741Z" fill="#A2001D"></path><path d="M11.9996 7.82642L12.9352 10.7059H15.9633L13.5137 12.4859L14.4492 15.3655L11.9996 13.5859L9.54996 15.3655L10.4857 12.4859L8.03613 10.7059H11.064L11.9996 7.82642Z" fill="#FFDA44"></path><path d="M12.0043 -6.10352e-05H11.9963C8.68444 0.00101709 5.68627 1.34366 3.51562 3.51406H20.485C18.3143 1.34366 15.3161 0.00101709 12.0043 -6.10352e-05Z" fill="#A2001D"></path><path d="M3.51562 20.4857C5.68716 22.6569 8.68688 23.9998 12.0002 23.9998C15.3136 23.9998 18.3133 22.6569 20.4848 20.4857H3.51562Z" fill="#A2001D"></path><path d="M12.0006 1.3042L12.1949 1.90204H12.8235L12.315 2.27156L12.5093 2.8694L12.0006 2.49993L11.4921 2.8694L11.6864 2.27156L11.1777 1.90204H11.8063L12.0006 1.3042Z" fill="#FFDA44"></path><path d="M9.09047 1.3042L9.28477 1.90204H9.91336L9.40481 2.27156L9.59911 2.8694L9.09047 2.49993L8.58197 2.8694L8.77622 2.27156L8.26758 1.90204H8.89617L9.09047 1.3042Z" fill="#FFDA44"></path><path d="M14.9098 1.3042L15.1041 1.90204H15.7327L15.2241 2.27156L15.4184 2.8694L14.9098 2.49993L14.4013 2.8694L14.5956 2.27156L14.0869 1.90204H14.7155L14.9098 1.3042Z" fill="#FFDA44"></path><path d="M12.0006 21.1298L12.1949 21.7276H12.8235L12.315 22.0971L12.5093 22.695L12.0006 22.3254L11.4921 22.695L11.6864 22.0971L11.1777 21.7276H11.8063L12.0006 21.1298Z" fill="#FFDA44"></path><path d="M9.09047 21.1298L9.28477 21.7276H9.91336L9.40481 22.0971L9.59911 22.695L9.09047 22.3254L8.58197 22.695L8.77622 22.0971L8.26758 21.7276H8.89617L9.09047 21.1298Z" fill="#FFDA44"></path><path d="M14.9098 21.1298L15.1041 21.7276H15.7327L15.2241 22.0971L15.4184 22.695L14.9098 22.3254L14.4013 22.695L14.5956 22.0971L14.0869 21.7276H14.7155L14.9098 21.1298Z" fill="#FFDA44"></path><path d="M3.65664 11.8019C3.96484 12.2889 3.82 12.9335 3.33301 13.2417C2.84607 13.55 2.20145 13.4051 1.8932 12.9182C1.33515 12.0365 1.65873 10.5967 1.65873 10.5967C1.65873 10.5967 3.09854 10.9203 3.65664 11.8019Z" fill="#FFDA44"></path><path d="M3.05395 13.3225C3.34209 13.3225 3.57567 13.0889 3.57567 12.8008C3.57567 12.5126 3.34209 12.2791 3.05395 12.2791C2.76581 12.2791 2.53223 12.5126 2.53223 12.8008C2.53223 13.0889 2.76581 13.3225 3.05395 13.3225Z" fill="#A2001D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ln2 = [
  in2
];
function sn2(r, e) {
  return n(), o("svg", on2, ln2);
}
const Yq2 = /* @__PURE__ */ i(nn2, [["render", sn2]]);
var hn2 = {}, an2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dn2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -72)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z" fill="#D80027"></path><path d="M7.30428 5.73981V4.17456H5.73908V5.73981H4.17383V7.30501H5.73908V8.87022H7.30428V7.30501H8.86948V5.73981H7.30428Z" fill="#D80027"></path><path d="M18.2613 5.73981V4.17456H16.6961V5.73981H15.1309V7.30501H16.6961V8.87022H18.2613V7.30501H19.8265V5.73981H18.2613Z" fill="#D80027"></path><path d="M7.30428 16.6967V15.1315H5.73908V16.6967H4.17383V18.2619H5.73908V19.8271H7.30428V18.2619H8.86948V16.6967H7.30428Z" fill="#D80027"></path><path d="M18.2613 16.6967V15.1315H16.6961V16.6967H15.1309V18.2619H16.6961V19.8271H18.2613V18.2619H19.8265V16.6967H18.2613Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), cn2 = [
  dn2
];
function _n2(r, e) {
  return n(), o("svg", an2, cn2);
}
const Xq2 = /* @__PURE__ */ i(hn2, [["render", _n2]]);
var Cn2 = {}, fn2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vn2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -576)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4348H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5305 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z" fill="#D80027"></path><path d="M15.3914 12.5219L16.174 13.0437V10.9567L15.3914 11.4785H12.5218V8.60887L13.0435 7.82629H10.9566L11.4783 8.60887V11.4785H8.60875L7.82617 10.9567V13.0437L8.60875 12.5219H11.4783V15.3915L10.9566 16.1741H13.0435L12.5218 15.3915V12.5219H15.3914Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), un2 = [
  vn2
];
function wn2(r, e) {
  return n(), o("svg", fn2, un2);
}
const Qq2 = /* @__PURE__ */ i(Cn2, [["render", wn2]]);
var pn2 = {}, gn2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $n2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -184)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 11.9991C0 13.467 0.264047 14.873 0.746391 16.173L12 16.6948L23.2536 16.1731C23.736 14.873 24 13.467 24 11.9991C24 10.5313 23.736 9.12522 23.2536 7.82523L12 7.30347L0.746391 7.82519C0.264047 9.12522 0 10.5313 0 11.9991Z" fill="#FFDA44"></path><path d="M11.9997 -0.000976562C6.84012 -0.000976562 2.44161 3.25552 0.746094 7.82513H23.2534C21.5578 3.25552 17.1593 -0.000976562 11.9997 -0.000976562Z" fill="#D80027"></path><path d="M23.2533 16.1741H0.746094C2.44161 20.7436 6.84013 24.0002 11.9997 24.0002C17.1593 24.0002 21.5578 20.7436 23.2533 16.1741Z" fill="#496E2D"></path><path d="M12 7.82629L13.0359 11.0147H16.3888L13.6764 12.9855L14.7124 16.1741L12 14.2035L9.28753 16.1741L10.3237 12.9855L7.61133 11.0147H10.964L12 7.82629Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Mn2 = [
  $n2
];
function Ln2(r, e) {
  return n(), o("svg", gn2, Mn2);
}
const Jq2 = /* @__PURE__ */ i(pn2, [["render", Ln2]]);
var kn2 = {}, mn2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xn2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -240)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F9F9F9"></path><path d="M11.9997 24.0007C17.1593 24.0007 21.5578 20.7442 23.2533 16.1746H0.746094C2.44166 20.7442 6.84012 24.0007 11.9997 24.0007Z" fill="#D80027"></path><path d="M16.6955 9.91359V8.34839H17.2173V7.30491H16.1738V7.82667H15.1303V7.30491H14.0869V8.34839H14.6086V9.91359H13.5651V6.26152H14.0869V5.21808H13.0434V5.7397H12.5216V5.21808H11.4782V5.7397H10.9564V5.21808H9.91292V6.26152H10.4347V9.91359H9.3912V8.34839H9.91292V7.30491H8.86943V7.82667H7.82599V7.30491H6.78251V8.34839H7.30423V9.91359H6.26074V14.0875H17.739V9.91359H16.6955Z" fill="#D80027"></path><path d="M12 13.5651C11.1356 13.5651 10.4348 14.2659 10.4348 15.1303C10.4348 15.8117 10.8705 16.3913 11.4783 16.6061V18.7826H9.91309V20.8695H12.5218V16.6062C13.1296 16.3913 13.5653 15.8118 13.5653 15.1304C13.5652 14.266 12.8644 13.5651 12 13.5651ZM12 15.6521C11.7119 15.6521 11.4783 15.4185 11.4783 15.1304C11.4783 14.8422 11.7119 14.6087 12 14.6087C12.2881 14.6087 12.5217 14.8422 12.5217 15.1304C12.5217 15.4185 12.2881 15.6521 12 15.6521Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Hn2 = [
  xn2
];
function Vn2(r, e) {
  return n(), o("svg", mn2, Hn2);
}
const tz2 = /* @__PURE__ */ i(kn2, [["render", Vn2]]);
var Zn2 = {}, Bn2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fn2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -352)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z" fill="#F0F0F0"></path><path d="M24 12.0004C24 18.6278 18.6274 24.0004 12 24.0004C5.37262 24.0004 0 18.6278 0 12.0004" fill="#D80027"></path><path d="M8.34754 17.7397C11.5172 17.7397 14.0867 15.1702 14.0867 12.0006C14.0867 8.83091 11.5172 6.26141 8.34754 6.26141C5.1779 6.26141 2.6084 8.83091 2.6084 12.0006C2.6084 15.1702 5.1779 17.7397 8.34754 17.7397Z" fill="#F0F0F0"></path><path d="M2.6084 12.0006C2.6084 8.83101 5.1779 6.26141 8.34754 6.26141C11.5172 6.26141 14.0867 8.83096 14.0867 12.0006" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), jn2 = [
  Fn2
];
function In2(r, e) {
  return n(), o("svg", Bn2, jn2);
}
const ez2 = /* @__PURE__ */ i(Zn2, [["render", In2]]);
var bn2 = {}, yn2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Dn2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -16)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12.0003 0.000793457C7.03927 0.000793457 2.78171 3.01139 0.954102 7.30514H23.0465C21.2189 3.01139 16.9613 0.000793457 12.0003 0.000793457Z" fill="#A2001D"></path><path d="M12.0003 24.0007C16.9613 24.0007 21.2189 20.9901 23.0465 16.6964H0.954102C2.78171 20.9901 7.03927 24.0007 12.0003 24.0007Z" fill="#496E2D"></path><path d="M23.5866 8.86963H0.413391C0.144375 9.86774 0 10.9169 0 12.0001C0 13.0832 0.144375 14.1324 0.413391 15.1305H23.5867C23.8556 14.1324 24 13.0832 24 12.0001C24 10.9169 23.8556 9.86774 23.5866 8.86963Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Pn2 = [
  Dn2
];
function An2(r, e) {
  return n(), o("svg", yn2, Pn2);
}
const rz2 = /* @__PURE__ */ i(bn2, [["render", An2]]);
var Sn2 = {}, Tn2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, On2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -688)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M16.1743 0.746315C14.8742 0.263925 13.4681 -0.00012207 12.0002 -0.00012207C10.5325 -0.00012207 9.12639 0.263925 7.82645 0.746222L7.30469 11.9999L7.82641 23.2535C9.12639 23.7359 10.5325 23.9999 12.0002 23.9999C13.4682 23.9999 14.8742 23.7359 16.1743 23.2534L16.696 11.9999L16.1743 0.746315Z" fill="#FFDA44"></path><path d="M0 12.0004C0 17.1599 3.2565 21.5585 7.82611 23.2539V0.746704C3.2565 2.44227 0 6.84073 0 12.0004Z" fill="#D80027"></path><path d="M23.9999 12.0004C23.9999 6.84073 20.7434 2.44227 16.1738 0.746704V23.254C20.7434 21.5585 23.9999 17.1599 23.9999 12.0004Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), En2 = [
  On2
];
function Rn2(r, e) {
  return n(), o("svg", Tn2, En2);
}
const nz2 = /* @__PURE__ */ i(Sn2, [["render", Rn2]]);
var Un2 = {}, Nn2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qn2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -800)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M7.30486 7.82574H23.2541C21.5586 3.25613 17.16 -0.000366211 12.0005 -0.000366211C8.68673 -0.000366211 5.68706 1.34302 3.51562 3.51474L7.30486 7.82574Z" fill="#6DA544"></path><path d="M7.30486 16.1742H23.2541C21.5586 20.7438 17.16 24.0003 12.0005 24.0003C8.68673 24.0003 5.68706 22.6569 3.51562 20.4852L7.30486 16.1742Z" fill="#D80027"></path><path d="M3.51471 3.5155C-1.17157 8.20178 -1.17157 15.7998 3.51471 20.4861C5.45126 18.5496 7.31375 16.6871 12 12.0008L3.51471 3.5155Z" fill="#0052B4"></path><path d="M14.0869 9.91272V12.5214C14.0869 14.1189 16.1739 14.6084 16.1739 14.6084C16.1739 14.6084 18.2609 14.1189 18.2609 12.5214V9.91272H14.0869Z" fill="#DEDDE0"></path><path d="M16.6958 12.0524H15.6523V13.5654H16.6958V12.0524Z" fill="#786145"></path><path d="M17.2171 11.4788C17.2171 10.9025 16.7499 10.4353 16.1736 10.4353C15.5973 10.4353 15.1301 10.9025 15.1301 11.4788C14.842 11.4788 14.6084 11.7124 14.6084 12.0005C14.6084 12.2887 14.842 12.5222 15.1301 12.5222C15.3012 12.5222 17.046 12.5222 17.2171 12.5222C17.5052 12.5222 17.7388 12.2887 17.7388 12.0005C17.7388 11.7124 17.5053 11.4788 17.2171 11.4788Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), zn2 = [
  qn2
];
function Kn2(r, e) {
  return n(), o("svg", Nn2, zn2);
}
const oz2 = /* @__PURE__ */ i(Un2, [["render", Kn2]]);
var Gn2 = {}, Wn2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yn2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -296)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12 8.87002H23.5866C23.2857 7.75373 22.8284 6.70181 22.2387 5.73956H12V8.87002Z" fill="#338AF3"></path><path d="M4.53058 21.3914H19.4702C20.5654 20.5191 21.5046 19.4597 22.2391 18.2609H1.76172C2.4963 19.4596 3.43548 20.5191 4.53058 21.3914Z" fill="#338AF3"></path><path d="M4.17433 2.90375C3.23092 3.71614 2.41534 4.67281 1.76172 5.7395H4.17433V2.90375Z" fill="#338AF3"></path><path d="M12 12C12 10.7776 12 9.75469 12 8.86951H7.30434V12H4.17389V8.86951H0.413391C0.144375 9.86766 0 10.9168 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1304H23.5867C23.8556 14.1323 24 13.0831 24 12H12Z" fill="#338AF3"></path><path d="M12.0003 0.000671387C10.334 0.000671387 8.74703 0.340656 7.30469 0.954484V5.73981H12.0003C12.0003 4.64706 12.0003 3.71767 12.0003 2.60936H19.4702C17.4203 0.976796 14.8245 0.000671387 12.0003 0.000671387Z" fill="#338AF3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Xn2 = [
  Yn2
];
function Qn2(r, e) {
  return n(), o("svg", Wn2, Xn2);
}
const iz2 = /* @__PURE__ */ i(Gn2, [["render", Qn2]]);
var Jn2 = {}, to2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eo2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -520)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.9994 12.0002C23.9994 7.24267 21.2307 3.13192 17.2168 1.19092V22.8094C21.2307 20.8685 23.9994 16.7577 23.9994 12.0002Z" fill="#338AF3"></path><path d="M0 12.0001C0 16.7576 2.76867 20.8684 6.78262 22.8094V1.1908C2.76867 3.1318 0 7.24255 0 12.0001Z" fill="#338AF3"></path><path d="M15.135 14.0284L13.106 11.9994L15.0374 10.0679L14.9499 9.04778L14.3969 8.49475L11.9992 10.8925L9.60142 8.49475L9.04848 9.04778L8.96097 10.0679L10.8924 11.9994L8.86328 14.0284L9.97009 15.1351L11.9992 13.1061L14.0282 15.1351L15.135 14.0284Z" fill="#ACABB1"></path><path d="M14.9515 9.04895L13.8447 10.1557C14.3168 10.6278 14.6088 11.28 14.6088 12.0003C14.6088 13.4411 13.4408 14.609 12.0001 14.609C10.5594 14.609 9.39138 13.4411 9.39138 12.0003C9.39138 11.28 9.68341 10.6278 10.1555 10.1557L9.04872 9.04895C8.29333 9.8042 7.82617 10.8477 7.82617 12.0003C7.82617 14.3056 9.69489 16.1742 12.0001 16.1742C14.3052 16.1742 16.174 14.3055 16.174 12.0003C16.174 10.8477 15.7068 9.80425 14.9515 9.04895Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ro2 = [
  eo2
];
function no2(r, e) {
  return n(), o("svg", to2, ro2);
}
const lz2 = /* @__PURE__ */ i(Jn2, [["render", no2]]);
var oo2 = {}, io2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lo2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -464)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M5.23633 21.9123C7.16214 23.2288 9.49089 23.9992 11.9998 23.9992C14.5087 23.9992 16.8374 23.2288 18.7632 21.9123L11.9998 20.8688L5.23633 21.9123Z" fill="#D80027"></path><path d="M18.7642 2.08685C16.8383 0.770362 14.5096 -0.00012207 12.0008 -0.00012207C9.49187 -0.00012207 7.16312 0.770362 5.2373 2.08685L12.0008 3.13033L18.7642 2.08685Z" fill="#D80027"></path><path d="M24 12.0004C24 8.02965 21.6227 4.042 18.7635 2.0874H5.23655C2.07516 4.24853 0 7.882 0 12.0004C0 16.119 2.07516 19.7523 5.23655 21.9135H18.7635C21.9249 19.7523 24 16.119 24 12.0004Z" fill="#0052B4"></path><path d="M11.3213 19.5748C11.1573 19.4342 7.30469 16.0851 7.30469 12C7.30469 7.91486 11.1573 4.56569 11.3213 4.42511L12.0003 3.84302L12.6794 4.42506C12.8434 4.56569 16.696 7.91481 16.696 12C16.696 16.0851 12.8434 19.4343 12.6794 19.5748L12.0003 20.1569L11.3213 19.5748Z" fill="#D80027"></path><path d="M15.652 12C15.652 8.34786 11.9998 5.21741 11.9998 5.21741C11.9998 5.21741 8.34766 8.34795 8.34766 12C8.34766 13.1173 8.6897 14.1855 9.16417 15.1305H14.8355C15.31 14.1855 15.652 13.1173 15.652 12Z" fill="#338AF3"></path><path d="M15.652 12.0005C15.652 13.1178 15.31 14.186 14.8355 15.1309L11.9998 15.6527L9.16417 15.1309C8.6897 14.186 8.34766 13.1178 8.34766 12.0005H15.652Z" fill="#0052B4"></path><path d="M11.9997 18.7824C11.9997 18.7824 13.7588 17.2741 14.8354 15.1302H9.16406C10.2406 17.2741 11.9997 18.7824 11.9997 18.7824Z" fill="#FFDA44"></path><path d="M9.65137 9.9126H14.347L11.9992 12.2604L9.65137 9.9126Z" fill="#6DA544"></path><path d="M12.783 11.4773H11.2178V16.173H12.783V11.4773Z" fill="#A2001D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), so2 = [
  lo2
];
function ho2(r, e) {
  return n(), o("svg", io2, so2);
}
const sz2 = /* @__PURE__ */ i(oo2, [["render", ho2]]);
var ao2 = {}, do2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, co2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -632)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12.0001 -0.00012207C10.917 -0.00012207 9.86772 0.144253 8.86961 0.413269L7.82617 11.9999L8.86966 23.5865C9.86772 23.8555 10.917 23.9999 12.0001 23.9999C18.6274 23.9999 24.0001 18.6273 24.0001 11.9999C24.0001 5.3725 18.6274 -0.00012207 12.0001 -0.00012207Z" fill="#FFDA44"></path><path d="M7.82617 12.0005L8.86966 23.5871C9.86772 23.8561 10.917 24.0005 12.0001 24.0005C18.6274 24.0005 24.0001 18.6279 24.0001 12.0005H7.82617Z" fill="#6DA544"></path><path d="M0 11.9994C0 16.5479 2.53078 20.5051 6.26086 22.5403V1.4585C2.53078 3.49372 0 7.4509 0 11.9994Z" fill="#D80027"></path><path d="M0 11.9995C0 17.5438 3.76036 22.2091 8.86955 23.5861V0.412842C3.76036 1.78984 0 6.45512 0 11.9995Z" fill="#D80027"></path><path d="M4.53468 8.86841L5.31163 11.2598H7.82629L5.79201 12.7378L6.56891 15.1293L4.53468 13.6513L2.50035 15.1293L3.27745 12.7378L1.24316 11.2598H3.75768L4.53468 8.86841Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), _o2 = [
  co2
];
function Co2(r, e) {
  return n(), o("svg", do2, _o2);
}
const hz2 = /* @__PURE__ */ i(ao2, [["render", Co2]]);
var fo2 = {}, vo2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uo2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -744)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 -0.000976562C9.87813 -0.000976562 7.88556 0.550367 6.15625 1.51646V22.4816C7.88561 23.4477 9.87813 23.999 11.9997 23.999C18.6271 23.999 23.9997 18.6264 23.9997 11.999C23.9997 5.37165 18.6271 -0.000976562 11.9997 -0.000976562Z" fill="#6DA544"></path><path d="M6.19178 1.49817C5.43686 1.91653 4.73195 2.41378 4.08794 2.97909C4.15305 2.922 4.21881 2.86556 4.28509 2.80987L13.4756 12.0005L4.28505 21.1911C4.21872 21.1354 4.153 21.0789 4.08789 21.0218C4.73191 21.5872 5.43686 22.0844 6.19173 22.5028L24 12.0005L6.19178 1.49817Z" fill="#F0F0F0"></path><path d="M5.17837 2.12695C4.81241 2.38036 4.46095 2.65303 4.12602 2.94445L12.0001 11.9997L4.12598 21.0549C4.4609 21.3463 4.81237 21.619 5.17832 21.8724L21.9459 11.9997L5.17837 2.12695Z" fill="#FFDA44"></path><path d="M4.28504 2.80981C4.01827 3.03397 3.76084 3.26896 3.51465 3.5151L10.9565 12.0004L3.51465 20.4857C3.76084 20.7319 4.01823 20.9669 4.28504 21.191L13.4756 12.0004L4.28504 2.80981Z" fill="black"></path><path d="M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31375 16.6859 12 11.9996L3.51471 3.51428Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), wo2 = [
  uo2
];
function po2(r, e) {
  return n(), o("svg", vo2, wo2);
}
const az2 = /* @__PURE__ */ i(fo2, [["render", po2]]);
var go2 = {}, $o2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mo2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -912)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M13.2387 9.07752C12.966 10.2118 12.4815 9.99552 12.2437 10.9848C10.8429 10.648 9.98021 9.23938 10.317 7.83852C10.6537 6.43775 12.0624 5.57506 13.4632 5.91186C12.9876 7.89031 13.4827 8.063 13.2387 9.07752Z" fill="#F0F0F0"></path><path d="M9.60395 9.91749C10.5985 10.5273 10.243 10.9214 11.1103 11.4533C10.3571 12.6815 8.75092 13.0665 7.5227 12.3134C6.29453 11.5603 5.90936 9.954 6.66255 8.72583C8.3972 9.78952 8.71431 9.372 9.60395 9.91749Z" fill="#F0F0F0"></path><path d="M9.27946 13.6349C10.1668 12.8775 10.4316 13.3373 11.2055 12.6769C12.1409 13.7727 12.0108 15.4193 10.915 16.3547C9.81918 17.2901 8.17255 17.1598 7.2373 16.0641C8.78483 14.743 8.48573 14.3123 9.27946 13.6349Z" fill="#F0F0F0"></path><path d="M12.7145 15.0914C12.2683 14.0135 12.7875 13.9036 12.3984 12.9636C13.7296 12.4127 15.2555 13.0452 15.8065 14.3764C16.3574 15.7076 15.7248 17.2334 14.3936 17.7844C13.6156 15.9043 13.1136 16.0557 12.7145 15.0914Z" fill="#F0F0F0"></path><path d="M15.1618 12.2739C13.9987 12.3652 14.0545 11.8374 13.0403 11.917C12.9277 10.4808 14.0009 9.22495 15.4372 9.11222C16.8734 8.99976 18.1292 10.0728 18.2418 11.5092C16.2132 11.6682 16.202 12.1924 15.1618 12.2739Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Lo2 = [
  Mo2
];
function ko2(r, e) {
  return n(), o("svg", $o2, Lo2);
}
const dz2 = /* @__PURE__ */ i(go2, [["render", ko2]]);
var mo2 = {}, xo2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ho2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -856)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 23.9987C16.7572 23.9987 20.868 21.23 22.809 17.2161H1.19043C3.13143 21.23 7.24218 23.9987 11.9997 23.9987Z" fill="#338AF3"></path><path d="M12.0007 -0.000976562C7.24316 -0.000976562 3.13241 2.7677 1.19141 6.78165H22.8099C20.869 2.7677 16.7582 -0.000976562 12.0007 -0.000976562Z" fill="#338AF3"></path><path d="M7.38504 7.82446L7.77354 9.0202H9.03077L8.01368 9.75913L8.40223 10.9549L7.38504 10.2159L6.36785 10.9549L6.7564 9.75913L5.73926 9.0202H6.99649L7.38504 7.82446Z" fill="#338AF3"></path><path d="M7.38504 13.0425L7.77354 14.2383H9.03077L8.01368 14.9772L8.40223 16.1729L7.38504 15.4339L6.36785 16.1729L6.7564 14.9772L5.73926 14.2383H6.99649L7.38504 13.0425Z" fill="#338AF3"></path><path d="M16.6145 7.82446L17.0031 9.0202H18.2603L17.2432 9.75913L17.6317 10.9549L16.6145 10.2159L15.5973 10.9549L15.9859 9.75913L14.9688 9.0202H16.226L16.6145 7.82446Z" fill="#338AF3"></path><path d="M16.6145 13.0425L17.0031 14.2383H18.2603L17.2432 14.9772L17.6317 16.1729L16.6145 15.4339L15.5973 16.1729L15.9859 14.9772L14.9688 14.2383H16.226L16.6145 13.0425Z" fill="#338AF3"></path><path d="M11.9993 10.4333L12.3878 11.6291H13.6451L12.6279 12.3681L13.0165 13.5638L11.9993 12.8248L10.9821 13.5638L11.3707 12.3681L10.3535 11.6291H11.6107L11.9993 10.4333Z" fill="#338AF3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Vo2 = [
  Ho2
];
function Zo2(r, e) {
  return n(), o("svg", xo2, Vo2);
}
const cz2 = /* @__PURE__ */ i(mo2, [["render", Zo2]]);
var Bo2 = {}, Fo2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jo2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -16)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 10.5321 23.736 9.12602 23.2536 7.82609L12 7.30432L0.746391 7.82604C0.264047 9.12602 0 10.5321 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739L12 16.6956L23.2536 16.1739C23.736 14.8739 24 13.4678 24 12Z" fill="#F0F0F0"></path><path d="M11.9997 23.9995C17.1593 23.9995 21.5578 20.743 23.2533 16.1733H0.746094C2.44161 20.743 6.84013 23.9995 11.9997 23.9995Z" fill="#0052B4"></path><path d="M0.746094 7.82666H23.2534C21.5578 3.25705 17.1593 0.000549316 11.9997 0.000549316C6.84012 0.000549316 2.44161 3.25705 0.746094 7.82666Z" fill="#D80027"></path><path d="M15.1309 8.34753H13.0439L13.3918 5.7388L14.7831 4.69531L16.1743 5.7388V7.82576L15.1309 8.34753Z" fill="#338AF3"></path><path d="M8.86961 8.34802H10.9566L10.6087 5.73928L9.21742 4.6958L7.82617 5.73928V7.82625L8.86961 8.34802Z" fill="#338AF3"></path><path d="M13.3911 8.34777H10.6084V5.73904L11.9997 4.69556L13.3911 5.73904V8.34777Z" fill="#0052B4"></path><path d="M7.82617 7.82574V13.5648C7.82617 14.9314 8.48627 16.1467 9.50439 16.9085L10.2348 16.7258L11.1566 17.653C11.4292 17.7092 11.7112 17.7388 12.0001 17.7388C12.2875 17.7388 12.5681 17.7096 12.8392 17.654L13.8914 16.7779L14.4957 16.9068C15.5134 16.145 16.174 14.931 16.174 13.5648V7.82574H7.82617Z" fill="#F0F0F0"></path><path d="M9.49572 7.82593H7.82617V9.49548H9.49572V7.82593Z" fill="#D80027"></path><path d="M12.8346 7.82593H11.165V9.49548H12.8346V7.82593Z" fill="#D80027"></path><path d="M16.1744 7.82593H14.5049V9.49548H16.1744V7.82593Z" fill="#D80027"></path><path d="M11.1647 9.495H9.49512V11.1645H11.1647V9.495Z" fill="#D80027"></path><path d="M14.5045 9.495H12.835V11.1645H14.5045V9.495Z" fill="#D80027"></path><path d="M9.49572 11.1638H7.82617V12.8334H9.49572V11.1638Z" fill="#D80027"></path><path d="M11.1647 12.8347H9.49512V14.5042H11.1647V12.8347Z" fill="#D80027"></path><path d="M12.8346 11.1638H11.165V12.8334H12.8346V11.1638Z" fill="#D80027"></path><path d="M16.1744 11.1638H14.5049V12.8334H16.1744V11.1638Z" fill="#D80027"></path><path d="M14.5045 12.8347H12.835V14.5042H14.5045V12.8347Z" fill="#D80027"></path><path d="M12.8346 14.5039H11.165V16.1734H12.8346V14.5039Z" fill="#D80027"></path><path d="M9.49542 14.5039H7.93359C8.07684 15.1245 8.35847 15.6924 8.74462 16.1734H9.49542V14.5039Z" fill="#D80027"></path><path d="M14.5049 16.1736H15.2556C15.6419 15.6926 15.9234 15.1247 16.0667 14.5041H14.5049V16.1736Z" fill="#D80027"></path><path d="M9.49512 16.1732V16.9016C9.98069 17.267 10.5482 17.529 11.1647 17.6547V16.1732H9.49512Z" fill="#D80027"></path><path d="M12.835 16.1732V17.6547C13.4515 17.5291 14.0189 17.267 14.5045 16.9016V16.1732H12.835Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Io2 = [
  jo2
];
function bo2(r, e) {
  return n(), o("svg", Fo2, Io2);
}
const _z2 = /* @__PURE__ */ i(Bo2, [["render", bo2]]);
var yo2 = {}, Do2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Po2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -800)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 5.37262 12 0 12 0C12 0 24 5.37262 24 12Z" fill="#A2001D"></path><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#0052B4"></path><path d="M16.174 15.1305L12.0001 14.6088L7.82617 15.1305V8.86963H16.174V15.1305Z" fill="#F0F0F0"></path><path d="M12.0001 14.6083C13.1527 14.6083 14.087 13.6739 14.087 12.5213C14.087 11.3687 13.1527 10.4343 12.0001 10.4343C10.8475 10.4343 9.91309 11.3687 9.91309 12.5213C9.91309 13.6739 10.8475 14.6083 12.0001 14.6083Z" fill="#0052B4"></path><path d="M12.0005 13.5651C12.5768 13.5651 13.044 13.0979 13.044 12.5216C13.044 11.9453 12.5768 11.4781 12.0005 11.4781C11.4242 11.4781 10.957 11.9453 10.957 12.5216C10.957 13.0979 11.4242 13.5651 12.0005 13.5651Z" fill="#A2001D"></path><path d="M10.4346 9.91333H13.565L11.9998 11.4786L10.4346 9.91333Z" fill="#6DA544"></path><path d="M12.522 10.9556H11.4785V14.086H12.522V10.9556Z" fill="#FFDA44"></path><path d="M13.6696 13.7745H10.3304L7.82617 15.1311H16.174L13.6696 13.7745Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ao2 = [
  Po2
];
function So2(r, e) {
  return n(), o("svg", Do2, Ao2);
}
const Cz2 = /* @__PURE__ */ i(yo2, [["render", So2]]);
var To2 = {}, Oo2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Eo2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -968)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0.746391 7.82522C0.264047 9.12525 0 10.5313 0 11.9991C0 13.467 0.264047 14.8731 0.746391 16.173L12 17.2165L23.2536 16.173C23.736 14.8731 24 13.467 24 11.9991C24 10.5313 23.736 9.12525 23.2536 7.82522L12 6.78174L0.746391 7.82522Z" fill="#F0F0F0"></path><path d="M12.0006 -0.000976562C6.8411 -0.000976562 2.44254 3.25552 0.74707 7.82513H23.2543C21.5587 3.25552 17.1603 -0.000976562 12.0006 -0.000976562Z" fill="#D80027"></path><path d="M12.0006 23.9993C17.1603 23.9993 21.5587 20.7428 23.2543 16.1732H0.74707C2.44254 20.7428 6.8411 23.9993 12.0006 23.9993Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ro2 = [
  Eo2
];
function Uo2(r, e) {
  return n(), o("svg", Oo2, Ro2);
}
const fz2 = /* @__PURE__ */ i(To2, [["render", Uo2]]);
var No2 = {}, qo2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zo2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -1136)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#A2001D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ko2 = [
  zo2
];
function Go2(r, e) {
  return n(), o("svg", qo2, Ko2);
}
const vz2 = /* @__PURE__ */ i(No2, [["render", Go2]]);
var Wo2 = {}, Yo2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xo2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -1304)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.9999 11.999C23.9999 6.83951 20.7434 2.44095 16.1738 0.745483V23.2527C20.7434 21.5571 23.9999 17.1587 23.9999 11.999Z" fill="#FF9811"></path><path d="M0 11.9997C0 17.1593 3.2565 21.5578 7.82611 23.2533V0.746094C3.2565 2.44156 0 6.84013 0 11.9997Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Qo2 = [
  Xo2
];
function Jo2(r, e) {
  return n(), o("svg", Yo2, Qo2);
}
const uz2 = /* @__PURE__ */ i(Wo2, [["render", Jo2]]);
var ti2 = {}, ei2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ri2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -16)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M16.5173 9.39207H13.505L11.9989 6.78339L10.4928 9.39207H7.48047L8.98675 12.0008L7.48047 14.6094H10.4928L11.9989 17.2181L13.505 14.6094H16.5173L15.011 12.0008L16.5173 9.39207ZM13.8493 12.0008L12.9242 13.6033H11.0738L10.1485 12.0008L11.0737 10.3982H12.9241L13.8493 12.0008ZM11.9989 8.79559L12.3432 9.39203H11.6546L11.9989 8.79559ZM9.22324 10.3982H9.91192L9.56758 10.9946L9.22324 10.3982ZM9.22324 13.6033L9.56763 13.0069L9.91197 13.6033H9.22324ZM11.9989 15.2059L11.6546 14.6094H12.3432L11.9989 15.2059ZM14.7746 13.6033H14.0859L14.4303 13.0069L14.7746 13.6033ZM14.0859 10.3982H14.7746L14.4302 10.9946L14.0859 10.3982Z" fill="#0052B4"></path><path d="M19.4693 2.60907H4.5296C3.43446 3.48132 2.49527 4.54079 1.76074 5.73952H22.2382C21.5036 4.54084 20.5644 3.48132 19.4693 2.60907Z" fill="#0052B4"></path><path d="M4.5296 21.3914H19.4693C20.5644 20.5191 21.5036 19.4597 22.2381 18.2609H1.76074C2.49532 19.4596 3.43451 20.5191 4.5296 21.3914Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ni2 = [
  ri2
];
function oi2(r, e) {
  return n(), o("svg", ei2, ni2);
}
const wz2 = /* @__PURE__ */ i(ti2, [["render", oi2]]);
var ii2 = {}, li2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, si2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -1360)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M16.4437 8.04392L15.5955 11.0707L13.0507 10.6008L11.4126 7.22412L6.98727 8.79448L6.63828 7.81104L5.48047 7.6684L6.35286 10.1269L9.39828 9.34812L10.2637 11.787L8.15848 14.8939L11.7312 17.9411L11.054 18.735L11.5093 19.8091L13.2024 17.8242L11.0052 15.5763L12.6845 13.6074L16.4279 13.8771L17.2805 9.25943L18.3066 9.44895L19.0093 8.51754L16.4437 8.04392Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), hi2 = [
  si2
];
function ai2(r, e) {
  return n(), o("svg", li2, hi2);
}
const pz2 = /* @__PURE__ */ i(ii2, [["render", ai2]]);
var di2 = {}, ci2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _i2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -1080)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 -0.000976562C7.24218 -0.000976562 3.13143 2.7677 1.19043 6.78165H22.8089C20.868 2.7677 16.7572 -0.000976562 11.9997 -0.000976562Z" fill="#FF9811"></path><path d="M11.9997 23.9997C16.7572 23.9997 20.868 21.231 22.809 17.217H1.19043C3.13143 21.231 7.24218 23.9997 11.9997 23.9997Z" fill="#6DA544"></path><path d="M12.0001 16.1732C14.3052 16.1732 16.174 14.3045 16.174 11.9993C16.174 9.69415 14.3052 7.82544 12.0001 7.82544C9.69489 7.82544 7.82617 9.69415 7.82617 11.9993C7.82617 14.3045 9.69489 16.1732 12.0001 16.1732Z" fill="#0052B4"></path><path d="M12.0003 14.608C13.441 14.608 14.609 13.44 14.609 11.9993C14.609 10.5586 13.441 9.39062 12.0003 9.39062C10.5595 9.39062 9.3916 10.5586 9.3916 11.9993C9.3916 13.44 10.5595 14.608 12.0003 14.608Z" fill="#F0F0F0"></path><path d="M12.0007 8.78088L12.8055 10.6061L14.7885 10.3904L13.6102 12L14.7885 13.6095L12.8055 13.3939L12.0007 15.2191L11.1959 13.3939L9.21289 13.6095L10.3911 12L9.21289 10.3904L11.1959 10.6061L12.0007 8.78088Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ci2 = [
  _i2
];
function fi2(r, e) {
  return n(), o("svg", ci2, Ci2);
}
const gz2 = /* @__PURE__ */ i(di2, [["render", fi2]]);
var vi2 = {}, ui2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wi2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -296)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M21.9999 13.4358C20.9999 13.4358 20.9999 12.5214 19.9998 12.5214C18.9999 12.5214 18.9999 13.4358 17.9999 13.4358C17 13.4358 16.9999 12.5214 16 12.5214C15 12.5214 15 13.4358 14 13.4358C13 13.4358 12.9999 12.5214 11.9998 12.5214C10.9998 12.5214 10.9998 13.4358 9.99991 13.4358C9.00006 13.4358 9.00006 12.5214 8.00008 12.5214C7 12.5214 7 13.4358 5.99992 13.4358C4.99984 13.4358 4.99984 12.5214 3.99977 12.5214C2.99992 12.5214 2.99992 13.4358 1.99994 13.4358C1.00534 13.4358 0.999578 12.5315 0.015625 12.5218C0.0433281 13.0707 0.108859 13.6096 0.207953 14.1366C1.00502 14.2537 1.07481 15.0357 2.00003 15.0357C3.00002 15.0357 3.00002 14.1215 3.99986 14.1215C4.99994 14.1215 4.99994 15.0357 6.00002 15.0357C7.00009 15.0357 7.00009 14.1215 8.00017 14.1215C9.00016 14.1215 9.00016 15.0357 10 15.0357C11 15.0357 11 14.1215 11.9999 14.1215C13 14.1215 13 15.0357 14.0001 15.0357C15.0002 15.0357 15.0002 14.1215 16.0001 14.1215C17.0001 14.1215 17.0001 15.0357 18 15.0357C19 15.0357 19 14.1215 19.9999 14.1215C21 14.1215 21 15.0357 22 15.0357C22.9252 15.0357 22.995 14.2537 23.7921 14.1366C23.8913 13.6096 23.9567 13.0708 23.9845 12.5218C23.0004 12.5315 22.9945 13.4358 21.9999 13.4358Z" fill="#0052B4"></path><path d="M20.0003 15.6514C19.0003 15.6514 19.0003 16.5658 18.0003 16.5658C17.0004 16.5658 17.0004 15.6514 16.0004 15.6514C15.0004 15.6514 15.0004 16.5658 14.0004 16.5658C13.0003 16.5658 13.0003 15.6514 12.0003 15.6514C11.0003 15.6514 11.0003 16.5658 10.0003 16.5658C9.00049 16.5658 9.00049 15.6514 8.00051 15.6514C7.00043 15.6514 7.00043 16.5658 6.00035 16.5658C5.00027 16.5658 5.00027 15.6514 4.0002 15.6514C3.00035 15.6514 3.00035 16.5658 2.00037 16.5658C1.26373 16.5658 1.06924 16.0699 0.618164 15.8087C0.891352 16.6253 1.25018 17.4024 1.68354 18.1301C1.77738 18.1527 1.88173 18.1658 2.00032 18.1658C3.0003 18.1658 3.0003 17.2515 4.00015 17.2515C5.00023 17.2515 5.00023 18.1658 6.0003 18.1658C7.00038 18.1658 7.00038 17.2515 8.00046 17.2515C9.00045 17.2515 9.00045 18.1658 10.0003 18.1658C11.0003 18.1658 11.0003 17.2515 12.0002 17.2515C13.0003 17.2515 13.0003 18.1658 14.0004 18.1658C15.0004 18.1658 15.0004 17.2515 16.0004 17.2515C17.0004 17.2515 17.0004 18.1658 18.0003 18.1658C19.0002 18.1658 19.0003 17.2515 20.0002 17.2515C21.0003 17.2515 21.0003 18.1658 22.0002 18.1658C22.1189 18.1658 22.2234 18.1527 22.3173 18.13C22.7507 17.4024 23.1094 16.6253 23.3826 15.8088C22.9315 16.07 22.737 16.5658 22.0002 16.5658C21.0004 16.5658 21.0003 15.6514 20.0003 15.6514Z" fill="#0052B4"></path><path d="M23.7211 9.41946C22.9902 9.57119 22.897 10.306 22.0002 10.306C21.0002 10.306 21.0002 9.39166 20.0002 9.39166C19.0002 9.39166 19.0002 10.306 18.0002 10.306C17.0003 10.306 17.0003 9.39166 16.0003 9.39166C15.0003 9.39166 15.0003 10.306 14.0003 10.306C13.0003 10.306 13.0002 9.39166 12.0001 9.39166C11.4598 9.39166 11.2114 9.65857 10.9395 9.904V11.504C11.2114 11.2586 11.4598 10.9917 12.0001 10.9917C13.0002 10.9917 13.0002 11.906 14.0003 11.906C15.0004 11.906 15.0004 10.9917 16.0003 10.9917C17.0003 10.9917 17.0003 11.906 18.0002 11.906C19.0002 11.906 19.0002 10.9917 20.0002 10.9917C21.0002 10.9917 21.0002 11.906 22.0002 11.906C22.9254 11.906 22.9952 11.124 23.7923 11.0069C23.8434 11.0069 23.9005 11.0064 23.959 11.0057C23.9147 10.466 23.8345 9.93654 23.7211 9.41946Z" fill="#0052B4"></path><path d="M22.8445 6.85727C22.6373 7.03132 22.3978 7.17588 22.0002 7.17588C21.0002 7.17588 21.0002 6.26154 20.0002 6.26154C19.0002 6.26154 19.0002 7.17588 18.0002 7.17588C17.0003 7.17588 17.0003 6.26154 16.0003 6.26154C15.0003 6.26154 15.0003 7.17588 14.0003 7.17588C13.0003 7.17588 13.0002 6.26154 12.0001 6.26154C11.4598 6.26154 11.2114 6.52844 10.9395 6.77388V8.37386C11.2114 8.12847 11.4598 7.86161 12.0001 7.86161C13.0002 7.86161 13.0002 8.77586 14.0003 8.77586C15.0003 8.77586 15.0003 7.86161 16.0003 7.86161C17.0003 7.86161 17.0003 8.77586 18.0002 8.77586C19.0001 8.77586 19.0001 7.86161 20.0001 7.86161C21.0002 7.86161 21.0002 8.77586 22.0001 8.77586C22.7097 8.77586 22.9164 8.31625 23.3335 8.04897C23.1914 7.6413 23.0281 7.24357 22.8445 6.85727Z" fill="#0052B4"></path><path d="M20.0856 3.13263C20.0579 3.13113 20.0296 3.13019 20.0002 3.13019C19.0002 3.13019 19.0002 4.04453 18.0003 4.04453C17.0003 4.04453 17.0003 3.13019 16.0004 3.13019C15.0004 3.13019 15.0004 4.04453 14.0003 4.04453C13.0002 4.04453 13.0002 3.13019 12.0001 3.13019C11.4598 3.13019 11.2114 3.39709 10.9395 3.64253V5.24252C11.2114 4.99713 11.4598 4.73027 12.0001 4.73027C13.0002 4.73027 13.0002 5.64452 14.0003 5.64452C15.0004 5.64452 15.0004 4.73027 16.0003 4.73027C17.0003 4.73027 17.0003 5.64452 18.0002 5.64452C19.0002 5.64452 19.0002 4.73027 20.0002 4.73027C21.0002 4.73027 21.0002 5.64452 22.0002 5.64452C22.0618 5.64452 22.1193 5.64086 22.1738 5.63435C21.5929 4.70791 20.8896 3.86617 20.0856 3.13263Z" fill="#0052B4"></path><path d="M15.0668 0.396249C14.7923 0.643186 14.5443 0.914405 13.9996 0.914405C12.9996 0.914405 12.9996 0.000154785 11.9995 6.10352e-05H11.9994C11.4822 0.00010791 11.2326 0.244655 10.9736 0.480858V2.08089C11.2325 1.84469 11.4823 1.60009 11.9995 1.60009C12.9996 1.60009 12.9996 2.51434 13.9997 2.51434C14.9997 2.51434 14.9997 1.60009 15.9997 1.60009C16.9997 1.60009 16.9997 2.51434 17.9996 2.51434C18.4192 2.51434 18.6626 2.35328 18.8778 2.16644C17.7371 1.36698 16.4509 0.761077 15.0668 0.396249Z" fill="#0052B4"></path><path d="M14.0003 22.8273C13.0002 22.8273 13.0002 21.913 12.0001 21.913C11.0002 21.913 11.0002 22.8273 10.0002 22.8273C9.00037 22.8273 9.00037 21.913 8.00038 21.913C7.2344 21.913 7.05473 22.4489 6.56348 22.7001C7.91817 23.3898 9.42131 23.8294 11.0122 23.9591C11.2583 23.7343 11.5082 23.513 12.0001 23.513C12.4922 23.513 12.7421 23.7343 12.9882 23.9592C14.5792 23.8295 16.0824 23.3898 17.4372 22.7001C16.9458 22.449 16.7662 21.9129 16.0003 21.9129C15.0004 21.9129 15.0004 22.8273 14.0003 22.8273Z" fill="#0052B4"></path><path d="M18.0003 19.6977C17.0003 19.6977 17.0003 18.7833 16.0003 18.7833C15.0004 18.7833 15.0004 19.6977 14.0003 19.6977C13.0002 19.6977 13.0003 18.7833 12.0002 18.7833C11.0002 18.7833 11.0002 19.6977 10.0003 19.6977C9.00041 19.6977 9.00041 18.7833 8.00042 18.7833C7.00034 18.7833 7.00034 19.6977 6.00027 19.6977C5.00019 19.6977 5.00019 18.7833 4.00011 18.7833C3.281 18.7833 3.07906 19.2563 2.65039 19.5218C2.91908 19.8555 3.20473 20.1749 3.50703 20.4777C3.64245 20.4199 3.80136 20.3834 4.00006 20.3834C5.00014 20.3834 5.00014 21.2976 6.00022 21.2976C7.0003 21.2976 7.0003 20.3834 8.00038 20.3834C9.00036 20.3834 9.00036 21.2976 10.0002 21.2976C11.0002 21.2976 11.0002 20.3834 12.0001 20.3834C13.0002 20.3834 13.0002 21.2976 14.0003 21.2976C15.0004 21.2976 15.0004 20.3834 16.0003 20.3834C17.0002 20.3834 17.0003 21.2976 18.0002 21.2976C19.0002 21.2976 19.0002 20.3834 20.0001 20.3834C20.1991 20.3834 20.358 20.4199 20.4935 20.4778C20.7958 20.1749 21.0815 19.8555 21.3502 19.5219C20.9215 19.2564 20.7195 18.7834 20.0002 18.7834C19.0002 18.7833 19.0002 19.6977 18.0003 19.6977Z" fill="#0052B4"></path><path d="M11.9678 11.9991H11.9999C11.9999 11.9883 11.9999 11.9778 11.9999 11.9669C11.9892 11.9777 11.9785 11.9884 11.9678 11.9991Z" fill="#F0F0F0"></path><path d="M12.0001 6.26153V9.78714L7.82617 5.73981L12.0001 6.26153Z" fill="#0052B4"></path><path d="M6.26102 12.0005H9.78649L6.26098 7.30487L5.73926 10.957L6.26102 12.0005Z" fill="#0052B4"></path><path d="M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.3715 0.001125 0 5.37323 0 12H6.2609V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z" fill="#F0F0F0"></path><path d="M6.07124 1.56415C4.19441 2.63285 2.63413 4.19313 1.56543 6.06996V11.9989H4.69588V4.6947V4.6946H12.0002C12.0002 3.70727 12.0002 2.76668 12.0002 1.56415H6.07124Z" fill="#D80027"></path><path d="M11.9999 10.5234L7.73637 6.25995H6.26074V6.26004L11.9998 11.999H11.9999C11.9999 11.999 11.9999 10.9815 11.9999 10.5234Z" fill="#D80027"></path><path d="M15.6523 6.26099H20.348L18.0002 8.60882L15.6523 6.26099Z" fill="#6DA544"></path><path d="M18.522 8.08649H17.4785V10.956H18.522V8.08649Z" fill="#A2001D"></path><path d="M18.521 15.652H17.4775V18.5215H18.521V15.652Z" fill="#A2001D"></path><path d="M21.13 14.0874C21.13 13.2229 20.4292 12.5222 19.5648 12.5222C19.1638 12.5222 18.7983 12.6731 18.5213 12.921V12.0004H19.043V10.9569H18.5213V10.4352H17.4778V10.9569H16.9561V12.0004H17.4778V12.921C17.2008 12.6731 16.8353 12.5222 16.4343 12.5222C15.5699 12.5222 14.8691 13.2229 14.8691 14.0874C14.8691 14.5508 15.0708 14.9671 15.3909 15.2537V16.1743H20.6082V15.2537C20.9284 14.9671 21.13 14.5508 21.13 14.0874Z" fill="#FFDA44"></path><path d="M19.5652 13.5649C19.4006 13.5649 19.2854 13.6372 19.2177 13.6978L18.5217 14.3208H17.4783L16.7823 13.6978C16.7146 13.6372 16.5994 13.5649 16.4348 13.5649C16.1471 13.5649 15.9131 13.799 15.9131 14.0867C15.9131 14.2893 16.0224 14.4173 16.0875 14.4757L16.4349 14.7867V15.1301H19.5653V14.7867L19.9127 14.4757C19.9778 14.4174 20.0871 14.2893 20.0871 14.0867C20.087 13.799 19.8529 13.5649 19.5652 13.5649Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), pi2 = [
  wi2
];
function gi2(r, e) {
  return n(), o("svg", ui2, pi2);
}
const $z2 = /* @__PURE__ */ i(vi2, [["render", gi2]]);
var $i2 = {}, Mi2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Li2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -1248)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 -0.000610352C6.84012 -0.000610352 2.44161 3.25589 0.746094 7.8255H23.2534C21.5578 3.25589 17.1593 -0.000610352 11.9997 -0.000610352Z" fill="#A2001D"></path><path d="M11.9997 24.0006C17.1593 24.0006 21.5578 20.7441 23.2533 16.1744H0.746094C2.44161 20.7441 6.84013 24.0006 11.9997 24.0006Z" fill="black"></path><path d="M9.13039 11.2186C9.12383 11.2186 9.1174 11.219 9.11084 11.2191V11.2186H6.81692C6.93322 10.7692 7.34094 10.4359 7.82605 10.4359V8.87073C6.38759 8.87073 5.21736 10.041 5.21736 11.4794V12.7577V12.7838H9.11084C9.11966 12.7838 9.12659 12.7838 9.13039 12.7838C9.27425 12.7838 9.39125 12.9009 9.39125 13.0447V13.5664H4.17383V15.1316H10.9565V13.0446C10.9565 12.0377 10.1373 11.2186 9.13039 11.2186Z" fill="#496E2D"></path><path d="M13.0437 13.5657V8.87H11.4785V15.1309H14.0872V13.5657H13.0437Z" fill="#496E2D"></path><path d="M18.2606 13.5657V8.87H16.6954V13.5657H16.1736V12.0005H14.6084V15.1309H19.3041V13.5657H18.2606Z" fill="#496E2D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ki2 = [
  Li2
];
function mi2(r, e) {
  return n(), o("svg", Mi2, ki2);
}
const Mz2 = /* @__PURE__ */ i($i2, [["render", mi2]]);
var xi2 = {}, Hi2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vi2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -1192)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M15.8976 8.86968H14.3275C14.3405 9.04222 14.3479 9.21632 14.3479 9.39139C14.3479 10.5522 14.0577 11.6774 13.5519 12.4783C13.3958 12.7253 13.1336 13.0741 12.7826 13.3094V8.86963H11.2174V13.3094C10.8665 13.0741 10.6042 12.7253 10.4481 12.4783C9.94227 11.6774 9.65216 10.5522 9.65216 9.39139C9.65216 9.21632 9.65957 9.04218 9.67251 8.86968H8.10248C8.0924 9.04138 8.08691 9.21529 8.08691 9.39139C8.08691 12.6096 9.80573 15.1305 11.9999 15.1305C14.1942 15.1305 15.913 12.6096 15.913 9.39139C15.9131 9.21529 15.9076 9.04138 15.8976 8.86968Z" fill="#D80027"></path><path d="M4.9572 5.73816H6.52241V6.78165H8.08761V5.73816H9.65281V6.78165H11.218V5.73816H12.7832V6.78165H14.3484V5.73816H15.9136V6.78165H17.4788V5.73816H19.044V6.78165H22.8098C20.869 2.7677 16.7582 -0.000976562 12.0007 -0.000976562C7.2432 -0.000976562 3.13241 2.7677 1.19141 6.78165H4.9572V5.73816Z" fill="#6DA544"></path><path d="M19.0442 17.217V18.2605H17.479V17.217H15.9138V18.2605H14.3486V17.217H12.7834V18.2605H11.2182V17.217H9.65295V18.2605H8.08775V17.217H6.52241V18.2605H4.9572V17.217H1.19141C3.13241 21.231 7.24316 23.9997 12.0007 23.9997C16.7582 23.9997 20.869 21.231 22.81 17.217H19.0442Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Zi2 = [
  Vi2
];
function Bi2(r, e) {
  return n(), o("svg", Hi2, Zi2);
}
const Lz2 = /* @__PURE__ */ i(xi2, [["render", Bi2]]);
var Fi2 = {}, ji2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ii2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -1024)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M0.413086 15.1301C1.1074 17.7063 2.63763 19.9392 4.69535 21.5202V15.1301H0.413086Z" fill="#0052B4"></path><path d="M10.9561 23.954C11.3 23.9837 11.6479 23.9997 11.9995 23.9997C17.5439 23.9997 22.2091 20.2393 23.5861 15.1301H10.9561V23.954Z" fill="#0052B4"></path><path d="M23.5861 8.86918C22.2091 3.75999 17.5439 -0.000366211 11.9995 -0.000366211C11.6479 -0.000366211 11.3 0.015665 10.9561 0.04529V8.86918H23.5861Z" fill="#0052B4"></path><path d="M4.69535 2.47937C2.63763 4.06046 1.1074 6.29326 0.413086 8.86946H4.69535V2.47937Z" fill="#0052B4"></path><path d="M23.8984 10.4352H9.39136H9.39131V0.285645C8.28234 0.531551 7.23098 0.930129 6.26086 1.45949V10.4352H0.101578C0.0347813 10.9476 0 11.4699 0 12.0004C0 12.5309 0.0347813 13.0533 0.101578 13.5656H6.26081H6.26086V22.5413C7.23098 23.0706 8.28234 23.4693 9.39131 23.7151V13.5658V13.5657H23.8984C23.9651 13.0533 24 12.5309 24 12.0004C24 11.4699 23.9651 10.9475 23.8984 10.4352Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), bi2 = [
  Ii2
];
function yi2(r, e) {
  return n(), o("svg", ji2, bi2);
}
const kz2 = /* @__PURE__ */ i(Fi2, [["render", yi2]]);
var Di2 = {}, Pi2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ai2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -72)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.9999 11.9992C23.9999 6.83958 20.7434 2.44106 16.1738 0.745544V23.2528C20.7434 21.5572 23.9999 17.1587 23.9999 11.9992Z" fill="#D80027"></path><path d="M0 11.9997C0 17.1593 3.2565 21.5578 7.82611 23.2533V0.746094C3.2565 2.44161 0 6.84013 0 11.9997Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Si2 = [
  Ai2
];
function Ti2(r, e) {
  return n(), o("svg", Pi2, Si2);
}
const mz2 = /* @__PURE__ */ i(Di2, [["render", Ti2]]);
var Oi2 = {}, Ei2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ri2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -240)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M21.5209 19.3071L14.2143 12.0006H14.2142L21.5209 4.69382C21.2058 4.28432 20.861 3.89033 20.486 3.51519C20.1109 3.1401 19.7169 2.79533 19.3074 2.48029L12.0007 9.78693L12.0007 9.78697L4.69405 2.48029C4.28459 2.79538 3.89056 3.14005 3.51542 3.51519C3.14028 3.89033 2.79556 4.28432 2.48052 4.69382L9.78716 12.0004L9.7872 12.0005L2.48047 19.3072C2.79561 19.7167 3.14033 20.1107 3.51538 20.4858C3.89052 20.8609 4.28445 21.2057 4.694 21.5207L12.0007 14.2141L12.0007 14.214L19.3074 21.5207C19.7168 21.2056 20.1109 20.8609 20.486 20.4858C20.8611 20.1106 21.2058 19.7166 21.5209 19.3071Z" fill="#D80027"></path><path d="M9.91309 3.65288L12.0001 4.1746L14.087 3.65288V1.87899L13.2522 2.29636L12.0001 1.04419L10.7479 2.29636L9.91309 1.87899V3.65288Z" fill="#FFDA44"></path><path d="M9.91309 3.65289V4.95733C9.91309 6.55483 12.0001 7.0443 12.0001 7.0443C12.0001 7.0443 14.087 6.55478 14.087 4.95733V3.65289H9.91309Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ui2 = [
  Ri2
];
function Ni2(r, e) {
  return n(), o("svg", Ei2, Ui2);
}
const xz2 = /* @__PURE__ */ i(Oi2, [["render", Ni2]]);
var qi2 = {}, zi2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ki2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -128)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M19.3059 2.48075C17.2824 0.925388 14.7495 0.00012207 12.0001 0.00012207C9.25073 0.00012207 6.71779 0.925434 4.69434 2.48075L12.0001 9.7865L19.3059 2.48075Z" fill="#6DA544"></path><path d="M2.48058 4.6936C0.925312 6.71706 0 9.24995 0 11.9994C0 14.7488 0.925312 17.2817 2.48062 19.3052L9.78642 11.9994L2.48058 4.6936Z" fill="black"></path><path d="M4.69434 21.5188C6.71784 23.0741 9.25073 23.9994 12.0001 23.9994C14.7495 23.9994 17.2824 23.0741 19.3059 21.5188L12.0001 14.213L4.69434 21.5188Z" fill="#6DA544"></path><path d="M21.5196 19.3051C23.075 17.2816 24.0002 14.7488 24.0002 11.9994C24.0002 9.24995 23.075 6.71706 21.5196 4.6936L14.2139 11.9994L21.5196 19.3051Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Gi2 = [
  Ki2
];
function Wi2(r, e) {
  return n(), o("svg", zi2, Gi2);
}
const Hz2 = /* @__PURE__ */ i(qi2, [["render", Wi2]]);
var Yi2 = {}, Xi2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qi2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -296)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M7.30388 7.82623H23.2531C21.5576 3.25662 17.1591 0.00012207 11.9995 0.00012207C8.68576 0.00012207 5.68609 1.34351 3.51465 3.51523L7.30388 7.82623Z" fill="black"></path><path d="M7.30388 16.1745H23.2531C21.5576 20.7441 17.1591 24.0006 11.9995 24.0006C8.68576 24.0006 5.68609 22.6572 3.51465 20.4855L7.30388 16.1745Z" fill="#6DA544"></path><path d="M3.51471 3.51379C-1.17157 8.20008 -1.17157 15.7981 3.51471 20.4844C5.45126 18.5479 7.31375 16.6854 12 11.9991L3.51471 3.51379Z" fill="#D80027"></path><path d="M4.76268 9.39178L5.42123 10.7689L6.90852 10.4252L6.24243 11.7987L7.43845 12.7471L5.94937 13.0827L5.95349 14.6092L4.76268 13.6542L3.57182 14.6092L3.57599 13.0827L2.08691 12.7471L3.28288 11.7987L2.61688 10.4252L4.10409 10.7689L4.76268 9.39178Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ji2 = [
  Qi2
];
function tl2(r, e) {
  return n(), o("svg", Xi2, Ji2);
}
const Vz2 = /* @__PURE__ */ i(Yi2, [["render", tl2]]);
var el2 = {}, rl2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nl2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -184)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9996 17.2178C14.8811 17.2178 17.217 14.8819 17.217 12.0004C17.217 9.11892 14.8811 6.78302 11.9996 6.78302C9.11813 6.78302 6.78223 9.11892 6.78223 12.0004C6.78223 14.8819 9.11813 17.2178 11.9996 17.2178Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ol2 = [
  nl2
];
function il2(r, e) {
  return n(), o("svg", rl2, ol2);
}
const Zz2 = /* @__PURE__ */ i(el2, [["render", il2]]);
var ll2 = {}, sl2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hl2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -408)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12.0007 -0.000732422C7.24316 -0.000732422 3.13241 2.76794 1.19141 6.78189H22.8099C20.869 2.76794 16.7582 -0.000732422 12.0007 -0.000732422Z" fill="black"></path><path d="M12.0007 24C7.24316 24 3.13241 21.2314 1.19141 17.2174H22.8099C20.869 21.2314 16.7582 24 12.0007 24Z" fill="#496E2D"></path><path d="M23.4333 8.34705H0.566672C0.199078 9.49872 0 10.7257 0 11.9992C0 13.2728 0.199078 14.4997 0.566672 15.6514H23.4333C23.8009 14.4997 24 13.2728 24 11.9992C24 10.7257 23.8009 9.49872 23.4333 8.34705Z" fill="#A2001D"></path><path d="M15.7369 5.54508L14.3158 4.88916L12.0003 10.1322L9.68478 4.88916L8.26367 5.54508L11.1384 11.9997L8.26367 18.4544L9.68478 19.1103L12.0003 13.8673L14.3158 19.1103L15.7369 18.4544L12.8622 11.9997L15.7369 5.54508Z" fill="#F0F0F0"></path><path d="M12.9656 6.16321C12.4154 5.56242 12.0004 5.21704 12.0004 5.21704C12.0004 5.21704 11.5853 5.56237 11.0352 6.16321V17.836C11.5853 18.4369 12.0004 18.7823 12.0004 18.7823C12.0004 18.7823 12.4154 18.437 12.9656 17.8361V6.16321Z" fill="#F0F0F0"></path><path d="M9.3916 8.40226V15.5981C9.97294 16.6282 10.6845 17.4725 11.2177 18.0323V5.96814C10.6845 6.52787 9.9729 7.37223 9.3916 8.40226Z" fill="#A2001D"></path><path d="M14.6083 8.40287C14.0269 7.3728 13.3155 6.52848 12.7822 5.96875V18.0329C13.3154 17.4731 14.0269 16.6288 14.6083 15.5987V8.40287Z" fill="#A2001D"></path><path d="M14.6084 8.40088V15.5968C15.1969 14.5538 15.6519 13.3206 15.6519 11.9989C15.6519 10.6771 15.1969 9.44385 14.6084 8.40088Z" fill="black"></path><path d="M9.39114 8.40088V15.5968C8.80263 14.5538 8.34766 13.3206 8.34766 11.9989C8.34766 10.6771 8.80263 9.44385 9.39114 8.40088Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), al2 = [
  hl2
];
function dl2(r, e) {
  return n(), o("svg", sl2, al2);
}
const Bz2 = /* @__PURE__ */ i(ll2, [["render", dl2]]);
var cl2 = {}, _l2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cl2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -576)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M17.8681 12L15.4702 13.1279L16.7471 15.4504L14.1431 14.9522L13.8133 17.5826L11.9994 15.6481L10.1857 17.5826L9.85578 14.9522L7.25197 15.4503L8.52884 13.1278L6.13086 12L8.52884 10.8721L7.25197 8.54956L9.85569 9.04784L10.1858 6.41736L11.9994 8.35193L13.8133 6.41736L14.1431 9.04784L16.7472 8.54956L15.4702 10.8723L17.8681 12Z" fill="#FFDA44"></path><path d="M11.9998 15.6514C14.0169 15.6514 15.652 14.0163 15.652 11.9992C15.652 9.98218 14.0169 8.34705 11.9998 8.34705C9.98279 8.34705 8.34766 9.98218 8.34766 11.9992C8.34766 14.0163 9.98279 15.6514 11.9998 15.6514Z" fill="#D80027"></path><path d="M10.1746 12.0004C10.0867 12.0004 9.9998 12.0049 9.91406 12.0134C9.9172 12.5192 10.1002 12.9822 10.4025 13.3419C10.5637 12.908 10.8045 12.5123 11.1081 12.1737C10.8181 12.0621 10.5035 12.0004 10.1746 12.0004Z" fill="#FFDA44"></path><path d="M11.2988 13.967C11.5182 14.0454 11.7544 14.0884 12.0008 14.0884C12.2472 14.0884 12.4834 14.0454 12.7027 13.967C12.5832 13.4977 12.3363 13.0788 12.0008 12.7495C11.6653 13.0787 11.4184 13.4977 11.2988 13.967Z" fill="#FFDA44"></path><path d="M13.8079 10.9573C13.447 10.3335 12.7731 9.91345 12.0006 9.91345C11.2281 9.91345 10.5542 10.3335 10.1934 10.9573C10.8512 10.9606 11.4681 11.1395 12.0006 11.4483C12.5332 11.1395 13.15 10.9606 13.8079 10.9573Z" fill="#FFDA44"></path><path d="M12.8936 12.1739C13.1972 12.5125 13.4379 12.9082 13.5992 13.3421C13.9014 12.9825 14.0844 12.5195 14.0876 12.0136C14.0018 12.0051 13.9149 12.0006 13.827 12.0006C13.4982 12.0006 13.1836 12.0623 12.8936 12.1739Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), fl2 = [
  Cl2
];
function vl2(r, e) {
  return n(), o("svg", _l2, fl2);
}
const Fz2 = /* @__PURE__ */ i(cl2, [["render", vl2]]);
var ul2 = {}, wl2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pl2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -632)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 12.0009C0 14.0798 0.528891 16.0351 1.45908 17.74L12 18.7835L22.5409 17.74C23.4711 16.0351 24 14.0798 24 12.0009C24 9.92198 23.4711 7.96664 22.5409 6.26175L12 5.21826L1.45908 6.26175C0.528891 7.96664 0 9.92198 0 12.0009Z" fill="#D80027"></path><path d="M1.45898 6.26123H22.5408C20.5056 2.5311 16.5484 0.000366211 11.9999 0.000366211C7.45139 0.000366211 3.49425 2.5311 1.45898 6.26123Z" fill="#0052B4"></path><path d="M11.9999 24.0008C16.5484 24.0008 20.5056 21.4701 22.5408 17.74H1.45898C3.49425 21.4701 7.45139 24.0008 11.9999 24.0008Z" fill="#0052B4"></path><path d="M16.1745 14.3473V12.7821H15.131V10.6951L14.0876 9.65167L13.0441 10.6951V8.60818L12.0006 7.5647L10.9571 8.60818V10.6951L9.91361 9.65167L8.87013 10.6951V12.7821H7.82669V14.3473H6.7832V15.9125H17.218V14.3473H16.1745Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), gl2 = [
  pl2
];
function $l2(r, e) {
  return n(), o("svg", wl2, gl2);
}
const jz2 = /* @__PURE__ */ i(ul2, [["render", $l2]]);
var Ml2 = {}, Ll2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kl2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -464)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#D80027"></path><path d="M16.173 11.16L14.4674 11.9622L15.3757 13.614L13.5237 13.2597L13.289 15.1305L11.9991 13.7545L10.7091 15.1305L10.4745 13.2597L8.62249 13.6139L9.5307 11.9622L7.8252 11.16L9.5307 10.3577L8.62249 8.70605L10.4744 9.06023L10.7091 7.18945L11.9991 8.56537L13.2891 7.18945L13.5237 9.06023L15.3757 8.70605L14.4676 10.3578L16.173 11.16Z" fill="#FFDA44"></path><path d="M15.13 3.913H12.7822C12.7822 3.48086 12.4318 3.13037 11.9996 3.13037C11.5674 3.13037 11.217 3.48081 11.217 3.913H8.86914C8.86914 4.34518 9.24564 4.69562 9.67783 4.69562H9.65172C9.65172 5.12781 10.0021 5.47824 10.4343 5.47824C10.4343 5.91043 10.7847 6.26087 11.217 6.26087H12.7822C13.2143 6.26087 13.5648 5.91048 13.5648 5.47824C13.9969 5.47824 14.3474 5.12785 14.3474 4.69562H14.3213C14.7535 4.69562 15.13 4.34523 15.13 3.913Z" fill="#FFDA44"></path><path d="M24 11.9996C24 18.627 18.6274 23.9996 12 23.9996C5.37262 23.9996 0 18.627 0 11.9996C0.521719 11.9996 24 11.9996 24 11.9996Z" fill="#F0F0F0"></path><path d="M12.0004 24.0005C15.7515 24.0005 19.0999 22.279 21.3005 19.5835C20.9047 19.3137 20.691 18.8774 20.0003 18.8774C19.0003 18.8774 19.0003 19.7918 18.0003 19.7918C17.0004 19.7918 17.0004 18.8774 16.0004 18.8774C15.0004 18.8774 15.0004 19.7918 14.0004 19.7918C13.0004 19.7918 13.0003 18.8774 12.0002 18.8774C11.0003 18.8774 11.0003 19.7918 10.0003 19.7918C9.00048 19.7918 9.00048 18.8774 8.00049 18.8774C7.00041 18.8774 7.00041 19.7918 6.00034 19.7918C5.00026 19.7918 5.00026 18.8774 4.00018 18.8774C3.30952 18.8774 3.09582 19.3136 2.7002 19.5834C4.9007 22.279 8.24935 24.0005 12.0004 24.0005Z" fill="#0052B4"></path><path d="M21.9999 13.5312C20.9999 13.5312 20.9999 12.6168 19.9998 12.6168C18.9999 12.6168 18.9999 13.5312 17.9999 13.5312C17 13.5312 16.9999 12.6168 16 12.6168C15 12.6168 15 13.5312 14 13.5312C13 13.5312 12.9999 12.6168 11.9998 12.6168C10.9998 12.6168 10.9998 13.5312 9.99991 13.5312C9.00006 13.5312 9.00006 12.6168 8.00008 12.6168C7 12.6168 7 13.5312 5.99992 13.5312C4.99984 13.5312 4.99984 12.6168 3.99977 12.6168C2.99992 12.6168 2.99992 13.5312 1.99994 13.5312C1.00534 13.5312 0.999578 12.6269 0.015625 12.6172C0.0433281 13.1661 0.108859 13.705 0.207953 14.232C1.00502 14.3491 1.07481 15.1311 1.99998 15.1311C2.99997 15.1311 2.99997 14.2169 3.99981 14.2169C4.99989 14.2169 4.99989 15.1311 5.99997 15.1311C7.00005 15.1311 7.00005 14.2169 8.00012 14.2169C9.00011 14.2169 9.00011 15.1311 9.99995 15.1311C10.9999 15.1311 10.9999 14.2169 11.9999 14.2169C13 14.2169 13 15.1311 14 15.1311C15.0001 15.1311 15.0001 14.2169 16 14.2169C17 14.2169 17 15.1311 18 15.1311C18.9999 15.1311 19 14.2169 19.9999 14.2169C21 14.2169 21 15.1311 21.9999 15.1311C22.9252 15.1311 22.995 14.3492 23.7921 14.232C23.8912 13.705 23.9567 13.1662 23.9845 12.6173C23.0004 12.627 22.9945 13.5312 21.9999 13.5312Z" fill="#0052B4"></path><path d="M19.9998 15.7477C18.9998 15.7477 18.9998 16.662 17.9998 16.662C16.9999 16.662 16.9999 15.7477 15.9999 15.7477C14.9999 15.7477 14.9999 16.662 13.9999 16.662C12.9998 16.662 12.9998 15.7477 11.9998 15.7477C10.9998 15.7477 10.9998 16.662 9.99983 16.662C8.99998 16.662 8.99998 15.7477 8 15.7477C6.99992 15.7477 6.99992 16.662 5.99984 16.662C4.99977 16.662 4.99977 15.7477 3.99969 15.7477C2.99984 15.7477 2.99984 16.662 1.99986 16.662C1.28534 16.662 1.08125 16.1953 0.658203 15.9287C0.939828 16.7424 1.3062 17.5165 1.74744 18.24C1.82417 18.2542 1.9077 18.262 1.99986 18.262C2.99984 18.262 2.99984 17.3478 3.99969 17.3478C4.99977 17.3478 4.99977 18.262 5.99984 18.262C6.99992 18.262 6.99992 17.3478 8 17.3478C8.99998 17.3478 8.99998 18.262 9.99983 18.262C10.9998 18.262 10.9998 17.3478 11.9998 17.3478C12.9998 17.3478 12.9998 18.262 13.9999 18.262C15 18.262 15 17.3478 15.9999 17.3478C16.9999 17.3478 16.9999 18.262 17.9998 18.262C18.9998 18.262 18.9998 17.3478 19.9998 17.3478C20.9998 17.3478 20.9998 18.262 21.9998 18.262C22.092 18.262 22.1756 18.2542 22.2523 18.24C22.6935 17.5165 23.0599 16.7424 23.3416 15.9288C22.9185 16.1952 22.7144 16.662 21.9998 16.662C20.9998 16.662 20.9998 15.7477 19.9998 15.7477Z" fill="#0052B4"></path><path d="M23.9628 11.0511C23.0004 11.0738 22.9872 11.9644 21.9998 11.9644C20.9999 11.9644 20.9999 11.05 19.9998 11.05C18.9998 11.05 18.9998 11.9644 17.9999 11.9644C17 11.9644 16.9999 11.05 16 11.05C15 11.05 15 11.9644 14 11.9644C12.9999 11.9644 12.9999 11.05 11.9998 11.05C10.9998 11.05 10.9998 11.9644 9.99989 11.9644C9.00005 11.9644 9.00005 11.05 8.00006 11.05C6.99998 11.05 6.99998 11.9644 5.99991 11.9644C4.99983 11.9644 4.99983 11.05 3.99975 11.05C2.99991 11.05 2.99991 11.9644 1.99992 11.9644C1.01278 11.9644 0.999422 11.0739 0.0371719 11.0511C0.01275 11.3639 0 11.68 0 11.9991C0 12.2177 0.0061875 12.4349 0.0178594 12.6505C0.999563 12.6616 1.00608 13.5643 1.99997 13.5643C2.99995 13.5643 2.99995 12.6501 3.9998 12.6501C4.99988 12.6501 4.99988 13.5643 5.99995 13.5643C7.00003 13.5643 7.00003 12.6501 8.00011 12.6501C9.00009 12.6501 9.00009 13.5643 9.99994 13.5643C10.9999 13.5643 10.9999 12.6501 11.9999 12.6501C12.9999 12.6501 12.9999 13.5643 14 13.5643C15.0001 13.5643 15.0001 12.6501 16 12.6501C17 12.6501 17 13.5643 18 13.5643C18.9999 13.5643 18.9999 12.6501 19.9999 12.6501C21 12.6501 21 13.5643 21.9999 13.5643C22.9939 13.5643 23.0004 12.6616 23.9823 12.6505C23.9938 12.4348 24 12.2177 24 11.9991C24 11.68 23.9872 11.3639 23.9628 11.0511Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ml2 = [
  kl2
];
function xl2(r, e) {
  return n(), o("svg", Ll2, ml2);
}
const Iz2 = /* @__PURE__ */ i(Ml2, [["render", xl2]]);
var Hl2 = {}, Vl2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zl2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -1248)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.9994 11.9653H10.9911C8.40842 14.548 6.84664 16.542 5.25195 18.1367L12.0346 18.7479L22.5596 17.7044C23.4781 16.0078 23.9998 14.0649 23.9998 12.0001C23.9998 11.9884 23.9994 11.977 23.9994 11.9653Z" fill="#D80027"></path><path d="M5.25272 6.22564H22.522C20.4812 2.51464 16.5348 -0.000488281 12.0005 -0.000488281C8.69559 -0.000488281 5.70328 1.33597 3.5332 3.49751L5.25272 6.22564Z" fill="#FFDA44"></path><path d="M5.77327 17.704C4.69449 18.7828 4.27759 19.6866 3.49707 20.4671C5.66996 22.649 8.67676 23.9996 11.9994 23.9996C16.562 23.9996 20.5297 21.4531 22.5592 17.704H5.77327Z" fill="#0052B4"></path><path d="M3.51471 3.48035C-1.17157 8.16663 -1.17157 15.7646 3.51471 20.451C5.45126 18.5144 7.31374 16.6519 12 11.9657L3.51471 3.48035Z" fill="#6DA544"></path><path d="M3.16584 11.9647C3.16584 10.2163 4.39457 8.75575 6.03538 8.39744C5.78319 8.34236 5.52154 8.3125 5.25276 8.3125C3.23568 8.3125 1.60059 9.9476 1.60059 11.9647C1.60059 13.9818 3.23568 15.6169 5.25276 15.6169C5.52149 15.6169 5.78315 15.587 6.03538 15.5319C4.39457 15.1736 3.16584 13.713 3.16584 11.9647Z" fill="#F0F0F0"></path><path d="M5.99574 8.83472L6.19004 9.43256H6.81863L6.31004 9.80208L6.50434 10.3999L5.99574 10.0305L5.48715 10.3999L5.68145 9.80208L5.17285 9.43256H5.80145L5.99574 8.83472Z" fill="#F0F0F0"></path><path d="M5.99574 10.3998L6.19004 10.9977H6.81863L6.31004 11.3671L6.50434 11.965L5.99574 11.5955L5.48715 11.965L5.68145 11.3671L5.17285 10.9977H5.80145L5.99574 10.3998Z" fill="#F0F0F0"></path><path d="M5.99574 11.9646L6.19004 12.5624H6.81863L6.31004 12.932L6.50434 13.5298L5.99574 13.1603L5.48715 13.5298L5.68145 12.932L5.17285 12.5624H5.80145L5.99574 11.9646Z" fill="#F0F0F0"></path><path d="M5.99574 13.5297L6.19004 14.1275H6.81863L6.31004 14.497L6.50434 15.0949L5.99574 14.7254L5.48715 15.0949L5.68145 14.497L5.17285 14.1275H5.80145L5.99574 13.5297Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Bl2 = [
  Zl2
];
function Fl2(r, e) {
  return n(), o("svg", Vl2, Bl2);
}
const bz2 = /* @__PURE__ */ i(Hl2, [["render", Fl2]]);
var jl2 = {}, Il2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bl2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -1360)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z" fill="#FFDA44"></path><path d="M3.51539 20.4852C4.01878 20.9885 4.55593 21.4375 5.11932 21.8327L21.8335 5.11856C21.4383 4.55512 20.9893 4.01802 20.4859 3.51463C19.9825 3.01124 19.4454 2.56241 18.882 2.16711L2.16797 18.8813C2.56313 19.4447 3.012 19.9818 3.51539 20.4852Z" fill="black"></path><path d="M3.51426 3.51475C-0.271509 7.30053 -0.998308 12.9861 1.33251 17.5021L17.5016 1.33309C12.9856 -0.997679 7.2999 -0.27088 3.51426 3.51475Z" fill="#6DA544"></path><path d="M20.4855 20.4847C24.2712 16.699 24.998 11.0134 22.6673 6.49731L6.49805 22.6665C11.0141 24.9972 16.6997 24.2705 20.4855 20.4847Z" fill="#D80027"></path><path d="M7.62971 14.1578L8.74993 14.7286L9.63896 13.8396L9.44228 15.0813L10.5624 15.6521L9.32068 15.8488L9.12399 17.0905L8.55324 15.9703L7.31152 16.167L8.20051 15.278L7.62971 14.1578Z" fill="#F0F0F0"></path><path d="M14.1561 7.63057L15.2763 8.20136L16.1653 7.31238L15.9686 8.55405L17.0888 9.1249L15.8471 9.32158L15.6504 10.5633L15.0796 9.44313L13.8379 9.63977L14.7269 8.75079L14.1561 7.63057Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), yl2 = [
  bl2
];
function Dl2(r, e) {
  return n(), o("svg", Il2, yl2);
}
const yz2 = /* @__PURE__ */ i(jl2, [["render", Dl2]]);
var Pl2 = {}, Al2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sl2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -72)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9999 -0.000244141C8.36285 -0.000244141 5.10396 1.61807 2.90332 4.17365H21.0965C18.8959 1.61807 15.637 -0.000244141 11.9999 -0.000244141Z" fill="#0052B4"></path><path d="M21.0965 19.827H2.90332C5.10396 22.3825 8.36285 24.0009 11.9999 24.0009C15.637 24.0009 18.8959 22.3825 21.0965 19.827Z" fill="#0052B4"></path><path d="M22.2387 5.73859H1.76128C0.644297 7.56132 0 9.70506 0 11.9994C0 14.2938 0.644297 16.4376 1.76128 18.2603H22.2387C23.3557 16.4376 24 14.2938 24 11.9994C24 9.70506 23.3557 7.56132 22.2387 5.73859Z" fill="#D80027"></path><path d="M7.383 16.6182C9.9331 16.6182 12.0004 14.551 12.0004 12.0009C12.0004 9.45076 9.9331 7.38348 7.383 7.38348C4.83289 7.38348 2.76562 9.45076 2.76562 12.0009C2.76562 14.551 4.83289 16.6182 7.383 16.6182Z" fill="#F0F0F0"></path><path d="M7.38279 7.38348L8.41877 10.572H11.7768L9.05913 12.5427L10.1032 15.7407L7.38279 13.7606L4.66648 15.737L5.70645 12.5427L2.99121 10.572H6.34676L7.38279 7.38348Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Tl2 = [
  Sl2
];
function Ol2(r, e) {
  return n(), o("svg", Al2, Tl2);
}
const Dz2 = /* @__PURE__ */ i(Pl2, [["render", Ol2]]);
var El2 = {}, Rl2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ul2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -968)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M16.174 11.9996C16.174 13.0431 14.3052 15.6517 12.0001 15.6517C9.69489 15.6517 7.82617 13.0431 7.82617 11.9996C7.82617 9.69436 9.69489 7.82568 12.0001 7.82568C14.3052 7.82568 16.174 9.69436 16.174 11.9996Z" fill="#D80027"></path><path d="M16.174 11.9995C16.174 14.3047 14.3052 16.1734 12.0001 16.1734C9.69489 16.1734 7.82617 14.3047 7.82617 11.9995" fill="#0052B4"></path><path d="M17.5335 14.5826L16.4268 15.6893L17.1646 16.4272L18.2714 15.3204L17.5335 14.5826Z" fill="black"></path><path d="M15.6888 16.4268L14.582 17.5336L15.3199 18.2714L16.4266 17.1647L15.6888 16.4268Z" fill="black"></path><path d="M19.7474 16.7947L18.6406 17.9015L19.3785 18.6393L20.4852 17.5326L19.7474 16.7947Z" fill="black"></path><path d="M17.9027 18.6409L16.7959 19.7477L17.5337 20.4855L18.6405 19.3788L17.9027 18.6409Z" fill="black"></path><path d="M18.6409 15.6896L17.5342 16.7964L18.272 17.5342L19.3788 16.4275L18.6409 15.6896Z" fill="black"></path><path d="M16.7962 17.5339L15.6895 18.6406L16.4273 19.3785L17.5341 18.2717L16.7962 17.5339Z" fill="black"></path><path d="M15.6893 5.35821L18.6406 8.30957L19.3785 7.57172L16.4271 4.62037L15.6893 5.35821Z" fill="black"></path><path d="M14.5827 6.46612L15.6895 7.57288L16.4273 6.83506L15.3205 5.7283L14.5827 6.46612Z" fill="black"></path><path d="M16.4274 8.31L17.5342 9.41675L18.272 8.67893L17.1652 7.57218L16.4274 8.31Z" fill="black"></path><path d="M16.7946 4.25225L17.9014 5.35901L18.6392 4.62116L17.5325 3.5144L16.7946 4.25225Z" fill="black"></path><path d="M18.6413 6.09771L19.748 7.20447L20.4859 6.46662L19.3791 5.35987L18.6413 6.09771Z" fill="black"></path><path d="M7.20331 19.748L4.25195 16.7966L3.5141 17.5345L6.46546 20.4858L7.20331 19.748Z" fill="black"></path><path d="M8.31086 18.64L7.2041 17.5332L6.46629 18.271L7.57304 19.3778L8.31086 18.64Z" fill="black"></path><path d="M6.46613 16.796L5.35938 15.6892L4.62153 16.4271L5.72828 17.5338L6.46613 16.796Z" fill="black"></path><path d="M9.41718 17.5336L6.46582 14.5823L5.72797 15.3201L8.67933 18.2715L9.41718 17.5336Z" fill="black"></path><path d="M4.25274 7.20465L7.2041 4.2533L6.46625 3.51545L3.5149 6.46681L4.25274 7.20465Z" fill="black"></path><path d="M5.35821 8.30976L8.30957 5.3584L7.57172 4.62055L4.62036 7.57191L5.35821 8.30976Z" fill="black"></path><path d="M6.46661 9.41706L9.41797 6.4657L8.68015 5.72788L5.7288 8.67924L6.46661 9.41706Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Nl2 = [
  Ul2
];
function ql2(r, e) {
  return n(), o("svg", Rl2, Nl2);
}
const Pz2 = /* @__PURE__ */ i(El2, [["render", ql2]]);
var zl2 = {}, Kl2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gl2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -520)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M23.2536 16.173C23.736 14.873 24 13.467 24 11.9991C24 10.5313 23.736 9.12521 23.2536 7.82522L12 6.78174L0.746391 7.82522C0.264047 9.12521 0 10.5313 0 11.9991C0 13.467 0.264047 14.873 0.746391 16.173L12 17.2165L23.2536 16.173Z" fill="#F0F0F0"></path><path d="M12.0007 23.9996C17.1603 23.9996 21.5588 20.7431 23.2543 16.1735H0.74707C2.44263 20.7431 6.8411 23.9996 12.0007 23.9996Z" fill="#D80027"></path><path d="M11.9997 -0.000488281C6.84012 -0.000488281 2.44166 3.25601 0.746094 7.82562H23.2534C21.5578 3.25601 17.1593 -0.000488281 11.9997 -0.000488281Z" fill="#6DA544"></path><path d="M3.51471 3.51453C-1.17157 8.20081 -1.17157 15.7988 3.51471 20.4852C4.73791 19.2619 5.93182 18.068 7.82609 16.1738V7.82595L3.51471 3.51453Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Wl2 = [
  Gl2
];
function Yl2(r, e) {
  return n(), o("svg", Kl2, Wl2);
}
const Az2 = /* @__PURE__ */ i(zl2, [["render", Yl2]]);
var Xl2 = {}, Ql2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jl2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -800)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"></path><path d="M11.9688 12.0004H12.0009C12.0009 11.9896 12.0009 11.9791 12.0009 11.9683C11.9902 11.979 11.9795 11.9897 11.9688 12.0004Z" fill="#F0F0F0"></path><path d="M12 6.26037C12 4.14889 12 2.76537 12 -0.000488281H11.998C5.37145 0.000636719 0 5.37275 0 11.9995H6.26086V8.474L9.78638 11.9995H11.9679C11.9786 11.9888 11.9893 11.9781 12 11.9674C12 11.1589 12 10.4376 12 9.78598L8.47444 6.26037H12Z" fill="#F0F0F0"></path><path d="M17.2169 8.86913C18.3695 8.86913 19.3038 7.93476 19.3038 6.78216C19.3038 5.62956 18.3695 4.69519 17.2169 4.69519C16.0642 4.69519 15.1299 5.62956 15.1299 6.78216C15.1299 7.93476 16.0642 8.86913 17.2169 8.86913Z" fill="#6DA544"></path><path d="M6.07027 1.56531C4.19344 2.63401 2.63311 4.19429 1.56445 6.07112V12.0001H4.69491V4.69586V4.69576H11.9993C11.9993 3.70843 11.9993 2.76784 11.9993 1.56531H6.07027Z" fill="#D80027"></path><path d="M11.9989 10.5239L7.73539 6.2605H6.25977V6.26059L11.9988 11.9996H11.9989C11.9989 11.9996 11.9989 10.9821 11.9989 10.5239Z" fill="#D80027"></path><path d="M20.8688 6.2605H13.5645V9.39095H20.8688V6.2605Z" fill="#D80027"></path><path d="M13.5654 14.0869V16.1739H14.6634C15.3218 16.8191 16.223 17.2174 17.2176 17.2174C18.2122 17.2174 19.1134 16.8191 19.7718 16.1739H19.8263H20.8698V14.0869H13.5654Z" fill="#FFDA44"></path><path d="M13.5654 8.86902V11.9995C13.5654 14.7951 17.2176 15.6516 17.2176 15.6516C17.2176 15.6516 20.8698 14.7951 20.8698 11.9995V8.86902H13.5654Z" fill="#338AF3"></path><path d="M17.2174 10.5404C16.3044 10.5404 16.3044 11.3752 15.3914 11.3752C14.4784 11.3752 14.4784 10.5404 13.5654 10.5404V12.0013C14.4784 12.0013 14.4784 12.8361 15.3914 12.8361C16.3044 12.8361 16.3044 12.0013 17.2174 12.0013C18.1304 12.0013 18.1304 12.8361 19.0436 12.8361C19.9567 12.8361 19.9566 12.0013 20.8698 12.0013V10.5404C19.9567 10.5404 19.9567 11.3752 19.0436 11.3752C18.1304 11.3752 18.1304 10.5404 17.2174 10.5404Z" fill="#F3F3F3"></path><path d="M17.2174 7.6167C16.3044 7.6167 16.3044 8.4515 15.3914 8.4515C14.4784 8.4515 14.4784 7.6167 13.5654 7.6167V9.07756C14.4784 9.07756 14.4784 9.91236 15.3914 9.91236C16.3044 9.91236 16.3044 9.07756 17.2174 9.07756C18.1304 9.07756 18.1304 9.91236 19.0436 9.91236C19.9567 9.91236 19.9566 9.07756 20.8698 9.07756V7.6167C19.9567 7.6167 19.9567 8.4515 19.0436 8.4515C18.1304 8.4515 18.1304 7.6167 17.2174 7.6167Z" fill="#F3F3F3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ts2 = [
  Jl2
];
function es2(r, e) {
  return n(), o("svg", Ql2, ts2);
}
const Sz2 = /* @__PURE__ */ i(Xl2, [["render", es2]]);
var rs2 = {}, ns2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, os2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -352)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"></path><path d="M18.783 12.1301H5.21777C5.21777 13.0666 6.03345 13.8258 6.96987 13.8258H6.91343C6.91343 14.7623 7.67257 15.5214 8.60909 15.5214C8.60909 16.458 9.36823 17.2171 10.3047 17.2171H13.6961C14.6326 17.2171 15.3917 16.458 15.3917 15.5214C16.3282 15.5214 17.0874 14.7623 17.0874 13.8258H17.0309C17.9673 13.8258 18.783 13.0666 18.783 12.1301Z" fill="#FFDA44"></path><path d="M16.696 9.91351C16.696 12.5068 14.5937 14.6092 12.0003 14.6092C9.40698 14.6092 7.30469 12.5068 7.30469 9.91351" fill="#338AF3"></path><path d="M15.5864 9.91238L14.1208 10.6018L14.9012 12.0212L13.3098 11.7167L13.1082 13.3243L11.9997 12.1419L10.8912 13.3243L10.6896 11.7167L9.09821 12.0211L9.87859 10.6017L8.41309 9.91238L9.87863 9.22304L9.09821 7.80371L10.6896 8.10812L10.8913 6.50049L11.9997 7.68291L13.1082 6.50049L13.3098 8.10812L14.9013 7.80371L14.1209 9.22308L15.5864 9.91238Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), is2 = [
  os2
];
function ls2(r, e) {
  return n(), o("svg", ns2, is2);
}
const Tz2 = /* @__PURE__ */ i(rs2, [["render", ls2]]);
var ss2 = {}, hs2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, as2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -632)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M22.809 6.78189C20.868 2.76794 16.7572 -0.000732422 11.9997 -0.000732422C7.24218 -0.000732422 3.13143 2.76794 1.19043 6.78189L11.9997 7.82538L22.809 6.78189Z" fill="#D80027"></path><path d="M1.19043 17.2162C3.13143 21.2302 7.24218 23.9988 11.9997 23.9988C16.7572 23.9988 20.868 21.2302 22.809 17.2162L11.9997 16.1727L1.19043 17.2162Z" fill="#D80027"></path><path d="M22.8093 6.78174H1.19072C0.427875 8.35932 0 10.1292 0 11.9991C0 13.869 0.427875 15.6389 1.19072 17.2165H22.8092C23.5722 15.6389 24 13.869 24 11.9991C24 10.1292 23.5722 8.35932 22.8093 6.78174Z" fill="#0052B4"></path><path d="M12.0001 16.1736C14.3052 16.1736 16.174 14.3049 16.174 11.9997C16.174 9.69452 14.3052 7.82581 12.0001 7.82581C9.69489 7.82581 7.82617 9.69452 7.82617 11.9997C7.82617 14.3049 9.69489 16.1736 12.0001 16.1736Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ds2 = [
  as2
];
function cs2(r, e) {
  return n(), o("svg", hs2, ds2);
}
const Oz2 = /* @__PURE__ */ i(ss2, [["render", cs2]]);
var _s2 = {}, Cs2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fs2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -744)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 -0.000732422C7.24218 -0.000732422 3.13143 2.76794 1.19043 6.78189H22.8089C20.868 2.76794 16.7572 -0.000732422 11.9997 -0.000732422Z" fill="#D80027"></path><path d="M11.9997 23.9993C16.7572 23.9993 20.868 21.2306 22.809 17.2167H1.19043C3.13143 21.2306 7.24218 23.9993 11.9997 23.9993Z" fill="#D80027"></path><path d="M15.131 14.0862L12.0006 8.34705L8.87012 14.0862H11.2179V15.6514H12.7832V14.0862H15.131Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), vs2 = [
  fs2
];
function us2(r, e) {
  return n(), o("svg", Cs2, vs2);
}
const Ez2 = /* @__PURE__ */ i(_s2, [["render", us2]]);
var ws2 = {}, ps2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gs2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -1248)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"></path><path d="M7.56543 16.1739H16.435L12.0002 5.73914L7.56543 16.1739Z" fill="#F3F3F3"></path><path d="M9.10645 15.1303L12 8.54858L14.8936 15.1303H9.10645Z" fill="#333333"></path><path d="M7.56543 16.1745H16.435L12.0002 12.0006L7.56543 16.1745Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), $s2 = [
  gs2
];
function Ms2(r, e) {
  return n(), o("svg", ps2, $s2);
}
const Rz2 = /* @__PURE__ */ i(ws2, [["render", Ms2]]);
var Ls2 = {}, ks2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ms2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -968)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 11.9995C24 18.6269 18.6274 23.9995 12 23.9995C5.37262 23.9995 0 18.6269 0 11.9995C0.521719 11.9995 12 10.4343 12 10.4343L24 11.9995Z" fill="#D80027"></path><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#0052B4"></path><path d="M8.87023 8.34736C8.87023 7.48294 8.16945 6.78216 7.30503 6.78216C6.90401 6.78216 6.53853 6.9331 6.26154 7.18102V6.26039H6.78326V5.21691H6.26154V4.69519H5.21806V5.21691H4.69634V6.26039H5.21806V7.18102C4.94108 6.9331 4.57559 6.78216 4.17458 6.78216C3.31016 6.78216 2.60938 7.48294 2.60938 8.34736C2.60938 8.81082 2.81098 9.22707 3.13109 9.51371V10.4343H8.34846V9.51371C8.66867 9.22707 8.87023 8.81082 8.87023 8.34736Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), xs2 = [
  ms2
];
function Hs2(r, e) {
  return n(), o("svg", ks2, xs2);
}
const Uz2 = /* @__PURE__ */ i(Ls2, [["render", Hs2]]);
var Vs2 = {}, Zs2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bs2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -1136)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z" fill="#FFDA44"></path><path d="M9.39149 2.08618H5.23672C5.0526 2.21204 4.87241 2.34306 4.69583 2.47867L3.65234 11.9992L4.69583 21.5197C4.87241 21.6554 5.0526 21.7864 5.23672 21.9122H9.39149V2.08618Z" fill="#FF9811"></path><path d="M0 12.0007C0 15.8793 1.84069 19.3276 4.69567 21.5212V2.4801C1.84069 4.67376 0 8.12199 0 12.0007Z" fill="#6DA544"></path><path d="M19.3047 7.31531V7.61582L19.3159 7.61751L19.3047 7.31531Z" fill="#FFDA44"></path><path d="M23.043 15.1296H20.7821L19.8256 16.1731V18.2601H17.7386V17.2166H18.7821V15.1296H14.0865V16.434H13.043V13.9482C12.7228 13.6616 12.5213 13.2453 12.5213 12.7818V5.99922C12.5213 5.1348 13.222 4.43401 14.0865 4.43401V14.0862H16.1734L16.8895 13.4894C16.7644 13.1915 16.6952 12.8644 16.6952 12.521V10.9558H15.13V7.82538H18.2604C18.2604 7.30366 19.043 6.78189 19.043 6.78189C19.043 6.78189 19.8256 7.30361 19.8256 7.82538V8.60801V10.9558C20.4061 10.9627 21.3283 10.9477 22.3246 10.9558C22.0629 10.4983 21.9125 9.95548 21.9125 9.39063C21.9125 8.46996 22.31 7.64224 22.9428 7.06943C22.0308 5.04841 20.5755 3.32518 18.763 2.08618H10.9561V21.9123H18.763C20.967 20.4057 22.6428 18.1833 23.4558 15.5799L23.043 15.1296Z" fill="#A2001D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Fs2 = [
  Bs2
];
function js2(r, e) {
  return n(), o("svg", Zs2, Fs2);
}
const Nz2 = /* @__PURE__ */ i(Vs2, [["render", js2]]);
var Is2 = {}, bs2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ys2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -856)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M2.74316 4.36307H21.2573C20.5735 3.53502 19.7804 2.80073 18.9006 2.18127H5.0999C4.2201 2.80063 3.42702 3.53498 2.74316 4.36307Z" fill="#F0F0F0"></path><path d="M0 12.0005C0 12.3684 0.0174844 12.732 0.049875 13.0915H23.9501C23.9825 12.732 24 12.3684 24 12.0005C24 11.6327 23.9825 11.2691 23.9501 10.9097H0.049875C0.0174844 11.2691 0 11.6327 0 12.0005Z" fill="#F0F0F0"></path><path d="M1.30884 17.4546H22.6917C23.0451 16.7634 23.3332 16.0335 23.5484 15.2728H0.452148C0.667258 16.0335 0.955539 16.7634 1.30884 17.4546Z" fill="#F0F0F0"></path><path d="M5.0999 21.818H18.9005C19.7803 21.1986 20.5734 20.4643 21.2572 19.6362H2.74316C3.42702 20.4642 4.2201 21.1986 5.0999 21.818Z" fill="#F0F0F0"></path><path d="M0.452148 8.72782H23.5485C23.3333 7.96713 23.0451 7.23719 22.6918 6.54602H1.30888C0.955586 7.23719 0.667305 7.96713 0.452148 8.72782Z" fill="#F0F0F0"></path><path d="M5.73926 2.18192H18.9004C16.9486 0.807638 14.5687 0.00012207 12.0001 0.00012207C10.4349 0.00012207 7.69113 0.807638 5.73926 2.18192Z" fill="#D80027"></path><path d="M11.4785 6.54532H22.6917C22.2926 5.76471 21.8107 5.03351 21.2573 4.36353H11.4785V6.54532Z" fill="#D80027"></path><path d="M11.4785 10.9085H23.9504C23.8829 10.1593 23.7472 9.42976 23.5484 8.72668H11.4785V10.9085Z" fill="#D80027"></path><path d="M0.451805 15.2737H23.5481C23.7469 14.5707 23.8826 13.8411 23.9501 13.0919H0.0498047C0.117305 13.8411 0.252961 14.5706 0.451805 15.2737Z" fill="#D80027"></path><path d="M2.74297 19.6369H21.2571C21.8105 18.9668 22.2924 18.2356 22.6915 17.4551H1.30859C1.70764 18.2357 2.18961 18.9669 2.74297 19.6369Z" fill="#D80027"></path><path d="M11.9999 24.0005C14.5685 24.0005 16.9484 23.193 18.9003 21.8187H5.09961C7.05148 23.193 9.43133 24.0005 11.9999 24.0005Z" fill="#D80027"></path><path d="M0.451758 8.72692C0.252914 9.43004 0.117305 10.1596 0.0498047 10.9087H11.9999V-0.000366211C6.50711 -0.000366211 1.87638 3.6902 0.451758 8.72692Z" fill="#0052B4"></path><path d="M7.14405 3.13049L7.92101 5.52182H10.4357L8.40138 6.99989L9.17829 9.39136L7.14405 7.91339L5.10973 9.39136L5.88682 6.99989L3.85254 5.52182H6.36705L7.14405 3.13049Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ds2 = [
  ys2
];
function Ps2(r, e) {
  return n(), o("svg", bs2, Ds2);
}
const qz2 = /* @__PURE__ */ i(Is2, [["render", Ps2]]);
var As2 = {}, Ss2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ts2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -800)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 11.9999C0 13.8697 0.427828 15.6396 1.19072 17.2173L12 17.739L22.8093 17.2173C23.5722 15.6396 24 13.8697 24 11.9999C24 10.13 23.5722 8.36013 22.8093 6.78251L12 6.26074L1.19072 6.78246C0.427828 8.36013 0 10.13 0 11.9999Z" fill="#F0F0F0"></path><path d="M12.0007 24C16.7582 24 20.869 21.2314 22.81 17.2174H1.19141C3.13241 21.2314 7.24316 24 12.0007 24Z" fill="#6DA544"></path><path d="M12.0007 -0.000732422C7.24316 -0.000732422 3.13241 2.76794 1.19141 6.78189H22.8099C20.869 2.76794 16.7582 -0.000732422 12.0007 -0.000732422Z" fill="#0052B4"></path><path d="M12.7828 11.7392V8.86963H11.2176V11.7392L9.32715 13.6297C9.87694 14.5297 10.8684 15.1305 12.0002 15.1305C13.1321 15.1305 14.1235 14.5297 14.6733 13.6297L12.7828 11.7392Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Os2 = [
  Ts2
];
function Es2(r, e) {
  return n(), o("svg", Ss2, Os2);
}
const zz2 = /* @__PURE__ */ i(As2, [["render", Es2]]);
var Rs2 = {}, Us2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ns2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -1024)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M23.2536 16.1743C23.736 14.8744 24 13.4683 24 12.0005C24 10.5326 23.736 9.1265 23.2536 7.82656L12 6.78308L0.746391 7.82656C0.264 9.1265 0 10.5326 0 12.0005C0 13.4683 0.264 14.8744 0.746391 16.1743L12 17.2178L23.2536 16.1743Z" fill="#6DA544"></path><path d="M23.2533 7.82574C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2533Z" fill="#FFDA44"></path><path d="M12.0007 24.0008C17.1603 24.0008 21.5588 20.7443 23.2543 16.1747H0.74707C2.44259 20.7443 6.8411 24.0008 12.0007 24.0008Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), qs2 = [
  Ns2
];
function zs2(r, e) {
  return n(), o("svg", Us2, qs2);
}
const Kz2 = /* @__PURE__ */ i(Rs2, [["render", zs2]]);
var Ks2 = {}, Gs2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ws2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -1080)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 -0.000366211C6.84012 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z" fill="#D80027"></path><path d="M12.0007 24.0008C17.1603 24.0008 21.5588 20.7443 23.2543 16.1747H0.74707C2.44259 20.7443 6.8411 24.0008 12.0007 24.0008Z" fill="#338AF3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ys2 = [
  Ws2
];
function Xs2(r, e) {
  return n(), o("svg", Gs2, Ys2);
}
const Gz2 = /* @__PURE__ */ i(Ks2, [["render", Xs2]]);
var Qs2 = {}, Js2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, th2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -688)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12.0007 -0.000732422C6.45634 -0.000732422 1.79106 3.75963 0.414062 8.86881H23.5873C22.2103 3.75963 17.545 -0.000732422 12.0007 -0.000732422Z" fill="#A2001D"></path><path d="M12.0007 23.9986C17.545 23.9986 22.2103 20.2382 23.5873 15.129H0.414062C1.79106 20.2382 6.45634 23.9986 12.0007 23.9986Z" fill="#A2001D"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), eh2 = [
  th2
];
function rh2(r, e) {
  return n(), o("svg", Js2, eh2);
}
const Wz2 = /* @__PURE__ */ i(Qs2, [["render", rh2]]);
var nh2 = {}, oh2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ih2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -912)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M1.19072 6.78274C0.427875 8.36037 0 10.1302 0 12.0001C0 13.87 0.427875 15.6399 1.19072 17.2175L12 18.261L22.8093 17.2175C23.5721 15.6399 24 13.87 24 12.0001C24 10.1302 23.5721 8.36037 22.8093 6.78274L12 5.73926L1.19072 6.78274Z" fill="black"></path><path d="M1.19141 17.2168C3.13231 21.2307 7.24273 23.9994 12.0003 23.9994C16.7577 23.9994 20.8682 21.2307 22.8091 17.2168H1.19141Z" fill="#496E2D"></path><path d="M1.19141 6.78299H22.8091C20.8682 2.76904 16.7577 0.000366211 12.0003 0.000366211C7.24273 0.000366211 3.13231 2.76904 1.19141 6.78299Z" fill="#D80027"></path><path d="M14.7929 9.80481L15.7775 11.1616L17.372 10.6446L16.3859 12.0002L17.3704 13.357L15.7764 12.838L14.7903 14.1936L14.7913 12.5173L13.1973 11.9983L14.7919 11.4812L14.7929 9.80481Z" fill="#F0F0F0"></path><path d="M12.1062 15.3904C10.2332 15.3904 8.71485 13.8721 8.71485 11.9991C8.71485 10.1262 10.2332 8.60782 12.1062 8.60782C12.6901 8.60782 13.2396 8.75548 13.7194 9.01545C12.9667 8.27946 11.9376 7.8252 10.8018 7.8252C8.4966 7.8252 6.62793 9.69391 6.62793 11.9991C6.62793 14.3043 8.49665 16.173 10.8018 16.173C11.9376 16.173 12.9668 15.7187 13.7194 14.9827C13.2396 15.2428 12.6902 15.3904 12.1062 15.3904Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), lh2 = [
  ih2
];
function sh2(r, e) {
  return n(), o("svg", oh2, lh2);
}
const Yz2 = /* @__PURE__ */ i(nh2, [["render", sh2]]);
var hh2 = {}, ah2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dh2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -744)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M19.0924 9.84775H13.6749L12.0008 4.69543L10.3267 9.84775H4.90918L9.29204 13.0321L7.6179 18.1845L12.0008 15.0002L16.3837 18.1846L14.7096 13.0321L19.0924 9.84775ZM10.5187 12.6335L11.0848 10.8912H12.9167L13.4829 12.6335V12.6335L12.0008 13.7103L10.5188 12.6335L10.5187 12.6335ZM12.5777 9.84775H11.4239L12.0008 8.07212L12.5777 9.84775ZM14.3705 11.9886L14.0139 10.8912H15.8809L14.3705 11.9886ZM9.98766 10.8912L9.63109 11.9886L8.12063 10.8912H9.98766ZM9.60273 15.4526L10.1797 13.6771L11.1132 14.3552L9.60273 15.4526ZM12.8884 14.3553L13.8219 13.6771L14.3989 15.4527L12.8884 14.3553Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ch2 = [
  dh2
];
function _h2(r, e) {
  return n(), o("svg", ah2, ch2);
}
const Xz2 = /* @__PURE__ */ i(hh2, [["render", _h2]]);
var Ch2 = {}, fh2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vh2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -520)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), uh2 = [
  vh2
];
function wh2(r, e) {
  return n(), o("svg", fh2, uh2);
}
const Qz2 = /* @__PURE__ */ i(Ch2, [["render", wh2]]);
var ph2 = {}, gh2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $h2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -464)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M17.2175 1.19133C15.6399 0.428485 13.87 0.000610352 12.0001 0.000610352C10.1303 0.000610352 8.36037 0.428485 6.78274 1.19133L5.73926 12.0006L6.78274 22.8099C8.36037 23.5727 10.1303 24.0006 12.0001 24.0006C13.87 24.0006 15.6399 23.5727 17.2175 22.8099L18.261 12.0006L17.2175 1.19133Z" fill="#FFDA44"></path><path d="M6.78262 1.19214C2.76872 3.13309 0 7.24351 0 12.001C0 16.7585 2.76872 20.8689 6.78262 22.8099V1.19214Z" fill="#0052B4"></path><path d="M17.2178 1.19214V22.8099C21.2317 20.8689 24.0004 16.7585 24.0004 12.001C24.0004 7.24351 21.2317 3.13309 17.2178 1.19214Z" fill="#D80027"></path><path d="M16.174 9.44228H13.3044C13.3044 8.72191 12.7204 8.13794 12.0001 8.13794C11.2797 8.13794 10.6957 8.72191 10.6957 9.44228H7.82617C7.82617 10.1515 8.44403 10.7265 9.1532 10.7265H9.11045C9.11045 11.4358 9.68542 12.0108 10.3947 12.0108C10.3947 12.6388 10.8458 13.1606 11.4415 13.2722L10.4294 15.5569C10.9143 15.754 11.4443 15.8636 12.0001 15.8636C12.5558 15.8636 13.0858 15.754 13.5707 15.5569L12.5587 13.2722C13.1544 13.1606 13.6054 12.6388 13.6054 12.0108C14.3147 12.0108 14.8897 11.4358 14.8897 10.7265H14.8469C15.5561 10.7265 16.174 10.1515 16.174 9.44228Z" fill="#FF9811"></path><path d="M12.0003 11.2178L10.3047 12.0004V13.5656L12.0003 14.6091L13.696 13.5656V12.0004L12.0003 11.2178Z" fill="#0052B4"></path><path d="M13.696 10.4341H10.3047V11.9993H13.696V10.4341Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Mh2 = [
  $h2
];
function Lh2(r, e) {
  return n(), o("svg", gh2, Mh2);
}
const Jz2 = /* @__PURE__ */ i(ph2, [["render", Lh2]]);
var kh2 = {}, mh2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xh2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -632)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M24 11.9997C24 7.88122 21.9249 4.24775 18.7635 2.08667H5.23655C2.07516 4.24775 0 7.88122 0 11.9997C0 16.1183 2.07516 19.7517 5.23655 21.9127H18.7635C21.9249 19.7517 24 16.1183 24 11.9997Z" fill="#A2001D"></path><path d="M9.3916 8.87015H14.609V6.78323L13.5655 7.30495L12.0003 5.73975L10.4351 7.30495L9.3916 6.78323V8.87015Z" fill="#FFDA44"></path><path d="M16.6961 12.0003H14.0884C14.1907 11.8234 14.2501 11.6187 14.2501 11.3997C14.2501 10.7347 13.711 10.1957 13.0461 10.1957C12.5867 10.1957 12.1877 10.4531 11.9846 10.8314C11.7816 10.4531 11.3826 10.1957 10.9232 10.1957C10.2583 10.1957 9.71917 10.7347 9.71917 11.3997C9.71917 11.6188 9.7787 11.8235 9.88089 12.0003H7.30469C7.30469 12.7983 7.9997 13.4451 8.79761 13.4451H8.74952C8.74952 14.0996 9.18484 14.6523 9.7817 14.8298L8.60903 16.0026L9.7158 17.1093L11.2858 15.5393C11.3473 15.5619 11.4109 15.5799 11.4767 15.5923L10.528 17.7342C10.9826 17.9191 11.4794 18.0217 12.0004 18.0217C12.5214 18.0217 13.0182 17.9191 13.4729 17.7342L12.5242 15.5923C12.5899 15.5799 12.6535 15.5619 12.715 15.5393L14.285 17.1093L15.3917 16.0026L14.219 14.8298C14.8158 14.6522 15.2512 14.0997 15.2512 13.4451H15.203C16.001 13.4451 16.6961 12.7983 16.6961 12.0003Z" fill="#FFDA44"></path><path d="M12.0003 12.7828L10.3047 13.5654V15.1307L12.0003 16.1741L13.696 15.1307V13.5654L12.0003 12.7828Z" fill="#6DA544"></path><path d="M13.696 11.9991H10.3047V14.0861H13.696V11.9991Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Hh2 = [
  xh2
];
function Vh2(r, e) {
  return n(), o("svg", mh2, Hh2);
}
const tK2 = /* @__PURE__ */ i(kh2, [["render", Vh2]]);
var Zh2 = {}, Bh2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fh2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -1192)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M7.82617 11.9995V23.2531C9.12611 23.7355 10.5322 23.9995 12.0001 23.9995C18.6274 23.9995 24.0001 18.6268 24.0001 11.9995C24.0001 5.37208 7.82617 11.9995 7.82617 11.9995Z" fill="#6DA544"></path><path d="M12.0001 0.000366211C10.5322 0.000366211 9.12611 0.264413 7.82617 0.746757V12.0004C7.82617 12.0004 18.4697 12.0004 24.0001 12.0004C24.0001 5.37299 18.6274 0.000366211 12.0001 0.000366211Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), jh2 = [
  Fh2
];
function Ih2(r, e) {
  return n(), o("svg", Bh2, jh2);
}
const eK2 = /* @__PURE__ */ i(Zh2, [["render", Ih2]]);
var bh2 = {}, yh2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Dh2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -128)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 9.98611 23.5031 8.08847 22.6265 6.42188L11.9859 12.0141L17.5781 1.37353C15.9115 0.496875 14.0139 0 12 0C5.37262 0 0 5.37262 0 12C0 15.3137 1.34316 18.3137 3.51469 20.4853C5.68627 22.6569 8.68627 24 12 24Z" fill="#0052B4"></path><path d="M22.6141 6.43435C22.0648 5.38885 21.3507 4.40724 20.4716 3.52815C19.5925 2.64906 18.611 1.93492 17.5654 1.38568L3.50098 20.4987L22.6141 6.43435Z" fill="#F0F0F0"></path><path d="M3.50098 20.4994L22.6141 6.43501C22.0648 5.38951 21.3507 4.4079 20.4716 3.52881L3.50098 20.4994Z" fill="#FF9811"></path><path d="M10.4204 7.03688L8.95485 7.72622L9.73527 9.1456L8.14387 8.84114L7.94221 10.4488L6.83371 9.26635L5.72521 10.4488L5.52365 8.84114L3.93224 9.1455L4.71257 7.72617L3.24707 7.03688L4.71262 6.34749L3.93224 4.9282L5.52355 5.23256L5.72526 3.62494L6.83371 4.80736L7.94221 3.62494L8.14387 5.23256L9.73532 4.9282L8.9549 6.34753L10.4204 7.03688Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ph2 = [
  Dh2
];
function Ah2(r, e) {
  return n(), o("svg", yh2, Ph2);
}
const rK2 = /* @__PURE__ */ i(bh2, [["render", Ah2]]);
var Sh2 = {}, Th2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Oh2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -968)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M13.8259 23.8624C15.7776 23.5647 17.5741 22.7961 19.0973 21.6772L12.001 12.0004L13.8259 23.8624Z" fill="#D80027"></path><path d="M10.1757 0.137695C8.22408 0.435445 6.42755 1.20401 4.9043 2.32287L12.0007 11.9997L10.1757 0.137695Z" fill="#D80027"></path><path d="M4.9043 21.6772C6.42745 22.7961 8.22398 23.5646 10.1756 23.8625L12.0007 12.0004L4.9043 21.6772Z" fill="#D80027"></path><path d="M2.32384 4.90234C1.20494 6.42559 0.436469 8.22208 0.138672 10.1738L12.0007 11.9988L2.32384 4.90234Z" fill="#D80027"></path><path d="M0.138672 13.8253C0.436422 15.777 1.20498 17.5735 2.32389 19.0967L12.0007 12.0004L0.138672 13.8253Z" fill="#D80027"></path><path d="M23.863 10.174C23.5652 8.22233 22.7967 6.42579 21.6778 4.90259L12.001 11.999L23.863 10.174Z" fill="#D80027"></path><path d="M19.0973 2.32282C17.5741 1.20396 15.7776 0.435445 13.8259 0.137695L12.001 11.9997L19.0973 2.32282Z" fill="#D80027"></path><path d="M21.6779 19.0967C22.7968 17.5735 23.5653 15.7769 23.8631 13.8254L12.001 12.0004L21.6779 19.0967Z" fill="#D80027"></path><path d="M12.001 16.1743C14.3062 16.1743 16.1749 14.3056 16.1749 12.0004C16.1749 9.69525 14.3062 7.82654 12.001 7.82654C9.69586 7.82654 7.82715 9.69525 7.82715 12.0004C7.82715 14.3056 9.69586 16.1743 12.001 16.1743Z" fill="#D80027"></path><path d="M12.0006 15.1297C13.7295 15.1297 15.131 13.7281 15.131 11.9992C15.131 10.2703 13.7295 8.86877 12.0006 8.86877C10.2717 8.86877 8.87012 10.2703 8.87012 11.9992C8.87012 13.7281 10.2717 15.1297 12.0006 15.1297Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Eh2 = [
  Oh2
];
function Rh2(r, e) {
  return n(), o("svg", Th2, Eh2);
}
const nK2 = /* @__PURE__ */ i(Sh2, [["render", Rh2]]);
var Uh2 = {}, Nh2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qh2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -16)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M16.1745 0.745902C14.8745 0.263559 13.4684 -0.000488281 12.0006 -0.000488281C10.5327 -0.000488281 9.12667 0.263559 7.82669 0.745902L6.7832 11.9995L7.82669 23.2531C9.12667 23.7355 10.5327 23.9995 12.0006 23.9995C13.4684 23.9995 14.8745 23.7355 16.1745 23.2531L17.218 11.9995L16.1745 0.745902Z" fill="#FFDA44"></path><path d="M23.9999 12.0002C23.9999 6.84067 20.7434 2.44211 16.1738 0.746643V23.2539C20.7434 21.5583 23.9999 17.1598 23.9999 12.0002Z" fill="#D80027"></path><path d="M0 11.9994C0 17.159 3.2565 21.5575 7.82611 23.2531V0.74585C3.2565 2.44132 0 6.83988 0 11.9994Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), zh2 = [
  qh2
];
function Kh2(r, e) {
  return n(), o("svg", Nh2, zh2);
}
const oK2 = /* @__PURE__ */ i(Uh2, [["render", Kh2]]);
var Gh2 = {}, Wh2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yh2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -856)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M23.2536 16.1744C23.736 14.8744 24 13.4683 24 12.0005C24 10.5326 23.736 9.1265 23.2536 7.82657L12 6.78308L0.746391 7.82657C0.264047 9.1265 0 10.5326 0 12.0005C0 13.4683 0.264047 14.8744 0.746391 16.1744L12 17.2178L23.2536 16.1744Z" fill="#6DA544"></path><path d="M23.2533 7.82599C21.5578 3.25638 17.1593 -0.00012207 11.9997 -0.00012207C6.84013 -0.00012207 2.44161 3.25638 0.746094 7.82599H23.2533Z" fill="#FFDA44"></path><path d="M11.9997 23.9991C17.1593 23.9991 21.5578 20.7426 23.2533 16.173H0.746094C2.44161 20.7426 6.84012 23.9991 11.9997 23.9991Z" fill="#D80027"></path><path d="M20.2292 10.153H13.9429L12.0003 4.17444L10.0577 10.153H3.77148L8.85719 13.848L6.91459 19.8267L12.0003 16.1744L17.0861 19.8266L15.1435 13.8479L20.2292 10.153Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Xh2 = [
  Yh2
];
function Qh2(r, e) {
  return n(), o("svg", Wh2, Xh2);
}
const iK2 = /* @__PURE__ */ i(Gh2, [["render", Qh2]]);
var Jh2 = {}, ta2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ea2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -576)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M11.9994 24.0006C13.4672 24.0006 14.8733 23.7366 16.1733 23.2542L16.695 12.0006L16.1733 0.747001C14.8733 0.264657 13.4672 0.000610352 11.9994 0.000610352C10.5315 0.000610352 9.12541 0.264657 7.82548 0.747001L7.30371 12.0006L7.82543 23.2542C9.12541 23.7366 10.5315 24.0006 11.9994 24.0006Z" fill="#0052B4"></path><path d="M0 12.0001C0 17.1596 3.2565 21.5582 7.82611 23.2537V0.74646C3.2565 2.44198 0 6.84049 0 12.0001Z" fill="#A2001D"></path><path d="M16.1738 0.745972V23.2532C20.7434 21.5577 23.9999 17.1592 23.9999 11.9996C23.9999 6.84 20.7434 2.44149 16.1738 0.745972Z" fill="#A2001D"></path><path d="M6.78274 11.9989H5.73926V16.1728H6.78274V11.9989Z" fill="#FFDA44"></path><path d="M2.60891 11.9989H1.56543V16.1728H2.60891V11.9989Z" fill="#FFDA44"></path><path d="M4.17434 14.6085C4.75064 14.6085 5.21783 14.1413 5.21783 13.565C5.21783 12.9887 4.75064 12.5215 4.17434 12.5215C3.59804 12.5215 3.13086 12.9887 3.13086 13.565C3.13086 14.1413 3.59804 14.6085 4.17434 14.6085Z" fill="#FFDA44"></path><path d="M4.17406 10.4336C4.4622 10.4336 4.69578 10.2 4.69578 9.91185C4.69578 9.62372 4.4622 9.39014 4.17406 9.39014C3.88593 9.39014 3.65234 9.62372 3.65234 9.91185C3.65234 10.2 3.88593 10.4336 4.17406 10.4336Z" fill="#FFDA44"></path><path d="M5.21783 15.1288H3.13086V16.1723H5.21783V15.1288Z" fill="#FFDA44"></path><path d="M5.21783 10.9551H3.13086V11.9986H5.21783V10.9551Z" fill="#FFDA44"></path><path d="M4.17458 6.26001L4.54414 7.3972H5.73983L4.77256 8.10004L5.14184 9.23723L4.17458 8.53439L3.20736 9.23723L3.57664 8.10004L2.60938 7.3972H3.80506L4.17458 6.26001Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ra2 = [
  ea2
];
function na2(r, e) {
  return n(), o("svg", ta2, ra2);
}
const lK2 = /* @__PURE__ */ i(Jh2, [["render", na2]]);
var oa2 = {}, ia2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, la2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -1136)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D"></path><path d="M14.0872 11.5003C13.7927 11.5003 13.513 11.559 13.2533 11.6525C13.3956 11.3354 13.491 10.9826 13.491 10.6059C13.491 9.11521 12.0003 7.99719 12.0003 7.99719C12.0003 7.99719 10.5096 9.11521 10.5096 10.6059C10.5096 10.9826 10.605 11.3354 10.7473 11.6525C10.4875 11.5591 10.2079 11.5003 9.91337 11.5003C8.4227 11.5003 7.30469 12.9909 7.30469 12.9909C7.30469 12.9909 8.4227 14.4816 9.91337 14.4816C10.7874 14.4816 11.5328 13.9694 12.0003 13.5454C12.4679 13.9693 13.2133 14.4816 14.0873 14.4816C15.578 14.4816 16.696 12.9909 16.696 12.9909C16.696 12.9909 15.5779 11.5003 14.0872 11.5003Z" fill="#F0F0F0"></path><path d="M12.0006 4.69458L12.3086 5.64221H13.305L12.499 6.22796L12.8066 7.17558L12.0006 6.58983L11.1946 7.17558L11.5023 6.22796L10.6963 5.64221H11.6927L12.0006 4.69458Z" fill="#FFDA44"></path><path d="M8.2111 6.35156L8.80351 6.88491L9.49384 6.48637L9.16965 7.21458L9.76201 7.74802L8.96926 7.66467L8.64507 8.39288L8.47923 7.6132L7.68652 7.52986L8.3768 7.13123L8.2111 6.35156Z" fill="#FFDA44"></path><path d="M5.4375 9.12594L6.21722 9.29164L6.6158 8.60132L6.69914 9.39402L7.47877 9.55986L6.75061 9.8841L6.83395 10.6768L6.30047 10.0845L5.57231 10.4087L5.97089 9.7183L5.4375 9.12594Z" fill="#FFDA44"></path><path d="M15.7891 6.35156L15.1968 6.88491L14.5065 6.48637L14.8306 7.21458L14.2383 7.74802L15.031 7.66467L15.3552 8.39288L15.5211 7.6132L16.3138 7.52986L15.6235 7.13123L15.7891 6.35156Z" fill="#FFDA44"></path><path d="M18.5627 9.12594L17.783 9.29164L17.3845 8.60132L17.3011 9.39402L16.5215 9.55986L17.2496 9.8841L17.1663 10.6768L17.6998 10.0845L18.4279 10.4087L18.0294 9.7183L18.5627 9.12594Z" fill="#FFDA44"></path><path d="M11.9997 18.6554C13.1838 18.6554 14.2752 18.2603 15.1507 17.5956H8.84863C9.72416 18.2603 10.8156 18.6554 11.9997 18.6554Z" fill="#F0F0F0"></path><path d="M7.2168 15.5243C7.38241 15.9033 7.59241 16.2583 7.83906 16.5841H16.1602C16.4069 16.2584 16.6169 15.9033 16.7825 15.5243H7.2168Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), sa2 = [
  la2
];
function ha2(r, e) {
  return n(), o("svg", ia2, sa2);
}
const sK2 = /* @__PURE__ */ i(oa2, [["render", ha2]]);
var aa2 = {}, da2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ca2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -128)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"></path><path d="M11.6216 19.5561C11.2981 19.5405 11.0304 19.3302 10.9256 19.0448C10.7404 19.2864 10.4221 19.408 10.1085 19.3271C9.79442 19.2462 9.57482 18.9864 9.52939 18.6848C9.29877 18.8841 8.96277 18.9383 8.67219 18.796C8.38105 18.653 8.2183 18.354 8.23499 18.0498C7.96944 18.199 7.62927 18.1844 7.3731 17.9861C7.11744 17.7879 7.01778 17.4628 7.09499 17.168C6.80488 17.2609 6.47516 17.1785 6.26385 16.9327C6.05253 16.6875 6.02014 16.3489 6.15482 16.076C5.85219 16.1083 5.54544 15.9612 5.38785 15.6785C5.22974 15.3957 5.2663 15.0571 5.45357 14.8165C5.15043 14.7873 4.87911 14.5812 4.78208 14.2723C4.68453 13.9635 4.78888 13.639 5.02105 13.4412C4.72991 13.3514 4.5066 13.0947 4.47374 12.7728C4.44088 12.451 4.60785 12.1551 4.87442 12.008C4.6078 11.8619 4.4398 11.5661 4.47163 11.2447C4.47163 11.2447 4.47163 11.2447 4.47214 11.2447C4.50397 10.9222 4.72728 10.6651 5.01786 10.5742C4.78569 10.377 4.68032 10.053 4.77683 9.74411C4.87335 9.43474 5.1441 9.22811 5.44728 9.19783C5.25997 8.95783 5.22243 8.61916 5.37946 8.33594C5.53649 8.05315 5.84328 7.90549 6.14643 7.93732C6.01077 7.66446 6.0426 7.32583 6.25339 7.0796C6.46367 6.83388 6.79339 6.75091 7.08402 6.84274C7.00574 6.54846 7.10488 6.22291 7.36053 6.02416C7.61567 5.82532 7.95585 5.81018 8.22139 5.95835C8.20419 5.65422 8.36642 5.35521 8.65705 5.21172C8.94716 5.06875 9.28368 5.122 9.51477 5.32127C9.55911 5.01977 9.77877 4.75891 10.0923 4.67744C10.4053 4.59607 10.7236 4.71658 10.9093 4.95761C11.0142 4.67224 11.2813 4.46144 11.6048 4.44527C11.9278 4.42863 12.2147 4.61013 12.3483 4.88308C12.508 4.62429 12.8116 4.47091 13.1315 4.51943C13.4518 4.56743 13.6976 4.80321 13.7737 5.09805C13.9824 4.87572 14.3111 4.7876 14.6148 4.89921C14.9189 5.01138 15.112 5.29207 15.1266 5.59675C15.3755 5.42149 15.7156 5.4011 15.9906 5.57224C16.2656 5.74286 16.3976 6.05641 16.3506 6.35744C16.6297 6.2359 16.9668 6.28441 17.2016 6.50664C17.4364 6.72944 17.5031 7.06282 17.3967 7.34819C17.6946 7.28505 18.015 7.39985 18.2007 7.66539C18.3864 7.93043 18.3849 8.2706 18.2237 8.52888C18.5278 8.52677 18.8185 8.70419 18.9473 9.00105C19.0757 9.29843 19.0052 9.63185 18.795 9.85254C19.094 9.91202 19.3428 10.1442 19.4085 10.4614C19.4737 10.7786 19.3376 11.0901 19.0877 11.2638C19.3673 11.3823 19.5645 11.6593 19.5651 11.9828C19.5651 11.9864 19.5651 11.9896 19.5651 11.9933C19.5651 11.9954 19.5651 11.998 19.5651 12.0001C19.5651 12.3235 19.3689 12.6011 19.0892 12.7206C19.3397 12.8933 19.4769 13.2048 19.4117 13.522C19.347 13.8392 19.0986 14.0719 18.7997 14.1324C19.0105 14.3526 19.082 14.6854 18.9541 14.9834C18.8263 15.2808 18.5357 15.4587 18.231 15.4571C18.3927 15.7154 18.3953 16.0556 18.2101 16.3211C18.0249 16.5867 17.7051 16.7025 17.4072 16.6399C17.5141 16.9248 17.4478 17.2587 17.2136 17.482C16.9788 17.7048 16.6423 17.7538 16.3632 17.6333C16.4106 17.9338 16.2792 18.2479 16.0047 18.4196C15.7303 18.5913 15.3901 18.5714 15.1407 18.3966C15.1266 18.7013 14.9346 18.9826 14.631 19.0953C14.631 19.0953 14.631 19.0953 14.6305 19.0953C14.3268 19.2074 13.9981 19.1198 13.7889 18.8981C13.7138 19.1934 13.4686 19.4297 13.1482 19.4788C12.8284 19.5273 12.5242 19.375 12.3641 19.1162C12.2368 19.3786 11.9676 19.557 11.6608 19.557C11.6477 19.5572 11.6346 19.5567 11.6216 19.5561Z" fill="#F3F3F3"></path><path d="M12.0006 17.2183C14.8821 17.2183 17.218 14.8824 17.218 12.0009C17.218 9.11941 14.8821 6.78351 12.0006 6.78351C9.1191 6.78351 6.7832 9.11941 6.7832 12.0009C6.7832 14.8824 9.1191 17.2183 12.0006 17.2183Z" fill="#338AF3"></path><path d="M13.142 10.2289C13.3983 10.0388 13.5652 9.73488 13.5652 9.39119V8.86947C13.5652 8.29315 13.0981 7.82599 12.5217 7.82599H11.4783C10.902 7.82599 10.4348 8.29315 10.4348 8.86947V9.39119C10.4348 9.73488 10.6017 10.0388 10.858 10.2289L9.91309 19.8259C9.91309 19.8259 10.4348 20.3478 12.0001 20.3478C13.5653 20.3478 14.087 19.8259 14.087 19.8259L13.142 10.2289Z" fill="#BDBCC1"></path><path d="M12.0002 7.82599L12.9067 10.6159H15.8404L13.4671 12.3403L14.3735 15.1303L12.0002 13.406L9.62687 15.1303L10.5335 12.3403L8.16016 10.6159H11.0937L12.0002 7.82599Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), _a2 = [
  ca2
];
function Ca2(r, e) {
  return n(), o("svg", da2, _a2);
}
const hK2 = /* @__PURE__ */ i(aa2, [["render", Ca2]]);
var fa2 = {}, va2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ua2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -184)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.8964 10.4353C23.5654 7.90475 22.4287 5.45947 20.4845 3.51533C18.5404 1.57119 16.095 0.434425 13.5645 0.103394L13.5645 10.4353H23.8964Z" fill="#0052B4"></path><path d="M10.4345 0.104065C7.9039 0.435096 5.45857 1.57182 3.51443 3.51596C1.57034 5.46014 0.43357 7.90547 0.102539 10.4361L10.4345 10.4361L10.4345 0.104065Z" fill="#0052B4"></path><path d="M0.102539 13.5664C0.43357 16.097 1.57034 18.5424 3.51443 20.4865C5.45857 22.4306 7.90385 23.5673 10.4345 23.8984L10.4345 13.5665L0.102539 13.5664Z" fill="#0052B4"></path><path d="M13.5645 23.8983C16.095 23.5673 18.5403 22.4306 20.4845 20.4864C22.4286 18.5423 23.5653 16.097 23.8964 13.5664H13.5645V23.8983Z" fill="#0052B4"></path><path d="M16.0961 7.61471C16.0961 7.45515 16.2258 7.32545 16.3854 7.32545H17.0053C17.9851 7.32545 18.7823 6.52829 18.7823 5.54846C18.7823 4.56863 17.9852 3.77143 17.0053 3.77143H16.4166C16.2245 3.6271 15.9667 3.53809 15.6824 3.53809C15.0892 3.53809 14.6084 3.9227 14.6084 4.39716C14.6084 4.86704 15.0801 5.24823 15.6652 5.25563L15.665 5.25906H17.0053C17.1649 5.25906 17.2946 5.38881 17.2946 5.54837C17.2946 5.70793 17.1649 5.83763 17.0053 5.83763H16.3854C15.4055 5.83763 14.6084 6.63479 14.6084 7.61462C14.6084 8.59445 15.4055 9.39165 16.3854 9.39165H18.7823V7.90393H16.3854C16.2258 7.90398 16.0961 7.77428 16.0961 7.61471Z" fill="#F0F0F0"></path><path d="M6.70442 7.61484C6.70442 7.45527 6.83413 7.32557 6.99373 7.32557H7.61361C8.59348 7.32557 9.39069 6.52841 9.39069 5.54858C9.39069 4.56876 8.59353 3.77155 7.61361 3.77155H7.02495C6.83281 3.62722 6.57505 3.53821 6.2907 3.53821C5.69759 3.53821 5.2168 3.92282 5.2168 4.39729C5.2168 4.86716 5.68841 5.24835 6.27359 5.25576L6.27331 5.25918H7.61366C7.77327 5.25918 7.90297 5.38893 7.90297 5.54849C7.90297 5.70805 7.77327 5.83776 7.61366 5.83776H6.99378C6.01391 5.83776 5.2168 6.63491 5.2168 7.61474C5.2168 8.59457 6.01386 9.39177 6.99378 9.39177H9.39064V7.90406H6.99373C6.83413 7.9041 6.70442 7.7744 6.70442 7.61484Z" fill="#F0F0F0"></path><path d="M16.0961 18.6859C16.0961 18.5264 16.2258 18.3967 16.3854 18.3967H17.0053C17.9852 18.3967 18.7824 17.5995 18.7824 16.6197C18.7824 15.6399 17.9852 14.8427 17.0053 14.8427H16.4167C16.2245 14.6983 15.9667 14.6093 15.6824 14.6093C15.0892 14.6093 14.6084 14.994 14.6084 15.4684C14.6084 15.9383 15.0801 16.3195 15.6652 16.3269L15.665 16.3303H17.0053C17.1649 16.3303 17.2946 16.46 17.2946 16.6196C17.2946 16.7792 17.1649 16.9089 17.0053 16.9089H16.3854C15.4055 16.9089 14.6084 17.706 14.6084 18.6858C14.6084 19.6657 15.4055 20.4629 16.3854 20.4629H18.7823V18.9752H16.3854C16.2258 18.9753 16.0961 18.8455 16.0961 18.6859Z" fill="#F0F0F0"></path><path d="M6.70447 18.6859C6.70447 18.5264 6.83417 18.3967 6.99378 18.3967H7.61365C8.59353 18.3967 9.39073 17.5995 9.39073 16.6197C9.39073 15.6399 8.59358 14.8427 7.61365 14.8427H7.025C6.83286 14.6983 6.57509 14.6093 6.29075 14.6093C5.69759 14.6093 5.2168 14.994 5.2168 15.4684C5.2168 15.9383 5.68841 16.3195 6.27359 16.3269L6.27331 16.3303H7.61365C7.77326 16.3303 7.90297 16.46 7.90297 16.6196C7.90297 16.7792 7.77326 16.9089 7.61365 16.9089H6.99378C6.01391 16.9089 5.2168 17.706 5.2168 18.6858C5.2168 19.6657 6.01386 20.4629 6.99378 20.4629H9.39068V18.9752H6.99378C6.83417 18.9753 6.70447 18.8455 6.70447 18.6859Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), wa2 = [
  ua2
];
function pa2(r, e) {
  return n(), o("svg", va2, wa2);
}
const aK2 = /* @__PURE__ */ i(fa2, [["render", pa2]]);
var ga2 = {}, $a2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ma2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -240)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D"></path><path d="M12.0001 13.8637C10.002 13.8637 8.33275 12.4594 7.9232 10.5842C7.8603 10.8724 7.82617 11.1714 7.82617 11.4786C7.82617 13.7838 9.69484 15.6525 12.0001 15.6525C14.3053 15.6525 16.174 13.7838 16.174 11.4786C16.174 11.1714 16.1398 10.8724 16.0769 10.5841C15.6674 12.4594 13.9982 13.8637 12.0001 13.8637Z" fill="#FFDA44"></path><path d="M12.0002 8.34778L12.3887 9.54351H13.6461L12.6289 10.2825L13.0174 11.4782L12.0002 10.7392L10.9831 11.4782L11.3716 10.2825L10.3545 9.54351H11.6117L12.0002 8.34778Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), La2 = [
  Ma2
];
function ka2(r, e) {
  return n(), o("svg", $a2, La2);
}
const dK2 = /* @__PURE__ */ i(ga2, [["render", ka2]]);
var ma2 = {}, xa2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ha2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -688)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"></path><path d="M11.9678 11.9997H11.9999C11.9999 11.9889 11.9999 11.9784 11.9999 11.9675C11.9892 11.9783 11.9785 11.989 11.9678 11.9997Z" fill="#F0F0F0"></path><path d="M12 6.26123C12 4.14974 12 2.76623 12 0.000366211H11.998C5.37145 0.00149121 0 5.3736 0 12.0004H6.26086V8.47485L9.78637 12.0004H11.9679C11.9786 11.9897 11.9893 11.979 12 11.9683C12 11.1598 12 10.4384 12 9.78683L8.47443 6.26123H12Z" fill="#F0F0F0"></path><path d="M6.07124 1.56543C4.19441 2.63413 2.63409 4.19441 1.56543 6.07124V12.0002H4.69588V4.69598V4.69588H12.0002C12.0002 3.70856 12.0002 2.76796 12.0002 1.56543H6.07124Z" fill="#D80027"></path><path d="M12.0009 10.5242L7.73734 6.26074H6.26172V6.26084L12.0008 11.9998H12.0009C12.0009 11.9998 12.0009 10.9823 12.0009 10.5242Z" fill="#D80027"></path><path d="M13.5654 6.2605V11.9996C13.5654 14.7952 17.2176 15.6518 17.2176 15.6518C17.2176 15.6518 20.8698 14.7952 20.8698 11.9996V6.2605H13.5654Z" fill="#338AF3"></path><path d="M13.5654 11.9991C13.5654 14.7948 17.2176 15.6514 17.2176 15.6514C17.2176 15.6514 20.8698 14.7948 20.8698 11.9991H13.5654Z" fill="#A2001D"></path><path d="M18.7828 8.86909H17.7393V7.82556H16.6958V8.86909H15.6523V9.91253H16.6958V13.0429H17.7393V9.91253H18.7828V8.86909Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Va2 = [
  Ha2
];
function Za2(r, e) {
  return n(), o("svg", xa2, Va2);
}
const cK2 = /* @__PURE__ */ i(ma2, [["render", Za2]]);
var Ba2 = {}, Fa2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ja2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -72)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12 -0.000488281C18.6274 -0.000488281 24 5.37214 24 11.9995C24 18.6269 18.6274 23.9995 12 23.9995" fill="#D80027"></path><path d="M8.34725 4.69624V3.13104H6.78205V4.69624H5.2168V6.26145H6.78205V7.82669H8.34725V6.26145H9.91245V4.69624H8.34725Z" fill="#ACABB1"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ia2 = [
  ja2
];
function ba2(r, e) {
  return n(), o("svg", Fa2, Ia2);
}
const _K2 = /* @__PURE__ */ i(Ba2, [["render", ba2]]);
var ya2 = {}, Da2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pa2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -296)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M1.45898 6.26037L11.9999 7.30386L22.5408 6.26037C20.5056 2.53025 16.5484 -0.000488281 11.9999 -0.000488281C7.45139 -0.000488281 3.49425 2.53025 1.45898 6.26037Z" fill="#D80027"></path><path d="M1.45908 17.7384L12 18.7819L22.5409 17.7384C23.4711 16.0335 24 14.0782 24 11.9993L12 10.9558L0 11.9993C0 14.0782 0.528891 16.0335 1.45908 17.7384Z" fill="#FFDA44"></path><path d="M1.45908 6.26099C0.528891 7.96588 0 9.92122 0 12.0001H24C24 9.92122 23.4711 7.96588 22.5409 6.26099H12H1.45908Z" fill="#0052B4"></path><path d="M11.9999 23.9996C16.5484 23.9996 20.5056 21.4688 22.5408 17.7387H1.45898C3.49425 21.4688 7.45139 23.9996 11.9999 23.9996Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Aa2 = [
  Pa2
];
function Sa2(r, e) {
  return n(), o("svg", Da2, Aa2);
}
const CK2 = /* @__PURE__ */ i(ya2, [["render", Sa2]]);
var Ta2 = {}, Oa2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ea2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -1360)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M19.826 6.26099H4.17383V17.7393H19.826V6.26099Z" fill="#6DA544"></path><path d="M13.9323 15.3913C12.0594 15.3913 10.541 13.8729 10.541 12C10.541 10.127 12.0594 8.60867 13.9323 8.60867C14.5163 8.60867 15.0658 8.75633 15.5455 9.0163C14.793 8.28032 13.7638 7.82605 12.628 7.82605C10.3229 7.82605 8.4541 9.69477 8.4541 11.9999C8.4541 14.3051 10.3229 16.1738 12.628 16.1738C13.7638 16.1738 14.793 15.7196 15.5455 14.9836C15.0658 15.2436 14.5163 15.3913 13.9323 15.3913Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ra2 = [
  Ea2
];
function Ua2(r, e) {
  return n(), o("svg", Oa2, Ra2);
}
const fK2 = /* @__PURE__ */ i(Ta2, [["render", Ua2]]);
var Na2 = {}, qa2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, za2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -1248)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 11.9997C0 13.4676 0.264047 14.8736 0.746391 16.1736L12 16.6954L23.2536 16.1737C23.736 14.8736 24 13.4676 24 11.9997C24 10.5319 23.736 9.12583 23.2536 7.82584L12 7.30408L0.746391 7.8258C0.264047 9.12583 0 10.5319 0 11.9997Z" fill="#D80027"></path><path d="M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z" fill="black"></path><path d="M23.2533 16.1747H0.746094C2.44161 20.7442 6.84012 24.0008 11.9997 24.0008C17.1593 24.0008 21.5578 20.7442 23.2533 16.1747Z" fill="#496E2D"></path><path d="M15.5864 5.73994L14.1209 5.0506L14.9013 3.63127L13.3099 3.93572L13.1082 2.328L11.9997 3.51042L10.8913 2.328L10.6896 3.93572L9.09821 3.63127L9.87863 5.0506L8.41309 5.73994H15.5864Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ka2 = [
  za2
];
function Ga2(r, e) {
  return n(), o("svg", qa2, Ka2);
}
const vK2 = /* @__PURE__ */ i(Na2, [["render", Ga2]]);
var Wa2 = {}, Ya2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xa2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -352)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.9994 11.9997C23.9994 7.24218 21.2307 3.13143 17.2168 1.19043V22.8089C21.2307 20.868 23.9994 16.7572 23.9994 11.9997Z" fill="#D80027"></path><path d="M0 11.9997C0 16.7572 2.76867 20.868 6.78262 22.809V1.19043C2.76867 3.13143 0 7.24218 0 11.9997Z" fill="#6DA544"></path><path d="M8.87012 11.9992C8.87012 13.7281 10.2717 15.1297 12.0006 15.1297C13.7295 15.1297 15.131 13.7281 15.131 11.9992V10.9557H8.87012V11.9992Z" fill="#6DA544"></path><path d="M16.1731 9.91336H13.0426C13.0426 9.33708 12.5754 8.86987 11.9991 8.86987C11.4229 8.86987 10.9557 9.33708 10.9557 9.91336H7.8252C7.8252 10.4897 8.32718 10.9568 8.90342 10.9568H8.86868C8.86868 11.5332 9.33584 12.0003 9.91217 12.0003C9.91217 12.5766 10.3793 13.0438 10.9557 13.0438H13.0426C13.619 13.0438 14.0861 12.5766 14.0861 12.0003C14.6624 12.0003 15.1296 11.5332 15.1296 10.9568H15.0948C15.6711 10.9568 16.1731 10.4897 16.1731 9.91336Z" fill="#FF9811"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Qa2 = [
  Xa2
];
function Ja2(r, e) {
  return n(), o("svg", Ya2, Qa2);
}
const uK2 = /* @__PURE__ */ i(Wa2, [["render", Ja2]]);
var td2 = {}, ed2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rd2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-240 -1304)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.4785 12.0002H24.0002C24.0002 10.9171 23.8559 9.86791 23.5869 8.86975H11.4785V12.0002Z" fill="#D80027"></path><path d="M11.4785 5.73873H22.239C21.5044 4.54004 20.5652 3.48053 19.4701 2.60828H11.4785V5.73873Z" fill="#D80027"></path><path d="M12.0011 24.0002C14.8253 24.0002 17.4211 23.024 19.471 21.3915H4.53125C6.58114 23.024 9.17694 24.0002 12.0011 24.0002Z" fill="#D80027"></path><path d="M1.76195 18.2601H22.2394C22.8291 17.2978 23.2864 16.2459 23.5873 15.1296H0.414062C0.714859 16.2459 1.17222 17.2978 1.76195 18.2601Z" fill="#D80027"></path><path d="M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z" fill="#0052B4"></path><path d="M7.98001 10.2709C6.34117 10.2709 5.01263 8.94229 5.01263 7.30349C5.01263 5.6647 6.34121 4.33612 7.98001 4.33612C8.491 4.33612 8.97179 4.46535 9.39156 4.69279C8.73306 4.04887 7.8325 3.65137 6.8387 3.65137C4.82171 3.65137 3.18652 5.28651 3.18652 7.30354C3.18652 9.32057 4.82171 10.9557 6.8387 10.9557C7.8325 10.9557 8.73306 10.5582 9.39156 9.91429C8.97179 10.1416 8.49104 10.2709 7.98001 10.2709Z" fill="#FFDA44"></path><path d="M8.81647 5.21729L9.3433 6.31894L10.533 6.04407L10.0002 7.14277L10.9571 7.90153L9.76578 8.17008L9.76911 9.39122L8.81647 8.62725L7.86378 9.39122L7.86706 8.17008L6.67578 7.90153L7.63259 7.14277L7.09977 6.04407L8.28959 6.31894L8.81647 5.21729Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), nd2 = [
  rd2
];
function od2(r, e) {
  return n(), o("svg", ed2, nd2);
}
const wK2 = /* @__PURE__ */ i(td2, [["render", od2]]);
var id2 = {}, ld2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sd2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -800)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M6.48568 16.6959L3.51465 20.4852C5.68609 22.6569 8.68576 24.0003 11.9995 24.0003C16.9603 24.0003 21.2172 20.9895 23.0447 16.6959H6.48568Z" fill="#FFDA44"></path><path d="M23.0634 7.34841C21.2461 3.03164 16.9771 0.000610352 11.9995 0.000610352C8.68576 0.000610352 5.68609 1.344 3.51465 3.51572L6.51981 7.34841H23.0634Z" fill="#496E2D"></path><path d="M2.6084 8.82593V15.1302H23.5864C23.8555 14.1322 23.9997 13.083 23.9997 11.9998C23.9997 10.901 23.8517 9.83693 23.575 8.82593H2.6084Z" fill="black"></path><path d="M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31374 16.6859 12 11.9996L3.51471 3.51428Z" fill="#A2001D"></path><path d="M4.85694 8.86938L5.6339 11.2608H8.14855L6.11427 12.7388L6.89118 15.1303L4.85694 13.6523L2.82262 15.1303L3.59971 12.7388L1.56543 11.2608H4.0799L4.85694 8.86938Z" fill="#FFDA44"></path><path d="M7.13101 11.9991H2.58301V14.0861H7.13101V11.9991Z" fill="#F0F0F0"></path><path d="M7.99252 9.60729L7.25466 8.86938L4.8571 11.2669L2.45954 8.86938L1.72168 9.60729L4.12135 12.0027L1.72168 14.4024L2.45954 15.1303L4.8571 12.737L7.25466 15.1303L7.99252 14.4024L5.59285 12.0027L7.99252 9.60729Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), hd2 = [
  sd2
];
function ad2(r, e) {
  return n(), o("svg", ld2, hd2);
}
const pK2 = /* @__PURE__ */ i(id2, [["render", ad2]]);
var dd2 = {}, cd2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _d2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -912)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M3.51451 20.4849C4.0179 20.9883 4.55499 21.4372 5.11838 21.8325L21.8326 5.11826C21.4374 4.55487 20.9884 4.01778 20.485 3.51439C19.9816 3.011 19.4445 2.56212 18.8811 2.16687L2.16699 18.8811C2.5622 19.4444 3.01112 19.9815 3.51451 20.4849Z" fill="#A2001D"></path><path d="M3.51526 3.51478C-0.270555 7.30059 -0.997306 12.9862 1.33346 17.5022L17.5026 1.33307C12.9866 -0.997692 7.30098 -0.270848 3.51526 3.51478Z" fill="#0052B4"></path><path d="M20.4854 20.4847C24.2711 16.699 24.9979 11.0134 22.6672 6.49731L6.49805 22.6665C11.014 24.9972 16.6996 24.2705 20.4854 20.4847Z" fill="#496E2D"></path><path d="M9.91356 6.78182L8.56891 7.41431L9.28497 8.71659L7.82486 8.43731L7.6398 9.91223L6.6228 8.8274L5.60575 9.91223L5.42078 8.43731L3.96063 8.71654L4.67664 7.41426L3.33203 6.78182L4.67669 6.14929L3.96063 4.8471L5.42073 5.12638L5.6058 3.65137L6.6228 4.73624L7.63984 3.65137L7.82486 5.12638L9.28497 4.8471L8.569 6.14934L9.91356 6.78182Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Cd2 = [
  _d2
];
function fd2(r, e) {
  return n(), o("svg", cd2, Cd2);
}
const gK2 = /* @__PURE__ */ i(dd2, [["render", fd2]]);
var vd2 = {}, ud2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wd2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -1248)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M1.19072 6.78213C0.427875 8.35976 0 10.1296 0 11.9995C0 13.8694 0.427875 15.6393 1.19072 17.2169L12 18.2604L22.8093 17.2169C23.5721 15.6393 24 13.8694 24 11.9995C24 10.1296 23.5721 8.35976 22.8093 6.78213L12 5.73865L1.19072 6.78213Z" fill="#F0F0F0"></path><path d="M1.19043 17.2183C3.13134 21.2322 7.24176 24.0009 11.9993 24.0009C16.7568 24.0009 20.8672 21.2322 22.8081 17.2183H1.19043Z" fill="#6DA544"></path><path d="M1.19043 6.78238H22.8081C20.8672 2.76843 16.7568 -0.000244141 11.9993 -0.000244141C7.24181 -0.000244141 3.13134 2.76843 1.19043 6.78238Z" fill="#FF9811"></path><path d="M11.9991 16.1742C14.3043 16.1742 16.173 14.3055 16.173 12.0003C16.173 9.69513 14.3043 7.82642 11.9991 7.82642C9.69391 7.82642 7.8252 9.69513 7.8252 12.0003C7.8252 14.3055 9.69391 16.1742 11.9991 16.1742Z" fill="#FF9811"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), pd2 = [
  wd2
];
function gd2(r, e) {
  return n(), o("svg", ud2, pd2);
}
const $K2 = /* @__PURE__ */ i(vd2, [["render", gd2]]);
var $d2 = {}, Md2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ld2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -16)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M17.2165 1.19047C15.6389 0.427631 13.869 -0.000244141 11.9991 -0.000244141C10.1292 -0.000244141 8.35939 0.427631 6.78176 1.19047L5.73828 11.9998L6.78176 22.809C8.35939 23.5719 10.1292 23.9998 11.9991 23.9998C13.869 23.9998 15.6389 23.5719 17.2165 22.809L18.26 11.9998L17.2165 1.19047Z" fill="#F0F0F0"></path><path d="M6.78262 1.19122C2.76867 3.13213 0 7.24255 0 12.0001C0 16.7576 2.76867 20.868 6.78262 22.8089V1.19122Z" fill="#6DA544"></path><path d="M17.2168 1.19122V22.8089C21.2307 20.868 23.9994 16.7576 23.9994 12.0001C23.9994 7.2426 21.2307 3.13213 17.2168 1.19122Z" fill="#6DA544"></path><path d="M15.131 15.6516L12.0006 5.73859L8.87012 15.6516H11.2179V18.2603H12.7832V15.6516H15.131Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), kd2 = [
  Ld2
];
function md2(r, e) {
  return n(), o("svg", Md2, kd2);
}
const MK2 = /* @__PURE__ */ i($d2, [["render", md2]]);
var xd2 = {}, Hd2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vd2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -1304)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M0 12.0003C0 17.1599 3.2565 21.5584 7.82611 23.2539V0.746704C3.2565 2.44217 0 6.84074 0 12.0003Z" fill="#6DA544"></path><path d="M23.9999 12.0003C23.9999 6.84074 20.7434 2.44217 16.1738 0.746704V23.254C20.7434 21.5584 23.9999 17.1599 23.9999 12.0003Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Zd2 = [
  Vd2
];
function Bd2(r, e) {
  return n(), o("svg", Hd2, Zd2);
}
const LK2 = /* @__PURE__ */ i(xd2, [["render", Bd2]]);
var Fd2 = {}, jd2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Id2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -1192)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12.0007 -0.000244141C7.24316 -0.000244141 3.13241 2.76843 1.19141 6.78238H22.8099C20.869 2.76843 16.7582 -0.000244141 12.0007 -0.000244141Z" fill="#338AF3"></path><path d="M12.0007 24.001C16.7582 24.001 20.869 21.2323 22.81 17.2184H1.19141C3.13241 21.2323 7.24316 24.001 12.0007 24.001Z" fill="#338AF3"></path><path d="M11.9998 8.34766C9.9828 8.34766 8.34766 9.9828 8.34766 11.9998C8.34766 14.0169 9.9828 15.652 11.9998 15.652C14.0169 15.652 15.652 14.0169 15.652 11.9998C15.652 9.9828 14.0169 8.34766 11.9998 8.34766ZM11.9998 14.0868C10.8473 14.0868 9.91286 13.1525 9.91286 11.9998C9.91286 10.8472 10.8472 9.91286 11.9998 9.91286C13.1524 9.91286 14.0868 10.8472 14.0868 11.9998C14.0868 13.1525 13.1524 14.0868 11.9998 14.0868Z" fill="#FFDA44"></path><path d="M13.8071 12.5222L11.9997 12.0005L10.1923 12.5222L9.58984 13.5657H14.4095L13.8071 12.5222Z" fill="#0052B4"></path><path d="M11.9998 9.39136L10.7949 11.4783L11.9998 12L13.2048 11.4783L11.9998 9.39136Z" fill="#338AF3"></path><path d="M10.1924 12.5211H13.8072L13.2047 11.4777H10.7949L10.1924 12.5211Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), bd2 = [
  Id2
];
function yd2(r, e) {
  return n(), o("svg", jd2, bd2);
}
const kK2 = /* @__PURE__ */ i(Fd2, [["render", yd2]]);
var Dd2 = {}, Pd2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ad2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -1080)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 -0.000488281C6.84013 -0.000488281 2.44161 3.25601 0.746094 7.82562H23.2534C21.5578 3.25601 17.1593 -0.000488281 11.9997 -0.000488281Z" fill="#A2001D"></path><path d="M11.9997 24.0004C17.1593 24.0004 21.5578 20.7439 23.2533 16.1743H0.746094C2.44161 20.7439 6.84012 24.0004 11.9997 24.0004Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Sd2 = [
  Ad2
];
function Td2(r, e) {
  return n(), o("svg", Pd2, Sd2);
}
const mK2 = /* @__PURE__ */ i(Dd2, [["render", Td2]]);
var Od2 = {}, Ed2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rd2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -184)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M0.413086 15.131C1.1074 17.7072 2.63763 19.94 4.69535 21.5211V15.131H0.413086Z" fill="#D80027"></path><path d="M10.9561 23.9549C11.3 23.9845 11.6479 24.0005 11.9995 24.0005C17.5439 24.0005 22.2091 20.2402 23.5861 15.131H10.9561V23.9549Z" fill="#D80027"></path><path d="M23.5861 8.87004C22.2091 3.76085 17.5439 0.000488281 11.9995 0.000488281C11.6479 0.000488281 11.3 0.0165195 10.9561 0.0461445V8.87004H23.5861Z" fill="#D80027"></path><path d="M4.69535 2.48029C2.63763 4.06138 1.1074 6.29418 0.413086 8.87038H4.69535V2.48029Z" fill="#D80027"></path><path d="M23.8984 10.4343H9.39136H9.39131V0.284729C8.28234 0.530635 7.23098 0.929213 6.26086 1.45857V10.4342V10.4342H0.101578C0.0347813 10.9466 0 11.469 0 11.9995C0 12.53 0.0347813 13.0524 0.101578 13.5647H6.26081H6.26086V22.5404C7.23098 23.0697 8.28234 23.4684 9.39131 23.7142V13.5648V13.5647H23.8984C23.9651 13.0524 24 12.53 24 11.9995C24 11.469 23.9651 10.9466 23.8984 10.4343Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Ud2 = [
  Rd2
];
function Nd2(r, e) {
  return n(), o("svg", Ed2, Ud2);
}
const xK2 = /* @__PURE__ */ i(Od2, [["render", Nd2]]);
var qd2 = {}, zd2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Kd2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -1024)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.9292 13.3041C23.9292 13.304 23.9293 13.3039 23.9293 13.3037L10.7693 0.0621338C10.1757 0.122649 9.59475 0.226431 9.02986 0.37029C3.83897 1.69193 0 11.9997 0 11.9997C0 11.9997 16.7999 23.242 18.7165 21.9449C19.1 21.6854 19.4677 21.4043 19.8177 21.1034L12.0185 13.3041H23.9292Z" fill="#0052B4"></path><path d="M20.8695 11.9995L9.19899 0.328979C3.92288 1.59071 0 6.33662 0 11.9995C0 18.6269 5.37263 23.9995 12 23.9995C14.5139 23.9995 16.8467 23.226 18.7748 21.9047L8.86955 11.9995H20.8695Z" fill="#D80027"></path><path d="M11.4126 17.7174L9.94704 17.028L10.7275 15.6087L9.13605 15.9131L8.9344 14.3054L7.82595 15.4878L6.71749 14.3054L6.51579 15.9131L4.92443 15.6086L5.70485 17.028L4.23926 17.7174L5.70485 18.4067L4.92443 19.826L6.51588 19.5216L6.71745 21.1292L7.82595 19.9468L8.9344 21.1292L9.13605 19.5216L10.7274 19.8261L9.94699 18.4067L11.4126 17.7174Z" fill="#F0F0F0"></path><path d="M10.4342 6.6549L9.36828 6.15357L9.93589 5.12124L8.77841 5.34268L8.63174 4.17334L7.82553 5.03335L7.01933 4.17334L6.87261 5.34268L5.71512 5.12124L6.28278 6.15357L5.2168 6.6549L7.82553 7.17671L10.4342 6.6549Z" fill="#F0F0F0"></path><path d="M10.9572 6.65527C10.9572 8.38416 9.55563 9.78572 7.82674 9.78572C6.09785 9.78572 4.69629 8.38416 4.69629 6.65527" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Gd2 = [
  Kd2
];
function Wd2(r, e) {
  return n(), o("svg", zd2, Gd2);
}
const HK2 = /* @__PURE__ */ i(qd2, [["render", Wd2]]);
var Yd2 = {}, Xd2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qd2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -968)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#0052B4"></path><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M12.0012 -0.000488281C5.72536 -0.000488281 0.575766 4.81737 0.046875 10.956H23.9555C23.4266 4.81737 18.277 -0.000488281 12.0012 -0.000488281Z" fill="#0052B4"></path><path d="M12.0002 24.0001C18.276 24.0001 23.4256 19.1822 23.9545 13.0436H0.0458984C0.574789 19.1822 5.72438 24.0001 12.0002 24.0001Z" fill="#0052B4"></path><path d="M9.91361 16.1745L8.56895 16.807L9.28497 18.1092L7.82486 17.8299L7.63984 19.3049L6.6228 18.2201L5.6058 19.3049L5.42078 17.8299L3.96063 18.1092L4.67669 16.807L3.33203 16.1745L4.67673 15.542L3.96063 14.2398L5.42073 14.5191L5.60584 13.0441L6.6228 14.1289L7.63989 13.0441L7.82486 14.5191L9.28502 14.2398L8.569 15.542L9.91361 16.1745Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Jd2 = [
  Qd2
];
function tc2(r, e) {
  return n(), o("svg", Xd2, Jd2);
}
const VK2 = /* @__PURE__ */ i(Yd2, [["render", tc2]]);
var ec2 = {}, rc2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -1360)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#FFDA44"></path><path d="M12.0001 5.7395V9.78683L7.82617 5.7395H12.0001Z" fill="#0052B4"></path><path d="M6.26098 12.0002H9.78649L6.26098 7.30457L5.73926 10.9567L6.26098 12.0002Z" fill="#0052B4"></path><path d="M11.9688 12.0007H12.0009C12.0009 11.9899 12.0009 11.9794 12.0009 11.9685C11.9902 11.9793 11.9795 11.99 11.9688 12.0007Z" fill="#F0F0F0"></path><path d="M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z" fill="#F0F0F0"></path><path d="M11.9989 10.5247L7.73539 6.26123H6.25977V6.26132L11.9988 12.0003H11.9989C11.9989 12.0003 11.9989 10.9828 11.9989 10.5247Z" fill="#D80027"></path><path d="M6.07027 1.56494C5.60766 1.82838 5.16445 2.12196 4.74295 2.44244H5.23533L3.93398 3.3881L4.43095 4.91796L3.12961 3.97249L2.99114 4.07313C2.45081 4.68672 1.97175 5.35554 1.56445 6.07075V11.9997H4.69491V4.69549V4.69539H11.9993C11.9993 3.70807 11.9993 2.76747 11.9993 1.56494H6.07027Z" fill="#D80027"></path><path d="M5.12601 2.16431C4.99659 2.25492 4.86899 2.34806 4.74332 2.44363L3.93449 3.38929L3.13012 3.97363L2.99048 4.07507C2.69582 4.40976 2.41949 4.76095 2.16309 5.12718C2.45535 5.26903 2.78343 5.34876 3.13012 5.34876C4.35477 5.34876 5.34749 4.35604 5.34749 3.13138C5.34759 2.7846 5.2679 2.45662 5.12601 2.16431Z" fill="#0052B4"></path><path d="M2.99023 4.07382L3.12987 3.97238L4.43122 4.9179L3.9342 3.38804L5.23545 2.44238H4.74299C4.10577 2.92702 3.51856 3.47377 2.99023 4.07382Z" fill="#FFDA44"></path><path d="M8.29451 2.0874L8.55354 2.88451H9.39167L8.71362 3.37721L8.97251 4.17432L8.29451 3.68167L7.61647 4.17432L7.87531 3.37721L7.19727 2.88451H8.03544L8.29451 2.0874Z" fill="#FFDA44"></path><path d="M3.13041 7.30518L3.38944 8.10228H4.22756L3.54956 8.59504L3.80845 9.39215L3.13041 8.89944L2.45231 9.39215L2.7112 8.59504L2.0332 8.10228H2.87133L3.13041 7.30518Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), oc2 = [
  nc2
];
function ic2(r, e) {
  return n(), o("svg", rc2, oc2);
}
const ZK2 = /* @__PURE__ */ i(ec2, [["render", ic2]]);
var lc2 = {}, sc2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -1136)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"></path><path d="M11.9678 12.0004H11.9999C11.9999 11.9896 11.9999 11.9791 11.9999 11.9683C11.9892 11.979 11.9785 11.9897 11.9678 12.0004Z" fill="#F0F0F0"></path><path d="M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.3715 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78642 12H11.9679C11.9786 11.9893 11.9894 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z" fill="#F0F0F0"></path><path d="M6.07124 1.56494C4.19441 2.63364 2.63413 4.19393 1.56543 6.07075V11.9997H4.69588V4.69549V4.69539H12.0002C12.0002 3.70807 12.0002 2.76747 12.0002 1.56494H6.07124Z" fill="#D80027"></path><path d="M12.0008 10.5247L7.73739 6.26123C7.73739 6.26123 6.26172 6.26132 6.26172 6.26123V6.26132L12.0008 12.0003H12.0008C12.0008 12.0003 12.0008 10.9828 12.0008 10.5247Z" fill="#D80027"></path><path d="M20.7808 8.90466L21.0398 9.70182H21.878L21.1999 10.1945L21.4589 10.9916L20.7808 10.499L20.1027 10.9916L20.3617 10.1945L19.6836 9.70182H20.5218L20.7808 8.90466Z" fill="#D80027"></path><path d="M17.7854 14.6436L18.174 15.8393H19.4312L18.414 16.5783L18.8026 17.774L17.7854 17.035L16.7682 17.774L17.1568 16.5783L16.1396 15.8393H17.3969L17.7854 14.6436Z" fill="#D80027"></path><path d="M17.8988 5.25183L18.2226 6.24834H19.2703L18.4226 6.86405L18.7464 7.86051L17.8988 7.24463L17.0512 7.86051L17.3749 6.86405L16.5273 6.24834H17.575L17.8988 5.25183Z" fill="#D80027"></path><path d="M15.0149 8.86987L15.4034 10.0657H16.6607L15.6435 10.8046L16.0321 12.0003L15.0149 11.2613L13.9977 12.0003L14.3863 10.8046L13.3691 10.0657H14.6264L15.0149 8.86987Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ac2 = [
  hc2
];
function dc2(r, e) {
  return n(), o("svg", sc2, ac2);
}
const BK2 = /* @__PURE__ */ i(lc2, [["render", dc2]]);
var cc2 = {}, _c2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -240)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M0 12.0005C0 16.549 2.53078 20.5062 6.26086 22.5414V1.45959C2.53078 3.49481 0 7.452 0 12.0005Z" fill="#D80027"></path><path d="M23.2537 16.1752C23.736 14.8752 24 13.4691 24 12.0013C24 10.5334 23.736 9.12733 23.2537 7.82739H0.746438C0.264047 9.12733 0 10.5334 0 12.0013C0 13.4691 0.264047 14.8752 0.746438 16.1752L12 17.2187L23.2537 16.1752Z" fill="#D80027"></path><path d="M12.0006 23.9997C17.1603 23.9997 21.5587 20.7432 23.2543 16.1736H0.74707C2.44254 20.7432 6.8411 23.9997 12.0006 23.9997Z" fill="#6DA544"></path><path d="M0 11.9996C0 17.544 3.76036 22.2092 8.86955 23.5862V0.413025C3.76036 1.79002 0 6.45531 0 11.9996Z" fill="#D80027"></path><path d="M7.34159 5.28157L6.23483 4.1748L5.49701 4.91271L4.7592 4.1748L3.65244 5.28157L4.3903 6.01943L3.65234 6.75734L4.75911 7.8641L5.49697 7.1262L6.23483 7.8641L7.34159 6.75734L6.60373 6.01943L7.34159 5.28157Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), fc2 = [
  Cc2
];
function vc2(r, e) {
  return n(), o("svg", _c2, fc2);
}
const FK2 = /* @__PURE__ */ i(cc2, [["render", vc2]]);
var uc2 = {}, wc2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -464)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M0 11.9998C0 18.6271 5.37262 23.9998 12 23.9998C12 19.4362 12 11.9998 12 11.9998C12 11.9998 4.17389 11.9998 0 11.9998Z" fill="#0052B4"></path><path d="M12 0.000854492C18.6274 0.000854492 24 5.37348 24 12.0009C19.4365 12.0009 12 12.0009 12 12.0009C12 12.0009 12 4.17475 12 0.000854492Z" fill="#D80027"></path><path d="M7.1441 4.1748L7.92115 6.56627H10.4357L8.40138 8.04424L9.17838 10.4357L7.1441 8.9577L5.10982 10.4357L5.88682 8.04424L3.85254 6.56627H6.36705L7.1441 4.1748Z" fill="#0052B4"></path><path d="M16.857 13.5647L17.634 15.9562H20.1486L18.1142 17.4341L18.8913 19.8256L16.857 18.3476L14.8227 19.8256L15.5997 17.4341L13.5654 15.9562H16.0799L16.857 13.5647Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), gc2 = [
  pc2
];
function $c2(r, e) {
  return n(), o("svg", wc2, gc2);
}
const jK2 = /* @__PURE__ */ i(uc2, [["render", $c2]]);
var Mc2 = {}, Lc2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -632)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.9999 12.0015C23.9999 6.84196 20.7434 2.44339 16.1738 0.747925V23.2552C20.7434 21.5596 23.9999 17.1611 23.9999 12.0015Z" fill="#D80027"></path><path d="M0 12.0006C0 17.1603 3.2565 21.5587 7.82611 23.2543V0.74707C3.2565 2.44254 0 6.8411 0 12.0006Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), mc2 = [
  kc2
];
function xc2(r, e) {
  return n(), o("svg", Lc2, mc2);
}
const IK2 = /* @__PURE__ */ i(Mc2, [["render", xc2]]);
var Hc2 = {}, Vc2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -1304)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M1.45898 6.26159H22.5408C20.5056 2.53147 16.5484 0.000732422 11.9999 0.000732422C7.45139 0.000732422 3.49425 2.53147 1.45898 6.26159Z" fill="#D80027"></path><path d="M11.9999 23.9999C16.5484 23.9999 20.5056 21.4691 22.5408 17.739H1.45898C3.49425 21.4691 7.45139 23.9999 11.9999 23.9999Z" fill="#D80027"></path><path d="M16.174 11.9997C16.174 14.3049 14.3052 15.6519 12.0001 15.6519C9.69489 15.6519 7.82617 14.3049 7.82617 11.9997C7.82617 9.69448 9.69489 7.82581 12.0001 7.82581C14.3052 7.82581 16.174 9.69448 16.174 11.9997Z" fill="#FFDA44"></path><path d="M16.174 11.9998C16.174 14.305 14.3052 16.1737 12.0001 16.1737C9.69489 16.1737 7.82617 14.305 7.82617 11.9998" fill="#0052B4"></path><path d="M10.4351 10.9559H9.3916V13.0429H10.4351V10.9559Z" fill="#D80027"></path><path d="M14.6089 10.9559H13.5654V13.0429H14.6089V10.9559Z" fill="#D80027"></path><path d="M12.522 9.39087H11.4785V13.043H12.522V9.39087Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Bc2 = [
  Zc2
];
function Fc2(r, e) {
  return n(), o("svg", Vc2, Bc2);
}
const bK2 = /* @__PURE__ */ i(Hc2, [["render", Fc2]]);
var jc2 = {}, Ic2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -520)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M20.4853 20.4857C15.799 25.172 8.20108 25.172 3.51471 20.4857C-1.17158 15.7995 -1.17158 8.20145 3.51475 3.51512C8.20103 -1.17115 15.0611 -0.433295 19.7474 4.25303C24.4337 8.93931 25.1716 15.7995 20.4853 20.4857Z" fill="black"></path><path d="M3.51465 3.51467C8.20093 -1.17161 15.7989 -1.17152 20.4852 3.51472C25.1715 8.201 25.1715 15.799 20.4852 20.4853" fill="#A2001D"></path><path d="M9.17152 16.174L9.36577 16.7718H9.99441L9.48582 17.1413L9.68012 17.7392L9.17152 17.3697L8.66293 17.7392L8.85718 17.1413L8.34863 16.7718H8.97723L9.17152 16.174Z" fill="#F0F0F0"></path><path d="M7.56483 10.4351L7.88869 11.4315H8.93635L8.08871 12.0473L8.41247 13.0438L7.56483 12.4279L6.71724 13.0438L7.04105 12.0473L6.19336 11.4315H7.24111L7.56483 10.4351Z" fill="#F0F0F0"></path><path d="M7.56483 17.7388L7.8886 18.7352H8.93635L8.08861 19.351L8.41247 20.3475L7.56483 19.7316L6.71724 20.3475L7.04095 19.351L6.19336 18.7352H7.24097L7.56483 17.7388Z" fill="#F0F0F0"></path><path d="M10.6292 13.0439L10.9531 14.0404H12.0008L11.1531 14.6562L11.4769 15.6526L10.6292 15.0367L9.78164 15.6526L10.1055 14.6562L9.25781 14.0404H10.3055L10.6292 13.0439Z" fill="#F0F0F0"></path><path d="M4.50233 13.0439L4.82619 14.0404H5.8738L5.02621 14.6562L5.34993 15.6526L4.50233 15.0367L3.65469 15.6526L3.97855 14.6562L3.13086 14.0404H4.17856L4.50233 13.0439Z" fill="#F0F0F0"></path><path d="M20.0879 8.88636C19.5516 8.35006 18.8547 8.03324 18.1059 7.97881L20.3475 6.23539C19.4547 5.34266 18.2582 4.93949 17.0906 5.02475C16.9509 4.52244 16.6844 4.04797 16.2894 3.65295L15.4039 5.4238C15.3459 5.31795 15.2723 5.21834 15.1826 5.12867C14.6732 4.61928 13.8473 4.61928 13.338 5.12867C12.8286 5.63806 12.8285 6.46391 13.338 6.9733C13.4276 7.06297 13.5273 7.13652 13.6331 7.19464L11.8623 8.08006C12.2574 8.47522 12.7322 8.74189 13.2348 8.88158C13.1493 10.0491 13.552 11.2455 14.4448 12.1383L16.4032 9.62023C16.5506 9.47516 16.7451 9.39505 16.9521 9.39505C17.1612 9.39505 17.3577 9.47642 17.5055 9.62431C17.6533 9.77211 17.7348 9.96866 17.7348 10.1777C17.7348 10.3867 17.6533 10.5832 17.5055 10.7311L18.2434 11.469C18.5883 11.1241 18.7782 10.6655 18.7782 10.1777C18.7782 9.77863 18.6509 9.39922 18.4159 9.08553C18.7584 9.17699 19.082 9.35614 19.3502 9.62431C20.1639 10.438 20.1639 11.762 19.3502 12.5757L20.0881 13.3136C20.6793 12.7223 21.0049 11.9362 21.0049 11.1C21.0048 10.2637 20.6791 9.47764 20.0879 8.88636Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), yc2 = [
  bc2
];
function Dc2(r, e) {
  return n(), o("svg", Ic2, yc2);
}
const yK2 = /* @__PURE__ */ i(jc2, [["render", Dc2]]);
var Pc2 = {}, Ac2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -688)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12 0V12L3.51465 20.4853C5.68623 22.6568 8.68623 24 12 24C18.6273 24 24 18.6274 24 12C24 5.37262 12 0 12 0Z" fill="#D80027"></path><path d="M12 0C8.68623 0 5.68623 1.34316 3.51465 3.51469C6.45887 6.45891 7.50404 7.50412 12 12H24C24 5.37262 18.6273 0 12 0Z" fill="#0052B4"></path><path d="M8.21723 11.9998L6.75173 11.3104L7.53215 9.89111L5.94074 10.1956L5.73909 8.58789L4.63059 9.77027L3.52213 8.58789L3.32043 10.1956L1.72907 9.89106L2.50949 11.3104L1.04395 11.9998L2.50949 12.6891L1.72907 14.1085L3.32057 13.8041L3.52209 15.4117L4.63059 14.2293L5.73909 15.4117L5.94074 13.8041L7.53205 14.1085L6.75168 12.6892L8.21723 11.9998Z" fill="#FFDA44"></path><path d="M3.20082 4.69519L3.68851 5.37689L4.48749 5.12382L3.98977 5.79825L4.47746 6.47996L3.68218 6.21507L3.18451 6.88946L3.19074 6.05133L2.39551 5.78639L3.19463 5.53332L3.20082 4.69519Z" fill="#FFDA44"></path><path d="M3.20082 17.1095L3.68851 17.7912L4.48749 17.5381L3.98977 18.2126L4.47746 18.8943L3.68218 18.6294L3.18451 19.3038L3.19074 18.4656L2.39551 18.2007L3.19463 17.9476L3.20082 17.1095Z" fill="#FFDA44"></path><path d="M10.1558 10.9032L9.66817 11.5849L8.86914 11.3317L9.36686 12.0062L8.87917 12.688L9.67445 12.423L10.1722 13.0974L10.1659 12.2593L10.9611 11.9944L10.162 11.7413L10.1558 10.9032Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Tc2 = [
  Sc2
];
function Oc2(r, e) {
  return n(), o("svg", Ac2, Tc2);
}
const DK2 = /* @__PURE__ */ i(Pc2, [["render", Oc2]]);
var Ec2 = {}, Rc2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -296)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M0 12.0002C0 16.5487 2.53074 20.5059 6.26086 22.5411V1.45929C2.53074 3.49455 0 7.4517 0 12.0002Z" fill="#F0F0F0"></path><path d="M11.9999 0.000793457C9.92098 0.000793457 7.96563 0.529684 6.26074 1.45987V22.5417C7.96563 23.4719 9.92098 24.0008 11.9999 24.0008C18.6273 24.0008 23.9999 18.6282 23.9999 12.0008C23.9999 5.37342 18.6273 0.000793457 11.9999 0.000793457Z" fill="#496E2D"></path><path d="M17.1307 13.9861C15.6126 15.083 13.4926 14.7415 12.3957 13.2234C11.2987 11.7053 11.6402 9.58533 13.1584 8.48846C13.6317 8.14646 14.1636 7.94428 14.7046 7.87402C13.6637 7.71835 12.5633 7.95291 11.6428 8.61802C9.77437 9.96811 9.35404 12.5772 10.7041 14.4458C12.0541 16.3142 14.6633 16.7345 16.5318 15.3843C17.4524 14.7192 18.0206 13.7483 18.1995 12.711C17.963 13.2025 17.6041 13.644 17.1307 13.9861Z" fill="#F0F0F0"></path><path d="M17.0659 7.82721L17.9211 8.74882L19.0618 8.22044L18.4495 9.31844L19.3047 10.2401L18.0711 9.9971L17.4588 11.0952L17.3088 9.84691L16.0752 9.60386L17.216 9.07549L17.0659 7.82721Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Nc2 = [
  Uc2
];
function qc2(r, e) {
  return n(), o("svg", Rc2, Nc2);
}
const PK2 = /* @__PURE__ */ i(Ec2, [["render", qc2]]);
var zc2 = {}, Kc2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -1024)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M24 11.9995C24 18.6269 18.6274 23.9995 12 23.9995C5.37262 23.9995 0 18.6269 0 11.9995" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Wc2 = [
  Gc2
];
function Yc2(r, e) {
  return n(), o("svg", Kc2, Wc2);
}
const AK2 = /* @__PURE__ */ i(zc2, [["render", Yc2]]);
var Xc2 = {}, Qc2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jc2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -744)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"></path><path d="M11.9678 12.0005H11.9999C11.9999 11.9897 11.9999 11.9792 11.9999 11.9684C11.9892 11.9791 11.9785 11.9898 11.9678 12.0005Z" fill="#F0F0F0"></path><path d="M12 6.26098C12 4.1495 12 2.76598 12 0.00012207H11.998C5.37145 0.00124707 0 5.37336 0 12.0001H6.26086V8.47461L9.78637 12.0001H11.9679C11.9786 11.9894 11.9893 11.9787 12 11.968C12 11.1596 12 10.4382 12 9.78659L8.47443 6.26098H12Z" fill="#F0F0F0"></path><path d="M6.07124 1.56506C4.19441 2.63377 2.63409 4.19405 1.56543 6.07088V11.9999H4.69588V4.69561V4.69552H12.0002C12.0002 3.70819 12.0002 2.7676 12.0002 1.56506H6.07124Z" fill="#D80027"></path><path d="M12.0009 10.5248L7.73734 6.26135H6.26172V6.26145L12.0008 12.0005H12.0009C12.0009 12.0005 12.0009 10.9829 12.0009 10.5248Z" fill="#D80027"></path><path d="M18.783 7.30388L17.2178 7.82564L15.6526 7.30388L15.1309 5.99953L15.6526 4.69519H18.783L18.2613 5.99953L18.783 7.30388Z" fill="#ACABB1"></path><path d="M13.5654 7.30396V13.0431C13.5654 15.8387 17.2176 16.6953 17.2176 16.6953C17.2176 16.6953 20.8698 15.8387 20.8698 13.0431V7.30396H13.5654Z" fill="#338AF3"></path><path d="M13.8945 14.4023C14.7923 16.1258 17.2175 16.6948 17.2175 16.6948C17.2175 16.6948 19.6427 16.1258 20.5405 14.4023L17.2175 8.86877L13.8945 14.4023Z" fill="#6DA544"></path><path d="M20.8698 12.9851L17.2176 7.30396L13.5654 12.9851V13.043C13.5654 13.5605 13.6908 14.0113 13.8946 14.4027L17.2176 9.23356L20.5406 14.4027C20.7444 14.0112 20.8698 13.5604 20.8698 13.043V12.9851Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), t_2 = [
  Jc2
];
function e_2(r, e) {
  return n(), o("svg", Qc2, t_2);
}
const SK2 = /* @__PURE__ */ i(Xc2, [["render", e_2]]);
var r_2 = {}, n_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o_2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -856)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.999 -0.000610352C8.07308 -0.000610352 4.58769 1.88484 2.39844 4.79939H21.5995C19.4102 1.88484 15.9248 -0.000610352 11.999 -0.000610352Z" fill="#D80027"></path><path d="M11.999 23.9993C15.9248 23.9993 19.4102 22.1139 21.5995 19.1993H2.39844C4.58769 22.1139 8.07308 23.9993 11.999 23.9993Z" fill="#D80027"></path><path d="M-0.000976562 11.9994C-0.000976562 12.8213 0.0818984 13.6239 0.239352 14.3994H23.7588C23.9162 13.6239 23.999 12.8213 23.999 11.9994C23.999 11.1774 23.9161 10.3748 23.7587 9.59937H0.239352C0.0818984 10.3748 -0.000976562 11.1774 -0.000976562 11.9994Z" fill="#D80027"></path><path d="M3.51471 3.51538C-1.17157 8.20166 -1.17157 15.7997 3.51471 20.486C5.45126 18.5495 7.31374 16.687 12 12.0007L3.51471 3.51538Z" fill="#0052B4"></path><path d="M4.85694 8.86877L5.6339 11.2601H8.14855L6.11427 12.7382L6.89118 15.1297L4.85694 13.6517L2.82262 15.1297L3.59971 12.7382L1.56543 11.2601H4.0799L4.85694 8.86877Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), i_2 = [
  o_2
];
function l_2(r, e) {
  return n(), o("svg", n_2, i_2);
}
const TK2 = /* @__PURE__ */ i(r_2, [["render", l_2]]);
var s_2 = {}, h_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, a_2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -408)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M7.30388 7.82696H23.2531C21.5576 3.25735 17.1591 0.000854492 11.9995 0.000854492C8.68576 0.000854492 5.68609 1.34424 3.51465 3.51596L7.30388 7.82696Z" fill="black"></path><path d="M7.30388 16.1736H23.2531C21.5576 20.7432 17.1591 23.9997 11.9995 23.9997C8.68576 23.9997 5.68609 22.6563 3.51465 20.4846L7.30388 16.1736Z" fill="#6DA544"></path><path d="M3.51471 3.51489C-1.17157 8.20117 -1.17157 15.7992 3.51471 20.4855C5.45126 18.549 7.31375 16.6865 12 12.0002L3.51471 3.51489Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), d_2 = [
  a_2
];
function c_2(r, e) {
  return n(), o("svg", h_2, d_2);
}
const OK2 = /* @__PURE__ */ i(s_2, [["render", c_2]]);
var __2 = {}, C_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, f_2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -800)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 12.0007C0 17.1602 3.2565 21.5587 7.82602 23.2542L8.86955 12.0006L7.82602 0.74707C3.2565 2.44263 0 6.8411 0 12.0007Z" fill="#6DA544"></path><path d="M24.0002 12C24.0002 5.37262 18.6275 0 12.0002 0C10.5323 0 9.1262 0.264047 7.82617 0.746391V23.2536C9.1262 23.736 10.5323 24 12.0002 24C18.6275 24 24.0002 18.6274 24.0002 12Z" fill="#D80027"></path><path d="M7.82623 16.1744C10.1314 16.1744 12.0001 14.3057 12.0001 12.0006C12.0001 9.69537 10.1314 7.82666 7.82623 7.82666C5.52106 7.82666 3.65234 9.69537 3.65234 12.0006C3.65234 14.3057 5.52106 16.1744 7.82623 16.1744Z" fill="#FFDA44"></path><path d="M5.47754 9.9126V12.5213C5.47754 13.8179 6.52866 14.8691 7.82537 14.8691C9.12207 14.8691 10.1732 13.818 10.1732 12.5213V9.9126H5.47754Z" fill="#D80027"></path><path d="M7.82657 13.3037C7.39504 13.3037 7.04395 12.9526 7.04395 12.5211V11.4777H8.60915V12.5211C8.60915 12.9526 8.25805 13.3037 7.82657 13.3037Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), v_2 = [
  f_2
];
function u_2(r, e) {
  return n(), o("svg", C_2, v_2);
}
const EK2 = /* @__PURE__ */ i(__2, [["render", u_2]]);
var w_2 = {}, p_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g_2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -352)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"></path><path d="M9.3912 17.2183C12.2727 17.2183 14.6086 14.8824 14.6086 12.0009C14.6086 9.11941 12.2727 6.78351 9.3912 6.78351C6.50973 6.78351 4.17383 9.11941 4.17383 12.0009C4.17383 14.8824 6.50973 17.2183 9.3912 17.2183Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), $_2 = [
  g_2
];
function M_2(r, e) {
  return n(), o("svg", p_2, $_2);
}
const RK2 = /* @__PURE__ */ i(w_2, [["render", M_2]]);
var L_2 = {}, k_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, m_2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -576)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12.0007 0C7.24316 0 3.13241 2.76867 1.19141 6.78262H22.8099C20.869 2.76867 16.7582 0 12.0007 0Z" fill="#D80027"></path><path d="M12.0007 24.0008C16.7582 24.0008 20.869 21.2321 22.81 17.2181H1.19141C3.13241 21.2321 7.24316 24.0008 12.0007 24.0008Z" fill="#0052B4"></path><path d="M14.9514 8.52661L13.8446 9.63338C14.3167 10.1055 14.6088 10.7576 14.6088 11.478C14.6088 12.9188 13.4408 14.0867 12.0001 14.0867C10.5594 14.0867 9.39138 12.9187 9.39138 11.478C9.39138 10.7576 9.68341 10.1055 10.1555 9.63338L9.04872 8.52661C8.29333 9.28186 7.82617 10.3253 7.82617 11.478C7.82617 13.7832 9.69489 15.6519 12.0001 15.6519C14.3052 15.6519 16.174 13.7832 16.174 11.478C16.1739 10.3253 15.7068 9.28186 14.9514 8.52661Z" fill="#6DA544"></path><path d="M12.0003 9.9126L12.3888 11.1084H13.6461L12.6289 11.8473L13.0175 13.043L12.0003 12.3041L10.9831 13.043L11.3716 11.8473L10.3545 11.1084H11.6117L12.0003 9.9126Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), x_2 = [
  m_2
];
function H_2(r, e) {
  return n(), o("svg", k_2, x_2);
}
const UK2 = /* @__PURE__ */ i(L_2, [["render", H_2]]);
var V_2 = {}, Z_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, B_2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -912)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.9997 12C23.9997 5.37262 18.627 0 11.9997 0C9.65216 0 7.46244 0.674766 5.61284 1.83989L8.24314 2.95744L4.69531 4.46484L8.24314 5.9722L4.69531 7.47952L8.24314 8.98678L4.69531 10.4939L8.24314 12.0008L4.69531 13.5082L8.24314 15.0154L4.69531 16.5225L8.24314 18.0297L4.69531 19.537L8.24314 21.0441L5.61402 22.161C7.46338 23.3256 9.65263 24 11.9997 24C18.627 24 23.9997 18.6274 23.9997 12Z" fill="#751A46"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), F_2 = [
  B_2
];
function j_2(r, e) {
  return n(), o("svg", Z_2, F_2);
}
const NK2 = /* @__PURE__ */ i(V_2, [["render", j_2]]);
var I_2 = {}, b_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y_2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -1136)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M16.1745 0.745367C14.8744 0.26307 13.4684 -0.000976556 12.0006 -0.000976556C10.5327 -0.00102343 9.12667 0.26307 7.82669 0.745367L6.7832 11.999L7.82669 23.2526C9.12662 23.735 10.5327 23.999 12.0006 23.999C13.4684 23.999 14.8745 23.735 16.1745 23.2526L17.2179 11.999L16.1745 0.745367Z" fill="#FFDA44"></path><path d="M23.9999 11.9996C23.9999 6.84005 20.7434 2.44144 16.1738 0.745972V23.2533C20.7434 21.5576 23.9999 17.1592 23.9999 11.9996Z" fill="#D80027"></path><path d="M0 11.9995C0 17.1592 3.2565 21.5576 7.82602 23.2532L7.82606 0.745972C3.2565 2.44144 0 6.83991 0 11.9995Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), D_2 = [
  y_2
];
function P_2(r, e) {
  return n(), o("svg", b_2, D_2);
}
const qK2 = /* @__PURE__ */ i(I_2, [["render", P_2]]);
var A_2 = {}, S_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, T_2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -352)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12 0C5.37262 0 0 5.37262 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739H23.2537C23.736 14.874 24 13.4678 24 12C24 5.37262 18.6274 0 12 0Z" fill="#0052B4"></path><path d="M12.0007 0.00012207C6.8411 0.00012207 2.44259 3.25662 0.74707 7.82623H23.2543C21.5588 3.25662 17.1603 0.00012207 12.0007 0.00012207Z" fill="#D80027"></path><path d="M3.10352 6.78314V12.7694C3.10352 16.1746 7.552 17.2179 7.552 17.2179C7.552 17.2179 12.0004 16.1746 12.0004 12.7694V6.78314H3.10352Z" fill="#D80027"></path><path d="M4.94238 7.82638H10.1598V5.73941L9.11632 6.26113L7.55112 4.69592L5.98587 6.26113L4.94238 5.73941V7.82638Z" fill="#FFDA44"></path><path d="M10.9565 13.6026L7.56514 10.2112L4.17383 13.6026L5.28059 14.7093L7.56514 12.4248L9.84969 14.7093L10.9565 13.6026Z" fill="#FFDA44"></path><path d="M10.9565 10.4341H9.37414C9.46311 10.2805 9.51486 10.1027 9.51486 9.91244C9.51486 9.33607 9.04766 8.86896 8.47137 8.86896C8.07317 8.86896 7.72737 9.09199 7.55145 9.41988C7.37553 9.09204 7.02973 8.86896 6.63153 8.86896C6.05525 8.86896 5.58805 9.33607 5.58805 9.91244C5.58805 10.1027 5.6398 10.2806 5.72877 10.4341H4.17383C4.17383 11.0104 4.67581 11.4776 5.25205 11.4776H5.21731C5.21731 12.0539 5.68447 12.521 6.2608 12.521C6.2608 13.0313 6.62726 13.4553 7.11125 13.546L6.28906 15.4023C6.68309 15.5625 7.11369 15.6515 7.56519 15.6515C8.01669 15.6515 8.44728 15.5625 8.84131 15.4023L8.01912 13.546C8.50311 13.4553 8.86958 13.0314 8.86958 12.521C9.44591 12.521 9.91306 12.0539 9.91306 11.4776H9.87833C10.4545 11.4776 10.9565 11.0103 10.9565 10.4341Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), O_2 = [
  T_2
];
function E_2(r, e) {
  return n(), o("svg", S_2, O_2);
}
const zK2 = /* @__PURE__ */ i(A_2, [["render", E_2]]);
var R_2 = {}, U_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, N_2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -1192)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.2536 16.1733C23.736 14.8734 24 13.4673 24 11.9995C24 10.5316 23.736 9.12555 23.2536 7.82556H0.746391C0.264047 9.12555 0 10.5316 0 11.9995C0 13.4673 0.264047 14.8734 0.746391 16.1733L12 17.2168L23.2536 16.1733Z" fill="#0052B4"></path><path d="M12.0007 23.9995C17.1603 23.9995 21.5588 20.743 23.2543 16.1733H0.74707C2.44259 20.743 6.8411 23.9995 12.0007 23.9995Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), q_2 = [
  N_2
];
function z_2(r, e) {
  return n(), o("svg", U_2, q_2);
}
const KK2 = /* @__PURE__ */ i(R_2, [["render", z_2]]);
var K_2 = {}, G_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, W_2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -1248)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0 11.9991C0 14.078 0.528891 16.0333 1.45908 17.7382L12 18.7817L22.5409 17.7382C23.4711 16.0333 24 14.078 24 11.9991L12 10.9556L0 11.9991Z" fill="#FFDA44"></path><path d="M22.5409 6.26086C20.5057 2.53073 16.5485 0 12 0C7.45148 0 3.49434 2.53073 1.45908 6.26086C0.528891 7.96575 0 9.92109 0 12H24C24 9.92109 23.4711 7.96575 22.5409 6.26086Z" fill="#338AF3"></path><path d="M11.9999 23.9991C16.5484 23.9991 20.5056 21.4684 22.5408 17.7383H1.45898C3.49425 21.4684 7.45139 23.9991 11.9999 23.9991Z" fill="#496E2D"></path><path d="M13.5654 7.02244L15.031 7.71183L14.2506 9.1312L15.842 8.8268L16.0437 10.4344L17.1521 9.252L18.2606 10.4344L18.4622 8.8268L20.0536 9.13111L19.2732 7.71178L20.7387 7.02244L19.2732 6.33314L20.0536 4.91377L18.4622 5.21817L18.2605 3.6106L17.1521 4.79297L16.0436 3.6106L15.842 5.21817L14.2506 4.91377L15.031 6.33319L13.5654 7.02244Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Y_2 = [
  W_2
];
function X_2(r, e) {
  return n(), o("svg", G_2, Y_2);
}
const GK2 = /* @__PURE__ */ i(K_2, [["render", X_2]]);
var Q_2 = {}, J_2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tC2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -240)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#6DA544"></path><path d="M6.7832 14.3477C6.7832 15.2121 7.48399 15.9129 8.34841 15.9129H13.0441C13.0441 16.6332 13.628 17.2172 14.3484 17.2172H15.9136C16.634 17.2172 17.218 16.6332 17.218 15.9129V14.3477H6.7832Z" fill="#F0F0F0"></path><path d="M17.3472 6.78308V10.4352C17.3472 11.0106 16.8791 11.4787 16.3037 11.4787V13.0439C17.7422 13.0439 18.9124 11.8737 18.9124 10.4352V6.78308H17.3472Z" fill="#F0F0F0"></path><path d="M6.1304 10.435C6.1304 11.0104 5.6623 11.4785 5.08691 11.4785V13.0437C6.52537 13.0437 7.6956 11.8734 7.6956 10.435V6.78284H6.1304V10.435Z" fill="#F0F0F0"></path><path d="M16.5652 6.78308H15V10.4353H16.5652V6.78308Z" fill="#F0F0F0"></path><path d="M12.6524 8.87005C12.6524 9.01391 12.5354 9.13091 12.3916 9.13091C12.2477 9.13091 12.1307 9.01386 12.1307 8.87005V6.78308H10.5655V8.87005C10.5655 9.01391 10.4484 9.13091 10.3046 9.13091C10.1608 9.13091 10.0438 9.01386 10.0438 8.87005V6.78308H8.47852V8.87005C8.47852 9.87697 9.2977 10.6962 10.3046 10.6962C10.6924 10.6962 11.0521 10.5743 11.3481 10.3673C11.6441 10.5742 12.0038 10.6962 12.3916 10.6962C12.4697 10.6962 12.5465 10.6907 12.622 10.6811C12.5111 11.138 12.0995 11.4787 11.609 11.4787V13.0439C13.0474 13.0439 14.2177 11.8737 14.2177 10.4353V8.87005V6.78308H12.6525V8.87005H12.6524Z" fill="#F0F0F0"></path><path d="M10.8263 11.4781H8.47852V13.0433H10.8263V11.4781Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), eC2 = [
  tC2
];
function rC2(r, e) {
  return n(), o("svg", J_2, eC2);
}
const WK2 = /* @__PURE__ */ i(Q_2, [["render", rC2]]);
var nC2 = {}, oC2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iC2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -800)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M20.4863 20.4851C24.9868 15.9846 25.1645 8.79939 21.0213 4.08569L12.0007 11.9994L4.08691 21.0201C8.80061 25.1633 15.9858 24.9856 20.4863 20.4851Z" fill="#496E2D"></path><path d="M3.51438 3.5144C8.01488 -0.986107 15.2001 -1.16381 19.9138 2.97942L12 12.0001L2.97944 19.9138C-1.16383 15.2001 -0.986083 8.01491 3.51438 3.5144Z" fill="#0052B4"></path><path d="M19.9139 2.98022L2.97949 19.9146C3.15068 20.1094 3.32843 20.3005 3.51448 20.4864C3.70048 20.6724 3.89158 20.8502 4.0864 21.0214L21.0207 4.08703C20.8495 3.89222 20.6717 3.70116 20.4856 3.51511C20.2997 3.32921 20.1086 3.15141 19.9139 2.98022Z" fill="#FFDA44"></path><path d="M5.05619 4.17444L5.31526 4.97164H6.15343L5.47534 5.46425L5.73433 6.26145L5.05619 5.76875L4.37805 6.26145L4.63712 5.46425L3.95898 4.97164H4.7972L5.05619 4.17444Z" fill="#F0F0F0"></path><path d="M9.33744 4.17358L9.59652 4.97079H10.4346L9.75655 5.46339L10.0156 6.2606L9.33744 5.76789L8.6593 6.2606L8.91837 5.46339L8.24023 4.97079H9.07841L9.33744 4.17358Z" fill="#F0F0F0"></path><path d="M5.05619 8.34778L5.31526 9.14498H6.15343L5.47534 9.63763L5.73433 10.4348L5.05619 9.94213L4.37805 10.4348L4.63712 9.63763L3.95898 9.14498H4.7972L5.05619 8.34778Z" fill="#F0F0F0"></path><path d="M9.33744 8.34778L9.59652 9.14498H10.4346L9.75655 9.63763L10.0156 10.4348L9.33744 9.94213L8.6593 10.4348L8.91837 9.63763L8.24023 9.14498H9.07841L9.33744 8.34778Z" fill="#F0F0F0"></path><path d="M7.19686 6.2616L7.45593 7.0588H8.29406L7.61597 7.55145L7.875 8.34865L7.19686 7.85595L6.51872 8.34865L6.77775 7.55145L6.09961 7.0588H6.93783L7.19686 6.2616Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), lC2 = [
  iC2
];
function sC2(r, e) {
  return n(), o("svg", oC2, lC2);
}
const YK2 = /* @__PURE__ */ i(nC2, [["render", sC2]]);
var hC2 = {}, aC2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dC2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -408)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M20.1006 3.14638C17.9659 1.19206 15.1224 -0.000671387 12.0002 -0.000671387C11.489 -0.000671387 10.9854 0.0315317 10.491 0.0935474L4.69581 6.78195L0.379883 15.0055C0.658695 16.0865 1.08498 17.108 1.63496 18.0485L12.0002 11.9993L20.1006 3.14638Z" fill="#FFDA44"></path><path d="M21.9903 18.6479L5.20117 21.8879C7.13378 23.2192 9.47556 23.9993 11.9998 23.9993C16.168 23.9993 19.8392 21.8738 21.9903 18.6479Z" fill="#6DA544"></path><path d="M20.1021 3.14819L1.6416 18.0603C2.12446 18.8838 2.70257 19.6446 3.36102 20.3276L23.9999 11.9996C23.9999 8.49522 22.4976 5.34204 20.1021 3.14819Z" fill="#D80027"></path><path d="M0 12C0 13.0382 0.131906 14.0455 0.379734 15.0062L10.4909 0.0942383C4.57584 0.836457 0 5.88377 0 12Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), cC2 = [
  dC2
];
function _C2(r, e) {
  return n(), o("svg", aC2, cC2);
}
const XK2 = /* @__PURE__ */ i(hC2, [["render", _C2]]);
var CC2 = {}, fC2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vC2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -128)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M9.39067 10.435H23.8977C23.1307 4.54721 18.0962 0.000244141 11.9993 0.000244141C11.1033 0.000244141 10.2306 0.099291 9.39062 0.285479V10.435H9.39067Z" fill="#0052B4"></path><path d="M6.26085 10.4349V1.45923C2.96581 3.25707 0.607016 6.55478 0.101562 10.4349H6.26085V10.4349Z" fill="#0052B4"></path><path d="M6.2608 13.5657H0.101562C0.607016 17.4458 2.96581 20.7436 6.26085 22.5414L6.2608 13.5657Z" fill="#0052B4"></path><path d="M9.39062 13.5657V23.7152C10.2306 23.9014 11.1033 24.0005 11.9993 24.0005C18.0962 24.0005 23.1307 19.4535 23.8977 13.5657H9.39062V13.5657Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), uC2 = [
  vC2
];
function wC2(r, e) {
  return n(), o("svg", fC2, uC2);
}
const QK2 = /* @__PURE__ */ i(CC2, [["render", wC2]]);
var pC2 = {}, gC2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $C2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -520)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#D80027"></path><path d="M7.30353 6.26101C7.30353 4.51267 8.53226 3.05214 10.1731 2.69378C9.92089 2.63875 9.65928 2.60889 9.39045 2.60889C7.37337 2.60889 5.73828 4.24398 5.73828 6.26106C5.73828 8.27814 7.37337 9.91323 9.39045 9.91323C9.65919 9.91323 9.92084 9.88337 10.1731 9.82829C8.53226 9.46993 7.30353 8.0094 7.30353 6.26101Z" fill="#F0F0F0"></path><path d="M11.9995 2.87L12.2585 3.66711H13.0967L12.4186 4.15981L12.6776 4.95692L11.9995 4.46431L11.3214 4.95692L11.5804 4.15981L10.9023 3.66711H11.7405L11.9995 2.87Z" fill="#F0F0F0"></path><path d="M9.96639 4.43469L10.2254 5.23185H11.0635L10.3855 5.7245L10.6445 6.52161L9.96639 6.029L9.2882 6.52161L9.54728 5.7245L8.86914 5.23185H9.70731L9.96639 4.43469Z" fill="#F0F0F0"></path><path d="M14.0327 4.43469L14.2918 5.23185H15.1299L14.4518 5.7245L14.7108 6.52161L14.0327 6.029L13.3546 6.52161L13.6136 5.7245L12.9355 5.23185H13.7737L14.0327 4.43469Z" fill="#F0F0F0"></path><path d="M13.2505 6.78345L13.5095 7.5806H14.3476L13.6695 8.07326L13.9286 8.87037L13.2505 8.37776L12.5724 8.87037L12.8314 8.07326L12.1533 7.5806H12.9914L13.2505 6.78345Z" fill="#F0F0F0"></path><path d="M10.7486 6.78345L11.0076 7.5806H11.8458L11.1676 8.07326L11.4267 8.87037L10.7486 8.37776L10.0704 8.87037L10.3295 8.07326L9.65137 7.5806H10.4895L10.7486 6.78345Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), MC2 = [
  $C2
];
function LC2(r, e) {
  return n(), o("svg", gC2, MC2);
}
const JK2 = /* @__PURE__ */ i(pC2, [["render", LC2]]);
var kC2 = {}, mC2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xC2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -744)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.2536 7.82637H10.4348V4.69592H4.17389V7.82637H0.746391C0.264047 9.12631 0 10.5324 0 12.0003C0 13.4681 0.264047 14.8742 0.746391 16.1742L12 17.2176L23.2536 16.1742C23.736 14.8742 24 13.4681 24 12.0003C24 10.5324 23.736 9.12631 23.2536 7.82637Z" fill="#0052B4"></path><path d="M11.9997 23.9997C17.1593 23.9997 21.5578 20.7432 23.2533 16.1736H0.746094C2.44161 20.7432 6.84012 23.9997 11.9997 23.9997Z" fill="#D80027"></path><path d="M4.17383 7.82641V8.86984C4.17383 11.2661 7.30428 12.0003 7.30428 12.0003C7.30428 12.0003 10.4347 11.2661 10.4347 8.86984V7.82641L9.39125 8.86989L7.30428 7.30469L5.21731 8.86989L4.17383 7.82641Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), HC2 = [
  xC2
];
function VC2(r, e) {
  return n(), o("svg", mC2, HC2);
}
const tG2 = /* @__PURE__ */ i(kC2, [["render", VC2]]);
var ZC2 = {}, BC2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, FC2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -688)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12 23.9996C18.6274 23.9996 24 18.6269 24 11.9996C24 10.5317 23.736 9.12562 23.2536 7.82568H0.746391C0.264047 9.12562 0 10.5317 0 11.9996C0 18.6269 5.37262 23.9996 12 23.9996Z" fill="#0052B4"></path><path d="M11.9997 23.9997C17.1593 23.9997 21.5578 20.7432 23.2533 16.1736H0.746094C2.44161 20.7432 6.84012 23.9997 11.9997 23.9997Z" fill="#D80027"></path><path d="M3.10254 6.78186V12.7681C3.10254 16.1733 7.55102 17.2167 7.55102 17.2167C7.55102 17.2167 11.9995 16.1733 11.9995 12.7681V6.78186H3.10254Z" fill="#F0F0F0"></path><path d="M4.14648 6.78186V12.7681C4.14648 13.1678 4.23527 13.5454 4.41114 13.8993C6.15648 13.8993 8.76517 13.8993 10.6918 13.8993C10.8677 13.5454 10.9564 13.1678 10.9564 12.7681V6.78186H4.14648Z" fill="#D80027"></path><path d="M9.63874 10.9561H8.07358V9.91261H9.11707V8.86912H8.07358V7.82568H7.03009V8.86912H5.98666V9.91261H7.03009V10.9561H5.46484V11.9996H7.03009V13.0431H8.07358V11.9996H9.63874V10.9561Z" fill="#F0F0F0"></path><path d="M5.8344 15.3573C6.50682 15.7799 7.19766 16.0252 7.55134 16.1343C7.90501 16.0253 8.59585 15.7799 9.26827 15.3573C9.94637 14.9311 10.4217 14.4437 10.6916 13.9007C10.3939 13.69 10.0307 13.5658 9.63831 13.5658C9.49543 13.5658 9.35663 13.5827 9.22318 13.6138C8.94038 12.9713 8.29843 12.5223 7.55138 12.5223C6.80434 12.5223 6.16234 12.9713 5.87959 13.6138C5.74613 13.5827 5.60729 13.5658 5.46446 13.5658C5.07207 13.5658 4.70884 13.69 4.41113 13.9007C4.6809 14.4437 5.15626 14.9311 5.8344 15.3573Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), jC2 = [
  FC2
];
function IC2(r, e) {
  return n(), o("svg", BC2, jC2);
}
const eG2 = /* @__PURE__ */ i(ZC2, [["render", IC2]]);
var bC2 = {}, yC2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, DC2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -464)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M23.2536 16.1743C23.736 14.8744 24 13.4683 24 12.0005C24 10.5326 23.736 9.12655 23.2536 7.82656L12 6.78308L0.746391 7.82656C0.264 9.12655 0 10.5326 0 12.0005C0 13.4683 0.264 14.8744 0.746391 16.1743L12 17.2178L23.2536 16.1743Z" fill="#F0F0F0"></path><path d="M11.9997 24.0006C17.1593 24.0006 21.5578 20.7441 23.2533 16.1744H0.746094C2.44166 20.7441 6.84012 24.0006 11.9997 24.0006Z" fill="#338AF3"></path><path d="M11.9997 0.00012207C6.84012 0.00012207 2.44166 3.25662 0.746094 7.82623H23.2534C21.5578 3.25662 17.1593 0.00012207 11.9997 0.00012207Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), PC2 = [
  DC2
];
function AC2(r, e) {
  return n(), o("svg", yC2, PC2);
}
const rG2 = /* @__PURE__ */ i(bC2, [["render", AC2]]);
var SC2 = {}, TC2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OC2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -128)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 11.9997C24 18.6271 18.6274 23.9997 12 23.9997C5.37262 23.9997 0 18.6271 0 11.9997C0.521719 11.9997 12 10.4345 12 10.4345L24 11.9997Z" fill="#338AF3"></path><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#F0F0F0"></path><path d="M16.7631 8.28088L11.9998 13.0442L7.23659 8.28088C6.6206 9.19527 6.26074 10.2959 6.26074 11.4789V13.0441C6.26074 15.5574 7.88473 17.6983 10.1383 18.4732C9.83754 19.0627 9.88826 19.7984 10.329 20.3485C10.9144 19.8793 11.5204 19.3936 12.0346 18.9817C12.5487 19.3937 13.1548 19.8794 13.7401 20.3485C14.186 19.792 14.2331 19.0453 13.9204 18.4523C16.1433 17.6606 17.7389 15.5354 17.7389 13.0441V11.479C17.739 10.2959 17.3791 9.19532 16.7631 8.28088Z" fill="#6DA544"></path><path d="M12.0001 17.2176C9.69855 17.2176 7.82617 15.3451 7.82617 13.0437V11.4785C7.82617 9.17694 9.69859 7.30457 12.0001 7.30457C14.3015 7.30457 16.174 9.17699 16.174 11.4785V13.0437C16.174 15.3451 14.3016 17.2176 12.0001 17.2176Z" fill="#FFDA44"></path><path d="M14.609 13.0433V11.4781C14.609 10.0397 13.4387 8.86945 12.0003 8.86945C10.5619 8.86945 9.3916 10.0397 9.3916 11.4781V13.0433L12.0003 13.565L14.609 13.0433Z" fill="#338AF3"></path><path d="M9.3916 13.0432C9.3916 14.4817 10.5619 15.6519 12.0003 15.6519C13.4387 15.6519 14.609 14.4816 14.609 13.0432H9.3916Z" fill="#6DA544"></path><path d="M15.13 7.30397C15.13 6.43955 14.4292 5.73876 13.5648 5.73876C13.1638 5.73876 12.7983 5.8897 12.5213 6.13762V5.217H13.043V4.17351H12.5213V3.65179H11.4778V4.17351H10.9561V5.217H11.4778V6.13762C11.2008 5.8897 10.8353 5.73876 10.4343 5.73876C9.56992 5.73876 8.86914 6.43955 8.86914 7.30397C8.86914 7.76742 9.07075 8.18367 9.39086 8.47031V9.39094H14.6082V8.47031C14.9284 8.18367 15.13 7.76742 15.13 7.30397Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), EC2 = [
  OC2
];
function RC2(r, e) {
  return n(), o("svg", TC2, EC2);
}
const nG2 = /* @__PURE__ */ i(SC2, [["render", RC2]]);
var UC2 = {}, NC2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qC2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -296)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M17.2175 1.19084C15.6399 0.427997 13.87 0.00012207 12.0001 0.00012207C10.1303 0.00012207 8.36037 0.427997 6.78274 1.19084L5.73926 12.0001L6.78274 22.8094C8.36037 23.5722 10.1303 24.0001 12.0001 24.0001C13.87 24.0001 15.6399 23.5722 17.2175 22.8094L18.261 12.0001L17.2175 1.19084Z" fill="#FFDA44"></path><path d="M12 7.82605L13.0359 11.0145H16.3888L13.6764 12.9853L14.7124 16.1738L12 14.2032L9.28753 16.1738L10.3237 12.9853L7.61133 11.0145H10.964L12 7.82605Z" fill="#496E2D"></path><path d="M6.78262 1.1908C2.76872 3.13175 0 7.24217 0 11.9997C0 16.7571 2.76872 20.8676 6.78262 22.8085V1.1908Z" fill="#496E2D"></path><path d="M17.2178 1.19141V22.8091C21.2317 20.8682 24.0004 16.7578 24.0004 12.0003C24.0004 7.24278 21.2317 3.13236 17.2178 1.19141Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), zC2 = [
  qC2
];
function KC2(r, e) {
  return n(), o("svg", NC2, zC2);
}
const oG2 = /* @__PURE__ */ i(UC2, [["render", KC2]]);
var GC2 = {}, WC2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YC2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -856)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"></path><path d="M12.0006 6.26062L13.2956 10.2464H17.4864L14.096 12.7096L15.391 16.6954L12.0006 14.2321L8.6101 16.6954L9.90516 12.7096L6.51465 10.2464H10.7055L12.0006 6.26062Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), XC2 = [
  YC2
];
function QC2(r, e) {
  return n(), o("svg", WC2, XC2);
}
const iG2 = /* @__PURE__ */ i(GC2, [["render", QC2]]);
var JC2 = {}, tf2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ef2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -16)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.2536 7.82684H0.746344C0.264047 9.12687 0 10.5329 0 12.0007C0 13.4686 0.264047 14.8747 0.746344 16.1746H23.2536C23.736 14.8747 24 13.4686 24 12.0007C24 10.5329 23.736 9.12687 23.2536 7.82684Z" fill="#A2001D"></path><path d="M12.0345 24.0012C16.1446 24.0012 19.7716 21.9344 21.9343 18.7838H2.13477C4.29748 21.9344 7.92439 24.0012 12.0345 24.0012Z" fill="#6DA544"></path><path d="M12.0345 0.000305176C16.1446 0.000305176 19.7716 2.06712 21.9343 5.21768H2.13477C4.29748 2.06712 7.92439 0.000305176 12.0345 0.000305176Z" fill="#6DA544"></path><path d="M11.9991 7.82684L13.0351 11.0153H16.3878L13.6754 12.9861L14.7115 16.1746L11.9991 14.204L9.28665 16.1746L10.3228 12.9861L7.61035 11.0153H10.9631L11.9991 7.82684Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), rf2 = [
  ef2
];
function nf2(r, e) {
  return n(), o("svg", tf2, rf2);
}
const lG2 = /* @__PURE__ */ i(JC2, [["render", nf2]]);
var of2 = {}, if2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lf2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -1024)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.0634 7.34694C21.2461 3.03018 16.9771 -0.000854492 11.9995 -0.000854492C8.68576 -0.000854492 5.68609 1.34254 3.51465 3.51425L6.51981 7.34694H23.0634Z" fill="black"></path><path d="M6.55388 16.6075L3.51465 20.4837C5.68609 22.6554 8.68576 23.9988 11.9995 23.9988C16.9939 23.9988 21.2751 20.9475 23.0819 16.6075H6.55388Z" fill="#496E2D"></path><path d="M2.6084 8.82605V15.1304H23.5864C23.8555 14.1323 23.9997 13.0831 23.9997 12C23.9997 10.9011 23.8517 9.83705 23.575 8.82605H2.6084Z" fill="#A2001D"></path><path d="M3.51471 3.51465C-1.17157 8.20093 -1.17157 15.7989 3.51471 20.4853C5.45126 18.5487 7.31375 16.6862 12 12L3.51471 3.51465Z" fill="#0052B4"></path><path d="M3.90889 9.01648L5.3735 11.0603L7.77013 10.2988L6.27899 12.3235L7.7436 14.3674L5.35728 13.5748L3.8661 15.5995L3.8825 13.085L1.49609 12.2923L3.89253 11.5309L3.90889 9.01648Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), sf2 = [
  lf2
];
function hf2(r, e) {
  return n(), o("svg", if2, sf2);
}
const sG2 = /* @__PURE__ */ i(of2, [["render", hf2]]);
var af2 = {}, df2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cf2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -184)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M7.30486 7.82623H23.2541C21.5586 3.25662 17.16 0.00012207 12.0005 0.00012207C8.68673 0.00012207 5.68706 1.34351 3.51562 3.51523L7.30486 7.82623Z" fill="#6DA544"></path><path d="M7.30388 16.1746H23.2531C21.5576 20.7442 17.1591 24.0007 11.9995 24.0007C8.68576 24.0007 5.68609 22.6573 3.51465 20.4856L7.30388 16.1746Z" fill="#6DA544"></path><path d="M3.51471 3.51379C-1.17157 8.20008 -1.17157 15.7981 3.51471 20.4844C5.45126 18.5479 7.31375 16.6854 12 11.9991L3.51471 3.51379Z" fill="#D80027"></path><path d="M15.2383 9.91278L15.7563 11.5071H17.4327L16.0765 12.4924L16.5945 14.0867L15.2383 13.1014L13.8821 14.0867L14.4001 12.4924L13.0439 11.5071H14.7203L15.2383 9.91278Z" fill="black"></path><path d="M20.4561 9.91278L20.9741 11.5071H22.6504L21.2943 12.4924L21.8123 14.0867L20.4561 13.1014L19.0999 14.0867L19.6179 12.4924L18.2617 11.5071H19.9381L20.4561 9.91278Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), _f2 = [
  cf2
];
function Cf2(r, e) {
  return n(), o("svg", df2, _f2);
}
const hG2 = /* @__PURE__ */ i(af2, [["render", Cf2]]);
var ff2 = {}, vf2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uf2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -16)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 -0.000976562C7.24218 -0.000976562 3.13143 2.7677 1.19043 6.78165H22.8089C20.868 2.7677 16.7572 -0.000976562 11.9997 -0.000976562Z" fill="#0052B4"></path><path d="M11.9997 23.9989C16.7572 23.9989 20.868 21.2302 22.809 17.2162H1.19043C3.13143 21.2302 7.24218 23.9989 11.9997 23.9989Z" fill="#0052B4"></path><path d="M9.58984 12.5225L11.9997 8.34857L14.4095 12.5225H9.58984Z" fill="#FFDA44"></path><path d="M15.13 13.8996L11.9996 15.4649L8.86914 13.8996V11.8127H15.13V13.8996Z" fill="#6DA544"></path><path d="M14.9514 8.52728L13.8446 9.63405C14.3167 10.1061 14.6088 10.7583 14.6088 11.4787C14.6088 12.9194 13.4408 14.0874 12.0001 14.0874C10.5594 14.0874 9.39138 12.9194 9.39138 11.4787C9.39138 10.7583 9.68341 10.1061 10.1555 9.63405L9.04872 8.52728C8.29333 9.28253 7.82617 10.326 7.82617 11.4787C7.82617 13.7839 9.69489 15.6526 12.0001 15.6526C14.3052 15.6526 16.174 13.7839 16.174 11.4787C16.1739 10.326 15.7068 9.28253 14.9514 8.52728Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), wf2 = [
  uf2
];
function pf2(r, e) {
  return n(), o("svg", vf2, wf2);
}
const aG2 = /* @__PURE__ */ i(ff2, [["render", pf2]]);
var gf2 = {}, $f2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mf2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -632)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M10.9565 13.0426C10.9565 13.0426 3.52168 3.51219 3.51465 3.51388C5.68618 1.3423 8.68623 -0.000854492 12 -0.000854492C18.6273 -0.000854492 24 5.37177 24 11.9991L10.9565 13.0426Z" fill="#D80027"></path><path d="M10.9565 11.9995C10.9565 11.9995 3.52168 20.4865 3.51465 20.4848C5.68618 22.6563 8.68623 23.9995 12 23.9995C18.6273 23.9995 24 18.6269 24 11.9995H10.9565Z" fill="#0052B4"></path><path d="M3.51471 3.51465C-1.17157 8.20093 -1.17157 15.7989 3.51471 20.4853C5.45126 18.5487 7.31375 16.6862 12 12L3.51471 3.51465Z" fill="#F0F0F0"></path><path d="M1.3157 11.9995C1.30914 12.0857 1.30469 12.1725 1.30469 12.2603C1.30469 14.1333 2.82306 15.6516 4.696 15.6516C6.56894 15.6516 8.08731 14.1333 8.08731 12.2603C8.08731 12.1725 8.08286 12.0856 8.0763 11.9995H1.3157Z" fill="#FFDA44"></path><path d="M4.69583 10.4338C5.27213 10.4338 5.73931 9.96659 5.73931 9.39029C5.73931 8.81399 5.27213 8.3468 4.69583 8.3468C4.11953 8.3468 3.65234 8.81399 3.65234 9.39029C3.65234 9.96659 4.11953 10.4338 4.69583 10.4338Z" fill="#FFDA44"></path><path d="M2.34766 9.13025V12.5216C2.34766 14.3187 4.69548 14.8694 4.69548 14.8694C4.69548 14.8694 7.04331 14.3187 7.04331 12.5216V9.13025H2.34766Z" fill="#D80027"></path><path d="M4.69712 13.7777C4.26155 13.6209 3.3916 13.2203 3.3916 12.5219V10.1741H6.00033V12.5219C6.00033 13.2226 5.13048 13.6222 4.69712 13.7777Z" fill="#338AF3"></path><path d="M5.21743 11.4777V10.9559L4.69571 10.6951L4.17395 10.9559V11.4777L3.91309 11.7386V12.782H5.47834V11.7386L5.21743 11.4777Z" fill="#F3F3F3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Lf2 = [
  Mf2
];
function kf2(r, e) {
  return n(), o("svg", $f2, Lf2);
}
const dG2 = /* @__PURE__ */ i(gf2, [["render", kf2]]);
var mf2 = {}, xf2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hf2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -240)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 -0.000732422C6.84013 -0.000732422 2.44161 3.25577 0.746094 7.82538H23.2534C21.5578 3.25577 17.1593 -0.000732422 11.9997 -0.000732422Z" fill="#D80027"></path><path d="M11.9997 24.0005C17.1593 24.0005 21.5578 20.744 23.2533 16.1744H0.746094C2.44161 20.744 6.84012 24.0005 11.9997 24.0005Z" fill="black"></path><path d="M7.17067 9.13013L7.81815 11.1229H9.91361L8.21837 12.3547L8.8659 14.3475L7.17067 13.1159L5.47544 14.3475L6.12297 12.3547L4.42773 11.1229H6.52319L7.17067 9.13013Z" fill="#6DA544"></path><path d="M16.8308 9.13013L17.4783 11.1229H19.5738L17.8785 12.3547L18.5261 14.3475L16.8308 13.1159L15.1356 14.3475L15.7831 12.3547L14.0879 11.1229H16.1833L16.8308 9.13013Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Vf2 = [
  Hf2
];
function Zf2(r, e) {
  return n(), o("svg", xf2, Vf2);
}
const cG2 = /* @__PURE__ */ i(mf2, [["render", Zf2]]);
var Bf2 = {}, Ff2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jf2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -72)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M22.8093 17.2165C23.5721 15.639 24 13.869 24 11.9992C24 10.1293 23.5721 8.35936 22.8093 6.78178L12 6.26001L1.19072 6.78173C0.427875 8.35936 0 10.1293 0 11.9992C0 13.869 0.427875 15.639 1.19072 17.2165L12 17.7383L22.8093 17.2165Z" fill="#FFDA44"></path><path d="M11.9997 0.000305176C7.24218 0.000305176 3.13143 2.76898 1.19043 6.78293H22.8089C20.868 2.76898 16.7572 0.000305176 11.9997 0.000305176Z" fill="black"></path><path d="M11.9997 23.9994C7.24218 23.9994 3.13143 21.2307 1.19043 17.2167H22.8089C20.868 21.2307 16.7572 23.9994 11.9997 23.9994Z" fill="#0052B4"></path><path d="M23.4333 8.34784H0.566672C0.199078 9.49951 0 10.7265 0 12C0 13.2736 0.199078 14.5005 0.566672 15.6522H23.4333C23.8009 14.5005 24 13.2736 24 12C24 10.7265 23.8009 9.49951 23.4333 8.34784Z" fill="#A2001D"></path><path d="M19.826 11.4791H4.17383V12.5226H19.826V11.4791Z" fill="#FFDA44"></path><path d="M17.739 9.39117H6.26074V10.4347H17.739V9.39117Z" fill="#FFDA44"></path><path d="M17.8133 11.9995C17.8133 11.9995 15.13 15.13 11.9996 15.13C8.86919 15.13 8.86914 11.9995 8.86914 11.9995C8.86914 11.9995 8.86914 8.86908 11.9996 8.86908C15.1301 8.86908 17.8133 11.9995 17.8133 11.9995Z" fill="#F0F0F0"></path><path d="M11.9992 15.13C8.86877 15.13 6.18555 11.9995 6.18555 11.9995C6.18555 11.9995 8.86877 8.86908 11.9992 8.86908" fill="black"></path><path d="M10.9566 10.957H9.91309V13.0439H10.9566V10.957Z" fill="#F0F0F0"></path><path d="M14.0865 10.957H13.043V13.0439H14.0865V10.957Z" fill="black"></path><path d="M4.17434 13.0445C4.75065 13.0445 5.21783 12.5773 5.21783 12.001C5.21783 11.4247 4.75065 10.9575 4.17434 10.9575C3.59804 10.9575 3.13086 11.4247 3.13086 12.001C3.13086 12.5773 3.59804 13.0445 4.17434 13.0445Z" fill="#0052B4"></path><path d="M19.8267 13.0441C20.403 13.0441 20.8702 12.5769 20.8702 12.0006C20.8702 11.4243 20.403 10.9572 19.8267 10.9572C19.2504 10.9572 18.7832 11.4243 18.7832 12.0006C18.7832 12.5769 19.2504 13.0441 19.8267 13.0441Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), If2 = [
  jf2
];
function bf2(r, e) {
  return n(), o("svg", Ff2, If2);
}
const _G2 = /* @__PURE__ */ i(Bf2, [["render", bf2]]);
var yf2 = {}, Df2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pf2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -912)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"></path><path d="M11.9688 11.9996H12.0009C12.0009 11.9888 12.0009 11.9783 12.0009 11.9674C11.9902 11.9782 11.9795 11.9889 11.9688 11.9996Z" fill="#F0F0F0"></path><path d="M12.001 6.26123C12.001 4.14974 12.001 2.76623 12.001 0.000366211H11.999C5.37243 0.00149121 0.000976562 5.3736 0.000976562 12.0004H6.26184V8.47485L9.78735 12.0004H11.9689C11.9796 11.9897 11.9903 11.979 12.001 11.9683C12.001 11.1598 12.001 10.4384 12.001 9.78683L8.47541 6.26123H12.001Z" fill="#F0F0F0"></path><path d="M6.07124 1.56543C4.19441 2.63413 2.63409 4.19441 1.56543 6.07124V12.0002H4.69588V4.69598V4.69588H12.0002C12.0002 3.70856 12.0002 2.76796 12.0002 1.56543H6.07124Z" fill="#D80027"></path><path d="M12.0009 10.5242L7.73734 6.26074H6.26172V6.26084L12.0008 11.9998H12.0009C12.0009 11.9998 12.0009 10.9823 12.0009 10.5242Z" fill="#D80027"></path><path d="M13.5654 6.26038V11.9995C13.5654 14.7951 17.2176 15.6517 17.2176 15.6517C17.2176 15.6517 20.8698 14.7951 20.8698 11.9995V6.26038H13.5654Z" fill="#FFDA44"></path><path d="M16.6954 8.34768C16.6954 8.92401 16.2282 10.4347 15.6519 10.4347C15.0756 10.4347 14.6084 8.92401 14.6084 8.34768C14.6084 7.77136 15.6519 7.3042 15.6519 7.3042C15.6519 7.3042 16.6954 7.77136 16.6954 8.34768Z" fill="#FF9811"></path><path d="M19.4642 9.48417C19.6326 9.07331 19.7636 8.47275 19.7636 8.17378C19.7636 7.6935 19.1374 7.3042 19.1374 7.3042C19.1374 7.3042 18.5113 7.69354 18.5113 8.17378C18.5113 8.47275 18.6423 9.07331 18.8107 9.48417L18.4492 10.3003C18.6617 10.3866 18.8939 10.4346 19.1374 10.4346C19.3809 10.4346 19.6131 10.3866 19.8256 10.3003L19.4642 9.48417Z" fill="#A2001D"></path><path d="M16.4348 12C16.4348 12 15.9131 13.0435 15.9131 14.087C15.9131 14.087 17.4783 14.087 18.5218 14.087C18.5217 13.0435 18 12 18 12L17.2174 11.4783L16.4348 12Z" fill="#6DA544"></path><path d="M18.0008 12.0005V11.7397C18.0008 11.3075 17.6504 10.957 17.2182 10.957C16.786 10.957 16.4355 11.3074 16.4355 11.7397V12.0005H18.0008Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Af2 = [
  Pf2
];
function Sf2(r, e) {
  return n(), o("svg", Df2, Af2);
}
const CG2 = /* @__PURE__ */ i(yf2, [["render", Sf2]]);
var Tf2 = {}, Of2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ef2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -912)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12.0003 -0.000488281C10.5325 -0.000488281 9.12639 0.263559 7.82645 0.745902L7.30469 11.9995L7.82641 23.2531C9.12639 23.7355 10.5325 23.9995 12.0003 23.9995C13.4682 23.9995 14.8743 23.7355 16.1742 23.2531L16.696 11.9995L16.1743 0.745902C14.8743 0.263559 13.4682 -0.000488281 12.0003 -0.000488281Z" fill="#FFDA44"></path><path d="M24.0009 12.0004C24.0009 6.84086 20.7444 2.44234 16.1748 0.746826V23.2541C20.7444 21.5585 24.0009 17.16 24.0009 12.0004Z" fill="#D80027"></path><path d="M7.82611 23.254V0.746826C3.2565 2.44234 0 6.84086 0 12.0004C0 17.16 3.2565 21.5585 7.82611 23.254Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Rf2 = [
  Ef2
];
function Uf2(r, e) {
  return n(), o("svg", Of2, Rf2);
}
const fG2 = /* @__PURE__ */ i(Tf2, [["render", Uf2]]);
var Nf2 = {}, qf2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zf2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -520)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M12.0002 0.000366211C11.9915 0.000459961 11.4785 4.80037 11.4785 4.80037H21.6008C19.4115 1.88582 15.9261 0.000366211 12.0002 0.000366211Z" fill="#496E2D"></path><path d="M11.9999 24.0003C15.9258 24.0003 19.4112 22.1149 21.6004 19.2003H2.39941C4.58866 22.1149 8.07405 24.0003 11.9999 24.0003Z" fill="#496E2D"></path><path d="M23.7599 9.60034H11.4785L12.0002 14.4003H23.7599C23.9174 13.6249 24.0002 12.8223 24.0002 12.0003C24.0002 11.1784 23.9174 10.3758 23.7599 9.60034Z" fill="#496E2D"></path><path d="M12 14.4C12 11.8957 12 2.81737 12 0C5.37262 0 0 5.37262 0 12C0 12.822 0.082875 13.6245 0.240281 14.4H12Z" fill="#D80027"></path><path d="M6.62155 5.73828L7.39855 8.12961H9.91316L7.87892 9.60772L8.65583 11.9991L6.62155 10.5212L4.58727 11.9991L5.36431 9.60772L3.33008 8.12961H5.84459L6.62155 5.73828Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Kf2 = [
  zf2
];
function Gf2(r, e) {
  return n(), o("svg", qf2, Kf2);
}
const vG2 = /* @__PURE__ */ i(Nf2, [["render", Gf2]]);
var Wf2 = {}, Yf2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xf2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -464)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M23.2536 7.82593H0.746391C0.264 9.12591 0 10.532 0 11.9998C0 13.4677 0.264 14.8737 0.746391 16.1737H23.2537C23.736 14.8737 24 13.4677 24 11.9998C24 10.532 23.736 9.12591 23.2536 7.82593Z" fill="#0052B4"></path><path d="M12.0009 -0.000610352C8.36383 -0.000610352 5.10494 1.6177 2.9043 4.17328H21.0975C18.8969 1.6177 15.638 -0.000610352 12.0009 -0.000610352Z" fill="#D80027"></path><path d="M21.0965 19.826H2.90332C5.10396 22.3816 8.36285 23.9999 11.9999 23.9999C15.637 23.9999 18.8959 22.3816 21.0965 19.826Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Qf2 = [
  Xf2
];
function Jf2(r, e) {
  return n(), o("svg", Yf2, Qf2);
}
const uG2 = /* @__PURE__ */ i(Wf2, [["render", Jf2]]);
var tv2 = {}, ev2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rv2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -352)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M1.19072 6.78177C0.427875 8.35939 0 10.1293 0 11.9991C0 13.869 0.427875 15.6389 1.19072 17.2165L12 18.26L22.8093 17.2165C23.5721 15.6389 24 13.869 24 11.9991C24 10.1293 23.5721 8.35939 22.8093 6.78177L12 5.73828L1.19072 6.78177Z" fill="#F0F0F0"></path><path d="M1.19141 17.2176C3.13236 21.2315 7.24278 24.0002 12.0003 24.0002C16.7577 24.0002 20.8682 21.2315 22.8091 17.2176H1.19141Z" fill="#6DA544"></path><path d="M1.19141 6.78201H22.8091C20.8682 2.76811 16.7577 -0.000610352 12.0003 -0.000610352C7.24278 -0.000610352 3.13236 2.76811 1.19141 6.78201Z" fill="#D80027"></path><path d="M9.91309 15.1315H14.087V13.3576L13.2522 13.7749L12.0001 12.5228L10.7479 13.7749L9.91309 13.3576V15.1315Z" fill="#FFDA44"></path><path d="M7.52504 13.0438L7.71934 13.6416H8.34793L7.83934 14.0111L8.03363 14.609L7.52504 14.2395L7.01645 14.609L7.21074 14.0111L6.70215 13.6416H7.33074L7.52504 13.0438Z" fill="#FFDA44"></path><path d="M8.12758 10.9577L8.32187 11.5555H8.95047L8.44187 11.9251L8.63612 12.5229L8.12758 12.1534L7.61898 12.5229L7.81328 11.9251L7.30469 11.5555H7.93328L8.12758 10.9577Z" fill="#FFDA44"></path><path d="M9.84926 9.39282L10.0436 9.99067H10.6721L10.1636 10.3602L10.3578 10.958L9.84926 10.5886L9.34071 10.958L9.53496 10.3602L9.02637 9.99067H9.65501L9.84926 9.39282Z" fill="#FFDA44"></path><path d="M16.4752 13.0438L16.2809 13.6416H15.6523L16.1609 14.0111L15.9666 14.609L16.4752 14.2395L16.9838 14.609L16.7895 14.0111L17.2981 13.6416H16.6695L16.4752 13.0438Z" fill="#FFDA44"></path><path d="M15.8727 10.9577L15.6784 11.5555H15.0498L15.5584 11.9251L15.3641 12.5229L15.8727 12.1534L16.3813 12.5229L16.187 11.9251L16.6956 11.5555H16.067L15.8727 10.9577Z" fill="#FFDA44"></path><path d="M14.151 9.39282L13.9567 9.99067H13.3281L13.8366 10.3602L13.6424 10.958L14.151 10.5886L14.6595 10.958L14.4653 10.3602L14.9738 9.99067H14.3452L14.151 9.39282Z" fill="#FFDA44"></path><path d="M12.0006 8.60938L12.1949 9.20722H12.8235L12.3149 9.57673L12.5092 10.1746L12.0006 9.80511L11.492 10.1746L11.6863 9.57673L11.1777 9.20722H11.8063L12.0006 8.60938Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), nv2 = [
  rv2
];
function ov2(r, e) {
  return n(), o("svg", ev2, nv2);
}
const wG2 = /* @__PURE__ */ i(tv2, [["render", ov2]]);
var iv2 = {}, lv2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sv2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -576)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M19.3043 5.73914C19.1967 6.25641 19.1478 6.80733 19.1478 7.35652C19.1478 10.5222 21.035 13.2621 23.7394 14.4955C23.9097 13.6904 24 12.8558 24 12C24 5.37262 18.6274 0 12 0C5.37262 0 0 5.37262 0 12C0 18.6274 5.37262 24 12 24C16.1101 24 19.7371 21.9332 21.8998 18.7826H6.78263V17.2174H22.8093C22.9733 16.8782 23.1215 16.53 23.2537 16.1739H6.78263L19.3043 5.73914Z" fill="#0052B4"></path><path d="M8.81498 6.26123L9.07401 7.05839H9.91214L9.23409 7.55109L9.49312 8.3482L8.81498 7.85559L8.13693 8.3482L8.39592 7.55109L7.71777 7.05839H8.55595L8.81498 6.26123Z" fill="#F0F0F0"></path><path d="M5.41146 12L5.73528 12.9965H6.78294L5.93529 13.6122L6.25911 14.6087L5.41146 13.9928L4.56387 14.6087L4.88763 13.6122L4.04004 12.9965H5.0877L5.41146 12Z" fill="#F0F0F0"></path><path d="M5.41146 3.65247L5.73528 4.64898H6.78294L5.93529 5.26468L6.25911 6.26115L5.41146 5.64531L4.56387 6.26115L4.88763 5.26468L4.04004 4.64898H5.0877L5.41146 3.65247Z" fill="#F0F0F0"></path><path d="M2.80209 8.34753L3.1259 9.34405H4.17351L3.32591 9.95975L3.64973 10.9562L2.80209 10.3404L1.95449 10.9562L2.27826 9.95975L1.43066 9.34405H2.47827L2.80209 8.34753Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), hv2 = [
  sv2
];
function av2(r, e) {
  return n(), o("svg", lv2, hv2);
}
const pG2 = /* @__PURE__ */ i(iv2, [["render", av2]]);
var dv2 = {}, cv2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _v2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -576)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M12.0001 -0.000366211C9.06209 -0.000366211 6.37119 1.05606 4.28516 2.80904L17.2175 11.9996L4.28516 21.1902C6.37119 22.9432 9.06209 23.9996 12.0001 23.9996C18.6275 23.9996 24.0001 18.627 24.0001 11.9996C24.0001 5.37226 18.6275 -0.000366211 12.0001 -0.000366211Z" fill="#D80027"></path><path d="M3.51471 3.5155C-1.17157 8.20178 -1.17157 15.7998 3.51471 20.4861C5.45126 18.5496 7.31375 16.6871 12 12.0008L3.51471 3.5155Z" fill="black"></path><path d="M3.32659 9.25146L5.15284 10.9798L7.36103 9.77684L6.28173 12.0479L8.10803 13.7763L5.61456 13.4516L4.53513 15.7226L4.07355 13.2508L1.58008 12.926L3.78817 11.7231L3.32659 9.25146Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Cv2 = [
  _v2
];
function fv2(r, e) {
  return n(), o("svg", cv2, Cv2);
}
const gG2 = /* @__PURE__ */ i(dv2, [["render", fv2]]);
var vv2 = {}, uv2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wv2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -856)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M11.9995 -0.000610352C11.1035 -0.000610352 10.2308 0.0984365 9.39086 0.284624L8.86914 11.9993L9.39086 23.7141C10.2308 23.9003 11.1036 23.9994 11.9995 23.9994C18.6269 23.9994 23.9995 18.6268 23.9995 11.9993C23.9995 5.37197 18.6269 -0.000610352 11.9995 -0.000610352Z" fill="#496E2D"></path><path d="M3.13041 3.91711C1.18584 6.04974 0 8.88615 0 11.9997C0 15.1132 1.18589 17.9496 3.13045 20.0823L3.65217 11.9997L3.13041 3.91711Z" fill="#496E2D"></path><path d="M17.5512 9.05156C18.1416 7.40596 17.4783 5.61623 16.0548 4.72485C16.3109 4.75818 16.5672 4.81846 16.8201 4.90917C18.7187 5.59035 19.7056 7.68154 19.0244 9.58007C18.3432 11.4787 16.252 12.4656 14.3535 11.7844C14.1005 11.6936 13.8643 11.5771 13.6455 11.4401C15.311 11.657 16.9608 10.6971 17.5512 9.05156Z" fill="#F0F0F0"></path><path d="M14.2766 4.27429L13.7636 4.9372L12.9747 4.65412L13.4465 5.34684L12.9336 6.00965L13.7382 5.77499L14.2101 6.46762L14.2355 5.62987L15.0401 5.39517L14.2513 5.11218L14.2766 4.27429Z" fill="#F0F0F0"></path><path d="M15.6624 6.4353L15.1493 7.09816L14.3604 6.81508L14.8323 7.5078L14.3193 8.17062L15.1239 7.93587L15.5959 8.62863L15.6213 7.79083L16.4259 7.55608L15.637 7.27305L15.6624 6.4353Z" fill="#F0F0F0"></path><path d="M11.8332 5.06042L11.3202 5.72324L10.5313 5.44025L11.0032 6.13293L10.4902 6.79578L11.2948 6.56108L11.7667 7.25375L11.7921 6.416L12.5967 6.1813L11.8079 5.89822L11.8332 5.06042Z" fill="#F0F0F0"></path><path d="M11.7776 7.53455L11.2646 8.19741L10.4757 7.91437L10.9477 8.60709L10.4346 9.26991L11.2393 9.03525L11.7112 9.72787L11.7365 8.89012L12.5412 8.65542L11.7522 8.37234L11.7776 7.53455Z" fill="#F0F0F0"></path><path d="M14.1321 8.38L13.6191 9.04282L12.8302 8.75979L13.3022 9.4525L12.7891 10.1153L13.5938 9.88061L14.0657 10.5733L14.091 9.73549L14.8957 9.50083L14.1067 9.2178L14.1321 8.38Z" fill="#F0F0F0"></path><path d="M3.12988 3.91743V20.0826C4.76488 21.8758 6.9366 23.1707 9.39074 23.7147V0.285278C6.93655 0.82931 4.76493 2.12423 3.12988 3.91743Z" fill="#D80027"></path><path d="M5.51985 6.31761L4.47168 5.53676V4.43253L5.51985 3.65173H7.00228L8.05045 4.43253V5.53676L7.00228 6.31761H5.51985Z" fill="#F0F0F0"></path><path d="M6.26108 3.65173H5.51985L4.47168 4.43253V4.97239H6.26108V3.65173Z" fill="#FF9811"></path><path d="M6.26074 6.31668H7.00193L8.0501 5.53583V4.97253H6.26074V6.31668Z" fill="#FF9811"></path><path d="M5.51985 20.3485L4.47168 19.5676V18.4635L5.51985 17.6826H7.00228L8.05045 18.4635V19.5676L7.00228 20.3485H5.51985Z" fill="#F0F0F0"></path><path d="M6.26108 17.6826H5.51985L4.47168 18.4635V19.0033H6.26108V17.6826Z" fill="#FF9811"></path><path d="M6.26074 20.3493H7.00193L8.0501 19.5685V19.0052H6.26074V20.3493Z" fill="#FF9811"></path><path d="M5.51985 13.3324L4.47168 12.5515V11.4473L5.51985 10.6665H7.00227L8.05044 11.4473V12.5515L7.00227 13.3324H5.51985Z" fill="#496E2D"></path><path d="M8.0867 15.0514H7.63014V14.5949H6.82787L6.26059 14.0276L5.69335 14.5949H4.89109V15.0514H4.43457V15.9644H4.89109V16.4209H5.69331L6.26063 16.9883L6.82787 16.4209H7.63014V15.9644H8.0867V15.0514Z" fill="#496E2D"></path><path d="M8.0867 8.03605H7.63014V7.57949H6.82787L6.26059 7.01221L5.69335 7.57949H4.89109V8.03605H4.43457V8.94908H4.89109V9.4056H5.69331L6.26063 9.97297L6.82787 9.4056H7.63014V8.94908H8.0867V8.03605Z" fill="#496E2D"></path><path d="M6.78274 11.4791H5.73926V12.5226H6.78274V11.4791Z" fill="#D80027"></path><path d="M6.26097 9.01487C6.54911 9.01487 6.78269 8.78129 6.78269 8.49315C6.78269 8.20502 6.54911 7.97144 6.26097 7.97144C5.97284 7.97144 5.73926 8.20502 5.73926 8.49315C5.73926 8.78129 5.97284 9.01487 6.26097 9.01487Z" fill="#D80027"></path><path d="M6.26097 16.0309C6.54911 16.0309 6.78269 15.7973 6.78269 15.5091C6.78269 15.221 6.54911 14.9874 6.26097 14.9874C5.97284 14.9874 5.73926 15.221 5.73926 15.5091C5.73926 15.7973 5.97284 16.0309 6.26097 16.0309Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), pv2 = [
  wv2
];
function gv2(r, e) {
  return n(), o("svg", uv2, pv2);
}
const $G2 = /* @__PURE__ */ i(vv2, [["render", gv2]]);
var $v2 = {}, Mv2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lv2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -744)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M11.9999 17.7386C15.1695 17.7386 17.739 15.1692 17.739 11.9995C17.739 8.82988 15.1695 6.26038 11.9999 6.26038C8.83025 6.26038 6.26074 8.82988 6.26074 11.9995C6.26074 15.1692 8.83025 17.7386 11.9999 17.7386Z" fill="#F0F0F0"></path><path d="M12.707 9.80505L13.6915 11.1619L15.2861 10.6448L14.3 12.0004L15.2844 13.3572L13.6904 12.8382L12.7043 14.1938L12.7053 12.5175L11.1113 11.9985L12.7059 11.4815L12.707 9.80505Z" fill="#D80027"></path><path d="M13.3044 15.3906C11.4315 15.3906 9.91309 13.8722 9.91309 11.9993C9.91309 10.1263 11.4315 8.60794 13.3044 8.60794C13.8884 8.60794 14.4379 8.7556 14.9176 9.01557C14.165 8.27958 13.1359 7.82532 12.0001 7.82532C9.69494 7.82532 7.82617 9.69404 7.82617 11.9992C7.82617 14.3044 9.69494 16.1731 12.0001 16.1731C13.1359 16.1731 14.1651 15.7188 14.9176 14.9828C14.4379 15.2429 13.8884 15.3906 13.3044 15.3906Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), kv2 = [
  Lv2
];
function mv2(r, e) {
  return n(), o("svg", Mv2, kv2);
}
const MG2 = /* @__PURE__ */ i($v2, [["render", mv2]]);
var xv2 = {}, Hv2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Vv2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -632)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M7.82577 6.26137V4.69617H6.26052V6.26137H4.69531V7.82662H6.26052V9.39183H7.82577V7.82662H9.39097V6.26137H7.82577Z" fill="#D80027"></path><path d="M12 0V12C5.37262 12 2.73867 12 0 12C0 18.6274 5.37262 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37262 18.6274 0 12 0Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Zv2 = [
  Vv2
];
function Bv2(r, e) {
  return n(), o("svg", Hv2, Zv2);
}
const LG2 = /* @__PURE__ */ i(xv2, [["render", Bv2]]);
var Fv2 = {}, jv2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Iv2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -800)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M11.5087 9.80505L12.4933 11.1619L14.0879 10.6448L13.1017 12.0004L14.0862 13.3572L12.4922 12.8382L11.5061 14.1938L11.5071 12.5175L9.91309 11.9985L11.5077 11.4815L11.5087 9.80505Z" fill="#F0F0F0"></path><path d="M8.82198 15.3906C6.94905 15.3906 5.43067 13.8722 5.43067 11.9993C5.43067 10.1263 6.94905 8.60794 8.82198 8.60794C9.40595 8.60794 9.95542 8.75565 10.4351 9.01557C9.68256 8.27954 8.65333 7.82532 7.51764 7.82532C5.21242 7.82532 3.34375 9.69404 3.34375 11.9992C3.34375 14.3044 5.21247 16.1731 7.51764 16.1731C8.65342 16.1731 9.68261 15.7188 10.4351 14.9828C9.95542 15.2429 9.40595 15.3906 8.82198 15.3906Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), bv2 = [
  Iv2
];
function yv2(r, e) {
  return n(), o("svg", jv2, bv2);
}
const kG2 = /* @__PURE__ */ i(Fv2, [["render", yv2]]);
var Dv2 = {}, Pv2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Av2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -688)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M6.49812 1.33191C5.42384 1.88639 4.41541 2.61319 3.51485 3.51375C2.61424 4.41436 1.88745 5.42278 1.33301 6.49706L9.04896 14.9509L17.5028 22.6669C18.5771 22.1124 19.5856 21.3856 20.4861 20.4851C21.3867 19.5845 22.1135 18.576 22.668 17.5018L14.952 9.04786L6.49812 1.33191Z" fill="#F0F0F0"></path><path d="M20.4858 20.486C20.9892 19.9826 21.4382 19.4455 21.8334 18.8821L5.11852 2.16711C4.55513 2.56232 4.01799 3.01129 3.5146 3.51468C3.01121 4.01807 2.56224 4.55521 2.16699 5.11865L18.8819 21.8335C19.4453 21.4383 19.9824 20.9894 20.4858 20.486Z" fill="black"></path><path d="M3.51431 20.4865C7.30026 24.2725 12.9861 24.9992 17.5023 22.6683L1.33251 6.49854C-0.998347 11.0148 -0.271457 16.7006 3.51431 20.4865Z" fill="#D80027"></path><path d="M20.485 3.51461C16.6991 -0.271293 11.0133 -0.998043 6.49707 1.33272L22.6668 17.5026C24.9977 12.9864 24.271 7.30052 20.485 3.51461Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Sv2 = [
  Av2
];
function Tv2(r, e) {
  return n(), o("svg", Pv2, Sv2);
}
const mG2 = /* @__PURE__ */ i(Dv2, [["render", Tv2]]);
var Ov2 = {}, Ev2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rv2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -968)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37263 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#338AF3"></path><path d="M5.73926 12.0012H9.78654L6.26098 7.82727L5.73926 9.39247V12.0012Z" fill="#0052B4"></path><path d="M12.0001 9.78671L7.82617 5.73938H12.0001L12.0001 9.78671Z" fill="#0052B4"></path><path d="M11.9678 11.9996H11.9999C11.9999 11.9888 11.9999 11.9783 11.9999 11.9674C11.9892 11.9782 11.9785 11.9889 11.9678 11.9996Z" fill="#F0F0F0"></path><path d="M12 6.26123C12 4.14974 12 2.76618 12 0.000366211H11.998C5.3715 0.00149121 0 5.3736 0 12.0004H6.26091V8.47485L9.78642 12.0004H11.968C11.9787 11.9897 11.9894 11.979 12.0001 11.9683C12.0001 11.1598 12.0001 10.4384 12.0001 9.78683L8.47444 6.26123H12Z" fill="#F0F0F0"></path><path d="M6.07124 1.56543C4.19441 2.63413 2.63413 4.19441 1.56543 6.07124V12.0002H4.69588V4.69598V4.69588H12.0002C12.0002 3.70856 12.0002 2.76796 12.0002 1.56543H6.07124Z" fill="#D80027"></path><path d="M12.0009 10.5242L7.73735 6.26074H6.26172V6.26084L12.0008 11.9998H12.0009C12.0009 11.9998 12.0009 10.9823 12.0009 10.5242Z" fill="#D80027"></path><path d="M13.0972 19.8252L13.3562 20.6224H14.1944L13.5163 21.115L13.7753 21.9121L13.0972 21.4195L12.4191 21.9121L12.6781 21.115L12 20.6224H12.8381L13.0972 19.8252Z" fill="#FFDA44"></path><path d="M19.773 14.6094L20.032 15.4065H20.8701L20.1921 15.8992L20.4512 16.6963L19.773 16.2037L19.0949 16.6963L19.354 15.8992L18.6758 15.4065H19.5139L19.773 14.6094Z" fill="#FFDA44"></path><path d="M21.4448 6.78259L21.7038 7.57975H22.542L21.864 8.07241L22.123 8.86951L21.4448 8.3769L20.7668 8.86951L21.0258 8.07241L20.3477 7.57975H21.1858L21.4448 6.78259Z" fill="#FFDA44"></path><path d="M21.8599 12.5215L22.1189 13.3187H22.9571L22.279 13.8113L22.538 14.6085L21.8599 14.1158L21.1819 14.6085L21.4409 13.8113L20.7627 13.3187H21.6009L21.8599 12.5215Z" fill="#FFDA44"></path><path d="M14.299 17.9513L15.0459 18.3319L15.6386 17.7393L15.5075 18.567L16.2543 18.9475L15.4264 19.0787L15.2953 19.9066L14.9148 19.1597L14.0869 19.2909L14.6796 18.6983L14.299 17.9513Z" fill="#FFDA44"></path><path d="M14.299 14.8215L15.0459 15.202L15.6386 14.6094L15.5075 15.4372L16.2543 15.8177L15.4264 15.9488L15.2953 16.7767L14.9148 16.0299L14.0869 16.161L14.6796 15.5684L14.299 14.8215Z" fill="#FFDA44"></path><path d="M16.9084 16.8272L17.6553 17.2078L18.2479 16.6151L18.1169 17.4429L18.8637 17.8234L18.0357 17.9546L17.9046 18.7824L17.5242 18.0355L16.6963 18.1668L17.2889 17.5741L16.9084 16.8272Z" fill="#FFDA44"></path><path d="M16.9084 10.1248L17.6553 10.5054L18.2479 9.91272L18.1169 10.7405L18.8637 11.121L18.0357 11.2522L17.9046 12.08L17.5242 11.3332L16.6963 11.4644L17.2889 10.8717L16.9084 10.1248Z" fill="#FFDA44"></path><path d="M19.4367 10.0445L20.1836 10.425L20.7763 9.8324L20.6451 10.6602L21.392 11.0407L20.5641 11.1718L20.4329 11.9997L20.0525 11.2529L19.2246 11.3841L19.8172 10.7914L19.4367 10.0445Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Uv2 = [
  Rv2
];
function Nv2(r, e) {
  return n(), o("svg", Ev2, Uv2);
}
const xG2 = /* @__PURE__ */ i(Ov2, [["render", Nv2]]);
var qv2 = {}, zv2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Kv2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -296)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z" fill="#D80027"></path><path d="M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z" fill="#0052B4"></path><path d="M10.435 7.02305L8.96945 7.71249L9.74983 9.13181L8.15847 8.82731L7.95677 10.435L6.84836 9.25261L5.73986 10.435L5.53825 8.82731L3.94684 9.13172L4.72722 7.71239L3.26172 7.02305L4.72727 6.33375L3.94684 4.91438L5.5382 5.21883L5.73991 3.61121L6.84836 4.79358L7.95681 3.61121L8.15847 5.21883L9.74987 4.91438L8.96945 6.3338L10.435 7.02305Z" fill="#F0F0F0"></path><path d="M6.84897 9.25671C8.08262 9.25671 9.0827 8.25664 9.0827 7.02298C9.0827 5.78932 8.08262 4.78925 6.84897 4.78925C5.61531 4.78925 4.61523 5.78932 4.61523 7.02298C4.61523 8.25664 5.61531 9.25671 6.84897 9.25671Z" fill="#0052B4"></path><path d="M6.84841 8.21399C6.19211 8.21399 5.6582 7.68004 5.6582 7.02374C5.6582 6.36745 6.19216 5.8335 6.84841 5.8335C7.50471 5.8335 8.03866 6.36745 8.03866 7.02374C8.03861 7.68004 7.50461 8.21399 6.84841 8.21399Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Gv2 = [
  Kv2
];
function Wv2(r, e) {
  return n(), o("svg", zv2, Gv2);
}
const HG2 = /* @__PURE__ */ i(qv2, [["render", Wv2]]);
var Yv2 = {}, Xv2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qv2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -408)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M3.51446 20.4856C4.01785 20.989 4.55495 21.4379 5.11834 21.8331L21.8326 5.11887C21.4374 4.55548 20.9884 4.01839 20.485 3.515C19.9816 3.01161 19.4446 2.56273 18.8812 2.16748L2.16699 18.8817C2.56215 19.445 3.01112 19.9821 3.51446 20.4856Z" fill="black"></path><path d="M3.51422 3.5138C-0.271495 7.29961 -0.998292 12.9851 1.33247 17.5012L17.5016 1.3321C12.9856 -0.998668 7.29999 -0.271825 3.51422 3.5138Z" fill="#6DA544"></path><path d="M20.4854 20.4851C24.2711 16.6994 24.9979 11.0138 22.6672 6.49768L6.49805 22.6668C11.014 24.9976 16.6996 24.2708 20.4854 20.4851Z" fill="#338AF3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Jv2 = [
  Qv2
];
function tu2(r, e) {
  return n(), o("svg", Xv2, Jv2);
}
const VG2 = /* @__PURE__ */ i(Yv2, [["render", tu2]]);
var eu2 = {}, ru2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nu2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -1080)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"></path><path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#338AF3"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), ou2 = [
  nu2
];
function iu2(r, e) {
  return n(), o("svg", ru2, ou2);
}
const ZG2 = /* @__PURE__ */ i(eu2, [["render", iu2]]);
var lu2 = {}, su2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hu2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -1024)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M20.9434 20.0001C22.8439 17.8771 24 15.0739 24 12.0002C24 8.92648 22.8438 6.12321 20.9434 4.00015L12 3.13062L3.05662 4.00015C1.15617 6.12321 0 8.92648 0 12.0002C0 15.0739 1.15613 17.8771 3.05658 20.0001L12 20.8697L20.9434 20.0001Z" fill="#FFDA44"></path><path d="M3.05664 4.00047H20.9434C18.7462 1.54577 15.5537 0.000488281 12 0.000488281C8.44628 0.000488281 5.25386 1.54577 3.05664 4.00047Z" fill="black"></path><path d="M0 12.0008L12 13.0442L24 12.0008C24 10.5981 23.7585 9.25192 23.3162 8.00073H0.683812C0.241453 9.25192 0 10.5981 0 12.0008Z" fill="#D80027"></path><path d="M0.683812 15.9993H23.3163C23.7585 14.7481 24 13.402 24 11.9993H0C0 13.402 0.241453 14.7481 0.683812 15.9993Z" fill="black"></path><path d="M20.9435 19.9995H3.05664C5.25386 22.4543 8.44628 23.9995 12.0001 23.9995C15.5538 23.9995 18.7463 22.4543 20.9435 19.9995Z" fill="#D80027"></path><path d="M16.0038 12.0007C16.0038 14.2124 14.2112 16.005 11.9995 16.005C9.78776 16.005 7.99512 14.2124 7.99512 12.0007C7.99512 9.78898 9.78776 7.99634 11.9995 7.99634C14.2112 7.99634 16.0038 9.78898 16.0038 12.0007Z" fill="#F0F0F0"></path><path d="M13.4669 12.2036L11.9999 11.568C11.9999 11.568 12.3431 10.4288 12.3614 10.3508C12.3748 10.2939 12.3819 10.2345 12.3819 10.1734C12.3819 9.9573 12.2943 9.76164 12.1526 9.62008L12.5215 9.25117C12.2855 9.01516 11.9594 8.86914 11.5992 8.86914C11.239 8.86914 10.9129 9.01511 10.6769 9.25117L11.0458 9.62008C10.9042 9.76169 10.8166 9.95734 10.8166 10.1734C10.8166 10.2525 10.8285 10.3286 10.8503 10.4006L10.2949 10.956H11.3044C11.3044 10.956 10.887 11.5829 10.6592 12.0977C10.4313 12.6125 10.6623 13.2409 11.1889 13.475L11.4934 13.6104L11.9999 14.0864V14.6081L11.4782 15.1299H12.5217V14.0864L12.9978 13.6103H13.9825C13.9873 13.6005 13.9922 13.5909 13.9967 13.5809C14.2307 13.0543 13.9935 12.4376 13.4669 12.2036Z" fill="black"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), au2 = [
  hu2
];
function du2(r, e) {
  return n(), o("svg", su2, au2);
}
const BG2 = /* @__PURE__ */ i(lu2, [["render", du2]]);
var cu2 = {}, _u2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cu2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -1248)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.4775 12H23.9993C23.9993 10.9169 23.8549 9.86761 23.5859 8.86951H11.4775V12Z" fill="#D80027"></path><path d="M11.4775 5.73848H22.238C21.5034 4.5398 20.5642 3.48028 19.4691 2.60803H11.4775V5.73848Z" fill="#D80027"></path><path d="M12.0001 23.9999C14.8243 23.9999 17.4201 23.0238 19.4699 21.3912H4.53027C6.58012 23.0238 9.17591 23.9999 12.0001 23.9999Z" fill="#D80027"></path><path d="M1.76098 18.2598H22.2384C22.8281 17.2975 23.2855 16.2457 23.5863 15.1294H0.413086C0.713883 16.2457 1.17124 17.2975 1.76098 18.2598Z" fill="#D80027"></path><path d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), fu2 = [
  Cu2
];
function vu2(r, e) {
  return n(), o("svg", _u2, fu2);
}
const FG2 = /* @__PURE__ */ i(cu2, [["render", vu2]]);
var uu2 = {}, wu2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pu2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -1304)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M12 8.86873H23.5866C23.2857 7.75245 22.8284 6.70053 22.2387 5.73828H12V8.86873Z" fill="#338AF3"></path><path d="M4.5296 21.3898H19.4693C20.5644 20.5176 21.5036 19.4581 22.2381 18.2594H1.76074C2.49532 19.4581 3.43451 20.5176 4.5296 21.3898Z" fill="#338AF3"></path><path d="M12 -0.000854492C12 1.04263 12 2.60783 12 2.60783H19.4699C17.42 0.975271 14.8242 -0.000854492 12 -0.000854492Z" fill="#338AF3"></path><path d="M12 8.86873H23.5866C23.2857 7.75245 22.8284 6.70053 22.2387 5.73828H12V8.86873Z" fill="#338AF3"></path><path d="M0 12.0001C0 13.0833 0.144375 14.1324 0.413391 15.1306H23.5867C23.8556 14.1324 24 13.0833 24 12.0001H0Z" fill="#338AF3"></path><path d="M10.435 7.02317L8.96941 7.71256L9.74983 9.13194L8.15842 8.82753L7.95677 10.4351L6.84836 9.25273L5.73986 10.4351L5.53825 8.82753L3.94684 9.13184L4.72722 7.71251L3.26172 7.02317L4.72727 6.33387L3.94684 4.9145L5.5382 5.21891L5.73991 3.61133L6.84836 4.7937L7.95681 3.61133L8.15842 5.21891L9.74988 4.9145L8.96945 6.33392L10.435 7.02317Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), gu2 = [
  pu2
];
function $u2(r, e) {
  return n(), o("svg", wu2, gu2);
}
const jG2 = /* @__PURE__ */ i(uu2, [["render", $u2]]);
var Mu2 = {}, Lu2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ku2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-464 -1360)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M0.566625 8.34794C0.199031 9.49956 -4.68667e-05 10.7264 8.27601e-09 12C-4.68667e-05 13.2736 0.199078 14.5005 0.566672 15.6521L12 16.174L23.4333 15.6522C23.8009 14.5006 24.0001 13.2736 24.0001 12.0001C24 10.7265 23.8009 9.49956 23.4333 8.34789L12 7.82617L0.566625 8.34794Z" fill="#F0F0F0"></path><path d="M23.4332 8.34789L11.9999 7.82617L0.5665 8.34789C0.457563 8.68933 0.363766 9.03747 0.285156 9.39137H23.7144C23.6359 9.03742 23.5421 8.68923 23.4332 8.34789Z" fill="#D80027"></path><path d="M0.285156 14.609C0.363672 14.9629 0.457469 15.311 0.566406 15.6524L0.567531 15.6525L11.9997 16.1742L23.433 15.6525C23.542 15.3111 23.6358 14.9629 23.7143 14.609H0.285156Z" fill="#D80027"></path><path d="M12.0007 24.0007C17.3545 24.0007 21.8888 20.4943 23.434 15.6528H0.567383C2.11262 20.4942 6.64693 24.0007 12.0007 24.0007Z" fill="#6DA544"></path><path d="M11.9997 -0.000854492C6.64595 -0.000807617 2.11173 3.50558 0.566406 8.34697L23.433 8.34702C21.8879 3.50554 17.3536 -0.000901367 11.9997 -0.000854492Z" fill="#338AF3"></path><path d="M5.48376 4.95618C5.48376 3.83226 6.27365 2.89335 7.32847 2.66301C7.16638 2.62757 6.99815 2.6084 6.82536 2.6084C5.52871 2.6084 4.47754 3.65952 4.47754 4.95623C4.47754 6.25293 5.52862 7.30406 6.82536 7.30406C6.99815 7.30406 7.16633 7.28484 7.32847 7.24945C6.27369 7.01901 5.48376 6.0801 5.48376 4.95618Z" fill="#F0F0F0"></path><path d="M8.71531 6.02246L8.87421 6.5116H9.38853L8.97246 6.81395L9.13137 7.30309L8.71531 7.00079L8.29915 7.30309L8.4581 6.81395L8.04199 6.5116H8.55631L8.71531 6.02246Z" fill="#F0F0F0"></path><path d="M10.3578 6.02246L10.5167 6.5116H11.0311L10.6149 6.81395L10.7739 7.30309L10.3578 7.00079L9.94168 7.30309L10.1006 6.81395L9.68457 6.5116H10.1988L10.3578 6.02246Z" fill="#F0F0F0"></path><path d="M11.9995 6.02246L12.1584 6.5116H12.6728L12.2566 6.81395L12.4156 7.30309L11.9995 7.00079L11.5833 7.30309L11.7423 6.81395L11.3262 6.5116H11.8405L11.9995 6.02246Z" fill="#F0F0F0"></path><path d="M13.6411 6.02246L13.8 6.5116H14.3143L13.8982 6.81395L14.0572 7.30309L13.6411 7.00079L13.2249 7.30309L13.3839 6.81395L12.9678 6.5116H13.4821L13.6411 6.02246Z" fill="#F0F0F0"></path><path d="M15.2826 6.02246L15.4415 6.5116H15.9559L15.5398 6.81395L15.6987 7.30309L15.2826 7.00079L14.8665 7.30309L15.0254 6.81395L14.6094 6.5116H15.1236L15.2826 6.02246Z" fill="#F0F0F0"></path><path d="M10.3578 4.31506L10.5167 4.80416H11.0311L10.6149 5.10655L10.7739 5.59564L10.3578 5.29335L9.94168 5.59564L10.1006 5.10655L9.68457 4.80416H10.1988L10.3578 4.31506Z" fill="#F0F0F0"></path><path d="M11.9995 4.31506L12.1584 4.80416H12.6728L12.2566 5.10655L12.4156 5.59564L11.9995 5.29335L11.5833 5.59564L11.7423 5.10655L11.3262 4.80416H11.8405L11.9995 4.31506Z" fill="#F0F0F0"></path><path d="M13.6411 4.31506L13.8 4.80416H14.3143L13.8982 5.10655L14.0572 5.59564L13.6411 5.29335L13.2249 5.59564L13.3839 5.10655L12.9678 4.80416H13.4821L13.6411 4.31506Z" fill="#F0F0F0"></path><path d="M15.2826 4.31506L15.4415 4.80416H15.9559L15.5398 5.10655L15.6987 5.59564L15.2826 5.29335L14.8665 5.59564L15.0254 5.10655L14.6094 4.80416H15.1236L15.2826 4.31506Z" fill="#F0F0F0"></path><path d="M11.9995 2.60803L12.1584 3.09722H12.6728L12.2566 3.39952L12.4156 3.8887L11.9995 3.58641L11.5833 3.8887L11.7423 3.39952L11.3262 3.09722H11.8405L11.9995 2.60803Z" fill="#F0F0F0"></path><path d="M13.6411 2.60803L13.8 3.09722H14.3143L13.8982 3.39952L14.0572 3.8887L13.6411 3.58641L13.2249 3.8887L13.3839 3.39952L12.9678 3.09722H13.4821L13.6411 2.60803Z" fill="#F0F0F0"></path><path d="M15.2826 2.60803L15.4415 3.09722H15.9559L15.5398 3.39952L15.6987 3.8887L15.2826 3.58641L14.8665 3.8887L15.0254 3.39952L14.6094 3.09722H15.1236L15.2826 2.60803Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), mu2 = [
  ku2
];
function xu2(r, e) {
  return n(), o("svg", Lu2, mu2);
}
const IG2 = /* @__PURE__ */ i(Mu2, [["render", xu2]]);
var Hu2 = {}, Vu2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zu2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -1304)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M17.7395 1.45932C16.0346 0.529135 14.0793 0.000244141 12.0004 0.000244141C9.92149 0.000244141 7.96615 0.529135 6.26126 1.45932L5.21777 12.0002L6.26126 22.5412C7.96615 23.4714 9.92149 24.0002 12.0004 24.0002C14.0793 24.0002 16.0346 23.4714 17.7395 22.5412L18.783 12.0002L17.7395 1.45932Z" fill="#FFDA44"></path><path d="M6.26086 22.5408V1.45898C2.53073 3.4943 0 7.45144 0 12C0 16.5485 2.53073 20.5056 6.26086 22.5408Z" fill="#338AF3"></path><path d="M24.0001 12.0002C24.0001 7.45168 21.4694 3.49454 17.7393 1.45923V22.541C21.4694 20.5059 24.0001 16.5487 24.0001 12.0002Z" fill="#6DA544"></path><path d="M9.3917 15.1298L7.30469 11.9993L9.39166 8.8689L11.4787 11.9993L9.3917 15.1298Z" fill="#6DA544"></path><path d="M14.6094 15.1298L12.5225 11.9993L14.6094 8.8689L16.6964 11.9993L14.6094 15.1298Z" fill="#6DA544"></path><path d="M12.001 19.3037L9.91406 16.1733L12.001 13.0428L14.088 16.1733L12.001 19.3037Z" fill="#6DA544"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Bu2 = [
  Zu2
];
function Fu2(r, e) {
  return n(), o("svg", Vu2, Bu2);
}
const bG2 = /* @__PURE__ */ i(Hu2, [["render", Fu2]]);
var ju2 = {}, Iu2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bu2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -1416)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M22.8093 17.2166C23.5722 15.639 24 13.8692 24 11.9993C24 10.1294 23.5722 8.35951 22.8093 6.78189L12 5.7384L1.19072 6.78189C0.427828 8.35951 0 10.1294 0 11.9993C0 13.8692 0.427828 15.639 1.19072 17.2166L12 18.2601L22.8093 17.2166Z" fill="#0052B4"></path><path d="M11.9997 24.0004C16.7572 24.0004 20.868 21.2317 22.809 17.2178H1.19043C3.13143 21.2317 7.24218 24.0004 11.9997 24.0004Z" fill="#D80027"></path><path d="M20.7824 14.3561L20.1486 14.8514L20.4236 15.607L19.7568 15.1574L19.1229 15.6525L19.3445 14.8793L18.6777 14.4295L19.4816 14.4015L19.7034 13.6283L19.9786 14.3841L20.7824 14.3561Z" fill="#F0F0F0"></path><path d="M19.1585 11.5444L18.7324 12.2266L19.2495 12.8426L18.469 12.6483L18.0427 13.3303L17.9865 12.5279L17.2061 12.3333L17.9519 12.0319L17.8959 11.2295L18.4129 11.8458L19.1585 11.5444Z" fill="#F0F0F0"></path><path d="M16.6724 9.45837L16.5052 10.2452L17.2018 10.6474L16.4019 10.7317L16.2346 11.5183L15.9074 10.7835L15.1074 10.8675L15.7053 10.3293L15.3781 9.59455L16.0747 9.99664L16.6724 9.45837Z" fill="#F0F0F0"></path><path d="M13.6219 8.34802L13.7339 9.14457L14.526 9.28416L13.8031 9.63695L13.9151 10.4334L13.3563 9.85482L12.6332 10.2074L13.0109 9.49712L12.4521 8.91859L13.2443 9.05823L13.6219 8.34802Z" fill="#F0F0F0"></path><path d="M10.3767 8.34802L10.7544 9.05822L11.5464 8.91849L10.9878 9.49726L11.3653 10.2075L10.6424 9.85482L10.0835 10.4333L10.1956 9.63694L9.47266 9.28435L10.2648 9.14457L10.3767 8.34802Z" fill="#F0F0F0"></path><path d="M7.32614 9.45837L7.92399 9.99664L8.62041 9.59455L8.29336 10.3295L8.89106 10.8677L8.09114 10.7835L7.76386 11.5183L7.59684 10.7315L6.79688 10.6475L7.49344 10.2453L7.32614 9.45837Z" fill="#F0F0F0"></path><path d="M4.83973 11.5444L5.58565 11.8457L6.10249 11.2296L6.04657 12.0322L6.79225 12.3335L6.01183 12.528L5.95563 13.3303L5.52954 12.6483L4.74902 12.8428L5.26605 12.2266L4.83973 11.5444Z" fill="#F0F0F0"></path><path d="M3.2168 14.3561L4.0208 14.3841L4.29577 13.6284L4.51772 14.4017L5.32148 14.4297L4.65464 14.8796L4.87627 15.6527L4.24252 15.1575L3.57562 15.6072L3.85073 14.8514L3.2168 14.3561Z" fill="#F0F0F0"></path><path d="M22.809 6.78226C20.868 2.76831 16.7572 -0.000366211 11.9997 -0.000366211C7.24218 -0.000366211 3.13143 2.76831 1.19043 6.78226H22.809Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), yu2 = [
  bu2
];
function Du2(r, e) {
  return n(), o("svg", Iu2, yu2);
}
const yG2 = /* @__PURE__ */ i(ju2, [["render", Du2]]);
var Pu2 = {}, Au2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Su2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-72 -352)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"></path><path d="M11.9688 12.0007H12.0009C12.0009 11.9899 12.0009 11.9794 12.0009 11.9686C11.9902 11.9793 11.9795 11.99 11.9688 12.0007Z" fill="#F0F0F0"></path><path d="M12 6.26178C12 4.15029 12 2.76677 12 0.000915527H11.998C5.37145 0.00204053 0 5.37415 0 12.0009H6.26086V8.4754L9.78637 12.0009H11.9679C11.9786 11.9902 11.9893 11.9795 12 11.9688C12 11.1604 12 10.439 12 9.78738L8.47443 6.26178H12Z" fill="#F0F0F0"></path><path d="M6.07027 1.56415C4.19344 2.63285 2.63311 4.19313 1.56445 6.06996V11.9989H4.69491V4.6947V4.6946H11.9993C11.9993 3.70727 11.9993 2.76668 11.9993 1.56415H6.07027Z" fill="#D80027"></path><path d="M17.218 11.9996L13.9746 15.2431C14.5825 16.4154 15.8063 17.217 17.218 17.217C18.6298 17.217 19.8536 16.4154 20.4615 15.2431L17.218 11.9996Z" fill="#FFDA44"></path><path d="M11.9999 10.5244L7.73637 6.26099H6.26074V6.26108L11.9998 12.0001H11.9999C11.9999 12.0001 11.9999 10.9826 11.9999 10.5244Z" fill="#D80027"></path><path d="M13.5654 6.26099V12.0001V12.0001C13.5655 14.7957 17.2176 15.6523 17.2176 15.6523C17.2176 15.6523 20.8697 14.7957 20.8698 12.0001V12.0001V6.26099H13.5654Z" fill="#6DA544"></path><path d="M17.9998 8.86987H16.4346V13.0438H17.9998V8.86987Z" fill="#F0F0F0"></path><path d="M17.2172 9.65174C17.6494 9.65174 17.9998 9.30135 17.9998 8.86911C17.9998 8.43688 17.6494 8.08649 17.2172 8.08649C16.785 8.08649 16.4346 8.43688 16.4346 8.86911C16.4346 9.30135 16.785 9.65174 17.2172 9.65174Z" fill="#A2001D"></path><path d="M15.6529 7.30481H14.6094V8.34829H15.6529V7.30481Z" fill="#FFDA44"></path><path d="M15.6519 9.65198H14.6084V10.6955H15.6519V9.65198Z" fill="#FFDA44"></path><path d="M15.6519 12.0005H14.6084V13.044H15.6519V12.0005Z" fill="#FFDA44"></path><path d="M19.8257 7.30548H18.7822V8.34897H19.8257V7.30548Z" fill="#FFDA44"></path><path d="M19.8257 9.65198H18.7822V10.6955H19.8257V9.65198Z" fill="#FFDA44"></path><path d="M19.8257 12.0005H18.7822V13.044H19.8257V12.0005Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Tu2 = [
  Su2
];
function Ou2(r, e) {
  return n(), o("svg", Au2, Tu2);
}
const DG2 = /* @__PURE__ */ i(Pu2, [["render", Ou2]]);
var Eu2 = {}, Ru2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Uu2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-184 -1416)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FCFCFC"></path><path d="M14.0373 8.38349C14.0373 7.25793 13.1249 6.34546 11.9993 6.34546C10.8737 6.34546 9.96118 7.25793 9.96118 8.38349H5.47754C5.47754 9.49166 6.44288 10.3901 7.55105 10.3901H7.48431C7.48431 11.4984 8.38262 12.3969 9.49098 12.3969C9.49098 13.3781 10.1957 14.1934 11.1264 14.3677L11.1212 14.3794H12.8774L12.8722 14.3677C13.8029 14.1934 14.5076 13.3781 14.5076 12.3969C15.6159 12.3969 16.5143 11.4984 16.5143 10.3901H16.4474C17.5556 10.3901 18.521 9.49166 18.521 8.38349H14.0373Z" fill="#FFDA44"></path><path d="M11.1035 14.1724L9.83984 17.0253C10.5066 17.2964 11.2354 17.447 11.9995 17.447C12.7636 17.447 13.4923 17.2964 14.159 17.0253L12.8954 14.1724H11.1035Z" fill="#FFDA44"></path><path d="M9.3916 9.3855V12.896C9.3916 14.8928 12.0003 15.5047 12.0003 15.5047C12.0003 15.5047 14.609 14.8928 14.609 12.896V9.3855H9.3916Z" fill="#F0F0F0"></path><path d="M2.91024 12.0846L4.32113 16.0307L5.71735 12.0846H6.78292L4.74732 17.302H3.8949L1.84473 12.0846H2.91024Z" fill="#338AF3"></path><path d="M19.3047 17.302V12.0846H20.3187V17.302H19.3047Z" fill="#338AF3"></path><path d="M10.4346 10.5195V14.7736C10.7932 15.0376 11.1791 15.2191 11.4781 15.3354V10.5195H10.4346Z" fill="#D80027"></path><path d="M13.565 10.5195V14.7736C13.2063 15.0376 12.8205 15.2191 12.5215 15.3354V10.5195H13.565Z" fill="#D80027"></path><path d="M14.609 9.3855H9.3916V11.0409H14.609V9.3855Z" fill="#0052B4"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Nu2 = [
  Uu2
];
function qu2(r, e) {
  return n(), o("svg", Ru2, Nu2);
}
const PG2 = /* @__PURE__ */ i(Eu2, [["render", qu2]]);
var zu2 = {}, Ku2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gu2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-128 -1416)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"></path><path d="M12.0005 6.26123L13.2956 10.247H17.4864L14.0959 12.7103L15.391 16.696L12.0005 14.2327L8.61005 16.696L9.90511 12.7103L6.51465 10.247H10.7055L12.0005 6.26123Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), Wu2 = [
  Gu2
];
function Yu2(r, e) {
  return n(), o("svg", Ku2, Wu2);
}
const AG2 = /* @__PURE__ */ i(zu2, [["render", Yu2]]);
var Xu2 = {}, Qu2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ju2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-16 -1416)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12.0003C24 11.4698 23.9651 10.9475 23.8984 10.4351H10.4347C7.98306 7.98365 3.51452 3.51539 3.5147 3.51501C-1.17157 8.20129 -1.17157 15.7992 3.5147 20.4856L10.4348 13.5656H23.8984C23.9651 13.0532 24 12.5308 24 12.0003Z" fill="black"></path><path d="M23.9968 12.2726C23.9963 12.2958 23.9958 12.319 23.9951 12.3422C23.9957 12.3189 23.9962 12.2958 23.9968 12.2726Z" fill="#F0F0F0"></path><path d="M23.9853 12.6002C23.9843 12.6232 23.9827 12.646 23.9814 12.6689C23.9827 12.6461 23.9842 12.6232 23.9853 12.6002Z" fill="#F0F0F0"></path><path d="M23.9684 12.8632C23.966 12.8969 23.9637 12.9307 23.9609 12.9643C23.9637 12.9307 23.966 12.8969 23.9684 12.8632Z" fill="#F0F0F0"></path><path d="M23.9287 10.6921C23.9331 10.7323 23.9375 10.7724 23.9415 10.8127C23.9375 10.7724 23.9331 10.7323 23.9287 10.6921Z" fill="#F0F0F0"></path><path d="M23.9805 11.3298C23.9817 11.3527 23.9833 11.3756 23.9844 11.3985C23.9832 11.3756 23.9817 11.3527 23.9805 11.3298Z" fill="#F0F0F0"></path><path d="M23.9951 11.6567C23.9958 11.6799 23.9962 11.7032 23.9968 11.7264C23.9963 11.7031 23.9957 11.6799 23.9951 11.6567Z" fill="#F0F0F0"></path><path d="M23.9609 11.0355C23.9637 11.0692 23.966 11.1029 23.9684 11.1367C23.966 11.1029 23.9637 11.0692 23.9609 11.0355Z" fill="#F0F0F0"></path><path d="M23.8984 10.4344C23.9038 10.4755 23.9086 10.5168 23.9135 10.558C23.2013 4.61044 18.1395 -0.000366211 12 -0.000366211C8.68626 -0.000366211 5.68622 1.34283 3.51465 3.5145L10.4345 10.4344H23.8984V10.4344Z" fill="#D80027"></path><path d="M23.8984 13.5652H10.4345L3.51465 20.4851C5.68622 22.6567 8.68626 24 12 24C18.1395 24 23.2014 19.3892 23.9135 13.4415C23.9086 13.4827 23.9037 13.5241 23.8984 13.5652Z" fill="#6DA544"></path><path d="M23.9415 13.1877C23.9375 13.228 23.9331 13.2681 23.9287 13.3083C23.9331 13.2681 23.9376 13.2281 23.9415 13.1877Z" fill="#F0F0F0"></path><path d="M23.9688 11.137C23.9733 11.2012 23.9774 11.2655 23.981 11.33C23.9774 11.2655 23.9733 11.2012 23.9688 11.137Z" fill="black"></path><path d="M23.9131 10.5583C23.9185 10.6029 23.9236 10.6475 23.9284 10.6922C23.9235 10.6475 23.9184 10.6029 23.9131 10.5583Z" fill="black"></path><path d="M23.9414 10.8124C23.9487 10.8869 23.9553 10.9616 23.9613 11.0367C23.9554 10.9616 23.9488 10.8869 23.9414 10.8124Z" fill="black"></path><path d="M24.0005 12C24.0005 12.0913 23.9991 12.1823 23.9971 12.2731C23.9991 12.1823 24.0005 12.0913 24.0005 12Z" fill="black"></path><path d="M23.981 12.6688C23.9774 12.7333 23.9733 12.7977 23.9688 12.8619C23.9733 12.7977 23.9773 12.7333 23.981 12.6688Z" fill="black"></path><path d="M23.9613 12.964C23.9553 13.0389 23.9487 13.1137 23.9414 13.1882C23.9488 13.1137 23.9554 13.0389 23.9613 12.964Z" fill="black"></path><path d="M23.9284 13.3081C23.9236 13.3528 23.9185 13.3974 23.9131 13.4419C23.9184 13.3974 23.9235 13.3528 23.9284 13.3081Z" fill="black"></path><path d="M23.9971 11.7274C23.9991 11.8183 24.0005 11.9093 24.0005 12.0005C24.0005 11.9093 23.9991 11.8183 23.9971 11.7274Z" fill="black"></path><path d="M23.9854 11.3982C23.9896 11.4841 23.9928 11.5704 23.9952 11.6569C23.9928 11.5704 23.9896 11.4841 23.9854 11.3982Z" fill="black"></path><path d="M23.9952 12.3419C23.9928 12.4283 23.9896 12.5146 23.9854 12.6006C23.9897 12.5146 23.9928 12.4283 23.9952 12.3419Z" fill="black"></path><path d="M23.9892 11.4733H9.9945L2.80591 4.28577C2.57355 4.53083 2.32169 4.87302 2.16592 5.11672L9.04055 11.995L2.16016 18.8755C2.29637 19.1178 2.59314 19.4765 2.8015 19.7099L9.99464 12.5168H23.9909C23.9984 12.3437 24.0007 12.1699 24.0007 11.995C24.0007 11.7608 23.9942 11.588 23.9892 11.4733Z" fill="#FFDA44"></path><path d="M2.91515 14.5574V13.5523C3.91818 13.5523 4.73413 12.7362 4.73413 11.7333C4.73413 11.0237 4.15677 10.4464 3.44718 10.4464C2.96376 10.4464 2.57043 10.8396 2.57043 11.3232C2.57043 11.6323 2.82191 11.8838 3.1311 11.8838C3.30585 11.8838 3.44802 11.7416 3.44802 11.5668H4.45311C4.45311 12.2959 3.86005 12.8889 3.13115 12.8889C2.26776 12.889 1.56543 12.1865 1.56543 11.3232C1.56543 10.2856 2.40965 9.44141 3.44722 9.44141C4.71106 9.44141 5.73931 10.4697 5.73931 11.7335C5.73927 13.2905 4.47238 14.5574 2.91515 14.5574Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), tw2 = [
  Ju2
];
function ew2(r, e) {
  return n(), o("svg", Qu2, tw2);
}
const SG2 = /* @__PURE__ */ i(Xu2, [["render", ew2]]);
var rw2 = {}, nw2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ow2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -72)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z" fill="#D80027"></path><path d="M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z" fill="#0052B4"></path><path d="M9.61098 7.82617L9.80527 8.42406H10.4339L9.92527 8.79348L10.1196 9.39137L9.61098 9.02186L9.10238 9.39137L9.29668 8.79348L8.78809 8.42406H9.41668L9.61098 7.82617Z" fill="#F0F0F0"></path><path d="M6.45448 3.13116L6.77824 4.12768H7.826L6.97831 4.74338L7.30217 5.73985L6.45448 5.12396L5.60684 5.73985L5.93065 4.74338L5.08301 4.12768H6.13067L6.45448 3.13116Z" fill="#F0F0F0"></path><path d="M9.58534 4.17499L9.9091 5.17155H10.9568L10.1092 5.78725L10.4329 6.78372L9.58534 6.16783L8.7377 6.78372L9.06151 5.78725L8.21387 5.17155H9.26153L9.58534 4.17499Z" fill="#F0F0F0"></path><path d="M7.11072 8.349L7.43454 9.34551H8.48219L7.63455 9.96122L7.95836 10.9577L7.11072 10.3418L6.26309 10.9577L6.5869 9.96122L5.73926 9.34551H6.78696L7.11072 8.349Z" fill="#F0F0F0"></path><path d="M4.36752 5.73987L4.69133 6.73638H5.73903L4.89135 7.35209L5.21516 8.34856L4.36752 7.73271L3.51992 8.34856L3.84369 7.35209L2.99609 6.73638H4.04375L4.36752 5.73987Z" fill="#F0F0F0"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), iw2 = [
  ow2
];
function lw2(r, e) {
  return n(), o("svg", nw2, iw2);
}
const TG2 = /* @__PURE__ */ i(rw2, [["render", lw2]]);
var sw2 = {}, hw2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aw2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-296 -1416)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M11.9997 23.9992C17.1593 23.9992 21.5578 20.7427 23.2533 16.1731H0.746094C2.44161 20.7427 6.84013 23.9992 11.9997 23.9992Z" fill="black"></path><path d="M11.9997 0.000610352C6.84013 0.000610352 2.44161 3.25711 0.746094 7.82672H23.2534C21.5578 3.25711 17.1593 0.000610352 11.9997 0.000610352Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), dw2 = [
  aw2
];
function cw2(r, e) {
  return n(), o("svg", hw2, dw2);
}
const OG2 = /* @__PURE__ */ i(sw2, [["render", cw2]]);
var _w2 = {}, Cw2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fw2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -912)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M3.51471 20.4853C-1.17157 15.7989 -1.17157 8.20098 3.51471 3.51465C3.51438 3.51516 10.4348 12 10.4348 12L3.51471 20.4853Z" fill="black"></path><path d="M10.4351 12.0002L1.59187 6.02429C1.3177 6.50087 1.07591 6.99831 0.868164 7.51318L5.34515 12.0003L0.868305 16.4876C1.07587 17.0021 1.31741 17.4992 1.5914 17.9755L10.4351 12.0002Z" fill="#FFDA44"></path><path d="M23.8982 10.4347H10.4342L3.51434 3.51477C2.76865 4.26046 2.12079 5.10379 1.59129 6.02399L7.55562 11.9999L1.59082 17.975C2.12032 18.8955 2.76846 19.7391 3.51434 20.485L10.4342 13.5651H23.8982C23.9649 13.0528 23.9997 12.5304 23.9997 11.9999C23.9997 11.4694 23.9649 10.947 23.8982 10.4347Z" fill="#6DA544"></path><path d="M4.69336 21.5181C6.71691 23.0735 9.24989 23.9988 11.9994 23.9988C17.5437 23.9988 22.209 20.2385 23.586 15.1293H11.0822L4.69336 21.5181Z" fill="#0052B4"></path><path d="M23.586 8.86869C22.209 3.7595 17.5437 -0.000854492 11.9994 -0.000854492C9.24989 -0.000854492 6.71691 0.924505 4.69336 2.47991L11.0821 8.86869H23.586Z" fill="#D80027"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), vw2 = [
  fw2
];
function uw2(r, e) {
  return n(), o("svg", Cw2, vw2);
}
const EG2 = /* @__PURE__ */ i(_w2, [["render", uw2]]);
var ww2 = {}, pw2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gw2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-352 -1416)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D"></path><path d="M16.6957 11.9993H12V23.9993C13.4027 23.9993 14.7488 23.7578 16 23.3156L16.6957 11.9993Z" fill="#D80027"></path><path d="M20.0003 20.9427C22.4551 18.7455 24.0004 15.553 24.0004 11.9993H19.3047L20.0003 20.9427Z" fill="#FF9811"></path><path d="M16 11.9993V23.3155C17.4905 22.7886 18.8458 21.9759 20 20.9427V11.9993H16Z" fill="black"></path><path d="M22.174 7.82669H19.0436C19.0436 7.25041 18.5764 6.7832 18.0001 6.7832C17.4238 6.7832 16.9566 7.25041 16.9566 7.82669H13.8262C13.8262 8.40302 14.3282 8.87017 14.9044 8.87017H14.8697C14.8697 9.4465 15.3368 9.91366 15.9131 9.91366C15.9131 10.49 16.3803 10.9571 16.9566 10.9571H19.0436C19.6199 10.9571 20.0871 10.49 20.0871 9.91366C20.6634 9.91366 21.1306 9.4465 21.1306 8.87017H21.0958C21.6721 8.87013 22.174 8.40297 22.174 7.82669Z" fill="#FF9811"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), $w2 = [
  gw2
];
function Mw2(r, e) {
  return n(), o("svg", pw2, $w2);
}
const RG2 = /* @__PURE__ */ i(ww2, [["render", Mw2]]);
var Lw2 = {}, kw2 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mw2 = /* @__PURE__ */ a('<rect width="24" height="24" fill="none"></rect><rect width="504" height="1456" transform="translate(-408 -1416)" fill="none"></rect><g clip-path="url(#clip0_1025_31781)"><path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"></path><path d="M22.8522 6.87246C22.2426 5.58461 21.4105 4.42291 20.4055 3.43643L12.0008 2.60913L3.5961 3.43647C3.56929 3.46277 3.54313 3.48968 3.5166 3.51625L6.87285 6.8725L12.0008 7.02911L22.8522 6.87246Z" fill="#FFDA44"></path><path d="M3.51562 20.4852C3.55978 20.5294 3.60384 20.5736 3.64866 20.6171L12 21.3922L20.3512 20.6171C21.3665 19.6327 22.2088 18.4709 22.827 17.181L7.30425 16.6965C5.96864 18.0322 4.42814 19.5726 3.51562 20.4852Z" fill="#FFDA44"></path><path d="M23.8807 10.3081L9.91309 9.91309L12.0001 12.0001C11.3819 12.6182 10.4591 13.541 9.91309 14.087L23.8734 13.7442C23.9564 13.1747 24.0001 12.5925 24.0001 12.0001C24.0001 11.4256 23.9588 10.861 23.8807 10.3081Z" fill="black"></path><path d="M12.0004 0.000610352C8.7272 0.000610352 5.76067 1.3117 3.5957 3.43664H20.4051C18.2401 1.3117 15.2736 0.000610352 12.0004 0.000610352Z" fill="#6DA544"></path><path d="M10.3071 10.3086H23.8797C23.7085 9.09551 23.3562 7.94079 22.8505 6.87256H6.87109L10.3071 10.3086Z" fill="#D80027"></path><path d="M6.81934 17.1815H22.8266C23.3382 16.1141 23.6961 14.9592 23.8729 13.7455H10.2554C8.92473 15.0761 7.79701 16.2038 6.81934 17.1815Z" fill="#D80027"></path><path d="M11.9996 24.0006C15.246 24.0006 18.1907 22.7109 20.3508 20.6167H3.64844C5.80863 22.7109 8.75331 24.0006 11.9996 24.0006Z" fill="#6DA544"></path><path d="M4.28504 2.80994C4.01827 3.03409 3.76088 3.26908 3.51465 3.51522L12 12.0005L3.51465 20.4858C3.76084 20.732 4.01827 20.967 4.28504 21.1911L13.4756 12.0005L4.28504 2.80994Z" fill="black"></path><path d="M4.82467 8.86914L5.60163 11.2605H8.11624L6.08195 12.7386L6.85895 15.13L4.82467 13.652L2.79034 15.13L3.56744 12.7386L1.5332 11.2605H4.04767L4.82467 8.86914Z" fill="#D80027"></path><path d="M6.96184 12.1947L4.93694 11.4773C4.93694 11.4773 4.78731 10.0738 4.77827 10.0262C4.70955 9.66418 4.39141 9.39038 4.00937 9.39038C3.57719 9.39038 3.22675 9.74077 3.22675 10.173C3.22675 10.2447 3.2372 10.3137 3.25525 10.3797L2.6875 10.9513C2.6875 10.9513 3.36184 10.9513 3.697 10.9513C3.697 11.9991 2.91512 11.9991 2.91512 13.0425L3.34886 14.086H5.95755L6.39236 13.0425H6.39217C6.43572 12.9424 6.46216 12.8392 6.47308 12.736C6.84789 12.5844 6.96184 12.1947 6.96184 12.1947Z" fill="#FFDA44"></path></g><defs><clipPath id="clip0_1025_31781"><rect width="24" height="24" fill="none"></rect></clipPath></defs>', 4), xw2 = [
  mw2
];
function Hw2(r, e) {
  return n(), o("svg", kw2, xw2);
}
const UG2 = /* @__PURE__ */ i(Lw2, [["render", Hw2]]);
var Vw2 = { class: "flex justify-end items-center sticky right-1 text-gray-500" }, Zw2 = { class: "pr-5" }, Bw2 = {
  class: "pr-7",
  for: ""
}, Fw2 = ["value"], jw2 = { class: "pl-7" }, Iw2 = { class: "pr-5 pl-8 flex" }, bw2 = {
  __name: "DPagination",
  props: {
    totalRows: { type: Number, default: 0 },
    perPage: { type: Number, default: 10 },
    currentPage: { type: Number, default: 1 },
    startRow: { type: Number, default: 0 },
    endRow: { type: Number, default: 0 },
    perPageDropdown: { type: Array, default: function() {
      return [];
    } },
    paginationLimit: { type: Boolean, default: !0 },
    textPerPage: { type: String, default: "Filas por pagina :" }
  },
  emits: ["currentPage", "perPage", "change"],
  setup: function(r, e) {
    var l = e.emit, s = r, h = S(s.perPage), c = function() {
      return l("change");
    }, _ = function(V) {
      l("currentPage", V);
    }, C = function(V) {
      return l("perPage", V);
    }, d = S(1), u = i0(s, "currentPage");
    k1(u, function() {
      d.value = u.value;
    });
    var f = function(V) {
      d.value > 1 && (V == !1 ? d.value-- : d.value = 1, _(d.value), c());
    }, m = function(V) {
      d.value * s.perPage < s.totalRows && (V == !1 ? d.value++ : d.value = Math.ceil(s.totalRows / s.perPage), _(d.value), c());
    }, F = function() {
      d.value = 1, _(d.value), C(h.value), c();
    };
    return function(V, P) {
      return n(), o("div", Vw2, [
        t("div", Zw2, [
          t("label", Bw2, I(s.textPerPage), 1),
          l1(t("select", {
            "onUpdate:modelValue": P[0] || (P[0] = function(M) {
              return h.value = M;
            }),
            onChange: F
          }, [
            (n(!0), o(K, null, t1(r.perPageDropdown, function(M, g) {
              return n(), o("option", {
                key: g,
                value: M
              }, I(M), 9, Fw2);
            }), 128))
          ], 544), [
            [l0, h.value]
          ])
        ]),
        t("div", jw2, [
          t("p", null, I(r.totalRows != null ? "".concat(r.startRow + 1, "-").concat(r.endRow, " de ").concat(r.totalRows) : ""), 1)
        ]),
        t("div", Iw2, [
          r.paginationLimit ? (n(), o("button", {
            key: 0,
            class: z(["rounded-full h-7 w-8", [
              d.value == 1 ? "cursor-auto text-gray-400" : "hover:text-black hover:bg-gray-300"
            ]]),
            onClick: P[1] || (P[1] = H1(function(M) {
              return f(!0);
            }, ["prevent"]))
          }, [
            W(U(Mp), { class: "w-7 h-7" })
          ], 2)) : D("", !0),
          t("button", {
            class: z(["rounded-full h-7 w-8", [
              d.value == 1 ? "cursor-auto text-gray-400" : "hover:text-black hover:bg-gray-300"
            ]]),
            onClick: P[2] || (P[2] = H1(function(M) {
              return f(!1);
            }, ["prevent"]))
          }, [
            W(U(Zp), { class: "w-7 h-7" })
          ], 2),
          t("button", {
            class: z(["rounded-full h-7 w-8", [
              d.value == Math.ceil(s.totalRows / s.perPage) ? "cursor-auto text-gray-400" : "hover:text-black hover:bg-gray-300"
            ]]),
            onClick: P[3] || (P[3] = H1(function(M) {
              return m(!1);
            }, ["prevent"]))
          }, [
            W(U(Rp), { class: "w-7 h-7" })
          ], 2),
          r.paginationLimit ? (n(), o("button", {
            key: 1,
            class: z(["rounded-full h-7 w-8", [
              d.value == Math.ceil(s.totalRows / s.perPage) ? "cursor-auto text-gray-400" : "hover:text-black hover:bg-gray-300"
            ]]),
            onClick: P[4] || (P[4] = H1(function(M) {
              return m(!0);
            }, ["prevent"]))
          }, [
            W(U(Dp), { class: "w-7 h-7" })
          ], 2)) : D("", !0)
        ])
      ]);
    };
  }
};
const T2 = bw2;
var O2 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function E2(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var R2 = { exports: {} };
(function(r, e) {
  (function(l, s) {
    r.exports = s();
  })(O2, function() {
    var l = 1e3, s = 6e4, h = 36e5, c = "millisecond", _ = "second", C = "minute", d = "hour", u = "day", f = "week", m = "month", F = "quarter", V = "year", P = "date", M = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, L = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, Z = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(w) {
      var p = ["th", "st", "nd", "rd"], v = w % 100;
      return "[" + w + (p[(v - 20) % 10] || p[v] || p[0]) + "]";
    } }, A = function(w, p, v) {
      var k = String(w);
      return !k || k.length >= p ? w : "" + Array(p + 1 - k.length).join(v) + w;
    }, b = { s: A, z: function(w) {
      var p = -w.utcOffset(), v = Math.abs(p), k = Math.floor(v / 60), B = v % 60;
      return (p <= 0 ? "+" : "-") + A(k, 2, "0") + ":" + A(B, 2, "0");
    }, m: function w(p, v) {
      if (p.date() < v.date())
        return -w(v, p);
      var k = 12 * (v.year() - p.year()) + (v.month() - p.month()), B = p.clone().add(k, m), T = v - B < 0, j = p.clone().add(k + (T ? -1 : 1), m);
      return +(-(k + (v - B) / (T ? B - j : j - B)) || 0);
    }, a: function(w) {
      return w < 0 ? Math.ceil(w) || 0 : Math.floor(w);
    }, p: function(w) {
      return { M: m, y: V, w: f, d: u, D: P, h: d, m: C, s: _, ms: c, Q: F }[w] || String(w || "").toLowerCase().replace(/s$/, "");
    }, u: function(w) {
      return w === void 0;
    } }, E = "en", O = {};
    O[E] = Z;
    var R = function(w) {
      return w instanceof x;
    }, q = function w(p, v, k) {
      var B;
      if (!p)
        return E;
      if (typeof p == "string") {
        var T = p.toLowerCase();
        O[T] && (B = T), v && (O[T] = v, B = T);
        var j = p.split("-");
        if (!B && j.length > 1)
          return w(j[0]);
      } else {
        var N = p.name;
        O[N] = p, B = N;
      }
      return !k && B && (E = B), B || !k && E;
    }, H = function(w, p) {
      if (R(w))
        return w.clone();
      var v = typeof p == "object" ? p : {};
      return v.date = w, v.args = arguments, new x(v);
    }, $ = b;
    $.l = q, $.i = R, $.w = function(w, p) {
      return H(w, { locale: p.$L, utc: p.$u, x: p.$x, $offset: p.$offset });
    };
    var x = function() {
      function w(v) {
        this.$L = q(v.locale, null, !0), this.parse(v);
      }
      var p = w.prototype;
      return p.parse = function(v) {
        this.$d = function(k) {
          var B = k.date, T = k.utc;
          if (B === null)
            return /* @__PURE__ */ new Date(NaN);
          if ($.u(B))
            return /* @__PURE__ */ new Date();
          if (B instanceof Date)
            return new Date(B);
          if (typeof B == "string" && !/Z$/i.test(B)) {
            var j = B.match(g);
            if (j) {
              var N = j[2] - 1 || 0, G = (j[7] || "0").substring(0, 3);
              return T ? new Date(Date.UTC(j[1], N, j[3] || 1, j[4] || 0, j[5] || 0, j[6] || 0, G)) : new Date(j[1], N, j[3] || 1, j[4] || 0, j[5] || 0, j[6] || 0, G);
            }
          }
          return new Date(B);
        }(v), this.$x = v.x || {}, this.init();
      }, p.init = function() {
        var v = this.$d;
        this.$y = v.getFullYear(), this.$M = v.getMonth(), this.$D = v.getDate(), this.$W = v.getDay(), this.$H = v.getHours(), this.$m = v.getMinutes(), this.$s = v.getSeconds(), this.$ms = v.getMilliseconds();
      }, p.$utils = function() {
        return $;
      }, p.isValid = function() {
        return this.$d.toString() !== M;
      }, p.isSame = function(v, k) {
        var B = H(v);
        return this.startOf(k) <= B && B <= this.endOf(k);
      }, p.isAfter = function(v, k) {
        return H(v) < this.startOf(k);
      }, p.isBefore = function(v, k) {
        return this.endOf(k) < H(v);
      }, p.$g = function(v, k, B) {
        return $.u(v) ? this[k] : this.set(B, v);
      }, p.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, p.valueOf = function() {
        return this.$d.getTime();
      }, p.startOf = function(v, k) {
        var B = this, T = !!$.u(k) || k, j = $.p(v), N = function(h1, o1) {
          var f1 = $.w(B.$u ? Date.UTC(B.$y, o1, h1) : new Date(B.$y, o1, h1), B);
          return T ? f1 : f1.endOf(u);
        }, G = function(h1, o1) {
          return $.w(B.toDate()[h1].apply(B.toDate("s"), (T ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(o1)), B);
        }, X = this.$W, J = this.$M, e1 = this.$D, i1 = "set" + (this.$u ? "UTC" : "");
        switch (j) {
          case V:
            return T ? N(1, 0) : N(31, 11);
          case m:
            return T ? N(1, J) : N(0, J + 1);
          case f:
            var d1 = this.$locale().weekStart || 0, L1 = (X < d1 ? X + 7 : X) - d1;
            return N(T ? e1 - L1 : e1 + (6 - L1), J);
          case u:
          case P:
            return G(i1 + "Hours", 0);
          case d:
            return G(i1 + "Minutes", 1);
          case C:
            return G(i1 + "Seconds", 2);
          case _:
            return G(i1 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, p.endOf = function(v) {
        return this.startOf(v, !1);
      }, p.$set = function(v, k) {
        var B, T = $.p(v), j = "set" + (this.$u ? "UTC" : ""), N = (B = {}, B[u] = j + "Date", B[P] = j + "Date", B[m] = j + "Month", B[V] = j + "FullYear", B[d] = j + "Hours", B[C] = j + "Minutes", B[_] = j + "Seconds", B[c] = j + "Milliseconds", B)[T], G = T === u ? this.$D + (k - this.$W) : k;
        if (T === m || T === V) {
          var X = this.clone().set(P, 1);
          X.$d[N](G), X.init(), this.$d = X.set(P, Math.min(this.$D, X.daysInMonth())).$d;
        } else
          N && this.$d[N](G);
        return this.init(), this;
      }, p.set = function(v, k) {
        return this.clone().$set(v, k);
      }, p.get = function(v) {
        return this[$.p(v)]();
      }, p.add = function(v, k) {
        var B, T = this;
        v = Number(v);
        var j = $.p(k), N = function(J) {
          var e1 = H(T);
          return $.w(e1.date(e1.date() + Math.round(J * v)), T);
        };
        if (j === m)
          return this.set(m, this.$M + v);
        if (j === V)
          return this.set(V, this.$y + v);
        if (j === u)
          return N(1);
        if (j === f)
          return N(7);
        var G = (B = {}, B[C] = s, B[d] = h, B[_] = l, B)[j] || 1, X = this.$d.getTime() + v * G;
        return $.w(X, this);
      }, p.subtract = function(v, k) {
        return this.add(-1 * v, k);
      }, p.format = function(v) {
        var k = this, B = this.$locale();
        if (!this.isValid())
          return B.invalidDate || M;
        var T = v || "YYYY-MM-DDTHH:mm:ssZ", j = $.z(this), N = this.$H, G = this.$m, X = this.$M, J = B.weekdays, e1 = B.months, i1 = B.meridiem, d1 = function(o1, f1, x1, B1) {
          return o1 && (o1[f1] || o1(k, T)) || x1[f1].slice(0, B1);
        }, L1 = function(o1) {
          return $.s(N % 12 || 12, o1, "0");
        }, h1 = i1 || function(o1, f1, x1) {
          var B1 = o1 < 12 ? "AM" : "PM";
          return x1 ? B1.toLowerCase() : B1;
        };
        return T.replace(L, function(o1, f1) {
          return f1 || function(x1) {
            switch (x1) {
              case "YY":
                return String(k.$y).slice(-2);
              case "YYYY":
                return $.s(k.$y, 4, "0");
              case "M":
                return X + 1;
              case "MM":
                return $.s(X + 1, 2, "0");
              case "MMM":
                return d1(B.monthsShort, X, e1, 3);
              case "MMMM":
                return d1(e1, X);
              case "D":
                return k.$D;
              case "DD":
                return $.s(k.$D, 2, "0");
              case "d":
                return String(k.$W);
              case "dd":
                return d1(B.weekdaysMin, k.$W, J, 2);
              case "ddd":
                return d1(B.weekdaysShort, k.$W, J, 3);
              case "dddd":
                return J[k.$W];
              case "H":
                return String(N);
              case "HH":
                return $.s(N, 2, "0");
              case "h":
                return L1(1);
              case "hh":
                return L1(2);
              case "a":
                return h1(N, G, !0);
              case "A":
                return h1(N, G, !1);
              case "m":
                return String(G);
              case "mm":
                return $.s(G, 2, "0");
              case "s":
                return String(k.$s);
              case "ss":
                return $.s(k.$s, 2, "0");
              case "SSS":
                return $.s(k.$ms, 3, "0");
              case "Z":
                return j;
            }
            return null;
          }(o1) || j.replace(":", "");
        });
      }, p.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, p.diff = function(v, k, B) {
        var T, j = this, N = $.p(k), G = H(v), X = (G.utcOffset() - this.utcOffset()) * s, J = this - G, e1 = function() {
          return $.m(j, G);
        };
        switch (N) {
          case V:
            T = e1() / 12;
            break;
          case m:
            T = e1();
            break;
          case F:
            T = e1() / 3;
            break;
          case f:
            T = (J - X) / 6048e5;
            break;
          case u:
            T = (J - X) / 864e5;
            break;
          case d:
            T = J / h;
            break;
          case C:
            T = J / s;
            break;
          case _:
            T = J / l;
            break;
          default:
            T = J;
        }
        return B ? T : $.a(T);
      }, p.daysInMonth = function() {
        return this.endOf(m).$D;
      }, p.$locale = function() {
        return O[this.$L];
      }, p.locale = function(v, k) {
        if (!v)
          return this.$L;
        var B = this.clone(), T = q(v, k, !0);
        return T && (B.$L = T), B;
      }, p.clone = function() {
        return $.w(this.$d, this);
      }, p.toDate = function() {
        return new Date(this.valueOf());
      }, p.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, p.toISOString = function() {
        return this.$d.toISOString();
      }, p.toString = function() {
        return this.$d.toUTCString();
      }, w;
    }(), y = x.prototype;
    return H.prototype = y, [["$ms", c], ["$s", _], ["$m", C], ["$H", d], ["$W", u], ["$M", m], ["$y", V], ["$D", P]].forEach(function(w) {
      y[w[1]] = function(p) {
        return this.$g(p, w[0], w[1]);
      };
    }), H.extend = function(w, p) {
      return w.$i || (w(p, x, H), w.$i = !0), H;
    }, H.locale = q, H.isDayjs = R, H.unix = function(w) {
      return H(1e3 * w);
    }, H.en = O[E], H.Ls = O, H.p = {}, H;
  });
})(R2);
var yw2 = R2.exports;
const z1 = /* @__PURE__ */ E2(yw2);
var U2 = { exports: {} };
(function(r, e) {
  (function(l, s) {
    r.exports = s();
  })(O2, function() {
    var l = "minute", s = /[+-]\d\d(?::?\d\d)?/g, h = /([+-]|\d\d)/g;
    return function(c, _, C) {
      var d = _.prototype;
      C.utc = function(M) {
        var g = { date: M, utc: !0, args: arguments };
        return new _(g);
      }, d.utc = function(M) {
        var g = C(this.toDate(), { locale: this.$L, utc: !0 });
        return M ? g.add(this.utcOffset(), l) : g;
      }, d.local = function() {
        return C(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var u = d.parse;
      d.parse = function(M) {
        M.utc && (this.$u = !0), this.$utils().u(M.$offset) || (this.$offset = M.$offset), u.call(this, M);
      };
      var f = d.init;
      d.init = function() {
        if (this.$u) {
          var M = this.$d;
          this.$y = M.getUTCFullYear(), this.$M = M.getUTCMonth(), this.$D = M.getUTCDate(), this.$W = M.getUTCDay(), this.$H = M.getUTCHours(), this.$m = M.getUTCMinutes(), this.$s = M.getUTCSeconds(), this.$ms = M.getUTCMilliseconds();
        } else
          f.call(this);
      };
      var m = d.utcOffset;
      d.utcOffset = function(M, g) {
        var L = this.$utils().u;
        if (L(M))
          return this.$u ? 0 : L(this.$offset) ? m.call(this) : this.$offset;
        if (typeof M == "string" && (M = function(E) {
          E === void 0 && (E = "");
          var O = E.match(s);
          if (!O)
            return null;
          var R = ("" + O[0]).match(h) || ["-", 0, 0], q = R[0], H = 60 * +R[1] + +R[2];
          return H === 0 ? 0 : q === "+" ? H : -H;
        }(M), M === null))
          return this;
        var Z = Math.abs(M) <= 16 ? 60 * M : M, A = this;
        if (g)
          return A.$offset = Z, A.$u = M === 0, A;
        if (M !== 0) {
          var b = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (A = this.local().add(Z + b, l)).$offset = Z, A.$x.$localOffset = b;
        } else
          A = this.utc();
        return A;
      };
      var F = d.format;
      d.format = function(M) {
        var g = M || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return F.call(this, g);
      }, d.valueOf = function() {
        var M = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * M;
      }, d.isUTC = function() {
        return !!this.$u;
      }, d.toISOString = function() {
        return this.toDate().toISOString();
      }, d.toString = function() {
        return this.toDate().toUTCString();
      };
      var V = d.toDate;
      d.toDate = function(M) {
        return M === "s" && this.$offset ? C(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : V.call(this);
      };
      var P = d.diff;
      d.diff = function(M, g, L) {
        if (M && this.$u === M.$u)
          return P.call(this, M, g, L);
        var Z = this.local(), A = C(M).local();
        return P.call(Z, A, g, L);
      };
    };
  });
})(U2);
var Dw2 = U2.exports;
const Pw2 = /* @__PURE__ */ E2(Dw2), Aw2 = { class: "min-w-full table-auto shadow-lg" }, Sw2 = { class: "h-14" }, Tw2 = { class: "" }, Ow2 = {
  key: 0,
  class: "py-1 pr-1 pl-4 bg-white"
}, Ew2 = ["onClick"], Rw2 = { class: "flex items-center justify-start text-base text-gray-600 px-3 hover:text-gray-900 whitespace-nowrap" }, Uw2 = { class: "w-5" }, Nw2 = { class: "bg-gray-50 shadow-xl" }, qw2 = {
  key: 0,
  class: "py-1 pr-1 pl-4"
}, zw2 = ["value"], Kw2 = ["colspan"], Gw2 = {
  key: 0,
  class: "text-center py-8"
}, Ww2 = {
  key: 1,
  class: "text-center py-8"
}, Yw2 = ["innerHTML"], Xw2 = { key: 2 }, Qw2 = { class: "h-16 bg-white sticky bottom-0" }, Jw2 = ["colspan"], tp2 = { class: "flex justify-between" }, ep2 = { class: "ml-3 border-1 h-16 flex justify-center items-center" }, rp2 = /* @__PURE__ */ r1({
  __name: "DTable",
  props: {
    columns: { default: () => [] },
    rows: { default: () => [] },
    selectOptions: { type: Boolean, default: !1 },
    perPageDropdown: { default: () => [10, 25, 50, 200] },
    totalRows: { default: 0 },
    paginationLimit: { type: Boolean, default: !0 },
    textNoData: { default: "No hay datos para mostrar" },
    textPerPage: { default: "Filas por pagina :" },
    tableScroll: { type: Boolean, default: !0 },
    noDataContent: { default: "" }
  },
  emits: ["perPage", "selected", "offset", "changePage", "sort"],
  setup(r, { expose: e, emit: l }) {
    const s = r;
    z1.extend(Pw2);
    const h = (w) => l("selected", w), c = (w) => l("perPage", w), _ = (w) => l("offset", w), C = (w, p) => l("sort", [w, p]), d = () => l("changePage"), u = S(s.columns), f = S(!1), m = S("asc"), F = S(1), V = S(s.perPageDropdown[0]), P = S(s.perPageDropdown);
    let M = S(0);
    const g = S([]), L = S([]), Z = S(0), A = n1(() => [...s.rows]), b = n1(() => (g.value[F.value - 1] === void 0 && (g.value[F.value - 1] = []), F.value == 1 ? F.value - 1 : Z.value - V.value)), E = n1(() => s.rows.length < V.value ? Z.value - V.value + s.rows.length : Z.value), O = (w, p) => {
      w != null && (w === f.value && (m.value = m.value === "asc" ? "desc" : "asc"), f.value = w, C(m.value, f.value), $(), u.value[M.value].icon = !1, u.value[p].icon = !0, M.value = p);
    }, R = () => {
      for (const w of s.columns)
        w.icon = !1;
    }, q = () => {
      if (g.value[F.value - 1] = [], !L.value[F.value - 1])
        for (let w in s.rows)
          g.value[F.value - 1].push(String(s.rows[w].id));
      h(g.value.flat());
    }, H = () => {
      s.rows.length != g.value[F.value - 1].length ? L.value[F.value - 1] = !1 : L.value[F.value - 1] = !0, h(g.value.flat());
    }, $ = () => {
      Z.value = 0, F.value = 1, x();
    };
    e({ resetData: $ });
    const x = () => {
      Z.value = F.value * V.value, _(Z.value - V.value);
    }, y = (w, p) => w.format ? w.format(p) : p;
    return M1(() => {
      c(V.value), x(), R();
    }), (w, p) => (n(), o("div", {
      class: z([[w.tableScroll ? "table-scroll" : ""], "z-0 pb-6"])
    }, [
      t("div", {
        class: z(["relative overflow-x-auto rounded-lg h-full scroll", [w.rows.length >= 10 ? "shadow-lg" : ""]])
      }, [
        t("table", Aw2, [
          t("thead", Sw2, [
            t("tr", Tw2, [
              w.selectOptions ? (n(), o("th", Ow2, [
                l1(t("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": p[0] || (p[0] = (v) => L.value[F.value - 1] = v),
                  onClick: q,
                  onChange: H
                }, null, 544), [
                  [A1, L.value[F.value - 1]]
                ])
              ])) : D("", !0),
              (n(!0), o(K, null, t1(u.value, (v, k) => (n(), o("th", {
                key: k,
                onClick: (B) => O(v.table, k),
                style: { "z-index": "1" },
                class: z(["sticky top-0 bg-white", [
                  v.table != null ? "cursor-pointer" : "",
                  v.name === "actions" ? "sticky right-0 bg-white" : ""
                ]])
              }, [
                t("div", Rw2, [
                  Y(I(v.title) + " ", 1),
                  t("div", Uw2, [
                    m.value === "asc" && v.icon && typeof v.title < "u" ? (n(), Q(U(vr), {
                      key: 0,
                      class: "h-5 ml-1"
                    })) : D("", !0),
                    m.value === "desc" && v.icon && typeof v.title < "u" ? (n(), Q(U(Y7), {
                      key: 1,
                      class: "h-5 ml-1"
                    })) : D("", !0)
                  ])
                ])
              ], 10, Ew2))), 128))
            ])
          ]),
          t("tbody", Nw2, [
            (n(!0), o(K, null, t1(A.value, (v) => (n(), o("tr", {
              key: v,
              class: "bg-white border-y-2 border-gray-100 h-tr hover:bg-gray-100"
            }, [
              w.selectOptions ? (n(), o("td", qw2, [
                l1(t("input", {
                  class: "h-full w-full",
                  type: "checkbox",
                  value: String(v.id),
                  "onUpdate:modelValue": p[1] || (p[1] = (k) => g.value[F.value - 1] = k),
                  onChange: H
                }, null, 40, zw2), [
                  [A1, g.value[F.value - 1]]
                ])
              ])) : D("", !0),
              (n(!0), o(K, null, t1(w.columns, (k) => (n(), o("td", {
                class: z(["px-3", k.name === "actions" ? "sticky right-0 bg-white" : ""]),
                key: k.name
              }, [
                s1(w.$slots, k.name, s0(h0(v)), () => [
                  t("div", {
                    class: z(["max-w-xs overflow-hidden whitespace-pre-line text-ellipsis flex break-all", `justify-${k.align ?? "start"}`]),
                    style: { "inline-size": "max-content" }
                  }, [
                    k.name.indexOf("updated") >= 0 || k.name.indexOf("created") >= 0 ? (n(), o(K, { key: 0 }, [
                      Y(I(U(z1)(v[k.name]).format("DD/MM/YYYY h:mm A")), 1)
                    ], 64)) : (k.name.indexOf("date") >= 0 || k.name.indexOf("applies_from") >= 0 || k.name.indexOf("appliesFrom") >= 0 || k.name.indexOf("expires_at") >= 0) && U(z1)(v[k.name]).isValid() ? (n(), o(K, { key: 1 }, [
                      Y(I(v[k.name] ? v[k.name].indexOf("/") < 0 && v[k.name].indexOf("-") > 0 ? U(z1).utc(v[k.name]).format("DD/MM/YYYY") : v[k.name] : ""), 1)
                    ], 64)) : v[k.name] === !0 || v[k.name] === !1 || v[k.name] === "true" || v[k.name] === "false" ? (n(), o(K, { key: 2 }, [
                      Y(I(v[k.name] ? "Si" : "No"), 1)
                    ], 64)) : (n(), o(K, { key: 3 }, [
                      Y(I(y(k, v[k.name])), 1)
                    ], 64))
                  ], 2)
                ], !0)
              ], 2))), 128))
            ]))), 128)),
            w.rows.length == 0 ? (n(), o("th", {
              key: 0,
              class: "bg-white py-5",
              colspan: w.columns.length + 1
            }, [
              w.$slots.noDataContent ? (n(), o("div", Gw2, [
                s1(w.$slots, "noDataContent", {}, void 0, !0)
              ])) : w.noDataContent ? (n(), o("div", Ww2, [
                t("div", { innerHTML: w.noDataContent }, null, 8, Yw2)
              ])) : (n(), o("h1", Xw2, I(s.textNoData), 1))
            ], 8, Kw2)) : D("", !0)
          ]),
          t("tfoot", Qw2, [
            t("tr", null, [
              t("th", {
                colspan: w.columns.length + 1
              }, [
                t("div", tp2, [
                  t("div", ep2, [
                    s1(w.$slots, "refresh", {}, void 0, !0)
                  ]),
                  w.$props.perPageDropdown.length > 1 ? (n(), Q(T2, {
                    key: 0,
                    "per-page": V.value,
                    "total-rows": w.totalRows,
                    "start-row": b.value,
                    "end-row": E.value,
                    "per-page-dropdown": P.value,
                    "pagination-limit": w.paginationLimit,
                    "current-page": F.value,
                    "text-per-page": s.textPerPage,
                    onCurrentPage: p[2] || (p[2] = (v) => F.value = v),
                    onPerPage: p[3] || (p[3] = (v) => V.value = v),
                    onChange: p[4] || (p[4] = (v) => (x(), d(), c(V.value)))
                  }, null, 8, ["per-page", "total-rows", "start-row", "end-row", "per-page-dropdown", "pagination-limit", "current-page", "text-per-page"])) : D("", !0)
                ])
              ], 8, Jw2)
            ])
          ])
        ])
      ], 2)
    ], 2));
  }
});
const NG2 = /* @__PURE__ */ i(rp2, [["__scopeId", "data-v-14118653"]]);
var Q1 = function() {
  return Q1 = Object.assign || function(e) {
    for (var l, s = 1, h = arguments.length; s < h; s++) {
      l = arguments[s];
      for (var c in l)
        Object.prototype.hasOwnProperty.call(l, c) && (e[c] = l[c]);
    }
    return e;
  }, Q1.apply(this, arguments);
};
function np2(r, e, l) {
  if (l || arguments.length === 2)
    for (var s = 0, h = e.length, c; s < h; s++)
      (c || !(s in e)) && (c || (c = Array.prototype.slice.call(e, 0, s)), c[s] = e[s]);
  return r.concat(c || Array.prototype.slice.call(e));
}
const D1 = /* @__PURE__ */ r1({
  __name: "DIcon",
  props: {
    name: {},
    class: { default: "text-gray-500" }
  },
  setup(r) {
    return (e, l) => (n(), Q(a0(e.name), {
      class: z(e.class)
    }, null, 8, ["class"]));
  }
}), op2 = ["disabled", "type"], p1 = /* @__PURE__ */ r1({
  __name: "DBtn",
  props: {
    color: { default: "default" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    type: { default: "submit" },
    icon: { default: "" }
  },
  setup(r) {
    const e = r, l = n1(() => {
      switch (e.color) {
        case "disabled":
          return "bg-gray-300 text-gray-500 cursor-not-allowed";
        case "success":
          return "bg-green-500 text-white hover:bg-green-700 focus:ring-green-500 cursor-pointer";
        case "warning":
          return "bg-orange-500 text-white hover:bg-orange-700 focus:ring-orange-500 cursor-pointer";
        case "danger":
          return "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 cursor-pointer";
        case "secondary":
          return "bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-300 cursor-pointer";
        case "white":
          return "bg-white text-gray-800 hover:bg-gray-100 focus:ring-gray-100 cursor-pointer";
        case "light":
          return "bg-white-400 text-indigo-700 hover:bg-indigo-700 hover:text-white border-4 border-indigo-300 text-black focus:ring-white cursor-pointer";
        case "excel":
          return "bg-green-600 text-white hover:bg-green-700 focus:ring-green-600 cursor-pointer";
        case "ods":
          return "bg-green-700 text-white hover:bg-green-800 focus:ring-green-700 cursor-pointer";
        default:
          return "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 cursor-pointer";
      }
    });
    return (s, h) => (n(), o("button", {
      disabled: s.disabled,
      type: s.type,
      class: z(["inline-flex text-sm justify-center items-center py-1.5 px-4 border border-transparent shadow-sm rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2", [l.value]])
    }, [
      s.icon ? (n(), Q(D1, {
        key: 0,
        class: "text-white pr-2 w-7",
        name: s.icon
      }, null, 8, ["name"])) : D("", !0),
      s.loading ? (n(), Q(U(R1), {
        key: 1,
        class: "rotate"
      })) : s1(s.$slots, "default", { key: 2 })
    ], 10, op2));
  }
});
const ip2 = { class: "flex flex-col justify-between border-2 sm:w-full rounded-lg bg-white h-auto min-h-0" }, lp2 = {
  key: 0,
  class: "bg-gray-100 py-3 rounded-t-lg px-5"
}, sp2 = { class: "px-5 flex flex-col gap-3 py-5" }, hp2 = { key: 0 }, ap2 = { key: 1 }, dp2 = {
  key: 1,
  class: "bg-gray-50 py-3 rounded-b-lg px-5"
}, qG2 = /* @__PURE__ */ r1({
  __name: "DCard",
  props: {
    title: { default: "" },
    description: { default: "" },
    header: { type: Boolean, default: !1 },
    footer: { type: Boolean, default: !1 }
  },
  setup(r) {
    return (e, l) => (n(), o("div", ip2, [
      e.header ? (n(), o("header", lp2, [
        s1(e.$slots, "header")
      ])) : D("", !0),
      t("main", sp2, [
        e.title ? (n(), o("h1", hp2, I(e.title), 1)) : D("", !0),
        e.description ? (n(), o("p", ap2, I(e.description), 1)) : D("", !0),
        s1(e.$slots, "default")
      ]),
      e.footer ? (n(), o("footer", dp2, [
        s1(e.$slots, "footer")
      ])) : D("", !0)
    ]));
  }
});
const cp2 = { class: "dropdown" }, _p2 = { key: 1 }, Cp2 = ["onClick"], zG2 = /* @__PURE__ */ r1({
  __name: "DDropdown",
  props: {
    label: { default: "" },
    options: {},
    icon: { type: Boolean, default: !0 }
  },
  emits: ["action"],
  setup(r, { emit: e }) {
    return (l, s) => (n(), o("div", cp2, [
      t("span", null, [
        l.icon ? (n(), Q(U(hS), {
          key: 0,
          class: "w-4"
        })) : (n(), o("p", _p2, I(l.label), 1))
      ]),
      t("ul", null, [
        (n(!0), o(K, null, t1(l.options, (h, c) => (n(), o(K, { key: c }, [
          h.view ? (n(), o("li", {
            key: 0,
            class: "text-sm flex items-center",
            onClick: (_) => l.$emit("action", h.action)
          }, I(h.name), 9, Cp2)) : D("", !0)
        ], 64))), 128))
      ])
    ]));
  }
});
const fp2 = { class: "w-full min-w-full" }, vp2 = { class: "block text-sm font-medium text-gray-700 mb-1.5" }, up2 = ["disabled"], wp2 = {
  key: 0,
  class: "flex flex-col justify-center items-center max-w-2xl mx-3 overflow-hidden"
}, pp2 = { class: "max-w-2xl overflow-hidden whitespace-nowrap text-ellipsis mt-1" }, gp2 = {
  key: 1,
  class: "flex flex-col justify-center items-center"
}, $p2 = ["value"], Mp2 = /* @__PURE__ */ t("br", null, null, -1), Lp2 = { class: "text-xs text-red-500" }, KG2 = /* @__PURE__ */ r1({
  __name: "DFileUploader",
  props: {
    label: { default: "" },
    uploadFile: { default: "create" },
    modelValue: { default: "" },
    helpText: { default: "Carga tu archivo" },
    multiple: { type: Boolean, default: !1 },
    accept: { default: "" },
    disabled: { type: Boolean, default: !1 },
    error: { default: "" }
  },
  emits: ["update:modelValue", "file", "handleFileDownload"],
  setup(r, { emit: e }) {
    const l = r, s = (d) => {
      e("update:modelValue", d.target.value);
    }, h = (d) => {
      const u = d.target.files;
      if (u.length > 0) {
        const f = u[0];
        f.type.match(l.accept) && c(f);
      }
    }, c = (d) => {
      const u = new FileReader();
      u.readAsArrayBuffer(d), u.onload = (f) => {
        const m = _(f.target.result);
        e("file", { content: m, name: d.name });
      };
    }, _ = (d) => {
      for (var u = "", f = new Uint8Array(d), m = f.byteLength, F = 0; F < m; F++)
        u += String.fromCharCode(f[F]);
      return window.btoa(u);
    }, C = () => {
      e("update:modelValue", ""), e("file", "");
    };
    return (d, u) => (n(), o("div", null, [
      t("div", fp2, [
        t("label", vp2, I(d.label), 1),
        t("label", {
          class: z(["flex justify-center items-center rounded-xl border-2 border-dashed border-gray-300 hover:border-blue-500 hover:bg-gray-100 h-32", [
            { error: d.error },
            { "bg-gray-200": d.disabled, "pointer-events-none": d.disabled }
          ]]),
          onInput: u[0] || (u[0] = (f) => s(f)),
          disabled: d.disabled
        }, [
          d.modelValue ? (n(), o("span", wp2, [
            W(U(gU), { class: "h-10 w-10 text-gray-300" }),
            t("span", pp2, I(d.modelValue.indexOf("\\") >= 0 ? d.modelValue.split("\\")[d.modelValue.split("\\").length - 1].indexOf("UpHere") >= 0 ? d.modelValue.split("\\")[d.modelValue.split("\\").length - 1].split("UpHere")[d.modelValue.split("\\")[d.modelValue.split("\\").length - 1].split("UpHere").length - 1] : d.modelValue.split("\\")[d.modelValue.split("\\").length - 1] : d.modelValue.split("/")[d.modelValue.split("/").length - 1].indexOf("UpHere") >= 0 ? d.modelValue.split("/")[d.modelValue.split("/").length - 1].split("UpHere")[d.modelValue.split("/")[d.modelValue.split("/").length - 1].split("UpHere").length - 1] : d.modelValue.split("/")[d.modelValue.split("/").length - 1]), 1)
          ])) : (n(), o("span", gp2, [
            Y(I(d.helpText) + " ", 1),
            W(U(SX1), { class: "mt-1 h-10 w-10 text-gray-300" })
          ])),
          t("input", {
            value: d.modelValue === "" ? d.modelValue : "",
            type: "file",
            class: "opacity-0 hidden",
            onInput: h
          }, null, 40, $p2)
        ], 42, up2),
        d.modelValue !== "" ? (n(), Q(p1, {
          key: 0,
          disabled: d.disabled,
          color: d.disabled ? "disabled" : "default",
          class: "mt-2 mr-2",
          type: "button",
          onClick: u[1] || (u[1] = (f) => C())
        }, {
          default: a1(() => [
            Y(" Borrar archivo ")
          ]),
          _: 1
        }, 8, ["disabled", "color"])) : D("", !0),
        (d.uploadFile === "edit" || d.uploadFile === "view") && d.modelValue !== "" && d.modelValue.startsWith("https://") ? (n(), Q(p1, {
          key: 1,
          class: "mt-2 mr-2",
          type: "button",
          onClick: u[2] || (u[2] = (f) => d.$emit("handleFileDownload", d.modelValue))
        }, {
          default: a1(() => [
            Y(" Descargar ")
          ]),
          _: 1
        })) : D("", !0),
        Mp2,
        t("span", Lp2, I(d.error), 1)
      ])
    ]));
  }
});
var kp2 = { class: "flex ml-1" }, mp2 = ["id"], xp2 = { class: "bg-gray-100 text-base py-2 px-4" }, Hp2 = { class: "font-semibold" }, Vp2 = { class: "py-3 px-4 flex flex-col gap-3 max-h-96 overflow-y-auto" }, Zp2 = {
  key: 0,
  class: "break-words text-sm leading-4"
}, Bp2 = {
  key: 1,
  class: "text-base leading-4"
}, Fp2 = {
  __name: "DInfo",
  props: {
    title: { type: String, default: "" },
    formula: { type: String, default: "" },
    errors: Array,
    icon: { type: String, default: "info" },
    td: { type: String, default: "" }
  },
  setup: function(r) {
    var e = S(null), l = S(!0);
    k1(e, function(c) {
      c != null && l.value == !0 && e.value.focus();
    });
    var s = function() {
      l.value = !1;
    }, h = function(c) {
      l.value = !0, setTimeout(function() {
        document.getElementById(c).clientHeight > 200 ? document.getElementById(c).style.width = "500px" : document.getElementById(c).style.width = "300px", document.getElementById(c).scrollIntoView({ behavior: "smooth", block: "center", inline: "end" });
      }, 10);
    };
    return function(c, _) {
      return n(), o("div", kp2, [
        r.icon === "error" ? (n(), Q(U(S2), {
          key: 0,
          onClick: _[0] || (_[0] = function(C) {
            return h(r.td);
          }),
          class: "mr-1.5 w-6 text-red-600 cursor-pointer"
        })) : D("", !0),
        r.icon === "info" ? (n(), Q(U(A81), {
          key: 1,
          onClick: _[1] || (_[1] = function(C) {
            return h(r.td);
          }),
          class: "w-6 text-blue-600 cursor-pointer"
        })) : D("", !0),
        l.value ? (n(), o("div", {
          key: 2,
          ref_key: "info",
          ref: e,
          id: r.td,
          onFocusout: s,
          tabindex: "0",
          class: "absolute z-10 bg-white overflow-hidden flex flex-col border-2 border-gray-200 rounded-md h-auto shadow-2xl focus:outline-none ml-6"
        }, [
          t("header", xp2, [
            t("h1", Hp2, I(r.title), 1)
          ]),
          t("main", Vp2, [
            r.icon === "info" ? (n(), o("p", Zp2, I(r.formula), 1)) : (n(), o("ul", Bp2, [
              (n(!0), o(K, null, t1(r.errors, function(C) {
                return n(), o("li", {
                  type: "disc",
                  class: "ml-5",
                  key: C
                }, I(C.value), 1);
              }), 128))
            ])),
            s1(c.$slots, "default")
          ])
        ], 40, mp2)) : D("", !0)
      ]);
    };
  }
};
const K1 = Fp2;
var jp2 = { class: "font-semibold text-justify text-gray-500 w-full truncate ..." }, Ip2 = {
  __name: "DList",
  props: {
    nameItem: { type: String, default: "Prueba item" }
  },
  emits: ["clicked"],
  setup: function(r) {
    return function(e, l) {
      return n(), o("div", {
        class: "w-full h-11 bg-gray-50 flex justify-between items-center px-3 cursor-pointer rounded-lg mr-5 hover:bg-gray-200 my-2",
        onClick: l[0] || (l[0] = function(s) {
          return e.$emit("clicked");
        })
      }, [
        t("p", jp2, I(r.nameItem), 1)
      ]);
    };
  }
};
const x2 = Ip2, bp2 = { class: "fixed flex flex-col gap-5 justify-center items-center inset-0 bg-gray-600 bg-opacity-75 z-50" }, yp2 = { class: "text-gray-200 italic font-semibold tracking-wide" }, GG2 = /* @__PURE__ */ r1({
  __name: "DLoading",
  props: {
    message: { default: "Loading..." }
  },
  setup(r) {
    return (e, l) => (n(), o("div", bp2, [
      W(U(R1), { class: "rotate h-14 w-14 text-white" }),
      t("p", yp2, I(e.message), 1)
    ]));
  }
});
const Dp2 = {
  class: "fixed z-50 inset-0 overflow-hidden bg-gray-500 bg-opacity-75 transition-opacity",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}, Pp2 = { class: "w-screen h-full flex pt-10 justify-start flex-col items-center relative align-bottom rounded-lg overflow-hidden shadow-2xl transform transition-all px-3" }, Ap2 = {
  class: "content-modal flex flex-col items-center py-6 px-4 overflow-y-auto scroll",
  style: { "max-height": "calc(100vh - 11rem)" }
}, Sp2 = { class: "mt-3 flex flex-col py-2 gap-3 items-center w-available" }, Tp2 = {
  key: 0,
  class: "text-2xl text-center leading-6 font-medium text-gray-900 w-available break-words"
}, Op2 = ["innerHTML"], Ep2 = { class: "text-center max-h-full overflow-y-auto scroll" }, Rp2 = {
  key: 0,
  class: "sticky inset-x-0 bottom-0 bg-gray-100 w-full flex justify-center items-center sm:justify-end h-16"
}, Up2 = {
  key: 0,
  class: "absolute top-0 w-full bg-gray-300 h-1"
}, Np2 = /* @__PURE__ */ r1({
  __name: "DModal",
  props: {
    title: { default: "" },
    description: { default: "" },
    typeAlert: { default: "" },
    open: { type: Boolean, default: !1 },
    acceptQuestion: { default: "Si, continuar" },
    nameButtonClose: { default: "Cerrar" },
    time: { default: 0 },
    size: { default: "w-full md:w-2/3 2xl:w-1/3" },
    form: { type: Boolean, default: !1 },
    isFooter: { type: Boolean, default: !0 }
  },
  emits: ["closeModal", "otherMethod"],
  setup(r, { emit: e }) {
    const l = r, s = S(100), h = () => {
      e("closeModal");
    }, c = () => {
      const _ = l.time / 10;
      let C = _;
      const d = setInterval(() => {
        C -= 1, s.value = 100 * C / _, s.value <= 0 && (clearInterval(d), h());
      }, 10);
    };
    return M1(() => {
      l.time > 0 && c();
    }), (_, C) => l1((n(), o("div", Dp2, [
      t("div", Pp2, [
        t("div", {
          class: z(["card overflow-hidden rounded-lg bg-white relative", _.size])
        }, [
          t("div", Ap2, [
            _.form ? D("", !0) : (n(), o(K, { key: 0 }, [
              t("div", {
                class: z(["flex items-center justify-center rounded-full sm:mx-0 h-28 w-28", [
                  {
                    "bg-gray-50 ": _.typeAlert === "question",
                    hidden: _.typeAlert === ""
                  }
                ]])
              }, [
                _.typeAlert === "success" ? (n(), Q(U(ow), {
                  key: 0,
                  class: "h-20 w-20 text-green-600"
                })) : D("", !0),
                _.typeAlert === "warning" ? (n(), Q(U(K4), {
                  key: 1,
                  class: "h-20 w-20 text-yellow-400"
                })) : D("", !0),
                _.typeAlert === "error" ? (n(), Q(U(S2), {
                  key: 2,
                  class: "h-20 w-20 text-red-600"
                })) : D("", !0),
                _.typeAlert === "question" ? (n(), Q(U(A6), {
                  key: 3,
                  class: "h-20 w-20 text-yellow-300"
                })) : D("", !0)
              ], 2),
              t("div", Sp2, [
                _.title ? (n(), o("h3", Tp2, I(_.title), 1)) : D("", !0),
                s1(_.$slots, "title", {}, void 0, !0),
                _.description ? (n(), o("p", {
                  key: 1,
                  class: "text-center text-medium text-gray-500",
                  innerHTML: _.description
                }, null, 8, Op2)) : D("", !0),
                t("div", Ep2, [
                  s1(_.$slots, "description", {}, void 0, !0)
                ])
              ])
            ], 64)),
            s1(_.$slots, "form", {}, void 0, !0)
          ]),
          t("div", null, [
            s1(_.$slots, "actions", {}, () => [
              _.typeAlert != "question" && !_.form && _.isFooter ? (n(), o("footer", Rp2, [
                _.time > 0 ? (n(), o("div", Up2, [
                  t("div", {
                    class: z(["h-1", "bg-blue-500"]),
                    style: E1({ width: `${s.value}%` })
                  }, null, 4)
                ])) : D("", !0),
                t("div", null, [
                  W(p1, {
                    type: "button",
                    color: "secondary",
                    class: "mx-5",
                    onClick: C[0] || (C[0] = (d) => _.$emit("closeModal"))
                  }, {
                    default: a1(() => [
                      Y(I(_.nameButtonClose), 1)
                    ]),
                    _: 1
                  })
                ])
              ])) : D("", !0),
              _.typeAlert == "question" || _.form ? (n(), o("footer", {
                key: 1,
                class: z(["sticky inset-x-0 bottom-0 bg-gray-100 w-full flex items-center pt-5 pb-5 h-17", [_.form ? "justify-end" : "justify-center"]])
              }, [
                t("div", null, [
                  W(p1, {
                    type: "button",
                    color: "secondary",
                    class: "py-2 px-8 mx-2",
                    onClick: C[1] || (C[1] = (d) => _.$emit("closeModal"))
                  }, {
                    default: a1(() => [
                      Y(" Cancelar ")
                    ]),
                    _: 1
                  })
                ]),
                t("div", null, [
                  W(p1, {
                    color: _.form ? "" : "danger",
                    class: "py-2 px-8 mx-2",
                    onClick: C[2] || (C[2] = (d) => _.$emit("otherMethod"))
                  }, {
                    default: a1(() => [
                      Y(I(_.acceptQuestion), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ])
              ], 2)) : D("", !0)
            ], !0)
          ])
        ], 2)
      ])
    ], 512)), [
      [b1, _.open]
    ]);
  }
});
const WG2 = /* @__PURE__ */ i(Np2, [["__scopeId", "data-v-25b144c8"]]), qp2 = {
  key: 0,
  class: "block text-sm font-medium text-gray-800 mb-1.5"
}, zp2 = {
  key: 0,
  class: "text-red-500"
}, Kp2 = ["placeholder", "value", "disabled", "type", "autocomplete", "maxlength", "minlength", "min", "max", "step"], Gp2 = { key: 3 }, Wp2 = { class: "text-xs text-blue-500" }, Yp2 = /* @__PURE__ */ t("br", null, null, -1), Xp2 = {
  key: 4,
  class: "text-xs text-red-500"
}, N2 = /* @__PURE__ */ r1({
  __name: "DTextField",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    placeholder: { default: "" },
    hint: { default: "" },
    type: { default: "text" },
    disabled: { type: Boolean, default: !1 },
    hidden: { type: Boolean, default: !1 },
    min: {},
    max: {},
    minlength: {},
    maxlength: {},
    default: { default: "" },
    mask: { default: "" },
    validation: {},
    error: { default: "" },
    step: { default: "any" },
    required: { type: Boolean, default: !1 },
    icon: { default: "" },
    classInput: { default: "" },
    headerTitle: {}
  },
  emits: ["update:modelValue", "enter"],
  setup(r, { emit: e }) {
    const l = r, s = (h) => {
      let c = h;
      l.maxlength && h.length > l.maxlength && (c = h.slice(0, l.maxlength)), e("update:modelValue", c);
    };
    return M1(() => {
      l.default && l.modelValue === "" && s(l.default);
    }), (h, c) => (n(), o("div", {
      class: z(["relative", [h.hidden ? "hidden" : ""]])
    }, [
      h.label ? (n(), o("label", qp2, [
        Y(I(h.label) + " ", 1),
        h.required ? (n(), o("span", zp2, "*")) : D("", !0)
      ])) : D("", !0),
      h.icon ? (n(), Q(D1, {
        key: 1,
        name: h.icon,
        class: "text-gray-500 absolute pt-2 pl-2 w-7 h-7"
      }, null, 8, ["name"])) : D("", !0),
      h.type === "color" && typeof h.modelValue == "string" ? (n(), o("span", {
        key: 2,
        class: "absolute pt-2 pl-2 w-7 h-7",
        style: E1({ color: h.modelValue, backgroundColor: h.modelValue })
      }, null, 4)) : D("", !0),
      t("input", {
        placeholder: h.placeholder,
        value: h.modelValue,
        disabled: h.disabled,
        type: h.type,
        autocomplete: h.type === "password" ? "on" : "off",
        class: z([[
          h.disabled ? "bg-gray-200 cursor-no-drop" : "bg-white",
          h.icon ? "pl-9" : "pl-2",
          h.error ? "border-red-500" : "border-gray-300",
          h.classInput
        ], "focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-transparent block w-full shadow-sm text-sm border rounded-md py-2 pr-2"]),
        maxlength: h.maxlength,
        minlength: h.minlength,
        min: h.min,
        max: h.max,
        step: h.step,
        onInput: c[0] || (c[0] = (_) => s(_.target.value)),
        onKeyup: c[1] || (c[1] = J1((_) => e("enter"), ["enter"]))
      }, null, 42, Kp2),
      h.hint ? (n(), o("label", Gp2, [
        t("span", Wp2, I(h.hint), 1),
        Yp2
      ])) : D("", !0),
      h.error ? (n(), o("span", Xp2, I(h.error), 1)) : D("", !0)
    ], 2));
  }
}), Qp2 = { class: "block text-left text-sm font-medium text-gray-700 mb-1.5" }, Jp2 = {
  key: 0,
  class: "text-red-500"
}, tg2 = {
  key: 0,
  class: "w-full h-full items-center justify-between flex"
}, eg2 = { class: "text-sm truncate ..." }, rg2 = {
  key: 1,
  class: "w-full h-full items-center justify-between flex"
}, ng2 = { class: "text-gray-400 pl-2 text-sm truncate ..." }, og2 = ["value"], ig2 = { key: 0 }, lg2 = { class: "text-xs text-blue-500" }, sg2 = /* @__PURE__ */ t("br", null, null, -1), hg2 = { class: "text-xs text-red-500" }, ag2 = {
  key: 0,
  class: "fixed z-40 inset-0 overflow-hidden bg-gray-500 bg-opacity-75 transition-opacity h-full"
}, dg2 = { class: "w-screen h-full flex justify-center flex-col items-center align-bottom overflow-hidden shadow-2xl transform transition-all px-3" }, cg2 = { class: "card-container bg-white rounded-lg overflow-hidden" }, _g2 = { class: "sticky inset-x-0 top-0 bg-gray-100 w-full h-16 px-4 flex items-center justify-center gap-3 border" }, Cg2 = { class: "font-bold text-xl" }, fg2 = {
  class: "flex justify-center items-center rounded-full bg-blue-600 text-white w-auto h-9 font-bold p-1.5",
  style: { "min-width": "2.25rem" }
}, vg2 = { class: "p-3" }, ug2 = { class: "flex flex-row items-start" }, wg2 = { class: "w-screen h-full border-2 border-white border-r-gray-200 py-5 px-2 max-h-96 overflow-y-auto overflow-x-hidden" }, pg2 = ["onClick"], gg2 = { class: "w-screen h-full py-5 px-2 max-h-96 overflow-y-auto overflow-x-hidden" }, $g2 = ["onClick"], Mg2 = { class: "sticky inset-x-0 bottom-0 right-0 w-full flex justify-center items-center sm:justify-end h-16 gap-2 border-2 border-white border-t-gray-200 px-5" }, YG2 = /* @__PURE__ */ r1({
  inheritAttrs: !1,
  __name: "DMultiselect",
  props: {
    label: { default: "" },
    modelValue: { default: () => [] },
    options: { default: () => [] },
    headerTitle: { default: "" },
    showKey: { default: "name" },
    valueKey: { default: "id" },
    error: { default: "" },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    class: { default: "" },
    field: {},
    readonly: {},
    allModel: {},
    placeholder: {},
    hint: { default: "" },
    helpText: {},
    uploadFile: {}
  },
  emits: [
    "update:modelValue",
    "change",
    "filter",
    "file",
    "handleFileDownload"
  ],
  setup(r, { emit: e }) {
    const l = r, s = S(!1), h = S(""), c = S();
    s2(() => {
      c.value = l.options;
    });
    const _ = S([]), C = S(0), d = S(), u = S(), f = S(), m = S(), { modelValue: F } = t2(l), V = ($) => {
      e("update:modelValue", $);
    }, P = () => {
      e("change");
    }, M = ($) => {
      _.value.map((y) => y[l.valueKey]).indexOf($[l.valueKey]) === -1 && (_.value.push($), C.value += 1), c.value = L(c.value, _.value);
    }, g = ($) => {
      c.value.push($), _.value = L(_.value, c.value), C.value -= 1;
    }, L = ($, x) => (x = x.map((y) => y[l.valueKey]), $ = $.filter(
      (y) => x.indexOf(y[l.valueKey]) == -1
    ), $), Z = () => {
      var $;
      if ((($ = l.options) == null ? void 0 : $.length) > 0 && (s.value = !0), b(), A(), l.modelValue.length == l.options.length)
        E();
      else {
        let x = c.value.filter(
          (y) => l.modelValue.indexOf(String(y[l.valueKey])) > -1
        );
        for (const y of x)
          M(y);
      }
    }, A = () => {
      u.value = [...c.value], f.value = [..._.value], m.value = C.value;
    }, b = () => {
      _.value.length !== l.modelValue.length && (_.value = _.value.filter(
        ($) => l.modelValue.indexOf($[l.valueKey]) > -1
      ), C.value = _.value.length);
    }, E = () => {
      var $;
      _.value = [], _.value = [...l.options], c.value = [], C.value = ($ = _.value) == null ? void 0 : $.length;
    }, O = () => {
      _.value = [], c.value = l.options, C.value = 0;
    }, R = () => {
      d.value = _.value, h.value = "", V(
        d.value.map(
          ($) => typeof $[l.valueKey] == "number" ? $[l.valueKey].toString() : $[l.valueKey]
        )
      ), P(), s.value = !1;
    }, q = () => {
      var $;
      c.value = u.value, _.value = f.value, s.value = !1, C.value = ($ = _.value) == null ? void 0 : $.length;
    };
    function H($) {
      document.addEventListener("keydown", function(x) {
        x.key === "Escape" && $();
      });
    }
    return H(function() {
      s.value = !1;
    }), ($, x) => {
      var y, w;
      return n(), o(K, null, [
        t("div", {
          class: z(["w-full", $.class])
        }, [
          t("label", Qp2, [
            Y(I($.label) + " ", 1),
            $.required ? (n(), o("span", Jp2, "*")) : D("", !0)
          ]),
          t("label", {
            class: z(["block w-full py-2 px-2 rounded-md shadow-sm border h-9_3", [$.error === "" ? "border-gray-300" : "border-red-500"]])
          }, [
            ((y = $.options) == null ? void 0 : y.length) > 0 ? (n(), o("div", tg2, [
              t("span", eg2, I(`${(w = U(F)) == null ? void 0 : w.length} Opciones Seleccionadas`), 1),
              W(U(A2), { class: "w-4 h-4" })
            ])) : (n(), o("div", rg2, [
              t("span", ng2, I("Esperando datos..."), 1),
              W(U(R1), { class: "rotate text-gray-400" })
            ])),
            t("input", {
              class: "opacity-0 hidden",
              onClick: Z,
              onInput: x[0] || (x[0] = (p) => V(p.target.value)),
              value: U(F)
            }, null, 40, og2)
          ], 2),
          $.hint ? (n(), o("label", ig2, [
            t("span", lg2, I($.hint), 1),
            sg2
          ])) : D("", !0),
          t("span", hg2, I($.error), 1)
        ], 2),
        s.value ? (n(), o("div", ag2, [
          t("div", dg2, [
            t("div", cg2, [
              t("div", null, [
                t("header", _g2, [
                  t("h1", Cg2, I($.headerTitle), 1),
                  t("div", fg2, I(C.value), 1)
                ]),
                t("article", null, [
                  t("div", vg2, [
                    W(N2, {
                      placeholder: "Buscar...",
                      modelValue: h.value,
                      "onUpdate:modelValue": x[1] || (x[1] = (p) => h.value = p)
                    }, null, 8, ["modelValue"])
                  ]),
                  t("div", ug2, [
                    t("div", wg2, [
                      t("a", {
                        class: z([[{ "cursor-not-allowed pointer-events-none": $.disabled }], "text-gray-400 cursor-pointer underline"]),
                        onClick: H1(E, ["prevent"])
                      }, " Marcar Todos ", 10, pg2),
                      (n(!0), o(K, null, t1(c.value.filter(function(p) {
                        return h.value == "" || p[$.showKey].toUpperCase().indexOf(h.value.toUpperCase()) > -1;
                      }), (p, v) => (n(), Q(x2, {
                        key: v,
                        nameItem: p[$.showKey],
                        onClicked: (k) => M(p),
                        class: z([{ "cursor-not-allowed pointer-events-none": $.disabled }])
                      }, null, 8, ["nameItem", "onClicked", "class"]))), 128))
                    ]),
                    t("div", gg2, [
                      t("a", {
                        class: z(["text-gray-400 cursor-pointer underline", [{ "cursor-not-allowed pointer-events-none": $.disabled }]]),
                        onClick: H1(O, ["prevent"])
                      }, " Desmarcar Todos ", 10, $g2),
                      (n(!0), o(K, null, t1(_.value.filter(function(p) {
                        return h.value == "" || p[$.showKey].toUpperCase().indexOf(h.value.toUpperCase()) > -1;
                      }), (p, v) => (n(), Q(x2, {
                        key: v,
                        nameItem: p[$.showKey],
                        onClicked: (k) => g(p),
                        class: z([{ "cursor-not-allowed pointer-events-none": $.disabled }])
                      }, null, 8, ["nameItem", "onClicked", "class"]))), 128))
                    ])
                  ])
                ]),
                t("footer", Mg2, [
                  W(p1, {
                    color: "secondary",
                    onClick: x[2] || (x[2] = (p) => q())
                  }, {
                    default: a1(() => [
                      Y("Cancelar")
                    ]),
                    _: 1
                  }),
                  W(p1, {
                    onClick: H1(R, ["prevent"])
                  }, {
                    default: a1(() => [
                      Y("Aceptar")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ])
        ])) : D("", !0)
      ], 64);
    };
  }
});
var Lg2 = {
  key: 0,
  class: "block text-sm font-medium text-gray-700"
}, kg2 = {
  key: 0,
  class: "text-red-500"
}, mg2 = ["disabled", "value"], xg2 = {
  disabled: "",
  value: null
}, Hg2 = ["value", "selected"], Vg2 = { class: "text-xs text-red-500" }, Zg2 = {
  __name: "DSelectField",
  props: {
    modelValue: { type: [String, Number, Object, Array, Boolean], default: "" },
    label: { type: String, default: "" },
    options: { type: Array, required: !0 },
    showKey: { type: String, default: "name" },
    valueKey: { type: String, default: "id" },
    disabled: { type: Boolean, default: !1 },
    error: { type: String, default: "" },
    placeholder: {
      type: String,
      required: !1,
      default: "Seleccione una opcion"
    },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup: function(r, e) {
    var l = e.emit, s = function(h) {
      l("update:modelValue", h);
    };
    return function(h, c) {
      return n(), o("div", null, [
        r.label ? (n(), o("label", Lg2, [
          Y(I(r.label) + " ", 1),
          r.required ? (n(), o("span", kg2, "*")) : D("", !0)
        ])) : D("", !0),
        t("select", d0({
          class: ["mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm", [{ error: r.error }, { "bg-gray-300": r.disabled }]],
          disabled: r.disabled,
          value: r.modelValue
        }, Q1(Q1({}, h.$attrs), { onChange: function(_) {
          s(_.target.value);
        } })), [
          t("option", xg2, I("Seleccione ".concat(r.label)), 1),
          (n(!0), o(K, null, t1(r.options, function(_, C) {
            return n(), o("option", {
              key: C,
              value: _[r.valueKey],
              selected: typeof _ == "object" ? _[r.valueKey] == r.modelValue : _[C] == r.modelValue
            }, I(typeof _ == "object" ? _[r.showKey] : r.options[C]), 9, Hg2);
          }), 128))
        ], 16, mg2),
        t("span", Vg2, I(r.error), 1)
      ]);
    };
  }
};
const XG2 = Zg2, Bg2 = { class: "relative block" }, Fg2 = {
  key: 0,
  class: "block text-sm font-medium text-gray-800 mb-1.5"
}, jg2 = {
  key: 0,
  class: "text-red-500"
}, Ig2 = {
  key: 0,
  class: "text-sm truncate ..."
}, bg2 = {
  key: 1,
  class: "text-gray-400 text-sm truncate ..."
}, yg2 = ["disabled", "placeholder"], Dg2 = { class: "absolute z-10 mt-1 bg-white w-full border border-gray-300 rounded-md shadow-xl max-h-72 overflow-y-auto scroll px-1" }, Pg2 = ["onMousedown"], Ag2 = { class: "text-xs text-red-500" }, Sg2 = { key: 3 }, Tg2 = { class: "text-xs text-red-500" }, QG2 = /* @__PURE__ */ r1({
  __name: "DSelectFieldSearch",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    hint: { default: "" },
    options: { default: () => [] },
    showKey: { default: "name" },
    valueKey: { default: "id" },
    disabled: { type: Boolean, default: !1 },
    error: { default: "" },
    required: { type: Boolean, default: !1 },
    placeholder: { default: "Seleccione" }
  },
  emits: ["update:modelValue", "filter", "focus", "change"],
  setup(r, { emit: e }) {
    const l = r, s = S(!1), h = S(!0), c = S(!1), _ = S(null), C = (g) => {
      e("update:modelValue", g);
    }, d = (g) => e("filter", g), u = () => e("focus"), f = (g) => e("change", g), m = n1(() => {
      var g;
      return ((g = l.options.find((L) => L[l.valueKey] == l.modelValue)) == null ? void 0 : g[l.showKey]) || `${l.placeholder}`;
    }), F = () => {
      l.disabled || (s.value = !0, M());
    }, V = () => {
      s.value = !1, h.value = !0, c.value = !1, d("");
    }, P = (g) => {
      s.value = !1, h.value = !0, c.value = !1, d(""), g[l.valueKey] ? (C(String(g[l.valueKey])), f(String(g[l.valueKey]))) : (C(""), f(""));
    }, M = () => {
      setTimeout(() => {
        _.value.focus();
      }, 1);
    };
    return (g, L) => (n(), o("div", Bg2, [
      g.label ? (n(), o("label", Fg2, [
        Y(I(g.label) + " ", 1),
        g.required ? (n(), o("span", jg2, "*")) : D("", !0)
      ])) : D("", !0),
      s.value ? D("", !0) : (n(), o("label", {
        key: 1,
        class: z(["w-full flex justify-between items-center rounded-md shadow-sm border py-2 px-2 gap-2 cursor-default", [
          g.disabled ? "bg-gray-200 cursor-no-drop " : "bg-white",
          g.error === "" ? "btn-block border-gray-300" : "border-red-500"
        ]]),
        onClick: F
      }, [
        g.options.length > 0 ? (n(), o("span", Ig2, I(`${m.value}`), 1)) : (n(), o("span", bg2, I("Esperando datos..."), 1)),
        g.options.length > 0 ? (n(), Q(U(A2), {
          key: 2,
          class: "ml-2 w-4 h-4 text-black font-black"
        })) : (n(), Q(U(R1), {
          key: 3,
          class: "rotate text-gray-400 w-6 h-6 absolute right-2"
        }))
      ], 2)),
      s.value ? (n(), o("input", {
        key: 2,
        ref_key: "input",
        ref: _,
        class: z(["mt-1 block w-full py-2 px-4 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-600 focus:border-blue-600 sm:text-sm cursor-pointer", [{ error: g.error }, { "bg-gray-300": g.disabled }]]),
        onInput: L[0] || (L[0] = (Z) => d(Z.target.value)),
        onBlur: L[1] || (L[1] = (Z) => V()),
        onFocusout: L[2] || (L[2] = (Z) => u()),
        onChange: L[3] || (L[3] = (Z) => f(Z)),
        disabled: g.disabled,
        placeholder: g.placeholder
      }, null, 42, yg2)) : D("", !0),
      l1(t("ul", Dg2, [
        (n(!0), o(K, null, t1(g.options, (Z, A) => (n(), o("li", {
          class: z(["dropdown-item rounded-md my-1 hover:bg-blue-500 hover:text-white cursor-pointer text-sm px-2 py-1", [Z[g.showKey] === "Seleccione" ? "text-gray-400" : ""]]),
          onMousedown: (b) => P(Z),
          key: A
        }, I(typeof Z == "object" ? Z[g.showKey] : Z), 43, Pg2))), 128))
      ], 512), [
        [b1, s.value]
      ]),
      t("span", Ag2, I(g.error), 1),
      g.hint ? (n(), o("label", Sg2, [
        t("span", Tg2, I(g.hint), 1)
      ])) : D("", !0)
    ]));
  }
}), Og2 = { class: "block text-sm font-medium text-gray-700 mb-1.5" }, Eg2 = {
  key: 0,
  class: "text-red-500"
}, Rg2 = ["placeholder", "value", "disabled", "rows"], Ug2 = {
  key: 0,
  class: "mt-2 text-sm text-gray-500"
}, Ng2 = { class: "text-xs text-red-500" }, JG2 = /* @__PURE__ */ r1({
  __name: "DTextAreaField",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    placeholder: { default: "" },
    hint: { default: "" },
    disabled: { type: Boolean, default: !1 },
    rows: { default: 3 },
    validation: { default: () => ({}) },
    error: { default: "" },
    required: { type: Boolean, default: !1 },
    resize: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "enter"],
  setup(r, { emit: e }) {
    const l = (s) => {
      e("update:modelValue", s.target.value);
    };
    return (s, h) => (n(), o("div", null, [
      t("label", Og2, [
        Y(I(s.label) + " ", 1),
        s.required ? (n(), o("span", Eg2, "*")) : D("", !0)
      ]),
      t("div", null, [
        t("textarea", {
          class: z(["shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-transparent mt-1 block w-full sm:text-sm border rounded-md p-2", [
            s.error ? "border-red-500" : "border-gray-300",
            s.resize ? "resize" : "resize-none",
            { "bg-gray-200": s.disabled }
          ]]),
          type: "text",
          placeholder: s.placeholder,
          value: s.modelValue,
          disabled: s.disabled,
          rows: s.rows,
          onInput: h[0] || (h[0] = (c) => l(c)),
          onKeyup: h[1] || (h[1] = J1((c) => e("enter"), ["enter"]))
        }, null, 42, Rg2)
      ]),
      s.hint ? (n(), o("p", Ug2, I(s.hint), 1)) : D("", !0),
      t("span", Ng2, I(s.error), 1)
    ]));
  }
}), q2 = (r) => (e2("data-v-7fc97006"), r = r(), r2(), r), qg2 = { class: "relative" }, zg2 = ["disabled", "checked"], Kg2 = /* @__PURE__ */ q2(() => /* @__PURE__ */ t("div", { class: "base block bg-gray-200 w-10 h-5 rounded-full" }, null, -1)), Gg2 = /* @__PURE__ */ q2(() => /* @__PURE__ */ t("div", { class: "dot absolute left-1 top-0.5 bg-white w-4 h-4 rounded-full transition" }, null, -1)), Wg2 = { class: "ml-2 text-sm font-medium text-gray-700" }, Yg2 = { key: 0 }, Xg2 = { class: "text-xs text-blue-500" }, Qg2 = /* @__PURE__ */ r1({
  __name: "DToggleField",
  props: {
    modelValue: { type: [Boolean, String], default: !1 },
    disabled: { type: Boolean, default: !1 },
    hidden: { type: Boolean, default: !1 },
    label: { default: "" },
    color: { default: "rgb(37 99 235)" },
    hint: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: e }) {
    D2((s) => ({
      "4350ee09": s.color
    }));
    const l = (s) => {
      e("update:modelValue", s.target.checked);
    };
    return (s, h) => (n(), o("div", null, [
      t("label", {
        class: z(["flex items-center", [s.hidden ? "hidden" : "", s.disabled ? "" : "cursor-pointer"]])
      }, [
        t("div", qg2, [
          t("input", {
            type: "checkbox",
            disabled: s.disabled,
            class: "sr-only",
            checked: !!s.modelValue,
            onValue: h[0] || (h[0] = //@ts-ignore
            (...c) => s.modelValue && s.modelValue(...c)),
            onInput: l
          }, null, 40, zg2),
          Kg2,
          Gg2
        ]),
        t("div", Wg2, I(s.label), 1)
      ], 2),
      s.hint ? (n(), o("label", Yg2, [
        t("span", Xg2, I(s.hint), 1)
      ])) : D("", !0)
    ]));
  }
});
const tW2 = /* @__PURE__ */ i(Qg2, [["__scopeId", "data-v-7fc97006"]]), Jg2 = (r) => (e2("data-v-556b479b"), r = r(), r2(), r), t$2 = { class: "w-auto" }, e$2 = { class: "flex text-sm flex-row justify-between items-center" }, r$2 = ["value"], n$2 = {
  class: "fixed z-50 inset-0 overflow-hidden bg-gray-500 bg-opacity-75 transition-opacity",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}, o$2 = { class: "w-screen h-full flex pt-10 justify-start flex-col items-center relative align-bottom rounded-lg overflow-hidden shadow-2xl transform transition-all px-3" }, i$2 = {
  class: "card overflow-hidden rounded-lg bg-white w-full md:w-2/3 2xl:w-5/12 relative",
  style: { "max-height": "86vh" }
}, l$2 = { class: "content-modal flex flex-col items-center" }, s$2 = { class: "sticky inset-x-0 top-0 w-full h-14 flex items-center justify-between px-4" }, h$2 = { class: "text-base text-center leading-6 font-medium text-gray-500" }, a$2 = {
  class: "w-full overflow-auto scroll",
  style: { height: "calc(100vh - 16rem)" }
}, d$2 = {
  key: 0,
  class: "flex items-center justify-between rounded-md bg-indigo-50 h-8 mt-2 mx-4 px-4"
}, c$2 = { class: "p-2 text-indigo-700 text-sm" }, _$2 = { class: "p-2 text-red-700 font-bold text-sm" }, C$2 = { class: "p-2 text-gray-700 text-sm" }, f$2 = { class: "flex flex-col gap-1 w-full px-4 pt-4" }, v$2 = { class: "relative grid grid-cols-4 gap-2" }, u$2 = { class: "col-span-2" }, w$2 = { class: "flex items-end gap-1" }, p$2 = ["placeholder"], g$2 = {
  key: 0,
  class: "w-full scroll absolute bg-white rounded-md max-h-48 overflow-y-auto border border-gray-300 shadow-xl"
}, $$2 = ["onMousedown"], M$2 = { class: "col-span-2 border-l-2 border-gray-300 pl-2" }, L$2 = { class: "overflow-y-auto scroll h-list" }, k$2 = { class: "w-full flex items-center" }, m$2 = ["value", "onUpdate:modelValue", "onClick"], x$2 = {
  class: "ml-3 font-medium text-gray-700",
  style: { "font-size": "15px" }
}, H$2 = /* @__PURE__ */ Jg2(() => /* @__PURE__ */ t("hr", null, null, -1)), V$2 = { class: "sticky inset-x-0 bottom-0 bg-gray-100 w-full flex justify-center items-center sm:justify-end h-16" }, Z$2 = /* @__PURE__ */ r1({
  __name: "DEmployeesFilter",
  props: {
    headerTitle: { default: "Empleados" },
    modelValue: { default: () => [] },
    placeholder: { default: "Filtro General" },
    label: { default: "Filtrar" },
    items: { default: () => [] },
    showKey: { default: "name" },
    valueKey: { default: "id" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: e }) {
    const l = r, { items: s } = t2(l), h = (x) => {
      e("update:modelValue", x);
    };
    k1(
      () => l.items.length,
      () => {
        l.items.length === 0 && (f.value = []);
      }
    );
    const c = S(!1), _ = [
      {
        name: "Direccion",
        value: "direccion",
        type: "property"
      },
      {
        name: "Gerencia",
        value: "gerencia",
        type: "property"
      },
      {
        name: "Departamento",
        value: "departamento",
        type: "property"
      },
      {
        name: "Sucursal",
        value: "sucursal",
        type: "property"
      },
      {
        name: "Cargo",
        value: "cargo",
        type: "property"
      },
      {
        name: "Turno",
        value: "turno",
        type: "property"
      },
      {
        name: "Registro Patronal",
        value: "registroPatronal",
        type: "property"
      }
    ], C = [
      {
        name: "Igual a",
        value: "=",
        type: "operator"
      },
      {
        name: "Es diferente a",
        value: "<>",
        type: "operator"
      },
      {
        name: "Contiene",
        value: "like",
        type: "operator"
      }
    ], d = S([]), u = S(!1), f = S([]), m = S([
      {
        property: {
          name: "Codigo - Nombre",
          value: "codigo_name",
          type: "property"
        },
        operator: {
          name: "Contiene",
          value: "like",
          type: "operator"
        },
        value: {
          name: "",
          value: "",
          type: "value"
        }
      }
    ]), F = S(""), V = S(""), P = n1(() => d.value.filter((x) => (x.name || "").toLowerCase().includes((F.value || "").toLowerCase()))), M = n1(() => l.items.filter((x) => m.value.filter(
      (y) => {
        var w, p, v;
        return g((w = y.operator) == null ? void 0 : w.value, x[(p = y.property) == null ? void 0 : p.value], (v = y.value) == null ? void 0 : v.value);
      }
    ).length == m.value.length)), g = (x, y, w) => {
      switch (x) {
        case "=":
          return y == w;
        case "<>":
          return y != w;
        case "like":
          return (y || "").toLowerCase().includes((w || "").toLowerCase());
        default:
          return !1;
      }
    }, L = (x) => {
      var y;
      x.type === "property" ? (H(), m.value.push({
        property: x,
        operator: null,
        value: null
      })) : x.type === "operator" ? (H(), m.value[m.value.length - 1].operator = x) : x.type === "value" ? (H(), m.value[m.value.length - 1].value = x, ((y = m.value[m.value.length - 1].operator) == null ? void 0 : y.value) == "like" && (m.value[m.value.length - 1].value.name = F.value, m.value[m.value.length - 1].value.value = F.value)) : (m.value[0].value.name = x, m.value[0].value.value = x), A(x), F.value = "";
    }, Z = (x) => {
      m.value.splice(x, 1), d.value = _;
    }, A = (x) => {
      x.type === "property" ? d.value = C : x.type === "operator" ? d.value = b() : x.type === "value" && (d.value = _);
    }, b = () => {
      const x = m.value[m.value.length - 1].property;
      return Array.from(new Set(l.items.map((w) => w[x.value]))).map((w) => ({
        name: w,
        value: w,
        type: "value"
      }));
    }, E = () => {
      (f.value.length === 0 || l.items.length === l.modelValue.length) && q(), s.value.length > 0 && (c.value = !0);
    }, O = () => {
      c.value = !1;
    }, R = (x) => {
      f.value.indexOf(String(x)) > -1 ? f.value.splice(f.value.indexOf(String(x)), 1) : f.value.push(x.toString());
    }, q = () => {
      let x = M.value;
      x = x.filter((y) => {
        y.isChecked = !0;
      }), f.value = M.value.map(
        (y) => typeof y[l.valueKey] == "number" ? y[l.valueKey].toString() : y[l.valueKey]
      ), h(f.value);
    }, H = () => {
      let x = M.value;
      x = x.filter((y) => {
        y.isChecked = !1;
      }), l.items.forEach((y) => {
        y.isChecked = !1;
      }), f.value = [];
    }, $ = () => {
      c.value = !1, h(f.value);
    };
    return M1(() => {
      d.value = _;
    }), (x, y) => {
      var w, p, v, k, B, T;
      return n(), o(K, null, [
        t("div", t$2, [
          t("a", {
            class: "cursor-pointer text-blue-700 text-xl font-bold",
            onClick: E
          }, [
            t("span", e$2, I(x.label), 1),
            t("input", {
              class: "opacity-0 hidden",
              onClick: E,
              onInput: y[0] || (y[0] = (j) => h(j.target.value)),
              value: x.modelValue
            }, null, 40, r$2)
          ])
        ]),
        l1(t("div", n$2, [
          t("div", o$2, [
            t("div", i$2, [
              t("article", l$2, [
                t("header", s$2, [
                  t("h3", h$2, I(`${x.headerTitle} (${f.value.length}/${U(s).length})`), 1),
                  t("div", null, [
                    W(U(m2), {
                      class: "cursor-pointer h-6 text-gray-500 font-bold",
                      onClick: O
                    })
                  ])
                ]),
                t("div", a$2, [
                  (n(!0), o(K, null, t1(m.value, (j, N) => {
                    var G, X, J;
                    return n(), o("div", {
                      key: N,
                      class: "w-full mt-5",
                      style: { "margin-bottom": "-12px" }
                    }, [
                      N != 0 ? (n(), o("div", d$2, [
                        t("span", c$2, I((G = j.property) == null ? void 0 : G.name), 1),
                        t("span", _$2, I((X = j.operator) == null ? void 0 : X.name), 1),
                        t("span", C$2, I((J = j.value) == null ? void 0 : J.name), 1),
                        W(U(m2), {
                          class: "cursor-pointer h-6 text-gray-500 font-bold hover:text-red-500",
                          onClick: (e1) => Z(N)
                        }, null, 8, ["onClick"])
                      ])) : D("", !0)
                    ]);
                  }), 128)),
                  t("div", f$2, [
                    t("div", v$2, [
                      t("div", u$2, [
                        t("div", w$2, [
                          l1(t("input", {
                            class: "appearance-none mt-1 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-transparent block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md py-2 px-2",
                            "onUpdate:modelValue": y[1] || (y[1] = (j) => F.value = j),
                            placeholder: x.placeholder,
                            type: "text",
                            onFocusin: y[2] || (y[2] = (j) => u.value = !0),
                            onFocusout: y[3] || (y[3] = (j) => u.value = !1)
                          }, null, 40, p$2), [
                            [h2, F.value]
                          ]),
                          ((w = P.value[0]) == null ? void 0 : w.type) !== "property" && (((p = m.value[m.value.length - 1].property) == null ? void 0 : p.value) || "") !== "codigo_name" && (((v = m.value[m.value.length - 1].operator) == null ? void 0 : v.value) || "") === "like" ? (n(), o("button", {
                            key: 0,
                            class: "inline-flex text-sm justify-center items-center px-2 border border-transparent shadow-sm rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 cursor-pointer",
                            style: { height: "38px" },
                            onClick: y[4] || (y[4] = (j) => L({
                              name: F.value,
                              value: F.value,
                              type: "value"
                            }))
                          }, [
                            W(U(UI1), { class: "h-5 w-5" })
                          ])) : D("", !0)
                        ]),
                        u.value && !(((k = P.value[0]) == null ? void 0 : k.type) !== "property" && (((B = m.value[m.value.length - 1].property) == null ? void 0 : B.value) || "") !== "codigo_name" && (((T = m.value[m.value.length - 1].operator) == null ? void 0 : T.value) || "") === "like") ? (n(), o("ul", g$2, [
                          (n(!0), o(K, null, t1(P.value, (j, N) => (n(), o("li", {
                            key: j.id,
                            class: z(["p-2 w-full text-sm text-gray-700 hover:bg-indigo-300", N == 0 ? "bg-indigo-100" : ""]),
                            onMousedown: (G) => L(j)
                          }, I(j.name), 43, $$2))), 128))
                        ])) : D("", !0)
                      ]),
                      t("div", M$2, [
                        l1(t("input", {
                          class: "appearance-none mt-1 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-transparent block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md py-2 px-2",
                          type: "text",
                          "onUpdate:modelValue": y[5] || (y[5] = (j) => V.value = j),
                          placeholder: "Filtro por Codigo y/o Nombre",
                          onInput: y[6] || (y[6] = (j) => L(V.value))
                        }, null, 544), [
                          [h2, V.value]
                        ])
                      ])
                    ]),
                    t("div", { class: "flex justify-between text-sm py-2" }, [
                      t("a", {
                        class: "text-blue-500 font-semibold cursor-pointer underline",
                        onClick: q
                      }, " Seleccionar todo (registros visibles) "),
                      t("a", {
                        class: "text-blue-500 font-semibold cursor-pointer underline",
                        onClick: H
                      }, " Deseleccionar todo ")
                    ]),
                    t("div", null, [
                      t("ul", L$2, [
                        (n(!0), o(K, null, t1(M.value, (j, N) => (n(), o("li", {
                          class: "py-1.5 px-1 flex items-center border-b border-gray-300",
                          key: N
                        }, [
                          t("div", k$2, [
                            l1(t("input", {
                              class: "w-4 h-4",
                              type: "checkbox",
                              value: j[x.valueKey],
                              "onUpdate:modelValue": (G) => j.isChecked = G,
                              onClick: (G) => R(j[x.valueKey])
                            }, null, 8, m$2), [
                              [A1, j.isChecked]
                            ]),
                            t("label", x$2, I(j.codigo) + " - " + I(j[x.showKey]), 1),
                            H$2
                          ])
                        ]))), 128))
                      ])
                    ])
                  ])
                ]),
                t("footer", V$2, [
                  t("div", null, [
                    W(p1, {
                      class: "mx-5",
                      onClick: H1($, ["prevent"])
                    }, {
                      default: a1(() => [
                        Y("Aceptar")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ])
            ])
          ])
        ], 512), [
          [b1, c.value]
        ])
      ], 64);
    };
  }
});
const eW2 = /* @__PURE__ */ i(Z$2, [["__scopeId", "data-v-556b479b"]]), B$2 = {
  key: 0,
  class: "block text-sm font-medium text-gray-800 mb-1.5"
}, F$2 = {
  key: 0,
  class: "text-red-500"
}, j$2 = { class: "relative" }, I$2 = ["placeholder", "disabled", "type", "autocomplete", "maxlength", "minlength", "min", "max", "step", "onKeyup"], b$2 = { key: 3 }, y$2 = { class: "text-xs text-gray-500" }, D$2 = /* @__PURE__ */ t("br", null, null, -1), P$2 = {
  key: 4,
  class: "max-h-80 overflow-auto flex flex-wrap gap-2 py-2"
}, A$2 = {
  key: 5,
  class: "text-xs text-red-500"
}, rW2 = /* @__PURE__ */ r1({
  __name: "DTagsField",
  props: {
    modelValue: { default: () => [] },
    label: { default: "" },
    placeholder: { default: "" },
    hint: { default: "" },
    type: { default: "text" },
    disabled: { type: Boolean, default: !1 },
    hidden: { type: Boolean, default: !1 },
    min: {},
    max: {},
    minlength: {},
    maxlength: {},
    default: { default: "" },
    mask: { default: "" },
    validation: {},
    error: { default: "" },
    step: { default: "any" },
    required: { type: Boolean, default: !1 },
    icon: { default: "" },
    classInput: { default: "" },
    headerTitle: {},
    colorTags: { default: "default" }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: e }) {
    const l = r, s = S(""), h = n1(() => {
      switch (l.colorTags) {
        case "secondary":
          return {
            container: "bg-gray-200 hover:bg-gray-300",
            text: "text-gray-600",
            icon: "text-gray-500"
          };
        case "success":
          return {
            container: "bg-green-100 hover:bg-green-200",
            text: "text-green-600",
            icon: "text-green-500"
          };
        case "warning":
          return {
            container: "bg-orange-100 hover:bg-orange-200",
            text: "text-orange-600",
            icon: "text-orange-500"
          };
        default:
          return {
            container: "bg-red-100 hover:bg-red-200",
            text: "text-red-600",
            icon: "text-red-500"
          };
      }
    }), c = (d) => {
      const u = d.trim();
      if (!u)
        return;
      l.modelValue.some((m) => m === u) || e("update:modelValue", [...l.modelValue, u]);
    }, _ = () => {
      c(s.value), s.value = "";
    }, C = (d) => {
      const u = [...l.modelValue];
      u.splice(d, 1), e("update:modelValue", u);
    };
    return (d, u) => (n(), o("div", {
      class: z(["relative", [d.hidden ? "hidden" : ""]])
    }, [
      d.label ? (n(), o("label", B$2, [
        Y(I(d.label) + " ", 1),
        d.required ? (n(), o("span", F$2, "*")) : D("", !0)
      ])) : D("", !0),
      d.icon ? (n(), Q(U(D1), {
        key: 1,
        name: d.icon,
        class: "text-gray-500 absolute pt-2 pl-2 w-7 h-7"
      }, null, 8, ["name"])) : D("", !0),
      d.type === "color" && typeof d.modelValue == "string" ? (n(), o("span", {
        key: 2,
        class: "absolute pt-2 pl-2 w-7 h-7",
        style: E1({ color: d.modelValue, backgroundColor: d.modelValue })
      }, null, 4)) : D("", !0),
      t("div", j$2, [
        l1(t("input", {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => s.value = f),
          placeholder: d.placeholder,
          disabled: d.disabled,
          type: d.type,
          autocomplete: d.type === "password" ? "on" : "off",
          class: z([[
            d.disabled ? "bg-gray-200 cursor-no-drop" : "bg-white",
            d.icon ? "pl-9" : "pl-2",
            d.error ? "border-red-500" : "border-gray-300",
            d.classInput
          ], "focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-transparent block w-full shadow-sm text-sm border rounded-md py-2 pr-2"]),
          maxlength: d.maxlength,
          minlength: d.minlength,
          min: d.min,
          max: d.max,
          step: d.step,
          onKeyup: J1(_, ["enter"])
        }, null, 42, I$2), [
          [c0, s.value]
        ]),
        t("button", {
          type: "button",
          onClick: _,
          class: "absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-blue-600"
        }, [
          W(U(D1), {
            name: "PlusIcon",
            class: "w-5 h-5"
          })
        ])
      ]),
      d.hint ? (n(), o("label", b$2, [
        t("span", y$2, I(d.hint), 1),
        D$2
      ])) : D("", !0),
      d.modelValue.length ? (n(), o("div", P$2, [
        (n(!0), o(K, null, t1(d.modelValue, (f, m) => (n(), o("div", {
          key: m,
          class: z(["flex flex-row items-center justify-between px-2 py-3 h-5 rounded-xl cursor-default", h.value.container])
        }, [
          t("div", null, [
            t("p", {
              class: z([h.value.text, "text-center tracking-wider text-sm max-w-xs truncate ..."])
            }, I(f), 3)
          ]),
          t("div", null, [
            W(U(D1), {
              name: "XIcon",
              onClick: (F) => C(m),
              class: z([h.value.icon, "w-4 h-4 cursor-pointer"])
            }, null, 8, ["onClick", "class"])
          ])
        ], 2))), 128))
      ])) : D("", !0),
      d.error ? (n(), o("span", A$2, I(d.error), 1)) : D("", !0)
    ], 2));
  }
});
var n2 = function(r) {
  return e2("data-v-a0dc6524"), r = r(), r2(), r;
}, S$2 = { class: "min-w-full table-auto shadow-lg" }, T$2 = {
  class: "bg-gray-200",
  style: { "font-size": "12.5px" }
}, O$2 = {
  key: 0,
  class: "p-3"
}, E$2 = { class: "bg-gray-200 shadow-xl" }, R$2 = { key: 0 }, U$2 = ["value"], N$2 = { class: "px-3 py-1 h-full flex justify-start items-center border-b-2 border-gray-100" }, q$2 = {
  class: "w-full break-words",
  style: { "min-width": "70px" }
}, z$2 = {
  class: "w-full",
  style: { "min-width": "35px" }
}, K$2 = {
  class: "w-full break-words font-semibold",
  style: { "min-width": "77px" }
}, G$2 = {
  class: "w-full",
  style: { "min-width": "35px" }
}, W$2 = {
  class: "w-full",
  style: { "min-width": "70px" }
}, Y$2 = {
  key: 0,
  class: "flex justify-center items-center"
}, X$2 = /* @__PURE__ */ n2(function() {
  return t("p", { class: "text-red-700 text-xs" }, "Errores", -1);
}), Q$2 = { class: "bg-gray-100" }, J$2 = { class: "total-cantidad bg-white h-10" }, tM2 = ["colspan"], eM2 = /* @__PURE__ */ n2(function() {
  return t("div", { class: "flex items-center h-10 px-3" }, "Total Cantidad", -1);
}), rM2 = [
  eM2
], nM2 = { class: "px-3 text-left" }, oM2 = { class: "total-monto bg-white h-10" }, iM2 = ["colspan"], lM2 = /* @__PURE__ */ n2(function() {
  return t("div", { class: "flex items-center h-10 px-3" }, "Total Monto", -1);
}), sM2 = [
  lM2
], hM2 = { class: "px-3 text-left" }, aM2 = {
  key: 1,
  class: "mt-3 font-bold"
}, dM2 = { key: 2 }, cM2 = /* @__PURE__ */ n2(function() {
  return t("h1", { class: "text-center font-bold mt-5 mb-14" }, "No hay datos para mostrar", -1);
}), _M2 = [
  cM2
], CM2 = {
  __name: "DTablePendingProcesses",
  props: {
    columns: Array,
    rows: Array,
    footer: Object,
    selectOptions: { type: Boolean, default: !1 },
    perPageDropdown: Array,
    totalRows: { type: Number, default: 0 }
  },
  emits: ["perPage", "selected", "offset", "changePage"],
  setup: function(r, e) {
    var l = e.expose, s = e.emit, h = r, c = function(R) {
      return s("selected", R);
    }, _ = function(R) {
      return s("perPage", R);
    }, C = function(R) {
      return s("offset", R);
    }, d = function() {
      return s("changePage");
    }, u = S(1), f = S(10), m = S([10, 25, 50, 200]), F = S(0), V = S([]), P = S(!1);
    S(!1);
    var M = n1(function() {
      return np2([], h.rows, !0);
    }), g = n1(function() {
      return u.value == 1 ? u.value - 1 : F.value - f.value;
    }), L = n1(function() {
      return h.rows.length < f.value ? F.value - f.value + h.rows.length : F.value;
    }), Z = n1(function() {
      return h.columns.slice(2, h.columns.length);
    }), A = function() {
      if (V.value = [], !P.value)
        for (var R in h.rows)
          V.value.push(String(h.rows[R].id));
      c(V.value);
    }, b = function() {
      h.rows.length != V.value.length ? P.value = !1 : P.value = !0, c(V.value);
    }, E = function() {
      F.value = 0, u.value = 1, O();
    };
    l({ resetData: E });
    var O = function() {
      F.value = u.value * f.value, C(F.value - f.value);
    };
    return M1(function() {
      _(f.value), O();
    }), function(R, q) {
      return n(), o(K, null, [
        r.rows.length != 0 ? (n(), o("div", {
          key: 0,
          id: "tableFix",
          style: { "scroll-behavior": "smooth" },
          class: z([[r.selectOptions ? "checkOn" : "checkOff"], "tableFix showInfo relative overflow-x-auto rounded-lg border-1 border-gray-600 scroll-gray text-sm"])
        }, [
          t("table", S$2, [
            t("thead", null, [
              t("tr", T$2, [
                r.selectOptions ? (n(), o("th", O$2, [
                  l1(t("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": q[0] || (q[0] = function(H) {
                      return P.value = H;
                    }),
                    onClick: A,
                    onChange: b
                  }, null, 544), [
                    [A1, P.value]
                  ])
                ])) : D("", !0),
                (n(!0), o(K, null, t1(r.columns, function(H, $) {
                  return n(), o("th", {
                    key: $,
                    class: z([[H.table != null ? "cursor-pointer" : ""], "p-0"]),
                    style: E1("background-color:" + H.backgroundColor)
                  }, [
                    t("div", {
                      class: z(["flex items-center justify-start text-gray-600 px-3 py-2 hover:text-black text-left", [
                        $ == 0 ? "w-24" : $ == 1 || $ == r.columns.length - 1 || $ == r.columns.length - 2 || $ == r.columns.length - 3 ? "w-40" : ""
                      ]]),
                      style: { "min-height": "52px", "line-height": "16px" }
                    }, I($ == 0 || $ == 1 || $ == r.columns.length - 1 || $ == r.columns.length - 2 || $ == r.columns.length - 3 ? H.value : H.key + " - " + H.value), 3)
                  ], 6);
                }), 128))
              ])
            ]),
            t("tbody", E$2, [
              (n(!0), o(K, null, t1(M.value, function(H, $) {
                return n(), o("tr", {
                  key: $,
                  class: "bg-white hover:bg-gray-100 h-12"
                }, [
                  r.selectOptions ? (n(), o("td", R$2, [
                    l1(t("input", {
                      class: "h-full w-full",
                      type: "checkbox",
                      value: String(H.id),
                      "onUpdate:modelValue": q[1] || (q[1] = function(x) {
                        return V.value = x;
                      }),
                      onChange: b
                    }, null, 40, U$2), [
                      [A1, V.value]
                    ])
                  ])) : D("", !0),
                  (n(!0), o(K, null, t1(r.columns, function(x, y) {
                    var w, p, v, k, B;
                    return n(), o("td", {
                      class: "p-0 h-inherit",
                      key: y
                    }, [
                      t("div", N$2, [
                        y == 0 ? (n(), o(K, { key: 0 }, [
                          Y(I(H.employeeCode), 1)
                        ], 64)) : y == 1 ? (n(), o(K, { key: 1 }, [
                          Y(I(H.employeeName) + " ", 1),
                          t("div", null, [
                            W(U(K1), {
                              title: "Formula",
                              formula: "gfdg dfgdfg dfgdfg dfgdfg"
                            })
                          ])
                        ], 64)) : y == r.columns.length - 3 ? (n(), o(K, { key: 2 }, [
                          Y(I(H.totalAsign), 1)
                        ], 64)) : y == r.columns.length - 2 ? (n(), o(K, { key: 3 }, [
                          Y(I(H.totalDed), 1)
                        ], 64)) : y == r.columns.length - 1 ? (n(), o(K, { key: 4 }, [
                          Y(I(H.totalExpense), 1)
                        ], 64)) : (n(), o(K, { key: 5 }, [
                          t("div", q$2, I((w = H[x.key]) === null || w === void 0 ? void 0 : w.quantity), 1),
                          t("div", z$2, [
                            !((p = H[x.key]) === null || p === void 0) && p.evalQauntity ? (n(), Q(U(K1), {
                              key: 0,
                              td: $ + "" + y + 1,
                              title: "Formula",
                              formula: H[x.key].evalQauntity
                            }, null, 8, ["td", "formula"])) : D("", !0)
                          ]),
                          t("div", K$2, I((v = H[x.key]) === null || v === void 0 ? void 0 : v.amount), 1),
                          t("div", G$2, [
                            !((k = H[x.key]) === null || k === void 0) && k.evalAmount ? (n(), Q(U(K1), {
                              key: 0,
                              td: $ + "" + y + 2,
                              title: "Formula",
                              formula: H[x.key].evalAmount
                            }, null, 8, ["td", "formula"])) : D("", !0)
                          ]),
                          t("div", W$2, [
                            !((B = H[x.key]) === null || B === void 0) && B.errors ? (n(), o(K, { key: 0 }, [
                              H[x.key].errors.length != 0 ? (n(), o("div", Y$2, [
                                W(U(K1), {
                                  icon: "error",
                                  title: "Errores",
                                  td: $ + "" + y + 3,
                                  errors: H[x.key].errors
                                }, null, 8, ["td", "errors"]),
                                X$2
                              ])) : D("", !0)
                            ], 64)) : D("", !0)
                          ])
                        ], 64))
                      ])
                    ]);
                  }), 128))
                ]);
              }), 128))
            ]),
            t("tfoot", Q$2, [
              t("tr", J$2, [
                t("th", {
                  class: "p-0",
                  colspan: r.selectOptions ? 3 : 2
                }, rM2, 8, tM2),
                (n(!0), o(K, null, t1(Z.value, function(H) {
                  return n(), o("th", { key: H }, [
                    t("div", nM2, I(r.footer[H.key].totalCant), 1)
                  ]);
                }), 128))
              ]),
              t("tr", oM2, [
                t("th", {
                  class: "p-0",
                  colspan: r.selectOptions ? 3 : 2
                }, sM2, 8, iM2),
                (n(!0), o(K, null, t1(Z.value, function(H) {
                  return n(), o("th", { key: H }, [
                    t("div", hM2, I(r.footer[H.key].totalAmount), 1)
                  ]);
                }), 128))
              ])
            ])
          ])
        ], 2)) : D("", !0),
        r.rows.length != 0 ? (n(), o("div", aM2, [
          W(T2, {
            "per-page": f.value,
            "total-rows": r.totalRows,
            "start-row": g.value,
            "end-row": L.value,
            "per-page-dropdown": m.value,
            onCurrentPage: q[2] || (q[2] = function(H) {
              return u.value = H;
            }),
            "current-page": u.value,
            onPerPage: q[3] || (q[3] = function(H) {
              return f.value = H;
            }),
            onChange: q[4] || (q[4] = function(H) {
              return O(), d(), _(f.value);
            })
          }, null, 8, ["per-page", "total-rows", "start-row", "end-row", "per-page-dropdown", "current-page"])
        ])) : D("", !0),
        r.rows.length == 0 ? (n(), o("div", dM2, _M2)) : D("", !0)
      ], 64);
    };
  }
};
const nW2 = /* @__PURE__ */ i(CM2, [["__scopeId", "data-v-a0dc6524"]]), fM2 = { class: "tabs__content" }, oW2 = /* @__PURE__ */ r1({
  __name: "DTab",
  props: {
    title: String,
    selectedTitle: String
  },
  setup(r) {
    return (e, l) => l1((n(), o("div", fM2, [
      s1(e.$slots, "default")
    ], 512)), [
      [b1, r.title == r.selectedTitle]
    ]);
  }
}), vM2 = { class: "h-full flex flex-row overflow-auto px-4 scroll" }, uM2 = ["onClick"], wM2 = /* @__PURE__ */ r1({
  __name: "DTabs",
  props: {
    heightFormModal: { type: Boolean, default: !1 }
  },
  setup(r) {
    const e = P2(), l = S(""), s = S([]), h = () => {
      var _, C, d;
      const c = Number(e.default()[0].children.length) > 0 ? (C = (_ = e.default()) == null ? void 0 : _[0]) == null ? void 0 : C.children : e.default();
      l.value = ((d = c == null ? void 0 : c[0].props) == null ? void 0 : d.title) ?? "", s.value = [...c].map((u) => {
        var f, m;
        return {
          title: (f = u == null ? void 0 : u.props) == null ? void 0 : f.title,
          isActive: (m = u == null ? void 0 : u.props) == null ? void 0 : m.isActive
        };
      });
    };
    return M1(() => {
      h();
    }), (c, _) => (n(), o("div", null, [
      t("div", null, [
        t("ul", vM2, [
          (n(!0), o(K, null, t1(s.value, (C) => (n(), o("li", {
            key: C.title,
            class: z([
              "w-min text-base font-semibold tracking-normal p-3 text-center cursor-pointer break-words whitespace-nowrap overflow-hidden",
              l.value === C.title ? "border-b-2 border-blue-600 text-blue-600 " : "text-gray-400 border-b-2 border-gray-200"
            ]),
            onClick: (d) => l.value = C.title
          }, I(C.title), 11, uM2))), 128))
        ])
      ]),
      t("div", {
        class: z([[c.heightFormModal ? "content-modal" : "content"], "shadow-md rounded-b-none scroll rounded-md overflow-y-auto w-full bg-white pt-1.5"])
      }, [
        s1(c.$slots, "default", { selectedTitle: l.value }, void 0, !0)
      ], 2)
    ]));
  }
});
const iW2 = /* @__PURE__ */ i(wM2, [["__scopeId", "data-v-de5b92de"]]);
function a2(r, e, l) {
  var s, h, c, _, C;
  e == null && (e = 100);
  function d() {
    var f = Date.now() - _;
    f < e && f >= 0 ? s = setTimeout(d, e - f) : (s = null, l || (C = r.apply(c, h), c = h = null));
  }
  var u = function() {
    c = this, h = arguments, _ = Date.now();
    var f = l && !s;
    return s || (s = setTimeout(d, e)), f && (C = r.apply(c, h), c = h = null), C;
  };
  return u.clear = function() {
    s && (clearTimeout(s), s = null);
  }, u.flush = function() {
    s && (C = r.apply(c, h), c = h = null, clearTimeout(s), s = null);
  }, u;
}
a2.debounce = a2;
var i2 = a2;
function pM2(r, e, l) {
  v0(r) ? k1(r, (s, h) => {
    h == null || h.removeEventListener(e, l), s == null || s.addEventListener(e, l);
  }) : M1(() => {
    r.addEventListener(e, l);
  }), c2(() => {
    var s;
    (s = U(r)) === null || s === void 0 || s.removeEventListener(e, l);
  });
}
function gM2(r, e) {
  const l = "pointerdown";
  return typeof window > "u" || !window ? void 0 : pM2(window, l, (h) => {
    const c = U(r);
    c && (c === h.target || h.composedPath().includes(c) || e(h));
  });
}
function $M2(r, e, l) {
  let s = null;
  const h = S(!1);
  M1(() => {
    (r.content !== void 0 || l.value) && (h.value = !0), s = new MutationObserver(c), s.observe(e.value, {
      childList: !0,
      subtree: !0
    });
  }), c2(() => s.disconnect()), k1(l, (_) => {
    _ ? h.value = !0 : h.value = !1;
  });
  const c = () => {
    r.content ? h.value = !0 : h.value = !1;
  };
  return {
    hasContent: h
  };
}
function F1(r, e) {
  var l = r.getBoundingClientRect(), s = 1, h = 1;
  return {
    width: l.width / s,
    height: l.height / h,
    top: l.top / h,
    right: l.right / s,
    bottom: l.bottom / h,
    left: l.left / s,
    x: l.left / s,
    y: l.top / h
  };
}
function w1(r) {
  if (r == null)
    return window;
  if (r.toString() !== "[object Window]") {
    var e = r.ownerDocument;
    return e && e.defaultView || window;
  }
  return r;
}
function _2(r) {
  var e = w1(r), l = e.pageXOffset, s = e.pageYOffset;
  return {
    scrollLeft: l,
    scrollTop: s
  };
}
function S1(r) {
  var e = w1(r).Element;
  return r instanceof e || r instanceof Element;
}
function c1(r) {
  var e = w1(r).HTMLElement;
  return r instanceof e || r instanceof HTMLElement;
}
function z2(r) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = w1(r).ShadowRoot;
  return r instanceof e || r instanceof ShadowRoot;
}
function MM2(r) {
  return {
    scrollLeft: r.scrollLeft,
    scrollTop: r.scrollTop
  };
}
function LM2(r) {
  return r === w1(r) || !c1(r) ? _2(r) : MM2(r);
}
function $1(r) {
  return r ? (r.nodeName || "").toLowerCase() : null;
}
function Z1(r) {
  return ((S1(r) ? r.ownerDocument : (
    // $FlowFixMe[prop-missing]
    r.document
  )) || window.document).documentElement;
}
function C2(r) {
  return F1(Z1(r)).left + _2(r).scrollLeft;
}
function m1(r) {
  return w1(r).getComputedStyle(r);
}
function f2(r) {
  var e = m1(r), l = e.overflow, s = e.overflowX, h = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(l + h + s);
}
function kM2(r) {
  var e = r.getBoundingClientRect(), l = e.width / r.offsetWidth || 1, s = e.height / r.offsetHeight || 1;
  return l !== 1 || s !== 1;
}
function mM2(r, e, l) {
  l === void 0 && (l = !1);
  var s = c1(e);
  c1(e) && kM2(e);
  var h = Z1(e), c = F1(r), _ = {
    scrollLeft: 0,
    scrollTop: 0
  }, C = {
    x: 0,
    y: 0
  };
  return (s || !s && !l) && (($1(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  f2(h)) && (_ = LM2(e)), c1(e) ? (C = F1(e), C.x += e.clientLeft, C.y += e.clientTop) : h && (C.x = C2(h))), {
    x: c.left + _.scrollLeft - C.x,
    y: c.top + _.scrollTop - C.y,
    width: c.width,
    height: c.height
  };
}
function v2(r) {
  var e = F1(r), l = r.offsetWidth, s = r.offsetHeight;
  return Math.abs(e.width - l) <= 1 && (l = e.width), Math.abs(e.height - s) <= 1 && (s = e.height), {
    x: r.offsetLeft,
    y: r.offsetTop,
    width: l,
    height: s
  };
}
function o2(r) {
  return $1(r) === "html" ? r : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    r.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    r.parentNode || // DOM Element detected
    (z2(r) ? r.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Z1(r)
  );
}
function K2(r) {
  return ["html", "body", "#document"].indexOf($1(r)) >= 0 ? r.ownerDocument.body : c1(r) && f2(r) ? r : K2(o2(r));
}
function P1(r, e) {
  var l;
  e === void 0 && (e = []);
  var s = K2(r), h = s === ((l = r.ownerDocument) == null ? void 0 : l.body), c = w1(s), _ = h ? [c].concat(c.visualViewport || [], f2(s) ? s : []) : s, C = e.concat(_);
  return h ? C : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    C.concat(P1(o2(_)))
  );
}
function xM2(r) {
  return ["table", "td", "th"].indexOf($1(r)) >= 0;
}
function H2(r) {
  return !c1(r) || // https://github.com/popperjs/popper-core/issues/837
  m1(r).position === "fixed" ? null : r.offsetParent;
}
function HM2(r) {
  var e = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, l = navigator.userAgent.indexOf("Trident") !== -1;
  if (l && c1(r)) {
    var s = m1(r);
    if (s.position === "fixed")
      return null;
  }
  for (var h = o2(r); c1(h) && ["html", "body"].indexOf($1(h)) < 0; ) {
    var c = m1(h);
    if (c.transform !== "none" || c.perspective !== "none" || c.contain === "paint" || ["transform", "perspective"].indexOf(c.willChange) !== -1 || e && c.willChange === "filter" || e && c.filter && c.filter !== "none")
      return h;
    h = h.parentNode;
  }
  return null;
}
function U1(r) {
  for (var e = w1(r), l = H2(r); l && xM2(l) && m1(l).position === "static"; )
    l = H2(l);
  return l && ($1(l) === "html" || $1(l) === "body" && m1(l).position === "static") ? e : l || HM2(r) || e;
}
var _1 = "top", v1 = "bottom", u1 = "right", C1 = "left", u2 = "auto", N1 = [_1, v1, u1, C1], j1 = "start", T1 = "end", VM2 = "clippingParents", G2 = "viewport", y1 = "popper", ZM2 = "reference", V2 = /* @__PURE__ */ N1.reduce(function(r, e) {
  return r.concat([e + "-" + j1, e + "-" + T1]);
}, []), W2 = /* @__PURE__ */ [].concat(N1, [u2]).reduce(function(r, e) {
  return r.concat([e, e + "-" + j1, e + "-" + T1]);
}, []), BM2 = "beforeRead", FM2 = "read", jM2 = "afterRead", IM2 = "beforeMain", bM2 = "main", yM2 = "afterMain", DM2 = "beforeWrite", PM2 = "write", AM2 = "afterWrite", SM2 = [BM2, FM2, jM2, IM2, bM2, yM2, DM2, PM2, AM2];
function TM2(r) {
  var e = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Set(), s = [];
  r.forEach(function(c) {
    e.set(c.name, c);
  });
  function h(c) {
    l.add(c.name);
    var _ = [].concat(c.requires || [], c.requiresIfExists || []);
    _.forEach(function(C) {
      if (!l.has(C)) {
        var d = e.get(C);
        d && h(d);
      }
    }), s.push(c);
  }
  return r.forEach(function(c) {
    l.has(c.name) || h(c);
  }), s;
}
function OM2(r) {
  var e = TM2(r);
  return SM2.reduce(function(l, s) {
    return l.concat(e.filter(function(h) {
      return h.phase === s;
    }));
  }, []);
}
function EM2(r) {
  var e;
  return function() {
    return e || (e = new Promise(function(l) {
      Promise.resolve().then(function() {
        e = void 0, l(r());
      });
    })), e;
  };
}
function g1(r) {
  return r.split("-")[0];
}
function RM2(r) {
  var e = r.reduce(function(l, s) {
    var h = l[s.name];
    return l[s.name] = h ? Object.assign({}, h, s, {
      options: Object.assign({}, h.options, s.options),
      data: Object.assign({}, h.data, s.data)
    }) : s, l;
  }, {});
  return Object.keys(e).map(function(l) {
    return e[l];
  });
}
function UM2(r) {
  var e = w1(r), l = Z1(r), s = e.visualViewport, h = l.clientWidth, c = l.clientHeight, _ = 0, C = 0;
  return s && (h = s.width, c = s.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (_ = s.offsetLeft, C = s.offsetTop)), {
    width: h,
    height: c,
    x: _ + C2(r),
    y: C
  };
}
var V1 = Math.max, O1 = Math.min, G1 = Math.round;
function NM2(r) {
  var e, l = Z1(r), s = _2(r), h = (e = r.ownerDocument) == null ? void 0 : e.body, c = V1(l.scrollWidth, l.clientWidth, h ? h.scrollWidth : 0, h ? h.clientWidth : 0), _ = V1(l.scrollHeight, l.clientHeight, h ? h.scrollHeight : 0, h ? h.clientHeight : 0), C = -s.scrollLeft + C2(r), d = -s.scrollTop;
  return m1(h || l).direction === "rtl" && (C += V1(l.clientWidth, h ? h.clientWidth : 0) - c), {
    width: c,
    height: _,
    x: C,
    y: d
  };
}
function Y2(r, e) {
  var l = e.getRootNode && e.getRootNode();
  if (r.contains(e))
    return !0;
  if (l && z2(l)) {
    var s = e;
    do {
      if (s && r.isSameNode(s))
        return !0;
      s = s.parentNode || s.host;
    } while (s);
  }
  return !1;
}
function d2(r) {
  return Object.assign({}, r, {
    left: r.x,
    top: r.y,
    right: r.x + r.width,
    bottom: r.y + r.height
  });
}
function qM2(r) {
  var e = F1(r);
  return e.top = e.top + r.clientTop, e.left = e.left + r.clientLeft, e.bottom = e.top + r.clientHeight, e.right = e.left + r.clientWidth, e.width = r.clientWidth, e.height = r.clientHeight, e.x = e.left, e.y = e.top, e;
}
function Z2(r, e) {
  return e === G2 ? d2(UM2(r)) : c1(e) ? qM2(e) : d2(NM2(Z1(r)));
}
function zM2(r) {
  var e = P1(o2(r)), l = ["absolute", "fixed"].indexOf(m1(r).position) >= 0, s = l && c1(r) ? U1(r) : r;
  return S1(s) ? e.filter(function(h) {
    return S1(h) && Y2(h, s) && $1(h) !== "body";
  }) : [];
}
function KM2(r, e, l) {
  var s = e === "clippingParents" ? zM2(r) : [].concat(e), h = [].concat(s, [l]), c = h[0], _ = h.reduce(function(C, d) {
    var u = Z2(r, d);
    return C.top = V1(u.top, C.top), C.right = O1(u.right, C.right), C.bottom = O1(u.bottom, C.bottom), C.left = V1(u.left, C.left), C;
  }, Z2(r, c));
  return _.width = _.right - _.left, _.height = _.bottom - _.top, _.x = _.left, _.y = _.top, _;
}
function I1(r) {
  return r.split("-")[1];
}
function w2(r) {
  return ["top", "bottom"].indexOf(r) >= 0 ? "x" : "y";
}
function X2(r) {
  var e = r.reference, l = r.element, s = r.placement, h = s ? g1(s) : null, c = s ? I1(s) : null, _ = e.x + e.width / 2 - l.width / 2, C = e.y + e.height / 2 - l.height / 2, d;
  switch (h) {
    case _1:
      d = {
        x: _,
        y: e.y - l.height
      };
      break;
    case v1:
      d = {
        x: _,
        y: e.y + e.height
      };
      break;
    case u1:
      d = {
        x: e.x + e.width,
        y: C
      };
      break;
    case C1:
      d = {
        x: e.x - l.width,
        y: C
      };
      break;
    default:
      d = {
        x: e.x,
        y: e.y
      };
  }
  var u = h ? w2(h) : null;
  if (u != null) {
    var f = u === "y" ? "height" : "width";
    switch (c) {
      case j1:
        d[u] = d[u] - (e[f] / 2 - l[f] / 2);
        break;
      case T1:
        d[u] = d[u] + (e[f] / 2 - l[f] / 2);
        break;
    }
  }
  return d;
}
function Q2() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function J2(r) {
  return Object.assign({}, Q2(), r);
}
function t0(r, e) {
  return e.reduce(function(l, s) {
    return l[s] = r, l;
  }, {});
}
function p2(r, e) {
  e === void 0 && (e = {});
  var l = e, s = l.placement, h = s === void 0 ? r.placement : s, c = l.boundary, _ = c === void 0 ? VM2 : c, C = l.rootBoundary, d = C === void 0 ? G2 : C, u = l.elementContext, f = u === void 0 ? y1 : u, m = l.altBoundary, F = m === void 0 ? !1 : m, V = l.padding, P = V === void 0 ? 0 : V, M = J2(typeof P != "number" ? P : t0(P, N1)), g = f === y1 ? ZM2 : y1, L = r.rects.popper, Z = r.elements[F ? g : f], A = KM2(S1(Z) ? Z : Z.contextElement || Z1(r.elements.popper), _, d), b = F1(r.elements.reference), E = X2({
    reference: b,
    element: L,
    strategy: "absolute",
    placement: h
  }), O = d2(Object.assign({}, L, E)), R = f === y1 ? O : b, q = {
    top: A.top - R.top + M.top,
    bottom: R.bottom - A.bottom + M.bottom,
    left: A.left - R.left + M.left,
    right: R.right - A.right + M.right
  }, H = r.modifiersData.offset;
  if (f === y1 && H) {
    var $ = H[h];
    Object.keys(q).forEach(function(x) {
      var y = [u1, v1].indexOf(x) >= 0 ? 1 : -1, w = [_1, v1].indexOf(x) >= 0 ? "y" : "x";
      q[x] += $[w] * y;
    });
  }
  return q;
}
var B2 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function F2() {
  for (var r = arguments.length, e = new Array(r), l = 0; l < r; l++)
    e[l] = arguments[l];
  return !e.some(function(s) {
    return !(s && typeof s.getBoundingClientRect == "function");
  });
}
function GM2(r) {
  r === void 0 && (r = {});
  var e = r, l = e.defaultModifiers, s = l === void 0 ? [] : l, h = e.defaultOptions, c = h === void 0 ? B2 : h;
  return function(C, d, u) {
    u === void 0 && (u = c);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, B2, c),
      modifiersData: {},
      elements: {
        reference: C,
        popper: d
      },
      attributes: {},
      styles: {}
    }, m = [], F = !1, V = {
      state: f,
      setOptions: function(L) {
        var Z = typeof L == "function" ? L(f.options) : L;
        M(), f.options = Object.assign({}, c, f.options, Z), f.scrollParents = {
          reference: S1(C) ? P1(C) : C.contextElement ? P1(C.contextElement) : [],
          popper: P1(d)
        };
        var A = OM2(RM2([].concat(s, f.options.modifiers)));
        return f.orderedModifiers = A.filter(function(b) {
          return b.enabled;
        }), P(), V.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!F) {
          var L = f.elements, Z = L.reference, A = L.popper;
          if (F2(Z, A)) {
            f.rects = {
              reference: mM2(Z, U1(A), f.options.strategy === "fixed"),
              popper: v2(A)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function($) {
              return f.modifiersData[$.name] = Object.assign({}, $.data);
            });
            for (var b = 0; b < f.orderedModifiers.length; b++) {
              if (f.reset === !0) {
                f.reset = !1, b = -1;
                continue;
              }
              var E = f.orderedModifiers[b], O = E.fn, R = E.options, q = R === void 0 ? {} : R, H = E.name;
              typeof O == "function" && (f = O({
                state: f,
                options: q,
                name: H,
                instance: V
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: EM2(function() {
        return new Promise(function(g) {
          V.forceUpdate(), g(f);
        });
      }),
      destroy: function() {
        M(), F = !0;
      }
    };
    if (!F2(C, d))
      return V;
    V.setOptions(u).then(function(g) {
      !F && u.onFirstUpdate && u.onFirstUpdate(g);
    });
    function P() {
      f.orderedModifiers.forEach(function(g) {
        var L = g.name, Z = g.options, A = Z === void 0 ? {} : Z, b = g.effect;
        if (typeof b == "function") {
          var E = b({
            state: f,
            name: L,
            instance: V,
            options: A
          }), O = function() {
          };
          m.push(E || O);
        }
      });
    }
    function M() {
      m.forEach(function(g) {
        return g();
      }), m = [];
    }
    return V;
  };
}
var W1 = {
  passive: !0
};
function WM2(r) {
  var e = r.state, l = r.instance, s = r.options, h = s.scroll, c = h === void 0 ? !0 : h, _ = s.resize, C = _ === void 0 ? !0 : _, d = w1(e.elements.popper), u = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return c && u.forEach(function(f) {
    f.addEventListener("scroll", l.update, W1);
  }), C && d.addEventListener("resize", l.update, W1), function() {
    c && u.forEach(function(f) {
      f.removeEventListener("scroll", l.update, W1);
    }), C && d.removeEventListener("resize", l.update, W1);
  };
}
var YM2 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: WM2,
  data: {}
};
function XM2(r) {
  var e = r.state, l = r.name;
  e.modifiersData[l] = X2({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
var QM2 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: XM2,
  data: {}
}, JM2 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function tL2(r) {
  var e = r.x, l = r.y, s = window, h = s.devicePixelRatio || 1;
  return {
    x: G1(G1(e * h) / h) || 0,
    y: G1(G1(l * h) / h) || 0
  };
}
function j2(r) {
  var e, l = r.popper, s = r.popperRect, h = r.placement, c = r.variation, _ = r.offsets, C = r.position, d = r.gpuAcceleration, u = r.adaptive, f = r.roundOffsets, m = f === !0 ? tL2(_) : typeof f == "function" ? f(_) : _, F = m.x, V = F === void 0 ? 0 : F, P = m.y, M = P === void 0 ? 0 : P, g = _.hasOwnProperty("x"), L = _.hasOwnProperty("y"), Z = C1, A = _1, b = window;
  if (u) {
    var E = U1(l), O = "clientHeight", R = "clientWidth";
    E === w1(l) && (E = Z1(l), m1(E).position !== "static" && C === "absolute" && (O = "scrollHeight", R = "scrollWidth")), E = E, (h === _1 || (h === C1 || h === u1) && c === T1) && (A = v1, M -= E[O] - s.height, M *= d ? 1 : -1), (h === C1 || (h === _1 || h === v1) && c === T1) && (Z = u1, V -= E[R] - s.width, V *= d ? 1 : -1);
  }
  var q = Object.assign({
    position: C
  }, u && JM2);
  if (d) {
    var H;
    return Object.assign({}, q, (H = {}, H[A] = L ? "0" : "", H[Z] = g ? "0" : "", H.transform = (b.devicePixelRatio || 1) <= 1 ? "translate(" + V + "px, " + M + "px)" : "translate3d(" + V + "px, " + M + "px, 0)", H));
  }
  return Object.assign({}, q, (e = {}, e[A] = L ? M + "px" : "", e[Z] = g ? V + "px" : "", e.transform = "", e));
}
function eL2(r) {
  var e = r.state, l = r.options, s = l.gpuAcceleration, h = s === void 0 ? !0 : s, c = l.adaptive, _ = c === void 0 ? !0 : c, C = l.roundOffsets, d = C === void 0 ? !0 : C, u = {
    placement: g1(e.placement),
    variation: I1(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: h
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, j2(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: _,
    roundOffsets: d
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, j2(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: d
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
var rL2 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: eL2,
  data: {}
};
function nL2(r) {
  var e = r.state;
  Object.keys(e.elements).forEach(function(l) {
    var s = e.styles[l] || {}, h = e.attributes[l] || {}, c = e.elements[l];
    !c1(c) || !$1(c) || (Object.assign(c.style, s), Object.keys(h).forEach(function(_) {
      var C = h[_];
      C === !1 ? c.removeAttribute(_) : c.setAttribute(_, C === !0 ? "" : C);
    }));
  });
}
function oL2(r) {
  var e = r.state, l = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, l.popper), e.styles = l, e.elements.arrow && Object.assign(e.elements.arrow.style, l.arrow), function() {
    Object.keys(e.elements).forEach(function(s) {
      var h = e.elements[s], c = e.attributes[s] || {}, _ = Object.keys(e.styles.hasOwnProperty(s) ? e.styles[s] : l[s]), C = _.reduce(function(d, u) {
        return d[u] = "", d;
      }, {});
      !c1(h) || !$1(h) || (Object.assign(h.style, C), Object.keys(c).forEach(function(d) {
        h.removeAttribute(d);
      }));
    });
  };
}
var iL2 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: nL2,
  effect: oL2,
  requires: ["computeStyles"]
}, lL2 = [YM2, QM2, rL2, iL2], sL2 = /* @__PURE__ */ GM2({
  defaultModifiers: lL2
});
function hL2(r) {
  return r === "x" ? "y" : "x";
}
function Y1(r, e, l) {
  return V1(r, O1(e, l));
}
function aL2(r) {
  var e = r.state, l = r.options, s = r.name, h = l.mainAxis, c = h === void 0 ? !0 : h, _ = l.altAxis, C = _ === void 0 ? !1 : _, d = l.boundary, u = l.rootBoundary, f = l.altBoundary, m = l.padding, F = l.tether, V = F === void 0 ? !0 : F, P = l.tetherOffset, M = P === void 0 ? 0 : P, g = p2(e, {
    boundary: d,
    rootBoundary: u,
    padding: m,
    altBoundary: f
  }), L = g1(e.placement), Z = I1(e.placement), A = !Z, b = w2(L), E = hL2(b), O = e.modifiersData.popperOffsets, R = e.rects.reference, q = e.rects.popper, H = typeof M == "function" ? M(Object.assign({}, e.rects, {
    placement: e.placement
  })) : M, $ = {
    x: 0,
    y: 0
  };
  if (O) {
    if (c || C) {
      var x = b === "y" ? _1 : C1, y = b === "y" ? v1 : u1, w = b === "y" ? "height" : "width", p = O[b], v = O[b] + g[x], k = O[b] - g[y], B = V ? -q[w] / 2 : 0, T = Z === j1 ? R[w] : q[w], j = Z === j1 ? -q[w] : -R[w], N = e.elements.arrow, G = V && N ? v2(N) : {
        width: 0,
        height: 0
      }, X = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Q2(), J = X[x], e1 = X[y], i1 = Y1(0, R[w], G[w]), d1 = A ? R[w] / 2 - B - i1 - J - H : T - i1 - J - H, L1 = A ? -R[w] / 2 + B + i1 + e1 + H : j + i1 + e1 + H, h1 = e.elements.arrow && U1(e.elements.arrow), o1 = h1 ? b === "y" ? h1.clientTop || 0 : h1.clientLeft || 0 : 0, f1 = e.modifiersData.offset ? e.modifiersData.offset[e.placement][b] : 0, x1 = O[b] + d1 - f1 - o1, B1 = O[b] + L1 - f1;
      if (c) {
        var $2 = Y1(V ? O1(v, x1) : v, p, V ? V1(k, B1) : k);
        O[b] = $2, $[b] = $2 - p;
      }
      if (C) {
        var n0 = b === "x" ? _1 : C1, o0 = b === "x" ? v1 : u1, q1 = O[E], M2 = q1 + g[n0], L2 = q1 - g[o0], k2 = Y1(V ? O1(M2, x1) : M2, q1, V ? V1(L2, B1) : L2);
        O[E] = k2, $[E] = k2 - q1;
      }
    }
    e.modifiersData[s] = $;
  }
}
var dL2 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: aL2,
  requiresIfExists: ["offset"]
}, cL2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function X1(r) {
  return r.replace(/left|right|bottom|top/g, function(e) {
    return cL2[e];
  });
}
var _L2 = {
  start: "end",
  end: "start"
};
function I2(r) {
  return r.replace(/start|end/g, function(e) {
    return _L2[e];
  });
}
function CL2(r, e) {
  e === void 0 && (e = {});
  var l = e, s = l.placement, h = l.boundary, c = l.rootBoundary, _ = l.padding, C = l.flipVariations, d = l.allowedAutoPlacements, u = d === void 0 ? W2 : d, f = I1(s), m = f ? C ? V2 : V2.filter(function(P) {
    return I1(P) === f;
  }) : N1, F = m.filter(function(P) {
    return u.indexOf(P) >= 0;
  });
  F.length === 0 && (F = m);
  var V = F.reduce(function(P, M) {
    return P[M] = p2(r, {
      placement: M,
      boundary: h,
      rootBoundary: c,
      padding: _
    })[g1(M)], P;
  }, {});
  return Object.keys(V).sort(function(P, M) {
    return V[P] - V[M];
  });
}
function fL2(r) {
  if (g1(r) === u2)
    return [];
  var e = X1(r);
  return [I2(r), e, I2(e)];
}
function vL2(r) {
  var e = r.state, l = r.options, s = r.name;
  if (!e.modifiersData[s]._skip) {
    for (var h = l.mainAxis, c = h === void 0 ? !0 : h, _ = l.altAxis, C = _ === void 0 ? !0 : _, d = l.fallbackPlacements, u = l.padding, f = l.boundary, m = l.rootBoundary, F = l.altBoundary, V = l.flipVariations, P = V === void 0 ? !0 : V, M = l.allowedAutoPlacements, g = e.options.placement, L = g1(g), Z = L === g, A = d || (Z || !P ? [X1(g)] : fL2(g)), b = [g].concat(A).reduce(function(e1, i1) {
      return e1.concat(g1(i1) === u2 ? CL2(e, {
        placement: i1,
        boundary: f,
        rootBoundary: m,
        padding: u,
        flipVariations: P,
        allowedAutoPlacements: M
      }) : i1);
    }, []), E = e.rects.reference, O = e.rects.popper, R = /* @__PURE__ */ new Map(), q = !0, H = b[0], $ = 0; $ < b.length; $++) {
      var x = b[$], y = g1(x), w = I1(x) === j1, p = [_1, v1].indexOf(y) >= 0, v = p ? "width" : "height", k = p2(e, {
        placement: x,
        boundary: f,
        rootBoundary: m,
        altBoundary: F,
        padding: u
      }), B = p ? w ? u1 : C1 : w ? v1 : _1;
      E[v] > O[v] && (B = X1(B));
      var T = X1(B), j = [];
      if (c && j.push(k[y] <= 0), C && j.push(k[B] <= 0, k[T] <= 0), j.every(function(e1) {
        return e1;
      })) {
        H = x, q = !1;
        break;
      }
      R.set(x, j);
    }
    if (q)
      for (var N = P ? 3 : 1, G = function(i1) {
        var d1 = b.find(function(L1) {
          var h1 = R.get(L1);
          if (h1)
            return h1.slice(0, i1).every(function(o1) {
              return o1;
            });
        });
        if (d1)
          return H = d1, "break";
      }, X = N; X > 0; X--) {
        var J = G(X);
        if (J === "break")
          break;
      }
    e.placement !== H && (e.modifiersData[s]._skip = !0, e.placement = H, e.reset = !0);
  }
}
var uL2 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: vL2,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function wL2(r, e, l) {
  var s = g1(r), h = [C1, _1].indexOf(s) >= 0 ? -1 : 1, c = typeof l == "function" ? l(Object.assign({}, e, {
    placement: r
  })) : l, _ = c[0], C = c[1];
  return _ = _ || 0, C = (C || 0) * h, [C1, u1].indexOf(s) >= 0 ? {
    x: C,
    y: _
  } : {
    x: _,
    y: C
  };
}
function pL2(r) {
  var e = r.state, l = r.options, s = r.name, h = l.offset, c = h === void 0 ? [0, 0] : h, _ = W2.reduce(function(f, m) {
    return f[m] = wL2(m, e.rects, c), f;
  }, {}), C = _[e.placement], d = C.x, u = C.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += d, e.modifiersData.popperOffsets.y += u), e.modifiersData[s] = _;
}
var gL2 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: pL2
}, $L2 = function(e, l) {
  return e = typeof e == "function" ? e(Object.assign({}, l.rects, {
    placement: l.placement
  })) : e, J2(typeof e != "number" ? e : t0(e, N1));
};
function ML2(r) {
  var e, l = r.state, s = r.name, h = r.options, c = l.elements.arrow, _ = l.modifiersData.popperOffsets, C = g1(l.placement), d = w2(C), u = [C1, u1].indexOf(C) >= 0, f = u ? "height" : "width";
  if (!(!c || !_)) {
    var m = $L2(h.padding, l), F = v2(c), V = d === "y" ? _1 : C1, P = d === "y" ? v1 : u1, M = l.rects.reference[f] + l.rects.reference[d] - _[d] - l.rects.popper[f], g = _[d] - l.rects.reference[d], L = U1(c), Z = L ? d === "y" ? L.clientHeight || 0 : L.clientWidth || 0 : 0, A = M / 2 - g / 2, b = m[V], E = Z - F[f] - m[P], O = Z / 2 - F[f] / 2 + A, R = Y1(b, O, E), q = d;
    l.modifiersData[s] = (e = {}, e[q] = R, e.centerOffset = R - O, e);
  }
}
function LL2(r) {
  var e = r.state, l = r.options, s = l.element, h = s === void 0 ? "[data-popper-arrow]" : s;
  h != null && (typeof h == "string" && (h = e.elements.popper.querySelector(h), !h) || Y2(e.elements.popper, h) && (e.elements.arrow = h));
}
var kL2 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: ML2,
  effect: LL2,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
const l2 = (r) => parseInt(r, 10);
function mL2({
  arrowPadding: r,
  emit: e,
  locked: l,
  offsetDistance: s,
  offsetSkid: h,
  placement: c,
  popperNode: _,
  triggerNode: C
}) {
  const d = C0({
    isOpen: !1,
    popperInstance: null
  }), u = (M) => {
    var g;
    (g = d.popperInstance) === null || g === void 0 || g.setOptions((L) => ({
      ...L,
      modifiers: [...L.modifiers, {
        name: "eventListeners",
        enabled: M
      }]
    }));
  }, f = () => u(!0), m = () => u(!1), F = () => {
    d.isOpen && (d.isOpen = !1, e("close:popper"));
  }, V = () => {
    d.isOpen || (d.isOpen = !0, e("open:popper"));
  };
  k1([() => d.isOpen, c], async ([M]) => {
    M ? (await P(), f()) : m();
  });
  const P = async () => {
    await f0(), d.popperInstance = sL2(C.value, _.value, {
      placement: c.value,
      modifiers: [dL2, uL2, {
        name: "flip",
        enabled: !l.value
      }, kL2, {
        name: "arrow",
        options: {
          padding: l2(r.value)
        }
      }, gL2, {
        name: "offset",
        options: {
          offset: [l2(h.value), l2(s.value)]
        }
      }]
    }), d.popperInstance.update();
  };
  return c2(() => {
    var M;
    (M = d.popperInstance) === null || M === void 0 || M.destroy();
  }), {
    ...t2(d),
    open: V,
    close: F
  };
}
const xL2 = {
  id: "arrow",
  "data-popper-arrow": ""
};
function HL2(r, e) {
  return n(), o("div", xL2);
}
function e0(r, e) {
  e === void 0 && (e = {});
  var l = e.insertAt;
  if (!(!r || typeof document > "u")) {
    var s = document.head || document.getElementsByTagName("head")[0], h = document.createElement("style");
    h.type = "text/css", l === "top" && s.firstChild ? s.insertBefore(h, s.firstChild) : s.appendChild(h), h.styleSheet ? h.styleSheet.cssText = r : h.appendChild(document.createTextNode(r));
  }
}
var VL2 = `
#arrow[data-v-20b7fd4a],
  #arrow[data-v-20b7fd4a]::before {
    transition: background 250ms ease-in-out;
    position: absolute;
    width: calc(10px - var(--popper-theme-border-width, 0px));
    height: calc(10px - var(--popper-theme-border-width, 0px));
    box-sizing: border-box;
    background: var(--popper-theme-background-color);
}
#arrow[data-v-20b7fd4a] {
    visibility: hidden;
}
#arrow[data-v-20b7fd4a]::before {
    visibility: visible;
    content: "";
    transform: rotate(45deg);
}

  /* Top arrow */
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a] {
    bottom: -5px;
}
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-bottom: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Bottom arrow */
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a] {
    top: -5px;
}
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a]::before {
    border-left: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Left arrow */
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a] {
    right: -5px;
}
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Right arrow */
.popper[data-popper-placement^="right"] > #arrow[data-v-20b7fd4a] {
    left: -5px;
}
`;
e0(VL2);
const g2 = {};
g2.render = HL2;
g2.__scopeId = "data-v-20b7fd4a";
var ZL2 = g2;
const BL2 = ["onKeyup"];
var r0 = {
  props: {
    /**
     * Preferred placement (the "auto" placements will choose the side with most space.)
     */
    placement: {
      type: String,
      default: "bottom",
      validator: function(r) {
        return ["auto", "auto-start", "auto-end", "top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "right", "right-start", "right-end", "left", "left-start", "left-end"].includes(r);
      }
    },
    /**
     * Disables automatically closing the popover when the user clicks away from it
     */
    disableClickAway: {
      type: Boolean,
      default: !1
    },
    /**
     * Offset in pixels along the trigger element
     */
    offsetSkid: {
      type: String,
      default: "0"
    },
    /**
     * Offset in pixels away from the trigger element
     */
    offsetDistance: {
      type: String,
      default: "12"
    },
    /**
     * Trigger the popper on hover
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually open/close the Popper, other events are ignored if this prop is set
     */
    show: {
      type: Boolean,
      default: null
    },
    /**
     * Disables the Popper. If it was already open, it will be closed.
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Open the Popper after a delay (ms).
     */
    openDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * Close the Popper after a delay (ms).
     */
    closeDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * The z-index of the Popper.
     */
    zIndex: {
      type: [Number, String],
      default: 9999
    },
    /**
     * Display an arrow on the popper
     */
    arrow: {
      type: Boolean,
      default: !1
    },
    /**
     * Stop arrow from reaching the edge of the popper
     */
    arrowPadding: {
      type: String,
      default: "0"
    },
    /**
     * If the Popper should be interactive, it will close when clicked/hovered if false
     */
    interactive: {
      type: Boolean,
      default: !0
    },
    /**
     * Lock the Popper into place, it will not flip dynamically when it runs out of space if true
     */
    locked: {
      type: Boolean,
      default: !1
    },
    /**
     * If the content is just a simple string, it can be passed in as a prop
     */
    content: {
      type: String,
      default: null
    }
  },
  emits: ["open:popper", "close:popper"],
  setup(r, {
    emit: e
  }) {
    const l = r;
    D2((T) => ({
      c81fc0a4: r.zIndex
    }));
    const s = P2(), h = S(null), c = S(null), _ = S(null), C = S(!1);
    M1(() => {
      const T = s.default();
      if (T && T.length > 1)
        return console.error(`[Popper]: The <Popper> component expects only one child element at its root. You passed ${T.length} child nodes.`);
    });
    const {
      arrowPadding: d,
      closeDelay: u,
      content: f,
      disableClickAway: m,
      disabled: F,
      interactive: V,
      locked: P,
      offsetDistance: M,
      offsetSkid: g,
      openDelay: L,
      placement: Z,
      show: A
    } = t2(l), {
      isOpen: b,
      open: E,
      close: O
    } = mL2({
      arrowPadding: d,
      emit: e,
      locked: P,
      offsetDistance: M,
      offsetSkid: g,
      placement: Z,
      popperNode: c,
      triggerNode: _
    }), {
      hasContent: R
    } = $M2(s, c, f), q = n1(() => A.value !== null), H = n1(() => F.value || !R.value), $ = n1(() => b.value && !H.value), x = n1(() => !m.value && !q.value), y = n1(() => V.value ? `border: ${M.value}px solid transparent; margin: -${M.value}px;` : null), w = i2.debounce(E, L.value), p = i2.debounce(O, u.value), v = async () => {
      H.value || q.value || (p.clear(), w());
    }, k = async () => {
      q.value || (w.clear(), p());
    }, B = () => {
      b.value ? k() : v();
    };
    return k1([R, F], ([T, j]) => {
      b.value && (!T || j) && O();
    }), k1(b, (T) => {
      T ? C.value = !0 : i2.debounce(() => {
        C.value = !1;
      }, 200);
    }), s2(() => {
      q.value && (A.value ? w() : p());
    }), s2(() => {
      x.value && gM2(h, k);
    }), (T, j) => (n(), o("div", {
      class: "inline-block",
      style: E1(U(y)),
      onMouseleave: j[2] || (j[2] = (N) => r.hover && k()),
      ref: (N, G) => {
        G.popperContainerNode = N, h.value = N;
      }
    }, [t("div", {
      ref: (N, G) => {
        G.triggerNode = N, _.value = N;
      },
      onMouseover: j[0] || (j[0] = (N) => r.hover && v()),
      onClick: B,
      onFocus: v,
      onKeyup: J1(k, ["esc"])
    }, [s1(T.$slots, "default")], 40, BL2), W(_0, {
      name: "fade"
    }, {
      default: a1(() => [l1(t("div", {
        onClick: j[1] || (j[1] = (N) => !U(V) && k()),
        class: "popper",
        ref: (N, G) => {
          G.popperNode = N, c.value = N;
        }
      }, [s1(T.$slots, "content", {
        close: U(O),
        isOpen: C.value
      }, () => [Y(I(U(f)), 1)]), r.arrow ? (n(), Q(ZL2, {
        key: 0
      })) : D("", !0)], 512), [[b1, U($)]])]),
      _: 3
    })], 36));
  }
}, FL2 = `
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.popper[data-v-5784ed69] {
    transition: background 250ms ease-in-out;
    background: var(--popper-theme-background-color);
    padding: var(--popper-theme-padding);
    color: var(--popper-theme-text-color);
    border-radius: var(--popper-theme-border-radius);
    border-width: var(--popper-theme-border-width);
    border-style: var(--popper-theme-border-style);
    border-color: var(--popper-theme-border-color);
    box-shadow: var(--popper-theme-box-shadow);
    z-index: var(--c81fc0a4);
}
.popper[data-v-5784ed69]:hover,
  .popper:hover > #arrow[data-v-5784ed69]::before {
    background: var(--popper-theme-background-color-hover);
}
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.fade-enter-active[data-v-5784ed69],
  .fade-leave-active[data-v-5784ed69] {
    transition: opacity 0.2s ease;
}
.fade-enter-from[data-v-5784ed69],
  .fade-leave-to[data-v-5784ed69] {
    opacity: 0;
}
`;
e0(FL2);
r0.__scopeId = "data-v-5784ed69";
var b2 = /* @__PURE__ */ (() => {
  const r = r0;
  return r.install = (e) => {
    e.component("Popper", r);
  }, r;
})();
const jL2 = (r) => (r = r.replace(
  /@deprecated|@Deprecated/g,
  '<span style="color:red;"> &#9888;&#65039; **NO USAR**, solo existe con fines de compatibilidad con formulas antiguas. </span>'
), r = r.replace(/\*\*(.*?)\*\*/g, '<span class="font-bold">$1</span>'), r = r.replace(/_(.*?)_/g, "<i>$1</i>"), r), IL2 = { class: "w-full grid grid-cols-8 h-14 bg-gray-50 px-3 py-2 rounded-lg mr-5 hover:bg-gray-200 my-2" }, bL2 = { class: "col-span-7 mr-3" }, yL2 = { class: "flex justify-start items-center" }, DL2 = { class: "text-justify text-gray-700 truncate leading-5 mr-1" }, PL2 = ["innerHTML"], AL2 = { class: "text-sm font-semibold text-justify text-gray-500 w-full truncate leading-5" }, SL2 = { class: "col-span-1 flex justify-end items-center" }, TL2 = /* @__PURE__ */ r1({
  __name: "DListItems",
  props: {
    name: { default: "Prueba item" },
    type: { default: "" },
    description: { default: "" }
  },
  emits: ["clicked"],
  setup(r) {
    return (e, l) => (n(), o("div", IL2, [
      t("div", bL2, [
        t("div", yL2, [
          t("p", DL2, I(e.name), 1),
          W(U(b2), {
            arrow: "",
            offsetDistance: "10",
            hover: !0,
            placement: "right",
            class: "tooltip-formula"
          }, {
            content: a1(() => [
              t("pre", {
                class: "max-w-xs font-normal text-gray-700 break-words",
                style: { "white-space": "pre-wrap" },
                innerHTML: U(jL2)(e.description)
              }, null, 8, PL2)
            ]),
            default: a1(() => [
              e.description ? (n(), Q(U(L41), {
                key: 0,
                class: "h-5 text-gray-400 cursor-pointer"
              })) : D("", !0)
            ]),
            _: 1
          })
        ]),
        t("p", AL2, I(e.type), 1)
      ]),
      t("div", SL2, [
        W(U(b2), {
          arrow: "",
          offsetDistance: "10",
          content: "Agregar a la formula",
          hover: !0,
          placement: "right",
          class: "tooltip-add"
        }, {
          default: a1(() => [
            W(U(ix1), {
              class: "text-gray-600 cursor-pointer",
              onClick: l[0] || (l[0] = (s) => e.$emit("clicked"))
            })
          ]),
          _: 1
        })
      ])
    ]));
  }
});
const OL2 = /* @__PURE__ */ i(TL2, [["__scopeId", "data-v-9e5758c5"]]);
class EL2 {
  constructor() {
    this.languageDef = {
      personalized: [],
      standard: [],
      entity: [],
      saved: [],
      operators: [
        "+",
        "-",
        "*",
        "/",
        "%",
        "^",
        "!",
        "!=",
        "==",
        ">",
        "<",
        ">=",
        "<=",
        "&&",
        "||"
      ],
      string: ['"', "'"],
      comment: ["/*", "*/"],
      ternary: ["?", ":"],
      types: ["int", "float", "double", "long", "short", "byte", "char", "boolean"]
    }, this.rawCode = "", this.closesParenthesis = [], this.tokenStyles = /* @__PURE__ */ new Map([
      ["personalized", "color: #cdae53; ; font-weight: 700;"],
      ["standard", "color: #ffaf5c; ; font-weight: 700;"],
      ["entity", "color: #ff7246; ; font-weight: 700;"],
      ["saved", "color:#909c5a; ; font-weight: 700;"],
      ["operator", "color: #b8114e; font-weight: 900;"],
      ["func", "color: #005cc5; font-weight: lighter;"],
      ["string", "color: #032f62; font-weight: bold;"],
      ["comment", "color: #90979f; font-weight: lighter;"],
      ["types", "color: #006a92; font-weight: bold;"],
      ["ternary", "color: #629fb1; font-weight: bold;"]
    ]), this.parenthesesColors = [
      "color: #2c8884; font-weight: bold;",
      "color: #2ef8a0; font-weight: bold;",
      "color: #e7c500; font-weight: bold;",
      "color: #f82d97; font-weight: bold;",
      "color: #1eff05; font-weight: bold;",
      "color: #2c8884; font-weight: bold;",
      "color: #2ef8a0; font-weight: bold;",
      "color: #e7c500; font-weight: bold;",
      "color: #f82d97; font-weight: bold;",
      "color: #1eff05; font-weight: bold;",
      "color: #2c8884; font-weight: bold;",
      "color: #2ef8a0; font-weight: bold;",
      "color: #e7c500; font-weight: bold;",
      "color: #f82d97; font-weight: bold;",
      "color: #1eff05; font-weight: bold;"
    ];
  }
  keywords(e) {
    return e && (e != null && e.entity && (e == null || e.entity.forEach((l) => {
      this.languageDef.entity.push(l == null ? void 0 : l.code);
    })), e != null && e.personalized && (e == null || e.personalized.forEach((l) => {
      this.languageDef.personalized.push(l == null ? void 0 : l.code);
    })), e != null && e.standard && (e == null || e.standard.forEach((l) => {
      this.languageDef.standard.push(l == null ? void 0 : l.code);
    })), e != null && e.saved && (e == null || e.saved.forEach((l) => {
      this.languageDef.saved.push(l == null ? void 0 : l.code);
    }))), !0;
  }
  highligh(e) {
    return this.rawCode = e, this.unSanitize().tokenize().map((l) => this.highlightKeywords(l)).join("");
  }
  unSanitize() {
    return this.rawCode = this.rawCode.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&"), this;
  }
  tokenize() {
    var s;
    const e = this.rawCode.split(""), l = [];
    for (let h = 0; h < e.length; h++) {
      const c = e[h];
      let _ = c;
      if (c.match(/{|[A-Za-z0-9]/)) {
        const C = this.getTokenToEnd(h, e, /{|}|_|-|[A-Za-z0-9]/);
        _ = C.token, h = C.cursor;
      } else if (c.match(/!|=|>|<|=|&|\|/gm)) {
        const C = this.getTokenToEnd(h, e, /!|=|>|<|=|&|\|/);
        _ = C.token, h = C.cursor;
      } else if (c.match(/\//) && ((s = e[h + 1]) != null && s.match(/\*/))) {
        const C = this.getTokenToEnd(h, e, /[A-Za-z0-9]|\*|\/|\\|\s/);
        _ = C.token, h = C.cursor;
      }
      l.push(_), _ = "";
    }
    return l;
  }
  getTokenToEnd(e, l, s) {
    let h = "";
    for (let c = e; c < l.length; c++) {
      const _ = l[c];
      if (_.match(s))
        h += _;
      else
        break;
      e = c;
    }
    return {
      token: h,
      cursor: e
    };
  }
  highlightKeywords(e) {
    if (this.languageDef.personalized.includes(e))
      return this.setTokenColor("personalized", e);
    if (this.languageDef.standard.includes(e))
      return this.setTokenColor("standard", e);
    if (this.languageDef.entity.includes(e))
      return this.setTokenColor("entity", e);
    if (this.languageDef.saved.includes(e))
      return this.setTokenColor("saved", e);
    if (e.includes("/*"))
      return this.setTokenColor("comment", e);
    if (this.languageDef.operators.includes(e))
      return this.setTokenColor("operator", e);
    if (e === "(") {
      this.closesParenthesis.push("(");
      const l = this.parenthesesColors[this.closesParenthesis.length - 1];
      return this.setTokenColor("func", e, l);
    } else if (e === ")") {
      const l = this.parenthesesColors[this.closesParenthesis.length - 1];
      return this.closesParenthesis.pop(), this.setTokenColor("func", e, l);
    } else {
      if (this.languageDef.ternary.includes(e))
        return this.setTokenColor("ternary", e);
      if (e.includes('"') || e.includes("'"))
        return this.setTokenColor("string", e);
      if (!isNaN(Number(e)))
        return this.setTokenColor("types", e);
    }
    return e;
  }
  setTokenColor(e, l, s) {
    return `<span style="${s ?? this.tokenStyles.get(e) ?? ""}">${l}</span>`;
  }
}
const RL2 = (r) => (e2("data-v-c0f4d170"), r = r(), r2(), r), UL2 = { class: "w-9 sticky left-0 float-left pr-1 text-right bg-gray-100 text-gray-500 border-r-2 border-r-gray-300" }, NL2 = /* @__PURE__ */ RL2(() => /* @__PURE__ */ t("div", { class: "h-5 w-full left-0 absolute bg-transparent" }, null, -1)), qL2 = ["innerHTML"], zL2 = /* @__PURE__ */ r1({
  __name: "DCodeEditor",
  props: {
    modelValue: { default: "" },
    language: { default: "javascript" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    height: { default: "" },
    textarea: { type: Boolean, default: !0 },
    keywords: {}
  },
  emits: ["update:modelValue"],
  setup(r, { expose: e, emit: l }) {
    const s = r, h = { APSFormulas: new EL2() }, c = S(""), _ = S(null), C = S(null), d = n1(() => {
      let L = u();
      return L = L < 8 && !s.textarea ? 8 : L, Array.from({ length: L }, (Z, A) => A + 1);
    }), u = () => {
      var O;
      if (!_.value)
        return 1;
      const L = window.getComputedStyle(_.value), Z = parseFloat(L.fontSize), A = Math.floor(((O = _.value) == null ? void 0 : O.offsetWidth) / Z);
      if (A == 0)
        return 1;
      const b = c.value.split(`
`);
      let E = 0;
      return b.map((R) => {
        R.length === 0 ? E++ : E += Math.ceil(R.length / A);
      }), E + 1;
    }, f = n1(() => h.APSFormulas.highligh(c.value)), m = S({
      line: 0,
      column: 0,
      start: 0,
      end: 0
    }), F = () => {
      var O, R;
      const L = ((O = _.value) == null ? void 0 : O.selectionStart) ?? 0, Z = ((R = _.value) == null ? void 0 : R.selectionEnd) ?? 0, A = c.value.split(/\r\n|\r|\n/), b = A.findIndex((q, H) => {
        const $ = A.slice(0, H).reduce((y, w) => y + w.length + 1, 0), x = $ + A[H].length;
        return L >= $ && L <= x;
      }), E = L - A.slice(0, b).reduce((q, H) => q + H.length + 1, 0);
      m.value = {
        line: b,
        column: E,
        start: L,
        end: Z
      }, V(), l("update:modelValue", c.value);
    }, V = () => {
      var Z, A;
      const L = u();
      (Z = _.value) == null || Z.setAttribute("style", `height: ${L * 20}px;`), (A = C.value) == null || A.setAttribute("style", `height: ${L * 20}px;`);
    }, P = (L) => {
      c.value = c.value.slice(0, m.value.start) + L + c.value.slice(m.value.end), V(), l("update:modelValue", c.value);
    }, M = (L) => {
      var Z, A, b;
      if (L.key === "Tab") {
        L.preventDefault();
        const E = ((Z = _.value) == null ? void 0 : Z.selectionStart) ?? 0, O = ((A = _.value) == null ? void 0 : A.selectionEnd) ?? 0;
        c.value = c.value.slice(0, E) + "  " + c.value.slice(O), (b = _.value) == null || b.setSelectionRange(E + 2, E + 2);
      }
    }, g = (L) => {
      const Z = document.createElement("textarea");
      Z.innerHTML = L, c.value = Z.value;
    };
    return e({
      addFragmentOnCaret: P
    }), k1(
      () => s.keywords,
      (L) => {
        h.APSFormulas.keywords(L), g(s.modelValue), V();
      }
    ), M1(() => {
      var L;
      g(s.modelValue), (L = _.value) == null || L.focus(), V(), h.APSFormulas.keywords(s.keywords);
    }), (L, Z) => {
      var A;
      return (A = L.keywords) != null && A.entity ? (n(), o("div", {
        key: 0,
        class: z([[L.height ? L.height : "h-formulator"], "code-editor scroll overflow-x-auto relative bg-gray-100 text-black font-mono text-sm caret-white leading-5 resize-y rounded-lg"])
      }, [
        t("div", UL2, [
          (n(!0), o(K, null, t1(d.value, (b) => (n(), o("span", {
            class: "block",
            key: b
          }, [
            NL2,
            Y(" " + I(b), 1)
          ]))), 128))
        ]),
        L.textarea ? l1((n(), o("textarea", {
          key: 0,
          class: "p-0 m-0 ml-10 resize-none overflow-hidden border-none outline-none top-0 left-0 absolute bg-gray-200 caret-gray-400",
          ref_key: "textArea",
          ref: _,
          "onUpdate:modelValue": Z[0] || (Z[0] = (b) => c.value = b),
          spellcheck: "false",
          onClick: F,
          onKeyup: F,
          onKeydown: M
        }, null, 544)), [
          [h2, c.value]
        ]) : D("", !0),
        t("pre", {
          ref_key: "preElement",
          ref: C,
          class: z(["m-0 p-0 ml-10 absolute top-0 pointer-events-none select-none", L.textarea ? "hidden" : ""]),
          innerHTML: f.value
        }, null, 10, qL2)
      ], 2)) : (n(), o("div", {
        key: 1,
        class: z([[L.height ? L.height : "h-formulator"], "flex justify-center items-center bg-gray-100 rounded-md"])
      }, [
        W(U(R1), { class: "rotate h-11 w-11 text-gray-400" })
      ], 2));
    };
  }
});
const y2 = /* @__PURE__ */ i(zL2, [["__scopeId", "data-v-c0f4d170"]]), KL2 = { class: "block text-sm font-semibold text-gray-700 mb-1" }, GL2 = {
  key: 0,
  class: "text-red-500"
}, WL2 = {
  key: 0,
  class: "text-xs text-red-500"
}, YL2 = {
  class: "fixed z-50 inset-0 overflow-hidden bg-gray-500 bg-opacity-75 transition-opacity",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}, XL2 = { class: "w-screen h-full flex py-6 flex-col items-center justify-center relative align-bottom rounded-lg overflow-hidden shadow-2xl transform transition-all px-3" }, QL2 = { class: "card overflow-hidden rounded-lg bg-white w-10/12 max-w-7xl relative" }, JL2 = { class: "content-modal flex flex-col items-center pt-6 pb-5 px-5" }, tk2 = { class: "grid grid-cols-12 gap-3 w-full" }, ek2 = { class: "col-span-12" }, rk2 = { class: "font-semibold text-gray-700 mb-1" }, nk2 = { class: "col-span-12 md:col-span-5" }, ok2 = { class: "overflow-x-hidden overflow-y-auto scroll-gray mt-3 pr-3 scroll prefixesList" }, ik2 = { class: "col-span-12 md:col-span-7" }, lk2 = { class: "bg-gray-100 flex justify-end items-center py-4 px-4 gap-2" }, sk2 = /* @__PURE__ */ r1({
  __name: "Formulator",
  props: {
    modelValue: { default: "" },
    formulas: { default: () => [] },
    label: { default: "Formula" },
    disabled: { type: Boolean },
    required: { type: Boolean, default: !1 },
    error: { default: "" }
  },
  emits: ["update:modelValue", "enter"],
  setup(r, { emit: e }) {
    const l = r, s = (g) => {
      e("update:modelValue", g);
    }, h = S(null), c = S(""), _ = S(""), C = S(""), d = S(!1), u = S(0);
    let f = S(0);
    const m = () => {
      u.value += 1, f.value += 1, d.value = !1;
    }, F = (g) => {
      var L;
      (L = h.value) == null || L.addFragmentOnCaret(g);
    }, V = () => {
      s(_.value), m();
    }, P = () => {
      l.disabled || (C.value = l.modelValue, _.value = l.modelValue, d.value = !0, f.value += 1);
    }, M = () => {
      _.value = C.value, s(C.value), m();
    };
    return (g, L) => (n(), o("div", null, [
      t("div", null, [
        t("label", KL2, [
          Y(I(g.label) + " ", 1),
          g.required ? (n(), o("span", GL2, "*")) : D("", !0)
        ]),
        t("div", {
          class: z([[g.disabled ? "" : "cursor-pointer"], "w-full"]),
          onClick: P
        }, [
          (n(), Q(y2, {
            key: u.value,
            keywords: g.formulas,
            "model-value": g.modelValue,
            language: "APSFormulas",
            height: "h-40",
            textarea: !1
          }, null, 8, ["keywords", "model-value"])),
          g.error ? (n(), o("span", WL2, I(g.error), 1)) : D("", !0)
        ], 2)
      ]),
      l1(t("div", YL2, [
        t("div", XL2, [
          t("div", QL2, [
            t("article", JL2, [
              t("div", tk2, [
                t("div", ek2, [
                  t("label", rk2, I(g.label), 1)
                ]),
                t("div", nk2, [
                  W(U(N2), {
                    placeholder: "Buscar por nombre o tipo...",
                    icon: "SearchLgIcon",
                    modelValue: c.value,
                    "onUpdate:modelValue": L[0] || (L[0] = (Z) => c.value = Z)
                  }, null, 8, ["modelValue"]),
                  t("div", ok2, [
                    (n(!0), o(K, null, t1(g.formulas, (Z, A) => (n(), o(K, { key: A }, [
                      (n(!0), o(K, null, t1(Z.filter(function(b) {
                        return c.value == "" || b.name.toLowerCase().indexOf(c.value.toLowerCase()) > -1 || b.type.toLowerCase().indexOf(c.value.toLowerCase()) > -1;
                      }), (b, E) => (n(), Q(OL2, {
                        key: E,
                        name: b.name,
                        description: b.description,
                        type: b.type,
                        onClicked: (O) => F(b.code)
                      }, null, 8, ["name", "description", "type", "onClicked"]))), 128))
                    ], 64))), 128))
                  ])
                ]),
                t("div", ik2, [
                  (n(), Q(y2, {
                    key: U(f),
                    ref_key: "editor",
                    ref: h,
                    modelValue: _.value,
                    "onUpdate:modelValue": L[1] || (L[1] = (Z) => _.value = Z),
                    language: "APSFormulas",
                    keywords: g.formulas
                  }, null, 8, ["modelValue", "keywords"]))
                ])
              ])
            ]),
            t("footer", lk2, [
              W(U(p1), {
                color: "secondary",
                type: "button",
                class: "py-2 px-8",
                onClick: L[2] || (L[2] = (Z) => M())
              }, {
                default: a1(() => [
                  Y(" Cancelar ")
                ]),
                _: 1
              }),
              W(U(p1), {
                color: "blue",
                type: "button",
                class: "py-2 px-8",
                onClick: L[3] || (L[3] = (Z) => V())
              }, {
                default: a1(() => [
                  Y(" Guardar ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 512), [
        [b1, d.value]
      ])
    ]));
  }
});
const lW2 = /* @__PURE__ */ i(sk2, [["__scopeId", "data-v-1a3a15ea"]]), sW2 = {
  install: (r) => {
  }
};
export {
  VN2 as ADIcon,
  ZN2 as AEIcon,
  BN2 as AFIcon,
  FN2 as AGIcon,
  jN2 as AIIcon,
  IN2 as ALIcon,
  bN2 as AMIcon,
  yN2 as AOIcon,
  DN2 as ARIcon,
  PN2 as ASIcon,
  AN2 as ATIcon,
  SN2 as AUIcon,
  TN2 as AWIcon,
  ON2 as AXIcon,
  EN2 as AZIcon,
  ak2 as ActivityHeartIcon,
  dk2 as ActivityIcon,
  ck2 as AirplayIcon,
  _k2 as AirpodsIcon,
  Ck2 as AlarmClockCheckIcon,
  wk2 as AlarmClockIcon,
  fk2 as AlarmClockMinusIcon,
  vk2 as AlarmClockOffIcon,
  uk2 as AlarmClockPlusIcon,
  pk2 as AlertCircleIcon,
  gk2 as AlertHexagonIcon,
  $k2 as AlertOctagonIcon,
  Mk2 as AlertSquareIcon,
  K4 as AlertTriangleIcon,
  Lk2 as AlignBottom01Icon,
  kk2 as AlignBottom02Icon,
  mk2 as AlignCenterIcon,
  xk2 as AlignHorizontalCentre01Icon,
  Hk2 as AlignHorizontalCentre02Icon,
  Vk2 as AlignJustifyIcon,
  Zk2 as AlignLeft01Icon,
  Bk2 as AlignLeft02Icon,
  Fk2 as AlignLeftIcon,
  jk2 as AlignRight01Icon,
  Ik2 as AlignRight02Icon,
  bk2 as AlignRightIcon,
  yk2 as AlignTopArrow01Icon,
  Dk2 as AlignTopArrow02Icon,
  Pk2 as AlignVerticalCenter01Icon,
  Ak2 as AlignVerticalCenter02Icon,
  Sk2 as AnchorIcon,
  Tk2 as AnnotationAlertIcon,
  Ok2 as AnnotationCheckIcon,
  Ek2 as AnnotationDotsIcon,
  Rk2 as AnnotationHeartIcon,
  zk2 as AnnotationIcon,
  Uk2 as AnnotationInfoIcon,
  Nk2 as AnnotationPlusIcon,
  A6 as AnnotationQuestionIcon,
  qk2 as AnnotationXIcon,
  Kk2 as Announcement01Icon,
  Gk2 as Announcement02Icon,
  Wk2 as Announcement03Icon,
  Yk2 as ArchiveIcon,
  Xk2 as ArrowBlockDownIcon,
  Qk2 as ArrowBlockLeftIcon,
  Jk2 as ArrowBlockRightIcon,
  tm2 as ArrowBlockUpIcon,
  nm2 as ArrowCircleBrokenDownIcon,
  em2 as ArrowCircleBrokenDownLeftIcon,
  rm2 as ArrowCircleBrokenDownRightIcon,
  om2 as ArrowCircleBrokenLeftIcon,
  im2 as ArrowCircleBrokenRightIcon,
  hm2 as ArrowCircleBrokenUpIcon,
  lm2 as ArrowCircleBrokenUpLeftIcon,
  sm2 as ArrowCircleBrokenUpRightIcon,
  cm2 as ArrowCircleDownIcon,
  am2 as ArrowCircleDownLeftIcon,
  dm2 as ArrowCircleDownRightIcon,
  _m2 as ArrowCircleLeftIcon,
  Cm2 as ArrowCircleRightIcon,
  um2 as ArrowCircleUpIcon,
  fm2 as ArrowCircleUpLeftIcon,
  vm2 as ArrowCircleUpRightIcon,
  Y7 as ArrowDownIcon,
  wm2 as ArrowDownLeftIcon,
  pm2 as ArrowDownRightIcon,
  gm2 as ArrowLeftIcon,
  Lm2 as ArrowNarrowDownIcon,
  $m2 as ArrowNarrowDownLeftIcon,
  Mm2 as ArrowNarrowDownRightIcon,
  km2 as ArrowNarrowLeftIcon,
  mm2 as ArrowNarrowRightIcon,
  Vm2 as ArrowNarrowUpIcon,
  xm2 as ArrowNarrowUpLeftIcon,
  Hm2 as ArrowNarrowUpRightIcon,
  Zm2 as ArrowRightIcon,
  jm2 as ArrowSquareDownIcon,
  Bm2 as ArrowSquareDownLeftIcon,
  Fm2 as ArrowSquareDownRightIcon,
  Im2 as ArrowSquareLeftIcon,
  bm2 as ArrowSquareRightIcon,
  Pm2 as ArrowSquareUpIcon,
  ym2 as ArrowSquareUpLeftIcon,
  Dm2 as ArrowSquareUpRightIcon,
  vr as ArrowUpIcon,
  Am2 as ArrowUpLeftIcon,
  Sm2 as ArrowUpRightIcon,
  Tm2 as ArrowsDownIcon,
  Om2 as ArrowsLeftIcon,
  Em2 as ArrowsRightIcon,
  Rm2 as ArrowsTriangleIcon,
  Um2 as ArrowsUpIcon,
  Nm2 as Asterisk01Icon,
  qm2 as Asterisk02Icon,
  zm2 as AtSignIcon,
  Km2 as Atom01Icon,
  Gm2 as Atom02Icon,
  Wm2 as Attachment01Icon,
  Ym2 as Attachment02Icon,
  Xm2 as Award01Icon,
  Qm2 as Award02Icon,
  Jm2 as Award03Icon,
  tx2 as Award04Icon,
  ex2 as Award05Icon,
  RN2 as BAIcon,
  UN2 as BBIcon,
  NN2 as BDIcon,
  qN2 as BEIcon,
  zN2 as BFIcon,
  KN2 as BGIcon,
  GN2 as BHIcon,
  WN2 as BIIcon,
  YN2 as BJIcon,
  XN2 as BLIcon,
  QN2 as BMIcon,
  JN2 as BNIcon,
  tq2 as BOIcon,
  eq2 as BQ1Icon,
  rq2 as BQ2Icon,
  nq2 as BQIcon,
  oq2 as BRIcon,
  iq2 as BSIcon,
  lq2 as BTIcon,
  sq2 as BWIcon,
  hq2 as BYIcon,
  aq2 as BZIcon,
  rx2 as BackpackIcon,
  lx2 as BankIcon,
  nx2 as BankNote01Icon,
  ox2 as BankNote02Icon,
  ix2 as BankNote03Icon,
  sx2 as BarChart01Icon,
  hx2 as BarChart02Icon,
  ax2 as BarChart03Icon,
  dx2 as BarChart04Icon,
  cx2 as BarChart05Icon,
  _x2 as BarChart06Icon,
  Cx2 as BarChart07Icon,
  fx2 as BarChart08Icon,
  vx2 as BarChart09Icon,
  ux2 as BarChart10Icon,
  wx2 as BarChart11Icon,
  px2 as BarChart12Icon,
  gx2 as BarChartCircle01Icon,
  $x2 as BarChartCircle02Icon,
  Mx2 as BarChartCircle03Icon,
  Lx2 as BarChartSquare01Icon,
  kx2 as BarChartSquare02Icon,
  mx2 as BarChartSquare03Icon,
  xx2 as BarChartSquareDownIcon,
  Hx2 as BarChartSquareMinusIcon,
  Vx2 as BarChartSquarePlusIcon,
  Zx2 as BarChartSquareUpIcon,
  Bx2 as BarLineChartIcon,
  Fx2 as BatteryCharging01Icon,
  jx2 as BatteryCharging02Icon,
  Ix2 as BatteryEmptyIcon,
  bx2 as BatteryFullIcon,
  yx2 as BatteryLowIcon,
  Dx2 as BatteryMidIcon,
  Px2 as Beaker01Icon,
  Ax2 as Beaker02Icon,
  Sx2 as Bell01Icon,
  Tx2 as Bell02Icon,
  Ox2 as Bell03Icon,
  Ex2 as Bell04Icon,
  Rx2 as BellMinusIcon,
  Ux2 as BellOff01Icon,
  Nx2 as BellOff02Icon,
  qx2 as BellOff03Icon,
  zx2 as BellPlusIcon,
  Kx2 as BellRinging01Icon,
  Gx2 as BellRinging02Icon,
  Wx2 as BellRinging03Icon,
  Yx2 as BellRinging04Icon,
  Xx2 as BezierCurve01Icon,
  Qx2 as BezierCurve02Icon,
  Jx2 as BezierCurve03Icon,
  tH2 as BluetoothConnectIcon,
  eH2 as BluetoothOffIcon,
  rH2 as BluetoothOnIcon,
  nH2 as BluetoothSignalIcon,
  oH2 as Bold01Icon,
  iH2 as Bold02Icon,
  lH2 as BoldSquareIcon,
  sH2 as BookClosedIcon,
  hH2 as BookOpen01Icon,
  aH2 as BookOpen02Icon,
  dH2 as BookmarkAddIcon,
  cH2 as BookmarkCheckIcon,
  fH2 as BookmarkIcon,
  _H2 as BookmarkMinusIcon,
  CH2 as BookmarkXIcon,
  vH2 as BoxIcon,
  uH2 as BracketsCheckIcon,
  wH2 as BracketsEllipsesIcon,
  LH2 as BracketsIcon,
  pH2 as BracketsMinusIcon,
  gH2 as BracketsPlusIcon,
  $H2 as BracketsSlashIcon,
  MH2 as BracketsXIcon,
  kH2 as Briefcase01Icon,
  mH2 as Briefcase02Icon,
  xH2 as BrowserIcon,
  HH2 as Brush01Icon,
  VH2 as Brush02Icon,
  ZH2 as Brush03Icon,
  BH2 as Building01Icon,
  FH2 as Building02Icon,
  jH2 as Building03Icon,
  IH2 as Building04Icon,
  bH2 as Building05Icon,
  yH2 as Building06Icon,
  DH2 as Building07Icon,
  PH2 as Building08Icon,
  AH2 as BusIcon,
  dq2 as CAIcon,
  cq2 as CCIcon,
  _q2 as CD1Icon,
  Cq2 as CDIcon,
  fq2 as CFIcon,
  vq2 as CHIcon,
  uq2 as CKIcon,
  wq2 as CLIcon,
  pq2 as CMIcon,
  gq2 as CNIcon,
  $q2 as COLIcon,
  Mq2 as CRIcon,
  Lq2 as CUIcon,
  kq2 as CWIcon,
  mq2 as CXIcon,
  xq2 as CYIcon,
  Hq2 as CZIcon,
  SH2 as CalculatorIcon,
  TH2 as CalendarCheck01Icon,
  OH2 as CalendarCheck02Icon,
  EH2 as CalendarDateIcon,
  RH2 as CalendarHeart01Icon,
  UH2 as CalendarHeart02Icon,
  GH2 as CalendarIcon,
  NH2 as CalendarMinus01Icon,
  qH2 as CalendarMinus02Icon,
  zH2 as CalendarPlus01Icon,
  KH2 as CalendarPlus02Icon,
  WH2 as Camera01Icon,
  YH2 as Camera02Icon,
  XH2 as Camera03Icon,
  QH2 as CameraLensIcon,
  JH2 as CameraOffIcon,
  tV2 as CameraPlusIcon,
  eV2 as Car01Icon,
  rV2 as Car02Icon,
  nV2 as Certificate01Icon,
  oV2 as Certificate02Icon,
  iV2 as ChartBreakoutCircleIcon,
  lV2 as ChartBreakoutSquareIcon,
  sV2 as CheckCircleBrokenIcon,
  ow as CheckCircleIcon,
  hV2 as CheckDone01Icon,
  aV2 as CheckDone02Icon,
  dV2 as CheckHeartIcon,
  uV2 as CheckIcon,
  cV2 as CheckSquareBrokenIcon,
  _V2 as CheckSquareIcon,
  CV2 as CheckVerified01Icon,
  fV2 as CheckVerified02Icon,
  vV2 as CheckVerified03Icon,
  wV2 as ChevronDownDoubleIcon,
  A2 as ChevronDownIcon,
  Mp as ChevronLeftDoubleIcon,
  Zp as ChevronLeftIcon,
  Dp as ChevronRightDoubleIcon,
  Rp as ChevronRightIcon,
  pV2 as ChevronSelectorHorizontalIcon,
  gV2 as ChevronSelectorVerticalIcon,
  $V2 as ChevronUpDoubleIcon,
  MV2 as ChevronUpIcon,
  LV2 as ChromeCastIcon,
  kV2 as CircleCutIcon,
  mV2 as CircleIcon,
  xV2 as ClapperboardIcon,
  HV2 as ClipboardAttachmentIcon,
  VV2 as ClipboardCheckIcon,
  ZV2 as ClipboardDownloadIcon,
  IV2 as ClipboardIcon,
  BV2 as ClipboardMinusIcon,
  FV2 as ClipboardPlusIcon,
  jV2 as ClipboardXIcon,
  bV2 as ClockCheckIcon,
  yV2 as ClockFastForwardIcon,
  OV2 as ClockIcon,
  DV2 as ClockPlusIcon,
  PV2 as ClockRefreshIcon,
  AV2 as ClockRewindIcon,
  SV2 as ClockSnoozeIcon,
  TV2 as ClockStopwatchIcon,
  EV2 as Cloud01Icon,
  RV2 as Cloud02Icon,
  UV2 as Cloud03Icon,
  NV2 as CloudBlank01Icon,
  qV2 as CloudBlank02Icon,
  zV2 as CloudLightningIcon,
  KV2 as CloudMoonIcon,
  GV2 as CloudOffIcon,
  WV2 as CloudRaining01Icon,
  YV2 as CloudRaining02Icon,
  XV2 as CloudRaining03Icon,
  QV2 as CloudRaining04Icon,
  JV2 as CloudRaining05Icon,
  tZ2 as CloudRaining06Icon,
  eZ2 as CloudSnowing01Icon,
  rZ2 as CloudSnowing02Icon,
  nZ2 as CloudSun01Icon,
  oZ2 as CloudSun02Icon,
  iZ2 as CloudSun03Icon,
  lZ2 as Code01Icon,
  sZ2 as Code02Icon,
  hZ2 as CodeBrowserIcon,
  aZ2 as CodeCircle01Icon,
  dZ2 as CodeCircle02Icon,
  cZ2 as CodeCircle03Icon,
  _Z2 as CodeSnippet01Icon,
  CZ2 as CodeSnippet02Icon,
  fZ2 as CodeSquare01Icon,
  vZ2 as CodeSquare02Icon,
  uZ2 as CodepenIcon,
  wZ2 as Coins01Icon,
  pZ2 as Coins02Icon,
  gZ2 as Coins03Icon,
  $Z2 as Coins04Icon,
  MZ2 as CoinsHandIcon,
  LZ2 as CoinsStacked01Icon,
  kZ2 as CoinsStacked02Icon,
  mZ2 as CoinsStacked03Icon,
  xZ2 as CoinsStacked04Icon,
  HZ2 as CoinsSwap01Icon,
  VZ2 as CoinsSwap02Icon,
  ZZ2 as ColorsIcon,
  BZ2 as Columns01Icon,
  FZ2 as Columns02Icon,
  jZ2 as Columns03Icon,
  IZ2 as CommandIcon,
  bZ2 as Compass01Icon,
  yZ2 as Compass02Icon,
  DZ2 as Compass03Icon,
  PZ2 as CompassIcon,
  AZ2 as ContainerIcon,
  SZ2 as Contrast01Icon,
  TZ2 as Contrast02Icon,
  OZ2 as Contrast03Icon,
  EZ2 as Copy01Icon,
  RZ2 as Copy02Icon,
  UZ2 as Copy03Icon,
  NZ2 as Copy04Icon,
  qZ2 as Copy05Icon,
  zZ2 as Copy06Icon,
  KZ2 as Copy07Icon,
  GZ2 as CornerDownLeftIcon,
  WZ2 as CornerDownRightIcon,
  YZ2 as CornerLeftDownIcon,
  XZ2 as CornerLeftUpIcon,
  QZ2 as CornerRightDownIcon,
  JZ2 as CornerRightUpIcon,
  tB2 as CornerUpLeftIcon,
  eB2 as CornerUpRightIcon,
  rB2 as CpuChip01Icon,
  nB2 as CpuChip02Icon,
  oB2 as CreditCard01Icon,
  iB2 as CreditCard02Icon,
  lB2 as CreditCardCheckIcon,
  sB2 as CreditCardDownIcon,
  hB2 as CreditCardDownloadIcon,
  aB2 as CreditCardEditIcon,
  dB2 as CreditCardLockIcon,
  cB2 as CreditCardMinusIcon,
  _B2 as CreditCardPlusIcon,
  CB2 as CreditCardRefreshIcon,
  fB2 as CreditCardSearchIcon,
  vB2 as CreditCardShieldIcon,
  uB2 as CreditCardUpIcon,
  wB2 as CreditCardUploadIcon,
  pB2 as CreditCardXIcon,
  gB2 as Crop01Icon,
  $B2 as Crop02Icon,
  MB2 as Cryptocurrency01Icon,
  LB2 as Cryptocurrency02Icon,
  kB2 as Cryptocurrency03Icon,
  mB2 as Cryptocurrency04Icon,
  xB2 as Cube01Icon,
  HB2 as Cube02Icon,
  VB2 as Cube03Icon,
  ZB2 as Cube04Icon,
  BB2 as CubeOutlineIcon,
  FB2 as CurrencyBitcoinCircleIcon,
  jB2 as CurrencyBitcoinIcon,
  IB2 as CurrencyDollarCircleIcon,
  bB2 as CurrencyDollarIcon,
  yB2 as CurrencyEthereumCircleIcon,
  DB2 as CurrencyEthereumIcon,
  PB2 as CurrencyEuroCircleIcon,
  AB2 as CurrencyEuroIcon,
  SB2 as CurrencyPoundCircleIcon,
  TB2 as CurrencyPoundIcon,
  OB2 as CurrencyRubleCircleIcon,
  EB2 as CurrencyRubleIcon,
  RB2 as CurrencyRupeeCircleIcon,
  UB2 as CurrencyRupeeIcon,
  NB2 as CurrencyYenCircleIcon,
  qB2 as CurrencyYenIcon,
  zB2 as Cursor01Icon,
  KB2 as Cursor02Icon,
  GB2 as Cursor03Icon,
  WB2 as Cursor04Icon,
  YB2 as CursorBoxIcon,
  XB2 as CursorClick01Icon,
  QB2 as CursorClick02Icon,
  p1 as DBtn,
  qG2 as DCard,
  zG2 as DDropdown,
  Vq2 as DEIcon,
  eW2 as DEmployeesFilter,
  KG2 as DFileUploader,
  D1 as DIcon,
  K1 as DInfo,
  Zq2 as DJIcon,
  Bq2 as DKIcon,
  x2 as DList,
  GG2 as DLoading,
  Fq2 as DMIcon,
  WG2 as DModal,
  YG2 as DMultiselect,
  jq2 as DOIcon,
  T2 as DPagination,
  Iq2 as DSIcon,
  XG2 as DSelectField,
  QG2 as DSelectFieldSearch,
  oW2 as DTab,
  NG2 as DTable,
  nW2 as DTablePendingProcesses,
  iW2 as DTabs,
  rW2 as DTagsField,
  JG2 as DTextAreaField,
  N2 as DTextField,
  tW2 as DToggleField,
  bq2 as DZIcon,
  JB2 as DataIcon,
  tF2 as Database01Icon,
  eF2 as Database02Icon,
  rF2 as Database03Icon,
  nF2 as Dataflow01Icon,
  oF2 as Dataflow02Icon,
  iF2 as Dataflow03Icon,
  lF2 as Dataflow04Icon,
  sF2 as DeleteIcon,
  hF2 as Diamond01Icon,
  aF2 as Diamond02Icon,
  dF2 as Dice1Icon,
  cF2 as Dice2Icon,
  _F2 as Dice3Icon,
  CF2 as Dice4Icon,
  fF2 as Dice5Icon,
  vF2 as Dice6Icon,
  uF2 as Disc01Icon,
  wF2 as Disc02Icon,
  pF2 as DistributeSpacingHorizontalIcon,
  gF2 as DistributeSpacingVerticalIcon,
  $F2 as Divide01Icon,
  MF2 as Divide02Icon,
  LF2 as Divide03Icon,
  kF2 as DividerIcon,
  mF2 as Dotpoints01Icon,
  xF2 as Dotpoints02Icon,
  HF2 as DotsGridIcon,
  VF2 as DotsHorizontalIcon,
  hS as DotsVerticalIcon,
  ZF2 as Download01Icon,
  BF2 as Download02Icon,
  FF2 as Download03Icon,
  jF2 as Download04Icon,
  IF2 as DownloadCloud01Icon,
  bF2 as DownloadCloud02Icon,
  yF2 as DropIcon,
  DF2 as Droplets01Icon,
  PF2 as Droplets02Icon,
  AF2 as Droplets03Icon,
  SF2 as DropperIcon,
  yq2 as ECIcon,
  Dq2 as EEIcon,
  Pq2 as EGIcon,
  Aq2 as EHIcon,
  Sq2 as ERIcon,
  Tq2 as ESIcon,
  Oq2 as ETIcon,
  TF2 as Edit01Icon,
  OF2 as Edit02Icon,
  EF2 as Edit03Icon,
  RF2 as Edit04Icon,
  UF2 as Edit05Icon,
  qF2 as EqualIcon,
  NF2 as EqualNotIcon,
  zF2 as EraserIcon,
  KF2 as Expand01Icon,
  GF2 as Expand02Icon,
  WF2 as Expand03Icon,
  YF2 as Expand04Icon,
  XF2 as Expand05Icon,
  QF2 as Expand06Icon,
  tj2 as EyeIcon,
  JF2 as EyeOffIcon,
  Eq2 as FIIcon,
  Rq2 as FJIcon,
  Uq2 as FKIcon,
  Nq2 as FMIcon,
  qq2 as FOIcon,
  zq2 as FRIcon,
  ej2 as FaceContentIcon,
  rj2 as FaceFrownIcon,
  nj2 as FaceHappyIcon,
  ij2 as FaceIdIcon,
  oj2 as FaceIdSquareIcon,
  lj2 as FaceNeutralIcon,
  sj2 as FaceSadIcon,
  hj2 as FaceSmileIcon,
  aj2 as FaceWinkIcon,
  dj2 as FastBackwardIcon,
  cj2 as FastForwardIcon,
  _j2 as FeatherIcon,
  Cj2 as FigmaIcon,
  fj2 as File01Icon,
  vj2 as File02Icon,
  uj2 as File03Icon,
  wj2 as File04Icon,
  pj2 as File05Icon,
  gU as File06Icon,
  gj2 as File07Icon,
  $j2 as FileAttachment01Icon,
  Mj2 as FileAttachment02Icon,
  Lj2 as FileAttachment03Icon,
  kj2 as FileAttachment04Icon,
  mj2 as FileAttachment05Icon,
  xj2 as FileCheck01Icon,
  Hj2 as FileCheck02Icon,
  Vj2 as FileCheck03Icon,
  Zj2 as FileCode01Icon,
  Bj2 as FileCode02Icon,
  Fj2 as FileDownload01Icon,
  jj2 as FileDownload02Icon,
  Ij2 as FileDownload03Icon,
  bj2 as FileHeart01Icon,
  yj2 as FileHeart02Icon,
  Dj2 as FileHeart03Icon,
  Pj2 as FileLock01Icon,
  Aj2 as FileLock02Icon,
  Sj2 as FileLock03Icon,
  Tj2 as FileMinus01Icon,
  Oj2 as FileMinus02Icon,
  Ej2 as FileMinus03Icon,
  Rj2 as FilePlus01Icon,
  Uj2 as FilePlus02Icon,
  Nj2 as FilePlus03Icon,
  qj2 as FileQuestion01Icon,
  zj2 as FileQuestion02Icon,
  Kj2 as FileQuestion03Icon,
  Gj2 as FileSearch01Icon,
  Wj2 as FileSearch02Icon,
  Yj2 as FileSearch03Icon,
  Xj2 as FileShield01Icon,
  Qj2 as FileShield02Icon,
  Jj2 as FileShield03Icon,
  tI2 as FileX01Icon,
  eI2 as FileX02Icon,
  rI2 as FileX03Icon,
  nI2 as Film01Icon,
  oI2 as Film02Icon,
  iI2 as Film03Icon,
  lI2 as FilterFunnel01Icon,
  sI2 as FilterFunnel02Icon,
  hI2 as FilterLinesIcon,
  aI2 as Fingerprint01Icon,
  dI2 as Fingerprint02Icon,
  cI2 as Fingerprint03Icon,
  _I2 as Fingerprint04Icon,
  CI2 as Flag01Icon,
  fI2 as Flag02Icon,
  vI2 as Flag03Icon,
  uI2 as Flag04Icon,
  wI2 as Flag05Icon,
  pI2 as Flag06Icon,
  $I2 as FlashIcon,
  gI2 as FlashOffIcon,
  MI2 as FlexAlignBottomIcon,
  LI2 as FlexAlignLeftIcon,
  kI2 as FlexAlignRightIcon,
  mI2 as FlexAlignTopIcon,
  xI2 as FlipBackwardIcon,
  HI2 as FlipForwardIcon,
  VI2 as FolderCheckIcon,
  ZI2 as FolderClosedIcon,
  BI2 as FolderCodeIcon,
  FI2 as FolderDownloadIcon,
  SI2 as FolderIcon,
  jI2 as FolderLockIcon,
  II2 as FolderMinusIcon,
  bI2 as FolderPlusIcon,
  yI2 as FolderQuestionIcon,
  DI2 as FolderSearchIcon,
  PI2 as FolderShieldIcon,
  AI2 as FolderXIcon,
  lW2 as Formulator,
  TI2 as FramerIcon,
  Kq2 as GAIcon,
  Gq2 as GB2Icon,
  Wq2 as GBIcon,
  Yq2 as GDIcon,
  Xq2 as GEIcon,
  Qq2 as GGIcon,
  Jq2 as GHIcon,
  tz2 as GIIcon,
  ez2 as GLIcon,
  rz2 as GMIcon,
  nz2 as GNIcon,
  oz2 as GQIcon,
  iz2 as GRIcon,
  lz2 as GTIcon,
  sz2 as GUIcon,
  hz2 as GWIcon,
  az2 as GYIcon,
  OI2 as GamingPad01Icon,
  EI2 as GamingPad02Icon,
  RI2 as Gift01Icon,
  UI2 as Gift02Icon,
  NI2 as GitBranch01Icon,
  qI2 as GitBranch02Icon,
  zI2 as GitCommitIcon,
  KI2 as GitMergeIcon,
  GI2 as GitPullRequestIcon,
  WI2 as Glasses01Icon,
  YI2 as Glasses02Icon,
  XI2 as Globe011Icon,
  QI2 as Globe01Icon,
  JI2 as Globe021Icon,
  tb2 as Globe02Icon,
  eb2 as Globe03Icon,
  rb2 as Globe04Icon,
  nb2 as Globe05Icon,
  ob2 as Globe06Icon,
  ib2 as GoogleChromeIcon,
  lb2 as GraduationHat01Icon,
  sb2 as GraduationHat02Icon,
  hb2 as Grid01Icon,
  ab2 as Grid02Icon,
  db2 as Grid03Icon,
  cb2 as GridDotsBlankIcon,
  _b2 as GridDotsBottomIcon,
  Cb2 as GridDotsHorizontalCenterIcon,
  fb2 as GridDotsLeftIcon,
  vb2 as GridDotsOuterIcon,
  ub2 as GridDotsRightIcon,
  wb2 as GridDotsTopIcon,
  pb2 as GridDotsVerticalCenterIcon,
  dz2 as HKIcon,
  cz2 as HNIcon,
  _z2 as HRIcon,
  Cz2 as HTIcon,
  fz2 as HUIcon,
  gb2 as HandIcon,
  $b2 as HardDriveIcon,
  Mb2 as Hash01Icon,
  Lb2 as Hash02Icon,
  kb2 as Heading01Icon,
  mb2 as Heading02Icon,
  xb2 as HeadingSquareIcon,
  Hb2 as Headphones01Icon,
  Vb2 as Headphones02Icon,
  Zb2 as HeartCircleIcon,
  Bb2 as HeartHandIcon,
  Fb2 as HeartHexagonIcon,
  yb2 as HeartIcon,
  jb2 as HeartOctagonIcon,
  Ib2 as HeartRoundedIcon,
  bb2 as HeartSquareIcon,
  Db2 as HeartsIcon,
  L41 as HelpCircleIcon,
  Pb2 as HelpOctagon1Icon,
  Ab2 as HelpOctagonIcon,
  Sb2 as HelpSquareIcon,
  Tb2 as Hexagon01Icon,
  Ob2 as Hexagon02Icon,
  Eb2 as Home01Icon,
  Rb2 as Home02Icon,
  Ub2 as Home03Icon,
  Nb2 as Home04Icon,
  qb2 as Home05Icon,
  zb2 as HomeLineIcon,
  Kb2 as HomeSmileIcon,
  Gb2 as HorizontalBarChart01Icon,
  Wb2 as HorizontalBarChart02Icon,
  Yb2 as HorizontalBarChart03Icon,
  Xb2 as Hourglass01Icon,
  Qb2 as Hourglass02Icon,
  Jb2 as Hourglass03Icon,
  ty2 as Hurricane01Icon,
  ey2 as Hurricane02Icon,
  ry2 as Hurricane03Icon,
  vz2 as IDIcon,
  uz2 as IEIcon,
  wz2 as ILIcon,
  pz2 as IMIcon,
  gz2 as INIcon,
  $z2 as IOIcon,
  Mz2 as IQIcon,
  Lz2 as IRIcon,
  kz2 as ISIcon,
  mz2 as ITIcon,
  ny2 as Image01Icon,
  oy2 as Image02Icon,
  iy2 as Image03Icon,
  ly2 as Image04Icon,
  sy2 as Image05Icon,
  hy2 as ImageCheckIcon,
  ay2 as ImageDownIcon,
  dy2 as ImageIndentLeftIcon,
  cy2 as ImageIndentRightIcon,
  _y2 as ImageLeftIcon,
  Cy2 as ImagePlusIcon,
  fy2 as ImageRightIcon,
  vy2 as ImageUpIcon,
  uy2 as ImageUserCheckIcon,
  wy2 as ImageUserDownIcon,
  ky2 as ImageUserIcon,
  py2 as ImageUserLeftIcon,
  gy2 as ImageUserPlusIcon,
  $y2 as ImageUserRightIcon,
  My2 as ImageUserUpIcon,
  Ly2 as ImageUserXIcon,
  my2 as ImageXIcon,
  xy2 as Inbox01Icon,
  Hy2 as Inbox02Icon,
  Vy2 as InfinityIcon,
  A81 as InfoCircleIcon,
  Zy2 as InfoHexagonIcon,
  By2 as InfoOctagonIcon,
  Fy2 as InfoSquareIcon,
  jy2 as IntersectCircleIcon,
  Iy2 as IntersectSquareIcon,
  by2 as Italic01Icon,
  yy2 as Italic02Icon,
  Dy2 as ItalicSquareIcon,
  xz2 as JEIcon,
  Hz2 as JMIcon,
  Vz2 as JOIcon,
  Zz2 as JPIcon,
  Bz2 as KEIcon,
  Fz2 as KGIcon,
  jz2 as KHIcon,
  Iz2 as KIIcon,
  bz2 as KMIcon,
  yz2 as KNIcon,
  Dz2 as KPIcon,
  Pz2 as KRIcon,
  Az2 as KWIcon,
  Sz2 as KYIcon,
  Tz2 as KZIcon,
  Py2 as Key01Icon,
  Ay2 as Key02Icon,
  Sy2 as Keyboard01Icon,
  Ty2 as Keyboard02Icon,
  Oz2 as LAIcon,
  Ez2 as LBIcon,
  Rz2 as LCIcon,
  Uz2 as LIIcon,
  Nz2 as LKIcon,
  qz2 as LRIcon,
  zz2 as LSIcon,
  Kz2 as LTIcon,
  Gz2 as LUIcon,
  Wz2 as LVIcon,
  Yz2 as LYIcon,
  Oy2 as Laptop01Icon,
  Ey2 as Laptop02Icon,
  Ry2 as LayerSingleIcon,
  Uy2 as LayersThree01Icon,
  Ny2 as LayersThree02Icon,
  qy2 as LayersTwo01Icon,
  zy2 as LayersTwo02Icon,
  Ky2 as LayoutAlt01Icon,
  Gy2 as LayoutAlt02Icon,
  Wy2 as LayoutAlt03Icon,
  Yy2 as LayoutAlt04Icon,
  Xy2 as LayoutBottomIcon,
  Qy2 as LayoutGrid01Icon,
  Jy2 as LayoutGrid02Icon,
  tD2 as LayoutLeftIcon,
  eD2 as LayoutRightIcon,
  rD2 as LayoutTopIcon,
  nD2 as LeftIndent01Icon,
  oD2 as LeftIndent02Icon,
  iD2 as LetterSpacing01Icon,
  lD2 as LetterSpacing02Icon,
  sD2 as LifeBuoy01Icon,
  hD2 as LifeBuoy02Icon,
  aD2 as Lightbulb01Icon,
  dD2 as Lightbulb02Icon,
  cD2 as Lightbulb03Icon,
  _D2 as Lightbulb04Icon,
  CD2 as Lightbulb05Icon,
  fD2 as Lightning01Icon,
  vD2 as Lightning02Icon,
  uD2 as LineChartDown01Icon,
  wD2 as LineChartDown02Icon,
  pD2 as LineChartDown03Icon,
  gD2 as LineChartDown04Icon,
  $D2 as LineChartDown05Icon,
  MD2 as LineChartUp01Icon,
  LD2 as LineChartUp02Icon,
  kD2 as LineChartUp03Icon,
  mD2 as LineChartUp04Icon,
  xD2 as LineChartUp05Icon,
  HD2 as LineHeightIcon,
  VD2 as Link01Icon,
  ZD2 as Link02Icon,
  BD2 as Link03Icon,
  FD2 as Link04Icon,
  jD2 as Link05Icon,
  ID2 as LinkBroken01Icon,
  bD2 as LinkBroken02Icon,
  yD2 as LinkExternal01Icon,
  DD2 as LinkExternal02Icon,
  PD2 as ListIcon,
  AD2 as Loading01Icon,
  R1 as Loading02Icon,
  SD2 as Loading03Icon,
  TD2 as Lock01Icon,
  OD2 as Lock02Icon,
  ED2 as Lock03Icon,
  RD2 as Lock04Icon,
  UD2 as LockKeyholeCircleIcon,
  ND2 as LockKeyholeSquareIcon,
  qD2 as LockUnlocked01Icon,
  zD2 as LockUnlocked02Icon,
  KD2 as LockUnlocked03Icon,
  GD2 as LockUnlocked04Icon,
  WD2 as LogIn01Icon,
  YD2 as LogIn02Icon,
  XD2 as LogIn03Icon,
  QD2 as LogIn04Icon,
  JD2 as LogOut01Icon,
  tP2 as LogOut02Icon,
  eP2 as LogOut03Icon,
  rP2 as LogOut04Icon,
  nP2 as Luggage01Icon,
  oP2 as Luggage02Icon,
  iP2 as Luggage03Icon,
  Xz2 as MAIcon,
  Qz2 as MCIcon,
  Jz2 as MDIcon,
  tK2 as MEIcon,
  eK2 as MGIcon,
  rK2 as MHIcon,
  nK2 as MKIcon,
  oK2 as MLIcon,
  iK2 as MMIcon,
  lK2 as MNIcon,
  sK2 as MOIcon,
  hK2 as MPIcon,
  aK2 as MQIcon,
  dK2 as MRIcon,
  cK2 as MSIcon,
  _K2 as MTIcon,
  CK2 as MUIcon,
  fK2 as MVIcon,
  vK2 as MWIcon,
  uK2 as MXIcon,
  wK2 as MYIcon,
  pK2 as MZIcon,
  lP2 as MagicWand01Icon,
  sP2 as MagicWand02Icon,
  hP2 as Mail01Icon,
  aP2 as Mail02Icon,
  dP2 as Mail03Icon,
  cP2 as Mail04Icon,
  _P2 as Mail05Icon,
  CP2 as Map01Icon,
  fP2 as Map02Icon,
  vP2 as MarkIcon,
  uP2 as MarkerPin01Icon,
  wP2 as MarkerPin02Icon,
  pP2 as MarkerPin03Icon,
  gP2 as MarkerPin04Icon,
  $P2 as MarkerPin05Icon,
  MP2 as MarkerPin06Icon,
  LP2 as Maximize01Icon,
  kP2 as Maximize02Icon,
  mP2 as MedicalCircleIcon,
  xP2 as MedicalCrossIcon,
  HP2 as MedicalSquareIcon,
  VP2 as Menu01Icon,
  ZP2 as Menu02Icon,
  BP2 as Menu03Icon,
  FP2 as Menu04Icon,
  jP2 as Menu05Icon,
  IP2 as MessageAlertCircleIcon,
  bP2 as MessageAlertSquareIcon,
  yP2 as MessageChatCircleIcon,
  DP2 as MessageChatSquareIcon,
  PP2 as MessageCheckCircleIcon,
  AP2 as MessageCheckSquareIcon,
  SP2 as MessageCircle01Icon,
  TP2 as MessageCircle02Icon,
  OP2 as MessageDotsCircleIcon,
  EP2 as MessageDotsSquareIcon,
  RP2 as MessageHeartCircleIcon,
  UP2 as MessageHeartSquareIcon,
  NP2 as MessageNotificationCircleIcon,
  qP2 as MessageNotificationSquareIcon,
  zP2 as MessagePlusCircleIcon,
  KP2 as MessagePlusSquareIcon,
  GP2 as MessageQuestionCircleIcon,
  WP2 as MessageQuestionSquareIcon,
  YP2 as MessageSmileCircleIcon,
  XP2 as MessageSmileSquareIcon,
  QP2 as MessageSquare01Icon,
  JP2 as MessageSquare02Icon,
  tA2 as MessageTextCircle01Icon,
  eA2 as MessageTextCircle02Icon,
  rA2 as MessageTextSquare01Icon,
  nA2 as MessageTextSquare02Icon,
  oA2 as MessageXCircleIcon,
  iA2 as MessageXSquareIcon,
  lA2 as Microphone01Icon,
  sA2 as Microphone02Icon,
  hA2 as MicrophoneOff01Icon,
  aA2 as MicrophoneOff02Icon,
  dA2 as MicroscopeIcon,
  cA2 as Minimize01Icon,
  _A2 as Minimize02Icon,
  CA2 as MinusCircleIcon,
  vA2 as MinusIcon,
  fA2 as MinusSquareIcon,
  uA2 as Modem01Icon,
  wA2 as Modem02Icon,
  pA2 as Monitor01Icon,
  gA2 as Monitor02Icon,
  $A2 as Monitor03Icon,
  MA2 as Monitor04Icon,
  LA2 as Monitor05Icon,
  kA2 as Moon01Icon,
  mA2 as Moon02Icon,
  xA2 as MoonEclipseIcon,
  HA2 as MoonStarIcon,
  VA2 as MouseIcon,
  ZA2 as MoveIcon,
  BA2 as MusicNote01Icon,
  FA2 as MusicNote02Icon,
  jA2 as MusicNotePlusIcon,
  gK2 as NAIcon,
  $K2 as NEIcon,
  MK2 as NFIcon,
  LK2 as NGIcon,
  kK2 as NIIcon,
  mK2 as NLIcon,
  xK2 as NOIcon,
  HK2 as NPIcon,
  VK2 as NRIcon,
  ZK2 as NUIcon,
  BK2 as NZIcon,
  IA2 as NavigationPointer01Icon,
  bA2 as NavigationPointer02Icon,
  yA2 as NavigationPointerOff01Icon,
  DA2 as NavigationPointerOff02Icon,
  PA2 as NotificationBoxIcon,
  AA2 as NotificationMessageIcon,
  SA2 as NotificationTextIcon,
  FK2 as OMIcon,
  TA2 as OctagonIcon,
  jK2 as PAIcon,
  IK2 as PEIcon,
  bK2 as PFIcon,
  yK2 as PGIcon,
  DK2 as PHIcon,
  PK2 as PKIcon,
  AK2 as PLIcon,
  SK2 as PNIcon,
  TK2 as PRIcon,
  OK2 as PSIcon,
  EK2 as PTIcon,
  RK2 as PWIcon,
  UK2 as PYIcon,
  OA2 as PackageCheckIcon,
  qA2 as PackageIcon,
  EA2 as PackageMinusIcon,
  RA2 as PackagePlusIcon,
  UA2 as PackageSearchIcon,
  NA2 as PackageXIcon,
  KA2 as PaintIcon,
  zA2 as PaintPourIcon,
  GA2 as PaletteIcon,
  WA2 as PaperclipIcon,
  YA2 as ParagraphSpacingIcon,
  XA2 as ParagraphWrapIcon,
  JA2 as PasscodeIcon,
  QA2 as PasscodeLockIcon,
  tS2 as PassportIcon,
  eS2 as PauseCircleIcon,
  rS2 as PauseSquareIcon,
  nS2 as PenTool01Icon,
  oS2 as PenTool02Icon,
  iS2 as PenToolMinusIcon,
  lS2 as PenToolPlusIcon,
  sS2 as Pencil01Icon,
  hS2 as Pencil02Icon,
  aS2 as PencilLineIcon,
  dS2 as PentagonIcon,
  cS2 as Percent01Icon,
  _S2 as Percent02Icon,
  CS2 as Percent03Icon,
  fS2 as Perspective01Icon,
  vS2 as Perspective02Icon,
  uS2 as Phone01Icon,
  wS2 as Phone02Icon,
  pS2 as PhoneCall01Icon,
  gS2 as PhoneCall02Icon,
  $S2 as PhoneHangUpIcon,
  ZS2 as PhoneIcon,
  MS2 as PhoneIncoming01Icon,
  LS2 as PhoneIncoming02Icon,
  kS2 as PhoneOutgoing01Icon,
  mS2 as PhoneOutgoing02Icon,
  xS2 as PhonePauseIcon,
  HS2 as PhonePlusIcon,
  VS2 as PhoneXIcon,
  BS2 as PieChart01Icon,
  FS2 as PieChart02Icon,
  jS2 as PieChart03Icon,
  IS2 as PieChart04Icon,
  bS2 as PiggyBank01Icon,
  yS2 as PiggyBank02Icon,
  DS2 as Pilcrow01Icon,
  PS2 as Pilcrow02Icon,
  AS2 as PilcrowSquareIcon,
  SS2 as Pin01Icon,
  TS2 as Pin02Icon,
  OS2 as PlaceholderIcon,
  ES2 as PlaneIcon,
  RS2 as PlayCircleIcon,
  NS2 as PlayIcon,
  US2 as PlaySquareIcon,
  ix1 as PlusCircleIcon,
  zS2 as PlusIcon,
  qS2 as PlusSquareIcon,
  KS2 as PodcastIcon,
  GS2 as Power01Icon,
  WS2 as Power02Icon,
  YS2 as Power03Icon,
  XS2 as PresentationChart01Icon,
  QS2 as PresentationChart02Icon,
  JS2 as PresentationChart03Icon,
  tT2 as PrinterIcon,
  eT2 as PuzzlePiece01Icon,
  rT2 as PuzzlePiece02Icon,
  NK2 as QAIcon,
  nT2 as QrCode01Icon,
  oT2 as QrCode02Icon,
  qK2 as ROIcon,
  zK2 as RSIcon,
  KK2 as RUIcon,
  GK2 as RWIcon,
  iT2 as ReceiptCheckIcon,
  lT2 as ReceiptIcon,
  sT2 as Recording01Icon,
  hT2 as Recording02Icon,
  aT2 as Recording03Icon,
  dT2 as Reflect01Icon,
  cT2 as Reflect02Icon,
  _T2 as RefreshCcw01Icon,
  CT2 as RefreshCcw02Icon,
  fT2 as RefreshCcw03Icon,
  vT2 as RefreshCcw04Icon,
  uT2 as RefreshCcw05Icon,
  wT2 as RefreshCw01Icon,
  pT2 as RefreshCw02Icon,
  gT2 as RefreshCw03Icon,
  $T2 as RefreshCw04Icon,
  MT2 as RefreshCw05Icon,
  LT2 as Repeat01Icon,
  kT2 as Repeat02Icon,
  mT2 as Repeat03Icon,
  xT2 as Repeat04Icon,
  HT2 as ReverseLeftIcon,
  VT2 as ReverseRightIcon,
  ZT2 as RightIndent01Icon,
  BT2 as RightIndent02Icon,
  FT2 as Rocket01Icon,
  jT2 as Rocket02Icon,
  IT2 as RollerBrushIcon,
  bT2 as RouteIcon,
  yT2 as Rows01Icon,
  DT2 as Rows02Icon,
  PT2 as Rows03Icon,
  AT2 as Rss01Icon,
  ST2 as Rss02Icon,
  TT2 as RulerIcon,
  WK2 as SAIcon,
  YK2 as SBIcon,
  XK2 as SCIcon,
  QK2 as SEIcon,
  JK2 as SGIcon,
  tG2 as SIIcon,
  eG2 as SKIcon,
  rG2 as SLIcon,
  nG2 as SMIcon,
  oG2 as SNIcon,
  iG2 as SOIcon,
  lG2 as SRIcon,
  sG2 as SSIcon,
  hG2 as STIcon,
  aG2 as SVIcon,
  dG2 as SXIcon,
  cG2 as SYIcon,
  _G2 as SZIcon,
  OT2 as SafeIcon,
  ET2 as Sale01Icon,
  RT2 as Sale02Icon,
  UT2 as Sale03Icon,
  NT2 as Sale04Icon,
  qT2 as Save01Icon,
  zT2 as Save02Icon,
  KT2 as Save03Icon,
  GT2 as Scale01Icon,
  WT2 as Scale02Icon,
  YT2 as Scale03Icon,
  XT2 as Scales01Icon,
  QT2 as Scales02Icon,
  JT2 as ScanIcon,
  tO2 as Scissors01Icon,
  eO2 as Scissors02Icon,
  rO2 as ScissorsCut01Icon,
  nO2 as ScissorsCut02Icon,
  oO2 as SearchLgIcon,
  UI1 as SearchMdIcon,
  iO2 as SearchRefractionIcon,
  lO2 as SearchSmIcon,
  sO2 as Send01Icon,
  hO2 as Send02Icon,
  aO2 as Send03Icon,
  dO2 as Server01Icon,
  cO2 as Server02Icon,
  _O2 as Server03Icon,
  CO2 as Server04Icon,
  fO2 as Server05Icon,
  vO2 as Server06Icon,
  uO2 as Settings01Icon,
  wO2 as Settings02Icon,
  pO2 as Settings03Icon,
  gO2 as Settings04Icon,
  $O2 as Share01Icon,
  MO2 as Share02Icon,
  LO2 as Share03Icon,
  kO2 as Share04Icon,
  mO2 as Share05Icon,
  xO2 as Share06Icon,
  HO2 as Share07Icon,
  VO2 as Shield01Icon,
  ZO2 as Shield02Icon,
  BO2 as Shield03Icon,
  FO2 as ShieldDollarIcon,
  jO2 as ShieldOffIcon,
  IO2 as ShieldPlusIcon,
  bO2 as ShieldTickIcon,
  yO2 as ShieldZapIcon,
  DO2 as ShoppingBag01Icon,
  PO2 as ShoppingBag02Icon,
  AO2 as ShoppingBag03Icon,
  SO2 as ShoppingCart01Icon,
  TO2 as ShoppingCart02Icon,
  OO2 as ShoppingCart03Icon,
  EO2 as Shuffle01Icon,
  RO2 as Shuffle02Icon,
  UO2 as Signal01Icon,
  NO2 as Signal02Icon,
  qO2 as Signal03Icon,
  zO2 as SimcardIcon,
  KO2 as SkewIcon,
  GO2 as SkipBackIcon,
  WO2 as SkipForwardIcon,
  YO2 as SlashCircle01Icon,
  XO2 as SlashCircle02Icon,
  QO2 as SlashDividerIcon,
  JO2 as SlashOctagonIcon,
  tE2 as Sliders01Icon,
  eE2 as Sliders02Icon,
  rE2 as Sliders03Icon,
  nE2 as Sliders04Icon,
  oE2 as Snowflake01Icon,
  iE2 as Snowflake02Icon,
  lE2 as SpacingHeight01Icon,
  sE2 as SpacingHeight02Icon,
  hE2 as SpacingWidth01Icon,
  aE2 as SpacingWidth02Icon,
  dE2 as Speaker01Icon,
  cE2 as Speaker02Icon,
  _E2 as Speaker03Icon,
  CE2 as Speedometer01Icon,
  fE2 as Speedometer02Icon,
  vE2 as Speedometer03Icon,
  uE2 as Speedometer04Icon,
  wE2 as SquareIcon,
  pE2 as StandIcon,
  gE2 as Star01Icon,
  $E2 as Star02Icon,
  ME2 as Star03Icon,
  LE2 as Star04Icon,
  kE2 as Star05Icon,
  mE2 as Star06Icon,
  xE2 as Star07Icon,
  HE2 as Stars01Icon,
  VE2 as Stars02Icon,
  ZE2 as Stars03Icon,
  BE2 as StickerCircleIcon,
  FE2 as StickerSquareIcon,
  jE2 as StopCircleIcon,
  bE2 as StopIcon,
  IE2 as StopSquareIcon,
  yE2 as Strikethrough01Icon,
  DE2 as Strikethrough02Icon,
  PE2 as StrikethroughSquareIcon,
  AE2 as SubscriptIcon,
  EE2 as SunIcon,
  SE2 as SunSetting01Icon,
  TE2 as SunSetting02Icon,
  OE2 as SunSetting03Icon,
  RE2 as SunriseIcon,
  UE2 as SunsetIcon,
  NE2 as SwitchHorizontal01Icon,
  qE2 as SwitchHorizontal02Icon,
  zE2 as SwitchVertical01Icon,
  KE2 as SwitchVertical02Icon,
  CG2 as TCIcon,
  fG2 as TDIcon,
  vG2 as TGIcon,
  uG2 as THIcon,
  wG2 as TJIcon,
  pG2 as TKIcon,
  gG2 as TLIcon,
  $G2 as TMIcon,
  MG2 as TNIcon,
  LG2 as TOIcon,
  kG2 as TRIcon,
  mG2 as TTIcon,
  xG2 as TVIcon,
  HG2 as TWIcon,
  VG2 as TZIcon,
  GE2 as TableIcon,
  WE2 as Tablet01Icon,
  YE2 as Tablet02Icon,
  XE2 as Tag01Icon,
  QE2 as Tag02Icon,
  JE2 as Tag03Icon,
  tR2 as Target01Icon,
  eR2 as Target02Icon,
  rR2 as Target03Icon,
  nR2 as Target04Icon,
  oR2 as Target05Icon,
  iR2 as TelescopeIcon,
  lR2 as TerminalBrowserIcon,
  sR2 as TerminalCircleIcon,
  aR2 as TerminalIcon,
  hR2 as TerminalSquareIcon,
  dR2 as TextInputIcon,
  cR2 as Thermometer01Icon,
  _R2 as Thermometer02Icon,
  CR2 as Thermometer03Icon,
  fR2 as ThermometerColdIcon,
  vR2 as ThermometerWarmIcon,
  uR2 as ThumbsDownIcon,
  wR2 as ThumbsUpIcon,
  pR2 as Ticket01Icon,
  gR2 as Ticket02Icon,
  $R2 as Toggle01LeftIcon,
  MR2 as Toggle01RightIcon,
  LR2 as Toggle02LeftIcon,
  kR2 as Toggle02RightIcon,
  mR2 as Toggle03LeftIcon,
  xR2 as Toggle03RightIcon,
  HR2 as Tool01Icon,
  VR2 as Tool02Icon,
  ZR2 as TrainIcon,
  BR2 as TramIcon,
  FR2 as TransformIcon,
  jR2 as Translate01Icon,
  IR2 as Translate02Icon,
  bR2 as Trash01Icon,
  yR2 as Trash02Icon,
  DR2 as Trash03Icon,
  PR2 as Trash04Icon,
  AR2 as TrendDown01Icon,
  SR2 as TrendDown02Icon,
  TR2 as TrendUp01Icon,
  OR2 as TrendUp02Icon,
  ER2 as TriangleIcon,
  RR2 as Trophy01Icon,
  UR2 as Trophy02Icon,
  NR2 as Truck01Icon,
  qR2 as Truck02Icon,
  zR2 as Tv01Icon,
  KR2 as Tv02Icon,
  GR2 as Tv03Icon,
  WR2 as Type01Icon,
  YR2 as Type02Icon,
  XR2 as TypeSquareIcon,
  QR2 as TypeStrikethrough01Icon,
  JR2 as TypeStrikethrough02Icon,
  ZG2 as UAIcon,
  BG2 as UGIcon,
  FG2 as USIcon,
  jG2 as UYIcon,
  IG2 as UZIcon,
  tU2 as Umbrella01Icon,
  eU2 as Umbrella02Icon,
  rU2 as Umbrella03Icon,
  nU2 as Underline01Icon,
  oU2 as Underline02Icon,
  iU2 as UnderlineSquareIcon,
  lU2 as Upload01Icon,
  sU2 as Upload02Icon,
  hU2 as Upload03Icon,
  aU2 as Upload04Icon,
  SX1 as UploadCloud01Icon,
  dU2 as UploadCloud02Icon,
  cU2 as UsbFlashDriveIcon,
  _U2 as User01Icon,
  CU2 as User02Icon,
  fU2 as User03Icon,
  vU2 as UserCheck01Icon,
  uU2 as UserCheck02Icon,
  wU2 as UserCircleIcon,
  pU2 as UserDown01Icon,
  gU2 as UserDown02Icon,
  $U2 as UserEditIcon,
  MU2 as UserLeft01Icon,
  LU2 as UserLeft02Icon,
  kU2 as UserMinus01Icon,
  mU2 as UserMinus02Icon,
  xU2 as UserPlus01Icon,
  HU2 as UserPlus02Icon,
  VU2 as UserRight01Icon,
  ZU2 as UserRight02Icon,
  BU2 as UserSquareIcon,
  FU2 as UserUp01Icon,
  jU2 as UserUp02Icon,
  IU2 as UserX01Icon,
  bU2 as UserX02Icon,
  yU2 as Users01Icon,
  DU2 as Users02Icon,
  PU2 as Users03Icon,
  AU2 as UsersCheckIcon,
  SU2 as UsersDownIcon,
  TU2 as UsersEditIcon,
  OU2 as UsersLeftIcon,
  EU2 as UsersMinusIcon,
  RU2 as UsersPlusIcon,
  UU2 as UsersRightIcon,
  NU2 as UsersUpIcon,
  qU2 as UsersXIcon,
  bG2 as VCIcon,
  yG2 as VEIcon,
  DG2 as VGIcon,
  PG2 as VIIcon,
  AG2 as VNIcon,
  SG2 as VUIcon,
  zU2 as VariableIcon,
  GU2 as VideoRecorderIcon,
  KU2 as VideoRecorderOffIcon,
  WU2 as VirusIcon,
  YU2 as VoicemailIcon,
  XU2 as VolumeMaxIcon,
  QU2 as VolumeMinIcon,
  JU2 as VolumeMinusIcon,
  tN2 as VolumePlusIcon,
  eN2 as VolumeXIcon,
  TG2 as WSIcon,
  rN2 as Wallet01Icon,
  nN2 as Wallet02Icon,
  oN2 as Wallet03Icon,
  iN2 as Wallet04Icon,
  lN2 as Wallet05Icon,
  sN2 as WatchCircleIcon,
  hN2 as WatchSquareIcon,
  aN2 as WavesIcon,
  dN2 as Webcam01Icon,
  cN2 as Webcam02Icon,
  CN2 as WifiIcon,
  _N2 as WifiOffIcon,
  fN2 as Wind01Icon,
  vN2 as Wind02Icon,
  uN2 as Wind03Icon,
  S2 as XCircleIcon,
  wN2 as XCloseIcon,
  m2 as XIcon,
  pN2 as XSquareIcon,
  OG2 as YEIcon,
  gN2 as YoutubeIcon,
  EG2 as ZAIcon,
  RG2 as ZMIcon,
  UG2 as ZWIcon,
  $N2 as ZapCircleIcon,
  MN2 as ZapFastIcon,
  mN2 as ZapIcon,
  LN2 as ZapOffIcon,
  kN2 as ZapSquareIcon,
  xN2 as ZoomInIcon,
  HN2 as ZoomOutIcon,
  sW2 as default
};
